{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.887609391867532, 7.059480295149824],
              [6.897178541039904, 7.061337430936929],
              [6.906359618048674, 7.048198980782513],
              [6.8904830876277865, 7.039707465042571],
              [6.887609391867532, 7.059480295149824]
            ]
          ],
          [
            [
              [6.8071271250725385, 6.977980166648687],
              [6.811829867339072, 6.992817443901319],
              [6.804807538273112, 7.009393876839882],
              [6.810308125844409, 7.041358661428872],
              [6.831079649422017, 7.036328609838109],
              [6.856214919214871, 7.0444637765344185],
              [6.867596924998236, 7.043643499021343],
              [6.881888145435692, 7.031274531181048],
              [6.879880481161471, 7.005355060229516],
              [6.8701970815941396, 6.997078939423257],
              [6.871447343587019, 6.96782152530626],
              [6.8658508223008035, 6.962483509375408],
              [6.847643900206201, 6.965881401221372],
              [6.8370361716263535, 6.945918508098055],
              [6.829553973950477, 6.957851469201623],
              [6.814388758278986, 6.961999395720482],
              [6.8071271250725385, 6.977980166648687]
            ]
          ],
          [
            [
              [6.527657572066481, 6.784420585030981],
              [6.528010871493735, 6.798691696381925],
              [6.5563806219463485, 6.798609638616202],
              [6.556676505659368, 6.773161992220753],
              [6.528584720466724, 6.778762096766927],
              [6.527657572066481, 6.784420585030981]
            ]
          ],
          [
            [
              [4.253589163264651, 8.420616079720046],
              [4.258389881432037, 8.430762270648202],
              [4.257223099202112, 8.462766897280902],
              [4.261612284757695, 8.482747696820363],
              [4.269538516437786, 8.49133171207626],
              [4.297288343251268, 8.49630222464315],
              [4.298423993996922, 8.478644842960627],
              [4.291046635533502, 8.457452650904532],
              [4.294146631635801, 8.4445921473138],
              [4.287987133135455, 8.433377717473652],
              [4.26998147495272, 8.41744784246772],
              [4.253589163264651, 8.420616079720046]
            ]
          ],
          [
            [
              [4.227148983267847, 8.29551984268572],
              [4.2692375493109065, 8.319042622309842],
              [4.270052929282085, 8.31311776321318],
              [4.253970566867816, 8.29465243154817],
              [4.237966133781626, 8.290096504528034],
              [4.227148983267847, 8.29551984268572]
            ]
          ],
          [
            [
              [4.176457930484866, 8.446870599225916],
              [4.1972211162632975, 8.432119235553513],
              [4.197670679375411, 8.41962665083915],
              [4.1867071819369555, 8.411249551157507],
              [4.176457930484866, 8.446870599225916]
            ]
          ],
          [
            [
              [4.128851985555534, 8.334193733478038],
              [4.139489138251398, 8.354124402625652],
              [4.163523650849657, 8.365848770551503],
              [4.192650051559047, 8.374599953281427],
              [4.212130688036872, 8.384425367608259],
              [4.226194782507239, 8.37150995807182],
              [4.201725113434407, 8.340076008223246],
              [4.187407975306995, 8.340238923420316],
              [4.176133877464868, 8.330823729702512],
              [4.140135686064313, 8.31918043447193],
              [4.128851985555534, 8.334193733478038]
            ]
          ],
          [
            [
              [4.110392063659172, 8.366797483393265],
              [4.125345692784384, 8.387856183033843],
              [4.13992742822703, 8.38279987258954],
              [4.1155023584601365, 8.3597296170387],
              [4.110392063659172, 8.366797483393265]
            ]
          ],
          [
            [
              [4.0976337994348215, 8.297560855569122],
              [4.114134732807386, 8.307244158889887],
              [4.11806492711094, 8.295048387661874],
              [4.107010793902642, 8.290180042285492],
              [4.0976337994348215, 8.297560855569122]
            ]
          ],
          [
            [
              [4.085850825350346, 8.396180960709717],
              [4.091514641450619, 8.41355570947904],
              [4.106149971037661, 8.416711343358545],
              [4.114277071341621, 8.410119772229972],
              [4.097740834651884, 8.392190267884402],
              [4.085850825350346, 8.396180960709717]
            ]
          ],
          [
            [
              [4.059088820191616, 8.242462993170754],
              [4.061852557892915, 8.259511119199946],
              [4.07560999459981, 8.282399798100748],
              [4.086611644161851, 8.275937617478608],
              [4.07202164065826, 8.247469133620585],
              [4.059088820191616, 8.242462993170754]
            ]
          ],
          [
            [
              [4.051456117931345, 8.354277092611689],
              [4.067449985170504, 8.372104694875093],
              [4.0848182713552825, 8.367294113282847],
              [4.10050300586186, 8.346798414961665],
              [4.105340218887978, 8.328074050015173],
              [4.0728833716929325, 8.322320134363872],
              [4.051456117931345, 8.354277092611689]
            ]
          ],
          [
            [
              [4.040615551714857, 8.43011990909251],
              [4.052564543757081, 8.437508951311223],
              [4.064375374415076, 8.424931244131926],
              [4.058565780242721, 8.407360707227724],
              [4.044507721916947, 8.411131660778508],
              [4.040615551714857, 8.43011990909251]
            ]
          ],
          [
            [
              [4.0423058182714975, 8.1938543302004],
              [4.068434315694428, 8.208231889745631],
              [4.081659816323949, 8.211046937770988],
              [4.094672482633624, 8.232026255035874],
              [4.131426872465603, 8.256504659339381],
              [4.157446795557195, 8.288548483421566],
              [4.1670729616851245, 8.287352204493349],
              [4.19068784507095, 8.265972025777781],
              [4.181317859219392, 8.255697934266772],
              [4.1613095170861305, 8.252712623305495],
              [4.121165482938424, 8.232432473093434],
              [4.124897054761109, 8.212721206932175],
              [4.1343267826186, 8.202684243234906],
              [4.107740469782308, 8.19453356409156],
              [4.093832094242353, 8.197101708552482],
              [4.079025947861711, 8.179108454638508],
              [4.058012669491713, 8.163158693276007],
              [4.0423058182714975, 8.1938543302004]
            ]
          ],
          [
            [
              [3.900465786465391, 8.380882843476831],
              [3.922494120404478, 8.39006629835844],
              [3.9337383358824036, 8.38292320665399],
              [3.9364834992615285, 8.363982925877924],
              [3.913344876222945, 8.361851819330903],
              [3.900465786465391, 8.380882843476831]
            ]
          ],
          [
            [
              [3.205364789869224, 8.07623315619551],
              [3.2430973987922536, 8.054181725466165],
              [3.2562092800475844, 8.052167397627299],
              [3.314501154184949, 8.066926387051243],
              [3.3403419409645054, 8.065888605453921],
              [3.360703375075298, 8.071221780498146],
              [3.3878981989548445, 8.086693802015343],
              [3.4583321204654256, 8.11513351814865],
              [3.4950981672217996, 8.136161614623301],
              [3.50621365493197, 8.139790122169277],
              [3.5318780097009532, 8.138313416909995],
              [3.5496399603747357, 8.141773115350286],
              [3.5620149264389482, 8.151445756312103],
              [3.5771888279096427, 8.154379671815233],
              [3.606015884725029, 8.16699413474379],
              [3.6183633183732646, 8.18128413332594],
              [3.6430518594994874, 8.181025118364108],
              [3.6654134536405185, 8.206769009946138],
              [3.698659811855309, 8.223923506438513],
              [3.7204190682653238, 8.22839741218875],
              [3.7357083091626353, 8.251998662943262],
              [3.7551724182362634, 8.251765631743973],
              [3.765420768857086, 8.242009527869385],
              [3.801643713435618, 8.256235099588656],
              [3.811079655330669, 8.251975217263455],
              [3.8290073624111294, 8.25817542064976],
              [3.8300193111077054, 8.27633663308382],
              [3.8475767228212105, 8.275684520448374],
              [3.8664298766543417, 8.287432320140441],
              [3.8693930106412053, 8.301224221866422],
              [3.895608825150023, 8.316915352764143],
              [3.909016529524724, 8.341022630483923],
              [3.914974018087506, 8.34377730546752],
              [3.9387917583843026, 8.33378647880537],
              [3.9719982104148572, 8.354587707121944],
              [3.9830971261625443, 8.366012186798056],
              [4.001302960198261, 8.361836156782845],
              [4.007676009323994, 8.34099097742879],
              [4.018306047284737, 8.336680099933657],
              [4.033815425578336, 8.340257648195532],
              [4.0431666214904585, 8.316324826804767],
              [4.051829884617038, 8.315937204827016],
              [4.064464003258497, 8.296716912079393],
              [4.051316408292423, 8.288531441825468],
              [4.040330893259717, 8.26117646104583],
              [4.0432154886597, 8.250204068835322],
              [4.025052573919816, 8.216006818629108],
              [4.011815325975156, 8.196921655847055],
              [3.9975011369373963, 8.195289653705139],
              [3.9919159704096545, 8.170821051659908],
              [3.9796902013276316, 8.162201631730653],
              [3.9915095250720056, 8.130193381495985],
              [4.004943729795505, 8.107491244103317],
              [3.9951418675761152, 8.087990852366628],
              [3.9643431698146414, 8.065342904461293],
              [3.9612591950872718, 8.034228223109508],
              [3.942177870830298, 8.006695209951795],
              [3.94779086049661, 7.9938557505339105],
              [3.971894192122019, 7.9899601726204645],
              [4.030079767316466, 8.02968580139688],
              [4.0488292591985, 8.03610707265206],
              [4.086459802250378, 8.068186077337627],
              [4.078480917299334, 8.082070763850306],
              [4.10336218749092, 8.079593292429117],
              [4.125826595168872, 8.071034065640465],
              [4.1937217320930085, 8.019342077237917],
              [4.228029447173904, 8.002719439417813],
              [4.249603585890288, 8.012388584372955],
              [4.272626006075806, 7.998449939030817],
              [4.2982628394995075, 7.987388513079004],
              [4.311393207447987, 7.992702401520623],
              [4.330447037708523, 7.960705539323517],
              [4.348015771358887, 7.970189719246841],
              [4.359602448937115, 7.97020896322308],
              [4.371537271612874, 7.983557754709781],
              [4.386847148010582, 7.970704709228031],
              [4.38613765380314, 7.947748863345605],
              [4.406971965728906, 7.951628227893144],
              [4.42038336682707, 7.937552464178856],
              [4.454050613734317, 7.937527603299985],
              [4.484449856440247, 7.878485125601639],
              [4.494800664434234, 7.873548783119675],
              [4.500194252794262, 7.84882227280828],
              [4.508464236762084, 7.839270806203029],
              [4.519046208086391, 7.8128873708476005],
              [4.5302093877169, 7.801109306964067],
              [4.530442367726775, 7.778953991260012],
              [4.601352039381179, 7.764020513774418],
              [4.672254203106715, 7.749070597232104],
              [4.746742476519673, 7.733815880890813],
              [4.821222680537394, 7.718543150063931],
              [4.895694820029544, 7.703252424666823],
              [4.97015890023739, 7.687943724850563],
              [5.035542569707288, 7.674740903645592],
              [5.100920130028638, 7.661524295185387],
              [5.166291584822087, 7.648293913242336],
              [5.231656937925606, 7.6350497717298245],
              [5.255290290512489, 7.630773980906078],
              [5.342533355088922, 7.588461131861581],
              [5.4297537321712435, 7.546115034018598],
              [5.438606272914174, 7.536701686254529],
              [5.478806022557934, 7.526254825938003],
              [5.5071885802749305, 7.5390743195078915],
              [5.550443486664869, 7.528699068490202],
              [5.563366978664558, 7.504002630003357],
              [5.595942648218091, 7.5065394526751374],
              [5.602361117167874, 7.535316125864413],
              [5.613601139865993, 7.525160291756186],
              [5.629078769560386, 7.5369171774454475],
              [5.646153710223585, 7.536314888988857],
              [5.651577218494863, 7.544134401467626],
              [5.667612488412368, 7.543359313468486],
              [5.6778919725680685, 7.520312390591213],
              [5.6856176283146915, 7.516747654300073],
              [5.704436574111802, 7.526612158400379],
              [5.712069261680308, 7.5176593983185045],
              [5.735299844437728, 7.50514822107134],
              [5.754772791610406, 7.514485753797722],
              [5.7594735807717825, 7.5232893632779865],
              [5.803395864876846, 7.495323276051852],
              [5.823641973870168, 7.488161844756734],
              [5.855080938516113, 7.502246775873114],
              [5.865049407006856, 7.4878255035607015],
              [5.885365853410755, 7.490010919459829],
              [5.924848030357918, 7.482912322851012],
              [5.9412643966314045, 7.468316232222718],
              [5.963492038473178, 7.4645251496606555],
              [5.956521971068724, 7.447983611746929],
              [5.961466758734355, 7.432220992144882],
              [5.983531873283189, 7.425240270820583],
              [5.979965082960254, 7.414190065911271],
              [5.944350582382089, 7.3707906418257],
              [5.9483992558438405, 7.357363074326961],
              [5.963572610411861, 7.35282377860156],
              [5.974982708396613, 7.336059045245951],
              [6.005566682394538, 7.3339349329985515],
              [6.012427850896417, 7.34311217584702],
              [6.0441738061305275, 7.35171705680338],
              [6.054423453963893, 7.334042007478889],
              [6.051178199334454, 7.326428725886977],
              [6.080050713849095, 7.316031821771092],
              [6.091816454563816, 7.3206647586459095],
              [6.112661248730922, 7.315596995183836],
              [6.126594794303751, 7.318118096789689],
              [6.139679014813682, 7.309456825173185],
              [6.145908229906131, 7.292004828247522],
              [6.159390039508179, 7.283181353190255],
              [6.177277550937224, 7.279123274851663],
              [6.180418455753473, 7.268480416670437],
              [6.196489577230881, 7.256766429559893],
              [6.201939807965346, 7.243401351071478],
              [6.17391293558743, 7.230499198513669],
              [6.17459871926365, 7.215036884549914],
              [6.1850125640501155, 7.207561399129368],
              [6.212930651685734, 7.173415976898087],
              [6.200434693319855, 7.1326130333459945],
              [6.1776710928252125, 7.137286504588074],
              [6.175943687154709, 7.1278633049442295],
              [6.198404818280619, 7.10868573461664],
              [6.201378547562673, 7.083829440360078],
              [6.209120654445223, 7.071453622169586],
              [6.1980908459659165, 7.034835831888101],
              [6.185021058526027, 7.025510730449015],
              [6.166588576241912, 7.002567321664553],
              [6.1771349575906935, 6.9786005229329815],
              [6.172138794982073, 6.956957001031978],
              [6.156514935085203, 6.930277804599792],
              [6.190722396897597, 6.915559134829094],
              [6.193978667377595, 6.922962641063846],
              [6.223471154296268, 6.926682482203868],
              [6.249165588091459, 6.924906773744083],
              [6.258684688464612, 6.932705352062147],
              [6.271369870274898, 6.954758556060519],
              [6.287727245704685, 6.968569403056023],
              [6.314154375393776, 6.950767675344444],
              [6.324212854514291, 6.921413333866149],
              [6.316431267312091, 6.902776794980903],
              [6.300269189839482, 6.878104047460823],
              [6.2902317492148985, 6.845140474131763],
              [6.288634733075553, 6.8191603692699125],
              [6.280235917898956, 6.81172015288928],
              [6.28087907620348, 6.787990787292345],
              [6.270956808004088, 6.775968976821123],
              [6.277318529679339, 6.7560091477666315],
              [6.298840022078374, 6.7349642143319555],
              [6.31624819590397, 6.725957322200756],
              [6.335321175690323, 6.691837984320826],
              [6.356343865868928, 6.691626821513314],
              [6.384988582524139, 6.682703555915062],
              [6.389041744532967, 6.675396527712549],
              [6.373400745663652, 6.661127554888192],
              [6.365787893350707, 6.631495716852971],
              [6.3692594495014125, 6.600867334672164],
              [6.368747332477841, 6.573419287655465],
              [6.338522008710066, 6.5591684781554225],
              [6.3221018271705915, 6.5578095778325896],
              [6.267684760743351, 6.542878960877979],
              [6.242005301971014, 6.529746694238056],
              [6.225333615567561, 6.507096672778122],
              [6.2230076489308574, 6.4926766335985135],
              [6.234265880556143, 6.470519634796103],
              [6.213823345465599, 6.416105220453609],
              [6.194461604434593, 6.401265288195707],
              [6.181863577224657, 6.370968266982231],
              [6.172549178902027, 6.335692629897139],
              [6.150241694511931, 6.307842557885442],
              [6.142167186150392, 6.289221307426043],
              [6.139657977612433, 6.254871972881734],
              [6.130525112712319, 6.212350961761378],
              [6.128550220309317, 6.188470149685341],
              [6.130803257359273, 6.152069230883334],
              [6.115219382725763, 6.141291325200014],
              [6.120237415872537, 6.124535775700221],
              [6.143596624842768, 6.106263083366558],
              [6.166784961131988, 6.099838947475342],
              [6.1858973188208655, 6.100851736543982],
              [6.19584854390118, 6.107995608678677],
              [6.220440387639859, 6.166389310614059],
              [6.239993889000193, 6.195485060855276],
              [6.251296574177086, 6.19543905820573],
              [6.272335640295027, 6.214882712460762],
              [6.302290846657917, 6.223147575351435],
              [6.309713054366912, 6.23234916555812],
              [6.31303645176449, 6.250070390230386],
              [6.33149130618829, 6.281640139767084],
              [6.326841977233841, 6.307788850379825],
              [6.348052097659638, 6.346584241980306],
              [6.3629340890278, 6.366236174072025],
              [6.378186182928871, 6.401256455029988],
              [6.395069619847749, 6.427532188823139],
              [6.414158463181957, 6.442611538933172],
              [6.431018373048107, 6.438977038629116],
              [6.42674957780736, 6.422305900564936],
              [6.443855854144881, 6.424355170225922],
              [6.448536896244643, 6.443325779198035],
              [6.461487506455967, 6.44467339198737],
              [6.470467607772836, 6.454246008100581],
              [6.481369026503372, 6.451345732530463],
              [6.4989391137901835, 6.477774283178479],
              [6.519737637375767, 6.482557865305575],
              [6.53730882901686, 6.461843780976427],
              [6.55083680380349, 6.434169294130513],
              [6.5560759616315245, 6.437843917578246],
              [6.549653334558628, 6.476668584637562],
              [6.55047668929375, 6.488083262486209],
              [6.532825563443715, 6.50585147149518],
              [6.536463878469933, 6.526897758902785],
              [6.55020337272927, 6.559513275917655],
              [6.557600133355761, 6.591161102586242],
              [6.574835810751354, 6.620649966580814],
              [6.5803700466599855, 6.643736803313926],
              [6.594805337733114, 6.6605252706344364],
              [6.60582152550342, 6.654320538716641],
              [6.605735693641582, 6.683217883932291],
              [6.617864611951414, 6.6951501906484765],
              [6.616523033497475, 6.721947997425208],
              [6.621747916102966, 6.7403478104233585],
              [6.627199033570388, 6.777762856121841],
              [6.636818112951719, 6.7850865977686565],
              [6.65791607645996, 6.774789585293958],
              [6.664260469953905, 6.763295643869365],
              [6.676247944040168, 6.76700616665551],
              [6.670660157561106, 6.786638223904408],
              [6.675213489163703, 6.797583844477337],
              [6.689084233287487, 6.8071713410074635],
              [6.707613163589109, 6.808085291381905],
              [6.702640209953543, 6.839454470407738],
              [6.709325174431335, 6.87401126722705],
              [6.731603880925656, 6.871765493123337],
              [6.73460572456555, 6.9151012313384665],
              [6.7465592757908235, 6.906311567621873],
              [6.767107455448941, 6.90981047425087],
              [6.783217348197084, 6.922088366096171],
              [6.793503950802022, 6.9201877806962715],
              [6.804207944048951, 6.904323903387498],
              [6.79571206620016, 6.889461813029644],
              [6.799609649923933, 6.84135257631751],
              [6.785826110273271, 6.837958038453491],
              [6.780833199652033, 6.850496660548724],
              [6.762084784082405, 6.853568851750132],
              [6.763683885200393, 6.820561679657094],
              [6.762671571731562, 6.780886051156566],
              [6.774508530967681, 6.77145689723602],
              [6.761434722590337, 6.758756556351814],
              [6.748581404968075, 6.778261642375361],
              [6.736445922876808, 6.764701297541387],
              [6.743922510560352, 6.749402576549047],
              [6.757803800140393, 6.746304802449192],
              [6.767850097742085, 6.7167617440012855],
              [6.757950398454165, 6.701175291460566],
              [6.7433205076770815, 6.716191252605089],
              [6.733829813441511, 6.701252316960039],
              [6.7468106602924784, 6.692795437839381],
              [6.716683205468766, 6.685100157540435],
              [6.717855359284932, 6.660532037748347],
              [6.710641551273919, 6.630091250480575],
              [6.694381478876776, 6.620916339000621],
              [6.679548014937851, 6.583322094026004],
              [6.682179666039404, 6.563027950082149],
              [6.693535282965291, 6.543765281966836],
              [6.673909955750775, 6.531030369437675],
              [6.6665419901646645, 6.511383913921523],
              [6.677509514157473, 6.490161025955098],
              [6.639661045197008, 6.462124965788909],
              [6.633439508313906, 6.4533188621498745],
              [6.628132675779778, 6.424788673324096],
              [6.613360526393604, 6.413317162032818],
              [6.605158828501045, 6.396475025909055],
              [6.6064152324970795, 6.379423524993736],
              [6.596946333308795, 6.356965672756532],
              [6.593857322148355, 6.326177187313334],
              [6.576255903218553, 6.282650318276961],
              [6.565657934971149, 6.245035118552012],
              [6.558470307843935, 6.230917648631999],
              [6.537775420527424, 6.20692596248078],
              [6.530285621087654, 6.174062674786383],
              [6.520902606092989, 6.152236880963621],
              [6.513494481060588, 6.110973001417491],
              [6.512070888234918, 6.076685183285023],
              [6.506619986283999, 6.055159684054068],
              [6.507401472565589, 6.034487803666412],
              [6.499670576977658, 5.992618446200937],
              [6.501599566990415, 5.974105381018869],
              [6.492444074234652, 5.948671693769709],
              [6.4867130100638954, 5.918392125157184],
              [6.492234015578499, 5.890594268205029],
              [6.508988865243516, 5.858839014182761],
              [6.5211834341362325, 5.829579473666099],
              [6.523583747861689, 5.810889669530817],
              [6.517637708181272, 5.779362262656992],
              [6.504998431908278, 5.758014552538358],
              [6.489824122480302, 5.741139321403332],
              [6.464072996999884, 5.72633570885101],
              [6.432922987652005, 5.695526548040266],
              [6.429762259532507, 5.673402617014487],
              [6.431768832107683, 5.643403691333598],
              [6.4148619942807015, 5.6102163582247755],
              [6.408934895876155, 5.5794219852528375],
              [6.408376821456452, 5.555722584829215],
              [6.397290416840021, 5.529954501477468],
              [6.394045468523205, 5.490738812992823],
              [6.389452877283759, 5.46845375416873],
              [6.39729890966692, 5.439593172759548],
              [6.402659619153071, 5.398798419550238],
              [6.428530950024959, 5.353507887463148],
              [6.420677552435144, 5.326805303522826],
              [6.430400266654502, 5.277917406429175],
              [6.411937249662672, 5.227714730640379],
              [6.38350586516942, 5.164307200895607],
              [6.378463734987394, 5.148368058834938],
              [6.378937245950656, 5.109875802380007],
              [6.383482229615713, 5.0776820980480375],
              [6.37711599903829, 5.0481327341896725],
              [6.336451527510312, 4.968105464873813],
              [6.330241706742272, 4.9323136396829],
              [6.329135857434096, 4.8875517610581865],
              [6.322030259104747, 4.863292281879869],
              [6.317736913405027, 4.829042324451622],
              [6.320203332421692, 4.814677143669511],
              [6.3316885353484516, 4.793935017374232],
              [6.3334912716810745, 4.776802273726497],
              [6.346747783874764, 4.751289173504097],
              [6.335273777777039, 4.712704762847826],
              [6.338409443334449, 4.700773571940234],
              [6.356507830388614, 4.680122512508768],
              [6.367832522095296, 4.65253727093042],
              [6.347656744551062, 4.622563209417948],
              [6.346440964239999, 4.605574264826734],
              [6.3531506006528184, 4.587328160150599],
              [6.363774661342449, 4.573518225105246],
              [6.386455255013616, 4.553564244305942],
              [6.390867885626176, 4.544361680306183],
              [6.3927004707965525, 4.515280581833078],
              [6.398762830612071, 4.498213256500128],
              [6.394407616163754, 4.479475579999246],
              [6.399552519125451, 4.456707508994226],
              [6.416678474154549, 4.419381411735806],
              [6.441309681423867, 4.392787291902298],
              [6.46961168630204, 4.370990393206547],
              [6.459212543308475, 4.357827708140606],
              [6.455082891882399, 4.337430016716041],
              [6.459061397628088, 4.321582820235556],
              [6.456931322766489, 4.2880131280951534],
              [6.446033294525339, 4.261493153519436],
              [6.439261868444657, 4.220657348500902],
              [6.440117583115206, 4.191690381689166],
              [6.446420805915144, 4.164863171869033],
              [6.453080506984935, 4.106113466671235],
              [6.462599189360064, 4.078734046600045],
              [6.348124161956465, 4.070897957520463],
              [6.233650651343308, 4.063036370704713],
              [6.1195646489034665, 4.052256991302082],
              [6.016304318794681, 4.043744611744654],
              [5.933923270998633, 4.037486663971589],
              [5.851543209743163, 4.031215503809351],
              [5.743644590892394, 4.01986564154483],
              [5.592853350582467, 4.012660740881042],
              [5.498484636083215, 4.006835736345516],
              [5.404116889606898, 4.000993420864787],
              [5.304669121197377, 3.996048861505157],
              [5.205222094822162, 3.991085089840908],
              [5.098996148152486, 3.987023280048339],
              [4.993824669368608, 3.9805279490845438],
              [4.888654485504942, 3.9740110975493192],
              [4.801944723596657, 3.9712211378898066],
              [4.680519592599577, 3.9631890309197466],
              [4.559096463000489, 3.9551282184293055],
              [4.472423231268022, 3.9509480065490843],
              [4.385750629327054, 3.946753194607181],
              [4.39036987645043, 3.953980149277714],
              [4.383101731937818, 3.978157554432355],
              [4.368723864444179, 4.005642716981564],
              [4.348791916830914, 4.028430486544873],
              [4.3351413100928315, 4.066857750831702],
              [4.321778596865963, 4.076169410456324],
              [4.285209606468988, 4.084890654448231],
              [4.223898431868165, 4.094995630741899],
              [4.188424463207493, 4.104575749077036],
              [4.172686905050235, 4.112931939096705],
              [4.149806807377635, 4.113093831065875],
              [4.128614085891687, 4.12418700588759],
              [4.116920604460896, 4.13841521372904],
              [4.075049177232609, 4.159635067939449],
              [4.063635406685303, 4.179217188697834],
              [4.051873209735334, 4.2282807666640005],
              [4.050358288896139, 4.249449458696912],
              [4.038002938743635, 4.256132352926128],
              [4.039932152486227, 4.271191420938312],
              [4.031540748571291, 4.304121271019501],
              [3.9969802953886022, 4.329236745494542],
              [3.992797697694515, 4.3595432492488575],
              [3.9939629024301357, 4.382797185730792],
              [3.969664977463491, 4.45722402489408],
              [3.964742116829608, 4.48579567913238],
              [3.9659820578869245, 4.5223340666116325],
              [3.96271560992577, 4.547361153597211],
              [3.9864216336447815, 4.576198394495659],
              [4.001667765287336, 4.621077757610824],
              [4.0290670833390205, 4.650470806926574],
              [4.043192313618133, 4.676992601701091],
              [4.021148443803267, 4.7138707932764525],
              [4.004411173013478, 4.734848915050221],
              [3.9879345185630863, 4.746746520033049],
              [3.9493510090735393, 4.764416021899368],
              [3.9342067299213963, 4.766837616388744],
              [3.924019340657423, 4.783142064142642],
              [3.934878932613338, 4.813226378255368],
              [3.9296851608718284, 4.837498480048964],
              [3.9099018409598267, 4.862300937371041],
              [3.9066529153251417, 4.876654016341807],
              [3.9176362422771662, 4.902042160745052],
              [3.915091965080603, 4.917702139268153],
              [3.9147439465526, 4.9296351062294],
              [3.9029267202414246, 4.940561097589038],
              [3.8938201742063403, 4.965322107357292],
              [3.90096097413512, 4.981422744848167],
              [3.9007878572833268, 4.998427678772984],
              [3.8725475836576306, 5.030609718879155],
              [3.8744526106400254, 5.06307513939992],
              [3.8684102454542835, 5.070054487019993],
              [3.8680367208780506, 5.125017517969159],
              [3.8765909539123293, 5.149185777469666],
              [3.8756431312112998, 5.160497274366583],
              [3.8822632390049927, 5.190657072885054],
              [3.868243892526943, 5.207479597530223],
              [3.849927421544077, 5.261530078502435],
              [3.8296556775033492, 5.280865462447206],
              [3.8217170575211914, 5.301603448417808],
              [3.8086916778230693, 5.3101457871908595],
              [3.793906357815223, 5.329005768596543],
              [3.7878031085984927, 5.346373378542883],
              [3.7717774084259412, 5.364962458694812],
              [3.7568183003139706, 5.373935357547242],
              [3.730280662293437, 5.410249465655888],
              [3.7010890779522647, 5.415506477604009],
              [3.6817839621059876, 5.4254324527863815],
              [3.6273664830092156, 5.431293919747972],
              [3.608738350090885, 5.450412338792868],
              [3.581286680635796, 5.46457952669037],
              [3.5533759908367517, 5.497926597583943],
              [3.5345201987001644, 5.503580748147969],
              [3.5315494371015053, 5.520017694614508],
              [3.5166588955145697, 5.5317665585000055],
              [3.5014969872806634, 5.532975304416417],
              [3.484679281918622, 5.544977228952378],
              [3.4533518201128106, 5.5602862014224375],
              [3.4442554354306463, 5.573996241310639],
              [3.4104432210980233, 5.594739091242793],
              [3.3962333254940353, 5.628676392229273],
              [3.399354507268368, 5.640050965882511],
              [3.3926750733801345, 5.666350625839855],
              [3.374528949204346, 5.679047964693265],
              [3.37134937147913, 5.689500557904134],
              [3.3782672332857473, 5.704078373169959],
              [3.3687216851271855, 5.725801559159336],
              [3.357201606057932, 5.732732029324435],
              [3.3434406669657086, 5.750551413645488],
              [3.3076399807229153, 5.769240492731297],
              [3.286211512874187, 5.777440139567003],
              [3.2747189431902877, 5.789589712061335],
              [3.2332445091044812, 5.800441746058904],
              [3.2233531887950346, 5.808193663854813],
              [3.1961452042607132, 5.812179499684616],
              [3.158184497118737, 5.82194049761332],
              [3.1129587422733582, 5.855245871404218],
              [3.09383350764809, 5.881100472875928],
              [3.093023833958534, 5.897225469791879],
              [3.0839390600522116, 5.918356153149307],
              [3.0728239978720158, 5.93078106607714],
              [3.05940274951966, 5.936506632994133],
              [3.0113187435443045, 5.937887598314894],
              [2.99579680367073, 5.929750915825865],
              [2.964206930772059, 5.944034377958222],
              [2.955192713852556, 5.941495016929769],
              [2.9374208447493317, 5.949943532750431],
              [2.921948948270156, 5.941475030730066],
              [2.900121943405006, 5.97688088292637],
              [2.8915882409232676, 5.973905636456872],
              [2.8770420904037364, 5.9845473647551195],
              [2.862782837545157, 5.986998959188802],
              [2.861732642857391, 6.01086504486837],
              [2.8540167611148095, 6.020609560649908],
              [2.8303888830118864, 6.034094132626254],
              [2.803621633825116, 6.063448987541021],
              [2.7770729892087274, 6.085871528482479],
              [2.740490757026866, 6.104846388993138],
              [2.725789593026267, 6.118347192815585],
              [2.7271342197409045, 6.13522837812159],
              [2.7381698273707014, 6.154966832951132],
              [2.743237541921643, 6.179847854291902],
              [2.7529903839404426, 6.208557966846044],
              [2.749566893184944, 6.229462682596363],
              [2.7526126444521997, 6.243252884855632],
              [2.7444206388299013, 6.259804334363578],
              [2.754758000743028, 6.275156181778214],
              [2.760047797265192, 6.304662008511522],
              [2.7566203686406534, 6.32293902309245],
              [2.745580968320661, 6.338880639226186],
              [2.7433258745642273, 6.367909104824772],
              [2.747069514465347, 6.395305655619384],
              [2.7234199689609584, 6.416292754341062],
              [2.7188115998722586, 6.43082641187625],
              [2.726356268637587, 6.445257451813903],
              [2.758216318978694, 6.474861618893018],
              [2.7520138198237167, 6.508247475894252],
              [2.7507121497380447, 6.539891494283466],
              [2.7416325163813378, 6.548434544675781],
              [2.7415596403306206, 6.570372429676684],
              [2.7496717212363073, 6.584375217029252],
              [2.742608467161443, 6.61490457323647],
              [2.748200670291432, 6.627094662614746],
              [2.7422793128462897, 6.656030728816301],
              [2.7571231022685616, 6.665976056065657],
              [2.7754795473259066, 6.687329382619776],
              [2.782682676449083, 6.702562720576488],
              [2.7785109629861378, 6.719604007979656],
              [2.7952982594839715, 6.739121838061411],
              [2.805166319842896, 6.759940465470505],
              [2.814580973213269, 6.765435910977094],
              [2.815739168612731, 6.8083382624829865],
              [2.811011329738532, 6.820983410480354],
              [2.791366929931451, 6.830053516800189],
              [2.774959282622702, 6.858002575432256],
              [2.757090981439768, 6.878663877182908],
              [2.756589937277816, 6.905117847636456],
              [2.724810935001761, 6.929688231592435],
              [2.7139193144908043, 6.930263990843465],
              [2.6878615955584007, 6.922488042788071],
              [2.654207340956972, 6.927980360528395],
              [2.6450837257656334, 6.935529619346417],
              [2.6447986464380513, 6.9700075954690845],
              [2.6400798319832917, 6.998435872468748],
              [2.645496402283644, 7.025016292111781],
              [2.650591466555562, 7.0767520122083925],
              [2.691143652865213, 7.104488743297832],
              [2.7080662128045123, 7.124921757003929],
              [2.7109359195084015, 7.143239459103944],
              [2.725075101147218, 7.172138974060945],
              [2.719137607170207, 7.187843358111036],
              [2.736845491600349, 7.208604229258006],
              [2.73979170525222, 7.229061309178372],
              [2.757211757360641, 7.256224084284431],
              [2.7784637842405866, 7.268329046075514],
              [2.7785709803696648, 7.273985800216731],
              [2.8029480646100584, 7.295065885733838],
              [2.8636207058575076, 7.316227774117998],
              [2.864508390698885, 7.332450890500638],
              [2.8832334428967163, 7.3492009876490885],
              [2.9051328598246666, 7.341433569209362],
              [2.9235459598743154, 7.34281139590664],
              [2.937508044797488, 7.382880695303158],
              [2.952095958526152, 7.3939199004958915],
              [2.9933062318454833, 7.381930171754173],
              [3.005499256755175, 7.397676749963796],
              [3.00514247047115, 7.411996084097531],
              [3.0150789605688266, 7.435352255955749],
              [3.0382561042983802, 7.444365528315173],
              [3.0257305451532353, 7.783220495805177],
              [3.018524763055728, 7.988230213672524],
              [3.0165175604667116, 8.028743845515324],
              [3.035133130103164, 8.014651967385646],
              [3.0720692854887255, 8.015013639188503],
              [3.076229770911781, 8.02979392574309],
              [3.0951640730380126, 8.055725701309825],
              [3.074588874151701, 8.067053195346089],
              [3.085406756794856, 8.08229092961002],
              [3.1148990878698304, 8.081888366877864],
              [3.1197202037904046, 8.105379774647783],
              [3.1339898041431433, 8.11493830722498],
              [3.1525888167537928, 8.11628593370485],
              [3.1924033350941334, 8.078134816954382],
              [3.205364789869224, 8.07623315619551]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.01208169858565, "lat": 44.63718274228952 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779806"
      },
      "bbox": [
        2.6400798319832917, 3.946753194607181, 6.906359618048674,
        8.49630222464315
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.14653520905366, 4.808290704311723],
              [18.153094750460937, 4.83477879051892],
              [18.172995922788665, 4.835031941225516],
              [18.171711167201032, 4.844088504512075],
              [18.19507149145697, 4.84727250767765],
              [18.17158224979579, 4.816369209830441],
              [18.14653520905366, 4.808290704311723]
            ]
          ],
          [
            [
              [18.108950138146184, 4.639458532316917],
              [18.126372601381444, 4.657064739760668],
              [18.156878021896077, 4.6505810982323705],
              [18.140589245868348, 4.635800259324974],
              [18.108950138146184, 4.639458532316917]
            ]
          ],
          [
            [
              [16.709995669717824, 3.687383187720213],
              [16.715863393444224, 3.6996672499973027],
              [16.70761750768484, 3.723499099375544],
              [16.719209972210525, 3.7386072385764826],
              [16.730542731538634, 3.7431137525919604],
              [16.73266211499832, 3.789698373155889],
              [16.722072556851053, 3.81786702602754],
              [16.738331257264644, 3.8352805827215763],
              [16.75458904722435, 3.831374336417132],
              [16.787443772625263, 3.8480695901450135],
              [16.80725296376612, 3.855052085395391],
              [16.818077236204633, 3.832640454573129],
              [16.836502604650892, 3.815911613236037],
              [16.825571138508245, 3.787111448981686],
              [16.805466553207204, 3.751057908423669],
              [16.759555900885275, 3.7108480079761748],
              [16.75413290425644, 3.6999513496004854],
              [16.719263274969027, 3.6773237853198655],
              [16.709995669717824, 3.687383187720213]
            ]
          ],
          [
            [
              [14.467709206111628, 6.65543336602906],
              [14.480600396123318, 6.681204943469048],
              [14.496558671454393, 6.687205990369254],
              [14.487646366585128, 6.661397239730488],
              [14.467709206111628, 6.65543336602906]
            ]
          ],
          [
            [
              [14.416803450741215, 6.8073243987330745],
              [14.42377317883533, 6.822072353455788],
              [14.442207525852515, 6.825241589158195],
              [14.44047418854149, 6.811011230607782],
              [14.422233247685641, 6.802310181939746],
              [14.416803450741215, 6.8073243987330745]
            ]
          ],
          [
            [
              [14.402358108869858, 6.652205244833436],
              [14.423956505517317, 6.687702620747675],
              [14.437972707985482, 6.677440507344255],
              [14.414964909001727, 6.6554165962863046],
              [14.402358108869858, 6.652205244833436]
            ]
          ],
          [
            [
              [12.34107876064715, 4.611228174705898],
              [12.39331123131562, 4.649335967529983],
              [12.466172691551929, 4.715699523672161],
              [12.50325527733904, 4.753914187771249],
              [12.525607272306452, 4.780143692438701],
              [12.539771748932461, 4.789616976830735],
              [12.55633887011074, 4.8130908786272615],
              [12.55793045681554, 4.834444766306873],
              [12.567136219070724, 4.837318855928049],
              [12.59369721549294, 4.869401984820756],
              [12.595607468462456, 4.88121655979985],
              [12.614402891361944, 4.8819376403339],
              [12.621745478907423, 4.896903306142517],
              [12.648909400507138, 4.91076247194205],
              [12.663722459554663, 4.929162359684889],
              [12.71253779853297, 4.963367751053106],
              [12.73461782183278, 4.969228422732799],
              [12.74001789636523, 4.981182271493064],
              [12.74126765296781, 5.007604345045577],
              [12.75092140152625, 5.032928850606023],
              [12.779586013671898, 5.070041040783285],
              [12.776563834649581, 5.089782068095184],
              [12.783504398116477, 5.118185227653556],
              [12.810324964658323, 5.136460503772492],
              [12.820963871139444, 5.139191047276534],
              [12.849967470821374, 5.171510441465418],
              [12.867693078784253, 5.180112358459956],
              [12.899153869153928, 5.220924128845627],
              [12.903801997166367, 5.244609990266932],
              [12.885584743819857, 5.270331606563865],
              [12.892638311018072, 5.288005354179128],
              [12.880116004566785, 5.299305472112136],
              [12.847209509203337, 5.3413990269471565],
              [12.843183693432842, 5.365130255425018],
              [12.829503019105998, 5.386570113660832],
              [12.818217770777025, 5.393688094076874],
              [12.796823886695394, 5.391757313739109],
              [12.785328276549073, 5.400876545435802],
              [12.756243282977781, 5.412426352066049],
              [12.748531642062204, 5.420704108543404],
              [12.742316199587183, 5.441559438265092],
              [12.748286620299702, 5.455449549687529],
              [12.752258373321766, 5.483729879491804],
              [12.745021112297424, 5.492293423212619],
              [12.694716371370637, 5.495565938166621],
              [12.701329493685092, 5.5263443351658434],
              [12.69105951234093, 5.537720681640619],
              [12.70592646612256, 5.564483048679446],
              [12.692934056254247, 5.592652041531262],
              [12.691444986773885, 5.618815686981316],
              [12.676447439221706, 5.6715218143902755],
              [12.664694162421288, 5.677848484947816],
              [12.698781653257674, 5.695379378566309],
              [12.720739975909092, 5.703520172389984],
              [12.75876814001263, 5.7260749144318215],
              [12.81190216896162, 5.754968246939944],
              [12.821550354111247, 5.763062815506211],
              [12.864222885253383, 5.780046325021087],
              [12.894196671624973, 5.797215914388888],
              [12.923522131945619, 5.807061517338671],
              [12.958164068292541, 5.827844869507932],
              [13.017834796646861, 5.850957566264376],
              [13.058504529348156, 5.863794003231183],
              [13.070437684635484, 5.86198952171148],
              [13.142532241950404, 5.88119648739068],
              [13.166793083487473, 5.881781017720089],
              [13.226661249021168, 5.89236080345125],
              [13.241025367503783, 5.8920911842126396],
              [13.279711990272666, 5.901041404798707],
              [13.292351578756076, 5.907576215431866],
              [13.331542581515397, 5.91585620302711],
              [13.384094307903528, 5.917084201085872],
              [13.407926505846007, 5.919690198134597],
              [13.431920342166814, 5.9272535885654385],
              [13.464221758509478, 5.922134426119194],
              [13.556542946440917, 5.922464490323913],
              [13.58268578278175, 5.928839453997492],
              [13.618817079121076, 5.917908173856611],
              [13.625841294605861, 5.906319683377758],
              [13.670206209103585, 5.882987120737667],
              [13.689872981846438, 5.8784793605181695],
              [13.731622784168026, 5.858050734881425],
              [13.751709202501424, 5.854333308462763],
              [13.766576900627163, 5.857477939942419],
              [13.784500848508495, 5.8756334433700985],
              [13.794464821030134, 5.877684930676945],
              [13.823927234044465, 5.8961633861940514],
              [13.863399513780529, 5.916604834529173],
              [13.892173245469312, 5.927719862824615],
              [13.947459226975514, 5.935317601734287],
              [13.98172591093421, 5.949016502404388],
              [14.011336167226947, 5.952265281619719],
              [14.026457810065253, 5.963157398069726],
              [14.036588954519303, 5.961436071766992],
              [14.056663323294217, 5.969286730708048],
              [14.100544445883825, 5.965630641538269],
              [14.10620780200708, 5.960062429977408],
              [14.127159922154535, 5.963853008226305],
              [14.143834541809511, 5.971701922583591],
              [14.171238906723719, 5.973175714158181],
              [14.205006338963956, 6.005953690762545],
              [14.218962099813215, 6.005691109240214],
              [14.24179907487037, 6.023051806017615],
              [14.274861423404586, 6.033828417397476],
              [14.295183992639256, 6.050063112543342],
              [14.314541431273959, 6.076990556141929],
              [14.338199814492755, 6.084610760078399],
              [14.351421418976253, 6.107791875591114],
              [14.36942172577776, 6.159262492911837],
              [14.389739066842996, 6.174671425478582],
              [14.410691941767178, 6.203398044886949],
              [14.458520044061498, 6.240882023366602],
              [14.466573629073554, 6.263127619038791],
              [14.502655406912787, 6.298809415628844],
              [14.531627196750632, 6.307553534337368],
              [14.550680645659758, 6.298888209550509],
              [14.588922142052107, 6.307226912340241],
              [14.596788177097121, 6.315922463237735],
              [14.62486169219219, 6.330542510617349],
              [14.633031185096769, 6.3427783876940484],
              [14.638214646964462, 6.380000298659082],
              [14.635980594355056, 6.405524384154106],
              [14.62475650066037, 6.467135323916683],
              [14.61466054819061, 6.4991889694116916],
              [14.594286437028899, 6.552881178128484],
              [14.572483711815071, 6.59991690822554],
              [14.56437969196314, 6.610074183341035],
              [14.530585224897012, 6.628688856811036],
              [14.516291260995281, 6.6231860239295495],
              [14.51386672409085, 6.640433801999217],
              [14.519357001926535, 6.653971422274149],
              [14.534570475762722, 6.6712148435278165],
              [14.55271825259458, 6.679483270343861],
              [14.56120726944156, 6.6750019053360825],
              [14.554466408277838, 6.6567460610773255],
              [14.578863869174542, 6.66319036267426],
              [14.608031812962848, 6.695425809568024],
              [14.624661962243138, 6.706447701673668],
              [14.615110542269894, 6.740300995549241],
              [14.607456014672902, 6.7465320235287916],
              [14.626379928030989, 6.766816212103881],
              [14.639240544241781, 6.790188180612406],
              [14.655834630884534, 6.791147261845567],
              [14.650405408680133, 6.813147087407721],
              [14.637569410378019, 6.815810149327824],
              [14.61186662292294, 6.777065743310777],
              [14.589677136946253, 6.76135085785891],
              [14.559105254333478, 6.764452254578665],
              [14.551260681492455, 6.780017046924582],
              [14.561241464130626, 6.796778193629489],
              [14.586758556058564, 6.810628770055631],
              [14.601056202184742, 6.830379810324806],
              [14.598964127993566, 6.845065793094906],
              [14.581241058840089, 6.832746681836779],
              [14.56788518120832, 6.833817111240001],
              [14.579070199818407, 6.856890778046687],
              [14.571321198508196, 6.8656556948389245],
              [14.558860405716965, 6.863871478105732],
              [14.538137933884746, 6.847573677559457],
              [14.523471615203764, 6.8570160575238175],
              [14.506252580636222, 6.851668266169819],
              [14.497003283410839, 6.83739516638844],
              [14.489476955397677, 6.802388693435803],
              [14.496334555399915, 6.798958311188026],
              [14.525352763491192, 6.81877425096198],
              [14.542937433049243, 6.822480172006832],
              [14.545555386823537, 6.813634751450636],
              [14.536568702085692, 6.794658327686206],
              [14.530871618298786, 6.768285242400605],
              [14.509984483918544, 6.7471134232353265],
              [14.500255510182582, 6.750653241832113],
              [14.50824506556947, 6.76954091298266],
              [14.507134645083749, 6.781205176587746],
              [14.477073086245657, 6.800504337420598],
              [14.476862825184167, 6.823993330396322],
              [14.472493245157263, 6.839409963079487],
              [14.45927449043098, 6.836167129059903],
              [14.42519595767333, 6.846073408556867],
              [14.432971164672914, 6.85810639789763],
              [14.411840614225733, 6.872499579065386],
              [14.423495027212184, 6.894826975662962],
              [14.417551568432831, 6.9042801883316915],
              [14.432324219264743, 6.972810238006546],
              [14.449599583798165, 6.981228392591825],
              [14.478331196368966, 6.987130448554782],
              [14.51254838311394, 7.0121886096527515],
              [14.527647069368133, 7.034043618952902],
              [14.520788102217546, 7.074499563175025],
              [14.539096973012715, 7.094486322430239],
              [14.561896775657592, 7.102253421462381],
              [14.59154899572426, 7.141255347915154],
              [14.619088616230403, 7.163171483833338],
              [14.641560377164305, 7.163155897199356],
              [14.654634558416548, 7.1723370631374745],
              [14.676133006162885, 7.196197480496623],
              [14.699408681694607, 7.228381978914752],
              [14.726798617630104, 7.272291468955173],
              [14.727555063054815, 7.312538804785268],
              [14.747096238481948, 7.3616940114230065],
              [14.768610934401217, 7.393734978544954],
              [14.803090171735189, 7.451114879579901],
              [14.827739518404861, 7.484606775666895],
              [14.887446793682773, 7.584425030023154],
              [14.903775954823171, 7.603370604060133],
              [14.93319776451978, 7.646486725530812],
              [14.936734951341164, 7.663733951868476],
              [14.94814827687137, 7.667176709812681],
              [14.9638054288294, 7.685434333564047],
              [14.97674857001298, 7.709690377171076],
              [14.984809518300754, 7.708647694487738],
              [15.002392585582598, 7.7330970190621295],
              [14.996282240883808, 7.742102600382957],
              [15.048973030455128, 7.795109604961904],
              [15.059726202254666, 7.797456483366467],
              [15.08245476893895, 7.818506630506066],
              [15.099158247424143, 7.825611610919043],
              [15.098903051220844, 7.844278994122189],
              [15.122343579275386, 7.861628428773853],
              [15.143783526708303, 7.868801541549533],
              [15.178590855271729, 7.905966863003101],
              [15.18295754773988, 7.926301131034434],
              [15.195635555371927, 7.935175528871381],
              [15.240095459463337, 7.945051693392027],
              [15.250276424581767, 7.964292961475116],
              [15.264768825198109, 7.968034453686788],
              [15.28897367876064, 7.9890288566253425],
              [15.306429558283183, 7.991644821378372],
              [15.314473531084325, 7.983363485319556],
              [15.334738713918059, 7.988902747177391],
              [15.33930372198392, 7.979082850435103],
              [15.360220392816913, 7.979193111393739],
              [15.37751544241374, 7.996213276031917],
              [15.390747679392579, 7.995507217049047],
              [15.468975825543174, 8.011931935593402],
              [15.547207196545333, 8.028339684578919],
              [15.632546225262498, 8.04266713077392],
              [15.762205397957716, 8.072170071973623],
              [15.854645518303814, 8.098694364232205],
              [15.947093512157336, 8.125194042293828],
              [16.023305072805112, 8.145181054856712],
              [16.107911348221272, 8.165429180534204],
              [16.176690712522017, 8.184754515656646],
              [16.245474228628442, 8.20406624325561],
              [16.309757524628914, 8.221168207735548],
              [16.307412030099883, 8.196649020155167],
              [16.32340092680699, 8.17859863722098],
              [16.333454536969622, 8.138400218556317],
              [16.32590753611177, 8.116566333216563],
              [16.32598572069884, 8.078000594312696],
              [16.32267271376719, 8.055100540665705],
              [16.337847086348756, 8.039793031517368],
              [16.36381875510735, 8.023736672497396],
              [16.369143530172916, 8.008843850839435],
              [16.363293283475766, 7.991333696503528],
              [16.357937481008616, 7.958185921236341],
              [16.36810505111249, 7.9154640752012195],
              [16.3702677130152, 7.886546964530139],
              [16.368214798576187, 7.85298654623581],
              [16.37064427746011, 7.833996589225154],
              [16.383758976705685, 7.819153150415626],
              [16.382737285029183, 7.808401293243921],
              [16.4074673569484, 7.782261390978051],
              [16.418461127652325, 7.778763867927719],
              [16.442793670225026, 7.745499427134616],
              [16.455711438788548, 7.735019577816192],
              [16.466044092718995, 7.713297736575931],
              [16.480170894760555, 7.667298737295178],
              [16.4764749617763, 7.625670847406849],
              [16.467467686335652, 7.606902219675848],
              [16.47038288047774, 7.59183932303149],
              [16.483213510401157, 7.571364955605299],
              [16.488698371397472, 7.548315449812622],
              [16.50633853579713, 7.515951026913406],
              [16.504812541913502, 7.484526396854399],
              [16.48977334536018, 7.467041611778762],
              [16.486520345820136, 7.443932311098917],
              [16.471131467633015, 7.420296137965728],
              [16.473302707204272, 7.376575560956839],
              [16.467080034544182, 7.361739661778362],
              [16.474928006240287, 7.343003312728261],
              [16.470318032960364, 7.307824978254805],
              [16.472523095133, 7.273115699142031],
              [16.495561438250604, 7.260148042028212],
              [16.502556538043265, 7.245993280730847],
              [16.50537901496644, 7.214395239417815],
              [16.512406315877406, 7.203109975793897],
              [16.519302188210133, 7.169534784001336],
              [16.53523348420735, 7.142734210788473],
              [16.557226326749436, 7.118423940142755],
              [16.555629724711906, 7.102736665270816],
              [16.565379252939778, 7.090836148926981],
              [16.556539613612305, 7.064983138445782],
              [16.573532601612982, 7.045049805044073],
              [16.589716105458585, 7.035788905350227],
              [16.59789161853208, 7.02340826927932],
              [16.591073917792837, 6.993391597557522],
              [16.59494078548293, 6.974891457579431],
              [16.580556823065915, 6.938375645244459],
              [16.581967536039876, 6.914435552923905],
              [16.576346278765474, 6.87716641946652],
              [16.58568810905929, 6.868020164985181],
              [16.58775569245817, 6.828159143945575],
              [16.612908672769596, 6.817861491649658],
              [16.620914837026735, 6.827431969326622],
              [16.615720683259227, 6.842334830144198],
              [16.617844907421148, 6.864749978176316],
              [16.62710784697662, 6.879777664624228],
              [16.655295033191457, 6.888929498383815],
              [16.666852080162126, 6.8886523019677695],
              [16.68959289919088, 6.847868217120653],
              [16.71141640135401, 6.8384471116806855],
              [16.730194411185124, 6.81217084999777],
              [16.72902252212076, 6.802496564461824],
              [16.785721437317196, 6.542417792007646],
              [16.818157764203956, 6.382661412481758],
              [16.829552150200094, 6.323399764474288],
              [16.87149820224348, 6.125169840636767],
              [16.870302813781333, 6.092463025852894],
              [16.893911768776178, 6.040627719186864],
              [16.902060924292833, 6.042522196775324],
              [16.898034568581473, 5.878557134458239],
              [16.89403914848875, 5.7145069684595695],
              [16.889891681911838, 5.542942512935105],
              [16.88521080237491, 5.358602322746027],
              [16.901920907041287, 5.324884086481278],
              [16.908785599680986, 5.326495530562303],
              [16.91884406805214, 5.277801850167428],
              [16.960520052022826, 5.038750298302886],
              [16.986073773221555, 4.901393741387843],
              [17.001414169233936, 4.809460846525806],
              [17.017934069959495, 4.717055270102266],
              [17.035144192448954, 4.609995968675279],
              [17.04098690174082, 4.579490184692928],
              [17.10999921259019, 4.510629640258678],
              [17.034197877470913, 4.434577310442071],
              [16.958410835479782, 4.358503898064173],
              [17.032003656790202, 4.28421029889332],
              [17.03466443577536, 4.261070048342278],
              [17.03849195621447, 4.241576133852156],
              [17.02690251473277, 4.233718022548872],
              [17.026314052326928, 4.218522578878585],
              [17.002296797206274, 4.194600708503607],
              [16.9813091602445, 4.169508766788729],
              [16.96974606735904, 4.138687865950396],
              [16.96614644394902, 4.108933540215232],
              [16.951452631293904, 4.101302485572098],
              [16.957728369699943, 4.079618028508436],
              [16.97982859844564, 4.056354785410727],
              [16.981526000055005, 4.0445182328126],
              [16.99804300577083, 4.0428008034268075],
              [17.014573374114896, 4.026801062544057],
              [17.01020317485158, 4.059462641545689],
              [16.99870254853095, 4.068449256095262],
              [17.0047472714778, 4.080305355091537],
              [16.999391692037634, 4.092420462306614],
              [17.042118180933453, 4.085575531066677],
              [17.03948307849111, 4.100218004038143],
              [17.019828530480822, 4.1020641722731215],
              [17.01138615461526, 4.127860668008703],
              [17.022435127851047, 4.135237624288413],
              [17.05267411758242, 4.129260628956009],
              [17.06981144571983, 4.109947630581484],
              [17.07429753697042, 4.1309631915358285],
              [17.064031130259224, 4.153652295938498],
              [17.07032089175744, 4.174207180952291],
              [17.096518442638786, 4.186865313432407],
              [17.11947047245312, 4.205812809721982],
              [17.134334161571143, 4.202035497883622],
              [17.139605487413473, 4.1802120732259285],
              [17.146358235652016, 4.171980993499777],
              [17.173162937295448, 4.177122139996467],
              [17.165900793138757, 4.188203228411191],
              [17.176410835009197, 4.197795764120885],
              [17.185642289866852, 4.181613111169596],
              [17.201665482543497, 4.174500639066437],
              [17.192638240417555, 4.199658724033721],
              [17.1676112277952, 4.227587696620472],
              [17.171096988851993, 4.249871868130214],
              [17.188926492451444, 4.245166229441472],
              [17.208400368476443, 4.246710807190285],
              [17.217968230228156, 4.234595715307847],
              [17.21497158605251, 4.224265443368724],
              [17.233500146298848, 4.221103678039021],
              [17.244554569948843, 4.22883612300418],
              [17.25870261519523, 4.2231968315141994],
              [17.270722391199666, 4.230016747612587],
              [17.27260249357649, 4.251517174237525],
              [17.25872312005619, 4.254345892245809],
              [17.24629710523226, 4.244460426280564],
              [17.234248811151133, 4.24951536277364],
              [17.229842868525257, 4.272314778868839],
              [17.23632902406673, 4.274817997361304],
              [17.261522641694718, 4.256492960529218],
              [17.278604104647467, 4.253092265447099],
              [17.28721356044385, 4.260543966364467],
              [17.31485713837958, 4.261973875490962],
              [17.337302313882624, 4.2573099614676195],
              [17.367828450226813, 4.255671943301969],
              [17.42155413993538, 4.292346853343904],
              [17.411717245340373, 4.32855232158354],
              [17.430718369618386, 4.344877673760607],
              [17.44432617034025, 4.339825008364342],
              [17.461526203469937, 4.347774699655034],
              [17.479875909196092, 4.344012486035696],
              [17.552111685600632, 4.363161278454141],
              [17.58304621294204, 4.366985628506428],
              [17.61757307518626, 4.377669822825172],
              [17.63984264725093, 4.3889687025734965],
              [17.68390232631458, 4.394933109041471],
              [17.703807185500125, 4.40312936282334],
              [17.72881229031492, 4.41910635346015],
              [17.780465012971042, 4.436262059162369],
              [17.813098116753174, 4.460635083548942],
              [17.851493181846813, 4.514362352006905],
              [17.878007675602213, 4.533572389250798],
              [17.88760188780493, 4.550657240358677],
              [17.892872265361433, 4.572467275551228],
              [17.91219914916641, 4.579251511645931],
              [17.925306931604457, 4.591222266319959],
              [17.931253012934775, 4.6116231513815515],
              [17.93896700303897, 4.618971142289742],
              [17.945536043330183, 4.641590715096659],
              [17.969363572021468, 4.64634710202386],
              [17.97346855851954, 4.657016643416083],
              [17.99539832564234, 4.673699377779629],
              [18.022953261061186, 4.675078598485081],
              [18.018963979769214, 4.6540384495007485],
              [18.004522241750646, 4.638167732922512],
              [17.978387467935914, 4.649749650280628],
              [17.967376269668183, 4.639047532374335],
              [17.96386714560961, 4.615423266491932],
              [17.979303948638506, 4.609327990884169],
              [17.98499242455111, 4.598404622862812],
              [18.01375429450326, 4.597142868810333],
              [18.014903090865314, 4.584441494044398],
              [18.02530590240818, 4.571064470208323],
              [18.02793013711194, 4.5552830615163],
              [18.050982238390358, 4.56965122581338],
              [18.09076421029644, 4.567140475196214],
              [18.105657831609356, 4.592321993632481],
              [18.12758808100514, 4.583915738507716],
              [18.13145879826537, 4.568536115580831],
              [18.15275364029118, 4.548962576231132],
              [18.170033627801114, 4.544620662074245],
              [18.178820494456986, 4.564376975389836],
              [18.19602349208793, 4.583709337493903],
              [18.218862696641352, 4.590535167884852],
              [18.23050819441198, 4.618055971271057],
              [18.24687762896789, 4.615721687040491],
              [18.25584691324644, 4.625753746898834],
              [18.24836009585159, 4.647655994828949],
              [18.284635618968256, 4.672325310573185],
              [18.293205344316636, 4.665602938474187],
              [18.323046763519134, 4.666732502565686],
              [18.31464432415083, 4.644830714598062],
              [18.26015330518945, 4.604491372970815],
              [18.215798812571958, 4.5652441828957935],
              [18.161094030672064, 4.5223394172959095],
              [18.084018255062517, 4.456382414928532],
              [18.018555355770147, 4.3978388101303745],
              [17.983059226487015, 4.367661917680617],
              [17.93506901881029, 4.3307354051879505],
              [17.807889517072507, 4.242621016349143],
              [17.73794704958433, 4.197227089063885],
              [17.675662957880434, 4.152094441826506],
              [17.63664529437044, 4.122045310410298],
              [17.57959666385411, 4.073127404008011],
              [17.53140314437609, 4.039618418431999],
              [17.44824013457212, 3.990421355093884],
              [17.410970100741846, 3.972100321650122],
              [17.37905408205548, 3.9630932693044083],
              [17.361586272343953, 3.9716370103829126],
              [17.343779592916505, 3.9646270244125725],
              [17.3002319430633, 3.934031012209203],
              [17.233015865686397, 3.898233313183962],
              [17.194964863894892, 3.874657642248738],
              [17.188416727496797, 3.8809048625234284],
              [17.164128008738373, 3.877043260407915],
              [17.143291320805282, 3.8670063153702854],
              [17.096051492848666, 3.8566014678521734],
              [17.043289752249006, 3.851377512518349],
              [17.002775634838997, 3.8279636900999128],
              [16.9738473638405, 3.8052639714544894],
              [16.955898888949594, 3.795128586966013],
              [16.934762101499775, 3.7770406242385945],
              [16.93096512866035, 3.786766057183604],
              [16.949457982860373, 3.802371104682796],
              [16.969786420832563, 3.8106494896182017],
              [16.953412660998865, 3.826683628096134],
              [16.9293857636764, 3.81562226118679],
              [16.921280801892344, 3.806815649795063],
              [16.889743910914834, 3.7942460269174174],
              [16.880399947477848, 3.8135423170744986],
              [16.852080111582005, 3.8211424062275205],
              [16.839621632703437, 3.8401137031689414],
              [16.841640534026013, 3.8587268209393195],
              [16.856269898647987, 3.8813647433023584],
              [16.844079122434845, 3.8961775734395663],
              [16.85033644418888, 3.9043048352716547],
              [16.83157027190263, 3.9348958022093887],
              [16.829565057711246, 3.9733535029158413],
              [16.850663097860256, 4.049998935219695],
              [16.852611213214338, 4.075477485943749],
              [16.860685568355123, 4.1162188869556156],
              [16.862921523675787, 4.157341884315765],
              [16.863595181696823, 4.21321862649404],
              [16.855250125765608, 4.227187024259033],
              [16.696987132502056, 4.277726629370518],
              [16.572917569497598, 4.315532594425661],
              [16.488600856266185, 4.342622165761066],
              [16.393944835200873, 4.378751175940339],
              [16.269433634895496, 4.421945685687195],
              [16.196942500218572, 4.446304334048551],
              [16.197471907840598, 4.456629453910387],
              [16.17626128692106, 4.474988610588784],
              [16.157872397956343, 4.479660987351045],
              [16.147043579550395, 4.510964356238263],
              [16.13599539277248, 4.500347669264019],
              [16.10913509381991, 4.4949809165996495],
              [16.09765265222831, 4.511053809092225],
              [16.077308081296, 4.495665651332965],
              [16.058743906607535, 4.504665380464603],
              [16.038267260102515, 4.4936980891135105],
              [16.029215718645055, 4.51218973159301],
              [16.015819289958856, 4.523848236037078],
              [15.996654634226262, 4.529722630455305],
              [15.979346687347421, 4.51973291309736],
              [15.961595795823294, 4.519406903938707],
              [15.953729167383932, 4.545101953827652],
              [15.94250542758762, 4.543400218651347],
              [15.935755663846537, 4.559033913175914],
              [15.91709651702876, 4.571073036660628],
              [15.918995420278366, 4.583852513355085],
              [15.899135697066031, 4.5978246427767075],
              [15.891603041649423, 4.610110005054482],
              [15.866486454439586, 4.627613507855495],
              [15.873706900819718, 4.639266574232751],
              [15.885788455708665, 4.6445477111229],
              [15.871843840781947, 4.687311445181493],
              [15.862833475386807, 4.6975004737347525],
              [15.864115327210385, 4.712173647229638],
              [15.84812418704286, 4.728945557664094],
              [15.860430022879742, 4.738824892058178],
              [15.849484782423005, 4.774908423782157],
              [15.829042382063095, 4.789873824147595],
              [15.807719351333072, 4.787884289809114],
              [15.813108953222379, 4.827579996823965],
              [15.790769933708864, 4.83407926085374],
              [15.785433408922765, 4.854285217295649],
              [15.764918183036817, 4.858458858888576],
              [15.750036580175706, 4.852847305319829],
              [15.741567622646402, 4.868661361767868],
              [15.731534186060555, 4.859722668517758],
              [15.719689574189847, 4.865622748014421],
              [15.707621612000217, 4.861552952076177],
              [15.703479711326096, 4.8503613318711425],
              [15.671648013483136, 4.856997460804576],
              [15.662632987540727, 4.87207473767093],
              [15.661031439192254, 4.891965975568265],
              [15.645771055234322, 4.9213483919421055],
              [15.631817248994462, 4.934381390204297],
              [15.62103150470146, 4.92626766589955],
              [15.603184121305684, 4.942088664886391],
              [15.592392320296314, 4.945952198074255],
              [15.589343139832318, 4.964259510096525],
              [15.574596969440341, 4.967873127490774],
              [15.484286228830488, 4.947903985777022],
              [15.393978836608264, 4.9279193095701315],
              [15.299100430540065, 4.906266330875082],
              [15.206236773372428, 4.887296290748189],
              [15.114931285816658, 4.8679346063919615],
              [15.023629049355932, 4.8485571244405605],
              [14.864897893795202, 4.814556779392628],
              [14.779236644825733, 4.7973055031897545],
              [14.675077232133289, 4.777248539566399],
              [14.5709215248881, 4.7571711980119895],
              [14.447207549225311, 4.732055321192163],
              [14.30021283496757, 4.699973105986153],
              [14.16242329168816, 4.6729851937890325],
              [14.024640535073686, 4.645961624140816],
              [13.906480187687754, 4.622182877282049],
              [13.788325086143125, 4.598377870833863],
              [13.66837904469005, 4.57558782351628],
              [13.575850911326695, 4.559700884943559],
              [13.469938790318691, 4.538174668966248],
              [13.3518261833645, 4.516639184308593],
              [13.233718185740868, 4.495077679568177],
              [13.122939027583389, 4.472912910806083],
              [13.032301213213584, 4.455829739097817],
              [12.953417878340668, 4.442968574651726],
              [12.811345848766242, 4.418002727569611],
              [12.70468009800133, 4.398548061462899],
              [12.598018203730179, 4.379072203781372],
              [12.45415554271507, 4.355128126029702],
              [12.387857959324206, 4.3434164872075876],
              [12.34107876064715, 4.611228174705898]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.50381972650405, "lat": 42.9409425866198 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779796"
      },
      "bbox": [
        12.34107876064715, 3.6773237853198655, 18.323046763519134,
        8.221168207735548
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.27327646575219, 2.988473635073093],
            [-9.150306875384137, 2.9710401708504883],
            [-9.00806780267587, 2.9519816117032867],
            [-8.86583283172655, 2.9328922141929854],
            [-8.773059865598668, 2.9207669399564216],
            [-8.680288600482735, 2.9086285604364357],
            [-8.528513625240134, 2.8911269625129794],
            [-8.372208206620261, 2.871634372462276],
            [-8.215907393206912, 2.8521046310531797],
            [-8.119936278120374, 2.840941747788259],
            [-8.023966758867122, 2.8297648859520534],
            [-7.9301751190782035, 2.8182973445971453],
            [-7.751262832458146, 2.7979412700785105],
            [-7.645155652885323, 2.784908548505112],
            [-7.494980508764134, 2.767730701451386],
            [-7.344809283207848, 2.7505186576008445],
            [-7.246406076305771, 2.7367605669255215],
            [-7.1694706294964305, 2.7270175767608134],
            [-7.053153807749678, 2.7138309752971077],
            [-6.927946869080648, 2.7007324728379034],
            [-6.802742404500524, 2.6876102794907473],
            [-6.686488272819081, 2.6763351684224164],
            [-6.570236090134439, 2.665039662104415],
            [-6.452546078389735, 2.653881702359018],
            [-6.303714555722924, 2.6396091069232583],
            [-6.154886238636301, 2.62530309182903],
            [-6.1355671374760625, 2.6247386442670964],
            [-6.021001766054384, 2.6158757099714456],
            [-5.865661957523721, 2.602364174275008],
            [-5.711157548943858, 2.5888999126816556],
            [-5.556656276441772, 2.5753996714605933],
            [-5.4470764537103555, 2.5661678276211304],
            [-5.330786142125657, 2.55725142965392],
            [-5.236407238630318, 2.54946704161374],
            [-5.142029450509161, 2.5416692392524842],
            [-4.985420421748122, 2.5300025836339626],
            [-4.828814117902616, 2.5182990331582498],
            [-4.670575084492804, 2.5063688140816587],
            [-4.555218965291271, 2.4983440832751795],
            [-4.439864232018421, 2.490299349649632],
            [-4.340757207582826, 2.4835980639049784],
            [-4.24165118216062, 2.476882017762314],
            [-4.062582575589385, 2.4654205927326167],
            [-4.078561452865083, 2.2112145535903447],
            [-4.092476446724796, 1.9982275546478367],
            [-4.1049663755436905, 1.7975067964893765],
            [-4.117688383290835, 1.6062847851201676],
            [-4.126822499258076, 1.4600188352959906],
            [-4.136532180492734, 1.3056858477867548],
            [-4.148744384338328, 1.1004387588694535],
            [-4.162242097950218, 0.8760626106721703],
            [-4.16925607881352, 0.7549380954427215],
            [-4.184257398984513, 0.49683040895674296],
            [-4.198344278634931, 0.2613491345296642],
            [-4.2073297162853525, 0.11645478357088274],
            [-4.221384381258824, -0.1011709061823192],
            [-4.233735993570824, -0.30642703614386174],
            [-4.2470506188801975, -0.5124830493818544],
            [-4.2612616564715315, -0.7564329882277453],
            [-4.2680813557071815, -0.8805458359628718],
            [-4.277740260036826, -1.0268067269080536],
            [-4.2894241659620205, -1.2108373293953443],
            [-4.302972944334442, -1.4232756543569378],
            [-4.312581802134678, -1.5730893088079339],
            [-4.559765402927883, -1.5553742726339366],
            [-4.830228801763204, -1.536198028501368],
            [-4.920104333883186, -1.525171146670728],
            [-5.057859590965613, -1.516372094707364],
            [-5.069750699194865, -1.5138966209814764],
            [-5.190993485281601, -1.5047230305346424],
            [-5.440215575690302, -1.4867408028458098],
            [-5.6472966178118105, -1.4711360546518002],
            [-5.863036259101317, -1.4550594123417042],
            [-6.12411375218037, -1.435298967181331],
            [-6.349154299249158, -1.414315783822781],
            [-6.365373820397578, -1.4138511608283093],
            [-6.645407195430993, -1.3879043989663464],
            [-6.66803871802045, -1.3862944332760028],
            [-6.739885136192615, -1.3766785843471137],
            [-6.996825933589092, -1.3509097536230035],
            [-7.138695027911062, -1.336972436981272],
            [-7.4288075441795245, -1.307188716191141],
            [-7.590435192052807, -1.291270192932592],
            [-7.7018345666129955, -1.2790764343004235],
            [-7.917417773040539, -1.2564965133418666],
            [-8.116051019118409, -1.2345023559896153],
            [-8.121052616545114, -1.226090556880314],
            [-8.37214944815262, -1.1968863520768096],
            [-8.595859677603729, -1.1701312034340023],
            [-8.776953644506646, -1.1479302370676179],
            [-9.003153533422367, -1.1195724909484932],
            [-9.198423776931506, -1.0955334649141495],
            [-9.19935461445599, -1.0948570412146987],
            [-9.42350897042423, -1.0657097505154773],
            [-9.590672354069358, -1.043530342410286],
            [-9.822358383519017, -1.011957823660947],
            [-9.798343407154421, -0.8336630314228928],
            [-9.770881369127915, -0.6359331943621936],
            [-9.746294657075527, -0.48058563335361765],
            [-9.727913507216279, -0.34516181234931775],
            [-9.693661694162007, -0.10404451017355784],
            [-9.685999246617166, -0.03677772534566125],
            [-9.658643807393803, 0.15357022278633936],
            [-9.65743180599137, 0.26635161200307717],
            [-9.626302244904604, 0.49089603178816926],
            [-9.595564488867396, 0.7107925748177759],
            [-9.570026327162434, 0.8653388967945008],
            [-9.53327536008065, 1.1161658604733782],
            [-9.499460624173555, 1.3566261385189542],
            [-9.481808287540483, 1.4876710011759766],
            [-9.459074018911512, 1.6503271842902765],
            [-9.429118939720349, 1.8646374205922518],
            [-9.381359885475707, 2.2119980690546406],
            [-9.350722291586779, 2.433404587672387],
            [-9.336816606898928, 2.5291464724405746],
            [-9.3244135710859, 2.607669606357837],
            [-9.31203169768867, 2.7029239453787515],
            [-9.296167829565377, 2.81414283608019],
            [-9.27327646575219, 2.988473635073093]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.54785394257894,
          "lat": 38.99852361255616
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779779"
      },
      "bbox": [
        -9.822358383519017, -1.5730893088079339, -4.062582575589385,
        2.988473635073093
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [4.786181400796913, 9.401793743665047],
              [4.79333521426434, 9.413149037525033],
              [4.81138466839343, 9.408945403650188],
              [4.790524655171234, 9.39433394540489],
              [4.786181400796913, 9.401793743665047]
            ]
          ],
          [
            [
              [-0.35246367901907194, 10.271623053199017],
              [-0.2535725701331642, 10.270253446308338],
              [-0.15468210393006357, 10.26885013600537],
              [-0.06772971114267375, 10.268142918108639],
              [0.019222458772877194, 10.26740964707887],
              [0.09567055262124012, 10.267092398819102],
              [0.17211860478283775, 10.26675501285784],
              [0.24856656241885827, 10.266397489390359],
              [0.32501437269030625, 10.266019828568979],
              [0.39848807248801393, 10.265952121538062],
              [0.471961751215058, 10.265865814117175],
              [0.5454353619654487, 10.26576090632258],
              [0.6189088578367515, 10.265637398133906],
              [0.6849606929594602, 10.2657557884739],
              [0.7510125111561824, 10.265859146617041],
              [0.8170642783542272, 10.26594747246841],
              [0.8831159604859138, 10.266020765909206],
              [0.954521720173388, 10.266660277077287],
              [1.025927673747486, 10.267282219469788],
              [1.0246089997452297, 10.441311808640677],
              [1.0228031475198278, 10.641303024596539],
              [1.040664798812493, 10.627005053461017],
              [1.0857744948731887, 10.611661440890238],
              [1.1148002860741333, 10.615086045401373],
              [1.1315181101054992, 10.627365155555028],
              [1.1522699516870818, 10.628834671472772],
              [1.184322835149901, 10.609795237202821],
              [1.2209843883997504, 10.584994968554449],
              [1.2461519017130556, 10.582227890522212],
              [1.2403077549078634, 10.556367930919428],
              [1.2600265659451904, 10.478910688022957],
              [1.2596759240818438, 10.462980214326537],
              [1.277120445514468, 10.388322821236732],
              [1.2926111541349514, 10.367682590389482],
              [1.3147212428266828, 10.2715199688175],
              [1.3392803827973263, 10.159032826792906],
              [1.3339084049134422, 10.129224697516332],
              [1.3389917497197086, 10.116379398595281],
              [1.3268174750504658, 10.100806101527505],
              [1.33322310933024, 10.0862186298347],
              [1.3340077533585677, 10.059927610229721],
              [1.3626189013814975, 10.034691669219962],
              [1.3699803879588737, 10.020574258192282],
              [1.3848629829490635, 10.01700832698952],
              [1.4047700384289505, 9.998317124325276],
              [1.4273156612500455, 9.99701634909063],
              [1.4390278944764219, 9.983979755989093],
              [1.4651086004309966, 9.979816623396681],
              [1.5058093100894199, 9.977474829041311],
              [1.5205673237565305, 9.993357360469417],
              [1.5387940262394024, 9.994630148519501],
              [1.5696925106742243, 9.986812970736208],
              [1.5924673916871206, 9.993887024235663],
              [1.6220105375976868, 9.983385469617833],
              [1.6311687770568246, 9.968544160809667],
              [1.6292064003952207, 9.949387666138271],
              [1.6362402527459425, 9.939336975878792],
              [1.6944888817024248, 9.932943335797455],
              [1.7387040343613478, 9.931759446352201],
              [1.7556648462474198, 9.93447015065179],
              [1.7800040504583816, 9.929853326011266],
              [1.7950218183725077, 9.932434419655182],
              [1.8312229819272936, 9.924357069552034],
              [1.9038925546899934, 9.922134054531586],
              [1.919682492767491, 9.90196216487183],
              [1.9313661297458196, 9.86433723724846],
              [1.9236001218793206, 9.824905927630839],
              [1.9398438258370705, 9.811595433981035],
              [1.9676424751189605, 9.811358295906391],
              [1.996878419106264, 9.814883769477913],
              [2.006639275269513, 9.811941229558993],
              [2.0395524156498555, 9.815181954633186],
              [2.051893381073992, 9.828851720052045],
              [2.06271434776406, 9.820024172662498],
              [2.0734005485005427, 9.827246572741476],
              [2.1049710468477487, 9.827935494947642],
              [2.1361122826343566, 9.840944865556143],
              [2.1578313590941782, 9.845863417520015],
              [2.164645488732032, 9.861812635653724],
              [2.158751262393428, 9.89086937250403],
              [2.175960420697367, 9.892872366395348],
              [2.1955591496741103, 9.908054030127674],
              [2.2047427180325045, 9.90331768194878],
              [2.2309818707336886, 9.912115570439312],
              [2.2358328865234247, 9.92689550070716],
              [2.2972688856519077, 9.944369780091609],
              [2.3289655037984587, 9.944977417694043],
              [2.349093643250125, 9.926911055415891],
              [2.40884725740921, 9.932837736542893],
              [2.4780735927961057, 9.931195649631409],
              [2.501131850411378, 9.938440447466991],
              [2.502022569517849, 9.91687407757556],
              [2.5155778964279474, 9.915944032339853],
              [2.584062772066304, 9.885250780781842],
              [2.6525291543956495, 9.854534033074144],
              [2.6992046308618565, 9.862937138834031],
              [2.71466769671401, 9.860167860667495],
              [2.72225470870952, 9.831334206329409],
              [2.71500870934966, 9.81779057982176],
              [2.6735953576845004, 9.811932809098957],
              [2.6654938240026684, 9.780543030539723],
              [2.682598437108525, 9.76246062856153],
              [2.704258478597151, 9.756198937463182],
              [2.7579519208646035, 9.762104201126716],
              [2.78344216385896, 9.76972749325597],
              [2.8034680956098157, 9.770617873722326],
              [2.825761253101637, 9.74303510116185],
              [2.838832473333468, 9.739033310609901],
              [2.8392719692888577, 9.726286126992196],
              [2.8267067951180063, 9.697136480017969],
              [2.8319993076790406, 9.677867455796408],
              [2.8591828241461044, 9.63316756662227],
              [2.8700888826890876, 9.624190391631306],
              [2.904552320544521, 9.551971664676653],
              [2.9149186160609326, 9.562199998674751],
              [2.9403994622418086, 9.57314174688933],
              [2.9630502151597304, 9.577670835759278],
              [2.9672812711846324, 9.59003366114823],
              [2.95575304919864, 9.598172044483823],
              [2.9474220592069873, 9.620412991809262],
              [2.951380352144706, 9.638006703632257],
              [2.953680391946414, 9.673797633533756],
              [2.9711302533512356, 9.68613933653305],
              [3.0086954460485384, 9.678484901799584],
              [3.027479255556166, 9.685367662064436],
              [3.0379238133371476, 9.696918282557752],
              [3.0506655006220407, 9.690433832702677],
              [3.091030496586871, 9.689857630452515],
              [3.1097742626011824, 9.69584724660923],
              [3.1165916772556868, 9.67221438608271],
              [3.1274826035505714, 9.663949353755147],
              [3.1482861081995996, 9.660442256969827],
              [3.1406642384857473, 9.636704916560868],
              [3.146291032611831, 9.60568574083094],
              [3.1818773801378852, 9.593733817431042],
              [3.1804044706777135, 9.57539728003234],
              [3.2083814514142315, 9.582329273513505],
              [3.2234094694070694, 9.581822111030968],
              [3.241395471232885, 9.564397427885934],
              [3.2442667207994345, 9.552721310688744],
              [3.276722292207498, 9.558736711932948],
              [3.288987114435722, 9.550531112846325],
              [3.322103550646702, 9.548101899706506],
              [3.32873027309755, 9.55360747613853],
              [3.3450340403008925, 9.549397792659834],
              [3.352762763906254, 9.522002077409875],
              [3.3514167851697994, 9.504257265244872],
              [3.358871644203838, 9.493768902675676],
              [3.350786397327983, 9.46705210030942],
              [3.363592284237284, 9.469235692514587],
              [3.374744879236004, 9.46083224009967],
              [3.3903221806113444, 9.463787781653483],
              [3.399910431797035, 9.451847235655691],
              [3.434140802487237, 9.458535850317038],
              [3.447472785052864, 9.450515636849358],
              [3.445540255073519, 9.406799942011878],
              [3.451443972591664, 9.402104569306157],
              [3.467664177688244, 9.412204673179499],
              [3.5032415258963265, 9.42835135761581],
              [3.529001939877239, 9.430289199461436],
              [3.543892041679738, 9.411215432575432],
              [3.569420999573582, 9.42072436865303],
              [3.582464271009239, 9.433429271552802],
              [3.6029537211902833, 9.4381642233964],
              [3.6365374771652563, 9.440492777891995],
              [3.6630285949284227, 9.451725289737169],
              [3.6861026426259955, 9.471327203464753],
              [3.701126416958581, 9.493565644674625],
              [3.7061384062926743, 9.491216155641977],
              [3.735358185425119, 9.519030914917545],
              [3.7498727102977085, 9.536312963395906],
              [3.7707140117799933, 9.551758736377982],
              [3.8046784729051892, 9.56103329261676],
              [3.8397595832809515, 9.593185826529893],
              [3.874031711064114, 9.605201571722777],
              [3.8997783730932842, 9.622105651667171],
              [3.9071676041984404, 9.614672305005614],
              [3.9254405237492245, 9.622161731349257],
              [3.9311932113818653, 9.617644857566301],
              [3.9391548588198617, 9.553737489967537],
              [3.958004318124391, 9.558733405509724],
              [3.9641188575918256, 9.540994941263508],
              [3.975451642143699, 9.52837343789449],
              [3.965052358819392, 9.521611643599988],
              [3.9793332417762386, 9.507289898761625],
              [3.9909562164826666, 9.482638497648407],
              [4.004682798316755, 9.479763467179247],
              [4.030043585959, 9.482550365391857],
              [4.041286615222269, 9.487577882587862],
              [4.071399793804916, 9.492189930017037],
              [4.080826438808409, 9.500873824954867],
              [4.114596545988741, 9.511640644684379],
              [4.128828981049456, 9.48806007891836],
              [4.17557270606141, 9.493731025454693],
              [4.188034913007578, 9.503981349794119],
              [4.20829598371022, 9.495285389206998],
              [4.2316173083659105, 9.502873183684367],
              [4.246411066982048, 9.492048069667316],
              [4.275703682882327, 9.49672743654981],
              [4.297235567407094, 9.50672485555256],
              [4.308558209669889, 9.501397287175879],
              [4.3514773296223765, 9.51292548581158],
              [4.375702084450826, 9.514186708043677],
              [4.413140675849899, 9.52020077770663],
              [4.424614071517301, 9.513588933126128],
              [4.441146553407976, 9.514922042025473],
              [4.488133626202241, 9.498306396251301],
              [4.51038965785045, 9.46472913916132],
              [4.512200683293342, 9.444630215470733],
              [4.540907134680311, 9.429135667291492],
              [4.5524232631428365, 9.434630574715822],
              [4.557992773032196, 9.421458626596372],
              [4.579164375840969, 9.40884315538491],
              [4.59689335618072, 9.408348452402143],
              [4.623487748732119, 9.424106911702095],
              [4.62965840941679, 9.439027077582347],
              [4.639757285805505, 9.438378608153323],
              [4.664255331899734, 9.448616982682108],
              [4.6869529230714475, 9.449371685948197],
              [4.709912603817818, 9.435518110525749],
              [4.718066158930802, 9.440532047597195],
              [4.760955171725289, 9.444082374711204],
              [4.781854416134418, 9.438425774191249],
              [4.796697410243097, 9.4200970569689],
              [4.773839556796308, 9.41464288839809],
              [4.762451301982736, 9.42765309326191],
              [4.746596019385022, 9.411532422141386],
              [4.742033917575147, 9.39920426130129],
              [4.729653931336849, 9.396797473641149],
              [4.713095303672633, 9.37039855987197],
              [4.691105613148561, 9.346981926247496],
              [4.654889610078354, 9.31994480281681],
              [4.603474568019457, 9.299203646795078],
              [4.596146808767032, 9.292306167173278],
              [4.5724333418847705, 9.287168836254901],
              [4.566578123192083, 9.273801608285536],
              [4.537092623003186, 9.252709001713997],
              [4.472480597657137, 9.229032327700157],
              [4.4664259119384075, 9.221286050744231],
              [4.442726955518416, 9.211115467599749],
              [4.410976832505154, 9.206685831453413],
              [4.396038276537269, 9.190990842387142],
              [4.366619313313509, 9.18816615607637],
              [4.3501916901503215, 9.182349113024257],
              [4.292224312290535, 9.153337943125075],
              [4.264355466689801, 9.14782085364263],
              [4.2300948908772815, 9.136514240561556],
              [4.228085458024433, 9.129691892620373],
              [4.2084818816529745, 9.12353329383027],
              [4.164497079926138, 9.10471295909629],
              [4.155625092568713, 9.091650529433089],
              [4.133379405769675, 9.081038489032778],
              [4.07682998437339, 9.044177094371497],
              [4.038996465458908, 9.023908618744846],
              [3.995419001847799, 8.988318924278328],
              [3.9518535558088095, 8.95271559443828],
              [3.908333876332004, 8.908378237805255],
              [3.894459998635496, 8.898304594938216],
              [3.841621978206892, 8.84662964773463],
              [3.833080999463948, 8.84450634980705],
              [3.8012791265806025, 8.801709375639565],
              [3.779031840648095, 8.784648830639355],
              [3.7579139698002817, 8.75933318799326],
              [3.7447692419023726, 8.729026739518181],
              [3.730071172369711, 8.714978625136045],
              [3.7157506229747637, 8.691629291685182],
              [3.709473800168624, 8.689175421996264],
              [3.703319009890383, 8.668379600143645],
              [3.6869976556418402, 8.658888181539522],
              [3.672370734250186, 8.639266597905753],
              [3.6534688847815606, 8.62168883101663],
              [3.636008893464721, 8.598846391303443],
              [3.6273645268879746, 8.58190590653162],
              [3.5816783260926948, 8.539867288224485],
              [3.5693126477183315, 8.520028283346992],
              [3.552886142246885, 8.503950800417693],
              [3.535615090974891, 8.497926998724804],
              [3.5266245288744327, 8.48280989745576],
              [3.5072677428579286, 8.471209013002595],
              [3.491131116132554, 8.466959485967273],
              [3.477947136712483, 8.439247532355578],
              [3.4721857656496833, 8.440371951753585],
              [3.446406225624011, 8.411037602868442],
              [3.4246678933708004, 8.392694749906886],
              [3.4174351917856187, 8.380910470428793],
              [3.405514368342388, 8.37962587738006],
              [3.3843052725905314, 8.35660540123593],
              [3.356223535277039, 8.3163804351745],
              [3.3353405470901123, 8.302947249806927],
              [3.3154377330982356, 8.296752764103402],
              [3.2990808463080783, 8.279739340534666],
              [3.2881074353014528, 8.275591906420276],
              [3.2670668816901642, 8.253469197265277],
              [3.2201112947548194, 8.218147312277505],
              [3.2113357002174654, 8.207236319070876],
              [3.1799022064106275, 8.186416472096374],
              [3.1692190840531635, 8.172030651406121],
              [3.1476869575506243, 8.154751773554137],
              [3.1608683245548614, 8.126209207518293],
              [3.1969674025758237, 8.080254857170026],
              [3.205364789869224, 8.07623315619551],
              [3.1924033350941334, 8.078134816954382],
              [3.1525888167537928, 8.11628593370485],
              [3.1339898041431433, 8.11493830722498],
              [3.1197202037904046, 8.105379774647783],
              [3.1148990878698304, 8.081888366877864],
              [3.085406756794856, 8.08229092961002],
              [3.074588874151701, 8.067053195346089],
              [3.0951640730380126, 8.055725701309825],
              [3.076229770911781, 8.02979392574309],
              [3.0720692854887255, 8.015013639188503],
              [3.035133130103164, 8.014651967385646],
              [3.0165175604667116, 8.028743845515324],
              [3.018524763055728, 7.988230213672524],
              [3.0257305451532353, 7.783220495805177],
              [3.0382561042983802, 7.444365528315173],
              [3.0150789605688266, 7.435352255955749],
              [3.00514247047115, 7.411996084097531],
              [3.005499256755175, 7.397676749963796],
              [2.9933062318454833, 7.381930171754173],
              [2.952095958526152, 7.3939199004958915],
              [2.937508044797488, 7.382880695303158],
              [2.9235459598743154, 7.34281139590664],
              [2.9051328598246666, 7.341433569209362],
              [2.8832334428967163, 7.3492009876490885],
              [2.864508390698885, 7.332450890500638],
              [2.8636207058575076, 7.316227774117998],
              [2.8029480646100584, 7.295065885733838],
              [2.7785709803696648, 7.273985800216731],
              [2.7784637842405866, 7.268329046075514],
              [2.757211757360641, 7.256224084284431],
              [2.73979170525222, 7.229061309178372],
              [2.736845491600349, 7.208604229258006],
              [2.719137607170207, 7.187843358111036],
              [2.725075101147218, 7.172138974060945],
              [2.7109359195084015, 7.143239459103944],
              [2.7080662128045123, 7.124921757003929],
              [2.691143652865213, 7.104488743297832],
              [2.650591466555562, 7.0767520122083925],
              [2.645496402283644, 7.025016292111781],
              [2.6400798319832917, 6.998435872468748],
              [2.6447986464380513, 6.9700075954690845],
              [2.6450837257656334, 6.935529619346417],
              [2.654207340956972, 6.927980360528395],
              [2.6878615955584007, 6.922488042788071],
              [2.7139193144908043, 6.930263990843465],
              [2.724810935001761, 6.929688231592435],
              [2.756589937277816, 6.905117847636456],
              [2.757090981439768, 6.878663877182908],
              [2.774959282622702, 6.858002575432256],
              [2.791366929931451, 6.830053516800189],
              [2.811011329738532, 6.820983410480354],
              [2.815739168612731, 6.8083382624829865],
              [2.814580973213269, 6.765435910977094],
              [2.805166319842896, 6.759940465470505],
              [2.7952982594839715, 6.739121838061411],
              [2.7785109629861378, 6.719604007979656],
              [2.782682676449083, 6.702562720576488],
              [2.7754795473259066, 6.687329382619776],
              [2.7571231022685616, 6.665976056065657],
              [2.7422793128462897, 6.656030728816301],
              [2.748200670291432, 6.627094662614746],
              [2.742608467161443, 6.61490457323647],
              [2.7496717212363073, 6.584375217029252],
              [2.7415596403306206, 6.570372429676684],
              [2.7416325163813378, 6.548434544675781],
              [2.7507121497380447, 6.539891494283466],
              [2.7520138198237167, 6.508247475894252],
              [2.758216318978694, 6.474861618893018],
              [2.726356268637587, 6.445257451813903],
              [2.7188115998722586, 6.43082641187625],
              [2.7234199689609584, 6.416292754341062],
              [2.747069514465347, 6.395305655619384],
              [2.7433258745642273, 6.367909104824772],
              [2.745580968320661, 6.338880639226186],
              [2.7566203686406534, 6.32293902309245],
              [2.760047797265192, 6.304662008511522],
              [2.754758000743028, 6.275156181778214],
              [2.7444206388299013, 6.259804334363578],
              [2.7526126444521997, 6.243252884855632],
              [2.749566893184944, 6.229462682596363],
              [2.7529903839404426, 6.208557966846044],
              [2.743237541921643, 6.179847854291902],
              [2.7381698273707014, 6.154966832951132],
              [2.7271342197409045, 6.13522837812159],
              [2.725789593026267, 6.118347192815585],
              [2.740490757026866, 6.104846388993138],
              [2.7770729892087274, 6.085871528482479],
              [2.803621633825116, 6.063448987541021],
              [2.8303888830118864, 6.034094132626254],
              [2.8540167611148095, 6.020609560649908],
              [2.861732642857391, 6.01086504486837],
              [2.862782837545157, 5.986998959188802],
              [2.8770420904037364, 5.9845473647551195],
              [2.8915882409232676, 5.973905636456872],
              [2.900121943405006, 5.97688088292637],
              [2.921948948270156, 5.941475030730066],
              [2.9374208447493317, 5.949943532750431],
              [2.955192713852556, 5.941495016929769],
              [2.964206930772059, 5.944034377958222],
              [2.99579680367073, 5.929750915825865],
              [3.0113187435443045, 5.937887598314894],
              [3.05940274951966, 5.936506632994133],
              [3.0728239978720158, 5.93078106607714],
              [3.0839390600522116, 5.918356153149307],
              [3.093023833958534, 5.897225469791879],
              [3.09383350764809, 5.881100472875928],
              [3.1129587422733582, 5.855245871404218],
              [3.158184497118737, 5.82194049761332],
              [3.1961452042607132, 5.812179499684616],
              [3.2233531887950346, 5.808193663854813],
              [3.2332445091044812, 5.800441746058904],
              [3.2747189431902877, 5.789589712061335],
              [3.286211512874187, 5.777440139567003],
              [3.3076399807229153, 5.769240492731297],
              [3.3434406669657086, 5.750551413645488],
              [3.357201606057932, 5.732732029324435],
              [3.3687216851271855, 5.725801559159336],
              [3.3782672332857473, 5.704078373169959],
              [3.37134937147913, 5.689500557904134],
              [3.374528949204346, 5.679047964693265],
              [3.3926750733801345, 5.666350625839855],
              [3.399354507268368, 5.640050965882511],
              [3.3962333254940353, 5.628676392229273],
              [3.4104432210980233, 5.594739091242793],
              [3.4442554354306463, 5.573996241310639],
              [3.4533518201128106, 5.5602862014224375],
              [3.484679281918622, 5.544977228952378],
              [3.5014969872806634, 5.532975304416417],
              [3.5166588955145697, 5.5317665585000055],
              [3.5315494371015053, 5.520017694614508],
              [3.5345201987001644, 5.503580748147969],
              [3.5533759908367517, 5.497926597583943],
              [3.581286680635796, 5.46457952669037],
              [3.608738350090885, 5.450412338792868],
              [3.6273664830092156, 5.431293919747972],
              [3.6817839621059876, 5.4254324527863815],
              [3.7010890779522647, 5.415506477604009],
              [3.730280662293437, 5.410249465655888],
              [3.7568183003139706, 5.373935357547242],
              [3.7717774084259412, 5.364962458694812],
              [3.7878031085984927, 5.346373378542883],
              [3.793906357815223, 5.329005768596543],
              [3.8086916778230693, 5.3101457871908595],
              [3.8217170575211914, 5.301603448417808],
              [3.8296556775033492, 5.280865462447206],
              [3.849927421544077, 5.261530078502435],
              [3.868243892526943, 5.207479597530223],
              [3.8822632390049927, 5.190657072885054],
              [3.8756431312112998, 5.160497274366583],
              [3.8765909539123293, 5.149185777469666],
              [3.8680367208780506, 5.125017517969159],
              [3.8684102454542835, 5.070054487019993],
              [3.8744526106400254, 5.06307513939992],
              [3.8725475836576306, 5.030609718879155],
              [3.9007878572833268, 4.998427678772984],
              [3.90096097413512, 4.981422744848167],
              [3.8938201742063403, 4.965322107357292],
              [3.9029267202414246, 4.940561097589038],
              [3.9147439465526, 4.9296351062294],
              [3.915091965080603, 4.917702139268153],
              [3.886389495572894, 4.916702985907932],
              [3.773350488589498, 4.911055516544113],
              [3.6603129520728674, 4.9053796624097705],
              [3.522046786415325, 4.899315703827072],
              [3.3837824864700874, 4.893209302490908],
              [3.282729237791721, 4.88904688506605],
              [3.1816769365352426, 4.8848618029908355],
              [3.0670982198575625, 4.880349804969073],
              [2.9525206967180764, 4.875808675612068],
              [2.816351820118971, 4.8709536006024905],
              [2.680184474162066, 4.86605739609835],
              [2.560624574758428, 4.862233065222658],
              [2.4410657382694523, 4.858377036883898],
              [2.3224838290012917, 4.855324692930019],
              [2.2039027060987886, 4.852241179275219],
              [2.0663257533133543, 4.849182641676717],
              [1.9287497187635023, 4.846082155438422],
              [1.8248614505308778, 4.844159954620867],
              [1.720973610683026, 4.842213837407455],
              [1.6098218358088343, 4.8404946340021375],
              [1.4986704697629964, 4.838748055410061],
              [1.3730326562524684, 4.837365817306658],
              [1.247395182709142, 4.83594860625554],
              [1.140290412444361, 4.834880516983745],
              [1.0331859053846078, 4.833787012124928],
              [0.9528607279542363, 4.832872244154962],
              [0.8725357611642535, 4.8319431815262055],
              [0.734489202833593, 4.831041837180704],
              [0.6069534244476247, 4.830881396405891],
              [0.47941767903383786, 4.830684926325596],
              [0.38883796638213136, 4.830888466947581],
              [0.2982582004552121, 4.83107383311668],
              [0.21737290401496087, 4.831436519741026],
              [0.13648753483494733, 4.8317847135304826],
              [0.137307690818881, 5.021175811994435],
              [0.138682581304729, 5.309572932622421],
              [0.1401696091080964, 5.528180008495507],
              [0.14211054926412414, 5.7911645117175405],
              [0.14346078745774446, 6.033168875305303],
              [0.144128184502302, 6.29171604711663],
              [0.14532400046492822, 6.536692942550115],
              [0.14521977256869698, 6.62529498095343],
              [0.12021577637682275, 6.684004967745576],
              [0.09733373813724783, 6.702580195896509],
              [0.08038122319266285, 6.708044663426243],
              [0.0301758163515238, 6.7352142578267875],
              [-0.013833221859788629, 6.737903772131699],
              [-0.02226643028573328, 6.744757755475061],
              [-0.04922787421399642, 6.784371952172646],
              [-0.05886186446208415, 6.815918623361212],
              [-0.072473567787591, 6.848496388395242],
              [-0.13650126456715647, 6.932964693629121],
              [-0.12425393223486568, 6.971886791335657],
              [-0.06805151200217126, 7.013308749732217],
              [-0.06061284662652187, 7.024423967178745],
              [-0.033084438878454, 7.0428412872737995],
              [-0.006089333851284535, 7.057300696867932],
              [0.008285508342682758, 7.071555102962363],
              [0.027325363660702484, 7.112198859786426],
              [0.03632444836185154, 7.118603351496711],
              [0.05938394087431718, 7.149568333688782],
              [0.06313116836011803, 7.166673231021599],
              [0.06656427138532804, 7.234978100320264],
              [0.07123911518028396, 7.257937844817463],
              [0.06675903187623927, 7.286056791891904],
              [0.06435428158086272, 7.338517980245187],
              [0.06186046424471473, 7.348762139117911],
              [0.07670797196791179, 7.3862586168437705],
              [0.07848740325031435, 7.405205983693192],
              [0.06896256115928044, 7.453098002516091],
              [0.061543178533682796, 7.468283168260679],
              [0.06155861206026024, 7.496744098421468],
              [0.053361872250317806, 7.505027861933241],
              [0.05847599324667706, 7.524263744250306],
              [0.05269751010732137, 7.533954354171202],
              [0.04819099667951811, 7.58167089529094],
              [0.05120603402585795, 7.596058411182474],
              [0.04850016007245198, 7.648065432671898],
              [0.03434691382818768, 7.660099783692024],
              [0.018362596885361973, 7.680966657710359],
              [0.0030395457315968793, 7.693149876208084],
              [-0.007775710157804, 7.726113451058061],
              [-0.015592728165751057, 7.740267005869181],
              [-0.032863816724118367, 7.758051784928572],
              [-0.029150038578908032, 7.782866735954816],
              [-0.03834710022414632, 7.789770552553941],
              [-0.04623223738430828, 7.818749682309612],
              [-0.04326001867347859, 7.828485953720718],
              [-0.053135666054710914, 7.866553460635411],
              [-0.05129782666521328, 7.892286929693117],
              [-0.06873350086016349, 7.920054622279926],
              [-0.07284545575893277, 7.940547895828279],
              [-0.08655960856542924, 7.969945742814067],
              [-0.07656839691329682, 8.009593156888217],
              [-0.07963427325605618, 8.019793044216128],
              [-0.07278694512153723, 8.038106714893239],
              [-0.07645220333333452, 8.05725595271618],
              [-0.06995347766578706, 8.081978828727443],
              [-0.08399482512995193, 8.09162325467289],
              [-0.08357314630666096, 8.122432306703192],
              [-0.0699639372147944, 8.170191637385035],
              [-0.07312430820722463, 8.183541705037571],
              [-0.05690585303191897, 8.239571025914795],
              [-0.07932951404558287, 8.240443820968672],
              [-0.09820774213654768, 8.288772532062396],
              [-0.10028785196955711, 8.309150064937247],
              [-0.10724976345315697, 8.321112146773336],
              [-0.09604971118199082, 8.356214673286066],
              [-0.10084686214771318, 8.365572614399667],
              [-0.09516293403794732, 8.388308045177135],
              [-0.09497597282322119, 8.418493483528158],
              [-0.1033419351648488, 8.449884284311013],
              [-0.09892108835221203, 8.482351904723195],
              [-0.11164010336909726, 8.53888505538437],
              [-0.10497224630487106, 8.553128717910953],
              [-0.11334758491760061, 8.579942159087516],
              [-0.11188730406290978, 8.59955563372965],
              [-0.1033000575450049, 8.613203021532907],
              [-0.10919040023576229, 8.646656727130045],
              [-0.11689361361863981, 8.665347029579992],
              [-0.11196355102875671, 8.673299493609528],
              [-0.10819982497617087, 8.70295009175463],
              [-0.1230101959083379, 8.718891053996781],
              [-0.12316732905205385, 8.741453542971712],
              [-0.11625862150312866, 8.780192508151353],
              [-0.12340834511749438, 8.792905188190009],
              [-0.11355627027068557, 8.800801062404275],
              [-0.12715644814648533, 8.831371327095889],
              [-0.11364892096855471, 8.854507057878022],
              [-0.1260871740047446, 8.86762610249051],
              [-0.11570939855527936, 8.880994500225434],
              [-0.1180361996084824, 8.911709123794651],
              [-0.1331389978429796, 8.921477190766558],
              [-0.1302565627223938, 8.929412150069735],
              [-0.1379102039380814, 8.953380184392515],
              [-0.13686644658282035, 8.963566697002332],
              [-0.15128906006784543, 8.993648867237505],
              [-0.15928837276140653, 9.021711502340008],
              [-0.16818335196796141, 9.036136106053165],
              [-0.16922756979516423, 9.064888777443132],
              [-0.18329511851038588, 9.07315420964411],
              [-0.18460434463681746, 9.090097725868718],
              [-0.19887479800176497, 9.101996379521518],
              [-0.20036357913564937, 9.127888262653652],
              [-0.21081936008000163, 9.147149052069436],
              [-0.215931268305995, 9.166999627889679],
              [-0.22665446115285431, 9.16946453841429],
              [-0.22891531100253648, 9.191430028562863],
              [-0.22209529505969222, 9.203306662227343],
              [-0.22378566632015853, 9.215664140957163],
              [-0.24835257273766, 9.241878565368205],
              [-0.2528199862168584, 9.258866531364218],
              [-0.24720774375883833, 9.282659539435597],
              [-0.2543458332741955, 9.293074352083993],
              [-0.2613963640317538, 9.346209786846456],
              [-0.27610498233503933, 9.364333686794206],
              [-0.27730051478188567, 9.378829484274045],
              [-0.29672444644630425, 9.425266368855867],
              [-0.3076459293068175, 9.437101306314068],
              [-0.30982634899462363, 9.474664838228065],
              [-0.3036524484600517, 9.493340879023556],
              [-0.2926315254599435, 9.507609165143284],
              [-0.30317418313317174, 9.51235776696547],
              [-0.30550405856980073, 9.535828011422678],
              [-0.29223310930889135, 9.54254383189635],
              [-0.2920984955576727, 9.580341927966384],
              [-0.2837946507610618, 9.586010642880607],
              [-0.3003073798403367, 9.600099590206051],
              [-0.29192743811948896, 9.62571815712556],
              [-0.2987861836942085, 9.63954340766412],
              [-0.311470413942416, 9.650800542460768],
              [-0.3005270141096051, 9.657145261670868],
              [-0.31236553163825304, 9.672254076423682],
              [-0.2948635422038432, 9.692402394116106],
              [-0.3027722174964382, 9.703670043551707],
              [-0.3009246138288582, 9.72370194902936],
              [-0.29226443567274013, 9.744790498993625],
              [-0.3012954518435514, 9.747868713317702],
              [-0.3113582732697533, 9.765771879343447],
              [-0.2943613439436238, 9.77610839362104],
              [-0.3059864658022371, 9.785617819568051],
              [-0.30821509274860037, 9.81248657412285],
              [-0.31934876445507054, 9.847367671290867],
              [-0.3064471743483624, 9.849637043055232],
              [-0.3008543982340115, 9.879526008183445],
              [-0.28022058843113684, 9.910498344191998],
              [-0.2704728300456681, 9.93834671743079],
              [-0.2717966197630743, 9.959906509589262],
              [-0.283776522265451, 9.979757518568203],
              [-0.28293171036706743, 9.98940158235418],
              [-0.29804888508114785, 10.015010262300665],
              [-0.2953297746333783, 10.027416099565189],
              [-0.30783431404533196, 10.053563566363104],
              [-0.31152787047470815, 10.072366189222471],
              [-0.3082765472728576, 10.086653610138749],
              [-0.3207558309059573, 10.10031609968409],
              [-0.317468489875479, 10.125056163647425],
              [-0.32175881807650425, 10.146811898636162],
              [-0.3338891858407543, 10.154411610070925],
              [-0.32788948008975255, 10.168180461063494],
              [-0.339721377524104, 10.176251046733672],
              [-0.3449040188564567, 10.205514993227686],
              [-0.35668442605041134, 10.220206043352896],
              [-0.3591142318545304, 10.254280512457154],
              [-0.35246367901907194, 10.271623053199017]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.30936382034007,
          "lat": 46.316413057266516
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "00662849"
      },
      "bbox": [
        -0.3591142318545304, 4.830684926325596, 4.81138466839343,
        10.641303024596539
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": 145.60963241424713, "lat": 15.83709541567186 },
        "year": "2023",
        "ste_code": ["69"],
        "ste_name": ["Commonwealth of the Northern Mariana Islands"],
        "ste_area_code": "MNP",
        "ste_type": "outlying area",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779809"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [5.892131116056546, -1.5396953503345954],
              [5.863956318959887, -1.520339084713577],
              [5.8527994742081795, -1.5033402850629347],
              [5.84882923686423, -1.4870829755563957],
              [5.857522457319219, -1.4490720487455817],
              [5.875605775044434, -1.4226687167226706],
              [5.888899122007435, -1.4117949585191547],
              [5.9041134182100885, -1.3870995161845037],
              [5.910723669234213, -1.3620083385072161],
              [5.9225071317225675, -1.3422369408753547],
              [5.956233185115891, -1.303310481995472],
              [5.978069788452338, -1.288284233440276],
              [5.998323541515711, -1.2814155853107292],
              [6.015641534240955, -1.285088601459926],
              [6.044779566675667, -1.2837491699427224],
              [6.134344108880593, -1.3128435804532927],
              [6.159283312699399, -1.3310091509950663],
              [6.195699011799084, -1.353360049173941],
              [6.230953468233795, -1.3552862812990096],
              [6.2660083884481415, -1.369316744691342],
              [6.293120911683532, -1.3774352387500428],
              [6.311513987586914, -1.389917533344408],
              [6.325772295384051, -1.4080391734664044],
              [6.367729083237786, -1.4193409407747035],
              [6.398513100660043, -1.4151016204796991],
              [6.414963487524756, -1.406779009037305],
              [6.425749798729578, -1.3846986587271783],
              [6.425600007771073, -1.3705985922704016],
              [6.437189061070967, -1.3258911015388575],
              [6.430982136063334, -1.318416736144753],
              [6.414711874142131, -1.275936019423834],
              [6.394520231619532, -1.2607019459572746],
              [6.382475612527796, -1.240776435182271],
              [6.361642991095849, -1.2207972904194344],
              [6.354707931346398, -1.1991538493136293],
              [6.357046000833377, -1.184301599067041],
              [6.373051431137725, -1.1414449375985543],
              [6.3774039046515085, -1.093218050037438],
              [6.391825984308174, -1.0701894563366667],
              [6.427482679744922, -1.0503962821458728],
              [6.466330571320226, -1.0698493189849896],
              [6.501658497692073, -1.0288491432592721],
              [6.524905721451061, -1.0148006863602892],
              [6.568902095473269, -1.0063509819470822],
              [6.607331413431567, -0.9967071116500855],
              [6.638122375914613, -0.9862216645484241],
              [6.679812613342853, -0.9813392985655934],
              [6.692920308372296, -0.9570114640556164],
              [6.685396361395257, -0.9279078074969186],
              [6.669676443945786, -0.919264261854644],
              [6.656291829979532, -0.9013209338494518],
              [6.630198018507552, -0.8825158756022808],
              [6.622005745068072, -0.8546148460449728],
              [6.605917561341001, -0.8183552774119961],
              [6.604001292794047, -0.7935960186880456],
              [6.620442078432018, -0.7649231734199518],
              [6.626361522425347, -0.7486300042103743],
              [6.671510058842154, -0.7128974491641139],
              [6.6856495509121, -0.6828591787022412],
              [6.688838719189655, -0.6574644677711436],
              [6.6943006719984055, -0.6496011995450596],
              [6.70411884623183, -0.64603305924615],
              [6.735520882779716, -0.657494314121808],
              [6.749538805206836, -0.6712856184989213],
              [6.761472917470745, -0.66821254263904],
              [6.767228059853423, -0.647491818818104],
              [6.788092378234191, -0.6331436116598592],
              [6.78956468041973, -0.6227436871293803],
              [6.778188947696016, -0.5914302329761718],
              [6.759998012863342, -0.5744142819402451],
              [6.756377299908676, -0.5515502475068856],
              [6.779593742973882, -0.5150239905880637],
              [6.788919515867872, -0.5111482655419443],
              [6.805028821255511, -0.5167935376202228],
              [6.818693258078115, -0.5362457619225517],
              [6.842179508968669, -0.5587766282479035],
              [6.875939526339479, -0.5557269520295033],
              [6.893245960749851, -0.5398499659951727],
              [6.911947150359931, -0.5342098753474191],
              [6.93338736636914, -0.533149288247311],
              [6.950972681424513, -0.5223326193461846],
              [6.9673472865366985, -0.5282816708370357],
              [6.968772221227268, -0.5442860450769128],
              [6.959348786106704, -0.5693746947733751],
              [6.968909837842834, -0.5956912326384134],
              [6.989873799046915, -0.5971189644024899],
              [7.013065787977306, -0.588913308207762],
              [7.030265892528642, -0.5604184906528247],
              [7.03036001633758, -0.5337708627998073],
              [7.002130951729844, -0.5131395106446708],
              [6.995312429420193, -0.4989649026665268],
              [7.010181965482401, -0.4693759703003718],
              [7.011420795838043, -0.4478153301892933],
              [7.0318320768711455, -0.44957878917871347],
              [7.036509144850878, -0.4705983541957364],
              [7.05464374052505, -0.4904925789121019],
              [7.087303060385609, -0.506829238434149],
              [7.098244282020268, -0.5010420461100458],
              [7.120619922112117, -0.4761960111169977],
              [7.14122066958644, -0.4636588814672656],
              [7.1602123699321, -0.46144308775263887],
              [7.18254801253669, -0.4665586514792995],
              [7.216483131654405, -0.490343601224656],
              [7.236592826912907, -0.49422361290576317],
              [7.269040122554139, -0.5114063241857645],
              [7.289276846045106, -0.527028508499382],
              [7.319198257804945, -0.543851629397628],
              [7.332452777071603, -0.5472794490879553],
              [7.363208429468417, -0.5475989955912689],
              [7.383657849662454, -0.5710808040120855],
              [7.395704679324001, -0.6000842946522366],
              [7.422009028465151, -0.5989857698560164],
              [7.441007519801909, -0.5807128247226182],
              [7.448674392553232, -0.5536008999470838],
              [7.455194798758541, -0.5113784560082207],
              [7.451251341365498, -0.485602772430079],
              [7.474469933682494, -0.4586799207084474],
              [7.499357826289198, -0.44465820844800097],
              [7.5401979179289595, -0.43577914935056544],
              [7.557639836026134, -0.42260402734888053],
              [7.568083837458279, -0.4047391507412429],
              [7.589460064203632, -0.3781059706896428],
              [7.613542198390595, -0.3639617287931177],
              [7.636201520010226, -0.37138779446705505],
              [7.651640197993661, -0.40437282271803404],
              [7.67829541325427, -0.44496472986178837],
              [7.695305387016664, -0.46212646416957137],
              [7.7055343659417534, -0.4623598929421761],
              [7.728797565392523, -0.43982354807394397],
              [7.7569764739993055, -0.4395521718739895],
              [7.762691901238711, -0.4550304445050109],
              [7.752644551012968, -0.4944329068655902],
              [7.757202649275056, -0.5069786136073323],
              [7.772910914940007, -0.5068750197921118],
              [7.7975405094896555, -0.4886538073632972],
              [7.801701593057549, -0.478996639245737],
              [7.79642210151179, -0.4395676168344502],
              [7.803744229661076, -0.4242229699414356],
              [7.820997871862651, -0.42148701443739134],
              [7.846467370584793, -0.42417976253429235],
              [7.863546405034485, -0.41322282386767145],
              [7.86558675235823, -0.4025460840905622],
              [7.848301691134886, -0.3720154249091853],
              [7.842465745769538, -0.3120624669810143],
              [7.846942592320108, -0.296640322768481],
              [7.89666123520222, -0.28367311133909745],
              [7.910022606271676, -0.2653947419268221],
              [7.907059663179129, -0.2458090561793362],
              [7.8869022616002376, -0.2384609957401624],
              [7.8794182850605, -0.22050852771844454],
              [7.890749590084312, -0.2063902305477477],
              [7.9066431020638275, -0.20675713971157747],
              [7.927593535768353, -0.22440926747481724],
              [7.948117645417004, -0.19712659781167385],
              [7.975357384213363, -0.19728913444499102],
              [7.983789639434625, -0.1921024940551555],
              [7.988386423209079, -0.17640080409731657],
              [7.982291247631367, -0.16912517370214195],
              [7.952143069017997, -0.16535120117502342],
              [7.94232338604136, -0.15635347604444258],
              [7.942893787918796, -0.13399260685917208],
              [7.962869746368983, -0.12991846843748617],
              [7.988865533897516, -0.1500593201610412],
              [8.013663651764661, -0.16271415261369665],
              [8.02961419388515, -0.18965873776642278],
              [8.025764126009427, -0.21952215863046198],
              [8.028730576913002, -0.2377669847524186],
              [8.039524146742057, -0.26272993118573773],
              [8.067569316712667, -0.27727609396413233],
              [8.078553431316731, -0.28776337271042934],
              [8.114682423009066, -0.30224528244067617],
              [8.151508036966607, -0.29236311206226406],
              [8.170608329599695, -0.29398920850687704],
              [8.191098154393126, -0.30403134989482233],
              [8.205009560792716, -0.3279636894827086],
              [8.21811791343772, -0.3419376418311301],
              [8.229852925446409, -0.33651928542990384],
              [8.227247755560787, -0.31979687369673027],
              [8.23351960712365, -0.30578923920386547],
              [8.269934670702185, -0.29292422575408367],
              [8.293272284100988, -0.28872706762492745],
              [8.308139398089947, -0.2701891179850603],
              [8.31119819995303, -0.23011400458515513],
              [8.316766308363773, -0.20107865058926724],
              [8.30926387115533, -0.15632130812189365],
              [8.308722735233587, -0.11540302236470239],
              [8.323861762116639, -0.08410529586699535],
              [8.343455711245628, -0.06314580675977034],
              [8.351801801270518, -0.044186166766758864],
              [8.351307292090738, -0.018279193727217008],
              [8.363970978708148, 0.00044558536572454843],
              [8.386874078497325, 0.009154662999269472],
              [8.398504104283438, 0.0074179505429151195],
              [8.408741598093295, -0.005299045551852029],
              [8.424706307335239, -0.0077463567265910705],
              [8.465973424100383, 0.024775886337589318],
              [8.484652805458897, 0.055642631988737194],
              [8.493126839344743, 0.09730278037333946],
              [8.494071434734998, 0.12962624198619432],
              [8.502000750882958, 0.1616681260191186],
              [8.51106692365482, 0.17735930893175839],
              [8.52424828522001, 0.1882271859048337],
              [8.57062382716919, 0.2010081109647477],
              [8.589421891708005, 0.21386618871936347],
              [8.609326130956335, 0.25935664826475907],
              [8.629977946304294, 0.272926497796858],
              [8.641060649916634, 0.28534047749174163],
              [8.642720417797294, 0.31664441887793715],
              [8.623059260754394, 0.34983825581576533],
              [8.618954583371886, 0.3626929485966667],
              [8.614358440781313, 0.410771053742222],
              [8.59894372372001, 0.432187198636665],
              [8.59842564119492, 0.45864995963989563],
              [8.608489759520745, 0.4803860455976866],
              [8.627528751878206, 0.49130268503870994],
              [8.657433965376187, 0.48786245840773734],
              [8.675122425859763, 0.49173352707050705],
              [8.707567512668103, 0.5047838901522975],
              [8.73599392904635, 0.506598281030519],
              [8.753823557292787, 0.5001431177811305],
              [8.772351334183186, 0.47587574268196803],
              [8.783504660421865, 0.46655605963512453],
              [8.803310960104236, 0.46082531698792334],
              [8.81523575956099, 0.46263475856270353],
              [8.841746957846595, 0.47808620945396285],
              [8.868516550012433, 0.5088877639671301],
              [8.886690606277538, 0.5252683127903108],
              [8.930487225804765, 0.5562236432150409],
              [8.943763554369077, 0.5694612738724327],
              [8.97784329666045, 0.5703356690316533],
              [8.989089985631717, 0.5737138167750704],
              [9.022095374364245, 0.5951253417735888],
              [9.061192404477497, 0.5896935215742731],
              [9.079003502916493, 0.5913720965828803],
              [9.080318768939389, 0.5999438066866455],
              [9.065409348800202, 0.6244812997213725],
              [9.065835720661534, 0.6454362164152119],
              [9.089709205296579, 0.673808875292239],
              [9.08903432585285, 0.6919224698223899],
              [9.077386898802278, 0.6995403483667345],
              [9.053516005476311, 0.7030073462545985],
              [9.02279234221044, 0.7025717420585794],
              [9.013938853864339, 0.7175181315721312],
              [9.018904066315168, 0.7314339949482882],
              [9.042743868018707, 0.7634486054076413],
              [9.045447414033651, 0.7753811227244074],
              [9.03768378804248, 0.7934482900139521],
              [8.984432732405807, 0.8535044286572327],
              [8.988892289909252, 0.86731493387318],
              [9.009028988567831, 0.8816402316959966],
              [9.027958583696153, 0.9065890821458579],
              [9.036739570403844, 0.91269942906734],
              [9.062848621776903, 0.9285773960441345],
              [9.081984037185729, 0.9599202206820416],
              [9.099333756164285, 0.9597479849210537],
              [9.110515947085473, 0.9535587139049777],
              [9.136429994573914, 0.9232051778528851],
              [9.168002487569066, 0.9142785673423077],
              [9.18345981552524, 0.900984959084298],
              [9.207264388869515, 0.9011598906691596],
              [9.228851346928382, 0.9118429422862444],
              [9.243010365260325, 0.9311464165498884],
              [9.263878592503707, 0.9263536041201664],
              [9.275067434687458, 0.9292371821652556],
              [9.30158504765758, 0.9607342820598131],
              [9.321740046022406, 0.9560759889327097],
              [9.333675752150405, 0.9369916397386289],
              [9.340378443290772, 0.9011997997796625],
              [9.359408076358424, 0.8907150975600018],
              [9.395442462935572, 0.8907672479289704],
              [9.423044358612387, 0.8800316428767818],
              [9.442325995731546, 0.861044372501606],
              [9.461242738937509, 0.8118453044197618],
              [9.489108841557764, 0.7821560606707632],
              [9.510094891778095, 0.7542620803313452],
              [9.521678779070331, 0.6878642282579235],
              [9.537509737300892, 0.6686326625725476],
              [9.582510864552221, 0.6632688071044317],
              [9.620539169104752, 0.6521045542328197],
              [9.650254516793742, 0.6469208691702862],
              [9.670929932601883, 0.6496309941365347],
              [9.719130396095734, 0.6725680037143897],
              [9.746253188923983, 0.672471658004446],
              [9.760807652711259, 0.6620600035958462],
              [9.792116250359536, 0.6599963512426038],
              [9.814755693126378, 0.6539356789679921],
              [9.82644413373148, 0.6406741447065404],
              [9.83336899280739, 0.6208202264175025],
              [9.849322909451791, 0.610314833518406],
              [9.87424112267247, 0.6054876854520185],
              [9.880430759012787, 0.6001433228489649],
              [9.89407261530669, 0.5637378052461514],
              [9.902307580392108, 0.558646969420045],
              [9.9349673613765, 0.5573855986519604],
              [9.975331867010606, 0.5429649945785265],
              [9.992499356245702, 0.5497683516506012],
              [9.99672464453357, 0.5851077408326761],
              [10.002669301775276, 0.5994942162997634],
              [10.059612470641563, 0.6267286817630661],
              [10.080769801764804, 0.6338557316720889],
              [10.108901500368555, 0.6243906444265392],
              [10.12495745607202, 0.6116185702684912],
              [10.204934909695046, 0.605020373201875],
              [10.227092723597739, 0.5948825956689675],
              [10.242623612350156, 0.581623904983154],
              [10.249206792914288, 0.5607334931556146],
              [10.268818008089188, 0.5504766628534249],
              [10.28703780996791, 0.576389895312554],
              [10.301723345563463, 0.5874884560789005],
              [10.335479038589948, 0.5799954565752987],
              [10.373489538655848, 0.5872908420183272],
              [10.386098515938487, 0.6021437430629791],
              [10.391931385121179, 0.6309421712726748],
              [10.404629057617262, 0.6511352425206987],
              [10.418299642556802, 0.6568489448349769],
              [10.440116576365513, 0.6748579262737064],
              [10.451659302727784, 0.7049499621387663],
              [10.467025543169434, 0.7134327495559171],
              [10.492402208288228, 0.7127672291362238],
              [10.517752581814683, 0.7339033097398375],
              [10.553363887210926, 0.7523877656471959],
              [10.56531827068792, 0.7488489699017445],
              [10.575902017039551, 0.7265700310372571],
              [10.575290409083381, 0.6877492284310125],
              [10.58914751741875, 0.668370547927782],
              [10.597737666128738, 0.6459165042526013],
              [10.60163441003286, 0.6207041374675525],
              [10.61180451016016, 0.5959734642501029],
              [10.635657299293554, 0.5763984257743373],
              [10.652361935198837, 0.5690257309684503],
              [10.71086529635302, 0.5715343127807087],
              [10.740669766452298, 0.5536233004784803],
              [10.771441512043756, 0.5180904090088978],
              [10.807790592691523, 0.5005069824304395],
              [10.817330006183525, 0.4868803589267144],
              [10.830872703699372, 0.4500269229077461],
              [10.836781790808573, 0.40849751285271085],
              [10.838332051587361, 0.37264367854828384],
              [10.857237611818345, 0.35820907645865935],
              [10.86285585446941, 0.34393731071898365],
              [10.857352564873485, 0.3299955506791999],
              [10.867786962241036, 0.2941774294158447],
              [10.861600726512709, 0.2746769152691361],
              [10.84532565980946, 0.27273258629706054],
              [10.842795284710949, 0.26072434245796533],
              [10.85607643990247, 0.2451067704400952],
              [10.858252778054958, 0.22485186700590626],
              [10.852634685498591, 0.19786013929675497],
              [10.831335789191943, 0.1944003386330535],
              [10.837220562423495, 0.1625318058164138],
              [10.850665885041364, 0.15724154355962874],
              [10.88157195953625, 0.13613567168625582],
              [10.885171680959864, 0.1199809488936198],
              [10.913293931779153, 0.10372096956239678],
              [10.927797588639843, 0.07170072788934036],
              [10.939263753832668, 0.06214141772934616],
              [10.951948253437509, 0.03622917837283194],
              [10.971435906137001, 0.03876260695443581],
              [10.97763599355645, 0.024463594710330036],
              [10.991784779592539, 0.027130377774044652],
              [10.990813367682984, 0.000809015669936872],
              [10.970846055494409, -0.028575387508985903],
              [10.983682219430754, -0.04050240432395325],
              [11.01289816412916, -0.04739081551132637],
              [11.039022492821772, -0.0661205041255729],
              [11.042445618001551, -0.08882688877875075],
              [11.067106032961343, -0.12841018098780008],
              [11.08718197585871, -0.14553061352661917],
              [11.11714895485911, -0.1574960956680822],
              [11.12518878347837, -0.17773710009307095],
              [11.136439984637944, -0.18447628035413016],
              [11.128319122987227, -0.19958150867251964],
              [11.14198573853033, -0.2079827505014529],
              [11.145285205568102, -0.21925093803116846],
              [11.165981791277616, -0.2523361084926233],
              [11.187924431223696, -0.2719964953054909],
              [11.200514105503478, -0.2773410875239569],
              [11.212768809680844, -0.2706389686672653],
              [11.225096888436314, -0.2774893749092981],
              [11.238993100369836, -0.3039039970140301],
              [11.263352906258191, -0.29837479851123105],
              [11.287767725281935, -0.32986088282976733],
              [11.306658118086835, -0.3265393293827684],
              [11.315285495549562, -0.34253738197771955],
              [11.30801225247869, -0.35641023963026025],
              [11.311855494214504, -0.36710615257699347],
              [11.332862512951081, -0.35650519259028307],
              [11.337661888322547, -0.36333813102345486],
              [11.358136211291619, -0.3580544341450198],
              [11.367670618873584, -0.37517614615966616],
              [11.395201165980605, -0.37029162514303054],
              [11.412426018780012, -0.3718123121152906],
              [11.439467614494799, -0.35470229437478373],
              [11.442383717567298, -0.3629145599698426],
              [11.386501415119639, -0.42990530240354347],
              [11.336818798846183, -0.4915858403145339],
              [11.284609611903814, -0.5524757771193844],
              [11.207232983938058, -0.6456033375570169],
              [11.202228578713338, -0.6582644792242146],
              [11.184023475203666, -0.677327927845774],
              [11.124477707223615, -0.7066248341863566],
              [11.110731927361286, -0.7115216347773075],
              [11.074361259257776, -0.7339335078310465],
              [11.059783901036237, -0.7504361176194927],
              [11.03736379701558, -0.7622494220518236],
              [11.00757096127167, -0.7885258598710967],
              [10.979554087111802, -0.8216451471595356],
              [10.965699700692905, -0.8260073383960942],
              [10.948457145704944, -0.8457182874536089],
              [10.942208347411002, -0.8457126039194884],
              [10.915096442234013, -0.865503814438392],
              [10.923721867595894, -0.9277261159693302],
              [10.922799520120902, -0.9440149110661727],
              [10.909272717327486, -0.9466295699194671],
              [10.88380410268069, -0.983998488128655],
              [10.852624538517736, -0.9925490642815085],
              [10.837971958742031, -1.0152997830857418],
              [10.820363109578068, -1.0275654979822222],
              [10.833638880594952, -1.04784771563611],
              [10.834344670724166, -1.0755032057453124],
              [10.82306854236673, -1.0946836496188046],
              [10.824107298530485, -1.1137762771563482],
              [10.781551399158827, -1.1419011229997114],
              [10.757223205604006, -1.1550325074578467],
              [10.735290378844402, -1.1591304366175768],
              [10.730440134745686, -1.168704455562367],
              [10.713063075152286, -1.1633487515573218],
              [10.69731657649678, -1.1692792902563032],
              [10.677302271566791, -1.1691677392011406],
              [10.677135991774785, -1.1831486554192137],
              [10.657855843757776, -1.197805491657597],
              [10.662470107783744, -1.2122535214392216],
              [10.649622027555266, -1.2392289672749588],
              [10.639401225831977, -1.247057876959231],
              [10.648069037287218, -1.2788678928430406],
              [10.642390707504731, -1.2875258261706233],
              [10.597104909526962, -1.2973450972320946],
              [10.527250587740047, -1.3329522713524444],
              [10.512384751793777, -1.3373946425151806],
              [10.453527355155533, -1.3705273631436994],
              [10.447193521558864, -1.381354244754332],
              [10.42647535976323, -1.3936863056680702],
              [10.402404523525115, -1.399532390510332],
              [10.370825495254412, -1.3983211731412335],
              [10.341568617186576, -1.4073792417924398],
              [10.308858655517305, -1.4353029714860113],
              [10.280567184868245, -1.446955934490406],
              [10.27344540079677, -1.4568458432518918],
              [10.25524566185446, -1.4678774442895206],
              [10.236917153213385, -1.486451159722707],
              [10.227210902968636, -1.506241698774407],
              [10.14950207560028, -1.5149952555041868],
              [9.991913768749695, -1.5293605221595958],
              [9.881485337598436, -1.541460247991401],
              [9.768042501620648, -1.5551360492288884],
              [9.632029277527971, -1.5676080105057397],
              [9.552823997822793, -1.5770396789741397],
              [9.487842462945268, -1.5815271639072501],
              [9.314924409532289, -1.596470106834591],
              [9.169896398677537, -1.5989708317553284],
              [9.034338816337147, -1.6083238307105654],
              [8.958992722354141, -1.615917771469073],
              [8.951499764523577, -1.6188093364738303],
              [8.84963666805424, -1.6358204002571692],
              [8.804068408187419, -1.6449117835608063],
              [8.654013654563341, -1.6582061439249378],
              [8.555780302356192, -1.6645226349777849],
              [8.531568758765196, -1.667503147705949],
              [8.429889865797657, -1.6721834280397143],
              [8.37211147862975, -1.676005590232404],
              [8.332871011733475, -1.6765917441801195],
              [8.240883493339812, -1.6805697211688488],
              [8.132805069859938, -1.6821224527939969],
              [7.9942910363541335, -1.6924054978905971],
              [7.951614968095405, -1.7159087430851758],
              [7.929340074136872, -1.6988411973257278],
              [7.831683301292815, -1.7116623357619491],
              [7.514969539947847, -1.7490392612973982],
              [7.278198696692433, -1.7722370912923464],
              [7.098892873600873, -1.7913057669239805],
              [6.931398758644581, -1.8107298053150933],
              [6.9316456992703595, -1.779864704971663],
              [6.802086579418662, -1.777391786471079],
              [6.7554952046045, -1.780193727200703],
              [6.758880973739128, -1.7985134735912465],
              [6.767889070720297, -1.8143990142486603],
              [6.781951264893076, -1.854105211333327],
              [6.797229935912164, -1.9158817681911466],
              [6.795265482701825, -1.9431941042498067],
              [6.784471209280115, -1.961028743894539],
              [6.7254931733765595, -1.9645169496385155],
              [6.563889457282864, -1.9757361244487448],
              [6.3936128060189406, -1.9880059356317759],
              [6.16374618484365, -2.004596786877035],
              [6.060699831849336, -2.013036192839508],
              [5.93904371245615, -2.0205257737854603],
              [5.793652578752229, -2.0273408889253957],
              [5.72213220532714, -2.040512978416927],
              [5.701299804083866, -2.0420288825828727],
              [5.713032318814526, -1.997405514494931],
              [5.714022229327384, -1.9798197371211046],
              [5.722774959501791, -1.9549832998607637],
              [5.726316309491103, -1.9222531264068308],
              [5.740443353797834, -1.9084001536880075],
              [5.763791643390805, -1.9029726221778474],
              [5.775214279975538, -1.9143737652596717],
              [5.7919760094246024, -1.9398860800285964],
              [5.814835209029547, -1.9633746444036353],
              [5.822846915494205, -1.9668116533115318],
              [5.84712885073432, -1.9606054684580143],
              [5.857270661818628, -1.9490133173109474],
              [5.864415199932448, -1.9267971465510043],
              [5.866368525578332, -1.898980123973972],
              [5.894235860123664, -1.8591261186004575],
              [5.886192538151267, -1.8541006767223094],
              [5.8843280334417365, -1.8370504763635083],
              [5.858633562022027, -1.8114107429105069],
              [5.858270720701087, -1.7877963703953152],
              [5.867759387229628, -1.7727230158243363],
              [5.881283403088419, -1.765685356629964],
              [5.91411469011194, -1.7713058735987297],
              [5.919721657734245, -1.7467460382043027],
              [5.909286003264716, -1.7352895826494295],
              [5.887844782196641, -1.7353724951554592],
              [5.86950053119358, -1.718336202940882],
              [5.866592293946043, -1.6941619142465623],
              [5.870305333594023, -1.6853573110825946],
              [5.897783236349084, -1.6757437122102072],
              [5.910988913801707, -1.634305387345951],
              [5.920117147280087, -1.576350086891429],
              [5.919535844714394, -1.5555761134456072],
              [5.903505584562542, -1.5391963369348156],
              [5.892131116056546, -1.5396953503345954]
            ]
          ],
          [
            [
              [5.647265000096341, -2.04729262884135],
              [5.604489220131763, -2.049767203232579],
              [5.5858367345555795, -2.0232238424040387],
              [5.57568772631737, -2.001758589693611],
              [5.578048086682571, -1.9845360071708924],
              [5.588414365646052, -1.9707248789483267],
              [5.608027489021804, -1.9653767415662375],
              [5.642594704635868, -1.97244417919315],
              [5.652542173727762, -1.9837987978210068],
              [5.660536644847745, -2.0135599134040376],
              [5.647265000096341, -2.04729262884135]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.2902500039348, "lat": 37.52664069710751 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779786"
      },
      "bbox": [
        5.57568772631737, -2.049767203232579, 11.442383717567298,
        0.9607342820598131
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.970354314944897, 8.895086305804204],
            [-13.970128585761405, 8.918165774001952],
            [-13.974144947053112, 8.962219629658938],
            [-13.9809701372165, 8.978332514809768],
            [-13.994595997618463, 8.985957139029011],
            [-13.994530474067915, 8.997402479390384],
            [-13.97728996751204, 9.001375003851859],
            [-13.965678521098882, 9.023463923979076],
            [-13.953227224369513, 9.033054702033645],
            [-13.948198644126334, 9.0506758300337],
            [-13.938832929597472, 9.05518613465552],
            [-13.946452753503637, 9.081402896266573],
            [-13.957634110227652, 9.098668068211607],
            [-13.957641290319437, 9.10853894727516],
            [-13.947201585432278, 9.122912465009886],
            [-13.949153578332062, 9.158940829010634],
            [-13.959938220999668, 9.176582729273452],
            [-13.951966692670105, 9.191333512603629],
            [-13.971481468393481, 9.217955481316054],
            [-13.968993796103009, 9.238782457356452],
            [-13.988600784908217, 9.252780800447358],
            [-13.988861338690782, 9.272775577966085],
            [-13.975019909818236, 9.284118174641936],
            [-13.958293010687129, 9.319487179020676],
            [-13.96018767658383, 9.327076847302472],
            [-13.899771877959695, 9.590588318581467],
            [-13.874850292503766, 9.701085392241012],
            [-13.82377452694876, 9.92455684056673],
            [-13.777990188821239, 10.125620287421322],
            [-13.730237661449834, 10.3341976926713],
            [-13.709829664812435, 10.426145130592785],
            [-13.653151710484764, 10.678615547474696],
            [-13.62533814272638, 10.799686649675222],
            [-13.58999015307666, 10.950134544048002],
            [-13.532598221191245, 11.18260862860391],
            [-13.50471709452705, 11.304881233975491],
            [-13.44906761116855, 11.541078523095774],
            [-13.42114946871368, 11.65898421082036],
            [-13.394364304951525, 11.776285390775541],
            [-13.31455557947541, 11.759127554053887],
            [-13.234751740232593, 11.741946263030579],
            [-13.154952850195373, 11.724741528682946],
            [-13.075158972354972, 11.707513361950403],
            [-12.995370405088234, 11.690844741879458],
            [-12.915586544060538, 11.674152761996329],
            [-12.835807452031952, 11.65743743291277],
            [-12.756033191784057, 11.640698765202629],
            [-12.799352625964639, 11.442468199108323],
            [-12.86364688904887, 11.148264070979408],
            [-12.909140920687676, 10.939095647239535],
            [-12.96826225472624, 10.668390399771264],
            [-12.956782560899585, 10.661766479854085],
            [-12.937202503292704, 10.601498858119832],
            [-12.92667373131878, 10.593869149135099],
            [-12.907223238412307, 10.536499199681652],
            [-12.898342032637608, 10.520370861617677],
            [-12.884227265063982, 10.523704935715635],
            [-12.879817171958244, 10.508366203163028],
            [-12.868410057052975, 10.49641809889102],
            [-12.866880334759246, 10.485683380515468],
            [-12.874578322636678, 10.457681411536043],
            [-12.866434611690336, 10.423202213709677],
            [-12.851307259070744, 10.425916438224352],
            [-12.83921632768557, 10.407661954548988],
            [-12.844039425342606, 10.396180295977558],
            [-12.839683669515782, 10.383240190233915],
            [-12.829625790390343, 10.382409035694486],
            [-12.814283133429313, 10.365295796319902],
            [-12.810496701287882, 10.35405214867841],
            [-12.817364598820491, 10.334014061680357],
            [-12.827775900663351, 10.3177137639989],
            [-12.826263827908397, 10.305012289833838],
            [-12.812881556804752, 10.294751782227213],
            [-12.806191429933772, 10.282313499308774],
            [-12.812124400188987, 10.263548052609664],
            [-12.807939523276978, 10.25455770108569],
            [-12.860550600192017, 10.22249636992535],
            [-12.861034826930387, 10.21199243767266],
            [-12.83787991546913, 10.188493183771925],
            [-12.829119637559291, 10.148369632257625],
            [-12.816177700443589, 10.149551727398121],
            [-12.813246911770822, 10.138114021971148],
            [-12.795253926497296, 10.137903633118654],
            [-12.803558785702796, 10.117874174697205],
            [-12.82908715240321, 10.116515094721262],
            [-12.838581972596572, 10.12248084246898],
            [-12.879029891385276, 10.115459498448887],
            [-12.89025586283086, 10.099977912401949],
            [-12.864652256327188, 10.096517838759548],
            [-12.86049112248291, 10.085347868608219],
            [-12.84724778606104, 10.082539606199814],
            [-12.827137173050296, 10.063249468551282],
            [-12.822210363718684, 10.03938955975083],
            [-12.805438416382366, 10.040875465552926],
            [-12.780708381825102, 10.020871650737286],
            [-12.78132361211196, 10.009467988189337],
            [-12.76575859650272, 9.99759645924637],
            [-12.761754312205056, 9.948869077326535],
            [-12.738590530118, 9.934282496817632],
            [-12.722930789705286, 9.928766222115664],
            [-12.71841790622858, 9.918987288290205],
            [-12.69712175142988, 9.916593085696478],
            [-12.691005863590679, 9.899662272066028],
            [-12.672374471898918, 9.89892255519309],
            [-12.656679902810486, 9.887706722215507],
            [-12.643481093152827, 9.888250482797371],
            [-12.633485100979714, 9.879668139285783],
            [-12.633351825444489, 9.856603494716287],
            [-12.62313322525833, 9.846736798418247],
            [-12.621423060772843, 9.830878457096288],
            [-12.631196224284869, 9.81630109600884],
            [-12.62357457234051, 9.804780906262515],
            [-12.607587071948663, 9.799742150559583],
            [-12.60085196923587, 9.76739609780128],
            [-12.586993491659154, 9.762858538833678],
            [-12.566855727645686, 9.739182471016461],
            [-12.562038316132622, 9.71593828572163],
            [-12.544414238536994, 9.70720910265365],
            [-12.542131460540492, 9.673691897219944],
            [-12.52728699651372, 9.649144119451364],
            [-12.51753578595338, 9.645554205667999],
            [-12.51083979046558, 9.624250370850765],
            [-12.513990753559568, 9.593970781688753],
            [-12.505235212910476, 9.578435076846944],
            [-12.474216542309255, 9.562885095001743],
            [-12.466484635168314, 9.538684556120664],
            [-12.455321327884292, 9.517550368893506],
            [-12.433636800943987, 9.501550610613158],
            [-12.445543571403281, 9.482461128535686],
            [-12.446147369310157, 9.462010187152964],
            [-12.460509759309318, 9.449095862484505],
            [-12.448601269214128, 9.440588208774454],
            [-12.448619828671912, 9.412676563991003],
            [-12.429446167275206, 9.391195879844977],
            [-12.414078323028901, 9.393228399466045],
            [-12.395903117960618, 9.3579871906414],
            [-12.381456360522382, 9.3543724461361],
            [-12.35730875875097, 9.325581184735483],
            [-12.36508028614626, 9.303828618298713],
            [-12.381814689206816, 9.284167044768276],
            [-12.360724298757832, 9.264993524744126],
            [-12.34920740246797, 9.277548472375035],
            [-12.328587748122176, 9.278856956244427],
            [-12.318135758595634, 9.293280997531562],
            [-12.293177699333476, 9.293738505626726],
            [-12.271527281035628, 9.262131182334063],
            [-12.274446466746346, 9.242497605501276],
            [-12.289351486344591, 9.232938397337664],
            [-12.289204615105504, 9.213138889712123],
            [-12.279526115374752, 9.20974373815252],
            [-12.278552601204899, 9.190574896982188],
            [-12.258890940489907, 9.180878231988462],
            [-12.247771681135818, 9.188831393408645],
            [-12.232107293939885, 9.187132854707963],
            [-12.18056518775168, 9.164145751871555],
            [-12.165193226458571, 9.178867430032481],
            [-12.146170845137062, 9.186432105600588],
            [-12.099683230704365, 9.185506039070459],
            [-12.08440793215696, 9.17478438978812],
            [-12.07885476397248, 9.160256937965762],
            [-12.086731912170146, 9.125453521099143],
            [-12.105242940065152, 9.107416899247632],
            [-12.10000779252977, 9.089123044904522],
            [-12.114685433585086, 9.07181561649985],
            [-12.120412119818468, 9.049943204178328],
            [-12.11822056135098, 9.03822721596504],
            [-12.12641304485442, 9.029261509532775],
            [-12.143599762529549, 9.026572531021307],
            [-12.159995853201256, 9.030185497403707],
            [-12.165294242045638, 9.008031996303615],
            [-12.154311899605958, 8.98746560128001],
            [-12.15268580900441, 8.969176417671383],
            [-12.164127737636194, 8.956072046493379],
            [-12.16734553247693, 8.940310472197064],
            [-12.1971613241061, 8.92209203343545],
            [-12.193468426596782, 8.899095402087863],
            [-12.201721435556472, 8.870906893389785],
            [-12.21996043557088, 8.844929065242816],
            [-12.220552640020514, 8.82246295330656],
            [-12.227428097032698, 8.816749896916324],
            [-12.25344549862711, 8.811185072451206],
            [-12.25422501300172, 8.792276619389442],
            [-12.245501840338399, 8.784146828419697],
            [-12.246888123378936, 8.746492914075779],
            [-12.254337880475024, 8.71874399116821],
            [-12.277327906948917, 8.709846788537984],
            [-12.284812415773613, 8.718272042486197],
            [-12.303272812253828, 8.720455005216909],
            [-12.314930734135752, 8.702706528724844],
            [-12.314566227755176, 8.681205035532866],
            [-12.295819382519769, 8.666062163620603],
            [-12.285944581739113, 8.663828708592654],
            [-12.278891132470822, 8.646977962722671],
            [-12.291932419971696, 8.61334079958506],
            [-12.310143377222202, 8.60740125566267],
            [-12.323621285139165, 8.58935963957055],
            [-12.305537907061218, 8.584389738484953],
            [-12.30409049102296, 8.566631534546895],
            [-12.315671523120253, 8.559415740608689],
            [-12.308531432889396, 8.54655284812359],
            [-12.296209759052903, 8.549310179873137],
            [-12.291394552729827, 8.538294595509642],
            [-12.268733875592275, 8.524348811971791],
            [-12.266259195452637, 8.503813740499712],
            [-12.290196493730217, 8.486410791449059],
            [-12.282464477843908, 8.460182905274284],
            [-12.272160521080579, 8.447415435319801],
            [-12.271266440058394, 8.42852037157611],
            [-12.283755924574644, 8.42055726541216],
            [-12.291407820663485, 8.402371003891343],
            [-12.309097280151601, 8.41609096778472],
            [-12.332914885037653, 8.409567747545617],
            [-12.360919479573184, 8.409035925995251],
            [-12.367964589915935, 8.391875033506185],
            [-12.414027763744167, 8.346648105624471],
            [-12.40159221462451, 8.32923550786627],
            [-12.406249396568262, 8.31456813198414],
            [-12.395606760924816, 8.297008419413443],
            [-12.381357072431214, 8.28820344525805],
            [-12.378927907184375, 8.268976202506252],
            [-12.384849495789291, 8.260706653274113],
            [-12.388267787524999, 8.237074134127901],
            [-12.408294486325149, 8.220563382640153],
            [-12.419916236630739, 8.223762709896421],
            [-12.439346956666332, 8.209438206023638],
            [-12.42696848083826, 8.182278832065037],
            [-12.445112000023459, 8.16212978271172],
            [-12.446492640882168, 8.134900094284301],
            [-12.426589931280418, 8.144933939698142],
            [-12.409428572359277, 8.126110753576267],
            [-12.385781958277839, 8.126573772567331],
            [-12.387801692951157, 8.111681700769791],
            [-12.367923540379117, 8.091817823735331],
            [-12.363120419898625, 8.070895665569726],
            [-12.343812447845444, 8.059415585554122],
            [-12.33102160520019, 8.045783908672425],
            [-12.321921796816222, 8.012440392852728],
            [-12.315301602313474, 8.01056516658213],
            [-12.27313096961187, 8.023602205197497],
            [-12.257365004080935, 8.037331150780329],
            [-12.242573276448521, 8.06317757819801],
            [-12.239596341320182, 8.083029264854138],
            [-12.22494910243761, 8.08066568187739],
            [-12.210741094032882, 8.067561330420352],
            [-12.192038832896731, 8.079224962195871],
            [-12.160260566537994, 8.079515967888918],
            [-12.145065976246183, 8.104133312291705],
            [-12.128231830868875, 8.103380342842662],
            [-12.115673798002808, 8.111066599403184],
            [-12.112483356017757, 8.124881099147817],
            [-12.099259587371327, 8.139386698945865],
            [-12.087975642929072, 8.142012793571796],
            [-12.072352396851263, 8.154645109384832],
            [-12.062293619121803, 8.153040965189355],
            [-12.057109097356392, 8.167093129303625],
            [-12.063074469877094, 8.180649972298488],
            [-12.054127223996293, 8.196073182104037],
            [-12.034961059873773, 8.202983498788873],
            [-12.01963654814375, 8.199564258588465],
            [-12.012375917028882, 8.185554299612223],
            [-11.998697520916524, 8.188620031149895],
            [-11.992329537332019, 8.149222314105948],
            [-11.97838473715368, 8.132015060068547],
            [-11.98826891174407, 8.111918255160756],
            [-11.97671933600999, 8.105552568787918],
            [-11.958719228143469, 8.108361068182925],
            [-11.94828323007351, 8.095115249964769],
            [-11.934518548673621, 8.092237749189001],
            [-11.925596630707858, 8.081174342990296],
            [-11.922380301060628, 8.059748532853062],
            [-11.940351222760162, 8.04153448230956],
            [-11.959280493490875, 8.004615560366615],
            [-11.937288926854588, 8.003137992236471],
            [-11.918167327738162, 7.990578488620367],
            [-11.915661677842019, 7.956324450878467],
            [-11.928862568674049, 7.948399814627018],
            [-11.936559593722016, 7.934985427962964],
            [-11.935747254774036, 7.914031168051784],
            [-11.925674909796312, 7.904468266905343],
            [-11.93905439542882, 7.896281193711601],
            [-11.939216627373677, 7.885942705593413],
            [-11.922639416570517, 7.8790907301145285],
            [-11.914434949390396, 7.866990086461687],
            [-11.917954356447188, 7.8307018244896],
            [-11.92739283469217, 7.820642339237318],
            [-11.928831808256769, 7.805155031300246],
            [-11.917800081777253, 7.790410608619091],
            [-11.914553101133249, 7.7748892440759],
            [-11.898397361449224, 7.749971187821361],
            [-11.90938715211241, 7.736015957918373],
            [-11.90237132231305, 7.720771076449287],
            [-11.8894686959002, 7.710044160033959],
            [-11.880384489276931, 7.6796542611673155],
            [-11.854455169675447, 7.645821207266224],
            [-11.859285602711395, 7.629139887850836],
            [-11.852775862699243, 7.6093446748674065],
            [-11.853572463873304, 7.592498447535089],
            [-11.838566831498706, 7.57106857477292],
            [-11.812349001091455, 7.570049249599566],
            [-11.808683807004822, 7.561622064137999],
            [-11.823291538650569, 7.547686203303013],
            [-11.8019546570105, 7.525545857913438],
            [-11.802747842023134, 7.5144808811552535],
            [-11.780474628020913, 7.5059610343062255],
            [-11.78114681746784, 7.480124391804987],
            [-11.785215017856833, 7.467999471871057],
            [-11.78011846518471, 7.453562896454052],
            [-11.787381079532215, 7.446774506138192],
            [-11.79295250482337, 7.408279312068289],
            [-11.80997335687901, 7.398991523188195],
            [-11.820382883445939, 7.4033797177956595],
            [-11.83414827503442, 7.397207695103493],
            [-11.832543797606762, 7.379591866113598],
            [-11.821686837515458, 7.362348444236797],
            [-11.828492804255665, 7.349222300661018],
            [-11.818368495158978, 7.338799526192695],
            [-11.818007681279559, 7.317180136488832],
            [-11.801743650883111, 7.302857303548503],
            [-11.799795444018725, 7.2856644504813195],
            [-11.773880989574318, 7.280852813710135],
            [-11.75742107917471, 7.259943750109545],
            [-11.75259269312255, 7.223732689107966],
            [-11.722660830138295, 7.233086332248042],
            [-11.705807854891638, 7.242703731237417],
            [-11.680593505841363, 7.248812025108435],
            [-11.67607435632909, 7.239107621855792],
            [-11.657068626037884, 7.230760830032165],
            [-11.640363674751603, 7.205635677183107],
            [-11.60965372124556, 7.185801729118788],
            [-11.616070762538405, 7.173898392044972],
            [-11.596404401152464, 7.139301574393072],
            [-11.60033695463146, 7.116598987291434],
            [-11.590561803135328, 7.09174255050152],
            [-11.581857192951897, 7.085538662213781],
            [-11.585626516800337, 7.056366280245697],
            [-11.57798886140753, 7.042554382860521],
            [-11.585194875885431, 7.025310247359332],
            [-11.59828564129504, 7.022990684912883],
            [-11.60987442995015, 7.010448223308678],
            [-11.594853405979018, 6.994518165687854],
            [-11.599294544488316, 6.9878650929442845],
            [-11.581253158672748, 6.970482013261701],
            [-11.591232352235403, 6.955288914691211],
            [-11.577487691031427, 6.942423840272524],
            [-11.5666217295858, 6.92240589863123],
            [-11.57444260551566, 6.919826785136119],
            [-11.585665546062462, 6.901577920892337],
            [-11.576179911397347, 6.875076504887013],
            [-11.578228662591027, 6.857305672640394],
            [-11.563828402726877, 6.834326127167483],
            [-11.546884352543616, 6.814985487700314],
            [-11.533219710385133, 6.80836285568331],
            [-11.516174197596364, 6.790941025145507],
            [-11.50703519066924, 6.795809438117822],
            [-11.504797674479184, 6.769211633580699],
            [-11.483132392921318, 6.743431936079562],
            [-11.457352461019587, 6.757805198153388],
            [-11.45805942780618, 6.789025794654295],
            [-11.467420012990676, 6.807218122479511],
            [-11.456818101579511, 6.822043782812362],
            [-11.431406218498207, 6.839372635366805],
            [-11.414976603922257, 6.859434840396406],
            [-11.385434341028484, 6.860715731314768],
            [-11.368965445194837, 6.871248540389615],
            [-11.348696766534895, 6.861436636255178],
            [-11.33322642756243, 6.846659528970163],
            [-11.310963396781695, 6.847598780257809],
            [-11.309272514893081, 6.838958324173261],
            [-11.289275112872703, 6.843448269084902],
            [-11.278959820364456, 6.831940047797052],
            [-11.253489416763676, 6.83090303966451],
            [-11.23001656609923, 6.8169248746829645],
            [-11.210767628802673, 6.809690030584587],
            [-11.201561349463656, 6.81647954985987],
            [-11.1657206341356, 6.784069430421736],
            [-11.145508665618832, 6.775066078474238],
            [-11.131035503405226, 6.790629959468113],
            [-11.116896453314979, 6.8159188695835855],
            [-11.112387487574894, 6.851229191258018],
            [-11.10792395911393, 6.857319321751097],
            [-11.082800216948723, 6.856496347469141],
            [-11.07591739083191, 6.869883204688884],
            [-11.054528995514469, 6.88142518687184],
            [-11.033692882301853, 6.880571460512332],
            [-11.015585930179423, 6.870204839660378],
            [-11.013737254412606, 6.849095222332264],
            [-10.989054426207069, 6.834320355364688],
            [-10.974099791977006, 6.840318732820604],
            [-10.955076721634809, 6.835294448006469],
            [-10.949334118546329, 6.823272471879606],
            [-10.933387620565263, 6.812500165716844],
            [-10.92605036180743, 6.820499417443816],
            [-10.908258822579189, 6.824448022087643],
            [-10.883561989742192, 6.812011275490839],
            [-10.880771586401272, 6.829629977048286],
            [-10.863045494787752, 6.818334807732635],
            [-10.843857953923061, 6.81248977514787],
            [-10.82041927424954, 6.829203044653269],
            [-10.785676435336445, 6.824632368127338],
            [-10.764162087899845, 6.827062391114138],
            [-10.750700951669408, 6.787103068653971],
            [-10.739000389145307, 6.767754465811009],
            [-10.72480974441672, 6.780257132173658],
            [-10.711260345453683, 6.777926624966925],
            [-10.68103108145045, 6.79022873315239],
            [-10.659034576991406, 6.789207114291659],
            [-10.648288423089268, 6.803854694558725],
            [-10.599256746053456, 6.789317163223058],
            [-10.58592492162464, 6.782580810304149],
            [-10.565302563127888, 6.79320244116605],
            [-10.523593813777852, 6.7714385885017325],
            [-10.51952198463794, 6.759828094712955],
            [-10.493772083938714, 6.760740184861166],
            [-10.492665337033428, 6.774537381126656],
            [-10.509924913819253, 6.78354322593906],
            [-10.503974591057013, 6.793072770950776],
            [-10.513950291555027, 6.804463969311822],
            [-10.51537284961723, 6.827930063100961],
            [-10.506408867665183, 6.841775670720158],
            [-10.495937510685694, 6.846556649102842],
            [-10.502713267954046, 6.865048932120725],
            [-10.48803550841032, 6.8629164164737215],
            [-10.468243064824227, 6.882447352893393],
            [-10.475121973502121, 6.917508348911679],
            [-10.456405331852011, 6.9274607380650375],
            [-10.431149801063777, 6.930641073269755],
            [-10.420541973673558, 6.918882879474445],
            [-10.406827643559234, 6.930100259121167],
            [-10.398558971845056, 6.957272073911767],
            [-10.381862579525464, 6.944353019135934],
            [-10.37650846951126, 6.928330478335642],
            [-10.363091040246179, 6.93218244668363],
            [-10.339173811906603, 6.896963182502242],
            [-10.34114855588813, 6.886201075647402],
            [-10.331216663833093, 6.876452383034043],
            [-10.32498555104662, 6.856973272077976],
            [-10.298784944877477, 6.809851428300737],
            [-10.313886407250365, 6.804992469455599],
            [-10.311153546587786, 6.76656927140385],
            [-10.29310795661757, 6.762389344857309],
            [-10.279815379358208, 6.7535413158193665],
            [-10.281904257602521, 6.739408602651247],
            [-10.267939335914193, 6.7284853414032995],
            [-10.263894052026098, 6.716452056416609],
            [-10.25082597964994, 6.711803613876385],
            [-10.258382864585549, 6.697303392802676],
            [-10.25545121301433, 6.679971402017791],
            [-10.236517862307322, 6.664502318974822],
            [-10.203932989888141, 6.649873288870813],
            [-10.202187348093167, 6.645220638841391],
            [-10.22173851821333, 6.526823331265312],
            [-10.274068254212983, 6.198339375653054],
            [-10.276034156465192, 6.178290422400769],
            [-10.304719338066393, 5.996762097006375],
            [-10.353484870698784, 5.686015101376792],
            [-10.400422347295132, 5.388958953394926],
            [-10.43590786964345, 5.166119782473772],
            [-10.475671273858199, 4.916309021241383],
            [-10.51253702322444, 4.701147513419061],
            [-10.537418442790758, 4.547100891427056],
            [-10.570283834917902, 4.342001006002326],
            [-10.592349556832646, 4.202332016486536],
            [-10.690733727456225, 4.217889684066389],
            [-10.789120663483045, 4.23342949122344],
            [-10.906839755536003, 4.250995068529408],
            [-11.006134071932173, 4.267282449128282],
            [-11.10543132401479, 4.283551601176585],
            [-11.25223289045407, 4.307303698825377],
            [-11.39904066875811, 4.331015969402906],
            [-11.412345376920264, 4.337664450935757],
            [-11.551781076518884, 4.361227831138835],
            [-11.700945990541937, 4.38680856090048],
            [-11.850117784938172, 4.412347996452412],
            [-11.965838458613531, 4.431922496670568],
            [-12.081563140797407, 4.451472157349072],
            [-12.239086559240928, 4.478019709172456],
            [-12.396617268966326, 4.504521243288873],
            [-12.48344905598958, 4.5191161243651985],
            [-12.57028302561319, 4.533697026735359],
            [-12.669684077778056, 4.551585646452922],
            [-12.732984971631494, 4.568287246827497],
            [-12.77007841343745, 4.576176516246913],
            [-12.857122781851107, 4.593142707624603],
            [-12.944169869173265, 4.610094700502241],
            [-13.078423007116074, 4.637599808644719],
            [-13.173224431979156, 4.655258112380211],
            [-13.261114564614005, 4.676487713777388],
            [-13.32239080314261, 4.692379548193095],
            [-13.372762727629704, 4.701949054267855],
            [-13.486584581317997, 4.719437143031464],
            [-13.588544198873475, 4.7402762743198466],
            [-13.69050772247273, 4.76109580987815],
            [-13.782950785804825, 4.780591259019899],
            [-13.875397193979856, 4.800070546617587],
            [-13.915681194920893, 4.809061191114107],
            [-14.029746357345712, 4.832611269962884],
            [-14.143816408854718, 4.856136770638951],
            [-14.233353613523978, 4.8761831530517625],
            [-14.329582932382738, 4.89678962434099],
            [-14.425815893781039, 4.917378529908844],
            [-14.451783118264759, 4.921975426511769],
            [-14.544713711538462, 4.943021369312953],
            [-14.637647976291905, 4.964050829095016],
            [-14.760819590833663, 4.991991613452758],
            [-14.883997628083016, 5.019903411444217],
            [-14.92486600987085, 5.029971282100715],
            [-14.888070478072866, 5.192916489985554],
            [-14.841459174727527, 5.400463045737311],
            [-14.787144119729161, 5.641215506329828],
            [-14.746546691853846, 5.8194535211898435],
            [-14.69879092753657, 6.031967765700701],
            [-14.634818466837654, 6.314911899014345],
            [-14.584036752385039, 6.5394039989505925],
            [-14.526139706217975, 6.794734740257234],
            [-14.520087383245357, 6.80492230012969],
            [-14.525690627765023, 6.817028692629125],
            [-14.505798968573167, 6.8327459744870795],
            [-14.510313851539037, 6.843155255802358],
            [-14.48111297313585, 6.84917988999396],
            [-14.471667631810732, 6.871112469026717],
            [-14.469590866240127, 6.891582442769902],
            [-14.457222580862842, 6.891102811482152],
            [-14.456939073110682, 6.908720188552854],
            [-14.445083224063234, 6.935719097966142],
            [-14.454143187611214, 6.948870192475946],
            [-14.44093156573905, 6.954307944535324],
            [-14.42540276977776, 6.952554203006991],
            [-14.425202915377625, 6.971498361905082],
            [-14.414768735251387, 6.987615800065522],
            [-14.41781672215009, 7.002988651244288],
            [-14.435304475756185, 7.020277962385667],
            [-14.430652485511002, 7.056592742006617],
            [-14.404843772772747, 7.059725719420109],
            [-14.391581240023209, 7.070316301165853],
            [-14.356114928583613, 7.1163825420535725],
            [-14.357945223134505, 7.136451816764598],
            [-14.371092571484303, 7.151688896270763],
            [-14.386636210032457, 7.154856664226356],
            [-14.402116553291076, 7.16441239627877],
            [-14.3966581675128, 7.183841030518321],
            [-14.395054791001598, 7.209341780109747],
            [-14.432770057438828, 7.2236545136514305],
            [-14.453856411844603, 7.210245828359881],
            [-14.45846693395685, 7.224676839010109],
            [-14.470805816106171, 7.241946932934452],
            [-14.476252609564094, 7.265307906615991],
            [-14.488490059362135, 7.265647480529875],
            [-14.504694418511933, 7.250699403497314],
            [-14.526958605197692, 7.255208337823241],
            [-14.55288548821509, 7.291103777352311],
            [-14.5493104840347, 7.309501715878919],
            [-14.537910878840082, 7.312897203821796],
            [-14.523255913326462, 7.33363340462096],
            [-14.525524615123764, 7.34411555914],
            [-14.546513319655439, 7.376878886677561],
            [-14.546722113878603, 7.400071094520982],
            [-14.533810148438352, 7.406375231000597],
            [-14.520747108083052, 7.4254370534920895],
            [-14.515813231398804, 7.4456023752681855],
            [-14.51669207682534, 7.477768726150413],
            [-14.503505225542943, 7.481193801605962],
            [-14.49020667979329, 7.4926997507787645],
            [-14.476258212096086, 7.513082617754138],
            [-14.461515788151786, 7.512019972390917],
            [-14.44528274115995, 7.529247340114003],
            [-14.441502591111506, 7.551788230236751],
            [-14.423386830837522, 7.563243953436276],
            [-14.413644582739801, 7.592459109592031],
            [-14.392450719621035, 7.6142260969984985],
            [-14.38551566630856, 7.637162798333202],
            [-14.37326497587131, 7.643534501010019],
            [-14.367872545032638, 7.6611543603604995],
            [-14.35269649742606, 7.6725042385649305],
            [-14.348511933001182, 7.692426091383307],
            [-14.332061987941474, 7.707072399302182],
            [-14.308456602978785, 7.71371862842492],
            [-14.298254787573471, 7.710980044022031],
            [-14.27193362557706, 7.724254783939738],
            [-14.247834660002498, 7.727755175439707],
            [-14.243881326337098, 7.742035938005315],
            [-14.21670565565044, 7.772642198002316],
            [-14.20524198028875, 7.791417171472129],
            [-14.1809602363455, 7.801142330320117],
            [-14.168343196956291, 7.81561604532521],
            [-14.150857618517149, 7.848375558977022],
            [-14.145240119204033, 7.864447324219773],
            [-14.151802723418701, 7.883662035578443],
            [-14.146973642619004, 7.896613176393521],
            [-14.15024440657748, 7.9099286625216765],
            [-14.138149190921698, 7.924671264275177],
            [-14.135824966053006, 7.94566474150366],
            [-14.092761991162424, 7.974430807071359],
            [-14.079754149208695, 7.9885335720895005],
            [-14.07482889813192, 8.006560285135553],
            [-14.05171469668655, 8.019940078742101],
            [-14.041313427010035, 8.037012698266023],
            [-14.029967348886561, 8.041522529457875],
            [-14.018308682077798, 8.071007597465258],
            [-14.001402549662513, 8.09928398921138],
            [-13.988862349766443, 8.134876451764825],
            [-13.971917521661727, 8.158615081894405],
            [-13.961475748449777, 8.164944148657124],
            [-13.951243446510253, 8.208511146874848],
            [-13.89716432743, 8.274461818729176],
            [-13.879218191480714, 8.285307127678086],
            [-13.866395335256811, 8.31306862056091],
            [-13.839240480395665, 8.327435462498173],
            [-13.838044246078729, 8.345672835059773],
            [-13.831151484923403, 8.369543946508838],
            [-13.820716423281482, 8.375339978829093],
            [-13.799945583800232, 8.403660807112994],
            [-13.7813788663746, 8.41988353332801],
            [-13.76562177175301, 8.426999222414384],
            [-13.761792065487645, 8.437239342606636],
            [-13.7468923560538, 8.449040202517155],
            [-13.744026226977699, 8.461578827877482],
            [-13.753430787322273, 8.498009518314063],
            [-13.774222240217444, 8.534600471912993],
            [-13.776887508981199, 8.545562163641216],
            [-13.767988205532392, 8.586628302531372],
            [-13.771866324470855, 8.604405898567027],
            [-13.779692222965837, 8.610371659745361],
            [-13.7975612746453, 8.63787941793278],
            [-13.822778395934463, 8.649885031607017],
            [-13.846123279393197, 8.651963902402517],
            [-13.853705675477741, 8.665347464081533],
            [-13.86004409952791, 8.694310623829683],
            [-13.884899952986276, 8.70514113421436],
            [-13.905453241193761, 8.699938101560393],
            [-13.916673538506462, 8.711300036512494],
            [-13.918602926967448, 8.745203822099333],
            [-13.926773543944876, 8.766296836292694],
            [-13.94357961964589, 8.784886117876542],
            [-13.953847394517096, 8.81211417749285],
            [-13.95211186532841, 8.849603070865866],
            [-13.961035802617598, 8.85723452037858],
            [-13.95879784323947, 8.873284504154256],
            [-13.970354314944897, 8.895086305804204]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.65932905299483,
          "lat": 44.38910510198778
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779783"
      },
      "bbox": [
        -14.92486600987085, 4.202332016486536, -10.202187348093167,
        11.776285390775541
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-12.810561323081624, -11.929273958103355],
              [-12.8072807399064, -11.924979129616384],
              [-12.807684455204654, -11.92012645090632],
              [-12.79551663733991, -11.921530184704457],
              [-12.801510910894653, -11.926722583830975],
              [-12.803091451993595, -11.932933858791635],
              [-12.810561323081624, -11.929273958103355]
            ]
          ],
          [
            [
              [-12.82775979774005, -11.899409920749768],
              [-12.824941787008502, -11.897407308000881],
              [-12.824757961205794, -11.888896622652823],
              [-12.821897053729788, -11.882235895471972],
              [-12.827665151953894, -11.879228675595321],
              [-12.827697526045347, -11.870554949174513],
              [-12.824183554755743, -11.867424131500012],
              [-12.816445134768227, -11.868760348059187],
              [-12.818002542991604, -11.859378629358003],
              [-12.825550217070674, -11.85926227996822],
              [-12.827281518185783, -11.855420024687154],
              [-12.83491948970336, -11.855036407321911],
              [-12.831086391734996, -11.850566713776645],
              [-12.842760675071302, -11.834828787458124],
              [-12.841777537507864, -11.827898704065776],
              [-12.843413142815752, -11.822214225476701],
              [-12.838507166144247, -11.822594151667376],
              [-12.83148639185828, -11.819489698666905],
              [-12.829369305868648, -11.821466300375526],
              [-12.820070675260341, -11.821753729171956],
              [-12.82082547318489, -11.824820546017198],
              [-12.809359301381857, -11.830956405060652],
              [-12.803854840518841, -11.829199567395296],
              [-12.79918168354763, -11.830291506225487],
              [-12.793653570207452, -11.835130266536964],
              [-12.781357927787313, -11.838606256780656],
              [-12.787697083569816, -11.843227288578838],
              [-12.780107066080094, -11.856789908719778],
              [-12.780504954631894, -11.867950007091503],
              [-12.774418198050997, -11.871919641995884],
              [-12.771804437045096, -11.882194556704137],
              [-12.774850172935523, -11.893895358872205],
              [-12.794310920823667, -11.900525352019708],
              [-12.7991132313704, -11.896738228511493],
              [-12.800645945355313, -11.890935733461017],
              [-12.806111047128345, -11.885996349591743],
              [-12.808563483583333, -11.88886719216794],
              [-12.804713398985257, -11.895501785965461],
              [-12.811230810930041, -11.905359812200647],
              [-12.814023416934903, -11.91378847292992],
              [-12.823051016995533, -11.910600013986887],
              [-12.82775979774005, -11.899409920749768]
            ]
          ],
          [
            [
              [-12.933963892331635, -11.639815592615014],
              [-12.927069899128794, -11.637067627337586],
              [-12.932989769775329, -11.628980679027727],
              [-12.930975805830155, -11.622644312031381],
              [-12.926297720637411, -11.618446568441966],
              [-12.92193765141147, -11.620628629120285],
              [-12.911305727900357, -11.630157839641436],
              [-12.91240154395593, -11.635127235097475],
              [-12.924039169912394, -11.636773073972707],
              [-12.930394408355548, -11.641482347993644],
              [-12.933963892331635, -11.639815592615014]
            ]
          ],
          [
            [
              [-12.921059382356729, -11.757400268275353],
              [-12.915717841241452, -11.7537805279917],
              [-12.915261668456255, -11.749939664292045],
              [-12.90491594148971, -11.745418196730608],
              [-12.90245688185828, -11.75478803176576],
              [-12.905929970917676, -11.761076521514418],
              [-12.914622399609415, -11.767279848632098],
              [-12.916054644665609, -11.761195497825316],
              [-12.921059382356729, -11.757400268275353]
            ]
          ],
          [
            [
              [-13.020851475634407, -11.597950342227469],
              [-13.019843111816426, -11.58614963264742],
              [-13.01373164347035, -11.588978303591727],
              [-13.0028846298882, -11.603710750361248],
              [-13.001833661591638, -11.611024671778688],
              [-13.007380567622997, -11.615347456025743],
              [-13.013510466966979, -11.606294397282365],
              [-13.015478299596296, -11.61029790854278],
              [-13.021090796686755, -11.601042135093566],
              [-13.020851475634407, -11.597950342227469]
            ]
          ],
          [
            [
              [-13.018115953860349, -11.797846417613915],
              [-13.01009397396489, -11.795241743154364],
              [-13.006227664535356, -11.799954938676912],
              [-13.014151876475697, -11.800116630994523],
              [-13.018115953860349, -11.797846417613915]
            ]
          ],
          [
            [
              [-13.149403797690347, -11.47311920389039],
              [-13.15152729904064, -11.466500649211731],
              [-13.14674454357861, -11.463547306818382],
              [-13.142883427025433, -11.4691644857822],
              [-13.146237871095508, -11.474881251348561],
              [-13.149403797690347, -11.47311920389039]
            ]
          ],
          [
            [
              [-13.155946799389252, -11.456986352860014],
              [-13.153221360545174, -11.446644791133728],
              [-13.146075901738728, -11.440490741667304],
              [-13.144090730484217, -11.44766543737772],
              [-13.150646776934904, -11.457804305230447],
              [-13.155946799389252, -11.456986352860014]
            ]
          ],
          [
            [
              [-13.150776915570216, -11.519260222654765],
              [-13.14915821931427, -11.508820438695256],
              [-13.143300268613674, -11.499895623312794],
              [-13.123095326005469, -11.5059567825095],
              [-13.122057591961353, -11.510382289552716],
              [-13.127761697338974, -11.512980581927833],
              [-13.12798626927072, -11.518825396125903],
              [-13.133965579961714, -11.523179671095011],
              [-13.134038389374187, -11.527783177414046],
              [-13.139068967604487, -11.529818278374538],
              [-13.144806820097257, -11.528505671018568],
              [-13.14823278360968, -11.525575771030388],
              [-13.150776915570216, -11.519260222654765]
            ]
          ],
          [
            [
              [-13.166872436965562, -11.475008805131418],
              [-13.16439656576126, -11.462611816611886],
              [-13.159556902705026, -11.469284071679466],
              [-13.159488355826209, -11.478667805946687],
              [-13.161426427189083, -11.480349133719264],
              [-13.166872436965562, -11.475008805131418]
            ]
          ],
          [
            [
              [-13.173331961284346, -11.485815731486994],
              [-13.167874172278099, -11.481417119482883],
              [-13.16500158896678, -11.482756749091],
              [-13.16294368784971, -11.489497059066634],
              [-13.171354768693963, -11.489778409721787],
              [-13.173331961284346, -11.485815731486994]
            ]
          ],
          [
            [
              [-13.177315028647405, -11.496196781365756],
              [-13.174026163093599, -11.492081374190318],
              [-13.164956583671616, -11.494439951086374],
              [-13.160770562720428, -11.498063112587282],
              [-13.161995692173607, -11.502983869254168],
              [-13.174628160943815, -11.499693268390857],
              [-13.177315028647405, -11.496196781365756]
            ]
          ],
          [
            [
              [-13.038266401934038, -12.014758662784022],
              [-13.031567024005545, -12.011560192261529],
              [-13.030878642809618, -12.008235431522147],
              [-13.019902105327409, -12.002216189601109],
              [-13.00908575771423, -12.009516283630326],
              [-13.003261972818079, -12.008113791211269],
              [-12.994169953645974, -12.01562999023571],
              [-12.99715978199553, -12.017739448599256],
              [-12.998933291207123, -12.023572158214293],
              [-12.992391125818491, -12.025512349187021],
              [-12.995096259015964, -12.029652493726639],
              [-12.996896122544673, -12.036756181560156],
              [-12.990301942092195, -12.036905763324526],
              [-12.985639976493857, -12.04361335390817],
              [-12.980215351897623, -12.04817240392664],
              [-12.982182032156754, -12.058434418010382],
              [-12.987018753855944, -12.058426690726108],
              [-12.992224190643242, -12.0556204142747],
              [-13.00303294577784, -12.041442546553238],
              [-13.010629653021352, -12.038181034368613],
              [-13.012201254662244, -12.035778854160338],
              [-13.023314336934414, -12.033063029118807],
              [-13.030689525364094, -12.025488617772874],
              [-13.031915549299773, -12.020292113394992],
              [-13.038266401934038, -12.014758662784022]
            ]
          ],
          [
            [
              [-13.075017540998477, -11.973320999329687],
              [-13.075693477586016, -11.969663780484096],
              [-13.070059070757612, -11.961674441005393],
              [-13.065577044213457, -11.970531063409071],
              [-13.070678096651285, -11.976391010305553],
              [-13.075017540998477, -11.973320999329687]
            ]
          ],
          [
            [
              [-13.191463178819983, -11.628084410795871],
              [-13.190197864829749, -11.620595558417072],
              [-13.180611162107706, -11.621287958590138],
              [-13.172635881141598, -11.629344582136481],
              [-13.178100370932006, -11.629120060820942],
              [-13.180058749578587, -11.632217822032311],
              [-13.18589354437555, -11.633067077378142],
              [-13.191463178819983, -11.628084410795871]
            ]
          ],
          [
            [
              [-13.210622239132833, -11.609442658992837],
              [-13.203235527564157, -11.606810289860217],
              [-13.190518902984833, -11.612018058378158],
              [-13.190133536683158, -11.616939230225034],
              [-13.196682478576442, -11.617156218379636],
              [-13.204985310034049, -11.610812156060552],
              [-13.210622239132833, -11.609442658992837]
            ]
          ],
          [
            [
              [-13.21743678026039, -11.589908381731837],
              [-13.217242353077152, -11.582716842732586],
              [-13.211011437583512, -11.582267175299808],
              [-13.208981350353563, -11.587100449107348],
              [-13.213865385145622, -11.592460714214532],
              [-13.21743678026039, -11.589908381731837]
            ]
          ],
          [
            [
              [-13.214263466445823, -11.600939898424349],
              [-13.21594238279254, -11.59482014666935],
              [-13.206348172798407, -11.592863642868764],
              [-13.201073943439884, -11.594104214178042],
              [-13.198432548766219, -11.598794069785765],
              [-13.199573913437852, -11.603149660490296],
              [-13.20473285822446, -11.604878907260211],
              [-13.212100911624807, -11.603923077375269],
              [-13.214263466445823, -11.600939898424349]
            ]
          ],
          [
            [
              [-13.210986956276862, -11.613739218558905],
              [-13.205920980328276, -11.613979273992596],
              [-13.201305783156126, -11.620505687869962],
              [-13.20543159279705, -11.623454565243899],
              [-13.210986956276862, -11.613739218558905]
            ]
          ],
          [
            [
              [-13.099900304321105, -11.947446623436296],
              [-13.092817367776005, -11.940530645376036],
              [-13.091121313194861, -11.94380338543026],
              [-13.09560760321585, -11.948323610960337],
              [-13.099900304321105, -11.947446623436296]
            ]
          ],
          [
            [
              [-13.239946788257619, -11.56200408007875],
              [-13.237231312808685, -11.555262319907479],
              [-13.236019348615825, -11.533961356226992],
              [-13.2292856444116, -11.523251453705363],
              [-13.225013071723119, -11.520001801276885],
              [-13.214552914191142, -11.517201107085405],
              [-13.204684980072116, -11.51938261339041],
              [-13.19241766088793, -11.509537114410083],
              [-13.186095060987956, -11.507934163727903],
              [-13.176192966312607, -11.510035883310664],
              [-13.165838860895704, -11.515294240151382],
              [-13.16137308110337, -11.52457430240194],
              [-13.164910586290869, -11.528778940489177],
              [-13.1673275453912, -11.540290228772918],
              [-13.165499115432194, -11.544462250613591],
              [-13.160821722155285, -11.548446649614714],
              [-13.156473963370138, -11.55623936845116],
              [-13.155471236333895, -11.562692582266157],
              [-13.157234955667116, -11.565870655605648],
              [-13.165903529397825, -11.573922621952066],
              [-13.178624366290924, -11.580508989904253],
              [-13.190123109342673, -11.590457591658542],
              [-13.193913677325208, -11.585902505500068],
              [-13.207228175567975, -11.581027673094026],
              [-13.211046545320269, -11.57650883317355],
              [-13.220050693834013, -11.573513366134543],
              [-13.236561623680796, -11.569702198132143],
              [-13.239946788257619, -11.56200408007875]
            ]
          ],
          [
            [
              [-13.212924420281622, -11.649640716916746],
              [-13.210927004123928, -11.64095681545668],
              [-13.202488911736301, -11.635531046933718],
              [-13.19795826660183, -11.643572175386094],
              [-13.193710867689012, -11.645839775698914],
              [-13.192316864882184, -11.65365772401327],
              [-13.1982586933281, -11.653620907249255],
              [-13.204397709319363, -11.655560327809098],
              [-13.21047729278764, -11.654796738762888],
              [-13.212924420281622, -11.649640716916746]
            ]
          ],
          [
            [
              [-13.261911182770609, -11.530367185794464],
              [-13.257298368098725, -11.52849379067166],
              [-13.253939758558571, -11.523793058416441],
              [-13.24977900160724, -11.528394395324836],
              [-13.255452207829151, -11.5304193411381],
              [-13.261911182770609, -11.530367185794464]
            ]
          ],
          [
            [
              [-13.186206389757409, -11.882835606598086],
              [-13.183998451476269, -11.872526459764574],
              [-13.176636530035864, -11.868406230580145],
              [-13.17160184238506, -11.869096167367632],
              [-13.170209800057552, -11.87360954149247],
              [-13.17156144484106, -11.882733153681976],
              [-13.175775835551086, -11.883190046249696],
              [-13.181016562649408, -11.887758354093775],
              [-13.186206389757409, -11.882835606598086]
            ]
          ],
          [
            [
              [-13.223206585062584, -11.853430366972159],
              [-13.220007928921643, -11.84414446841871],
              [-13.22037574262277, -11.840640239785593],
              [-13.21496598556965, -11.839524108661337],
              [-13.211580119939681, -11.83449391634725],
              [-13.206311502116318, -11.836708527294872],
              [-13.2000077793856, -11.835304440186574],
              [-13.193581981918582, -11.838168460627658],
              [-13.189291405124287, -11.84534023328979],
              [-13.18860273555581, -11.854186258412193],
              [-13.189671201739072, -11.86131176469643],
              [-13.195863025518042, -11.867771893617373],
              [-13.196417577858226, -11.874980440304409],
              [-13.208335409904922, -11.867615842655937],
              [-13.213373860699539, -11.860230349866072],
              [-13.22038587981192, -11.857679740898924],
              [-13.223206585062584, -11.853430366972159]
            ]
          ],
          [
            [
              [-13.273627864567425, -11.74133347131482],
              [-13.271038844672487, -11.738318309709513],
              [-13.26648855320856, -11.741025038350253],
              [-13.272383165956287, -11.744256871675582],
              [-13.273627864567425, -11.74133347131482]
            ]
          ],
          [
            [
              [-13.169154921059457, -12.082913241949823],
              [-13.165152090956527, -12.083240811024204],
              [-13.158553157442135, -12.090452772186318],
              [-13.154779657386866, -12.097861120165975],
              [-13.154114554637289, -12.106857850635443],
              [-13.160852112883674, -12.104032518751739],
              [-13.162849829226083, -12.094101778072393],
              [-13.169154921059457, -12.082913241949823]
            ]
          ],
          [
            [
              [-13.268436614368971, -11.812511528598705],
              [-13.261487095663227, -11.811312955188228],
              [-13.254477213096001, -11.813628746349469],
              [-13.252451606162525, -11.821707246470034],
              [-13.257513519099053, -11.832147959507045],
              [-13.262026172031891, -11.825496466753236],
              [-13.256177920914748, -11.821371695320604],
              [-13.268436614368971, -11.812511528598705]
            ]
          ],
          [
            [
              [-13.245808383816923, -11.889865928644182],
              [-13.243842950302238, -11.88295801408131],
              [-13.238178770393858, -11.878776281883217],
              [-13.234486313927968, -11.872422721429096],
              [-13.236810045498185, -11.865953326369427],
              [-13.236310226836027, -11.858682820807456],
              [-13.221541045975034, -11.862170155287712],
              [-13.21431640064808, -11.86687300289694],
              [-13.209491192014648, -11.87845141054767],
              [-13.212672141755338, -11.884928505620367],
              [-13.231164603978291, -11.893364755140452],
              [-13.235804921220568, -11.889134890041902],
              [-13.245808383816923, -11.889865928644182]
            ]
          ],
          [
            [
              [-13.24374062556131, -11.940712273950359],
              [-13.24462724204598, -11.937196205886174],
              [-13.239629011488681, -11.931472479301183],
              [-13.239556698773635, -11.923873241554915],
              [-13.237081101346291, -11.918347761200511],
              [-13.246269639491077, -11.918134670116089],
              [-13.245390482155509, -11.910584333776967],
              [-13.238084044912867, -11.904390792655105],
              [-13.240881839409969, -11.899729453143213],
              [-13.238722443716556, -11.894937792843395],
              [-13.235002613273334, -11.893588473451912],
              [-13.231283077293481, -11.898639712296783],
              [-13.225934866550581, -11.897266673669115],
              [-13.217460966152368, -11.891955831081985],
              [-13.21400568160887, -11.893739883065422],
              [-13.204975056749968, -11.886352142037861],
              [-13.200799441091661, -11.89305341265651],
              [-13.200479496169569, -11.898878395951694],
              [-13.207365868955499, -11.903754395209434],
              [-13.212569062194579, -11.90984883196352],
              [-13.218634726434257, -11.922915626072287],
              [-13.224210912559899, -11.921637411341882],
              [-13.222405484611468, -11.931477306021772],
              [-13.223792737006946, -11.939445241456111],
              [-13.222764906951106, -11.954112608185406],
              [-13.22734529911385, -11.955629732902022],
              [-13.230994010604318, -11.950190288565818],
              [-13.23631805639306, -11.9495517190153],
              [-13.2393864265366, -11.939901105600864],
              [-13.24374062556131, -11.940712273950359]
            ]
          ],
          [
            [
              [-13.281616315715373, -11.847428731604696],
              [-13.27821746594048, -11.844232330021343],
              [-13.274730014469652, -11.848220935557778],
              [-13.277492727582183, -11.851847417511173],
              [-13.281616315715373, -11.847428731604696]
            ]
          ],
          [
            [
              [-13.335554036596026, -11.73646530431121],
              [-13.332098202373071, -11.72975845828702],
              [-13.332073529271806, -11.7222426079905],
              [-13.329011160408205, -11.709492717254149],
              [-13.324050030963033, -11.698597739641384],
              [-13.325976396837753, -11.693223355151773],
              [-13.320143250418273, -11.684926421104407],
              [-13.308661481721167, -11.681938075527528],
              [-13.303728031324875, -11.683652492185963],
              [-13.29835992098137, -11.680405077360476],
              [-13.290268657318082, -11.678503106623435],
              [-13.294881930601576, -11.673445987713924],
              [-13.306994969898442, -11.675977205882871],
              [-13.316008383848157, -11.675912686649585],
              [-13.319960451971946, -11.673607543496491],
              [-13.320520995302937, -11.66181166504173],
              [-13.310237648782802, -11.665675465855816],
              [-13.307317721989845, -11.65985407870291],
              [-13.304360906008453, -11.658789731451277],
              [-13.309161971502789, -11.649986642865375],
              [-13.316284306762036, -11.649867926952837],
              [-13.323397511037257, -11.6430283388965],
              [-13.330034292909907, -11.647087076836524],
              [-13.334779703784065, -11.641845627050472],
              [-13.329160534073356, -11.639295116673559],
              [-13.33126024154595, -11.629955938065917],
              [-13.336441692914823, -11.625904366497036],
              [-13.340297863909814, -11.620255634121595],
              [-13.340032140084913, -11.615090087981397],
              [-13.344884186193504, -11.610989629989039],
              [-13.343968547324764, -11.604250018456876],
              [-13.339788905472094, -11.605374772609663],
              [-13.337331430205536, -11.6016215401105],
              [-13.343848839374877, -11.598044081065499],
              [-13.342568444777607, -11.59304548464409],
              [-13.314527775996064, -11.59090812787777],
              [-13.301889510710431, -11.591272925677561],
              [-13.299546207495151, -11.58749710390776],
              [-13.288426119422462, -11.583953096522418],
              [-13.283849458520098, -11.583604029601899],
              [-13.28061289051196, -11.586386504098606],
              [-13.271562835426828, -11.579485655178392],
              [-13.266426758415234, -11.581926057147939],
              [-13.262256156632674, -11.575943127558137],
              [-13.256463856479096, -11.57686460306385],
              [-13.24321678105548, -11.589264586308254],
              [-13.24001121205496, -11.59088819320402],
              [-13.236613750337366, -11.599147965204445],
              [-13.228795545763042, -11.597846224703158],
              [-13.225876820358224, -11.604427740093092],
              [-13.21968502122475, -11.608869041156323],
              [-13.21999512280737, -11.614650815433693],
              [-13.214621519531335, -11.618736832395857],
              [-13.213439294654059, -11.627320386616194],
              [-13.2169120872593, -11.635458636454263],
              [-13.215135511554756, -11.639626967848551],
              [-13.219105925712755, -11.648859849162497],
              [-13.218224666361616, -11.655328025797225],
              [-13.21222106501395, -11.65923254413103],
              [-13.211484140738474, -11.663356772224084],
              [-13.205323748956985, -11.663766130683946],
              [-13.1967646505096, -11.656289894019338],
              [-13.18793110216495, -11.656137294716016],
              [-13.188930796313223, -11.651856285224458],
              [-13.182180230394907, -11.650148452602092],
              [-13.179525676286937, -11.653751202828206],
              [-13.17734810771482, -11.6616785076168],
              [-13.168759745019011, -11.65923891925702],
              [-13.162556377531661, -11.65326385833441],
              [-13.159106605584366, -11.659653827520726],
              [-13.153887735334953, -11.658454560146206],
              [-13.145092462128005, -11.662764346750535],
              [-13.137139886528686, -11.66304370323584],
              [-13.131151674203956, -11.67001908245406],
              [-13.107094259616959, -11.680475825407482],
              [-13.105403788696478, -11.684140876262516],
              [-13.097366453674148, -11.687756911014908],
              [-13.090727104217793, -11.694098962778067],
              [-13.083629793719647, -11.697734563142237],
              [-13.06828797138279, -11.710961769793636],
              [-13.06581608172217, -11.712204140702342],
              [-13.067482039235895, -11.721508444012029],
              [-13.063432172583978, -11.725476888146723],
              [-13.05385892896082, -11.731502827698892],
              [-13.054451648338341, -11.738118380563389],
              [-13.051613987849972, -11.745013386822185],
              [-13.047900853145096, -11.747184927570776],
              [-13.044821724294854, -11.756286561818513],
              [-13.040831092172898, -11.752204524044876],
              [-13.043209969997374, -11.746729929104688],
              [-13.038179765575004, -11.744099165499687],
              [-13.028709790410465, -11.750748601406352],
              [-13.021192608981833, -11.764195443599496],
              [-13.017665212316619, -11.765506442677472],
              [-13.015957106311834, -11.771165130292395],
              [-13.009597134432676, -11.774846367862516],
              [-13.00609594839437, -11.78130253326246],
              [-13.002479114971223, -11.778982043407803],
              [-12.984841073359442, -11.782904250777168],
              [-12.976659068205311, -11.787902263407233],
              [-12.968737470993764, -11.798465425030336],
              [-12.973957745675532, -11.80220106387002],
              [-12.98285716881134, -11.798577697131481],
              [-12.988110862032496, -11.794254181503474],
              [-13.003972074810946, -11.790799171399389],
              [-13.02373505804808, -11.788727394151495],
              [-13.029580232666076, -11.788775106663993],
              [-13.031988661478293, -11.786583366708214],
              [-13.03906162307588, -11.785782279064176],
              [-13.042872195543127, -11.781721257040882],
              [-13.049407998199065, -11.778571426100124],
              [-13.050774043734211, -11.773355164710471],
              [-13.054086886373566, -11.7736082760982],
              [-13.061378263052182, -11.778633004451791],
              [-13.063386686723735, -11.788176586944529],
              [-13.053156639918205, -11.788677083113036],
              [-13.05394796194726, -11.799632154546014],
              [-13.059651280646072, -11.820081930109788],
              [-13.049616972627728, -11.818261941426167],
              [-13.05173972845636, -11.807907880322725],
              [-13.044342534181435, -11.802612290895123],
              [-13.037267374697196, -11.803841226597397],
              [-13.02560545080847, -11.795863268473186],
              [-13.017717215797544, -11.807872633271678],
              [-13.014094485512993, -11.80467812343378],
              [-13.00787949972889, -11.804961876310804],
              [-13.004542447355226, -11.80173641790921],
              [-13.001566642432579, -11.80516239713231],
              [-12.992388588260338, -11.810751764240505],
              [-12.995516588638264, -11.814229731207543],
              [-13.006449117357613, -11.820851548452785],
              [-13.012886340008741, -11.820953563967489],
              [-13.015296925901035, -11.82660284249624],
              [-13.005049928981368, -11.833714725048143],
              [-13.003575924599163, -11.827588047101425],
              [-12.993180064785104, -11.819971035169724],
              [-12.986189523143045, -11.818358059569993],
              [-12.977838343010351, -11.824032060272978],
              [-12.975902711993399, -11.827737455079118],
              [-12.95712088270244, -11.834361940353034],
              [-12.952877251726168, -11.842514878443613],
              [-12.942507950025455, -11.852153314463543],
              [-12.939143060853938, -11.851541040591512],
              [-12.937249366084052, -11.856668515700562],
              [-12.941665355147379, -11.867467036952597],
              [-12.945818364420635, -11.870498638416402],
              [-12.95698944854492, -11.87157563531032],
              [-12.960500732177879, -11.878261756748172],
              [-12.963237696431746, -11.879539773880767],
              [-12.962235577734745, -11.887914769438497],
              [-12.95206860896174, -11.879600262102738],
              [-12.950185551241182, -11.876371648721353],
              [-12.931090722875476, -11.879220387123064],
              [-12.928959235463038, -11.866180777107225],
              [-12.931532926247455, -11.862552766707834],
              [-12.929176261510701, -11.851262620823235],
              [-12.924554569695617, -11.848091051365625],
              [-12.917236382546523, -11.85252212936219],
              [-12.915048403140108, -11.859173516953351],
              [-12.909344794337137, -11.866904708724892],
              [-12.904659033484366, -11.878081999222491],
              [-12.908084682202562, -11.888629759734018],
              [-12.911140710250722, -11.893667291917257],
              [-12.90987648376864, -11.898630941446196],
              [-12.901912949703028, -11.89853713501059],
              [-12.900292427359616, -11.901143402054032],
              [-12.90786210898644, -11.913194029594608],
              [-12.91467209248731, -11.917029927458312],
              [-12.91571851149462, -11.924326737166933],
              [-12.91027150777374, -11.928810864575444],
              [-12.917627991787029, -11.936301487550383],
              [-12.91791476852574, -11.939232277565912],
              [-12.932969840117817, -11.951204170602953],
              [-12.93107003090981, -11.954566346853008],
              [-12.92473219160302, -11.95322037576165],
              [-12.924020301984909, -11.950270012697137],
              [-12.915102479808814, -11.950031552346058],
              [-12.911847370481452, -11.941666423673196],
              [-12.905862511118253, -11.939316976437667],
              [-12.90436336397865, -11.93388118173118],
              [-12.900763623279623, -11.933364015496606],
              [-12.900133907090465, -11.927184295959144],
              [-12.895757279552146, -11.927661816718272],
              [-12.889616715269472, -11.923547940654164],
              [-12.88852572913388, -11.932382965434092],
              [-12.885946620216401, -11.9323288722579],
              [-12.884367865834724, -11.940042334749178],
              [-12.878339900219338, -11.947842610438656],
              [-12.875516049987123, -11.958805378501797],
              [-12.875971103239344, -11.96167875089601],
              [-12.869590918230491, -11.975563181857341],
              [-12.871024340516545, -11.979115743388633],
              [-12.880828881951572, -11.975632099164427],
              [-12.882098862656283, -11.9708634758116],
              [-12.88697824616203, -11.974184195547624],
              [-12.883073809895748, -11.979256418633872],
              [-12.867167925344027, -11.983884215887713],
              [-12.86296542727006, -11.988191192013943],
              [-12.857614426922456, -11.997765250035194],
              [-12.856710936030405, -12.002272244497552],
              [-12.862218430991046, -12.006880765246642],
              [-12.863603093402096, -12.01607977309115],
              [-12.860073235086448, -12.01839198134543],
              [-12.857892181688062, -12.02408850163731],
              [-12.859587976205885, -12.032059929622434],
              [-12.856781266050492, -12.037949354624082],
              [-12.86578210546206, -12.037368939754893],
              [-12.872255591604619, -12.03971267233399],
              [-12.87657169300668, -12.044957117561275],
              [-12.885967612401007, -12.047598724959382],
              [-12.886880874095983, -12.043086935321062],
              [-12.89368248997571, -12.044560332624206],
              [-12.896272586078123, -12.038872544951476],
              [-12.90128941856876, -12.043568894708786],
              [-12.908365852061877, -12.041902218363363],
              [-12.909760586021429, -12.04826788339917],
              [-12.91839305411738, -12.04854984518568],
              [-12.91818338142501, -12.044612516591435],
              [-12.921665881363422, -12.040560721097687],
              [-12.930134774534856, -12.042023627206387],
              [-12.93331656083802, -12.040002754619406],
              [-12.932926244129437, -12.034822015494516],
              [-12.935308672168642, -12.031004078104516],
              [-12.939480670747741, -12.035500150357448],
              [-12.946740032414999, -12.033685375296425],
              [-12.956859222249035, -12.040773837639321],
              [-12.960962282636784, -12.037667825061266],
              [-12.954281730940579, -12.033099019414683],
              [-12.956204066915738, -12.028389085983324],
              [-12.954132554501344, -12.020439261940849],
              [-12.946321752541689, -12.02197059443495],
              [-12.946544401095142, -12.018829248530468],
              [-12.937509694143074, -12.01891354648305],
              [-12.932680720681995, -12.010490062637432],
              [-12.936711576964099, -12.01038981006663],
              [-12.940813390397604, -12.003935131164349],
              [-12.952169548668383, -12.003682284456556],
              [-12.957850366565886, -11.997307597439162],
              [-12.96662115909021, -11.998664037375743],
              [-12.973237002911603, -12.003502163231241],
              [-12.977019080502629, -12.003804995456717],
              [-12.982623854073793, -11.998044960498333],
              [-12.982374668473623, -11.992440853889592],
              [-12.988887442041923, -11.993883248687446],
              [-13.003123650805055, -11.985233662199027],
              [-13.00486143766466, -11.97851532900113],
              [-13.00371628683728, -11.974057009404753],
              [-12.99828434086876, -11.973905942706002],
              [-12.99991864140582, -11.968240301334408],
              [-13.003945080231189, -11.96896618583742],
              [-13.005307153774865, -11.961296235254272],
              [-13.001722416796307, -11.958403324063678],
              [-13.00070498658055, -11.952269097877394],
              [-13.003854790334412, -11.951137449409055],
              [-13.003808121283027, -11.940117038971756],
              [-13.001403348201833, -11.93790505763831],
              [-13.002705635608594, -11.93292994216635],
              [-13.007694064372279, -11.937411682063564],
              [-13.008994070478375, -11.932142676348953],
              [-13.012482978853459, -11.93235177597839],
              [-13.014715052371303, -11.946679573970155],
              [-13.013958400373536, -11.959352945423545],
              [-13.019275944682175, -11.951556178774643],
              [-13.0193517926172, -11.943823048221939],
              [-13.020947181528825, -11.940612815701247],
              [-13.019750772877691, -11.924425247204706],
              [-13.021677965307022, -11.918338129556336],
              [-13.027132839095636, -11.911445969735116],
              [-13.037128239667668, -11.90530457907049],
              [-13.038449310667065, -11.909357429665864],
              [-13.028196130559275, -11.920367773787298],
              [-13.027309022311409, -11.926205825675522],
              [-13.029534046974378, -11.932471746944751],
              [-13.035931236573274, -11.933842722693633],
              [-13.043795218009567, -11.932998134905828],
              [-13.055059023009889, -11.92807008899314],
              [-13.061337227155212, -11.92829005866382],
              [-13.062139722900003, -11.924878190036676],
              [-13.069493856035756, -11.924269482274891],
              [-13.062607160327753, -11.931638415247733],
              [-13.054430941080707, -11.932737714212806],
              [-13.045904332484735, -11.938837382532272],
              [-13.040271110196514, -11.936699250902327],
              [-13.033928432161533, -11.93973806664121],
              [-13.037892011507125, -11.950022473084818],
              [-13.029622127700051, -11.954924404145322],
              [-13.02937024803113, -11.959359968507872],
              [-13.024267391751783, -11.96477482573332],
              [-13.023536912653551, -11.974465352856566],
              [-13.034174662531706, -11.986078694667409],
              [-13.03887603978304, -11.983323630419019],
              [-13.043995684173206, -11.985568807460698],
              [-13.050444123024613, -11.983130998392006],
              [-13.057881732261182, -11.984006288086698],
              [-13.063207966131637, -11.981154489639563],
              [-13.061778855203881, -11.96989655184069],
              [-13.063220016704681, -11.960109167147186],
              [-13.067251143419451, -11.959447057193163],
              [-13.070318140803046, -11.954797434664671],
              [-13.076841137691448, -11.953564209714902],
              [-13.078971391339461, -11.94886116165778],
              [-13.076958591093186, -11.94189714922014],
              [-13.082223157591399, -11.939625209276059],
              [-13.088575740220191, -11.939317077678272],
              [-13.087778962596712, -11.932603816731184],
              [-13.090817571564438, -11.927418183442526],
              [-13.100023709584654, -11.92900217279953],
              [-13.104315313056247, -11.934383969791755],
              [-13.109703504428657, -11.93439582286931],
              [-13.11265211420845, -11.930793559995786],
              [-13.112238763921924, -11.924556314364075],
              [-13.115834464717024, -11.916770614750126],
              [-13.121468905534567, -11.916763638743578],
              [-13.120674749832588, -11.921390788159664],
              [-13.12701067845253, -11.920774691860428],
              [-13.125506811895738, -11.926493859642402],
              [-13.120006786694569, -11.937926912562268],
              [-13.119514632256307, -11.944806782060004],
              [-13.114538930373232, -11.94175484782009],
              [-13.108435153060956, -11.950026478148786],
              [-13.11311206818725, -11.955039700781786],
              [-13.09483243012265, -11.96021546715209],
              [-13.090463033469648, -11.972387845510621],
              [-13.099767499473273, -11.977222896007914],
              [-13.08650245592441, -11.983034841645866],
              [-13.087393301404775, -11.985919233750606],
              [-13.072407293229677, -11.991572821431527],
              [-13.071036533053984, -12.001054504225214],
              [-13.068158788606885, -12.005143689275215],
              [-13.055985763672494, -12.01190374109757],
              [-13.051847980122725, -12.016280327643022],
              [-13.054479829622155, -12.020128790497681],
              [-13.047272926657875, -12.025392286524047],
              [-13.040535898511111, -12.024158181621651],
              [-13.038158849867706, -12.028071763191038],
              [-13.029516197239936, -12.033218079730162],
              [-13.02931720958964, -12.0375425742298],
              [-13.02436248647496, -12.037125502683978],
              [-13.01191882782662, -12.042720901775539],
              [-13.009594082015896, -12.047942175903419],
              [-13.000020828688722, -12.057090671600832],
              [-13.000271341666702, -12.06201690212101],
              [-12.998020069215848, -12.06910045991606],
              [-12.989525464270814, -12.068172487953344],
              [-12.991388729142633, -12.07565737205975],
              [-12.988519565819512, -12.07888375112708],
              [-12.992295324242411, -12.081941998637431],
              [-12.98139154071153, -12.084640257883738],
              [-12.983344994645119, -12.089784150114976],
              [-12.987466913920667, -12.088100972051432],
              [-12.990562473607575, -12.091830104141406],
              [-12.997554213084014, -12.08780622416641],
              [-13.000178271210128, -12.084398295576616],
              [-13.004539947924362, -12.089027620387132],
              [-13.017199121521232, -12.090244012069629],
              [-13.023272719327082, -12.08784751183352],
              [-13.021253497844947, -12.084674743809957],
              [-13.02805516778567, -12.079052830407209],
              [-13.027575790328184, -12.07311620597499],
              [-13.03676311082889, -12.066391363064723],
              [-13.044701100532295, -12.0666699928515],
              [-13.052086359366818, -12.06316604032376],
              [-13.054100672031366, -12.059864934797574],
              [-13.060574638592163, -12.057253138699375],
              [-13.069527103826358, -12.049322928943173],
              [-13.07509936933924, -12.039875663334046],
              [-13.083326796087235, -12.034824098056227],
              [-13.08500834416571, -12.030835043589892],
              [-13.093171064946086, -12.03259844391921],
              [-13.100806294259023, -12.028832079088081],
              [-13.106391226602947, -12.024415200941037],
              [-13.104349388140106, -12.02224449511585],
              [-13.109918756963637, -12.01453667696324],
              [-13.10803101076765, -12.010698350292861],
              [-13.112700210796508, -12.005998475698904],
              [-13.11396095519452, -12.001592166441558],
              [-13.120442925791483, -12.001391901231436],
              [-13.124888362029896, -11.997800483415618],
              [-13.126487803453303, -11.992966414985622],
              [-13.123938209041095, -11.990836350131772],
              [-13.134509089346768, -11.985661172288113],
              [-13.135878399247542, -11.980759587532203],
              [-13.127171528225215, -11.974577318560552],
              [-13.13610124664413, -11.973882540547406],
              [-13.132569259615162, -11.967335569228517],
              [-13.140138695445268, -11.961518232890269],
              [-13.137263939715039, -11.955867895994187],
              [-13.144183408191171, -11.95532169048368],
              [-13.145758623289602, -11.950252213549946],
              [-13.145390680333357, -11.94276359024794],
              [-13.147801826491252, -11.935620959045927],
              [-13.14692405357137, -11.933001522417358],
              [-13.135715383005195, -11.92637316047591],
              [-13.132362841988012, -11.919063523363752],
              [-13.141573068866004, -11.92418399742949],
              [-13.148306641985597, -11.923100388171473],
              [-13.152653305342515, -11.926670082855482],
              [-13.151690635564249, -11.932900136016688],
              [-13.152013147256437, -11.943393243414544],
              [-13.161336229656833, -11.948530703913704],
              [-13.166476223512833, -11.953515466822097],
              [-13.171521537877585, -11.948320966404026],
              [-13.177208324859711, -11.948448965630678],
              [-13.181162958601771, -11.956906601838028],
              [-13.186107464068236, -11.957479149729103],
              [-13.191359538966786, -11.953905314067805],
              [-13.195097082768712, -11.947032669244189],
              [-13.197174116809165, -11.938233496644829],
              [-13.189093751918836, -11.936630525232566],
              [-13.191464365223709, -11.93318521668518],
              [-13.196779870793302, -11.933047099355116],
              [-13.202004284087167, -11.923440968301742],
              [-13.198287411649627, -11.91931145427712],
              [-13.187838047952724, -11.917544582785393],
              [-13.189237360671024, -11.9129732021839],
              [-13.184247403197581, -11.908049595586235],
              [-13.17910921956446, -11.907211663548322],
              [-13.166808841660481, -11.921930948325107],
              [-13.156921200860207, -11.919929016198802],
              [-13.158100954634238, -11.91304371613043],
              [-13.166993897492377, -11.90869602314746],
              [-13.169472064918056, -11.905098443901114],
              [-13.168864288585628, -11.899408685030918],
              [-13.163758490508654, -11.888553573180483],
              [-13.1570637151931, -11.88657869503195],
              [-13.149219199559733, -11.890316659512123],
              [-13.149381654219793, -11.882340832894071],
              [-13.146637515481753, -11.876847670043663],
              [-13.142754351538697, -11.876730224716933],
              [-13.13387691611058, -11.870148090901473],
              [-13.132083321197491, -11.865970545692912],
              [-13.140787797047746, -11.866281057188715],
              [-13.14166377331717, -11.864290311220982],
              [-13.130834154886918, -11.854071313377386],
              [-13.13650376397388, -11.853120973938536],
              [-13.14201575926575, -11.857685010574906],
              [-13.15184315659805, -11.857059236392995],
              [-13.160515075623737, -11.853452839284717],
              [-13.158634655935378, -11.848384399592751],
              [-13.160094617186676, -11.839886024543905],
              [-13.157835459256827, -11.830726009822644],
              [-13.164180975723678, -11.824297422727366],
              [-13.166964567270215, -11.834840747993924],
              [-13.170500808734111, -11.82556524020868],
              [-13.168745566485983, -11.81300030391557],
              [-13.178066574243324, -11.814164192855825],
              [-13.176303296889621, -11.817886999566674],
              [-13.180633995326614, -11.82000859317478],
              [-13.183861577065256, -11.82437626912274],
              [-13.18927384880717, -11.824496400053775],
              [-13.193355739568636, -11.828080036026428],
              [-13.200930468392343, -11.824762537557813],
              [-13.213283817985225, -11.823060085151328],
              [-13.22366614202725, -11.816854295816132],
              [-13.231431667453187, -11.81582720611454],
              [-13.22664901949647, -11.809626758694565],
              [-13.222286084679823, -11.799215463547606],
              [-13.228263364808655, -11.79669229077383],
              [-13.231820625801717, -11.785294024697194],
              [-13.22998573543119, -11.782645102033841],
              [-13.22112819940721, -11.789988962967236],
              [-13.220595963031407, -11.779829387494727],
              [-13.225099109142015, -11.775373685646336],
              [-13.230694938008448, -11.774339119230968],
              [-13.239292854921542, -11.783782454498565],
              [-13.247735454619619, -11.78319805242314],
              [-13.254455173739409, -11.781109066225294],
              [-13.259066877967683, -11.782018786837329],
              [-13.252705203918103, -11.79009736620579],
              [-13.250454848901056, -11.790068868113247],
              [-13.24897061446687, -11.79914681801206],
              [-13.254250482831997, -11.805276587836033],
              [-13.265382595153316, -11.804596404520128],
              [-13.270351828477791, -11.80199703219112],
              [-13.279417276307159, -11.800234086231708],
              [-13.283916412807814, -11.793855929795143],
              [-13.287941069650621, -11.793039130906527],
              [-13.296189803312608, -11.785652760644703],
              [-13.288766564054994, -11.778742890436401],
              [-13.291934283534712, -11.777732764125],
              [-13.291811521120044, -11.77007667368942],
              [-13.28775030937478, -11.765072040304966],
              [-13.282582179716108, -11.77014602692642],
              [-13.279324045165149, -11.761159121717789],
              [-13.273887988133525, -11.759804582470545],
              [-13.27092055957244, -11.762003361012841],
              [-13.259321160092421, -11.763768879773657],
              [-13.259291219941124, -11.769578449745804],
              [-13.256548461899861, -11.771223607288503],
              [-13.2476803918587, -11.768786728228898],
              [-13.236724220996724, -11.7631365148098],
              [-13.236788627173755, -11.758152108710636],
              [-13.22907523798709, -11.756543615207988],
              [-13.228247384445874, -11.753539702021335],
              [-13.234083683441998, -11.74950794530808],
              [-13.23476962786541, -11.740107066430259],
              [-13.24157860915627, -11.732495410856433],
              [-13.248910541135817, -11.737009122769118],
              [-13.25294933466627, -11.73169763036365],
              [-13.26456751315699, -11.731017702427712],
              [-13.260936632708855, -11.726714424688645],
              [-13.259921569979682, -11.721743330312263],
              [-13.268317628700922, -11.72326869895491],
              [-13.277262687613014, -11.719352176729382],
              [-13.274137108636614, -11.703333754567295],
              [-13.278404236272241, -11.698923326022772],
              [-13.28238103218829, -11.69853845678455],
              [-13.286512750123181, -11.711770352277904],
              [-13.295322898232335, -11.719347875812367],
              [-13.296379186789963, -11.732513187905246],
              [-13.298659538968728, -11.737389839126799],
              [-13.302910367298786, -11.737987723925592],
              [-13.308840225170782, -11.743871063929756],
              [-13.30999988097805, -11.75029043008063],
              [-13.31662990040038, -11.741927559976567],
              [-13.319575586015509, -11.746413457865701],
              [-13.32338085888846, -11.742343357518083],
              [-13.328840020408725, -11.746906547507018],
              [-13.335554036596026, -11.73646530431121]
            ]
          ],
          [
            [
              [-13.283337658244719, -11.903668624646789],
              [-13.283564091474775, -11.900494504589853],
              [-13.277856392545173, -11.893030141531396],
              [-13.279976874425117, -11.88811783856152],
              [-13.278727345064693, -11.88217066157034],
              [-13.271227767800598, -11.874492005059041],
              [-13.271038648078624, -11.872015831774922],
              [-13.28081140149318, -11.870773555025648],
              [-13.278670316838781, -11.862865941088465],
              [-13.265643638617219, -11.857393880073586],
              [-13.255869534205273, -11.861231179574608],
              [-13.257125791270191, -11.855673932962018],
              [-13.25141228068175, -11.856560240269392],
              [-13.247943404634187, -11.859496837324777],
              [-13.246141822417455, -11.872969709610727],
              [-13.251957544512086, -11.877436404373446],
              [-13.249944340401923, -11.888240731305267],
              [-13.253205859818635, -11.896663375246188],
              [-13.258526014995468, -11.89351148499463],
              [-13.264505878773146, -11.89351754622612],
              [-13.26844181803538, -11.889889719109462],
              [-13.277846360364737, -11.896754147652379],
              [-13.280526190489471, -11.9041130547368],
              [-13.283337658244719, -11.903668624646789]
            ]
          ],
          [
            [
              [-13.387860408650875, -11.584025565017923],
              [-13.382348060009807, -11.582900180167973],
              [-13.375565084544855, -11.587534608617686],
              [-13.38012729848953, -11.591637013698344],
              [-13.387860408650875, -11.584025565017923]
            ]
          ],
          [
            [
              [-13.396457249559194, -11.560902185556598],
              [-13.392011745132695, -11.559631718579244],
              [-13.38562410688878, -11.562770098765146],
              [-13.38134280786311, -11.56712433680173],
              [-13.383578936978907, -11.570649292555805],
              [-13.389892857690713, -11.568052369175124],
              [-13.396457249559194, -11.560902185556598]
            ]
          ],
          [
            [
              [-13.484494329602217, -11.308234151287483],
              [-13.48570735692877, -11.302955501974493],
              [-13.484941702316442, -11.294017460809796],
              [-13.48011628575656, -11.29045263836402],
              [-13.472266162098736, -11.294287225833354],
              [-13.484494329602217, -11.308234151287483]
            ]
          ],
          [
            [
              [-13.353754259460962, -11.761035869762132],
              [-13.35532314548932, -11.756105465450654],
              [-13.345690325548382, -11.745170763541823],
              [-13.34029331860372, -11.746341520606947],
              [-13.33362640815808, -11.75818489402942],
              [-13.33223417480691, -11.766048440852616],
              [-13.334358920680069, -11.775761006302115],
              [-13.342222651926095, -11.775624649388726],
              [-13.347863465157456, -11.771260180894748],
              [-13.353754259460962, -11.761035869762132]
            ]
          ],
          [
            [
              [-13.619835478835766, -11.048711927037816],
              [-13.61166106124993, -11.048456038730862],
              [-13.610492010156298, -11.053628942241469],
              [-13.618002521731805, -11.052505138983452],
              [-13.619835478835766, -11.048711927037816]
            ]
          ],
          [
            [
              [-13.610436898331496, -11.122056209547088],
              [-13.605547668927542, -11.121174466131617],
              [-13.603267885190201, -11.125358556338195],
              [-13.596310532251321, -11.130911235682394],
              [-13.595910413583148, -11.133068990247814],
              [-13.580763313139016, -11.147142593415134],
              [-13.577499421027294, -11.15368792728842],
              [-13.582597073170946, -11.155140635085717],
              [-13.5842156068729, -11.151611810546692],
              [-13.599049175399037, -11.139851241726612],
              [-13.597228107656733, -11.135198878113275],
              [-13.610436898331496, -11.122056209547088]
            ]
          ],
          [
            [
              [-13.628369126173714, -11.104758611319117],
              [-13.621617084973517, -11.103093193583634],
              [-13.615572389721033, -11.106818213218911],
              [-13.611943151816467, -11.105906474034441],
              [-13.60563751766363, -11.111326079084172],
              [-13.60560873348081, -11.1150938219098],
              [-13.614670559659146, -11.119280852929117],
              [-13.625422197010646, -11.11037128677811],
              [-13.628369126173714, -11.104758611319117]
            ]
          ],
          [
            [
              [-13.434005978131003, -11.781936715185278],
              [-13.430279165842103, -11.77452022589339],
              [-13.422043577639718, -11.775640699552637],
              [-13.416273393736935, -11.771046224526062],
              [-13.412561610456782, -11.781976752637384],
              [-13.406345093925983, -11.779107012813105],
              [-13.407697747908951, -11.775879785778802],
              [-13.400762134296938, -11.77236052243272],
              [-13.399188861191737, -11.768683759433307],
              [-13.394555493243082, -11.765757374274198],
              [-13.388484921192838, -11.76569374325685],
              [-13.388488950866186, -11.77248616866717],
              [-13.394880719522876, -11.777427734572955],
              [-13.39563282800047, -11.779998165165413],
              [-13.403097257090169, -11.788846054290907],
              [-13.40360585223058, -11.793449512319045],
              [-13.409670931774805, -11.798858107003113],
              [-13.415545078440456, -11.80645602255686],
              [-13.42197901402967, -11.803974857333456],
              [-13.424118698701808, -11.799924392230286],
              [-13.420354347619126, -11.792917102327946],
              [-13.429424818503634, -11.78773714792541],
              [-13.434005978131003, -11.781936715185278]
            ]
          ],
          [
            [
              [-13.5385499338449, -11.480519124288396],
              [-13.538372819705517, -11.473742411239892],
              [-13.534254604847245, -11.46943446994493],
              [-13.530777555165988, -11.461395891874739],
              [-13.532151236829263, -11.458959681094939],
              [-13.52717131293263, -11.451966350771913],
              [-13.522086562976513, -11.450490335090562],
              [-13.506469370720415, -11.457517459745684],
              [-13.498321918561826, -11.459736054147442],
              [-13.491804729010296, -11.46309869112579],
              [-13.492421671219452, -11.452676283572107],
              [-13.507805161533811, -11.448254561336114],
              [-13.50591372650224, -11.445211688215426],
              [-13.512531040091954, -11.441790705767634],
              [-13.516592537980097, -11.443804102830313],
              [-13.519637308171783, -11.438609414864795],
              [-13.509368046146324, -11.438273485081755],
              [-13.504478087463513, -11.440719388730733],
              [-13.500317245556394, -11.437364589381767],
              [-13.49821600752031, -11.427167308495811],
              [-13.492696600989705, -11.429649445795896],
              [-13.48228954287043, -11.430182063248138],
              [-13.478324034443832, -11.432526202763837],
              [-13.47716747942675, -11.437685634228233],
              [-13.47421230125537, -11.439076993343509],
              [-13.46527314916043, -11.450662862733125],
              [-13.460229041726802, -11.461480689719961],
              [-13.453836260939868, -11.460188023519724],
              [-13.45229076904962, -11.465805087197644],
              [-13.445456724747007, -11.468732797763211],
              [-13.438014145153472, -11.481791783593886],
              [-13.440342830312694, -11.487664674827634],
              [-13.434133133518252, -11.490837072093022],
              [-13.429329908785201, -11.495426128053637],
              [-13.427099588072831, -11.488496532731935],
              [-13.429292640590216, -11.482220407238067],
              [-13.431734083976162, -11.468143407191846],
              [-13.438551496878693, -11.462450442418342],
              [-13.43559926853917, -11.459015946004946],
              [-13.431162917064357, -11.460232914805884],
              [-13.423917852616862, -11.458757855775648],
              [-13.422836878320542, -11.462880212626226],
              [-13.411949143043104, -11.460887251167367],
              [-13.408367727592395, -11.454097478057054],
              [-13.408548800177106, -11.450063582431348],
              [-13.415870773276877, -11.448216407629959],
              [-13.420829681380434, -11.450924422336826],
              [-13.432101871828184, -11.446419512444635],
              [-13.43028804545349, -11.44197550322572],
              [-13.440746485168079, -11.443032336043444],
              [-13.447780924905421, -11.435876949999258],
              [-13.445978013809055, -11.429760383099255],
              [-13.44741116936527, -11.424076347814074],
              [-13.459366361895581, -11.419466337581062],
              [-13.453792798292932, -11.417901750011215],
              [-13.455947933162271, -11.413518615781602],
              [-13.466890348079184, -11.409069656380089],
              [-13.476330526584926, -11.402877567497624],
              [-13.48796075267662, -11.398676601211928],
              [-13.485956018648917, -11.391484614797003],
              [-13.490376749613079, -11.387522391013782],
              [-13.488219766330698, -11.38104988554518],
              [-13.477219277305757, -11.373137201056924],
              [-13.467388840284992, -11.364546963174147],
              [-13.452777921344886, -11.365320093429073],
              [-13.437924581857171, -11.362837013963006],
              [-13.430935789941621, -11.366034647964149],
              [-13.419129176063526, -11.365612778884989],
              [-13.411604217156759, -11.362594425271988],
              [-13.405537706828419, -11.36572006870721],
              [-13.40099884140465, -11.36451737270216],
              [-13.397492327539657, -11.366519315376722],
              [-13.389160747694113, -11.364280309262007],
              [-13.376745806806838, -11.36819815623717],
              [-13.369192858263379, -11.367927576776673],
              [-13.354884523985024, -11.360002272311268],
              [-13.345561460725698, -11.3599075695407],
              [-13.333496019509603, -11.354725520643939],
              [-13.319476458331081, -11.353867810528781],
              [-13.316637684488613, -11.352681433279761],
              [-13.310184414052111, -11.354788729816967],
              [-13.298199133576576, -11.364919978833543],
              [-13.289985525581674, -11.366696136656978],
              [-13.284662139896007, -11.37193290554857],
              [-13.278880516184524, -11.382238851091076],
              [-13.275088425468514, -11.385014136246676],
              [-13.269209361603728, -11.395301703148197],
              [-13.268337179452178, -11.400620040404494],
              [-13.260320117867858, -11.406136051418873],
              [-13.251547545484588, -11.406038704081181],
              [-13.242770683093111, -11.404380043665206],
              [-13.232090366441758, -11.41233011104439],
              [-13.228016978919594, -11.413320370068606],
              [-13.220244112667656, -11.421700290858412],
              [-13.218300248765578, -11.42574457139823],
              [-13.211005358518593, -11.427577318657484],
              [-13.206735556360234, -11.431245008806384],
              [-13.192131831352475, -11.433196146802159],
              [-13.190995895285107, -11.440918553143348],
              [-13.186630796948139, -11.443279850995255],
              [-13.182475177842074, -11.448836777782004],
              [-13.17085203449418, -11.449293840513205],
              [-13.168347629440522, -11.456059945936543],
              [-13.179274362766463, -11.47140528277217],
              [-13.184673629969197, -11.472551517804185],
              [-13.187478940924327, -11.4789234417285],
              [-13.19156306090367, -11.483670846200878],
              [-13.195072202247134, -11.49240742622799],
              [-13.1983595750926, -11.493150193348194],
              [-13.208669962129619, -11.501473676660598],
              [-13.22052451534654, -11.50022229689348],
              [-13.224740789825207, -11.504476212392785],
              [-13.234816356372308, -11.504493098398273],
              [-13.239811937470042, -11.49619093312006],
              [-13.243778880050016, -11.499170370947798],
              [-13.240873322599397, -11.504115474367781],
              [-13.24259827675034, -11.506671736238552],
              [-13.253019665533621, -11.506328759907431],
              [-13.25594164637492, -11.502829440816036],
              [-13.261812314171767, -11.50589327225705],
              [-13.27243420592716, -11.509139750866012],
              [-13.269648191697426, -11.51578372761033],
              [-13.263431026781731, -11.525350159049635],
              [-13.266768354231791, -11.532814355395132],
              [-13.274658435185959, -11.539660537577555],
              [-13.286970703457488, -11.533036680925196],
              [-13.291240777177446, -11.53682743165168],
              [-13.295718924002747, -11.534640787267277],
              [-13.29938001668128, -11.54050960273007],
              [-13.305688182851634, -11.540080794504002],
              [-13.307339099498352, -11.535061933261083],
              [-13.31599993269041, -11.533080395496604],
              [-13.320395699583173, -11.536519157480047],
              [-13.322053161495816, -11.540573174722063],
              [-13.31664294081296, -11.543410398491051],
              [-13.323283574897006, -11.553360961531357],
              [-13.328266810147763, -11.55577136770903],
              [-13.332304974090393, -11.562056654624952],
              [-13.3416216562984, -11.56390691716044],
              [-13.345424849177968, -11.565973054670973],
              [-13.356577104596735, -11.568827490545457],
              [-13.361475128817546, -11.560847038806275],
              [-13.366352023333281, -11.54736995021511],
              [-13.370549085730612, -11.53823010123266],
              [-13.37047946497905, -11.531598867408752],
              [-13.376608604043716, -11.530004084960362],
              [-13.378019364027953, -11.52473218294995],
              [-13.372976724442502, -11.518360500396998],
              [-13.37928886432334, -11.513950720788998],
              [-13.38130482664679, -11.521975689211791],
              [-13.38443633540544, -11.525206382245889],
              [-13.384660442956667, -11.533906927014538],
              [-13.39328700971846, -11.535574781193185],
              [-13.397395113126377, -11.530237857526425],
              [-13.406645585253278, -11.527236941290267],
              [-13.408403246618573, -11.523536935195358],
              [-13.414595276334637, -11.526189199585724],
              [-13.415067522699212, -11.530713951558951],
              [-13.408031742734016, -11.532044145589088],
              [-13.404549879748698, -11.536490505430935],
              [-13.406713408202078, -11.540972967070088],
              [-13.405428107057606, -11.554164135870442],
              [-13.407121002064812, -11.558788273520868],
              [-13.414358203221736, -11.558972185554374],
              [-13.411659215445985, -11.565038077947701],
              [-13.398548324632808, -11.567589693700045],
              [-13.393864365130533, -11.576834406261554],
              [-13.388821117404971, -11.581623983968658],
              [-13.394208025575903, -11.583891202465164],
              [-13.399338694153625, -11.5800246800269],
              [-13.403051031217274, -11.582862446002197],
              [-13.392512471612822, -11.596289183819126],
              [-13.399101278256472, -11.601002879330748],
              [-13.39552251155482, -11.606489956346573],
              [-13.383175735853053, -11.608773349336209],
              [-13.376976559009245, -11.616542509062846],
              [-13.380511053351634, -11.624361746333168],
              [-13.376900960172717, -11.629613665333387],
              [-13.380403139763645, -11.634531385409444],
              [-13.385998856052135, -11.627892281565066],
              [-13.389394907699002, -11.627839865118997],
              [-13.401931550255219, -11.615883283496931],
              [-13.407285766468384, -11.618604547418158],
              [-13.402965469349342, -11.627049588465756],
              [-13.394654928706371, -11.629209495208258],
              [-13.39050596904481, -11.636481570787323],
              [-13.387514664299125, -11.637228645200791],
              [-13.375729923442389, -11.652051792143128],
              [-13.377099401007605, -11.659743874551639],
              [-13.38203501196441, -11.657924951525727],
              [-13.387771728168984, -11.662099439448848],
              [-13.379464227286485, -11.674212143880355],
              [-13.37718085597942, -11.684129132593332],
              [-13.380691983221883, -11.686200055078096],
              [-13.37655562591107, -11.6972278736536],
              [-13.376722547824425, -11.699756652776864],
              [-13.382542469930039, -11.704817106701705],
              [-13.386524985133978, -11.704503270557858],
              [-13.395143874235615, -11.69597505585522],
              [-13.394985891734908, -11.6848380303877],
              [-13.396234751431987, -11.679366267883196],
              [-13.400987375339145, -11.670778118530885],
              [-13.408128172004512, -11.664108074051553],
              [-13.410696921599273, -11.657052955613949],
              [-13.408679607364064, -11.651362474895443],
              [-13.414503491001932, -11.638141634978943],
              [-13.420879796238223, -11.632160693614798],
              [-13.41734840306378, -11.644409275977853],
              [-13.417483939081087, -11.648718504969194],
              [-13.413395945148743, -11.656921617030802],
              [-13.416665073094876, -11.661566530849228],
              [-13.411129098120087, -11.678652282371514],
              [-13.413029152021595, -11.684598206083658],
              [-13.423130107158139, -11.688645626110862],
              [-13.425195920309347, -11.692547575114315],
              [-13.407783397824959, -11.693093840441996],
              [-13.406093888115683, -11.704290283781406],
              [-13.400731083049868, -11.705762963735976],
              [-13.403057765205327, -11.711611061451553],
              [-13.407155593641342, -11.713849592138164],
              [-13.406866889184238, -11.71800233022975],
              [-13.400379154602597, -11.721951712379468],
              [-13.3989762038462, -11.732256967991955],
              [-13.401090675998274, -11.736807243052686],
              [-13.410190998050151, -11.73444813182361],
              [-13.414665361159768, -11.724070317888472],
              [-13.425781891292079, -11.722507058404549],
              [-13.426609427428906, -11.715376596143292],
              [-13.42464371829304, -11.709741101780272],
              [-13.435203214967936, -11.70758449297427],
              [-13.436825496204495, -11.703791594794946],
              [-13.431517018503731, -11.698632446972988],
              [-13.42965290556063, -11.692843328006488],
              [-13.432460115519103, -11.690835971140139],
              [-13.440549775866705, -11.693122360284827],
              [-13.440374345372046, -11.688889608242604],
              [-13.445353487398835, -11.673437560309708],
              [-13.452209579105268, -11.66463390384284],
              [-13.453156737583202, -11.660368086728985],
              [-13.445852356821675, -11.654574612588338],
              [-13.44417769098961, -11.650991088840247],
              [-13.44520755382318, -11.642632454462387],
              [-13.440146580193705, -11.636799569474183],
              [-13.44419485016945, -11.635415486007178],
              [-13.450770918644476, -11.643642212956113],
              [-13.448842720945525, -11.646566858674063],
              [-13.450883961485804, -11.651442679678597],
              [-13.45574964745519, -11.65299654645637],
              [-13.461347164633338, -11.646955923167646],
              [-13.457960260617394, -11.643763942940746],
              [-13.459556603683449, -11.639888516979346],
              [-13.46446699348179, -11.63634521144217],
              [-13.465559977892056, -11.632227148786797],
              [-13.46126864239016, -11.625173126919206],
              [-13.460421096678479, -11.610978902808757],
              [-13.463999329978058, -11.609833748308086],
              [-13.463397510807683, -11.604081583637377],
              [-13.467209557365056, -11.601261394070168],
              [-13.467421389745772, -11.596134483185946],
              [-13.46353593084484, -11.587702290658923],
              [-13.455460218600399, -11.595085188793576],
              [-13.441834293491805, -11.614124170930044],
              [-13.441720664474971, -11.6063846713551],
              [-13.448965459328045, -11.597564885403221],
              [-13.445052835709856, -11.58878216739675],
              [-13.453703526202194, -11.578986090147177],
              [-13.462651738363567, -11.573246296816363],
              [-13.467985794116645, -11.56571365849044],
              [-13.476850180302026, -11.563247991362388],
              [-13.485947678384328, -11.56461241374832],
              [-13.491886601912322, -11.56413215741702],
              [-13.488581425537639, -11.559239287136876],
              [-13.493177190793917, -11.553703610346552],
              [-13.490639158022063, -11.543920718470636],
              [-13.496927369195458, -11.535707680265933],
              [-13.502844887641798, -11.537853773567363],
              [-13.507579914260603, -11.53030644932146],
              [-13.512335278862036, -11.531116371782677],
              [-13.514157319883875, -11.526173890135443],
              [-13.523506765551069, -11.515700103264841],
              [-13.525292463704165, -11.510097810019415],
              [-13.52505500667296, -11.504269987369964],
              [-13.533041802141879, -11.492009219767528],
              [-13.5385499338449, -11.480519124288396]
            ]
          ],
          [
            [
              [-13.793627935574246, -10.96605917856216],
              [-13.792853551899864, -10.962565425997662],
              [-13.774551665150724, -10.980311822559518],
              [-13.765291526140116, -10.992296751925796],
              [-13.769277537140223, -10.99530902455213],
              [-13.78467812757496, -10.978166182624909],
              [-13.793627935574246, -10.96605917856216]
            ]
          ],
          [
            [
              [-13.790961338477883, -11.003422777527733],
              [-13.79271879534509, -10.989874872032741],
              [-13.790082369291856, -10.9908117048791],
              [-13.782659708521187, -10.998465036536217],
              [-13.771426344018378, -11.015869037081773],
              [-13.768661596007126, -11.014796087638617],
              [-13.7677703355061, -11.007673491650245],
              [-13.76461984779264, -11.006531950272999],
              [-13.757081072309848, -11.011332392062995],
              [-13.754514839105193, -11.019203246789752],
              [-13.74266447313927, -11.02557916315757],
              [-13.73882935487214, -11.032955076390124],
              [-13.734556868215083, -11.036967713463964],
              [-13.730975150028398, -11.037357437064605],
              [-13.727352855423224, -11.049399818711532],
              [-13.721947409776478, -11.058901931216429],
              [-13.711740245956047, -11.055088479941213],
              [-13.700839296659442, -11.04609799595659],
              [-13.69603330397498, -11.043458134613692],
              [-13.688711037363534, -11.044986757904422],
              [-13.679111455417537, -11.041592299953441],
              [-13.674321185847127, -11.041564567414518],
              [-13.664157937098299, -11.045441030001703],
              [-13.654045192710969, -11.044855299329049],
              [-13.652791823500909, -11.041677555717877],
              [-13.646784877194404, -11.040688415865588],
              [-13.645849351690085, -11.037379071412529],
              [-13.639786895217947, -11.035690831106017],
              [-13.636087720324777, -11.031277138700515],
              [-13.630207410223766, -11.03207891184476],
              [-13.629363589292323, -11.037838203865554],
              [-13.625301185224043, -11.042175335482566],
              [-13.630052941207119, -11.04836118110065],
              [-13.624328881408175, -11.054194433014676],
              [-13.624839034180933, -11.057836090054167],
              [-13.61985397735849, -11.062175607248012],
              [-13.602736008923229, -11.073821951772864],
              [-13.598277637054247, -11.08082440433543],
              [-13.599275001570732, -11.084670273876434],
              [-13.582487534173417, -11.097303525725021],
              [-13.572002722613345, -11.103624530841778],
              [-13.572676533151343, -11.110389428522005],
              [-13.54480021094144, -11.133261973453378],
              [-13.541269139989145, -11.146396651791598],
              [-13.535997412652206, -11.1548007021154],
              [-13.532601504680695, -11.156139860874928],
              [-13.534089908287863, -11.162686094459373],
              [-13.530616030843227, -11.173304529673041],
              [-13.520329315234152, -11.18165959375171],
              [-13.51013213883644, -11.186924401300919],
              [-13.503792994888608, -11.200916037228392],
              [-13.503935111312575, -11.20615551383805],
              [-13.509414319110652, -11.205495518456724],
              [-13.514954899525863, -11.19864915350473],
              [-13.517150963270403, -11.1922044100414],
              [-13.525914455660379, -11.186171665448567],
              [-13.53163570759421, -11.1809064466443],
              [-13.53654136664381, -11.179656246528756],
              [-13.545631745825835, -11.173406405112694],
              [-13.555625534768224, -11.160753910500919],
              [-13.556655658843255, -11.156768200819789],
              [-13.562267038634792, -11.152945257709248],
              [-13.563604874293857, -11.144761855351256],
              [-13.571115765582238, -11.136956281988684],
              [-13.585349924026616, -11.129782113628991],
              [-13.59249785657042, -11.12041822677143],
              [-13.59634571817709, -11.121536724075016],
              [-13.60526873595819, -11.1072117477124],
              [-13.603161519984363, -11.103209638296716],
              [-13.606578754803913, -11.097604932196024],
              [-13.614684388809035, -11.092010190896834],
              [-13.61527400988696, -11.089100110896922],
              [-13.623875103732564, -11.08247869868475],
              [-13.631290838311777, -11.082713831383394],
              [-13.636024404281388, -11.080643716804886],
              [-13.642071200447782, -11.081278646404394],
              [-13.62412497943953, -11.092856503360963],
              [-13.628354208900998, -11.096397816565482],
              [-13.633409925879597, -11.095963764639594],
              [-13.640600523210018, -11.092945852360247],
              [-13.64155134461652, -11.097722494441344],
              [-13.63706979364012, -11.10001139300496],
              [-13.632419328383529, -11.107563533726875],
              [-13.623694755532307, -11.11753571948393],
              [-13.62126587490079, -11.126359390673091],
              [-13.620914264175044, -11.141551173883666],
              [-13.614024764015808, -11.130055631299886],
              [-13.61004836227367, -11.132001441565764],
              [-13.604041149219608, -11.139988860057313],
              [-13.58823503434775, -11.155018900973154],
              [-13.58599856587122, -11.159046820504038],
              [-13.571949859246436, -11.173079456835909],
              [-13.562088730150966, -11.17846253113354],
              [-13.55711892604122, -11.184646748168472],
              [-13.563455698086399, -11.187670129273227],
              [-13.564352584675825, -11.192340096655855],
              [-13.548986097634183, -11.188771494081413],
              [-13.540695983277471, -11.192343052498813],
              [-13.532650845948242, -11.197319740157006],
              [-13.530288078646425, -11.20036183469498],
              [-13.528107256705283, -11.214119342492246],
              [-13.52146890253254, -11.223861106468904],
              [-13.511028650870964, -11.231296230240376],
              [-13.500233630539523, -11.244341499330359],
              [-13.504481868871526, -11.24421584986239],
              [-13.511605898390586, -11.239164310063742],
              [-13.514529127812041, -11.247015925024703],
              [-13.508876527284423, -11.25229351739538],
              [-13.506684759620535, -11.251391672301619],
              [-13.500674597998582, -11.258360793840893],
              [-13.500403573206261, -11.264647094655142],
              [-13.491953449444905, -11.275866443495756],
              [-13.49341777937218, -11.281862198000082],
              [-13.50159084772481, -11.290374117910936],
              [-13.503564401491708, -11.3011515879018],
              [-13.506488222923196, -11.30273714926878],
              [-13.51450744942695, -11.298012456915265],
              [-13.523423195481273, -11.297995993522749],
              [-13.531648611467132, -11.290791216498317],
              [-13.528889798454985, -11.299839338022732],
              [-13.531435078126854, -11.304260756840781],
              [-13.537415910568628, -11.294939004850534],
              [-13.541853038372857, -11.290510967329299],
              [-13.545641302141616, -11.290225183555863],
              [-13.549554566134615, -11.285363697517608],
              [-13.553631677493447, -11.289222316883281],
              [-13.545181179354351, -11.293777785413356],
              [-13.542510229109647, -11.299896094434592],
              [-13.534865917644508, -11.305576424364652],
              [-13.534716863343174, -11.310522833752373],
              [-13.524719125501157, -11.316791325823951],
              [-13.523445244606531, -11.323068439351559],
              [-13.526769943901861, -11.32847238212078],
              [-13.531426426208466, -11.331593036851913],
              [-13.52850574992164, -11.344928740433577],
              [-13.535312522917614, -11.358475495770582],
              [-13.544318498917331, -11.358263569503679],
              [-13.54599447988877, -11.369474377686402],
              [-13.543932277336628, -11.372612311548654],
              [-13.547659987047153, -11.375909689381295],
              [-13.554122218079867, -11.376174691066154],
              [-13.551083252903942, -11.381248731313033],
              [-13.56310101471052, -11.383492854481213],
              [-13.564409299373077, -11.389448483348039],
              [-13.555897594827748, -11.394103050176806],
              [-13.562592758851304, -11.405198308064083],
              [-13.571484066778789, -11.41457438309641],
              [-13.567438186182189, -11.421411256292057],
              [-13.574617485020628, -11.423075241290642],
              [-13.580143883239815, -11.426429413263442],
              [-13.585364986531218, -11.422490777233623],
              [-13.594114523314234, -11.42702136321333],
              [-13.593681028407342, -11.422436647886295],
              [-13.605308750630217, -11.403549325299185],
              [-13.608322656501146, -11.394011987616004],
              [-13.604230418441237, -11.385120865895042],
              [-13.614594039556193, -11.377205951611016],
              [-13.618989616888133, -11.36897423614006],
              [-13.620412933457834, -11.36324703037059],
              [-13.61579010104478, -11.360731971590242],
              [-13.604621087984816, -11.362429629267279],
              [-13.601763376510453, -11.355853838983617],
              [-13.60847564982685, -11.355988793145716],
              [-13.616645109896494, -11.351515982709953],
              [-13.618457478326098, -11.347895088642456],
              [-13.614044991638979, -11.344563741699917],
              [-13.611653551753472, -11.333290915133048],
              [-13.603375293065453, -11.327335768036265],
              [-13.604933553232428, -11.323646282700127],
              [-13.61032561921043, -11.32178508374709],
              [-13.61559808606447, -11.323804965187522],
              [-13.618575457120363, -11.3223335495299],
              [-13.620097257555177, -11.31053009761366],
              [-13.624403892712781, -11.30365430824453],
              [-13.615648602435256, -11.2991790981419],
              [-13.614602216258133, -11.304853523573613],
              [-13.60511146596587, -11.307751668410763],
              [-13.594607882722178, -11.305736453563478],
              [-13.595009868009251, -11.300511145333749],
              [-13.602661680285093, -11.302970630737642],
              [-13.603376448028742, -11.300051413172266],
              [-13.623437463219128, -11.284329262247729],
              [-13.625157892839876, -11.279645546366707],
              [-13.632116962461627, -11.280048213549462],
              [-13.632190771690981, -11.27616615772348],
              [-13.636588041363744, -11.270486302707726],
              [-13.646803281676645, -11.251579546582466],
              [-13.656769842986657, -11.243294112081257],
              [-13.663568533989569, -11.23911483361876],
              [-13.663357991496342, -11.236765828910762],
              [-13.67544210601394, -11.217508305326858],
              [-13.676512062344496, -11.212024572551766],
              [-13.682752879428868, -11.207785569340556],
              [-13.686625752583602, -11.199161494011468],
              [-13.686559963296824, -11.183606140186383],
              [-13.689145735229483, -11.181177166871988],
              [-13.690478302863403, -11.168325957999123],
              [-13.694753816656608, -11.164577468146263],
              [-13.694429649709292, -11.161254861470807],
              [-13.700272032629218, -11.151290386062348],
              [-13.704150817931318, -11.147613664167253],
              [-13.70872809639437, -11.134978881945278],
              [-13.716467082113557, -11.125427624145045],
              [-13.714933956041552, -11.121664739267098],
              [-13.71809387962462, -11.11624159084904],
              [-13.723272323246622, -11.112110161904985],
              [-13.730428147991, -11.102923733148199],
              [-13.731009642304421, -11.09392736241332],
              [-13.728475146384392, -11.0933054980097],
              [-13.727640303519113, -11.083449061672415],
              [-13.734934969533311, -11.082916246664828],
              [-13.741888380895615, -11.071725923261324],
              [-13.74955526315669, -11.065845693143276],
              [-13.751758461102632, -11.062027150835693],
              [-13.760981301057575, -11.05835898729325],
              [-13.767499953514244, -11.049271882189032],
              [-13.763260809214884, -11.038869021197106],
              [-13.766231417666633, -11.037619588588894],
              [-13.770051896465882, -11.042458854809984],
              [-13.776608091385159, -11.03487889375373],
              [-13.782850365913328, -11.022726189541345],
              [-13.78399140554051, -11.014849125161764],
              [-13.790961338477883, -11.003422777527733]
            ]
          ],
          [
            [
              [-13.816186793770203, -10.95842515313727],
              [-13.808793662987604, -10.961408269156157],
              [-13.803821421414806, -10.960506032568075],
              [-13.802457489832836, -10.965200259683112],
              [-13.806710712846968, -10.968796196622364],
              [-13.814238206705207, -10.961908112532369],
              [-13.816186793770203, -10.95842515313727]
            ]
          ],
          [
            [
              [-13.921171636573899, -10.809241312258987],
              [-13.91622244303182, -10.810211187780963],
              [-13.906387055879474, -10.823690799495164],
              [-13.904516686980358, -10.834122255296219],
              [-13.90956163966977, -10.833924683837711],
              [-13.916397135627367, -10.821867697440203],
              [-13.921171636573899, -10.809241312258987]
            ]
          ],
          [
            [
              [-13.756714584272446, -11.446738382010752],
              [-13.753386824315367, -11.443375709065316],
              [-13.750246642642857, -11.44683414762182],
              [-13.752665019158512, -11.452059728236248],
              [-13.756714584272446, -11.446738382010752]
            ]
          ],
          [
            [
              [-13.776491736461352, -11.40845314467616],
              [-13.770937579775197, -11.399622695116825],
              [-13.76580059404184, -11.40078242262468],
              [-13.760549063448046, -11.397423943217667],
              [-13.755937433638149, -11.397433041066831],
              [-13.754715824436586, -11.40616325728149],
              [-13.75670517308262, -11.415486856966176],
              [-13.761138170272545, -11.42040806208659],
              [-13.774456453294441, -11.412255637918065],
              [-13.776491736461352, -11.40845314467616]
            ]
          ],
          [
            [
              [-13.749676443875805, -11.53558414907798],
              [-13.749753274145052, -11.531244286372859],
              [-13.741672121744319, -11.533306936987607],
              [-13.741764451443355, -11.53780549411406],
              [-13.749676443875805, -11.53558414907798]
            ]
          ],
          [
            [
              [-13.821880764993814, -11.37404639479159],
              [-13.821353271162065, -11.370234235284512],
              [-13.811034816880454, -11.367000314187532],
              [-13.79643207028358, -11.366823252722321],
              [-13.790997490457336, -11.365348874288614],
              [-13.79214622601537, -11.361405926581035],
              [-13.801083671327454, -11.361384433831114],
              [-13.80420657988512, -11.359598281316723],
              [-13.81215817587959, -11.361998171013354],
              [-13.814295191400586, -11.358791134974837],
              [-13.807729226407114, -11.351466485844028],
              [-13.805443389591352, -11.343503865042965],
              [-13.806287236435935, -11.33884301219594],
              [-13.801626619980425, -11.336990834893633],
              [-13.804988082980511, -11.325125186312153],
              [-13.809490953710604, -11.319529290513179],
              [-13.80238423132305, -11.312422420738192],
              [-13.800048461261008, -11.304550309380401],
              [-13.796110277952337, -11.297000322022287],
              [-13.784119363200787, -11.293306694375598],
              [-13.771980530780281, -11.296771048743567],
              [-13.767724800817435, -11.30255880617359],
              [-13.763459339522809, -11.304595582476948],
              [-13.765274828955183, -11.310554110802496],
              [-13.774182016757225, -11.31861142507467],
              [-13.781201644512466, -11.327914257092813],
              [-13.776096686054263, -11.328534935500263],
              [-13.771548318847096, -11.32441208390845],
              [-13.770475880793052, -11.319531507832231],
              [-13.761547652686787, -11.313432353695228],
              [-13.752860663285583, -11.311559371137974],
              [-13.749197392259486, -11.308090332791856],
              [-13.74197593701889, -11.30941908263276],
              [-13.735318941175628, -11.316496744810204],
              [-13.739949529727973, -11.319377385985602],
              [-13.723590008290325, -11.320429329463545],
              [-13.71380502431196, -11.3220243430904],
              [-13.711355954332268, -11.325542658167194],
              [-13.701921329272311, -11.321586447725277],
              [-13.699560516793454, -11.31702870693638],
              [-13.68737989493422, -11.312419973714075],
              [-13.674479647455476, -11.314695474538082],
              [-13.670167345727165, -11.316381229624419],
              [-13.670727857432801, -11.320600452174231],
              [-13.665553930509752, -11.326059553110186],
              [-13.662383103932523, -11.332372670734504],
              [-13.658872813989131, -11.335169890846778],
              [-13.658623458512018, -11.342464630680526],
              [-13.656447509407576, -11.349111727084994],
              [-13.659412728122247, -11.351763974801111],
              [-13.662674849224773, -11.346057815385052],
              [-13.667092675169659, -11.345760466853632],
              [-13.676872385692352, -11.339897489640382],
              [-13.682091294269405, -11.343342066620016],
              [-13.684138071893107, -11.347247510884227],
              [-13.683589753647093, -11.354039838105086],
              [-13.679160839229365, -11.356488963102503],
              [-13.677458309769785, -11.36571781277751],
              [-13.67113179966893, -11.368081196928115],
              [-13.66976916437213, -11.363444627437866],
              [-13.673527639333608, -11.357805756023437],
              [-13.667528683661859, -11.355835337093886],
              [-13.656442206807244, -11.36773663778963],
              [-13.654874486081903, -11.374618200585761],
              [-13.656270588408047, -11.379917674160314],
              [-13.645009000002851, -11.387218964171815],
              [-13.640468527278731, -11.39352338232106],
              [-13.642829741918996, -11.395645305001361],
              [-13.641179857326941, -11.400622689053439],
              [-13.636898023205852, -11.403122464381944],
              [-13.618496808170137, -11.433942855671118],
              [-13.619463818070049, -11.437891843002655],
              [-13.613594180137836, -11.442304381648638],
              [-13.608718083319726, -11.459558890333264],
              [-13.60563423379088, -11.460377283423517],
              [-13.600995338074446, -11.46846351744218],
              [-13.59507085558969, -11.475014727440021],
              [-13.5943559248691, -11.482165087285104],
              [-13.591154104476505, -11.489242783226185],
              [-13.589790381125628, -11.49588450263305],
              [-13.582751117014116, -11.49983840337197],
              [-13.57243263413324, -11.521003032025328],
              [-13.565447418137126, -11.52891079883661],
              [-13.561997094442765, -11.539550387782498],
              [-13.557389193375661, -11.547281133543851],
              [-13.556917731776776, -11.552859510859651],
              [-13.553801154100611, -11.557427530187102],
              [-13.55126747253533, -11.569112782980396],
              [-13.551221506893476, -11.573933867153384],
              [-13.547509508919067, -11.587448376896585],
              [-13.550279705259205, -11.58901439245168],
              [-13.556839790395335, -11.57647697170303],
              [-13.557137225441316, -11.583935119743893],
              [-13.554084826103814, -11.59172961204711],
              [-13.548047340114534, -11.602555441927162],
              [-13.547503994417536, -11.606676224659791],
              [-13.542114156559007, -11.61083357980105],
              [-13.538197488478602, -11.627531215031256],
              [-13.533599035846986, -11.635182628136837],
              [-13.534048836635247, -11.63904036674594],
              [-13.530387770256251, -11.643624796014231],
              [-13.53037670302897, -11.654949495681308],
              [-13.53712139761109, -11.664955673756223],
              [-13.526861231477636, -11.659677814497252],
              [-13.523980201759274, -11.667666865584426],
              [-13.52662787950501, -11.675677069880328],
              [-13.52910062822765, -11.677820932652107],
              [-13.526403067314568, -11.683177737897404],
              [-13.51833959835789, -11.68009986816354],
              [-13.51994262184703, -11.692165515772547],
              [-13.51915888634757, -11.700080208967883],
              [-13.516744903494994, -11.70245055780109],
              [-13.515861284095884, -11.714324072869124],
              [-13.520901603372867, -11.713076014322912],
              [-13.525198156873651, -11.709595852651455],
              [-13.523183467323356, -11.704978773897603],
              [-13.528556719510837, -11.699070255774467],
              [-13.533474538632742, -11.703018166001899],
              [-13.54090082566242, -11.70348242129682],
              [-13.549842334647613, -11.69799725980776],
              [-13.555655028498926, -11.690421820202863],
              [-13.55571746794363, -11.686092071732224],
              [-13.560050222652475, -11.685604160139956],
              [-13.561144821686414, -11.68119856659797],
              [-13.573295056391057, -11.678209604599378],
              [-13.577460562269328, -11.668235742646928],
              [-13.58833218919644, -11.660822935032728],
              [-13.59042521901513, -11.650218611062131],
              [-13.599241580721433, -11.64575189697972],
              [-13.605548639730698, -11.635437365122701],
              [-13.613956466997047, -11.628930706323189],
              [-13.619185792016902, -11.618978068794908],
              [-13.624422493939107, -11.617432897851618],
              [-13.624442045417833, -11.610355362826464],
              [-13.628868691230878, -11.603375331373229],
              [-13.626375555644668, -11.594036540423907],
              [-13.619779669279099, -11.588389289165086],
              [-13.615389161878651, -11.587778724205517],
              [-13.613434408547114, -11.582716842754875],
              [-13.621741761180164, -11.578371838962415],
              [-13.62947427929365, -11.57956952721385],
              [-13.629607981081529, -11.584522592312839],
              [-13.638106867821959, -11.595906333520455],
              [-13.646955271246581, -11.598813560976252],
              [-13.646501558548241, -11.591708932500671],
              [-13.649523053592752, -11.585882039593395],
              [-13.653856804204178, -11.582350403208812],
              [-13.654436697267526, -11.568914726506243],
              [-13.661208726248596, -11.57201721282607],
              [-13.66041659348292, -11.577398222184641],
              [-13.666235591311661, -11.580365708700722],
              [-13.672797318797718, -11.576019437826254],
              [-13.671471915910102, -11.57087906649215],
              [-13.668008218722516, -11.568631925405729],
              [-13.667353909597791, -11.56284320155871],
              [-13.672013953812067, -11.562490789457403],
              [-13.676399879717003, -11.568439273107236],
              [-13.684501271817822, -11.573366316466737],
              [-13.686533050698218, -11.568575712526098],
              [-13.691864129664442, -11.564814613261522],
              [-13.694131865554994, -11.558090355189512],
              [-13.68721310694659, -11.551514680266425],
              [-13.68916592960396, -11.548434344437899],
              [-13.697109150340893, -11.545748131096511],
              [-13.700602981935596, -11.558801953214283],
              [-13.706682082688278, -11.549246198562056],
              [-13.711471208357638, -11.55259946072952],
              [-13.712815337635199, -11.542824150767302],
              [-13.718123384720274, -11.541811933386422],
              [-13.71857450402055, -11.537250113876807],
              [-13.713911975761503, -11.533662695001397],
              [-13.717427962213824, -11.530702044053072],
              [-13.718975427721047, -11.515387402427695],
              [-13.716037847568478, -11.51165593525694],
              [-13.721980288270872, -11.508853159487632],
              [-13.715977836662129, -11.50592826818361],
              [-13.718223601980403, -11.497978340128343],
              [-13.728011270336932, -11.495940825296358],
              [-13.725913865359402, -11.493378834848833],
              [-13.728477593786426, -11.481288633949358],
              [-13.715186569219892, -11.480148068353337],
              [-13.716642882869255, -11.476807295226356],
              [-13.726743495325435, -11.477904151250597],
              [-13.728178577159944, -11.473424234304582],
              [-13.720995055403481, -11.47449567798491],
              [-13.714808839840295, -11.468273674118096],
              [-13.708644027226342, -11.467403491544532],
              [-13.705252482890634, -11.458681505935846],
              [-13.693528483431434, -11.463306339150224],
              [-13.702155196252116, -11.455090785338822],
              [-13.706852975040972, -11.453836359698855],
              [-13.710118509075087, -11.460274012094455],
              [-13.714627312215036, -11.461485248808145],
              [-13.7180369079514, -11.457552801071794],
              [-13.725034024287467, -11.45804357327989],
              [-13.733868909363428, -11.455251549375976],
              [-13.74429164736282, -11.443914041866272],
              [-13.744199531166545, -11.43671967923851],
              [-13.740904907882612, -11.433574139094357],
              [-13.743445295706758, -11.429076514074389],
              [-13.737733015445638, -11.421741181636634],
              [-13.728106385709504, -11.4186440319154],
              [-13.733698934920655, -11.415247994426437],
              [-13.740204523268988, -11.419073024314018],
              [-13.745024945189702, -11.424816691558194],
              [-13.746370830229983, -11.4312399480974],
              [-13.750229438692415, -11.429744275733196],
              [-13.754500083975378, -11.424121504423491],
              [-13.752443383253594, -11.417088641641566],
              [-13.748902394018806, -11.411619730613108],
              [-13.751082489282265, -11.40085798565281],
              [-13.747442404679555, -11.394166515853033],
              [-13.760829142609643, -11.39582841532568],
              [-13.766321547302702, -11.399019665049472],
              [-13.771093619215844, -11.397933821770547],
              [-13.776752164151791, -11.399981239941305],
              [-13.780747249340791, -11.406619787048426],
              [-13.784645532718846, -11.408630199449219],
              [-13.79309891697001, -11.398200380772506],
              [-13.796800706350936, -11.395547138393368],
              [-13.792495825352797, -11.392000355984422],
              [-13.806860498671966, -11.386766050605859],
              [-13.807624032688382, -11.383101838235124],
              [-13.81582275567518, -11.381051786834739],
              [-13.821880764993814, -11.37404639479159]
            ]
          ],
          [
            [
              [-13.925055395280085, -11.042095870822884],
              [-13.91448893961348, -11.03391101774791],
              [-13.905938620872702, -11.0333375442754],
              [-13.888234330477959, -11.041151977736893],
              [-13.889456394538012, -11.046574768222403],
              [-13.893373646219594, -11.048689420111943],
              [-13.902355232630104, -11.049936014786947],
              [-13.90621456234789, -11.052055078920995],
              [-13.913774512173777, -11.051535350259412],
              [-13.925055395280085, -11.042095870822884]
            ]
          ],
          [
            [
              [-13.84216557446173, -11.428166666793837],
              [-13.836766545293115, -11.417036916075153],
              [-13.840670045206672, -11.411866047002189],
              [-13.842008101332183, -11.403606694506454],
              [-13.841392231940073, -11.398437888774296],
              [-13.847927520722493, -11.395603267493245],
              [-13.847743837401419, -11.389411477583646],
              [-13.835891304106212, -11.387431570968722],
              [-13.83414163406716, -11.38186113039265],
              [-13.821060491735732, -11.385440466322306],
              [-13.816971283446748, -11.388802310851894],
              [-13.813838153736596, -11.387620858764135],
              [-13.795716570584185, -11.398067668377555],
              [-13.788664277362914, -11.405406717236879],
              [-13.786556652893006, -11.412177310821091],
              [-13.79137074123496, -11.413290639292022],
              [-13.79864588369127, -11.409292788927788],
              [-13.795112593062562, -11.418749659068885],
              [-13.789338574828625, -11.423998775435932],
              [-13.786860386217999, -11.434960068929893],
              [-13.780395683948008, -11.427904252000115],
              [-13.779131524331968, -11.424050568328594],
              [-13.78120643881601, -11.41707935880278],
              [-13.779873149369683, -11.41026294596207],
              [-13.772310636434385, -11.414404861686116],
              [-13.76131148794414, -11.421958247517148],
              [-13.767029781415161, -11.432182785077892],
              [-13.767744799928044, -11.438239506430914],
              [-13.779105063731999, -11.435884252142516],
              [-13.776212296057057, -11.442452836326881],
              [-13.776505312519628, -11.451437273027283],
              [-13.773665798269349, -11.45766021711831],
              [-13.777563072723899, -11.466689179384174],
              [-13.776379705999753, -11.475460624167914],
              [-13.77905188194753, -11.48341455194697],
              [-13.782233399279487, -11.487026563063614],
              [-13.78689781566736, -11.488274727303576],
              [-13.79189959086234, -11.493729105852635],
              [-13.801098720491614, -11.496687880099696],
              [-13.808666505706686, -11.501408728446616],
              [-13.815795958722553, -11.504062323428089],
              [-13.818595175541137, -11.498870129975156],
              [-13.817218346118482, -11.496135885381701],
              [-13.822848563262713, -11.472852101781342],
              [-13.819957190819318, -11.470027794270969],
              [-13.81720269763966, -11.463137707110967],
              [-13.810795696423872, -11.459526482889402],
              [-13.812600817096197, -11.451130911376739],
              [-13.809243729834103, -11.446701707922362],
              [-13.812944331566037, -11.44196805666276],
              [-13.821361620656115, -11.440654879560634],
              [-13.824502087986776, -11.444696339864475],
              [-13.830072356728841, -11.44286932024113],
              [-13.829720260752309, -11.432193005971246],
              [-13.831747649690266, -11.427234218592329],
              [-13.829513183518154, -11.421517596535672],
              [-13.834654097785803, -11.41985491070865],
              [-13.834929627198292, -11.42622503597019],
              [-13.84216557446173, -11.428166666793837]
            ]
          ],
          [
            [
              [-14.020502901729072, -10.985862135053925],
              [-14.015434406004411, -10.981894683464013],
              [-14.00965096549676, -10.986654412095772],
              [-14.006398198742824, -10.99256057164781],
              [-14.008374651296828, -10.996433123994606],
              [-14.019954162679891, -10.987450515240797],
              [-14.020502901729072, -10.985862135053925]
            ]
          ],
          [
            [
              [-13.99178922066983, -11.091852637860514],
              [-13.986863529941758, -11.082349441891813],
              [-13.98244891377693, -11.082135399965507],
              [-13.974278915994763, -11.073442958334109],
              [-13.96966792036322, -11.088803234999821],
              [-13.973698024614198, -11.089273401348201],
              [-13.975768314241822, -11.094930479322427],
              [-13.979458701854863, -11.097093635500999],
              [-13.985450886756176, -11.096705596562884],
              [-13.99178922066983, -11.091852637860514]
            ]
          ],
          [
            [
              [-14.043121177244869, -10.968714586395567],
              [-14.037780631322352, -10.96590739935644],
              [-14.036733651587738, -10.970133273427829],
              [-14.038705000013387, -10.975084776872942],
              [-14.043121177244869, -10.968714586395567]
            ]
          ],
          [
            [
              [-13.963030228120497, -11.2858302902872],
              [-13.95968710096692, -11.284888917832028],
              [-13.957270899023493, -11.280050717297398],
              [-13.95110332836206, -11.286752652086943],
              [-13.95698029534547, -11.289486527620602],
              [-13.963030228120497, -11.2858302902872]
            ]
          ],
          [
            [
              [-14.03448840609266, -11.107009769215116],
              [-14.025710336330306, -11.106231403713483],
              [-14.01986254498612, -11.107981432698692],
              [-14.019053589278036, -11.102554377846912],
              [-14.01191594399237, -11.104165757855167],
              [-14.011353735336252, -11.109401061099097],
              [-14.013651706891272, -11.115289206005105],
              [-14.022756362804124, -11.115579107636174],
              [-14.03448840609266, -11.107009769215116]
            ]
          ],
          [
            [
              [-14.043088496882984, -11.194502003477128],
              [-14.04162151435501, -11.187991757913101],
              [-14.04462505552824, -11.182998571268906],
              [-14.042196018188298, -11.17090672369387],
              [-14.034431150266856, -11.167531403269221],
              [-14.02994533289473, -11.1671718458602],
              [-14.027404750268277, -11.16181529441926],
              [-14.028600936463892, -11.159041661679433],
              [-14.023034746623834, -11.151516091174527],
              [-14.016614576715325, -11.145462100081243],
              [-14.009792065830167, -11.148633773590268],
              [-14.003942055182115, -11.148210790774378],
              [-14.010795259701293, -11.137103164920223],
              [-14.01888509827547, -11.130406303299536],
              [-14.021437485856444, -11.125610248900212],
              [-14.0212680467645, -11.120670524593232],
              [-14.012613587894279, -11.122491575170324],
              [-14.010695095778177, -11.117507401035361],
              [-14.006273135016238, -11.119160297216824],
              [-14.005105375042941, -11.124006773739602],
              [-13.998422049211799, -11.128235103111674],
              [-13.994046052512669, -11.136910869144048],
              [-13.987428580526531, -11.13546712756679],
              [-13.9864843138574, -11.13272332922822],
              [-13.990136088572735, -11.127617563295928],
              [-13.982838002326774, -11.109721029752754],
              [-13.970008270363145, -11.109707005068717],
              [-13.965152449047848, -11.106999810939614],
              [-13.960083946326662, -11.110656390141704],
              [-13.958932360741265, -11.114888141812585],
              [-13.951884153641886, -11.112384157844193],
              [-13.952014725272209, -11.106485269540219],
              [-13.947987520956845, -11.101265340522408],
              [-13.947034929989996, -11.0964834515988],
              [-13.942893005894796, -11.09033587921083],
              [-13.938143359062309, -11.088003025328158],
              [-13.9334285966796, -11.080240852132981],
              [-13.933152962073423, -11.075423705353817],
              [-13.92522205931009, -11.07252049619358],
              [-13.919257325404494, -11.077045911965271],
              [-13.912957580633128, -11.085085185826607],
              [-13.899629461450017, -11.086739422241513],
              [-13.896037804283027, -11.083537763360033],
              [-13.889991893269434, -11.088945219362206],
              [-13.871456342854236, -11.092222593585564],
              [-13.864202794392629, -11.096048295819314],
              [-13.867160639895626, -11.104560681454336],
              [-13.863830013280209, -11.114281793662387],
              [-13.864957624476935, -11.12136767221366],
              [-13.871108650963333, -11.129927946604202],
              [-13.875430116866207, -11.142951371591833],
              [-13.883623027268339, -11.142934771242723],
              [-13.88638404156104, -11.148542207294678],
              [-13.882989967261842, -11.15145041033102],
              [-13.87300185170999, -11.151893664378088],
              [-13.872713170112076, -11.159995334275633],
              [-13.87089539547855, -11.163909235997632],
              [-13.864210624229585, -11.16103063739936],
              [-13.861316061251896, -11.15030026275357],
              [-13.862338769645387, -11.144342927332485],
              [-13.860059237168414, -11.133973561377092],
              [-13.857140830073071, -11.132322403842155],
              [-13.856394553770352, -11.123534895551657],
              [-13.849462299934036, -11.116747926411595],
              [-13.85331843581092, -11.111038024533658],
              [-13.854193266584288, -11.106561744493067],
              [-13.849327867934727, -11.10474223765174],
              [-13.848107546346665, -11.101520018170422],
              [-13.8429448519619, -11.101030522277279],
              [-13.831297329462235, -11.104898211110449],
              [-13.820812354271416, -11.112882153003069],
              [-13.818061517146111, -11.109600274803046],
              [-13.799599638611857, -11.108281876862215],
              [-13.789271850087282, -11.103544029904404],
              [-13.783096668349573, -11.105334397850783],
              [-13.782429806218595, -11.111324275380301],
              [-13.760179211836864, -11.11048962810129],
              [-13.755051739462782, -11.112090153980795],
              [-13.749108936051202, -11.118972246501297],
              [-13.747008836684582, -11.124267733368352],
              [-13.74205433593039, -11.130700151837786],
              [-13.745439172161992, -11.133242850504597],
              [-13.744158184671145, -11.139482681878425],
              [-13.740095285713375, -11.141317465214197],
              [-13.73831318339267, -11.148912325319975],
              [-13.748558241431521, -11.16404958591313],
              [-13.75656892035099, -11.164328683692105],
              [-13.765409431955309, -11.161308627074574],
              [-13.771712843222378, -11.160875552078512],
              [-13.788527091714384, -11.155930528575562],
              [-13.788247588884866, -11.159810642250887],
              [-13.779048429759305, -11.167460879973605],
              [-13.771895701705361, -11.171825610989803],
              [-13.759314197608317, -11.17256790488959],
              [-13.753335171979671, -11.17449914592962],
              [-13.748708178464891, -11.181813263119691],
              [-13.733360144190852, -11.186626449802652],
              [-13.74040482585901, -11.198617337648008],
              [-13.749552652674758, -11.205707299512223],
              [-13.755039435549767, -11.203305381382938],
              [-13.7587372836853, -11.207207299649053],
              [-13.755179306531103, -11.212496093160201],
              [-13.748339243570861, -11.214092199219818],
              [-13.743795653806139, -11.211238540901515],
              [-13.738361201422611, -11.213519392043692],
              [-13.73252221556197, -11.205758476816326],
              [-13.723071208967268, -11.204276262118242],
              [-13.71657453717539, -11.219179474375824],
              [-13.71195294650862, -11.22408560961709],
              [-13.714409710269173, -11.23458259685493],
              [-13.707251738409749, -11.236683810545228],
              [-13.695576493506616, -11.250652326210634],
              [-13.69121888763372, -11.258622554719368],
              [-13.6876415857365, -11.275366381669292],
              [-13.681365600890175, -11.283437967086607],
              [-13.678662602936019, -11.29021700822979],
              [-13.680056572492695, -11.292067543246032],
              [-13.68705996008519, -11.286056628619445],
              [-13.691201558951105, -11.290742806832379],
              [-13.684484810167755, -11.295350271341905],
              [-13.686982948589607, -11.30063986606306],
              [-13.693739387605158, -11.302850910206514],
              [-13.701373256211987, -11.303613760157488],
              [-13.710448447264886, -11.309029071086579],
              [-13.716953886503102, -11.30780668131771],
              [-13.722536218883372, -11.309043563692585],
              [-13.726550055668456, -11.306964385043969],
              [-13.732613762751033, -11.300572215743749],
              [-13.739193789725059, -11.299136441370678],
              [-13.747448473642978, -11.294471150865977],
              [-13.751520522873259, -11.294740422784695],
              [-13.759660907751917, -11.289721001913398],
              [-13.764470365383534, -11.288895017492496],
              [-13.781717810277033, -11.281364617113747],
              [-13.785212378751908, -11.282307132750523],
              [-13.795369082081258, -11.277487738150736],
              [-13.808851784957673, -11.274057345785602],
              [-13.817176977054347, -11.269265516526424],
              [-13.828514826140259, -11.265429854821972],
              [-13.838920282733596, -11.28510189408457],
              [-13.830015555246028, -11.287382060280839],
              [-13.825632743728143, -11.283380372587228],
              [-13.815106832668345, -11.284697268789206],
              [-13.812058280391007, -11.287148050690973],
              [-13.82038760641159, -11.294835632643668],
              [-13.821475738548733, -11.29976842158449],
              [-13.82574007867981, -11.299498646144782],
              [-13.82663568931909, -11.303670186453154],
              [-13.816582393146732, -11.306180502000997],
              [-13.816586011864455, -11.31565408421498],
              [-13.80680355001484, -11.32786233047738],
              [-13.805352367105288, -11.3358028680409],
              [-13.81221969905752, -11.342363922420448],
              [-13.80992344274377, -11.347398096910075],
              [-13.814272739760051, -11.351058908955116],
              [-13.815505619859923, -11.356186191702133],
              [-13.822880369055166, -11.358235841158395],
              [-13.82080413095791, -11.364459329441527],
              [-13.82469248829744, -11.372248686179853],
              [-13.832460973809475, -11.373929113203976],
              [-13.839881529264435, -11.369533294189786],
              [-13.844825858854957, -11.371812037928414],
              [-13.853307807336991, -11.370736461143613],
              [-13.859774447233537, -11.363455839911266],
              [-13.868956431438244, -11.357198152662765],
              [-13.876698236751574, -11.353606935685526],
              [-13.88097842518243, -11.35411387452857],
              [-13.88561199645501, -11.346843772812186],
              [-13.890277109051333, -11.344101460561571],
              [-13.893929821450374, -11.344845004209812],
              [-13.901156817144614, -11.341042649374808],
              [-13.901825531717884, -11.336713025921075],
              [-13.907405400782777, -11.333399303829076],
              [-13.913050148216966, -11.327713445163866],
              [-13.913449614429283, -11.324249074588781],
              [-13.907883748864133, -11.319030638706424],
              [-13.915395511184787, -11.314973896043195],
              [-13.920498032189942, -11.319538930342027],
              [-13.923230787570976, -11.326145169643528],
              [-13.927574411458787, -11.327272573617805],
              [-13.940825803261355, -11.323020662905217],
              [-13.933830120310645, -11.315820636721954],
              [-13.943813269868803, -11.313488160203226],
              [-13.944099136242675, -11.309500905316206],
              [-13.948767453919512, -11.306057194353636],
              [-13.954206288348718, -11.296380607282218],
              [-13.94961786298267, -11.28943539158585],
              [-13.944978254351234, -11.289093828918157],
              [-13.947002519959048, -11.281208079529964],
              [-13.942252720672366, -11.278319323537707],
              [-13.945633070023636, -11.27470036267292],
              [-13.951694892817928, -11.273797175342363],
              [-13.961292662773433, -11.267369298780011],
              [-13.96017122173025, -11.279448034956577],
              [-13.964492113946397, -11.281489130809415],
              [-13.96814891646134, -11.276515623568988],
              [-13.971714541047778, -11.27516148266557],
              [-13.970755522886225, -11.266490964997121],
              [-13.975045486740944, -11.266643853238227],
              [-13.978552465763098, -11.26062007436331],
              [-13.984089465297904, -11.259567767030028],
              [-13.987091721201592, -11.252126272598316],
              [-13.991253425355541, -11.251971534223452],
              [-13.991691606056811, -11.256918998834204],
              [-13.995856474303823, -11.25791425370059],
              [-14.001031804428523, -11.250691062281886],
              [-14.011021328281172, -11.24779252258522],
              [-14.014089236249532, -11.244366508487236],
              [-14.01142750422137, -11.237690252061924],
              [-14.014707122181857, -11.235067286938078],
              [-14.021406044038864, -11.2354433770667],
              [-14.028154088088002, -11.23380267408504],
              [-14.030480082134408, -11.235721483080306],
              [-14.033786490234807, -11.227479328882312],
              [-14.031502465551139, -11.224583029777314],
              [-14.035660510703446, -11.219720067300399],
              [-14.036444998693522, -11.208376110324505],
              [-14.03236879107274, -11.203818937176974],
              [-14.038893378541637, -11.202845607683818],
              [-14.043088496882984, -11.194502003477128]
            ]
          ],
          [
            [
              [-14.175780419743996, -10.905919404002532],
              [-14.174501386677981, -10.901957627489864],
              [-14.16670241390649, -10.902338394762907],
              [-14.165941833943165, -10.907128667187182],
              [-14.159727638500721, -10.911290748814547],
              [-14.165730353911984, -10.913333658840166],
              [-14.174067882930519, -10.908669407316411],
              [-14.175780419743996, -10.905919404002532]
            ]
          ],
          [
            [
              [-14.71288392607712, -10.756902361549217],
              [-14.711679544165765, -10.751495975467776],
              [-14.705680694269859, -10.75125333325643],
              [-14.698857623584763, -10.753899963514783],
              [-14.70487875754238, -10.759954860256737],
              [-14.711394650412633, -10.759248623861394],
              [-14.71288392607712, -10.756902361549217]
            ]
          ],
          [
            [
              [-14.73856514051488, -10.808765131841158],
              [-14.734103331580737, -10.802545429350381],
              [-14.731416348593953, -10.793860371061662],
              [-14.727902657609302, -10.79143073926847],
              [-14.726847624878843, -10.80264893165696],
              [-14.72332962750527, -10.80495393034613],
              [-14.725451715148495, -10.809319317187896],
              [-14.73060109542108, -10.811569487986013],
              [-14.732984441878948, -10.818073514704409],
              [-14.73856514051488, -10.808765131841158]
            ]
          ],
          [
            [
              [-15.571126277715727, -10.757275101439484],
              [-15.565814580830017, -10.756558087175767],
              [-15.553831248237701, -10.759213067550538],
              [-15.550936140962964, -10.765195928410641],
              [-15.550756823309094, -10.771986410356368],
              [-15.553321090794759, -10.777191180382923],
              [-15.559085728701382, -10.76958921557392],
              [-15.568953305764417, -10.761545392748666],
              [-15.571126277715727, -10.757275101439484]
            ]
          ],
          [
            [
              [-15.582802149832606, -10.88563370825409],
              [-15.579705381232468, -10.873620220821318],
              [-15.578697287381917, -10.864072384004848],
              [-15.571800951401908, -10.852870199868612],
              [-15.561116608461266, -10.83785068509103],
              [-15.560029429815799, -10.830720005553806],
              [-15.554039961744635, -10.829242208440393],
              [-15.546427165343921, -10.81839833065422],
              [-15.547020384634717, -10.814418779954286],
              [-15.52644375969559, -10.803022998353143],
              [-15.521962866133379, -10.80357140766607],
              [-15.526808432536143, -10.81004206564959],
              [-15.537371659793578, -10.821200243569741],
              [-15.548977709519214, -10.836490672047693],
              [-15.554906724311795, -10.842657251213705],
              [-15.560242004990886, -10.85489195243023],
              [-15.565380319675535, -10.85882423197913],
              [-15.571255054290662, -10.867519384336736],
              [-15.57623385872038, -10.87896326029351],
              [-15.582802149832606, -10.88563370825409]
            ]
          ],
          [
            [
              [-15.69207961044964, -10.715601432816934],
              [-15.690698841501451, -10.705174566784905],
              [-15.68499218296861, -10.702162358760559],
              [-15.69088927364309, -10.7155257478499],
              [-15.69207961044964, -10.715601432816934]
            ]
          ],
          [
            [
              [-15.852696213702803, -10.710260166527972],
              [-15.84319225041735, -10.705085710294016],
              [-15.832341134642483, -10.707456902221368],
              [-15.826921436651691, -10.706271447740978],
              [-15.819396358981074, -10.709361271933304],
              [-15.807424206575895, -10.707449018013056],
              [-15.805866164777644, -10.711262447439209],
              [-15.80712643134028, -10.717590469363126],
              [-15.81122302107904, -10.720463828750804],
              [-15.819873257667522, -10.722294964362824],
              [-15.826360646987226, -10.720627689356736],
              [-15.831117761288823, -10.715602100165064],
              [-15.851396859690981, -10.71210662938264],
              [-15.852696213702803, -10.710260166527972]
            ]
          ],
          [
            [
              [-15.91108970429659, -10.693525844514559],
              [-15.908837797620718, -10.688220524123638],
              [-15.9095070183108, -10.682558952000647],
              [-15.905239430113458, -10.67454606512838],
              [-15.893770818423317, -10.672575573008402],
              [-15.88363697473563, -10.668064836037692],
              [-15.8807077223576, -10.669878418777705],
              [-15.869455797026966, -10.660102183129617],
              [-15.860383469062256, -10.656103018843625],
              [-15.857723217570792, -10.650383525732037],
              [-15.853290003277491, -10.653064823259228],
              [-15.850816540431428, -10.645538632168666],
              [-15.843755119614098, -10.644285606943287],
              [-15.842610287812118, -10.641955221823087],
              [-15.833547955720986, -10.641631802246687],
              [-15.824566451499136, -10.637088123309125],
              [-15.819007443940214, -10.640510250428727],
              [-15.824682079030104, -10.649817630237012],
              [-15.837303956945895, -10.658828789542849],
              [-15.842905051930158, -10.663976884942759],
              [-15.847892122232878, -10.666161610443792],
              [-15.86011834807783, -10.674982697610615],
              [-15.869878091422375, -10.684277186765263],
              [-15.89284051866881, -10.696158266012887],
              [-15.907355954476886, -10.696928692031104],
              [-15.91108970429659, -10.693525844514559]
            ]
          ],
          [
            [
              [-15.97535821686134, -10.729265998319095],
              [-15.972399651418524, -10.726988222419768],
              [-15.972164072314545, -10.718441192945933],
              [-15.968911878749852, -10.713320441703953],
              [-15.963895283791299, -10.70019053121993],
              [-15.959118538965145, -10.69230261151945],
              [-15.94651638010879, -10.689692185750054],
              [-15.9417724033629, -10.694495753714055],
              [-15.933892577039222, -10.692965489084342],
              [-15.929533991338497, -10.694390089039464],
              [-15.92130765540958, -10.688090536458372],
              [-15.913410885119626, -10.69232404323557],
              [-15.914727081019553, -10.699315785080126],
              [-15.914385390679904, -10.706775087314359],
              [-15.90932492342896, -10.71337692598366],
              [-15.903634789509896, -10.70958703028508],
              [-15.89261110601836, -10.70668975971628],
              [-15.874881467389796, -10.70034874570879],
              [-15.872675269094271, -10.706657257565283],
              [-15.867121840506062, -10.706576986391447],
              [-15.863305651191938, -10.722665317852293],
              [-15.874744178690763, -10.722943650625325],
              [-15.882052954834093, -10.726327332268196],
              [-15.89113970895799, -10.736287847291543],
              [-15.895436683425759, -10.733838587806776],
              [-15.906459528498367, -10.73697879517441],
              [-15.92180614167466, -10.74734176892655],
              [-15.929799590780782, -10.75465928914829],
              [-15.93914366662282, -10.76687298013916],
              [-15.948825099080361, -10.77703383557333],
              [-15.956280614459619, -10.777358043185497],
              [-15.958255960696558, -10.771961718641455],
              [-15.962424678812228, -10.772046939414855],
              [-15.966175811880394, -10.764062398039584],
              [-15.959261750430622, -10.755742553296098],
              [-15.944991355703879, -10.746490012270536],
              [-15.944633099666541, -10.742404496505738],
              [-15.939166815843024, -10.74184027490546],
              [-15.938241265629513, -10.732668710506664],
              [-15.945736959649032, -10.736725554656887],
              [-15.95398119957564, -10.736775525569042],
              [-15.956711640521762, -10.744345545011235],
              [-15.959971841046363, -10.746172611992316],
              [-15.967221773885226, -10.740793071815627],
              [-15.972085539984233, -10.74266771161161],
              [-15.974361421342305, -10.737442110745738],
              [-15.973183554553716, -10.733967895799797],
              [-15.97535821686134, -10.729265998319095]
            ]
          ],
          [
            [
              [-16.006562136600355, -10.581071352147072],
              [-16.00736295437716, -10.573268725335648],
              [-16.003082589906615, -10.563521249390597],
              [-15.9975495644371, -10.568194474867234],
              [-15.997168622395565, -10.558866102116388],
              [-15.98813386293574, -10.56850424912709],
              [-15.990640200158053, -10.572779155739193],
              [-15.989249243905249, -10.577941737971512],
              [-15.991104430363608, -10.581706110789323],
              [-16.0018900086624, -10.584900277641637],
              [-16.006562136600355, -10.581071352147072]
            ]
          ],
          [
            [
              [-16.41416481277403, -7.367736106468194],
              [-16.40995839070295, -7.360875420694754],
              [-16.40573878988022, -7.364206998994303],
              [-16.41416481277403, -7.367736106468194]
            ]
          ],
          [
            [
              [-16.094474297425172, -10.569087712509623],
              [-16.084277791473845, -10.565700813797063],
              [-16.083585120723097, -10.560403293893897],
              [-16.07590348369736, -10.557332756541319],
              [-16.07172395682024, -10.56230580975904],
              [-16.067817051516645, -10.558949084607612],
              [-16.063486642990345, -10.563649369087042],
              [-16.053424325548544, -10.564030643121894],
              [-16.059077425949194, -10.571722930165093],
              [-16.06448926795721, -10.575147249971268],
              [-16.07063569973463, -10.57335609846027],
              [-16.072241720663804, -10.566804668169363],
              [-16.077875566249677, -10.571874974541021],
              [-16.081488150624594, -10.56984757171194],
              [-16.089916504553447, -10.570895766209903],
              [-16.094474297425172, -10.569087712509623]
            ]
          ],
          [
            [
              [-16.104202743999284, -10.63160592404744],
              [-16.094986558648703, -10.626060715133033],
              [-16.093473140283603, -10.630108542981835],
              [-16.096510299863624, -10.636705928851962],
              [-16.104202743999284, -10.63160592404744]
            ]
          ],
          [
            [
              [-16.116156540529577, -10.622924815890668],
              [-16.10430199362308, -10.62096520281064],
              [-16.10335697482712, -10.6258742837849],
              [-16.114871957538675, -10.625180050148748],
              [-16.116156540529577, -10.622924815890668]
            ]
          ],
          [
            [
              [-16.116896066707724, -10.648952311946795],
              [-16.110282532829956, -10.64613044266029],
              [-16.106459030471708, -10.6375182283612],
              [-16.102187556530684, -10.63580921552724],
              [-16.095818524681555, -10.647910278729976],
              [-16.093039088432718, -10.64274654605963],
              [-16.086104189486704, -10.64630471154614],
              [-16.08925248992731, -10.65543185259595],
              [-16.092843026687504, -10.65667609147345],
              [-16.100772829822372, -10.650579446035682],
              [-16.102195046594197, -10.65629862781309],
              [-16.108028972487347, -10.660831551019498],
              [-16.109407089842023, -10.657688368254409],
              [-16.105708729895706, -10.64980804367622],
              [-16.114260046058565, -10.65245692323386],
              [-16.116896066707724, -10.648952311946795]
            ]
          ],
          [
            [
              [-16.103343983019272, -10.785350617408385],
              [-16.09730747962315, -10.782109157317063],
              [-16.092169616300954, -10.773680956711168],
              [-16.086413234362958, -10.768175003730665],
              [-16.084008431156597, -10.77153399392382],
              [-16.077471905868098, -10.766437638600623],
              [-16.075828047547393, -10.77604078568668],
              [-16.078853337619194, -10.77997812716881],
              [-16.087002888223473, -10.784745244672807],
              [-16.0976718327888, -10.795357535236047],
              [-16.10250562418772, -10.793327994972797],
              [-16.10038176884522, -10.789768228902206],
              [-16.103343983019272, -10.785350617408385]
            ]
          ],
          [
            [
              [-16.135187866342267, -10.683511261812447],
              [-16.12756236168835, -10.684724208257059],
              [-16.126570013073977, -10.68972853064872],
              [-16.12813965968943, -10.695272456630992],
              [-16.134562442899153, -10.687312773608532],
              [-16.135187866342267, -10.683511261812447]
            ]
          ],
          [
            [
              [-16.161613299226897, -10.95413975178169],
              [-16.156941676747465, -10.950363037054826],
              [-16.157166028236876, -10.943509970050362],
              [-16.16042630775934, -10.936397251368303],
              [-16.15667454377733, -10.927373889207418],
              [-16.15259604289564, -10.923655260032591],
              [-16.138750082516975, -10.9216430787048],
              [-16.134757550644547, -10.916232466497178],
              [-16.141926448930164, -10.916811528486685],
              [-16.145598803375332, -10.910251500945437],
              [-16.144465732330584, -10.90593671968919],
              [-16.137059833897503, -10.900508340411875],
              [-16.134099353541792, -10.893138861626424],
              [-16.124529596590854, -10.89253520088159],
              [-16.121885346170767, -10.887586314726171],
              [-16.12550882251, -10.883309749756382],
              [-16.126151991549023, -10.877972721481457],
              [-16.11430848575018, -10.870967852199175],
              [-16.107792127615387, -10.863638730598849],
              [-16.105257885314195, -10.856896130049423],
              [-16.08599499878764, -10.840154468233472],
              [-16.081355407085468, -10.833498177540422],
              [-16.080946391038722, -10.828941273971363],
              [-16.07711439438828, -10.823393121234444],
              [-16.07772364207186, -10.81660174010913],
              [-16.072771741631104, -10.812750545695856],
              [-16.06873574619682, -10.805259006354285],
              [-16.06690336591166, -10.798931228118159],
              [-16.069141675866955, -10.793665638035659],
              [-16.052495549441883, -10.78667889645721],
              [-16.05377528645818, -10.77719296783169],
              [-16.052265435598645, -10.772665288477667],
              [-16.057119801004085, -10.770864964689522],
              [-16.055843185681343, -10.763708255685641],
              [-16.048449178926045, -10.762593944028543],
              [-16.049032607745776, -10.758609242075325],
              [-16.055379217524315, -10.757086457810335],
              [-16.056161492471844, -10.74966986640613],
              [-16.048269506994863, -10.744408107176353],
              [-16.047190558180603, -10.740704072979662],
              [-16.03806203606164, -10.736709775642668],
              [-16.036894486681327, -10.743290368378815],
              [-16.04393648511189, -10.75042136938801],
              [-16.035160934128513, -10.74898884679435],
              [-16.032164240935995, -10.750027909483821],
              [-16.02028725091019, -10.746963310055019],
              [-16.021772586940767, -10.75463029528489],
              [-16.032752814962937, -10.766591372547477],
              [-16.036063997280714, -10.774699723538351],
              [-16.0327551742623, -10.776283628429084],
              [-16.0236818540186, -10.769540958047347],
              [-16.01886252733543, -10.76250029629885],
              [-16.01400788478369, -10.761954005181018],
              [-16.01044611070593, -10.757862639691616],
              [-16.004282142583588, -10.75836042085463],
              [-16.00361477097732, -10.763726987181025],
              [-16.008046363438307, -10.771227081025529],
              [-16.010492194123756, -10.779176516271098],
              [-16.02849471603669, -10.79767165729117],
              [-16.028891264675817, -10.80017187152177],
              [-16.036896650475384, -10.805542019931742],
              [-16.04720258442341, -10.816719876707358],
              [-16.05418703992181, -10.828507571674947],
              [-16.056743199110667, -10.834679126469583],
              [-16.06269256292123, -10.842218511966003],
              [-16.070803527581884, -10.855937410845685],
              [-16.07360003743645, -10.870542746745429],
              [-16.07102851988932, -10.873710322550393],
              [-16.072181602300383, -10.880791069617173],
              [-16.066993689885646, -10.884652849606365],
              [-16.0701778750785, -10.887771837110352],
              [-16.07906015346072, -10.884062850275166],
              [-16.091167905257223, -10.894685857640042],
              [-16.091026056775814, -10.90152544917224],
              [-16.088342163203, -10.904983471617488],
              [-16.080800145513628, -10.906070223614956],
              [-16.08111258072417, -10.914160450211785],
              [-16.07930446790982, -10.917168680001096],
              [-16.08344282168286, -10.922575632686394],
              [-16.093346205026215, -10.929365198043435],
              [-16.101699364582814, -10.92569528688614],
              [-16.109034045514544, -10.927012712857758],
              [-16.11500833343188, -10.934776969922579],
              [-16.11555277685927, -10.939920259635112],
              [-16.119899915722364, -10.945588283872574],
              [-16.122078996176178, -10.943845120596196],
              [-16.129417627763875, -10.9458952335016],
              [-16.139502210254665, -10.952543389931026],
              [-16.144122779890672, -10.958147536053453],
              [-16.151628367039386, -10.960986959865982],
              [-16.15752281283214, -10.958909335229233],
              [-16.161613299226897, -10.95413975178169]
            ]
          ],
          [
            [
              [-16.183345770092288, -10.795300087229517],
              [-16.17837694464068, -10.791012918449333],
              [-16.177827245190645, -10.782304336160665],
              [-16.175684043863352, -10.778314651927685],
              [-16.160919890994812, -10.775707221634027],
              [-16.155526180473334, -10.773457124079236],
              [-16.15192111679536, -10.768472523009718],
              [-16.146956447556953, -10.766095315980039],
              [-16.150428560469063, -10.760829927238227],
              [-16.15788293676052, -10.767757093871962],
              [-16.164042981342707, -10.771462910512753],
              [-16.172213447919848, -10.77179771061049],
              [-16.175031973427597, -10.764589563629945],
              [-16.169932070607903, -10.76188496990384],
              [-16.17208398789108, -10.755640997729117],
              [-16.16821981200385, -10.750360691907309],
              [-16.164086635307196, -10.726303271092435],
              [-16.160077709564842, -10.720123750614631],
              [-16.16061216486914, -10.715379904276203],
              [-16.156147177654123, -10.714886773417469],
              [-16.15799091365748, -10.725214376257801],
              [-16.14882082885533, -10.724934051386327],
              [-16.14913573891418, -10.702950486855553],
              [-16.144301536484612, -10.701241226282221],
              [-16.139748996901453, -10.706333804132553],
              [-16.136301757275188, -10.701747450437235],
              [-16.139789753349373, -10.692140139257315],
              [-16.136811931202583, -10.690235760458345],
              [-16.132716976171274, -10.695098680585232],
              [-16.128701633158038, -10.70356462829217],
              [-16.129121721142504, -10.708240535259499],
              [-16.1323286693296, -10.711765839161302],
              [-16.130943529669995, -10.717526030006786],
              [-16.135563878461003, -10.720911041797459],
              [-16.127743201979907, -10.730161725064507],
              [-16.13354852732868, -10.73582929026872],
              [-16.140013150983407, -10.737413487350025],
              [-16.140880212330735, -10.740343881634976],
              [-16.1369783740574, -10.744946054201927],
              [-16.128993781791696, -10.742035146258074],
              [-16.12669349135801, -10.749965233554054],
              [-16.130152373430626, -10.756692368957896],
              [-16.12993652989058, -10.760586801990991],
              [-16.133831809301018, -10.763319359530817],
              [-16.132857323009077, -10.768246666482794],
              [-16.137547052262008, -10.774728015603683],
              [-16.138422357391665, -10.77889363411714],
              [-16.14251686182035, -10.782216760408705],
              [-16.14129600601342, -10.787169790184121],
              [-16.14499865786672, -10.789884836266298],
              [-16.142508808715377, -10.796441210838525],
              [-16.13637658425295, -10.793620387322916],
              [-16.138695426656486, -10.80725800743933],
              [-16.142226876086028, -10.8105346945326],
              [-16.14422382225623, -10.824651010963773],
              [-16.149284619246927, -10.82327371095649],
              [-16.152271960326228, -10.81539452652922],
              [-16.155200758342016, -10.817670559022458],
              [-16.159700097509354, -10.813863571013616],
              [-16.155445505579685, -10.802913566646014],
              [-16.180102159179764, -10.802655084078133],
              [-16.179794947099737, -10.797516283553882],
              [-16.183345770092288, -10.795300087229517]
            ]
          ],
          [
            [
              [-16.20729710987536, -10.63324909712812],
              [-16.202224926615845, -10.631349742899374],
              [-16.198510528573948, -10.639880497244226],
              [-16.19536641063136, -10.64036619953857],
              [-16.20040109014182, -10.627354596915163],
              [-16.196085373312037, -10.624754147522962],
              [-16.19299248649527, -10.627499067126582],
              [-16.187506013904745, -10.627770593948778],
              [-16.17639349352369, -10.641590658094207],
              [-16.179247802383763, -10.649231187813916],
              [-16.19026403803358, -10.647071644814366],
              [-16.19046968062611, -10.655496514900266],
              [-16.197186207568173, -10.649996658669194],
              [-16.19802093590217, -10.645635166703332],
              [-16.20264924270124, -10.645877520178363],
              [-16.20278844501986, -10.637364477358496],
              [-16.20729710987536, -10.63324909712812]
            ]
          ],
          [
            [
              [-16.193785084632154, -10.82713224517056],
              [-16.190557466511276, -10.819002720348358],
              [-16.18674814098077, -10.824869895943316],
              [-16.190959431140698, -10.831759413384487],
              [-16.193785084632154, -10.82713224517056]
            ]
          ],
          [
            [
              [-16.189113458513372, -10.90002167559563],
              [-16.181672534291685, -10.885354405917806],
              [-16.17839718861134, -10.883868791416326],
              [-16.177379647109348, -10.879125774929436],
              [-16.171249469423092, -10.873926067601838],
              [-16.170460542329423, -10.866779905735257],
              [-16.16730242063404, -10.86411016274545],
              [-16.162277155725217, -10.856133195303462],
              [-16.157487541166333, -10.852328254868896],
              [-16.150640951128455, -10.858400684234034],
              [-16.157394827888307, -10.881483200172124],
              [-16.16551721047759, -10.891199998237397],
              [-16.184240312513218, -10.903632260293866],
              [-16.189113458513372, -10.90002167559563]
            ]
          ],
          [
            [
              [-16.217343882075564, -10.776654644835457],
              [-16.21664573737246, -10.771130009698638],
              [-16.207591505433257, -10.765612451013679],
              [-16.209090107580217, -10.761343160593544],
              [-16.2021345460169, -10.753238580830718],
              [-16.1966675805932, -10.754098874584958],
              [-16.194724704683704, -10.749732911747806],
              [-16.190324418956273, -10.754186447371776],
              [-16.190283264547695, -10.761760065811483],
              [-16.19364800359495, -10.773964741221949],
              [-16.19353933479149, -10.7859128230797],
              [-16.202651446969316, -10.789126250041146],
              [-16.21159284855907, -10.787417705176408],
              [-16.216033066779683, -10.78298721838819],
              [-16.217343882075564, -10.776654644835457]
            ]
          ],
          [
            [
              [-16.207222368288413, -10.884879439428758],
              [-16.203440290464986, -10.882534129816761],
              [-16.202444254506368, -10.865954605354188],
              [-16.199554567809603, -10.861181606022557],
              [-16.196988784310584, -10.851510582514127],
              [-16.191547811255997, -10.847952283108874],
              [-16.191296170131427, -10.844359542965005],
              [-16.183404496471102, -10.840459105076846],
              [-16.184683986242796, -10.837373617110119],
              [-16.181791517774432, -10.83190807638298],
              [-16.178289283190217, -10.837951106036794],
              [-16.169327428547103, -10.83538149065667],
              [-16.16547226086169, -10.840243133728388],
              [-16.164902452343657, -10.844542489883187],
              [-16.180018751014973, -10.860934730216352],
              [-16.180244344398748, -10.865682214643586],
              [-16.18731384364238, -10.866968069120585],
              [-16.189675764755556, -10.872029202048825],
              [-16.193090731955742, -10.872412266367288],
              [-16.20131085922859, -10.888606393728821],
              [-16.207222368288413, -10.884879439428758]
            ]
          ],
          [
            [
              [-16.222303244175272, -10.906732153972548],
              [-16.216144669892415, -10.906164452205266],
              [-16.213827448308024, -10.898505040443286],
              [-16.215296603709, -10.894635230443035],
              [-16.210758914294516, -10.892308515143629],
              [-16.208014331478434, -10.898062131847736],
              [-16.20456351278309, -10.89451269989822],
              [-16.197986168445077, -10.892804361893386],
              [-16.19203474919866, -10.880795082829428],
              [-16.18395277215239, -10.868725818803366],
              [-16.180559613453926, -10.87216700141745],
              [-16.183418915442257, -10.87632969208993],
              [-16.187020513414865, -10.886034118314791],
              [-16.195522029959136, -10.89872976281203],
              [-16.206931838409332, -10.906195369924909],
              [-16.21770499122635, -10.908772032099316],
              [-16.222303244175272, -10.906732153972548]
            ]
          ],
          [
            [
              [-16.415462262042244, -10.933462331000422],
              [-16.410454110637264, -10.931262941316833],
              [-16.41490643225164, -10.926358511276845],
              [-16.410765695063674, -10.918784751505248],
              [-16.408534255930043, -10.922912241763779],
              [-16.40963143202107, -10.93227772665431],
              [-16.415462262042244, -10.933462331000422]
            ]
          ],
          [
            [
              [-16.422395932715197, -10.952316920987522],
              [-16.42042309392735, -10.945992983537323],
              [-16.41455735618588, -10.949305371466986],
              [-16.422395932715197, -10.952316920987522]
            ]
          ],
          [
            [
              [-16.494483512949472, -11.017453297640804],
              [-16.487235703176044, -11.024201665120277],
              [-16.481803144695338, -11.031956441181686],
              [-16.47868531606966, -11.04019214896373],
              [-16.49197843289834, -11.024494988476471],
              [-16.494483512949472, -11.017453297640804]
            ]
          ],
          [
            [
              [-16.600271082353252, -10.521959217870494],
              [-16.593286721288347, -10.517984385469614],
              [-16.591037448304693, -10.50723051738631],
              [-16.581769799320707, -10.504060837206245],
              [-16.58113614940328, -10.511517217092845],
              [-16.58553413029791, -10.517194764456526],
              [-16.592317440144605, -10.522909022478897],
              [-16.600271082353252, -10.521959217870494]
            ]
          ],
          [
            [
              [-16.59311434650754, -11.128381695378975],
              [-16.590734713222886, -11.125894794817695],
              [-16.581959470763906, -11.124027951931025],
              [-16.580813576040065, -11.127518912110046],
              [-16.58287931001375, -11.137916439137987],
              [-16.588950458797157, -11.13526961045656],
              [-16.58493234123278, -11.128742403234712],
              [-16.59311434650754, -11.128381695378975]
            ]
          ],
          [
            [
              [-16.651665146317757, -11.149344509489424],
              [-16.651140447114614, -11.141998301086694],
              [-16.647328959010036, -11.142903334694244],
              [-16.645783567043612, -11.134048022829127],
              [-16.641261076317708, -11.131488571497396],
              [-16.640137098088505, -11.12612754885893],
              [-16.6413067853906, -11.119711255905086],
              [-16.639544068599214, -11.114490937514612],
              [-16.629076704898107, -11.117690183665859],
              [-16.62403371650607, -11.12207372272291],
              [-16.625887967474597, -11.125424529726413],
              [-16.623206092128044, -11.131474684000901],
              [-16.624491805437984, -11.136848363640919],
              [-16.628516149726636, -11.138387219586159],
              [-16.63169284555367, -11.143270645128787],
              [-16.631727911146076, -11.147540449451828],
              [-16.63468632242545, -11.153462330647049],
              [-16.64155034072552, -11.159324716481025],
              [-16.643504904972485, -11.151631374276446],
              [-16.64712974550384, -11.154527202156036],
              [-16.65163771890206, -11.153319584336723],
              [-16.651665146317757, -11.149344509489424]
            ]
          ],
          [
            [
              [-16.783455046606882, -11.213990487623423],
              [-16.778523493632814, -11.213914217708213],
              [-16.769285185921877, -11.218445773402987],
              [-16.765696401994408, -11.223650978747646],
              [-16.76736867642853, -11.227142919143573],
              [-16.773385250720796, -11.225202246343946],
              [-16.777241150971197, -11.221266031555588],
              [-16.78249551807901, -11.219650953045937],
              [-16.783455046606882, -11.213990487623423]
            ]
          ],
          [
            [
              [-16.81831348511941, -11.226101174040453],
              [-16.814678567407363, -11.221121752183556],
              [-16.802701581094297, -11.227501641236431],
              [-16.806581885067676, -11.232685454417368],
              [-16.815943476078125, -11.231153714362408],
              [-16.81831348511941, -11.226101174040453]
            ]
          ],
          [
            [
              [-16.846656521498225, -11.21323084985879],
              [-16.83645247852873, -11.2053638330869],
              [-16.831719278930013, -11.206258391052916],
              [-16.830355845443446, -11.210085850784035],
              [-16.833197669296474, -11.219981648726138],
              [-16.840033160762992, -11.216726254909913],
              [-16.8455281848839, -11.216364569681211],
              [-16.846656521498225, -11.21323084985879]
            ]
          ],
          [
            [
              [-16.838543073963585, -11.543079048074611],
              [-16.838467737040123, -11.537301458868022],
              [-16.83369083970713, -11.532369961487735],
              [-16.835924337880353, -11.526841688985874],
              [-16.828893846674116, -11.518957734774077],
              [-16.820843774166043, -11.522141365005597],
              [-16.819405279638893, -11.527217867284982],
              [-16.820001673863327, -11.537963781318608],
              [-16.822213254273848, -11.546269523834303],
              [-16.832147251764937, -11.554092053762014],
              [-16.838543073963585, -11.543079048074611]
            ]
          ],
          [
            [
              [-16.86954317785504, -11.29691238684621],
              [-16.86188909395334, -11.29311394492186],
              [-16.857579890453074, -11.296747568981038],
              [-16.8669026350166, -11.299245680532726],
              [-16.86954317785504, -11.29691238684621]
            ]
          ],
          [
            [
              [-16.87931426583791, -11.294445709855918],
              [-16.876825801635594, -11.287443618277479],
              [-16.8731669777679, -11.285331497344757],
              [-16.870590077301294, -11.289207079021967],
              [-16.874610807242423, -11.293550103873457],
              [-16.87931426583791, -11.294445709855918]
            ]
          ],
          [
            [
              [-16.895232519680736, -10.804632441880718],
              [-16.89381709175978, -10.798382151288966],
              [-16.887019607318255, -10.798105646306857],
              [-16.8826051866585, -10.794973808796376],
              [-16.881960778443208, -10.787897672807306],
              [-16.88434975292636, -10.784765046881901],
              [-16.877926318016467, -10.780603514136292],
              [-16.87540205540829, -10.773600414203498],
              [-16.874208816276667, -10.763363548095771],
              [-16.87652409849547, -10.758578807007769],
              [-16.87316195306618, -10.749865460506628],
              [-16.869397968578756, -10.744982451411888],
              [-16.857219318397767, -10.751714746890064],
              [-16.853815933663835, -10.754598383379385],
              [-16.863695513949835, -10.762353075548615],
              [-16.862226829420454, -10.768580475797927],
              [-16.86410848949056, -10.771108852759859],
              [-16.871962338995143, -10.774995013299524],
              [-16.877732083555554, -10.786880299460858],
              [-16.873219809753316, -10.794937325069426],
              [-16.878500380608283, -10.799153763009368],
              [-16.89346930105208, -10.806003793702127],
              [-16.895232519680736, -10.804632441880718]
            ]
          ],
          [
            [
              [-16.91081942424733, -11.697404000080073],
              [-16.903533365055093, -11.690028174150413],
              [-16.901094915037923, -11.685260258922833],
              [-16.89722868536, -11.690824771359125],
              [-16.907713120116473, -11.697675212452557],
              [-16.91081942424733, -11.697404000080073]
            ]
          ],
          [
            [
              [-16.90876110016605, -11.831742896198945],
              [-16.90194307179391, -11.8221073389137],
              [-16.896930570784384, -11.82554455695229],
              [-16.903039669547383, -11.831423557573059],
              [-16.90876110016605, -11.831742896198945]
            ]
          ],
          [
            [
              [-16.929852227996555, -11.298354065750425],
              [-16.92407680694392, -11.299016171968393],
              [-16.918608745293703, -11.28463879854015],
              [-16.90741622071804, -11.29049867961957],
              [-16.901469085055624, -11.289708056011591],
              [-16.89801486454468, -11.286996354962945],
              [-16.894196369815084, -11.291181623255577],
              [-16.89842296723451, -11.293070921587766],
              [-16.903056388489, -11.29188433690952],
              [-16.90915068381258, -11.299166770797868],
              [-16.91837152205448, -11.301876111794103],
              [-16.924979350358914, -11.30138534754593],
              [-16.929852227996555, -11.298354065750425]
            ]
          ],
          [
            [
              [-16.92003519578126, -11.688346748731716],
              [-16.91445238801765, -11.681807447022438],
              [-16.91088014652366, -11.688252874169686],
              [-16.913363958965952, -11.693151513793612],
              [-16.918619612696084, -11.695329138826835],
              [-16.92003519578126, -11.688346748731716]
            ]
          ],
          [
            [
              [-16.950554125792838, -11.641368545980344],
              [-16.941909205453673, -11.631675515890368],
              [-16.936835209759, -11.627582371248256],
              [-16.931349845827736, -11.634143871803687],
              [-16.929658705862725, -11.638669397597317],
              [-16.921291575006283, -11.639144099176184],
              [-16.914960421619675, -11.643069238767763],
              [-16.921533588423994, -11.653443166409827],
              [-16.929226504262104, -11.65271393944208],
              [-16.934454077084826, -11.648100870240796],
              [-16.94626326107727, -11.640808329617029],
              [-16.950554125792838, -11.641368545980344]
            ]
          ],
          [
            [
              [-16.989566109766, -10.868941546166221],
              [-16.986396857713675, -10.86340984158747],
              [-16.979124096011166, -10.8664837695308],
              [-16.97682450394997, -10.87071914417054],
              [-16.975661260467284, -10.881085879689888],
              [-16.97358303093801, -10.885373848072664],
              [-16.97412799280385, -10.890804808902415],
              [-16.98016180013995, -10.886499607012711],
              [-16.988227698916305, -10.872742789893262],
              [-16.989566109766, -10.868941546166221]
            ]
          ],
          [
            [
              [-17.014647943856307, -11.629998143232635],
              [-17.012223083727648, -11.625274760384944],
              [-17.00229405818536, -11.62215457651259],
              [-16.994143318324657, -11.62287365974387],
              [-16.98897450735749, -11.619526976349805],
              [-16.991872497391217, -11.63336842705754],
              [-16.99569454499057, -11.640728545224988],
              [-16.999368428039233, -11.642140731442874],
              [-17.012221726655234, -11.635292195911747],
              [-17.014647943856307, -11.629998143232635]
            ]
          ],
          [
            [
              [-17.11819052038672, -11.595715018617588],
              [-17.114086658607143, -11.588762232800669],
              [-17.103279978061597, -11.582050261156395],
              [-17.103391307244202, -11.575400364707205],
              [-17.099905544371158, -11.56945208670158],
              [-17.09573851798222, -11.566129747618339],
              [-17.08899335531688, -11.566532592734756],
              [-17.07712775741179, -11.580989883838434],
              [-17.072341449345434, -11.585166274117759],
              [-17.05792191604469, -11.58485220350394],
              [-17.050972326682903, -11.577369904754589],
              [-17.06372374423477, -11.577238982260804],
              [-17.070459203956013, -11.578144975495848],
              [-17.07193459464867, -11.572420296520143],
              [-17.07564776391603, -11.569659552985149],
              [-17.081831983287316, -11.561448034725354],
              [-17.080258281984236, -11.546901881272802],
              [-17.07390178174523, -11.541570954938765],
              [-17.06927667886199, -11.544529273885466],
              [-17.057493288546187, -11.54665942797315],
              [-17.05221449977803, -11.54904321164724],
              [-17.047752215559314, -11.546352068628963],
              [-17.043067457486277, -11.546930520223029],
              [-17.043048660178655, -11.539564405665006],
              [-17.054213482498746, -11.534598962401517],
              [-17.060615320677876, -11.526251177679912],
              [-17.054550577553393, -11.52019119022965],
              [-17.05067760088388, -11.510723911922334],
              [-17.04012649387737, -11.51396593382971],
              [-17.038337784871647, -11.516862191290103],
              [-17.027071539101705, -11.517977246310524],
              [-17.024824964758686, -11.52194054476082],
              [-17.01679764228775, -11.51639111628487],
              [-17.01356976526052, -11.518500913694222],
              [-17.009302511873244, -11.513670964849192],
              [-17.01362094545878, -11.51182345911904],
              [-17.025071396135235, -11.509864716232155],
              [-17.030493632567204, -11.500673006395344],
              [-17.02805333015692, -11.498187397563868],
              [-17.02215900187911, -11.497341745227834],
              [-17.019777766172734, -11.500327758709124],
              [-17.014145776754784, -11.501016096757061],
              [-17.009133002174035, -11.506584449872081],
              [-17.00178925898878, -11.509441392429814],
              [-17.000398441596175, -11.505833286795063],
              [-17.007092089994185, -11.497106537885958],
              [-17.002919460684993, -11.49445722985959],
              [-17.002593535496672, -11.488615289313627],
              [-17.007459508109726, -11.488916500149436],
              [-17.010764693148978, -11.484127062454027],
              [-17.01532845673422, -11.484205231057219],
              [-17.017201260905434, -11.476563029707929],
              [-17.008085103822943, -11.476106365166883],
              [-17.001717830639723, -11.470422438278057],
              [-17.000613142529055, -11.464534618114609],
              [-16.99659985846708, -11.463304900024927],
              [-16.995725938968008, -11.456867828384274],
              [-16.9901232711891, -11.455008027829262],
              [-16.98361341701965, -11.455181929874806],
              [-16.979326474190785, -11.448551774635565],
              [-16.970775277915603, -11.453084309234969],
              [-16.96596522892403, -11.452898594260635],
              [-16.959773373769437, -11.456318974401304],
              [-16.95472284752843, -11.453299580138891],
              [-16.97033268223546, -11.444165811535175],
              [-16.97429093592071, -11.444283049121596],
              [-16.980409455342944, -11.440192634226175],
              [-16.978243705225285, -11.431860009702831],
              [-16.982409971460115, -11.429251945472705],
              [-16.98103372120648, -11.42043014805693],
              [-16.977559339971986, -11.41698982651659],
              [-16.978216319524055, -11.412438655646932],
              [-16.972737458345687, -11.405888538546431],
              [-16.969182883873195, -11.406454480421145],
              [-16.966279796524123, -11.40093790408494],
              [-16.9611613607515, -11.403897738425607],
              [-16.96117074157873, -11.407351168578849],
              [-16.95362424850286, -11.408593832214153],
              [-16.949321475533473, -11.404106874375172],
              [-16.944546912175554, -11.395987346312598],
              [-16.93756927633021, -11.404221287535542],
              [-16.934915861393062, -11.397936569848326],
              [-16.92414528762971, -11.393630218500117],
              [-16.925938736071693, -11.408037093251105],
              [-16.92296670410424, -11.411035306529149],
              [-16.928842002530427, -11.419797390536113],
              [-16.930676662017323, -11.426031814583546],
              [-16.927155651314035, -11.430090226023562],
              [-16.933843885869173, -11.436274540312134],
              [-16.935353538785606, -11.443620222303002],
              [-16.940103518956043, -11.447964986605127],
              [-16.94784788086853, -11.452376718315788],
              [-16.94794022223496, -11.455845022826098],
              [-16.951806457066976, -11.46128233640581],
              [-16.953624467766264, -11.467189742863496],
              [-16.95230004622688, -11.471916305344106],
              [-16.945375345890227, -11.476347962110012],
              [-16.94981362312753, -11.485495787931733],
              [-16.948299484163098, -11.492627977111884],
              [-16.94242770122086, -11.492495434158732],
              [-16.939204141510572, -11.485383805030843],
              [-16.934483250443872, -11.493470556193728],
              [-16.92699727460328, -11.489987805723121],
              [-16.926693143252876, -11.483029627829476],
              [-16.922558271171276, -11.47804036927172],
              [-16.925795772595087, -11.470317868752067],
              [-16.919885099868498, -11.463661370176474],
              [-16.912104754294024, -11.467279420599404],
              [-16.909518113747914, -11.47145618027303],
              [-16.90520192672963, -11.473616989642004],
              [-16.899203192218046, -11.481607568638895],
              [-16.90347852764362, -11.485923726204062],
              [-16.898754181778596, -11.491636751703226],
              [-16.893105796612105, -11.489726723206491],
              [-16.89075128442809, -11.483698601422232],
              [-16.883241857922272, -11.477102643407628],
              [-16.880733604169798, -11.484153549797178],
              [-16.875921679088183, -11.483589890443525],
              [-16.879413677250348, -11.499658037362988],
              [-16.88412446131858, -11.51160691103971],
              [-16.88530373884622, -11.520714590444387],
              [-16.884147424460423, -11.53523363652269],
              [-16.881180267678438, -11.533601223342618],
              [-16.878245499324308, -11.523359345509464],
              [-16.87823009538578, -11.516389289499333],
              [-16.873992415658083, -11.50625198499437],
              [-16.86922289536296, -11.505428385120895],
              [-16.871364964094944, -11.518432550499226],
              [-16.86486063624957, -11.51278287332186],
              [-16.85899332584262, -11.493703312455615],
              [-16.855663881894934, -11.492960448942657],
              [-16.852565183707814, -11.497376975926732],
              [-16.85342463175115, -11.503332214568417],
              [-16.85182109392919, -11.52255073093545],
              [-16.85563455149225, -11.529078946197043],
              [-16.852978664143485, -11.531626877855967],
              [-16.857719362705055, -11.540814890126962],
              [-16.863675460414406, -11.540428979041684],
              [-16.86800777769079, -11.544648666263347],
              [-16.865875139853173, -11.548683269379627],
              [-16.872560059707325, -11.559313846795877],
              [-16.878015065456694, -11.56140903233631],
              [-16.882304960292892, -11.558377110380183],
              [-16.883496883799218, -11.551895833000165],
              [-16.89127564635013, -11.553745674704924],
              [-16.8944687296866, -11.552191835944226],
              [-16.89884718478239, -11.542435015328968],
              [-16.895685137857775, -11.539809331883644],
              [-16.8987366910884, -11.533686744996809],
              [-16.904765223316268, -11.528762951593741],
              [-16.9064964060371, -11.530960025996645],
              [-16.915201408301083, -11.530361662206202],
              [-16.915078773836466, -11.540135149416804],
              [-16.91092473973821, -11.543564339465044],
              [-16.910649908632266, -11.552351984655688],
              [-16.918631120592202, -11.548153019990899],
              [-16.91716351966785, -11.557604392445167],
              [-16.90549261092619, -11.566934858015763],
              [-16.92012555867161, -11.575333786210178],
              [-16.920988585023327, -11.57069022344198],
              [-16.92745449488294, -11.569637141015013],
              [-16.92930291739849, -11.57283325638511],
              [-16.9404406686836, -11.56691809119656],
              [-16.9416200898123, -11.570744220912635],
              [-16.95297155349321, -11.57432199508604],
              [-16.954724205928937, -11.584038280116086],
              [-16.959268214575136, -11.584784253583134],
              [-16.961824848668613, -11.574209837332196],
              [-16.96005174188365, -11.567220525868693],
              [-16.9606204961122, -11.553383658081572],
              [-16.962405891361062, -11.549756823554123],
              [-16.96668064633637, -11.550234360949093],
              [-16.9684433036364, -11.561828850046476],
              [-16.968436545388293, -11.572360851740125],
              [-16.97281354734386, -11.585021812094308],
              [-16.977505056792285, -11.593546716282853],
              [-16.99146873000529, -11.597578796981146],
              [-16.996774489129972, -11.595557323850992],
              [-16.999777321467157, -11.596909215644693],
              [-16.99529684637123, -11.606261558778296],
              [-16.999698154628867, -11.617514834032866],
              [-17.00314466273655, -11.618962702301085],
              [-17.013281792095178, -11.617621910505719],
              [-17.020042056637845, -11.62596842138833],
              [-17.024746870151205, -11.623487324232524],
              [-17.0370664060146, -11.623244602033525],
              [-17.041676707724953, -11.62088610512286],
              [-17.04924942544236, -11.620258088321362],
              [-17.05659988070245, -11.616590077135466],
              [-17.064734608875334, -11.60981171790486],
              [-17.079201793269586, -11.605054094354845],
              [-17.082521288263873, -11.59916503123256],
              [-17.085397082044604, -11.600971082856528],
              [-17.09564530931491, -11.599091536453455],
              [-17.108067298388608, -11.603453742950583],
              [-17.110704482202753, -11.598546523161366],
              [-17.11819052038672, -11.595715018617588]
            ]
          ],
          [
            [
              [-17.150023974189768, -11.143260731583092],
              [-17.14748517622532, -11.137779082618575],
              [-17.136388775815607, -11.137409808844549],
              [-17.130476249532677, -11.132777192446568],
              [-17.12227659562863, -11.129791146297649],
              [-17.117163734945958, -11.13083025646061],
              [-17.115038764968773, -11.1369409094564],
              [-17.10944489079458, -11.143480676489453],
              [-17.108203174259064, -11.149354642443456],
              [-17.112110629537924, -11.1558655160085],
              [-17.122010647406626, -11.159631308267143],
              [-17.138693228896713, -11.162228458710409],
              [-17.145663762009143, -11.157178583830484],
              [-17.14411188036451, -11.1494000383696],
              [-17.150023974189768, -11.143260731583092]
            ]
          ],
          [
            [
              [-17.15243710145839, -11.994679553649313],
              [-17.149506417490883, -11.992080208482978],
              [-17.14113761847087, -11.989713207918879],
              [-17.14092325684588, -11.994565030265385],
              [-17.147015102721667, -11.999013082041067],
              [-17.15243710145839, -11.994679553649313]
            ]
          ],
          [
            [
              [-17.255383364680753, -12.0691485339975],
              [-17.251719200074596, -12.061726770037078],
              [-17.248205514650998, -12.059361944436164],
              [-17.243606117796176, -12.061427584083214],
              [-17.23886178334324, -12.057183216386143],
              [-17.233621534653437, -12.055845631020047],
              [-17.229339881589052, -12.057502758322867],
              [-17.228795411668283, -12.066183492129639],
              [-17.230392166414063, -12.068555362880131],
              [-17.249036682191786, -12.065132869978827],
              [-17.255383364680753, -12.0691485339975]
            ]
          ],
          [
            [
              [-17.295374451163713, -12.117293988290937],
              [-17.28555097045579, -12.102346810720435],
              [-17.28064142670625, -12.098554555098449],
              [-17.26791054788156, -12.091829564484277],
              [-17.26266680644031, -12.095254121159819],
              [-17.253342274724375, -12.094380514480866],
              [-17.243878069921337, -12.090989229805155],
              [-17.240411960293024, -12.095881683874747],
              [-17.240006525774533, -12.100861859173953],
              [-17.233841600966894, -12.11155032534425],
              [-17.229678347796238, -12.113932289508945],
              [-17.214119125643673, -12.111997418375804],
              [-17.2079901014336, -12.109925168781826],
              [-17.200576824762027, -12.110586570463893],
              [-17.19947058935105, -12.114536222610171],
              [-17.203120224363037, -12.121236423697184],
              [-17.21319027573877, -12.126193192425562],
              [-17.215981661994448, -12.13033161685285],
              [-17.22404729094503, -12.131324164297165],
              [-17.225605496086832, -12.129795390981528],
              [-17.237292902694744, -12.13181338943718],
              [-17.246001069817467, -12.131757285355928],
              [-17.25639754332401, -12.128634500428998],
              [-17.269705625162334, -12.13421683790834],
              [-17.278308309407645, -12.130497517380183],
              [-17.290721107654285, -12.129182334413143],
              [-17.295040150210585, -12.123046855947573],
              [-17.295374451163713, -12.117293988290937]
            ]
          ],
          [
            [
              [-17.32044166919053, -11.594531600122242],
              [-17.317528410084066, -11.592218901866238],
              [-17.311317876973586, -11.594727633333084],
              [-17.311031609225132, -11.597626696434181],
              [-17.31785017646834, -11.59982729361538],
              [-17.32044166919053, -11.594531600122242]
            ]
          ],
          [
            [
              [-17.378974155528223, -12.154591566863523],
              [-17.373425147724923, -12.143578513885766],
              [-17.365579381321933, -12.131292424760346],
              [-17.358149932399712, -12.122289082590305],
              [-17.34841978215006, -12.115599625757097],
              [-17.332692360805247, -12.101954631905977],
              [-17.324011444047915, -12.097087501013753],
              [-17.31637635103711, -12.096829234953532],
              [-17.30246820902378, -12.102078217900903],
              [-17.299939899922208, -12.107523673985643],
              [-17.300935696411525, -12.113310219440914],
              [-17.31455006084009, -12.122748758558586],
              [-17.31540514581946, -12.127012924496015],
              [-17.332132626502016, -12.132822397545732],
              [-17.341019349084846, -12.137109964155155],
              [-17.34831516363159, -12.142263055245445],
              [-17.357884042045548, -12.15347007742147],
              [-17.360555471813246, -12.158488399825947],
              [-17.366079347545952, -12.163612860543878],
              [-17.371929057543632, -12.164765560095748],
              [-17.377881016632415, -12.159109427297976],
              [-17.378974155528223, -12.154591566863523]
            ]
          ],
          [
            [
              [-17.375349267831997, -11.84024457372279],
              [-17.372095199731277, -11.833985886553787],
              [-17.368862086215252, -11.836840314729766],
              [-17.3642519313253, -11.836846972779085],
              [-17.360493477433888, -11.832925234815661],
              [-17.357011412512982, -11.825348771700238],
              [-17.35641993594706, -11.81607576258235],
              [-17.35995116370411, -11.812126577129115],
              [-17.350301733076485, -11.80330607348207],
              [-17.34702388278663, -11.792405853569083],
              [-17.343700468663577, -11.785417280085612],
              [-17.334840654514743, -11.78150597214121],
              [-17.324800789307147, -11.77422395043784],
              [-17.321835479697892, -11.765265429322655],
              [-17.318738603861323, -11.761785380554707],
              [-17.311816302700255, -11.764155360639048],
              [-17.304631809257184, -11.76083066121263],
              [-17.299425083395434, -11.753071423280316],
              [-17.290367551138168, -11.746646820527335],
              [-17.288741017847173, -11.741451615668208],
              [-17.28194927181811, -11.74196486101437],
              [-17.274170131912662, -11.73998634311664],
              [-17.267486173030168, -11.733105731837625],
              [-17.243574068607845, -11.737138974603619],
              [-17.235938167540258, -11.736098916366274],
              [-17.231054746079003, -11.733655048991618],
              [-17.22169000189959, -11.737588709233606],
              [-17.22337587844917, -11.74392754483183],
              [-17.22164261746519, -11.747294225710856],
              [-17.222083710915058, -11.759370773100462],
              [-17.219857311515195, -11.76576264525786],
              [-17.222436183763964, -11.773736255080442],
              [-17.211211815176107, -11.777541849800487],
              [-17.2103991405612, -11.786573622610133],
              [-17.201267370459455, -11.78401576869352],
              [-17.20226787481243, -11.773365251170684],
              [-17.189042247243204, -11.759275370681793],
              [-17.202635359634343, -11.743382697216436],
              [-17.200072164994737, -11.737301887043339],
              [-17.191946846506138, -11.738026018240165],
              [-17.177078780883036, -11.737103933290545],
              [-17.17351616116413, -11.739799734808715],
              [-17.162058378604993, -11.74027243472548],
              [-17.159546898756464, -11.736675566375993],
              [-17.164681975836743, -11.73062802202894],
              [-17.170101346814164, -11.729167570929562],
              [-17.187470473232192, -11.721415668166888],
              [-17.192035337427, -11.721908596060498],
              [-17.199890308546845, -11.718216963214182],
              [-17.210525108380523, -11.71989240368735],
              [-17.21355005862947, -11.708770469640175],
              [-17.211874141611816, -11.702490226468669],
              [-17.21316529396665, -11.695039994080902],
              [-17.212602930531425, -11.682933794954204],
              [-17.206424218470154, -11.677791235735288],
              [-17.20603140962717, -11.674832330878825],
              [-17.20055925818932, -11.672952398310231],
              [-17.197831698734987, -11.668467537628452],
              [-17.198591754772217, -11.664122208884546],
              [-17.18615495603479, -11.662307870505769],
              [-17.17586588819078, -11.653973663057497],
              [-17.17184350925903, -11.656345880935698],
              [-17.162395933493613, -11.658517903213626],
              [-17.15446173585095, -11.657780582434535],
              [-17.156673622935575, -11.664310988284145],
              [-17.15504734384678, -11.670823707721198],
              [-17.150412880263033, -11.670623054986848],
              [-17.145486020101696, -11.674637513504702],
              [-17.143037035360084, -11.684064595558736],
              [-17.140280119131358, -11.686440798105892],
              [-17.137791653239468, -11.694350197212605],
              [-17.141514521914697, -11.699691386611965],
              [-17.141647709710018, -11.71246790210942],
              [-17.136260646118707, -11.716096143286231],
              [-17.133134861767857, -11.707567433677086],
              [-17.130142721482482, -11.693859338166869],
              [-17.125468703044895, -11.697439532195153],
              [-17.120611602021683, -11.696267278269625],
              [-17.121587269664364, -11.690830000928338],
              [-17.128079809968433, -11.680867839077097],
              [-17.129686535490812, -11.673266236076557],
              [-17.127012039861103, -11.670897027354039],
              [-17.115323256575056, -11.674540937117676],
              [-17.1050499397509, -11.681713846403529],
              [-17.09472427409933, -11.684396911219594],
              [-17.089573150267043, -11.678640920487195],
              [-17.097942170649244, -11.676857162960403],
              [-17.100817473110908, -11.6678821118384],
              [-17.11262349066165, -11.665689273953785],
              [-17.115404135419002, -11.660802158800099],
              [-17.123583661400612, -11.658611531377653],
              [-17.130692381854278, -11.651977688187385],
              [-17.138876412857012, -11.641791975333017],
              [-17.135613575582703, -11.630448322018418],
              [-17.128468500944475, -11.627057120687972],
              [-17.125339354564762, -11.627769459248341],
              [-17.117669813644955, -11.634339893060197],
              [-17.113349340033338, -11.635082977295724],
              [-17.10850953907114, -11.639376769459929],
              [-17.103655030724056, -11.640415492784507],
              [-17.09784162414536, -11.648165861154743],
              [-17.09206260028304, -11.649982509943682],
              [-17.08728153749136, -11.656512234486456],
              [-17.087654557454204, -11.659189756133925],
              [-17.082433446699856, -11.666358531846337],
              [-17.07765459856989, -11.666259045298176],
              [-17.083320761789086, -11.653906062758312],
              [-17.07066747818845, -11.658086508877199],
              [-17.067620668823857, -11.6629764802992],
              [-17.055861505826986, -11.669227301282644],
              [-17.056764222400528, -11.661500780738445],
              [-17.060317545699192, -11.659765901105922],
              [-17.06432989407947, -11.653301181730901],
              [-17.07571240324332, -11.64206648825924],
              [-17.0773962551522, -11.637660469766717],
              [-17.081678671094583, -11.636712329740815],
              [-17.08979376029073, -11.631554674009346],
              [-17.09510851705172, -11.624371281079583],
              [-17.096566367862746, -11.619663593339581],
              [-17.092206799583696, -11.616325762665882],
              [-17.086699854379415, -11.617435633171214],
              [-17.077443022944905, -11.626689534258151],
              [-17.06871690522643, -11.627884183615642],
              [-17.062171099204903, -11.633654772265226],
              [-17.056412078907222, -11.629979024862239],
              [-17.050877923818707, -11.629253068472725],
              [-17.040639349906538, -11.634050450616126],
              [-17.03283517367007, -11.634800824270846],
              [-17.027798350000943, -11.633204401315366],
              [-17.022130968271473, -11.637755911132473],
              [-17.01241378192102, -11.639373804748375],
              [-17.0039156875951, -11.644766638324441],
              [-17.00257523224864, -11.649796320820574],
              [-17.01417419531469, -11.656852677430713],
              [-17.01426364324991, -11.662330370865387],
              [-17.018852543790583, -11.668563215957352],
              [-17.02347511253591, -11.67782999224098],
              [-17.019596854743067, -11.68527384762965],
              [-17.023623430148177, -11.692532604876119],
              [-17.021139032375785, -11.701153906094167],
              [-17.01559743695725, -11.705553779062718],
              [-17.013679848708893, -11.710818088133907],
              [-17.009682037258234, -11.70814843809332],
              [-17.011044463800694, -11.704342337194358],
              [-17.012049047334614, -11.690063797283756],
              [-17.011071602248506, -11.675331418830094],
              [-17.008243061861, -11.670263755470954],
              [-16.999941677892355, -11.66420144270929],
              [-16.99506873378299, -11.669194670005567],
              [-16.992238686271055, -11.677183075315247],
              [-16.98898858752032, -11.676626431118313],
              [-16.98710541786849, -11.66458468011584],
              [-16.984303926637676, -11.659626124238837],
              [-16.976965722004845, -11.656006736827699],
              [-16.9722664669143, -11.651208339140643],
              [-16.97218718631798, -11.642969182020012],
              [-16.963449971079456, -11.64078283937674],
              [-16.96323080209031, -11.645706198715452],
              [-16.956834072183646, -11.64929339062727],
              [-16.950229636064417, -11.645360961994678],
              [-16.940942379849005, -11.650542378941978],
              [-16.938753999020474, -11.65887481345083],
              [-16.933077590179185, -11.659658626071487],
              [-16.928712626833562, -11.663797161231617],
              [-16.931507370016984, -11.66868745468735],
              [-16.936053715899515, -11.671377103391091],
              [-16.931220345124782, -11.677077601291451],
              [-16.92763577265337, -11.673897429795556],
              [-16.918228966106902, -11.670660470216475],
              [-16.91792235435129, -11.67585386269462],
              [-16.92103877767839, -11.682437119309899],
              [-16.93627501390595, -11.689481905036104],
              [-16.943086557908597, -11.698351851147695],
              [-16.942462741583277, -11.701893717382037],
              [-16.949806809582505, -11.710771751144657],
              [-16.948294266821225, -11.715295249052984],
              [-16.942073124679204, -11.709475300346083],
              [-16.939517568093017, -11.716384206877537],
              [-16.941277653869665, -11.72135948522312],
              [-16.94031496009451, -11.726258886595808],
              [-16.946763419185224, -11.731034574553998],
              [-16.942824915369926, -11.735532255657196],
              [-16.939155299625646, -11.731078365313214],
              [-16.926008788622877, -11.72055127879362],
              [-16.921225720079914, -11.723800556732087],
              [-16.929814596562004, -11.73366146605457],
              [-16.935504271408455, -11.74643238971252],
              [-16.93716705464279, -11.753166494984974],
              [-16.931122068376023, -11.753027743400375],
              [-16.927736180032994, -11.747827643355707],
              [-16.919511999589734, -11.740763112244265],
              [-16.919617625091735, -11.73656736098388],
              [-16.91599712045731, -11.732238756228455],
              [-16.910338766657773, -11.738132973028863],
              [-16.91027787373111, -11.74390543659029],
              [-16.901670688603286, -11.740013723467321],
              [-16.89763143949682, -11.744809868977718],
              [-16.884024853882988, -11.741825655192914],
              [-16.880387933625652, -11.752537786268384],
              [-16.88970344838442, -11.763124417444564],
              [-16.899089010050243, -11.77502944372737],
              [-16.905536880611493, -11.77892133958425],
              [-16.91090113498554, -11.795602562023394],
              [-16.911052782627113, -11.805315653535747],
              [-16.908700041193406, -11.808202382841554],
              [-16.913213599076265, -11.811655094371798],
              [-16.926287228444625, -11.807000950677157],
              [-16.935405476017774, -11.804882155429961],
              [-16.934767837012867, -11.799771170658909],
              [-16.941356689304335, -11.796713359374687],
              [-16.94661955596452, -11.808604513222553],
              [-16.95133688537797, -11.803433306039997],
              [-16.960391579617706, -11.801823452603108],
              [-16.96706772048691, -11.794362643560177],
              [-16.972291256457034, -11.798507342467591],
              [-16.97859426912564, -11.798016362916794],
              [-16.9887073414797, -11.78512782247154],
              [-16.99561007744159, -11.785517535163235],
              [-17.000497011559485, -11.78885170938961],
              [-17.008780505263204, -11.784432269078067],
              [-17.015887767503482, -11.783279329547353],
              [-17.021362495403935, -11.794382495470222],
              [-17.018662816172267, -11.798378154775513],
              [-17.015113502181, -11.797178428716256],
              [-17.00320934043229, -11.796625229065741],
              [-16.992593568127877, -11.801090576360643],
              [-16.98669554536558, -11.808231152920744],
              [-16.98552311680045, -11.81335198879277],
              [-16.974338066597866, -11.81836952089737],
              [-16.967137190634556, -11.818533967817412],
              [-16.966276812596192, -11.823267580396646],
              [-16.962012297810336, -11.826084485708346],
              [-16.962578667648597, -11.835120966564327],
              [-16.967553615848125, -11.839098347869808],
              [-16.967632237002835, -11.848133233648047],
              [-16.979365106544144, -11.861947177074738],
              [-16.9820727601218, -11.85436786556225],
              [-16.988682558127127, -11.851052798368562],
              [-17.00080573843093, -11.867018837696861],
              [-17.00691353858716, -11.864255855618133],
              [-17.006109669539352, -11.856522158364552],
              [-17.01056281415415, -11.85436015644496],
              [-17.014901828851894, -11.858919204354162],
              [-17.017853925589126, -11.848440994590748],
              [-17.013763014694025, -11.837800139964589],
              [-17.02668576000369, -11.845749133109571],
              [-17.032013295173954, -11.845963011018426],
              [-17.03413810693238, -11.841853610505359],
              [-17.04693134819598, -11.845915379527009],
              [-17.055650607061605, -11.850308783197185],
              [-17.0640450410003, -11.84918343275991],
              [-17.070657934100748, -11.855249908402731],
              [-17.058837665966653, -11.857482845658339],
              [-17.054922165811686, -11.86155260174282],
              [-17.038986177075017, -11.85700318809665],
              [-17.03499329162056, -11.861754026436556],
              [-17.031796887313728, -11.861778918826442],
              [-17.025982844221037, -11.869318587743122],
              [-17.027041687037446, -11.873631949749536],
              [-17.03245777020278, -11.877556398556418],
              [-17.040729681416206, -11.880019297450751],
              [-17.049759711714614, -11.886243206647396],
              [-17.065942058706238, -11.886012522825512],
              [-17.068442113122625, -11.883789904212238],
              [-17.07451091891221, -11.88355332216266],
              [-17.076994157234978, -11.886277579179106],
              [-17.075724512794064, -11.890903813517168],
              [-17.068070257620267, -11.891784665417054],
              [-17.066364093904443, -11.895079937548584],
              [-17.06686272654514, -11.905260100237237],
              [-17.05782574690011, -11.897890073477416],
              [-17.047850080864606, -11.893997244687249],
              [-17.04966137523378, -11.899417666308784],
              [-17.03969293506267, -11.90109130096258],
              [-17.037554723978822, -11.89672527717389],
              [-17.030356983166616, -11.89392035460395],
              [-17.026168164365533, -11.894298299298715],
              [-17.024660204382386, -11.898520635788655],
              [-17.020602486309993, -11.901730347161582],
              [-17.012951078523997, -11.901783313337102],
              [-17.010924592520933, -11.907015726638619],
              [-17.019200066431882, -11.915608005609323],
              [-17.02700402250245, -11.917812470761172],
              [-17.039726767491107, -11.916761970991184],
              [-17.04655008567481, -11.921598728746938],
              [-17.052938724808822, -11.922439043440445],
              [-17.05297736616377, -11.926117755765437],
              [-17.058584257656964, -11.92827487795187],
              [-17.06503185562732, -11.92489971767484],
              [-17.07440873823004, -11.932282589168315],
              [-17.076676211574597, -11.938783893458984],
              [-17.074043534763856, -11.939995088336548],
              [-17.072617228571488, -11.94583546612875],
              [-17.079783942029938, -11.958484148938078],
              [-17.084979757715896, -11.95871944974681],
              [-17.093253780882083, -11.96280517567691],
              [-17.100648468915047, -11.955948745523903],
              [-17.096227692145405, -11.950843101130145],
              [-17.096376577731526, -11.945251631006904],
              [-17.103318371539586, -11.941902779442465],
              [-17.09804502883524, -11.936706107639676],
              [-17.100520558561183, -11.932872325832525],
              [-17.110845731048585, -11.938245434143248],
              [-17.111578382014958, -11.932220951859748],
              [-17.102938579994493, -11.925581569456208],
              [-17.106934226659426, -11.917954872926499],
              [-17.098999775100307, -11.90964370510551],
              [-17.092890354190928, -11.899980353773016],
              [-17.09030007169939, -11.898228221878625],
              [-17.090515758033, -11.886780405953381],
              [-17.096559464828168, -11.893295786078376],
              [-17.100500303901672, -11.894882068406481],
              [-17.105520328385047, -11.89196802298711],
              [-17.10522223424738, -11.89948222954545],
              [-17.111361516487865, -11.90692671948296],
              [-17.116406077849856, -11.91675402159959],
              [-17.1207345867777, -11.921617982695603],
              [-17.123990496598527, -11.920270638472557],
              [-17.127297863515015, -11.912369438382594],
              [-17.13154217743892, -11.910896149075285],
              [-17.13325932380033, -11.9160885935644],
              [-17.128785140256447, -11.923718805667212],
              [-17.12734074241212, -11.929646444988679],
              [-17.129892967171553, -11.937823925110067],
              [-17.134251272627925, -11.934263239332752],
              [-17.14489128091557, -11.928349394976477],
              [-17.150513371962166, -11.930688473873253],
              [-17.1623739731939, -11.930751899391746],
              [-17.162216460978975, -11.935095732079152],
              [-17.168551135237138, -11.940846646416285],
              [-17.160736118149945, -11.942096219802524],
              [-17.156142972547542, -11.94012053915707],
              [-17.147741158096416, -11.941226258122338],
              [-17.14481496189755, -11.94697662124245],
              [-17.150873971851954, -11.953183312536122],
              [-17.137812945937203, -11.960073796474926],
              [-17.140363300858706, -11.970489711097226],
              [-17.1482500453991, -11.975474954461646],
              [-17.150332590641725, -11.982871393240622],
              [-17.16142251446952, -11.984043318513137],
              [-17.168593917151583, -11.980739542674854],
              [-17.16610873658435, -11.989094967722842],
              [-17.168940658605635, -11.994093913208614],
              [-17.174090227412613, -11.99848011459382],
              [-17.18047376557696, -12.001310201781074],
              [-17.18213590508094, -12.005905838520222],
              [-17.17139686956986, -12.002612585518147],
              [-17.163954401852926, -12.003247794269418],
              [-17.168637547747714, -12.010846125583454],
              [-17.174804016282682, -12.012476778203741],
              [-17.18422826538876, -12.018040344497367],
              [-17.18683416348191, -12.012473458445175],
              [-17.193317476919816, -12.015791219213218],
              [-17.19466346549554, -12.02235200792816],
              [-17.205005433008356, -12.032549376943965],
              [-17.206494627574823, -12.039965920580578],
              [-17.211860993124347, -12.042206474909316],
              [-17.220413400309436, -12.048290808884794],
              [-17.22828970589764, -12.048291393042426],
              [-17.23201931055904, -12.04145199150753],
              [-17.23565942171323, -12.041449605017737],
              [-17.241443769501963, -12.045778692542651],
              [-17.25009798206057, -12.048580918496175],
              [-17.252550800612035, -12.046028042677186],
              [-17.24956907923592, -12.034239472170169],
              [-17.24496810454848, -12.029291086196809],
              [-17.24491545038171, -12.024649059619588],
              [-17.237496337455504, -12.012212654970337],
              [-17.226646531697703, -12.008384294523703],
              [-17.221522255787058, -11.995819347443755],
              [-17.21440992833721, -11.989715402625423],
              [-17.20947168447711, -11.989042619657846],
              [-17.206667085043307, -11.985967722868402],
              [-17.201096245439263, -11.985424268997258],
              [-17.195720000398893, -11.979495648709348],
              [-17.195104164788642, -11.972156303602539],
              [-17.19882232865273, -11.968563832755025],
              [-17.209082245339395, -11.975071672289765],
              [-17.220216264843234, -11.97450267625686],
              [-17.21786951053773, -11.963611397632626],
              [-17.21900094802447, -11.961657351159387],
              [-17.211736337455477, -11.948596572502721],
              [-17.208990492043412, -11.941804214712457],
              [-17.210708541488124, -11.939455291780082],
              [-17.20084399035117, -11.929995884115655],
              [-17.196652097440364, -11.929189217902989],
              [-17.187251884873604, -11.921366368832226],
              [-17.183444272372622, -11.914711445435143],
              [-17.184237158769413, -11.906525519637176],
              [-17.1882446283003, -11.906006642995406],
              [-17.19124467046102, -11.911546877535358],
              [-17.191276786156713, -11.916240116111023],
              [-17.195189217238298, -11.918862765309342],
              [-17.202756033765255, -11.920074158595684],
              [-17.207026194361642, -11.927125373644543],
              [-17.220095780443014, -11.938397866310698],
              [-17.22086193738371, -11.941325742217401],
              [-17.228628554584287, -11.954019116867709],
              [-17.23324058983004, -11.959168506351594],
              [-17.234735669652512, -11.963787866217878],
              [-17.239717936603892, -11.97084979600955],
              [-17.24759121394072, -11.97132794673416],
              [-17.24950170196516, -11.976482217849497],
              [-17.25645637937434, -11.988079892437339],
              [-17.26543843804901, -11.99157198180995],
              [-17.269408355382968, -11.999130091065119],
              [-17.268652624543567, -12.003498668778013],
              [-17.277483132798675, -12.010597819105305],
              [-17.28284296484647, -12.011422161545388],
              [-17.28256009187521, -11.999301311890333],
              [-17.28388276676437, -11.991323608242872],
              [-17.287794033631304, -11.985073755575243],
              [-17.29461012364814, -11.980811776395807],
              [-17.301801396061496, -11.972098784539911],
              [-17.313885900589177, -11.966153997954804],
              [-17.325159906761908, -11.96202787608368],
              [-17.32326180853396, -11.950761915769515],
              [-17.32285710105241, -11.933861277103214],
              [-17.3244856148751, -11.90642965852709],
              [-17.32558195296962, -11.897352477284212],
              [-17.32879596859929, -11.88910409167831],
              [-17.33234644691989, -11.883905013333097],
              [-17.33363998641354, -11.87775439557748],
              [-17.336955537785872, -11.871986316802065],
              [-17.342518185801158, -11.866949477011802],
              [-17.35237459436511, -11.865532101128984],
              [-17.35583319083459, -11.861703204109887],
              [-17.3624559433215, -11.86436911090837],
              [-17.372845556049857, -11.862885896237787],
              [-17.366883332272685, -11.859292225417029],
              [-17.367907015776797, -11.854783254668929],
              [-17.36522241940366, -11.851286014921085],
              [-17.366695472303316, -11.84690696446969],
              [-17.37182527064377, -11.845086729041208],
              [-17.375349267831997, -11.84024457372279]
            ]
          ],
          [
            [
              [-17.569488286126113, -12.359611403879704],
              [-17.554849197198312, -12.351526984861682],
              [-17.549652988187614, -12.345397149124695],
              [-17.545484139606074, -12.333584749638554],
              [-17.538061173924056, -12.329245099577621],
              [-17.531499497917597, -12.33144997097327],
              [-17.53099518418183, -12.335659000706052],
              [-17.536335779509663, -12.350144293399113],
              [-17.532602579523722, -12.363665618268172],
              [-17.532366288154893, -12.371307735490518],
              [-17.537317795260737, -12.380756094243836],
              [-17.542647553238837, -12.382553293126191],
              [-17.548681898842737, -12.377008049267843],
              [-17.55383730909223, -12.37564662780753],
              [-17.55845334523014, -12.376950904657274],
              [-17.564692093702334, -12.375924504724775],
              [-17.56626933164993, -12.370211419738094],
              [-17.564010355653142, -12.366106804760921],
              [-17.569488286126113, -12.359611403879704]
            ]
          ],
          [
            [
              [-17.762334212174473, -12.27979560369012],
              [-17.757288872036497, -12.28022651319245],
              [-17.754789908732683, -12.272683541422921],
              [-17.759021148441718, -12.2673295511099],
              [-17.757619220785447, -12.26379463476685],
              [-17.751481493877783, -12.269040819497121],
              [-17.747112368070493, -12.263258218147548],
              [-17.740305162431714, -12.26925236190264],
              [-17.739412193325098, -12.276973031877391],
              [-17.748246650095176, -12.279493938205622],
              [-17.749157160849855, -12.28578421085787],
              [-17.747231927024927, -12.294329364849522],
              [-17.74949043650462, -12.294969250553986],
              [-17.754043162404795, -12.289278104684948],
              [-17.753628239664387, -12.286016794353909],
              [-17.760151476704838, -12.284207454600097],
              [-17.762334212174473, -12.27979560369012]
            ]
          ],
          [
            [
              [-17.771206569763947, -12.234676743743165],
              [-17.770858196119626, -12.224486877399793],
              [-17.765937449960894, -12.220836237428331],
              [-17.76018246753613, -12.226873177878339],
              [-17.76316186843324, -12.232738506241931],
              [-17.7633936631568, -12.240351449790726],
              [-17.77114384276307, -12.238581467470537],
              [-17.771206569763947, -12.234676743743165]
            ]
          ],
          [
            [
              [-17.866383957563393, -12.103204919452097],
              [-17.854333168367265, -12.089672715572501],
              [-17.849017360697232, -12.088669690260518],
              [-17.842085145674204, -12.09106625289733],
              [-17.834476994585987, -12.089041975575618],
              [-17.82764242935234, -12.090662123615218],
              [-17.817176831538923, -12.091050882838296],
              [-17.8020120982501, -12.101707136992424],
              [-17.80617299753704, -12.102512253284548],
              [-17.825769802780304, -12.100277212575845],
              [-17.830097153746852, -12.103540384719349],
              [-17.83211821088084, -12.108349877818725],
              [-17.83845442171514, -12.10665939765706],
              [-17.84082546093768, -12.108257560094803],
              [-17.849690724823578, -12.105812756485328],
              [-17.854473977275315, -12.107022947892993],
              [-17.861698875575843, -12.105728237101193],
              [-17.866383957563393, -12.103204919452097]
            ]
          ],
          [
            [
              [-17.980883185847162, -12.162993532770805],
              [-17.97394663383794, -12.158779514436503],
              [-17.966226789343377, -12.156822080606105],
              [-17.962026789343447, -12.160629112344825],
              [-17.964773835398084, -12.164226879992981],
              [-17.96120013663668, -12.172477604698281],
              [-17.96687610078552, -12.176411613018736],
              [-17.9713422862848, -12.17312745536783],
              [-17.973651689122352, -12.167748507627692],
              [-17.978869897180925, -12.166319862484542],
              [-17.980883185847162, -12.162993532770805]
            ]
          ],
          [
            [
              [-18.1865769520854, -12.328192958115036],
              [-18.181517254552613, -12.317564714141147],
              [-18.183288587346212, -12.315010920660889],
              [-18.179508447596387, -12.310751201932401],
              [-18.174647615432423, -12.311373751457309],
              [-18.165469345965708, -12.306718621878002],
              [-18.155725062960354, -12.31335201609878],
              [-18.155940551708532, -12.322033925262625],
              [-18.150612832697686, -12.322725937991091],
              [-18.147450646843243, -12.326196434559586],
              [-18.150145963170193, -12.33109385494837],
              [-18.153907498780143, -12.330053161476458],
              [-18.153095759030993, -12.325346082951313],
              [-18.15951284551712, -12.326729455649764],
              [-18.161661146696286, -12.322868789826115],
              [-18.167217349051228, -12.321469438607807],
              [-18.165188246259525, -12.31680573816277],
              [-18.175468220445357, -12.318593271673572],
              [-18.179106023128725, -12.322820903079066],
              [-18.179876726819156, -12.328720981754204],
              [-18.1865769520854, -12.328192958115036]
            ]
          ],
          [
            [
              [-18.242124164109597, -12.318491663002408],
              [-18.2354182421875, -12.311368658305737],
              [-18.23397688142218, -12.307357159811263],
              [-18.224528228941516, -12.315582481478101],
              [-18.224678283506766, -12.322876137385403],
              [-18.229076789920992, -12.325523976058243],
              [-18.23387178339017, -12.324290901583058],
              [-18.23797305641195, -12.319946430958327],
              [-18.242124164109597, -12.318491663002408]
            ]
          ],
          [
            [
              [-18.299529047393516, -12.637094269379508],
              [-18.291842055703775, -12.634654103315073],
              [-18.289933378425193, -12.630684609417964],
              [-18.29287645058916, -12.626805041923747],
              [-18.28575612240287, -12.6212330317867],
              [-18.283041711580886, -12.624390129117947],
              [-18.28353443249394, -12.629263858324386],
              [-18.278420490371857, -12.631250325331163],
              [-18.271538856487123, -12.62976778379952],
              [-18.270492336913826, -12.635837289331361],
              [-18.273668615714264, -12.64191309414046],
              [-18.27826940601233, -12.646569991102348],
              [-18.286908221031897, -12.650632922426105],
              [-18.29389042302445, -12.648496083700936],
              [-18.296043299552178, -12.640224412603052],
              [-18.299529047393516, -12.637094269379508]
            ]
          ],
          [
            [
              [-18.278789268129902, -12.332640077352938],
              [-18.276369068125298, -12.328247819004547],
              [-18.26815785794614, -12.325820611465156],
              [-18.26429864654191, -12.331901144141359],
              [-18.26522666483216, -12.337518340049566],
              [-18.261313514453384, -12.340415973688899],
              [-18.26370639914267, -12.34505174284808],
              [-18.26951273827512, -12.34861448654437],
              [-18.268720993800628, -12.342110325954254],
              [-18.27393282382092, -12.33364651078063],
              [-18.278789268129902, -12.332640077352938]
            ]
          ],
          [
            [
              [-18.287612702698897, -12.357431167785316],
              [-18.284641963538277, -12.354748976576431],
              [-18.28051663582348, -12.339552153727702],
              [-18.27356893496348, -12.340605155054568],
              [-18.273646379144964, -12.344759018747535],
              [-18.28454018953892, -12.356066867765655],
              [-18.287612702698897, -12.357431167785316]
            ]
          ],
          [
            [
              [-18.32377863154313, -12.59415204831658],
              [-18.31833769610835, -12.589780722147932],
              [-18.314472679163263, -12.581363053089172],
              [-18.30893388699028, -12.583718638442601],
              [-18.301180248543947, -12.581301818889232],
              [-18.296091469580887, -12.583336399857595],
              [-18.294707872908326, -12.588578212697005],
              [-18.298357883725288, -12.589924474750594],
              [-18.30342693563568, -12.587049825561582],
              [-18.306623623498762, -12.593844974765002],
              [-18.302804850315926, -12.594521457912455],
              [-18.29698513380334, -12.602827198038128],
              [-18.294511773783572, -12.611151913134846],
              [-18.30207424323315, -12.612239211272113],
              [-18.30672934421658, -12.618089203831449],
              [-18.3124169729866, -12.619040077236996],
              [-18.31523018369638, -12.621715787349713],
              [-18.319519909824262, -12.611176775469227],
              [-18.315753878168334, -12.607411911389924],
              [-18.308565629657817, -12.610228956718446],
              [-18.30827626509748, -12.60389614852271],
              [-18.31246213259273, -12.600712656465642],
              [-18.31099139895536, -12.588875363739744],
              [-18.31480943084198, -12.590483981252385],
              [-18.319618675003028, -12.59588835736634],
              [-18.32377863154313, -12.59415204831658]
            ]
          ],
          [
            [
              [-18.354718456449092, -12.662034347403747],
              [-18.352441798965856, -12.659078527068145],
              [-18.346785697897854, -12.659871625937372],
              [-18.342217987323952, -12.667753210126344],
              [-18.33674418338541, -12.672986374910492],
              [-18.339397698056445, -12.68263300461364],
              [-18.349694331548278, -12.683013637779283],
              [-18.354272863753582, -12.679677476738757],
              [-18.350952810857596, -12.67638072496403],
              [-18.352124790781346, -12.668208546662036],
              [-18.354718456449092, -12.662034347403747]
            ]
          ],
          [
            [
              [-18.35590832432105, -12.556012384648753],
              [-18.353677318603324, -12.55233025080602],
              [-18.347424016495353, -12.55559825914748],
              [-18.34329245109321, -12.561905063868371],
              [-18.337328867611316, -12.565844921886127],
              [-18.335963464126564, -12.562180727855985],
              [-18.342108764708833, -12.555943629051423],
              [-18.33981669800875, -12.549842942516179],
              [-18.332882205678363, -12.55185509666356],
              [-18.33342872420145, -12.54710620004025],
              [-18.33744421796338, -12.54444926866871],
              [-18.336320315438275, -12.539700008791009],
              [-18.339332745930257, -12.527122604193208],
              [-18.336368089624074, -12.52532014929749],
              [-18.331657963439287, -12.529240594915558],
              [-18.32523043038891, -12.517537005853383],
              [-18.322422844180178, -12.52032151967328],
              [-18.32526580488447, -12.530226559710972],
              [-18.330871653286593, -12.534514850228188],
              [-18.330274170253816, -12.540334058009494],
              [-18.323714982179165, -12.540541658265202],
              [-18.322154300259545, -12.547417935931533],
              [-18.328326286319705, -12.548221158170788],
              [-18.323103009345388, -12.554094076189259],
              [-18.32776567566449, -12.55842142730556],
              [-18.331116047922638, -12.564114589646355],
              [-18.332291194575582, -12.571712615435176],
              [-18.32408603198952, -12.582549094314142],
              [-18.32941178005385, -12.586132056169172],
              [-18.333661680184218, -12.581585262994572],
              [-18.33595683733792, -12.572672626497367],
              [-18.34132580642778, -12.571766294192127],
              [-18.34085737554473, -12.584077241263692],
              [-18.345816177205208, -12.583902937317],
              [-18.348867701785487, -12.58103695680071],
              [-18.356898882941696, -12.582098052245884],
              [-18.3568268577743, -12.575802871260892],
              [-18.35274164931154, -12.569517448952475],
              [-18.346713787606365, -12.570529466007047],
              [-18.345005227877355, -12.56679943380039],
              [-18.350908567111155, -12.563280469549523],
              [-18.351750143552366, -12.558688414031554],
              [-18.35590832432105, -12.556012384648753]
            ]
          ],
          [
            [
              [-18.376423225847525, -12.564451651784506],
              [-18.369870816089183, -12.553582772270188],
              [-18.366086264308567, -12.557211096566128],
              [-18.367941677207522, -12.564701823382196],
              [-18.37104737414359, -12.566865615273585],
              [-18.376423225847525, -12.564451651784506]
            ]
          ],
          [
            [
              [-18.398277276247413, -12.657758507486841],
              [-18.390954144479156, -12.655521872358989],
              [-18.388120376984713, -12.656654850116812],
              [-18.380834876543293, -12.650469731185526],
              [-18.371903448193937, -12.653895420767153],
              [-18.382600785007604, -12.658436904816142],
              [-18.38850786872588, -12.666385599490482],
              [-18.394412984137304, -12.665647724477218],
              [-18.398277276247413, -12.657758507486841]
            ]
          ],
          [
            [
              [-18.39152353170832, -12.570301687532899],
              [-18.386267592067274, -12.563939771756832],
              [-18.379208958638316, -12.56729413987336],
              [-18.379003168997023, -12.57249101251338],
              [-18.386924842374352, -12.574989820678462],
              [-18.39152353170832, -12.570301687532899]
            ]
          ],
          [
            [
              [-18.3983557358558, -12.579750832934751],
              [-18.392394476949942, -12.582085336600983],
              [-18.389995522274106, -12.589999456571247],
              [-18.394011201121113, -12.591524238185203],
              [-18.3983557358558, -12.579750832934751]
            ]
          ],
          [
            [
              [-18.312968092029983, -11.357806764357766],
              [-18.30805365955713, -11.359054970393194],
              [-18.306797425904215, -11.362846744389243],
              [-18.31052055870942, -11.365600308320884],
              [-18.312968092029983, -11.357806764357766]
            ]
          ],
          [
            [
              [-18.43999174125859, -12.476761967963668],
              [-18.434594915503926, -12.473979480616336],
              [-18.429691646768696, -12.474418614826641],
              [-18.423318529379877, -12.4815216243526],
              [-18.426128662773632, -12.487152419405621],
              [-18.438937630725373, -12.483718227960983],
              [-18.43999174125859, -12.476761967963668]
            ]
          ],
          [
            [
              [-18.48274067855279, -12.620410918464586],
              [-18.47984649588424, -12.611844212243419],
              [-18.475777069112286, -12.60872855841926],
              [-18.469094969211042, -12.612126917221465],
              [-18.46458629926679, -12.606894467063068],
              [-18.46720039005171, -12.600617265172604],
              [-18.461335952533975, -12.597968616946845],
              [-18.45479669491873, -12.585908521704077],
              [-18.448379588175467, -12.58263065979856],
              [-18.443010425350614, -12.576967616537674],
              [-18.445870840100792, -12.572786608886704],
              [-18.45367214695827, -12.574816433268916],
              [-18.460732608567263, -12.571560019085037],
              [-18.460642112702914, -12.566103377520255],
              [-18.448616243249845, -12.56336390159925],
              [-18.45044491031006, -12.559954790222987],
              [-18.46228451307751, -12.554026998009853],
              [-18.460116690014075, -12.54759962852112],
              [-18.45547414618197, -12.548255064244003],
              [-18.44718415166551, -12.55504569415767],
              [-18.44186712369864, -12.556433198756348],
              [-18.447129765520035, -12.545885267323328],
              [-18.44883124217343, -12.539904106763828],
              [-18.444401946205744, -12.535712792806777],
              [-18.43866187311204, -12.54088834007143],
              [-18.434869215347767, -12.549572697786747],
              [-18.425425154546765, -12.555612063647247],
              [-18.423070379214828, -12.552112198046753],
              [-18.42371163436851, -12.546670358066562],
              [-18.42739655802714, -12.542918069641306],
              [-18.42689964131463, -12.538604804161075],
              [-18.429933891029002, -12.535330071854498],
              [-18.432309225561273, -12.52834146212129],
              [-18.427218596313423, -12.522323337896351],
              [-18.42304176825508, -12.525067783461195],
              [-18.416820181342047, -12.53278719956333],
              [-18.413156202065156, -12.533132464971995],
              [-18.414594612977265, -12.520553417076169],
              [-18.409978124456018, -12.522936384475097],
              [-18.405675740118152, -12.52121831332553],
              [-18.408047249839846, -12.510987324306601],
              [-18.40050354289618, -12.503696038790917],
              [-18.397264812955548, -12.49607926644335],
              [-18.39442083243994, -12.495907875041517],
              [-18.38988004481469, -12.503779841635776],
              [-18.388857274697582, -12.511676343213537],
              [-18.391677842354827, -12.516548174864516],
              [-18.40108244735231, -12.516035959888228],
              [-18.40261851748793, -12.51799544387621],
              [-18.40069057620001, -12.526887961447473],
              [-18.404777245658906, -12.545021863708875],
              [-18.39566202825542, -12.543435750230246],
              [-18.395004873474424, -12.535131806413716],
              [-18.388506591984, -12.534713458741496],
              [-18.385857497883435, -12.541041415091573],
              [-18.389635497989996, -12.551737373513674],
              [-18.396259569224835, -12.550817106307948],
              [-18.394164018522417, -12.557735046048943],
              [-18.39863969706293, -12.562316155781703],
              [-18.404873134822058, -12.557577923731964],
              [-18.411095879640378, -12.549388095760095],
              [-18.413977030086667, -12.550604141511737],
              [-18.41484860744867, -12.559038975317698],
              [-18.413091839952415, -12.568525641646108],
              [-18.41477508938145, -12.570712179422415],
              [-18.421011362558353, -12.569884655174729],
              [-18.426348973254434, -12.56658935574338],
              [-18.427964975288734, -12.570601297940499],
              [-18.424523256972634, -12.576042439079485],
              [-18.432410976701778, -12.583403371437377],
              [-18.435160324352278, -12.581313172691099],
              [-18.43827877911265, -12.589565880042041],
              [-18.444627547435978, -12.59339403827485],
              [-18.45004328415725, -12.594661515941121],
              [-18.4539737221508, -12.601489717518227],
              [-18.453948522417093, -12.607553863254521],
              [-18.460480452380335, -12.608625354709108],
              [-18.467470152432455, -12.612204802787488],
              [-18.46734046311763, -12.621892530931447],
              [-18.47286496489027, -12.626638736935924],
              [-18.47157755598403, -12.631258227406075],
              [-18.47860998977, -12.63063791354762],
              [-18.478809817933097, -12.625484320552784],
              [-18.48274067855279, -12.620410918464586]
            ]
          ],
          [
            [
              [-18.36892949646308, -11.326237518419358],
              [-18.365793601118188, -11.321575350160472],
              [-18.36037299554697, -11.32054297349657],
              [-18.36185317704076, -11.329589331873093],
              [-18.356693628531417, -11.334897290294984],
              [-18.36118423011377, -11.337003563239481],
              [-18.36891527007684, -11.328759869143548],
              [-18.36892949646308, -11.326237518419358]
            ]
          ],
          [
            [
              [-18.483224877585887, -12.441151252903445],
              [-18.478001222457234, -12.435114842564921],
              [-18.46499469992799, -12.429780609280042],
              [-18.460531246137563, -12.43237326721529],
              [-18.454226256679963, -12.439202384893326],
              [-18.449226415814373, -12.439427237979636],
              [-18.444648345970492, -12.437111282761263],
              [-18.445914689565797, -12.447927093353565],
              [-18.443647490575092, -12.4529982353749],
              [-18.444026669447407, -12.457979643540037],
              [-18.446753579735432, -12.461041405672175],
              [-18.4560994896781, -12.455306221985799],
              [-18.461075000725696, -12.447839544076034],
              [-18.46793466438506, -12.447082316948752],
              [-18.471522987117776, -12.452901299532893],
              [-18.4792813177319, -12.452499735359188],
              [-18.483758684542682, -12.443454136423515],
              [-18.483224877585887, -12.441151252903445]
            ]
          ],
          [
            [
              [-18.391014151674657, -11.324578172740868],
              [-18.388262526027663, -11.320396631037134],
              [-18.386434211886936, -11.310663634243936],
              [-18.382275553125872, -11.30444429036515],
              [-18.37973854383989, -11.311597690988787],
              [-18.380369028521514, -11.32020591190325],
              [-18.388373678190028, -11.32807806306618],
              [-18.391014151674657, -11.324578172740868]
            ]
          ],
          [
            [
              [-18.522774516760826, -12.473686109806826],
              [-18.516034514978, -12.469884237884969],
              [-18.51675937512816, -12.46433526057654],
              [-18.509514911945875, -12.462196396106453],
              [-18.50839666580672, -12.46573833347624],
              [-18.500886624301607, -12.469516185142895],
              [-18.489676636654412, -12.463749508628506],
              [-18.4827152206782, -12.463937405797948],
              [-18.481356338683394, -12.467034161449309],
              [-18.48716415234205, -12.471040442790121],
              [-18.481479708077213, -12.473150484420284],
              [-18.479642659046156, -12.483539796365077],
              [-18.485704021325684, -12.497850125193892],
              [-18.488045972144285, -12.499398690545974],
              [-18.495424974679718, -12.496008811684236],
              [-18.496289608055037, -12.487418427241906],
              [-18.504165729246257, -12.486720742602516],
              [-18.506282884427716, -12.482661682724993],
              [-18.512716937403212, -12.48516330982415],
              [-18.520941504339, -12.477543238098402],
              [-18.522774516760826, -12.473686109806826]
            ]
          ],
          [
            [
              [-18.589562078888928, -12.466656361031081],
              [-18.584039762662922, -12.465262365428284],
              [-18.58374303562778, -12.460436559200959],
              [-18.57456004292462, -12.447707901219768],
              [-18.565113184101556, -12.444777742530285],
              [-18.559571894203792, -12.440109868473217],
              [-18.555076742867765, -12.443199247934523],
              [-18.546685351577587, -12.444884954973503],
              [-18.544253719544482, -12.448464197384851],
              [-18.546248414472878, -12.462774447749357],
              [-18.555836476710198, -12.469542250622514],
              [-18.55395073411754, -12.47567743731378],
              [-18.550772992571417, -12.477152393610382],
              [-18.541639412467692, -12.470658027428334],
              [-18.535718240502046, -12.468076404282774],
              [-18.539229073051075, -12.46197556000913],
              [-18.527737703384293, -12.44893723809641],
              [-18.519258022699372, -12.454255837951756],
              [-18.519483043387144, -12.461195378762797],
              [-18.523301769051333, -12.465609828172246],
              [-18.530027604222273, -12.469139745346215],
              [-18.533407440823932, -12.477593813432444],
              [-18.53233135642034, -12.488066441172855],
              [-18.525120487356823, -12.494903040755027],
              [-18.5268297379051, -12.500974200488345],
              [-18.530798682102287, -12.499706636160393],
              [-18.533489650129276, -12.503682401412416],
              [-18.5223410694844, -12.505129759085454],
              [-18.519307179755632, -12.517156476977073],
              [-18.523613496389093, -12.52107720751344],
              [-18.52150524283124, -12.526686431227501],
              [-18.528491148249095, -12.537721851417624],
              [-18.530212712240523, -12.5287637141044],
              [-18.536335743991863, -12.528871544365213],
              [-18.54053347135335, -12.531635782310373],
              [-18.545542293531415, -12.530635169572113],
              [-18.548676462978676, -12.52440604691546],
              [-18.55231204249491, -12.524936110457112],
              [-18.557008170499945, -12.521397146470001],
              [-18.55796918448744, -12.513610873210382],
              [-18.562741746950522, -12.511321948555695],
              [-18.572434779009985, -12.51185066445867],
              [-18.57934233505411, -12.523097547926143],
              [-18.58219446649148, -12.532050703762426],
              [-18.587146658804162, -12.534587844899407],
              [-18.583580835836553, -12.523885391498295],
              [-18.585065192423095, -12.513056607361758],
              [-18.59022377198585, -12.502283428295216],
              [-18.586310544430756, -12.49459696286249],
              [-18.586025702709534, -12.489201962265835],
              [-18.589990754356972, -12.48391449964077],
              [-18.584534521193014, -12.474882495012375],
              [-18.58662104333747, -12.468976041890155],
              [-18.589562078888928, -12.466656361031081]
            ]
          ],
          [
            [
              [-18.582320029179485, -12.269288932026114],
              [-18.577853174359355, -12.266352359948847],
              [-18.56876762824444, -12.26649616265812],
              [-18.560885542235596, -12.258812252283148],
              [-18.557473879717755, -12.265069260003544],
              [-18.58140052041027, -12.269887752645072],
              [-18.582320029179485, -12.269288932026114]
            ]
          ],
          [
            [
              [-18.510600651333384, -11.346386495775123],
              [-18.50786418708391, -11.34174976329319],
              [-18.50832238629083, -11.33122328206465],
              [-18.502822953377105, -11.318568745153513],
              [-18.50147660843607, -11.310174873249096],
              [-18.494839010284586, -11.307275553500212],
              [-18.490573032863665, -11.303252063710689],
              [-18.475037480298273, -11.296567163710565],
              [-18.46639653135544, -11.297663244334744],
              [-18.460835201739325, -11.295773346157526],
              [-18.451090250529408, -11.28899099412637],
              [-18.446586416766618, -11.28950740072944],
              [-18.44145096521879, -11.281739072752126],
              [-18.436762478171854, -11.281648472992945],
              [-18.43486803603313, -11.285132853584082],
              [-18.448811940508033, -11.306113307755721],
              [-18.456157829116027, -11.321185005948896],
              [-18.46693533480493, -11.337403951109222],
              [-18.474908535121408, -11.354080207454064],
              [-18.481778388276254, -11.359304079193205],
              [-18.490405037280226, -11.362450547034362],
              [-18.493589420100626, -11.360457395336516],
              [-18.504096146109347, -11.35858162641399],
              [-18.510015855107014, -11.361816322194805],
              [-18.512148711102256, -11.359105843339192],
              [-18.509197429309868, -11.352783505806148],
              [-18.510600651333384, -11.346386495775123]
            ]
          ],
          [
            [
              [-18.70860932556327, -12.495373445765741],
              [-18.70453721201389, -12.490528920888655],
              [-18.69895292905667, -12.488521127117906],
              [-18.69446727196357, -12.491975739420933],
              [-18.68942681820364, -12.490052145130784],
              [-18.689060325918476, -12.496481071878438],
              [-18.686286199959873, -12.501894799645218],
              [-18.686639930947262, -12.507183428650713],
              [-18.690540600871515, -12.512022145758094],
              [-18.703281788680084, -12.503050686911937],
              [-18.70860932556327, -12.495373445765741]
            ]
          ],
          [
            [
              [-18.74700560029518, -12.53553518175267],
              [-18.73844570669267, -12.52630246585945],
              [-18.734064236304995, -12.53328634411636],
              [-18.735130735667312, -12.538572368729044],
              [-18.741905913846576, -12.540848186020634],
              [-18.74700560029518, -12.53553518175267]
            ]
          ],
          [
            [
              [-18.758265114379395, -12.487012247850426],
              [-18.755000487433538, -12.479451496790942],
              [-18.74910620969292, -12.47607076245891],
              [-18.73969968442051, -12.47842753067784],
              [-18.73496529051347, -12.475948868779918],
              [-18.72454159417326, -12.47366629110587],
              [-18.72337938262806, -12.476661899455728],
              [-18.727935465350985, -12.481073059935154],
              [-18.73209750069522, -12.491546610924003],
              [-18.736669031309248, -12.488375837790162],
              [-18.74569735002793, -12.493638316161277],
              [-18.758265114379395, -12.487012247850426]
            ]
          ],
          [
            [
              [-18.801934671318634, -12.504737563058216],
              [-18.798744116530884, -12.499143302173692],
              [-18.79349417346624, -12.498468834732883],
              [-18.7909644442408, -12.494977734386866],
              [-18.785307025064153, -12.493484042918453],
              [-18.7788584663825, -12.498291948793707],
              [-18.773342964358836, -12.499158755197993],
              [-18.765485082344522, -12.50963641413132],
              [-18.750266849550158, -12.517111672475705],
              [-18.750264995818664, -12.52377549504676],
              [-18.75878571127351, -12.52634436047686],
              [-18.7653718492548, -12.530135759014447],
              [-18.7677884025171, -12.535314246971742],
              [-18.77663012359714, -12.53765233496944],
              [-18.779754687937686, -12.531932580114894],
              [-18.782887193451145, -12.53007416965932],
              [-18.781634520447078, -12.521728264029699],
              [-18.775708616835676, -12.518030046809935],
              [-18.773214775461913, -12.512820773210569],
              [-18.774064913567706, -12.506155214382652],
              [-18.777134102735836, -12.501246789409615],
              [-18.784833233945086, -12.518220303969066],
              [-18.79555796514417, -12.510687846001991],
              [-18.799518717652585, -12.510629767606902],
              [-18.801934671318634, -12.504737563058216]
            ]
          ],
          [
            [
              [-18.33941459542076, -8.69806289037481],
              [-18.337049665903724, -8.691720136434805],
              [-18.337127523844906, -8.682926320917764],
              [-18.33270584132472, -8.68104138776483],
              [-18.334455419698685, -8.690697327400295],
              [-18.33038736109871, -8.692932374443302],
              [-18.3284254714307, -8.697947068423723],
              [-18.33290840348653, -8.699655778496929],
              [-18.33941459542076, -8.69806289037481]
            ]
          ],
          [
            [
              [-18.8093526833903, -12.54623010448393],
              [-18.804557163430843, -12.547848040405688],
              [-18.80006358301036, -12.554932446363082],
              [-18.802338183183593, -12.558608805512508],
              [-18.80638552101843, -12.553774833533826],
              [-18.8093526833903, -12.54623010448393]
            ]
          ],
          [
            [
              [-18.80790424178719, -12.515275155966021],
              [-18.803377108663952, -12.513616757265321],
              [-18.801377813385752, -12.517347695852367],
              [-18.795681609805165, -12.5199523162661],
              [-18.80049112750939, -12.524799117324216],
              [-18.80790424178719, -12.515275155966021]
            ]
          ],
          [
            [
              [-18.81752366958614, -12.525263915321304],
              [-18.811429918829383, -12.53855201636802],
              [-18.814280957475052, -12.539856273043188],
              [-18.817303432063976, -12.53141327966397],
              [-18.81752366958614, -12.525263915321304]
            ]
          ],
          [
            [
              [-18.917339201726442, -12.564479984868713],
              [-18.909598105687362, -12.563498171899079],
              [-18.906004322818603, -12.56124028392771],
              [-18.90187620836549, -12.553925922085314],
              [-18.892684086296445, -12.548718311756941],
              [-18.88062742467653, -12.552613955523748],
              [-18.87639674782116, -12.560175278169925],
              [-18.87828497347575, -12.570395439164773],
              [-18.878627153656097, -12.583264165738157],
              [-18.887932592523253, -12.59268037150608],
              [-18.888949581002088, -12.597783771046355],
              [-18.897870155734985, -12.601614161486278],
              [-18.903400248424663, -12.597870929140699],
              [-18.90435271432579, -12.592547762234712],
              [-18.91030670267658, -12.588208653878068],
              [-18.912178953314147, -12.583126719664019],
              [-18.915264672309238, -12.582366832105429],
              [-18.916310457955653, -12.574305859761479],
              [-18.915160026589398, -12.567345064867341],
              [-18.917339201726442, -12.564479984868713]
            ]
          ],
          [
            [
              [-18.949644518583405, -12.738385155648901],
              [-18.94738667922698, -12.736436175543133],
              [-18.941631279946492, -12.741273336633117],
              [-18.93589146446365, -12.743359524689856],
              [-18.935862208510507, -12.748717124320592],
              [-18.941481122668513, -12.753267839727936],
              [-18.946628564711585, -12.74679367995885],
              [-18.949644518583405, -12.738385155648901]
            ]
          ],
          [
            [
              [-18.576368894445853, -9.60336483893283],
              [-18.565231686303562, -9.598241519937226],
              [-18.5599369640356, -9.591358170783117],
              [-18.555104311296326, -9.59173486466973],
              [-18.549487298293517, -9.588750788106713],
              [-18.545058428266877, -9.589575228651055],
              [-18.53778282067137, -9.594654380913095],
              [-18.532718427652302, -9.594480883681056],
              [-18.52998194373854, -9.590152120319294],
              [-18.522273247467613, -9.59496866534208],
              [-18.523110479174917, -9.601247061750554],
              [-18.518132424942205, -9.60754195129492],
              [-18.52146774171071, -9.61003031584696],
              [-18.52326764857159, -9.615223705595742],
              [-18.521086727890523, -9.622083018022439],
              [-18.52930440375275, -9.617547981597742],
              [-18.53339163670313, -9.622081890262303],
              [-18.541794585442883, -9.619766097449158],
              [-18.543405287814874, -9.621903559687633],
              [-18.55164340616703, -9.618633245399005],
              [-18.56337535188496, -9.619420986522565],
              [-18.5657293591148, -9.613989863719034],
              [-18.571429480717796, -9.613416021947337],
              [-18.571275393460237, -9.607268369362522],
              [-18.576368894445853, -9.60336483893283]
            ]
          ],
          [
            [
              [-19.02552198734256, -12.724503288146071],
              [-19.019682489463445, -12.719768920142748],
              [-19.017739235389772, -12.7130783752076],
              [-19.017673760157518, -12.706905884191096],
              [-19.010199220295377, -12.703269515326522],
              [-18.9924139442074, -12.713126048637976],
              [-18.991063261965063, -12.715771480081504],
              [-18.98506718054367, -12.717634132052744],
              [-18.978156015336157, -12.723604093019773],
              [-18.973096712921706, -12.725199319018191],
              [-18.965016048952986, -12.730883896629052],
              [-18.965224530735455, -12.737231995507942],
              [-18.968638671268916, -12.743820264643434],
              [-18.977903490305742, -12.740957460251748],
              [-18.988562431290777, -12.739256338592863],
              [-18.99413858370635, -12.740827540642883],
              [-19.00064797342043, -12.735706803495516],
              [-19.012281229429156, -12.740344255233364],
              [-19.021889879243606, -12.72766559182609],
              [-19.02552198734256, -12.724503288146071]
            ]
          ],
          [
            [
              [-19.041114594714855, -12.380297257188758],
              [-19.039458054847294, -12.375812425832034],
              [-19.03367367666241, -12.374605413741078],
              [-19.029384231357046, -12.379678145397115],
              [-19.030609787209197, -12.386591507779613],
              [-19.035100208838653, -12.388354206811318],
              [-19.039105280378415, -12.385334659993406],
              [-19.041114594714855, -12.380297257188758]
            ]
          ],
          [
            [
              [-18.898049508131912, -9.744250529966173],
              [-18.893523946413193, -9.740912159271527],
              [-18.887871891089127, -9.744202483121006],
              [-18.892927517267786, -9.748932186171942],
              [-18.898049508131912, -9.744250529966173]
            ]
          ],
          [
            [
              [-18.899313530372638, -9.730696720535144],
              [-18.89266223848797, -9.722937390236622],
              [-18.890845686545745, -9.73091090252981],
              [-18.896429357875345, -9.734114831704224],
              [-18.899313530372638, -9.730696720535144]
            ]
          ],
          [
            [
              [-19.446043921937736, -12.740751089341554],
              [-19.439631840839557, -12.739621611536442],
              [-19.42745843845559, -12.735330281531178],
              [-19.420685451287635, -12.735980327009267],
              [-19.421072580252243, -12.740792415339119],
              [-19.42659168086125, -12.738686500090589],
              [-19.4335797091865, -12.742227159676183],
              [-19.442085282268454, -12.744056003762651],
              [-19.446043921937736, -12.740751089341554]
            ]
          ],
          [
            [
              [-18.971400666490272, -9.868273791570202],
              [-18.966901043676447, -9.863309326720383],
              [-18.96443878743339, -9.867402951987499],
              [-18.958620990500027, -9.867356266032674],
              [-18.955611585265306, -9.871403257352977],
              [-18.954399215812273, -9.889944687307196],
              [-18.964753544572847, -9.891023802522794],
              [-18.969429512365373, -9.887308955382139],
              [-18.9727552044968, -9.880536790343974],
              [-18.971400666490272, -9.868273791570202]
            ]
          ],
          [
            [
              [-19.436740787201014, -12.611422492528527],
              [-19.432249551645178, -12.604858887522948],
              [-19.42296555298816, -12.603716179524378],
              [-19.4164514613962, -12.599575158077121],
              [-19.405490753315153, -12.595670281209044],
              [-19.397867209915443, -12.59634210085551],
              [-19.386000800730155, -12.591904480828996],
              [-19.376222204003017, -12.58031065024953],
              [-19.3674346553655, -12.568139775411028],
              [-19.359623811572607, -12.55399829849174],
              [-19.353226757164553, -12.547181343426352],
              [-19.343948159894385, -12.531797014349431],
              [-19.343457409070023, -12.525413289259351],
              [-19.34095183098715, -12.519158405447113],
              [-19.334469715953645, -12.516860628273832],
              [-19.328074165579874, -12.511663788067123],
              [-19.32068913286611, -12.511062277127326],
              [-19.31458086744834, -12.508322821465296],
              [-19.30804385571972, -12.512189629444254],
              [-19.297962761857686, -12.523236748882649],
              [-19.283624484542127, -12.521385454016093],
              [-19.268610829209763, -12.515373762764513],
              [-19.26007210830218, -12.508472855044863],
              [-19.252970637196537, -12.505271359088976],
              [-19.24322421630013, -12.50951345328369],
              [-19.23442769525282, -12.507947123474244],
              [-19.21685772495062, -12.499896585296264],
              [-19.202673225750647, -12.489079091460141],
              [-19.193816962638763, -12.490891712987027],
              [-19.178493354115083, -12.4870963716596],
              [-19.172273882204557, -12.4905590475077],
              [-19.15626821289412, -12.494317029644241],
              [-19.136228529201883, -12.495264059599828],
              [-19.13143143788854, -12.494249694807062],
              [-19.13292279614913, -12.50252743069012],
              [-19.131590196240623, -12.506055608785719],
              [-19.12376769244119, -12.51379166099136],
              [-19.116156194380082, -12.524838173480804],
              [-19.113836755230217, -12.530908007878399],
              [-19.110221660860702, -12.550948079459813],
              [-19.112903861623263, -12.553593717267512],
              [-19.11446297951457, -12.568077490785411],
              [-19.1097329177982, -12.577802369848083],
              [-19.110788298763474, -12.588548263350336],
              [-19.103572856601502, -12.60129724732499],
              [-19.09767168354835, -12.602583125812313],
              [-19.08425739003051, -12.602883903415417],
              [-19.073806074471793, -12.597593625385995],
              [-19.072435000465738, -12.60106487828902],
              [-19.067162269850453, -12.601991874285694],
              [-19.059732076694967, -12.614745280091478],
              [-19.05948374777001, -12.622774791714415],
              [-19.060838653249508, -12.627728164026461],
              [-19.05457857750268, -12.63050993639066],
              [-19.051053371188072, -12.635835237743494],
              [-19.05463565558336, -12.63902642310071],
              [-19.059603702352515, -12.638075756894013],
              [-19.071441977088167, -12.632122129904015],
              [-19.06330493326721, -12.626970195488475],
              [-19.073808998053444, -12.623491591949676],
              [-19.080066095361424, -12.622594578302351],
              [-19.086053212043765, -12.62405177640601],
              [-19.09298351957817, -12.62208655590112],
              [-19.091080959000784, -12.616452464044743],
              [-19.09872026691103, -12.619263491865253],
              [-19.1043233373285, -12.611840466204155],
              [-19.105092849791035, -12.602246524459046],
              [-19.11203655284805, -12.6006235990954],
              [-19.11783970699456, -12.602160331387205],
              [-19.12492844574204, -12.60914921156103],
              [-19.123005250049015, -12.619078512661634],
              [-19.126700667823286, -12.63022211853621],
              [-19.14385854241198, -12.629646469532771],
              [-19.14851121423154, -12.635940970635346],
              [-19.15933766283809, -12.636072776251867],
              [-19.162807258042385, -12.640897302654293],
              [-19.17459865340725, -12.635231232448575],
              [-19.182285463312095, -12.632588951202605],
              [-19.20656667334954, -12.626355392517487],
              [-19.21496400859463, -12.626486630225779],
              [-19.235793419093454, -12.623503783756293],
              [-19.254191587019026, -12.622893561185967],
              [-19.263347928049043, -12.623310340951365],
              [-19.27614425255604, -12.625456335663896],
              [-19.287933766983745, -12.628434547506059],
              [-19.29755827449458, -12.632328574284932],
              [-19.313773608792644, -12.642236018012984],
              [-19.319326455984946, -12.649104188786971],
              [-19.31670252043314, -12.655296911657747],
              [-19.31965159586816, -12.657205608520572],
              [-19.319394017959535, -12.6622996716082],
              [-19.321864010600986, -12.66578530244121],
              [-19.32946832577169, -12.671633371737565],
              [-19.346215590578943, -12.679842383383487],
              [-19.354673192712603, -12.680871953763692],
              [-19.35931238907328, -12.679839637762255],
              [-19.37734562604129, -12.681177572907727],
              [-19.387759427001416, -12.684176858066758],
              [-19.398603613177993, -12.678515600444813],
              [-19.405682676974816, -12.679591096138333],
              [-19.41609542313109, -12.67520319410662],
              [-19.425478078051828, -12.66764877167334],
              [-19.426355840896047, -12.660933253782387],
              [-19.42940394215926, -12.658936691683335],
              [-19.429571866486512, -12.65152610197201],
              [-19.435530342328857, -12.644162495659229],
              [-19.432084793365316, -12.640468787027844],
              [-19.43285046255834, -12.635021741622845],
              [-19.437112848194424, -12.630274599159435],
              [-19.437743884211002, -12.625209725158976],
              [-19.436094130273034, -12.617821060965445],
              [-19.436740787201014, -12.611422492528527]
            ]
          ],
          [
            [
              [-18.983048897076454, -9.900317376062427],
              [-18.97271556758519, -9.89923977396657],
              [-18.966981029893063, -9.900991850223074],
              [-18.96642654167137, -9.908507954478665],
              [-18.981824688333308, -9.903905794259275],
              [-18.983048897076454, -9.900317376062427]
            ]
          ],
          [
            [
              [-19.09055871354254, -10.487311864063962],
              [-19.084360219660798, -10.4739792219127],
              [-19.07352938895947, -10.481022836056257],
              [-19.06824923801066, -10.48731604988104],
              [-19.067512620009445, -10.490477050520592],
              [-19.077423572661615, -10.493403825319097],
              [-19.086826161260923, -10.494500150564638],
              [-19.09034960218949, -10.492093873706237],
              [-19.09055871354254, -10.487311864063962]
            ]
          ],
          [
            [
              [-18.98724217557778, -9.879612837483698],
              [-18.98179156827582, -9.872856592341687],
              [-18.97962434750878, -9.881100042834573],
              [-18.976387824066734, -9.886239892316661],
              [-18.977618742507815, -9.89055512660955],
              [-18.986491027522128, -9.8895717263761],
              [-18.98724217557778, -9.879612837483698]
            ]
          ],
          [
            [
              [-18.995802518304462, -9.888462487205274],
              [-18.991327216511138, -9.88607642332552],
              [-18.988404821611827, -9.891249490746253],
              [-18.995870500512126, -9.89184356320918],
              [-18.995802518304462, -9.888462487205274]
            ]
          ],
          [
            [
              [-19.519831212676316, -12.762665133995087],
              [-19.51391684498377, -12.758298807282062],
              [-19.505712963843926, -12.760669748176197],
              [-19.50210529086863, -12.75529301824708],
              [-19.4955498099308, -12.759167191961739],
              [-19.489249356954478, -12.757939811238003],
              [-19.483100573996573, -12.763619096841737],
              [-19.478677560558477, -12.761501171909389],
              [-19.469192549263592, -12.765069446308257],
              [-19.466642779022177, -12.760573552345504],
              [-19.459463384996393, -12.76024642745711],
              [-19.45811406882481, -12.768889064754799],
              [-19.461996103249067, -12.771920174303725],
              [-19.46795659202952, -12.780733554103252],
              [-19.473637659038335, -12.778315990129876],
              [-19.485264374164935, -12.780515485425195],
              [-19.49352264888163, -12.778100932181507],
              [-19.50331893208436, -12.770558702777995],
              [-19.508197340058704, -12.77182551676361],
              [-19.513488563653922, -12.768056842586686],
              [-19.519458898322334, -12.766486963609783],
              [-19.519831212676316, -12.762665133995087]
            ]
          ],
          [
            [
              [-19.57447861102235, -12.762726516457946],
              [-19.564054702838174, -12.762133395842925],
              [-19.557226273963906, -12.763337584560528],
              [-19.549760034692145, -12.761221428670364],
              [-19.54156363792412, -12.763372084208106],
              [-19.53373082700512, -12.762804407462147],
              [-19.52887992335194, -12.76453156508542],
              [-19.52480582589555, -12.77466326722398],
              [-19.53409066114299, -12.773306661772796],
              [-19.537333549683026, -12.781305639681314],
              [-19.542509723301517, -12.777445815783937],
              [-19.54497572920826, -12.769214003388566],
              [-19.561670851071103, -12.764901661549214],
              [-19.565268970369644, -12.765884201928102],
              [-19.57447861102235, -12.762726516457946]
            ]
          ],
          [
            [
              [-19.595407343263105, -12.770349004918373],
              [-19.592576909762492, -12.77035192991812],
              [-19.584110282887202, -12.764413230066404],
              [-19.578220706796177, -12.77502811115469],
              [-19.59259488410529, -12.777064179867034],
              [-19.595407343263105, -12.770349004918373]
            ]
          ],
          [
            [
              [-19.60545343621503, -12.698181172631788],
              [-19.60193919054164, -12.6910944317741],
              [-19.593198110211727, -12.689192883289662],
              [-19.59093051224333, -12.682135028604758],
              [-19.586390176004173, -12.684311560304055],
              [-19.581026352366077, -12.690135815923187],
              [-19.574208071864856, -12.686259976447351],
              [-19.567095498258915, -12.685939815531011],
              [-19.559755799170688, -12.68930489836979],
              [-19.561566198399635, -12.693080137589474],
              [-19.56744343321508, -12.691453093899943],
              [-19.570301354053676, -12.696924141816758],
              [-19.57850591698215, -12.69888491215596],
              [-19.579502661099802, -12.704965817218069],
              [-19.569617555055537, -12.716519466958134],
              [-19.563885101201464, -12.716533726464938],
              [-19.55612197613629, -12.720402933993734],
              [-19.55106627815187, -12.718660841546084],
              [-19.54734020251763, -12.724679591639555],
              [-19.55193332811429, -12.731604945926444],
              [-19.554956260362655, -12.729408266751006],
              [-19.567777258355544, -12.727230914128944],
              [-19.571070571809646, -12.733460763440412],
              [-19.58529673840464, -12.73656999249231],
              [-19.58236963777871, -12.742325852150003],
              [-19.585925979083814, -12.747213965848296],
              [-19.59127654451274, -12.747743135919201],
              [-19.598289565994346, -12.74402851815823],
              [-19.598755047837788, -12.734014726607542],
              [-19.592679505810633, -12.728362230767354],
              [-19.59170395839728, -12.725157808037354],
              [-19.59625911720173, -12.722157235021518],
              [-19.598254391360694, -12.715696253577395],
              [-19.59617461040876, -12.713503488182404],
              [-19.585790360912306, -12.708312469934159],
              [-19.585699224624133, -12.705345334616286],
              [-19.590944207415564, -12.700738047699813],
              [-19.59752455896254, -12.705135643467722],
              [-19.603028241750618, -12.70413544239844],
              [-19.60545343621503, -12.698181172631788]
            ]
          ],
          [
            [
              [-19.69891179901862, -12.724041744228037],
              [-19.69610690034236, -12.722855752376839],
              [-19.694569633144475, -12.715503842195119],
              [-19.689704074065432, -12.714688033502753],
              [-19.689630178587738, -12.706933254248893],
              [-19.682437823283607, -12.703737122575783],
              [-19.677038657058663, -12.704268644139857],
              [-19.67085216414007, -12.697948937841764],
              [-19.66607847645566, -12.695715396945987],
              [-19.65178254815004, -12.70133383758867],
              [-19.644629537656012, -12.702259569042338],
              [-19.64396420255973, -12.706953236170204],
              [-19.648177345483283, -12.71339168719255],
              [-19.645313236027135, -12.718524721809775],
              [-19.64000087134262, -12.721146765332993],
              [-19.63491450572962, -12.71639891893777],
              [-19.62285175275894, -12.724340463441456],
              [-19.622011371573475, -12.730031639951932],
              [-19.634260106477964, -12.734646086062396],
              [-19.623652198597956, -12.740889045916104],
              [-19.61672863964998, -12.740453028506098],
              [-19.60767613645573, -12.738115094543868],
              [-19.613306304537723, -12.74997427605578],
              [-19.620573105776206, -12.749823199526062],
              [-19.63365246205352, -12.75536759760537],
              [-19.636416554455007, -12.75203426234174],
              [-19.648536432562544, -12.748555605982986],
              [-19.650572338056662, -12.756073577802402],
              [-19.658024901576017, -12.761963722340834],
              [-19.661584667802217, -12.759981519021128],
              [-19.65965919554381, -12.753360158753951],
              [-19.665867279044104, -12.749603991851643],
              [-19.67121814934857, -12.751120278954527],
              [-19.6756608858032, -12.746173899617261],
              [-19.678499043576004, -12.750454306106159],
              [-19.691122743951354, -12.752553919942862],
              [-19.68957237774248, -12.742725317640923],
              [-19.692418722889904, -12.73699555442378],
              [-19.69662958394175, -12.733775623709228],
              [-19.69891179901862, -12.724041744228037]
            ]
          ],
          [
            [
              [-19.725172266703034, -12.766512890263636],
              [-19.719088197514754, -12.766741964638275],
              [-19.71722601451737, -12.763493969608598],
              [-19.705969719024036, -12.76900942683463],
              [-19.705528126068554, -12.772605245821193],
              [-19.701098545598455, -12.776239306738553],
              [-19.704446077717332, -12.779008946218239],
              [-19.716598628163307, -12.779354702750373],
              [-19.72587341073346, -12.775690866978113],
              [-19.725172266703034, -12.766512890263636]
            ]
          ],
          [
            [
              [-19.760615195717023, -12.828760463961835],
              [-19.757867534740665, -12.825540100110747],
              [-19.753225942270582, -12.831885575079477],
              [-19.751779192215878, -12.825775162980605],
              [-19.744957819245208, -12.824268438959926],
              [-19.746441824424505, -12.835042811267636],
              [-19.742251422936015, -12.831983780052786],
              [-19.738192788017628, -12.825009903681373],
              [-19.737807673968376, -12.818661954457326],
              [-19.734625590286072, -12.816662484412916],
              [-19.726061281666045, -12.815538497447385],
              [-19.715736530223115, -12.816718391145267],
              [-19.711508548424476, -12.818813636063997],
              [-19.72313570345591, -12.824765593934469],
              [-19.724963212745273, -12.830051861694743],
              [-19.72052537863364, -12.83357421242772],
              [-19.724396777232986, -12.83630619657075],
              [-19.725547963348422, -12.841986085939572],
              [-19.731699926395493, -12.841144396366536],
              [-19.735149177175902, -12.838209235872576],
              [-19.738721452439286, -12.839606848890652],
              [-19.732450518795922, -12.848261857770353],
              [-19.738882836765054, -12.853089216394702],
              [-19.746178101276126, -12.851109826005315],
              [-19.749238742225415, -12.858204158798898],
              [-19.75287164541728, -12.855423962981384],
              [-19.754540861221955, -12.848030717431891],
              [-19.759862846302433, -12.846232224330516],
              [-19.760879884745684, -12.841345977900254],
              [-19.759356333354962, -12.83198373451714],
              [-19.760615195717023, -12.828760463961835]
            ]
          ],
          [
            [
              [-19.540798873620595, -10.623843871252506],
              [-19.533473090530624, -10.629629607014468],
              [-19.52886062061436, -10.628371253351188],
              [-19.524918658866223, -10.624667787735211],
              [-19.511718961983316, -10.622171406121907],
              [-19.50521994237879, -10.628122894740352],
              [-19.500250635636363, -10.624577579588836],
              [-19.490676688476018, -10.627013305234534],
              [-19.483761624272617, -10.630351335204931],
              [-19.478777729242758, -10.628131512080564],
              [-19.477531395223895, -10.631908512611309],
              [-19.469662941942683, -10.63708712417871],
              [-19.460396604600408, -10.636712854221978],
              [-19.452216864863217, -10.63765881245113],
              [-19.45307010045104, -10.643892901720248],
              [-19.44738424123765, -10.645783885639501],
              [-19.440806334262685, -10.643002729535189],
              [-19.43809087426903, -10.647058145948613],
              [-19.431387493822182, -10.641201981587331],
              [-19.427101801948265, -10.63461464182549],
              [-19.427097092852325, -10.629739961118855],
              [-19.429861394278856, -10.62626404099385],
              [-19.426062311133947, -10.621582481242411],
              [-19.411477804137995, -10.613850343238523],
              [-19.408117543052878, -10.618011498801364],
              [-19.4051736949828, -10.612940265199278],
              [-19.398194538376895, -10.614432031819549],
              [-19.39714084385913, -10.610555356783296],
              [-19.389173956167888, -10.616491465381783],
              [-19.386828937034096, -10.619997095654433],
              [-19.38216608770136, -10.615909244172272],
              [-19.38219272356023, -10.605336839882746],
              [-19.373956798835128, -10.603331760016829],
              [-19.36587706011852, -10.59683289740678],
              [-19.362245099896636, -10.597883690127597],
              [-19.352731689239498, -10.604653152356715],
              [-19.348118000442852, -10.611354709921814],
              [-19.342790373779188, -10.608582224784703],
              [-19.335412403661117, -10.6072811240755],
              [-19.33307855895314, -10.604986775162748],
              [-19.314724196268354, -10.60397891581513],
              [-19.308460791465443, -10.609967667024984],
              [-19.30401203593102, -10.60646548719984],
              [-19.30588427141598, -10.595180454176544],
              [-19.302174191660487, -10.59536044165153],
              [-19.301229849711596, -10.601074621519352],
              [-19.303295759310675, -10.61129805588529],
              [-19.299894282707015, -10.615483755567649],
              [-19.30124525828016, -10.618355046876998],
              [-19.296473361311318, -10.625596975593538],
              [-19.298621531802723, -10.63095032361012],
              [-19.286604244684938, -10.636420426695675],
              [-19.273227722645984, -10.636718352887744],
              [-19.27016079603363, -10.630493857870954],
              [-19.26448126934561, -10.629977605980153],
              [-19.2533026945146, -10.638562545523193],
              [-19.24749872616655, -10.639421037185176],
              [-19.246718068481176, -10.644058762781274],
              [-19.23390418705494, -10.653419649491587],
              [-19.23658311598266, -10.657041564281915],
              [-19.233736287368693, -10.661837353276661],
              [-19.23806146582197, -10.666704892044452],
              [-19.244093384290252, -10.66748912399141],
              [-19.24383731071644, -10.674020410116944],
              [-19.23924875337369, -10.676148057359034],
              [-19.23951629738789, -10.685251901799154],
              [-19.245276093637138, -10.690252526173614],
              [-19.24893985518688, -10.69636818188947],
              [-19.24764872174573, -10.69987112890444],
              [-19.24126438042686, -10.700241010650107],
              [-19.243694072081574, -10.705333870734224],
              [-19.24113697901054, -10.713915556788315],
              [-19.243098106846674, -10.72059256227335],
              [-19.251774794779845, -10.728635931363371],
              [-19.248280644509645, -10.7336968118682],
              [-19.249745649156356, -10.741096803001843],
              [-19.24190442856906, -10.74820783945203],
              [-19.247195746875207, -10.757950618991273],
              [-19.240657221134402, -10.76700718902034],
              [-19.235349038413105, -10.763008020025653],
              [-19.231605871356795, -10.766322397803961],
              [-19.23684575173531, -10.769710842458087],
              [-19.23955940402067, -10.775205715180036],
              [-19.23593036430618, -10.781300168538323],
              [-19.239923625611176, -10.786871699242793],
              [-19.245957986281493, -10.785700559167388],
              [-19.249636962782354, -10.788319337989542],
              [-19.25513121521235, -10.787655290569578],
              [-19.264793595679883, -10.78901725335493],
              [-19.266260145028692, -10.784539015349052],
              [-19.271452550704915, -10.783376504883483],
              [-19.280545847343475, -10.785995717056569],
              [-19.283700452429603, -10.784769508191806],
              [-19.2924763324139, -10.789989616351319],
              [-19.30490583838985, -10.786562326759586],
              [-19.314319866160005, -10.787848305770275],
              [-19.32210247050639, -10.790342922202727],
              [-19.335843604504, -10.798168254883734],
              [-19.342208324848787, -10.79890034620669],
              [-19.337803676163855, -10.806577613122158],
              [-19.338718399656557, -10.809642347564411],
              [-19.334619438399148, -10.817183508669515],
              [-19.336743972130716, -10.82150249507112],
              [-19.34851163043886, -10.82369590442503],
              [-19.354669987777065, -10.821902265371962],
              [-19.357754382834397, -10.816885387840031],
              [-19.35736756847131, -10.81036219179645],
              [-19.361918811027255, -10.802602687576979],
              [-19.368094184189108, -10.795174683897935],
              [-19.376110031210164, -10.791316519605363],
              [-19.378573512532096, -10.786477871543944],
              [-19.389688170675864, -10.778733968949503],
              [-19.397369850378766, -10.778475971435586],
              [-19.402842072324354, -10.779927512768397],
              [-19.41058610521078, -10.776923155001088],
              [-19.421267340754554, -10.775078577900826],
              [-19.42982028001103, -10.76230257400535],
              [-19.437098059798547, -10.757753126964715],
              [-19.443060178579458, -10.755777322598634],
              [-19.446613355221707, -10.748495950582576],
              [-19.453899289211115, -10.738740096527492],
              [-19.46359527920737, -10.727993626701695],
              [-19.471116539312057, -10.723334632417469],
              [-19.47346644947617, -10.720095294722487],
              [-19.481442680603287, -10.71626143277176],
              [-19.485816410100192, -10.711975884084248],
              [-19.488788969495797, -10.712984148251214],
              [-19.496154400745233, -10.711372389122088],
              [-19.5051146210801, -10.701741672312096],
              [-19.51301184258245, -10.689578138449171],
              [-19.51470475003378, -10.683746345750212],
              [-19.5254340209015, -10.680210584766593],
              [-19.529883751541995, -10.67591606738993],
              [-19.526984443923897, -10.670062995406928],
              [-19.52712089046013, -10.656680059255338],
              [-19.533096171926047, -10.640243079813482],
              [-19.53451149024296, -10.633605495235996],
              [-19.539777630960582, -10.627505447399551],
              [-19.540798873620595, -10.623843871252506]
            ]
          ],
          [
            [
              [-20.108309690390527, -12.926803277510498],
              [-20.098391864542375, -12.924154941924842],
              [-20.085500072469458, -12.91865677586063],
              [-20.084827114645236, -12.91600747040102],
              [-20.070706943848318, -12.90814333260518],
              [-20.06240838192322, -12.908773195028223],
              [-20.05633510424063, -12.912445799139729],
              [-20.050006502483633, -12.912545283632998],
              [-20.04417362567901, -12.907566746572419],
              [-20.040092648793372, -12.908907700099856],
              [-20.039183274350226, -12.913474658295808],
              [-20.029751954189283, -12.913894804050573],
              [-20.031180193593315, -12.9073297237293],
              [-20.02592132498158, -12.906096856165735],
              [-20.018724114595486, -12.898067942184035],
              [-20.010452354420416, -12.904174375188155],
              [-20.00854048507209, -12.911493772932863],
              [-20.00506571355689, -12.911251377310585],
              [-20.00480270187452, -12.904071307094148],
              [-19.997833535545414, -12.910500041768561],
              [-19.99473707634236, -12.916920990920163],
              [-19.9918901922676, -12.912392732105754],
              [-19.994560685058133, -12.905271982324047],
              [-19.99177947535557, -12.899112465328495],
              [-19.985812628007622, -12.908529885074117],
              [-19.983851809664767, -12.896922995830568],
              [-19.980640521363487, -12.894265979672284],
              [-19.96418601774001, -12.903305159083853],
              [-19.961357623764417, -12.900397066365649],
              [-19.95454593734752, -12.9033280645953],
              [-19.952373824069205, -12.88934208301023],
              [-19.956606175149716, -12.88313921337991],
              [-19.94324619881453, -12.888598258909495],
              [-19.934277715503605, -12.893558524016125],
              [-19.930325525003017, -12.890916378672816],
              [-19.937242013242074, -12.886555187454098],
              [-19.937222990117665, -12.88165430824384],
              [-19.944924536343304, -12.876229135868869],
              [-19.944477097801055, -12.865091557785558],
              [-19.94687900143816, -12.858374585023464],
              [-19.942370608427247, -12.851788253330568],
              [-19.93299397909214, -12.849580599186638],
              [-19.929731503672027, -12.850999305361107],
              [-19.926151777187414, -12.85703117642975],
              [-19.920514700025073, -12.859177835768644],
              [-19.919552917091842, -12.852610032374795],
              [-19.913066727597677, -12.857879011071407],
              [-19.91222562064072, -12.850897688400044],
              [-19.917600715188257, -12.844769585780712],
              [-19.922836254562014, -12.841307812759839],
              [-19.922182699729195, -12.8344181055089],
              [-19.91349955200298, -12.827746409230771],
              [-19.906189517321465, -12.826670411849127],
              [-19.884499090310342, -12.830407446875386],
              [-19.884865981942735, -12.835342876618395],
              [-19.88123404453543, -12.840553732175483],
              [-19.879923714876334, -12.846607870415207],
              [-19.881442695960246, -12.856288597731035],
              [-19.875921657091645, -12.852904038428731],
              [-19.871918645160765, -12.857813363234502],
              [-19.868076109364843, -12.853861403922686],
              [-19.86993065712074, -12.845711957286213],
              [-19.872614333843448, -12.84293610310816],
              [-19.867630386951927, -12.836633617225042],
              [-19.864227618739488, -12.841358352370946],
              [-19.858387460479072, -12.833509540325299],
              [-19.852504293708762, -12.837138499362526],
              [-19.84459955143931, -12.838949906367903],
              [-19.846375919081403, -12.833857081997703],
              [-19.85788891125511, -12.828748923172093],
              [-19.862775282759777, -12.827942512834936],
              [-19.874560683096448, -12.822596719638666],
              [-19.879198509370934, -12.817196562714406],
              [-19.887617802371267, -12.814751549044944],
              [-19.89412237742438, -12.807450239045947],
              [-19.904810175662742, -12.812973120632234],
              [-19.915881862365268, -12.799798050592596],
              [-19.91770887722982, -12.788128344219075],
              [-19.92894278425923, -12.782741753160469],
              [-19.927645848925028, -12.772662993872283],
              [-19.921247550055426, -12.77237955166114],
              [-19.915773348867216, -12.767919726792314],
              [-19.91084749086703, -12.757927700341517],
              [-19.906733433771773, -12.753839115972779],
              [-19.898140541519425, -12.752419606097408],
              [-19.895092793262027, -12.746787379635105],
              [-19.89065139756609, -12.744610156424532],
              [-19.884787270042256, -12.746861134267677],
              [-19.874473315759683, -12.74416033859682],
              [-19.864027337846657, -12.739780273151053],
              [-19.860903845001555, -12.743607149043003],
              [-19.854437992388874, -12.744721354885769],
              [-19.850354763228335, -12.741034466190198],
              [-19.842487156982425, -12.74061524563799],
              [-19.834186866222, -12.736636364720976],
              [-19.83110192657427, -12.742434804441109],
              [-19.826390129690214, -12.743447069464167],
              [-19.823151821577223, -12.739693083556585],
              [-19.81834403369994, -12.738829338329568],
              [-19.81038964309254, -12.743985924272552],
              [-19.807117943863418, -12.751801616420407],
              [-19.807111125545212, -12.757722224138975],
              [-19.80914766601085, -12.761854205846948],
              [-19.814001635038625, -12.762546200290036],
              [-19.820267112560803, -12.771130565539679],
              [-19.816745961561704, -12.78240940415951],
              [-19.821329818911085, -12.786629516249441],
              [-19.81776870555878, -12.79038567352398],
              [-19.812444386777965, -12.786083559731736],
              [-19.811383313436703, -12.790730826717436],
              [-19.814106291768496, -12.797322010120654],
              [-19.817340442896384, -12.799002858827041],
              [-19.814652760379776, -12.80378819645015],
              [-19.811149287553402, -12.798701889649548],
              [-19.80443236918616, -12.795967640266712],
              [-19.806478088487403, -12.789313908662805],
              [-19.802207002824034, -12.786659732511959],
              [-19.801490759671044, -12.77931038958529],
              [-19.79656608553349, -12.775468114014858],
              [-19.79229121097426, -12.775316677235239],
              [-19.791460562092112, -12.779501783770597],
              [-19.799514192300272, -12.783759804567945],
              [-19.79457858851702, -12.788808804220261],
              [-19.78555004187287, -12.784289853447786],
              [-19.781229823644757, -12.785453854760652],
              [-19.77741708471145, -12.778558920861663],
              [-19.778486589772502, -12.775327425495638],
              [-19.77668363810104, -12.769133609093691],
              [-19.772031881072913, -12.772418820193083],
              [-19.768119654113733, -12.759317009229681],
              [-19.761847976534828, -12.756788183707622],
              [-19.756495741877323, -12.758619874679322],
              [-19.764305400222504, -12.772847307615963],
              [-19.755910695642125, -12.774849515697701],
              [-19.742782789583284, -12.765055534933163],
              [-19.73923010657884, -12.769144431862133],
              [-19.738375082526165, -12.77991928495114],
              [-19.740849509837407, -12.785678487317352],
              [-19.738271149785486, -12.787724575158267],
              [-19.732684335057357, -12.785779581019208],
              [-19.733230120132845, -12.791648943785159],
              [-19.7396213542571, -12.794395505686673],
              [-19.739933364213694, -12.799946623158606],
              [-19.750307198310825, -12.802841720621243],
              [-19.759521711668658, -12.79994265728229],
              [-19.762361388590133, -12.794709745846816],
              [-19.765477509643635, -12.80412307130063],
              [-19.772984657562187, -12.807896409035648],
              [-19.776065065567394, -12.812046612892916],
              [-19.78211297400121, -12.81071243620517],
              [-19.780573054882268, -12.818513431730072],
              [-19.793919997432205, -12.822617533680761],
              [-19.803233291640353, -12.820523066422881],
              [-19.800945084007573, -12.831128954490476],
              [-19.817488476244495, -12.833627558066517],
              [-19.817560463336427, -12.837441702975113],
              [-19.813248865796115, -12.840026220642207],
              [-19.821015199676502, -12.843648791220621],
              [-19.81528029795731, -12.8461585984864],
              [-19.81119052768695, -12.852458656263453],
              [-19.80811387717081, -12.847517967094005],
              [-19.808348359496513, -12.843840781836365],
              [-19.804183953312865, -12.841542822727902],
              [-19.79894957874295, -12.844684021154581],
              [-19.792944092673775, -12.836266532157188],
              [-19.783077569768544, -12.83336356749498],
              [-19.77775712443267, -12.843697244228665],
              [-19.774222432391237, -12.831511354090667],
              [-19.766184586355884, -12.828677963438638],
              [-19.764133910508406, -12.836502080877194],
              [-19.76359051535811, -12.846708437465566],
              [-19.759145336779234, -12.848373020107474],
              [-19.7564470240426, -12.85339656284917],
              [-19.75642129474891, -12.85876234549698],
              [-19.76109351268231, -12.859568347226661],
              [-19.762611122079296, -12.864728801514582],
              [-19.770462574807087, -12.865074334253755],
              [-19.779671010018316, -12.867362505462518],
              [-19.783890192299154, -12.863976344503369],
              [-19.787277560213045, -12.868233156493467],
              [-19.793027847870558, -12.8680757300963],
              [-19.798907043229512, -12.874778170119894],
              [-19.803596802838406, -12.87032014267399],
              [-19.809811967090603, -12.874198582331315],
              [-19.816050379976147, -12.8705955413501],
              [-19.820762703685872, -12.874481579508815],
              [-19.826445209054803, -12.88713512860641],
              [-19.82597718362475, -12.890524421108516],
              [-19.829685830971055, -12.89631530733529],
              [-19.83351483686738, -12.893225825367352],
              [-19.83615753740244, -12.899216979288324],
              [-19.83982732904177, -12.89480872411835],
              [-19.83976004242484, -12.887700281001118],
              [-19.844120556508766, -12.881205907120536],
              [-19.846776408362402, -12.885329681274346],
              [-19.843856954282447, -12.891849610956967],
              [-19.844144252956603, -12.904661370015269],
              [-19.849648003808653, -12.903651341140222],
              [-19.847919364296228, -12.910223325975776],
              [-19.851364529021943, -12.916658421831766],
              [-19.855244350320554, -12.915585010019786],
              [-19.858075677715668, -12.908850179864851],
              [-19.861495937613217, -12.910557429768074],
              [-19.866406255242662, -12.906295664162569],
              [-19.866406236810736, -12.901100918258448],
              [-19.86942252476822, -12.898250844936971],
              [-19.871010572675416, -12.889523851081353],
              [-19.876094635641515, -12.891227114193482],
              [-19.87255269804633, -12.904444460788879],
              [-19.87511276475346, -12.908787709121306],
              [-19.86929235992232, -12.913299581680542],
              [-19.870187830328955, -12.920708036617356],
              [-19.874247121555598, -12.92217150390428],
              [-19.8762917724964, -12.926838796749253],
              [-19.881659660532495, -12.921426276098227],
              [-19.88571220807198, -12.92094982263792],
              [-19.887841556076328, -12.926017613035183],
              [-19.894538010550562, -12.916787085262062],
              [-19.899403530834086, -12.926878929908588],
              [-19.909800830540345, -12.920956129907694],
              [-19.90709460241088, -12.914331764704832],
              [-19.91380757636871, -12.912377930095149],
              [-19.918096206292134, -12.923166365070413],
              [-19.924951086497344, -12.922506818920628],
              [-19.92031708976249, -12.916524451458345],
              [-19.926988531689073, -12.913860010442367],
              [-19.93438807150322, -12.91377673716696],
              [-19.937634296038677, -12.920369545266006],
              [-19.943263909810945, -12.921388800870236],
              [-19.954222375441077, -12.917998371789471],
              [-19.96127608041685, -12.924068570781543],
              [-19.969577370044654, -12.92546603740108],
              [-19.973709208442326, -12.92913215347974],
              [-19.99014184287129, -12.930297531908002],
              [-19.994849487725872, -12.941681402138599],
              [-20.00797460658555, -12.938583827518986],
              [-20.009740887102758, -12.93525076775583],
              [-20.01595779384118, -12.938718879955148],
              [-20.02566195316561, -12.940255876663933],
              [-20.026175985696774, -12.943901644732417],
              [-20.03264626981655, -12.950573707867543],
              [-20.03743292240896, -12.952747803224053],
              [-20.0368825974864, -12.958215150862028],
              [-20.040607344022828, -12.95872666186181],
              [-20.04595409111409, -12.950786957694516],
              [-20.050825473739927, -12.951063853234746],
              [-20.052899345131575, -12.948003523081606],
              [-20.058700404740197, -12.94547286128135],
              [-20.061875104180157, -12.947940666151547],
              [-20.065950152316027, -12.955932596592065],
              [-20.07294520817343, -12.957057453721722],
              [-20.07456025322957, -12.951626204664827],
              [-20.08099178650579, -12.947277023804332],
              [-20.098322929358584, -12.940789628662229],
              [-20.098744721997637, -12.93531755657715],
              [-20.10440972329866, -12.932423278696382],
              [-20.108309690390527, -12.926803277510498]
            ]
          ],
          [
            [
              [-19.296868067472047, -8.993574581386259],
              [-19.293082113365784, -8.990077392524022],
              [-19.289402535060916, -8.992351866897973],
              [-19.290784057950237, -8.997712854688906],
              [-19.296868067472047, -8.993574581386259]
            ]
          ],
          [
            [
              [-19.2504021264595, -8.76325701506927],
              [-19.24574996350015, -8.753496667038316],
              [-19.242800654060733, -8.750510707147999],
              [-19.225620093019568, -8.741526362929475],
              [-19.207610850993166, -8.735829583389858],
              [-19.183353241302424, -8.730240503327815],
              [-19.15771304648715, -8.722883955819865],
              [-19.129589817086895, -8.711269120965143],
              [-19.113191792282183, -8.702972955666],
              [-19.086065795186624, -8.688082959484845],
              [-19.039561814357693, -8.664902955818055],
              [-19.003878949040693, -8.647441916125322],
              [-18.973113427442083, -8.634602816199122],
              [-18.948193500003537, -8.625521567059705],
              [-18.937592474613677, -8.625056740745043],
              [-18.931793897040688, -8.618539791221025],
              [-18.92205234367729, -8.6138022070596],
              [-18.91702090750881, -8.613327981433299],
              [-18.912783778561188, -8.61016791511012],
              [-18.898807646460078, -8.603643883553653],
              [-18.86509121990484, -8.590418897851134],
              [-18.85135061921854, -8.585416826788844],
              [-18.816568679844988, -8.574075448354684],
              [-18.78129145972196, -8.563915267253448],
              [-18.72403733661977, -8.550975007348267],
              [-18.703333181638488, -8.54727453188313],
              [-18.671325378436773, -8.542455640096785],
              [-18.66468604243188, -8.543685825808092],
              [-18.637111599916988, -8.544684920779854],
              [-18.61890041168748, -8.546351836511276],
              [-18.599637528966806, -8.549380698210344],
              [-18.58341926284445, -8.553607284799986],
              [-18.57180200041321, -8.559237724435842],
              [-18.566117004401082, -8.56361419728377],
              [-18.568013604605863, -8.567261457491874],
              [-18.58594624295685, -8.558448310871025],
              [-18.598863842868788, -8.554433208826174],
              [-18.607083157342235, -8.55795763521784],
              [-18.605011299615008, -8.562269707693726],
              [-18.596041428900634, -8.560695189440606],
              [-18.589935525041074, -8.564834843396342],
              [-18.583642644011814, -8.566608410211199],
              [-18.584841260933462, -8.572871933753902],
              [-18.5817122449396, -8.580016872854202],
              [-18.583787364234343, -8.587831571407294],
              [-18.59024749478383, -8.599620476557696],
              [-18.603938925866245, -8.610396816475218],
              [-18.608569059295885, -8.620022937427242],
              [-18.609999220913135, -8.63621041419955],
              [-18.61298379461543, -8.64154779287449],
              [-18.607669813019854, -8.649331743838228],
              [-18.60790797019295, -8.65806496443934],
              [-18.610137923430994, -8.663707056981568],
              [-18.613558944353493, -8.665351777405128],
              [-18.625036213318257, -8.676426551882493],
              [-18.633294446863353, -8.676020430083605],
              [-18.645760894871934, -8.677369140902274],
              [-18.648631411734723, -8.68222442286511],
              [-18.645350591924746, -8.686484832698792],
              [-18.641171342054417, -8.6854150876608],
              [-18.634000041610335, -8.690989254871127],
              [-18.62931026747352, -8.69108901333095],
              [-18.621965017458518, -8.687151396462808],
              [-18.62089537687627, -8.698086617102716],
              [-18.618387975920335, -8.7105345945631],
              [-18.61024608150523, -8.726691923727312],
              [-18.60250769230028, -8.73238390445707],
              [-18.598615373634395, -8.733034560153747],
              [-18.591944279661703, -8.737611483311769],
              [-18.584044436000372, -8.734600882541775],
              [-18.577876361661158, -8.735167229106183],
              [-18.57118978410995, -8.731195944153315],
              [-18.553662092571745, -8.734443696481225],
              [-18.54852653636717, -8.733670591982394],
              [-18.545976958317755, -8.738265654589528],
              [-18.538816016286606, -8.742046251623288],
              [-18.52854886324853, -8.744034191327412],
              [-18.52510906925173, -8.74658832857309],
              [-18.51704550139909, -8.74658586788055],
              [-18.501136774403456, -8.743642485258336],
              [-18.494339610242218, -8.739661491975015],
              [-18.48375905872779, -8.74403050086366],
              [-18.466137706166155, -8.742302106728534],
              [-18.462773899815343, -8.748655270128824],
              [-18.458028204619314, -8.750895023995445],
              [-18.45732533747393, -8.755958046597122],
              [-18.451623591669946, -8.763231632308015],
              [-18.441460989451052, -8.763369984355062],
              [-18.432345608605686, -8.762149239935653],
              [-18.425330204018305, -8.759854536426587],
              [-18.422250464730265, -8.762822274715147],
              [-18.420659599718476, -8.768716010761318],
              [-18.415813010261044, -8.771577286688332],
              [-18.40222637174685, -8.76972692860636],
              [-18.394071721694488, -8.767006815597927],
              [-18.38090332114382, -8.759060887791295],
              [-18.377358157286725, -8.76312036599229],
              [-18.36482551735153, -8.765678982147104],
              [-18.359526620259953, -8.769164997444],
              [-18.346687572524395, -8.7830859045741],
              [-18.345295184073937, -8.789390170441262],
              [-18.351205074111345, -8.79766292045566],
              [-18.35043523273174, -8.801552608130317],
              [-18.33656518443974, -8.802539327111322],
              [-18.332493207243186, -8.79758309794575],
              [-18.339410084501754, -8.790246551718525],
              [-18.33282889516893, -8.77954757139926],
              [-18.324335968632678, -8.773540374381989],
              [-18.315630194571558, -8.759204285044285],
              [-18.314914363603403, -8.754327072293016],
              [-18.308690144249987, -8.74590745427317],
              [-18.302768028672702, -8.732776068976042],
              [-18.29452658779268, -8.720809388929395],
              [-18.290763603282794, -8.711754000049318],
              [-18.286394292940205, -8.710527596843034],
              [-18.281460906871732, -8.706326521627425],
              [-18.271339100827802, -8.708891497189127],
              [-18.261791046572977, -8.709202289019146],
              [-18.258635636518523, -8.722852436592563],
              [-18.246181649318235, -8.727981934212314],
              [-18.2411882725251, -8.728375721968144],
              [-18.226821150367417, -8.722463480194113],
              [-18.226259841464522, -8.728324563878306],
              [-18.228117227575563, -8.739293552174196],
              [-18.221868883392442, -8.74064499154995],
              [-18.2175353607864, -8.738924733728137],
              [-18.20894414342405, -8.731722758046386],
              [-18.20738613902344, -8.72701030176734],
              [-18.213411605840754, -8.720988382924565],
              [-18.215305835230396, -8.713573736344882],
              [-18.220472923788257, -8.70592586576898],
              [-18.221737648894816, -8.697235767477338],
              [-18.22835661840045, -8.685742521245142],
              [-18.241458369618066, -8.679899131662612],
              [-18.247904107604146, -8.674833643702828],
              [-18.258905359009336, -8.668681151736155],
              [-18.266416951148365, -8.667401950221752],
              [-18.276039379608036, -8.66099067526348],
              [-18.283204507904227, -8.658297576280637],
              [-18.291046208109755, -8.658317666521652],
              [-18.304108630358467, -8.656060176737178],
              [-18.31239285323556, -8.660684541723642],
              [-18.326300327354886, -8.666190638543965],
              [-18.332754645950445, -8.66595135750641],
              [-18.336842812711147, -8.668377876336377],
              [-18.338566332001346, -8.678644094638818],
              [-18.342211288571367, -8.677772946530288],
              [-18.33291507149582, -8.656930478214584],
              [-18.326830923932537, -8.636399309914108],
              [-18.324929631331077, -8.622632000362174],
              [-18.32615866827271, -8.611882353341773],
              [-18.328182972247777, -8.607009707850107],
              [-18.336974734680087, -8.59212917845644],
              [-18.35167876831615, -8.577002939719641],
              [-18.352886954150666, -8.565027417309352],
              [-18.35821702517813, -8.550836953950839],
              [-18.362310706031153, -8.544795046938328],
              [-18.368758471794774, -8.538959575946008],
              [-18.381710619348315, -8.533052938321783],
              [-18.40159996105835, -8.527776725432961],
              [-18.400802228560504, -8.51868437786995],
              [-18.401858355874698, -8.511728226827916],
              [-18.406148396499873, -8.498331192713634],
              [-18.41233087357284, -8.486920248683896],
              [-18.412115215377966, -8.476603490552428],
              [-18.40835924118674, -8.469495487374303],
              [-18.400425079206606, -8.469622990934203],
              [-18.395558369215255, -8.468166290516553],
              [-18.392816102140866, -8.458957743384653],
              [-18.388000779768905, -8.454036175034028],
              [-18.38603763905555, -8.463274021652875],
              [-18.380551873925086, -8.46596422176648],
              [-18.371003189115772, -8.461268975065801],
              [-18.366453775933397, -8.460705637819883],
              [-18.35900719321752, -8.48690935356024],
              [-18.349851014755288, -8.501916141049254],
              [-18.34653930972452, -8.512192887048833],
              [-18.343260698046283, -8.516477309668428],
              [-18.333762794676392, -8.519681297021572],
              [-18.33352609240046, -8.526179633032054],
              [-18.336927142258663, -8.535434674152242],
              [-18.344613209327957, -8.544842544510963],
              [-18.344678257169917, -8.553870103911914],
              [-18.34632574757806, -8.564218440527663],
              [-18.341671347495083, -8.569338121479484],
              [-18.34151951615693, -8.572282938672299],
              [-18.333542903387812, -8.586363001374364],
              [-18.330779391820155, -8.598362725090006],
              [-18.320906713851457, -8.609450547165732],
              [-18.314127646359594, -8.61835501601457],
              [-18.304718534306737, -8.627049607787788],
              [-18.29951279279025, -8.62952185091888],
              [-18.294817545015373, -8.637132938754702],
              [-18.2870781054269, -8.64343764596834],
              [-18.277942493970617, -8.643593252444855],
              [-18.261668245275654, -8.638666887925096],
              [-18.257215324941146, -8.63545881274588],
              [-18.24992802254555, -8.634255482427045],
              [-18.244974702857903, -8.627882677873343],
              [-18.2371692491798, -8.621404674919216],
              [-18.226610488582846, -8.61853093153845],
              [-18.22719278523357, -8.627632101902057],
              [-18.2245930013418, -8.633220102215008],
              [-18.215808262331826, -8.633986385639616],
              [-18.208180892706963, -8.64325176071245],
              [-18.203248124249445, -8.656354661863524],
              [-18.199018595791834, -8.658454977219499],
              [-18.187702529760124, -8.66840375460711],
              [-18.181748554486095, -8.6779242568315],
              [-18.177753750446964, -8.68192652316322],
              [-18.163288469391002, -8.682035398434472],
              [-18.157349106470942, -8.686627010699464],
              [-18.14906812029455, -8.684260678617594],
              [-18.14374449871216, -8.686815266073369],
              [-18.13582842188509, -8.681793862533553],
              [-18.119286360756796, -8.68326920884945],
              [-18.113727644956395, -8.68132641538882],
              [-18.105483598601555, -8.683497848625771],
              [-18.09971091447923, -8.681081043279569],
              [-18.094033927658568, -8.655438707473879],
              [-18.09454533737346, -8.648608157619563],
              [-18.092417072121687, -8.642132639427025],
              [-18.095987274546125, -8.62680620759917],
              [-18.109181786965163, -8.603775758818951],
              [-18.113858175330293, -8.59940672484451],
              [-18.11850980158526, -8.597862148194007],
              [-18.127610762299046, -8.598519090900515],
              [-18.13264277085601, -8.601092067473372],
              [-18.13130031325096, -8.60441309989081],
              [-18.13730953218458, -8.610713309461017],
              [-18.149326217110303, -8.606673642491623],
              [-18.15598511659591, -8.603203522776278],
              [-18.15876803395166, -8.599351928295292],
              [-18.16336088184682, -8.587969667283193],
              [-18.16844310817467, -8.583323071721823],
              [-18.175238641539803, -8.579670338363558],
              [-18.18800691363242, -8.579669715021073],
              [-18.196131592942134, -8.583520663629617],
              [-18.218350522587425, -8.582897835092485],
              [-18.229592003187975, -8.595878825883196],
              [-18.227811451492833, -8.599700692008533],
              [-18.233578459674604, -8.602363096933082],
              [-18.232003798298933, -8.608132347977584],
              [-18.23328046975867, -8.61404513210612],
              [-18.2436030668278, -8.619088025263228],
              [-18.257347755437994, -8.617488764711451],
              [-18.267542951088675, -8.609517693866218],
              [-18.271753636507373, -8.610633972277915],
              [-18.27719536491335, -8.605762029803055],
              [-18.274013426698563, -8.598011296954827],
              [-18.27466497892535, -8.594523669010107],
              [-18.28105047007128, -8.593602846756026],
              [-18.287915920935085, -8.584519951553204],
              [-18.29434639597785, -8.580594997983363],
              [-18.300328159551615, -8.568715636835654],
              [-18.302772698938153, -8.567222098253882],
              [-18.30967540861487, -8.555754948824593],
              [-18.304372260672963, -8.549448193353854],
              [-18.303392620407838, -8.545671984209793],
              [-18.311066570250002, -8.542931070991242],
              [-18.317336879024946, -8.543393738160646],
              [-18.310139637671995, -8.529087560153764],
              [-18.312222479723168, -8.522418955773754],
              [-18.30936766649741, -8.512139067119325],
              [-18.304013872439057, -8.50993537595439],
              [-18.300214555220915, -8.505473422425158],
              [-18.297122466274445, -8.49663618067259],
              [-18.298456810343193, -8.488774798541005],
              [-18.296261227197217, -8.485511908620827],
              [-18.2857527200171, -8.478879939514176],
              [-18.284021137862677, -8.47040163975546],
              [-18.27818821480434, -8.470395600862203],
              [-18.27525467719051, -8.467338258122576],
              [-18.270756303933325, -8.468307011808374],
              [-18.26386560471436, -8.473636619396176],
              [-18.253935131989007, -8.473634797471226],
              [-18.251959349400952, -8.465568863574731],
              [-18.254686386038, -8.45941422694813],
              [-18.25912048947947, -8.455431773069293],
              [-18.266709953021564, -8.45583472961147],
              [-18.269497939454276, -8.447789647887774],
              [-18.273566490962924, -8.447419346539288],
              [-18.278790575559576, -8.441449133501887],
              [-18.284978414664096, -8.444236025487875],
              [-18.288462703191325, -8.437162402829244],
              [-18.29598026779174, -8.430850365796903],
              [-18.301739838483652, -8.42992947412672],
              [-18.308764655084335, -8.431951747259708],
              [-18.316137028320917, -8.431394534864824],
              [-18.33834490866044, -8.435286202249012],
              [-18.356412333050237, -8.44245009160733],
              [-18.37361827528468, -8.440992973288282],
              [-18.381618200494408, -8.442644167923332],
              [-18.383593106939806, -8.438388940443199],
              [-18.380767554615765, -8.428450771594068],
              [-18.38673756804908, -8.432397357159443],
              [-18.393306978390154, -8.432811091890187],
              [-18.40155401668146, -8.429656274992066],
              [-18.406160135315613, -8.431943330229355],
              [-18.411188274448932, -8.425606266656727],
              [-18.412668357093594, -8.418592326088636],
              [-18.418081014587884, -8.41409013771985],
              [-18.42952909321959, -8.415787369226909],
              [-18.44285342615119, -8.414833162923683],
              [-18.45364875754715, -8.419085765066672],
              [-18.460655476267736, -8.415341113566333],
              [-18.47247667430868, -8.411336655466394],
              [-18.484757202557045, -8.40505140547352],
              [-18.497342522539824, -8.400506828180845],
              [-18.517526231155827, -8.390393414828184],
              [-18.53393151950204, -8.384920009115943],
              [-18.543665101764038, -8.380815167720296],
              [-18.550889246730605, -8.373915249354988],
              [-18.553281957402195, -8.369253873285738],
              [-18.549446361745595, -8.351022213728386],
              [-18.548690550427835, -8.328434352303269],
              [-18.549764782874234, -8.310551668313552],
              [-18.55078042189666, -8.308961369427616],
              [-18.552537878441083, -8.287815457000397],
              [-18.55477601266299, -8.272696124926787],
              [-18.557935493737652, -8.259373311842289],
              [-18.567549182325973, -8.223454761922143],
              [-18.571483534518304, -8.212060895579278],
              [-18.57570886888611, -8.203306584745047],
              [-18.585632674309707, -8.1891836280157],
              [-18.62690536681359, -8.15074312875589],
              [-18.637137365377818, -8.135529205116779],
              [-18.66381995790304, -8.098573244444047],
              [-18.66918967521883, -8.092919340868692],
              [-18.688962077307846, -8.06657300810299],
              [-18.69689768012487, -8.058551999124349],
              [-18.703523667240386, -8.046071289663757],
              [-18.714821680482213, -8.031784329203505],
              [-18.73099683580547, -8.017814143339438],
              [-18.753258273536094, -8.00329543867013],
              [-18.769645145303826, -7.995946064282304],
              [-18.779214914706344, -7.990540651764657],
              [-18.789680735419264, -7.979622711051401],
              [-18.791322033438252, -7.976702863931893],
              [-18.7925523656051, -7.9659926834237655],
              [-18.795816862514204, -7.955872020580773],
              [-18.80498022935371, -7.939722614607954],
              [-18.8160833498943, -7.926868587143534],
              [-18.82303355385603, -7.92041056738239],
              [-18.835932410187972, -7.910663717386861],
              [-18.857119414589732, -7.897934444450117],
              [-18.869598052213288, -7.892549299008915],
              [-18.880281248575393, -7.88994753042894],
              [-18.88589421766108, -7.887358283556275],
              [-18.87499843263899, -7.883954107205079],
              [-18.84348550194049, -7.877703275885914],
              [-18.82356418090825, -7.872056840678393],
              [-18.81809815176474, -7.868614840593005],
              [-18.812759781726186, -7.860755261398049],
              [-18.812080626944955, -7.853688187803864],
              [-18.80868345448018, -7.847334746947759],
              [-18.80911320789766, -7.84362327293006],
              [-18.79791282233061, -7.829987363103289],
              [-18.795078876358026, -7.822499163711984],
              [-18.795534518001492, -7.817929665164185],
              [-18.790191331110762, -7.801780166248637],
              [-18.791675328598924, -7.7992816077699345],
              [-18.78463144277859, -7.786844277112583],
              [-18.784099484581226, -7.77923351102787],
              [-18.777488292570204, -7.753184347635234],
              [-18.776621511089267, -7.723738794596742],
              [-18.774901659203564, -7.722068794632848],
              [-18.754888336045294, -7.729164817191064],
              [-18.70775982191886, -7.743981990281163],
              [-18.695166932278777, -7.74698955838541],
              [-18.690314123957197, -7.746824972160915],
              [-18.671052751163664, -7.749342063630528],
              [-18.659404003114716, -7.749824754851289],
              [-18.626955120113504, -7.748930173787156],
              [-18.604953839357652, -7.747622348453035],
              [-18.58459180371179, -7.747585582134296],
              [-18.571163621368665, -7.745106439760119],
              [-18.555424040540455, -7.747604535203494],
              [-18.539992740298125, -7.747992378793287],
              [-18.520169060680374, -7.746583426031586],
              [-18.510124892599666, -7.743320826532475],
              [-18.501266360417098, -7.738025680419897],
              [-18.487304091043775, -7.7338341809968405],
              [-18.479441387078804, -7.730506300951888],
              [-18.46632860576744, -7.719182599148807],
              [-18.44637935993369, -7.708826769655333],
              [-18.428051402793386, -7.693070355575932],
              [-18.420528127183278, -7.684293809848961],
              [-18.413933949525113, -7.674046353839303],
              [-18.397164581932405, -7.658293880929452],
              [-18.383890680496037, -7.643218452769093],
              [-18.377448986677976, -7.633938471080689],
              [-18.368569888668535, -7.616205093992048],
              [-18.36303376197031, -7.601903363900101],
              [-18.36006639526737, -7.57972345821101],
              [-18.357340884849712, -7.563952995727454],
              [-18.354739098603122, -7.538926019757063],
              [-18.35207009771691, -7.527884755628924],
              [-18.345931776391833, -7.515503167897151],
              [-18.342458804043993, -7.504681102703968],
              [-18.329990273240377, -7.47474571051111],
              [-18.32248145336756, -7.464388128550708],
              [-18.303592000940206, -7.444536845912249],
              [-18.282035561673492, -7.420394446860162],
              [-18.268433523555696, -7.401465044089398],
              [-18.263849428923603, -7.393490584303855],
              [-18.25630788448989, -7.385640808447114],
              [-18.248941308151277, -7.373970565175188],
              [-18.22889071200675, -7.35249580979536],
              [-18.22072805198714, -7.346676905753947],
              [-18.199082635392116, -7.33334612917524],
              [-18.191194421901322, -7.327681432340475],
              [-18.176646553183375, -7.319418268439252],
              [-18.16895794570854, -7.3132929004932645],
              [-18.13946454440835, -7.32476561568581],
              [-18.118534110460196, -7.330909371945689],
              [-18.099688646520406, -7.332317867256784],
              [-18.08257898086042, -7.326950111750153],
              [-18.070672539466734, -7.324748862276717],
              [-18.0350455075446, -7.309011128844612],
              [-18.00515519503338, -7.290638276662911],
              [-17.977154303211453, -7.268436771133604],
              [-17.961893208602095, -7.2546181055431935],
              [-17.947231225289112, -7.237065533162824],
              [-17.940392606297664, -7.232233967904437],
              [-17.920343079083903, -7.2116463927845],
              [-17.90848366774283, -7.2024790145191595],
              [-17.899574657302015, -7.194031682221227],
              [-17.889044109491085, -7.182368424880731],
              [-17.87635177533093, -7.175930355014404],
              [-17.835462359791176, -7.16115061401559],
              [-17.83591095636217, -7.162913831351071],
              [-17.848447653302234, -7.1668266616912915],
              [-17.84814560597198, -7.168976879660431],
              [-17.834927267238886, -7.168860818236604],
              [-17.831750857790368, -7.165653638388683],
              [-17.825848766711445, -7.179841146231237],
              [-17.83447982216904, -7.1791485946704725],
              [-17.84619329660105, -7.180200342215102],
              [-17.853124622511608, -7.182019443944626],
              [-17.85386918847702, -7.189971410354031],
              [-17.851224863851854, -7.1918902092912],
              [-17.849111802569706, -7.198238739519461],
              [-17.84380340338816, -7.192984989428848],
              [-17.837125064201487, -7.198515691552512],
              [-17.828193541610585, -7.1996034372912625],
              [-17.82222084369513, -7.197909640785422],
              [-17.812799143454924, -7.1988060810390415],
              [-17.809589004478404, -7.19756425327684],
              [-17.80741409850113, -7.1917914207926446],
              [-17.80998113291408, -7.189388548515542],
              [-17.820400962388053, -7.185035591243688],
              [-17.820039359319296, -7.1805230275501994],
              [-17.806996444692253, -7.1882913035024805],
              [-17.798035534472767, -7.1906950602395],
              [-17.77419486779801, -7.1944753306254485],
              [-17.76522008011635, -7.193485977156853],
              [-17.762117214699057, -7.191694486572964],
              [-17.75567087386738, -7.1930677126958695],
              [-17.748384090559583, -7.189083049938778],
              [-17.742381176610134, -7.192025401238782],
              [-17.733994139923922, -7.185633675382296],
              [-17.720245864281917, -7.18717275242013],
              [-17.704323090943152, -7.18529317102233],
              [-17.698392325235112, -7.183850403132933],
              [-17.680529402490258, -7.177351394419894],
              [-17.66682333733797, -7.170510922108442],
              [-17.66037910065426, -7.166330679239046],
              [-17.63437606977418, -7.147507829588877],
              [-17.62437504355789, -7.138456365181711],
              [-17.607709643348326, -7.120554180420353],
              [-17.598692995127962, -7.108373482766848],
              [-17.584419344999723, -7.085806253328355],
              [-17.580151824328638, -7.080443950638369],
              [-17.56735168275775, -7.061332752615576],
              [-17.548626183097696, -7.03669554719192],
              [-17.529065348750397, -7.0201564816113216],
              [-17.520041286163472, -7.015576051282917],
              [-17.519768793680377, -7.0280465768796745],
              [-17.51671135664917, -7.034930690286493],
              [-17.50892597578705, -7.03859524628779],
              [-17.506202340824053, -7.037130875426997],
              [-17.50153672103466, -7.045060496287445],
              [-17.498214254141452, -7.047146526347584],
              [-17.48949105418442, -7.046501977899411],
              [-17.47671758325457, -7.050384788153191],
              [-17.473614688182238, -7.053275289438534],
              [-17.465131677019, -7.056006100323501],
              [-17.46653143821403, -7.061655450114997],
              [-17.459814243497792, -7.068600157155638],
              [-17.464598448892268, -7.080090128240249],
              [-17.458170152420088, -7.078633638871194],
              [-17.451299327593443, -7.074220359954951],
              [-17.449606979583013, -7.065773546151157],
              [-17.447170162009044, -7.066493070230521],
              [-17.443785358330313, -7.074397244465104],
              [-17.43395460304854, -7.072290273900007],
              [-17.426918778308245, -7.072764876863296],
              [-17.422757515827332, -7.077654084253406],
              [-17.41610338492626, -7.077131776598933],
              [-17.406728488629412, -7.083536741978311],
              [-17.407199427851058, -7.0923313840807785],
              [-17.401166994096744, -7.1061471199374795],
              [-17.40092980845948, -7.110844749955578],
              [-17.404841411398564, -7.118082223978835],
              [-17.40910286574739, -7.1199992458346495],
              [-17.4112362964715, -7.12474360727668],
              [-17.41541510944759, -7.124223466151975],
              [-17.418991673900784, -7.131098898618671],
              [-17.424857477965936, -7.135020474242042],
              [-17.427221762611556, -7.1439601653021265],
              [-17.4341803140324, -7.143803570559463],
              [-17.436067913853847, -7.148909933776504],
              [-17.442727173310438, -7.147819572654255],
              [-17.461836242425978, -7.151176920818906],
              [-17.45897484855805, -7.154527413189739],
              [-17.456101757609026, -7.168067828227777],
              [-17.450975028338473, -7.185978543348645],
              [-17.452452880438795, -7.193078910118909],
              [-17.44574264254439, -7.195697263085413],
              [-17.43760797607044, -7.194409000022393],
              [-17.43327786965891, -7.1958907938761865],
              [-17.425517724413453, -7.194408184933096],
              [-17.420721111423113, -7.191320645898306],
              [-17.418897360975397, -7.197067366314676],
              [-17.41422034938771, -7.1982558404938946],
              [-17.410233512617594, -7.1915612754835525],
              [-17.400042660347104, -7.187648104662346],
              [-17.39896160785825, -7.179268618320153],
              [-17.399733840773433, -7.169684636103033],
              [-17.402001637861837, -7.15815721671006],
              [-17.39691980486079, -7.157664120946176],
              [-17.385814175224574, -7.145381702886396],
              [-17.384708599257536, -7.140895625516067],
              [-17.371592238891097, -7.134100907337042],
              [-17.366445491971657, -7.1464131616555875],
              [-17.36173911627607, -7.14536616048823],
              [-17.360061102820833, -7.138246982336055],
              [-17.36287222522598, -7.128907525717298],
              [-17.369360691670234, -7.1199983995986],
              [-17.371384005163915, -7.113757625646477],
              [-17.366750815565897, -7.108914424391191],
              [-17.358872204075453, -7.103502560082915],
              [-17.355381627098858, -7.11478732313073],
              [-17.350193449737795, -7.115932146763399],
              [-17.349095741156564, -7.104394014972892],
              [-17.350227076439435, -7.094565407752862],
              [-17.35216980959441, -7.090098345361583],
              [-17.349463304300563, -7.087902161413204],
              [-17.331513349208127, -7.100511708721195],
              [-17.31342669161722, -7.116501741168369],
              [-17.298109514365287, -7.133316683501668],
              [-17.291362679568905, -7.143933130856765],
              [-17.296157332671015, -7.149807438496446],
              [-17.297385424247754, -7.1594852689428174],
              [-17.297211212987868, -7.173574736328812],
              [-17.29601579636432, -7.189072353348868],
              [-17.29391697514142, -7.197527754833462],
              [-17.28257044039371, -7.200515898083224],
              [-17.272956958374078, -7.19823925808978],
              [-17.26598483199593, -7.198268559842107],
              [-17.25527653827867, -7.203154836871759],
              [-17.251279713490696, -7.210843484343833],
              [-17.254459398558662, -7.216149034978733],
              [-17.246735375237396, -7.2194458034240565],
              [-17.241472366945647, -7.217722577176705],
              [-17.234245418186614, -7.212256556627373],
              [-17.225324046135718, -7.202528560128712],
              [-17.218494070152033, -7.187366011011058],
              [-17.218707158237226, -7.182735830187861],
              [-17.21132796700637, -7.18055765969307],
              [-17.19660151554082, -7.178508455604716],
              [-17.172420097886086, -7.180127511041061],
              [-17.16313566729323, -7.179583516151804],
              [-17.15570434194726, -7.177485762764469],
              [-17.137936433360718, -7.167945823387088],
              [-17.13164686328862, -7.167160588325866],
              [-17.113171060218484, -7.170235724151399],
              [-17.108729615310608, -7.175593351439413],
              [-17.099406622434554, -7.177061339657],
              [-17.092496483982774, -7.190257730367192],
              [-17.086273175696654, -7.19116972186513],
              [-17.0824666933839, -7.179758501346568],
              [-17.06922789523278, -7.180709917248476],
              [-17.059142348486766, -7.179338748450254],
              [-17.048452162774655, -7.184436710033357],
              [-17.03764158247743, -7.18699245773431],
              [-17.033250475822722, -7.190847349450776],
              [-17.01717832515892, -7.196961553599362],
              [-17.01358329686022, -7.201258261033654],
              [-17.013095511130164, -7.2058006483896255],
              [-17.020445896831603, -7.208068089695055],
              [-17.025797405341155, -7.213151647801638],
              [-17.034305438383164, -7.235374139370301],
              [-17.039611873225727, -7.242940001525666],
              [-17.045629911284777, -7.2438942821668375],
              [-17.043426947073918, -7.262463498493908],
              [-17.038560082208924, -7.2710705718311],
              [-17.029399648331797, -7.275443029421188],
              [-17.025897095201902, -7.273394685483034],
              [-17.009624608334438, -7.278909134456121],
              [-17.003063512058045, -7.276846173914131],
              [-16.997237569025774, -7.278710934871321],
              [-16.995868299255527, -7.285451960836925],
              [-17.004173021569382, -7.2835206775767105],
              [-17.013200647028533, -7.2797582488614605],
              [-17.017874756551098, -7.283943754305041],
              [-17.022273623061885, -7.282590714267691],
              [-17.036688186168725, -7.283806861427985],
              [-17.04899306200205, -7.281022982790978],
              [-17.054323450801405, -7.2870583249835175],
              [-17.049246674945486, -7.295485947281535],
              [-17.04183879528608, -7.293593947923167],
              [-17.039319783473154, -7.290720207474173],
              [-17.02861503204564, -7.290861397996089],
              [-17.024442913339414, -7.292702203705484],
              [-17.014047183114066, -7.294427580093674],
              [-17.01077878971323, -7.291389083108454],
              [-17.00231608615446, -7.290122259774135],
              [-16.993852553958973, -7.291992954981459],
              [-16.991127991134082, -7.286646487622364],
              [-16.985728424807537, -7.285099485886356],
              [-16.978179100662576, -7.288382746572713],
              [-16.974542255580378, -7.287191426720103],
              [-16.96636531700928, -7.290418492025083],
              [-16.95469101534709, -7.2869854363921815],
              [-16.955642719228027, -7.291773987738844],
              [-16.963162997202666, -7.305005145159775],
              [-16.96052501027518, -7.310972311284416],
              [-16.96671896665428, -7.311445880151683],
              [-16.97679080926204, -7.315282018377218],
              [-16.980905527696482, -7.321160634384197],
              [-16.97942067140513, -7.325069658923345],
              [-16.971515211401346, -7.330285621229818],
              [-16.968249891976118, -7.328811177054897],
              [-16.958187180473693, -7.328047699071176],
              [-16.9511349910961, -7.3294644267174345],
              [-16.941243571886268, -7.32825755823403],
              [-16.93530525112404, -7.3261374359277855],
              [-16.926855487490617, -7.330074680389794],
              [-16.907561941110508, -7.335458183552234],
              [-16.901997123198832, -7.338005875471862],
              [-16.895453033880315, -7.347381669465071],
              [-16.883578999908313, -7.345115647122956],
              [-16.882221421811497, -7.340297417695445],
              [-16.876697867127326, -7.336389296155935],
              [-16.872412720224958, -7.327506198642879],
              [-16.86144416990518, -7.31621868163803],
              [-16.85587291094129, -7.31550307145973],
              [-16.849939922556814, -7.318350742521601],
              [-16.841910123053967, -7.314039970486843],
              [-16.83663491703307, -7.314462110561373],
              [-16.831162289382096, -7.318801744537452],
              [-16.827460306184598, -7.313332782586838],
              [-16.827282007082307, -7.308448924466587],
              [-16.810394480467455, -7.305693318520079],
              [-16.80748995262443, -7.309603033504979],
              [-16.797507121134984, -7.313002853351539],
              [-16.79246213917532, -7.319947231443987],
              [-16.793662612715615, -7.32351118489612],
              [-16.79018261987428, -7.329842322093578],
              [-16.770777036323206, -7.3201051482072685],
              [-16.760563444965136, -7.321289368331626],
              [-16.75322748868935, -7.3148819519233275],
              [-16.733010420505185, -7.291793516914377],
              [-16.72820565208509, -7.2972040460947785],
              [-16.722332917034056, -7.299404055881736],
              [-16.71530148749012, -7.2927275429980085],
              [-16.70738869486668, -7.292288576429105],
              [-16.69907803608882, -7.294767967055233],
              [-16.692958837825714, -7.292755335537484],
              [-16.68598266219002, -7.28691854054343],
              [-16.67985380633856, -7.295175322006197],
              [-16.67580324045027, -7.296149789980084],
              [-16.6697969548697, -7.290879324096354],
              [-16.663160656860406, -7.294820601703154],
              [-16.657953150782163, -7.293995953447917],
              [-16.64825160531086, -7.295627092868013],
              [-16.645248879215217, -7.299011433889259],
              [-16.636319778903243, -7.3013167445474485],
              [-16.63017023790441, -7.307748189506421],
              [-16.62133997900538, -7.31508012817311],
              [-16.617145923085367, -7.313541096898216],
              [-16.610142490104856, -7.315455005862813],
              [-16.602158247697894, -7.3197779993440575],
              [-16.594217851579284, -7.315762543552954],
              [-16.59225931677844, -7.317915220642066],
              [-16.58565976651314, -7.317177838723323],
              [-16.5827758902815, -7.321515966262971],
              [-16.578020118791255, -7.319603284524188],
              [-16.57277574751373, -7.326678101727684],
              [-16.570610609546083, -7.325617635418567],
              [-16.563523137620695, -7.331594911502566],
              [-16.561428173470876, -7.338129289313528],
              [-16.563552605818884, -7.343127778008317],
              [-16.553681263730333, -7.349847499073768],
              [-16.547641260437203, -7.349344801581738],
              [-16.536761401631242, -7.338395367741639],
              [-16.534152437608746, -7.338866502923831],
              [-16.533024798775102, -7.347215739139961],
              [-16.526887480431522, -7.3509750560518325],
              [-16.5192732957528, -7.333640545369183],
              [-16.516626215527832, -7.337792098925859],
              [-16.510760030285617, -7.339536921143837],
              [-16.507291082205917, -7.3441060387137655],
              [-16.498089458783802, -7.3446533556330635],
              [-16.497992531521078, -7.348846354116233],
              [-16.49298310719201, -7.349010770058233],
              [-16.49295328192732, -7.356025151762439],
              [-16.489394358171158, -7.356888212424957],
              [-16.479652998250113, -7.352924967650097],
              [-16.480635725740875, -7.363591478030296],
              [-16.484845857823995, -7.366503108945525],
              [-16.47612234262283, -7.372742131605159],
              [-16.472173158432923, -7.371404304365054],
              [-16.46268438593537, -7.375695237445848],
              [-16.44633703651336, -7.3738395417914235],
              [-16.42764862248626, -7.378528181968101],
              [-16.422725978554254, -7.377809228141887],
              [-16.41593868454693, -7.374203699960345],
              [-16.410236168494293, -7.374814661763206],
              [-16.408893648014622, -7.381679997825799],
              [-16.40470340477147, -7.381986163207036],
              [-16.40100899814469, -7.3869593791256385],
              [-16.396247945032925, -7.384672813241929],
              [-16.392779252112078, -7.38578133641122],
              [-16.378869740318546, -7.38446997051649],
              [-16.376718012445284, -7.385266128618331],
              [-16.370429184210852, -7.3786962590752445],
              [-16.36594026895712, -7.378121511353856],
              [-16.36308808890196, -7.373268700508233],
              [-16.353206641387942, -7.372769890156553],
              [-16.34850569497725, -7.374000553781988],
              [-16.340324943557956, -7.373118356790642],
              [-16.335526382905787, -7.370292755371874],
              [-16.330679461694668, -7.370876102793991],
              [-16.324291989861365, -7.367328692135319],
              [-16.318820934749898, -7.368552026644384],
              [-16.29614580420181, -7.3670414194724705],
              [-16.287838730914917, -7.370768459138724],
              [-16.276233430301566, -7.370778056280739],
              [-16.271358094363574, -7.375563786442498],
              [-16.26709926560619, -7.374614271988149],
              [-16.258556226239055, -7.376490327939665],
              [-16.25579811036976, -7.374225426407629],
              [-16.25087786318669, -7.377298414133615],
              [-16.244571580875782, -7.371108371624168],
              [-16.242922879840087, -7.365958891448165],
              [-16.230503939418867, -7.376748754709675],
              [-16.21181855417523, -7.3888873611021],
              [-16.20603265841106, -7.389817932383434],
              [-16.19313212398526, -7.394989864353754],
              [-16.18742045545781, -7.402725667079307],
              [-16.16583637132304, -7.407386467343877],
              [-16.160336439844023, -7.404884613336609],
              [-16.16024950453546, -7.410103544034092],
              [-16.1546432067225, -7.4134773300837455],
              [-16.129711826643188, -7.41657174641303],
              [-16.12706345947061, -7.4205569921044106],
              [-16.119523449375066, -7.418491646391147],
              [-16.111949867364476, -7.410915848021424],
              [-16.09781411435962, -7.413796760164598],
              [-16.087633990375757, -7.412945951979049],
              [-16.0809628841296, -7.407640601907407],
              [-16.069009264371783, -7.386576801633563],
              [-16.06103163382139, -7.383441406920463],
              [-16.049770675596342, -7.38209928932402],
              [-16.045667214333626, -7.375345532246414],
              [-16.03636101711486, -7.372213908912159],
              [-16.033190104503237, -7.367021414127254],
              [-16.025500755004423, -7.362148116274153],
              [-16.01962779357851, -7.360891495422954],
              [-16.01166282936116, -7.355796189245362],
              [-16.007514981641567, -7.348206011334765],
              [-16.00419077390653, -7.347853936162656],
              [-15.997150002950047, -7.350977621584894],
              [-15.991391193981542, -7.348753991300608],
              [-15.991765209793794, -7.344221845778991],
              [-15.981613023306945, -7.33951608808528],
              [-15.974966466143393, -7.338535603155311],
              [-15.97249763496489, -7.334372060859608],
              [-15.966008093496084, -7.333437041957539],
              [-15.952712665800847, -7.338028988382955],
              [-15.9446398514828, -7.3354993556641945],
              [-15.933775356944704, -7.3251324244435745],
              [-15.926375843766381, -7.3297224062702995],
              [-15.90182605148779, -7.339659864884216],
              [-15.89675210379203, -7.342892774711773],
              [-15.884974556638907, -7.3456943636790974],
              [-15.867375078569113, -7.351022638964679],
              [-15.848389000323031, -7.359732488613969],
              [-15.836858010322802, -7.367886212330942],
              [-15.830321997441484, -7.370857529858506],
              [-15.83074548703367, -7.3767162975481835],
              [-15.813430039693179, -7.384511243225781],
              [-15.813948538781233, -7.389451570519301],
              [-15.803143926142134, -7.386688604636072],
              [-15.78099711086191, -7.39915400086614],
              [-15.766873141282469, -7.403787693536269],
              [-15.756359241325764, -7.409024773834812],
              [-15.74665526002499, -7.409632591886588],
              [-15.728928805141326, -7.414368259523991],
              [-15.71264247142658, -7.421046756989454],
              [-15.706019946127707, -7.4248105532715405],
              [-15.687522603947025, -7.438438951445595],
              [-15.690051538313115, -7.440180351418451],
              [-15.683893508105662, -7.446262514221112],
              [-15.681784409957489, -7.452386168191499],
              [-15.672503398462954, -7.459842243443935],
              [-15.658199294378166, -7.457818357517493],
              [-15.658236215177306, -7.451143973317642],
              [-15.655602801858214, -7.438958575335801],
              [-15.645240515444666, -7.440220803597127],
              [-15.62904770559883, -7.446543689787722],
              [-15.604908106831504, -7.567304077778926],
              [-15.577754190932785, -7.703111220419579],
              [-15.554570588859466, -7.818964119206576],
              [-15.552133037098226, -7.832393438264398],
              [-15.531449396372377, -7.935769472967529],
              [-15.513735404593444, -8.0242427393757],
              [-15.48765090273577, -8.15448669217697],
              [-15.417938807227632, -8.502367948248436],
              [-15.380750275532888, -8.687776161830252],
              [-15.371733492925987, -8.732709040818452],
              [-15.337530815384989, -8.902691238469808],
              [-15.313827487814713, -9.020435485016842],
              [-15.247150991555452, -9.352439710949747],
              [-15.184835300480858, -9.66249464085696],
              [-15.165647296072361, -9.757909616071144],
              [-15.145884751293945, -9.856157275678298],
              [-15.126703835494519, -9.95150015809043],
              [-15.110254773576699, -10.033252546211383],
              [-15.103659928401642, -10.066640993416415],
              [-15.083725477573097, -10.165376609945634],
              [-15.05808828302595, -10.292575665738987],
              [-15.029247830546984, -10.435604589029257],
              [-15.000467410260946, -10.578400262266388],
              [-14.99464054105502, -10.607302738834056],
              [-14.981684124980337, -10.609320928147403],
              [-14.95204881111773, -10.615149331834209],
              [-14.906985394926714, -10.620388615378461],
              [-14.902712404299669, -10.588398963950825],
              [-14.812794941772832, -10.614300228950913],
              [-14.775485095944367, -10.552202374011816],
              [-14.67273866624533, -10.52348860849616],
              [-14.669695904554736, -10.534524614521656],
              [-14.673079398308092, -10.617149457582471],
              [-14.641140681436589, -10.643097356228989],
              [-14.592196565811745, -10.656860647942155],
              [-14.575219861733418, -10.65945833781383],
              [-14.565570938115387, -10.678849685012118],
              [-14.560857266942477, -10.690426313790002],
              [-14.55030148516416, -10.702552757873445],
              [-14.517773346874536, -10.722697974237127],
              [-14.466340817669655, -10.754232310867398],
              [-14.418500700224387, -10.783291944708836],
              [-14.374368333347798, -10.810436031646578],
              [-14.331480338061061, -10.83654306058979],
              [-14.308220606923207, -10.880007217661818],
              [-14.290599160281547, -10.91833358601835],
              [-14.288427602427051, -10.945742286546261],
              [-14.274860653968132, -10.941407150070196],
              [-14.251125547149186, -10.90239118325455],
              [-14.193654592939875, -10.839155363148627],
              [-14.188998571844873, -10.830840046963818],
              [-14.147246683621594, -10.8175837775844],
              [-14.139814265909726, -10.781893171580997],
              [-14.142529850114125, -10.776950903362302],
              [-14.138789877805156, -10.772760641103506],
              [-14.148630675939726, -10.74242951577926],
              [-14.156800388290572, -10.712567184277146],
              [-14.13740109237649, -10.713199442310565],
              [-14.127249413626073, -10.705149811709385],
              [-14.121434108869042, -10.682183626144544],
              [-14.124917318519937, -10.670562707003395],
              [-14.148092509810528, -10.662318220176854],
              [-14.12442532396344, -10.64156944088851],
              [-14.085702606380284, -10.623107813397162],
              [-14.018591203273399, -10.555714838410362],
              [-13.992640359697209, -10.57009847054698],
              [-13.970670191098653, -10.577994679680321],
              [-13.967234258052597, -10.577782642330142],
              [-13.961627869400754, -10.588180954690046],
              [-13.94745618991448, -10.597453507021376],
              [-13.940466019828795, -10.596401082830939],
              [-13.919536036581444, -10.61175126526338],
              [-13.910505723704858, -10.641143401240143],
              [-13.916687841405839, -10.651189091849094],
              [-13.918335335458746, -10.660382213720725],
              [-13.895389956290721, -10.668301474956529],
              [-13.898301160253697, -10.683816047725646],
              [-13.879757085006213, -10.701993892584454],
              [-13.832282718960101, -10.699633276051074],
              [-13.822876523204268, -10.717307968263038],
              [-13.797255926766972, -10.731783311382483],
              [-13.783229176756334, -10.72744918952135],
              [-13.772698038007535, -10.739596831081075],
              [-13.756353655580162, -10.752917819860665],
              [-13.754609966724477, -10.773875437221841],
              [-13.736804886042954, -10.774675308179761],
              [-13.736738045402353, -10.788654011239672],
              [-13.716824682837643, -10.805178224743674],
              [-13.657779814739634, -10.821127256702598],
              [-13.631069720577479, -10.8266080117301],
              [-13.59565133011673, -10.858037212393178],
              [-13.560305916011261, -10.879292453447453],
              [-13.519052477631307, -10.899867393593977],
              [-13.529121600463926, -10.918537705556362],
              [-13.49693970323704, -10.948737514985362],
              [-13.478456293344669, -10.960720586792405],
              [-13.453430956536183, -10.979373709259615],
              [-13.4537730296981, -10.980759818241053],
              [-13.41989859087922, -11.024446708375683],
              [-13.366284058501442, -11.06406208123688],
              [-13.331227074534834, -11.10270385245664],
              [-13.304271964887851, -11.124985881538082],
              [-13.301921862249882, -11.128620316828355],
              [-13.272058450178159, -11.15907576442408],
              [-13.22819239905978, -11.19217516285126],
              [-13.220800179332327, -11.198281156603183],
              [-13.185510136892882, -11.234067976391549],
              [-13.19374895225893, -11.280304854478182],
              [-13.130308674940535, -11.276005642388094],
              [-13.124944558137935, -11.336525310891009],
              [-13.071937591802469, -11.343251029828602],
              [-13.07103949547933, -11.361982157102053],
              [-13.057910479381691, -11.375970947337752],
              [-13.041396969249227, -11.408118294720696],
              [-12.996740790119057, -11.388103587434236],
              [-12.97001730693759, -11.40058985599056],
              [-12.903658928903265, -11.415093706086742],
              [-12.882845291103223, -11.423664695119015],
              [-12.822629369051608, -11.4166108582225],
              [-12.781707971147771, -11.43850889892553],
              [-12.764276185094596, -11.439333835995399],
              [-12.750506272924566, -11.435959608226074],
              [-12.730518680163335, -11.465884181117],
              [-12.715069242011738, -11.465032220390468],
              [-12.692170245357431, -11.468441560227525],
              [-12.669423926621187, -11.450404125504683],
              [-12.63692354705123, -11.480504913865552],
              [-12.62761704247958, -11.512345992775954],
              [-12.624504810731388, -11.51290311874915],
              [-12.62854182483081, -11.54579654009191],
              [-12.634149001047229, -11.55375493566591],
              [-12.634388665972464, -11.568272514768836],
              [-12.627274611387975, -11.58444218076246],
              [-12.616602759755134, -11.59229627518827],
              [-12.607049590871785, -11.62611812540218],
              [-12.589760518101816, -11.650189653361549],
              [-12.575025516924029, -11.661704713159702],
              [-12.557214570162836, -11.69683704776773],
              [-12.544287794579823, -11.70581423940424],
              [-12.541538846766564, -11.711559653961675],
              [-12.554517611444366, -11.749078964624704],
              [-12.556486960566563, -11.76802257813778],
              [-12.555425387234576, -11.774304114449373],
              [-12.556656897950823, -11.78696766890702],
              [-12.554419110444496, -11.79654258631263],
              [-12.559640372885093, -11.83096289827962],
              [-12.566314323864002, -11.853556986495079],
              [-12.575530821470203, -11.873507521148781],
              [-12.579432098269777, -11.884017490459971],
              [-12.593197747864915, -11.909543170214276],
              [-12.603553885815849, -11.91671017005374],
              [-12.606902749361653, -11.925082565567418],
              [-12.598169693281612, -11.9305955518601],
              [-12.601084508180449, -11.937259718125784],
              [-12.614893939936223, -11.937555845011545],
              [-12.62021405778985, -11.935119024828232],
              [-12.625458477355188, -11.927335241883263],
              [-12.627177629491927, -11.91616248999133],
              [-12.632793122637946, -11.917119914079256],
              [-12.638434980095088, -11.914546313473188],
              [-12.63487280882045, -11.926329286627602],
              [-12.637687264654225, -11.932107652790712],
              [-12.644602305528684, -11.938353053031497],
              [-12.652511548312708, -11.936248927587839],
              [-12.663694789870014, -11.931600753869319],
              [-12.669656314180358, -11.92333977453849],
              [-12.670085614677063, -11.916116118250574],
              [-12.67339248838932, -11.915282717382382],
              [-12.680032160898158, -11.900384418044183],
              [-12.68578631575089, -11.895488093988286],
              [-12.68566780754931, -11.891330484806495],
              [-12.681842612326493, -11.889977019487688],
              [-12.683388312777756, -11.885108371994958],
              [-12.688900343716213, -11.882071371584784],
              [-12.693576251679596, -11.87679724545271],
              [-12.702480868002437, -11.872913116708384],
              [-12.702735688503056, -11.86754348046168],
              [-12.70527209214618, -11.859906338544192],
              [-12.703532780307304, -11.85713431374465],
              [-12.705873405892351, -11.849210243428365],
              [-12.69295670171344, -11.838738715053651],
              [-12.687168227436088, -11.83140440229487],
              [-12.686709106375515, -11.825172442097504],
              [-12.681034625215299, -11.82277993846725],
              [-12.677719979436299, -11.829505702033673],
              [-12.66968780234663, -11.83448034936394],
              [-12.658224035913356, -11.822818133276106],
              [-12.659253286552165, -11.812200125035734],
              [-12.665239217865208, -11.811764206548382],
              [-12.66312344339941, -11.821842098869485],
              [-12.668122562201873, -11.826777842439249],
              [-12.673503634931045, -11.824978546439272],
              [-12.67642598009972, -11.819575695688897],
              [-12.682413752777137, -11.81286594521768],
              [-12.684847486004736, -11.817818944159287],
              [-12.690692600511156, -11.822721554522023],
              [-12.692984389871327, -11.831487536788464],
              [-12.697102193705476, -11.83582425565052],
              [-12.708784336503042, -11.843994539582596],
              [-12.715980610937768, -11.843760430952827],
              [-12.719183835330648, -11.839319182831646],
              [-12.728145705973674, -11.836808762408321],
              [-12.731021807584881, -11.830425048670937],
              [-12.735825902080439, -11.825044436822289],
              [-12.740073349636502, -11.815835347365676],
              [-12.732321844095665, -11.801502430241827],
              [-12.730111573623676, -11.794501209470216],
              [-12.726988158080285, -11.790806083186045],
              [-12.724173889821225, -11.780753520661133],
              [-12.725212032229882, -11.77569357157122],
              [-12.72147097997104, -11.769917658548447],
              [-12.712924985400164, -11.76936237272404],
              [-12.707734509013283, -11.764364898394778],
              [-12.713094213474912, -11.762102675901174],
              [-12.718084473042735, -11.75137052634762],
              [-12.721017229134006, -11.74746027241582],
              [-12.72226015784522, -11.739700504497717],
              [-12.725619508705009, -11.734567481121553],
              [-12.729499088685289, -11.736092834898518],
              [-12.737913545351498, -11.722741384340855],
              [-12.736551307279722, -11.71474242351768],
              [-12.735705529423948, -11.701201435651607],
              [-12.73934864689419, -11.695425965186148],
              [-12.739092815533201, -11.687948517839455],
              [-12.742692401281975, -11.683565244559666],
              [-12.748551705449072, -11.671402146651683],
              [-12.76359351045677, -11.644193190980392],
              [-12.763929328810425, -11.6378348345506],
              [-12.787020593264746, -11.616753455139207],
              [-12.784695501561819, -11.612310380915126],
              [-12.78676427692852, -11.60964139331404],
              [-12.792609984055353, -11.613855731352599],
              [-12.79622337781593, -11.61213563161789],
              [-12.812662754649269, -11.597316948057628],
              [-12.82317914889327, -11.589179913603775],
              [-12.826487903050143, -11.588594196455578],
              [-12.836067527275635, -11.58168724624317],
              [-12.845446184920469, -11.577939450034172],
              [-12.856595336471255, -11.566578016302339],
              [-12.852572119450748, -11.55930577866227],
              [-12.848493363724636, -11.555684251225196],
              [-12.841336222227092, -11.544108707791585],
              [-12.844805891377135, -11.537709314557945],
              [-12.84889572891484, -11.54001524071139],
              [-12.851306840624943, -11.547588374079258],
              [-12.85441730829426, -11.549866339002802],
              [-12.86133566231213, -11.562381104050363],
              [-12.874575634160111, -11.57224116733828],
              [-12.877902399670578, -11.581635365657373],
              [-12.874616721266486, -11.584708454518777],
              [-12.867230328580758, -11.576706226954633],
              [-12.861909889912493, -11.575021058475693],
              [-12.856296844299308, -11.580767393548934],
              [-12.847472187230634, -11.585928718482606],
              [-12.838678085010754, -11.589426529824776],
              [-12.834883219421494, -11.592904530757517],
              [-12.812190362157216, -11.608660637270793],
              [-12.800840629847444, -11.622124930532024],
              [-12.801350100490575, -11.626009787997305],
              [-12.785519585814045, -11.638399939297903],
              [-12.77856243351193, -11.642509616046292],
              [-12.77525596031695, -11.650527029361136],
              [-12.76724564348589, -11.65849827351623],
              [-12.76665734651898, -11.662204645950274],
              [-12.762193260514463, -11.668210119044213],
              [-12.763403283559425, -11.673854130214195],
              [-12.762196777615332, -11.6793537419458],
              [-12.756971052520463, -11.678555765748548],
              [-12.754844400464561, -11.682220497852503],
              [-12.755816967404348, -11.689862247612657],
              [-12.763883226080248, -11.688256331918689],
              [-12.76096308382363, -11.698818947267188],
              [-12.75789575255749, -11.703473605448673],
              [-12.75469816121022, -11.713122732403923],
              [-12.754863808125794, -11.71914883424107],
              [-12.752589607734452, -11.72207046682585],
              [-12.741030660536545, -11.742676924104137],
              [-12.743058105924149, -11.749210185847355],
              [-12.749509828319615, -11.7418909544374],
              [-12.753962127459529, -11.745436924014772],
              [-12.749011843450504, -11.753897069746927],
              [-12.74639497455926, -11.765113485109353],
              [-12.74821611072257, -11.770139322329607],
              [-12.745226488789443, -11.776969770974322],
              [-12.745637243810057, -11.780984007245205],
              [-12.742607293827888, -11.79217142938024],
              [-12.747962412481497, -11.799877281074078],
              [-12.74856784060081, -11.807911965833265],
              [-12.751476891036598, -11.808637412580799],
              [-12.753021597736446, -11.818805468726204],
              [-12.760710619363737, -11.824115162550251],
              [-12.774742358478438, -11.82232875404029],
              [-12.77735565621066, -11.818332043132301],
              [-12.786480195014638, -11.814904473520121],
              [-12.77893758505682, -11.795077198623494],
              [-12.778712317629875, -11.78114069601509],
              [-12.780175014187844, -11.774861527794439],
              [-12.77904920216243, -11.769007160229194],
              [-12.783458691253648, -11.758678729751576],
              [-12.788428009174105, -11.758842404224005],
              [-12.7999161913397, -11.768256775062595],
              [-12.796075382368283, -11.775182651208826],
              [-12.786642446548921, -11.781499712217771],
              [-12.78814564803681, -11.787855081920437],
              [-12.787292208520967, -11.797389842552914],
              [-12.788763396295483, -11.802322807927641],
              [-12.794329658611025, -11.806377425782957],
              [-12.797274254409569, -11.81163634174262],
              [-12.802270449101783, -11.81137620226058],
              [-12.806706614379888, -11.813909408487545],
              [-12.819216594152792, -11.812665997928999],
              [-12.825019390676292, -11.808201625869348],
              [-12.823022366338991, -11.798218886168238],
              [-12.813292884862365, -11.788140681983444],
              [-12.821263272089741, -11.788223668411824],
              [-12.826784587586749, -11.793769103783532],
              [-12.828948568056825, -11.798202029778102],
              [-12.833932789183928, -11.79724375997926],
              [-12.835111623039596, -11.803148473541714],
              [-12.834611027932613, -11.811539508924378],
              [-12.84873977567183, -11.80905652409297],
              [-12.86025814877724, -11.80375167953122],
              [-12.866080612667952, -11.803327959834169],
              [-12.869650601699723, -11.805603936443001],
              [-12.8503966512972, -11.8174014152267],
              [-12.85506345816022, -11.82209674167517],
              [-12.861037724145355, -11.818221297872169],
              [-12.865946152220362, -11.818868244640141],
              [-12.862442305940382, -11.825456682344509],
              [-12.856657016357039, -11.832104797233397],
              [-12.858394584539376, -11.834198491848557],
              [-12.85602883346885, -11.844690145169787],
              [-12.86379443570175, -11.844968217307112],
              [-12.866584660259402, -11.849829877873102],
              [-12.856489441889169, -11.855810356582351],
              [-12.855968659397067, -11.863905136678786],
              [-12.857885292106715, -11.869755494584126],
              [-12.852723608933946, -11.873932629525509],
              [-12.855786798849955, -11.879117280280752],
              [-12.859267336683784, -11.880302778007309],
              [-12.867284120975361, -11.874275135375255],
              [-12.873201137569025, -11.867630148270099],
              [-12.879810676760181, -11.862568270534522],
              [-12.879442891368235, -11.860302434020628],
              [-12.885478567214987, -11.851878563071022],
              [-12.890871235781173, -11.839729238408093],
              [-12.895475238576093, -11.835643954521277],
              [-12.900939453363474, -11.825719344437553],
              [-12.902534226691017, -11.818732741745759],
              [-12.901950135637723, -11.813878009400034],
              [-12.90917288606543, -11.808339311851759],
              [-12.909739141735386, -11.805553705264263],
              [-12.904788179396938, -11.800632405634289],
              [-12.909872992822406, -11.791095166196268],
              [-12.906478374062829, -11.789708498115798],
              [-12.894336076944663, -11.794824291105453],
              [-12.880226155048367, -11.802115230716465],
              [-12.88500370974835, -11.790412525243191],
              [-12.890393832198635, -11.789311101534185],
              [-12.900566067189601, -11.783146037575914],
              [-12.908407225928393, -11.780851072716803],
              [-12.91016729443663, -11.773702160578383],
              [-12.902126100198004, -11.767725975738802],
              [-12.894986209638624, -11.75199536947867],
              [-12.893823252412712, -11.746918925016134],
              [-12.895401507826364, -11.742417138735233],
              [-12.894786191823579, -11.734369380760276],
              [-12.897801193127673, -11.733593623755631],
              [-12.894924925106102, -11.726655727390732],
              [-12.889709082231727, -11.726627039535584],
              [-12.891080083838723, -11.718752148272381],
              [-12.902973937357823, -11.719285784985468],
              [-12.909748838460327, -11.713946489579069],
              [-12.912024264203389, -11.695777574547844],
              [-12.914967408792485, -11.689615269238281],
              [-12.922336321802815, -11.684435715500028],
              [-12.922837589210156, -11.678432452198027],
              [-12.915835480001723, -11.66639232762551],
              [-12.910996892955978, -11.664686492690048],
              [-12.905471266558889, -11.665732632773587],
              [-12.900320061619398, -11.657498536567289],
              [-12.893232711091779, -11.657369101235838],
              [-12.88589051500125, -11.648298913895875],
              [-12.894627129353452, -11.64686454504689],
              [-12.896031297676224, -11.6521806089701],
              [-12.902004189880289, -11.65314466980856],
              [-12.9094116681727, -11.659806566682159],
              [-12.919642831214416, -11.657664674002792],
              [-12.923953598369264, -11.66236797118584],
              [-12.930800844966077, -11.64786629563136],
              [-12.921467127219449, -11.643394159738778],
              [-12.916673769910648, -11.643055573124727],
              [-12.898382920036244, -11.637302828476031],
              [-12.893975676306612, -11.633598455347716],
              [-12.904992090007049, -11.633219329468234],
              [-12.90598570047819, -11.62817565853989],
              [-12.917430653915202, -11.620085750586282],
              [-12.917274496508197, -11.616179649507211],
              [-12.913509913440128, -11.614013030379162],
              [-12.916281329203057, -11.60910447637611],
              [-12.920831398624584, -11.61355018375434],
              [-12.92525300450705, -11.608361217160333],
              [-12.934313874064532, -11.619237596325531],
              [-12.938608082531543, -11.628091220075222],
              [-12.944343538809939, -11.637217414717234],
              [-12.952108294152714, -11.638141964537828],
              [-12.972190280026178, -11.651879238665694],
              [-12.965031406005748, -11.656503759603492],
              [-12.955797895890312, -11.653410092100973],
              [-12.94701020574262, -11.653561651014593],
              [-12.940089424706127, -11.65544912897543],
              [-12.93645295868835, -11.66520048111934],
              [-12.937366042451545, -11.674614997191014],
              [-12.939414762593684, -11.675675932141925],
              [-12.937697268524534, -11.69029841783011],
              [-12.938345727499243, -11.693362242641523],
              [-12.946650000653502, -11.694746466194458],
              [-12.931633128245602, -11.708975233430046],
              [-12.93573186591216, -11.715312703789586],
              [-12.934401099933902, -11.723284226015844],
              [-12.937741456643101, -11.723807527781],
              [-12.939103516810457, -11.730916489804141],
              [-12.942561008985196, -11.733645159596245],
              [-12.954767536813021, -11.729296470164158],
              [-12.950596522943727, -11.73889199334697],
              [-12.944582045315778, -11.741440570528155],
              [-12.940426044415302, -11.755563180331274],
              [-12.938202651982621, -11.75968797503115],
              [-12.941743018003077, -11.762348811040912],
              [-12.939773945413082, -11.771762036486624],
              [-12.942184910051772, -11.774039186302742],
              [-12.952472187884178, -11.771256280493025],
              [-12.958386998974033, -11.766733257232907],
              [-12.97418047584347, -11.766497697297567],
              [-12.98132228547513, -11.764185762194055],
              [-12.98580307318584, -11.759523837839122],
              [-12.990760911600153, -11.75825885554187],
              [-12.995017113913917, -11.753086268550677],
              [-12.99851155782577, -11.743968162970653],
              [-13.004326497944259, -11.73665001065265],
              [-13.011390176055539, -11.724583518523032],
              [-13.029345602071812, -11.708082715793038],
              [-13.025599369647061, -11.706056724592479],
              [-13.017620677924059, -11.710628904437897],
              [-13.011899306621387, -11.711947110722422],
              [-13.00923153600066, -11.709384769781536],
              [-13.009914186804304, -11.703092062533456],
              [-13.014561957381307, -11.692432967517325],
              [-13.015183543611155, -11.688306536163841],
              [-13.008375143792211, -11.686104731829984],
              [-13.00576357142449, -11.682214686223006],
              [-12.995213317572986, -11.679201565048562],
              [-12.995462120228257, -11.673061485495035],
              [-13.000583805994413, -11.67256363153635],
              [-13.003904717890437, -11.667398472218318],
              [-13.001493245479603, -11.65843754866632],
              [-12.998637974771368, -11.653996294846477],
              [-13.002779912443504, -11.645476230769802],
              [-13.007474617186286, -11.641979116023316],
              [-13.008620985265893, -11.634346038455893],
              [-13.00630036627679, -11.628544861156218],
              [-12.993447621851162, -11.62102897744852],
              [-12.99656019197188, -11.612038670319718],
              [-12.994548099746323, -11.6105633100378],
              [-13.006724719347151, -11.59157531590251],
              [-13.011995324486229, -11.570653202843848],
              [-13.017810098503706, -11.555017222690184],
              [-13.003869980768876, -11.54689203668263],
              [-13.004900883434008, -11.54182320487935],
              [-13.002500271843006, -11.538861086878322],
              [-12.99253514828092, -11.539861511074342],
              [-12.984280263384672, -11.532028539382074],
              [-12.970974146176811, -11.534147500889723],
              [-12.966697431795987, -11.530279697566788],
              [-12.959175102365679, -11.531119183520275],
              [-12.961186665636712, -11.526034574632634],
              [-12.97161717873807, -11.524027614253226],
              [-12.978748313846559, -11.52646442900863],
              [-12.98393326718848, -11.525085611687674],
              [-12.992119523131734, -11.530540547831517],
              [-12.99750388990409, -11.531626541908707],
              [-13.005935538382115, -11.530309986586582],
              [-13.009566619468458, -11.533172985426797],
              [-13.014077686686973, -11.546513772136782],
              [-13.023995918847472, -11.549309298368824],
              [-13.026857565497721, -11.554595753860028],
              [-13.025277938254858, -11.55812302839598],
              [-13.023152185109197, -11.571333918097118],
              [-13.028547805315803, -11.572872382583084],
              [-13.029843710714752, -11.579799291318833],
              [-13.036020835365722, -11.57550113372244],
              [-13.038387106080593, -11.571248651139074],
              [-13.044764782580163, -11.566636599282923],
              [-13.055025586671176, -11.567763921417813],
              [-13.054621000530455, -11.572717819997044],
              [-13.04584629556561, -11.578960124583704],
              [-13.038272861812345, -11.580822903991232],
              [-13.033073912024708, -11.585476055900543],
              [-13.035757365780583, -11.591186013197596],
              [-13.041001458994435, -11.5899108133395],
              [-13.041168406622957, -11.595474609257915],
              [-13.04650080739541, -11.599926043930271],
              [-13.048425746025856, -11.596503924406584],
              [-13.053958701131956, -11.600873742429966],
              [-13.051593077905672, -11.604582976866155],
              [-13.041872641368847, -11.606537547593364],
              [-13.044126388179413, -11.609287916291146],
              [-13.032765048379902, -11.619942963615797],
              [-13.033169855281429, -11.626320578492114],
              [-13.02967532633919, -11.627611856888803],
              [-13.023035134980463, -11.633832513271809],
              [-13.021436174485352, -11.64096460115558],
              [-13.023562713521384, -11.645946764442515],
              [-13.02905544789686, -11.64699993192222],
              [-13.035928752500656, -11.638719131534243],
              [-13.039456011457995, -11.650991996432593],
              [-13.0469442703564, -11.650732071414783],
              [-13.046181372775877, -11.65454570291179],
              [-13.049604058701773, -11.668872365782393],
              [-13.044624891019042, -11.676686900655898],
              [-13.05512673530588, -11.684526234153244],
              [-13.059696688014563, -11.67836833961755],
              [-13.06417725330729, -11.675358538789757],
              [-13.062285545738598, -11.658737660610399],
              [-13.07254537418747, -11.653835540306751],
              [-13.080080218289654, -11.655477906914625],
              [-13.080272510194954, -11.649206238736928],
              [-13.085719013981999, -11.649813375035803],
              [-13.082727300651293, -11.64349034733434],
              [-13.087519255987836, -11.64138692156111],
              [-13.078221186557585, -11.636491705386451],
              [-13.075990305544032, -11.632577939987861],
              [-13.08651773003718, -11.633815079233047],
              [-13.092456795511177, -11.636709416949259],
              [-13.096562744165707, -11.63166366267648],
              [-13.095914494414622, -11.618785612842922],
              [-13.10178089066704, -11.622612970996716],
              [-13.106814397626142, -11.620664595028405],
              [-13.110533923339709, -11.623158278478627],
              [-13.11162303941374, -11.628486589992724],
              [-13.12009610336671, -11.623506272495419],
              [-13.123234010988337, -11.629933745456986],
              [-13.121649554483929, -11.636379792833312],
              [-13.11641291167956, -11.638823649338052],
              [-13.11523779259376, -11.644495410076868],
              [-13.125506250327222, -11.641722537026446],
              [-13.133134418277722, -11.634461239280363],
              [-13.13733069219476, -11.628869080082877],
              [-13.145499079502603, -11.62101560904468],
              [-13.145955668625515, -11.617841308294539],
              [-13.15269853754424, -11.610299581995417],
              [-13.150366449687917, -11.601240648466064],
              [-13.155666006335416, -11.592579528751502],
              [-13.15344362935599, -11.588077161637642],
              [-13.159405646439344, -11.586788625004491],
              [-13.157461047006416, -11.5794627392519],
              [-13.154226857627945, -11.575804281335166],
              [-13.148743128585236, -11.576693169515723],
              [-13.140891647395824, -11.571952784378167],
              [-13.142142851683419, -11.551454622526132],
              [-13.138880994013649, -11.546278743975375],
              [-13.140650434577223, -11.54024656209836],
              [-13.138699835259096, -11.535240667667003],
              [-13.13307090622392, -11.534010904112195],
              [-13.122926141535613, -11.524913619960826],
              [-13.119559634315499, -11.525549761490073],
              [-13.107626458796206, -11.535793566245092],
              [-13.106984529657966, -11.547474610440203],
              [-13.102879944745279, -11.551619065170643],
              [-13.103248019675267, -11.559969160322613],
              [-13.092850016134827, -11.563698578837299],
              [-13.083531173962815, -11.57011681034197],
              [-13.074044390257177, -11.567349632135707],
              [-13.07093644124056, -11.562095643184154],
              [-13.077291636407127, -11.562483690276002],
              [-13.090425244178205, -11.556468874173033],
              [-13.097903258128216, -11.546000768832702],
              [-13.102373654556459, -11.543390226237793],
              [-13.101789630318509, -11.535426625950846],
              [-13.104422849766921, -11.522775436799176],
              [-13.112366336685579, -11.513700678922419],
              [-13.11185814515267, -11.507385868661505],
              [-13.10966308087854, -11.504607019891603],
              [-13.112612778852748, -11.499575063987846],
              [-13.117329399016306, -11.497589662366446],
              [-13.123462208748807, -11.491679946868604],
              [-13.130051372745456, -11.47979047429273],
              [-13.124128950368753, -11.477425974000363],
              [-13.117364451833529, -11.480754954224128],
              [-13.10644092883972, -11.479986012321081],
              [-13.100565984766765, -11.482397256015478],
              [-13.092792286048429, -11.492225549316936],
              [-13.091876520885783, -11.49836232917098],
              [-13.084432771615813, -11.503997675415645],
              [-13.079184902943341, -11.505255789082602],
              [-13.081322888174043, -11.494221068172438],
              [-13.08595997351565, -11.490519146262262],
              [-13.093569169555579, -11.477415027403678],
              [-13.10648650101073, -11.47090352491538],
              [-13.110952216453004, -11.473388460903783],
              [-13.117308230915922, -11.46802566493731],
              [-13.128652870154127, -11.463462891930009],
              [-13.13133851814171, -11.459598016071789],
              [-13.137566555646254, -11.441947399191738],
              [-13.135193840006341, -11.439452902356209],
              [-13.13380100308028, -11.425183017210388],
              [-13.137757340213787, -11.425452086743848],
              [-13.144450723284917, -11.432743014835768],
              [-13.149443496302682, -11.440654234900647],
              [-13.159238820308863, -11.446112682606634],
              [-13.1683771685883, -11.445466478864782],
              [-13.177632633141494, -11.442910756273163],
              [-13.179895104375587, -11.438678336795057],
              [-13.178577207970392, -11.433936699650777],
              [-13.184203782102985, -11.428585895835544],
              [-13.178739872669297, -11.426415381150509],
              [-13.179510152259098, -11.418671198451843],
              [-13.185822326618846, -11.4141211377806],
              [-13.184197716173022, -11.401582245870005],
              [-13.208776819526987, -11.39773343647595],
              [-13.221595463741002, -11.392151690960262],
              [-13.242013383091278, -11.386114192541934],
              [-13.24674451540357, -11.38016465165767],
              [-13.247557083766774, -11.375770445255693],
              [-13.252100038039929, -11.372069522873424],
              [-13.261203221688847, -11.369843475766714],
              [-13.267932757107625, -11.366285517581291],
              [-13.275431446588621, -11.356153061057157],
              [-13.28085331365876, -11.351772658756463],
              [-13.28604391148652, -11.350489437263057],
              [-13.28819074236047, -11.346633418875859],
              [-13.27715292380939, -11.343281355185292],
              [-13.27114441878912, -11.337154298642814],
              [-13.265379068102327, -11.33589853496087],
              [-13.265114071879141, -11.34007973684147],
              [-13.259985600202594, -11.34583119719959],
              [-13.256360935951365, -11.34287333123203],
              [-13.260602827979373, -11.336227006336733],
              [-13.260298618028093, -11.33275220933706],
              [-13.264454871714271, -11.32931793264642],
              [-13.27455138905077, -11.317692124057997],
              [-13.272000709831904, -11.31143683115863],
              [-13.273790586306193, -11.305559698086327],
              [-13.27830860450983, -11.303421096096146],
              [-13.2786425228286, -11.311223340057259],
              [-13.28203240413112, -11.31776949856284],
              [-13.278006144568439, -11.324380013380122],
              [-13.27767553077401, -11.329752390846833],
              [-13.280713338233225, -11.333027788473823],
              [-13.290587345212185, -11.328530241685385],
              [-13.299876063467526, -11.328865713775615],
              [-13.300062770317226, -11.333588333565771],
              [-13.307230245372748, -11.329758452189031],
              [-13.31436427368347, -11.32872252862023],
              [-13.320680159291225, -11.324712167112514],
              [-13.327758675624636, -11.32496304835316],
              [-13.336527694183728, -11.328677013874183],
              [-13.340851435851546, -11.328664215411862],
              [-13.347713087137056, -11.321088061903769],
              [-13.345954952369716, -11.31651762252661],
              [-13.348242384801395, -11.31360611225571],
              [-13.359297437529083, -11.317973924366397],
              [-13.359173963746429, -11.325161254434663],
              [-13.365835959442618, -11.330626501197063],
              [-13.375839439816096, -11.328557817199941],
              [-13.377313301621024, -11.32622516921844],
              [-13.388129460925033, -11.326270953710559],
              [-13.389845466053629, -11.324201102639723],
              [-13.397429274645992, -11.32471658819918],
              [-13.399404630694528, -11.321843935406328],
              [-13.406950394027941, -11.319411705923317],
              [-13.42045539135415, -11.317542517494577],
              [-13.413118922667996, -11.313307978887934],
              [-13.411438149975695, -11.310397396033586],
              [-13.41157789233778, -11.30184299734512],
              [-13.416564534631036, -11.295710858357824],
              [-13.42176788793431, -11.292395468284505],
              [-13.422266127634723, -11.285915603200824],
              [-13.415540104847434, -11.282420791511056],
              [-13.419926762259479, -11.276603520511896],
              [-13.416355255898859, -11.27362179548856],
              [-13.405032937042021, -11.278014973113269],
              [-13.400310281602946, -11.275555808695332],
              [-13.393692977646712, -11.275051763047456],
              [-13.389272073364952, -11.26813436975649],
              [-13.384690373742679, -11.269752122564098],
              [-13.373999856294091, -11.265441618332856],
              [-13.371916197402317, -11.260183942315617],
              [-13.365322449897858, -11.256326252778948],
              [-13.369038452368287, -11.250636406843803],
              [-13.37518625987842, -11.25583600972789],
              [-13.38488206141522, -11.254265941317644],
              [-13.397605820773103, -11.258792352073364],
              [-13.410607495205802, -11.258292884819868],
              [-13.417124050363254, -11.25704773380866],
              [-13.424102425186577, -11.24988935516064],
              [-13.422091213190427, -11.243429421952507],
              [-13.416675844368562, -11.239128915054996],
              [-13.418381198889056, -11.235916876181795],
              [-13.427087374497562, -11.235687683255453],
              [-13.442880847068123, -11.22126998845779],
              [-13.446711632693834, -11.209123186430968],
              [-13.44560827198122, -11.2063888561601],
              [-13.448827285037288, -11.198547396759626],
              [-13.44452900447121, -11.194501714909741],
              [-13.446124812346522, -11.182957098810093],
              [-13.458798374163797, -11.195114451171893],
              [-13.470669336197533, -11.192955011247735],
              [-13.472571157699932, -11.18918315404736],
              [-13.482534336408127, -11.183421573036473],
              [-13.48658560493539, -11.17800301453148],
              [-13.488802679138072, -11.169652104016965],
              [-13.486241870791677, -11.162770073121198],
              [-13.490926838062602, -11.152212175431826],
              [-13.475521837354355, -11.1452187138625],
              [-13.462561535991277, -11.153335214775085],
              [-13.454645340772608, -11.152051653490224],
              [-13.437456696730221, -11.153994795989238],
              [-13.42610202596658, -11.158249435572971],
              [-13.4026640538591, -11.16294414426237],
              [-13.391831801155208, -11.167017089637245],
              [-13.376279566628872, -11.179647306892136],
              [-13.365747606654027, -11.184416026078804],
              [-13.365240553588999, -11.178891998430128],
              [-13.376417996891107, -11.174288007593054],
              [-13.388642358316945, -11.16337275430015],
              [-13.397982443649168, -11.157171649785747],
              [-13.407600442273006, -11.153776928752539],
              [-13.413928007807622, -11.149015916934937],
              [-13.419499268351803, -11.146823229306264],
              [-13.428040272440237, -11.148924456700046],
              [-13.441272188976042, -11.142661013579577],
              [-13.451331322345844, -11.134803382945822],
              [-13.460430507411683, -11.134357476579082],
              [-13.467207117740776, -11.132164877669537],
              [-13.473581226711305, -11.12755692501676],
              [-13.48409665027193, -11.130929282646585],
              [-13.4812671756592, -11.123039004359702],
              [-13.48333323107488, -11.115946270387449],
              [-13.490771436835642, -11.107148044897974],
              [-13.491697461293935, -11.097562306793925],
              [-13.49536066652795, -11.088106086522806],
              [-13.5022734297263, -11.076887809095318],
              [-13.503390069002018, -11.083440585133744],
              [-13.497749251469894, -11.098031325328071],
              [-13.49994112978164, -11.100129497874727],
              [-13.505005331959609, -11.096770575560578],
              [-13.506551413242203, -11.100584839774985],
              [-13.499196748390904, -11.108169888511595],
              [-13.499734807864277, -11.112817919116287],
              [-13.495480056755254, -11.123847551241731],
              [-13.5027809815579, -11.127669448039052],
              [-13.510070969415002, -11.12677053903679],
              [-13.519976642531638, -11.1171212802082],
              [-13.520970503811338, -11.113455164556422],
              [-13.526554028225663, -11.109607070556555],
              [-13.531505365788325, -11.103100930250518],
              [-13.549093803550823, -11.088819808433767],
              [-13.55174991225183, -11.082881571448672],
              [-13.549760172392157, -11.076838025898304],
              [-13.539943410682016, -11.063650251169934],
              [-13.528901142462228, -11.077083410945708],
              [-13.523247030472891, -11.077156251941048],
              [-13.52373229719924, -11.072203406141828],
              [-13.528334938839173, -11.064202449290102],
              [-13.53656942132955, -11.055784678172902],
              [-13.5420060182563, -11.05405436743223],
              [-13.546096639822764, -11.045455843066124],
              [-13.548497037511163, -11.044424975053069],
              [-13.552297560478385, -11.051956453655452],
              [-13.551131476637185, -11.057186625832953],
              [-13.547248779590952, -11.06299215317289],
              [-13.555417922417156, -11.070008008565862],
              [-13.560061027414552, -11.077846840341508],
              [-13.568147576400607, -11.076321465178468],
              [-13.590153814472476, -11.061325977613972],
              [-13.59943922501374, -11.054036123578879],
              [-13.60479752913693, -11.047234388660046],
              [-13.606765674253463, -11.040992259136372],
              [-13.609679453372047, -11.039748866891356],
              [-13.60802916548469, -11.034223114379369],
              [-13.610950842036814, -11.032078301132104],
              [-13.613494321407211, -11.02502448257043],
              [-13.617678172085302, -11.018427854266852],
              [-13.619901885559601, -11.009479606238877],
              [-13.615988481843024, -11.003910540184064],
              [-13.620321204546253, -10.991913126300167],
              [-13.626014692254275, -10.987464298084639],
              [-13.613968390700517, -10.978208758771716],
              [-13.612809383297613, -10.97235585537235],
              [-13.609958881594828, -10.968826950751666],
              [-13.619219510484482, -10.962328361185493],
              [-13.619596826267864, -10.955375945390834],
              [-13.623578665099359, -10.95200053702302],
              [-13.629299653678618, -10.942682131645945],
              [-13.631600558211066, -10.945045447854216],
              [-13.6300588303713, -10.956852447857301],
              [-13.627483491847109, -10.96862640558856],
              [-13.632822573094883, -10.974390370320414],
              [-13.63706402552186, -10.981485846157705],
              [-13.63823215127179, -10.990400040447591],
              [-13.625940235916417, -11.000025606923368],
              [-13.62525986148322, -11.003203964386515],
              [-13.629900017851792, -11.005738123063288],
              [-13.629462062326613, -11.017028271378582],
              [-13.63686220467792, -11.016464828479803],
              [-13.648129812847145, -11.02369728218347],
              [-13.65165550391734, -11.027194683135322],
              [-13.665467341370398, -11.027927536280702],
              [-13.676594725134285, -11.024553286754728],
              [-13.680365215504414, -11.025496992146696],
              [-13.687403160597592, -11.023986235446412],
              [-13.69131482923395, -11.025058932980427],
              [-13.69427279188747, -11.030736695756982],
              [-13.710205007340742, -11.030527800627695],
              [-13.720109203325078, -11.025112385608923],
              [-13.729374227245193, -11.018484013423429],
              [-13.734987169700437, -11.012313035912598],
              [-13.730000920696497, -11.004512708918547],
              [-13.722323924879207, -10.999734422583133],
              [-13.724708967435346, -10.994914625374065],
              [-13.731623699454364, -10.99463200543479],
              [-13.734443287102009, -10.984770656036677],
              [-13.742878476176577, -10.985682565810949],
              [-13.749404498257519, -10.990286478228535],
              [-13.753753795038907, -10.987915959692252],
              [-13.754756424805464, -10.98388331733921],
              [-13.75950918485579, -10.980836650877974],
              [-13.759731283981646, -10.97716727279705],
              [-13.773793299125979, -10.951911126300658],
              [-13.783106078723737, -10.948086324347466],
              [-13.782131187642886, -10.94414205375847],
              [-13.788133050300486, -10.941161455867316],
              [-13.796119503168429, -10.9327840166544],
              [-13.807072282792015, -10.923047821753038],
              [-13.811263826472226, -10.921004392351657],
              [-13.82502993896885, -10.90360676959657],
              [-13.81327334274676, -10.89869814006089],
              [-13.819708303950442, -10.892870689829751],
              [-13.82183287129435, -10.885222975298465],
              [-13.822107929397989, -10.87529688026073],
              [-13.825940861684641, -10.866125982121718],
              [-13.830000948532025, -10.86468916582326],
              [-13.838134443298221, -10.858321063579098],
              [-13.838041668689414, -10.876853283703948],
              [-13.839975102908777, -10.880839935706867],
              [-13.846688074991583, -10.878675645392063],
              [-13.851955208410603, -10.870626432514719],
              [-13.865702703800169, -10.86015579211661],
              [-13.871163073585262, -10.852315476903277],
              [-13.870608229845576, -10.845656703439142],
              [-13.874413267708709, -10.837655907045395],
              [-13.881228550179495, -10.82915999480216],
              [-13.889152992226558, -10.806148769400654],
              [-13.896846000964041, -10.797135851429918],
              [-13.898563036106612, -10.7890905602097],
              [-13.901846799892109, -10.781743435406295],
              [-13.906153057608075, -10.777531989997222],
              [-13.910592432266387, -10.768362503810144],
              [-13.916622125208853, -10.760092320532307],
              [-13.922309156717855, -10.755363518771702],
              [-13.928817660319709, -10.74452898576497],
              [-13.934036624609176, -10.747367945595995],
              [-13.937158940643904, -10.743051382634745],
              [-13.93764682462969, -10.737334977833559],
              [-13.949199095082738, -10.726439198997966],
              [-13.949334760362637, -10.722011225372713],
              [-13.952875895303459, -10.711287964334353],
              [-13.953629791747417, -10.700917878895407],
              [-13.956733740401159, -10.690999582677799],
              [-13.956069400248237, -10.685119150400299],
              [-13.95883983375528, -10.673128814807004],
              [-13.958722761869156, -10.66697003415234],
              [-13.964602655788287, -10.666510074968347],
              [-13.963605197220774, -10.679038769230111],
              [-13.960957591941991, -10.689060562288551],
              [-13.95998464025566, -10.705197945844775],
              [-13.958422506031697, -10.71263883949085],
              [-13.955337876600586, -10.717911271461007],
              [-13.956885028615396, -10.721051053962732],
              [-13.972318745442998, -10.720305612163667],
              [-13.981938108673928, -10.715427812895431],
              [-13.982568711607637, -10.720828481740169],
              [-13.967173217856347, -10.726088102203889],
              [-13.962339282130728, -10.726758243304964],
              [-13.960662044682984, -10.731491757385625],
              [-13.956733486555558, -10.735010307468668],
              [-13.957062031223932, -10.742619467774297],
              [-13.94750856923869, -10.743588063724584],
              [-13.943178268594075, -10.745631504216917],
              [-13.930760782563086, -10.762228366585362],
              [-13.932434845694628, -10.766621176559145],
              [-13.91913427156366, -10.78039666660353],
              [-13.930094800501632, -10.777154491924303],
              [-13.933426143619585, -10.77776826079684],
              [-13.93599777118747, -10.769939842608315],
              [-13.94587839065862, -10.756410674012354],
              [-13.957575640811964, -10.746493842829821],
              [-13.966322246928698, -10.742901581266484],
              [-13.976357148937836, -10.7410069319463],
              [-13.980967550233945, -10.738330438899988],
              [-13.988342530628115, -10.741308015042522],
              [-13.97990640840602, -10.743963784637945],
              [-13.974362297193329, -10.75000295270629],
              [-13.96028878486706, -10.758935749839205],
              [-13.956755084569346, -10.762269179338649],
              [-13.953446721987799, -10.772097450752803],
              [-13.945810502180809, -10.780978561746632],
              [-13.938981547311451, -10.7804092061966],
              [-13.932737323154674, -10.784948561831538],
              [-13.931389268364901, -10.792275951516917],
              [-13.931247657310003, -10.804098659550567],
              [-13.92579015761216, -10.808483853968253],
              [-13.928991791632603, -10.813166851386896],
              [-13.92424751013691, -10.821837705742553],
              [-13.925354335017499, -10.825589167580782],
              [-13.917842914447029, -10.834068948384632],
              [-13.915493504540693, -10.840713331233685],
              [-13.906440193424732, -10.841056048371927],
              [-13.904827489913554, -10.847297440024358],
              [-13.906490917367783, -10.85028240196978],
              [-13.890081777132034, -10.871003344623107],
              [-13.887372561565522, -10.872309718468365],
              [-13.879057637588954, -10.881085052025504],
              [-13.873255065672087, -10.899354286380069],
              [-13.862125451694517, -10.908324794835828],
              [-13.857278547239778, -10.916346686934851],
              [-13.845864221948814, -10.929515628376194],
              [-13.840845294311446, -10.942310385563319],
              [-13.844427642089018, -10.942224005624553],
              [-13.847231609330478, -10.934753307705737],
              [-13.852260327171937, -10.940549960872936],
              [-13.848451261707714, -10.947780543689646],
              [-13.844200047908778, -10.949814233028423],
              [-13.842216664147605, -10.956950429030192],
              [-13.839297528354685, -10.958431494868021],
              [-13.82938553375502, -10.97128400189157],
              [-13.831458334515895, -10.974331967542486],
              [-13.826337933166823, -10.981523149163074],
              [-13.819072754724308, -10.988460512357864],
              [-13.809657594351501, -11.008340647978086],
              [-13.80366672909411, -11.015349054592843],
              [-13.798098155664878, -11.029882803728706],
              [-13.80657774237231, -11.035550459904226],
              [-13.802938166322788, -11.041055370628674],
              [-13.804888513971548, -11.04557214373995],
              [-13.798998545066475, -11.05487598337648],
              [-13.790430148450158, -11.065133584134099],
              [-13.791474371932509, -11.068452869930429],
              [-13.796910936454589, -11.067985176958539],
              [-13.805162524750843, -11.06396814985195],
              [-13.80936709184175, -11.06696932193377],
              [-13.822945954382057, -11.061054872993656],
              [-13.830711018608156, -11.064926361957337],
              [-13.839428536890399, -11.062330843524157],
              [-13.848067544590734, -11.05452077320433],
              [-13.854797676612835, -11.044943917058037],
              [-13.861740546815266, -11.040279616563206],
              [-13.865391980769358, -11.034815347582143],
              [-13.875548991559494, -11.016456888882068],
              [-13.881521309997291, -11.008854165784848],
              [-13.883577429454713, -11.000734459708664],
              [-13.89019152361144, -10.99198704207478],
              [-13.896630203879603, -10.986135599927891],
              [-13.898588134969943, -10.989624025045169],
              [-13.891620914456599, -10.994661057749775],
              [-13.889623375828464, -10.997798863662522],
              [-13.892305383102212, -11.003455553972806],
              [-13.880500076494442, -11.015752739233651],
              [-13.87980197899269, -11.024800551505916],
              [-13.884158633576916, -11.02829656983878],
              [-13.898089324756306, -11.020509740248878],
              [-13.901174273383006, -11.021863073423017],
              [-13.910420998835473, -11.017842826054341],
              [-13.919344029999518, -11.02865522511881],
              [-13.92738955211635, -11.03398327297823],
              [-13.93349488582553, -11.031972532998333],
              [-13.934604926837622, -11.034714919869735],
              [-13.943365793676179, -11.040900601466983],
              [-13.959534793166085, -11.047001437694371],
              [-13.959067066583389, -11.033971568047248],
              [-13.960912421897408, -11.031448818549526],
              [-13.963777983454937, -11.017902396739313],
              [-13.969873897721609, -11.02544563544216],
              [-13.980942775265683, -11.021687186613848],
              [-13.982717569102775, -11.017660558774844],
              [-13.977297917513289, -11.008489622063285],
              [-13.973146662521138, -11.008949050537838],
              [-13.973913196036618, -11.002676656416957],
              [-13.978423512929465, -11.002622752095462],
              [-13.983170913163072, -10.996816532186067],
              [-13.986846085422624, -10.986862143411452],
              [-13.982449980642071, -10.97705818124219],
              [-13.974859029629261, -10.982294670673035],
              [-13.966721618134878, -10.972430306527771],
              [-13.973921897630557, -10.972193348498896],
              [-13.983491816018613, -10.96471626188466],
              [-13.997029645859014, -10.944308793303012],
              [-14.001431640167455, -10.945025259685918],
              [-14.007255499966584, -10.940870457413238],
              [-14.008279807084547, -10.934879240206545],
              [-14.015025247498048, -10.926964376979392],
              [-14.018306702105715, -10.920713561143623],
              [-14.028683587537515, -10.912518566095672],
              [-14.029246221293716, -10.90593488567952],
              [-14.025934285698565, -10.901733689481297],
              [-14.019463448924299, -10.898167219316688],
              [-14.02013617815092, -10.894213664413588],
              [-14.027516139534034, -10.893760096724336],
              [-14.032680245238112, -10.886326586645714],
              [-14.035112239983405, -10.872184160241734],
              [-14.039560360470961, -10.870890967560909],
              [-14.041640089050725, -10.867286484394716],
              [-14.047626230494696, -10.86461148292742],
              [-14.049291123150805, -10.858530047660473],
              [-14.056539521850535, -10.859703477241322],
              [-14.055671737008515, -10.865671951605465],
              [-14.05232321620782, -10.871102922048175],
              [-14.047175623484174, -10.87284662913671],
              [-14.044627391406182, -10.877335478321665],
              [-14.046195713046975, -10.884083100493807],
              [-14.041590747184893, -10.886877358777765],
              [-14.036925923805422, -10.895722273073826],
              [-14.036416300116672, -10.913052118754],
              [-14.038541882313018, -10.917854561212165],
              [-14.036094290269894, -10.924989485889638],
              [-14.037947915147175, -10.92712106682494],
              [-14.034779627207204, -10.935874584563306],
              [-14.041711802080577, -10.935807062644908],
              [-14.04528292125936, -10.938665420544334],
              [-14.051756155896584, -10.93943794803836],
              [-14.058510303087894, -10.934554220025657],
              [-14.066879497472936, -10.933934789197945],
              [-14.083772624835326, -10.924366606711104],
              [-14.0889019510785, -10.92608575060141],
              [-14.091293194802313, -10.9233790651323],
              [-14.096617710361164, -10.924705639470911],
              [-14.101367097627463, -10.922142478517827],
              [-14.107207250145732, -10.914950577461585],
              [-14.107953437877603, -10.909838917018739],
              [-14.1164875631655, -10.89600227307015],
              [-14.118629632322953, -10.887544329518981],
              [-14.12650235497126, -10.885979854109907],
              [-14.123784103524661, -10.896702451483945],
              [-14.127802089659415, -10.901616968947955],
              [-14.132327724854653, -10.895098674962826],
              [-14.137011683741827, -10.89269612892888],
              [-14.143478938577097, -10.883893393730682],
              [-14.152817777061099, -10.876855310515955],
              [-14.154904514096696, -10.877794395563031],
              [-14.139932025130404, -10.895301648191692],
              [-14.133329625951033, -10.901494077297022],
              [-14.13021138749773, -10.907729216497785],
              [-14.130421608872217, -10.911510748945693],
              [-14.140570168759659, -10.911132585778041],
              [-14.143030352616176, -10.907850333794741],
              [-14.156354301325196, -10.902968978659285],
              [-14.162882052600937, -10.903050700706661],
              [-14.164843110872514, -10.900993530880443],
              [-14.180024864286024, -10.898186142342238],
              [-14.186757091059489, -10.891539063684158],
              [-14.19608577439446, -10.888358405863388],
              [-14.202886202904356, -10.880903817393781],
              [-14.210189027641304, -10.877738542574193],
              [-14.21644811539677, -10.871070169046193],
              [-14.221568223529575, -10.877687524956173],
              [-14.215132058039073, -10.886113693486294],
              [-14.209201612638715, -10.88566798802243],
              [-14.205329180199685, -10.89229928323168],
              [-14.197841355537047, -10.897826184678081],
              [-14.193268256095152, -10.898527834299719],
              [-14.18691958585045, -10.903879829873473],
              [-14.18506782693945, -10.907438490429158],
              [-14.18588022403803, -10.915770892313292],
              [-14.19197990134299, -10.914663472557667],
              [-14.201852930812962, -10.91760824671245],
              [-14.205497075502786, -10.92180343980495],
              [-14.20740193674715, -10.936614007808824],
              [-14.212922930666407, -10.943836690560936],
              [-14.214352468531379, -10.951017158100877],
              [-14.207696978755957, -10.951433891957832],
              [-14.202254335402275, -10.93548457362684],
              [-14.200200548071347, -10.933439553733137],
              [-14.19926767606791, -10.925110319120696],
              [-14.194810849574113, -10.92352441620774],
              [-14.18509577141902, -10.9247002664618],
              [-14.182740688823253, -10.921403657050698],
              [-14.176101374967342, -10.924634007163764],
              [-14.173131030727424, -10.923066379645478],
              [-14.16590001095358, -10.924361536665373],
              [-14.15750883368804, -10.932449988422768],
              [-14.159053421791501, -10.923512156496052],
              [-14.152459850604634, -10.923209673363717],
              [-14.149593286498451, -10.921094939530963],
              [-14.139852127218957, -10.925654161487497],
              [-14.134328478663141, -10.925275091960243],
              [-14.132069935956123, -10.928919640017504],
              [-14.123864393441956, -10.925147353811038],
              [-14.114899510590526, -10.9271876447442],
              [-14.100962943552329, -10.935982323214617],
              [-14.097690865109291, -10.93596057554834],
              [-14.099504136385166, -10.943412138579768],
              [-14.107474156654176, -10.942349292209729],
              [-14.111300010298736, -10.951748295932811],
              [-14.105867431352126, -10.952851551906635],
              [-14.100525997755074, -10.95624641398509],
              [-14.097607228940163, -10.950146460740212],
              [-14.093404496889184, -10.951610367358949],
              [-14.09064830830355, -10.955971602134701],
              [-14.085219145514166, -10.954060249445767],
              [-14.073311678396228, -10.957839725713075],
              [-14.06341220823494, -10.965790781417859],
              [-14.068446418775494, -10.979276914560106],
              [-14.074757330161608, -10.984767056895619],
              [-14.082824588522355, -11.00085364256795],
              [-14.08148008879552, -11.005069555488527],
              [-14.074744408364227, -11.003254965610212],
              [-14.075886043453737, -10.998167538447507],
              [-14.069565893348527, -10.990840556729792],
              [-14.063479132813333, -10.98911491096297],
              [-14.062792089953156, -10.98376016855745],
              [-14.05977618846459, -10.979443545966806],
              [-14.05473926272102, -10.98054751561606],
              [-14.057772702696791, -10.97203661568983],
              [-14.056686524591592, -10.969837327983337],
              [-14.048388553277723, -10.97295955144106],
              [-14.042324970653498, -10.978885950413257],
              [-14.03174958025874, -10.983260462904601],
              [-14.028577775377707, -10.987150979143179],
              [-14.031626042580962, -10.990709682791309],
              [-14.02251371427681, -10.999229180893114],
              [-14.017725054468457, -10.9978690283736],
              [-14.0134953536493, -11.002703245107911],
              [-14.01153932026998, -11.008002270263031],
              [-14.006708014126522, -11.012121508865473],
              [-14.00305660048882, -11.012241857958246],
              [-14.000198394001872, -11.024283710270165],
              [-13.994088472760927, -11.025982904311213],
              [-13.994654051990176, -11.033724779121378],
              [-13.991199058856825, -11.034977085624297],
              [-13.986194742620338, -11.043049628200562],
              [-13.984616224068214, -11.049871739698865],
              [-13.980062364036476, -11.05261492828761],
              [-13.98549600053974, -11.059842131922638],
              [-13.987597484885201, -11.067367629965933],
              [-13.991568100538668, -11.070107082459636],
              [-13.997968906056851, -11.070533148434917],
              [-14.00680457201161, -11.079315745776766],
              [-14.016821497719954, -11.086543547074735],
              [-14.021750167214266, -11.084085126208091],
              [-14.022791924486574, -11.078123785140004],
              [-14.020674202830538, -11.069067730183956],
              [-14.029594344950393, -11.065828684326812],
              [-14.030533379961202, -11.070786449494069],
              [-14.037343694403114, -11.072135050593928],
              [-14.038143036464122, -11.077065856985543],
              [-14.033721972973163, -11.080684947024258],
              [-14.031789721490822, -11.08507495238785],
              [-14.034424533618603, -11.097491965526428],
              [-14.038788943098188, -11.09354788951307],
              [-14.044672396893539, -11.093729997579166],
              [-14.051228519337286, -11.099960630704354],
              [-14.057603744527285, -11.100283024541678],
              [-14.062628839814572, -11.09760853354688],
              [-14.066654413794422, -11.098637480465838],
              [-14.07199536490856, -11.090400303816965],
              [-14.08116973375793, -11.094301781299498],
              [-14.072954013739038, -11.106836961775937],
              [-14.069201104136281, -11.106469911021293],
              [-14.062045719677249, -11.11735631841146],
              [-14.060892956447924, -11.123298150150928],
              [-14.063935743017796, -11.127290639640083],
              [-14.062860297818284, -11.133403943334965],
              [-14.067086915361955, -11.137364236239977],
              [-14.078776052388859, -11.140091328436185],
              [-14.088642053528947, -11.130521948991406],
              [-14.091943502849487, -11.121644048106788],
              [-14.08593087325723, -11.114025813905249],
              [-14.09048330634355, -11.112879097611788],
              [-14.093826020163633, -11.116589656311167],
              [-14.104900583135429, -11.118084912633094],
              [-14.10721612550171, -11.110764046356904],
              [-14.104617801308766, -11.104643964002852],
              [-14.110071699584424, -11.105278188813758],
              [-14.11189178233949, -11.113952481404189],
              [-14.118131540182521, -11.111551104419185],
              [-14.120037345484274, -11.096475121826277],
              [-14.124408760929263, -11.099811690152517],
              [-14.126224176256983, -11.10570023200199],
              [-14.131457768338684, -11.10476233639322],
              [-14.130768646774479, -11.092579557877297],
              [-14.13740041363821, -11.088966015456025],
              [-14.154994864906042, -11.088924291549507],
              [-14.164623723708546, -11.095514728089531],
              [-14.163285524522664, -11.099829332121224],
              [-14.166389771895163, -11.101976194592199],
              [-14.182223165957717, -11.090737949315356],
              [-14.198548808632973, -11.084611776673933],
              [-14.206038899965748, -11.084254187797429],
              [-14.213447573634364, -11.079500392024908],
              [-14.232661620389045, -11.072883290132054],
              [-14.245276432168048, -11.064298199980502],
              [-14.276178175400926, -11.051949989374886],
              [-14.283063207405819, -11.052110296437323],
              [-14.290371860648024, -11.047906916597912],
              [-14.292042317135897, -11.039195794070434],
              [-14.295088320049075, -11.034409395929421],
              [-14.309457607930016, -11.024658832273463],
              [-14.31992626683065, -11.018384644331244],
              [-14.336760729083231, -11.010800864024635],
              [-14.348639749158785, -11.004068528278333],
              [-14.353378627561868, -10.995509669514997],
              [-14.351504381026867, -10.992411683310948],
              [-14.352347550698092, -10.984665126425995],
              [-14.356895343859494, -10.97816995432363],
              [-14.359054229095452, -10.972387720189131],
              [-14.373150087107947, -10.961276690736073],
              [-14.388364398228852, -10.951484468664423],
              [-14.409658680881096, -10.940856406663185],
              [-14.412679321451806, -10.937111470591137],
              [-14.423757714640448, -10.932151317684948],
              [-14.443567093063821, -10.926390482533943],
              [-14.481648730704528, -10.920293697034648],
              [-14.495491632763889, -10.918731128938646],
              [-14.51003016608487, -10.912478705739154],
              [-14.535535456086652, -10.89888096281541],
              [-14.552681087074841, -10.891494568399409],
              [-14.566332642869689, -10.887244167362876],
              [-14.583549895698178, -10.883114864147212],
              [-14.625963554538727, -10.8741270507533],
              [-14.63673195989602, -10.871471785715526],
              [-14.66586104616936, -10.860979373247929],
              [-14.692017204515588, -10.85051342539871],
              [-14.706546778285125, -10.842917882713076],
              [-14.740241965356299, -10.829786407050321],
              [-14.74565690010916, -10.82608734329659],
              [-14.74212416028307, -10.819298422193583],
              [-14.730954759775184, -10.82268010645188],
              [-14.72374726730026, -10.819798431203374],
              [-14.727456492408429, -10.816934284231952],
              [-14.725918757609707, -10.811374975853605],
              [-14.721835892969867, -10.810414386531],
              [-14.721292352521148, -10.803687887950757],
              [-14.725443937317335, -10.800755005841443],
              [-14.72235663336323, -10.793318215301905],
              [-14.717800415982266, -10.795565706684771],
              [-14.71682830099754, -10.804640706281813],
              [-14.714624635791694, -10.809608754556413],
              [-14.708488208120094, -10.802843173346117],
              [-14.708715357245069, -10.79923677485758],
              [-14.701794517968757, -10.79361749327433],
              [-14.706288804628162, -10.79214722178745],
              [-14.704381894989059, -10.780948088745667],
              [-14.70122210812916, -10.778119377643232],
              [-14.701384981497652, -10.773677723355462],
              [-14.697854804388777, -10.768986131290132],
              [-14.69577373484261, -10.761874689838441],
              [-14.692469786327202, -10.760476093854127],
              [-14.692499406802334, -10.755798063203937],
              [-14.70570682958973, -10.747339912629014],
              [-14.710806702771967, -10.73958315502428],
              [-14.714377025423305, -10.737184231614712],
              [-14.71930128810423, -10.728951222878852],
              [-14.719618879617801, -10.723253250570123],
              [-14.72729100017489, -10.71480136292051],
              [-14.731038786840497, -10.705761391507226],
              [-14.731739669782339, -10.69577638206862],
              [-14.728307174420143, -10.694109193292928],
              [-14.720251280275832, -10.684316087461287],
              [-14.717536836543834, -10.675979595200799],
              [-14.718293175901957, -10.671115787191436],
              [-14.715151976026632, -10.65942874121453],
              [-14.722839861445133, -10.652169838506437],
              [-14.725882295922492, -10.645442213018073],
              [-14.729234640110295, -10.64919341445859],
              [-14.73232845809955, -10.659775680039841],
              [-14.735755630834253, -10.664929589077273],
              [-14.733309096293167, -10.672818381568787],
              [-14.733418452507978, -10.68077122656416],
              [-14.739814912349756, -10.686570690027722],
              [-14.745338256410221, -10.689443319819972],
              [-14.748682759567865, -10.693423783886868],
              [-14.754766529899008, -10.71202838360722],
              [-14.751736365288568, -10.721289156337471],
              [-14.752218602731428, -10.727003714583148],
              [-14.756755231889137, -10.731938928816835],
              [-14.772331187359043, -10.74255026766285],
              [-14.778856023650324, -10.74604437538303],
              [-14.795401206158854, -10.759229440072268],
              [-14.80682098391188, -10.766217675460053],
              [-14.814072023947727, -10.771991523130474],
              [-14.815466053229336, -10.777138252155785],
              [-14.819759576780301, -10.782700443842824],
              [-14.834224516061832, -10.791388908455518],
              [-14.847574102578166, -10.792092873907949],
              [-14.898454367404351, -10.7969613108754],
              [-14.92693443382919, -10.795906706741015],
              [-14.936900087328842, -10.794664446160702],
              [-14.954519266974744, -10.788382412293196],
              [-14.974202388416964, -10.783326736158859],
              [-15.011620439581659, -10.772987584456473],
              [-15.027995711892913, -10.769255829730584],
              [-15.042342822321304, -10.764539787935695],
              [-15.040053790286208, -10.757824905303302],
              [-15.035448147305468, -10.754109089000755],
              [-15.034920893402637, -10.749235869707903],
              [-15.030776782453326, -10.74556420407689],
              [-15.025800645238975, -10.7457096980057],
              [-15.018299558273535, -10.740851417215215],
              [-15.021013812458103, -10.731481222147213],
              [-15.0176891020425, -10.726176146937593],
              [-15.017622823587777, -10.720102261847858],
              [-15.022720768515203, -10.715016209078705],
              [-15.025186501876572, -10.708929952668221],
              [-15.033448771344972, -10.702071559538082],
              [-15.026999599354141, -10.700804199926456],
              [-15.025675400188963, -10.693211868082805],
              [-15.020191517193965, -10.688579882871398],
              [-15.018360778786244, -10.682311902198139],
              [-15.008180398393325, -10.675108204071721],
              [-15.007813645385706, -10.66429491428247],
              [-15.01111284832678, -10.66355697982904],
              [-15.013394582348605, -10.674694588134631],
              [-15.02068698317953, -10.68034066539903],
              [-15.026012287497707, -10.686815502252482],
              [-15.03128884578087, -10.690256358860806],
              [-15.041014841339704, -10.690124903890668],
              [-15.044987806090436, -10.68580193551839],
              [-15.04589804893256, -10.673148611127338],
              [-15.050284086734502, -10.66919518284997],
              [-15.05274136267318, -10.671446823531014],
              [-15.05592249266562, -10.680115966452206],
              [-15.066759411287185, -10.67665958308621],
              [-15.07353271518299, -10.670736788021106],
              [-15.078526126087453, -10.671170097745614],
              [-15.078001594410102, -10.676932106369367],
              [-15.073816122840064, -10.68055816184567],
              [-15.072104970034218, -10.685063689726887],
              [-15.065959289251193, -10.686203028007974],
              [-15.061327989542685, -10.689705444241508],
              [-15.056559601498911, -10.69713952238068],
              [-15.055655276075202, -10.702220340974783],
              [-15.049062222839815, -10.702564044913727],
              [-15.03895769298061, -10.711849456492372],
              [-15.042462574773594, -10.721682459897842],
              [-15.052036041900067, -10.7277172683556],
              [-15.058988155495268, -10.730634531515133],
              [-15.064451816992316, -10.73925915883179],
              [-15.072787715625825, -10.743305885659746],
              [-15.087675384256757, -10.746699021943124],
              [-15.096951225654465, -10.747766286633002],
              [-15.124200878391603, -10.739557341742582],
              [-15.144416527118365, -10.736408825600511],
              [-15.163465702655415, -10.737021721173315],
              [-15.182412570893394, -10.734092258048392],
              [-15.199103903763307, -10.732905022756187],
              [-15.214424447132524, -10.733204533706926],
              [-15.222677956058728, -10.734717520776499],
              [-15.225729760595415, -10.73221066423927],
              [-15.24194647765412, -10.73067858399334],
              [-15.27007159862674, -10.73217541284001],
              [-15.289277498336745, -10.734741860463918],
              [-15.305961181370476, -10.739229255602897],
              [-15.319565647970546, -10.74515699945062],
              [-15.34227904628733, -10.753845511878145],
              [-15.40852527039805, -10.771159364158773],
              [-15.425668796242226, -10.776314116791783],
              [-15.437466671447387, -10.782198261873456],
              [-15.455994269991109, -10.793575660270905],
              [-15.462401372814538, -10.798846967512617],
              [-15.470022627072897, -10.801658952174009],
              [-15.481641005970538, -10.79926777437389],
              [-15.486956335850563, -10.794711704269478],
              [-15.501657048130388, -10.794450259283249],
              [-15.510939155653112, -10.79756063939931],
              [-15.521433740510643, -10.796586744153108],
              [-15.53375221719995, -10.797869898481531],
              [-15.527973064920069, -10.791311462333846],
              [-15.516227856146836, -10.788703932759175],
              [-15.509771717124327, -10.789846806293275],
              [-15.506672995046165, -10.786573048219845],
              [-15.501646816998818, -10.78769392868678],
              [-15.497970776975508, -10.785740645405323],
              [-15.503676087106216, -10.776648566613863],
              [-15.520167620511302, -10.767005993125],
              [-15.528374468876642, -10.765640304049072],
              [-15.531785513651059, -10.761646595564702],
              [-15.53896313993994, -10.761694938751196],
              [-15.54680870380999, -10.758488753832609],
              [-15.545717164032173, -10.753254243842019],
              [-15.550718603312443, -10.75158417904651],
              [-15.550355785842212, -10.746211056108036],
              [-15.561162449279955, -10.751684527865793],
              [-15.571450979040916, -10.752536868271436],
              [-15.579082392767, -10.755024012175708],
              [-15.588928393032358, -10.750068230700663],
              [-15.594208821508863, -10.754397717722036],
              [-15.605327783610306, -10.749486163958888],
              [-15.616774632824397, -10.746261129546962],
              [-15.62709869435677, -10.745013358051878],
              [-15.655945337964562, -10.74615569032398],
              [-15.659553823940854, -10.743229992134289],
              [-15.649752825130854, -10.736434170036782],
              [-15.639548978811584, -10.734014157534158],
              [-15.629960831041592, -10.729039228404345],
              [-15.637012593822082, -10.722942625879256],
              [-15.642652133823345, -10.724125889693388],
              [-15.654550059078964, -10.721805517974405],
              [-15.659185241514276, -10.726005557089673],
              [-15.667533588915257, -10.72442275813312],
              [-15.669962266165873, -10.717404716737905],
              [-15.668000207126811, -10.711276082214185],
              [-15.661777198069228, -10.697772744626821],
              [-15.659311991551984, -10.689412697122867],
              [-15.660094969562072, -10.686969206499748],
              [-15.65341121421743, -10.668567367658286],
              [-15.650161264693244, -10.661503947367168],
              [-15.65639228822642, -10.662069114005646],
              [-15.663531429113139, -10.665372800274827],
              [-15.667080631820763, -10.67070111856208],
              [-15.66774672505795, -10.676554219912491],
              [-15.683390857459413, -10.683114430215587],
              [-15.689149095571604, -10.688217941157435],
              [-15.693052059584925, -10.69663335061276],
              [-15.696074507557768, -10.711223207364274],
              [-15.694596062785942, -10.722464481971771],
              [-15.699038963220712, -10.726025123264371],
              [-15.704403570376316, -10.722835121751427],
              [-15.712947358637706, -10.7257998777398],
              [-15.72835387409896, -10.71837658725376],
              [-15.730488655448308, -10.715645425073603],
              [-15.739824049442417, -10.713794433851357],
              [-15.755472521281314, -10.703602533912324],
              [-15.762547207298079, -10.70255867437237],
              [-15.76683205591993, -10.699156262472137],
              [-15.765255168157598, -10.692134194923716],
              [-15.774074476933896, -10.690449466393972],
              [-15.783809908238414, -10.684201404541676],
              [-15.801137696293972, -10.682072213195859],
              [-15.807707026311263, -10.683676976982232],
              [-15.812913620061686, -10.682073638241006],
              [-15.815261298253414, -10.68531688974815],
              [-15.831874983118247, -10.690740995096514],
              [-15.847464720859202, -10.685052499729107],
              [-15.842487701000973, -10.67956784271584],
              [-15.840255515037983, -10.674534897518562],
              [-15.836336018089355, -10.675956614477553],
              [-15.82943534231935, -10.667529100259618],
              [-15.821255069269675, -10.66248481440479],
              [-15.814242566918631, -10.645563289255634],
              [-15.809786915594163, -10.640657878563731],
              [-15.805943942169582, -10.629437590593191],
              [-15.804792432455006, -10.622126089655445],
              [-15.797587306643807, -10.614943873109477],
              [-15.79897626048115, -10.609887279100429],
              [-15.802505102878872, -10.609495467195751],
              [-15.804933373714986, -10.613687954459563],
              [-15.820924152974758, -10.625553576360094],
              [-15.834485030248008, -10.633099751979474],
              [-15.84146478174434, -10.634249387723923],
              [-15.841458031588187, -10.63099021874552],
              [-15.836483184712643, -10.628847776367211],
              [-15.831667740365168, -10.623984740917875],
              [-15.834917071781929, -10.621095124722403],
              [-15.843771162693457, -10.619511217811956],
              [-15.848959388959383, -10.621715898495975],
              [-15.849757562910595, -10.630284802018558],
              [-15.86022581964003, -10.634556704815523],
              [-15.862129705454766, -10.632897164018958],
              [-15.861700161884933, -10.625741170823984],
              [-15.851663318745329, -10.60407032354096],
              [-15.857359530347543, -10.60772694481306],
              [-15.869644217063742, -10.619349658630698],
              [-15.881900430745143, -10.627699629842201],
              [-15.885902906399316, -10.632159364086148],
              [-15.904304635980234, -10.636306534795269],
              [-15.907336143939931, -10.628442797285542],
              [-15.902201167733715, -10.625381322495299],
              [-15.895705196106219, -10.614610909103197],
              [-15.88528559363779, -10.603486018163913],
              [-15.881370243984948, -10.601773399716633],
              [-15.874801785670623, -10.59439097726902],
              [-15.878859713584063, -10.592061338750966],
              [-15.872332169749225, -10.587574210105066],
              [-15.878803318587426, -10.58216090931507],
              [-15.883375089455239, -10.58964366893046],
              [-15.886410499898698, -10.597156742090698],
              [-15.891892445311447, -10.599387850993201],
              [-15.903651446058294, -10.594974497098535],
              [-15.903797052484302, -10.603819755155358],
              [-15.907393426712957, -10.60633803467746],
              [-15.914548670823487, -10.607097401009103],
              [-15.918082168967576, -10.604308624398838],
              [-15.918781392386396, -10.596205302876179],
              [-15.917160946781742, -10.590914456412806],
              [-15.920813797894704, -10.589820300534152],
              [-15.921237429741764, -10.596933081450825],
              [-15.925444934447397, -10.605033593562665],
              [-15.930086676609417, -10.608177679695954],
              [-15.931292600606112, -10.616023743299968],
              [-15.936374434682634, -10.619194688289152],
              [-15.946961795522615, -10.622281864794344],
              [-15.952611134136207, -10.619583057257332],
              [-15.962265207043046, -10.620786222323435],
              [-15.968371908947203, -10.624348330210053],
              [-15.976019449584754, -10.620979932267742],
              [-15.97615569106268, -10.614529389775674],
              [-15.983266139501268, -10.607872318080668],
              [-15.979194961245806, -10.604855692539028],
              [-15.975788262343867, -10.608935780324005],
              [-15.971944283417935, -10.604720598031594],
              [-15.968589779278327, -10.59676576070672],
              [-15.963466887704353, -10.598642852451848],
              [-15.96415824844489, -10.604369760371378],
              [-15.953285768134625, -10.596647247308955],
              [-15.954148875594562, -10.5910953023645],
              [-15.944042624459719, -10.590269199699737],
              [-15.928126257024447, -10.583068412607352],
              [-15.923747822918827, -10.582388787081898],
              [-15.910974234327492, -10.57032269160956],
              [-15.90958999621336, -10.561985666937957],
              [-15.898795870155196, -10.558600149094381],
              [-15.88703412408109, -10.561877010538268],
              [-15.889492315511479, -10.557372021310272],
              [-15.893447953514382, -10.557774925315243],
              [-15.904048327181927, -10.549389859931638],
              [-15.90616252899077, -10.552250278246625],
              [-15.911838316736434, -10.548601464278857],
              [-15.915910951926483, -10.554984576779487],
              [-15.915272592038521, -10.557788670874704],
              [-15.92514339690676, -10.57055629110621],
              [-15.93665135498811, -10.575266368635868],
              [-15.939566287007386, -10.568062792287671],
              [-15.944755588256733, -10.57553408209685],
              [-15.948236079789291, -10.577234465487328],
              [-15.957002553675393, -10.577787815575878],
              [-15.96333134459152, -10.575971656471868],
              [-15.96565580390155, -10.572886232826809],
              [-15.96288353852036, -10.568876053711795],
              [-15.96888249862735, -10.564730018017581],
              [-15.9717068252219, -10.568822959712747],
              [-15.973366150773089, -10.576754593955553],
              [-15.976614040018578, -10.577513099558795],
              [-15.976634724991337, -10.568538536822428],
              [-15.974072271265399, -10.560876491240457],
              [-15.979046460090657, -10.557280259313805],
              [-15.984504299318727, -10.563946833331633],
              [-15.988653909473886, -10.559713823431043],
              [-15.990885479867554, -10.55447029375034],
              [-15.996541536461244, -10.54831409598131],
              [-15.997454819963997, -10.541769521026678],
              [-16.002432022202466, -10.53526549289809],
              [-15.996970961442202, -10.533052691349946],
              [-15.996047673451516, -10.536963497667658],
              [-15.991475204394396, -10.540179492316037],
              [-15.984602184255285, -10.536643082305048],
              [-15.97897268915453, -10.541104213748829],
              [-15.972606059923521, -10.539361194789915],
              [-15.976678101907977, -10.532766639955835],
              [-15.981360120911923, -10.531114131073391],
              [-15.988568755152377, -10.534327451043255],
              [-15.995852102797956, -10.528220863001813],
              [-15.992805112563664, -10.523822880699859],
              [-15.99347386103568, -10.515884318084822],
              [-15.990204318601245, -10.504722439410706],
              [-15.98587760406098, -10.50727116843974],
              [-15.977842508592145, -10.50598964755624],
              [-15.972145751990224, -10.507582947825881],
              [-15.974034183362226, -10.501308464224426],
              [-15.987978795784459, -10.498700678703125],
              [-15.989885002529732, -10.49395085544451],
              [-15.983915509115166, -10.486465355855344],
              [-15.975509265371114, -10.486978217420727],
              [-15.966375219601824, -10.484507477427663],
              [-15.961610864248527, -10.485075360977397],
              [-15.95261130005244, -10.483547267658029],
              [-15.943495786193116, -10.479596877014878],
              [-15.935636165582872, -10.481065374798673],
              [-15.9190416280413, -10.477807674463072],
              [-15.923934034237018, -10.47052471454252],
              [-15.930129482843341, -10.464829992327001],
              [-15.948059218400987, -10.468137054034695],
              [-15.951284406709672, -10.46500968945854],
              [-15.959811282966902, -10.466486667576046],
              [-15.96449275861471, -10.470062740520303],
              [-15.978311732806397, -10.472314241437509],
              [-15.977051583518694, -10.468185390036314],
              [-15.97975875922369, -10.465453224936061],
              [-15.983486490489776, -10.473382783870932],
              [-15.989056198264977, -10.478443012127466],
              [-15.992841810393731, -10.487220890519087],
              [-15.995258581836866, -10.497114081214367],
              [-16.01066823498022, -10.504640549258763],
              [-16.020083549010014, -10.523274064864742],
              [-16.020041471105873, -10.527507326283228],
              [-16.023085107529276, -10.533138332566441],
              [-16.03038978988744, -10.540732067295105],
              [-16.03681655246836, -10.545146427292481],
              [-16.041267069271573, -10.542923483976303],
              [-16.049553142655448, -10.542511624722781],
              [-16.049118110491204, -10.539407332957818],
              [-16.04341730187397, -10.533809411089827],
              [-16.038734180326596, -10.532359775052853],
              [-16.03950865307136, -10.526172807746857],
              [-16.044820263558414, -10.514352844223652],
              [-16.043763905521544, -10.509609593092906],
              [-16.04740145685168, -10.504491899394333],
              [-16.0490763660151, -10.497228753890479],
              [-16.05558006324417, -10.490803295399566],
              [-16.054950968312397, -10.487645895039966],
              [-16.058945732106224, -10.482095546722018],
              [-16.05285157017098, -10.478116669890504],
              [-16.049657548542953, -10.470770802710327],
              [-16.063471956636185, -10.469809388903768],
              [-16.070070027960806, -10.475464934605409],
              [-16.06686888726296, -10.48366745308161],
              [-16.065971809074444, -10.489857358453108],
              [-16.069682275939705, -10.493428664426576],
              [-16.064783752990973, -10.49707870651364],
              [-16.059279127178065, -10.517212913356213],
              [-16.06830268576271, -10.532542785953108],
              [-16.06571182575515, -10.545039679465924],
              [-16.071999465242833, -10.548565339977255],
              [-16.079522269055158, -10.542210642910394],
              [-16.08070414313402, -10.531256018745347],
              [-16.09065400810837, -10.535856599036503],
              [-16.08981545188715, -10.540257970261198],
              [-16.083961416429876, -10.550878317235615],
              [-16.08528565897605, -10.553151253114569],
              [-16.0945391080641, -10.555878108143482],
              [-16.095846955806845, -10.562859022010418],
              [-16.101417250904607, -10.56783297325741],
              [-16.109176535303042, -10.565444576483173],
              [-16.116760360811792, -10.565562476206706],
              [-16.115936423014997, -10.5594654058243],
              [-16.118190386413858, -10.556376809434667],
              [-16.109364871228376, -10.541832161900027],
              [-16.11182530756929, -10.54029123822941],
              [-16.11714034727688, -10.549321248791147],
              [-16.120355430666198, -10.542884719428033],
              [-16.120575127416203, -10.532660068722235],
              [-16.12298883954192, -10.532754521692434],
              [-16.1245080841693, -10.542186021528435],
              [-16.12683881268653, -10.546976341609493],
              [-16.126337445995016, -10.560713982924357],
              [-16.127592908870504, -10.567212160889897],
              [-16.131963324481106, -10.564803911505892],
              [-16.133314397166316, -10.560480281889133],
              [-16.1311333929474, -10.556244315108762],
              [-16.132861937129988, -10.546174490668157],
              [-16.135971738727466, -10.537026246018973],
              [-16.132191542785865, -10.531783020512576],
              [-16.132204024913076, -10.526386208203794],
              [-16.135110717035968, -10.510746858957397],
              [-16.129536095207925, -10.507854760595603],
              [-16.133333664064466, -10.50249501014975],
              [-16.13310840303958, -10.497687388273677],
              [-16.140255460251485, -10.484268096304515],
              [-16.144665745422145, -10.486621905859307],
              [-16.14163775101, -10.491012963520165],
              [-16.14012305436035, -10.499198887210149],
              [-16.141934304408487, -10.509384955013807],
              [-16.146522948115933, -10.521721035619953],
              [-16.143170807509204, -10.525657623493304],
              [-16.146070634296773, -10.539269542827599],
              [-16.148128541995256, -10.54444664708038],
              [-16.14264989796235, -10.54734985136582],
              [-16.141811505328242, -10.55155547518395],
              [-16.144661324851363, -10.560220737824231],
              [-16.140866786051298, -10.565674322534399],
              [-16.139546393591907, -10.571887267935573],
              [-16.1400812777094, -10.583340483175432],
              [-16.150621310052983, -10.58837420332945],
              [-16.153274404705297, -10.582778919143442],
              [-16.153863862191844, -10.575668547711043],
              [-16.162073926783997, -10.574349688795323],
              [-16.16480107331383, -10.570583930522536],
              [-16.16247591549149, -10.556546701602576],
              [-16.167159011570934, -10.555580748613652],
              [-16.168197347815493, -10.562668689643164],
              [-16.17238077769854, -10.578514887547568],
              [-16.17667849028686, -10.580495931548757],
              [-16.16392123126809, -10.588211340063179],
              [-16.167815719182073, -10.599320673773002],
              [-16.178775858133267, -10.596396327984232],
              [-16.175599735411037, -10.593755027370216],
              [-16.176425828615898, -10.586955724836171],
              [-16.182526010897064, -10.597233125789808],
              [-16.18633139089266, -10.595393198054824],
              [-16.192147470382142, -10.588481064155275],
              [-16.195350764915258, -10.574525771436345],
              [-16.19908850236363, -10.587616392565563],
              [-16.192361054962298, -10.596988173137312],
              [-16.192791084601442, -10.601788019644987],
              [-16.19962781797328, -10.60526198595857],
              [-16.204480849448743, -10.598733504607168],
              [-16.204234222985384, -10.609415228175669],
              [-16.21124824636288, -10.613455146077735],
              [-16.217579571062366, -10.611721556713821],
              [-16.222389417145887, -10.613310044869305],
              [-16.230437613496324, -10.609952134155964],
              [-16.232314742302965, -10.602823634980956],
              [-16.228592156187133, -10.592275434797502],
              [-16.229922446685272, -10.587710985353226],
              [-16.225222096035203, -10.576697253916793],
              [-16.227173653446094, -10.569894810949378],
              [-16.223665040838945, -10.56666286959506],
              [-16.218489439283374, -10.555596894336528],
              [-16.213476575142035, -10.550791228090315],
              [-16.209120629369025, -10.538927137620348],
              [-16.203929549758037, -10.531828976929795],
              [-16.203756359757072, -10.521990828902485],
              [-16.199328892558363, -10.51289398201806],
              [-16.206120779067096, -10.512589028313785],
              [-16.197560377474733, -10.502129701428567],
              [-16.191881238594743, -10.491470634743102],
              [-16.17953955131426, -10.473930517203726],
              [-16.178709020174292, -10.470608014599735],
              [-16.16881614485717, -10.465698851714858],
              [-16.15860425453156, -10.457309714034736],
              [-16.167547744933852, -10.45561011688174],
              [-16.17911831054415, -10.461572619017153],
              [-16.173158859471563, -10.4506174552313],
              [-16.170591074984948, -10.441968000420184],
              [-16.176131517180064, -10.439709661371634],
              [-16.185600205143572, -10.454549011183056],
              [-16.190448192328606, -10.468495783464318],
              [-16.19662108579138, -10.475775974420593],
              [-16.208443280391215, -10.496332885553198],
              [-16.211813245170564, -10.500226200164557],
              [-16.215421155999877, -10.508198106853694],
              [-16.214306621438116, -10.519423787086335],
              [-16.21839630898141, -10.527090271842825],
              [-16.22433610491865, -10.5353219682769],
              [-16.22773708269093, -10.537592221413629],
              [-16.23067608970624, -10.527652807213453],
              [-16.23321481797158, -10.526757508349805],
              [-16.235088085204787, -10.51627016440752],
              [-16.241288932257888, -10.505930343148234],
              [-16.23896993333189, -10.50087022830281],
              [-16.246027942002573, -10.501044338280325],
              [-16.24721336639458, -10.511183611440497],
              [-16.25375581535384, -10.510431035756007],
              [-16.263891545911175, -10.514083404029723],
              [-16.270615063511425, -10.523260572984658],
              [-16.281345617529496, -10.523918324054964],
              [-16.28161860387459, -10.527769206980844],
              [-16.274360836259625, -10.529278259834042],
              [-16.276297872965376, -10.539497132412498],
              [-16.279947151718254, -10.544873063050488],
              [-16.286244825415523, -10.54998857168404],
              [-16.28204813824662, -10.554237924523944],
              [-16.2757726126671, -10.549319990813592],
              [-16.26618963878085, -10.530147339439955],
              [-16.2579179808795, -10.522983826236311],
              [-16.252963800118156, -10.521643327245608],
              [-16.243378955845095, -10.51627271358426],
              [-16.242358159646226, -10.529028649007543],
              [-16.243508330503385, -10.537353088648443],
              [-16.242801353041113, -10.544363339683043],
              [-16.245274312121307, -10.546495251492427],
              [-16.24574244646296, -10.552555295027227],
              [-16.251572469789583, -10.556952259336896],
              [-16.250790975545222, -10.56304756353983],
              [-16.26181169033314, -10.557622727076712],
              [-16.25922296381376, -10.569650205430927],
              [-16.254502911198603, -10.57137200392741],
              [-16.25613391013495, -10.578121131270718],
              [-16.26061657083048, -10.58840303387246],
              [-16.257131716421206, -10.589351627661532],
              [-16.25901926643339, -10.599262920529721],
              [-16.272215630417772, -10.59194345788834],
              [-16.27546746323452, -10.59698843885693],
              [-16.26378581946551, -10.605790521627732],
              [-16.26667471264864, -10.611298674555567],
              [-16.27169847559535, -10.611170563369345],
              [-16.279284495574565, -10.603044394996333],
              [-16.29216593983414, -10.60362043166477],
              [-16.299229711858658, -10.607789117709084],
              [-16.309374623124757, -10.606736457949847],
              [-16.319249478961204, -10.61631625402841],
              [-16.32744531121076, -10.621782751852592],
              [-16.326495552061665, -10.62548619056417],
              [-16.318302650181863, -10.623916436800615],
              [-16.30932617136052, -10.618098518307388],
              [-16.30319241509459, -10.612825588852665],
              [-16.296830987468066, -10.615164273843304],
              [-16.28942147913155, -10.611390758151824],
              [-16.2831702254265, -10.61167827595623],
              [-16.28218351981588, -10.616539902133693],
              [-16.284718003016888, -10.619722388174303],
              [-16.295710374986275, -10.620297722563379],
              [-16.3047066525151, -10.626813491616932],
              [-16.309730007068424, -10.632364038562404],
              [-16.317900794527052, -10.645208656593411],
              [-16.318534563103906, -10.661862365136221],
              [-16.314231902239374, -10.66317610014914],
              [-16.305367020978917, -10.650697872673247],
              [-16.301085204753278, -10.636157854993028],
              [-16.29609478891723, -10.632656138117387],
              [-16.293835121522978, -10.6266950673257],
              [-16.29083464544266, -10.624930909321884],
              [-16.28086498040998, -10.62968214333151],
              [-16.279731441170732, -10.62439898446139],
              [-16.272560677986707, -10.619703326491734],
              [-16.26643065018507, -10.623676515442938],
              [-16.268610096244608, -10.626896076622977],
              [-16.26631949899094, -10.635056868152036],
              [-16.27117719150485, -10.640032746827634],
              [-16.268373170902333, -10.652273144245488],
              [-16.272155692732863, -10.660392630422715],
              [-16.27787057674429, -10.664335356268728],
              [-16.270779790002138, -10.669300503687795],
              [-16.263321711637893, -10.65840635101088],
              [-16.262090107499795, -10.649591211597428],
              [-16.254584216509933, -10.637654817889583],
              [-16.254575579338198, -10.634733886099431],
              [-16.25044836267712, -10.625433375735458],
              [-16.245193755154045, -10.623106103814303],
              [-16.229518439406913, -10.623668325211208],
              [-16.22411909773045, -10.626297612042167],
              [-16.22163024029671, -10.629986309770857],
              [-16.216940109044703, -10.655886351894207],
              [-16.223284458604766, -10.664416024241556],
              [-16.22944298943099, -10.667475554674489],
              [-16.231888368712283, -10.663163454260737],
              [-16.233286704094578, -10.655759467055598],
              [-16.236730362572587, -10.654657181353413],
              [-16.24182363278633, -10.647761267707072],
              [-16.24406955994744, -10.650941849089776],
              [-16.241429237702434, -10.655994254373523],
              [-16.236288301062196, -10.661299360913945],
              [-16.236628750586195, -10.66885116180157],
              [-16.232331083411484, -10.674797092010607],
              [-16.241155962955613, -10.6832575088279],
              [-16.244654073689745, -10.684586883625824],
              [-16.246229708777808, -10.689899626552114],
              [-16.255016967950905, -10.703983332242073],
              [-16.267781613236497, -10.7002009472275],
              [-16.269801157809027, -10.69665151844592],
              [-16.27544505468496, -10.69278715605366],
              [-16.280597707659567, -10.692016704988829],
              [-16.288361787123964, -10.695643455791227],
              [-16.29748059572025, -10.704900288599456],
              [-16.307798057027977, -10.71818073260072],
              [-16.310265550211472, -10.724538273809626],
              [-16.317904139103042, -10.734124553181347],
              [-16.31267730424064, -10.740411562507802],
              [-16.3094568047902, -10.735164215383302],
              [-16.30447721588376, -10.732902455016177],
              [-16.301157865856194, -10.726693985527904],
              [-16.295870081777892, -10.721059384734648],
              [-16.293009563893378, -10.71528423840981],
              [-16.28859674406589, -10.714026998675454],
              [-16.274468432174864, -10.70086817936525],
              [-16.2708502604651, -10.70539596781847],
              [-16.272022436953275, -10.710848598958918],
              [-16.262825648306908, -10.709032820507776],
              [-16.26077421425515, -10.714536391502024],
              [-16.256432184120804, -10.7136058406205],
              [-16.253195078080648, -10.71738954603754],
              [-16.257617333320848, -10.7214314356883],
              [-16.252939289656283, -10.723859063301676],
              [-16.248237237152846, -10.719973646552484],
              [-16.241431945320578, -10.71907216344456],
              [-16.24010183684658, -10.726954326793328],
              [-16.242755887383666, -10.737821902428655],
              [-16.236403925397923, -10.732365191327368],
              [-16.235455697328604, -10.726395783663065],
              [-16.236343393330532, -10.718455597675515],
              [-16.238521171164166, -10.71699846606601],
              [-16.239426234378247, -10.707221907861777],
              [-16.23268077264768, -10.698378286917807],
              [-16.228823892935708, -10.700335029267029],
              [-16.227317791238153, -10.712142965427113],
              [-16.22472176679695, -10.711857551895202],
              [-16.22682971434099, -10.698157204071142],
              [-16.226453333007992, -10.69049109928948],
              [-16.22429266455092, -10.683828219809897],
              [-16.2198527455719, -10.684304207664285],
              [-16.218239412628066, -10.678474853495825],
              [-16.213642562263615, -10.678312060345354],
              [-16.209220239749047, -10.687326035770269],
              [-16.204665289518587, -10.689737819426785],
              [-16.211449954094007, -10.695398720472598],
              [-16.20885088106529, -10.701694038920271],
              [-16.203332442959585, -10.694460230205939],
              [-16.19927143366539, -10.697239767100168],
              [-16.19929768669903, -10.704295423414212],
              [-16.1935819022817, -10.703055917432907],
              [-16.190207954980643, -10.709345629770159],
              [-16.193061928240184, -10.718367270412172],
              [-16.196998546428823, -10.723265839301249],
              [-16.19164540707279, -10.726587176454982],
              [-16.187777492067628, -10.72205689210781],
              [-16.183648678597574, -10.730483020111151],
              [-16.186964872509154, -10.73655422493022],
              [-16.191689846126987, -10.738318770251679],
              [-16.198817584582557, -10.747719380718522],
              [-16.20688712760081, -10.749163367872615],
              [-16.20780212562971, -10.754250502096259],
              [-16.21905381488399, -10.752829898901565],
              [-16.21329824180311, -10.760106290760906],
              [-16.214824261496258, -10.764294380740752],
              [-16.22027908347107, -10.768290711688598],
              [-16.229708295865425, -10.76757451863419],
              [-16.225986361422464, -10.780485008403408],
              [-16.24100770384373, -10.796887435448339],
              [-16.245351670958147, -10.79680436456749],
              [-16.247988089921904, -10.792105894762821],
              [-16.254283183863908, -10.789408516892237],
              [-16.2606415064398, -10.796018560143358],
              [-16.254145601100443, -10.797683745875785],
              [-16.247716438751457, -10.808524865826707],
              [-16.250850470862655, -10.816453784354627],
              [-16.24797822724994, -10.820263409014304],
              [-16.2449623322376, -10.811932222106398],
              [-16.242639791221848, -10.811798135788655],
              [-16.23613733226205, -10.800280500925469],
              [-16.224823711783635, -10.795825447313472],
              [-16.220312707395415, -10.798776875288468],
              [-16.22110789588089, -10.802584872090845],
              [-16.228082278535506, -10.80449130920499],
              [-16.219412030093057, -10.81509547422398],
              [-16.220941235819478, -10.825071448601324],
              [-16.217682916851395, -10.827964975599746],
              [-16.215646518885126, -10.814442921370963],
              [-16.214016537584, -10.81325831004118],
              [-16.213955324848367, -10.802906412250348],
              [-16.202469753943042, -10.809531286946887],
              [-16.206611551592818, -10.816972553482033],
              [-16.209698479727102, -10.828379797018776],
              [-16.205115274011114, -10.830766574773229],
              [-16.206064794646796, -10.836526354968926],
              [-16.200723051382383, -10.835813539097296],
              [-16.199935704523917, -10.824434291228764],
              [-16.20100774840048, -10.817198617851732],
              [-16.19582527030715, -10.813405346704204],
              [-16.193393117067085, -10.817694524952286],
              [-16.198411047069605, -10.8372542500836],
              [-16.20180112984474, -10.843047226182321],
              [-16.19889456855768, -10.845151812707558],
              [-16.20208501439539, -10.855015819442887],
              [-16.207218122956803, -10.864829051660907],
              [-16.206138412532994, -10.86851632344041],
              [-16.211141931672067, -10.87526141576105],
              [-16.220287816304143, -10.880614192243012],
              [-16.22888193492016, -10.87980392477455],
              [-16.236010506736008, -10.877425279589655],
              [-16.215686117871883, -10.872774788332448],
              [-16.226027094697503, -10.870474292033101],
              [-16.23330737846302, -10.871051371957263],
              [-16.23180805589464, -10.865428181265102],
              [-16.22626634218611, -10.863299378924392],
              [-16.217369582257483, -10.862747965892876],
              [-16.2170179200119, -10.85715238450201],
              [-16.222349002705034, -10.858328659126592],
              [-16.234728073763044, -10.853901550236422],
              [-16.234559824812923, -10.848020153361851],
              [-16.2370332108237, -10.845809088825048],
              [-16.235246586030748, -10.839959064062406],
              [-16.23608329582512, -10.832326751305384],
              [-16.240620356461466, -10.829411615830294],
              [-16.24615286007786, -10.830265768000313],
              [-16.24771282118159, -10.835659763702779],
              [-16.24503920855621, -10.839944333225551],
              [-16.248879899542573, -10.84274443216672],
              [-16.251202671547, -10.852554913448024],
              [-16.24699147382792, -10.856822355409648],
              [-16.248512747086167, -10.865938682743572],
              [-16.251551129998173, -10.867526255209679],
              [-16.25091899335273, -10.873904116512627],
              [-16.25275402596167, -10.878166646492378],
              [-16.258329762430066, -10.880497953407872],
              [-16.250075200476893, -10.884450679083535],
              [-16.25160024466538, -10.891110946179825],
              [-16.249881780616825, -10.893438090242098],
              [-16.253217961683355, -10.90038495940399],
              [-16.25362848356074, -10.906042261782837],
              [-16.261256672490738, -10.90480682681527],
              [-16.26221876499323, -10.898798656104006],
              [-16.265388487972732, -10.896505056697732],
              [-16.26688855626913, -10.888880819259802],
              [-16.269628300982422, -10.88866120900643],
              [-16.27563290601299, -10.879279593380435],
              [-16.27468560162906, -10.900492458532765],
              [-16.276717524062573, -10.90757421492935],
              [-16.28559143769168, -10.918055006762675],
              [-16.292209237757483, -10.919644873870897],
              [-16.29590660422596, -10.918264158275292],
              [-16.295711718259998, -10.912016173575912],
              [-16.301874506237027, -10.913004636972222],
              [-16.309093939109495, -10.907442630567072],
              [-16.318618671893923, -10.909601048226632],
              [-16.321408477686834, -10.917168624795075],
              [-16.32798288487892, -10.920143772623282],
              [-16.335547520580665, -10.913178327907406],
              [-16.33948785863129, -10.904829791967066],
              [-16.34667189526965, -10.904710012161278],
              [-16.351912793134865, -10.911726763842408],
              [-16.356269003357962, -10.913798891113231],
              [-16.35831992896162, -10.908742556118252],
              [-16.362210803238938, -10.907629508404565],
              [-16.364861597919727, -10.912165734586322],
              [-16.370874132193176, -10.911883021943702],
              [-16.375240336069737, -10.909688798576324],
              [-16.375255093830205, -10.903662657650898],
              [-16.366076740318142, -10.888463946676861],
              [-16.36310922187501, -10.886448205378247],
              [-16.362401848044417, -10.881043331867167],
              [-16.367021218965757, -10.877650615331246],
              [-16.37240465957335, -10.881850651951813],
              [-16.377068603869102, -10.881952214346212],
              [-16.379777250534445, -10.887075427705074],
              [-16.384094555129717, -10.888186175713344],
              [-16.38594204129046, -10.897152182986899],
              [-16.39278121688582, -10.910098726829721],
              [-16.392420409214825, -10.916719737156178],
              [-16.394447137560814, -10.923430616140369],
              [-16.399641398085674, -10.929583815225133],
              [-16.396255771823427, -10.934601560400168],
              [-16.399965924620375, -10.940902723821052],
              [-16.402909853029286, -10.939973926099093],
              [-16.402350825242426, -10.932719926724726],
              [-16.40502794235815, -10.927781732908585],
              [-16.404318751641714, -10.919325311912123],
              [-16.40520931034661, -10.909880925643272],
              [-16.410025693118484, -10.909392722367258],
              [-16.409469493640653, -10.895746844388931],
              [-16.41246746602069, -10.897659529755455],
              [-16.416160949395927, -10.873305848489053],
              [-16.420820921659573, -10.86837878604073],
              [-16.420182043904752, -10.860775086361814],
              [-16.42177591917655, -10.858734133791515],
              [-16.4319952467872, -10.861416742069753],
              [-16.434215037116502, -10.868142405467523],
              [-16.431766686804117, -10.87795972833713],
              [-16.432638137255143, -10.889795690641419],
              [-16.422233273482842, -10.902255265098043],
              [-16.428793231346553, -10.908518335777506],
              [-16.43084985342341, -10.921040233966576],
              [-16.433218784737, -10.929703446435354],
              [-16.43693644305824, -10.925628200100473],
              [-16.441083453427243, -10.925843245987695],
              [-16.445562506293793, -10.92910503185447],
              [-16.450887630572574, -10.937097680537041],
              [-16.44812875097293, -10.94456279856347],
              [-16.452514859671517, -10.945036268076024],
              [-16.45376411191397, -10.956441973402695],
              [-16.457803474804603, -10.960894734590212],
              [-16.45883651471084, -10.966949564094287],
              [-16.45361233952312, -10.969481104776225],
              [-16.451203194970077, -10.978592273490792],
              [-16.444035264247006, -10.984605961243604],
              [-16.442616919973112, -10.99065778632999],
              [-16.447672169013526, -10.995710009616177],
              [-16.44961157025832, -10.990268813689225],
              [-16.44907107745891, -10.9852883458177],
              [-16.454907080951582, -10.98434530025661],
              [-16.45861160018704, -10.972161228658639],
              [-16.462216577327435, -10.974791127491331],
              [-16.465452607935035, -10.97200327679515],
              [-16.46186780984865, -10.961281527533066],
              [-16.466903345181723, -10.960511510909294],
              [-16.46622656834406, -10.953972221521104],
              [-16.45871900069355, -10.946059031367477],
              [-16.466069097450823, -10.944595952976439],
              [-16.468476102824603, -10.928785961495649],
              [-16.47301793360682, -10.921154120666355],
              [-16.479140325366078, -10.920062122144698],
              [-16.482382118165866, -10.924216621586755],
              [-16.479510382519283, -10.931218317075109],
              [-16.47768888489945, -10.939760830367689],
              [-16.482354990500443, -10.951734235239554],
              [-16.479746715578948, -10.963887423459413],
              [-16.491386307213567, -10.9565060279517],
              [-16.499091116642262, -10.958962048193582],
              [-16.492804800178707, -10.962990013682374],
              [-16.487865701787726, -10.972263450937792],
              [-16.482724986176997, -10.97520630579339],
              [-16.486639254498186, -10.98024539753891],
              [-16.482855294986845, -10.982840960002887],
              [-16.48575535789581, -10.986475637396971],
              [-16.480535233012603, -10.989251113780915],
              [-16.48101208965417, -10.99381223672992],
              [-16.47809013698606, -11.000107686448233],
              [-16.477916378704318, -11.01014288924448],
              [-16.48027056767093, -11.011637703308727],
              [-16.476437871808326, -11.019938351214911],
              [-16.47952800010906, -11.02272509773435],
              [-16.485050837945202, -11.02327742336251],
              [-16.483213715257378, -11.01569778334087],
              [-16.4871614307526, -11.01559115606324],
              [-16.48576549551349, -11.009618541080306],
              [-16.48082038111124, -11.007051485137621],
              [-16.494893877779237, -10.999538558638497],
              [-16.495810971567412, -10.995662732022916],
              [-16.503022230925378, -10.995772902248138],
              [-16.50480701122069, -10.989365076658823],
              [-16.509036219025468, -10.98561004433132],
              [-16.51712253566841, -10.98632324768588],
              [-16.520579432035422, -10.984834176924839],
              [-16.52570775332248, -10.978897414712938],
              [-16.533322233227235, -10.97938609458684],
              [-16.537458667299223, -10.981444943306032],
              [-16.53521776377047, -10.985344084619996],
              [-16.518713539239904, -10.992704378366948],
              [-16.51572112671816, -10.996613777848369],
              [-16.517428300049012, -11.004692188932358],
              [-16.51242840030531, -11.002281370234327],
              [-16.508700739627283, -11.004313793259302],
              [-16.5080054889941, -11.013074809062612],
              [-16.509736945815277, -11.020829260115644],
              [-16.51277728015319, -11.023601815933548],
              [-16.519756327269498, -11.025365794039962],
              [-16.520415324544604, -11.03071579091519],
              [-16.5251966793777, -11.040390899635149],
              [-16.52972915678313, -11.034853037588512],
              [-16.529102911883925, -11.02892378074823],
              [-16.53587864405229, -11.024030145829],
              [-16.53781264475937, -11.0354883043881],
              [-16.53773346988579, -11.042416995570877],
              [-16.540061884295962, -11.04562476410783],
              [-16.54506690641851, -11.038789982566044],
              [-16.54720877883091, -11.043749195895238],
              [-16.54037013529966, -11.050316223095608],
              [-16.534375604995212, -11.052858850445466],
              [-16.5397419281983, -11.057325801165891],
              [-16.547247879479123, -11.060467497501945],
              [-16.55610970187171, -11.054243506605399],
              [-16.553573036167396, -11.063851052507813],
              [-16.549554592131447, -11.068158943475725],
              [-16.559793285866544, -11.073041355386682],
              [-16.564049709098658, -11.072965523959418],
              [-16.559577268795216, -11.082606400866881],
              [-16.562850476719344, -11.087600134257077],
              [-16.573032669696076, -11.089034851792944],
              [-16.572448132946317, -11.098987568690339],
              [-16.57056069718455, -11.106226972659304],
              [-16.577345961570085, -11.105677786763533],
              [-16.57676958228213, -11.111802767000071],
              [-16.584460509893734, -11.111339800839545],
              [-16.582594342066752, -11.1164170783084],
              [-16.587223859176692, -11.122094552013005],
              [-16.592520605940738, -11.11953445896676],
              [-16.589469398880954, -11.110103794390294],
              [-16.585453585133866, -11.103714477846331],
              [-16.581088279067796, -11.100644103389552],
              [-16.579130472071302, -11.096430940434908],
              [-16.588428678526434, -11.09722084786832],
              [-16.586282356311024, -11.091812617044376],
              [-16.579003891584886, -11.092672283074268],
              [-16.5774321755611, -11.088377923516587],
              [-16.581665031280544, -11.086169216322451],
              [-16.577361456847456, -11.080647008444677],
              [-16.58315406491568, -11.077982638512937],
              [-16.57586038684603, -11.065832855329898],
              [-16.576489408075755, -11.061022480411571],
              [-16.570704327410493, -11.054804046999465],
              [-16.57574283561472, -11.051173939900886],
              [-16.566917716219027, -11.03802542843484],
              [-16.570916692324744, -11.034137867023428],
              [-16.56612306024748, -11.027029974015733],
              [-16.56516890036832, -11.016304427227352],
              [-16.561724201385697, -11.011411394230525],
              [-16.560685202416636, -11.005867196062058],
              [-16.563261125859466, -10.999327682914835],
              [-16.571028879308045, -11.01675275087495],
              [-16.571397407797278, -11.02093722463879],
              [-16.575317846719347, -11.029028438164307],
              [-16.576988949233304, -11.03915874438841],
              [-16.58281507463545, -11.049044261025005],
              [-16.58666053645715, -11.060344941404987],
              [-16.59130935246917, -11.063336398596968],
              [-16.5943295992769, -11.079036257858792],
              [-16.597615901615136, -11.085350370147236],
              [-16.59935201717274, -11.092973136377665],
              [-16.602753505454622, -11.098266207947017],
              [-16.609399989502315, -11.09660877900034],
              [-16.609595763579293, -11.090972019839318],
              [-16.603887511757858, -11.088968832148431],
              [-16.606085730399585, -11.085313011989928],
              [-16.61046369089897, -11.08644469119478],
              [-16.616143059421386, -11.083518270082516],
              [-16.615560326578986, -11.079013578831246],
              [-16.61923716457839, -11.074747639227514],
              [-16.61461512728391, -11.069458180298895],
              [-16.609035075302724, -11.058591068570012],
              [-16.609603736839368, -11.050727391176673],
              [-16.61432671190295, -11.052735637619003],
              [-16.62072616082171, -11.058441346599832],
              [-16.62360529178014, -11.068874647613157],
              [-16.627329826963997, -11.072472044025545],
              [-16.630737529235443, -11.06962709086416],
              [-16.63582273557189, -11.072166422512085],
              [-16.626340582019402, -11.079442574442428],
              [-16.625383495486453, -11.083589772682814],
              [-16.620182885870072, -11.087992090374046],
              [-16.619874719419002, -11.096267615425798],
              [-16.630940274820578, -11.096697081435433],
              [-16.631062069334238, -11.099245607378785],
              [-16.621698307154624, -11.101299860029053],
              [-16.619521381312925, -11.104176066558075],
              [-16.623356951189344, -11.111957376387183],
              [-16.627918425883024, -11.11191457164554],
              [-16.633043035940613, -11.114881239459123],
              [-16.639266726793167, -11.109660397009915],
              [-16.646908269338738, -11.112866354258518],
              [-16.64787470492647, -11.120133703520782],
              [-16.65184374760767, -11.12995110488022],
              [-16.65753573309773, -11.134985287668842],
              [-16.664559129308543, -11.136652917216068],
              [-16.66468590570554, -11.139710496181255],
              [-16.670406236970862, -11.150225576353968],
              [-16.675626715812935, -11.151601022349594],
              [-16.677047574610317, -11.155958504766078],
              [-16.673526488740293, -11.1611822038755],
              [-16.671166624783663, -11.168094693869605],
              [-16.672243247325593, -11.171427125509737],
              [-16.67929100005584, -11.179944359843553],
              [-16.685757515503774, -11.179165586333777],
              [-16.69143081130936, -11.182228336713134],
              [-16.694362574235026, -11.178918562946805],
              [-16.69013688338661, -11.172226521107081],
              [-16.690251984162757, -11.167754944714016],
              [-16.69491763592312, -11.168170599483194],
              [-16.695723595445052, -11.162593369113361],
              [-16.699174860819973, -11.160249778541464],
              [-16.706089181493727, -11.168636409306096],
              [-16.71240562442736, -11.164899292748203],
              [-16.719649320270186, -11.16390404162842],
              [-16.729297388610313, -11.157272265969072],
              [-16.73728356851968, -11.161700534760344],
              [-16.72501726399015, -11.166180188908742],
              [-16.71806835152408, -11.171471765848924],
              [-16.708837681855854, -11.1740342373327],
              [-16.708029392423516, -11.182657451952204],
              [-16.711647908498502, -11.187699195398714],
              [-16.719232581843297, -11.192484986776165],
              [-16.729062000652156, -11.18756776827469],
              [-16.734403604930346, -11.19328291942764],
              [-16.737243218326807, -11.184839060173948],
              [-16.744071588796594, -11.19111203681072],
              [-16.751251654594032, -11.186777942208735],
              [-16.757826432030228, -11.179595569376481],
              [-16.76779078063325, -11.177001768896375],
              [-16.779620684539477, -11.185763801648775],
              [-16.77753369942548, -11.191240508766866],
              [-16.779830388011383, -11.197327145853933],
              [-16.79219456305003, -11.194633056027852],
              [-16.794506668610392, -11.198702389225135],
              [-16.801564607609524, -11.200274239011222],
              [-16.792043892067742, -11.205520691547722],
              [-16.794982606725082, -11.209384871980385],
              [-16.79886002872868, -11.20857715256524],
              [-16.814255868220357, -11.209593218257877],
              [-16.818576795086138, -11.212469782527473],
              [-16.823124413619897, -11.210689463376657],
              [-16.825982414505066, -11.205240799067365],
              [-16.82477505444742, -11.197330825271212],
              [-16.826785838344673, -11.189469465730674],
              [-16.832710649967172, -11.194387000221605],
              [-16.843810402745657, -11.19440169615766],
              [-16.853936727817818, -11.188364440888654],
              [-16.84834530939316, -11.180898510748259],
              [-16.8556644231113, -11.17940732348381],
              [-16.86127542765396, -11.181755505743483],
              [-16.86473375479159, -11.179442213435282],
              [-16.865041373883294, -11.170983801874995],
              [-16.867896357838074, -11.15985915896763],
              [-16.86369885119444, -11.156287221951592],
              [-16.863211580470836, -11.148593343439313],
              [-16.85644601501342, -11.143571283086356],
              [-16.84783188981364, -11.142687715261795],
              [-16.84061722780685, -11.144861210419103],
              [-16.836944385092522, -11.149130568049891],
              [-16.830352532786648, -11.14997497136536],
              [-16.83445433486687, -11.143346540886585],
              [-16.84397040696198, -11.139955398226304],
              [-16.844219822648974, -11.137397304261919],
              [-16.850679592507426, -11.135010289371696],
              [-16.85231852287107, -11.12871777554855],
              [-16.849392523451726, -11.121348210260091],
              [-16.836986783926946, -11.11642967441761],
              [-16.83067046824108, -11.112192030495413],
              [-16.824094360137227, -11.112452512108854],
              [-16.825149492567817, -11.11850040956582],
              [-16.815574351104587, -11.12981539690315],
              [-16.81389166494812, -11.127859243230656],
              [-16.819121122348026, -11.121404325143564],
              [-16.82146269130669, -11.114166647326252],
              [-16.81853907286707, -11.103808306134994],
              [-16.811663598771613, -11.101698885046838],
              [-16.80958549623544, -11.098587693389426],
              [-16.79495050980523, -11.103579586969179],
              [-16.785538972681202, -11.101892820513132],
              [-16.78336526095045, -11.098148590619973],
              [-16.772658531814173, -11.103745397615372],
              [-16.778103054236038, -11.093748634383457],
              [-16.778160919918694, -11.091170666566661],
              [-16.772910932211133, -11.082954585879227],
              [-16.77297358713623, -11.07750032413516],
              [-16.763373360383174, -11.076800554643512],
              [-16.757290031757435, -11.06821158968873],
              [-16.752837451730723, -11.067163985261748],
              [-16.748955256257382, -11.063521230151174],
              [-16.744943267442704, -11.066059886152075],
              [-16.741428621761706, -11.057738070521484],
              [-16.733824931638065, -11.05883867558495],
              [-16.72394415039846, -11.057617316792143],
              [-16.72941105883205, -11.052826034661713],
              [-16.732835056521534, -11.041788670098608],
              [-16.724387014064675, -11.036503945222165],
              [-16.71643998608529, -11.029537826771985],
              [-16.71767326538386, -11.021557755236755],
              [-16.711760710313, -11.01526168734292],
              [-16.71038017308537, -11.010610369794655],
              [-16.70643914841307, -11.006221349085566],
              [-16.70148544135806, -11.00393680525905],
              [-16.70165898139439, -10.99923271929517],
              [-16.69491844813473, -10.996826164576197],
              [-16.693727655104187, -10.99349010935944],
              [-16.697569862390054, -10.986455001157893],
              [-16.705879210712247, -10.987275962790152],
              [-16.71481774310822, -10.990843233946784],
              [-16.726481919942824, -11.000963290463018],
              [-16.733590471054207, -11.009567574458309],
              [-16.74117818005363, -11.015999957571857],
              [-16.757293763591306, -11.027984638718705],
              [-16.763735533041483, -11.029142466294703],
              [-16.771993588807504, -11.033183984083456],
              [-16.774629517426515, -11.039142645445207],
              [-16.783209539734543, -11.046417284064262],
              [-16.809949497627567, -11.041990908525031],
              [-16.816735075622532, -11.038538325286977],
              [-16.839198609489298, -11.022497822795389],
              [-16.842640221876042, -11.019161271251384],
              [-16.84873832760615, -11.009188138079454],
              [-16.851812006532384, -11.000777005306256],
              [-16.845522330939087, -10.986207261344415],
              [-16.841493711212905, -10.971210803063753],
              [-16.840403354878735, -10.962653249330245],
              [-16.83398271602528, -10.952279965691115],
              [-16.83091175390998, -10.941325866303254],
              [-16.827671591108327, -10.918203033736184],
              [-16.825316086691434, -10.910260060320804],
              [-16.820399771922578, -10.905358332389374],
              [-16.81113685068108, -10.888046325111688],
              [-16.794594315099758, -10.870247871949367],
              [-16.778837746909996, -10.846204557682672],
              [-16.774740678594696, -10.833433940262813],
              [-16.77312245193299, -10.81696930123106],
              [-16.773580251071063, -10.794437813696154],
              [-16.7715725705362, -10.790762503275898],
              [-16.75969030141896, -10.783498751060641],
              [-16.758674513248472, -10.768838815502466],
              [-16.758794235882725, -10.741905521208482],
              [-16.757155454331215, -10.729281313549373],
              [-16.76328427817173, -10.725261175323595],
              [-16.769395601044938, -10.71642397117667],
              [-16.772523341943813, -10.700589021255261],
              [-16.77471960314885, -10.6938582188617],
              [-16.782737484626345, -10.678615024169408],
              [-16.783641552456405, -10.671043225459357],
              [-16.77609361808038, -10.665586611594712],
              [-16.765470073751107, -10.662676701448582],
              [-16.760441068179336, -10.659511815318728],
              [-16.759141695323795, -10.652151927312248],
              [-16.7521367953765, -10.649259359254716],
              [-16.733556910454254, -10.64727624589646],
              [-16.72600768599019, -10.64564630113532],
              [-16.71949395168902, -10.642215773973788],
              [-16.71736215382062, -10.637624951649485],
              [-16.698430697615628, -10.62124356741166],
              [-16.69350968232827, -10.615175464721753],
              [-16.687005433882742, -10.610232944663343],
              [-16.675267568497695, -10.597047426657282],
              [-16.668783982886417, -10.592061553234062],
              [-16.6633148938084, -10.583614770752943],
              [-16.65520774956723, -10.580179024023058],
              [-16.635959818426684, -10.566262850310958],
              [-16.624770980096443, -10.560720856215742],
              [-16.61719811653274, -10.553669486528213],
              [-16.613938810423043, -10.553105184370157],
              [-16.607671346490022, -10.557935702413372],
              [-16.60343715532177, -10.56746651415787],
              [-16.59775587644152, -10.577484716331883],
              [-16.58908322561276, -10.587463205010053],
              [-16.580309165926554, -10.598919416229728],
              [-16.571147114746378, -10.5981991404576],
              [-16.56256699410987, -10.603264544380197],
              [-16.55829016074932, -10.601175675332218],
              [-16.5508978675164, -10.603182584098628],
              [-16.550254829994245, -10.609748012626328],
              [-16.545013328906467, -10.607556502245938],
              [-16.545425814937488, -10.599538606606426],
              [-16.538709948498443, -10.597447379116097],
              [-16.531961119770585, -10.582740944511231],
              [-16.524133126971343, -10.572757074501519],
              [-16.509532972390893, -10.571573627698767],
              [-16.492484244777923, -10.578548149373045],
              [-16.488043143725566, -10.585554998762062],
              [-16.482383478231878, -10.584788582871267],
              [-16.474772904220977, -10.58068625828705],
              [-16.467537141410517, -10.584083290417723],
              [-16.458265144778647, -10.585643731629126],
              [-16.451149804490733, -10.590663879025053],
              [-16.44814912502133, -10.588239587250376],
              [-16.443591618250466, -10.591569757108955],
              [-16.4375538947495, -10.592375876098181],
              [-16.422348335054803, -10.591117724169711],
              [-16.41753537707777, -10.593100389155556],
              [-16.406606287433338, -10.592743234701688],
              [-16.403274216040337, -10.595687944745153],
              [-16.39814186078717, -10.59509759411608],
              [-16.39058934970998, -10.59897559723748],
              [-16.377257927305003, -10.609782790498182],
              [-16.378471493246924, -10.60187237860786],
              [-16.382706081689648, -10.598054384498253],
              [-16.385626827267114, -10.592402931812241],
              [-16.394672322571594, -10.582896193723672],
              [-16.400767948939762, -10.581408439218901],
              [-16.412728865879057, -10.57329814356191],
              [-16.417349333333416, -10.57522521336736],
              [-16.43156806204764, -10.578121561932607],
              [-16.4403003044943, -10.581603942365751],
              [-16.443789588150842, -10.574808426536093],
              [-16.449083082670693, -10.573251864813514],
              [-16.463975910974376, -10.563474614684125],
              [-16.48364347063637, -10.563950737754773],
              [-16.48862859288386, -10.559609081798953],
              [-16.497975499636205, -10.557697158784773],
              [-16.506437404599346, -10.553869062643809],
              [-16.513075527533847, -10.5482896962955],
              [-16.51793285910116, -10.540609077058107],
              [-16.526411784854588, -10.531445852170489],
              [-16.53496921043506, -10.52783385658784],
              [-16.54061566293004, -10.523990457826262],
              [-16.547155254457355, -10.517007006914021],
              [-16.563754121018313, -10.511571151459743],
              [-16.564200237157646, -10.506543917942357],
              [-16.558411540729196, -10.500335849082898],
              [-16.55807403931349, -10.494707707965235],
              [-16.5511177829506, -10.494315842185928],
              [-16.541845854699044, -10.49096658293411],
              [-16.537857657724075, -10.485694748801594],
              [-16.534638886525673, -10.472417799645694],
              [-16.531436206691417, -10.46844514755356],
              [-16.52476171319481, -10.452423372501107],
              [-16.518881635958646, -10.447812050442515],
              [-16.513237764218687, -10.447279467195472],
              [-16.50941249805788, -10.443938542358232],
              [-16.50927254616016, -10.435763018533844],
              [-16.510766898936403, -10.431941437214265],
              [-16.508001537446543, -10.428212177213755],
              [-16.502470730696153, -10.425674046070837],
              [-16.49514946623412, -10.424450714324289],
              [-16.487503345297792, -10.418020583817677],
              [-16.479826951085347, -10.419454069539857],
              [-16.47789095244781, -10.413399023054804],
              [-16.465236112599552, -10.404987209734186],
              [-16.46197506386916, -10.399018410181277],
              [-16.456667407293114, -10.395453213529935],
              [-16.445945358578548, -10.394563914091012],
              [-16.440377332087635, -10.391632252467755],
              [-16.45651687306482, -10.38361267205675],
              [-16.4575884784387, -10.378930000571389],
              [-16.461080963560022, -10.378245087345421],
              [-16.473391822186976, -10.384424309500936],
              [-16.48907589958264, -10.388853813178926],
              [-16.493051686158026, -10.387452393961661],
              [-16.500547678736616, -10.391122575973643],
              [-16.506522940393502, -10.39702440627267],
              [-16.5186210422655, -10.406481159949884],
              [-16.52145290486891, -10.414595791773175],
              [-16.527605768887046, -10.424538230245524],
              [-16.535663254907853, -10.427260389609506],
              [-16.53798665165467, -10.429825876952773],
              [-16.539026159933215, -10.438581133663929],
              [-16.541891233444748, -10.444895186755076],
              [-16.542673292120792, -10.452178822924681],
              [-16.541135638988376, -10.457318212870826],
              [-16.542281178803968, -10.464183378400666],
              [-16.541341268576343, -10.46995795675972],
              [-16.55219084819271, -10.48097949793871],
              [-16.567415739384725, -10.476343736520821],
              [-16.57718964246755, -10.475380501022256],
              [-16.589319052009987, -10.475504290694497],
              [-16.603019162023404, -10.476994927471749],
              [-16.619825664059576, -10.481888482529795],
              [-16.633225540113596, -10.483050187854943],
              [-16.637856747186458, -10.481002338742357],
              [-16.64353730598487, -10.475513365423815],
              [-16.64802723154071, -10.466488055069998],
              [-16.65334889459483, -10.467627666833113],
              [-16.655275926572187, -10.471951237746032],
              [-16.65923765436389, -10.472841789135154],
              [-16.665441236419355, -10.46773981277687],
              [-16.670751269110475, -10.479359714440639],
              [-16.68075994945313, -10.486308495378964],
              [-16.694254574948634, -10.492844913790911],
              [-16.702090794706628, -10.498532253408511],
              [-16.71046033953946, -10.499845810665025],
              [-16.715273015436633, -10.50505230527115],
              [-16.726895291613285, -10.51307964743761],
              [-16.732546047046238, -10.522340890036395],
              [-16.733787581876438, -10.527253924562727],
              [-16.74266484931828, -10.549952484228795],
              [-16.746861713631407, -10.55680962756945],
              [-16.76234166425138, -10.559985973034507],
              [-16.770937403710548, -10.563045932615523],
              [-16.776150295199297, -10.570177988976639],
              [-16.77965801066381, -10.571069030146194],
              [-16.790022942902105, -10.570038721146005],
              [-16.800882962272944, -10.570866133915747],
              [-16.808758284824858, -10.577308218460846],
              [-16.814937145038673, -10.58398182421798],
              [-16.82289946913012, -10.590367691146712],
              [-16.82590632166965, -10.596015441123082],
              [-16.8343376722917, -10.604749589111728],
              [-16.837925774805367, -10.605285200922646],
              [-16.839094099650943, -10.610778388623782],
              [-16.846989492785685, -10.619291944256645],
              [-16.851831676191516, -10.627086845470114],
              [-16.851347202844472, -10.633071456628794],
              [-16.84704791473681, -10.643619398192785],
              [-16.84273372455773, -10.650267213770423],
              [-16.83435283120649, -10.668776494136235],
              [-16.835853799219837, -10.67643123120795],
              [-16.84162394616171, -10.675405405657584],
              [-16.843803132502067, -10.67218496960536],
              [-16.851905059453607, -10.670046918979624],
              [-16.85553482014265, -10.664470122548963],
              [-16.858591946141495, -10.66362868495776],
              [-16.866103117859616, -10.671071316576608],
              [-16.8708103395595, -10.673931173113006],
              [-16.87390771346633, -10.672559090144288],
              [-16.879990448537264, -10.676466959310538],
              [-16.88562531406095, -10.68631255361014],
              [-16.889902664078722, -10.687862140356419],
              [-16.897349908898345, -10.701257523330101],
              [-16.900235928212354, -10.71638457971554],
              [-16.906152618254684, -10.721865552351897],
              [-16.908755810711842, -10.721545804320115],
              [-16.920432173438638, -10.731318389068491],
              [-16.927949354665277, -10.739113314727792],
              [-16.935100355457852, -10.749532060989159],
              [-16.938620169171, -10.761247359798135],
              [-16.938162444196895, -10.771728881886917],
              [-16.934110819297338, -10.780598106817239],
              [-16.928105071952537, -10.783302826781647],
              [-16.92230838257652, -10.78876675944222],
              [-16.933304997264237, -10.797442826980681],
              [-16.933222877194176, -10.799814209093702],
              [-16.94454681559999, -10.803541920471554],
              [-16.94713602561963, -10.811602776184321],
              [-16.947908424443362, -10.820234850672017],
              [-16.95177638666826, -10.825834915966457],
              [-16.960586677120038, -10.828435468900866],
              [-16.966146393841164, -10.832528135897325],
              [-16.972327258567283, -10.84013131299856],
              [-16.97410190665783, -10.846339034118664],
              [-16.97710179661863, -10.848419337944133],
              [-16.98467852958545, -10.849270219516375],
              [-16.990314070166026, -10.84651287887882],
              [-16.99344430215511, -10.842388173130633],
              [-16.998189192385475, -10.844774291141611],
              [-17.003973858969175, -10.842503417287908],
              [-17.008835152242543, -10.848580850565504],
              [-17.015367089299406, -10.848149708362104],
              [-17.032371237032127, -10.842985817588689],
              [-17.02692361385536, -10.850999276084366],
              [-17.017993195968753, -10.857568597220208],
              [-17.01120963647776, -10.85903648970567],
              [-17.005832045023872, -10.86581972101604],
              [-16.995903374436914, -10.872270420742455],
              [-16.99748422657695, -10.877564915460527],
              [-16.992306520564423, -10.883921245918941],
              [-16.981588312738676, -10.890548492437025],
              [-16.977148895840635, -10.898495254642969],
              [-16.977584078327364, -10.908365106319538],
              [-16.98164684557355, -10.915740231359115],
              [-16.981393903163237, -10.919812080196136],
              [-16.993551057478236, -10.935087571566573],
              [-16.99539004085082, -10.938509178631135],
              [-16.997073649866966, -10.951807212879551],
              [-16.999584185643204, -10.956129858156455],
              [-17.01403302070892, -10.962358419296612],
              [-17.01680957381667, -10.968537027658812],
              [-17.026916674838947, -10.969780818538533],
              [-17.030832749256966, -10.967006837125833],
              [-17.039897326185965, -10.969682542399717],
              [-17.043475294926115, -10.967043315428946],
              [-17.050226451777103, -10.966137192543016],
              [-17.056634075317888, -10.96729994237951],
              [-17.06285914593923, -10.971130997383828],
              [-17.075238192999176, -10.975657050166705],
              [-17.078132636225636, -10.973882173677113],
              [-17.08450839974317, -10.978179125108662],
              [-17.09129489444475, -10.986907157787611],
              [-17.08416277065905, -10.987628016642265],
              [-17.07577860319495, -10.993212719207463],
              [-17.06912007185075, -10.990921584273499],
              [-17.065813513093058, -10.98449048176051],
              [-17.060658073240653, -10.9853057338268],
              [-17.053866729516532, -10.984035335332194],
              [-17.0505260058892, -10.985964325758745],
              [-17.04847136333174, -10.992218606162307],
              [-17.04961352128177, -11.00198920111429],
              [-17.057656112507185, -11.028228699967459],
              [-17.065775438478585, -11.036274333825702],
              [-17.07518477263423, -11.040189914870407],
              [-17.076617580892925, -11.045899697083955],
              [-17.08785754296724, -11.053116877819905],
              [-17.09510089762799, -11.051706842404323],
              [-17.098777276410473, -11.04122939567469],
              [-17.10549239919765, -11.04345121751612],
              [-17.102828214867333, -11.047937138251775],
              [-17.10233807908678, -11.054600769297029],
              [-17.10923865709827, -11.057984857944376],
              [-17.117267305484255, -11.052378255758136],
              [-17.122655936354484, -11.052742390581976],
              [-17.123555348638604, -11.048173464200291],
              [-17.11771610390911, -11.043423038881695],
              [-17.117845683150957, -11.038520142150935],
              [-17.115028203604023, -11.031276369538148],
              [-17.116532069452166, -11.02595863830329],
              [-17.109352816432867, -11.02185954941082],
              [-17.112728673020786, -11.018483808996915],
              [-17.116640577454067, -11.020007214716196],
              [-17.12616652993593, -11.005392219065806],
              [-17.13105864859792, -11.009146256806785],
              [-17.12751901130077, -11.025349514024436],
              [-17.127589067192954, -11.031840958632742],
              [-17.13052138274167, -11.038813971993173],
              [-17.13145207147303, -11.047803450735934],
              [-17.135872040890675, -11.052910894776396],
              [-17.142481282504527, -11.054305070701236],
              [-17.147946283544325, -11.057822127076289],
              [-17.149067428096338, -11.05306461930429],
              [-17.15459084887942, -11.047321158374059],
              [-17.15630025702564, -11.038122294435222],
              [-17.15999944728628, -11.042405405688445],
              [-17.15953559583673, -11.050310290402852],
              [-17.164049555090223, -11.05209453526599],
              [-17.172343261067965, -11.052155292102356],
              [-17.172508518022365, -11.057231025637742],
              [-17.168709504653126, -11.058518975678815],
              [-17.15848024402118, -11.055337426195342],
              [-17.154857381754837, -11.061926886176698],
              [-17.147906519387544, -11.063728776663027],
              [-17.14725859773911, -11.0695923656163],
              [-17.15185936036879, -11.081698706975331],
              [-17.153406587080724, -11.082766859318378],
              [-17.163641812764908, -11.081334338418682],
              [-17.171338465811143, -11.08333872468197],
              [-17.17591928398615, -11.082756585621786],
              [-17.184199105023122, -11.087065559306236],
              [-17.185484642032137, -11.091972481531267],
              [-17.182566806150188, -11.096679772002446],
              [-17.17822106294747, -11.098525015254657],
              [-17.172779617547995, -11.1127813752867],
              [-17.179475228048528, -11.118075935117735],
              [-17.17700356351977, -11.122790668319292],
              [-17.18311822067707, -11.12417078099199],
              [-17.19398175070605, -11.12881390750288],
              [-17.202060236007352, -11.126701770906193],
              [-17.208064615158573, -11.129004398387476],
              [-17.21661621000032, -11.140564709020175],
              [-17.22229390298149, -11.139420082329437],
              [-17.229744849560905, -11.142945223056305],
              [-17.233372668373487, -11.138646050612227],
              [-17.238865746103706, -11.144148510858972],
              [-17.243598606952684, -11.146542107680487],
              [-17.249912252996324, -11.146468125861874],
              [-17.24244875430081, -11.15433085581147],
              [-17.23365606893928, -11.151229025125065],
              [-17.223304712733384, -11.15252624867913],
              [-17.228736124812755, -11.15877086888057],
              [-17.239015727302114, -11.163882771423932],
              [-17.245072036021607, -11.16857784504496],
              [-17.249369426408947, -11.180095374537016],
              [-17.250226598774365, -11.192573251548415],
              [-17.248615767401084, -11.205528484671666],
              [-17.25207135554954, -11.203886002368865],
              [-17.257746667904737, -11.207164125004892],
              [-17.25540112334177, -11.211344572519128],
              [-17.260721452844827, -11.215170266331164],
              [-17.265881341935565, -11.214587276381371],
              [-17.268001664223796, -11.219365817890957],
              [-17.272738222286847, -11.224093618927636],
              [-17.271948642772003, -11.22865492802256],
              [-17.26106259651546, -11.229427168902314],
              [-17.2565372479914, -11.23118368911653],
              [-17.255512307564313, -11.237870400267528],
              [-17.26062895521251, -11.24071641666225],
              [-17.258197682492586, -11.246739085050951],
              [-17.261322090860844, -11.25148606507271],
              [-17.25495901569316, -11.263053276392451],
              [-17.250762044012472, -11.26532772589715],
              [-17.24680911571067, -11.261869565353669],
              [-17.23670790732626, -11.247861746328125],
              [-17.228783598590812, -11.247361556187156],
              [-17.2161934051091, -11.249631297967344],
              [-17.210715056240797, -11.252088414637514],
              [-17.199075807852463, -11.254152687666004],
              [-17.191507079632096, -11.24771492876878],
              [-17.187253335218, -11.245724526234197],
              [-17.18256434227678, -11.24667663262861],
              [-17.1806128154295, -11.250120495283497],
              [-17.172276851758422, -11.246636031361751],
              [-17.162146769500595, -11.262771274891998],
              [-17.155115077813207, -11.270536506194127],
              [-17.145209511055356, -11.277096328799335],
              [-17.139327869457247, -11.278300391439306],
              [-17.13304978264896, -11.272729136921214],
              [-17.12507441176975, -11.281693493163019],
              [-17.118708137534313, -11.281639406373763],
              [-17.117441086083492, -11.289310998562385],
              [-17.110729094661284, -11.297972437010763],
              [-17.10467449487778, -11.297956391567533],
              [-17.105149129957912, -11.303835758259218],
              [-17.103090902876787, -11.312379056824899],
              [-17.106501263554428, -11.31829423136125],
              [-17.10033166798793, -11.322774310615397],
              [-17.091797926116683, -11.319137340484911],
              [-17.090197067977435, -11.323401047413224],
              [-17.097141488199863, -11.327647545925192],
              [-17.105663988960764, -11.32436267349864],
              [-17.108596042440638, -11.32645360537799],
              [-17.11154878480212, -11.33535656403448],
              [-17.113262965047305, -11.349788503218083],
              [-17.11596437396944, -11.358585087041726],
              [-17.12489323682326, -11.372497076118059],
              [-17.131375507397355, -11.371421480483649],
              [-17.136457080172864, -11.378768566226318],
              [-17.144865446992256, -11.380846513542565],
              [-17.149619974479968, -11.388662409831358],
              [-17.151362065106216, -11.39878353542394],
              [-17.15863428134204, -11.39963480645616],
              [-17.16384755105589, -11.405477080797672],
              [-17.177312366602376, -11.407177633105526],
              [-17.18337681913142, -11.409041822679006],
              [-17.196164453286798, -11.406384371214934],
              [-17.205791126070697, -11.4079803745264],
              [-17.20813372292055, -11.415678850914263],
              [-17.206726513295138, -11.421417733658403],
              [-17.209184027688497, -11.426280095369505],
              [-17.211223591682806, -11.436473643693212],
              [-17.213656617506484, -11.441104110077372],
              [-17.21312417500488, -11.446800417565743],
              [-17.21777547720728, -11.448588313188624],
              [-17.22566596436411, -11.447693703178976],
              [-17.23707099712927, -11.449671217349563],
              [-17.239509054639253, -11.453293738419502],
              [-17.238066142325643, -11.466083226383645],
              [-17.23585861469589, -11.476638367096657],
              [-17.231774170065783, -11.479309111959433],
              [-17.227492562701194, -11.478667108122632],
              [-17.223089556114672, -11.482636093109532],
              [-17.22552336089364, -11.487584171592871],
              [-17.231705095343774, -11.48957244858365],
              [-17.233760129510532, -11.494327610100457],
              [-17.242254636634772, -11.493527513819933],
              [-17.244434352111675, -11.496484873472017],
              [-17.257989624052392, -11.493563486383135],
              [-17.26686370909178, -11.502981672732343],
              [-17.27821278191405, -11.51050526885886],
              [-17.28541660298143, -11.516319426050384],
              [-17.285946389607535, -11.518635066967462],
              [-17.281269508924577, -11.526028773073511],
              [-17.277756499199757, -11.527430876746385],
              [-17.2719818906884, -11.523234979644934],
              [-17.27415819999269, -11.51927047764164],
              [-17.272504560573864, -11.515288987164675],
              [-17.26697091440073, -11.514329247946351],
              [-17.262017083674117, -11.516162838585274],
              [-17.258469695374362, -11.506799274102287],
              [-17.252813936218402, -11.50922635466812],
              [-17.250697064355897, -11.516955245210427],
              [-17.24470861935898, -11.521753742811136],
              [-17.249228032675997, -11.525289447049408],
              [-17.25300673541806, -11.525037000534603],
              [-17.267694789122668, -11.52772793297605],
              [-17.263149820458747, -11.52996982019863],
              [-17.252998557145197, -11.537669862853265],
              [-17.25223949208462, -11.544263690892727],
              [-17.255548151478422, -11.548897966329555],
              [-17.26627632209533, -11.5536748884175],
              [-17.271140516369677, -11.552476374712025],
              [-17.27576951067422, -11.548239123819963],
              [-17.27770860085304, -11.5556973591934],
              [-17.275806296436397, -11.561631196900818],
              [-17.27001279251182, -11.563741859416359],
              [-17.2655427099611, -11.571417676752647],
              [-17.275475112241686, -11.57266019298358],
              [-17.28628142951699, -11.561973097167735],
              [-17.28776728407173, -11.574874833305673],
              [-17.283992715203087, -11.578572969299351],
              [-17.283085351268667, -11.587013471244951],
              [-17.28822923637018, -11.588089201625136],
              [-17.29760996289176, -11.574076411589948],
              [-17.301045207004154, -11.57294991164258],
              [-17.305518418895875, -11.566171454496944],
              [-17.305483785697444, -11.560585602941165],
              [-17.31214111762597, -11.550852353485707],
              [-17.311456030762045, -11.567680075898345],
              [-17.307992400830834, -11.583868686488092],
              [-17.31369408139026, -11.584567071225988],
              [-17.336379281869103, -11.573803202470273],
              [-17.338526844157226, -11.575983520400474],
              [-17.335580965156147, -11.583678488979398],
              [-17.33108717989828, -11.581364425240318],
              [-17.327436841450346, -11.584441045431305],
              [-17.328561474188405, -11.588836197469108],
              [-17.32462671508603, -11.593177754461038],
              [-17.330355000005138, -11.608458158318419],
              [-17.343759017292893, -11.605633852025257],
              [-17.345542040211793, -11.595054003923279],
              [-17.351297663707868, -11.595066510194377],
              [-17.358703338317834, -11.59892283406907],
              [-17.361622416895926, -11.612019971077371],
              [-17.36763666976716, -11.615486597955224],
              [-17.37465531023873, -11.616256420008982],
              [-17.378613005387614, -11.610222794540563],
              [-17.384816428053707, -11.608050975813732],
              [-17.39438195919065, -11.608588252867957],
              [-17.40231427831205, -11.615305600419642],
              [-17.406974094186793, -11.615380282839137],
              [-17.415210646259382, -11.618794914592026],
              [-17.41594586178986, -11.625750348094474],
              [-17.42001249118923, -11.632387069864217],
              [-17.424506801548848, -11.631318972515771],
              [-17.432122499385617, -11.633949956196533],
              [-17.43152934560043, -11.6378860660031],
              [-17.422375816941145, -11.650831590307595],
              [-17.426488683672595, -11.65887582113284],
              [-17.43936085735992, -11.66481830308052],
              [-17.444728277935134, -11.662976168538572],
              [-17.448690845552026, -11.659382177435168],
              [-17.453956843366164, -11.66171061924184],
              [-17.4514824926629, -11.670993213515782],
              [-17.455087822724803, -11.674301815341613],
              [-17.462820409240045, -11.676013990839685],
              [-17.472742543980676, -11.673259211686064],
              [-17.47403332129862, -11.68854702312345],
              [-17.471348159907247, -11.69557370043703],
              [-17.466582447420038, -11.700700551985918],
              [-17.46784033526044, -11.709355652091446],
              [-17.476245506451164, -11.709420498005164],
              [-17.482051400845716, -11.713568483131162],
              [-17.48871559814431, -11.702547500439687],
              [-17.503296028125646, -11.698201701420187],
              [-17.515617612839808, -11.685896846116465],
              [-17.52252486238224, -11.68743515713768],
              [-17.52646066820936, -11.691961068829599],
              [-17.525518321379142, -11.699916591641612],
              [-17.530096498756485, -11.7108447840366],
              [-17.5296891946374, -11.716718064963564],
              [-17.525655217554856, -11.721387952292254],
              [-17.520141865591132, -11.724458444515534],
              [-17.52319655774075, -11.730550267860522],
              [-17.529634131490486, -11.731302245855622],
              [-17.541611017032345, -11.73488824980739],
              [-17.549951951619327, -11.739316729898498],
              [-17.554440487508916, -11.736058742515521],
              [-17.55732424443859, -11.737667174994545],
              [-17.552837818788944, -11.743669804993287],
              [-17.54808440486729, -11.745192432471015],
              [-17.550067643759963, -11.749244475682518],
              [-17.548581663024894, -11.75797143977546],
              [-17.550339840864165, -11.761325032637291],
              [-17.550346670833033, -11.769914289618837],
              [-17.55941693685037, -11.768517322892398],
              [-17.564944457264136, -11.763111472949033],
              [-17.56527438996278, -11.758195866291757],
              [-17.57163010307186, -11.761046995283554],
              [-17.573976531341156, -11.766043875707014],
              [-17.583369906990317, -11.768982430488204],
              [-17.587606168684314, -11.772128888080022],
              [-17.594714195853147, -11.768504301879327],
              [-17.600817273701008, -11.760356357211228],
              [-17.60793301465891, -11.761009744923209],
              [-17.605055447234243, -11.775873838309595],
              [-17.60798735364319, -11.7762684735832],
              [-17.60729320993143, -11.793958496978748],
              [-17.60338384800891, -11.800193430693506],
              [-17.605457478856113, -11.805966582774161],
              [-17.618626369775633, -11.804181980349988],
              [-17.625159728017767, -11.793585467468837],
              [-17.634479399189765, -11.788611532560214],
              [-17.63985801724168, -11.791929170217815],
              [-17.642277686574747, -11.80088697442376],
              [-17.64874990439315, -11.802468911976554],
              [-17.653762273654948, -11.805884998404677],
              [-17.662021240931374, -11.807495642745252],
              [-17.66567390913292, -11.810877685659802],
              [-17.677303924780325, -11.824876243547484],
              [-17.683340995980405, -11.826489037786185],
              [-17.688164342860723, -11.833849694778232],
              [-17.69802661791608, -11.836882602215397],
              [-17.70365611361963, -11.839869888947163],
              [-17.705749642574272, -11.846555628359866],
              [-17.70342679258835, -11.854681167371231],
              [-17.699824975847093, -11.852227339706856],
              [-17.676342424430523, -11.84348798879641],
              [-17.668775876100693, -11.84156861646285],
              [-17.663705518435986, -11.845183145830875],
              [-17.66669818842969, -11.84984438093387],
              [-17.66196456070116, -11.852323405989397],
              [-17.666739229143435, -11.86719321330719],
              [-17.67445316867338, -11.868073649044916],
              [-17.677532696978943, -11.870572375189981],
              [-17.67948423983886, -11.87655877004201],
              [-17.675655977461716, -11.884344016337085],
              [-17.66551947666178, -11.888942537056773],
              [-17.673864423046354, -11.903683773705529],
              [-17.679178539876126, -11.905446207678038],
              [-17.682075896997098, -11.910660909372234],
              [-17.692549270826802, -11.909243062455682],
              [-17.689317093644842, -11.91439097939818],
              [-17.688390498244363, -11.923937051532356],
              [-17.69515050066153, -11.925444485444038],
              [-17.69717087157925, -11.929874857794267],
              [-17.702886894559757, -11.935213523477442],
              [-17.715415991803816, -11.936141969909619],
              [-17.710351440928804, -11.951574092344769],
              [-17.71265651180559, -11.957823788120827],
              [-17.718561865306643, -11.955832557502397],
              [-17.72938002019294, -11.949733266012135],
              [-17.73410863668111, -11.948658408275522],
              [-17.73846169992907, -11.939664458662246],
              [-17.742012226132882, -11.937012708326918],
              [-17.748183748400837, -11.940528859575203],
              [-17.75394925397202, -11.940815817296322],
              [-17.747693571700047, -11.950582908631858],
              [-17.755386882180392, -11.960099561970912],
              [-17.756450691814166, -11.969581433364688],
              [-17.760343986946832, -11.982146957550595],
              [-17.766836974197297, -11.983228474506657],
              [-17.768241254103074, -11.974391146653788],
              [-17.773558333199905, -11.96802060292891],
              [-17.77516898085114, -11.960805188249763],
              [-17.780739856120807, -11.960925008377238],
              [-17.783933019575457, -11.963925352430335],
              [-17.784631796863103, -11.970271760825264],
              [-17.788467498369197, -11.97820237453354],
              [-17.793430217275027, -11.977778871566317],
              [-17.802609325427035, -11.985003114990084],
              [-17.813029917783123, -12.003743804931187],
              [-17.82451322286287, -12.003821002966832],
              [-17.82814413338668, -12.009772023257888],
              [-17.82526059026732, -12.012698167622226],
              [-17.82594423733502, -12.018728518299653],
              [-17.83151566608182, -12.024483225547325],
              [-17.836904423497348, -12.02554469652106],
              [-17.84235764441957, -12.023452811372108],
              [-17.847283577904822, -12.016778674587428],
              [-17.854084764428134, -12.01309801978912],
              [-17.854625621937775, -12.008960524874421],
              [-17.862017174149408, -12.000513913096764],
              [-17.870976756447664, -11.991832884630353],
              [-17.875230471503244, -11.990877998813312],
              [-17.881292564738985, -11.992528358416873],
              [-17.888290247851042, -12.000759423448086],
              [-17.88703566683133, -12.009041266468515],
              [-17.884986464423026, -12.011681108565533],
              [-17.879011178602546, -12.012804297165072],
              [-17.879368814663813, -12.017861280589672],
              [-17.876111818465272, -12.022184496020747],
              [-17.8831260080097, -12.023888648311056],
              [-17.888355257327202, -12.027963435244127],
              [-17.890700874609994, -12.024531650122164],
              [-17.896910430910708, -12.023921294278582],
              [-17.90215727972181, -12.029351776435615],
              [-17.90796652893909, -12.043540061380334],
              [-17.906330185565817, -12.05220589390369],
              [-17.901192819504438, -12.054114311675882],
              [-17.898819909213167, -12.057533469287042],
              [-17.89297831845958, -12.05595078234731],
              [-17.891521286728143, -12.061587531605113],
              [-17.887755380813044, -12.066827400769938],
              [-17.889854972009914, -12.071478295819324],
              [-17.895935495256158, -12.074526769349315],
              [-17.904815005579117, -12.075736143340624],
              [-17.905965811652592, -12.073767579616446],
              [-17.91787578736722, -12.072376854356865],
              [-17.923436074216994, -12.075673338367407],
              [-17.93107997444481, -12.074879905146924],
              [-17.936609590328743, -12.069784686380123],
              [-17.94207489323844, -12.052145179746322],
              [-17.95158786154038, -12.051403668239132],
              [-17.961179735787347, -12.057163713933095],
              [-17.963245946644445, -12.06117601628937],
              [-17.97015182961132, -12.05966057639515],
              [-17.979613452403502, -12.062617414677543],
              [-17.982693670909054, -12.06513289907953],
              [-17.985725124292934, -12.072076357516995],
              [-17.989714645761904, -12.073834676116723],
              [-17.998763684695984, -12.073780801733102],
              [-18.008656409864265, -12.082563979520966],
              [-18.01433330282272, -12.085010596119291],
              [-18.018313705705186, -12.089583430330528],
              [-18.019436476882333, -12.09786521182375],
              [-18.010754668757325, -12.094903035857557],
              [-17.99517486902349, -12.090946257492934],
              [-17.9875962050081, -12.087342160262258],
              [-17.975856829857296, -12.086470820375784],
              [-17.969924712324712, -12.089576766091506],
              [-17.964054670087382, -12.088358661464087],
              [-17.9603042679757, -12.094710466084548],
              [-17.963419463356992, -12.098157118381353],
              [-17.96215417256086, -12.105476051218886],
              [-17.963507249217272, -12.11168267161489],
              [-17.969022256657, -12.114861729440198],
              [-17.96965294671548, -12.119287694738013],
              [-17.97458982524712, -12.119636723472537],
              [-17.98117443617325, -12.114931269724678],
              [-17.988779805600164, -12.113858729725472],
              [-17.991268419085557, -12.109500118364627],
              [-17.996067337029693, -12.110254586762274],
              [-18.000980402841673, -12.10543638970557],
              [-18.005627352854578, -12.105970692185265],
              [-18.015244419386924, -12.103771459271128],
              [-18.022414946624984, -12.100318108439074],
              [-18.025747045078074, -12.105046685071187],
              [-18.01842643425783, -12.111598875759961],
              [-18.021384463046115, -12.120909260148728],
              [-18.027899197756952, -12.118910481555432],
              [-18.031902478937198, -12.12218244309218],
              [-18.035834241155683, -12.119706647567643],
              [-18.04451268728193, -12.118489896873523],
              [-18.052172814744274, -12.112664051585757],
              [-18.059389059152295, -12.111304039044388],
              [-18.06915749118543, -12.11884054612105],
              [-18.075779609758012, -12.120870872181605],
              [-18.081141077028008, -12.129662187205218],
              [-18.08805584074989, -12.138829664124966],
              [-18.09679183877335, -12.14620699147251],
              [-18.095724449279594, -12.153739753362055],
              [-18.090913772994632, -12.158220205450034],
              [-18.08429319804246, -12.157546703537728],
              [-18.084023706658403, -12.161025707131643],
              [-18.077633258243697, -12.163749957681118],
              [-18.079629434007384, -12.169346670235187],
              [-18.07828369583884, -12.17468734470334],
              [-18.07396886916894, -12.17338143914406],
              [-18.07234367377984, -12.168460120522372],
              [-18.063966292938147, -12.165376625430474],
              [-18.060933055414708, -12.169025901104009],
              [-18.057289343825108, -12.168728634576448],
              [-18.05496316440193, -12.173349275500275],
              [-18.048706028827187, -12.173697385034941],
              [-18.04685645846882, -12.177186927310423],
              [-18.039165687870472, -12.178955790166848],
              [-18.043176300656533, -12.186018259137471],
              [-18.0498440539278, -12.188235497404527],
              [-18.06200107451137, -12.195856056460716],
              [-18.07534195726465, -12.198154338322963],
              [-18.066898437683253, -12.203369523092807],
              [-18.060087559242255, -12.204324557285675],
              [-18.066906579557095, -12.215966916482193],
              [-18.060323671366675, -12.214523297943142],
              [-18.05355464153775, -12.2112722405312],
              [-18.043248356530228, -12.204472768970469],
              [-18.035686010687012, -12.197566402362252],
              [-18.03241889309081, -12.20051389121147],
              [-18.033238508677822, -12.204273928188428],
              [-18.037870880758785, -12.20721034089516],
              [-18.038862440933205, -12.212527355724568],
              [-18.04470444937369, -12.211916110112874],
              [-18.051894934298033, -12.214214215202768],
              [-18.054404673508824, -12.220323688655464],
              [-18.057431294595535, -12.218429901598604],
              [-18.071566075950724, -12.224982514249671],
              [-18.0697536076928, -12.23144242127628],
              [-18.071941530635854, -12.23368661862002],
              [-18.076761085483845, -12.229300573281389],
              [-18.076007472358597, -12.216391425470567],
              [-18.079247777220754, -12.217703952620061],
              [-18.08267643965837, -12.223820348899565],
              [-18.082654559609512, -12.23032226730415],
              [-18.088741668489416, -12.227061265156848],
              [-18.08164377906642, -12.245171673665771],
              [-18.08340727526648, -12.254391895029254],
              [-18.088341792407842, -12.251429486513818],
              [-18.08743544114905, -12.24666261539098],
              [-18.09501014476694, -12.238930181699347],
              [-18.099733023908442, -12.238732181261746],
              [-18.095196360622158, -12.247702161996832],
              [-18.094932527474644, -12.251293796650796],
              [-18.09956441416933, -12.258117432919569],
              [-18.094363991606475, -12.265683252766088],
              [-18.092402979716084, -12.26287182619225],
              [-18.09394078980404, -12.25579978810568],
              [-18.085656784182863, -12.260463896021818],
              [-18.088184810167284, -12.268890774435983],
              [-18.087626487068075, -12.273939330213752],
              [-18.093761308177843, -12.275789073875433],
              [-18.09496633811179, -12.27038510260418],
              [-18.100945215544304, -12.26160337863477],
              [-18.10415577776498, -12.261276724973277],
              [-18.102955066594884, -12.271840786078007],
              [-18.104717782534205, -12.280758362235058],
              [-18.10733449308583, -12.280196784992484],
              [-18.112424374043183, -12.270390667478994],
              [-18.114920299653754, -12.262529184263897],
              [-18.1060582807179, -12.257869226296323],
              [-18.10748236631858, -12.25494974143497],
              [-18.11686714534056, -12.258125319618538],
              [-18.12174667523713, -12.258388276886459],
              [-18.120642739087476, -12.249373815122238],
              [-18.11257219710284, -12.247640925090927],
              [-18.113152279279223, -12.244983712318577],
              [-18.120880349317435, -12.244530881889636],
              [-18.118668830785918, -12.23364379177473],
              [-18.112258962372287, -12.232938256271849],
              [-18.10991701617576, -12.223045617851099],
              [-18.107802403696223, -12.220005393277798],
              [-18.098959543524824, -12.216526966966898],
              [-18.10315862644617, -12.212591141072199],
              [-18.102863838315354, -12.206366643115661],
              [-18.111245387917897, -12.20830339747931],
              [-18.117141125566015, -12.207156573909966],
              [-18.116374376590024, -12.212363385942801],
              [-18.11022538438832, -12.215548743631057],
              [-18.11683927243378, -12.2199205342428],
              [-18.11723104385869, -12.224675682567545],
              [-18.122925886346405, -12.230830270380075],
              [-18.12903412802237, -12.233802990117612],
              [-18.1314532946836, -12.230634599183848],
              [-18.12838627034493, -12.225727852804622],
              [-18.130193282738013, -12.221489066517078],
              [-18.134360380529927, -12.22395357979247],
              [-18.13372138088936, -12.228932256639087],
              [-18.137052760587085, -12.235208849919397],
              [-18.131064363599034, -12.242038813593515],
              [-18.134226205518697, -12.244007147430407],
              [-18.13399627264809, -12.251470009236279],
              [-18.139065369183914, -12.255016535473988],
              [-18.147045965252214, -12.254417781542472],
              [-18.14541548865526, -12.260137674570542],
              [-18.135618274762464, -12.259789117263406],
              [-18.131108082654045, -12.265683635523352],
              [-18.13258012881139, -12.275504257954722],
              [-18.14245629027958, -12.277745858364423],
              [-18.13518277052876, -12.284820711399716],
              [-18.14051831288022, -12.288655282599558],
              [-18.143625039025267, -12.28293776523382],
              [-18.14923930179578, -12.28704594994093],
              [-18.154163509759524, -12.284236154290456],
              [-18.152129416546046, -12.279697931652477],
              [-18.14726507266942, -12.279146904066746],
              [-18.14994884392594, -12.272821136616079],
              [-18.14712346550884, -12.269527729898636],
              [-18.157183327888315, -12.264467663063522],
              [-18.15704192850915, -12.270134093204993],
              [-18.161383690803227, -12.275304584785326],
              [-18.16562665662348, -12.273452516590957],
              [-18.167401208860152, -12.264748036769474],
              [-18.171615173514112, -12.264744286010469],
              [-18.17437128988396, -12.271687998442312],
              [-18.180446958257104, -12.279651967837847],
              [-18.18713308063186, -12.293104560520584],
              [-18.193499196270153, -12.290584976927287],
              [-18.20397357109179, -12.291736771129012],
              [-18.20582884721535, -12.304566330119947],
              [-18.210965726551194, -12.303317008195434],
              [-18.21760544601465, -12.292324820461765],
              [-18.22059772285305, -12.29207815281528],
              [-18.230047595507806, -12.29642021678904],
              [-18.233422783840144, -12.29598139571984],
              [-18.237738990865545, -12.302356283704817],
              [-18.24466613599386, -12.29869173252346],
              [-18.250361670857313, -12.298619818004068],
              [-18.259547355546488, -12.301121183605206],
              [-18.26206352900475, -12.308561703541171],
              [-18.272845121569357, -12.303732178978779],
              [-18.278407246354725, -12.305948793754576],
              [-18.284037536388425, -12.31035725059651],
              [-18.28648637816244, -12.321185112687639],
              [-18.28586912871993, -12.330063491953368],
              [-18.289659732223555, -12.333913516520653],
              [-18.29266478273582, -12.331084445646837],
              [-18.294278670237503, -12.325285062311384],
              [-18.297302105064468, -12.322244237048816],
              [-18.29872793944043, -12.313899648029793],
              [-18.295694903993045, -12.307637011547568],
              [-18.297447992971726, -12.303464511641588],
              [-18.293257888491233, -12.296025508068604],
              [-18.300700566580723, -12.294041130247694],
              [-18.308749728223066, -12.298036544914948],
              [-18.31237661992715, -12.304885674265432],
              [-18.309768724908114, -12.311055895252592],
              [-18.306202663765237, -12.313706742974922],
              [-18.305095811077276, -12.321063910913344],
              [-18.306076390517678, -12.327360288013846],
              [-18.304925852001194, -12.332799642783824],
              [-18.305288188541432, -12.341263825571136],
              [-18.30726499147901, -12.345850473897098],
              [-18.31368786060054, -12.350871788565245],
              [-18.31845336605309, -12.35769912641998],
              [-18.314566484726818, -12.362523772672844],
              [-18.31673692912068, -12.370305834788219],
              [-18.31700702609851, -12.378132031778854],
              [-18.32227971336478, -12.382190695661125],
              [-18.324937086829163, -12.38031410113968],
              [-18.329486107374866, -12.385282827204236],
              [-18.330124312357732, -12.388847237239153],
              [-18.33522337250423, -12.397921581390017],
              [-18.34864427771898, -12.402481390056616],
              [-18.357161275838713, -12.402589909369869],
              [-18.350940427956775, -12.390085258909973],
              [-18.341387967270844, -12.387543716197733],
              [-18.332128339565124, -12.382622880077944],
              [-18.333033554945562, -12.378678899791929],
              [-18.343644208572783, -12.373789103065075],
              [-18.347526956349107, -12.374591748699956],
              [-18.34196756728003, -12.363250759005505],
              [-18.332671129689366, -12.357998971861068],
              [-18.337510617289595, -12.355021124990024],
              [-18.34189238401879, -12.345782782571888],
              [-18.329707158531757, -12.324984981569424],
              [-18.328604383697016, -12.320924423448542],
              [-18.33197249994361, -12.31628706325693],
              [-18.347664340796833, -12.307245718693714],
              [-18.359006688552547, -12.306053891027968],
              [-18.366149076059788, -12.30372345967726],
              [-18.37397279190487, -12.307130344656429],
              [-18.37140509858317, -12.31189249651639],
              [-18.37355187866256, -12.31542333078919],
              [-18.37261046349911, -12.320827909798389],
              [-18.37601084102362, -12.326272955725411],
              [-18.383759092268892, -12.32635863133098],
              [-18.39439518874575, -12.313722249795632],
              [-18.39724930434064, -12.315949336280896],
              [-18.3955371069339, -12.321792597660393],
              [-18.397740745688516, -12.32915390036958],
              [-18.40187964246851, -12.321646429901191],
              [-18.40828174146432, -12.322387608166363],
              [-18.413940075569716, -12.3324734702407],
              [-18.408718748162176, -12.33741998576512],
              [-18.40753536228758, -12.341617090904073],
              [-18.41129926730671, -12.347216273888241],
              [-18.422344332874435, -12.34294020589848],
              [-18.42161658747695, -12.349699554692998],
              [-18.428302893292553, -12.348545906017252],
              [-18.4336392155405, -12.350019341450885],
              [-18.43140092253445, -12.360903611272766],
              [-18.432114678668434, -12.36371807732085],
              [-18.44941743351709, -12.365414469492569],
              [-18.45355288089362, -12.36116424353112],
              [-18.46294181753086, -12.36983788136764],
              [-18.477008001679906, -12.365738056155186],
              [-18.48845096496308, -12.358529908981579],
              [-18.493066069185698, -12.366566156971471],
              [-18.48454524123794, -12.371439272424835],
              [-18.479017184706304, -12.377310302675419],
              [-18.48514981504247, -12.378994730138702],
              [-18.49214561671979, -12.387450847763084],
              [-18.497697232641244, -12.388679069987823],
              [-18.49809815746625, -12.396494293221108],
              [-18.503218540900715, -12.40430997250399],
              [-18.502196106064076, -12.409141257601322],
              [-18.50544932824065, -12.415654501944015],
              [-18.51248901558106, -12.420951245358914],
              [-18.518862762952097, -12.419134652011778],
              [-18.521197261255622, -12.403871662401713],
              [-18.525671135924945, -12.394399449452878],
              [-18.52457255663422, -12.38952862466441],
              [-18.52747094195552, -12.384971827905131],
              [-18.52543441127088, -12.379558377647259],
              [-18.52856647871621, -12.374700536303328],
              [-18.532151582507115, -12.380911132353702],
              [-18.530208795669584, -12.383847231809819],
              [-18.5385836721437, -12.393346922923795],
              [-18.542684638590035, -12.394454673244404],
              [-18.551715642358573, -12.388943383529082],
              [-18.56001484224115, -12.390348477184352],
              [-18.562948224766398, -12.39780456921172],
              [-18.557119583236755, -12.400209890572732],
              [-18.552469272896552, -12.39983874675606],
              [-18.548108451594064, -12.402502473295442],
              [-18.542305206382974, -12.403316604239437],
              [-18.540301345016992, -12.408731904979888],
              [-18.541170599332244, -12.415790216871322],
              [-18.54444991362007, -12.421829097783428],
              [-18.549590060950514, -12.423661967860436],
              [-18.571288923589968, -12.42203583320838],
              [-18.578602139985634, -12.415902702775485],
              [-18.578517053150588, -12.408386087503581],
              [-18.57505436014039, -12.404962433231528],
              [-18.576224660577846, -12.40058665873732],
              [-18.580015322073688, -12.397959552884638],
              [-18.588720627812673, -12.39640504524941],
              [-18.59874745361308, -12.401651710545439],
              [-18.60204768874172, -12.408559598140794],
              [-18.608012923614282, -12.415103387463178],
              [-18.611235816326676, -12.423523715943421],
              [-18.62241720277389, -12.428309021920251],
              [-18.630161677415796, -12.433370723167357],
              [-18.637419168959784, -12.436323123073883],
              [-18.650183948731932, -12.438991696682649],
              [-18.65446611542135, -12.442880207126338],
              [-18.662727807907707, -12.447040897141568],
              [-18.672249983404818, -12.446298466719053],
              [-18.677074377687617, -12.444174902508019],
              [-18.677061232148418, -12.437972775981972],
              [-18.6848286879463, -12.435226101458785],
              [-18.69416026058904, -12.437229316711099],
              [-18.704530832203286, -12.44201769071461],
              [-18.714286637532748, -12.439801264151177],
              [-18.716305449819995, -12.435486511936054],
              [-18.71550110376664, -12.430208248829537],
              [-18.7113296584549, -12.42771079753324],
              [-18.708993357320725, -12.422524196867222],
              [-18.70426122811201, -12.406800912463618],
              [-18.704273023596507, -12.396250657265007],
              [-18.69197395347371, -12.385117763362905],
              [-18.690001568226307, -12.38031012160516],
              [-18.684708033579533, -12.373345316513447],
              [-18.680508125489073, -12.37085867920556],
              [-18.677326091662415, -12.364598518560111],
              [-18.676666647985652, -12.356118766344817],
              [-18.680994905914186, -12.35183534266768],
              [-18.6938881818486, -12.348158118387092],
              [-18.711154210580567, -12.34800158565906],
              [-18.72131306975171, -12.350239777945761],
              [-18.72607845842437, -12.353588195376878],
              [-18.725774551686705, -12.35843208334238],
              [-18.729027661861444, -12.359754646687376],
              [-18.735373597908357, -12.369342170513976],
              [-18.741231486845617, -12.375687484149237],
              [-18.740619332986043, -12.37890705510644],
              [-18.746296217651505, -12.381227755125636],
              [-18.74469246339386, -12.386461852845834],
              [-18.75037690339345, -12.41286499591965],
              [-18.748995865670626, -12.42101152728128],
              [-18.76273405947427, -12.43667030534759],
              [-18.765441583299225, -12.43840731323366],
              [-18.777172952128797, -12.451163130107568],
              [-18.780363625204977, -12.455662457573334],
              [-18.788498590218744, -12.462363418969868],
              [-18.791755099051876, -12.468168908948861],
              [-18.793925462831485, -12.477959604184843],
              [-18.79833835538163, -12.479410389588582],
              [-18.799679527283306, -12.48375982017259],
              [-18.80506793072055, -12.48051388116483],
              [-18.81311955391509, -12.471609838345222],
              [-18.823085917602945, -12.47012810822529],
              [-18.825586862215186, -12.475058990121749],
              [-18.821248292239098, -12.477254190172204],
              [-18.819848277285512, -12.490054029280042],
              [-18.823487483570418, -12.492777925653254],
              [-18.81333857832989, -12.498158938011507],
              [-18.81425795503958, -12.505415102019038],
              [-18.811475181362134, -12.509653415332911],
              [-18.814961991551478, -12.515968189278711],
              [-18.82102897300675, -12.518904604960039],
              [-18.827659154348027, -12.519595347131181],
              [-18.834530960620942, -12.525476623688297],
              [-18.839629555131562, -12.5188741170023],
              [-18.85005415361094, -12.509502389259831],
              [-18.84389868537721, -12.5060993209274],
              [-18.84548727645938, -12.50254002466864],
              [-18.843303444826027, -12.498124424274886],
              [-18.850136282146746, -12.494591275693276],
              [-18.85610091266214, -12.49480728052075],
              [-18.85810326331267, -12.49926607633238],
              [-18.866505717992744, -12.505992830008022],
              [-18.868389075777586, -12.510235384112814],
              [-18.864585836034195, -12.517089807313452],
              [-18.865460281792334, -12.520567680943527],
              [-18.863247473992814, -12.526995342782396],
              [-18.870162840083236, -12.536073980756964],
              [-18.876792615961005, -12.538811915786106],
              [-18.881849729155146, -12.537021281294576],
              [-18.88603644318486, -12.530715074618968],
              [-18.887089183371877, -12.523786754559023],
              [-18.890432059135655, -12.52475886827557],
              [-18.894434263274547, -12.530081022011842],
              [-18.901546070834883, -12.527865510838101],
              [-18.908519278204786, -12.529017118635977],
              [-18.915199681337818, -12.524619426568593],
              [-18.923111448857235, -12.516288696799547],
              [-18.926060516122398, -12.499257067017492],
              [-18.9151783065368, -12.497410645557386],
              [-18.910366446373278, -12.500256744200477],
              [-18.90959582678113, -12.504552670999136],
              [-18.901822790519816, -12.508400521154718],
              [-18.89318547133113, -12.507454938000707],
              [-18.8971953513548, -12.502135573073888],
              [-18.902142802381043, -12.502201234261184],
              [-18.90707524869098, -12.495360522686795],
              [-18.9101218158046, -12.488658243071956],
              [-18.916382467231983, -12.485211178249003],
              [-18.918752423287902, -12.47593223607182],
              [-18.918536044567198, -12.45362131985404],
              [-18.932436533169657, -12.444580202740369],
              [-18.926143225142944, -12.440173735295884],
              [-18.927320861960318, -12.435230099969678],
              [-18.945993960662392, -12.433819510845849],
              [-18.957160852181577, -12.447909129656612],
              [-18.96121230016171, -12.456475812869773],
              [-18.961025708961344, -12.461993612885744],
              [-18.95639264132639, -12.467921319068015],
              [-18.94764614340385, -12.468387934965888],
              [-18.946313117317576, -12.47344639915909],
              [-18.942641032312547, -12.478218987494332],
              [-18.94207401040541, -12.483837367082248],
              [-18.938206330639286, -12.488799831443412],
              [-18.941301371857133, -12.494213716858862],
              [-18.947115204071913, -12.496799341573597],
              [-18.947447579935243, -12.501794447623308],
              [-18.943484183891776, -12.50679904463135],
              [-18.94391333975065, -12.517577139273344],
              [-18.939860704775537, -12.530645076429863],
              [-18.942125861643245, -12.545693946082542],
              [-18.938940444140517, -12.549809840196893],
              [-18.941659447767385, -12.552296146961057],
              [-18.945788307360456, -12.549694972087629],
              [-18.946470686300824, -12.544696411016735],
              [-18.951471251285515, -12.538703872963975],
              [-18.96325495863928, -12.53505923584406],
              [-18.97120714498197, -12.539228997714709],
              [-18.969122421412536, -12.54429218614075],
              [-18.972997421010387, -12.549435700774833],
              [-18.97556022873851, -12.548611297422154],
              [-18.980038041348717, -12.553018837747654],
              [-18.985670255988126, -12.553841741019172],
              [-18.989806555148824, -12.550763294444502],
              [-18.994366708963575, -12.551321947565382],
              [-18.99688224917305, -12.554546519742145],
              [-19.0060005971661, -12.551587333596649],
              [-19.011819680181464, -12.544492291219166],
              [-19.01199925879528, -12.537953474575811],
              [-19.01827047372526, -12.532280696948616],
              [-19.019796801481146, -12.52646034079326],
              [-19.018454641596364, -12.521656780594126],
              [-19.01452622430981, -12.518840914140782],
              [-19.02011091632002, -12.510398073679196],
              [-19.024204136777392, -12.498564183753908],
              [-19.03491453737808, -12.487925113144225],
              [-19.042535820769118, -12.487135194713042],
              [-19.05053022105839, -12.490325562849454],
              [-19.05856263282601, -12.488016443773638],
              [-19.060968013517737, -12.493955935837988],
              [-19.068233854855126, -12.506234119766273],
              [-19.06818667540251, -12.510669655715885],
              [-19.05973136805509, -12.517496138907603],
              [-19.055439621055882, -12.517311491219305],
              [-19.051075004884282, -12.522334872420528],
              [-19.037962556997208, -12.534585527697757],
              [-19.035440533467916, -12.544099165576275],
              [-19.04247901600747, -12.549560830534197],
              [-19.050141637620246, -12.55187581031108],
              [-19.059997296966568, -12.557708857645352],
              [-19.060362198512284, -12.559771306539524],
              [-19.06771878455557, -12.565150077247877],
              [-19.072206153480586, -12.565058634274669],
              [-19.07776457545294, -12.573832648920181],
              [-19.083769220717016, -12.575891804014013],
              [-19.094514999869922, -12.575718980287839],
              [-19.09902928066293, -12.58234469571691],
              [-19.106878250302877, -12.580362708961427],
              [-19.108162025202624, -12.570880302336874],
              [-19.11059390915475, -12.5637612574132],
              [-19.097020745492248, -12.559442109654498],
              [-19.093966169251193, -12.548687177034134],
              [-19.09900672990469, -12.541662836550119],
              [-19.09562602310525, -12.532331794134585],
              [-19.090586815365565, -12.535852669200404],
              [-19.078980553398807, -12.540036119728862],
              [-19.07625741553558, -12.537535636440156],
              [-19.086195469752493, -12.529611081192499],
              [-19.08680766350143, -12.526720800048993],
              [-19.0815498834759, -12.513988077606047],
              [-19.080526580301687, -12.500873320026116],
              [-19.085515563184305, -12.48973479941012],
              [-19.082145994728926, -12.485763214799793],
              [-19.085765115165188, -12.482870777651776],
              [-19.090194488117874, -12.487563593921967],
              [-19.093184717240405, -12.48663348766167],
              [-19.077654860284937, -12.47694900062789],
              [-19.058759830983814, -12.466030325642684],
              [-19.047049740154534, -12.462606694814536],
              [-19.040868614099256, -12.462973411188738],
              [-19.03172658255146, -12.45694595580749],
              [-19.022658368034747, -12.448989259444028],
              [-19.018713518497226, -12.452275898330802],
              [-19.02542293861018, -12.454701831302291],
              [-19.029375552136848, -12.459648772059595],
              [-19.034215841641622, -12.462370340507025],
              [-19.032407030004833, -12.466547100239275],
              [-19.025290502705108, -12.468109085862285],
              [-19.016713884884528, -12.465740604892572],
              [-19.010228069534794, -12.471143866038924],
              [-19.005767401205606, -12.472857900663113],
              [-19.005025922461982, -12.467921560703367],
              [-18.996381699285138, -12.467025666181916],
              [-18.992715034126903, -12.468583790158934],
              [-18.988094721464247, -12.45622925014541],
              [-18.98516233598842, -12.454742629377815],
              [-18.985549197169444, -12.448147015203665],
              [-18.988827168507584, -12.445894424205145],
              [-18.992762246772486, -12.448416110863498],
              [-18.99710983238468, -12.44387077658376],
              [-18.984203860121617, -12.434867456011492],
              [-18.978438422870617, -12.43394020507018],
              [-18.97438240436077, -12.430827732702095],
              [-18.9719982962001, -12.42595756143343],
              [-18.96551889476044, -12.425352834199987],
              [-18.959758355378906, -12.428637415287628],
              [-18.951023100812957, -12.421207965641749],
              [-18.946840083625535, -12.414939024008117],
              [-18.938288163942897, -12.410535874583985],
              [-18.93089979203008, -12.413588178842392],
              [-18.926275628458132, -12.41910094260021],
              [-18.918106939936845, -12.416453349911368],
              [-18.90873684767184, -12.40700427971396],
              [-18.90918734515761, -12.399584928751942],
              [-18.911542258209487, -12.392548068063073],
              [-18.908371854345372, -12.387801717896508],
              [-18.907247760348213, -12.381875659682692],
              [-18.91473384391147, -12.381486310492813],
              [-18.917995719525983, -12.38440987413465],
              [-18.92477341453167, -12.383124461949835],
              [-18.90782210420082, -12.370306710332711],
              [-18.89819419062314, -12.360128930897458],
              [-18.87795021645231, -12.341710358335796],
              [-18.85998134455429, -12.322554362612108],
              [-18.851272402082632, -12.311958107207648],
              [-18.839313885962337, -12.303849844208473],
              [-18.825246172012804, -12.298658225907353],
              [-18.804048327232113, -12.281349900558642],
              [-18.792804508199847, -12.280294496228276],
              [-18.780195669679962, -12.274356649751837],
              [-18.767842803939715, -12.265679526617136],
              [-18.752888285575057, -12.252545867133707],
              [-18.72919969442203, -12.249012236305175],
              [-18.71528555959191, -12.245599809999778],
              [-18.70575537658579, -12.241856104373884],
              [-18.666504418183948, -12.236358696578957],
              [-18.648382190437847, -12.232474558802302],
              [-18.62505782022409, -12.225791874528408],
              [-18.624453427777087, -12.227503981285393],
              [-18.645166477616364, -12.232574597793855],
              [-18.647668546275387, -12.236932836105991],
              [-18.64713111732453, -12.24129887647177],
              [-18.63704286687177, -12.244409365476297],
              [-18.62925339399123, -12.242361451487904],
              [-18.62016436633643, -12.246081687540228],
              [-18.61209790525493, -12.243049582617006],
              [-18.612304381563206, -12.247060581783899],
              [-18.608206115992694, -12.25065221740054],
              [-18.602361470710022, -12.251124113744948],
              [-18.59683857726922, -12.245511800914748],
              [-18.58590305446425, -12.243847136177303],
              [-18.581252235962946, -12.23841819687718],
              [-18.576573540223098, -12.23967556222505],
              [-18.567158082747866, -12.235508381684857],
              [-18.56478057311575, -12.24215766516568],
              [-18.566601862014906, -12.25094910033748],
              [-18.563589447672882, -12.256064763349775],
              [-18.5675049094139, -12.259013730595372],
              [-18.57186834584296, -12.25105825737061],
              [-18.582722003229318, -12.252099624369327],
              [-18.589299189402265, -12.254952507094512],
              [-18.596945698138175, -12.26159007347429],
              [-18.59956094446361, -12.267557972706262],
              [-18.59686101278538, -12.27550205077814],
              [-18.587891783316742, -12.279273210706442],
              [-18.58856212664541, -12.293351816646108],
              [-18.58623288708986, -12.298324867746523],
              [-18.579357163796814, -12.30164773083883],
              [-18.570491672121086, -12.316805798272378],
              [-18.567451352679285, -12.31964193228475],
              [-18.56193620104225, -12.329313509199594],
              [-18.55681133379806, -12.322336214375031],
              [-18.54785976473825, -12.324967118510248],
              [-18.543410347985894, -12.32865546805719],
              [-18.543263114738334, -12.33507129186277],
              [-18.540662781434424, -12.342713114134535],
              [-18.537567790660923, -12.342513575924444],
              [-18.532511302221685, -12.328597888532169],
              [-18.540509048829154, -12.32239059044739],
              [-18.538553798230335, -12.320180808043029],
              [-18.543882876534408, -12.315376122907034],
              [-18.54688750567004, -12.31535383259262],
              [-18.55249048496039, -12.310518861500483],
              [-18.549863263690884, -12.30425280487289],
              [-18.55097904163917, -12.287099333442029],
              [-18.555583655629206, -12.279156967709737],
              [-18.55500844164857, -12.275911008280856],
              [-18.548034679520896, -12.278214418640815],
              [-18.537186347642233, -12.285795036075225],
              [-18.528276637371373, -12.288337914907483],
              [-18.510692807139193, -12.289180819409472],
              [-18.504713452997358, -12.286387264827512],
              [-18.4975086840499, -12.289040058426542],
              [-18.492255237402947, -12.30068380978327],
              [-18.495038399359377, -12.304596694377379],
              [-18.495453467809323, -12.312963731734767],
              [-18.49143227853119, -12.316885969085034],
              [-18.487490393508956, -12.311241008894543],
              [-18.480671111737617, -12.31014101271224],
              [-18.478210500822456, -12.318965131741528],
              [-18.473363653931408, -12.321718590006656],
              [-18.466684831875053, -12.320642708852338],
              [-18.462522299667175, -12.324661390146002],
              [-18.45324678780954, -12.326347755075926],
              [-18.451386158047907, -12.322153209266109],
              [-18.45606145200741, -12.320425851193336],
              [-18.460113788308302, -12.315832417062591],
              [-18.45962244918802, -12.312708603794432],
              [-18.46471760375261, -12.30819372227443],
              [-18.459814984068483, -12.306491940071334],
              [-18.44515069744309, -12.304173885349707],
              [-18.44884335603718, -12.300730235264163],
              [-18.45092816740919, -12.295566979062448],
              [-18.458330661636246, -12.296533293347029],
              [-18.47630743387169, -12.28164322026174],
              [-18.48102396053583, -12.274917839009515],
              [-18.49202564548708, -12.270755270488232],
              [-18.49736392860856, -12.264288080827127],
              [-18.498763621092365, -12.260077773544332],
              [-18.503694205267696, -12.26028939673646],
              [-18.4994707779532, -12.249938669208028],
              [-18.504291172345923, -12.244486504571125],
              [-18.510608634906227, -12.245705096182483],
              [-18.491707026801254, -12.221017008207514],
              [-18.483308387189858, -12.207853802913574],
              [-18.479995610119484, -12.201237195918184],
              [-18.479170033327673, -12.195754076049514],
              [-18.469041062631707, -12.174940051227946],
              [-18.462728901301155, -12.160121893152962],
              [-18.455295534503527, -12.148747021662773],
              [-18.44801824817413, -12.142981995530423],
              [-18.439554817848737, -12.138631062286102],
              [-18.429838675512865, -12.130947933499288],
              [-18.422642246607335, -12.121117102080067],
              [-18.41286424847902, -12.113829283773399],
              [-18.405076943102664, -12.110549867017419],
              [-18.400758985751075, -12.110757670090583],
              [-18.395032436961362, -12.10823865333167],
              [-18.370628357589478, -12.091092074375888],
              [-18.357618131800486, -12.080168375040921],
              [-18.350810275982877, -12.073040425315957],
              [-18.343813949623943, -12.067824031263614],
              [-18.31509617815109, -12.05727793589344],
              [-18.29049086976486, -12.046979063955536],
              [-18.27648389579137, -12.039077033623098],
              [-18.271551021553407, -12.034889316619074],
              [-18.25792861096215, -12.025779442805655],
              [-18.251855955734815, -12.025362891293742],
              [-18.240365494516976, -12.019082812791918],
              [-18.236409325407653, -12.01880638948097],
              [-18.225513099881805, -12.013157875916317],
              [-18.21721323360086, -12.007540811722308],
              [-18.186787057473147, -11.990837249728472],
              [-18.168350337059483, -11.974913868508894],
              [-18.170052747363957, -11.980271371320416],
              [-18.16352553332751, -11.990574856401226],
              [-18.153861000281623, -11.996888944700732],
              [-18.145804614220317, -12.0004192908656],
              [-18.138095439572414, -12.00190504741102],
              [-18.133282823796495, -11.999377572130017],
              [-18.113733044251237, -11.99782363584836],
              [-18.115494886276394, -11.994122943858335],
              [-18.113075995786012, -11.983577314826762],
              [-18.11667361236781, -11.978234054705498],
              [-18.116938023870247, -11.971804095681927],
              [-18.12005320158619, -11.96803759285938],
              [-18.11686916049705, -11.95636053275678],
              [-18.119451424133345, -11.950939490642943],
              [-18.117020745862135, -11.938980035202553],
              [-18.111040257674965, -11.925494665055284],
              [-18.102962426078843, -11.912898214173786],
              [-18.091611949707183, -11.8988652153621],
              [-18.08519639457621, -11.888882177420276],
              [-18.068463772338827, -11.86812573597383],
              [-18.052005155788446, -11.849292846960656],
              [-18.037361943718537, -11.835415612880357],
              [-18.029705596291443, -11.83207711429576],
              [-18.02242976422816, -11.82623862682719],
              [-18.013134784720787, -11.820987334417463],
              [-17.99385793929558, -11.814837804544252],
              [-17.993040228840933, -11.810035123974219],
              [-17.97500285140732, -11.796637576939224],
              [-17.969560933613966, -11.788958602676125],
              [-17.962528235136364, -11.776497092105297],
              [-17.950949173896444, -11.770414393961634],
              [-17.934552665940856, -11.75460495244451],
              [-17.926696943658254, -11.750235862187544],
              [-17.91772246256216, -11.74763599734566],
              [-17.91377213540626, -11.759360216433446],
              [-17.910508159097464, -11.763604313674643],
              [-17.910709957270825, -11.768439096539685],
              [-17.90849816858072, -11.774191971027262],
              [-17.900181746586345, -11.77488230893581],
              [-17.894164941957193, -11.764129948565012],
              [-17.8964517437286, -11.742938883228097],
              [-17.898400850632786, -11.732575900380425],
              [-17.907634525813226, -11.730804936782212],
              [-17.916358819280596, -11.73077883168774],
              [-17.91832238371616, -11.722642971013228],
              [-17.91581313136626, -11.69775723379537],
              [-17.90948729271594, -11.680870828537959],
              [-17.905322275428876, -11.667899253254376],
              [-17.899075403697935, -11.634571543579158],
              [-17.896160048497375, -11.612781517518098],
              [-17.89260526912262, -11.592036693522786],
              [-17.886373541318125, -11.562100635330227],
              [-17.878577697498095, -11.545092829998977],
              [-17.874705220890757, -11.543479890712797],
              [-17.865748172070102, -11.54513127881034],
              [-17.856780192326386, -11.54412063720314],
              [-17.851195010620525, -11.540343893986012],
              [-17.84792184177243, -11.53088499853624],
              [-17.85772491245769, -11.529700658040879],
              [-17.873822493986104, -11.506717452045194],
              [-17.87239515036302, -11.500936323685034],
              [-17.87493704525078, -11.497123283900338],
              [-17.87456830038436, -11.485163093741283],
              [-17.871341394874513, -11.466298825023255],
              [-17.869010135725947, -11.459016851597882],
              [-17.862758582448006, -11.445875331434356],
              [-17.860044585987115, -11.436974693712774],
              [-17.8541170067707, -11.427104957435889],
              [-17.85156308443544, -11.427218380195306],
              [-17.845717598707214, -11.421456524016952],
              [-17.840413252224753, -11.421725829010995],
              [-17.832268733961243, -11.413791839481359],
              [-17.82316869971819, -11.398730798157443],
              [-17.817271151330825, -11.390672957844005],
              [-17.80699635929794, -11.382165177618957],
              [-17.80029822160011, -11.373680635196427],
              [-17.78322496262352, -11.36082337184762],
              [-17.777954467148383, -11.359658218383121],
              [-17.779863766571182, -11.353063950749782],
              [-17.778976043272973, -11.339694452741265],
              [-17.77381240832309, -11.334618427550769],
              [-17.765618528301236, -11.322442340852],
              [-17.764405790802087, -11.31193806598562],
              [-17.76902343175699, -11.305991707838471],
              [-17.767872160348503, -11.301044941471936],
              [-17.761958024778107, -11.295040894723964],
              [-17.759981869556437, -11.27899100492639],
              [-17.7575294413117, -11.273145949468526],
              [-17.75173255378148, -11.272103489539317],
              [-17.754564564377667, -11.267102328049804],
              [-17.759135354788466, -11.267008006934613],
              [-17.767293978730564, -11.271905873286578],
              [-17.773191192965932, -11.280454113606462],
              [-17.77299533396317, -11.290000780837545],
              [-17.778001020315802, -11.295297628061743],
              [-17.78093349029662, -11.303358154604352],
              [-17.789539695414195, -11.307030538601309],
              [-17.814149611860962, -11.314664126342995],
              [-17.826047464589, -11.31550516943505],
              [-17.828742684852333, -11.318214639280162],
              [-17.83928102780909, -11.323354632687439],
              [-17.844882564690604, -11.328485022761763],
              [-17.852985523642133, -11.330407564918495],
              [-17.863824458699636, -11.334547948875779],
              [-17.868152957034333, -11.339881837629756],
              [-17.896045073524256, -11.347550142619381],
              [-17.912812724060597, -11.357156163062223],
              [-17.916636659936774, -11.360199159746735],
              [-17.925517816099163, -11.364041061040345],
              [-17.965375950366692, -11.37957164745787],
              [-17.976971284780866, -11.382492702051874],
              [-17.990288938273558, -11.381391736163753],
              [-18.00061832683779, -11.374657643980555],
              [-18.010435116019543, -11.363779449227637],
              [-18.010151874854344, -11.355646299035856],
              [-18.011688313270497, -11.34341397230183],
              [-18.01710079437114, -11.332508599418302],
              [-18.02769510120155, -11.323863408297527],
              [-18.04252764573951, -11.31850047524],
              [-18.04907743769349, -11.312428583138878],
              [-18.046493196965802, -11.306866839123181],
              [-18.04737148257199, -11.303133955582725],
              [-18.037501221480767, -11.2959843177577],
              [-18.037986521627847, -11.293066691409443],
              [-18.03333916365825, -11.26436808805482],
              [-18.031155346672254, -11.26097903993268],
              [-18.03197796561108, -11.255826294531179],
              [-18.029747817780194, -11.246460240776257],
              [-18.02019646102593, -11.243058293810577],
              [-18.015055136279646, -11.23893052366799],
              [-18.00607152343221, -11.235188966691231],
              [-18.003922688256157, -11.231917097574188],
              [-18.00597039563147, -11.227863526703786],
              [-18.01799144657642, -11.223960127818527],
              [-18.024113389382617, -11.233373741231492],
              [-18.03264029811072, -11.233588166902052],
              [-18.038519683583914, -11.237560296718739],
              [-18.039185716948296, -11.246969734491943],
              [-18.047354916907196, -11.256238591379548],
              [-18.054080408956025, -11.265384074283983],
              [-18.055865217630064, -11.274402092259596],
              [-18.06300777895408, -11.28006270454589],
              [-18.07852512532163, -11.286787166227112],
              [-18.08573229232566, -11.283901538911039],
              [-18.084841843258328, -11.289296150368726],
              [-18.086088145148285, -11.29532533754359],
              [-18.09083694952663, -11.307753218604718],
              [-18.088049920532196, -11.320792765123889],
              [-18.093973258404695, -11.333015221745748],
              [-18.102648563154865, -11.336250837291619],
              [-18.106998561061502, -11.334353603248893],
              [-18.10854045294995, -11.327157738665148],
              [-18.112104903198105, -11.327907583196737],
              [-18.1116306217172, -11.338692222628765],
              [-18.106446349539784, -11.346025755591286],
              [-18.10217578179745, -11.365821850658428],
              [-18.102356478182553, -11.371120260046292],
              [-18.098256433464794, -11.385932880355615],
              [-18.09374962202083, -11.396664238095273],
              [-18.091038552606495, -11.411715355690161],
              [-18.081822641830165, -11.416966216131886],
              [-18.089882376834378, -11.430984446938846],
              [-18.09965187287745, -11.44268424048454],
              [-18.104036297753964, -11.446339532412553],
              [-18.110060771433243, -11.448267353814844],
              [-18.12107966477934, -11.449148713634886],
              [-18.144747020133707, -11.438646928377109],
              [-18.148967117227734, -11.435889770732766],
              [-18.151339704121227, -11.428536905785856],
              [-18.151399339607106, -11.419936198891868],
              [-18.15491440672073, -11.419004924467385],
              [-18.168519428590166, -11.389212030807698],
              [-18.179181101718637, -11.361652991245398],
              [-18.191846861525153, -11.331934919452694],
              [-18.202385877787766, -11.312222116205868],
              [-18.211215775487183, -11.300041953475773],
              [-18.217481729664378, -11.293898144085237],
              [-18.231825259872814, -11.286896512089443],
              [-18.234679935889133, -11.28955160718569],
              [-18.240935950789193, -11.283483694320804],
              [-18.239756956870117, -11.279955191987934],
              [-18.230409053781155, -11.267665276268707],
              [-18.234867930171482, -11.25472349594534],
              [-18.2407740954446, -11.25216777985199],
              [-18.25783279708653, -11.25475827008999],
              [-18.255477739256623, -11.259221778339016],
              [-18.25878712468287, -11.26628383174068],
              [-18.264214332197504, -11.27293514002504],
              [-18.260542910193863, -11.278601825005529],
              [-18.261871067891903, -11.28290959689705],
              [-18.27012553188642, -11.27939791628444],
              [-18.272839771914317, -11.282310635233177],
              [-18.270970637441447, -11.287659868556448],
              [-18.270759118137434, -11.295187617954497],
              [-18.276338938881022, -11.298049243984922],
              [-18.28245303478035, -11.298670205007975],
              [-18.282724521520013, -11.302160097061599],
              [-18.290969429960153, -11.304594709284553],
              [-18.299281506049685, -11.292175289436097],
              [-18.301623169894018, -11.284351097758115],
              [-18.305344720663406, -11.282192462075248],
              [-18.302907034243606, -11.272330788557378],
              [-18.306632526896127, -11.266539355358493],
              [-18.31299278862578, -11.264378819870684],
              [-18.321158371504847, -11.265897218681285],
              [-18.322750557291943, -11.27144095065476],
              [-18.335501583823977, -11.267847585222745],
              [-18.332291114013444, -11.261446769284442],
              [-18.33523147442367, -11.253002160086503],
              [-18.339226297875985, -11.252063057102294],
              [-18.344996946828495, -11.254632347309798],
              [-18.349816063395863, -11.258902690040468],
              [-18.348215090939505, -11.24807218240482],
              [-18.351512112084063, -11.238811833820304],
              [-18.356819467097907, -11.237511838044092],
              [-18.358891911803443, -11.233203579541788],
              [-18.353360483607958, -11.228513537166132],
              [-18.347415317021117, -11.22619373555805],
              [-18.351083824170594, -11.211239369643534],
              [-18.359612971579708, -11.201292596695477],
              [-18.355034617106337, -11.20069480448894],
              [-18.358195639115547, -11.194301457094866],
              [-18.363699469976638, -11.194582225564853],
              [-18.36960147940366, -11.2007089672771],
              [-18.38545535108363, -11.207968665010952],
              [-18.393259666959402, -11.212455912610704],
              [-18.39839782370736, -11.218762519413604],
              [-18.404009921386592, -11.220688673361376],
              [-18.416362203058373, -11.227903595352947],
              [-18.426362445443857, -11.234683629511967],
              [-18.439428671548708, -11.244832156061648],
              [-18.448027679045275, -11.255398186779914],
              [-18.45463974646898, -11.269120103233266],
              [-18.45511055447199, -11.261705462321178],
              [-18.459177723061682, -11.253685568200588],
              [-18.463039059002003, -11.25048459162269],
              [-18.467990880708005, -11.249659723264076],
              [-18.46995993733877, -11.252372511700692],
              [-18.477939392859522, -11.251445219900269],
              [-18.484091194694333, -11.25815227392131],
              [-18.494793403702907, -11.263789976122213],
              [-18.50163122043175, -11.26931794255843],
              [-18.507570889482597, -11.270334420411947],
              [-18.51140455295651, -11.273981117926535],
              [-18.515310697653852, -11.272778341509659],
              [-18.51954416715488, -11.27493084566046],
              [-18.520443277102572, -11.27876078726057],
              [-18.526999713695243, -11.2780612931294],
              [-18.540718557659996, -11.280898034362941],
              [-18.543348609606397, -11.286016282617378],
              [-18.55534811832158, -11.296059102875397],
              [-18.558778953986735, -11.30263204923604],
              [-18.56012546957695, -11.311218585609405],
              [-18.55817703794349, -11.316784445958627],
              [-18.579495074651916, -11.321177471682182],
              [-18.589561323568702, -11.32489073614272],
              [-18.592938720568444, -11.327408174286802],
              [-18.596242971642983, -11.333388018729531],
              [-18.601985674206208, -11.331562753742633],
              [-18.60899276333623, -11.332917711009122],
              [-18.617993915616097, -11.338787407321673],
              [-18.62087171498519, -11.345075694895701],
              [-18.629409840585744, -11.34510952652222],
              [-18.6343334917007, -11.346951088368911],
              [-18.63264255486856, -11.337734146760619],
              [-18.63482616585236, -11.329087151035838],
              [-18.638256553296184, -11.322531584397742],
              [-18.64224688310447, -11.318851284759559],
              [-18.656588190361457, -11.317221663583867],
              [-18.66231497990282, -11.31517603247081],
              [-18.666828153518704, -11.317948714653753],
              [-18.671151126573175, -11.314390564959385],
              [-18.688470490764054, -11.316083157191056],
              [-18.69318425749835, -11.311868345671057],
              [-18.701552279221, -11.308391118486904],
              [-18.702773697328656, -11.30272898963059],
              [-18.69602526655815, -11.302450945688168],
              [-18.693994618796623, -11.298899841517196],
              [-18.677037289398733, -11.30030888332135],
              [-18.67185486167818, -11.297195648890545],
              [-18.66746666589348, -11.302280454933188],
              [-18.66303399503048, -11.30348987296785],
              [-18.663832743805347, -11.309120126086885],
              [-18.65347663377549, -11.308621114404527],
              [-18.646190422558632, -11.303148946115353],
              [-18.64285849879559, -11.29659590717953],
              [-18.64709726104033, -11.291305698435679],
              [-18.642489262896156, -11.285657410531838],
              [-18.634828187694293, -11.282139368941769],
              [-18.628018297361823, -11.272493366805582],
              [-18.62276563778725, -11.259514248070898],
              [-18.622277291318326, -11.250373464984945],
              [-18.625015063362333, -11.2325137855085],
              [-18.623632521200058, -11.215791459826047],
              [-18.62234972223812, -11.212110843876294],
              [-18.622332486584224, -11.2020994400893],
              [-18.62469392238639, -11.192945909119604],
              [-18.629350088778445, -11.181493670009152],
              [-18.624988427827365, -11.174533358678456],
              [-18.6343980230971, -11.167351484923563],
              [-18.64435276888278, -11.14842919886702],
              [-18.649194445541372, -11.137803659588553],
              [-18.652987276572038, -11.122235591566929],
              [-18.657553334167712, -11.096335948959235],
              [-18.652342207488648, -11.088714886880142],
              [-18.64332680691736, -11.07247553010758],
              [-18.636216371990837, -11.068478272829912],
              [-18.634911629570073, -11.05940129952339],
              [-18.621107619799794, -11.055140377397576],
              [-18.61700002227532, -11.04631837204838],
              [-18.613205250364167, -11.043025290825241],
              [-18.608849757303407, -11.044391773572432],
              [-18.60491653991358, -11.035025608297886],
              [-18.60146053244941, -11.03268556745203],
              [-18.593671101181812, -11.033310902725395],
              [-18.58797291429225, -11.030129602282877],
              [-18.585301802735415, -11.023690891668034],
              [-18.591261252139486, -11.011645933095794],
              [-18.59511152343609, -11.001265143140945],
              [-18.601576179178892, -10.990694642551992],
              [-18.6035692128222, -10.983404112168575],
              [-18.6089499787376, -10.972236914683931],
              [-18.609741763904598, -10.965553420115706],
              [-18.608562810015954, -10.959833465209536],
              [-18.610732068340887, -10.954453270537185],
              [-18.608527026426195, -10.950170528566641],
              [-18.6153331251583, -10.936944379132534],
              [-18.614716849743058, -10.933215260192664],
              [-18.619629436629204, -10.915232449715505],
              [-18.63314319722464, -10.892679094299902],
              [-18.636336872210272, -10.88415049788494],
              [-18.639132508248874, -10.869645436312238],
              [-18.63687896688899, -10.860480247720288],
              [-18.639090585260913, -10.85518235862163],
              [-18.643051860932726, -10.853515632405456],
              [-18.647194439317953, -10.84593749692255],
              [-18.651984694537614, -10.831308972631835],
              [-18.653051259818653, -10.82030421974696],
              [-18.65869908300623, -10.818828335328398],
              [-18.660116444093916, -10.809839941481552],
              [-18.66737370119371, -10.80049689540547],
              [-18.67226810955575, -10.786792001799892],
              [-18.673638322598304, -10.780046472914355],
              [-18.68694649703781, -10.77655435872067],
              [-18.694895011629345, -10.785532488896566],
              [-18.697298470188866, -10.791179417370573],
              [-18.698905042825725, -10.811239046820248],
              [-18.6980207308572, -10.82536673609125],
              [-18.705230699778674, -10.835779863396976],
              [-18.711471087766096, -10.840489589397901],
              [-18.72687059560599, -10.841212799544676],
              [-18.74151537617337, -10.833157185135663],
              [-18.745803942258334, -10.835041569462957],
              [-18.745948027439606, -10.840611135067787],
              [-18.75117821489478, -10.846494556085538],
              [-18.759544881446146, -10.850912676792461],
              [-18.77285216655039, -10.852944693512441],
              [-18.794560400632854, -10.863025468083697],
              [-18.803441201631287, -10.865613084715134],
              [-18.81107403263635, -10.869444802792014],
              [-18.830875719726546, -10.874277730313102],
              [-18.84215120194357, -10.874768176042961],
              [-18.8515837459276, -10.87718970521046],
              [-18.875836986132228, -10.879009970757002],
              [-18.897110892238473, -10.878624590287364],
              [-18.921711727816568, -10.87704157558955],
              [-18.942106503240975, -10.873921522294234],
              [-18.965878825437397, -10.866184666629833],
              [-18.969220915036217, -10.86366515269142],
              [-18.980375105903676, -10.859352033708898],
              [-18.994101034479044, -10.849699066390713],
              [-18.997987210888557, -10.842255838256227],
              [-19.000236329376413, -10.829052238066],
              [-19.00278862247155, -10.819317797770806],
              [-19.003268763857, -10.81277905288088],
              [-18.99409348647502, -10.806776819890754],
              [-18.989853263269733, -10.808374497718981],
              [-18.984093700897155, -10.806835710421524],
              [-18.98361036859402, -10.800390049115224],
              [-18.987870217784085, -10.796529965449796],
              [-18.995845916863537, -10.784347412277802],
              [-19.01398684461943, -10.771446231168449],
              [-19.017798155593976, -10.771190634976918],
              [-19.021230007396742, -10.76307798830201],
              [-19.0243869311188, -10.763423452847773],
              [-19.029600954473217, -10.749316492848331],
              [-19.037838488955423, -10.730191607111923],
              [-19.0360561367711, -10.724905767778814],
              [-19.04023195582868, -10.717885206246125],
              [-19.046775388694844, -10.714217249620226],
              [-19.05484193315102, -10.704947680484663],
              [-19.058878936699177, -10.69844866814312],
              [-19.060896035421823, -10.6842758882815],
              [-19.060065863178053, -10.677096846025119],
              [-19.063111520223217, -10.676652370404387],
              [-19.068392659988255, -10.680916800861512],
              [-19.074112803258956, -10.680019907676245],
              [-19.088676757893776, -10.674791015975147],
              [-19.09682622205596, -10.669431755107217],
              [-19.104784850114186, -10.661998002065234],
              [-19.116098525877955, -10.648206084841695],
              [-19.127334375991452, -10.629531186447426],
              [-19.131108099098796, -10.621250153206155],
              [-19.124335818024363, -10.615028091963216],
              [-19.116765634591122, -10.614791923624125],
              [-19.10662098101962, -10.608853987130102],
              [-19.10265787707923, -10.600754189328452],
              [-19.099004430582667, -10.600308424437591],
              [-19.096827540210462, -10.593928199450561],
              [-19.09816402865723, -10.589622452988602],
              [-19.113119326792006, -10.585599616471335],
              [-19.11663681130414, -10.588763722978536],
              [-19.120839360044435, -10.588558747635942],
              [-19.124840910735063, -10.592113054336735],
              [-19.131547796042096, -10.592984023430123],
              [-19.13333155356711, -10.596006128839218],
              [-19.13869147447507, -10.597918946782482],
              [-19.151532578780404, -10.597116770654834],
              [-19.156679215769135, -10.592629692481335],
              [-19.168638375067165, -10.5879264310078],
              [-19.169903448502712, -10.58018842143297],
              [-19.172085881382074, -10.578955992364886],
              [-19.172790282498596, -10.571584382251231],
              [-19.168025387935824, -10.570001291683932],
              [-19.165363888622462, -10.565162612018447],
              [-19.16045936835837, -10.56512156436967],
              [-19.150733454326613, -10.568717082861294],
              [-19.142799321655946, -10.564899351155665],
              [-19.142612613301193, -10.56026937876774],
              [-19.137502934739338, -10.55591693963477],
              [-19.1309573243132, -10.55729958686628],
              [-19.12633249032567, -10.553803750175492],
              [-19.122068888917063, -10.547247583499699],
              [-19.113188563685384, -10.546989911082683],
              [-19.110265061759133, -10.540988840069407],
              [-19.10500403545941, -10.536580327513809],
              [-19.099174444455883, -10.53817387813164],
              [-19.088934100730583, -10.531078506032388],
              [-19.087000459385568, -10.52622256050338],
              [-19.092890119844945, -10.518621905731912],
              [-19.095241114732154, -10.510329077688494],
              [-19.0944379601865, -10.503694466415034],
              [-19.088224663751834, -10.504656236684585],
              [-19.082167735200567, -10.503395256149277],
              [-19.0778032650119, -10.50025170892019],
              [-19.06788979900096, -10.496612231136604],
              [-19.06267421223287, -10.488840715756634],
              [-19.064238407445636, -10.484634325853133],
              [-19.07223451952485, -10.476989599319793],
              [-19.075229995455693, -10.47088972727875],
              [-19.074930172499517, -10.466343446881599],
              [-19.07060452380648, -10.459605267659427],
              [-19.067110392031992, -10.458133110845086],
              [-19.06702406336728, -10.451577188795296],
              [-19.071980184275315, -10.45096898662045],
              [-19.07644988815208, -10.455310963775219],
              [-19.08583967259412, -10.461662828160046],
              [-19.094191993565246, -10.460166355120016],
              [-19.10656079704881, -10.451877192262893],
              [-19.109658688019998, -10.44444719643261],
              [-19.109268583795778, -10.432425631463493],
              [-19.09898479311607, -10.424620728526392],
              [-19.094866005957574, -10.423463718516734],
              [-19.07930547055668, -10.427733362990605],
              [-19.066256304586222, -10.424369074367716],
              [-19.064414788709794, -10.409638129548732],
              [-19.069195127118054, -10.407747276109383],
              [-19.0754158072491, -10.413372082722184],
              [-19.084058959131692, -10.409326125292502],
              [-19.091982215580977, -10.401827619077844],
              [-19.093401004361503, -10.393538196596227],
              [-19.100187034508465, -10.386252593951912],
              [-19.09679418359418, -10.378368620441934],
              [-19.107377320279333, -10.374001877575731],
              [-19.115601493053322, -10.361938456397366],
              [-19.121678543142757, -10.364834683180865],
              [-19.1217402769537, -10.368150937466448],
              [-19.12838094944022, -10.378638622385951],
              [-19.13290966117825, -10.393313948621207],
              [-19.13741059414184, -10.394159791799263],
              [-19.145286217437185, -10.390960285028163],
              [-19.151650171548695, -10.390030336535643],
              [-19.160806229081455, -10.386276445352511],
              [-19.16743539318834, -10.381334094747755],
              [-19.169340137216473, -10.377876960683757],
              [-19.170586810071192, -10.3573995493409],
              [-19.167094267082355, -10.347748590183974],
              [-19.168922013503792, -10.343488389366907],
              [-19.169319878306933, -10.336121422478115],
              [-19.16789327627577, -10.33179183250613],
              [-19.16236021330736, -10.328982233212978],
              [-19.158529029613305, -10.322288081509216],
              [-19.16009246414381, -10.315223237230333],
              [-19.165225799776092, -10.318698781717556],
              [-19.166133829928725, -10.313971350567323],
              [-19.173964423149613, -10.312663444015016],
              [-19.188036525417548, -10.303218065821678],
              [-19.196637847488347, -10.302957815163019],
              [-19.20220150070166, -10.2953087799958],
              [-19.203636272329877, -10.281874334720024],
              [-19.205663837628872, -10.273046344893949],
              [-19.20325693613205, -10.263000053557478],
              [-19.19661350203869, -10.261437207767946],
              [-19.184074746293067, -10.25638521268596],
              [-19.176425356518273, -10.254636800261128],
              [-19.172202236147964, -10.247631609296553],
              [-19.172427968654688, -10.240739365199655],
              [-19.175896944767164, -10.236623297024641],
              [-19.179414841270688, -10.228215214228324],
              [-19.18507441545484, -10.227404944524377],
              [-19.193690342788, -10.219309488137784],
              [-19.198679082900433, -10.216357158869721],
              [-19.206053235312073, -10.216763370794853],
              [-19.20917461597905, -10.219917869911212],
              [-19.2230529782074, -10.220667069483738],
              [-19.228067140399673, -10.226475852269148],
              [-19.223582026455134, -10.230373860076423],
              [-19.22829226371394, -10.2327255606108],
              [-19.23498562238435, -10.224854292769724],
              [-19.234444963669567, -10.222940079527184],
              [-19.236313897710794, -10.20352769445641],
              [-19.236076671801833, -10.19637258162387],
              [-19.230768514420312, -10.182031142637362],
              [-19.2263752359269, -10.184093917098837],
              [-19.21137672163634, -10.184727777201822],
              [-19.20474040615534, -10.18320174618402],
              [-19.18573196918356, -10.181078239255562],
              [-19.171820228346725, -10.180813760122504],
              [-19.16343571658509, -10.179760265165168],
              [-19.16715238223006, -10.174946116297459],
              [-19.173290876773358, -10.174225947348686],
              [-19.1764596300415, -10.169495933506454],
              [-19.184896768691356, -10.168395466006926],
              [-19.19152143365118, -10.162555071266974],
              [-19.19048516782695, -10.158721322957096],
              [-19.19799676949592, -10.15879787119888],
              [-19.202782453411057, -10.145090943406288],
              [-19.202681076654432, -10.141743192806409],
              [-19.208652671158635, -10.129909963104428],
              [-19.206986449832957, -10.12336741004604],
              [-19.202616026866682, -10.125210718861995],
              [-19.197611864977354, -10.123668859425168],
              [-19.177964426021436, -10.123675286542746],
              [-19.170029203211175, -10.127404261461894],
              [-19.15891642285943, -10.127707052940064],
              [-19.1556229281811, -10.132905180939355],
              [-19.14681610694593, -10.125023396016342],
              [-19.132851184840657, -10.125173524685053],
              [-19.126689449108504, -10.124341858894105],
              [-19.13509105668958, -10.108397173362638],
              [-19.134592070718643, -10.104835055057492],
              [-19.139054933526715, -10.094928577203849],
              [-19.141186311893975, -10.07528426101133],
              [-19.138745722459063, -10.056907804005542],
              [-19.131172938738263, -10.04040487442404],
              [-19.127769702728624, -10.038745511786296],
              [-19.123415777474307, -10.030112090186151],
              [-19.121243856725947, -10.02912556049573],
              [-19.114882908025894, -10.018163281728688],
              [-19.11002723080377, -10.01698334542889],
              [-19.10017341508592, -10.00703204313857],
              [-19.08505471758527, -9.990525035774132],
              [-19.06928544635756, -9.976099056284784],
              [-19.054424068325382, -9.959595185869535],
              [-19.04908556699518, -9.95946793443658],
              [-19.044670732262304, -9.948894097049926],
              [-19.040021023710363, -9.942011648521797],
              [-19.03271943639655, -9.933728951031956],
              [-19.023083588115263, -9.924590881243716],
              [-19.003881971200283, -9.910972084617635],
              [-18.996869394719536, -9.906943792936561],
              [-18.989627851551855, -9.90686324347554],
              [-18.97926873589651, -9.912419238963741],
              [-18.965513143086852, -9.912779222426625],
              [-18.96300176879758, -9.917036231907781],
              [-18.969899585431456, -9.925577956537213],
              [-18.96859963581418, -9.93385661538653],
              [-18.965993608807363, -9.933651350728303],
              [-18.963125188767812, -9.925941962578309],
              [-18.95696924440341, -9.920096691493354],
              [-18.95231958555059, -9.913103049074076],
              [-18.9537679763818, -9.910356265779301],
              [-18.96107514880351, -9.90995663365757],
              [-18.963440502929988, -9.907710536568045],
              [-18.96202605358977, -9.900501573336625],
              [-18.947790800318746, -9.895209859878143],
              [-18.94736350985179, -9.88926073250137],
              [-18.951181648045665, -9.887111866506611],
              [-18.953428689293855, -9.874204761331898],
              [-18.952874772934468, -9.856418557333553],
              [-18.956356585058032, -9.849702568871265],
              [-18.95585653364293, -9.844076194589704],
              [-18.952307836354336, -9.839902587339973],
              [-18.952364190743637, -9.825653849768537],
              [-18.943562267005422, -9.822664502838595],
              [-18.949006971517775, -9.816279778698721],
              [-18.94692895364452, -9.80914144094457],
              [-18.94170307038885, -9.80071356569887],
              [-18.93541082346596, -9.78377630890048],
              [-18.930560003599503, -9.774400693778638],
              [-18.914374327760427, -9.754279281520745],
              [-18.904992511130164, -9.748714260715012],
              [-18.890509873832134, -9.752222039896711],
              [-18.886005398234563, -9.751120830316056],
              [-18.88476787731868, -9.744786479999998],
              [-18.890845164760023, -9.736461802988781],
              [-18.88677716166922, -9.73360871294858],
              [-18.88875417176192, -9.717853426517944],
              [-18.885758350170615, -9.712871933865951],
              [-18.878206921050523, -9.708571449705591],
              [-18.867389270032717, -9.699092140455411],
              [-18.856635410868897, -9.691106202814805],
              [-18.848893237559416, -9.68675152153378],
              [-18.8412879731069, -9.684125677461935],
              [-18.832691281634766, -9.68440077536337],
              [-18.81847559792826, -9.682213613252449],
              [-18.798156689184694, -9.683869313946346],
              [-18.789284737017642, -9.688750361703544],
              [-18.772181199954183, -9.702829266963837],
              [-18.76771764771072, -9.702438628811466],
              [-18.764292938442676, -9.7070427664911],
              [-18.759692727400804, -9.705441404735744],
              [-18.751373032107175, -9.708499928313227],
              [-18.752182824656067, -9.713401509288195],
              [-18.747888896438383, -9.717761196320382],
              [-18.742630806096145, -9.727495663585954],
              [-18.734290369602896, -9.738450978982844],
              [-18.73130512018404, -9.734120382802361],
              [-18.728057278826554, -9.738153598586006],
              [-18.72366996309055, -9.73940589439478],
              [-18.723016193058758, -9.74367981829649],
              [-18.726389253499878, -9.74928858719192],
              [-18.71781728190073, -9.748365688734959],
              [-18.718561850480516, -9.75229843276405],
              [-18.709137638286652, -9.759229193290306],
              [-18.702388208163836, -9.76978421039288],
              [-18.703352988660892, -9.775425205263462],
              [-18.700361435045984, -9.779720905351597],
              [-18.69119794128875, -9.776893454684737],
              [-18.661764603082723, -9.777401593928568],
              [-18.65088727669088, -9.774646143933218],
              [-18.637678525154975, -9.76001262722514],
              [-18.627777966249297, -9.756459558945473],
              [-18.616386214516922, -9.747432756785967],
              [-18.614609883129546, -9.744752850134802],
              [-18.613986902106458, -9.736414508727876],
              [-18.609558697498134, -9.730061168269401],
              [-18.600980868336038, -9.727184778661467],
              [-18.594505289706582, -9.730089594405316],
              [-18.5847673618828, -9.726646595363999],
              [-18.56962730947385, -9.711749946645577],
              [-18.560582650400768, -9.699458324466566],
              [-18.551064547543145, -9.689432772419778],
              [-18.538567188594364, -9.6729026770828],
              [-18.538773241337925, -9.670084047255305],
              [-18.529668359646283, -9.658506834950238],
              [-18.51175845984604, -9.645126200358012],
              [-18.511553078921708, -9.638220064061125],
              [-18.51543504260009, -9.625791919679507],
              [-18.50764859186252, -9.625969959961147],
              [-18.503472691669767, -9.628173028398118],
              [-18.500073324212345, -9.6339317065985],
              [-18.49553315422874, -9.631094940394437],
              [-18.492910086447647, -9.635946829669633],
              [-18.48566214660364, -9.639229592878486],
              [-18.48052567193802, -9.639585804105861],
              [-18.47836976642417, -9.646365765767433],
              [-18.472627934942416, -9.651594370849816],
              [-18.483624205571097, -9.655623374706979],
              [-18.483126693367428, -9.660197677188588],
              [-18.48726903427422, -9.667361641108434],
              [-18.479945703353348, -9.666058901198689],
              [-18.471673168024722, -9.662929698903064],
              [-18.467336866045695, -9.66873240769053],
              [-18.464402032875075, -9.662915348429049],
              [-18.45978702595492, -9.66619777318396],
              [-18.452314187680855, -9.66428088212618],
              [-18.445857938509135, -9.666208595551932],
              [-18.442598901897256, -9.6694230197885],
              [-18.432337548911566, -9.66465606318075],
              [-18.428937192274745, -9.665742424045181],
              [-18.42330757574696, -9.663024331413627],
              [-18.41481626393954, -9.66495104763366],
              [-18.406812072568755, -9.670011407796652],
              [-18.397063826880547, -9.669904321739605],
              [-18.39390182335629, -9.6644243637244],
              [-18.385159509776113, -9.670186191911776],
              [-18.374925174991752, -9.666266546661248],
              [-18.368102778980724, -9.665833750122697],
              [-18.363345355131994, -9.667522521398768],
              [-18.35161369514274, -9.663624621051468],
              [-18.344605958878603, -9.662709309515803],
              [-18.339229664130162, -9.658769771077191],
              [-18.335704036807513, -9.659462329896362],
              [-18.334056960153394, -9.650713504150694],
              [-18.328514393387806, -9.647987448407768],
              [-18.328842653882692, -9.642556656022089],
              [-18.321284439027636, -9.639154003879755],
              [-18.31712279933442, -9.63440570538932],
              [-18.311143190392794, -9.620016877277143],
              [-18.30784958622062, -9.623473369827511],
              [-18.30400295126103, -9.621316208133845],
              [-18.294475777406138, -9.611205615197358],
              [-18.28729987864852, -9.599170930800792],
              [-18.274797048403286, -9.584271820497456],
              [-18.268744826509458, -9.573450368164973],
              [-18.26711420597978, -9.56713922042595],
              [-18.26618486690055, -9.550730182806886],
              [-18.269328318062932, -9.535852378246284],
              [-18.270756357511104, -9.52420122801057],
              [-18.274112664684296, -9.510499236491398],
              [-18.28015307917532, -9.495649571632853],
              [-18.284106687836132, -9.473580609030579],
              [-18.285162947340673, -9.460681318346316],
              [-18.282932859112666, -9.450014288564654],
              [-18.28363203430128, -9.439470772914547],
              [-18.28064476119402, -9.419969114777851],
              [-18.282764021284727, -9.411838574536876],
              [-18.28680979916816, -9.404484875435344],
              [-18.302434142293638, -9.381239927000895],
              [-18.316553655291095, -9.359383839335816],
              [-18.31712060878952, -9.35585517472942],
              [-18.33839830605724, -9.341317919412974],
              [-18.338539115933024, -9.338892891815739],
              [-18.34843150660702, -9.338576627187289],
              [-18.359123683176335, -9.345638930363522],
              [-18.36045932272144, -9.339362236172228],
              [-18.35263841325626, -9.33368773455323],
              [-18.350003247561585, -9.328327513303403],
              [-18.34971514986401, -9.315743178788551],
              [-18.347404816671588, -9.30909406712451],
              [-18.34153549032024, -9.307505048284993],
              [-18.334966246297242, -9.301560530561066],
              [-18.33146885926573, -9.301279705826202],
              [-18.32826437221919, -9.306780762984022],
              [-18.310119027577166, -9.316240495020537],
              [-18.288244570870503, -9.319639343916498],
              [-18.27864171474471, -9.317357531373489],
              [-18.277592978484545, -9.31261357378884],
              [-18.284089018080312, -9.307827870568643],
              [-18.287318568058648, -9.308269442766957],
              [-18.289036183726445, -9.303060796498887],
              [-18.27744810298147, -9.304900889792682],
              [-18.26985153155954, -9.304254115140514],
              [-18.258495438863584, -9.291962475737641],
              [-18.25272518652849, -9.289789404354986],
              [-18.2420723364864, -9.28130066601349],
              [-18.240590433174017, -9.276187455791215],
              [-18.240479723334303, -9.265484667463777],
              [-18.23807982425402, -9.26011046278003],
              [-18.23699191838125, -9.246880042553622],
              [-18.243780103509437, -9.232270245623328],
              [-18.24706270239317, -9.223310499517533],
              [-18.24859753828721, -9.213201063914555],
              [-18.262936062956296, -9.204180917835668],
              [-18.27516209541487, -9.190804948603956],
              [-18.281814790712474, -9.180964600276692],
              [-18.28448029076237, -9.174144910989472],
              [-18.283611913998268, -9.16804045487012],
              [-18.288934477685384, -9.169536495913917],
              [-18.291964683966746, -9.175709137416609],
              [-18.2921990892938, -9.180427248262061],
              [-18.29548205594009, -9.184340183968269],
              [-18.3085918212999, -9.193923989675342],
              [-18.318508991989535, -9.206160775307245],
              [-18.32129623629903, -9.216818591673919],
              [-18.33493955451387, -9.221706731175084],
              [-18.344573252367397, -9.22307873830808],
              [-18.362216611186977, -9.213828418847191],
              [-18.365743005035185, -9.208557871542395],
              [-18.37448109491783, -9.213154071411877],
              [-18.396428046163443, -9.218030862811913],
              [-18.40683421346928, -9.227399948186688],
              [-18.39968961510808, -9.232110080992884],
              [-18.41029900861654, -9.23422504097599],
              [-18.4337385558118, -9.234040256493332],
              [-18.443858300983774, -9.236349769813021],
              [-18.452466054265727, -9.244239798364392],
              [-18.456554016962873, -9.256329998589386],
              [-18.462328059923088, -9.259335187174269],
              [-18.472268559612207, -9.261928089339948],
              [-18.477185636014656, -9.266227299911282],
              [-18.49214579736265, -9.27311501872653],
              [-18.499912099955957, -9.279221202881331],
              [-18.50659176919181, -9.281000448836586],
              [-18.511953879894623, -9.288639274625956],
              [-18.515936499757558, -9.296509366893057],
              [-18.519794826627837, -9.300030905153813],
              [-18.51904794530303, -9.307844615043393],
              [-18.52258349648944, -9.317568557750409],
              [-18.52636196215728, -9.321042119355598],
              [-18.526343977579522, -9.32938373209852],
              [-18.54373967968789, -9.336912680025142],
              [-18.55076902825571, -9.346084349274918],
              [-18.55456313179421, -9.343992325922558],
              [-18.554447746167813, -9.335948288266572],
              [-18.55181775761439, -9.329193734274247],
              [-18.551129691521414, -9.320208954507564],
              [-18.554080730150467, -9.307525963897708],
              [-18.55736247904808, -9.302872219521886],
              [-18.557261414403715, -9.295679506071268],
              [-18.552072007119353, -9.292949062289447],
              [-18.554386057967523, -9.285983313316265],
              [-18.56315850703323, -9.277662186084243],
              [-18.564864393128776, -9.269447982737999],
              [-18.576024501239402, -9.264619999444506],
              [-18.575772447167644, -9.258633623263835],
              [-18.577772257751487, -9.252792221217991],
              [-18.58376391866784, -9.246821075318458],
              [-18.587424150502347, -9.245967240347385],
              [-18.5924482590404, -9.238808870759366],
              [-18.588564454005436, -9.232907985362917],
              [-18.58906736191743, -9.229321669691231],
              [-18.596095561804272, -9.22909743169478],
              [-18.605011164776315, -9.226524429595187],
              [-18.607420901727004, -9.235166484999938],
              [-18.61126452757168, -9.239307061879478],
              [-18.6200395948278, -9.245175093984656],
              [-18.625277670200376, -9.24668914133685],
              [-18.618895756755332, -9.253898915211673],
              [-18.61252126195972, -9.263072920456857],
              [-18.60084944189954, -9.266643484853429],
              [-18.599229757933294, -9.275393651521293],
              [-18.595253534930734, -9.278454131046106],
              [-18.5875626124383, -9.276003203359965],
              [-18.580119591991025, -9.279535643118654],
              [-18.583190414182187, -9.285592708711302],
              [-18.58124402408415, -9.289871210836877],
              [-18.591325376866713, -9.293263300462964],
              [-18.594113476701065, -9.306050692094052],
              [-18.596696217910473, -9.311823002678256],
              [-18.603412201635525, -9.314759365991689],
              [-18.60727382636122, -9.31370037920712],
              [-18.609216670143436, -9.306873588954717],
              [-18.61576328254816, -9.293323949294422],
              [-18.615364454299645, -9.288154495774913],
              [-18.62226285686894, -9.280074638580682],
              [-18.627338023955467, -9.27860358531728],
              [-18.627281311705726, -9.27487302746067],
              [-18.632589086771173, -9.269249395419513],
              [-18.650059683204965, -9.25580598739736],
              [-18.662019256718892, -9.248713688899311],
              [-18.672141907209078, -9.245448060333036],
              [-18.68275948114625, -9.244745688376286],
              [-18.690860364554478, -9.240616200602307],
              [-18.702748928585066, -9.239305659223122],
              [-18.70790580626513, -9.243332658192807],
              [-18.713197881056118, -9.241248561573997],
              [-18.718805905375767, -9.244407565185108],
              [-18.730555372452127, -9.239409387160782],
              [-18.747195005492717, -9.235495696438548],
              [-18.767551272716144, -9.233724964413481],
              [-18.781164888825007, -9.235353216006793],
              [-18.804480292351155, -9.242643689376834],
              [-18.835390808035072, -9.254273526212096],
              [-18.840824193157122, -9.257281467354517],
              [-18.85254811304498, -9.26083460529458],
              [-18.864081341246045, -9.260696815370892],
              [-18.87509060402067, -9.258619551511954],
              [-18.878863707363863, -9.260412203596069],
              [-18.902768422006453, -9.245779297845028],
              [-18.933501506154283, -9.229621763281866],
              [-18.948352692668998, -9.22305056718119],
              [-18.97117818806802, -9.211806911968234],
              [-18.9902030963844, -9.204433913744428],
              [-18.99708619851789, -9.203039792510827],
              [-19.023824799443474, -9.190050134535053],
              [-19.04888822071154, -9.179225738427055],
              [-19.054741999541076, -9.174356051347765],
              [-19.063026583501635, -9.163431851599324],
              [-19.07073511576585, -9.154815029911154],
              [-19.072459080292713, -9.15094814887011],
              [-19.07533984268349, -9.136704426926554],
              [-19.077549256090347, -9.119711521016033],
              [-19.07408601991737, -9.111191070865578],
              [-19.073110046641567, -9.099185100094463],
              [-19.065295468794552, -9.096963306303696],
              [-19.061136167816827, -9.091112555949001],
              [-19.058738364969134, -9.07983547818434],
              [-19.05962950208422, -9.072323662344807],
              [-19.062919356100696, -9.06359596341248],
              [-19.067765617942634, -9.054832042202252],
              [-19.07312587300154, -9.047851268479983],
              [-19.09188805279678, -9.029216046102473],
              [-19.09307950526933, -9.024975603601037],
              [-19.088767799093244, -9.017230017988682],
              [-19.089975904884085, -9.010240127848853],
              [-19.094403629413076, -9.003446316454479],
              [-19.105469596189682, -8.993116620744944],
              [-19.10925343293224, -8.98803882224252],
              [-19.116892026667664, -8.968500246111256],
              [-19.117638821418844, -8.960417751397733],
              [-19.105367248822777, -8.93475387835504],
              [-19.09761915488302, -8.925065620694603],
              [-19.095261860853576, -8.931247057655083],
              [-19.097412435760855, -8.936454564324281],
              [-19.106975242047785, -8.940669699311728],
              [-19.11500967283706, -8.955872993088356],
              [-19.113127549494955, -8.965482491472043],
              [-19.11445414312147, -8.967845595507637],
              [-19.103131637240278, -8.976839279328635],
              [-19.103287416889284, -8.979173403756977],
              [-19.086604498543455, -8.986863740646521],
              [-19.077124334100862, -8.987642815126614],
              [-19.065404419704848, -8.985387524955172],
              [-19.061501948593552, -8.981060444413366],
              [-19.054348555392217, -8.977555786940018],
              [-19.046642753797112, -8.970358430385438],
              [-19.045388702019608, -8.954196864196595],
              [-19.040800007073553, -8.950063664070491],
              [-19.03022530458709, -8.946247284251843],
              [-19.02329084610327, -8.939530968163368],
              [-19.024428172980606, -8.934997943805753],
              [-19.030826997542537, -8.924935610805072],
              [-19.03681310894509, -8.919356817121358],
              [-19.04407958286339, -8.914817951622476],
              [-19.05491661187262, -8.91261236998178],
              [-19.059422866454817, -8.914977666329733],
              [-19.06897945175962, -8.912518453658366],
              [-19.087545492282224, -8.903463588801849],
              [-19.09937770161683, -8.893409454209188],
              [-19.116354460100887, -8.883285756056887],
              [-19.129842073155352, -8.879736871101874],
              [-19.138495652335802, -8.875112199593183],
              [-19.14790808788344, -8.873339825229088],
              [-19.166234839679706, -8.867355408897613],
              [-19.174476953907103, -8.86131246251848],
              [-19.182900218345715, -8.851379602815749],
              [-19.1913890705815, -8.843925606059651],
              [-19.191882091545153, -8.839469304848478],
              [-19.20247874250859, -8.825466115210144],
              [-19.21818076331811, -8.813402034856681],
              [-19.21955215904603, -8.807866242196232],
              [-19.228754520041445, -8.801328245258688],
              [-19.23774105721991, -8.797676138975351],
              [-19.24848118366081, -8.78872058077514],
              [-19.250344265771346, -8.782024310471208],
              [-19.248855063048698, -8.77942561763847],
              [-19.25127988396267, -8.770603219163798],
              [-19.2504021264595, -8.76325701506927]
            ]
          ],
          [
            [
              [-19.359336656987743, -8.700287425045634],
              [-19.35093246068774, -8.698383688711763],
              [-19.35225605854221, -8.707006750268944],
              [-19.35900761596902, -8.704928241847789],
              [-19.359336656987743, -8.700287425045634]
            ]
          ],
          [
            [
              [-20.405442972483616, -13.032940708676412],
              [-20.402979082809097, -13.030415570724523],
              [-20.394138235161176, -13.03045323929257],
              [-20.38942520105327, -13.025078761321328],
              [-20.39199363325675, -13.02074717016014],
              [-20.375415157310105, -13.022238985708638],
              [-20.370242820273226, -13.020794081879998],
              [-20.365738982178353, -13.014823566100075],
              [-20.36872942088238, -13.009206837858947],
              [-20.364171471180875, -13.002229230307606],
              [-20.35579722972819, -13.006669043372614],
              [-20.341204344582852, -13.001395379578387],
              [-20.341900933263013, -12.996872898360039],
              [-20.340951933033537, -12.983661954957121],
              [-20.324252819178703, -12.97893269141551],
              [-20.31558722778131, -12.968639149102554],
              [-20.312714859760018, -12.960136506576701],
              [-20.318965257047402, -12.953656201709746],
              [-20.31858813348714, -12.94938601771467],
              [-20.315254315605937, -12.94564525920531],
              [-20.31606290219625, -12.94205989602188],
              [-20.31315399372665, -12.93815307761623],
              [-20.30690340202039, -12.934312992481146],
              [-20.306306394692502, -12.930966238716595],
              [-20.296322086441585, -12.92447201667053],
              [-20.29253002883163, -12.924684174421856],
              [-20.287448881622204, -12.921083244101967],
              [-20.2860955045998, -12.917658249898126],
              [-20.280493166396475, -12.918884955600491],
              [-20.26950049010029, -12.910895823696935],
              [-20.267318978344633, -12.906290880926624],
              [-20.261994461882445, -12.908144517756645],
              [-20.25998673366353, -12.912323137246696],
              [-20.25304704081329, -12.917299351554831],
              [-20.247909089678522, -12.91729736222202],
              [-20.241496522974053, -12.914608296847696],
              [-20.24038763540148, -12.91152849662861],
              [-20.234094420722226, -12.913282612246013],
              [-20.232638910267518, -12.920382941633513],
              [-20.220753414813288, -12.920014307885126],
              [-20.21790404458068, -12.924141842298788],
              [-20.212806665863734, -12.921468480906865],
              [-20.209938010478847, -12.910992537551413],
              [-20.215074401755473, -12.910685134735877],
              [-20.21416834648612, -12.902367717325351],
              [-20.225883922612276, -12.897328874982163],
              [-20.221245183581804, -12.893169634340511],
              [-20.212252603137443, -12.880097470100742],
              [-20.214941913611685, -12.87430810033678],
              [-20.213699120274022, -12.865883450132486],
              [-20.210191517255804, -12.864094191310231],
              [-20.196996324225804, -12.85224373772722],
              [-20.183976446729574, -12.848207808652566],
              [-20.17178128503803, -12.8406533392163],
              [-20.17064641769305, -12.83829662454805],
              [-20.150838229636943, -12.836998931221007],
              [-20.138218315241616, -12.83412007904173],
              [-20.133674328269986, -12.83728660248593],
              [-20.127682679157832, -12.837680488262981],
              [-20.121424829742306, -12.835128609349635],
              [-20.115986629790505, -12.837688329864609],
              [-20.113195796236845, -12.842054625349817],
              [-20.113376123053904, -12.848434303012137],
              [-20.104076437621085, -12.85422566316035],
              [-20.095183665400356, -12.85690110350558],
              [-20.080639119294425, -12.859331144888504],
              [-20.08079674952129, -12.866626417323333],
              [-20.086426425063163, -12.873908044998636],
              [-20.09880011634708, -12.881255450378605],
              [-20.100341108816014, -12.888351765393352],
              [-20.098561905460002, -12.89384421232833],
              [-20.100569608680818, -12.902279563883138],
              [-20.107633292680458, -12.905655718253804],
              [-20.113698049023554, -12.906646220242985],
              [-20.1166324630023, -12.909838526728246],
              [-20.124515052180065, -12.910745377878909],
              [-20.13257992461456, -12.913166735196281],
              [-20.13833635716147, -12.917351046051792],
              [-20.151352534454126, -12.921499814574018],
              [-20.163175031217293, -12.923196818934157],
              [-20.165657320608823, -12.92715150071941],
              [-20.182377615202267, -12.928671390000261],
              [-20.199194068009618, -12.931937071287207],
              [-20.205409595480553, -12.936868564093285],
              [-20.214731531653047, -12.941720062879735],
              [-20.213112229400473, -12.945437724958287],
              [-20.218369945630332, -12.947885088784222],
              [-20.218963940969246, -12.952570258518277],
              [-20.22378686079481, -12.95193539785472],
              [-20.227250876151842, -12.960028185686282],
              [-20.225892284926147, -12.963546660438881],
              [-20.23327248387142, -12.965590458402735],
              [-20.239454004998247, -12.970026034582675],
              [-20.24860075760085, -12.979143352813017],
              [-20.25196944151569, -12.985841175028837],
              [-20.257995573155643, -12.986929422481845],
              [-20.26399320023951, -12.986080691335953],
              [-20.266407621851293, -12.988668918829761],
              [-20.280602362533134, -12.988923911253938],
              [-20.29354918812875, -13.000278528742966],
              [-20.29922455142019, -13.002902711261507],
              [-20.312370507675542, -13.004736228560287],
              [-20.315119668320374, -13.010494808378542],
              [-20.32307492232173, -13.004452993555578],
              [-20.327192328196396, -13.006090839997713],
              [-20.328011506284412, -13.012724943973502],
              [-20.32367733706633, -13.017275435319675],
              [-20.324341044034604, -13.02124982062857],
              [-20.330845668611047, -13.02081574814602],
              [-20.33329398247914, -13.01348171893766],
              [-20.339976686308567, -13.01570080691606],
              [-20.344780340393598, -13.01461209890853],
              [-20.349086389072855, -13.018129418999122],
              [-20.36921908819696, -13.025449780099581],
              [-20.3751772965884, -13.026495357735966],
              [-20.383948275714598, -13.02400551537722],
              [-20.389999327523007, -13.028379068595488],
              [-20.3914404622779, -13.032937480127108],
              [-20.399213058899548, -13.031339362788895],
              [-20.405442972483616, -13.032940708676412]
            ]
          ],
          [
            [
              [-20.43979286989935, -13.045698806279226],
              [-20.42704160685013, -13.039769233527933],
              [-20.41894744433372, -13.037342721089278],
              [-20.415117192658673, -13.03898677740699],
              [-20.42608368058623, -13.044325378736005],
              [-20.43979286989935, -13.045698806279226]
            ]
          ],
          [
            [
              [-20.52596340968961, -12.949231583970267],
              [-20.521086337534957, -12.943423461085427],
              [-20.51993515477088, -12.937115243060381],
              [-20.514866342880154, -12.937808314012774],
              [-20.51063375422094, -12.935202210728905],
              [-20.50490091907713, -12.935497982655068],
              [-20.5030530636864, -12.939931028551348],
              [-20.50455980834891, -12.94582980085104],
              [-20.508790247706003, -12.94989118430178],
              [-20.514671219579252, -12.960725538018876],
              [-20.520833915213622, -12.963059288812982],
              [-20.524624782472337, -12.959988118784798],
              [-20.52596340968961, -12.949231583970267]
            ]
          ],
          [
            [
              [-20.23162141541906, -11.741644652953227],
              [-20.2261450683819, -11.742596356157106],
              [-20.20774838820046, -11.75111729592991],
              [-20.19979000536009, -11.752108802914703],
              [-20.19515779398252, -11.754787132221336],
              [-20.178368760299445, -11.757135829491931],
              [-20.173273399921015, -11.762567327202849],
              [-20.1812660295119, -11.769068802610287],
              [-20.18864746238949, -11.769544141530062],
              [-20.194863931602075, -11.776714533089363],
              [-20.198984497705403, -11.778456956152324],
              [-20.20969217995271, -11.773819440534156],
              [-20.214627185526012, -11.767548251353848],
              [-20.213940223349667, -11.759386987226282],
              [-20.22064745493351, -11.754431305325891],
              [-20.226462957356766, -11.752548656017996],
              [-20.23162141541906, -11.741644652953227]
            ]
          ],
          [
            [
              [-20.527248820489877, -12.92271204709844],
              [-20.51855780373626, -12.91596755743585],
              [-20.514797963418335, -12.9241995562905],
              [-20.517630240656793, -12.928756434040604],
              [-20.527248820489877, -12.92271204709844]
            ]
          ],
          [
            [
              [-20.589413415582136, -12.986848861044736],
              [-20.58252612946254, -12.979503194175269],
              [-20.57383659119688, -12.980022390779633],
              [-20.562719154172655, -12.986787920739639],
              [-20.55777237833096, -12.986506610836857],
              [-20.5568006434277, -12.97950773168825],
              [-20.552550239363, -12.978057181477103],
              [-20.546485273210095, -12.980547593480722],
              [-20.53891096368757, -12.980933061958332],
              [-20.538546676005804, -12.97800910271115],
              [-20.529943012309698, -12.980288565514048],
              [-20.521781138694628, -12.984564742490987],
              [-20.520555781579816, -12.989667554802791],
              [-20.51681945994353, -12.990693987488438],
              [-20.5186388871323, -12.998696730403061],
              [-20.52326757688431, -13.00253041637795],
              [-20.520824067239765, -13.006919034963836],
              [-20.53055776774293, -13.011867516818338],
              [-20.52969543750791, -13.019506629069987],
              [-20.53765666155363, -13.019143451665176],
              [-20.538295164437336, -13.011454556256346],
              [-20.54389661978357, -13.005159981604411],
              [-20.548151798446376, -13.005360961167343],
              [-20.55413398621937, -13.001031415237176],
              [-20.558163761004135, -12.995755647198173],
              [-20.574826941238857, -13.00526588073102],
              [-20.580510786284705, -13.004514052326108],
              [-20.58506311035574, -13.000711134725897],
              [-20.58873313797161, -12.994653691293745],
              [-20.589413415582136, -12.986848861044736]
            ]
          ],
          [
            [
              [-20.60647582391646, -12.95893221776587],
              [-20.601025749410425, -12.957685792925222],
              [-20.59760527099163, -12.952987874290859],
              [-20.59084049201317, -12.954514974680036],
              [-20.583266044882215, -12.958992183258273],
              [-20.580371666296728, -12.963750253938287],
              [-20.584434843932648, -12.972667642016049],
              [-20.59456949971012, -12.975611778249194],
              [-20.602522135412567, -12.970332875235975],
              [-20.60647582391646, -12.95893221776587]
            ]
          ],
          [
            [
              [-20.634022587216265, -13.013626912989803],
              [-20.631504233675564, -13.011515021121456],
              [-20.63091284956006, -13.004704917771132],
              [-20.62603499835539, -12.998230354044644],
              [-20.626534739733792, -12.995088274034616],
              [-20.61403490038515, -12.996044822753925],
              [-20.61193553170861, -13.00047668051511],
              [-20.60309740822873, -13.005421484698102],
              [-20.6063114769146, -13.01421560733949],
              [-20.61243534975283, -13.020098307645345],
              [-20.622124652313815, -13.01907397184589],
              [-20.634022587216265, -13.013626912989803]
            ]
          ],
          [
            [
              [-20.303043460983417, -11.530581954936],
              [-20.299594003764327, -11.520792398113347],
              [-20.293086851017165, -11.516945127245153],
              [-20.28895537657161, -11.519446983628335],
              [-20.27631876430976, -11.516875137091098],
              [-20.273669377688012, -11.520284797678126],
              [-20.26407725757694, -11.522815280095784],
              [-20.248352519068092, -11.521610352890825],
              [-20.244466802585972, -11.522167334343346],
              [-20.25215185001019, -11.531948176365727],
              [-20.25369242003138, -11.537937468715118],
              [-20.257494999375158, -11.541507840821842],
              [-20.266072675938883, -11.544873627667938],
              [-20.274249006485014, -11.545182380463537],
              [-20.275497614910464, -11.548623713627396],
              [-20.281756130239394, -11.550038658870646],
              [-20.27999742211075, -11.5425178067359],
              [-20.28173381011301, -11.538870791818074],
              [-20.288120801044904, -11.53798680182386],
              [-20.303043460983417, -11.530581954936]
            ]
          ],
          [
            [
              [-20.784061529187756, -13.033585837205456],
              [-20.77513729810166, -13.01815230423709],
              [-20.7729601494745, -13.010548821549369],
              [-20.763222899596116, -13.011127988847486],
              [-20.758067057038264, -13.009438313010875],
              [-20.753889719243507, -13.002343054268616],
              [-20.749544773086836, -12.999944168101552],
              [-20.742894514274436, -13.002469030109724],
              [-20.73515310934224, -12.997075993352917],
              [-20.722593699438992, -13.003742999432445],
              [-20.716517368297858, -13.010861237608731],
              [-20.71961685156962, -13.02171820780994],
              [-20.723036052320932, -13.023195590066559],
              [-20.732221391145195, -13.03249811712574],
              [-20.74339420282211, -13.031586082900002],
              [-20.747758581112734, -13.028673037841195],
              [-20.75283741457982, -13.028870838702792],
              [-20.760070738594887, -13.031666833621385],
              [-20.762796550957198, -13.0352389644847],
              [-20.768233892271034, -13.037167380903837],
              [-20.775821132812975, -13.042052443046153],
              [-20.779610292023456, -13.035976423102097],
              [-20.784061529187756, -13.033585837205456]
            ]
          ],
          [
            [
              [-20.853274765889516, -13.015622124775307],
              [-20.848139734092346, -13.0112089155928],
              [-20.84323956197975, -13.00978047729784],
              [-20.839615033170837, -13.012285121999444],
              [-20.841992000586508, -13.020099323340114],
              [-20.853274765889516, -13.015622124775307]
            ]
          ],
          [
            [
              [-20.888756862466966, -13.034493951236334],
              [-20.88643621095662, -13.029094076618007],
              [-20.88143484076676, -13.024850197104389],
              [-20.871224684866498, -13.02231230023973],
              [-20.86303474940208, -13.03703553434434],
              [-20.868578213355903, -13.043487361385806],
              [-20.876363206384173, -13.048292967126482],
              [-20.882196343708948, -13.047087694116046],
              [-20.884262327860633, -13.043854398732554],
              [-20.88919861246072, -13.043030943848315],
              [-20.888756862466966, -13.034493951236334]
            ]
          ],
          [
            [
              [-19.974289903233974, -9.35709177796794],
              [-19.971495718014754, -9.34996992995388],
              [-19.96892062418189, -9.348309727999473],
              [-19.966939226320907, -9.335425880377096],
              [-19.96297747599019, -9.326854665784744],
              [-19.95419763344804, -9.317323645457511],
              [-19.9505536716771, -9.31095833624182],
              [-19.945150885041347, -9.308708314308037],
              [-19.941570619452996, -9.30282457447114],
              [-19.941963539754006, -9.294057679115527],
              [-19.939114513127954, -9.288327213918123],
              [-19.933403396771443, -9.281750379425855],
              [-19.930790135137663, -9.262431967946632],
              [-19.921501986349337, -9.263768791308568],
              [-19.917125837062432, -9.271197910694388],
              [-19.917575018685422, -9.277521753650614],
              [-19.920901258253835, -9.280474884981503],
              [-19.924127364571763, -9.290929518429209],
              [-19.923471364543595, -9.297261976992536],
              [-19.919370615055204, -9.303424673073863],
              [-19.91292812278481, -9.309834333118548],
              [-19.889329994411234, -9.328540569682998],
              [-19.873369985257657, -9.338981978854997],
              [-19.868134620798788, -9.341374575823757],
              [-19.844673706657655, -9.357732663516648],
              [-19.831428127474123, -9.364519126229023],
              [-19.824639351167722, -9.365848300399698],
              [-19.821190908642347, -9.363480643998505],
              [-19.81356875022913, -9.361916957137879],
              [-19.80959898425033, -9.358851289200867],
              [-19.796093362935615, -9.353836424288673],
              [-19.787175267253577, -9.347954523800938],
              [-19.7810202536426, -9.347251792139229],
              [-19.778174581955508, -9.344053552966198],
              [-19.769710478803688, -9.347920576367459],
              [-19.76259955681993, -9.348202340922708],
              [-19.760055285433516, -9.343195526232076],
              [-19.74945447820195, -9.340359193296695],
              [-19.741904814378092, -9.345851960391473],
              [-19.73132485357883, -9.349308004312071],
              [-19.72236313112417, -9.350623755074775],
              [-19.718057952048344, -9.36029428820503],
              [-19.713108351727225, -9.364896973573778],
              [-19.71320660633565, -9.370553982820251],
              [-19.70813955651739, -9.378647676694058],
              [-19.701675281423025, -9.381207222685102],
              [-19.698862664090196, -9.392289072632705],
              [-19.699814831248233, -9.400200120735423],
              [-19.698675011424836, -9.404777493298443],
              [-19.70129805638132, -9.407346715138129],
              [-19.698873664427676, -9.415637986480013],
              [-19.703581171706805, -9.423032271459837],
              [-19.7005462601209, -9.429214320757307],
              [-19.693551085618992, -9.434843568054879],
              [-19.691483672691625, -9.434511436590897],
              [-19.68152260055571, -9.443609338423911],
              [-19.678473611538912, -9.448580161382164],
              [-19.66204968241127, -9.456029943578715],
              [-19.647233992868095, -9.460723135545361],
              [-19.64515483468584, -9.46473411442169],
              [-19.63744282078196, -9.473253986091828],
              [-19.638443133510734, -9.478016923181606],
              [-19.636341043567434, -9.483550646378186],
              [-19.6281909081578, -9.48955662273026],
              [-19.61574133657448, -9.494890304800677],
              [-19.601940046319694, -9.49858784813061],
              [-19.59510274652162, -9.50312299208294],
              [-19.582031541879424, -9.507834827477765],
              [-19.56832214761175, -9.511310211040588],
              [-19.563193551900447, -9.511114658494074],
              [-19.54642550481303, -9.517374226995072],
              [-19.54439738550126, -9.520822893651275],
              [-19.53817469113868, -9.521011862469278],
              [-19.52918628177315, -9.530259586464219],
              [-19.51231995226721, -9.53738785708135],
              [-19.511263978900654, -9.53962927484528],
              [-19.51743322574332, -9.546217780522374],
              [-19.52192805340226, -9.560475811616907],
              [-19.52628209284615, -9.563011444746923],
              [-19.534486698382846, -9.573826428207],
              [-19.543212076724874, -9.580551119466092],
              [-19.552049938542382, -9.583710456422958],
              [-19.561723200033953, -9.576350970268086],
              [-19.563656949653307, -9.573590942132062],
              [-19.5722513409386, -9.56875000578437],
              [-19.58490968367903, -9.564383240390464],
              [-19.60214550018551, -9.56199587184658],
              [-19.617251566156447, -9.562436578084112],
              [-19.628694917027232, -9.564741478650271],
              [-19.63268772532689, -9.571448239423445],
              [-19.64364197699427, -9.578218218557558],
              [-19.649290683590607, -9.578923953021308],
              [-19.65929457136777, -9.584383437043241],
              [-19.669097638540364, -9.597096291714896],
              [-19.66814675803833, -9.606911127706942],
              [-19.665911622888917, -9.616727828507381],
              [-19.67701993056676, -9.616187504969133],
              [-19.682684800174805, -9.620192356251],
              [-19.686569003197192, -9.626428054013894],
              [-19.695514924317813, -9.619189711493108],
              [-19.70198261437696, -9.615649839866158],
              [-19.703235039408035, -9.61300481592999],
              [-19.698373767091354, -9.606782229072184],
              [-19.70148657544087, -9.598932017871425],
              [-19.699879534812855, -9.59301838013515],
              [-19.70058710217721, -9.584867891760968],
              [-19.703565294455654, -9.572921401635892],
              [-19.707800427835686, -9.562673037072571],
              [-19.71478751523927, -9.553449186539675],
              [-19.718927965081996, -9.545867883016617],
              [-19.725146276644463, -9.543712525996966],
              [-19.7285905503195, -9.537253638140761],
              [-19.72798804526179, -9.534532228897726],
              [-19.733540207779747, -9.529588292158136],
              [-19.740920826415284, -9.525494294611994],
              [-19.745288985523416, -9.526146215585701],
              [-19.753582156732655, -9.52338635403535],
              [-19.762664618105045, -9.515376771060426],
              [-19.76199603440123, -9.504690117951725],
              [-19.767048711070277, -9.484893684326293],
              [-19.775640502136252, -9.469151984075156],
              [-19.783731341657646, -9.458753699614428],
              [-19.79293069212342, -9.449442700001198],
              [-19.802119055040112, -9.443551192728286],
              [-19.83321476103255, -9.420199705624196],
              [-19.84252502677103, -9.41533859617682],
              [-19.86093217534683, -9.409484135208478],
              [-19.86831819393999, -9.408671206185627],
              [-19.878594539728564, -9.41319257556506],
              [-19.891333003809155, -9.41294959024709],
              [-19.899589689991906, -9.4153205114175],
              [-19.900633656189264, -9.422753795625926],
              [-19.90669686828277, -9.42509196116023],
              [-19.90861867988352, -9.428635080999003],
              [-19.914295183774637, -9.4276738095384],
              [-19.92941022813218, -9.433464751651156],
              [-19.93895286407689, -9.423889357609287],
              [-19.944737272044655, -9.425560711700532],
              [-19.945252269542767, -9.4185756868861],
              [-19.95019631232647, -9.417751025652866],
              [-19.963668608586353, -9.403656055992549],
              [-19.968739149004072, -9.4023272521484],
              [-19.969281793094115, -9.393581703129945],
              [-19.97539544336723, -9.374707914594822],
              [-19.97304664850203, -9.368213639884065],
              [-19.974289903233974, -9.35709177796794]
            ]
          ],
          [
            [
              [-21.18080378649944, -13.030075811395117],
              [-21.175318862717663, -13.021237652590862],
              [-21.169731163236364, -13.018696469748958],
              [-21.16082096823563, -13.008207589814518],
              [-21.14209161030838, -13.00569358256328],
              [-21.13764766527533, -13.00211339381936],
              [-21.12864065816323, -13.002132085158513],
              [-21.12278901560638, -13.003781212839636],
              [-21.123805822680172, -13.008262944307324],
              [-21.119054437872006, -13.013421451490775],
              [-21.108375971656923, -13.016807132170634],
              [-21.105340792034546, -13.021690937297322],
              [-21.106616879317045, -13.028461605574583],
              [-21.11109252484153, -13.033276655191319],
              [-21.116619189742927, -13.033572351759837],
              [-21.129077945669643, -13.036872722577815],
              [-21.134580064620046, -13.041250354079331],
              [-21.14069472378038, -13.036986969363216],
              [-21.148761038307356, -13.040931623032032],
              [-21.157194952397244, -13.039224727363328],
              [-21.163056578498935, -13.04360034779489],
              [-21.165762018740192, -13.039684562128004],
              [-21.17084571027918, -13.039059411744594],
              [-21.17940963557379, -13.035709091934374],
              [-21.18080378649944, -13.030075811395117]
            ]
          ],
          [
            [
              [-20.453409974865657, -10.296080802715684],
              [-20.444960553671706, -10.282221364282057],
              [-20.44372387504182, -10.277526851870528],
              [-20.437725255019046, -10.277202610305139],
              [-20.430294214984958, -10.273209744665953],
              [-20.42460530774618, -10.267074572229845],
              [-20.418436123324128, -10.269273902476664],
              [-20.419899459213106, -10.274905025203443],
              [-20.425736846482245, -10.282686822710893],
              [-20.424070615577882, -10.29263808771917],
              [-20.4246843751254, -10.298273830426313],
              [-20.42324769947975, -10.304881193270383],
              [-20.41882722431588, -10.312768795172142],
              [-20.41424713200899, -10.318129221691315],
              [-20.4110362162952, -10.326555543472088],
              [-20.400235738260577, -10.339889456140318],
              [-20.390558062722082, -10.349433778375547],
              [-20.38893343329728, -10.35246944029418],
              [-20.37725664028821, -10.360919597346424],
              [-20.363277486573708, -10.364850049655871],
              [-20.359660746903653, -10.36236091768469],
              [-20.352056233634954, -10.36727390675662],
              [-20.35293535320374, -10.369138267546203],
              [-20.347998343006186, -10.378748438756705],
              [-20.337519952828384, -10.393742949705043],
              [-20.331961445443092, -10.398748156874563],
              [-20.33944844951452, -10.402253465174535],
              [-20.346239171635794, -10.401086650496518],
              [-20.348486082441696, -10.388877574570767],
              [-20.361681866599728, -10.38215055248575],
              [-20.37698008814295, -10.378280241598492],
              [-20.384009226300407, -10.379853222586979],
              [-20.39474669971887, -10.379782749000507],
              [-20.3982685659841, -10.37226874601073],
              [-20.41207374892019, -10.358827501831719],
              [-20.41581996372937, -10.347231138388743],
              [-20.41920320010221, -10.34237602276403],
              [-20.425519658388822, -10.329456354762968],
              [-20.430898854252998, -10.321323712714324],
              [-20.43435316451432, -10.31104480320471],
              [-20.442341438154273, -10.307008400629012],
              [-20.446467919998568, -10.301595576106406],
              [-20.45256912591201, -10.299235685538816],
              [-20.453409974865657, -10.296080802715684]
            ]
          ],
          [
            [
              [-20.447039716770437, -10.240696817777403],
              [-20.43885015006322, -10.230491953499335],
              [-20.434450484411016, -10.231897008120256],
              [-20.438468029360376, -10.248817987699478],
              [-20.443372962432612, -10.247518460358096],
              [-20.447039716770437, -10.240696817777403]
            ]
          ],
          [
            [
              [-21.488262532108433, -12.99006541247948],
              [-21.472661030398346, -12.996398738664995],
              [-21.466199843490614, -12.998039051914807],
              [-21.452893346021526, -12.997900639367503],
              [-21.458364901120877, -13.005844995992604],
              [-21.44421743589217, -13.0084889287193],
              [-21.44200756909406, -13.012883705607091],
              [-21.435693021764045, -13.012441963073956],
              [-21.429980683827385, -13.007259079946378],
              [-21.41687229685517, -13.010446011178631],
              [-21.401474048468977, -13.010935318151267],
              [-21.398207986473498, -13.009575560302165],
              [-21.39141358398777, -13.011330631161506],
              [-21.390043026213224, -13.014841064764248],
              [-21.385533611228436, -13.01705416431268],
              [-21.3772775591313, -13.013077773890577],
              [-21.375927695634985, -13.01942412191143],
              [-21.38414236468863, -13.024813865647664],
              [-21.379093896406015, -13.027545897143833],
              [-21.379825103436872, -13.032144217518347],
              [-21.37576640658497, -13.033236594081739],
              [-21.37052722796665, -13.029654946652087],
              [-21.36712743478181, -13.035467313038378],
              [-21.358174699019138, -13.039284981044709],
              [-21.353717857438244, -13.039607480416144],
              [-21.347158684022336, -13.04354382558479],
              [-21.33579210612116, -13.045619230947157],
              [-21.329294927196347, -13.044873735156166],
              [-21.324739867715024, -13.04749049589074],
              [-21.322322072087946, -13.052018781189068],
              [-21.311346084677176, -13.049928105564248],
              [-21.305221361863836, -13.054077179909479],
              [-21.30346806504447, -13.05975244930985],
              [-21.297984712422394, -13.054048319415681],
              [-21.296182021594348, -13.057099935380808],
              [-21.28908428259936, -13.061055883791035],
              [-21.279518216630333, -13.062874932674307],
              [-21.274018051775315, -13.06610495494455],
              [-21.274582038897798, -13.06868119167113],
              [-21.280656611896116, -13.07071141595466],
              [-21.29624922079588, -13.065608123630362],
              [-21.3088503675967, -13.068280670593602],
              [-21.31934631491787, -13.065605750443725],
              [-21.32192886029761, -13.062477238812686],
              [-21.327751648853226, -13.063633151787904],
              [-21.334775715689293, -13.06117748044758],
              [-21.339756063807155, -13.061849766422368],
              [-21.349859052273796, -13.05911018923974],
              [-21.35718853489234, -13.06147315020392],
              [-21.377965858329596, -13.053305839554842],
              [-21.382126957584006, -13.055812485595125],
              [-21.391438828203096, -13.054311622439933],
              [-21.394584165207878, -13.055612934307712],
              [-21.397607294850427, -13.04771965979714],
              [-21.40198674949206, -13.043157948386579],
              [-21.406626601928924, -13.043908627012346],
              [-21.413675699209346, -13.037928244689605],
              [-21.417775993287112, -13.039353987628894],
              [-21.42267473124429, -13.035095880566306],
              [-21.43383740546659, -13.03555434612098],
              [-21.440471907006472, -13.032378278322431],
              [-21.452581506104103, -13.032747080949367],
              [-21.45946961159887, -13.025955113276474],
              [-21.47169360491888, -13.021755203210851],
              [-21.472220705154253, -13.01495104859263],
              [-21.476399236426417, -13.00206395429651],
              [-21.48347392807112, -13.00199870513469],
              [-21.488262532108433, -12.99006541247948]
            ]
          ],
          [
            [
              [-21.76469675987825, -12.94146861796259],
              [-21.76061780337985, -12.941587820205283],
              [-21.75647566477451, -12.94549356590131],
              [-21.74512206788287, -12.941110631385035],
              [-21.743675546810984, -12.944662792685186],
              [-21.737914466378633, -12.946678083876675],
              [-21.729755478982504, -12.941779705100394],
              [-21.716994611713844, -12.944210042442787],
              [-21.71233241400339, -12.953802454985603],
              [-21.701091266350982, -12.949826326850982],
              [-21.694887435944345, -12.944082786279381],
              [-21.689842354507, -12.945797405284221],
              [-21.688304776978818, -12.952811269228182],
              [-21.671508372137044, -12.94573928883466],
              [-21.67006123575882, -12.941089857010766],
              [-21.6643056522938, -12.940988464680206],
              [-21.66202485884769, -12.946767610829315],
              [-21.6572468374976, -12.947655747890995],
              [-21.654209760248502, -12.952473771713253],
              [-21.64822157164208, -12.952646367142242],
              [-21.642144065961215, -12.956283982636522],
              [-21.634734955196258, -12.957211239934072],
              [-21.631876117396747, -12.954933487419291],
              [-21.632232013204263, -12.949821908569172],
              [-21.62641713913039, -12.95066197254145],
              [-21.622905354839585, -12.956346885871092],
              [-21.6185817375795, -12.958275912614436],
              [-21.608632812275843, -12.958841566557274],
              [-21.601250886211243, -12.958026807906945],
              [-21.597809288104845, -12.951819333004789],
              [-21.59292624032444, -12.956463524919144],
              [-21.582229982210666, -12.958987857337391],
              [-21.579916990401912, -12.955704350104677],
              [-21.587408693080977, -12.953269005549759],
              [-21.588727552964, -12.9433463135197],
              [-21.585867628342882, -12.942418850348078],
              [-21.5781005003384, -12.947772238957137],
              [-21.57156680526432, -12.9458028531083],
              [-21.56223484042413, -12.950981902894357],
              [-21.55715477799115, -12.949828586916167],
              [-21.56353899101534, -12.941881139490711],
              [-21.562849239650838, -12.936229801519648],
              [-21.55751025346062, -12.93912992333954],
              [-21.549286227982126, -12.939935906862836],
              [-21.54281730640758, -12.944319930100166],
              [-21.540341827995025, -12.950426971145351],
              [-21.536894061279, -12.946586850797457],
              [-21.53387724313242, -12.949538519160898],
              [-21.52817820864351, -12.944290872062918],
              [-21.52295938669054, -12.946075643128802],
              [-21.520093068661915, -12.942187273435906],
              [-21.514674667070555, -12.94268329140038],
              [-21.511458531946435, -12.939446575230738],
              [-21.51171597784631, -12.931107216403781],
              [-21.522450037179862, -12.927837132320215],
              [-21.526198851215245, -12.923110230373572],
              [-21.534503992603376, -12.922933953555692],
              [-21.539087670002548, -12.920457167852257],
              [-21.540613211337742, -12.915504612202229],
              [-21.546483279310873, -12.915010220543541],
              [-21.551259435712943, -12.909515723334229],
              [-21.55204268825706, -12.903703917188611],
              [-21.5471074851082, -12.902126743094499],
              [-21.541394318561714, -12.905966845754667],
              [-21.52859752841616, -12.910928437807337],
              [-21.52138144942708, -12.90551843518835],
              [-21.520061215616124, -12.893770483903758],
              [-21.51625586937462, -12.892590074540687],
              [-21.51044383998894, -12.89528266164123],
              [-21.505840466201057, -12.890469873336395],
              [-21.494405654545606, -12.892040444732789],
              [-21.490735173542763, -12.88960104875541],
              [-21.478734412938945, -12.88988820881222],
              [-21.47360457885185, -12.89852399109567],
              [-21.465439815572235, -12.903873965968076],
              [-21.46421203557741, -12.91147475081969],
              [-21.459954421809126, -12.916123631486816],
              [-21.45550687564618, -12.918091013828613],
              [-21.458017820744434, -12.924457664800316],
              [-21.45613517364479, -12.929367407383356],
              [-21.456229902486005, -12.935539555426654],
              [-21.45974388111739, -12.942204210019757],
              [-21.46665303429147, -12.946835275219046],
              [-21.471527533498456, -12.947762916711469],
              [-21.47425196715036, -12.954699585377936],
              [-21.480374854996175, -12.95918361320987],
              [-21.49570989830142, -12.952574416603094],
              [-21.500014732872508, -12.953203953400694],
              [-21.502241700435828, -12.948871180620937],
              [-21.505691502136372, -12.949008420497806],
              [-21.51126001555537, -12.953472205752039],
              [-21.509385462615437, -12.960733067932239],
              [-21.50359032639226, -12.96341082309794],
              [-21.50429111551181, -12.971104712581848],
              [-21.494630809452232, -12.985199500166782],
              [-21.49492815861533, -12.991750692144644],
              [-21.50096362593566, -12.997416198006288],
              [-21.50160690482315, -12.99187315888912],
              [-21.50758134186766, -12.986029923248058],
              [-21.517217914509292, -12.986565873372554],
              [-21.525604946103403, -12.989220112790205],
              [-21.53686596257906, -12.98750789942469],
              [-21.53713520766806, -12.980852145815422],
              [-21.546074752347117, -12.975556583246547],
              [-21.550050138565126, -12.978437101566392],
              [-21.55611282129451, -12.977295049946614],
              [-21.55806250839169, -12.982464193704613],
              [-21.563015295235015, -12.981792380942789],
              [-21.566103543658986, -12.990618311209268],
              [-21.569008834183226, -12.991593667475476],
              [-21.573426415430085, -13.00035288591147],
              [-21.57649471361614, -12.995862402113525],
              [-21.578730156544502, -12.986267469316978],
              [-21.58387551881524, -12.980975199656745],
              [-21.59648771050098, -12.981608553911348],
              [-21.597039084333524, -12.98682736290534],
              [-21.602784821250648, -12.987642329205153],
              [-21.603903430477793, -12.98299511419324],
              [-21.609071735288396, -12.982215693705017],
              [-21.616558430031464, -12.986260137797457],
              [-21.62183320511357, -12.986695018112233],
              [-21.62317447266893, -12.982573108499333],
              [-21.628622197505795, -12.979196627445383],
              [-21.63120387392075, -12.983574958509584],
              [-21.63701125896918, -12.987489126325361],
              [-21.641747251490376, -12.986443663920982],
              [-21.650559063328036, -12.974954910961358],
              [-21.65811897907821, -12.973142078171318],
              [-21.670096678272255, -12.963583913129822],
              [-21.6779389677467, -12.965531475912092],
              [-21.686188973087038, -12.961498438183432],
              [-21.68894827742023, -12.966259785594945],
              [-21.69440653565764, -12.962770975863926],
              [-21.701448981103223, -12.967942827707335],
              [-21.703644742889594, -12.96577816391321],
              [-21.71303212799923, -12.962619267307334],
              [-21.718917910955078, -12.962405935621367],
              [-21.731320898195452, -12.95742924968967],
              [-21.73986462598454, -12.955776977155095],
              [-21.751005034984022, -12.947891176538345],
              [-21.756794816698246, -12.94690764332183],
              [-21.75950169138902, -12.948804459617632],
              [-21.76469675987825, -12.94146861796259]
            ]
          ],
          [
            [
              [-21.801674833337845, -12.945660443069903],
              [-21.794671112602668, -12.946533429246784],
              [-21.79089247224839, -12.944858359856005],
              [-21.788255624646574, -12.950224236387351],
              [-21.801674833337845, -12.945660443069903]
            ]
          ],
          [
            [
              [-21.786009422305955, -12.879028964138792],
              [-21.781388211431224, -12.878166111847284],
              [-21.778688966394704, -12.883200016196765],
              [-21.78544851113574, -12.884775020843664],
              [-21.786009422305955, -12.879028964138792]
            ]
          ],
          [
            [
              [-21.85538938158652, -12.937353244330923],
              [-21.850229579025797, -12.930818136364183],
              [-21.841368437885826, -12.937157718468551],
              [-21.837753897827177, -12.935752746671374],
              [-21.83518244993788, -12.940719545158004],
              [-21.848453650505025, -12.93993613513641],
              [-21.853073891111062, -12.945393351018378],
              [-21.85538938158652, -12.937353244330923]
            ]
          ],
          [
            [
              [-21.883291665098206, -12.931054798922224],
              [-21.878887281398317, -12.929132182884656],
              [-21.865477465096944, -12.931409590917465],
              [-21.865535829523097, -12.943578691349636],
              [-21.87412249022794, -12.942121263538255],
              [-21.875992219282722, -12.935323950535752],
              [-21.883291665098206, -12.931054798922224]
            ]
          ],
          [
            [
              [-21.89588917529943, -12.912213542692049],
              [-21.88481342460499, -12.912054000187732],
              [-21.869470950446885, -12.918793347872299],
              [-21.874081253850566, -12.922405430552976],
              [-21.879284824159267, -12.918545651820303],
              [-21.881720177841423, -12.924168944777385],
              [-21.891700040340236, -12.917633664390522],
              [-21.89588917529943, -12.912213542692049]
            ]
          ],
          [
            [
              [-21.92104334369434, -12.921970613880756],
              [-21.91847232585246, -12.917862677386449],
              [-21.9138981115154, -12.91671666890233],
              [-21.915098930143678, -12.924125272958662],
              [-21.92104334369434, -12.921970613880756]
            ]
          ],
          [
            [
              [-21.938793626240006, -12.93248851448482],
              [-21.93350685070598, -12.933900901728954],
              [-21.92672048716326, -12.931076041547373],
              [-21.917681288318633, -12.931665122984674],
              [-21.910133841777967, -12.933538131985646],
              [-21.914080349328685, -12.94016368416897],
              [-21.905152013591813, -12.94494221882717],
              [-21.90936809499888, -12.947849182520331],
              [-21.909281754791945, -12.952485840139893],
              [-21.912168618280674, -12.956418633871627],
              [-21.92297200589986, -12.94563398543476],
              [-21.929692519884547, -12.944561889799258],
              [-21.92964491736532, -12.940415598619941],
              [-21.938793626240006, -12.93248851448482]
            ]
          ],
          [
            [
              [-21.938682378910535, -12.870117177591517],
              [-21.936411432189626, -12.8662640560293],
              [-21.929777426819832, -12.864124848786483],
              [-21.92810356413844, -12.85965166232491],
              [-21.92426890303522, -12.860633478662104],
              [-21.918584104335817, -12.857936420746427],
              [-21.901187729161656, -12.867076049400074],
              [-21.899753161506688, -12.876921541903162],
              [-21.894938742255178, -12.8822887924509],
              [-21.89904922847382, -12.887391115039291],
              [-21.895246538331783, -12.89672417180327],
              [-21.903878887253292, -12.894984946533137],
              [-21.910461864085136, -12.895216451488912],
              [-21.911085402742987, -12.899210323688807],
              [-21.908942586097883, -12.908627251571483],
              [-21.91217968011731, -12.91085254039761],
              [-21.919604394689653, -12.910513015651718],
              [-21.92285564488725, -12.908077961253078],
              [-21.921126607132695, -12.902429016947266],
              [-21.92357922699359, -12.89813333152482],
              [-21.92740543959988, -12.898709871779017],
              [-21.93926194512882, -12.891839967097898],
              [-21.936907870042806, -12.887062277960197],
              [-21.939081572657816, -12.879177886268906],
              [-21.938682378910535, -12.870117177591517]
            ]
          ],
          [
            [
              [-21.96988941140158, -12.943146532370957],
              [-21.961060514743956, -12.93917308292123],
              [-21.962487081758283, -12.933283804757266],
              [-21.958180767183876, -12.928256895560637],
              [-21.9510178726992, -12.931154900514969],
              [-21.94992561492874, -12.936531442153951],
              [-21.946096188257222, -12.941593695604189],
              [-21.949505188758053, -12.946111815745688],
              [-21.943342245923034, -12.948770686858065],
              [-21.94204757732359, -12.944197904477491],
              [-21.93285157361764, -12.947004236367038],
              [-21.925778512418095, -12.952648240893502],
              [-21.92735430379628, -12.958576315090353],
              [-21.938630180708113, -12.956606624388847],
              [-21.94469713234016, -12.951741678188565],
              [-21.947489060169687, -12.96153678176683],
              [-21.953568297879237, -12.96170368476533],
              [-21.963094202939015, -12.965165906484264],
              [-21.964553503619832, -12.959497347439065],
              [-21.959440636037417, -12.956975809399749],
              [-21.968108808903263, -12.94958246705468],
              [-21.96988941140158, -12.943146532370957]
            ]
          ],
          [
            [
              [-22.148628689716617, -12.953333882910206],
              [-22.1440299206479, -12.952688988222945],
              [-22.143870121741763, -12.94524657250833],
              [-22.138306934895297, -12.93959888361946],
              [-22.130099724909304, -12.938121669911782],
              [-22.12193986778208, -12.938404552904213],
              [-22.115920581438004, -12.933873865141972],
              [-22.11159144073904, -12.933104932362754],
              [-22.111369008372268, -12.925621103659873],
              [-22.108137926437188, -12.921923664007117],
              [-22.113856546458443, -12.91438051341837],
              [-22.115354507308275, -12.90696225026862],
              [-22.111900978488194, -12.902738867469367],
              [-22.0997001171092, -12.899510996033733],
              [-22.098203485620537, -12.907238586777613],
              [-22.093723902112643, -12.909172703983891],
              [-22.08409118804406, -12.907683949444245],
              [-22.085113549024893, -12.903436095836446],
              [-22.07370142035922, -12.89444340058801],
              [-22.071903664005777, -12.888933756944196],
              [-22.076115824044923, -12.878373273974256],
              [-22.075745478273316, -12.870494925501319],
              [-22.06888287532479, -12.863271501490393],
              [-22.063908382486467, -12.86186167503737],
              [-22.053309317180567, -12.864278850587185],
              [-22.044163889966487, -12.87322960288056],
              [-22.034718259836897, -12.872434189823093],
              [-22.033566594409475, -12.868216353523609],
              [-22.022724889349806, -12.863102638421967],
              [-22.016900296761957, -12.868114826340369],
              [-22.018679881253195, -12.875435969927736],
              [-22.02377917929892, -12.881590338809136],
              [-22.021900996278287, -12.889755409319422],
              [-22.02412391333716, -12.892948323158137],
              [-22.030804557633175, -12.891913496250352],
              [-22.04031590890075, -12.893092671164744],
              [-22.045219876358605, -12.902890093276142],
              [-22.050007795135226, -12.906864720089096],
              [-22.041608106523583, -12.909607874311579],
              [-22.042792092088426, -12.914300829946448],
              [-22.03505540533551, -12.91532908616517],
              [-22.032285184229156, -12.919401888539179],
              [-22.02689353831682, -12.920172751825524],
              [-22.02080439707018, -12.91779963932248],
              [-22.01400180065501, -12.920265739347991],
              [-22.01366812233096, -12.924500865946678],
              [-21.99924763085572, -12.919191319481863],
              [-21.991280769940257, -12.920539644973505],
              [-21.9878578898163, -12.92479426374411],
              [-21.979818865833433, -12.923574799268858],
              [-21.97648386856437, -12.925025572453784],
              [-21.9756392137016, -12.92977055730705],
              [-21.980325045897697, -12.936674266687513],
              [-21.98556735384131, -12.936184241258314],
              [-21.985994752862002, -12.942190364935335],
              [-21.98016914478318, -12.941055955694326],
              [-21.97886638651822, -12.945907333433153],
              [-21.981600344275304, -12.955621589026013],
              [-21.989350400306414, -12.958061144420311],
              [-21.997862343255424, -12.967432172827582],
              [-22.00494876550602, -12.968218883359977],
              [-22.007458233808194, -12.964585418858972],
              [-22.014513634928306, -12.96154144129445],
              [-22.009129392327722, -12.944445686419325],
              [-22.014567114536927, -12.943484820277183],
              [-22.017597440462822, -12.948317878689902],
              [-22.01576957663127, -12.951694080448965],
              [-22.02008013690689, -12.958632088937959],
              [-22.026558344873326, -12.957948327932959],
              [-22.028657203753884, -12.952888345913733],
              [-22.05446052019969, -12.962928349626731],
              [-22.06230508931522, -12.960222909955494],
              [-22.07006710091614, -12.960086701978243],
              [-22.07365650337014, -12.95770466864758],
              [-22.08023086882042, -12.960415400287204],
              [-22.08293977595931, -12.956902801910044],
              [-22.087984044590474, -12.956320122055528],
              [-22.09229876826143, -12.963528072354567],
              [-22.090170867576603, -12.966523378923359],
              [-22.09449335467039, -12.974052755385133],
              [-22.099637780872502, -12.96724521270507],
              [-22.1132121047769, -12.972910107670184],
              [-22.11416736461115, -12.967021723625294],
              [-22.109728222554757, -12.960411864526446],
              [-22.110597176154158, -12.947998048080287],
              [-22.10625820703502, -12.944282231218011],
              [-22.104389104753004, -12.936044310096069],
              [-22.116372520124226, -12.94505208695004],
              [-22.118858763148964, -12.950610514955063],
              [-22.12364080104133, -12.951621659957176],
              [-22.129561287944593, -12.956539508457503],
              [-22.13570403256949, -12.964892326153098],
              [-22.14274461384589, -12.969155838580328],
              [-22.149996369852804, -12.961952753582489],
              [-22.148628689716617, -12.953333882910206]
            ]
          ],
          [
            [
              [-22.212985237162847, -12.831195019828145],
              [-22.211450002853088, -12.828302394336678],
              [-22.205882758743396, -12.827547782243263],
              [-22.203355085230776, -12.830176797296485],
              [-22.20371478843955, -12.83521385190168],
              [-22.21179612571218, -12.83678809395039],
              [-22.212985237162847, -12.831195019828145]
            ]
          ],
          [
            [
              [-22.285444144283076, -12.876233672587526],
              [-22.277906873323268, -12.87534617719801],
              [-22.268607800494333, -12.871907974708638],
              [-22.261091521480175, -12.878104020403676],
              [-22.25309197325796, -12.88292725413087],
              [-22.244529731755794, -12.884621360383527],
              [-22.241684472942676, -12.879290955952888],
              [-22.236099602113587, -12.882399878482442],
              [-22.226335400927542, -12.879003036423141],
              [-22.219820028564964, -12.882858001871812],
              [-22.21515558917673, -12.88137618180638],
              [-22.205135103469896, -12.881547321108735],
              [-22.191126749327122, -12.883148644929067],
              [-22.179977689063737, -12.881833859496759],
              [-22.170636656508904, -12.877699573489478],
              [-22.169205252720648, -12.871434788736071],
              [-22.16644859491293, -12.870260405996047],
              [-22.164475152691065, -12.863329981175596],
              [-22.16092351905697, -12.857344059904369],
              [-22.15484991347522, -12.842084894658747],
              [-22.150132405413444, -12.83948530119119],
              [-22.14018497774294, -12.843847060894173],
              [-22.132884054751695, -12.850362562235336],
              [-22.128403505912562, -12.859534265962719],
              [-22.12899345701996, -12.864447572487887],
              [-22.13541610942999, -12.866012497427578],
              [-22.136915241866536, -12.874439803353493],
              [-22.150016685766243, -12.876906798554502],
              [-22.15357847002057, -12.878835723373397],
              [-22.15723638334689, -12.886614532317905],
              [-22.155532533970685, -12.89486854628197],
              [-22.16095061634242, -12.901730346223257],
              [-22.16361951559479, -12.911929737894098],
              [-22.171260758961775, -12.917716756902653],
              [-22.17689670111785, -12.914788929466395],
              [-22.183622883686873, -12.914263299139295],
              [-22.192755661172182, -12.908888042207083],
              [-22.19327406104726, -12.91586684968246],
              [-22.20137072051334, -12.916850065722738],
              [-22.205062494633097, -12.913244414959363],
              [-22.206667126122262, -12.906940322543788],
              [-22.21267470056962, -12.893172800440182],
              [-22.21560513431376, -12.89377385308925],
              [-22.229983872352733, -12.889694894298618],
              [-22.237770080802488, -12.892595842170836],
              [-22.24571547228055, -12.893782503694476],
              [-22.265827020244732, -12.884093635033098],
              [-22.27488795706798, -12.887203899652176],
              [-22.27705167267116, -12.896551001062623],
              [-22.28450229329906, -12.894122719667468],
              [-22.281736292652223, -12.885031476972399],
              [-22.28493693165791, -12.883237236981502],
              [-22.28260893412304, -12.87816075361204],
              [-22.285444144283076, -12.876233672587526]
            ]
          ],
          [
            [
              [-22.370700073117543, -12.78300195786571],
              [-22.360470546512563, -12.775771940027708],
              [-22.3452639436341, -12.777529199703256],
              [-22.335568518100214, -12.78181178900888],
              [-22.331000116919853, -12.785098494019032],
              [-22.315096547162995, -12.789246004952329],
              [-22.310362434599497, -12.791898202393355],
              [-22.311815704199777, -12.795823707713978],
              [-22.305327777519338, -12.807587002905125],
              [-22.31172904547871, -12.812149452075243],
              [-22.308008997939233, -12.817710473884272],
              [-22.300370048468455, -12.8208565339988],
              [-22.302325873990362, -12.82579114130641],
              [-22.294990014559936, -12.828401120175545],
              [-22.29176982075021, -12.826531024289121],
              [-22.28531828656976, -12.826812248954514],
              [-22.281817857913435, -12.833733252682684],
              [-22.277055106027216, -12.836314214711813],
              [-22.266051229219883, -12.833748957409796],
              [-22.2536616933483, -12.836420610120163],
              [-22.253185919043364, -12.842517176128693],
              [-22.266990753543617, -12.844246290852869],
              [-22.27390487599954, -12.841179906163585],
              [-22.29132213412129, -12.842594355935892],
              [-22.298471592321064, -12.841747966324764],
              [-22.296656251388587, -12.848381144379893],
              [-22.310011197313443, -12.85838103297496],
              [-22.31007723959917, -12.865455099298883],
              [-22.312407113162426, -12.871223820110366],
              [-22.321987127499, -12.873807057212279],
              [-22.32481021502567, -12.870208199157195],
              [-22.333312401093767, -12.871417835343648],
              [-22.338299421857382, -12.87872868495172],
              [-22.337358095867213, -12.8844759802527],
              [-22.338235306359977, -12.895228818011004],
              [-22.345902439005965, -12.894234348416354],
              [-22.347568388217745, -12.883613853560561],
              [-22.344463728376063, -12.878602894059373],
              [-22.345791032871137, -12.875867993114644],
              [-22.355010323403196, -12.872312504769086],
              [-22.359289282943188, -12.869182475129119],
              [-22.358782847162047, -12.862307825039016],
              [-22.36870936835637, -12.862865886957868],
              [-22.373955975268135, -12.854823167312775],
              [-22.369439458251914, -12.851446515246545],
              [-22.367961140216906, -12.845275999845386],
              [-22.36250442915493, -12.849576573517867],
              [-22.355317534149236, -12.851967996207021],
              [-22.349179017586778, -12.85151679271812],
              [-22.335644509887246, -12.852798776339757],
              [-22.332050762013232, -12.849193101395247],
              [-22.329260509348412, -12.836591662728207],
              [-22.335381315147345, -12.831830677119966],
              [-22.338408912445995, -12.826658961353091],
              [-22.34420707005129, -12.82820192005422],
              [-22.34851303018616, -12.826611519298629],
              [-22.348960040804084, -12.821215324797594],
              [-22.352524258706993, -12.81735296896203],
              [-22.352050019278305, -12.811533569934022],
              [-22.359895810615516, -12.804143506336533],
              [-22.36438830839095, -12.796638584708028],
              [-22.370113572484648, -12.79180952423856],
              [-22.371966928210977, -12.78722456261512],
              [-22.370700073117543, -12.78300195786571]
            ]
          ],
          [
            [
              [-22.498625700905556, -12.834987010630497],
              [-22.497752714488747, -12.833221972359054],
              [-22.488219254572385, -12.834476713911481],
              [-22.482136261390593, -12.84102814572557],
              [-22.47683192622271, -12.841424123343154],
              [-22.47483522988423, -12.845510375906434],
              [-22.477626107501784, -12.849023057438764],
              [-22.48229582179745, -12.848707853576277],
              [-22.488774509798002, -12.843135564843427],
              [-22.497101738467176, -12.840244212304253],
              [-22.498625700905556, -12.834987010630497]
            ]
          ],
          [
            [
              [-22.53763904397596, -12.829839968504004],
              [-22.530195745818915, -12.833550271860501],
              [-22.524107728870042, -12.840776457365944],
              [-22.519013019036333, -12.841859023679904],
              [-22.51563331172193, -12.845408290861954],
              [-22.515730057029568, -12.85010922976229],
              [-22.52657679509258, -12.845811652865008],
              [-22.533705204410225, -12.844219280688359],
              [-22.533626486495592, -12.836384612529901],
              [-22.53763904397596, -12.829839968504004]
            ]
          ],
          [
            [
              [-22.512798272330105, -12.76294030454496],
              [-22.506246442530024, -12.753090486219563],
              [-22.499477209089005, -12.750135981731644],
              [-22.491266007106727, -12.753249002018832],
              [-22.484784449389508, -12.76483032247594],
              [-22.485492842256086, -12.774635623024723],
              [-22.49725178366267, -12.782620013792817],
              [-22.50612229396536, -12.779714594974287],
              [-22.512798272330105, -12.76294030454496]
            ]
          ],
          [
            [
              [-22.588509598449516, -12.880572257023445],
              [-22.583754342376114, -12.87670096025992],
              [-22.575174027211144, -12.887539564835025],
              [-22.576984658728815, -12.89992740415876],
              [-22.587075124136216, -12.894250026458472],
              [-22.58762415854437, -12.899262216095238],
              [-22.59208219863603, -12.902227501984033],
              [-22.597663670470084, -12.902986154294291],
              [-22.59362412261798, -12.893667762664109],
              [-22.58712476056679, -12.88765592166741],
              [-22.588509598449516, -12.880572257023445]
            ]
          ],
          [
            [
              [-22.634073104419926, -12.901640276969886],
              [-22.62415110979133, -12.896882113313112],
              [-22.62038853369073, -12.898258996704651],
              [-22.61861054421073, -12.905737406274259],
              [-22.62165119391472, -12.91317692236746],
              [-22.630710891143092, -12.921537755335905],
              [-22.635405841685998, -12.921059185661418],
              [-22.638686854171738, -12.916603240499335],
              [-22.633756717337207, -12.906765284601395],
              [-22.634073104419926, -12.901640276969886]
            ]
          ],
          [
            [
              [-22.818023858923947, -12.569172455548903],
              [-22.80637729102171, -12.573098506601108],
              [-22.793392976505764, -12.566750837311126],
              [-22.784428983596445, -12.567424762737748],
              [-22.776511258094605, -12.571413439223148],
              [-22.76142877042141, -12.59681202692213],
              [-22.761654672651293, -12.59984135264788],
              [-22.767645111595392, -12.603156905610126],
              [-22.772178236131197, -12.609657023006768],
              [-22.777722604710767, -12.613411600743607],
              [-22.79936466888115, -12.617079142509096],
              [-22.806654720384795, -12.614795575039066],
              [-22.821795655502285, -12.599369525606905],
              [-22.825926036194087, -12.588632399880254],
              [-22.825545602515653, -12.582816979834888],
              [-22.818023858923947, -12.569172455548903]
            ]
          ],
          [
            [
              [-23.036774289837094, -12.605251421001961],
              [-23.029943246137943, -12.600628009263666],
              [-23.023738322337422, -12.60274183045802],
              [-23.02289907650419, -12.608525435236757],
              [-23.014889001270255, -12.616261311415212],
              [-23.001325542568747, -12.621162188407872],
              [-22.98410342337606, -12.635888494268709],
              [-22.98234185374936, -12.640097140007144],
              [-22.98468139680963, -12.64629105238771],
              [-22.972830801236494, -12.663721083172938],
              [-22.96537600774097, -12.686790981232063],
              [-22.962198894943405, -12.69293025698165],
              [-22.955890238587443, -12.701495337892595],
              [-22.94721616254883, -12.707515282576756],
              [-22.945056094411992, -12.717270069096434],
              [-22.946068422222815, -12.726265314423706],
              [-22.940300889534196, -12.731459225056065],
              [-22.91577434001151, -12.74215029061625],
              [-22.904109957566735, -12.75736137333027],
              [-22.908149867366625, -12.759761112710045],
              [-22.91919472132837, -12.757307919434119],
              [-22.924126800737945, -12.750698778560228],
              [-22.947332395131742, -12.74629719489131],
              [-22.95306497679408, -12.736913371002954],
              [-22.952064964874047, -12.733378288333167],
              [-22.96915707230333, -12.706608747851769],
              [-22.974681080953292, -12.699016289758596],
              [-22.978289151027962, -12.681834661809386],
              [-22.984586791001625, -12.662668816387082],
              [-23.001212843120616, -12.642085554105552],
              [-23.003320316320455, -12.64049396985947],
              [-23.013905255275624, -12.639220663713237],
              [-23.026792109856206, -12.625854911166458],
              [-23.036933199804896, -12.610122249743926],
              [-23.036774289837094, -12.605251421001961]
            ]
          ],
          [
            [
              [-23.02464490819781, -12.483912425916955],
              [-23.01706679423883, -12.48370369907887],
              [-23.00428669569871, -12.494228177459913],
              [-22.999527962574906, -12.504177491787862],
              [-23.000801544272008, -12.506303720550742],
              [-23.01680574449391, -12.515124770351289],
              [-23.02464352254027, -12.513102294477749],
              [-23.026715456454163, -12.50840495236187],
              [-23.02700047501027, -12.50020847540567],
              [-23.02464490819781, -12.483912425916955]
            ]
          ],
          [
            [
              [-23.08746596818365, -12.512553568975015],
              [-23.074735621186132, -12.520469250164462],
              [-23.070831087296554, -12.52762739675808],
              [-23.06815275843238, -12.541003708076806],
              [-23.07908018161405, -12.536963938906762],
              [-23.08111941113468, -12.534182203524706],
              [-23.087195290651383, -12.516810997642034],
              [-23.08746596818365, -12.512553568975015]
            ]
          ],
          [
            [
              [-23.08659618127433, -12.436586358042522],
              [-23.079142067525968, -12.432995262203033],
              [-23.07477710940104, -12.435129808789132],
              [-23.06973826508575, -12.443946352782463],
              [-23.071770434209483, -12.454121045990222],
              [-23.076712896813458, -12.456388603807994],
              [-23.085673475746017, -12.454239449756647],
              [-23.08933343395262, -12.448407556060815],
              [-23.08659618127433, -12.436586358042522]
            ]
          ],
          [
            [
              [-23.2821288701151, -12.400817858287278],
              [-23.274195111400438, -12.399508025258037],
              [-23.26503114649681, -12.399735721701788],
              [-23.26145507800278, -12.40158152291919],
              [-23.246379493016605, -12.395039748523805],
              [-23.244416680161272, -12.392930601000653],
              [-23.2286156314494, -12.393766469490835],
              [-23.214039185230185, -12.398365741365353],
              [-23.210110368672918, -12.396960459438764],
              [-23.2051352885915, -12.390561858996534],
              [-23.201974411851225, -12.383595909556336],
              [-23.185028683264036, -12.367845348396978],
              [-23.178514162231973, -12.36294415221007],
              [-23.168580003497237, -12.361624120935952],
              [-23.16054777033093, -12.374383610962198],
              [-23.160693556777357, -12.3820108717105],
              [-23.167216088614435, -12.387609924276536],
              [-23.173171230029922, -12.386681472044897],
              [-23.186253766477133, -12.398981108508142],
              [-23.192711759600844, -12.400370190878792],
              [-23.204167181934636, -12.405012534116286],
              [-23.20640878981179, -12.412509709901803],
              [-23.200024804536227, -12.417351803488657],
              [-23.19376685776675, -12.420140277939396],
              [-23.198477782616024, -12.427672070374209],
              [-23.208818545786237, -12.426320490685614],
              [-23.236500773375344, -12.408534747802522],
              [-23.24512650843676, -12.408803766290102],
              [-23.25230366596144, -12.411303481077207],
              [-23.261140434862607, -12.418873738239311],
              [-23.26067161376886, -12.42165583785349],
              [-23.263965730167786, -12.428532559532186],
              [-23.271050499172677, -12.432260781131172],
              [-23.271807887726425, -12.424565613083276],
              [-23.279191123912913, -12.410877749023857],
              [-23.284341754673623, -12.405825557356964],
              [-23.2821288701151, -12.400817858287278]
            ]
          ],
          [
            [
              [-23.470244497009578, -12.134646364891053],
              [-23.463289062241426, -12.136197991772809],
              [-23.455945024723842, -12.14245508209851],
              [-23.454178622694275, -12.146563354483472],
              [-23.46204115725495, -12.151651212331805],
              [-23.46863857118439, -12.149121811430533],
              [-23.471138388175618, -12.144261838108982],
              [-23.471951301237286, -12.137573020159302],
              [-23.470244497009578, -12.134646364891053]
            ]
          ],
          [
            [
              [-23.758580473100693, -11.854841983616174],
              [-23.75083130405645, -11.854006214907434],
              [-23.744055059949954, -11.863206212631587],
              [-23.745254275232682, -11.871248343728649],
              [-23.754052302657826, -11.86580556288812],
              [-23.759571543224126, -11.85924333434441],
              [-23.758580473100693, -11.854841983616174]
            ]
          ],
          [
            [
              [-23.776417400962263, -11.837870850037971],
              [-23.76823171264975, -11.84480965609133],
              [-23.76709123738448, -11.850784291634495],
              [-23.77195746258288, -11.852311713314466],
              [-23.776485221084158, -11.846308301689385],
              [-23.776417400962263, -11.837870850037971]
            ]
          ],
          [
            [
              [-23.78887857720859, -11.822328022018112],
              [-23.78377551546497, -11.826242376818177],
              [-23.779497937145962, -11.833529749950811],
              [-23.78768788052812, -11.832329080376917],
              [-23.78887857720859, -11.822328022018112]
            ]
          ],
          [
            [
              [-23.945670841917988, -11.883692703740856],
              [-23.93682178540229, -11.878159340442805],
              [-23.920611981310255, -11.87766586131921],
              [-23.91699193619989, -11.884628349971308],
              [-23.912468570385904, -11.887366657142243],
              [-23.90548874233999, -11.887508030158367],
              [-23.895814303799924, -11.88114271207646],
              [-23.890240496900564, -11.885077989636674],
              [-23.878446236918276, -11.879552352882653],
              [-23.866762811344483, -11.883318390417235],
              [-23.85008176261003, -11.89225190162478],
              [-23.855423020601854, -11.895644874243835],
              [-23.867413377064143, -11.896682100339206],
              [-23.875591570118715, -11.904583235721558],
              [-23.87572375944725, -11.914122560585039],
              [-23.883682860321564, -11.934869019533554],
              [-23.897834694391065, -11.927625905083799],
              [-23.902705540831924, -11.91665476838304],
              [-23.9023976547954, -11.908040758255655],
              [-23.907839561813606, -11.90513837774169],
              [-23.919517088039065, -11.905292104645383],
              [-23.92842966492687, -11.90080564033442],
              [-23.929469116443617, -11.898316904823373],
              [-23.93870221862011, -11.888468873522877],
              [-23.945670841917988, -11.883692703740856]
            ]
          ],
          [
            [
              [-24.026114086801602, -11.638120657079542],
              [-23.982619297163026, -11.632661004767222],
              [-23.979378000085443, -11.632979882876752],
              [-23.959276156680314, -11.641524654664368],
              [-23.89525180511253, -11.682432125799624],
              [-23.891686568385023, -11.686533511448578],
              [-23.88866480348969, -11.693315820183924],
              [-23.888544799725175, -11.698665028816816],
              [-23.884700121076996, -11.708863250144956],
              [-23.876520438421792, -11.711280255865264],
              [-23.87117145899595, -11.720830068006565],
              [-23.86100298425877, -11.757739265975868],
              [-23.865514956669774, -11.762188764593864],
              [-23.8869793422615, -11.752723143185657],
              [-23.88956239897316, -11.74956509711136],
              [-23.895243913483576, -11.735633803896256],
              [-23.90094592071654, -11.735439965234468],
              [-23.90699965012112, -11.73900241265181],
              [-23.916935150545726, -11.747832170951847],
              [-23.924787650263983, -11.747904097915272],
              [-23.927757237749315, -11.746302428275825],
              [-23.948105906214526, -11.730652168620837],
              [-23.97168996434109, -11.731832372610441],
              [-23.984658752124375, -11.714166362875597],
              [-23.987483811811295, -11.699278251441427],
              [-23.980334787568545, -11.687917070789522],
              [-23.980170168236107, -11.682234064239205],
              [-23.99327519734467, -11.656514940108003],
              [-24.004223721298725, -11.652223241280465],
              [-24.020308705628103, -11.6498408203148],
              [-24.027421939454257, -11.643590551062113],
              [-24.026114086801602, -11.638120657079542]
            ]
          ],
          [
            [
              [-12.740105051650541, -11.752723130640646],
              [-12.739572869469749, -11.747562562932172],
              [-12.73554274800042, -11.745077678080449],
              [-12.72711004323873, -11.757284583403095],
              [-12.73000993816934, -11.767405583610104],
              [-12.736664153902103, -11.759189136675081],
              [-12.740105051650541, -11.752723130640646]
            ]
          ],
          [
            [
              [-12.754776513282424, -11.863991768179378],
              [-12.756163853265358, -11.859963236920823],
              [-12.753532503984932, -11.85686731470281],
              [-12.752959420712228, -11.849464959194473],
              [-12.748384154182924, -11.84948662474421],
              [-12.743083695070187, -11.855468716921763],
              [-12.744727625859952, -11.861707198434203],
              [-12.741638796506837, -11.866726682643703],
              [-12.742039484442401, -11.870948539556492],
              [-12.752273485909717, -11.867750671942234],
              [-12.754776513282424, -11.863991768179378]
            ]
          ],
          [
            [
              [-12.755610298532973, -11.886823345328871],
              [-12.755433595449531, -11.881966296130505],
              [-12.749379136064576, -11.880132149883766],
              [-12.748947606607652, -11.884540109976392],
              [-12.755610298532973, -11.886823345328871]
            ]
          ],
          [
            [
              [-12.8174967057563, -11.81618067533552],
              [-12.80650361393356, -11.81690622173272],
              [-12.80292256029425, -11.820689318083563],
              [-12.80825585338792, -11.82297968810101],
              [-12.8174967057563, -11.81618067533552]
            ]
          ],
          [
            [
              [-12.786413086800877, -11.925768149286895],
              [-12.784393205971647, -11.912819680164722],
              [-12.774320822542565, -11.911200697450626],
              [-12.773036712842702, -11.906235889093217],
              [-12.766740906847323, -11.903815190543742],
              [-12.762493406351417, -11.895639848025791],
              [-12.75621574090358, -11.894963052337342],
              [-12.746288992978238, -11.886942744220935],
              [-12.743254710012081, -11.88992883230085],
              [-12.74498625294576, -11.896523794941096],
              [-12.737712961659279, -11.903789040676894],
              [-12.73833979394171, -11.909527875501896],
              [-12.72826857565725, -11.909862508324887],
              [-12.725885201865507, -11.912048858160436],
              [-12.730155179146456, -11.921611327022081],
              [-12.728033706305837, -11.924528432898821],
              [-12.733701985027311, -11.928495342437765],
              [-12.733023490164651, -11.934264123855238],
              [-12.740202469562247, -11.936327989988815],
              [-12.745155014250871, -11.93467092697457],
              [-12.747826224299235, -11.941086261509254],
              [-12.758127606196457, -11.939691528265726],
              [-12.762271032396395, -11.933856428298965],
              [-12.77213386528557, -11.932067612203344],
              [-12.786413086800877, -11.925768149286895]
            ]
          ],
          [
            [
              [-12.802097614653286, -11.90660335719152],
              [-12.7929059466544, -11.907515702129716],
              [-12.790541622013546, -11.915654755321471],
              [-12.79470286748827, -11.914671548225462],
              [-12.802097614653286, -11.90660335719152]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -152.21846556439073,
          "lat": 64.21939087250757
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01785533"
      },
      "bbox": [
        -24.027421939454257, -13.07071141595466, -12.541538846766564,
        -7.015576051282917
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -170.3764717034724,
          "lat": -14.279252933307575
        },
        "year": "2023",
        "ste_code": ["60"],
        "ste_name": ["American Samoa"],
        "ste_area_code": "ASM",
        "ste_type": "outlying area",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01802701"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-8.027865041115536, -12.236470911473386],
              [-8.02064409392097, -12.230450752250151],
              [-8.017148557416323, -12.196150709812883],
              [-8.006831039281549, -12.181163137436194],
              [-7.990817726780901, -12.172663658854932],
              [-7.971727903342183, -12.154285582298844],
              [-7.9683563679456055, -12.143843664947983],
              [-7.9454577655568235, -12.121704636338313],
              [-7.897462658508152, -12.112604858260926],
              [-7.898614289317512, -12.099634816299881],
              [-7.881918835828581, -12.082245570934319],
              [-7.882378860606495, -12.07373303829032],
              [-7.8682040378780105, -12.059085058873551],
              [-7.868117479420004, -12.042863886106502],
              [-7.842340101703252, -12.019822539516992],
              [-7.838340744762799, -12.009298930113193],
              [-7.813331709497688, -11.998469690440121],
              [-7.804787932188053, -11.946096027169586],
              [-7.824604700033142, -11.918084118446735],
              [-7.844073977260473, -11.898701715893917],
              [-7.869637839393547, -11.850976163336615],
              [-7.882178873269578, -11.782205083817407],
              [-7.8776168238827315, -11.749069624943363],
              [-7.861905624351249, -11.722927874004434],
              [-7.848397325046034, -11.71482288644347],
              [-7.819039445333744, -11.712800617228899],
              [-7.790972450739834, -11.723324802113904],
              [-7.7640354402880964, -11.736966669419889],
              [-7.7569952064267325, -11.732589572739176],
              [-7.7188975448645225, -11.758150743119522],
              [-7.713074616713623, -11.776060459728313],
              [-7.675574999761124, -11.797670504133771],
              [-7.643835496215672, -11.811075929325552],
              [-7.62737382938941, -11.831420749592498],
              [-7.602348845611269, -11.837535886281943],
              [-7.584589756520836, -11.855766787092263],
              [-7.553574417935944, -11.845815800897782],
              [-7.516430187250999, -11.859245288167088],
              [-7.49760125989267, -11.862063809918087],
              [-7.44183956309444, -11.880788504938906],
              [-7.408010791369535, -11.897052381293872],
              [-7.340022343133597, -11.932951958491028],
              [-7.3028894595666145, -11.949713329582922],
              [-7.292799874227826, -11.951679217809415],
              [-7.255740273157733, -11.975755679582377],
              [-7.253019722249576, -11.98219687176009],
              [-7.229525823146745, -11.994021663521327],
              [-7.213008240214978, -12.0128748562117],
              [-7.19513735685257, -12.020402891014204],
              [-7.161148314126844, -12.049893741309765],
              [-7.145882944415753, -12.066113011107921],
              [-7.139722881169898, -12.083025152398378],
              [-7.114747452925224, -12.100788249326135],
              [-7.104700431658655, -12.128748006241656],
              [-7.114267747953332, -12.154749355194621],
              [-7.107897086827447, -12.17983033987506],
              [-7.112052839876108, -12.209645146105789],
              [-7.111243042606596, -12.227510585975946],
              [-7.103532204892291, -12.237916238553414],
              [-7.083575145283059, -12.235371590986047],
              [-7.065041169089178, -12.223245737955157],
              [-7.046148022330307, -12.228334158716732],
              [-7.0295820674492235, -12.225237877907745],
              [-7.019572525761365, -12.237688761649778],
              [-7.005176764457164, -12.271180411649699],
              [-7.009355041941869, -12.286637267147977],
              [-7.008970335459847, -12.315089986354195],
              [-7.002045761807718, -12.326415681825997],
              [-6.987023208424308, -12.335404531718686],
              [-6.973560220335819, -12.336936578690365],
              [-6.975257191671473, -12.352890060366798],
              [-6.955229779079069, -12.36564179284527],
              [-6.932943447119136, -12.388099720378735],
              [-6.883118637300508, -12.40902708154086],
              [-6.846333566045577, -12.427885201495465],
              [-6.841917079458579, -12.438310853833542],
              [-6.854352290855683, -12.4746189343442],
              [-6.868349913947166, -12.491472972865399],
              [-6.918982248218685, -12.536779487205783],
              [-6.937774926632383, -12.545730611124403],
              [-6.99077214464836, -12.593098698334815],
              [-6.996639351593631, -12.601294257993754],
              [-7.06892504989689, -12.63657132280235],
              [-7.090305281815142, -12.639276384710318],
              [-7.14548220646631, -12.676349735169062],
              [-7.171207081748834, -12.68501460362903],
              [-7.197322850638795, -12.687156405169347],
              [-7.204100482992901, -12.69414963868106],
              [-7.242907938542495, -12.688106539376419],
              [-7.270998305071056, -12.679919876896111],
              [-7.299997743410582, -12.687220427022938],
              [-7.323168846254437, -12.70824014927011],
              [-7.34295066599675, -12.719448238635964],
              [-7.350580391111039, -12.735584054667516],
              [-7.399736362633483, -12.761408417591095],
              [-7.414415499061561, -12.764983923965744],
              [-7.44768732501025, -12.7999209386036],
              [-7.49605248415448, -12.814017632042686],
              [-7.503940243740116, -12.826940554965116],
              [-7.519194921433649, -12.836912992799832],
              [-7.546529250800128, -12.86983445226712],
              [-7.543384292702305, -12.895166942153443],
              [-7.555935759148242, -12.917623681560352],
              [-7.566031162703673, -12.922623342823936],
              [-7.582818780475849, -12.950340513234206],
              [-7.587843338434404, -12.976496148005923],
              [-7.6071465341203215, -12.977287240047357],
              [-7.614473845856124, -12.996366024571579],
              [-7.640252499738221, -13.021467152686487],
              [-7.666740387160403, -13.033361106522525],
              [-7.667989422439959, -13.010184499673379],
              [-7.70569627452155, -12.979003234804585],
              [-7.739447770985947, -12.968636860198096],
              [-7.779217437670556, -12.936857132277181],
              [-7.826082765773064, -12.928028300371608],
              [-7.853743899619832, -12.914400030831716],
              [-7.857328626846057, -12.896383809444993],
              [-7.879688090392705, -12.869400325534805],
              [-7.890734447416918, -12.835474350360586],
              [-7.890715793545448, -12.81642976258627],
              [-7.883280816491385, -12.79999890064208],
              [-7.8745879421695655, -12.706296315335338],
              [-7.863473780998444, -12.665776847707493],
              [-7.860322200907788, -12.62648033752207],
              [-7.861851837731203, -12.61075740450397],
              [-7.873406881570449, -12.579231119344762],
              [-7.8848960059541, -12.56123889126879],
              [-7.87929844129376, -12.547777224260487],
              [-7.895044356690296, -12.522931824228605],
              [-7.90114562587273, -12.500645914478442],
              [-7.897796540359245, -12.478630969419559],
              [-7.922679328582519, -12.473627366085449],
              [-7.920610486817024, -12.465024326994424],
              [-7.932067261263783, -12.441032184393203],
              [-7.928002080440607, -12.428873972829823],
              [-7.938174051630812, -12.382272088573698],
              [-7.945231197547977, -12.359566608281728],
              [-7.970875201500844, -12.327147647713613],
              [-8.00084051631737, -12.308991997578053],
              [-7.995629389224767, -12.289298266656836],
              [-8.01566171480175, -12.267220699700987],
              [-8.017145928569743, -12.252190259509366],
              [-8.027865041115536, -12.236470911473386]
            ]
          ],
          [
            [
              [-8.630456097307563, -11.08182223039596],
              [-8.62567793424135, -11.05184023408769],
              [-8.601236973515642, -11.003894986303052],
              [-8.562514012180396, -10.978866971606504],
              [-8.528323012397399, -10.97002898810973],
              [-8.52355164612157, -10.981938484867324],
              [-8.501620721357574, -10.98650825770854],
              [-8.478607329247058, -11.014677572526303],
              [-8.468949783988494, -11.012377302320093],
              [-8.468676153943939, -11.034857963930689],
              [-8.441605988356573, -11.06738088730086],
              [-8.437214563118118, -11.082497066078286],
              [-8.42582444739755, -11.099344303442459],
              [-8.397705041324274, -11.100233761466699],
              [-8.374757367436041, -11.087799006400736],
              [-8.335659814232384, -11.081677947432306],
              [-8.322186543561044, -11.06861642897844],
              [-8.277541860348315, -11.05117851058788],
              [-8.263684259582355, -11.058306511395044],
              [-8.240304773340693, -11.052572307981421],
              [-8.232217146660899, -11.06321170141486],
              [-8.22183467851803, -11.058325264393027],
              [-8.200953597843359, -11.061891384445763],
              [-8.1888401221366, -11.06891969840528],
              [-8.188900031115512, -11.08150726395239],
              [-8.145464527487226, -11.11673239319569],
              [-8.131630567759219, -11.130214846606446],
              [-8.11041134614899, -11.137497392047926],
              [-8.097408575005224, -11.136145234169565],
              [-8.094552866608614, -11.154055332725685],
              [-8.075008376334702, -11.17159633517799],
              [-8.057169946863603, -11.166437735118004],
              [-8.028172626465263, -11.186993747471961],
              [-8.010981374124501, -11.187820546670682],
              [-7.975071560677822, -11.202016681196886],
              [-7.960557124075387, -11.219448111605416],
              [-7.95869374728599, -11.26996072344615],
              [-7.96266350586521, -11.283203174808836],
              [-7.98623442882342, -11.308719044229512],
              [-8.001002183595055, -11.311541547655992],
              [-8.012521897637836, -11.323325232315819],
              [-8.017939272016726, -11.337636439579244],
              [-8.034901549331236, -11.343614087412021],
              [-8.048149233706383, -11.339200192213793],
              [-8.062193017771301, -11.3483645997989],
              [-8.078218047910468, -11.350426934161135],
              [-8.10475305472266, -11.371558765521213],
              [-8.119231254630451, -11.363614693783166],
              [-8.140422120980007, -11.367349548212905],
              [-8.153973572815806, -11.361592916036914],
              [-8.174655631519498, -11.36688173886471],
              [-8.194179044129298, -11.378780644459056],
              [-8.24035855770328, -11.39767292757274],
              [-8.255739022624695, -11.40618372007053],
              [-8.277791144211886, -11.404354857672008],
              [-8.325521544072817, -11.414325911178897],
              [-8.334946716986348, -11.408586689090793],
              [-8.361778913524768, -11.406623049502416],
              [-8.388544462162823, -11.385827230903821],
              [-8.387222866455398, -11.369261466273372],
              [-8.400863545498988, -11.353918042372802],
              [-8.390608040013184, -11.343838144624572],
              [-8.392369545805419, -11.300745481716866],
              [-8.395881301626925, -11.270957838561502],
              [-8.403572842005314, -11.257653321808288],
              [-8.408253323305296, -11.215984262908874],
              [-8.420183748447325, -11.204339656053648],
              [-8.450522614379462, -11.199822300983],
              [-8.469094804210345, -11.218522467780229],
              [-8.480093871448185, -11.21990487615945],
              [-8.507221336822099, -11.202592914047013],
              [-8.523385032529081, -11.20009485521485],
              [-8.546399894223557, -11.185728225232044],
              [-8.556011045224881, -11.187844563029184],
              [-8.607979513911214, -11.135520146123069],
              [-8.619107548681718, -11.11030558577584],
              [-8.618879763404392, -11.095612159967779],
              [-8.630456097307563, -11.08182223039596]
            ]
          ],
          [
            [
              [-8.632429996447728, -11.460697504231547],
              [-8.611245729227752, -11.434292328566935],
              [-8.581317774990735, -11.425936910982983],
              [-8.546617460308173, -11.39992676115983],
              [-8.527236810624574, -11.390116180894383],
              [-8.508699233658538, -11.387220913533703],
              [-8.494758474834127, -11.395351513192248],
              [-8.48101018906283, -11.413421168093185],
              [-8.4894273530458, -11.424452007051732],
              [-8.495072098489235, -11.451765434350218],
              [-8.474108135652898, -11.46013966241363],
              [-8.486707354205514, -11.475985075994215],
              [-8.507560151670512, -11.47203894561218],
              [-8.52636593952789, -11.479575237123402],
              [-8.548287103619012, -11.471736446223431],
              [-8.576203140543104, -11.482973314345783],
              [-8.581687001132476, -11.47234572034669],
              [-8.600684294260516, -11.48699909371511],
              [-8.613136034551399, -11.484596329375995],
              [-8.632429996447728, -11.460697504231547]
            ]
          ],
          [
            [
              [-8.971398315222851, -11.096071225732446],
              [-8.967745565379454, -11.087745987637607],
              [-8.948119133651574, -11.076082142125264],
              [-8.902528207476152, -11.069819223428338],
              [-8.885107674766635, -11.075231948309714],
              [-8.855952111738546, -11.075104735924848],
              [-8.835184521718649, -11.078775640914541],
              [-8.804405326409327, -11.093576052048903],
              [-8.753888017454226, -11.140937790289657],
              [-8.732330593297462, -11.174298213092433],
              [-8.732625697837094, -11.188992525709214],
              [-8.754799140257408, -11.227719530952527],
              [-8.766858857565943, -11.236856844621752],
              [-8.789298836536465, -11.242636856516636],
              [-8.811705257389596, -11.258860110966012],
              [-8.85647552202004, -11.257464454755388],
              [-8.880309766574346, -11.261898139545982],
              [-8.897791411880046, -11.24083660506241],
              [-8.907480489140449, -11.208016620002795],
              [-8.903416556923668, -11.178533005849987],
              [-8.920654706714245, -11.147116557799167],
              [-8.961464840146924, -11.12702408178123],
              [-8.972233605651518, -11.107083577635066],
              [-8.971398315222851, -11.096071225732446]
            ]
          ],
          [
            [
              [-9.202544060523993, -10.89467580402468],
              [-9.188037558654788, -10.860711530481545],
              [-9.150743548637625, -10.826798942356596],
              [-9.147228788578191, -10.808311501327289],
              [-9.153259427223157, -10.781592128587409],
              [-9.138932751065582, -10.787769426828731],
              [-9.099181184726618, -10.791315310829743],
              [-9.09010606174499, -10.801951590043878],
              [-9.061598963337232, -10.806423592496467],
              [-9.036620993794664, -10.805691873042221],
              [-9.001834191054105, -10.810275075770667],
              [-8.971173222949693, -10.81913481351351],
              [-8.955333351774602, -10.816691835839512],
              [-8.913108332508736, -10.825574190553818],
              [-8.901036612783216, -10.819006284389108],
              [-8.898214703881754, -10.797658290723312],
              [-8.879917386339637, -10.793428527091402],
              [-8.8661771904676, -10.816625967452143],
              [-8.862133995039525, -10.831655972743292],
              [-8.817309825878597, -10.841047016749519],
              [-8.806825746701536, -10.83585284559402],
              [-8.788868384712222, -10.84290833785924],
              [-8.752544263308085, -10.836087250524491],
              [-8.730683377419576, -10.829377432703746],
              [-8.723382951316202, -10.835585126399796],
              [-8.699042481542703, -10.828374859087726],
              [-8.669841433955819, -10.83099638204447],
              [-8.666703164912267, -10.844616972328282],
              [-8.64171302298676, -10.845455770947199],
              [-8.644820798910313, -10.85973363728989],
              [-8.666879956085765, -10.888959116270879],
              [-8.702651684525254, -10.91704204270264],
              [-8.7290336209234, -10.934869998073005],
              [-8.742983626855317, -10.936513413997215],
              [-8.76077226934738, -10.947749922769443],
              [-8.781195010594077, -10.94599116329032],
              [-8.796915897786748, -10.956002345253623],
              [-8.821307973718186, -10.94726346918536],
              [-8.866446922489336, -10.938552453168109],
              [-8.942418107819854, -10.914745085921876],
              [-8.946737657149646, -10.90841353976086],
              [-9.004534647378714, -10.899323570102192],
              [-9.054757792318597, -10.911052760640702],
              [-9.0625610715625, -10.90985006428452],
              [-9.151919921199681, -10.914751661473485],
              [-9.195396260105523, -10.909144397477883],
              [-9.202544060523993, -10.89467580402468]
            ]
          ],
          [
            [
              [-10.11199757248635, -10.43445046364457],
              [-10.07188216693794, -10.429899332690734],
              [-10.03123697089638, -10.429287756777688],
              [-9.996512173226733, -10.431227438140267],
              [-9.966969074686977, -10.428754031942816],
              [-9.951766413269615, -10.409777865547255],
              [-9.932157702690274, -10.394886790097196],
              [-9.912619202113481, -10.374749069625958],
              [-9.90991851644363, -10.35886000510128],
              [-9.881752470444408, -10.33223630148804],
              [-9.86008625450693, -10.315175759108646],
              [-9.835918089398266, -10.305124270851879],
              [-9.820832663576002, -10.305480516190295],
              [-9.79335068518163, -10.3383431790261],
              [-9.784323169139425, -10.360876082422912],
              [-9.773661489119513, -10.367126779959104],
              [-9.776165283234462, -10.387775639330494],
              [-9.765306015266525, -10.405875382572384],
              [-9.756312921298926, -10.410928744014836],
              [-9.745745173122343, -10.43244508491516],
              [-9.724367328613054, -10.45246182911988],
              [-9.708313763247174, -10.462605532588277],
              [-9.696974578410947, -10.485004004858704],
              [-9.697336424887608, -10.502517204087772],
              [-9.71215107849111, -10.5050796964204],
              [-9.710930872444324, -10.52347619250676],
              [-9.700558567047011, -10.553512125828455],
              [-9.680409071252011, -10.555587485868351],
              [-9.66977029367564, -10.574645079641241],
              [-9.654730384891264, -10.584303343165331],
              [-9.652981371796743, -10.595619715811484],
              [-9.636813108262247, -10.596080894718146],
              [-9.625560181815041, -10.573116050877701],
              [-9.644514806943185, -10.563651808938564],
              [-9.630330425360658, -10.550997846267629],
              [-9.604568371093867, -10.564986923295317],
              [-9.612898729817521, -10.587296643143725],
              [-9.603068956153994, -10.60860385086719],
              [-9.586143044068924, -10.615694615206332],
              [-9.576822098257399, -10.628439087633605],
              [-9.579824814132817, -10.64791422979993],
              [-9.565613710734858, -10.674721023635161],
              [-9.533355722779286, -10.69696529385504],
              [-9.525580970536616, -10.708083497628337],
              [-9.558237974836159, -10.73049427189496],
              [-9.563655491750296, -10.741684712624979],
              [-9.580332721437362, -10.746090299377625],
              [-9.580469596248001, -10.728770000579742],
              [-9.589773974169631, -10.722021348733213],
              [-9.632015728722665, -10.730839035688994],
              [-9.661603947333681, -10.748356161810191],
              [-9.679456580905153, -10.74931765965862],
              [-9.68716122412824, -10.734342663443899],
              [-9.70855729818131, -10.724274275007627],
              [-9.746644280412049, -10.699789850447576],
              [-9.765462329296394, -10.7029714673418],
              [-9.803405952383073, -10.702397187302518],
              [-9.80336277750611, -10.690945376677766],
              [-9.820264221110719, -10.679216540670279],
              [-9.832567766577764, -10.690423573839889],
              [-9.900111928667014, -10.704612842381689],
              [-9.949523736461206, -10.709719662078541],
              [-9.958699621152357, -10.70360626190198],
              [-9.973130418418997, -10.665686625205845],
              [-9.974521008692383, -10.651592630175458],
              [-9.98503899922998, -10.630810282520336],
              [-10.00456696868154, -10.611719290998826],
              [-10.014785955347326, -10.60899472029628],
              [-10.020912075068075, -10.579687405481435],
              [-10.043342133136312, -10.550955505176777],
              [-10.068956327733895, -10.526691255380578],
              [-10.06680805632238, -10.4853672391371],
              [-10.069058592166181, -10.473506120890956],
              [-10.086899706721498, -10.453717208420274],
              [-10.11199757248635, -10.43445046364457]
            ]
          ],
          [
            [
              [-11.52245827753722, -9.981166895677017],
              [-11.518157391832563, -9.947249295467632],
              [-11.481807402895804, -9.915804509807032],
              [-11.467610353895719, -9.874523292148902],
              [-11.459581619668425, -9.864485383057236],
              [-11.437435367659186, -9.852506545213249],
              [-11.39979269324113, -9.842839244393927],
              [-11.37360517083829, -9.823997926302903],
              [-11.350568526664166, -9.813151637034803],
              [-11.327023337078113, -9.794423336821794],
              [-11.306382100658565, -9.791539431719249],
              [-11.268537037069656, -9.807009934679686],
              [-11.239939784792618, -9.789394044573385],
              [-11.218646344638145, -9.795718365869067],
              [-11.208529072561722, -9.792778640795225],
              [-11.184965031215375, -9.801511895766467],
              [-11.16409257721438, -9.793849876827698],
              [-11.160032909588656, -9.787130053997869],
              [-11.141210842694928, -9.802561786025606],
              [-11.101841074658847, -9.811169916251245],
              [-11.079276657807481, -9.83255530607297],
              [-11.058778217983672, -9.874197416521511],
              [-11.062262962789001, -9.912462186458946],
              [-11.08123098454862, -9.94126859203951],
              [-11.086047515637523, -9.960355767337273],
              [-11.096487740972364, -9.965249942877657],
              [-11.102235077511189, -9.991816907928207],
              [-11.094660570853657, -10.05363643721692],
              [-11.111367948458701, -10.065786410791029],
              [-11.118503848469189, -10.081301833494086],
              [-11.14180177124806, -10.091278621617999],
              [-11.151680361371273, -10.104687903859512],
              [-11.192843305796602, -10.13665732896722],
              [-11.20310794003751, -10.141998580289446],
              [-11.23150024227026, -10.128557617140174],
              [-11.265942678476513, -10.12240658733543],
              [-11.279752234317062, -10.126371146307838],
              [-11.324213773080611, -10.117227877814832],
              [-11.338507996713718, -10.107279083832003],
              [-11.355603260408515, -10.110090900328691],
              [-11.3794235053474, -10.096796361975402],
              [-11.411735428844494, -10.057018797138655],
              [-11.44821852320979, -10.049179809830273],
              [-11.455479842632343, -10.04332450192575],
              [-11.496307777895147, -10.030829434749162],
              [-11.509839797434553, -10.004959995980792],
              [-11.52141963864046, -9.99220905217758],
              [-11.52245827753722, -9.981166895677017]
            ]
          ],
          [
            [
              [-11.952412503529986, -10.154700643128514],
              [-11.940769114909836, -10.139569553550498],
              [-11.93331111129835, -10.113181012294131],
              [-11.911747481451021, -10.096872278490137],
              [-11.896995568144504, -10.079564488951648],
              [-11.849666770853108, -10.059750466715066],
              [-11.839119794213262, -10.052131106042621],
              [-11.828634605237387, -10.031601259159363],
              [-11.825740564498556, -10.013349147412754],
              [-11.80853140554154, -10.006240665124942],
              [-11.786716869641278, -10.004349207628374],
              [-11.77083986465196, -10.015291408396331],
              [-11.793078502440485, -10.051820022213077],
              [-11.799623661391369, -10.077781422247387],
              [-11.792407666618713, -10.110195991829682],
              [-11.843033001678554, -10.129445532821558],
              [-11.871556180176446, -10.138053194924954],
              [-11.902885350274483, -10.187415819862608],
              [-11.914277630982946, -10.221593509450576],
              [-11.939451155940041, -10.210227382884888],
              [-11.945248399357157, -10.197289125743428],
              [-11.953725841664662, -10.161008509577321],
              [-11.952412503529986, -10.154700643128514]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -156.34931951862802,
          "lat": 20.249023555607316
        },
        "year": "2023",
        "ste_code": ["15"],
        "ste_name": ["Hawaii"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779782"
      },
      "bbox": [
        -11.953725841664662, -13.033361106522525, -6.841917079458579,
        -9.787130053997869
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.38610727169448, 4.577472383580555],
            [-5.299433738477238, 4.570649512622229],
            [-5.212761399791492, 4.563810923548373],
            [-5.071027170723168, 4.55161231829379],
            [-4.916047154231561, 4.539435344018847],
            [-4.817559443551106, 4.531945876718961],
            [-4.719073277746229, 4.524436129166684],
            [-4.595488235826771, 4.515006653448175],
            [-4.471905707957089, 4.505545249592367],
            [-4.361356817624386, 4.497634853115394],
            [-4.250809793775354, 4.489698929994051],
            [-4.1039379713607635, 4.479922918703879],
            [-3.957069182661222, 4.470101884763057],
            [-3.872664386784412, 4.464806487234284],
            [-3.78826052938638, 4.459496228911805],
            [-3.689397575272638, 4.450771931790908],
            [-3.6254211206721316, 4.446578953104414],
            [-3.481924484162076, 4.43925514287718],
            [-3.3384298898427103, 4.431888447356086],
            [-3.2549569941042464, 4.427226930412307],
            [-3.171484934555088, 4.422550896450455],
            [-3.0748760194663682, 4.418285012889661],
            [-2.989257045112878, 4.4139358386772],
            [-2.9036388610405046, 4.4095713990145295],
            [-2.7880824528883883, 4.405249320199809],
            [-2.698605215690079, 4.4005557713682855],
            [-2.620291729661874, 4.397005171805163],
            [-2.5419788335040914, 4.393441807263606],
            [-2.4636665400734405, 4.389865678324474],
            [-2.385354862217553, 4.386276785708913],
            [-2.3057206019904166, 4.3830109178890755],
            [-2.226086896087067, 4.379731857638732],
            [-2.143273442573928, 4.376666335206856],
            [-2.060460515964137, 4.373586550440904],
            [-1.9600943181688602, 4.37015611303834],
            [-1.8597288325180323, 4.366704730842184],
            [-1.7524122010783714, 4.36329192766225],
            [-1.6450963365469424, 4.359855182529204],
            [-1.499179637570253, 4.355963809682711],
            [-1.3532640882319567, 4.352028186162179],
            [-1.34794199527739, 4.331213698107286],
            [-1.331915592511527, 4.300309395738328],
            [-1.312324018809789, 4.280381835023939],
            [-1.2983978656838018, 4.2837676924455295],
            [-1.242159332880356, 4.251183935822795],
            [-1.230466373730231, 4.2365029831286005],
            [-1.1973472199290554, 4.2241600616352475],
            [-1.1815326872947065, 4.223175415075466],
            [-1.1540237347124418, 4.201224230615772],
            [-1.1188975282927336, 4.184316909888821],
            [-1.1020299719391298, 4.1868435630295675],
            [-1.0885899634257352, 4.167691995653674],
            [-1.0412600647415065, 4.126400106029196],
            [-1.0391990124438304, 4.117978493399148],
            [-1.02128833341529, 4.108995597638496],
            [-0.9960007280803335, 4.107507622115047],
            [-0.9792546377000563, 4.113849108103646],
            [-0.9592407555679088, 4.113131477978134],
            [-0.9257133620264437, 4.141809971878723],
            [-0.9133574747225629, 4.160006818987023],
            [-0.9028981222205545, 4.201413472989035],
            [-0.880808118860169, 4.210021965249008],
            [-0.8295531580514774, 4.191029067411021],
            [-0.7902383432552993, 4.187965318547322],
            [-0.7655896294468029, 4.1825040119511225],
            [-0.7365009432286372, 4.187179406646241],
            [-0.705011911511227, 4.197404641443348],
            [-0.6747060264268403, 4.186088835638272],
            [-0.6527559248011303, 4.188293907467758],
            [-0.632930827755462, 4.1963773954174926],
            [-0.6185381896600081, 4.188016120678169],
            [-0.5875244232053051, 4.183382175690465],
            [-0.5688529312747397, 4.202860089333223],
            [-0.5394478595452543, 4.201703718600909],
            [-0.527118448932139, 4.191114161930839],
            [-0.5137029778313501, 4.19199350954664],
            [-0.4883962274327486, 4.203401666674152],
            [-0.4763074443176592, 4.191093020922989],
            [-0.44620912669496055, 4.190578775006156],
            [-0.4246653635308492, 4.180730941757056],
            [-0.41879309391850433, 4.1439832067077935],
            [-0.3851503026805777, 4.1354980309107745],
            [-0.3756696233073524, 4.129672611853849],
            [-0.36177889489174675, 4.105788262228017],
            [-0.34742800306513494, 4.103071561297807],
            [-0.3183732029442128, 4.105663742518924],
            [-0.2841871640205152, 4.095378401953544],
            [-0.25307998505913554, 4.093168258265501],
            [-0.23798130612553567, 4.073013413830347],
            [-0.23986480743611524, 4.052981269924945],
            [-0.22093203321863428, 4.051742628263625],
            [-0.19831061779033698, 4.06577737668773],
            [-0.18382465300691392, 4.057032498577222],
            [-0.1645819208281535, 4.052415234942305],
            [-0.1522341343881237, 4.0435003094362925],
            [-0.12513660979383304, 4.0353672820740485],
            [-0.12245318008117316, 4.003310516979624],
            [-0.11597258073092938, 3.997020124545856],
            [-0.09468190897719815, 3.992792029588207],
            [-0.06830737426618885, 3.997500779412322],
            [-0.03891619484078713, 3.983474936786826],
            [-0.0534662609177821, 3.9556667843364846],
            [-0.05630487961392704, 3.938432494562798],
            [-0.03805640471128307, 3.9079961116883077],
            [-0.018385593281414314, 3.896293392708504],
            [-0.003318364172046383, 3.881666685525558],
            [0.005266350378499618, 3.843068676713385],
            [0.021680343360863132, 3.8338088703800954],
            [0.035707055553366396, 3.8371094585083902],
            [0.055245560096835025, 3.8495902539279765],
            [0.079088136831482, 3.8392667838685544],
            [0.09639028943447953, 3.8115735670941624],
            [0.11524952431595231, 3.808752401422278],
            [0.1373248837675174, 3.819284287914901],
            [0.1734924171610186, 3.812562034616949],
            [0.18085391701839082, 3.802891253195955],
            [0.1846247245120239, 3.7746549299093317],
            [0.1795082287178049, 3.7607153500729398],
            [0.16166834630190263, 3.7390956042268226],
            [0.15926491941625204, 3.721576675299118],
            [0.16399124084846067, 3.7041285371217425],
            [0.15695552033270854, 3.6866883654362246],
            [0.1641455244202646, 3.6652677670773626],
            [0.18159622345475884, 3.653607929836296],
            [0.19196626034145928, 3.638501116672355],
            [0.19300488364822815, 3.6193777363764172],
            [0.20181203168934164, 3.6039033813677603],
            [0.22016848742424655, 3.5867055903980756],
            [0.22566003167274645, 3.5570007253604583],
            [0.21635441396672617, 3.546014342831427],
            [0.20143202996690565, 3.5423102695638233],
            [0.20762763550023242, 3.521751371407441],
            [0.20775574484076198, 3.4936701440115283],
            [0.22846343848824718, 3.4733365497878435],
            [0.23537013533734844, 3.4591176320976826],
            [0.25808714506779884, 3.4499579297575655],
            [0.26680384398793, 3.4366497442013837],
            [0.26652962226443855, 3.422489370939872],
            [0.258032250596008, 3.400246774520379],
            [0.26358897614957294, 3.371038842446115],
            [0.27488196533354586, 3.3640626543205534],
            [0.2879391785015013, 3.3670528284279624],
            [0.29879564348632753, 3.348491587387111],
            [0.2875219685203946, 3.338126158555501],
            [0.2942066416156755, 3.3201074303208937],
            [0.3049451039818932, 3.3324401910695967],
            [0.32498174147510306, 3.3320177022836943],
            [0.3219313824536074, 3.3100426233989957],
            [0.327745293069904, 3.3022235301630563],
            [0.3482007948540118, 3.3056468137954176],
            [0.3681419758601341, 3.297106333540602],
            [0.3577641761900989, 3.262645031585136],
            [0.3586379267406219, 3.240512187085077],
            [0.3442151901249433, 3.2268995455989837],
            [0.35483351246530065, 3.209776521203102],
            [0.35693267306161547, 3.196742128485857],
            [0.3778181458431288, 3.179630715491989],
            [0.3839320442424107, 3.1650093201272855],
            [0.3841455551674886, 3.145240423274059],
            [0.4121927562896701, 3.1279373959760113],
            [0.41458662114642053, 3.113253409152964],
            [0.4063399978830396, 3.1021047789135894],
            [0.4010401235440382, 3.0774527338024753],
            [0.38625789775849967, 3.0683096589242083],
            [0.3877303521877505, 3.052015152596733],
            [0.4047060735802109, 3.04188382694669],
            [0.40745416976989723, 3.0254810958593827],
            [0.3858404670216567, 3.0237469778650286],
            [0.376472278560918, 3.018027023274587],
            [0.37405599344339474, 3.0015693527474063],
            [0.3897135932491259, 2.9846159836453086],
            [0.39325222157260864, 2.9708623088015473],
            [0.37905901607549763, 2.9473413937779633],
            [0.37651035167467906, 2.9332803911786223],
            [0.3825581225364847, 2.9200620428216015],
            [0.40181987424618765, 2.9064244558579153],
            [0.40347407481466835, 2.897300149155492],
            [0.3942265360415502, 2.8812030472157644],
            [0.3953945839670001, 2.856683701725272],
            [0.4238437354537696, 2.8314479839709104],
            [0.43654093057201776, 2.8316311876619125],
            [0.44394050341031843, 2.863151213973245],
            [0.4637653158136409, 2.8622567123145353],
            [0.4690655259185516, 2.834600442863485],
            [0.44921405163749695, 2.809050474498073],
            [0.4602397864480645, 2.7946799957759927],
            [0.4894072720983778, 2.7857941531364707],
            [0.513617625459473, 2.7860969850820068],
            [0.5230266187769077, 2.7737910872308174],
            [0.5134575770547014, 2.75150008486474],
            [0.5152533781977031, 2.7280942409730877],
            [0.5107115315280746, 2.718233008048502],
            [0.5151259713949551, 2.6863299264440528],
            [0.49592125348397326, 2.670712655186316],
            [0.4986815651632024, 2.661350169808804],
            [0.5191059244312792, 2.643542309515958],
            [0.5466770194566155, 2.640447794943334],
            [0.5595252145286622, 2.617002473175922],
            [0.5514181645351983, 2.6024916453027838],
            [0.536441918811119, 2.5944198061265804],
            [0.5289796779462493, 2.6005551956677593],
            [0.5338794883023109, 2.6221079111596697],
            [0.5177823627685765, 2.6195764497027536],
            [0.5169008368426812, 2.6024583824454317],
            [0.5278687887363979, 2.5923975402067208],
            [0.5224366435262248, 2.579402372531532],
            [0.5298387502176454, 2.5587644709031343],
            [0.5197896550109142, 2.53176584383383],
            [0.5189817013321167, 2.5161547234409194],
            [0.5311589691341609, 2.5047844099818137],
            [0.5646731925859763, 2.508752058362515],
            [0.5822387371138085, 2.4953838406464137],
            [0.5736675233603942, 2.4857010301686007],
            [0.5593833873346152, 2.4884239657026286],
            [0.5507551875728017, 2.475093581425278],
            [0.5518151435239407, 2.4641161026592493],
            [0.5639529539442313, 2.4378426520395786],
            [0.5664625674618242, 2.408131542674806],
            [0.5548879800517587, 2.389165408431194],
            [0.5538739242988121, 2.3727558174587045],
            [0.5671361470882116, 2.3587990292759144],
            [0.5685513805583982, 2.3446728045043557],
            [0.5614146324502871, 2.3285392164751233],
            [0.5659179062161446, 2.316396249065262],
            [0.5883654805673065, 2.3016417446414206],
            [0.5922832627160881, 2.29128926265016],
            [0.583393353986226, 2.258592288038466],
            [0.5862994838928105, 2.2401579436342245],
            [0.602923151043651, 2.2213395084255114],
            [0.6046235969615288, 2.202502376456379],
            [0.5778895799343003, 2.18239016148217],
            [0.5858880715068198, 2.1531979601982894],
            [0.5810196480218682, 2.1213797986663665],
            [0.5862022681018685, 2.0938684073982787],
            [0.561387973914065, 2.076865615505528],
            [0.5511426936709565, 2.0649450476366407],
            [0.5472074272121549, 2.0488378327216887],
            [0.5515294853359836, 2.0344536301045992],
            [0.5694289152010591, 2.024878040252835],
            [0.5819388449886975, 1.994094416312047],
            [0.5969119980789673, 1.983782451107418],
            [0.6220678322856148, 1.9759186098347412],
            [0.6357744186304455, 1.9557941347357923],
            [0.6367453074453652, 1.9407074667787043],
            [0.6509412763254722, 1.9252506018374098],
            [0.649571076347882, 1.9088981788157735],
            [0.6401822948134792, 1.9011802407597256],
            [0.6342483383052611, 1.8941057326083874],
            [0.641796467812463, 1.8639723212936847],
            [0.637563701111645, 1.852224292822794],
            [0.6467608062914589, 1.8414934106380183],
            [0.6918880980065623, 1.844130375836676],
            [0.6941036160081335, 1.8728363390526157],
            [0.710949796466817, 1.8786230696999582],
            [0.7257200793611711, 1.853962412582397],
            [0.7186941764866784, 1.8329606603027442],
            [0.6898831221722344, 1.8207305435000283],
            [0.6951524788636128, 1.7845707815482827],
            [0.7113279021378655, 1.771818028856643],
            [0.721603173435057, 1.7569155672502557],
            [0.7192272040470026, 1.7307568755658973],
            [0.7325659079323931, 1.701462816292197],
            [0.7337780887551317, 1.6843036633497426],
            [0.7487784399646834, 1.6551431251518034],
            [0.7404353554330364, 1.6434532543746079],
            [0.7254070509978865, 1.6366247973364176],
            [0.7318182457314256, 1.6196154332145676],
            [0.758155493528625, 1.6280661303583408],
            [0.7798733382700641, 1.613645528689572],
            [0.8014529062310387, 1.6052496448868951],
            [0.7992938425335011, 1.5846676922310572],
            [0.808824052984977, 1.5745522492215482],
            [0.8297802651647489, 1.5630568948395964],
            [0.8469509972997118, 1.5635225469012373],
            [0.8590193092918336, 1.556688906216922],
            [0.8649906021674207, 1.5417820978942582],
            [0.8556055605021847, 1.514253518685919],
            [0.8602647703050363, 1.4954377975022106],
            [0.8721156578664391, 1.4825774916065142],
            [0.8906545363837198, 1.4721408734254402],
            [0.8948111221008516, 1.451679157691287],
            [0.9194002690497256, 1.43973346583115],
            [0.9237456303571525, 1.4243833036288953],
            [0.9105438698695386, 1.40448347306417],
            [0.9112483410330083, 1.3871251215301097],
            [0.902406972183949, 1.3715670373776536],
            [0.9086418810549124, 1.3508954971077527],
            [0.9319549439232736, 1.3396306981643145],
            [0.9463226667682222, 1.344150321223062],
            [0.9857658049515485, 1.3221254633122146],
            [0.9888107714647052, 1.3126668445997582],
            [0.7991405509988933, 1.3117468061249327],
            [0.6760278549007911, 1.311526393890513],
            [0.5529151905848424, 1.311287943345694],
            [0.3465628395031638, 1.3113532004945987],
            [0.23255555313087561, 1.311763563476781],
            [0.11192186466041686, 1.3126271961414364],
            [-0.008711950295315407, 1.313473506465764],
            [-0.17086860494994097, 1.3149984359425486],
            [-0.33302555264591926, 1.3164920614269722],
            [-0.49004751282210446, 1.3186389371303135],
            [-0.6834666479880754, 1.3217937563465365],
            [-0.807555432479006, 1.3239948418645027],
            [-0.9316445411048271, 1.3261775897302854],
            [-1.1299265476541214, 1.3306047676203487],
            [-1.240791826140919, 1.3333242970218058],
            [-1.3516574641372912, 1.3360291838558345],
            [-1.4725181297599645, 1.3391653407607855],
            [-1.5933792442461503, 1.3422840947288939],
            [-1.7636304952624529, 1.3473655326568237],
            [-1.941948510039168, 1.3528099279815393],
            [-2.1191407868654344, 1.358982373168501],
            [-2.2746547820648755, 1.364614936844663],
            [-2.430169813620717, 1.3702186758749442],
            [-2.575613954087233, 1.3764097122649694],
            [-2.7210591666720045, 1.3825755272403148],
            [-2.9271628346812726, 1.3922074600919683],
            [-3.089894075313207, 1.4005613937529178],
            [-3.282450458410086, 1.4102227253816777],
            [-3.4289528839569403, 1.418427815078435],
            [-3.5754567463542752, 1.4266072794563898],
            [-3.6405893471124053, 1.4299424356744157],
            [-3.8038958686074085, 1.4398498210968569],
            [-3.9672043223892195, 1.449725348705754],
            [-4.126822499258076, 1.4600188352959906],
            [-4.117688383290835, 1.6062847851201676],
            [-4.1049663755436905, 1.7975067964893765],
            [-4.092476446724796, 1.9982275546478367],
            [-4.078561452865083, 2.2112145535903447],
            [-4.062582575589385, 2.4654205927326167],
            [-4.24165118216062, 2.476882017762314],
            [-4.340757207582826, 2.4835980639049784],
            [-4.439864232018421, 2.490299349649632],
            [-4.555218965291271, 2.4983440832751795],
            [-4.670575084492804, 2.5063688140816587],
            [-4.828814117902616, 2.5182990331582498],
            [-4.985420421748122, 2.5300025836339626],
            [-5.142029450509161, 2.5416692392524842],
            [-5.236407238630318, 2.54946704161374],
            [-5.330786142125657, 2.55725142965392],
            [-5.4470764537103555, 2.5661678276211304],
            [-5.556656276441772, 2.5753996714605933],
            [-5.5435550343579525, 2.731819398069153],
            [-5.520451720315846, 2.99317246479185],
            [-5.503433757689663, 3.1988247982468336],
            [-5.481088001073683, 3.4619246288133323],
            [-5.460362479125146, 3.7017688517833744],
            [-5.4489103266844205, 3.837878975578938],
            [-5.4287862402935705, 4.077087981855903],
            [-5.40692803365175, 4.331651547327991],
            [-5.38610727169448, 4.577472383580555]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.81093129982696, "lat": 41.52707426820797 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779792"
      },
      "bbox": [
        -5.556656276441772, 1.311287943345694, 0.9888107714647052,
        4.577472383580555
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.908785599680986, 5.326495530562303],
            [16.947623291808405, 5.336821038843018],
            [17.09444152233837, 5.366470206246002],
            [17.177635613038632, 5.383602588100771],
            [17.260832109890323, 5.40072171068424],
            [17.394503396602314, 5.4314774506009815],
            [17.401674616370915, 5.393063545182944],
            [17.4361606043838, 5.407197764366401],
            [17.440265821756014, 5.436324525680792],
            [17.435868729293393, 5.441431880943359],
            [17.478589799655396, 5.4526721755200525],
            [17.543006789119985, 5.462555534232559],
            [17.562817658522135, 5.461206878471406],
            [17.56798967953646, 5.468131795091844],
            [17.59922373113464, 5.480256718792404],
            [17.750657108079864, 5.515966755152931],
            [17.88074313934693, 5.547327400478781],
            [17.933040978202946, 5.557700799283035],
            [17.98756288094156, 5.5712035682370935],
            [18.057139908668606, 5.586517663107996],
            [18.121689103721366, 5.602377393920277],
            [18.12662721117976, 5.587598911861518],
            [18.146006486554494, 5.517344355840045],
            [18.224750879380668, 5.248183266326044],
            [18.277821841186967, 5.013773436997032],
            [18.260835902305182, 5.012144206905627],
            [18.247605390498435, 4.994659835110515],
            [18.26013087980494, 4.978529392009897],
            [18.26203421707378, 4.95655343111516],
            [18.27383304785745, 4.935655662094203],
            [18.257004923044498, 4.908302539355107],
            [18.240745754482152, 4.920467919654932],
            [18.211290447199637, 4.9044613594362465],
            [18.191167229067567, 4.9095138499106925],
            [18.183161987886887, 4.890581022630125],
            [18.168763076457346, 4.89564165264144],
            [18.15189728139, 4.867496167704821],
            [18.121229222525272, 4.872165306248449],
            [18.089770910275536, 4.85895598113128],
            [18.08100643137115, 4.841089463297518],
            [18.06475966432347, 4.837245788620837],
            [18.045356965405098, 4.84657706989272],
            [18.034417930657995, 4.840070838454773],
            [18.027650135957032, 4.851719619545622],
            [18.011638928100844, 4.837995485130453],
            [18.017648195247112, 4.812597176146378],
            [17.991106040821542, 4.819945844295407],
            [17.979987225134792, 4.814826353020188],
            [17.976970323140993, 4.797790202309889],
            [17.937597104390836, 4.782461674750433],
            [17.92466447328688, 4.784504845543038],
            [17.908557482671956, 4.80975325502958],
            [17.90439942158135, 4.796673387651659],
            [17.921861115397977, 4.769211342763626],
            [17.89179583348662, 4.7542982016827455],
            [17.879022648812708, 4.7680391818229],
            [17.86016890418136, 4.759087361985174],
            [17.84037115000505, 4.759023114149015],
            [17.831117798356708, 4.746461060011175],
            [17.81793971914319, 4.745079223009711],
            [17.803661889230504, 4.726703918960529],
            [17.785578415790543, 4.728455383886992],
            [17.781289870654724, 4.712888406704239],
            [17.756849898089275, 4.726847682317996],
            [17.72255477486058, 4.722296194852796],
            [17.67691632574881, 4.696422759489538],
            [17.65460144111708, 4.69431249073136],
            [17.63948489074085, 4.6863846543409755],
            [17.618860689743272, 4.691963637145929],
            [17.601371126339963, 4.684383600514058],
            [17.589547495834758, 4.672416471218158],
            [17.57718544752014, 4.669565169894595],
            [17.53839979607634, 4.64654137402289],
            [17.526859327724324, 4.645994373697659],
            [17.521325764115346, 4.665786276534719],
            [17.514453494302256, 4.6691300983754696],
            [17.506614459207903, 4.693664096030638],
            [17.49437849364787, 4.674824719882809],
            [17.497812695963777, 4.656783948476677],
            [17.477935921823796, 4.6407751506561095],
            [17.474284410754425, 4.624589354550255],
            [17.464784876115818, 4.620917908678804],
            [17.45567219551265, 4.605084906005588],
            [17.451327578174684, 4.585370007295615],
            [17.424473609483954, 4.585028657572585],
            [17.40166241394441, 4.555237093778812],
            [17.392252345713143, 4.533648394883263],
            [17.400041090181052, 4.517597338612463],
            [17.381396837187594, 4.508257796266536],
            [17.348025153474847, 4.512806454286793],
            [17.32616408164191, 4.506460800998648],
            [17.31170125812412, 4.487323677368825],
            [17.304361320697172, 4.470210598873401],
            [17.292362238027938, 4.456945270832446],
            [17.27235398664223, 4.46212110788218],
            [17.259256965208852, 4.445397562844794],
            [17.23131055951838, 4.429905171930835],
            [17.22253282749879, 4.418434948021149],
            [17.19827952471446, 4.400896672916913],
            [17.194253507702296, 4.3843569555623425],
            [17.183092452119325, 4.365940297481768],
            [17.1561096790289, 4.3638522652388705],
            [17.149325005878197, 4.34788038774376],
            [17.1362939202522, 4.345261502738127],
            [17.104552356248497, 4.314489659170735],
            [17.08645057763628, 4.285909241662457],
            [17.074357742345605, 4.298624750989802],
            [17.05485511642509, 4.279287970902553],
            [17.04523189205998, 4.278340537471124],
            [17.03466443577536, 4.261070048342278],
            [17.032003656790202, 4.28421029889332],
            [16.958410835479782, 4.358503898064173],
            [17.034197877470913, 4.434577310442071],
            [17.10999921259019, 4.510629640258678],
            [17.04098690174082, 4.579490184692928],
            [17.035144192448954, 4.609995968675279],
            [17.017934069959495, 4.717055270102266],
            [17.001414169233936, 4.809460846525806],
            [16.986073773221555, 4.901393741387843],
            [16.960520052022826, 5.038750298302886],
            [16.91884406805214, 5.277801850167428],
            [16.908785599680986, 5.326495530562303]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.72518414954222, "lat": 41.62081461447827 },
        "year": "2023",
        "ste_code": ["09"],
        "ste_name": ["Connecticut"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779780"
      },
      "bbox": [
        16.908785599680986, 4.261070048342278, 18.277821841186967,
        5.602377393920277
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.09199840085031, -4.493052079178924],
            [-15.072200379500671, -4.469597910450658],
            [-15.062974016304938, -4.479481917463895],
            [-15.007078384501119, -4.500203157930851],
            [-15.001194922946436, -4.494955482060847],
            [-14.975754241477777, -4.499542858815712],
            [-14.958680692626112, -4.487978012453254],
            [-14.937942988756818, -4.491801736765706],
            [-14.92637971002104, -4.486634456301012],
            [-14.92368236184937, -4.452313995273612],
            [-14.901183445769759, -4.430944856293647],
            [-14.886650910640816, -4.426776921037586],
            [-14.861795505491239, -4.409301405606764],
            [-14.845989094416522, -4.354400713365417],
            [-14.844886334174662, -4.343118742141823],
            [-14.85406932567209, -4.318693442975413],
            [-14.839180902322939, -4.30006774100737],
            [-14.837148347290313, -4.284132164406323],
            [-14.854868568909465, -4.28311723549861],
            [-14.858781656166327, -4.234146577003786],
            [-14.867698119746844, -4.2191203964215225],
            [-14.908509288554217, -4.204282915969066],
            [-14.934695916875471, -4.210583254368341],
            [-14.95588280161195, -4.200618210974646],
            [-14.96229123166331, -4.184778357899276],
            [-14.979470749141317, -4.193106095274455],
            [-14.989255669540114, -4.186908586438872],
            [-14.98833978645223, -4.167454476650753],
            [-14.995995909836541, -4.151812314191665],
            [-14.995083489948724, -4.138619348580276],
            [-15.008533719144268, -4.131724458598869],
            [-15.00785823013727, -4.122368000863964],
            [-14.992179597034163, -4.090909984112708],
            [-14.971172354996858, -4.06259289073525],
            [-14.963327573002369, -4.038320612384662],
            [-14.963228483163919, -4.022707926935471],
            [-14.955413093461134, -4.001678038505525],
            [-14.96370755897438, -3.979812188786074],
            [-14.949509045844176, -3.972037971248918],
            [-14.948714900708579, -3.9572734060686563],
            [-14.961010023473868, -3.944983359517197],
            [-14.982839016024368, -3.93214749064991],
            [-14.986494320363343, -3.9167175321757717],
            [-14.966281928036278, -3.9021290110579567],
            [-14.9550317533971, -3.887562926408804],
            [-14.948748092053442, -3.864093530309266],
            [-14.951830425706007, -3.8399222910942874],
            [-14.960710762723956, -3.8231658161491984],
            [-14.95663289224271, -3.8146432285836203],
            [-14.94162903214115, -3.817119978413222],
            [-14.928545738653492, -3.8099323040216553],
            [-14.90546751398687, -3.819543032813252],
            [-14.892477819963657, -3.8183204639486843],
            [-14.879135022570033, -3.8092953763686896],
            [-14.868098148954516, -3.7823679470470277],
            [-14.843804433124507, -3.7587470390140982],
            [-14.834214621993395, -3.745147183383803],
            [-14.805984338808809, -3.733007169568096],
            [-14.801360702104374, -3.718472643081477],
            [-14.769526436867833, -3.7038409331853583],
            [-14.775451568965979, -3.6853379682099874],
            [-14.774882524743814, -3.6626483831611436],
            [-14.755958889133101, -3.646026954182728],
            [-14.760911570331906, -3.6321056104606337],
            [-14.752794627019954, -3.6226535275401686],
            [-14.75774685398214, -3.607597198394687],
            [-14.744223154010887, -3.60259394346963],
            [-14.752712861551979, -3.5868074090435944],
            [-14.742939127546856, -3.5721579233950203],
            [-14.718527242909149, -3.565670520808613],
            [-14.714254123997069, -3.543708948201072],
            [-14.724105500625134, -3.526339139315011],
            [-14.714463914146332, -3.5110379634539948],
            [-14.713274261649007, -3.493920665111517],
            [-14.721067917937825, -3.4441826429599165],
            [-14.712497877282674, -3.435193411567035],
            [-14.715237153911477, -3.4038430669462967],
            [-14.701727097429812, -3.403227074598222],
            [-14.689814757878716, -3.3868720528530107],
            [-14.702145340603431, -3.367267334622241],
            [-14.688714828654446, -3.362735083747689],
            [-14.688942492436446, -3.3519757840948867],
            [-14.704790235682719, -3.334206248924012],
            [-14.703712024917493, -3.3249130061541785],
            [-14.688733044638386, -3.3063644268147105],
            [-14.669665587978974, -3.3037979159511615],
            [-14.629359373438929, -3.272531422706221],
            [-14.608082484292819, -3.2535449689402407],
            [-14.602457985761227, -3.2390905236082586],
            [-14.602095000931339, -3.218544930171813],
            [-14.592206205001803, -3.1902524719186522],
            [-14.573538758553752, -3.1731416070453955],
            [-14.552629990799925, -3.174725296388512],
            [-14.53159941650992, -3.1701316455443243],
            [-14.513637619818649, -3.1573555129065465],
            [-14.494268235288013, -3.158774672601701],
            [-14.48274916987089, -3.152800468437791],
            [-14.457704892836222, -3.1312744412265023],
            [-14.430352394607835, -3.13320534683086],
            [-14.408151598156014, -3.1240875069889906],
            [-14.402194608020844, -3.11002406840259],
            [-14.345231981401815, -3.0719752809658343],
            [-14.3419051860755, -3.063031641539902],
            [-14.31428614860155, -3.064538292273452],
            [-14.316252012331395, -3.04951353758829],
            [-14.312236559970387, -3.0234188861312297],
            [-14.324664407131504, -3.0060201191363434],
            [-14.334491390608541, -2.971883850969271],
            [-14.350328740027956, -2.956447153707624],
            [-14.370862168684933, -2.947810484203611],
            [-14.375363186368778, -2.93591814564555],
            [-14.39476131641312, -2.906855452741098],
            [-14.412054199035838, -2.899379286691889],
            [-14.419332712614565, -2.875944455223687],
            [-14.437485394112224, -2.8616942813105646],
            [-14.447979159746177, -2.8450896614008845],
            [-14.473822050420567, -2.8446617447964657],
            [-14.482116125146943, -2.8317818769276224],
            [-14.46566788757822, -2.78433885520582],
            [-14.463498072377606, -2.7617426261888642],
            [-14.475313850684529, -2.718473109405281],
            [-14.48691209712598, -2.70483548479356],
            [-14.494989571667682, -2.686742000868969],
            [-14.482594207522277, -2.675158020244231],
            [-14.49210038241483, -2.6620011445660943],
            [-14.493479062771483, -2.6171258320747017],
            [-14.502069944033751, -2.5650819440431776],
            [-14.531966299976931, -2.535806469456806],
            [-14.554908356489399, -2.500345160655224],
            [-14.564187120190345, -2.470349725874871],
            [-14.568726998034679, -2.426955107511587],
            [-14.597702811308432, -2.3897000909477075],
            [-14.598757211905623, -2.36961036078878],
            [-14.589822743163223, -2.349236976282049],
            [-14.5815977169728, -2.312295687061361],
            [-14.582925197253708, -2.297538049583939],
            [-14.572069763683478, -2.265883024562385],
            [-14.573320821003112, -2.2553274498737936],
            [-14.570824824353997, -2.2285842738304535],
            [-14.559833258673399, -2.213961543460822],
            [-14.54077686625319, -2.2031289194535053],
            [-14.536101095264739, -2.18772956219732],
            [-14.564229372857973, -2.154361945742996],
            [-14.549722351596433, -2.14160550208369],
            [-14.521377307582853, -2.1424500288463713],
            [-14.50445524740983, -2.13853017669192],
            [-14.490946766194673, -2.1067724946394115],
            [-14.485509802084737, -2.0685179261118254],
            [-14.489969984966152, -2.0583364268670628],
            [-14.485326385158428, -2.005058968087924],
            [-14.48678120807353, -1.9692323699092937],
            [-14.47957255592661, -1.942616961785443],
            [-14.481256491437275, -1.9071133357281997],
            [-14.486475779306199, -1.8837958230811698],
            [-14.487865231608023, -1.8531807543856798],
            [-14.504290780449189, -1.8281496504248034],
            [-14.509494908307158, -1.8096594236914239],
            [-14.507458278062977, -1.789307490740426],
            [-14.511473346586117, -1.7568752512190269],
            [-14.507457993594315, -1.7431550972197611],
            [-14.487814693079827, -1.7270814725641725],
            [-14.486141554131759, -1.6936215494143352],
            [-14.492376693195192, -1.6764421381560817],
            [-14.478596542359744, -1.6721767026882421],
            [-14.469399480659169, -1.650032157551917],
            [-14.482425635172417, -1.6155768795735568],
            [-14.489742355625136, -1.6053723019053974],
            [-14.487766919864086, -1.590462884799357],
            [-14.477185703764583, -1.5684904623979328],
            [-14.48952517215964, -1.5531627932770173],
            [-14.490600583304625, -1.5419705315858454],
            [-14.479853531003394, -1.52155630612222],
            [-14.47419324790384, -1.499746206212506],
            [-14.476104238446618, -1.4858904789167329],
            [-14.469971736617937, -1.465409077317668],
            [-14.477218899012524, -1.447505672279994],
            [-14.458782552421933, -1.424331194008799],
            [-14.464368101456948, -1.405995379249027],
            [-14.425389160619975, -1.3883834268114013],
            [-14.449030579766378, -1.3547905535513205],
            [-14.45275099287421, -1.3230931645445567],
            [-14.466162319665727, -1.275356516460739],
            [-14.458654908503123, -1.2380847554850851],
            [-14.442041255747874, -1.2271718069145436],
            [-14.45382758181285, -1.205892679826647],
            [-14.446947833483726, -1.1992043802227392],
            [-14.45575272445436, -1.1652250149639147],
            [-14.437235676410715, -1.148689987993091],
            [-14.394298923238075, -1.1523337245785414],
            [-14.346820553698016, -1.1277455418477893],
            [-14.33334800944548, -1.1413860959391826],
            [-14.298475299896797, -1.1281912112345194],
            [-14.249313819438003, -1.1393281871560326],
            [-14.246559389245434, -1.1636322139814868],
            [-14.220474434579849, -1.1561418412295128],
            [-14.211073770543734, -1.1588723091988034],
            [-14.203484176826413, -1.173156971318667],
            [-14.177322145305734, -1.158208647787012],
            [-14.142420016871107, -1.1676168604189872],
            [-14.136488978031096, -1.1840252486170026],
            [-14.117090372106714, -1.210738399222784],
            [-14.104379979308117, -1.236879594409182],
            [-14.111851272696573, -1.2522523791968203],
            [-14.097921394130331, -1.2710115714757932],
            [-14.083153702192224, -1.279014532746526],
            [-14.079583475873852, -1.3003391649352964],
            [-14.060018647868977, -1.3171123537663796],
            [-14.04271028427811, -1.3184166082122588],
            [-14.010002906841478, -1.3125040290885113],
            [-13.993485213540177, -1.3194179521493266],
            [-13.976494817696175, -1.3013861198610277],
            [-13.969450703516946, -1.280248071721913],
            [-13.948513601371625, -1.2533752621116463],
            [-13.948907851899442, -1.2337678262674174],
            [-13.93202473795297, -1.23088459741404],
            [-13.898568268305281, -1.1788889842992292],
            [-13.87651895431457, -1.1670320709458832],
            [-13.862481124786884, -1.0875839729555754],
            [-13.840491802104612, -0.9827440866317197],
            [-13.823238922984158, -0.8932359166148685],
            [-13.819596509749605, -0.8668393526889139],
            [-13.786376501987917, -0.675057426312751],
            [-13.757927185927638, -0.5219287729939397],
            [-13.727936259507592, -0.36600235568978384],
            [-13.62343578048976, -0.38643324437511356],
            [-13.396724686764585, -0.4292479954822152],
            [-13.124714546375145, -0.4796672271397344],
            [-12.97326546281445, -0.5072909732724957],
            [-12.77830971860178, -0.5422024007283731],
            [-12.553087573220731, -0.5818983772755014],
            [-12.410693634391622, -0.6064250668204505],
            [-12.026874269867223, -0.6718740210988985],
            [-11.847154846743683, -0.7018169478869588],
            [-11.66798278179875, -0.7312069733130415],
            [-11.568824313077583, -0.7484078813204715],
            [-11.455886615739168, -0.7663098150300895],
            [-11.403129812787293, -0.7731158690323874],
            [-11.15628645236416, -0.8113269728955733],
            [-10.960726737729248, -0.8405711285961532],
            [-10.937842315282898, -0.8504829720175557],
            [-10.785935870448025, -0.8733617362893166],
            [-10.472731531033427, -0.9198332359432482],
            [-10.277076215640994, -0.9485355120568365],
            [-10.17492078271948, -0.9623955104160725],
            [-9.822358383519017, -1.011957823660947],
            [-9.854292096483833, -1.2418952602492161],
            [-9.887338230325641, -1.4810814449120027],
            [-9.915414173091197, -1.6819113829585886],
            [-9.944596999624972, -1.8936998524233786],
            [-9.977592270249964, -2.1306952455917916],
            [-10.003235368523328, -2.315080303546561],
            [-10.049480446590534, -2.646114848484998],
            [-10.064588828462691, -2.7595703230917983],
            [-10.104468295790664, -3.049284773050056],
            [-10.130696103689495, -3.237479201332402],
            [-10.157203945374619, -3.4286384161786323],
            [-10.183878432423443, -3.619951729964119],
            [-10.214554255937534, -3.839469110684387],
            [-10.237781221287975, -4.005636678560503],
            [-10.254541094735462, -4.13013808255927],
            [-10.273743632029213, -4.264450246407879],
            [-10.289192281391495, -4.378871973748453],
            [-10.319378453699798, -4.592881083585155],
            [-10.341524809952203, -4.751618966931861],
            [-10.362793963602945, -4.9078017053920115],
            [-10.37912508016368, -5.023439445500565],
            [-10.406301904104422, -5.220888041784823],
            [-10.424708638217094, -5.350333182657517],
            [-10.455048555995198, -5.569169690661018],
            [-10.502006815751734, -5.903245432892877],
            [-10.53228315507816, -6.119318078570261],
            [-10.564914322712212, -6.3508905289586925],
            [-10.587326643077576, -6.505540479952775],
            [-10.607484207250137, -6.651259223088225],
            [-10.703660332388198, -6.637216677638208],
            [-10.799834093784236, -6.623158705193909],
            [-10.887695512436906, -6.610773603712966],
            [-10.975555134487172, -6.598375646751808],
            [-11.119849897660211, -6.57761697521908],
            [-11.264139712445743, -6.556823584499331],
            [-11.408179367507202, -6.536650825784789],
            [-11.52581352020814, -6.518394532913985],
            [-11.660384385663606, -6.498713132828007],
            [-11.79495103132424, -6.479001477078747],
            [-11.935878551846914, -6.456889461357822],
            [-12.076800815181747, -6.434744129212527],
            [-12.249499463810404, -6.409088187928254],
            [-12.311833061835104, -6.399142115526766],
            [-12.426736920735893, -6.333303928810203],
            [-12.541615871037127, -6.267432557496864],
            [-12.617834659994296, -6.2236166833837805],
            [-12.69404259733936, -6.179786426270779],
            [-12.77652058574732, -6.132560842272464],
            [-12.85898608159828, -6.085318717175465],
            [-12.940983212245888, -6.038086674973773],
            [-13.02296805103489, -5.990838458475878],
            [-13.12729753203318, -5.930774557431272],
            [-13.231607406577975, -5.870684946529904],
            [-13.372781937737939, -5.789589929294759],
            [-13.513921340148327, -5.7084490257641605],
            [-13.614847780339996, -5.650126932366202],
            [-13.715756462278698, -5.591781831706286],
            [-13.8164532949026, -5.534404267390564],
            [-13.917133052769584, -5.477004506089251],
            [-13.987690633705364, -5.434355188018197],
            [-14.094199598317367, -5.370614935498489],
            [-14.200688610187923, -5.3068495810100496],
            [-14.299933360174904, -5.24756313889014],
            [-14.399161122011925, -5.188255417387286],
            [-14.48016948413403, -5.139514077857152],
            [-14.561166589243335, -5.09075875746824],
            [-14.672107939149837, -5.023909286750367],
            [-14.783028476993534, -4.9570341260227995],
            [-14.878746245434092, -4.8995103964273605],
            [-14.974448851839604, -4.8419680341240054],
            [-15.093973592107572, -4.770167734691931],
            [-15.213475143654543, -4.698339111631054],
            [-15.205777243290992, -4.685108147045843],
            [-15.207238725605956, -4.668709802287856],
            [-15.195745482592788, -4.6588090349379865],
            [-15.183405366676938, -4.6351419806198555],
            [-15.190365871746716, -4.622540461792047],
            [-15.182386262209334, -4.60299246803472],
            [-15.18571509680867, -4.578301145968346],
            [-15.169827782630701, -4.576655158880932],
            [-15.14371424450475, -4.560564486054974],
            [-15.126023961872072, -4.54208829324364],
            [-15.120288761638058, -4.528417458115479],
            [-15.09199840085031, -4.493052079178924]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.66434934261174,
          "lat": 34.29310711257213
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779777"
      },
      "bbox": [
        -15.213475143654543, -6.651259223088225, -9.822358383519017,
        -0.36600235568978384
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [1.4900723673501624, -9.39086673385287],
              [1.4912582333033246, -9.369801779580483],
              [1.500832254259646, -9.362908442266116],
              [1.5266448739602922, -9.381975083065592],
              [1.5262430021466247, -9.390315508116116],
              [1.5118790504963935, -9.401941490501661],
              [1.4913444880585143, -9.40137752744282],
              [1.4900723673501624, -9.39086673385287]
            ]
          ],
          [
            [
              [1.3952843447464458, -9.13572600780157],
              [1.4039170416246847, -9.131649567185146],
              [1.4135820013972873, -9.145216990699126],
              [1.4056945038555362, -9.15132788469394],
              [1.3952843447464458, -9.13572600780157]
            ]
          ],
          [
            [
              [1.3509160640108318, -9.037335504563124],
              [1.3728620747658504, -9.04322048964565],
              [1.3833472892586807, -9.066877029040832],
              [1.377062798168131, -9.086535965037804],
              [1.368104723688307, -9.08407094377989],
              [1.3598668968019185, -9.053562791653391],
              [1.3509160640108318, -9.037335504563124]
            ]
          ],
          [
            [
              [1.2315547773642952, -9.623774835458331],
              [1.2419849112690453, -9.616518687395036],
              [1.253319993575135, -9.595545818579149],
              [1.282131127757367, -9.577371821392243],
              [1.3029406876268785, -9.560190529809665],
              [1.3130962094177652, -9.557838082980522],
              [1.3208956638638807, -9.538942755995755],
              [1.3464880677680524, -9.523954267845099],
              [1.36994873025501, -9.49548449209018],
              [1.384763538226425, -9.49307418134374],
              [1.4056747793738578, -9.461356148467875],
              [1.4314089261423266, -9.444197143844724],
              [1.4459064492410019, -9.424916300722652],
              [1.47782612121324, -9.414827784495087],
              [1.4924257058441406, -9.404941330111141],
              [1.5122402249311127, -9.405820726746859],
              [1.5325000358660064, -9.393198951358077],
              [1.5393449295211983, -9.377007934657644],
              [1.5737792805168902, -9.382428755693924],
              [1.5390784089616305, -9.408281437204208],
              [1.5154362895766875, -9.42953127107491],
              [1.431445956312098, -9.485131320867312],
              [1.3720241011281609, -9.526251109140405],
              [1.3125908751773858, -9.567354087706097],
              [1.2613010343095161, -9.606273149305842],
              [1.244829530142699, -9.625089111651777],
              [1.2315547773642952, -9.623774835458331]
            ]
          ],
          [
            [
              [-0.5368012831893005, -10.847896022658553],
              [-0.5135273482858157, -10.806943498296562],
              [-0.503492899612714, -10.814560330308165],
              [-0.4951632789165583, -10.796563545585379],
              [-0.48192524720564034, -10.784765341818197],
              [-0.4709283238671683, -10.78871035140458],
              [-0.4676047673309116, -10.811976630019936],
              [-0.4816906903044701, -10.844922037500849],
              [-0.5367328687194496, -10.850980373702397],
              [-0.5368012831893005, -10.847896022658553]
            ]
          ],
          [
            [
              [-0.7310924473891337, -12.093073518197176],
              [-0.6824173257347779, -12.094560674651996],
              [-0.6598216304608913, -12.17427031114581],
              [-0.6359607656541626, -12.262671604189975],
              [-0.6145798080613597, -12.35719610422651],
              [-0.602883985030776, -12.42582110373979],
              [-0.5882035618850818, -12.550053971893341],
              [-0.5935439031492556, -12.548361671089026],
              [-0.5999033125235926, -12.513092234602901],
              [-0.6065714209994069, -12.49574622946343],
              [-0.6033965836531429, -12.463107810768141],
              [-0.6116814711662033, -12.41282867437281],
              [-0.6160565498541397, -12.40193517459745],
              [-0.6187457569671887, -12.368762275260682],
              [-0.6315431196917529, -12.311931488177905],
              [-0.6431234914731965, -12.286188129023554],
              [-0.6376715249013952, -12.279754120541552],
              [-0.6570178800423564, -12.241968706862856],
              [-0.6587871319536515, -12.203455033438432],
              [-0.6690318411274259, -12.155561852522059],
              [-0.6811952653610376, -12.145084326555587],
              [-0.6953422547137652, -12.106799320352858],
              [-0.7152112474229093, -12.096389824042706],
              [-0.7310924473891337, -12.093073518197176]
            ]
          ],
          [
            [
              [-0.791913445178705, -11.793855985727602],
              [-0.7853848441577119, -11.778382355612253],
              [-0.7873795596866059, -11.747734625560861],
              [-0.7802678013921619, -11.70711866771195],
              [-0.7860316532054954, -11.693327457623218],
              [-0.781742519595097, -11.648760042871087],
              [-0.7822866325769804, -11.621030356435568],
              [-0.7775676744573691, -11.5830726637395],
              [-0.7846897906344661, -11.544713035312583],
              [-0.7805680553835616, -11.539414473469042],
              [-0.7774655621176603, -11.49546705922633],
              [-0.7698374383912765, -11.46147920614467],
              [-0.7721783783080706, -11.425806480029905],
              [-0.761290875150129, -11.422459348710893],
              [-0.7527860253135721, -11.400333068616343],
              [-0.7594589786199032, -11.391794377942487],
              [-0.7611187615931876, -11.374675305985612],
              [-0.7476006773291066, -11.365184728661472],
              [-0.7565235819959598, -11.343743610544923],
              [-0.7520853453127487, -11.316005190804503],
              [-0.7286640577327693, -11.27370714609892],
              [-0.7230261155558626, -11.242798967304457],
              [-0.7019303775823511, -11.197590274295873],
              [-0.6931536507496885, -11.186736051400752],
              [-0.6986690201949254, -11.172048102015031],
              [-0.6632817075260617, -11.101204484136527],
              [-0.6398423838665451, -11.0497581571274],
              [-0.6226031943686687, -11.04987362978029],
              [-0.6071559888776132, -11.04132261672174],
              [-0.6012786017730372, -11.028331324148805],
              [-0.6007079868279499, -11.000360679855637],
              [-0.5892580623411175, -10.989392937999266],
              [-0.5691972647957432, -10.94859994154211],
              [-0.5659544713802724, -10.934139799734075],
              [-0.5540987297304091, -10.914845249605026],
              [-0.5359643203919783, -10.908374877754957],
              [-0.5306393056121501, -10.878207775908612],
              [-0.5374974878106126, -10.86054753565435],
              [-0.474458982872122, -10.847688704867613],
              [-0.4736590603293037, -10.86417296094551],
              [-0.5210921154507036, -10.924320835396099],
              [-0.5625877393501695, -10.988597762877811],
              [-0.6035699091355679, -11.06100778853426],
              [-0.638320340137873, -11.132287429247677],
              [-0.6730837005599208, -11.203532330480966],
              [-0.6994635431097205, -11.26787153657791],
              [-0.7136146594017552, -11.30606179383769],
              [-0.7317172029356815, -11.363139038320634],
              [-0.749628775700721, -11.431480778440708],
              [-0.7626510991819124, -11.504448182286803],
              [-0.7692388042888598, -11.565760862887153],
              [-0.7723259401328431, -11.655794123887029],
              [-0.7705971778385141, -11.704169625737755],
              [-0.7665768795740645, -11.752428072363728],
              [-0.7606954411127013, -11.796133280236326],
              [-0.738912192744528, -11.906005989967747],
              [-0.7172601030162373, -11.990875266933234],
              [-0.6885622520002759, -12.089920058961123],
              [-0.7016946582913767, -12.084022313358933],
              [-0.6961667072579666, -12.071577332485278],
              [-0.710112778368179, -12.06181751972029],
              [-0.7178981107778675, -12.039518088098456],
              [-0.7326694395768876, -12.00960758584885],
              [-0.7385676247147523, -11.98817414794593],
              [-0.7722489100617985, -11.885908156635907],
              [-0.7776386031010609, -11.860360217989696],
              [-0.7859402371097022, -11.844052023721613],
              [-0.7836861038825147, -11.821812740289412],
              [-0.791913445178705, -11.793855985727602]
            ]
          ],
          [
            [
              [-5.107072791315379, -2.0167843711479536],
              [-4.940111874323867, -2.0289224054741464],
              [-4.764168514292834, -2.0413119556687644],
              [-4.4398360036543405, -2.0631117966593675],
              [-4.255288181124038, -2.074658131690034],
              [-4.172942430513291, -2.080635739742341],
              [-3.9793644408156594, -2.092410244753107],
              [-3.8075231711016144, -2.1024285322893284],
              [-3.5835679461437127, -2.114896881134512],
              [-3.3972167427478452, -2.1241791541219506],
              [-3.1358861471386774, -2.137479832571115],
              [-2.986529497868491, -2.14430867733275],
              [-2.7207681708797633, -2.1556761897028043],
              [-2.7303749142370908, -2.3836715568328413],
              [-2.740175490060515, -2.6162286787878335],
              [-2.7527620415303593, -2.9148322964338096],
              [-2.7609836109566235, -3.109839118473127],
              [-2.7716882205140982, -3.3636871077595902],
              [-2.7831575443717487, -3.6355763544352535],
              [-2.795188356897902, -3.9206720578837504],
              [-2.8030728865587426, -4.107427701059519],
              [-2.779476261526876, -4.106734568544172],
              [-2.7576760291055415, -4.090436362222133],
              [-2.7385340137122123, -4.100305290362388],
              [-2.7111279029363287, -4.122770777739265],
              [-2.6848375107568025, -4.161530017992425],
              [-2.6602416926718226, -4.176098428120494],
              [-2.654618481269832, -4.198355683789884],
              [-2.6386598508065977, -4.2214401458267385],
              [-2.616359611885866, -4.238830938784932],
              [-2.6077246458796113, -4.255468678229771],
              [-2.577516963776495, -4.27523789778906],
              [-2.5749308055558155, -4.287296436064029],
              [-2.5609350487699105, -4.3005100762028645],
              [-2.547224856119522, -4.299566008268502],
              [-2.5347169899066606, -4.30620290957006],
              [-2.5224670330597703, -4.297990228371158],
              [-2.503211908046801, -4.307511425731294],
              [-2.4833913868912516, -4.307145437734838],
              [-2.4700848085230374, -4.291033410740955],
              [-2.4654611655457956, -4.265609019650465],
              [-2.450833108748326, -4.265487435120115],
              [-2.4245407415083804, -4.27236780513309],
              [-2.400145325058153, -4.275122742141635],
              [-2.390224682165157, -4.287207897243495],
              [-2.3732554675488924, -4.289894194834903],
              [-2.3622992582867477, -4.297984589599858],
              [-2.351157960890333, -4.3155744334564785],
              [-2.344040875294764, -4.305919055143154],
              [-2.3256545880581028, -4.315041354382004],
              [-2.3169566572153824, -4.308500690375713],
              [-2.315618240738987, -4.292145028779767],
              [-2.3082702483747806, -4.27605396462691],
              [-2.3157583118471057, -4.268318881028041],
              [-2.31315941863665, -4.245587947700931],
              [-2.301226012689425, -4.231087409020301],
              [-2.2798758265589596, -4.236951316595322],
              [-2.2818900899911507, -4.246650748851321],
              [-2.259662445812562, -4.26730763139588],
              [-2.2527220430812034, -4.281142478747345],
              [-2.232079691021595, -4.275317265111212],
              [-2.1870586281332987, -4.325812082618867],
              [-2.1848036772256982, -4.339205573540427],
              [-2.1655512453326686, -4.355699132295031],
              [-2.1633957929032643, -4.376632224671009],
              [-2.1692544603446566, -4.382757670813732],
              [-2.165490833782765, -4.4098810844177025],
              [-2.156143530108194, -4.412568064051989],
              [-2.1581349880062253, -4.449867298042145],
              [-2.1528843618603726, -4.480188969490654],
              [-2.11887973256649, -4.486213284525082],
              [-2.0956420596251655, -4.494714716225993],
              [-2.062785148270187, -4.4859611184804935],
              [-2.0336370001534356, -4.500276893602916],
              [-2.0274523810890845, -4.491724877906332],
              [-2.0085432271335333, -4.496034196028455],
              [-1.997983947726425, -4.481871222298249],
              [-1.9820784303996142, -4.482430723113869],
              [-1.9765894335741196, -4.4966921000492315],
              [-1.9568660925781036, -4.489149054182194],
              [-1.9333880564392674, -4.5182627106962885],
              [-1.893612605954502, -4.537972839420344],
              [-1.8652574505203068, -4.547396845728426],
              [-1.8605199271194082, -4.541850284265379],
              [-1.8388492591826293, -4.55075514233741],
              [-1.8074806071359377, -4.569313906348879],
              [-1.8008180825315188, -4.5813077438446665],
              [-1.781814527659367, -4.570675407399647],
              [-1.7460212616771034, -4.574493635519455],
              [-1.710223993715362, -4.543871660745412],
              [-1.6887518037979843, -4.551747133596193],
              [-1.6707013678424905, -4.548848821785278],
              [-1.6524248840954163, -4.561011334622519],
              [-1.638941959257343, -4.577211690662115],
              [-1.6395179873363006, -4.586877984213499],
              [-1.6199849640609776, -4.603702328191757],
              [-1.5945425896259056, -4.639597250178806],
              [-1.580153361993446, -4.649708212858895],
              [-1.5446318461685815, -4.630981095429137],
              [-1.5180748314893013, -4.6257245854899836],
              [-1.5175862446968815, -4.613412015173394],
              [-1.5068114219131776, -4.609421713361527],
              [-1.503368026894825, -4.58262847557467],
              [-1.4919351092784143, -4.564944523936236],
              [-1.4772648310061338, -4.557364280584023],
              [-1.4457463438614644, -4.564253061444977],
              [-1.4254294987589222, -4.5812711736041605],
              [-1.3896328150983415, -4.587249054140605],
              [-1.3686461510018615, -4.583179348476985],
              [-1.3627455630847731, -4.592289700634734],
              [-1.3436192049377664, -4.601082781256997],
              [-1.3182542177726413, -4.604288329538736],
              [-1.3059300348493912, -4.595964429328359],
              [-1.2909840745873062, -4.5739371473034875],
              [-1.2797725803014692, -4.5645939948189715],
              [-1.2683583995356325, -4.565278455111499],
              [-1.2636162727704743, -4.584390342049852],
              [-1.2536345875802863, -4.597886277670483],
              [-1.2653752511638106, -4.621519142209146],
              [-1.278095881199423, -4.635026938068197],
              [-1.2746245390241082, -4.657399833455167],
              [-1.2498054352906611, -4.67860039501133],
              [-1.2622075508634212, -4.696209103163337],
              [-1.2495319556250208, -4.709667256649103],
              [-1.2498511316845942, -4.718081246512002],
              [-1.2157247568697866, -4.7278144588819115],
              [-1.197920832991371, -4.7278440282742125],
              [-1.1583406136680894, -4.716991565650859],
              [-1.1476661551674123, -4.731863103710902],
              [-1.1375353609200396, -4.73453111787997],
              [-1.1501417187753702, -4.770897078136018],
              [-1.146442537763915, -4.784772997277115],
              [-1.148288345417261, -4.80856607349637],
              [-1.1711302399169334, -4.82190172602405],
              [-1.1577039220125223, -4.8405275420045335],
              [-1.132201762815818, -4.84428863865407],
              [-1.0996672809179535, -4.866246538209016],
              [-1.0743106525348425, -4.8753727141123955],
              [-1.0482418673767655, -4.86756766278457],
              [-1.0216871990990388, -4.845685092511562],
              [-1.0208788444345256, -4.831359802118534],
              [-1.002852506167948, -4.821076398738161],
              [-1.0074170464139656, -4.812545702392188],
              [-0.9853430594701417, -4.8073571598220335],
              [-0.9878264976756798, -4.791671049807765],
              [-0.9626708510897031, -4.789827496410528],
              [-0.9497133871104807, -4.779041179583578],
              [-0.9336607189602575, -4.749538787329558],
              [-0.9118933559562736, -4.735824592182807],
              [-0.880807893172628, -4.746519413650486],
              [-0.8607177605609587, -4.760080564175118],
              [-0.8443136823829877, -4.776634339164892],
              [-0.8515594564831167, -4.808297560028738],
              [-0.8388087071806974, -4.8291421389179225],
              [-0.8145057328243434, -4.8312802121804035],
              [-0.7926466897350432, -4.81777328218753],
              [-0.7724926397894973, -4.8101691033582314],
              [-0.7606298114181042, -4.81301462803822],
              [-0.7393121380761162, -4.82644248000465],
              [-0.7317439462887229, -4.839158041676712],
              [-0.7324831277602122, -4.85969551863227],
              [-0.7423198592683089, -4.888816352928839],
              [-0.7344446725829482, -4.9022233285874925],
              [-0.7126799251317331, -4.911724483042338],
              [-0.6685182376997372, -4.912316304132816],
              [-0.6564682405602151, -4.901884910811864],
              [-0.6400909074470864, -4.869948678445634],
              [-0.631552509151963, -4.87672270891109],
              [-0.6195913779123611, -4.865288732723665],
              [-0.6120302732469971, -4.845870585785309],
              [-0.5833654987866301, -4.874581482115157],
              [-0.5657463926333478, -4.85786880493354],
              [-0.5629168735847604, -4.832563685975354],
              [-0.5465367845922138, -4.818421149828459],
              [-0.5336688071530674, -4.817157897513485],
              [-0.5128896533190455, -4.832843996958248],
              [-0.5081769050541116, -4.8413857236611975],
              [-0.49803850549303463, -4.886623265153487],
              [-0.5103900240073158, -4.902467608704895],
              [-0.5287702991534214, -4.911823713566369],
              [-0.5308188054033479, -4.9307852221145305],
              [-0.5187988267076147, -4.952149684700317],
              [-0.5039881117561404, -4.996718221399728],
              [-0.48535741428125995, -5.012577284600046],
              [-0.46618523020326946, -5.017849309634427],
              [-0.4421549347529457, -5.007223663197869],
              [-0.43292112899049184, -4.991148928213757],
              [-0.4318664629491268, -4.969505367543714],
              [-0.43936687666644314, -4.936280054788995],
              [-0.42585669714921287, -4.922157535752392],
              [-0.40069599166708325, -4.917720587097092],
              [-0.4088888224997799, -4.898249941694646],
              [-0.4295468558334709, -4.894312093753429],
              [-0.4325275672664839, -4.881236863982544],
              [-0.41664114409782166, -4.874372534977707],
              [-0.406611106251252, -4.879226259158918],
              [-0.3987850240193981, -4.895554862758691],
              [-0.3783568738511068, -4.888931493071442],
              [-0.35802253690489994, -4.864414605236644],
              [-0.3468924490401635, -4.844520971178073],
              [-0.35567714686091945, -4.803181393328526],
              [-0.3558001656633549, -4.7878516097816775],
              [-0.33712557855189995, -4.799597666319569],
              [-0.2953681541721596, -4.776132268693774],
              [-0.28160677147509927, -4.788674217155201],
              [-0.27695101185026816, -4.802263492516804],
              [-0.2742469053901539, -4.839750423802049],
              [-0.2640346596246908, -4.86835039578225],
              [-0.25051299970950847, -4.883400994008804],
              [-0.23003387707597037, -4.883840311208085],
              [-0.22206272301620933, -4.861885629805246],
              [-0.19089480840903741, -4.868123139095374],
              [-0.17887982643075312, -4.879210912879708],
              [-0.17071224571928517, -4.909853414639236],
              [-0.16431330404762728, -4.912987135539189],
              [-0.12371414310567114, -4.9060470265096106],
              [-0.10567520977117725, -4.887785217433719],
              [-0.09849586588392986, -4.863829199985979],
              [-0.0972946595289443, -4.841423767462305],
              [-0.09100238989240324, -4.825331711840507],
              [-0.07980781835422535, -4.821004719538736],
              [-0.05392582028556337, -4.843455108528097],
              [-0.024796667983944063, -4.842498175929478],
              [-0.018586279194806543, -4.849230302178088],
              [-0.028551726200846856, -4.863068654812365],
              [-0.04064144623520854, -4.869100212911209],
              [-0.05476243139795073, -4.885680192887098],
              [-0.05004177197416214, -4.896676107055918],
              [-0.02037199416922077, -4.910388342348806],
              [-0.00877425154723377, -4.919402660222952],
              [0.029405178318786102, -4.917823125625833],
              [0.0376136608669234, -4.935655631833757],
              [0.03808392464540299, -4.951086541946293],
              [0.050910320248223076, -4.96642100487278],
              [0.08485091384197813, -4.963933290818713],
              [0.09404541428038503, -4.958157416027976],
              [0.11498283131106776, -4.963260680188716],
              [0.13064617665192266, -4.993184715980862],
              [0.15852894766948517, -5.02287853693035],
              [0.1645373800872063, -5.047976189678756],
              [0.1845048461743432, -5.051149674129994],
              [0.19849595939563536, -5.044804907889479],
              [0.20774774234550908, -5.029395114946854],
              [0.20995423360490648, -5.004803054268956],
              [0.21901633085666763, -4.973940955542951],
              [0.2258630180294741, -4.96851083273197],
              [0.24620357538575574, -4.972336872871766],
              [0.27468604321356116, -4.991924210446128],
              [0.2987351511527699, -4.987868077882497],
              [0.31677935774000837, -4.979473573686009],
              [0.32945755735983995, -4.951145479057839],
              [0.3278160883647426, -4.922009941475843],
              [0.3410273424143911, -4.920626549183979],
              [0.3416519885441344, -4.901957162691584],
              [0.36236615205904904, -4.899813572999392],
              [0.381807080696022, -4.909365279387997],
              [0.3812195618129349, -4.891798865011003],
              [0.42347428805950116, -4.903377529873013],
              [0.44758067789280936, -4.8992730130994975],
              [0.465099479904036, -4.888752668935879],
              [0.5121523370277506, -4.878128164574003],
              [0.5248937542208028, -4.854649604899328],
              [0.5913396740046688, -4.900672709939637],
              [0.6053602718216743, -4.903675871886653],
              [0.6107460670131333, -4.883010375127184],
              [0.6279022179030923, -4.878380226669464],
              [0.6529051197574625, -4.894326717558448],
              [0.6684554063641125, -4.878397521221247],
              [0.6594249991820489, -4.865103347671422],
              [0.6644809209527432, -4.84676279594522],
              [0.6837569824862416, -4.843444661280659],
              [0.7022657335872055, -4.854311472508205],
              [0.7234306491181626, -4.8489923216129185],
              [0.7437053870181874, -4.828989860411441],
              [0.7601851944208948, -4.834055278378744],
              [0.7711477721309756, -4.831115933387356],
              [0.7796463579544116, -4.811467665892536],
              [0.7900612151391767, -4.809642081104669],
              [0.7958575094441263, -4.796689711449365],
              [0.8088743500200694, -4.804881227206416],
              [0.8306585635074698, -4.810577320990991],
              [0.8356893394411742, -4.830168322299354],
              [0.8337516734731167, -4.845779735406879],
              [0.8483460619012149, -4.857585125074952],
              [0.8668369795041685, -4.8407131180031575],
              [0.8711519194210795, -4.861418265485555],
              [0.8983965929103106, -4.858152453999689],
              [0.924539255396077, -4.871964566046797],
              [0.9357365137477759, -4.8678658758642985],
              [0.9565930141381052, -4.874019663110452],
              [0.9709202250105494, -4.86967545591057],
              [0.9891653551788738, -4.871406646727401],
              [1.0118930828554848, -4.860962357126639],
              [1.0159467335918484, -4.8521885204013175],
              [1.0358594871690048, -4.862825336963232],
              [1.058105831728225, -4.859547395079921],
              [1.068580737317505, -4.8419280299458585],
              [1.0794627341203316, -4.842991966321937],
              [1.0828983989282537, -4.816907304303858],
              [1.0811896379684023, -4.798540986630514],
              [1.0953371035310158, -4.7871443628238355],
              [1.0971009089249049, -4.777026472218981],
              [1.1106643393070303, -4.77456337161004],
              [1.122906079995465, -4.7826636673416205],
              [1.1461845526899248, -4.789961940644842],
              [1.1568512539669271, -4.798884589911785],
              [1.1874686540105586, -4.804852300494729],
              [1.1789970981143647, -4.820270592334982],
              [1.1910596613772375, -4.8326166963319075],
              [1.2140459838948068, -4.821774888059463],
              [1.206196661908182, -4.845263885947642],
              [1.2213792116904691, -4.853776448023172],
              [1.222629931893599, -4.832908438151167],
              [1.2380605117719974, -4.833920438447792],
              [1.2397374433538784, -4.848284821453574],
              [1.2496096683706537, -4.873266001244592],
              [1.2941407805427547, -4.882956829464868],
              [1.3136475105768828, -4.874255134086926],
              [1.3176139087087613, -4.898197827981977],
              [1.3346600593317166, -4.90576090902524],
              [1.3268147030864745, -4.918720174451009],
              [1.338090953827641, -4.929431568846315],
              [1.3502451300299592, -4.926285511407218],
              [1.353129069328918, -4.943394638388107],
              [1.3733896375946093, -4.966005441529131],
              [1.381614841562336, -4.965732337115021],
              [1.3926452377744871, -4.9855257385801615],
              [1.4137043551253874, -4.994887314941876],
              [1.4290301522736246, -4.993782747151212],
              [1.428707501478405, -4.976145383635701],
              [1.4442216638459335, -4.98312216365109],
              [1.4411414679750678, -4.994922898371617],
              [1.464152246359726, -4.998546689480449],
              [1.4767443520008572, -5.006543231426116],
              [1.4973271619708317, -5.008759494231186],
              [1.4933615208501956, -5.023296518056518],
              [1.5079920314785542, -5.041819901187545],
              [1.5502723949619812, -5.0485450689557885],
              [1.5609010509960415, -5.0394133498705935],
              [1.5799249280404513, -5.048460842666089],
              [1.563342771045462, -5.0684220819219385],
              [1.5744912936705313, -5.07247579482931],
              [1.5892147670086552, -5.067840277180517],
              [1.5970766604950712, -5.051177101660529],
              [1.605802800347581, -5.050881577056612],
              [1.6181545233382846, -5.0689459263884995],
              [1.6366800151440961, -5.052859370594541],
              [1.6451176851460112, -5.079415656601041],
              [1.6622844050222199, -5.070678405243911],
              [1.6659775990761638, -5.085118273710786],
              [1.6471471406805571, -5.094457811019324],
              [1.6613166949086051, -5.102984427726394],
              [1.7001193286591927, -5.110220203054148],
              [1.7108885221497157, -5.105603262926602],
              [1.7153364813237575, -5.092739001057705],
              [1.746324360763717, -5.095622274022462],
              [1.7414187386373994, -5.115106071453628],
              [1.729407084548146, -5.1231649734569435],
              [1.7424335071751038, -5.138096192996021],
              [1.7622647347602243, -5.13887488186274],
              [1.7765940977365662, -5.160462345019935],
              [1.7965359232825546, -5.182788052062095],
              [1.8243775194029486, -5.185922276508394],
              [1.8267975058572767, -5.168395817859903],
              [1.8384574881254827, -5.161702477939862],
              [1.844151122416056, -5.175379843510562],
              [1.862591933643558, -5.176735490942125],
              [1.8714083607854202, -5.151957047923505],
              [1.8848837968277403, -5.1549547967502125],
              [1.8915145247990242, -5.169217136438536],
              [1.9048677522055364, -5.145043271083602],
              [1.9206351022916128, -5.1505582301191515],
              [1.9116342499097265, -5.170743630037739],
              [1.9314020970059507, -5.174243670206997],
              [1.9417894647889538, -5.163795926552832],
              [1.9435917652120793, -5.143689685198134],
              [1.9555545780686352, -5.14489303853454],
              [1.9657455450069916, -5.131695008891224],
              [1.9837590739081268, -5.137144779351379],
              [1.995582836137128, -5.160218456877361],
              [2.019230880958327, -5.158430857525312],
              [2.049881932248935, -5.149300808295203],
              [2.0630814387887733, -5.155638551091289],
              [2.058996261346948, -5.170813930668637],
              [2.082780023528329, -5.171945902362996],
              [2.087057651568523, -5.365910792200888],
              [2.09151095763117, -5.564742451829376],
              [2.0942305385462805, -5.706011006132126],
              [2.09744066216796, -5.853875934858309],
              [2.1008345787192173, -6.03240702270039],
              [2.1051582929457764, -6.238825852925727],
              [2.1099491001767774, -6.455551543926677],
              [2.113380438922474, -6.605010078042756],
              [2.115554355144486, -6.72541308642032],
              [2.1372415531371884, -6.7348696968970785],
              [2.157880250825982, -6.7722063520678555],
              [2.1684018444883506, -6.783389415014158],
              [2.175251651524045, -6.8016105509076565],
              [2.1879146554704114, -6.800776697696232],
              [2.1927187235769607, -6.812319737620316],
              [2.213255918319697, -6.810686590430422],
              [2.2187174272735617, -6.819609308593307],
              [2.240495175944421, -6.827375376668572],
              [2.237032156197055, -6.841791791472574],
              [2.2538336132424797, -6.859515603787642],
              [2.2533104159337376, -6.87437967168075],
              [2.2607902542649523, -6.8806263580704075],
              [2.2612674484403703, -6.899518955838924],
              [2.2797073513239323, -6.915260470276802],
              [2.291705944077884, -6.920114327917014],
              [2.296065974604185, -6.936992425315937],
              [2.3057357257971725, -6.944962348168276],
              [2.29563127824065, -6.971696146234195],
              [2.315314740782217, -6.99382228577333],
              [2.312786958047842, -7.010949594162291],
              [2.3318865959756154, -7.017181284906017],
              [2.3238566767167073, -7.033729099513685],
              [2.3056657006531904, -7.052832118281122],
              [2.3153674070560597, -7.087142404973655],
              [2.313328099027991, -7.1028140723924],
              [2.3035140590220684, -7.106035148054946],
              [2.296266559072017, -7.120670847725026],
              [2.3115250141562664, -7.150463351887447],
              [2.3129959986765796, -7.161005969136058],
              [2.347642582335141, -7.192930593502374],
              [2.3799199513623255, -7.190707646141319],
              [2.3881668755111303, -7.204098465220082],
              [2.405100425937921, -7.202083878804143],
              [2.393713220740863, -7.228198133087697],
              [2.381700145151886, -7.233829066342894],
              [2.3756066954649913, -7.248761062300571],
              [2.3992302319639247, -7.2633380920123525],
              [2.4144312142472724, -7.263489203329449],
              [2.424525323567805, -7.275615237749447],
              [2.4148631707035775, -7.297424360982877],
              [2.4445616894511124, -7.326663168440485],
              [2.4455522640253387, -7.34966467569983],
              [2.4716433837984675, -7.343215503070819],
              [2.4656926633435314, -7.3562474215773275],
              [2.4472840174600217, -7.362256743411531],
              [2.4473053120131536, -7.375606667845573],
              [2.431826922440399, -7.405620239704011],
              [2.4495374759717436, -7.417914913369588],
              [2.4563331845922587, -7.432773016001224],
              [2.470040282178394, -7.442764775677437],
              [2.4880980721613635, -7.441849002525389],
              [2.4953920127943134, -7.452230965015781],
              [2.492983850405342, -7.480500324454462],
              [2.5095317063673046, -7.488968055112812],
              [2.503025491246814, -7.507819540588185],
              [2.50971404749089, -7.536753952717305],
              [2.5200460627238925, -7.547018966811365],
              [2.5532381960727424, -7.525261121087156],
              [2.5666101024275023, -7.527045593991128],
              [2.55423106334388, -7.555844991125612],
              [2.562979488148155, -7.596799283270327],
              [2.5468719443286276, -7.614202632199984],
              [2.553229633420295, -7.632379639056169],
              [2.570052121127474, -7.636303972564649],
              [2.5820897583953233, -7.648614013408453],
              [2.5718497939107285, -7.659008041308144],
              [2.5804655700897197, -7.6740784401995805],
              [2.591864135029648, -7.680605111625873],
              [2.570813602566215, -7.691561111505521],
              [2.5662133811760337, -7.702298363610395],
              [2.543461259119361, -7.6980425221833],
              [2.533056057446077, -7.71139258359569],
              [2.5454067149928035, -7.722994367528751],
              [2.541279877847015, -7.734852051719905],
              [2.57382397121076, -7.751890307216501],
              [2.5792741153019074, -7.772310114024831],
              [2.57540404691788, -7.785333388055233],
              [2.5522253665754815, -7.796857652396738],
              [2.560486167613337, -7.812647177709657],
              [2.5459144938734073, -7.815602317151222],
              [2.5395372120659925, -7.826010501688681],
              [2.554716490450013, -7.8578709307900345],
              [2.545829110092114, -7.867094493625832],
              [2.558809198974789, -7.876616312795082],
              [2.5411541039922083, -7.908597836371677],
              [2.527190253349614, -7.946398442981061],
              [2.507953628152, -7.954438854182633],
              [2.5136733438213943, -7.962469934750281],
              [2.5119831542829765, -7.992090610467606],
              [2.5010291358026944, -8.0092148709938],
              [2.504658093838449, -8.01592212972922],
              [2.4899400171379864, -8.037316392735725],
              [2.475637170918024, -8.040520713123938],
              [2.4522278087419083, -8.070298875129],
              [2.450873507070515, -8.085780130788873],
              [2.457178293538336, -8.11650200174451],
              [2.4273425926683867, -8.123859081208819],
              [2.415431427189185, -8.137377505499371],
              [2.4191361570746706, -8.152023021313022],
              [2.411354992507347, -8.179821176614947],
              [2.4346292181525473, -8.199119689530873],
              [2.4271637968131645, -8.228513010007687],
              [2.442635911762943, -8.251979084176748],
              [2.4432801979724346, -8.272334033711372],
              [2.4258806216185316, -8.283235513569647],
              [2.4040840421143628, -8.313823869996849],
              [2.3949128839069562, -8.31931606365025],
              [2.396685663648511, -8.335096305738746],
              [2.3906425227165213, -8.366025546645263],
              [2.40802935142116, -8.405385485224881],
              [2.4422816474409825, -8.418533087178366],
              [2.4394161707949, -8.442830371810803],
              [2.4418053432298312, -8.468384846073032],
              [2.4313846822181695, -8.489557625957726],
              [2.4317706509146664, -8.499273374820437],
              [2.4527857327231595, -8.555365091073536],
              [2.4484230320629243, -8.593978305284477],
              [2.430447920002731, -8.612816968193224],
              [2.4374074259660152, -8.637415077696044],
              [2.4339913312719426, -8.653416232678813],
              [2.4199843164351567, -8.669350152199726],
              [2.4183229729302074, -8.682551844613018],
              [2.4051263218424768, -8.691572308157532],
              [2.3914519362700917, -8.710957790476675],
              [2.3782916445201434, -8.71655117883729],
              [2.3610631328572325, -8.752604955492524],
              [2.3542820635685953, -8.786227392861726],
              [2.3429170049578185, -8.812571163270759],
              [2.3221534914106665, -8.842970814148856],
              [2.2832599584843924, -8.870664595976903],
              [2.264578029609178, -8.889028706808451],
              [2.259795569891588, -8.910617764480595],
              [2.265608538338979, -8.922389382607024],
              [2.2866634295261776, -8.935251080701452],
              [2.29351718621719, -8.944892859975978],
              [2.2956839579050072, -8.96406272601926],
              [2.3121469068054745, -8.97037446016071],
              [2.3409753418709767, -9.014075020085068],
              [2.341452775168882, -9.025523517476545],
              [2.2416531946933014, -9.023437434275635],
              [2.1992827382518425, -9.026164415041796],
              [2.1516528205977195, -9.0373412205208],
              [2.1177770518311894, -9.048531246522442],
              [2.0408798213980646, -9.081855898221429],
              [1.9471928618892473, -9.125972232556478],
              [1.862443859696161, -9.164026640735939],
              [1.777680580827723, -9.202058388764906],
              [1.7135131655319171, -9.232479208640155],
              [1.6553814289902513, -9.262509391091545],
              [1.6125128737080066, -9.289911327700054],
              [1.5891106126584287, -9.311535537648044],
              [1.5678475484926784, -9.34640753595057],
              [1.5492716114827356, -9.34699208025456],
              [1.5284636724028111, -9.353335346411942],
              [1.5290699689859928, -9.339179020723797],
              [1.5380985655056372, -9.324658737198876],
              [1.5317717767873111, -9.316056970064505],
              [1.5484322546833273, -9.299396706902881],
              [1.5568175957415553, -9.306546345861252],
              [1.5809571519837744, -9.285016573795925],
              [1.5929796058345413, -9.278481505679322],
              [1.5996903763734327, -9.262367405691116],
              [1.615853820162321, -9.241666514598323],
              [1.62560554945358, -9.237664585408833],
              [1.6474187123792976, -9.242286854853461],
              [1.6767356766697916, -9.231620780218808],
              [1.6867245148006846, -9.207333174165433],
              [1.7039110858462467, -9.186946663622377],
              [1.7148290379828988, -9.183597116396509],
              [1.7427710675159576, -9.197053036396412],
              [1.7670423629057814, -9.203041034594845],
              [1.7785811065893773, -9.19377364456907],
              [1.7790894873219105, -9.180390956631758],
              [1.7938054027816406, -9.156984092660217],
              [1.749846287403335, -9.17323918375096],
              [1.747835346578962, -9.161830465421698],
              [1.7288628150494567, -9.142876483392088],
              [1.7150374784497522, -9.140568959534466],
              [1.6801392991696391, -9.155782822033585],
              [1.6320097077697726, -9.168173589647731],
              [1.605655518381457, -9.177912483452404],
              [1.5927412839806177, -9.177512923574403],
              [1.5594318657700528, -9.189657295038984],
              [1.540400174534498, -9.192636931046092],
              [1.5260346739989352, -9.186901445449227],
              [1.5511777881610245, -9.163549081282932],
              [1.5479755368482588, -9.155934845384202],
              [1.5622622835297977, -9.142274966427419],
              [1.5806682335805402, -9.107275444742006],
              [1.5921740267253568, -9.078195374992278],
              [1.5958316019286922, -9.036723254520547],
              [1.6017553739598012, -9.024809265749472],
              [1.5986505904624329, -8.994557033882963],
              [1.5947598822863587, -8.989306633708082],
              [1.5951387279733265, -8.959778644956074],
              [1.5842239017788224, -8.952909745078767],
              [1.5641277525984332, -8.930048364423277],
              [1.4916713176867167, -8.961778164622404],
              [1.4609838511248379, -8.998822474369678],
              [1.4492310808905742, -9.024690158050369],
              [1.4429669283865982, -9.04856307792242],
              [1.4121511334862058, -9.064385802812211],
              [1.4015241204862696, -9.063011950274976],
              [1.3872596554933065, -9.040132160027495],
              [1.3817640664374393, -9.02304668487886],
              [1.354529161357044, -9.018528342725865],
              [1.3506429834135727, -9.012245535206715],
              [1.3201991606296835, -9.015355717040878],
              [1.3477167670227639, -9.044077102390743],
              [1.3314384890738897, -9.056230840511],
              [1.3223539350656748, -9.0710780663955],
              [1.3194879970105136, -9.088247272118243],
              [1.3480459524763266, -9.11867505116909],
              [1.3296905023371342, -9.140355847466818],
              [1.3176270047644512, -9.164870223292544],
              [1.3204671008258528, -9.179549078298946],
              [1.3385147529664012, -9.19926324890451],
              [1.3543993857349523, -9.20756324578817],
              [1.4107378764128609, -9.22174504750459],
              [1.3965876990349972, -9.238116690257149],
              [1.3865509861069065, -9.238023465770533],
              [1.3763438592984167, -9.250490667445495],
              [1.3946927361622175, -9.265575774212534],
              [1.428821872966735, -9.283305919025077],
              [1.4338706781327324, -9.329311195333515],
              [1.451925967868546, -9.348488185088721],
              [1.4301029154039469, -9.360003668740644],
              [1.4170260086231043, -9.360102822233127],
              [1.415841699622348, -9.375958723468406],
              [1.4293196332034477, -9.390258385866755],
              [1.4296647734087302, -9.401905014342942],
              [1.4169722591710419, -9.406593416444554],
              [1.3913380414069219, -9.40091272985302],
              [1.3761547855356826, -9.422430446560313],
              [1.361745202309807, -9.432468155069712],
              [1.3278057063811568, -9.474216847529226],
              [1.3130296990552555, -9.48707829958911],
              [1.3069776921244314, -9.503748708405459],
              [1.2669412258208843, -9.525996539521536],
              [1.252500731482944, -9.537908243667284],
              [1.2430583907378847, -9.532746313532616],
              [1.236130242716414, -9.516224939548433],
              [1.2001729869627853, -9.520964651102533],
              [1.206486877789072, -9.536419742155825],
              [1.2021175781839402, -9.563895683121096],
              [1.191788433951546, -9.593849624146012],
              [1.1977736764416327, -9.612414295705676],
              [1.2068559841128452, -9.616835653974704],
              [1.2302588268642656, -9.643270028192578],
              [1.1726932638393726, -9.688861968564911],
              [1.1189887434165062, -9.734459893330781],
              [1.0816203726697764, -9.775896345582618],
              [1.041797198163924, -9.804401996209164],
              [1.009701612568713, -9.834203473846177],
              [1.0042336571482495, -9.84253291996834],
              [0.9758047987485559, -9.853057954987076],
              [0.9577715231527728, -9.853059904658101],
              [0.9346062094619874, -9.863744181049048],
              [0.8469937315078895, -9.915998584770762],
              [0.7861152839042669, -9.950584180423501],
              [0.7251435513574347, -9.987426178086155],
              [0.6641608931695988, -10.024251721760464],
              [0.609709961590427, -10.054929163841628],
              [0.5602453587370108, -10.079008101284515],
              [0.4852786310295069, -10.112344362727644],
              [0.47379537701573005, -10.116140520559894],
              [0.39039479168046476, -10.154039576695206],
              [0.2827724308148687, -10.209824541804657],
              [0.22545432582915886, -10.244966462411842],
              [0.2026601452722934, -10.26171206479006],
              [0.18159081331548324, -10.282074472681103],
              [0.16176718546166535, -10.287181742127673],
              [0.11938818993682097, -10.323233731664358],
              [0.1202030299968922, -10.32985541829437],
              [0.09940641232069813, -10.361422089390244],
              [0.07280381837628894, -10.385967778212951],
              [0.0050517069221609956, -10.41862779300862],
              [-0.031429979339040987, -10.43802743626382],
              [-0.09480964549868778, -10.478044751811906],
              [-0.14927075344481547, -10.516728694629041],
              [-0.20165548097982355, -10.55737503038709],
              [-0.2557561361210345, -10.602718109849386],
              [-0.2900982999134425, -10.633782550183016],
              [-0.35823649985197686, -10.702435810978997],
              [-0.3890167992088854, -10.737126498648308],
              [-0.42971383063183655, -10.787773324730182],
              [-0.4460120192886007, -10.811035899495351],
              [-0.4649429884135763, -10.850193781452502],
              [-0.4729806903041828, -10.842499282527154],
              [-0.46180940842929574, -10.815277110897688],
              [-0.4632167432014991, -10.799637852768544],
              [-0.45254575691324755, -10.778682550991261],
              [-0.4312210720351121, -10.767903864139553],
              [-0.41400532422940545, -10.743482025329387],
              [-0.40870247131013226, -10.729811536619609],
              [-0.40869466182837183, -10.709055209908822],
              [-0.39361320037536546, -10.676740659519343],
              [-0.36302156288818427, -10.63933912899987],
              [-0.3554470742172088, -10.607671644691708],
              [-0.3378684865190428, -10.595821074968923],
              [-0.3155220367787836, -10.590789757047807],
              [-0.32142117807228443, -10.580671408824998],
              [-0.3093809583309996, -10.563938123145661],
              [-0.2832679871970706, -10.58874557513543],
              [-0.26683928136315543, -10.585204434083778],
              [-0.2537873639504095, -10.574347762158586],
              [-0.25859660915761384, -10.539839497923397],
              [-0.26263450449112064, -10.532823277469248],
              [-0.24218457344564742, -10.513485840117067],
              [-0.1694557811787448, -10.506593273003874],
              [-0.1529620141328616, -10.497851410791114],
              [-0.15727674866214025, -10.48478194166462],
              [-0.12191272255733034, -10.474766144421661],
              [-0.10916188448268985, -10.449301320105738],
              [-0.08256141254730061, -10.434808966824113],
              [-0.06929504118356777, -10.409829047938311],
              [-0.05024621222905854, -10.401119737877222],
              [-0.01958534460827536, -10.397501172101677],
              [-0.014276787302278274, -10.386756239302771],
              [0.0001320412027612829, -10.38037055192775],
              [0.050743382545401894, -10.370881880242186],
              [0.07491413647466584, -10.361145181240133],
              [0.08109147446108611, -10.3408566137606],
              [0.06428919851898655, -10.32456915476207],
              [0.06906280633027997, -10.312690475584839],
              [0.09280425232964172, -10.300999460783318],
              [0.09338336827587647, -10.288692177899074],
              [0.06436709193130052, -10.286817027491754],
              [0.012519944820788846, -10.321232569000259],
              [-0.02152437097265965, -10.334793500116094],
              [-0.05256691862082561, -10.352773037637961],
              [-0.08813378049850872, -10.386515382229838],
              [-0.11602921971593609, -10.384791292141125],
              [-0.12353398561261021, -10.392744048338274],
              [-0.14041171664462, -10.38786496489993],
              [-0.14343994169467125, -10.374440905256893],
              [-0.15860077481075252, -10.354039904943589],
              [-0.15322735441924684, -10.322656713794446],
              [-0.15900274951766036, -10.29929825103667],
              [-0.19627076822133696, -10.291043587147541],
              [-0.20515998597946233, -10.262969374347236],
              [-0.2269366292442825, -10.24884633641002],
              [-0.24106318011995456, -10.222781733996124],
              [-0.26538601415231033, -10.238063514445127],
              [-0.25070884363977164, -10.248444953459307],
              [-0.2356045434045296, -10.245903132194737],
              [-0.21573746132930022, -10.275297560681741],
              [-0.21062575057629007, -10.290828090663531],
              [-0.23009907456894582, -10.301135600411097],
              [-0.25808113300786784, -10.277000565077335],
              [-0.27510351222841983, -10.270700269007172],
              [-0.2919862438693156, -10.283682041500018],
              [-0.29271180163279975, -10.294242053128928],
              [-0.2648859560464026, -10.323723957155739],
              [-0.24131189647560863, -10.337671216800445],
              [-0.2336928376172313, -10.379087073531606],
              [-0.23524724539550732, -10.389390762486213],
              [-0.2511576393703782, -10.410722629784248],
              [-0.24143040753366407, -10.425206684901626],
              [-0.2292030170790286, -10.45661370280759],
              [-0.23015879687323332, -10.47046502333095],
              [-0.25451822588548356, -10.481863864186462],
              [-0.26541570881932897, -10.500231097151143],
              [-0.28386392594997484, -10.518757688286335],
              [-0.2992718547810237, -10.525808987857545],
              [-0.3207675830968679, -10.542864901551411],
              [-0.322514276346751, -10.549626657995088],
              [-0.3451079558215986, -10.559582166795597],
              [-0.3604962675102382, -10.572858017770491],
              [-0.38630201496087074, -10.573354101266936],
              [-0.3720233071421124, -10.548099684076622],
              [-0.36875805737712475, -10.526567007949257],
              [-0.3627392354520413, -10.523750658575818],
              [-0.35272100998444955, -10.498999382168002],
              [-0.3672953631434848, -10.475245975917314],
              [-0.34222777175262026, -10.435759861507583],
              [-0.3762191767364806, -10.454216496258743],
              [-0.37631418776284764, -10.463556960527082],
              [-0.39222051964509896, -10.478387182640775],
              [-0.37249889167273764, -10.501580354669157],
              [-0.37596254134269685, -10.51182232104828],
              [-0.3910037707290594, -10.524987032470646],
              [-0.4063287468716184, -10.571377218517723],
              [-0.42899499210634423, -10.5572796986256],
              [-0.43591116059753776, -10.545943134794701],
              [-0.43661553226068334, -10.513660317562115],
              [-0.4267699193475744, -10.506884205998524],
              [-0.4350107780540905, -10.494249268521958],
              [-0.44861355098581146, -10.508436865535076],
              [-0.4871495219244748, -10.5218406911188],
              [-0.5208819594915166, -10.539223582151235],
              [-0.5340385520839027, -10.549340016923685],
              [-0.5499703947491492, -10.553980163482004],
              [-0.6044483208449288, -10.595939050332088],
              [-0.6188007632031861, -10.615583074801943],
              [-0.5802159332349259, -10.634552109384527],
              [-0.5795487772918326, -10.64842894317393],
              [-0.5651862174845883, -10.644595703674264],
              [-0.5585307559738409, -10.659674453073928],
              [-0.5451322915454302, -10.665894629915861],
              [-0.5096996909490205, -10.61617422993231],
              [-0.4978011428234079, -10.615383935110978],
              [-0.46935041648442233, -10.602242993483353],
              [-0.46283228172333674, -10.593275749021787],
              [-0.46424997832847653, -10.578984660369962],
              [-0.44325412764885047, -10.582393298772452],
              [-0.4541768557989261, -10.618944740162577],
              [-0.4443371896306414, -10.6618856685424],
              [-0.4608023377546765, -10.665716089874822],
              [-0.47732552392761046, -10.69679211635868],
              [-0.4833695135858918, -10.727005570213619],
              [-0.4999351236075862, -10.721358110626964],
              [-0.5303832728645371, -10.767682345028199],
              [-0.5397343166975231, -10.773946097568613],
              [-0.5413772666010124, -10.787698944567017],
              [-0.5677724582113656, -10.820560718729244],
              [-0.593438144727666, -10.864622789885887],
              [-0.6210036448096864, -10.863127876297288],
              [-0.6197806772811371, -10.8494653588653],
              [-0.6322024415452125, -10.837609890704007],
              [-0.6449887239911027, -10.812202985683902],
              [-0.6574645195693923, -10.807511356228925],
              [-0.6798454068092913, -10.808383558146096],
              [-0.7122390402350379, -10.819422959375128],
              [-0.7232770332764239, -10.803877852813681],
              [-0.7590415938505221, -10.811907918392388],
              [-0.78053972538052, -10.810120481276885],
              [-0.7928480640680389, -10.81553156634233],
              [-0.824915374811668, -10.814867427341118],
              [-0.8346202782939336, -10.822414211059666],
              [-0.851399427039095, -10.816196869851641],
              [-0.8641757423397918, -10.80387003797221],
              [-0.8821413938853019, -10.813471840443038],
              [-0.8811080231238804, -10.833307161141148],
              [-0.8570817692026492, -10.841810458518617],
              [-0.8510989257469393, -10.85711811239709],
              [-0.8352276078374644, -10.861163998463176],
              [-0.8108254013899893, -10.85279052114377],
              [-0.794201476727838, -10.863007978764783],
              [-0.7879152208535295, -10.852099160123032],
              [-0.7664027415524897, -10.845932464265537],
              [-0.7601819128762869, -10.853424192609609],
              [-0.7726481049459593, -10.871764693491222],
              [-0.7739955295356947, -10.901694552182462],
              [-0.7584250529634957, -10.934680095324737],
              [-0.7307544214997569, -10.95988260421717],
              [-0.7067030685023761, -10.971306136639953],
              [-0.674751917718153, -10.979640199397133],
              [-0.6532112181145919, -10.992487074807464],
              [-0.6637959151043415, -11.008437258173453],
              [-0.6928941920134947, -11.075785524690124],
              [-0.6889482370681909, -11.08880215110148],
              [-0.7137994629766378, -11.111548629086666],
              [-0.734657730694819, -11.165990527487299],
              [-0.7407726469205776, -11.196352478654326],
              [-0.7559952928491607, -11.233720010487259],
              [-0.7581114602211769, -11.265797026750915],
              [-0.786985490972568, -11.331174950298182],
              [-0.799611271638821, -11.351894741457372],
              [-0.8178794524557993, -11.35930858219437],
              [-0.8322063209307947, -11.359095341597556],
              [-0.8610877760857105, -11.374043432546772],
              [-0.8841805993465605, -11.396018240407004],
              [-0.905497245662166, -11.392209821682801],
              [-0.891890011302823, -11.366618425877968],
              [-0.8737557326092966, -11.361182558692759],
              [-0.878434042409912, -11.349952796519522],
              [-0.8591800978239712, -11.332573332540214],
              [-0.8646195586507316, -11.320957049783608],
              [-0.8563550454517825, -11.301726424403423],
              [-0.8733257570742764, -11.301362383874515],
              [-0.9003122524334011, -11.323078583592425],
              [-0.9058609523468129, -11.332262783990656],
              [-0.9510625260113373, -11.361704567127989],
              [-0.9723950993843444, -11.382937642359545],
              [-0.9850595214824378, -11.381121650420415],
              [-0.9969920662963621, -11.371137193626925],
              [-0.992038082311224, -11.361127785025305],
              [-0.9949553180691795, -11.345837293034561],
              [-1.0111936715108625, -11.34556215727328],
              [-1.0257889953834536, -11.32471677355683],
              [-1.0183668451226833, -11.313208951579835],
              [-1.032339900061872, -11.30534903577614],
              [-1.0356505956282196, -11.294788772262732],
              [-1.0613625201161907, -11.28517527101821],
              [-1.0640673394599984, -11.293776370865887],
              [-1.0519797457369662, -11.311699863159307],
              [-1.0473289998400355, -11.336083195438816],
              [-1.033168589356596, -11.357336782193412],
              [-1.0146342858542816, -11.364548505136547],
              [-1.0206942808388653, -11.380238408596018],
              [-1.0558633912694408, -11.392978107263277],
              [-1.0644283224253974, -11.404963981542542],
              [-1.0083999856771455, -11.39268506172763],
              [-0.9944889523305009, -11.426195432500903],
              [-0.963911132109239, -11.425895314379819],
              [-0.928063061945571, -11.43737697088099],
              [-0.9039443828403805, -11.440415161618144],
              [-0.8861721710696008, -11.434686062119344],
              [-0.8773842449124287, -11.425892968144183],
              [-0.8217304568003397, -11.40789317256848],
              [-0.8075842163245417, -11.414045131598547],
              [-0.8262196641298561, -11.505268750873123],
              [-0.8168055904234982, -11.508303949960482],
              [-0.8200712656704624, -11.523632082143964],
              [-0.8255933437745243, -11.590325848777177],
              [-0.8311226289774039, -11.677172334772566],
              [-0.844225463241143, -11.778806001648167],
              [-0.8043795388220257, -11.783748359307241],
              [-0.8041682551381326, -11.790534312458066],
              [-0.8419410154657234, -11.786838170668954],
              [-0.84780190210489, -11.813073380660366],
              [-0.830539420839038, -11.835504071733286],
              [-0.8522200180891986, -11.8356852953215],
              [-0.8539325877327929, -11.849532469813086],
              [-0.864882987054515, -11.852302450263105],
              [-0.856910771504616, -11.916341082737278],
              [-0.8541004115862265, -11.961804427422813],
              [-0.8372533668614764, -12.020949219942063],
              [-0.8383053076239457, -12.044406217793018],
              [-0.8276533059571934, -12.063707025352267],
              [-0.8171091924180399, -12.116379076660342],
              [-0.8048920414778641, -12.151536545063806],
              [-0.8108418404426854, -12.169199950859436],
              [-0.7814832419299325, -12.170240704428922],
              [-0.752280816621792, -12.241239988494618],
              [-0.731698066991525, -12.295194831464169],
              [-0.7086300289389552, -12.350112351038563],
              [-0.6945526368762857, -12.365370810894738],
              [-0.699239032742153, -12.377903248773608],
              [-0.7107210193525654, -12.384358420256842],
              [-0.7202868301894882, -12.414893408077177],
              [-0.7274509181380422, -12.419648894192349],
              [-0.7080540752780724, -12.450619060118418],
              [-0.7158110594294037, -12.471328863911724],
              [-0.7123615588884872, -12.493885090682861],
              [-0.7003459384849052, -12.51351990109836],
              [-0.7096521960298131, -12.527943491577492],
              [-0.6958065693246961, -12.547821803130569],
              [-0.6662208326243644, -12.559531128499433],
              [-0.6309538322220873, -12.560713957367076],
              [-0.6222813969925973, -12.573311237006775],
              [-0.6201542395411689, -12.592800820322463],
              [-0.5921216996785659, -12.576388907637737],
              [-0.5798742235050828, -12.58019423974755],
              [-0.5817531359722447, -12.600666481794589],
              [-0.5769521943302008, -12.66685772214811],
              [-0.5773982339082054, -12.683472664707839],
              [-0.6010374266572962, -12.672319314667233],
              [-0.6142419073160755, -12.681881675214578],
              [-0.6481745467969994, -12.67703283868869],
              [-0.6679657565459451, -12.68728006366638],
              [-0.694863158827736, -12.683149023113991],
              [-0.6954993999435917, -12.699292329649987],
              [-0.7201843784086835, -12.698690757111523],
              [-0.738996073715949, -12.709727284917294],
              [-0.7601006958692644, -12.702573315410131],
              [-0.7765764304680757, -12.730077955510414],
              [-0.7776458077026592, -12.746925435516125],
              [-0.7707558746504662, -12.759537390450804],
              [-0.780631522566176, -12.772930892476037],
              [-0.7837221407249454, -12.790199760677428],
              [-0.8074883191048245, -12.79083451525512],
              [-0.8336265414710919, -12.787425111365064],
              [-0.8472988309128693, -12.781577315775133],
              [-0.8486212660965833, -12.763230649026157],
              [-0.8605518200483787, -12.74642123240129],
              [-0.8715938692781725, -12.742088594637263],
              [-0.8820565120032541, -12.750271119160471],
              [-0.8962942635143362, -12.749465965383298],
              [-0.8951238751369544, -12.734755278834644],
              [-0.9165355411724269, -12.743912364847274],
              [-0.9256529151039161, -12.714451583838853],
              [-0.9393177626573392, -12.698231380598877],
              [-0.970895225191923, -12.691937337547445],
              [-0.9714902709060202, -12.670678618515087],
              [-0.9900870909322644, -12.673726614794708],
              [-0.9953305773662211, -12.655063862978842],
              [-1.0286703997056892, -12.625257176694623],
              [-1.0208315068755465, -12.617505980314162],
              [-1.027959762778799, -12.605038227550866],
              [-1.0478606776352026, -12.613290844388795],
              [-1.054928002629688, -12.60612322160551],
              [-1.0798471377625556, -12.60080918973142],
              [-1.1480755685789032, -12.60134466139973],
              [-1.1659078479154716, -12.5905544200593],
              [-1.1679819507925342, -12.571978765518919],
              [-1.2127713314678483, -12.578165239989952],
              [-1.2467568833773588, -12.563348364261397],
              [-1.252542031426379, -12.569600671014816],
              [-1.2837370985363517, -12.573114993641482],
              [-1.3036574997926158, -12.566988455222402],
              [-1.319508360334819, -12.57645140018784],
              [-1.329685149296993, -12.56851455344044],
              [-1.34995809670951, -12.562989405020351],
              [-1.3691085126204199, -12.567626142537724],
              [-1.376103910776948, -12.561787216289918],
              [-1.3848748047262927, -12.585209954223265],
              [-1.412558651647256, -12.574765984403841],
              [-1.4181077147326655, -12.558609017581487],
              [-1.4314341126779613, -12.566909482821481],
              [-1.4443601620514082, -12.558533836281775],
              [-1.4730057772902305, -12.563554903164494],
              [-1.4803542118814497, -12.575097228958814],
              [-1.5083319557502912, -12.549832631051633],
              [-1.5233303714054411, -12.570418755659952],
              [-1.548505132852213, -12.547578322780703],
              [-1.5740341469965011, -12.55127453613994],
              [-1.5913702577433104, -12.53042759830421],
              [-1.5933737564662886, -12.510016429896108],
              [-1.6121598124093002, -12.503341942829257],
              [-1.6377350078615478, -12.505430060700078],
              [-1.6507769769234115, -12.48599404328717],
              [-1.6533536831324556, -12.472641355151357],
              [-1.6772465595773236, -12.464499629696283],
              [-1.6944115900147392, -12.466555853443598],
              [-1.724654972877217, -12.438647535248075],
              [-1.746377073820746, -12.42405792306819],
              [-1.7437934466093805, -12.404467286123051],
              [-1.7639463171006091, -12.397798126688452],
              [-1.7983860536798262, -12.412470059705996],
              [-1.7985883028136316, -12.400393356906942],
              [-1.8175990276250387, -12.400519741274103],
              [-1.840245729423986, -12.38726417633784],
              [-1.8563764945816088, -12.394334468138469],
              [-1.8697355641707025, -12.386149888434257],
              [-1.8759727396204255, -12.36387139485483],
              [-1.8990439930242997, -12.36818609774072],
              [-1.9067808434992741, -12.362118140235387],
              [-1.917794105114637, -12.37579002902606],
              [-1.936852293995312, -12.38340933229733],
              [-1.950564501306798, -12.382685326077985],
              [-1.9590274291995577, -12.37350523676199],
              [-1.9627628037042426, -12.355146144144062],
              [-1.9938882181963062, -12.347474503083989],
              [-1.9932637712756598, -12.332143215324795],
              [-2.0266953800813603, -12.28881101392245],
              [-2.03736693413725, -12.29400818932956],
              [-2.056678271613799, -12.287380029656148],
              [-2.063420136122582, -12.259462008252354],
              [-2.0713985364563046, -12.250256426700311],
              [-2.0894947489842157, -12.250063750311687],
              [-2.1025965979145105, -12.259511884350305],
              [-2.123306466026402, -12.252776894131996],
              [-2.15257919023691, -12.263480382051506],
              [-2.157830329235066, -12.245251834656898],
              [-2.2054590015854267, -12.238387968529674],
              [-2.2022371981805757, -12.22475554533255],
              [-2.2219664554121654, -12.215011976887787],
              [-2.2322173390939306, -12.222805667464705],
              [-2.255105870579629, -12.222377026297972],
              [-2.26390191608173, -12.207158322568104],
              [-2.277476449755331, -12.200997513955745],
              [-2.3004731919957493, -12.216230554828853],
              [-2.3184668633069716, -12.216497205788434],
              [-2.3247809266231574, -12.205052537694758],
              [-2.343537503022771, -12.186816790680687],
              [-2.33551593930725, -12.171389894148296],
              [-2.324563165692571, -12.138219488795762],
              [-2.3358834229749332, -12.11518446990175],
              [-2.355577383367241, -12.090412859854574],
              [-2.390322486083247, -12.078722838147335],
              [-2.3901331954513036, -12.055497733001657],
              [-2.397719745017963, -11.996435920295767],
              [-2.416733012919362, -11.960931286077903],
              [-2.4239561240912946, -11.92424997163928],
              [-2.4219868342095396, -11.894350321377111],
              [-2.449244427675346, -11.872938742664608],
              [-2.449983558529428, -11.83166816401293],
              [-2.4668028057705116, -11.804445423054926],
              [-2.4716135810743376, -11.777484330481531],
              [-2.4817496364763136, -11.762702102532499],
              [-2.494666483663765, -11.755075928534744],
              [-2.514044006819843, -11.754035270073196],
              [-2.5244605494127583, -11.740121632775631],
              [-2.517166573962161, -11.714008513362879],
              [-2.530495359602531, -11.698060107145531],
              [-2.5569615042837444, -11.691036562032163],
              [-2.5754341419755336, -11.675610680549932],
              [-2.5790880230993527, -11.65619102335465],
              [-2.564579479547152, -11.647163469270085],
              [-2.587387784696307, -11.623442518854851],
              [-2.5972348577776807, -11.603727659700901],
              [-2.6148818171921406, -11.608335534313362],
              [-2.6244361070379436, -11.596824905991868],
              [-2.6233178001499975, -11.577279083903397],
              [-2.628596992423916, -11.558355911402629],
              [-2.6120496961136017, -11.543499886465385],
              [-2.607707813565294, -11.527714370556708],
              [-2.6176529906585912, -11.517106541457771],
              [-2.606843057524263, -11.496807283499816],
              [-2.6124477451553685, -11.469790124030789],
              [-2.601276776839807, -11.448597031675272],
              [-2.6062170591021245, -11.414258212090894],
              [-2.6164708008231776, -11.402144074726898],
              [-2.6122172370855488, -11.376367757185992],
              [-2.63098623886319, -11.357633394921903],
              [-2.6468163661462287, -11.365308611814376],
              [-2.660614630940959, -11.353377801422404],
              [-2.6527766863740134, -11.33866962460103],
              [-2.6576546743571625, -11.322420439667154],
              [-2.6888545029453543, -11.318840832528815],
              [-2.6957052963703614, -11.307332051130095],
              [-2.680670476930891, -11.300855291224353],
              [-2.6650649010437855, -11.286670468416354],
              [-2.667556316647425, -11.272571195513493],
              [-2.6526457114298956, -11.247462719068787],
              [-2.647358514846502, -11.216524625130425],
              [-2.653681468513134, -11.190427571656613],
              [-2.6526889279849364, -11.178123116012767],
              [-2.637572315456134, -11.152177851936393],
              [-2.6391677647600704, -11.142319533819823],
              [-2.652445241464615, -11.130664728095516],
              [-2.6805428725496503, -11.130827645550143],
              [-2.6731747855066677, -11.086927768476395],
              [-2.662809897013517, -11.067365269399508],
              [-2.6791572442885934, -11.051411080371912],
              [-2.688657801254855, -11.025846779630337],
              [-2.7034654439410697, -11.022454502697505],
              [-2.722707795456387, -11.028260447222047],
              [-2.7203763796724703, -11.011778470211535],
              [-2.7421388630406853, -10.988679137530005],
              [-2.774194048888798, -11.002377309084153],
              [-2.7978702399338116, -10.992477081533698],
              [-2.7905087151235257, -10.981194892191304],
              [-2.7996103733403395, -10.968932688857947],
              [-2.8151714785770485, -10.96689757273949],
              [-2.8315061298685826, -10.972627450007444],
              [-2.8461105085971914, -10.961111110744353],
              [-2.859571061839226, -10.935034823177755],
              [-2.8763311197660766, -10.915236771216701],
              [-2.887258356717693, -10.894966594168519],
              [-2.9058682016853585, -10.894391837529657],
              [-2.9143301613004846, -10.884476241311189],
              [-2.9232003024056925, -10.852630537082232],
              [-2.9432121800075066, -10.862675647785993],
              [-2.9499828134306343, -10.85652827447609],
              [-2.95594188359074, -10.831733890595762],
              [-2.979718194401197, -10.824177629644096],
              [-2.975734662634757, -10.809721923756669],
              [-2.9764557252290933, -10.787840064929407],
              [-2.9812834879819436, -10.775480016392255],
              [-2.9979901212846376, -10.761322001910372],
              [-2.9995864815281004, -10.745994036400562],
              [-2.9902577368760164, -10.733436715913959],
              [-2.9947825964786676, -10.714453701629315],
              [-3.0099476912642995, -10.708128001449593],
              [-3.0172165517262575, -10.69059523471572],
              [-3.026458319204688, -10.685349592057788],
              [-3.027139687683424, -10.672071854502928],
              [-3.020070160149933, -10.645989938224488],
              [-3.047377303241872, -10.642356866765146],
              [-3.070889256589085, -10.632235088343094],
              [-3.0853717263567866, -10.60417309779744],
              [-3.0927865390971974, -10.560827750339481],
              [-3.1230862505075048, -10.540005015895051],
              [-3.124575687146413, -10.523847135073884],
              [-3.143018620060159, -10.496074514472244],
              [-3.1473185721344827, -10.480812559644436],
              [-3.1788432081609264, -10.468139201107178],
              [-3.197269654636498, -10.455026455191254],
              [-3.212184528212541, -10.455071574416865],
              [-3.226208943206904, -10.442693231607356],
              [-3.258751297836339, -10.424536064744565],
              [-3.262227936880971, -10.394522547682262],
              [-3.2672153020625543, -10.38616684132429],
              [-3.2871897496043605, -10.38640206899927],
              [-3.2971412122445862, -10.379830308419296],
              [-3.3273823761058825, -10.33524996973233],
              [-3.319054567176003, -10.311885305931428],
              [-3.3209253806071297, -10.303524910192754],
              [-3.3421584808674063, -10.274210950484864],
              [-3.3443236837201544, -10.262794520843567],
              [-3.364771782037336, -10.234789718838071],
              [-3.3707662089024146, -10.217175954867756],
              [-3.3577067206606825, -10.190663195263681],
              [-3.36153248695334, -10.171433806208599],
              [-3.383282824088308, -10.145656662400043],
              [-3.3557460289820376, -10.130252201650306],
              [-3.353378642791818, -10.12191139021698],
              [-3.3985651973071827, -10.106396740606375],
              [-3.413479000037755, -10.084322614298259],
              [-3.4183231431964916, -10.06824902925653],
              [-3.404789775094229, -10.045519373936239],
              [-3.407020770874116, -10.034346708035411],
              [-3.4342081576015913, -10.02263220206817],
              [-3.4472172037112476, -10.01043449992877],
              [-3.4443760411404316, -9.979768214205448],
              [-3.459377438371653, -9.978349098123065],
              [-3.473456564774415, -9.9640564046951],
              [-3.489479027352565, -9.95900013710391],
              [-3.498491498469192, -9.927952486638059],
              [-3.4939874257689745, -9.879063793738355],
              [-3.517519595662637, -9.841504578778185],
              [-3.5156340151967163, -9.813755632718417],
              [-3.524758606308664, -9.79369605271848],
              [-3.5486082958826306, -9.789641748208995],
              [-3.546167331124655, -9.770373458604398],
              [-3.561277294179202, -9.755280769965818],
              [-3.5603782782970828, -9.746134883535964],
              [-3.5791426909040567, -9.716565890010685],
              [-3.600846271118498, -9.700927262445564],
              [-3.6000200657648898, -9.68979732368446],
              [-3.6096502775846395, -9.675182853887005],
              [-3.603310251114376, -9.631676081266464],
              [-3.615439566200089, -9.57032572134413],
              [-3.6148665934561595, -9.544588627969215],
              [-3.6229011519145713, -9.518932749123735],
              [-3.63757499121178, -9.502975413822671],
              [-3.6527591700113824, -9.497837588008142],
              [-3.6760959537458975, -9.477555282838887],
              [-3.677174395784818, -9.466245740168592],
              [-3.6916439177260463, -9.460062002241045],
              [-3.707648408334227, -9.442181085655909],
              [-3.6984051025383335, -9.430296739799612],
              [-3.7046305914820157, -9.40641744788555],
              [-3.7229320524042175, -9.368766632039874],
              [-3.7539074945648445, -9.352941736959968],
              [-3.772731402527319, -9.337908343281518],
              [-3.7913405864019007, -9.331835769549718],
              [-3.79755027523546, -9.304865929760794],
              [-3.8130115355402663, -9.29996830195463],
              [-3.824100357140395, -9.28741346449413],
              [-3.8430859083605493, -9.277587635559577],
              [-3.8496287545791, -9.263285099663403],
              [-3.896803549163394, -9.24352878020943],
              [-3.906515273255711, -9.220786704276549],
              [-3.9228182400247626, -9.201322891304661],
              [-3.9274396335246764, -9.177585095108999],
              [-3.9386844705661517, -9.166227302300916],
              [-3.940510630668195, -9.148448168883395],
              [-3.963411519316488, -9.136609356308806],
              [-3.9878980424916604, -9.136254714669722],
              [-4.0002142360812645, -9.125750177265981],
              [-4.0192757452240615, -9.126130253164654],
              [-4.03501057223743, -9.098641991851233],
              [-4.03630830691812, -9.088073842523256],
              [-4.052417497417104, -9.081549590056797],
              [-4.0891391365314025, -9.075039523051158],
              [-4.106433746587492, -9.078558610249738],
              [-4.110980517235896, -9.062054579269997],
              [-4.092007460804774, -9.034748962430879],
              [-4.099545956166984, -8.996012560139514],
              [-4.096779958542127, -8.976370023030535],
              [-4.112797989625636, -8.969698701669296],
              [-4.12342110599035, -8.984148854909947],
              [-4.122485001900588, -9.007931204406106],
              [-4.134920078466084, -9.026355904933911],
              [-4.1522064863858485, -9.011618072755274],
              [-4.151924051770347, -8.986329482964978],
              [-4.138988091252998, -8.957898542784301],
              [-4.150869571223496, -8.938797456950958],
              [-4.177168662350434, -8.934307274033449],
              [-4.18799839110809, -8.946500856126054],
              [-4.200054299373102, -8.915218957918482],
              [-4.2008539122203805, -8.893775620029515],
              [-4.219907499933483, -8.877665820209494],
              [-4.2206805927584705, -8.856751266801261],
              [-4.233150459936245, -8.847677142687491],
              [-4.219013606470074, -8.835055683065349],
              [-4.226764204270718, -8.824185631157942],
              [-4.250129314874948, -8.840856034305867],
              [-4.262958168066972, -8.839294462220385],
              [-4.270561480472442, -8.802676810847693],
              [-4.282492436006952, -8.805885314522687],
              [-4.308029726971129, -8.825549156557148],
              [-4.339345539872779, -8.82653053201028],
              [-4.333633177978684, -8.791296290727656],
              [-4.338835026823229, -8.77801745893484],
              [-4.361915365276851, -8.78862376983372],
              [-4.371691893993661, -8.8173844233612],
              [-4.398202887560575, -8.811325477636348],
              [-4.417859789888438, -8.815077737925133],
              [-4.432658501390054, -8.828496817368361],
              [-4.4455357548432906, -8.81092422483396],
              [-4.4626050792101095, -8.820312951396852],
              [-4.4693872718109, -8.809581255198035],
              [-4.4890003849828535, -8.816773577697822],
              [-4.503857897852945, -8.806911233266561],
              [-4.524702939637592, -8.799897808079978],
              [-4.5386310286491485, -8.78930409467011],
              [-4.553852796415777, -8.796284007343456],
              [-4.573386230819002, -8.79081391535506],
              [-4.565805261439978, -8.771880119394174],
              [-4.584075476758308, -8.766009244145595],
              [-4.579595714244435, -8.783816923355939],
              [-4.597018671338612, -8.778636011970388],
              [-4.606510868278159, -8.765016118886935],
              [-4.635059576464911, -8.7775363653871],
              [-4.643290087529466, -8.77266620948886],
              [-4.662843795256148, -8.773533124970827],
              [-4.689748222872579, -8.766381233925463],
              [-4.702698278416547, -8.768925678426283],
              [-4.706897376256476, -8.75366008333006],
              [-4.718752724076008, -8.750648262312362],
              [-4.749044292467548, -8.766473971489333],
              [-4.756550076168739, -8.760338206115874],
              [-4.771578644668296, -8.762992418588794],
              [-4.772750760364925, -8.772758822105898],
              [-4.800566217764466, -8.773733378037043],
              [-4.809393813621326, -8.765211217108387],
              [-4.830696705562894, -8.766692074042716],
              [-4.842484644197159, -8.755822989630794],
              [-4.858982561223521, -8.754233222743338],
              [-4.873186127857558, -8.741923726146332],
              [-4.888082729922006, -8.715335953223695],
              [-4.898816755678933, -8.70827638300272],
              [-4.926782383128635, -8.712523331064784],
              [-4.960434269668126, -8.696756270341298],
              [-4.991653947579993, -8.671465917161985],
              [-5.008197782864382, -8.669083352890539],
              [-5.013329857504329, -8.684660626736084],
              [-5.0264901037031, -8.677470462094702],
              [-5.048416127936549, -8.699734404689208],
              [-5.047481131385851, -8.711922552838706],
              [-5.06244343838495, -8.743636773147518],
              [-5.074370269772148, -8.760251653781859],
              [-5.073069312557533, -8.77705876223677],
              [-5.092966709063301, -8.776737938266468],
              [-5.114083036925955, -8.76339107314262],
              [-5.134264137696417, -8.764001665090836],
              [-5.1407236978727555, -8.754773714020908],
              [-5.153209505465214, -8.761500059952327],
              [-5.1585415930963165, -8.750658432233879],
              [-5.179638051292892, -8.762520361095909],
              [-5.182578212597696, -8.769673869567917],
              [-5.214225053772191, -8.788498590948182],
              [-5.229165565341883, -8.760847262933675],
              [-5.234025143953965, -8.775122808701726],
              [-5.248725216081551, -8.781444356126974],
              [-5.269915568311249, -8.781127499659458],
              [-5.279077900405674, -8.79194425294972],
              [-5.293641741810348, -8.7940368863415],
              [-5.312633557424294, -8.790127575869214],
              [-5.32307410543644, -8.781025702160939],
              [-5.339748401920775, -8.802863050597406],
              [-5.338977026976887, -8.819202793448179],
              [-5.346079868366349, -8.824745264538674],
              [-5.354281325522099, -8.851433119304032],
              [-5.362862473655191, -8.864009636177991],
              [-5.390045279794067, -8.887404050094789],
              [-5.390515633412324, -8.920528497019294],
              [-5.415404989005301, -8.923044781529311],
              [-5.4112021305664255, -8.93848175299346],
              [-5.425530150064826, -8.955278089112955],
              [-5.42548623531535, -8.969371978556675],
              [-5.437194550388239, -8.972076969926643],
              [-5.440861077030552, -8.982944453261522],
              [-5.455578914772835, -8.991929455842422],
              [-5.456420202511422, -9.01990322687218],
              [-5.465385076411987, -9.042050962979186],
              [-5.480518301679851, -9.067439786921335],
              [-5.4792586989505185, -9.114368474851688],
              [-5.488493910711139, -9.131975200969558],
              [-5.497953692829718, -9.136074766030465],
              [-5.493954466766272, -9.150952584134682],
              [-5.512928231821026, -9.156910713818526],
              [-5.527875035585507, -9.15286980650741],
              [-5.535917050105907, -9.185796970653833],
              [-5.544164820816312, -9.196610053430486],
              [-5.541370299454024, -9.213829974094068],
              [-5.555331509289571, -9.227851415992086],
              [-5.559250870225101, -9.242115146655022],
              [-5.544352838649527, -9.259447078656605],
              [-5.5302254796289345, -9.264401190348648],
              [-5.529071180820859, -9.283021953919816],
              [-5.537982003005772, -9.290474705452956],
              [-5.568583942186852, -9.296628598970194],
              [-5.57493212828724, -9.304186255278564],
              [-5.596965719011304, -9.309504386355366],
              [-5.608270921595101, -9.321556802839353],
              [-5.623050556698505, -9.313062611449336],
              [-5.645359416737426, -9.321333273350465],
              [-5.644404531676444, -9.335673900981684],
              [-5.656402073288705, -9.34757948253009],
              [-5.684181660274513, -9.394538464916327],
              [-5.700284182149661, -9.391479692066865],
              [-5.723506395613375, -9.403380305037528],
              [-5.721466248251714, -9.414215568889608],
              [-5.742928467964097, -9.427837488888398],
              [-5.750063776955381, -9.450092705147323],
              [-5.743441081167137, -9.461041076256398],
              [-5.762371101128235, -9.486148158259763],
              [-5.761819429014818, -9.500947751476154],
              [-5.779069616666485, -9.501393790524174],
              [-5.797148667104594, -9.511819539054374],
              [-5.810637645631862, -9.501964479845514],
              [-5.857714871717561, -9.489147266480414],
              [-5.879427276655629, -9.496862942303258],
              [-5.892869347070254, -9.480567315887434],
              [-5.9056744025302645, -9.498351308551463],
              [-5.909852933867255, -9.475056152433899],
              [-5.9239775971722, -9.46660215435627],
              [-5.9275160807717855, -9.455309670125121],
              [-5.947956635322294, -9.456274844209396],
              [-5.951677625055118, -9.444995242228783],
              [-5.942692806924106, -9.434321160745053],
              [-5.957672033060904, -9.42704132754799],
              [-5.973185858452813, -9.452205943240271],
              [-5.996956790274291, -9.444508299848064],
              [-6.0197615805602, -9.429471486003175],
              [-6.047693003468052, -9.400116204787826],
              [-6.067951831197032, -9.392900523812337],
              [-6.063838297876899, -9.37895689081535],
              [-6.075527596788943, -9.369150532604287],
              [-6.087553746844451, -9.347073841611888],
              [-6.108471917224193, -9.340398189094994],
              [-6.106719218423414, -9.325273607126913],
              [-6.128228487362079, -9.303984101589776],
              [-6.165185596723703, -9.306994961192991],
              [-6.179784833435445, -9.29049380366707],
              [-6.205603960659596, -9.292967321407133],
              [-6.259878477120117, -9.265398853207806],
              [-6.273147160541269, -9.267590410986909],
              [-6.290958679655378, -9.239225878759816],
              [-6.291281010477792, -9.22603595138999],
              [-6.3069293455502775, -9.214046999464392],
              [-6.324090259380437, -9.217375052875246],
              [-6.316382912826711, -9.198230861456796],
              [-6.3227599898977775, -9.180377569380536],
              [-6.341603858069991, -9.183810359326985],
              [-6.347572725766833, -9.16994886865461],
              [-6.359127054014751, -9.173723907473626],
              [-6.368899080978348, -9.1639163649405],
              [-6.390594054966521, -9.161236183994761],
              [-6.421185540197789, -9.15061641093518],
              [-6.438441787787323, -9.151540274946482],
              [-6.474246591529413, -9.13509245734697],
              [-6.486500798512268, -9.136695195564219],
              [-6.523562910984476, -9.11792670781958],
              [-6.5534140418788756, -9.096549474222293],
              [-6.552835421983119, -9.090261995795014],
              [-6.575214641184394, -9.079844758979009],
              [-6.59662961223683, -9.050136287715063],
              [-6.607068611829886, -9.05189160979483],
              [-6.61778770796673, -9.038303327997099],
              [-6.6308773146328805, -9.035531267064902],
              [-6.645834761459377, -9.023763131118411],
              [-6.654653421383757, -9.008525348920227],
              [-6.6544202377929205, -8.997177526393806],
              [-6.664027888626914, -8.977755258557066],
              [-6.678343303972676, -8.968191806009601],
              [-6.673797942193274, -8.93763786931143],
              [-6.693103546481469, -8.937867224348699],
              [-6.69399129920278, -8.924238400428164],
              [-6.716694921459717, -8.90173095207144],
              [-6.746146084901713, -8.888612604824038],
              [-6.782329169892257, -8.889603188707897],
              [-6.809622914288655, -8.863522484283294],
              [-6.828094872305082, -8.849782673368438],
              [-6.8309956118284845, -8.833424578074121],
              [-6.8738678955523715, -8.798559971772914],
              [-6.885677536373588, -8.79192528320401],
              [-6.8922127270841385, -8.772805726452429],
              [-6.910104199192098, -8.759629412576578],
              [-6.925488604731439, -8.757382418200367],
              [-6.931821356021855, -8.729545318476331],
              [-6.942615394390069, -8.71809193895118],
              [-6.933860815805552, -8.70616049972206],
              [-6.944795543777515, -8.700316766248314],
              [-6.943918048090309, -8.681297089554086],
              [-6.949756116932663, -8.67313215249219],
              [-6.945967717462486, -8.656179059397598],
              [-6.96237525679579, -8.642580436449537],
              [-6.957017850883169, -8.625573766912417],
              [-6.976315604231299, -8.596080847184309],
              [-6.988591895156154, -8.565391712311449],
              [-6.991744512161186, -8.547421146087096],
              [-7.00515209927249, -8.538939864454731],
              [-7.006330934974774, -8.521768970257655],
              [-7.026307718133026, -8.499022935043262],
              [-7.025748403084917, -8.489276569380488],
              [-7.037920025770748, -8.479109988423861],
              [-7.043006769150557, -8.453627524142384],
              [-7.039210823682955, -8.412930380830298],
              [-7.045698270579403, -8.383404742223515],
              [-7.041764551991925, -8.37493580827773],
              [-7.053282682445076, -8.364679999816884],
              [-7.045000013624049, -8.352392043189166],
              [-7.053334759516017, -8.338340310924579],
              [-7.032267703718171, -8.308768469521873],
              [-7.037895856366232, -8.288801730414292],
              [-7.03671987469797, -8.2572066830601],
              [-7.029802018553644, -8.241935759028639],
              [-7.024287299824462, -8.213678799737332],
              [-7.041330440225216, -8.166631461749278],
              [-7.0415838698652875, -8.153035406933606],
              [-7.057188235255943, -8.128449778261963],
              [-7.072202608577806, -8.12466590204536],
              [-7.0791608560673, -8.11540075138931],
              [-7.077141098166954, -8.08739955246955],
              [-7.089414614231902, -8.077284376682078],
              [-7.105288491218555, -8.055210260438358],
              [-7.117479713624541, -8.05083836800024],
              [-7.113756660339912, -8.022142824361294],
              [-7.135725004217339, -8.008996180627362],
              [-7.153073251498221, -7.990947065024115],
              [-7.149560373816294, -7.972792798716855],
              [-7.154995204905989, -7.93743886890516],
              [-7.1517875680241625, -7.916938530411227],
              [-7.155549267133074, -7.886268533638242],
              [-7.152451685463787, -7.870946958278436],
              [-7.170054049865921, -7.809942634745585],
              [-7.177746253067762, -7.794454802554709],
              [-7.193796927054609, -7.779002903126692],
              [-7.228784110408057, -7.764697877971877],
              [-7.2366051383104395, -7.739076765690932],
              [-7.235923441220431, -7.711528044461587],
              [-7.247810902413648, -7.7007289232016],
              [-7.251771097127471, -7.6865130691724675],
              [-7.287376997811529, -7.689086048056723],
              [-7.303056114940114, -7.665907568550706],
              [-7.326402094364101, -7.649481114156269],
              [-7.341834024921063, -7.614571062850145],
              [-7.37725603393638, -7.607656595999667],
              [-7.370738810251661, -7.592233174404124],
              [-7.388545742184147, -7.5919593551501725],
              [-7.402356372114664, -7.566604958686158],
              [-7.419712622638969, -7.551205583431442],
              [-7.440633819836291, -7.55295727923395],
              [-7.455138276444932, -7.5590138013807415],
              [-7.462692912272429, -7.543655115291966],
              [-7.481276946651051, -7.524912435152638],
              [-7.50391312191772, -7.538014897465408],
              [-7.504929039913382, -7.521469382447665],
              [-7.519998254186186, -7.506988818718847],
              [-7.551884816032879, -7.495350144045377],
              [-7.566924533240962, -7.493802763242007],
              [-7.563049742944593, -7.466845049356457],
              [-7.571383870277595, -7.46277472406393],
              [-7.577625216573011, -7.442291421150892],
              [-7.600868342576293, -7.430295827632646],
              [-7.607294655178364, -7.414117073157151],
              [-7.636449980797131, -7.392784328403315],
              [-7.644420378054744, -7.369328012348124],
              [-7.656449229457869, -7.368003752309033],
              [-7.669972847650549, -7.348428494188473],
              [-7.68983125281317, -7.3418127294737054],
              [-7.7074636635315406, -7.302140432765626],
              [-7.707413555811172, -7.272661970346541],
              [-7.715960321248857, -7.26328682914942],
              [-7.722563182961931, -7.242429331587094],
              [-7.739239420710076, -7.227229771388609],
              [-7.752099272279166, -7.225102674624532],
              [-7.755718044626651, -7.208201393188803],
              [-7.805115280717793, -7.182708213810111],
              [-7.812333817202503, -7.169178762175217],
              [-7.829459283856797, -7.1522053280749835],
              [-7.856085650060831, -7.146961370379404],
              [-7.862470597583647, -7.114194193606021],
              [-7.8703607125087665, -7.110121574671447],
              [-7.900787989060309, -7.062369143266937],
              [-7.924755714684809, -7.01783409317204],
              [-7.94762753171139, -7.011151622248901],
              [-7.955797185095227, -6.990620865285976],
              [-7.97589502219793, -6.988183478445422],
              [-7.9860108747711065, -6.960334773633563],
              [-7.982951320290351, -6.947292831566472],
              [-7.988453709589505, -6.935155595733887],
              [-8.002131818757848, -6.932536938762969],
              [-8.028796423746217, -6.903171648795393],
              [-8.087086767769291, -6.891924270675143],
              [-8.095536837973086, -6.887135775765668],
              [-8.116168819362455, -6.862769333410525],
              [-8.133401063244433, -6.859147097041654],
              [-8.1543072170126, -6.8430678088505985],
              [-8.17016071353558, -6.823414610300693],
              [-8.188806462113776, -6.814501022710211],
              [-8.200741556762564, -6.7956256735699325],
              [-8.203429427245641, -6.774996373117149],
              [-8.212259495703034, -6.761403578057353],
              [-8.216096424510287, -6.736616533891513],
              [-8.24390601042609, -6.709642958136983],
              [-8.247660397878063, -6.684674586255029],
              [-8.259361595158984, -6.640722632588191],
              [-8.278066119304935, -6.604172815727538],
              [-8.28697835552415, -6.570489702832662],
              [-8.305463641202602, -6.550313572328567],
              [-8.309631693202585, -6.53249401821182],
              [-8.33850685993555, -6.509365976677694],
              [-8.365023514599995, -6.494096620534911],
              [-8.384540956305928, -6.5054807373779955],
              [-8.399157657392179, -6.506326570356369],
              [-8.42786534994199, -6.46827646016047],
              [-8.441076255622429, -6.442554817419057],
              [-8.466038500402359, -6.436672354269584],
              [-8.473812873690694, -6.424056986310708],
              [-8.487640494432595, -6.416686695314349],
              [-8.483540660650648, -6.405397482172116],
              [-8.509111139428047, -6.375794139132698],
              [-8.501497989011149, -6.359080109696695],
              [-8.513768854338611, -6.346514550034231],
              [-8.508933552257439, -6.337269265320831],
              [-8.48286231539839, -6.324699314802454],
              [-8.492412577387379, -6.3182766325419255],
              [-8.488716542256546, -6.282794126771981],
              [-8.499330726922505, -6.262217850256454],
              [-8.479420372635152, -6.244190793943796],
              [-8.29125658696532, -6.263957894814737],
              [-8.128790575452108, -6.2812212753086065],
              [-8.065636238855756, -6.2872081849329255],
              [-7.90026254088277, -6.304947924537664],
              [-7.734884540210316, -6.3226487564267915],
              [-7.626568852459522, -6.333993998031215],
              [-7.518251339520916, -6.345322562731393],
              [-7.384182263231166, -6.358546674482103],
              [-7.250110648675626, -6.371745282159311],
              [-7.115239558515723, -6.38472498118972],
              [-6.980365928997684, -6.39767889335434],
              [-6.929515928717852, -6.404900625011126],
              [-6.9144853769642, -6.403232240146385],
              [-6.727260627794966, -6.420609637971063],
              [-6.557350694036456, -6.43566863431937],
              [-6.429073674895255, -6.446706272256011],
              [-6.300794644969867, -6.457720659158645],
              [-6.175397422574997, -6.46762228569231],
              [-6.0470727745254, -6.478455138627785],
              [-5.880322655422768, -6.49153852308255],
              [-5.713569477583268, -6.504582711640043],
              [-5.603286916637028, -6.512828397413604],
              [-5.493003085156609, -6.5210569575272626],
              [-5.468178720845662, -6.188199753156977],
              [-5.442445253150781, -5.841124172482838],
              [-5.418542471584097, -5.524399452617093],
              [-5.39840177245642, -5.305524882378409],
              [-5.382907747166302, -5.136559907965902],
              [-5.356650210840658, -4.852843284663803],
              [-5.326246717888332, -4.5216241961401336],
              [-5.313760232219485, -4.354073444184341],
              [-5.298465073021847, -4.144879541839831],
              [-5.275785535690646, -3.852467294450726],
              [-5.254439233341931, -3.5685356120350944],
              [-5.237198034996244, -3.3386192984884726],
              [-5.221133009920525, -3.126105551170803],
              [-5.2037247213138835, -2.8973036363886826],
              [-5.187450655632798, -2.6810050171704565],
              [-5.170816225323626, -2.4623102406595185],
              [-5.151899095787713, -2.1977029584218473],
              [-5.138428724799877, -2.0144223977961406],
              [-5.107072791315379, -2.0167843711479536]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.35113840919615,
          "lat": 31.484754160557326
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779801"
      },
      "bbox": [
        -8.513768854338611, -12.79083451525512, 2.591864135029648,
        -2.0144223977961406
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.160751138269198, 0.0392468799302667],
              [16.173227881917533, 0.05260585067267384],
              [16.185656813456752, 0.05070369833412802],
              [16.190591611369488, 0.03622590229800206],
              [16.174084896770395, 0.029143188962103342],
              [16.160751138269198, 0.0392468799302667]
            ]
          ],
          [
            [
              [15.992151819780261, 0.7596217603644255],
              [15.989247626515242, 0.7751726612131927],
              [16.0110115212677, 0.7676132975757158],
              [15.998431027785868, 0.7433099575782212],
              [15.992151819780261, 0.7596217603644255]
            ]
          ],
          [
            [
              [16.231133183951425, 0.9527044303573903],
              [16.243382038720906, 0.9837068391766816],
              [16.412612017289597, 1.0406485820668787],
              [16.52734479588741, 1.0800627457493506],
              [16.50017833610827, 1.0013733411596641],
              [16.480532113268275, 0.9158984986186314],
              [16.474119286549815, 0.9007288863050574],
              [16.459585035802714, 0.8832914770386812],
              [16.445132699842702, 0.9017640795409506],
              [16.465012738685694, 0.9001016756957253],
              [16.47787915148737, 0.9153304482442107],
              [16.477913932940282, 0.9288133548271907],
              [16.450603501082036, 0.9244686073984043],
              [16.430152633840393, 0.9266548816683008],
              [16.416277178400613, 0.8985672190607956],
              [16.401944318753, 0.8834365428750062],
              [16.38141901898491, 0.8467017965018502],
              [16.36217171490222, 0.7972624688013321],
              [16.351750412998204, 0.7530377680905491],
              [16.345806011319493, 0.739695255720993],
              [16.34094120384139, 0.6975249682993397],
              [16.33534621710537, 0.6906253878467469],
              [16.339400218947315, 0.666872285520869],
              [16.339403653720947, 0.6353675060066698],
              [16.33367635962357, 0.6056179224447072],
              [16.341833683726914, 0.5743082996543578],
              [16.35286106443503, 0.5705787869297968],
              [16.330236142437737, 0.508085831198735],
              [16.32240093252353, 0.48058287150983814],
              [16.305892205303834, 0.47356698214403914],
              [16.304063774946485, 0.45896375376836174],
              [16.316766291055572, 0.4474327569812337],
              [16.325106307121402, 0.45238021134474793],
              [16.332807667426767, 0.43401327204707957],
              [16.32518006379789, 0.42026548950829745],
              [16.30041107964711, 0.34115060234500694],
              [16.299986536220356, 0.32465610308893345],
              [16.287343500159388, 0.2904820169006074],
              [16.276220271202618, 0.2721920039733899],
              [16.26003531697366, 0.26605768866493607],
              [16.267339415485925, 0.253045077563133],
              [16.26757204594827, 0.20830551579664888],
              [16.273235786348355, 0.19076341399265354],
              [16.259972854232693, 0.18025907553458112],
              [16.264233389271734, 0.16044233712788808],
              [16.256731109766136, 0.13977049627347116],
              [16.241768973834393, 0.11830816498036541],
              [16.220060554033804, 0.07405993473940056],
              [16.194866784871905, 0.08075383212733353],
              [16.164982657957015, 0.06084941652633891],
              [16.15214712105348, 0.09655070506518708],
              [16.113060771344404, 0.14148248390484208],
              [16.109658073462363, 0.16977545882679596],
              [16.09244471771049, 0.19013124743266088],
              [16.097633628813437, 0.21398822478194174],
              [16.086600410101973, 0.23338939647942475],
              [16.08681750646084, 0.26779930291684995],
              [16.092924064203107, 0.28266330574236137],
              [16.107278255500386, 0.3403416837702037],
              [16.091883298727907, 0.3535585454593405],
              [16.08980629133803, 0.37634049532012914],
              [16.099506716395645, 0.41059203349480283],
              [16.094382422706385, 0.4155848100888228],
              [16.092626248654046, 0.44079871361611594],
              [16.094936805984272, 0.46374630883563794],
              [16.10242317093847, 0.49503455860271617],
              [16.09281226554436, 0.5066252472012664],
              [16.10459854829121, 0.5699089720800851],
              [16.116942230088792, 0.5571888531089142],
              [16.129002968505933, 0.559195898310878],
              [16.115251223378003, 0.6036781352010816],
              [16.12644948761773, 0.6216494907414769],
              [16.143421818851, 0.6268855149437592],
              [16.13518627888328, 0.641240349354076],
              [16.142552270380364, 0.6680783570424323],
              [16.161116040355417, 0.6800423001016788],
              [16.141981905058223, 0.6939550033367049],
              [16.152309423135236, 0.7111700535059899],
              [16.169699390044663, 0.7227659141287784],
              [16.151512233501293, 0.7439744909579329],
              [16.1405833644203, 0.7497965138418387],
              [16.15494769684159, 0.7685436096981269],
              [16.172355392505406, 0.77241577950558],
              [16.19653161801214, 0.758455346420165],
              [16.21434663293003, 0.7697844495524876],
              [16.208048654030804, 0.7966490262352838],
              [16.21447744838151, 0.8280830777806575],
              [16.227819015494415, 0.8173252852568073],
              [16.237618568341027, 0.8343850607573826],
              [16.2227841758915, 0.8400847385317816],
              [16.224512905774898, 0.8702159191273221],
              [16.20791647107164, 0.8805669895974351],
              [16.189869426876264, 0.8767499230248976],
              [16.170157947082593, 0.882946430422815],
              [16.183787246164542, 0.9090442370191387],
              [16.204054095586578, 0.9092040727005739],
              [16.213042321886988, 0.9239106533190693],
              [16.241617814666853, 0.9235339977073016],
              [16.242189100106682, 0.943607388635608],
              [16.231133183951425, 0.9527044303573903]
            ]
          ],
          [
            [
              [15.929920303076974, 0.8742523110628564],
              [15.970127637938052, 0.8827301716042092],
              [15.948345786767144, 0.8680140545720655],
              [15.929920303076974, 0.8742523110628564]
            ]
          ],
          [
            [
              [11.442383717567298, -0.3629145599698426],
              [11.463775375603376, -0.37690518765323805],
              [11.466154176729898, -0.3894174888929058],
              [11.442873606499075, -0.4173891237362161],
              [11.42928751898654, -0.42746942526445114],
              [11.43497780509958, -0.44274267806695683],
              [11.450384407043375, -0.4454019730083978],
              [11.455997110098538, -0.45424113229098484],
              [11.470600968698466, -0.45299277151246314],
              [11.488279849143051, -0.4814654644574684],
              [11.494333927858376, -0.5023816545822437],
              [11.49109001753226, -0.5184759607302359],
              [11.510383661062294, -0.5454167240533957],
              [11.524993150080412, -0.5516512361801211],
              [11.531090883476649, -0.5619670772576655],
              [11.543297205047311, -0.5614356642521311],
              [11.565230947977671, -0.580884211866097],
              [11.568764522452957, -0.5996196485456158],
              [11.59644321870485, -0.6039286713276899],
              [11.608206197957303, -0.5955175501048291],
              [11.642095657199368, -0.6008285735521407],
              [11.661554985176293, -0.6200086636042038],
              [11.66583289767004, -0.6354841821313509],
              [11.677565323485924, -0.6314332997332632],
              [11.685052264586027, -0.6422703544078134],
              [11.710044920334601, -0.6544804081816907],
              [11.71844009559674, -0.6650750950722253],
              [11.809342957517694, -0.6459254133078308],
              [11.819807563405616, -0.6299218230971882],
              [11.845787238797298, -0.6138780405042275],
              [11.847077765207272, -0.5932332972506447],
              [11.865257337103607, -0.5919260569746209],
              [11.87827924992561, -0.5752023405943921],
              [11.89521135310994, -0.5638667865159424],
              [11.911304391370223, -0.5622492957665638],
              [11.919629965791977, -0.5227264838108602],
              [11.93714840605732, -0.5118588045042839],
              [11.943765857877846, -0.49134285508592646],
              [11.982442533090225, -0.5245327498355998],
              [12.066462314835409, -0.5772730707336866],
              [12.107302803205114, -0.5422347078593605],
              [12.147222313685106, -0.5199796948410735],
              [12.20405012971003, -0.4989659036742577],
              [12.246958923893668, -0.47984359370117663],
              [12.248040989148322, -0.4894214445634638],
              [12.272633787470172, -0.4822988018221335],
              [12.306421857646065, -0.45733439420778366],
              [12.32718339206886, -0.4298977230974388],
              [12.34103378088475, -0.41914731759721174],
              [12.308841386645344, -0.38645281020300365],
              [12.320291188513607, -0.356086056369286],
              [12.322328875279332, -0.34018986940575546],
              [12.338718474454296, -0.34031280469610115],
              [12.365333007265333, -0.35672303008434214],
              [12.38408522455731, -0.36344688434344885],
              [12.398622088656328, -0.3838303468585139],
              [12.445424830079473, -0.35348440716565516],
              [12.518562381918573, -0.2888259567278374],
              [12.551460085758281, -0.2554137827144456],
              [12.58165379850359, -0.24215795795456227],
              [12.599853350136431, -0.263645613579678],
              [12.602109908752688, -0.28648315101098715],
              [12.619048571296066, -0.2960977141500755],
              [12.653368788260709, -0.2628739943826564],
              [12.696851528416772, -0.2248351147138369],
              [12.741291020469967, -0.18850277744614158],
              [12.750579975593693, -0.16110780981837125],
              [12.730714173563149, -0.17070211932127402],
              [12.71300758079983, -0.16457707408664138],
              [12.72522479195639, -0.15231135853551367],
              [12.709750656278919, -0.1363831412353571],
              [12.7584372297625, -0.0963387610239439],
              [12.770957526630093, -0.08250951837899488],
              [12.782409437827539, -0.0592891382863158],
              [12.766599779354944, -0.05179517596647308],
              [12.743410217433992, -0.0470356567555255],
              [12.732369908280209, -0.037649273920477254],
              [12.713640416555066, -0.0052429470165962395],
              [12.719853044148707, 0.0005231167694284644],
              [12.741400716576038, 0.03834014118039351],
              [12.731686769905119, 0.04543013629660774],
              [12.749974292402127, 0.0894117619692063],
              [12.748382891794504, 0.10350626667807479],
              [12.753865622509883, 0.12229379948815607],
              [12.774058660538532, 0.1543085489164517],
              [12.786444731466052, 0.19466778171863225],
              [12.800801035118925, 0.2047580606644851],
              [12.824769161688842, 0.2459685484434966],
              [12.829808795987338, 0.2460013287896609],
              [12.842732502888087, 0.2728767666380065],
              [12.860258405980069, 0.29147266845133885],
              [12.889624810763989, 0.3325969166340426],
              [12.910417140001522, 0.40878973690987197],
              [12.911791588445045, 0.4261307058336454],
              [12.928789081879662, 0.45643669348478505],
              [12.918335349853757, 0.45922948139018377],
              [12.910421003444325, 0.47833214492193904],
              [12.921171067844023, 0.4885519964833316],
              [12.926930201826858, 0.5133539488153069],
              [12.920282320247303, 0.5299979069401478],
              [12.935597022288917, 0.5455918196583427],
              [12.967451796215284, 0.5991567982088313],
              [12.985534034828035, 0.6107393578664291],
              [13.006896203400975, 0.6400512462771772],
              [12.997938225534963, 0.6558552939029278],
              [12.984168285460706, 0.6686588427400049],
              [12.99139725652075, 0.6887989772105797],
              [13.00729161632683, 0.7038825533261497],
              [13.0103168595575, 0.7259060510075864],
              [13.026309435271102, 0.7260576049133203],
              [13.038775888428278, 0.7383153295885372],
              [13.032465589532409, 0.7470081960646501],
              [13.04434383912084, 0.7924630523755505],
              [13.05460081472038, 0.8103370600754208],
              [13.052441408089102, 0.8294707580947528],
              [13.039935613042571, 0.8525859894426393],
              [13.040083391866157, 0.8721670504734593],
              [13.048049060485372, 0.8903375739495698],
              [13.061174917670385, 0.8976360306095804],
              [13.050574809468346, 0.9093231554656546],
              [13.0510814186148, 0.9521411731929293],
              [13.057961738989155, 0.9749568292812449],
              [13.150589452314414, 0.9494982569838482],
              [13.165299868704752, 0.93464927849282],
              [13.212902240164583, 0.8643846088484343],
              [13.346421554592625, 0.8414513963989656],
              [13.36915359570453, 0.8580980781961844],
              [13.391326074600286, 0.9088777873284561],
              [13.401134740186924, 0.9174256831404906],
              [13.40972501060498, 0.9358210546661855],
              [13.40772530095281, 0.9678813053702161],
              [13.429636468391502, 1.031897759332158],
              [13.430807597427137, 1.0609343281871135],
              [13.44182936609619, 1.1059790750044622],
              [13.448803021312276, 1.1144088741647873],
              [13.46970791359885, 1.1174465313620874],
              [13.471427131892217, 1.1454496091399082],
              [13.462213150022729, 1.159998417755943],
              [13.4694934001219, 1.2076683619758917],
              [13.480962171194472, 1.2354796903212624],
              [13.48126808094833, 1.2555368952631991],
              [13.495930370222363, 1.2581812859494035],
              [13.497150366194644, 1.2848656139599348],
              [13.506141356125532, 1.2932597093909362],
              [13.510771751568264, 1.320346950756571],
              [13.62119099540673, 1.2510156056598523],
              [13.645397921177741, 1.3251990555437358],
              [13.650677318881733, 1.3520157735260208],
              [13.660699815870634, 1.3835546920345252],
              [13.679843598936014, 1.402871487806855],
              [13.690251242286308, 1.4322366419426225],
              [13.701979914431673, 1.4386210217174047],
              [13.71159346186119, 1.4131145127803475],
              [13.729094462366048, 1.4368093126853587],
              [13.734915083112321, 1.4384283437570393],
              [13.747093538983922, 1.463316782948666],
              [13.75272614057184, 1.4856667462201203],
              [13.769861925089145, 1.5036768994708019],
              [13.787400938403982, 1.488447003827073],
              [13.798668484713355, 1.5171851011623974],
              [13.816305432525823, 1.5486829433560019],
              [13.797523732760077, 1.5594980693174711],
              [13.830248788816235, 1.6167017734092706],
              [13.853821478955677, 1.6498765832857956],
              [13.867191648343985, 1.6559713649471706],
              [13.87914695132933, 1.6774990332638373],
              [13.884491916581373, 1.6996262813925713],
              [13.89957071636067, 1.7175647488714658],
              [13.867510578937585, 1.7429821417546414],
              [13.886303815848702, 1.7805045845526557],
              [13.888270119278113, 1.7941704446300724],
              [13.870985101123393, 1.8046378398186362],
              [13.888556918226186, 1.8448367360464581],
              [13.90452160674446, 1.872818910887982],
              [13.912587970506667, 1.9110053599490475],
              [13.891644164789053, 1.9130258745534416],
              [13.903944879753382, 1.945636076563014],
              [13.887382032869214, 1.9668833994289117],
              [13.89407308584704, 1.983623564374751],
              [13.886638285955508, 2.021639097559692],
              [13.95967686167564, 1.9823245383807173],
              [14.051687123665621, 1.9269048724063704],
              [14.16100237013467, 1.8665999012073553],
              [14.34048675311383, 1.7654057807246542],
              [14.341511336057112, 1.7814596675263148],
              [14.34983180118155, 1.810274896849798],
              [14.351575726549616, 1.8475158736450983],
              [14.363185176021007, 1.8771610091568738],
              [14.370137007124097, 1.9383582923924145],
              [14.376102209979065, 1.95741088144332],
              [14.385953816308806, 1.9684806934736008],
              [14.40306288731875, 1.9690568772126291],
              [14.418245366059104, 1.9777316614661289],
              [14.439530242663565, 1.96810392644456],
              [14.467463640899398, 1.9652785329426963],
              [14.488451282240892, 1.9686016905614416],
              [14.503916611889755, 1.9759191382868913],
              [14.512121710935295, 1.956997413319138],
              [14.529124824243452, 1.9405796535033983],
              [14.558102972012632, 1.9315686011976554],
              [14.575354134758161, 1.929780784169245],
              [14.601694857468667, 1.9117702059474646],
              [14.592951628723904, 1.8929576035833118],
              [14.594529631619354, 1.8794119235421252],
              [14.58808828374079, 1.8686081594152812],
              [14.574338561594182, 1.8621803076939263],
              [14.568030526769414, 1.8494615842654833],
              [14.56465875210062, 1.8234415761967864],
              [14.57030240230637, 1.8056129001316732],
              [14.579068465458521, 1.7978453709794837],
              [14.603140130281169, 1.7930354293570265],
              [14.627088077831623, 1.7637604008795544],
              [14.658672649015093, 1.7603650035554128],
              [14.696053692494377, 1.7620304826078679],
              [14.721964375468852, 1.7689194026926538],
              [14.760805225050694, 1.7596903117035576],
              [14.777138652478722, 1.7501696918845067],
              [14.792584947317176, 1.749052312847918],
              [14.802617511901085, 1.7408682398188262],
              [14.797743309168428, 1.72167855393244],
              [14.810041633593293, 1.703682008551329],
              [14.829719862749855, 1.6960642557909882],
              [14.848733399837718, 1.6952396893718307],
              [14.872807432202158, 1.7013026960744089],
              [14.887681500785167, 1.700378029285201],
              [14.913897606654318, 1.6749028482263562],
              [14.939251410711972, 1.6507366651794082],
              [14.96053598303627, 1.648130402997801],
              [14.979986231743151, 1.6227131444267142],
              [14.98631055376111, 1.6245057723482559],
              [14.997181433714161, 1.6053879502387811],
              [14.995172440334915, 1.5861376155823976],
              [15.003435884670454, 1.546033719265387],
              [15.014710828586022, 1.4806190912826973],
              [15.009039435326962, 1.4630015593970713],
              [14.988957330614268, 1.458016648269004],
              [14.971728716663211, 1.441987091118636],
              [14.956152012030044, 1.4151708033082167],
              [14.958352993818805, 1.3909025626020906],
              [14.965623336512248, 1.3771254181553192],
              [14.94410150121035, 1.374708981357711],
              [14.93816865272006, 1.3617606424522417],
              [14.914630541488771, 1.3490335556791213],
              [14.90081341605755, 1.3670802476920159],
              [14.914639199679518, 1.3832285367086983],
              [14.880465351330024, 1.3858446805317404],
              [14.89236276581543, 1.3737030011833848],
              [14.877216353881646, 1.359606258650186],
              [14.881300553711737, 1.3454955667462989],
              [14.876941552270898, 1.322350393927917],
              [14.885817650005283, 1.3154126311885905],
              [14.873962710843553, 1.3024421777921238],
              [14.884027276761866, 1.2847669563110014],
              [14.871945953780864, 1.2678634368379087],
              [14.871396729418862, 1.2462727007414771],
              [14.857718774534087, 1.213055014003277],
              [14.85276124262841, 1.1816988845283756],
              [14.854610035454554, 1.1578423561277462],
              [14.875516770626698, 1.114724712141444],
              [14.873296088317865, 1.0997746114721765],
              [14.89216458167434, 1.0893486800801586],
              [14.910683424813081, 1.0617931293309468],
              [14.923555494247267, 1.057153491710662],
              [14.942471179228296, 1.0594361562108252],
              [14.967724630035459, 1.0741899143852438],
              [14.998446132785924, 1.0861037962013256],
              [15.012712534386159, 1.1115466585337712],
              [15.053292785666022, 1.120109056594159],
              [15.062155318678887, 1.1315155207243606],
              [15.071080800948236, 1.155129271721484],
              [15.079855667756027, 1.158316452389566],
              [15.101026214847796, 1.1438050059552707],
              [15.11361224225154, 1.0956947948961129],
              [15.10583318598285, 1.072344790153816],
              [15.133769609903135, 1.0472142028431697],
              [15.150895565373448, 1.0429341257703122],
              [15.16910275555424, 1.0283643941580185],
              [15.177014241688816, 1.0097126719523086],
              [15.171037044644951, 0.9985696848700146],
              [15.177501309214424, 0.9863750652274964],
              [15.199050570936643, 0.9787073141601074],
              [15.220177637619134, 0.9775327285598924],
              [15.252313459329802, 0.9584580684010734],
              [15.281902681537758, 0.9555014011086442],
              [15.310476207166824, 0.9669704983486777],
              [15.341191044303757, 0.9708427479316176],
              [15.361728407873947, 0.9555796399286487],
              [15.372412382232703, 0.9413001754904051],
              [15.396310115398018, 0.9755461238405315],
              [15.417589280368192, 0.9670335050735099],
              [15.442215171717342, 0.9456605167376393],
              [15.446566647295034, 0.9520536603288808],
              [15.433998788080217, 0.9710509579494527],
              [15.443673630937488, 0.977998275080055],
              [15.45785194966972, 0.976400204153143],
              [15.474231212450501, 0.9400175729109826],
              [15.493706983902973, 0.9283632074226684],
              [15.531718007149559, 0.9143415143932805],
              [15.54801073908111, 0.8896471663004787],
              [15.529725520694647, 0.8693680806819617],
              [15.556094906444171, 0.8704974938996245],
              [15.588728867372648, 0.8649777947358419],
              [15.59739760882464, 0.8572508816579777],
              [15.59427290054, 0.8433873667052905],
              [15.622476193803061, 0.8402642169460921],
              [15.651886016384973, 0.8250576200370195],
              [15.70408003270927, 0.8200636814083906],
              [15.77105942651482, 0.7970352733354519],
              [15.786245644657209, 0.7841098168636558],
              [15.797608721810917, 0.7810864208024056],
              [15.796028328940888, 0.7408681314386633],
              [15.798814202046787, 0.7240744372984409],
              [15.79057790888559, 0.7041685615453631],
              [15.758601426134758, 0.7020945662072219],
              [15.762365748188282, 0.6805345136957076],
              [15.757094852385853, 0.6717460365516897],
              [15.765898189926085, 0.6551822041429145],
              [15.77394339721493, 0.6213886751875282],
              [15.765592082298008, 0.6168242410403197],
              [15.769318966931483, 0.5990841594534753],
              [15.786090300990557, 0.5844681930842841],
              [15.789001194295595, 0.5733398573304218],
              [15.765812107770548, 0.5618698316936267],
              [15.774931912112244, 0.5537886307204254],
              [15.767535229149496, 0.5327496103139252],
              [15.77917806319271, 0.5081783086494769],
              [15.788976831305193, 0.5073232944571201],
              [15.791074105131944, 0.5234775589996106],
              [15.808000739779597, 0.5207514519802274],
              [15.821761738851462, 0.5052043164695155],
              [15.812646730786378, 0.5000016296957558],
              [15.794899828846079, 0.5063338616806811],
              [15.763615174125547, 0.49520210064982795],
              [15.759772411173657, 0.4840761122342871],
              [15.741905367503982, 0.49749530038454826],
              [15.725901899654893, 0.4945319187792199],
              [15.702079437688242, 0.5038660552929011],
              [15.691630143788455, 0.5132107562521294],
              [15.682903166320843, 0.5076337894064057],
              [15.664833787302264, 0.525999845693815],
              [15.675345127174804, 0.5353717187610935],
              [15.66049415316691, 0.5513855879600198],
              [15.64849379465177, 0.5382151490534712],
              [15.653723710859408, 0.5286330121001601],
              [15.646007541067435, 0.49476578902470975],
              [15.637775284922034, 0.49433331061133257],
              [15.61740207595146, 0.5065367898559461],
              [15.611088655496726, 0.5326330287874006],
              [15.60176898677485, 0.5517788589312452],
              [15.589344309111745, 0.5582198108730364],
              [15.575195745617961, 0.5735315399357162],
              [15.571235007745582, 0.5854215339457566],
              [15.555109036063602, 0.6077016275049342],
              [15.542448951639095, 0.6062795670403512],
              [15.527220038852926, 0.614355247971151],
              [15.517648972837467, 0.629692171301408],
              [15.492352507494964, 0.631070966402475],
              [15.47173455514082, 0.6462422601346521],
              [15.45593917531352, 0.6399193936639028],
              [15.418998334103577, 0.6659016940063922],
              [15.409930171961312, 0.6852888179924336],
              [15.395333799097552, 0.6858077300576957],
              [15.38896072503426, 0.7049665387389543],
              [15.360936286989036, 0.7260887412817222],
              [15.342317021969482, 0.7304901590207333],
              [15.333345273287195, 0.7271095007630669],
              [15.316218839646245, 0.7437007206939882],
              [15.305916192701766, 0.7645829959341017],
              [15.293017627629157, 0.7747851396228059],
              [15.276946394792278, 0.7718947789651667],
              [15.259859202645748, 0.8021517247520107],
              [15.249047589174415, 0.8108590949779785],
              [15.239886254878515, 0.8034909658388717],
              [15.253917852930874, 0.7841811386982344],
              [15.250857868513501, 0.7619506342015518],
              [15.261225649616925, 0.7556620096089526],
              [15.279486252835383, 0.7608285835705217],
              [15.29141141984005, 0.7585296186838134],
              [15.292779180993744, 0.7388214916098508],
              [15.325228213492114, 0.7097998005968464],
              [15.336623995669532, 0.7118770761448822],
              [15.347521388930321, 0.6999577655481027],
              [15.370018288717661, 0.697024390706279],
              [15.38549196894416, 0.6672042783305022],
              [15.396272930851012, 0.6607667064897393],
              [15.405596090756662, 0.6426201109475708],
              [15.417642987327408, 0.6335548979623581],
              [15.43576523479757, 0.611010433045292],
              [15.452784892530657, 0.6013279252331465],
              [15.480780391434468, 0.6011800402282256],
              [15.48836375790552, 0.5779599760089887],
              [15.517819080648001, 0.5787188406008794],
              [15.534604773341547, 0.5758505956145539],
              [15.537811576924417, 0.5622035924998949],
              [15.55749093195861, 0.5522019530722984],
              [15.56171423743655, 0.5349686150497032],
              [15.580201369129398, 0.5115552319839817],
              [15.57380564758673, 0.5025281087848457],
              [15.613950574471946, 0.4650501532651576],
              [15.632969816093143, 0.4585896982982256],
              [15.672608628607065, 0.4663929921215455],
              [15.704682802831153, 0.4751473761227069],
              [15.713611969955327, 0.4507815558844664],
              [15.74999835569078, 0.4434814553698573],
              [15.790925604535609, 0.44900444761736363],
              [15.805966354533156, 0.4426841274103492],
              [15.811759500526643, 0.42898223133412716],
              [15.775988854205469, 0.4093697083073379],
              [15.78211697062253, 0.38874251325357834],
              [15.801838588250579, 0.38356781522713956],
              [15.820323787588476, 0.3675244951594606],
              [15.830865793776896, 0.39220685628381263],
              [15.843501557081463, 0.39585403350284964],
              [15.854986546806328, 0.3761654391483607],
              [15.852501157254407, 0.3544259577931853],
              [15.874171771625392, 0.34536185134051567],
              [15.88034665629781, 0.33011179467285756],
              [15.89597124952092, 0.2737828786879629],
              [15.8813084698967, 0.24056354145597258],
              [15.888938452114248, 0.20482232115322252],
              [15.859399941485723, 0.21505585791359672],
              [15.819816910304096, 0.25025171716243344],
              [15.788935286209961, 0.2569922818097634],
              [15.77634346167485, 0.2726109584996539],
              [15.76001713255775, 0.27669456461138187],
              [15.76968624381237, 0.23647489090102392],
              [15.756048495408034, 0.24723174871011866],
              [15.726738362856736, 0.23936211241909114],
              [15.729351704120576, 0.22636667187845486],
              [15.747245997017528, 0.22990413622318295],
              [15.769953576717137, 0.21074314489659188],
              [15.776360658098607, 0.19758738482953528],
              [15.761026826061197, 0.18678058789352772],
              [15.762428917021133, 0.1786889816270764],
              [15.796817001306302, 0.17475976070318958],
              [15.810329382146126, 0.16698376966954545],
              [15.830519083117494, 0.14631080133680088],
              [15.810216193805713, 0.13678951567428882],
              [15.788980931784701, 0.13400688249441645],
              [15.777731928224963, 0.12326612805644001],
              [15.755549457067671, 0.11134598357735592],
              [15.740432227701126, 0.11327048724205624],
              [15.72337379178896, 0.0938859428312892],
              [15.737868530510179, 0.08238946720464235],
              [15.756948840426139, 0.07667651169006107],
              [15.820423087654374, 0.10037580736509226],
              [15.812731740334657, 0.07855694154103768],
              [15.824248408944394, 0.06700170562330211],
              [15.82560841519336, 0.04814261541227188],
              [15.814659726342018, 0.04643827100965369],
              [15.81415354591487, 0.03236287577827503],
              [15.839233852431159, 0.031659117999093454],
              [15.853376236780147, 0.047669636050776634],
              [15.861816186417894, 0.0497923215436602],
              [15.87166692257614, 0.03342942172851773],
              [15.897079956740878, 0.02499752786176207],
              [15.912119839440926, 0.013476088628055306],
              [15.909368031174287, 0.0034572914427546757],
              [15.928955448541538, -0.005716758085545527],
              [15.938402493761467, -0.01781764139222745],
              [15.932672501991128, -0.07311988594876115],
              [15.932342232490418, -0.1003203388752896],
              [15.899813699019566, -0.10055456490424161],
              [15.895848183444453, -0.11015480207690187],
              [15.875101113503206, -0.1245753157686786],
              [15.8635036477126, -0.14210228705141612],
              [15.856177188575632, -0.16359479204277208],
              [15.844424526839829, -0.16252538798732866],
              [15.817067695406292, -0.1354900067810778],
              [15.818109442420953, -0.1254306852672235],
              [15.80144704673509, -0.10844048036811245],
              [15.74633467998981, -0.08340229652898977],
              [15.742911100615991, -0.06804219803433811],
              [15.727915762674593, -0.0602688042516338],
              [15.710435254003011, -0.06937063731810764],
              [15.698247205069134, -0.058649498240567755],
              [15.656405436514758, -0.03573035384254411],
              [15.666028918753357, 0.00008965572573075294],
              [15.636781469114196, 0.04216900934248396],
              [15.618437269273935, 0.052996172211755316],
              [15.584561962523997, 0.0488602171654932],
              [15.578456576386499, 0.04087093550850984],
              [15.557145981156701, 0.0314150214611951],
              [15.552221916433494, 0.010181062545928475],
              [15.541036003233621, 0.006901669707730755],
              [15.519855752430153, 0.02077868123248214],
              [15.505366227511987, 0.040394619753181454],
              [15.48073323574828, 0.04812619759382117],
              [15.444463435265149, 0.03918568835366527],
              [15.438231137521962, 0.05913642494189078],
              [15.421233845437305, 0.04309655584214585],
              [15.408721053262694, 0.023779679932331134],
              [15.390589928824152, 0.023602640026967353],
              [15.387388462675197, 0.013007665630077917],
              [15.427508519308224, -0.007892681303435154],
              [15.454102760151088, 0.007007159105170928],
              [15.491335871928271, 0.01079506497772751],
              [15.505106760737453, 0.00638979006568145],
              [15.524467953600485, -0.010325758413517388],
              [15.542600355706446, -0.017050294695910455],
              [15.557217980693121, -0.032152111941997054],
              [15.58273231962594, -0.029497959869501864],
              [15.594900190665541, 0.023765668048400378],
              [15.617294457042474, 0.004261993400433114],
              [15.61443331946865, -0.011933242740871146],
              [15.617743466092884, -0.028446356081771252],
              [15.635679453118046, -0.05796165956465179],
              [15.6357738072242, -0.1094479187789372],
              [15.64770593779787, -0.12497784723891983],
              [15.659127474066517, -0.1290185169841915],
              [15.685492609672753, -0.12421273380601774],
              [15.706742857286443, -0.12689131760582809],
              [15.730104197401873, -0.14777028777706075],
              [15.750547234555599, -0.15955785127246486],
              [15.763687457767602, -0.1613841767138363],
              [15.77583039377414, -0.17512915695877354],
              [15.799047016048682, -0.1821754386192036],
              [15.803463246486178, -0.1997826815596412],
              [15.794322220477559, -0.21117476794381906],
              [15.81263075542487, -0.22294190600629243],
              [15.810612382913382, -0.25756897338975165],
              [15.83859635291041, -0.24866812027704915],
              [15.840293004867767, -0.22857014618226806],
              [15.85257630972365, -0.2246526308310214],
              [15.872424250452836, -0.227815851318179],
              [15.887448080414883, -0.222503272377065],
              [15.883862689688105, -0.19880613377279321],
              [15.908246245389607, -0.19420067814428707],
              [15.919643845332036, -0.23597318475617285],
              [15.931100371039925, -0.25403003490946646],
              [15.957364784988387, -0.24802190073267505],
              [15.939747485976872, -0.23826284309402637],
              [15.945546221379693, -0.22204302473495593],
              [15.934290845918872, -0.20837484880866836],
              [15.923092185939156, -0.17117253942869487],
              [15.931441811974624, -0.15570738905002832],
              [15.943158671478129, -0.15221375640770818],
              [15.943877581872677, -0.13900964674943775],
              [15.966715751340217, -0.13885588003133187],
              [16.007696867348894, -0.15595239581639306],
              [16.074738296644462, -0.15879457806337577],
              [16.11594813162574, -0.16577397124936002],
              [16.13906692655196, -0.15142100767850664],
              [16.149175204022356, -0.13591847407973637],
              [16.175703369219054, -0.13111737638128804],
              [16.185929854968574, -0.13616038812953618],
              [16.22143960846006, -0.21093876528655026],
              [16.23293216092667, -0.23926766061272112],
              [16.256107095992178, -0.2872725922119885],
              [16.29230658231036, -0.35086082995936485],
              [16.329222085968535, -0.4062314005024759],
              [16.352230433724113, -0.44971533290443755],
              [16.36438119318854, -0.48163348794928973],
              [16.111334390076202, -0.5355375459966785],
              [15.813200914631038, -0.5976704659491351],
              [15.63273979415984, -0.6349852309404855],
              [15.547598331292933, -0.6508322070743178],
              [15.54914734451746, -0.6590446893845103],
              [15.409359452626994, -0.6865219955595218],
              [15.364508549983675, -0.6961122226458403],
              [15.350625644734434, -0.6955675079522897],
              [15.323472582710401, -0.7038278213103734],
              [15.113197651571857, -0.7451692479095163],
              [14.898140271204092, -0.7868110483209715],
              [14.780302038122521, -0.8105059428906765],
              [14.598998504684625, -0.8460941851376311],
              [14.510884610918753, -0.8621841429570982],
              [14.3350337468166, -0.8973532811875587],
              [14.304617385396561, -0.9043048807543077],
              [14.184442831402725, -0.9255983229853194],
              [14.080407249396533, -0.9450165693203866],
              [13.942912150619852, -0.9696244466881092],
              [13.725387310195314, -1.0096939320932996],
              [13.520983227356759, -1.0462111214999783],
              [13.225295999291863, -1.0952678527320863],
              [13.041014022433837, -1.1267682724654227],
              [12.90496477016735, -1.1482202999794364],
              [12.643859867335681, -1.1765210048399388],
              [12.580367575411735, -1.1828536392124342],
              [12.47656863876141, -1.2028982095958158],
              [12.39079982754584, -1.2124764699598363],
              [12.34530749307849, -1.219284523626619],
              [12.301528934355973, -1.2228148168173008],
              [12.10484589592818, -1.2454977314373683],
              [12.051989587307812, -1.2540717361472706],
              [11.936148152496818, -1.2659724801190404],
              [11.87233408404559, -1.26910409391499],
              [11.81193691335464, -1.2771767341724631],
              [11.83241059136937, -1.2497666616476628],
              [11.76156085151573, -1.2600406596208367],
              [11.614977264733234, -1.2781399077131737],
              [11.609209292864897, -1.3014502808149806],
              [11.420463563927871, -1.328936486204878],
              [11.391560028108616, -1.3319758581781969],
              [11.19016647209001, -1.3624334404264],
              [11.178245404391092, -1.3628400439327475],
              [11.022361487382051, -1.387089465935186],
              [10.858466695675865, -1.410262182345723],
              [10.564439084907928, -1.4500503194691414],
              [10.551878897405357, -1.4473634429481452],
              [10.4742688120524, -1.45858710303105],
              [10.330865606035923, -1.477605008158624],
              [10.278884219063809, -1.483739912479101],
              [10.236917153213385, -1.486451159722707],
              [10.25524566185446, -1.4678774442895206],
              [10.27344540079677, -1.4568458432518918],
              [10.280567184868245, -1.446955934490406],
              [10.308858655517305, -1.4353029714860113],
              [10.341568617186576, -1.4073792417924398],
              [10.370825495254412, -1.3983211731412335],
              [10.402404523525115, -1.399532390510332],
              [10.42647535976323, -1.3936863056680702],
              [10.447193521558864, -1.381354244754332],
              [10.453527355155533, -1.3705273631436994],
              [10.512384751793777, -1.3373946425151806],
              [10.527250587740047, -1.3329522713524444],
              [10.597104909526962, -1.2973450972320946],
              [10.642390707504731, -1.2875258261706233],
              [10.648069037287218, -1.2788678928430406],
              [10.639401225831977, -1.247057876959231],
              [10.649622027555266, -1.2392289672749588],
              [10.662470107783744, -1.2122535214392216],
              [10.657855843757776, -1.197805491657597],
              [10.677135991774785, -1.1831486554192137],
              [10.677302271566791, -1.1691677392011406],
              [10.69731657649678, -1.1692792902563032],
              [10.713063075152286, -1.1633487515573218],
              [10.730440134745686, -1.168704455562367],
              [10.735290378844402, -1.1591304366175768],
              [10.757223205604006, -1.1550325074578467],
              [10.781551399158827, -1.1419011229997114],
              [10.824107298530485, -1.1137762771563482],
              [10.82306854236673, -1.0946836496188046],
              [10.834344670724166, -1.0755032057453124],
              [10.833638880594952, -1.04784771563611],
              [10.820363109578068, -1.0275654979822222],
              [10.837971958742031, -1.0152997830857418],
              [10.852624538517736, -0.9925490642815085],
              [10.88380410268069, -0.983998488128655],
              [10.909272717327486, -0.9466295699194671],
              [10.922799520120902, -0.9440149110661727],
              [10.923721867595894, -0.9277261159693302],
              [10.915096442234013, -0.865503814438392],
              [10.942208347411002, -0.8457126039194884],
              [10.948457145704944, -0.8457182874536089],
              [10.965699700692905, -0.8260073383960942],
              [10.979554087111802, -0.8216451471595356],
              [11.00757096127167, -0.7885258598710967],
              [11.03736379701558, -0.7622494220518236],
              [11.059783901036237, -0.7504361176194927],
              [11.074361259257776, -0.7339335078310465],
              [11.110731927361286, -0.7115216347773075],
              [11.124477707223615, -0.7066248341863566],
              [11.184023475203666, -0.677327927845774],
              [11.202228578713338, -0.6582644792242146],
              [11.207232983938058, -0.6456033375570169],
              [11.284609611903814, -0.5524757771193844],
              [11.336818798846183, -0.4915858403145339],
              [11.386501415119639, -0.42990530240354347],
              [11.442383717567298, -0.3629145599698426]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.81287903885527, "lat": 37.51507509283493 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779803"
      },
      "bbox": [
        10.236917153213385, -1.486451159722707, 16.52734479588741,
        2.021639097559692
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [7.2878878232225865, -7.944402146601031],
              [7.302289020734974, -7.928285065777283],
              [7.310342752658696, -7.932951508654054],
              [7.312033708289434, -7.958212428455198],
              [7.2878878232225865, -7.944402146601031]
            ]
          ],
          [
            [
              [7.075560911775494, -8.237494624045322],
              [7.099133770121533, -8.233684397044833],
              [7.162570453034738, -8.214889259382495],
              [7.233539103854541, -8.199684114586425],
              [7.251654874048384, -8.174220358663232],
              [7.291002714945477, -8.200824712154768],
              [7.261807274910842, -8.208993321824678],
              [7.2368910724860065, -8.204750940472351],
              [7.183719380829434, -8.210951181788298],
              [7.0950824630497245, -8.237770003241845],
              [7.075560911775494, -8.237494624045322]
            ]
          ],
          [
            [
              [6.792130435242689, -3.478987803252178],
              [6.788762571932351, -3.466745045054992],
              [6.953171725334941, -3.455185738540186],
              [7.073077693526557, -3.4452794823604025],
              [7.225183663133975, -3.4342352827985163],
              [7.415766968814657, -3.4180052465150386],
              [7.5206247309084455, -3.4103685914379556],
              [7.697757126401646, -3.398262472507277],
              [7.87488962389003, -3.3861429682696884],
              [8.024784064356071, -3.371449451142215],
              [8.144750096384554, -3.3609789507319974],
              [8.2507543874991, -3.3493296814991576],
              [8.517727473593075, -3.3239131287858488],
              [8.713891088651017, -3.3046089321068535],
              [8.891330600248326, -3.2888721062213198],
              [8.906074334039607, -3.3485415105036713],
              [8.952588687962006, -3.519729757374934],
              [9.018264146739114, -3.747169218341171],
              [9.07328023488033, -3.933355553634173],
              [9.129372492275989, -4.132607080628627],
              [9.131588121262126, -4.143180413171522],
              [9.202094912399442, -4.396508194522014],
              [9.230423459722989, -4.500404009863391],
              [9.30408840833018, -4.762069277713806],
              [9.336622111646502, -4.879373256881904],
              [9.406051864388282, -5.128876938329145],
              [9.472586961197194, -5.360910381908241],
              [9.473921163702222, -5.370044487343855],
              [9.500510846574834, -5.380969560149696],
              [9.491185478726921, -5.400455615289626],
              [9.493262007248164, -5.417952931462829],
              [9.50856917594306, -5.4338568558589815],
              [9.535628090708324, -5.4516827925862135],
              [9.52016028117228, -5.466223619486004],
              [9.530640785148455, -5.481426514963156],
              [9.547780540921535, -5.491155384030466],
              [9.542543056868805, -5.501714114010898],
              [9.549252374031445, -5.532087503723739],
              [9.57135402841043, -5.5520271778457],
              [9.576934968220188, -5.563455524133639],
              [9.564407124673467, -5.577914637551758],
              [9.579862952164456, -5.595696628424617],
              [9.603381785725011, -5.6392252320871945],
              [9.64510130160979, -5.67131552070741],
              [9.665840057201832, -5.697310131854208],
              [9.674755737209782, -5.725188460114961],
              [9.674911504819224, -5.749645923845484],
              [9.67994021714416, -5.760143296999589],
              [9.698948690876467, -5.765897955522473],
              [9.708316991931737, -5.785255659891116],
              [9.6961723783518, -5.797037280187501],
              [9.696227564444092, -5.850588725800787],
              [9.682977693194392, -5.866078787509962],
              [9.687928851880736, -5.888844772783416],
              [9.74753971885309, -5.905846598228164],
              [9.758177191211477, -5.917622742009222],
              [9.789265281375155, -5.938583096588554],
              [9.779335301215026, -5.943252682316415],
              [9.759860036045403, -5.984147886688922],
              [9.72484078285578, -5.989020212328247],
              [9.733800628802284, -6.011228343457251],
              [9.698622224787593, -6.028633258345944],
              [9.67203048411749, -6.07008047983016],
              [9.659550387457582, -6.082856334163729],
              [9.678674428535654, -6.126547264929644],
              [9.672931583384356, -6.1335078576253865],
              [9.672161531331314, -6.167741052586105],
              [9.679457774108236, -6.203047915205534],
              [9.673203099833168, -6.210377621755831],
              [9.669516489897836, -6.233407354641623],
              [9.674921378736936, -6.243344064818366],
              [9.658933836830952, -6.258651278868771],
              [9.66758821708745, -6.275351940386924],
              [9.652992755435898, -6.2909983411845305],
              [9.643509659240223, -6.3251528383395765],
              [9.627675887058734, -6.327263208539879],
              [9.633033042104099, -6.343436043251293],
              [9.625559333543933, -6.361975693406119],
              [9.626364456288744, -6.381479646592219],
              [9.634928481732912, -6.391149192143871],
              [9.639216610084635, -6.427136477854861],
              [9.63284150707247, -6.438312471883249],
              [9.64746040048309, -6.449805418596528],
              [9.646190207408202, -6.460197558771037],
              [9.657836391033511, -6.484985100166565],
              [9.653265709710777, -6.501478420848916],
              [9.656606621314289, -6.522992130590153],
              [9.688491135061923, -6.554496819781917],
              [9.707653908642188, -6.582828573931993],
              [9.722692858856032, -6.592091089524659],
              [9.727794363167602, -6.639484723695298],
              [9.745281236228177, -6.667445881627422],
              [9.744858614145182, -6.687651310219742],
              [9.73127570412409, -6.726135649567162],
              [9.728081153388596, -6.742297310957207],
              [9.737286378352026, -6.7791727128313415],
              [9.729810344486259, -6.785875226972534],
              [9.728604345577281, -6.82636891945482],
              [9.722673250177543, -6.847076264466299],
              [9.73361777820804, -6.8821988709607975],
              [9.732691048376395, -6.915690933677572],
              [9.716846888860596, -6.930833768290591],
              [9.716344185963322, -6.948329652482672],
              [9.734748785769122, -6.985022213407404],
              [9.728748329672246, -7.008725138812452],
              [9.730143743683437, -7.024848072582566],
              [9.738497463500602, -7.0302067126628245],
              [9.738741063901125, -7.044877201264703],
              [9.75970218900793, -7.051061747991925],
              [9.772040112615969, -7.064113497358803],
              [9.782463215049713, -7.084644456891065],
              [9.800078479458259, -7.095275130881158],
              [9.810947042952744, -7.118089745633111],
              [9.80993178824995, -7.127824114477308],
              [9.826937023179031, -7.14694703102069],
              [9.831069205367552, -7.167681568405174],
              [9.841685203005337, -7.185028650876032],
              [9.840603025130743, -7.1983393089815815],
              [9.738237517337549, -7.209920692043495],
              [9.635869953032927, -7.221483692615826],
              [9.527970023284945, -7.235495643894879],
              [9.42006701152063, -7.2494870645664955],
              [9.313397797357617, -7.26191393331862],
              [9.206726083461389, -7.274320817691247],
              [9.08462781594112, -7.289167209153765],
              [8.989734534517538, -7.299385055918543],
              [8.894839500486016, -7.309587124600047],
              [8.791477915225688, -7.318766763985248],
              [8.680150766559208, -7.3299637505343895],
              [8.552162120586528, -7.344001025710874],
              [8.514975122591439, -7.345705964867014],
              [8.393560016867854, -7.358129663186751],
              [8.377087609333861, -7.357562539351559],
              [8.290954085197466, -7.36542381930705],
              [8.204819447568024, -7.373272173876737],
              [8.114150685446887, -7.380873518295892],
              [8.02348088340449, -7.3884605690430405],
              [7.941294543861605, -7.399173710197057],
              [7.926402740310412, -7.398647711185643],
              [7.780075481074797, -7.412204208807013],
              [7.633744631506997, -7.425723422836608],
              [7.644961228917952, -7.45768012645026],
              [7.643668381303691, -7.470744985495234],
              [7.632636785996175, -7.498670260241406],
              [7.6239451493874055, -7.538441968788427],
              [7.614689954018194, -7.5587353234960855],
              [7.622764299536196, -7.575916563563459],
              [7.648070642809214, -7.600972740228161],
              [7.664682084405828, -7.607718104427629],
              [7.692448997668218, -7.631360050996929],
              [7.70733643160294, -7.6537127638046],
              [7.712857617241202, -7.672219343729684],
              [7.731574316778978, -7.6804899868078955],
              [7.7406808698454315, -7.691596763478099],
              [7.7591505885887155, -7.695023156261256],
              [7.765846079416224, -7.704323648610922],
              [7.786124252640319, -7.7092766023170505],
              [7.800269794413086, -7.719120839460485],
              [7.82632168328466, -7.730252597955253],
              [7.836492541620119, -7.750097658465456],
              [7.841760142507965, -7.7730310591873115],
              [7.839191306117885, -7.798459742452438],
              [7.826575895090736, -7.843235811876595],
              [7.813351621069747, -7.8570779530024755],
              [7.805800618330581, -7.879754293312191],
              [7.809166478974431, -7.898962497024921],
              [7.821812315333526, -7.909490561000443],
              [7.819423852253496, -7.924950905562386],
              [7.839423284945423, -7.946277667971876],
              [7.877989879003402, -7.9532031659417335],
              [7.879133838309847, -7.96941648382096],
              [7.853281510718178, -7.991960300097307],
              [7.831239948741298, -7.997623010400136],
              [7.823075331475855, -8.013296235006493],
              [7.825754618770127, -8.023715064545062],
              [7.816086939517382, -8.038124422861534],
              [7.8183278870239326, -8.058776970844752],
              [7.807552941898121, -8.072647099635674],
              [7.784597792471105, -8.077080330728668],
              [7.774207970725648, -8.084835047901446],
              [7.777353672673297, -8.101222430179336],
              [7.793974150597248, -8.102234981893293],
              [7.8143482389919345, -8.096936110040781],
              [7.821257091604689, -8.104384011216275],
              [7.766051296714882, -8.125522343379318],
              [7.766408790851986, -8.128941301955603],
              [7.732578464716613, -8.141022753391356],
              [7.713266473698409, -8.144758542068995],
              [7.64737574868308, -8.16910005379588],
              [7.583331811755762, -8.184519081930663],
              [7.528426409803032, -8.20049612856713],
              [7.496037576738732, -8.205431253332463],
              [7.4204207534016575, -8.208667348549806],
              [7.389433112959908, -8.212119785181747],
              [7.3336858911841265, -8.222624296766506],
              [7.336289360339316, -8.215697933291208],
              [7.384968715398523, -8.206429635501593],
              [7.398551679007107, -8.184449740517602],
              [7.409252860332601, -8.17866915684229],
              [7.447958815657353, -8.19752262813442],
              [7.476329336706853, -8.194069991325646],
              [7.511511375388223, -8.177138698364702],
              [7.537285731086439, -8.174980617720674],
              [7.553540688727037, -8.165413871362297],
              [7.569238336929066, -8.13886971175456],
              [7.5451910123447625, -8.117116501044698],
              [7.512034658479171, -8.09905343220559],
              [7.492524258413066, -8.07970801142778],
              [7.484162482490302, -8.057995558466033],
              [7.459831185670422, -8.052981239565181],
              [7.422167330111574, -8.03035524660525],
              [7.405215244550372, -7.970777455384549],
              [7.389640878722157, -7.959680625460463],
              [7.412098526398144, -7.9035351088810994],
              [7.410681554967198, -7.875340274571003],
              [7.3997515759380805, -7.856427249594195],
              [7.399280569009362, -7.826668746207238],
              [7.390716513877882, -7.816334583283569],
              [7.385476422132604, -7.794845837088224],
              [7.375051963602822, -7.78721463341501],
              [7.3584516148792325, -7.787186316089215],
              [7.331592339613017, -7.770853249143562],
              [7.312964155569611, -7.767850955819018],
              [7.30221335642956, -7.775145377167362],
              [7.300215401273921, -7.790920341418981],
              [7.288894933440157, -7.803930198504083],
              [7.26918249952884, -7.809864828536219],
              [7.278524260264092, -7.840075740264394],
              [7.271220409565786, -7.86479293892904],
              [7.256924416635523, -7.881369082304918],
              [7.260873039246659, -7.925001021762749],
              [7.246962542553352, -7.945036970711387],
              [7.246542006800084, -7.961724118040675],
              [7.253616289464952, -7.983024537711977],
              [7.246935696494358, -8.001812343965641],
              [7.251080119066942, -8.026797447213166],
              [7.252492078321692, -8.076507848265521],
              [7.247207672547492, -8.09752187507985],
              [7.235356159410762, -8.120647399157098],
              [7.1999791134803734, -8.13181490196059],
              [7.184954137002416, -8.140322658151598],
              [7.1790938989736235, -8.122144209886121],
              [7.1854058156060505, -8.114047094345597],
              [7.185180275919256, -8.096504887640089],
              [7.166407115486789, -8.1007030666895],
              [7.159579452164017, -8.093712694183592],
              [7.12040667387329, -8.082175776297566],
              [7.08652596204908, -8.081717724844825],
              [7.052240144544738, -8.065390927352494],
              [7.035491752743129, -8.064867883632735],
              [7.0312742324962905, -8.083731438026781],
              [7.022327484171295, -8.086830427525138],
              [7.006155954506046, -8.104219097785652],
              [6.984594591746644, -7.932796631810803],
              [6.946187600555248, -7.6138155546192285],
              [6.929688508062235, -7.483690073853705],
              [6.898500748997005, -7.238014506993156],
              [6.871327502423616, -7.027802568897604],
              [6.851277267591261, -6.867211763182068],
              [6.841032321871533, -6.791771106148407],
              [6.8180258561115785, -6.597460257144682],
              [6.824878307969032, -6.317509966838827],
              [6.827399197393819, -6.239795353314662],
              [6.829603782972699, -6.115512238522623],
              [6.8318890808503525, -6.040277177041143],
              [6.836261385187079, -5.775908873887957],
              [6.837529958201746, -5.739829652415678],
              [6.838939249592509, -5.611686551167742],
              [6.8423144250000805, -5.412452534531228],
              [6.845564803878848, -5.263589754367048],
              [6.8508297221097845, -4.96987349185781],
              [6.852393547494841, -4.908888739578774],
              [6.854609678634387, -4.761021399884054],
              [6.857916178003979, -4.632186568797967],
              [6.863242942819726, -4.4483523561897345],
              [6.864721556079743, -4.360782928478702],
              [6.867669030916599, -4.270974998973344],
              [6.867109965487471, -4.254710783726701],
              [6.8708522708188475, -4.09085227765162],
              [6.871818122600952, -4.00994521157489],
              [6.876486290353999, -3.8486447524929503],
              [6.880895847829824, -3.745680831705419],
              [6.8835026249364235, -3.5759075779596516],
              [6.850767378061669, -3.563079888260382],
              [6.83501016137596, -3.5494347194807774],
              [6.814270791927082, -3.510615812109614],
              [6.792130435242689, -3.478987803252178]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.8282793858514, "lat": 32.79004486663202 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779775"
      },
      "bbox": [
        6.788762571932351, -8.237770003241845, 9.841685203005337,
        -3.2888721062213198
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.483556340515383, -2.5603852277651202],
            [5.504439629589271, -2.5588309308612063],
            [5.517963369203855, -2.524519268379417],
            [5.520490447879729, -2.4753931441115946],
            [5.530326594449882, -2.4612887115265605],
            [5.560167206143414, -2.4481243329239377],
            [5.586182281477017, -2.425819890982799],
            [5.586055453877027, -2.4026520938939244],
            [5.572815288841673, -2.38225854348671],
            [5.50088711839723, -2.3327078733400617],
            [5.490047859287221, -2.321692797514984],
            [5.496949226540447, -2.3048621868704733],
            [5.5109520107936225, -2.3084618871360414],
            [5.531140154388708, -2.3046813562770536],
            [5.564894310948805, -2.3139630756273104],
            [5.583869181422427, -2.3124689951318946],
            [5.6064657811550225, -2.2992609612238994],
            [5.624889142454886, -2.29645325623423],
            [5.623031799363688, -2.2784181376808457],
            [5.587584010100187, -2.262852369199148],
            [5.559623738103991, -2.2437397429240273],
            [5.551962072435008, -2.2301844273464804],
            [5.558397720343885, -2.2121246354392836],
            [5.581398178817175, -2.2086376741504288],
            [5.598588820890136, -2.212135700146745],
            [5.621269634512791, -2.20907781600894],
            [5.63083429973198, -2.1989684021036804],
            [5.636496080695368, -2.173278599670051],
            [5.63235139272771, -2.1621717739665853],
            [5.607356713852394, -2.128271979676771],
            [5.6041756209068465, -2.113511453353006],
            [5.617176130883975, -2.0958111179719485],
            [5.622118055139882, -2.079844309394402],
            [5.6187870087722835, -2.0656084658349783],
            [5.604489220131763, -2.049767203232579],
            [5.647265000096341, -2.04729262884135],
            [5.64215309939818, -2.06664521002877],
            [5.64911882847234, -2.0834391831528603],
            [5.666961267617542, -2.0866938572349545],
            [5.687530911819314, -2.0678382660408032],
            [5.701299804083866, -2.0420288825828727],
            [5.72213220532714, -2.040512978416927],
            [5.793652578752229, -2.0273408889253957],
            [5.93904371245615, -2.0205257737854603],
            [6.060699831849336, -2.013036192839508],
            [6.16374618484365, -2.004596786877035],
            [6.3936128060189406, -1.9880059356317759],
            [6.563889457282864, -1.9757361244487448],
            [6.7254931733765595, -1.9645169496385155],
            [6.784471209280115, -1.961028743894539],
            [6.795265482701825, -1.9431941042498067],
            [6.797229935912164, -1.9158817681911466],
            [6.781951264893076, -1.854105211333327],
            [6.767889070720297, -1.8143990142486603],
            [6.758880973739128, -1.7985134735912465],
            [6.7554952046045, -1.780193727200703],
            [6.802086579418662, -1.777391786471079],
            [6.9316456992703595, -1.779864704971663],
            [6.931398758644581, -1.8107298053150933],
            [7.098892873600873, -1.7913057669239805],
            [7.278198696692433, -1.7722370912923464],
            [7.514969539947847, -1.7490392612973982],
            [7.831683301292815, -1.7116623357619491],
            [7.929340074136872, -1.6988411973257278],
            [7.951614968095405, -1.7159087430851758],
            [7.9942910363541335, -1.6924054978905971],
            [8.132805069859938, -1.6821224527939969],
            [8.240883493339812, -1.6805697211688488],
            [8.332871011733475, -1.6765917441801195],
            [8.37211147862975, -1.676005590232404],
            [8.429889865797657, -1.6721834280397143],
            [8.531568758765196, -1.667503147705949],
            [8.555780302356192, -1.6645226349777849],
            [8.654013654563341, -1.6582061439249378],
            [8.804068408187419, -1.6449117835608063],
            [8.84963666805424, -1.6358204002571692],
            [8.951499764523577, -1.6188093364738303],
            [8.958992722354141, -1.615917771469073],
            [9.034338816337147, -1.6083238307105654],
            [9.169896398677537, -1.5989708317553284],
            [9.314924409532289, -1.596470106834591],
            [9.487842462945268, -1.5815271639072501],
            [9.552823997822793, -1.5770396789741397],
            [9.632029277527971, -1.5676080105057397],
            [9.768042501620648, -1.5551360492288884],
            [9.881485337598436, -1.541460247991401],
            [9.991913768749695, -1.5293605221595958],
            [10.14950207560028, -1.5149952555041868],
            [10.227210902968636, -1.506241698774407],
            [10.236917153213385, -1.486451159722707],
            [10.278884219063809, -1.483739912479101],
            [10.330865606035923, -1.477605008158624],
            [10.4742688120524, -1.45858710303105],
            [10.551878897405357, -1.4473634429481452],
            [10.564439084907928, -1.4500503194691414],
            [10.858466695675865, -1.410262182345723],
            [11.022361487382051, -1.387089465935186],
            [11.178245404391092, -1.3628400439327475],
            [11.19016647209001, -1.3624334404264],
            [11.391560028108616, -1.3319758581781969],
            [11.420463563927871, -1.328936486204878],
            [11.609209292864897, -1.3014502808149806],
            [11.614977264733234, -1.2781399077131737],
            [11.76156085151573, -1.2600406596208367],
            [11.83241059136937, -1.2497666616476628],
            [11.81193691335464, -1.2771767341724631],
            [11.814966336236663, -1.2944788907165194],
            [11.79586034002067, -1.3326036555684184],
            [11.80899946135735, -1.3625853607977816],
            [11.816154112760168, -1.3992431906666183],
            [11.802349371105814, -1.4122481903125195],
            [11.805646468728764, -1.432278174768261],
            [11.802986172318239, -1.4475520213153026],
            [11.788706611795996, -1.4593013466944371],
            [11.798535018168181, -1.4920785853457157],
            [11.81690773427275, -1.5217450856902612],
            [11.79707126638802, -1.534951378556708],
            [11.780787817459984, -1.5364971823133224],
            [11.75778076588656, -1.52237640726518],
            [11.725612718809803, -1.5359558160561646],
            [11.70845018907234, -1.5513376848515368],
            [11.68866639952998, -1.5804130245999064],
            [11.673240557112843, -1.5900433486282013],
            [11.643183550195069, -1.6698934109801895],
            [11.601363728487554, -1.7859553683724803],
            [11.583793003579778, -1.782027089362687],
            [11.5801138179017, -1.79654162739688],
            [11.566516114086141, -1.8052793402912206],
            [11.526220205857825, -1.8113147683318938],
            [11.518260714059968, -1.7896432084901086],
            [11.506200024212335, -1.7703071357051052],
            [11.48439197772052, -1.780948798200564],
            [11.460039253327203, -1.7693662278064441],
            [11.445253273064235, -1.778719030376195],
            [11.430094509882062, -1.8004484720603358],
            [11.404393866220197, -1.80628206027629],
            [11.396185576042187, -1.8004401326302746],
            [11.361737414931191, -1.8266371527943792],
            [11.34706047261941, -1.82804567881326],
            [11.308676889685268, -1.8663998864002682],
            [11.278930633780408, -1.947715713851317],
            [11.247747380925714, -1.9828782286445137],
            [11.21449257583853, -2.001278884761452],
            [11.209464331063787, -2.0125636628926156],
            [11.192243339012434, -2.0045239300435123],
            [11.165450910503312, -2.005052645439444],
            [11.167908135250025, -1.984421196451557],
            [11.157477259558968, -1.9726690995350755],
            [11.164628410209785, -1.947203640617581],
            [11.162969404408255, -1.9355198599957124],
            [11.134570825896889, -1.9092853281561775],
            [11.0966520417684, -1.9346091102600858],
            [11.093504501821922, -1.9426928633842289],
            [11.07404557043432, -1.9556183415902435],
            [11.049522341957848, -1.9820821017706558],
            [11.029761270048972, -1.9908608613915144],
            [11.024108608838755, -2.004052793078925],
            [11.029050997111177, -2.0267300723328203],
            [11.027365034281212, -2.0400211930121843],
            [11.014746349693185, -2.056271167803686],
            [10.99984717210075, -2.066717778101095],
            [10.976086354807444, -2.0503040205091256],
            [10.958420207806846, -2.04908481903969],
            [10.944765397364325, -2.058633426958412],
            [10.941774061101157, -2.074119159376998],
            [10.931253901742757, -2.0819588977081795],
            [10.950852511963564, -2.123852692982267],
            [10.933177231529415, -2.1383436926772355],
            [10.940158232292065, -2.164970930458322],
            [10.919420358942977, -2.1848470982586794],
            [10.909423604011685, -2.2215324320923133],
            [10.889362801987259, -2.2406153285480315],
            [10.85234618575462, -2.2320035287009157],
            [10.818197983264652, -2.234575270436674],
            [10.80532613122044, -2.2499762721420944],
            [10.788353277333337, -2.2622978077278892],
            [10.757443646811302, -2.2678682725368615],
            [10.741095265098654, -2.305703227297529],
            [10.731661056149209, -2.311454251935128],
            [10.697685477654282, -2.314758841173872],
            [10.687400688819992, -2.326859312217285],
            [10.689915033231596, -2.3470399553519403],
            [10.67930359923362, -2.3633072924228724],
            [10.666051015051885, -2.3721775885545324],
            [10.661930369104292, -2.389779709014919],
            [10.649873364636736, -2.3943900969455676],
            [10.630719716627894, -2.3861121566972137],
            [10.618228233321984, -2.39349353525117],
            [10.608778475914077, -2.416248937997763],
            [10.59207670946411, -2.4237100874251305],
            [10.59007189007367, -2.4326112811358898],
            [10.560430018289708, -2.4519684489257347],
            [10.549396876853395, -2.451540200069798],
            [10.543300706992685, -2.4663401683011172],
            [10.531833231621137, -2.475732049608605],
            [10.52344368935588, -2.4993153931883105],
            [10.513898706137965, -2.505888508146875],
            [10.459345580030538, -2.51001672749552],
            [10.447063446714942, -2.514994401584211],
            [10.429152628726388, -2.5015405255297596],
            [10.408223934217306, -2.5147915849664053],
            [10.346214585375279, -2.522220026833839],
            [10.33408106200131, -2.530564389580811],
            [10.295449591745244, -2.5353193777034857],
            [10.290256362665932, -2.5479136011065773],
            [10.273554885433354, -2.5590115727784988],
            [10.257322817736023, -2.5791505586526773],
            [10.21259336596155, -2.5916469658082257],
            [10.200177964009123, -2.6141976337851576],
            [10.194486829447698, -2.6357802308650466],
            [10.174853801108107, -2.642875005048706],
            [10.166265835468444, -2.65448178107704],
            [10.156545202394607, -2.6526923580336117],
            [10.148870402740974, -2.6691331100971967],
            [10.134622254537408, -2.6819710902221265],
            [10.12019551003773, -2.710295293918181],
            [10.119107050229045, -2.723537019511672],
            [10.128146897502939, -2.7312295458581124],
            [10.131021629049197, -2.749882743982869],
            [10.120508108954708, -2.7689325393491444],
            [10.109391886375612, -2.7768427719516495],
            [10.118423011923053, -2.7905461826435567],
            [10.115455041068282, -2.80657674598984],
            [10.128848831078841, -2.8215391611379497],
            [10.105515821727595, -2.8582058942706965],
            [10.086003653012746, -2.867810368116665],
            [10.07414652776925, -2.8834545872808905],
            [10.066671408032057, -2.880026699063986],
            [9.993415419971049, -2.897145144051768],
            [9.980416244950767, -2.876023074220672],
            [9.970484521104115, -2.874213182018785],
            [9.944468630518408, -2.9050595843977014],
            [9.922448870585814, -2.924338422515646],
            [9.923600023596203, -3.0296264094813514],
            [9.926347655403003, -3.164552685089192],
            [9.774797855427016, -3.183491229025209],
            [9.684760971513402, -3.1940353546854263],
            [9.534299750803926, -3.2127044647959906],
            [9.428429791624438, -3.22480692539148],
            [9.155794715153473, -3.259117877341463],
            [9.06931058104359, -3.2708653695304664],
            [9.003313659687246, -3.2782415232168205],
            [8.891330600248326, -3.2888721062213198],
            [8.713891088651017, -3.3046089321068535],
            [8.517727473593075, -3.3239131287858488],
            [8.2507543874991, -3.3493296814991576],
            [8.144750096384554, -3.3609789507319974],
            [8.024784064356071, -3.371449451142215],
            [7.87488962389003, -3.3861429682696884],
            [7.697757126401646, -3.398262472507277],
            [7.5206247309084455, -3.4103685914379556],
            [7.415766968814657, -3.4180052465150386],
            [7.225183663133975, -3.4342352827985163],
            [7.073077693526557, -3.4452794823604025],
            [6.953171725334941, -3.455185738540186],
            [6.788762571932351, -3.466745045054992],
            [6.792130435242689, -3.478987803252178],
            [6.57937112384951, -3.4957724447684466],
            [6.399951064654212, -3.5103125595282276],
            [6.2049685912831904, -3.5257421234045467],
            [6.017431371180028, -3.5403963522748367],
            [5.968271712355204, -3.5431090988176708],
            [5.792091456615612, -3.556460664433564],
            [5.730274303305297, -3.5596943438108557],
            [5.543333230500684, -3.571782062243129],
            [5.5001096760977966, -3.575523445496771],
            [5.369823608351954, -3.5836473027882074],
            [5.084008686486994, -3.6001347696913455],
            [5.0818900148426955, -3.593200885754378],
            [5.090676677103929, -3.556896935251568],
            [5.116590517840582, -3.5530464695369712],
            [5.127680133143332, -3.5612899706228895],
            [5.164085706532367, -3.5649677541886766],
            [5.183546194066888, -3.5353694072146524],
            [5.187167475270384, -3.5128366220647576],
            [5.181767710016467, -3.504161183634135],
            [5.183450086056181, -3.4767286335934644],
            [5.190416893029014, -3.4647046792258496],
            [5.210510934427265, -3.4539309789645856],
            [5.23965751381092, -3.4658450455993033],
            [5.259138397995525, -3.4627378345783337],
            [5.271172835894298, -3.4463335555097196],
            [5.2682475505382325, -3.427191973667393],
            [5.240807009459782, -3.413675380239237],
            [5.226716882068638, -3.3954101441850755],
            [5.243331133302493, -3.3895489326323567],
            [5.248628345520016, -3.371594080161885],
            [5.258076801608323, -3.3617651063063523],
            [5.241673716818943, -3.3352272548261843],
            [5.22264512553767, -3.329337819053689],
            [5.204787835288581, -3.333966912065266],
            [5.194558566566675, -3.3308756222742724],
            [5.18169233468895, -3.3128999220747706],
            [5.181672028249333, -3.2941335940954835],
            [5.187512122861303, -3.285395923033083],
            [5.202067676051611, -3.2871882282572136],
            [5.225534372772084, -3.2795222567668207],
            [5.233916760835127, -3.234737854376367],
            [5.246738159599175, -3.2076224504275745],
            [5.244125760590547, -3.1969519500260697],
            [5.2176620635855, -3.1744488589164366],
            [5.203111718869364, -3.171068433305277],
            [5.192330580995959, -3.1786286120482594],
            [5.193346097601285, -3.1981409813993986],
            [5.200450511966576, -3.2087376523275],
            [5.176600403308095, -3.212915756040929],
            [5.16462779140876, -3.2023347840508847],
            [5.170735120254985, -3.164938515675903],
            [5.201274986546845, -3.1426301193073902],
            [5.207332892830098, -3.1175461720463047],
            [5.216597829378364, -3.106540630665082],
            [5.239734803474753, -3.105164580219657],
            [5.249434704496964, -3.1153099567296745],
            [5.246398584774655, -3.1480423118104115],
            [5.262241750072731, -3.1774539187566893],
            [5.2687565032391435, -3.1690990480565335],
            [5.289902019333033, -3.1592039010577295],
            [5.304173057918857, -3.1479054427739546],
            [5.299402731914894, -3.1252696995452713],
            [5.287787656803092, -3.1059428310928765],
            [5.266842335259122, -3.0858040149103743],
            [5.2605318541685575, -3.0647347240375655],
            [5.266841520788494, -3.0326222987098217],
            [5.291411051885051, -3.0179450706634974],
            [5.306644531233547, -3.0170054756591713],
            [5.3326552054116485, -3.033872542886049],
            [5.333598224230307, -3.0518498589561407],
            [5.3583745933983415, -3.061853026924107],
            [5.37431950729646, -3.058939933532407],
            [5.37890172334647, -3.0477464616611196],
            [5.368891089529334, -3.024098460330265],
            [5.3449602936179685, -3.017743123757364],
            [5.330394125803919, -2.99041616159501],
            [5.334991432653819, -2.977397687215802],
            [5.365758709061622, -2.9551345371580178],
            [5.38273172713855, -2.9552347822085996],
            [5.4086028881590735, -2.9353623759803553],
            [5.411478284623547, -2.9119621164179517],
            [5.404784367030851, -2.9007814505697493],
            [5.390568815191964, -2.9039265469909035],
            [5.38295487531454, -2.9176346070016015],
            [5.367712465743685, -2.92112998794431],
            [5.344065288258383, -2.9087093183927157],
            [5.324305973000426, -2.8803407007122077],
            [5.320936496194624, -2.8479583732915685],
            [5.335929009089313, -2.8294654679753517],
            [5.360703149606246, -2.812721526888996],
            [5.370929842243827, -2.8202428739885192],
            [5.39543402772036, -2.8123064624382614],
            [5.415759597499074, -2.8261342581412814],
            [5.445455882175498, -2.809041326697483],
            [5.444337974113685, -2.7776210061426436],
            [5.4575835268853226, -2.7596873905002117],
            [5.475868151039739, -2.7532256301498754],
            [5.500648376767736, -2.759413622944535],
            [5.524851537040717, -2.7397434710956263],
            [5.52304293095425, -2.7235986030005597],
            [5.464465071163361, -2.703368157310407],
            [5.459178054943224, -2.6933264768676692],
            [5.463484890757265, -2.6728025404344926],
            [5.481448060247342, -2.651088504998475],
            [5.504357315414, -2.654556299475826],
            [5.537216332499032, -2.6822301635503805],
            [5.55200270720497, -2.681199086926004],
            [5.561243453644994, -2.6713975479195256],
            [5.563511862341645, -2.649870221024208],
            [5.5547005099553965, -2.6295704538148175],
            [5.501526847568865, -2.6006217660114594],
            [5.494865193944066, -2.5931204024447694],
            [5.492449175231355, -2.5716689053229933],
            [5.483556340515383, -2.5603852277651202]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.34234464640446, "lat": 35.84311118518286 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01325873"
      },
      "bbox": [
        5.0818900148426955, -3.6001347696913455, 11.83241059136937,
        -1.2497666616476628
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.876615406855657, 10.488323418964386],
            [-4.824181233494833, 10.483625339267533],
            [-4.76247661344059, 10.478594524670811],
            [-4.70077310325646, 10.473550473682847],
            [-4.639070730915, 10.468493187974934],
            [-4.577369524388748, 10.463422669200593],
            [-4.50413839443903, 10.45761024165053],
            [-4.430908843506369, 10.451779183749064],
            [-4.358609270385407, 10.446565472801225],
            [-4.286310955514439, 10.441333619450214],
            [-4.214013943811674, 10.436083626151419],
            [-4.141718280201729, 10.430815495326982],
            [-4.054798147175206, 10.424564639400298],
            [-3.9678800207594387, 10.418287575255178],
            [-3.890795709199755, 10.413015620428247],
            [-3.8137128682874226, 10.407723065133325],
            [-3.736631552443712, 10.402409912058848],
            [-3.6595518160866374, 10.397076163849384],
            [-3.584589188066072, 10.392592881681471],
            [-3.5096276594234204, 10.388090139756532],
            [-3.434667280138829, 10.383567940352833],
            [-3.3597081001997045, 10.379026285709832],
            [-3.259447789757198, 10.373317047917437],
            [-3.159189471272122, 10.367573022492692],
            [-3.049322602455822, 10.361453452510249],
            [-2.93945821080549, 10.355292123877442],
            [-2.8703336050589385, 10.351902429635604],
            [-2.8012097603295656, 10.348496215709035],
            [-2.732086715764249, 10.345073483561027],
            [-2.6629645105142488, 10.34163423462652],
            [-2.5710617121985653, 10.337240565378805],
            [-2.479160386975665, 10.33281770736732],
            [-2.3965197149020017, 10.329061003157346],
            [-2.3138801899841717, 10.325280704707595],
            [-2.2246732894099073, 10.321466016053202],
            [-2.1354676492108844, 10.317623843701679],
            [-2.0508497241286023, 10.31442381441608],
            [-1.9662327173352592, 10.311199066312533],
            [-1.8723734853249525, 10.307839068803807],
            [-1.778515358572495, 10.304448665676484],
            [-1.6978110069689247, 10.301937536278473],
            [-1.617107291413299, 10.299403933988343],
            [-1.5513954277673012, 10.297547183507755],
            [-1.4856839269676168, 10.295675536973626],
            [-1.4199728225937425, 10.293788995135499],
            [-1.3542621482287032, 10.291887558719583],
            [-1.2671233670832753, 10.289592376602442],
            [-1.1799852811413818, 10.287271006691245],
            [-1.0908391789396221, 10.285168369952133],
            [-1.0016937264946912, 10.283038329967738],
            [-0.9166173483572579, 10.281262231823225],
            [-0.8315414919619636, 10.27946117933685],
            [-0.7444738056390643, 10.277855588500172],
            [-0.6574066107337003, 10.276223864971666],
            [-0.5811704364019922, 10.275103710216332],
            [-0.5049345213945724, 10.273963522946667],
            [-0.4286989181279005, 10.272803303756953],
            [-0.35246367901907194, 10.271623053199017],
            [-0.3591142318545304, 10.254280512457154],
            [-0.35668442605041134, 10.220206043352896],
            [-0.3449040188564567, 10.205514993227686],
            [-0.339721377524104, 10.176251046733672],
            [-0.32788948008975255, 10.168180461063494],
            [-0.3338891858407543, 10.154411610070925],
            [-0.32175881807650425, 10.146811898636162],
            [-0.317468489875479, 10.125056163647425],
            [-0.3207558309059573, 10.10031609968409],
            [-0.3082765472728576, 10.086653610138749],
            [-0.31152787047470815, 10.072366189222471],
            [-0.30783431404533196, 10.053563566363104],
            [-0.2953297746333783, 10.027416099565189],
            [-0.29804888508114785, 10.015010262300665],
            [-0.28293171036706743, 9.98940158235418],
            [-0.283776522265451, 9.979757518568203],
            [-0.2717966197630743, 9.959906509589262],
            [-0.2704728300456681, 9.93834671743079],
            [-0.28022058843113684, 9.910498344191998],
            [-0.3008543982340115, 9.879526008183445],
            [-0.3064471743483624, 9.849637043055232],
            [-0.31934876445507054, 9.847367671290867],
            [-0.30821509274860037, 9.81248657412285],
            [-0.3059864658022371, 9.785617819568051],
            [-0.2943613439436238, 9.77610839362104],
            [-0.3113582732697533, 9.765771879343447],
            [-0.3012954518435514, 9.747868713317702],
            [-0.29226443567274013, 9.744790498993625],
            [-0.3009246138288582, 9.72370194902936],
            [-0.3027722174964382, 9.703670043551707],
            [-0.2948635422038432, 9.692402394116106],
            [-0.31236553163825304, 9.672254076423682],
            [-0.3005270141096051, 9.657145261670868],
            [-0.311470413942416, 9.650800542460768],
            [-0.2987861836942085, 9.63954340766412],
            [-0.29192743811948896, 9.62571815712556],
            [-0.3003073798403367, 9.600099590206051],
            [-0.2837946507610618, 9.586010642880607],
            [-0.2920984955576727, 9.580341927966384],
            [-0.29223310930889135, 9.54254383189635],
            [-0.30550405856980073, 9.535828011422678],
            [-0.30317418313317174, 9.51235776696547],
            [-0.2926315254599435, 9.507609165143284],
            [-0.3036524484600517, 9.493340879023556],
            [-0.30982634899462363, 9.474664838228065],
            [-0.3076459293068175, 9.437101306314068],
            [-0.29672444644630425, 9.425266368855867],
            [-0.27730051478188567, 9.378829484274045],
            [-0.27610498233503933, 9.364333686794206],
            [-0.2613963640317538, 9.346209786846456],
            [-0.2543458332741955, 9.293074352083993],
            [-0.24720774375883833, 9.282659539435597],
            [-0.2528199862168584, 9.258866531364218],
            [-0.24835257273766, 9.241878565368205],
            [-0.22378566632015853, 9.215664140957163],
            [-0.22209529505969222, 9.203306662227343],
            [-0.22891531100253648, 9.191430028562863],
            [-0.22665446115285431, 9.16946453841429],
            [-0.215931268305995, 9.166999627889679],
            [-0.21081936008000163, 9.147149052069436],
            [-0.20036357913564937, 9.127888262653652],
            [-0.19887479800176497, 9.101996379521518],
            [-0.18460434463681746, 9.090097725868718],
            [-0.18329511851038588, 9.07315420964411],
            [-0.16922756979516423, 9.064888777443132],
            [-0.16818335196796141, 9.036136106053165],
            [-0.15928837276140653, 9.021711502340008],
            [-0.15128906006784543, 8.993648867237505],
            [-0.13686644658282035, 8.963566697002332],
            [-0.1379102039380814, 8.953380184392515],
            [-0.1302565627223938, 8.929412150069735],
            [-0.1331389978429796, 8.921477190766558],
            [-0.1180361996084824, 8.911709123794651],
            [-0.11570939855527936, 8.880994500225434],
            [-0.1260871740047446, 8.86762610249051],
            [-0.11364892096855471, 8.854507057878022],
            [-0.12715644814648533, 8.831371327095889],
            [-0.11355627027068557, 8.800801062404275],
            [-0.12340834511749438, 8.792905188190009],
            [-0.11625862150312866, 8.780192508151353],
            [-0.12316732905205385, 8.741453542971712],
            [-0.1230101959083379, 8.718891053996781],
            [-0.10819982497617087, 8.70295009175463],
            [-0.11196355102875671, 8.673299493609528],
            [-0.11689361361863981, 8.665347029579992],
            [-0.10919040023576229, 8.646656727130045],
            [-0.1033000575450049, 8.613203021532907],
            [-0.11188730406290978, 8.59955563372965],
            [-0.11334758491760061, 8.579942159087516],
            [-0.10497224630487106, 8.553128717910953],
            [-0.11164010336909726, 8.53888505538437],
            [-0.09892108835221203, 8.482351904723195],
            [-0.1033419351648488, 8.449884284311013],
            [-0.09497597282322119, 8.418493483528158],
            [-0.09516293403794732, 8.388308045177135],
            [-0.10084686214771318, 8.365572614399667],
            [-0.09604971118199082, 8.356214673286066],
            [-0.10724976345315697, 8.321112146773336],
            [-0.10028785196955711, 8.309150064937247],
            [-0.09820774213654768, 8.288772532062396],
            [-0.07932951404558287, 8.240443820968672],
            [-0.05690585303191897, 8.239571025914795],
            [-0.07312430820722463, 8.183541705037571],
            [-0.0699639372147944, 8.170191637385035],
            [-0.08357314630666096, 8.122432306703192],
            [-0.08399482512995193, 8.09162325467289],
            [-0.06995347766578706, 8.081978828727443],
            [-0.07645220333333452, 8.05725595271618],
            [-0.07278694512153723, 8.038106714893239],
            [-0.07963427325605618, 8.019793044216128],
            [-0.07656839691329682, 8.009593156888217],
            [-0.08655960856542924, 7.969945742814067],
            [-0.07284545575893277, 7.940547895828279],
            [-0.06873350086016349, 7.920054622279926],
            [-0.05129782666521328, 7.892286929693117],
            [-0.053135666054710914, 7.866553460635411],
            [-0.04326001867347859, 7.828485953720718],
            [-0.04623223738430828, 7.818749682309612],
            [-0.03834710022414632, 7.789770552553941],
            [-0.029150038578908032, 7.782866735954816],
            [-0.032863816724118367, 7.758051784928572],
            [-0.015592728165751057, 7.740267005869181],
            [-0.007775710157804, 7.726113451058061],
            [0.0030395457315968793, 7.693149876208084],
            [0.018362596885361973, 7.680966657710359],
            [0.03434691382818768, 7.660099783692024],
            [0.04850016007245198, 7.648065432671898],
            [0.05120603402585795, 7.596058411182474],
            [0.04819099667951811, 7.58167089529094],
            [0.05269751010732137, 7.533954354171202],
            [0.05847599324667706, 7.524263744250306],
            [0.053361872250317806, 7.505027861933241],
            [0.06155861206026024, 7.496744098421468],
            [0.061543178533682796, 7.468283168260679],
            [0.06896256115928044, 7.453098002516091],
            [0.07848740325031435, 7.405205983693192],
            [0.07670797196791179, 7.3862586168437705],
            [0.06186046424471473, 7.348762139117911],
            [0.06435428158086272, 7.338517980245187],
            [0.06675903187623927, 7.286056791891904],
            [0.07123911518028396, 7.257937844817463],
            [-0.012834028770350395, 7.258643547224137],
            [-0.09690736557451837, 7.259329223457833],
            [-0.2006738140460177, 7.260655346573365],
            [-0.3044407422376036, 7.261950958780582],
            [-0.3335320770465625, 7.261585830590572],
            [-0.4500780358457631, 7.263131625322019],
            [-0.5666244819745044, 7.264638931019307],
            [-0.6701099574274814, 7.266539981439162],
            [-0.7735960350117022, 7.268410680591494],
            [-0.8447038702933279, 7.270099047329163],
            [-0.9158121121545504, 7.271773080091538],
            [-0.986920738054339, 7.27343277838024],
            [-1.0580297254466973, 7.2750781417473185],
            [-1.1376920309895193, 7.277157899099029],
            [-1.2173548501936537, 7.279219662222955],
            [-1.3470670655903478, 7.283991316145071],
            [-1.4767815423491204, 7.28871522404836],
            [-1.5830822320754487, 7.292591793466889],
            [-1.689384299095329, 7.296436291510898],
            [-1.8041251463868824, 7.3001171119652275],
            [-1.8850141425553673, 7.303125514888974],
            [-1.9659038750547453, 7.306115343629835],
            [-2.0563920301198335, 7.309831455653028],
            [-2.1468812302931313, 7.313524315062611],
            [-2.2199826168469725, 7.316961690068228],
            [-2.293084835483207, 7.320383880791126],
            [-2.366187861654375, 7.323790886175803],
            [-2.4392916708021604, 7.327182705223109],
            [-2.5296058324295436, 7.331807664918514],
            [-2.619921350309769, 7.336409433125914],
            [-2.688452354459361, 7.339659530646658],
            [-2.7569840002418537, 7.342896277174465],
            [-2.8640316813159385, 7.348315477502467],
            [-2.9710810498659743, 7.353702090031181],
            [-3.087847452738474, 7.360170051163368],
            [-3.2046161090073326, 7.366599216246891],
            [-3.3077762512846918, 7.371917131451024],
            [-3.4132323924020493, 7.37828124780238],
            [-3.5186905342781314, 7.384613697899198],
            [-3.5974826932505657, 7.38964640539164],
            [-3.676276048276538, 7.394661426153228],
            [-3.755070568514817, 7.3996587586785925],
            [-3.8338662231163085, 7.404638401539142],
            [-3.96373897453028, 7.413493904582173],
            [-4.093615117153223, 7.422301316053969],
            [-4.221930278382978, 7.431368746181637],
            [-4.35024879759785, 7.4403892063522825],
            [-4.476473332221881, 7.449838857594297],
            [-4.6027013284802925, 7.459243023274717],
            [-4.6980023653635286, 7.466639091775553],
            [-4.79330543372866, 7.474009216945373],
            [-4.921043968381471, 7.484350011955672],
            [-5.0260338133898745, 7.493058710847798],
            [-5.131026307445941, 7.501735889876537],
            [-5.127347619893428, 7.555964166628073],
            [-5.115714310795587, 7.678931337546151],
            [-5.095477674361352, 7.9172008454216245],
            [-5.083127726587173, 8.057808441352563],
            [-5.0566700652987775, 8.373313634066358],
            [-5.030943725876586, 8.664236913858169],
            [-5.013150156636403, 8.87584353585659],
            [-4.9971840522145285, 9.05199063733067],
            [-4.977834424493673, 9.270298449419618],
            [-4.967107759192593, 9.382604828306123],
            [-4.9594773459409245, 9.489249088659326],
            [-4.936984965080938, 9.767146073595049],
            [-4.927375147087052, 9.881325015571035],
            [-4.909778323417601, 10.099870093006622],
            [-4.907136838346149, 10.125637333479574],
            [-4.8894667416146484, 10.340695202060454],
            [-4.876615406855657, 10.488323418964386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.46927078301798,
          "lat": 47.44625365935573
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779797"
      },
      "bbox": [
        -5.131026307445941, 7.257937844817463, 0.07848740325031435,
        10.488323418964386
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.621959981848986, -8.45205892826995],
              [6.635912406293357, -8.465716173192833],
              [6.65744427906143, -8.499452802278814],
              [6.667838588001647, -8.526832702968532],
              [6.67673755164388, -8.562113319241075],
              [6.67917369241706, -8.606733921398925],
              [6.671497793611738, -8.671850471349675],
              [6.6457316545435905, -8.735028178329948],
              [6.646948084374557, -8.703933988204431],
              [6.662450713404374, -8.670642735644094],
              [6.666049707036321, -8.641342680863286],
              [6.659370374755903, -8.63331871342064],
              [6.668672285817397, -8.617710974158278],
              [6.668063643580746, -8.576194866427421],
              [6.65835768076427, -8.552937882830673],
              [6.657778220520414, -8.523934242669707],
              [6.643716257226372, -8.486071020797118],
              [6.621959981848986, -8.45205892826995]
            ]
          ],
          [
            [
              [6.2145264938824765, -8.471451187493248],
              [6.234292414796627, -8.464151355127095],
              [6.245991980576158, -8.437096034847725],
              [6.330823164288642, -8.378757205626915],
              [6.316610085776423, -8.40131542052212],
              [6.308920940513451, -8.404712900304594],
              [6.297017406006317, -8.424488777226914],
              [6.309226553750875, -8.425372509047389],
              [6.318303277688307, -8.45199848870913],
              [6.343345148336299, -8.454315638218445],
              [6.356980095862895, -8.459877008992006],
              [6.361185120407027, -8.476841176279251],
              [6.352839634194743, -8.487949948547968],
              [6.3363061344187335, -8.487284496639775],
              [6.3281388436923365, -8.495077703298886],
              [6.330726053282499, -8.512000868640742],
              [6.306180949929728, -8.490537158417123],
              [6.304047821067802, -8.471385805677121],
              [6.291004112491646, -8.464748033794695],
              [6.273604099926313, -8.489252338484388],
              [6.2449188936300315, -8.48860366388512],
              [6.231029686148423, -8.481605161152501],
              [6.217115735799351, -8.485701083645642],
              [6.2145264938824765, -8.471451187493248]
            ]
          ],
          [
            [
              [6.124113193777322, -8.402213556392951],
              [6.122467402113266, -8.393203421831503],
              [6.143534959987748, -8.392442584665972],
              [6.1348141405800956, -8.408057591910145],
              [6.124113193777322, -8.402213556392951]
            ]
          ],
          [
            [
              [6.004202882513691, -9.005161373021942],
              [6.024680064591774, -9.000013850023645],
              [6.032512826367148, -8.991815195873597],
              [6.0567106024232364, -8.991118913017628],
              [6.036527962494426, -9.014169064657276],
              [6.029580834406566, -9.030807238758943],
              [6.01624304165228, -9.02217394115514],
              [6.004202882513691, -9.005161373021942]
            ]
          ],
          [
            [
              [5.780218953341581, -9.236029577412154],
              [5.785425896568399, -9.22985997961284],
              [5.804546072590862, -9.2299755619088],
              [5.79603165216148, -9.244348170291595],
              [5.780218953341581, -9.236029577412154]
            ]
          ],
          [
            [
              [5.663970109595315, -9.355857902579812],
              [5.71065462024036, -9.294712921393716],
              [5.738845497842483, -9.287975592338949],
              [5.736643109637931, -9.30181042787478],
              [5.700964587699062, -9.326539621409621],
              [5.663970109595315, -9.355857902579812]
            ]
          ],
          [
            [
              [5.227667530182002, -9.49085489959553],
              [5.299217996139196, -9.51170855729462],
              [5.29679523988405, -9.519140162856347],
              [5.246937896193124, -9.503671534122564],
              [5.227667530182002, -9.49085489959553]
            ]
          ],
          [
            [
              [5.047647374922138, -9.545508377868334],
              [5.0803658128379485, -9.534947422570873],
              [5.082153211887389, -9.540021696568521],
              [5.047647374922138, -9.545508377868334]
            ]
          ],
          [
            [
              [3.9131982719343608, -9.075654978648876],
              [3.9351541970286807, -9.04961449289716],
              [3.954395789153104, -9.037781358910408],
              [3.9699619646611946, -9.043250837414067],
              [3.9916833743520956, -9.040090404010579],
              [4.002888764665642, -9.021236332565667],
              [4.022436590352213, -9.01202944430917],
              [4.032943920088599, -9.020672723665598],
              [4.054646383454876, -9.018210059879916],
              [4.092555800014861, -9.043133581707618],
              [4.1078588735617085, -9.045085957779238],
              [4.111757516391445, -9.056295056807533],
              [4.127209070444906, -9.050305977169582],
              [4.141294718020675, -9.06910132720145],
              [4.166390466983908, -9.068198384837455],
              [4.17022723561872, -9.07978021856669],
              [4.1909782042240655, -9.085602094830524],
              [4.172463250436576, -9.101652515528716],
              [4.14701477596433, -9.117903944122947],
              [4.140253309336317, -9.137825906929562],
              [4.14606865861847, -9.1519831045991],
              [4.130790432819449, -9.159822146432711],
              [4.115485662677811, -9.155776448102502],
              [4.100427146286386, -9.170220589279362],
              [4.078548039565255, -9.165848889564794],
              [4.063553629623268, -9.142795359138285],
              [4.049900305371897, -9.143074088199105],
              [4.0169739993747005, -9.129742512802245],
              [3.982917498442362, -9.111782978311679],
              [3.9479908226269185, -9.100552145881752],
              [3.9177990634824864, -9.084149955571817],
              [3.9131982719343608, -9.075654978648876]
            ]
          ],
          [
            [
              [2.0942305385462805, -5.706011006132126],
              [2.227378347282711, -5.702949871078608],
              [2.3605256909218264, -5.69986987795275],
              [2.5541100652306223, -5.696035763872276],
              [2.7642495600695454, -5.690687325735906],
              [2.9041072924274802, -5.68672009658165],
              [3.0928869954453466, -5.682465723826605],
              [3.1325174679408176, -5.682346244772846],
              [3.2544608354295317, -5.679415762517647],
              [3.376404087668829, -5.676469420308467],
              [3.4934349150543818, -5.673562275078724],
              [3.610465673893632, -5.670640504476521],
              [3.723263526335187, -5.666851771363752],
              [3.836061071918249, -5.663049432473683],
              [3.900013280082617, -5.660010789404721],
              [4.106902607052829, -5.651891951707595],
              [4.265826496238728, -5.644991815220013],
              [4.378106153721363, -5.640376138986109],
              [4.49038541961474, -5.635746950419626],
              [4.485312012450959, -5.654256379151431],
              [4.462821095073075, -5.680332453554024],
              [4.465294238768537, -5.689129098305328],
              [4.454952526970946, -5.705927904596228],
              [4.45564618608131, -5.719899944542131],
              [4.469798899242302, -5.734546428517415],
              [4.500827011046838, -5.739900692158962],
              [4.512955073123551, -5.73365595422789],
              [4.523178870562653, -5.708518658866068],
              [4.516534024508967, -5.686091861862322],
              [4.5217239118945765, -5.674739135673839],
              [4.517102939839848, -5.659090425598972],
              [4.540712170956611, -5.648577047976252],
              [4.55783537192111, -5.660403791498012],
              [4.563904166836594, -5.6735994796706954],
              [4.564860665561788, -5.693190063224779],
              [4.57875053371332, -5.70925836714544],
              [4.580372854217664, -5.734638882126567],
              [4.5758924407975, -5.7473061406674555],
              [4.548264134650878, -5.7790634851923],
              [4.529879890268932, -5.783348824737438],
              [4.516233935863396, -5.796261025859597],
              [4.503890482021229, -5.827359909525865],
              [4.502977667888144, -5.854106397665649],
              [4.509500259333222, -5.859265020796361],
              [4.503966385148339, -5.8886457376004655],
              [4.517049019138047, -5.89751565883657],
              [4.539619824565496, -5.895351869281373],
              [4.5925126532095, -5.907966356376419],
              [4.598035521020618, -5.912925564215085],
              [4.591139739836326, -5.932652079936235],
              [4.577385212435491, -5.945182641217718],
              [4.547255559936189, -5.9638112784534565],
              [4.532264977108901, -5.98806979160199],
              [4.520179583108848, -5.998564276292398],
              [4.520210269068074, -6.0131617052151025],
              [4.527489952681645, -6.034862412091692],
              [4.537270722647818, -6.046876022548841],
              [4.551527572874474, -6.052669885783727],
              [4.583462330606876, -6.035466928906163],
              [4.607974077255996, -6.027682024149037],
              [4.615958093262301, -5.9979656299969335],
              [4.625998538463508, -5.987296201622401],
              [4.635919522568798, -5.99288005296309],
              [4.646334585016184, -6.010292360367969],
              [4.645640659437541, -6.023124280000965],
              [4.620821945666143, -6.054688859460802],
              [4.585018047752925, -6.079688488946981],
              [4.589730330044005, -6.0891827493887325],
              [4.610820106224204, -6.103941384343037],
              [4.63871662987995, -6.112374753509865],
              [4.659135800785893, -6.123730910177734],
              [4.663728088619367, -6.144377710830618],
              [4.652713428626044, -6.15057026698973],
              [4.62387866293993, -6.143763770086198],
              [4.612648157254792, -6.134636012043945],
              [4.590885991253226, -6.102391574111281],
              [4.574229746627836, -6.087567377309915],
              [4.569118079061661, -6.111389175189632],
              [4.557534945656559, -6.137472978209277],
              [4.558999274931132, -6.154416243517482],
              [4.577606514933741, -6.177887676106399],
              [4.614200783119681, -6.196319865198817],
              [4.6339893737624385, -6.200197353705846],
              [4.663034503353357, -6.181354720664082],
              [4.676072811281001, -6.184492341901777],
              [4.686905926610063, -6.197099848340496],
              [4.681358836092334, -6.219280477626731],
              [4.665339920538462, -6.228268167829986],
              [4.65848382657982, -6.264375090137786],
              [4.6743137358132305, -6.2799421384124],
              [4.737326842840272, -6.28892571144964],
              [4.748775727696096, -6.27339765935522],
              [4.76169261827289, -6.269512093708309],
              [4.736071020911365, -6.324888678745067],
              [4.710549005875373, -6.346349881841726],
              [4.6961349478126495, -6.333717701477598],
              [4.686039350481157, -6.33467143993675],
              [4.68172860498073, -6.36106696385743],
              [4.6940820859224655, -6.378198923066874],
              [4.685408775907553, -6.387577442225222],
              [4.68423140924254, -6.420604112095982],
              [4.669296837721006, -6.436175705649753],
              [4.667491483434161, -6.409074055926885],
              [4.640128769551812, -6.391996122163389],
              [4.629898227470072, -6.392927262899287],
              [4.618551578104452, -6.416019489868998],
              [4.5994021052400305, -6.409205195488972],
              [4.572215219122703, -6.430384812281032],
              [4.558149665856857, -6.424337299867842],
              [4.533285488019805, -6.442145411369102],
              [4.5266947067431, -6.484388525377229],
              [4.537702030842639, -6.506113559222326],
              [4.581457504602852, -6.511544145900135],
              [4.605955431350905, -6.501332338896348],
              [4.630408490768517, -6.50982429685256],
              [4.631594229645563, -6.476649609938137],
              [4.623129440797458, -6.463188253671032],
              [4.637338153142359, -6.459152123302788],
              [4.652097774671201, -6.470384754803063],
              [4.670713511383526, -6.469913515371945],
              [4.664856751209292, -6.5011183971670805],
              [4.64934111994581, -6.512526743081097],
              [4.6440303601190935, -6.535097224655238],
              [4.610171851610678, -6.555942766900341],
              [4.612432605384192, -6.5847154977166085],
              [4.596021386164478, -6.587457885310073],
              [4.582368607162282, -6.5782607717473836],
              [4.569382199977571, -6.5606311322024915],
              [4.552186897776678, -6.5579068327155765],
              [4.542042837474968, -6.570816555691483],
              [4.547279299802703, -6.585644197267975],
              [4.557026389911946, -6.591247045371329],
              [4.5992818770041195, -6.598185943542991],
              [4.616867504003476, -6.617898956945158],
              [4.605768982618348, -6.635131664321035],
              [4.5834313306591365, -6.6493676314193735],
              [4.544038524494297, -6.655866749025788],
              [4.524987061295564, -6.678410935971814],
              [4.5221398463112905, -6.703833008808896],
              [4.530281117733697, -6.70592111633144],
              [4.531568097887877, -6.722839683763425],
              [4.516903565665089, -6.730570256073636],
              [4.489931455073374, -6.764180967894404],
              [4.462939797540298, -6.779707753352718],
              [4.464443686371776, -6.791118296735107],
              [4.483072111537587, -6.8081674481213],
              [4.482144194955925, -6.819041296390034],
              [4.4704215639402465, -6.832566213603929],
              [4.4579001135546195, -6.831188325175863],
              [4.446308503322346, -6.814484660226237],
              [4.44136231435797, -6.783269544508224],
              [4.412494976511342, -6.790077273790604],
              [4.398047987685686, -6.802666298842517],
              [4.388524594063002, -6.846566900181975],
              [4.385288746139526, -6.884398772975869],
              [4.3941849655997105, -6.8875264391745326],
              [4.4187387861731855, -6.882889051376864],
              [4.451971419408869, -6.870722932675712],
              [4.471669687031877, -6.87480893009165],
              [4.4719896017627265, -6.887300319798185],
              [4.462172496838686, -6.896724283340415],
              [4.408576087103465, -6.89487109271438],
              [4.386365516739108, -6.89776826171943],
              [4.3610265446991905, -6.935746649096428],
              [4.359615642299437, -6.958970642933173],
              [4.36547903132197, -7.002598807656459],
              [4.362147263525109, -7.026507900884048],
              [4.345547083505402, -7.036084463703009],
              [4.308952796866791, -7.029047058151537],
              [4.279093115320254, -7.005506179944182],
              [4.2638634386216125, -7.024220620484137],
              [4.264675977491712, -7.039661382725104],
              [4.2771172377085644, -7.055131211313677],
              [4.292456020450256, -7.06394737070407],
              [4.315862581748696, -7.061443033102411],
              [4.34489265725481, -7.050582856276099],
              [4.361176206931763, -7.057084535106229],
              [4.358776187480921, -7.077551686753207],
              [4.324519460299033, -7.10881461720691],
              [4.299780377757275, -7.119263033903684],
              [4.291199516469536, -7.115777942404913],
              [4.269149495617957, -7.120177288694117],
              [4.263862681270916, -7.129217618081489],
              [4.270890970336749, -7.1408216224979615],
              [4.26941064639944, -7.167447907649768],
              [4.275319829236681, -7.206145846233857],
              [4.287761638968972, -7.229366473455342],
              [4.31269744970351, -7.252710140924282],
              [4.313533462110884, -7.27719178636654],
              [4.308395438969939, -7.2837850224783125],
              [4.286903234280992, -7.284802040765727],
              [4.27661088593015, -7.279966034140008],
              [4.261768757379886, -7.2607349887055825],
              [4.246074902023902, -7.219204153998976],
              [4.23231560561456, -7.229035741937249],
              [4.2222830990865905, -7.2538039137308745],
              [4.231254318885824, -7.274758478658966],
              [4.247491376064904, -7.275315161766844],
              [4.249662331547197, -7.3041784865200325],
              [4.284182782214099, -7.332896262867783],
              [4.286389048589249, -7.357882622077652],
              [4.2788959000201086, -7.374535951948278],
              [4.249417178429784, -7.3880982095493275],
              [4.231982255069665, -7.390660225995674],
              [4.191804482421463, -7.386009203123052],
              [4.177930218001577, -7.3867728625064775],
              [4.164562023774205, -7.3992628725526135],
              [4.173772638487949, -7.4201019288222065],
              [4.190531936852348, -7.427648793079893],
              [4.211351257343628, -7.444124831230706],
              [4.221890612606534, -7.458461174802703],
              [4.223449706884702, -7.473435562334294],
              [4.217323451662294, -7.48874967327846],
              [4.1975887708972754, -7.516164773886942],
              [4.1948266435523145, -7.536179290267313],
              [4.2049802743332485, -7.548199543831536],
              [4.246745307326735, -7.580297195468408],
              [4.254100140863162, -7.5959510298685435],
              [4.25097915683476, -7.611180109890588],
              [4.229748623984582, -7.6337536780702395],
              [4.200721240711668, -7.646923556141986],
              [4.201007726216122, -7.6530876539327295],
              [4.287012349189992, -7.649168178785925],
              [4.373016398222828, -7.645235978704202],
              [4.5241784597178905, -7.637388867159569],
              [4.676308253735606, -7.630251143006462],
              [4.824363651366938, -7.621788581221069],
              [4.961130992736869, -7.61479953549221],
              [5.1120944018638745, -7.605913649378933],
              [5.263055363111245, -7.596988463916796],
              [5.35525430199564, -7.590907440197951],
              [5.44745215392851, -7.58481173974444],
              [5.550276714224184, -7.578215167079858],
              [5.6531000447209685, -7.571600345278755],
              [5.7984454146307725, -7.5618403253479824],
              [5.815419798420064, -7.557763275472113],
              [5.820278416085138, -7.568906869738835],
              [5.81523410439384, -7.595897410611055],
              [5.799140438083661, -7.619938381273235],
              [5.810611197502528, -7.643661494494099],
              [5.801645270786148, -7.662041211146388],
              [5.787508426376093, -7.667152039578318],
              [5.794049308561689, -7.697074081911203],
              [5.781059305798277, -7.710514168267132],
              [5.777016292784923, -7.732298689844492],
              [5.783154949088849, -7.73662632902143],
              [5.759743309700926, -7.771599015647985],
              [5.745863067511768, -7.801634379592098],
              [5.753572292465849, -7.823465304673229],
              [5.752150085199131, -7.8405378476435414],
              [5.738119341340926, -7.8590598167963535],
              [5.747141604363888, -7.866201303629335],
              [5.739338561783306, -7.896074711941672],
              [5.759701277315171, -7.915276335172477],
              [5.76499537390132, -7.931465472199238],
              [5.764888021009643, -7.959492322117192],
              [5.7811501439561885, -7.995344231604173],
              [5.7951765749405, -7.991615804074946],
              [5.792862502990958, -8.013741917945403],
              [5.805488886574488, -8.01683984275144],
              [5.817217534357928, -8.04524061626106],
              [5.840462220145072, -8.061330661206224],
              [5.856076827392591, -8.06569321722514],
              [5.864499579060674, -8.079166173403731],
              [5.894099904958285, -8.103074881159085],
              [5.893710052837941, -8.115310935494763],
              [5.9008187361772695, -8.140190619211431],
              [5.896918412178125, -8.148537954945366],
              [5.9176797416703355, -8.18156357207343],
              [5.922972789680194, -8.19587445390937],
              [5.9477315346895905, -8.21135368724099],
              [5.952425598457017, -8.235915668973485],
              [5.941154953230604, -8.24359344006239],
              [5.935751845964837, -8.259835436799802],
              [5.950283161659114, -8.270427888096771],
              [5.95148286610705, -8.292936567825496],
              [5.965574791634745, -8.301465345924031],
              [5.966137844505063, -8.321194370297153],
              [5.980506519718377, -8.331558735751017],
              [6.0001757640158955, -8.359938589507959],
              [6.009703475484349, -8.36515960376783],
              [6.028814761064346, -8.351164343520566],
              [6.045336092595074, -8.354143940186885],
              [6.01110102250989, -8.372578369491505],
              [6.009382703109697, -8.38497705151188],
              [5.997143765924729, -8.395441733302428],
              [5.964745200232487, -8.390912069994855],
              [5.939054698110184, -8.431338935591935],
              [5.9195260859599115, -8.44635230444941],
              [5.917847350038137, -8.475573652836909],
              [5.8872900882688635, -8.48439424942536],
              [5.877866357239901, -8.500525310651705],
              [5.893097670652755, -8.523648134303478],
              [5.879610878052074, -8.530845485702415],
              [5.86552293509945, -8.518026886888448],
              [5.848185327724775, -8.50939954661483],
              [5.804711344004211, -8.512211371058477],
              [5.782510401809215, -8.537932614928042],
              [5.771278226110643, -8.556639023803024],
              [5.786413333757976, -8.601989941426783],
              [5.7957193218916485, -8.615009990636382],
              [5.811231253976026, -8.623486654236526],
              [5.836442584518448, -8.621993430968152],
              [5.872552385344458, -8.607262882132222],
              [5.887258981847299, -8.594355406636645],
              [5.900579915041509, -8.603883107199028],
              [5.873663874182166, -8.621794759453005],
              [5.877101017126397, -8.644237459482403],
              [5.899400207569893, -8.660495136571129],
              [5.913598070556321, -8.675130950116374],
              [5.948812207353741, -8.68426487623327],
              [5.97525127529521, -8.682124468527583],
              [6.007345121440777, -8.663764530642617],
              [6.011476197357756, -8.654161107095916],
              [6.008332577023301, -8.626310861349765],
              [6.016544476079868, -8.613690181942724],
              [6.015677464661567, -8.597437699007415],
              [6.024285827660885, -8.581387990756562],
              [6.023130752556998, -8.567352840341377],
              [6.013979454836166, -8.553316279510488],
              [6.0309799734136, -8.544108472024938],
              [6.05198065023271, -8.525898690259465],
              [6.087208889317936, -8.501698785138347],
              [6.081121063361447, -8.479184057686927],
              [6.094224712659693, -8.464497261875655],
              [6.1160684350584855, -8.478517132950463],
              [6.140159203448931, -8.501766345266402],
              [6.152351623372288, -8.490940552784878],
              [6.173344244123462, -8.481348760973859],
              [6.184730624174014, -8.485222984842721],
              [6.182105217604296, -8.497657762409824],
              [6.162250188056883, -8.505356357914243],
              [6.147272689526809, -8.518026178670354],
              [6.140910438098635, -8.50661590667069],
              [6.12878596796959, -8.51295940821464],
              [6.119031135083124, -8.538544182200019],
              [6.1405336998486595, -8.544008801321858],
              [6.1411943738446855, -8.560726153693713],
              [6.150977129246612, -8.570884334580203],
              [6.175771281736654, -8.56910702890008],
              [6.173741406816964, -8.577901683942073],
              [6.189640872135557, -8.589884020252576],
              [6.195996170262635, -8.624390570961806],
              [6.202121690577632, -8.638070044772565],
              [6.231935709881531, -8.621370555214249],
              [6.245383834521351, -8.606211286613082],
              [6.271128487997897, -8.552717721827122],
              [6.277141107803417, -8.53575409609814],
              [6.30173894346303, -8.531482678690866],
              [6.303073301678793, -8.550021944974738],
              [6.321650011887368, -8.55531281818782],
              [6.309444505034229, -8.591915064172872],
              [6.277628898682514, -8.597980075928087],
              [6.248358909924961, -8.624806426791656],
              [6.241575366417133, -8.638524350966602],
              [6.227027503558616, -8.645258206465732],
              [6.233671236558761, -8.655098678353653],
              [6.252496016894801, -8.645510042599092],
              [6.2718121412611465, -8.645747997341822],
              [6.3139780280026905, -8.63722645679501],
              [6.31523101171379, -8.643550355464377],
              [6.2952141892615785, -8.656526480049209],
              [6.2860851416636505, -8.675077174450848],
              [6.270489403035101, -8.661856376076527],
              [6.252330245381969, -8.673590714194855],
              [6.243718384636081, -8.703468818977834],
              [6.230358696422405, -8.678225134294047],
              [6.194036876936209, -8.690223380436155],
              [6.1989061589033465, -8.707716850238569],
              [6.213383912987155, -8.702136906218364],
              [6.217694773962556, -8.71868750802709],
              [6.238661185582186, -8.741610235377033],
              [6.2543948538614735, -8.741988967431368],
              [6.275690731595231, -8.725151632512562],
              [6.279011044507392, -8.756837836573107],
              [6.267805685683234, -8.76577796958789],
              [6.242174777643548, -8.746600017587634],
              [6.223730871909448, -8.744633974398576],
              [6.212467711634793, -8.75101821060284],
              [6.204199649974956, -8.740559796459147],
              [6.187921371999227, -8.740174409160325],
              [6.183409462065996, -8.760814373920615],
              [6.160126562281937, -8.791037357419214],
              [6.162519154693094, -8.81878126720719],
              [6.168785287358452, -8.833185242460639],
              [6.155952220015232, -8.849585251992188],
              [6.15422181494461, -8.860342866319522],
              [6.163321715908088, -8.874453805018346],
              [6.136120150657146, -8.880892989443652],
              [6.129778480903343, -8.860102825695817],
              [6.136825483397975, -8.85301679569509],
              [6.1311063252636036, -8.834388332775045],
              [6.114470929233664, -8.814765952482782],
              [6.1038986416115995, -8.817476374334866],
              [6.090723537685375, -8.808682583913738],
              [6.079605646729135, -8.810578590078343],
              [6.086540289710848, -8.834330190379715],
              [6.083092697562397, -8.861076824592757],
              [6.0779330592655825, -8.870262702515474],
              [6.096008375895216, -8.878517359892989],
              [6.104452969146524, -8.894829798374278],
              [6.089152323776501, -8.894985686315977],
              [6.081537840498705, -8.884711366446103],
              [6.049088429749486, -8.879321087355354],
              [6.034316282227994, -8.884491734773732],
              [6.025495635879761, -8.896464073598105],
              [6.00284868097022, -8.905321789553886],
              [5.991800600129002, -8.89807448063018],
              [5.966511696358037, -8.897496576892994],
              [5.969397656205248, -8.906513474525154],
              [5.991776254244991, -8.920583943534492],
              [6.0152612593247765, -8.943173147662193],
              [5.997723862180889, -8.944133941240946],
              [5.978663074342247, -8.917755725500077],
              [5.9564841431165405, -8.917784942767877],
              [5.962207612370797, -8.955425152899853],
              [5.980272426073632, -8.955521426741015],
              [5.988454873991325, -8.966237677377585],
              [5.970227223465793, -8.978494610996425],
              [5.952238526531135, -8.980814596608562],
              [5.9602988651582764, -9.005605834877386],
              [5.977987658326848, -9.00976293646668],
              [5.978526507233892, -9.019246364017366],
              [5.994662074768651, -9.03711866699266],
              [6.004336361181965, -9.037604243869465],
              [6.022521226421219, -9.048886922505032],
              [6.056603020805881, -9.042415548895832],
              [6.055708569995606, -9.061109914880006],
              [6.086466803616507, -9.092026829701393],
              [6.091982983753229, -9.11039397530462],
              [6.103551976689646, -9.11862917499776],
              [6.106239320121583, -9.12959211778503],
              [6.084952750068399, -9.129475220810354],
              [6.070516858718152, -9.139286582675421],
              [6.090829216438782, -9.14632394631189],
              [6.1139691557820015, -9.14916971059973],
              [6.149332409159086, -9.127776717247167],
              [6.178161545882468, -9.139177552788501],
              [6.204741926553417, -9.139202884250691],
              [6.2253520837926954, -9.135532666436033],
              [6.246239224008049, -9.143109146404043],
              [6.266919192623182, -9.165245542833375],
              [6.282444831294515, -9.16447575364373],
              [6.292036657612763, -9.147603098642401],
              [6.329827258626012, -9.166334157067428],
              [6.3431908958008725, -9.192219497829079],
              [6.360317596342106, -9.209303514956616],
              [6.3878923711598015, -9.167683933945087],
              [6.404256942444532, -9.173192215004507],
              [6.42163091706948, -9.206228262334232],
              [6.444020419011409, -9.216458431910587],
              [6.455071432978686, -9.240845894628322],
              [6.468688263073736, -9.252463391630823],
              [6.4575772856372575, -9.27397442633712],
              [6.471392335726166, -9.29206251970236],
              [6.466359703359029, -9.302884286421198],
              [6.511290045467837, -9.30806959397134],
              [6.549053725223611, -9.284002454301683],
              [6.568438581128247, -9.311151701179249],
              [6.558524172490348, -9.321681923694399],
              [6.532872117030385, -9.31553893925811],
              [6.5303658920576355, -9.329525610685783],
              [6.505065004073856, -9.330881739433268],
              [6.478311557730861, -9.343677515544684],
              [6.492691159111747, -9.363576349069396],
              [6.520613755328667, -9.366491854560053],
              [6.543080794127763, -9.363226650958744],
              [6.522715673061449, -9.408927296034943],
              [6.510782509764942, -9.391314497659604],
              [6.48849058948417, -9.385732678654158],
              [6.48750987777654, -9.40920095315643],
              [6.480375334321355, -9.42838962282323],
              [6.454053967504552, -9.433348230864995],
              [6.455314096981749, -9.462900729077672],
              [6.4474331747636064, -9.482446734498314],
              [6.4633346747806115, -9.511083492658278],
              [6.449611173236406, -9.507314753032054],
              [6.394921365244325, -9.485420162097226],
              [6.3959759568272805, -9.462559447081425],
              [6.389468564837856, -9.444255279552351],
              [6.370832109670225, -9.425906007958645],
              [6.361761132015031, -9.427828400573418],
              [6.356862953545853, -9.452687734088418],
              [6.336391907749263, -9.459091782547938],
              [6.310893711118138, -9.496023433371954],
              [6.2957821046734885, -9.510825514783308],
              [6.260317604285411, -9.560029244966275],
              [6.238361555218789, -9.586037645430858],
              [6.226251849995565, -9.585194436316321],
              [6.2386017275362144, -9.562294848317205],
              [6.240432821549273, -9.54628453367105],
              [6.264009812740079, -9.516250172745034],
              [6.27842837968869, -9.486777615208661],
              [6.277130067987978, -9.472909823615268],
              [6.283868296022742, -9.45843586237821],
              [6.304213410593374, -9.457230935582293],
              [6.315714383941218, -9.425646865224822],
              [6.315330739470014, -9.394072667999783],
              [6.319799663242608, -9.380835191129412],
              [6.3344442348043675, -9.375915182239378],
              [6.330389819177289, -9.354246033671794],
              [6.33377323765656, -9.340469744749806],
              [6.315831254921404, -9.316696573063163],
              [6.2951388929068965, -9.315470700433552],
              [6.28721106129235, -9.326892343857812],
              [6.290642185588857, -9.339987063228145],
              [6.2872474368893245, -9.368326365599174],
              [6.272258349138122, -9.388187474276675],
              [6.2298796293753265, -9.39695745878793],
              [6.204256956162282, -9.378182008985373],
              [6.18467144166119, -9.34276200349923],
              [6.151057271253661, -9.312024364588313],
              [6.102781823885772, -9.294366096593592],
              [6.041176212205894, -9.281245768472399],
              [6.033425850196278, -9.267434540486837],
              [6.024456506967523, -9.267004523825912],
              [6.009368693421868, -9.246891877457665],
              [5.981506204794955, -9.250216361003794],
              [5.933170099193702, -9.238554838347337],
              [5.830811504744788, -9.23054115798805],
              [5.83585931001984, -9.207014832509627],
              [5.8435123183240485, -9.193924359590213],
              [5.864353967597231, -9.194273346384122],
              [5.875503138882238, -9.218345005864288],
              [5.893590435087091, -9.209184031282796],
              [5.9009529561507215, -9.194978440556723],
              [5.929809311865469, -9.185435724617049],
              [5.9622054155852835, -9.182374640175633],
              [5.997433475212169, -9.162844519701377],
              [6.003856039597964, -9.165697925527873],
              [6.019910650769452, -9.191065265426971],
              [6.0434491305437845, -9.179869785464039],
              [6.02975593310225, -9.149638407018163],
              [6.004302887398569, -9.14169837996456],
              [5.9766658487552, -9.15048845935339],
              [5.954606518878228, -9.149684832019569],
              [5.936085692000547, -9.155199568257226],
              [5.891150623022136, -9.15689515444695],
              [5.889086066078227, -9.148477694228752],
              [5.869854270018354, -9.13702263143595],
              [5.849889434269443, -9.148960306380136],
              [5.838974067212711, -9.134318719474741],
              [5.823361886858157, -9.129297587191536],
              [5.828526862554902, -9.098724214953767],
              [5.844835885412214, -9.089689962552457],
              [5.826129514512214, -9.076457058817839],
              [5.80329647087153, -9.082432131341355],
              [5.803147858553622, -9.097593613128241],
              [5.787522380887316, -9.118758775770814],
              [5.780652548865052, -9.108855576192054],
              [5.7558100218818256, -9.10720558658541],
              [5.743350140789019, -9.11659257566993],
              [5.7330345016306445, -9.098201039665046],
              [5.711897897489709, -9.095230224675909],
              [5.692660609786458, -9.108923809187864],
              [5.71244616334114, -9.12631793789579],
              [5.700259395206292, -9.146534457522359],
              [5.686340234470634, -9.156004697798599],
              [5.682285725282634, -9.180219798177832],
              [5.653471051401787, -9.193069403641038],
              [5.657997540359351, -9.203849370440276],
              [5.677821250236779, -9.205383554468845],
              [5.692706995512576, -9.188172038449292],
              [5.711687852688021, -9.204088742363275],
              [5.70747790926711, -9.216130362136164],
              [5.6858479191987685, -9.215638155229634],
              [5.676575212642191, -9.208635966160374],
              [5.664542845990672, -9.215883505312169],
              [5.659568748148785, -9.227718902964813],
              [5.66449072690258, -9.256094867443641],
              [5.680828131905076, -9.258153152275387],
              [5.679618432421022, -9.271751473137469],
              [5.667938415494865, -9.277598941511844],
              [5.6457873974881085, -9.265857363662372],
              [5.62967602798573, -9.265724610336175],
              [5.603084648088916, -9.297989441353124],
              [5.612132655846145, -9.322844847225054],
              [5.627470544597149, -9.331944722172643],
              [5.63932593159726, -9.351893234457],
              [5.652711130018722, -9.350983150510766],
              [5.660259376954433, -9.369010881136079],
              [5.620293665727617, -9.397875055251014],
              [5.6028638649872295, -9.413601044208148],
              [5.557804341564446, -9.448737662772958],
              [5.544525049334515, -9.461602004470087],
              [5.513875781630891, -9.479170448431871],
              [5.4913018402366, -9.471090262805932],
              [5.502547068436794, -9.456945398387594],
              [5.501274684527008, -9.438699346969186],
              [5.4833784012263225, -9.425127420156763],
              [5.47780653585076, -9.403833301180251],
              [5.4697149511976715, -9.392325719283658],
              [5.475339338792727, -9.370366913001057],
              [5.459433004314329, -9.360248108270653],
              [5.428909927386658, -9.302843898076103],
              [5.416142187872094, -9.301344588089119],
              [5.395814316613821, -9.286461031241732],
              [5.386366686387956, -9.271038593950957],
              [5.367420029009573, -9.284131510931257],
              [5.372624855480224, -9.311994014573228],
              [5.353403553400705, -9.320696098930895],
              [5.348843550160366, -9.293101731700082],
              [5.353043674347824, -9.281692947383712],
              [5.348219502751914, -9.268763656523586],
              [5.323293328219723, -9.251267628645062],
              [5.318494416989628, -9.235162693317795],
              [5.308765498608728, -9.232141688233858],
              [5.291977019760487, -9.244884806531871],
              [5.300459902314958, -9.26016509532644],
              [5.27825779977591, -9.29042270349718],
              [5.265922743011612, -9.289081411574296],
              [5.254735275001568, -9.278968493618969],
              [5.2313526815065785, -9.28224643241685],
              [5.213126641586902, -9.300996040260607],
              [5.191757386476905, -9.274555233563593],
              [5.174417393895314, -9.285361389900672],
              [5.17307865608002, -9.29997725284554],
              [5.184617768767426, -9.316328417499214],
              [5.18191895747576, -9.341572280581026],
              [5.204621661923327, -9.34777077853558],
              [5.198609782492506, -9.35702128891177],
              [5.1795672400697494, -9.347644781963083],
              [5.162156094201041, -9.352103575373752],
              [5.171436733684805, -9.363465630891813],
              [5.167004019674056, -9.373137934765367],
              [5.146228205743054, -9.375221092672557],
              [5.140121776185537, -9.392053086208657],
              [5.136576255597147, -9.417350642773224],
              [5.113431197470119, -9.416380090479107],
              [5.100092432227444, -9.465479560701608],
              [5.0856383357473245, -9.474882148233007],
              [5.074279193671405, -9.456139101147985],
              [5.063358639940237, -9.458068686864564],
              [5.056415046693068, -9.475252804900276],
              [5.040102922626694, -9.47573215045146],
              [5.031756233744696, -9.486536133762579],
              [5.019298330525748, -9.487108922575835],
              [5.007600225996085, -9.501370389724565],
              [5.007745114731868, -9.527169941832819],
              [4.979506372079357, -9.530270973854092],
              [4.965588821134358, -9.522893801518425],
              [4.949638360581514, -9.492183841331915],
              [4.9304057686893605, -9.477324825532024],
              [4.920283063052759, -9.457677894544576],
              [4.904849810682419, -9.453167241789114],
              [4.865180193404185, -9.41765945922396],
              [4.845302808897965, -9.430886545668967],
              [4.821147112030977, -9.430298095066124],
              [4.806311905177454, -9.419185432700058],
              [4.805617853070375, -9.406111149106126],
              [4.795288104017189, -9.397529840628339],
              [4.773638607820894, -9.424554081616892],
              [4.760689551601076, -9.417535063193014],
              [4.746874103575682, -9.41772886569075],
              [4.730525417018709, -9.401253029370228],
              [4.714942558747677, -9.391393396937104],
              [4.671616796694172, -9.391526866710175],
              [4.640210229601664, -9.388997855196733],
              [4.57499513527416, -9.363803565397946],
              [4.561915486407661, -9.35262107065489],
              [4.531490613904397, -9.319300167472424],
              [4.565867296959538, -9.311142376585847],
              [4.582747139699779, -9.287940554334199],
              [4.581197969470127, -9.277959187024443],
              [4.589698310775713, -9.25915177328023],
              [4.6103678714293155, -9.24943542224978],
              [4.6117867223567846, -9.263075529524027],
              [4.650153235478888, -9.3113155663528],
              [4.667884475116014, -9.29477001123101],
              [4.676470926775593, -9.306314437436582],
              [4.674848176577963, -9.335260970361283],
              [4.682167551816301, -9.360384366435847],
              [4.714069660113789, -9.364611467461875],
              [4.723587458904487, -9.35389042527861],
              [4.709144599973853, -9.331793392613047],
              [4.720094756218986, -9.306773827608934],
              [4.705986995133731, -9.272996647522154],
              [4.690578025072, -9.269988127170535],
              [4.6806485898959975, -9.254525219427295],
              [4.6662379310634154, -9.252689951150328],
              [4.647464269973868, -9.241663463832028],
              [4.645171000229405, -9.22817257408116],
              [4.627824601219138, -9.221559396974513],
              [4.633222809236683, -9.197758872923833],
              [4.624468352501067, -9.182886066239199],
              [4.59328111984818, -9.175946060668256],
              [4.583139385081224, -9.145717691584672],
              [4.570105105468366, -9.139915287195015],
              [4.5594940053830575, -9.145190698922327],
              [4.542415540105081, -9.142343616885075],
              [4.534978272006862, -9.134399546743133],
              [4.518808894053649, -9.134622091731636],
              [4.506749537935947, -9.112126198838892],
              [4.483656915217271, -9.107362745768263],
              [4.474520985001978, -9.114078741202313],
              [4.452378181362784, -9.114869370651508],
              [4.443643365296882, -9.110477958908493],
              [4.440194101091204, -9.089676291746617],
              [4.4210185800517054, -9.084576612925098],
              [4.380392599364308, -9.093336439840794],
              [4.362457590897191, -9.103260498890213],
              [4.346967931982595, -9.101528335294882],
              [4.354250399828262, -9.08762128837129],
              [4.343230583722795, -9.06841682839224],
              [4.343980744771929, -9.049644613414449],
              [4.325084770248411, -9.000146037441864],
              [4.304482485806023, -8.997315755187106],
              [4.263310166691354, -9.00992675818705],
              [4.2532409532535, -8.997920609429867],
              [4.264047239431461, -8.968112018537932],
              [4.261836026593141, -8.95615797650546],
              [4.267161938949441, -8.9197647946115],
              [4.256594853660144, -8.89910965276308],
              [4.217314267388868, -8.895780932671375],
              [4.182280960972094, -8.906356702448553],
              [4.161503564556288, -8.894292532607741],
              [4.130701785373534, -8.900246807316938],
              [4.079061374525411, -8.927515694568234],
              [4.063923295401644, -8.940116748137022],
              [4.040563723775339, -8.933379406013422],
              [4.059052320271233, -8.918680999276392],
              [4.054963704365568, -8.903236737876718],
              [4.038018692816028, -8.893449915358287],
              [4.058240614991877, -8.869919489141619],
              [4.074284892436499, -8.87316664356937],
              [4.083019595881169, -8.865935905901363],
              [4.0848896405037705, -8.848025975349305],
              [4.076812070698217, -8.819815875164116],
              [4.0494992721934775, -8.823756671065706],
              [4.032230180362261, -8.81562056597297],
              [4.01084768943606, -8.820997954485614],
              [4.004104920739164, -8.832739412098327],
              [3.9849372118463475, -8.836126978983494],
              [3.9635746220605146, -8.827921576889603],
              [3.957730217322206, -8.819084800007134],
              [3.9431332131860874, -8.834998215162097],
              [3.950851561042339, -8.850841808485209],
              [3.90137179997021, -8.87435389332123],
              [3.8607186578322263, -8.898308923239615],
              [3.8336006709373973, -8.918802349067288],
              [3.8097572370592987, -8.94262606116351],
              [3.8047475197643594, -8.933324043951353],
              [3.820618387054569, -8.92187799682568],
              [3.826333980168978, -8.905315865393515],
              [3.818615244026692, -8.893382617963958],
              [3.7970945148841637, -8.907000038518133],
              [3.7815613813177937, -8.901159225777345],
              [3.7856787227284587, -8.92047707678702],
              [3.757207582509492, -8.908132460583666],
              [3.752657498461319, -8.915704692557249],
              [3.761120616611661, -8.935371051920336],
              [3.7890204771933895, -8.95948584856301],
              [3.8052920052789276, -8.96343110756788],
              [3.8167833097334785, -8.959090327637695],
              [3.845648880551841, -8.958264071736325],
              [3.846492395565458, -8.964179027496481],
              [3.8193806169374596, -8.987065103043266],
              [3.8190028075578177, -8.995453224714023],
              [3.8418573977021326, -9.038345581815973],
              [3.8475931582495697, -9.044548692278683],
              [3.865908611869227, -9.032862470695559],
              [3.878842045672426, -9.03538111082236],
              [3.8884580716727135, -9.045234243806417],
              [3.878525980189274, -9.05493565624491],
              [3.8733177570445894, -9.070640941306996],
              [3.8511884588545056, -9.067621922343788],
              [3.8141950764360883, -9.070942238251439],
              [3.7672948387334215, -9.09051995258124],
              [3.7203707083897317, -9.12039577405124],
              [3.6958088620026865, -9.127172458615787],
              [3.6616171504470856, -9.131244919921613],
              [3.5796548803795774, -9.117274537667708],
              [3.535030887806154, -9.105236086698916],
              [3.479364961422323, -9.09898694284567],
              [3.4406655918007534, -9.089853377836244],
              [3.399478910083056, -9.085998330284863],
              [3.387474061508548, -9.077023270532502],
              [3.374043236969558, -9.080146343041536],
              [3.2952198510937722, -9.05487315313235],
              [3.2762181588083563, -9.043262351720312],
              [3.2628305936313535, -9.041567867957124],
              [3.1935180262961445, -9.010460798037057],
              [3.1242150602133223, -8.979338350735736],
              [3.0970173940796366, -8.968259772019715],
              [3.0103229882675975, -8.941970158480368],
              [2.912418383235601, -8.920310213609381],
              [2.8482838587399457, -8.914869837782653],
              [2.819916528301774, -8.918218412458613],
              [2.765647959139531, -8.932245509838477],
              [2.7273008747813865, -8.929316590437061],
              [2.6569501475008734, -8.928618661358737],
              [2.6233947692808144, -8.931356859400731],
              [2.474975731888219, -8.955772392573639],
              [2.425227902714252, -8.967463025261157],
              [2.39051303776724, -8.980713999525996],
              [2.361126118322543, -8.996123693890903],
              [2.3409753418709767, -9.014075020085068],
              [2.3121469068054745, -8.97037446016071],
              [2.2956839579050072, -8.96406272601926],
              [2.29351718621719, -8.944892859975978],
              [2.2866634295261776, -8.935251080701452],
              [2.265608538338979, -8.922389382607024],
              [2.259795569891588, -8.910617764480595],
              [2.264578029609178, -8.889028706808451],
              [2.2832599584843924, -8.870664595976903],
              [2.3221534914106665, -8.842970814148856],
              [2.3429170049578185, -8.812571163270759],
              [2.3542820635685953, -8.786227392861726],
              [2.3610631328572325, -8.752604955492524],
              [2.3782916445201434, -8.71655117883729],
              [2.3914519362700917, -8.710957790476675],
              [2.4051263218424768, -8.691572308157532],
              [2.4183229729302074, -8.682551844613018],
              [2.4199843164351567, -8.669350152199726],
              [2.4339913312719426, -8.653416232678813],
              [2.4374074259660152, -8.637415077696044],
              [2.430447920002731, -8.612816968193224],
              [2.4484230320629243, -8.593978305284477],
              [2.4527857327231595, -8.555365091073536],
              [2.4317706509146664, -8.499273374820437],
              [2.4313846822181695, -8.489557625957726],
              [2.4418053432298312, -8.468384846073032],
              [2.4394161707949, -8.442830371810803],
              [2.4422816474409825, -8.418533087178366],
              [2.40802935142116, -8.405385485224881],
              [2.3906425227165213, -8.366025546645263],
              [2.396685663648511, -8.335096305738746],
              [2.3949128839069562, -8.31931606365025],
              [2.4040840421143628, -8.313823869996849],
              [2.4258806216185316, -8.283235513569647],
              [2.4432801979724346, -8.272334033711372],
              [2.442635911762943, -8.251979084176748],
              [2.4271637968131645, -8.228513010007687],
              [2.4346292181525473, -8.199119689530873],
              [2.411354992507347, -8.179821176614947],
              [2.4191361570746706, -8.152023021313022],
              [2.415431427189185, -8.137377505499371],
              [2.4273425926683867, -8.123859081208819],
              [2.457178293538336, -8.11650200174451],
              [2.450873507070515, -8.085780130788873],
              [2.4522278087419083, -8.070298875129],
              [2.475637170918024, -8.040520713123938],
              [2.4899400171379864, -8.037316392735725],
              [2.504658093838449, -8.01592212972922],
              [2.5010291358026944, -8.0092148709938],
              [2.5119831542829765, -7.992090610467606],
              [2.5136733438213943, -7.962469934750281],
              [2.507953628152, -7.954438854182633],
              [2.527190253349614, -7.946398442981061],
              [2.5411541039922083, -7.908597836371677],
              [2.558809198974789, -7.876616312795082],
              [2.545829110092114, -7.867094493625832],
              [2.554716490450013, -7.8578709307900345],
              [2.5395372120659925, -7.826010501688681],
              [2.5459144938734073, -7.815602317151222],
              [2.560486167613337, -7.812647177709657],
              [2.5522253665754815, -7.796857652396738],
              [2.57540404691788, -7.785333388055233],
              [2.5792741153019074, -7.772310114024831],
              [2.57382397121076, -7.751890307216501],
              [2.541279877847015, -7.734852051719905],
              [2.5454067149928035, -7.722994367528751],
              [2.533056057446077, -7.71139258359569],
              [2.543461259119361, -7.6980425221833],
              [2.5662133811760337, -7.702298363610395],
              [2.570813602566215, -7.691561111505521],
              [2.591864135029648, -7.680605111625873],
              [2.5804655700897197, -7.6740784401995805],
              [2.5718497939107285, -7.659008041308144],
              [2.5820897583953233, -7.648614013408453],
              [2.570052121127474, -7.636303972564649],
              [2.553229633420295, -7.632379639056169],
              [2.5468719443286276, -7.614202632199984],
              [2.562979488148155, -7.596799283270327],
              [2.55423106334388, -7.555844991125612],
              [2.5666101024275023, -7.527045593991128],
              [2.5532381960727424, -7.525261121087156],
              [2.5200460627238925, -7.547018966811365],
              [2.50971404749089, -7.536753952717305],
              [2.503025491246814, -7.507819540588185],
              [2.5095317063673046, -7.488968055112812],
              [2.492983850405342, -7.480500324454462],
              [2.4953920127943134, -7.452230965015781],
              [2.4880980721613635, -7.441849002525389],
              [2.470040282178394, -7.442764775677437],
              [2.4563331845922587, -7.432773016001224],
              [2.4495374759717436, -7.417914913369588],
              [2.431826922440399, -7.405620239704011],
              [2.4473053120131536, -7.375606667845573],
              [2.4472840174600217, -7.362256743411531],
              [2.4656926633435314, -7.3562474215773275],
              [2.4716433837984675, -7.343215503070819],
              [2.4455522640253387, -7.34966467569983],
              [2.4445616894511124, -7.326663168440485],
              [2.4148631707035775, -7.297424360982877],
              [2.424525323567805, -7.275615237749447],
              [2.4144312142472724, -7.263489203329449],
              [2.3992302319639247, -7.2633380920123525],
              [2.3756066954649913, -7.248761062300571],
              [2.381700145151886, -7.233829066342894],
              [2.393713220740863, -7.228198133087697],
              [2.405100425937921, -7.202083878804143],
              [2.3881668755111303, -7.204098465220082],
              [2.3799199513623255, -7.190707646141319],
              [2.347642582335141, -7.192930593502374],
              [2.3129959986765796, -7.161005969136058],
              [2.3115250141562664, -7.150463351887447],
              [2.296266559072017, -7.120670847725026],
              [2.3035140590220684, -7.106035148054946],
              [2.313328099027991, -7.1028140723924],
              [2.3153674070560597, -7.087142404973655],
              [2.3056657006531904, -7.052832118281122],
              [2.3238566767167073, -7.033729099513685],
              [2.3318865959756154, -7.017181284906017],
              [2.312786958047842, -7.010949594162291],
              [2.315314740782217, -6.99382228577333],
              [2.29563127824065, -6.971696146234195],
              [2.3057357257971725, -6.944962348168276],
              [2.296065974604185, -6.936992425315937],
              [2.291705944077884, -6.920114327917014],
              [2.2797073513239323, -6.915260470276802],
              [2.2612674484403703, -6.899518955838924],
              [2.2607902542649523, -6.8806263580704075],
              [2.2533104159337376, -6.87437967168075],
              [2.2538336132424797, -6.859515603787642],
              [2.237032156197055, -6.841791791472574],
              [2.240495175944421, -6.827375376668572],
              [2.2187174272735617, -6.819609308593307],
              [2.213255918319697, -6.810686590430422],
              [2.1927187235769607, -6.812319737620316],
              [2.1879146554704114, -6.800776697696232],
              [2.175251651524045, -6.8016105509076565],
              [2.1684018444883506, -6.783389415014158],
              [2.157880250825982, -6.7722063520678555],
              [2.1372415531371884, -6.7348696968970785],
              [2.115554355144486, -6.72541308642032],
              [2.113380438922474, -6.605010078042756],
              [2.1099491001767774, -6.455551543926677],
              [2.1051582929457764, -6.238825852925727],
              [2.1008345787192173, -6.03240702270039],
              [2.09744066216796, -5.853875934858309],
              [2.0942305385462805, -5.706011006132126]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.98775877065748,
          "lat": 31.060948834718427
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01629543"
      },
      "bbox": [
        2.0942305385462805, -9.586037645430858, 6.67917369241706,
        -5.635746950419626
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -64.79965939115458, "lat": 17.94015175456755 },
        "year": "2023",
        "ste_code": ["78"],
        "ste_name": ["United States Virgin Islands"],
        "ste_area_code": "VIR",
        "ste_type": "outlying area",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01802710"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.309757524628914, 8.221168207735548],
            [16.397384046879477, 8.244751610868022],
            [16.48501675456202, 8.268313038087133],
            [16.56619366462465, 8.286692455839532],
            [16.649458313451053, 8.309729542986396],
            [16.76679097037927, 8.337471489309728],
            [16.825464361598552, 8.349769568594253],
            [16.849928125614944, 8.350820172079],
            [16.901054921616666, 8.36415636803278],
            [17.01930959832569, 8.388665634628723],
            [17.12105220481655, 8.41678603725287],
            [17.160490538550675, 8.426194397003679],
            [17.26636837865347, 8.456011914036212],
            [17.28851629877422, 8.461100289825495],
            [17.388436509767626, 8.490507354700332],
            [17.44005634612085, 8.503816846630723],
            [17.569869189169268, 8.539499711586219],
            [17.556598663985536, 8.524339171080953],
            [17.550876490502258, 8.50783162771065],
            [17.572087208845147, 8.489629287965476],
            [17.582122699160557, 8.4541740752985],
            [17.60000103014472, 8.440368708902295],
            [17.58385767076881, 8.395757310303988],
            [17.577048347171278, 8.390563985047542],
            [17.575106686282545, 8.370465281766428],
            [17.580584274757634, 8.363173103118777],
            [17.576446805393246, 8.346501798775007],
            [17.574370142702424, 8.306443878999808],
            [17.54682303376789, 8.266220532792968],
            [17.55663927545912, 8.244756696831782],
            [17.58202493858263, 8.224931766066522],
            [17.59040352438849, 8.200820195694272],
            [17.60252563797863, 8.183729917828579],
            [17.61968746166272, 8.182508016868065],
            [17.632688616385188, 8.163044741616922],
            [17.63472847883984, 8.132477950528054],
            [17.654396113402075, 8.122712847781775],
            [17.650001406435855, 8.105542206552535],
            [17.637849084457677, 8.095335056933283],
            [17.624661065930223, 8.095004142007246],
            [17.621191937389813, 8.081841631613921],
            [17.640159295093284, 8.073214919787718],
            [17.638714217519038, 8.055102421417088],
            [17.64784486884509, 8.037699456067797],
            [17.636879779869677, 8.016579853572146],
            [17.624252071627428, 8.012844785660182],
            [17.622341271734303, 8.001409253184999],
            [17.608333062678817, 7.997788455891401],
            [17.60670532927549, 7.962741962461825],
            [17.598723624593617, 7.947581928463137],
            [17.576965458747242, 7.922288177176569],
            [17.561824005698206, 7.918254338681437],
            [17.559933873992545, 7.909518153446134],
            [17.543002064475214, 7.910458397009656],
            [17.52687505499472, 7.8998030093929055],
            [17.51515979817159, 7.8779715076167545],
            [17.522734461598866, 7.854665181229907],
            [17.499132117216256, 7.83170006868544],
            [17.48650399394592, 7.824095331349379],
            [17.463155702542664, 7.82925595731868],
            [17.4471646261475, 7.814969893316009],
            [17.411273244635368, 7.8056980485037615],
            [17.40914428627896, 7.798706696885035],
            [17.38951142810794, 7.78239784319395],
            [17.384402920646195, 7.762882827153609],
            [17.370387778271844, 7.742649500342744],
            [17.367520108895455, 7.726581399771431],
            [17.389926915056368, 7.6986265258825455],
            [17.391642407753956, 7.678926261079287],
            [17.38946352283596, 7.648492004714369],
            [17.41571350096556, 7.618744929835993],
            [17.42584899157346, 7.591540782534457],
            [17.416511908724388, 7.583631773561857],
            [17.42118168764428, 7.565511064994785],
            [17.437458426354812, 7.559845789031736],
            [17.427207423192364, 7.542014213239488],
            [17.431605311852, 7.535222638890552],
            [17.418194686544002, 7.482745113845137],
            [17.40668013467539, 7.4693700038725375],
            [17.403012513368225, 7.451362323921326],
            [17.424703115792273, 7.418764393960622],
            [17.414790581655257, 7.406078459776873],
            [17.41989356598095, 7.382828455060747],
            [17.402293772160945, 7.355840823441295],
            [17.392309138564467, 7.330657024518264],
            [17.388194881406424, 7.305412356987714],
            [17.397670807456073, 7.2851064915394765],
            [17.39594687681213, 7.273623744233123],
            [17.40313338470395, 7.256336162377644],
            [17.393729965238776, 7.233269528179928],
            [17.397347936411638, 7.220365358076237],
            [17.38878414769414, 7.210466374790795],
            [17.383373706934908, 7.1909352759360115],
            [17.359301753600032, 7.165887274020519],
            [17.347629483062832, 7.141080661973957],
            [17.35215647630822, 7.113226608762503],
            [17.34996001887239, 7.090128792320916],
            [17.352817567932508, 7.07542939958387],
            [17.345421926589577, 7.069046960822617],
            [17.345797724669016, 7.046251634122153],
            [17.35120007815628, 7.032026383443656],
            [17.327426066504987, 7.005770338722268],
            [17.32479741450952, 6.989122920968054],
            [17.332108970659988, 6.967049689192419],
            [17.326169993430472, 6.937318595324057],
            [17.343485278515157, 6.921058286790145],
            [17.342266551385045, 6.891613825965645],
            [17.352495435326283, 6.8189107711039805],
            [17.34776826133663, 6.801865239193582],
            [17.352995808183614, 6.7889851898217035],
            [17.370660767141754, 6.785446610499436],
            [17.36278595120174, 6.759466771369596],
            [17.37784829019207, 6.744024642504559],
            [17.37659316582784, 6.712712462333177],
            [17.371745586596397, 6.691463548260122],
            [17.363390291197373, 6.684255491829777],
            [17.37065076220093, 6.660277606001917],
            [17.36940734589483, 6.645157055190337],
            [17.375382132184715, 6.629871878749709],
            [17.369082557371605, 6.617715513180099],
            [17.37575501827476, 6.5720834602743174],
            [17.399220988887357, 6.550265674321997],
            [17.396767498392062, 6.530263745359005],
            [17.405809455357886, 6.517886088366217],
            [17.402526147636355, 6.501325329556876],
            [17.391525842219146, 6.479286840801899],
            [17.400551096214564, 6.456700281299055],
            [17.417919017696015, 6.442549776501075],
            [17.40970660590321, 6.4296774751293135],
            [17.412758378857326, 6.412742336591612],
            [17.4068298838319, 6.4000578030419595],
            [17.37755287941308, 6.383564497228663],
            [17.369433022067152, 6.367846166460747],
            [17.377486460998764, 6.359563471887895],
            [17.38442984161408, 6.33924386448444],
            [17.384379102254204, 6.318045305177116],
            [17.372477571314946, 6.3016815122256045],
            [17.377205938814914, 6.269926507320193],
            [17.3860547522993, 6.260802048916749],
            [17.401521519788364, 6.2263275428578995],
            [17.429394150000643, 6.207620947023132],
            [17.443777033543167, 6.203541865773666],
            [17.458157774091134, 6.19192498541979],
            [17.47809209521186, 6.165109857488111],
            [17.352756870088264, 6.1388743620722845],
            [17.227427691409908, 6.112605343879432],
            [17.146081935849438, 6.095105794807839],
            [17.064738880024798, 6.077592087629369],
            [16.983398538113295, 6.060064221750681],
            [16.902060924292833, 6.042522196775324],
            [16.893911768776178, 6.040627719186864],
            [16.870302813781333, 6.092463025852894],
            [16.87149820224348, 6.125169840636767],
            [16.829552150200094, 6.323399764474288],
            [16.818157764203956, 6.382661412481758],
            [16.785721437317196, 6.542417792007646],
            [16.72902252212076, 6.802496564461824],
            [16.730194411185124, 6.81217084999777],
            [16.71141640135401, 6.8384471116806855],
            [16.68959289919088, 6.847868217120653],
            [16.666852080162126, 6.8886523019677695],
            [16.655295033191457, 6.888929498383815],
            [16.62710784697662, 6.879777664624228],
            [16.617844907421148, 6.864749978176316],
            [16.615720683259227, 6.842334830144198],
            [16.620914837026735, 6.827431969326622],
            [16.612908672769596, 6.817861491649658],
            [16.58775569245817, 6.828159143945575],
            [16.58568810905929, 6.868020164985181],
            [16.576346278765474, 6.87716641946652],
            [16.581967536039876, 6.914435552923905],
            [16.580556823065915, 6.938375645244459],
            [16.59494078548293, 6.974891457579431],
            [16.591073917792837, 6.993391597557522],
            [16.59789161853208, 7.02340826927932],
            [16.589716105458585, 7.035788905350227],
            [16.573532601612982, 7.045049805044073],
            [16.556539613612305, 7.064983138445782],
            [16.565379252939778, 7.090836148926981],
            [16.555629724711906, 7.102736665270816],
            [16.557226326749436, 7.118423940142755],
            [16.53523348420735, 7.142734210788473],
            [16.519302188210133, 7.169534784001336],
            [16.512406315877406, 7.203109975793897],
            [16.50537901496644, 7.214395239417815],
            [16.502556538043265, 7.245993280730847],
            [16.495561438250604, 7.260148042028212],
            [16.472523095133, 7.273115699142031],
            [16.470318032960364, 7.307824978254805],
            [16.474928006240287, 7.343003312728261],
            [16.467080034544182, 7.361739661778362],
            [16.473302707204272, 7.376575560956839],
            [16.471131467633015, 7.420296137965728],
            [16.486520345820136, 7.443932311098917],
            [16.48977334536018, 7.467041611778762],
            [16.504812541913502, 7.484526396854399],
            [16.50633853579713, 7.515951026913406],
            [16.488698371397472, 7.548315449812622],
            [16.483213510401157, 7.571364955605299],
            [16.47038288047774, 7.59183932303149],
            [16.467467686335652, 7.606902219675848],
            [16.4764749617763, 7.625670847406849],
            [16.480170894760555, 7.667298737295178],
            [16.466044092718995, 7.713297736575931],
            [16.455711438788548, 7.735019577816192],
            [16.442793670225026, 7.745499427134616],
            [16.418461127652325, 7.778763867927719],
            [16.4074673569484, 7.782261390978051],
            [16.382737285029183, 7.808401293243921],
            [16.383758976705685, 7.819153150415626],
            [16.37064427746011, 7.833996589225154],
            [16.368214798576187, 7.85298654623581],
            [16.3702677130152, 7.886546964530139],
            [16.36810505111249, 7.9154640752012195],
            [16.357937481008616, 7.958185921236341],
            [16.363293283475766, 7.991333696503528],
            [16.369143530172916, 8.008843850839435],
            [16.36381875510735, 8.023736672497396],
            [16.337847086348756, 8.039793031517368],
            [16.32267271376719, 8.055100540665705],
            [16.32598572069884, 8.078000594312696],
            [16.32590753611177, 8.116566333216563],
            [16.333454536969622, 8.138400218556317],
            [16.32340092680699, 8.17859863722098],
            [16.307412030099883, 8.196649020155167],
            [16.309757524628914, 8.221168207735548]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -72.66266839285905,
          "lat": 44.075219229579915
        },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779802"
      },
      "bbox": [
        16.307412030099883, 6.040627719186864, 17.654396113402075,
        8.539499711586219
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.901176457974957, -3.0250479223237448],
            [11.151878015212663, -2.9046218176247596],
            [11.159625212252534, -2.925363334304369],
            [11.174892095841976, -2.919284302885039],
            [11.177962344884294, -2.9067772802827947],
            [11.188817859110195, -2.905701974515373],
            [11.195890170309633, -2.8897674150302937],
            [11.205467715341063, -2.889641940756223],
            [11.226469358269494, -2.8712032244666905],
            [11.223600274792798, -2.854361005493256],
            [11.244421387784788, -2.8585408016377554],
            [11.283754148622464, -2.8316992025185397],
            [11.314810802463846, -2.820954943811825],
            [11.335107060343615, -2.800966831222401],
            [11.341400052582012, -2.8075066869151213],
            [11.355450529375112, -2.7966741938723088],
            [11.372168743874614, -2.7931982992657214],
            [11.377172608148134, -2.7843593239235047],
            [11.39823504471171, -2.775595372294935],
            [11.416436834864978, -2.785484759581415],
            [11.427657083687519, -2.750537865749344],
            [11.448738750048989, -2.7304215776458594],
            [11.468975793815854, -2.7620618751346466],
            [11.475504857010653, -2.7515690774302755],
            [11.48873812523523, -2.747332815534058],
            [11.50694373610967, -2.7531762507116326],
            [11.512088560373872, -2.746435964468839],
            [11.543558444622592, -2.732308454686766],
            [11.623069209125852, -2.727112848066536],
            [11.825673124147245, -2.7056351535865955],
            [11.994418930824974, -2.6870792466532754],
            [12.103107358746263, -2.676442936999336],
            [12.377416636900804, -2.6473046190503027],
            [12.484356553430127, -2.636591134021101],
            [12.537601663920334, -2.6324936756973405],
            [12.535136601965648, -2.652093643482451],
            [12.551819115368447, -2.667099165399],
            [12.550095766997819, -2.678804471550897],
            [12.536772211202527, -2.697657984438779],
            [12.540184110817714, -2.7212893033864485],
            [12.555938745674784, -2.7368787596156823],
            [12.615351088264704, -2.6785312247532773],
            [12.631360046299788, -2.6609069327987585],
            [12.680062901627961, -2.7081130758938903],
            [12.742648833062212, -2.773381915584867],
            [12.781405212577173, -2.811944636665745],
            [12.787596609355505, -2.9292878767067188],
            [13.027261914544168, -2.892864051928598],
            [13.10787374079587, -2.881750258128065],
            [13.241483747276227, -2.861772108990545],
            [13.534383969035733, -2.8199352303661507],
            [13.612089886765613, -2.806031098365774],
            [13.69128321028691, -2.7935645327073],
            [13.793059568750024, -2.8656368239403824],
            [13.89484801983752, -2.9376912124345522],
            [13.991080837060224, -3.006282659325382],
            [14.095301512155926, -3.0855353795506555],
            [14.180643667478957, -3.1472410394146055],
            [14.26599518773344, -3.2089321311092625],
            [14.360084626978729, -3.276208119986698],
            [14.454185781983266, -3.3434657031410446],
            [14.556345589025263, -3.4167507662766274],
            [14.658519756935371, -3.4900128609966816],
            [14.769818767471937, -3.569706734684254],
            [14.76523433715746, -3.578036834272598],
            [14.73623499724966, -3.589269352801123],
            [14.678829201807416, -3.6243970245358024],
            [14.628843738635403, -3.6640337183121754],
            [14.586784933793574, -3.7070647898025437],
            [14.568232323654998, -3.728712434369351],
            [14.53866728291888, -3.768998984916149],
            [14.526161074426593, -3.7905006811287856],
            [14.491650334939296, -3.841892950511976],
            [14.448740292647184, -3.9246480393123355],
            [14.436078659730434, -3.962237162927169],
            [14.400630713821288, -4.017920368463149],
            [14.383467474495127, -4.066439536042548],
            [14.36806886506397, -4.131328483979606],
            [14.36821582149462, -4.158038604038476],
            [14.364029775967587, -4.180063186455185],
            [14.36653359207837, -4.199127100069323],
            [14.363082636470322, -4.21691111731872],
            [14.363267228899122, -4.258770415445374],
            [14.374669500984178, -4.300668743931111],
            [14.366613851989856, -4.344188015044347],
            [14.346214569890572, -4.3682061540236665],
            [14.331824654630203, -4.395007529662792],
            [14.314273316602476, -4.4047162190678435],
            [14.279479847286183, -4.431574395477059],
            [14.270110119693278, -4.446116745044821],
            [14.266605331173892, -4.48012174844105],
            [14.257390534604912, -4.527325497281054],
            [14.213291237948152, -4.537402229509785],
            [14.21179544210989, -4.528182436391502],
            [14.157985748723517, -4.544075504586251],
            [14.134571633973634, -4.524715633026413],
            [14.11348784996528, -4.525973087499595],
            [14.085190804943462, -4.552679778719061],
            [14.0632226537978, -4.598820167609784],
            [14.057560531114332, -4.619678577326415],
            [14.070416416265145, -4.644421102044641],
            [14.098173452324245, -4.637916665963096],
            [14.09559933003617, -4.6602149160989015],
            [14.057495020680395, -4.684961833911909],
            [14.008831867359966, -4.731322759172789],
            [14.006790293333264, -4.747245213716984],
            [13.995303728885188, -4.759633655967249],
            [13.993339909126314, -4.7801178236914],
            [13.946651262732006, -4.810050457023431],
            [13.920375249301523, -4.836667559415555],
            [13.901466521802869, -4.849155228127875],
            [13.886459538968506, -4.834031715741901],
            [13.864992161050797, -4.820523469737634],
            [13.835385198945001, -4.831765454999262],
            [13.83564883488282, -4.859766812954363],
            [13.862985419734045, -4.859889097540077],
            [13.876964416037817, -4.856183944811184],
            [13.887887851546054, -4.875503010707217],
            [13.878681544929332, -4.905602658316807],
            [13.881896209346925, -4.924269137212319],
            [13.861381905146338, -4.946200877031449],
            [13.820668397353243, -4.9779135009166],
            [13.809107535759333, -4.994241323012003],
            [13.801099849756044, -5.0164279313138005],
            [13.770249747751865, -5.017230026204597],
            [13.738574493038678, -5.029601859673084],
            [13.704102830255255, -5.048402142055756],
            [13.678855664395908, -5.0714776309771175],
            [13.673876886914485, -5.082617457578152],
            [13.648361902569325, -5.0887198333321955],
            [13.616758387427101, -5.111979495892686],
            [13.587230751895332, -5.1415811227205985],
            [13.548262803284048, -5.18857247330465],
            [13.533721316927961, -5.174335023890088],
            [13.520479053653391, -5.175381659269447],
            [13.501691955941721, -5.1913313641747365],
            [13.498960709228845, -5.199538494413154],
            [13.48240554499458, -5.2069987408023355],
            [13.475084111336827, -5.189093822697664],
            [13.451475069692966, -5.177323703798263],
            [13.42961235133485, -5.188995866181731],
            [13.425108531585705, -5.226259829808851],
            [13.431908890332457, -5.240591980661074],
            [13.455859422202014, -5.272673991367253],
            [13.473672861379866, -5.2675176102114065],
            [13.482607666837142, -5.2891757029708355],
            [13.475931842482844, -5.325515368533632],
            [13.464112672156007, -5.349289578416678],
            [13.473809051566153, -5.359366247905291],
            [13.434204109613722, -5.380493198599978],
            [13.400639718025426, -5.40818392839237],
            [13.379404286998101, -5.4221099278018325],
            [13.368064207399179, -5.416482719174724],
            [13.34280978499217, -5.445532168679124],
            [13.324342613480564, -5.445698546631237],
            [13.319880410646887, -5.415350158143722],
            [13.28175221406741, -5.410017025388483],
            [13.262107494995787, -5.392016628024748],
            [13.241641929449422, -5.39964505317674],
            [13.23673343456982, -5.4167123217982125],
            [13.227231919506822, -5.414790289072845],
            [13.22064603199767, -5.436988192159385],
            [13.243353629996893, -5.455841493246586],
            [13.254951866448856, -5.447091728985273],
            [13.292884195240113, -5.467687653865357],
            [13.307120570554286, -5.4802702071243],
            [13.31019421483936, -5.496092253981611],
            [13.299688008067484, -5.508125025889503],
            [13.281984464544783, -5.546070161363921],
            [13.264267774306111, -5.571696346859091],
            [13.20241155587909, -5.619676519639404],
            [13.183549127485895, -5.613329382652434],
            [13.164401888972218, -5.651803037552717],
            [13.14000312094916, -5.690716456134704],
            [13.141932123094664, -5.700685574429015],
            [13.126813710855686, -5.699257421194842],
            [13.098360299552066, -5.675222239903963],
            [13.072200236832101, -5.6698478980811355],
            [13.062587040161754, -5.65581111463044],
            [13.051281273597974, -5.650055397638919],
            [13.040983026892425, -5.655312489854087],
            [13.026063209444013, -5.672911415561746],
            [12.981763619559118, -5.663497097586048],
            [12.977566469559187, -5.653063564319244],
            [12.956887032177184, -5.652450888894652],
            [12.950054407607986, -5.633989612970407],
            [12.951927415070493, -5.615447361607229],
            [12.937739140106698, -5.600377090714977],
            [12.943685541071664, -5.583038435190258],
            [12.936835866012435, -5.567882087405796],
            [12.917020884691986, -5.550329462125983],
            [12.902372745003005, -5.530162680194332],
            [12.909367568972606, -5.5233392925444145],
            [12.921800387310844, -5.486854017542252],
            [12.921207045890792, -5.464923908735887],
            [12.91370261729506, -5.457416107018276],
            [12.908917864052242, -5.4359730536469355],
            [12.898246442201831, -5.423008214067657],
            [12.8815508071376, -5.425528921033886],
            [12.873528513275021, -5.408665487622564],
            [12.860236496106014, -5.399556301410832],
            [12.860602854359149, -5.385012272592128],
            [12.833701996753947, -5.358853097269877],
            [12.829180132664257, -5.345990696665003],
            [12.831325458174103, -5.314256282716997],
            [12.798764308455455, -5.288425325073841],
            [12.787482880118887, -5.268145665029286],
            [12.779690765095092, -5.271287547161283],
            [12.761621258949827, -5.261844307027828],
            [12.75021280908496, -5.237222703534077],
            [12.735424222206115, -5.232869140489605],
            [12.716213083098646, -5.239383155992819],
            [12.683800701914702, -5.2301198744812885],
            [12.678176689079061, -5.222718988021427],
            [12.6547602120332, -5.212505845789246],
            [12.62587814681846, -5.183599029340887],
            [12.629385553216578, -5.171874646768862],
            [12.642079372982378, -5.159591507686495],
            [12.631703150555154, -5.143647462743815],
            [12.632454544423403, -5.132768693499074],
            [12.612839505881306, -5.113143545315398],
            [12.61157016877523, -5.084010643771626],
            [12.617351905730118, -5.07138668524646],
            [12.607084408618025, -5.065205025860517],
            [12.610360866976453, -5.0493578159996675],
            [12.592414063433647, -5.033211484545297],
            [12.591186344924072, -5.004847341330996],
            [12.596029276122135, -5.000244825993732],
            [12.591195379235375, -4.979238510709373],
            [12.569580894081376, -4.966551651292421],
            [12.559385146142953, -4.966458565647349],
            [12.559032143158449, -4.944934289471522],
            [12.539870574263576, -4.944062256764453],
            [12.527104335859983, -4.901229043209298],
            [12.508429420956476, -4.886963134058716],
            [12.497030733564916, -4.860272304296297],
            [12.507114350741077, -4.8606970449707765],
            [12.506940983283354, -4.81820181354901],
            [12.488628703586755, -4.8016176715741095],
            [12.462081411646324, -4.790654030540307],
            [12.443280187717296, -4.788217262762803],
            [12.426350692691424, -4.7701510162369685],
            [12.413974815472777, -4.765068829622242],
            [12.39206145493293, -4.7455851367215836],
            [12.369927663017316, -4.751380057857199],
            [12.355165251297548, -4.743472860457021],
            [12.315141619937908, -4.736036696722269],
            [12.278445744808675, -4.715498811476629],
            [12.260547472555219, -4.700642882746102],
            [12.253171328963134, -4.682476078170536],
            [12.259875844670955, -4.66178551349666],
            [12.248055887526872, -4.644793747170308],
            [12.230912787488426, -4.655385157240643],
            [12.215570979875798, -4.652310741893796],
            [12.210935541812571, -4.642757334074678],
            [12.196889726632444, -4.639891190503412],
            [12.173359074603963, -4.623121617404827],
            [12.178144391025851, -4.604267589845617],
            [12.173587081198326, -4.586985217204882],
            [12.161415888997132, -4.587263139483759],
            [12.160006108063355, -4.573978207839936],
            [12.150262392678679, -4.560594023975903],
            [12.140132975071536, -4.561826702303574],
            [12.106627389689384, -4.5471337651027675],
            [12.101130942705128, -4.53632673300806],
            [12.080829525465344, -4.519918731756989],
            [12.08983350944282, -4.502308879103969],
            [12.083820033556805, -4.485781053013814],
            [12.091063107338673, -4.471290483012991],
            [12.082614927839046, -4.453695518019621],
            [12.095719498792501, -4.4423077755255544],
            [12.081236405065376, -4.419489156083985],
            [12.028902997622511, -4.403302276241221],
            [12.023158701885437, -4.389716256653871],
            [12.002674949581795, -4.3626239888811655],
            [11.993971382968006, -4.359240932156336],
            [11.96803323338061, -4.3338399857200764],
            [11.944110002931545, -4.323477739280707],
            [11.926135042877299, -4.320810226278853],
            [11.914330923737309, -4.309454737325057],
            [11.892752450988603, -4.317798401132288],
            [11.869647678118772, -4.301717818339107],
            [11.854456745943386, -4.2998121874675865],
            [11.83530707378686, -4.28554815477694],
            [11.828093956111696, -4.254955125728131],
            [11.809147857756395, -4.232804621401606],
            [11.79410483567397, -4.220866693509726],
            [11.785953749890073, -4.190931680765223],
            [11.77595745737408, -4.170335616170916],
            [11.729246249668092, -4.144742049940351],
            [11.726931938687486, -4.130392777756133],
            [11.683594809987358, -4.101234208436245],
            [11.663945504330691, -4.095456609753142],
            [11.628205124648915, -4.07622146942568],
            [11.611295189741927, -4.079131477285511],
            [11.587869344785252, -4.06644138132123],
            [11.553004807794544, -4.042893405370299],
            [11.532800426304142, -4.0181459935887665],
            [11.522462668999657, -4.013130331894102],
            [11.495833366195232, -4.014894177855669],
            [11.471360694742625, -3.9810284372177107],
            [11.462267455592574, -3.9644137973223397],
            [11.451780057791332, -3.934261504008825],
            [11.441481342166906, -3.928469259224964],
            [11.42197593755872, -3.905452695945686],
            [11.40497879820683, -3.8950708836916066],
            [11.407893855990102, -3.884003371201165],
            [11.390309306808891, -3.868795357753327],
            [11.373353890871824, -3.8449698979470543],
            [11.348252905228406, -3.8370995133005934],
            [11.336081531593035, -3.8291229424092856],
            [11.32207020151637, -3.805925905242055],
            [11.317648264574325, -3.7870576139189063],
            [11.308116190176671, -3.7729686059212133],
            [11.301179321008691, -3.731621610142974],
            [11.288948213374825, -3.7088883052590695],
            [11.263157446889332, -3.6896792241766154],
            [11.246739591763847, -3.6486411514427317],
            [11.210621458270104, -3.627548823938659],
            [11.207640550146, -3.61312744623914],
            [11.172796062621172, -3.5373082829205935],
            [11.139801362691678, -3.5150188752293046],
            [11.120580280957851, -3.5228709181642275],
            [11.105603957151096, -3.521013870753058],
            [11.067056611646398, -3.532866655844325],
            [11.062682283240713, -3.540196412294077],
            [11.001702110574525, -3.5184040868329056],
            [10.985287716788688, -3.4913597539773606],
            [10.97049714956869, -3.491744802710095],
            [10.962534987390695, -3.4781216723223785],
            [10.935948405250956, -3.4661694615153844],
            [10.932297294097886, -3.4554807057319206],
            [10.909594491565892, -3.440688287392275],
            [10.906236466729823, -3.424487350310934],
            [10.886148939446954, -3.4312704818040607],
            [10.87411571484066, -3.4254768485865585],
            [10.855842431971231, -3.427454936437076],
            [10.833628364594505, -3.4041371845193598],
            [10.800016546743402, -3.3911893532035484],
            [10.788701910154852, -3.377205458227854],
            [10.759182655844208, -3.3632599211491483],
            [10.743362743338308, -3.3346464855201665],
            [10.743803220163418, -3.315100361860419],
            [10.760288617498626, -3.298466355972198],
            [10.7640501654955, -3.2837111883761283],
            [10.757119405706316, -3.261674932727371],
            [10.772033761908727, -3.2447140055596764],
            [10.780556637770763, -3.2270614125688284],
            [10.797655378079023, -3.2220544045168067],
            [10.792510902170674, -3.208937154779428],
            [10.804739219316907, -3.197705788224222],
            [10.81038713602173, -3.1631735479130825],
            [10.830434403645043, -3.155398661452353],
            [10.839803683611455, -3.1568798305029344],
            [10.864456155728554, -3.113808760970828],
            [10.874873258388694, -3.114142161916417],
            [10.90833953110809, -3.090478956218911],
            [10.899035719142624, -3.07413949711331],
            [10.8969289858118, -3.058956801839788],
            [10.911069305061291, -3.033093573715902],
            [10.901176457974957, -3.0250479223237448]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.89616903969905, "lat": 33.90810891455183 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779799"
      },
      "bbox": [
        10.743362743338308, -5.700685574429015, 14.769818767471937,
        -2.6324936756973405
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.537611815158495, 5.321224483875918],
              [18.56103844149568, 5.311054970063371],
              [18.57585994320334, 5.309302880062649],
              [18.58515222467383, 5.290264102297734],
              [18.580864401627245, 5.265876267414823],
              [18.566339985235512, 5.264904499191892],
              [18.563903357742127, 5.303957467418424],
              [18.543331530795594, 5.308665656111423],
              [18.537611815158495, 5.321224483875918]
            ]
          ],
          [
            [
              [18.643791199106325, 5.378040989551329],
              [18.659611068890683, 5.374993390994894],
              [18.69263776486263, 5.375482933498569],
              [18.701453057438027, 5.32071210620319],
              [18.7114371412628, 5.31008517777842],
              [18.743876597347192, 5.2201933146006025],
              [18.73423246363111, 5.203072287750002],
              [18.70184739741188, 5.166345572942586],
              [18.697332315069197, 5.1941177430567205],
              [18.68180634132728, 5.205498055236112],
              [18.681882846716572, 5.2212616222060015],
              [18.662442140144957, 5.250169520969041],
              [18.6577878844681, 5.297896830984567],
              [18.642589142670428, 5.326221449009457],
              [18.626008065913826, 5.315311937954477],
              [18.63216636215578, 5.284012426324413],
              [18.640831359505555, 5.273081715980704],
              [18.65056620004154, 5.235252126474715],
              [18.658738604876834, 5.229575654543005],
              [18.652440169072673, 5.183892906340025],
              [18.630110159309027, 5.180424799340418],
              [18.620184697615674, 5.174164446378927],
              [18.622996941697753, 5.1434521211867],
              [18.6076288019487, 5.145228899136838],
              [18.602458570515676, 5.13283910037962],
              [18.586812159225317, 5.129764851937596],
              [18.579564039835986, 5.14247401915957],
              [18.608315070583465, 5.163513435235812],
              [18.5893635080481, 5.20137566327959],
              [18.600436141538736, 5.2082231316302225],
              [18.5946620356066, 5.231926687425675],
              [18.605710362941966, 5.297224624504473],
              [18.602439877525395, 5.314003933148754],
              [18.6134986919752, 5.332296199562841],
              [18.624021256432435, 5.334686797297635],
              [18.63248800721689, 5.352793851622241],
              [18.640630016939912, 5.354404836090787],
              [18.643791199106325, 5.378040989551329]
            ]
          ],
          [
            [
              [18.55221248738239, 5.1314340855864184],
              [18.555007931346776, 5.138692253427237],
              [18.544757221059506, 5.162732790265524],
              [18.55641070842458, 5.178236443179843],
              [18.54524040518756, 5.185287620491497],
              [18.539048064207392, 5.2274218674788075],
              [18.550414734984777, 5.245084863498389],
              [18.55682340435489, 5.231669824273062],
              [18.56792287217103, 5.170725157640949],
              [18.578098160159968, 5.15505277878455],
              [18.565719265865667, 5.149470443969647],
              [18.55221248738239, 5.1314340855864184]
            ]
          ],
          [
            [
              [18.476274779966584, 4.79926156479024],
              [18.476147380246903, 4.821930000063539],
              [18.48122202654165, 4.826421958411326],
              [18.49642242660255, 4.870938664756255],
              [18.505428120316445, 4.861603751243485],
              [18.50286776927319, 4.835226242230785],
              [18.506309871091016, 4.827264902370474],
              [18.52469702024034, 4.81675024442913],
              [18.525696096482584, 4.805348596629218],
              [18.489183243167734, 4.788772462334206],
              [18.476274779966584, 4.79926156479024]
            ]
          ],
          [
            [
              [18.257004923044498, 4.908302539355107],
              [18.27383304785745, 4.935655662094203],
              [18.26203421707378, 4.95655343111516],
              [18.26013087980494, 4.978529392009897],
              [18.247605390498435, 4.994659835110515],
              [18.260835902305182, 5.012144206905627],
              [18.277821841186967, 5.013773436997032],
              [18.224750879380668, 5.248183266326044],
              [18.146006486554494, 5.517344355840045],
              [18.12662721117976, 5.587598911861518],
              [18.149927243056972, 5.595378958010462],
              [18.23432487284826, 5.620113077125355],
              [18.318726636953514, 5.644832906368611],
              [18.337922972788224, 5.652146480427089],
              [18.422028087409416, 5.675926347112304],
              [18.45421653759287, 5.55417437076048],
              [18.4835897208797, 5.567321352008222],
              [18.486431028063645, 5.550647021652974],
              [18.496278540427063, 5.533228668964338],
              [18.494940483504234, 5.514720967014064],
              [18.502348571804642, 5.507030418284402],
              [18.496973961442603, 5.492746080390143],
              [18.521789251107307, 5.455105703980105],
              [18.576673768252675, 5.440371868958107],
              [18.613712283002545, 5.406808562578172],
              [18.60542886411059, 5.391369671759116],
              [18.615242548232064, 5.372916880031975],
              [18.606167760506857, 5.352997939960919],
              [18.5967790063277, 5.347190287484848],
              [18.579096510289066, 5.3476934097244335],
              [18.56953336311412, 5.342000555310948],
              [18.565429940648244, 5.364162826761708],
              [18.568185717679107, 5.3866057131631875],
              [18.55356733715722, 5.393208469372795],
              [18.551875985121836, 5.401989605554951],
              [18.527905907491757, 5.398964384582222],
              [18.5241478273319, 5.408279203197174],
              [18.508048129628683, 5.414701302624327],
              [18.489826217623964, 5.449623375533908],
              [18.47596554768744, 5.443576872892352],
              [18.49015950439023, 5.421019313851401],
              [18.4974820920052, 5.3935079071589715],
              [18.51523685271764, 5.3747206328409405],
              [18.515391631334417, 5.335265020420704],
              [18.50183025641673, 5.349797098628018],
              [18.458480283010488, 5.340831255875105],
              [18.466498136321828, 5.322033483965869],
              [18.481218784375905, 5.330022801857767],
              [18.49427754721087, 5.3260878060034935],
              [18.504901169272614, 5.28612078205891],
              [18.516796742191605, 5.255378909445742],
              [18.493686800803236, 5.241108046373171],
              [18.495818989877627, 5.22337962417917],
              [18.520510987731033, 5.201280921772168],
              [18.52760580593586, 5.182429135082033],
              [18.52750037085498, 5.1640524270735995],
              [18.536366547119524, 5.13941796804372],
              [18.53374581471857, 5.112405555632871],
              [18.519663890121656, 5.093835353193282],
              [18.527729183138767, 5.071753901414971],
              [18.51498763581505, 5.0291171358881295],
              [18.47970922861589, 5.024684400122306],
              [18.421988407464493, 4.9955533880230965],
              [18.375581323109724, 4.962511350747844],
              [18.358417095830156, 4.9458628681147765],
              [18.334188063034112, 4.933659919234832],
              [18.317639816183572, 4.932034294967275],
              [18.289585652799722, 4.916726940998608],
              [18.262755344424868, 4.895336303441538],
              [18.257004923044498, 4.908302539355107]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.55472622039959, "lat": 41.67693255920405 },
        "year": "2023",
        "ste_code": ["44"],
        "ste_name": ["Rhode Island"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01219835"
      },
      "bbox": [
        18.12662721117976, 4.788772462334206, 18.743876597347192,
        5.675926347112304
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.219909595290242, 6.5652203539821645],
            [-5.2289223518098975, 6.443531305614931],
            [-5.249303126659181, 6.203797866002558],
            [-5.275931046341002, 5.890205440224414],
            [-5.291475409235854, 5.700376908754585],
            [-5.3159696254613, 5.42070295106756],
            [-5.330324105621542, 5.248682365042791],
            [-5.353536078436803, 4.973391876649692],
            [-5.366501778048347, 4.815366882103244],
            [-5.38610727169448, 4.577472383580555],
            [-5.40692803365175, 4.331651547327991],
            [-5.4287862402935705, 4.077087981855903],
            [-5.4489103266844205, 3.837878975578938],
            [-5.460362479125146, 3.7017688517833744],
            [-5.481088001073683, 3.4619246288133323],
            [-5.503433757689663, 3.1988247982468336],
            [-5.520451720315846, 2.99317246479185],
            [-5.5435550343579525, 2.731819398069153],
            [-5.556656276441772, 2.5753996714605933],
            [-5.711157548943858, 2.5888999126816556],
            [-5.865661957523721, 2.602364174275008],
            [-6.021001766054384, 2.6158757099714456],
            [-6.1355671374760625, 2.6247386442670964],
            [-6.154886238636301, 2.62530309182903],
            [-6.303714555722924, 2.6396091069232583],
            [-6.452546078389735, 2.653881702359018],
            [-6.570236090134439, 2.665039662104415],
            [-6.686488272819081, 2.6763351684224164],
            [-6.802742404500524, 2.6876102794907473],
            [-6.927946869080648, 2.7007324728379034],
            [-7.053153807749678, 2.7138309752971077],
            [-7.1694706294964305, 2.7270175767608134],
            [-7.246406076305771, 2.7367605669255215],
            [-7.344809283207848, 2.7505186576008445],
            [-7.494980508764134, 2.767730701451386],
            [-7.645155652885323, 2.784908548505112],
            [-7.751262832458146, 2.7979412700785105],
            [-7.9301751190782035, 2.8182973445971453],
            [-8.023966758867122, 2.8297648859520534],
            [-8.119936278120374, 2.840941747788259],
            [-8.215907393206912, 2.8521046310531797],
            [-8.372208206620261, 2.871634372462276],
            [-8.528513625240134, 2.8911269625129794],
            [-8.680288600482735, 2.9086285604364357],
            [-8.773059865598668, 2.9207669399564216],
            [-8.86583283172655, 2.9328922141929854],
            [-9.00806780267587, 2.9519816117032867],
            [-9.150306875384137, 2.9710401708504883],
            [-9.27327646575219, 2.988473635073093],
            [-9.421980690416571, 3.0095084068374383],
            [-9.514733132886537, 3.021679985761781],
            [-9.60748723855648, 3.033838453821618],
            [-9.63299175375873, 3.0364845327812207],
            [-9.737781487500882, 3.0518237510865207],
            [-9.870384280599879, 3.0703427346067134],
            [-9.969022763489152, 3.08469137197812],
            [-10.067663375503251, 3.099025127996892],
            [-10.153933148089273, 3.1102688247926493],
            [-10.251245336622066, 3.124732808216697],
            [-10.34855963881364, 3.1391822968128413],
            [-10.377241535326565, 3.1452218166728487],
            [-10.53316231276618, 3.169913326128231],
            [-10.642493161957121, 3.187742852686528],
            [-10.751826998256716, 3.2055539859608855],
            [-10.72662032966022, 3.3626749712446173],
            [-10.69408552071222, 3.566017583283496],
            [-10.658693603422627, 3.783579308070293],
            [-10.627268423696604, 3.981962568425353],
            [-10.592349556832646, 4.202332016486536],
            [-10.570283834917902, 4.342001006002326],
            [-10.537418442790758, 4.547100891427056],
            [-10.51253702322444, 4.701147513419061],
            [-10.475671273858199, 4.916309021241383],
            [-10.43590786964345, 5.166119782473772],
            [-10.400422347295132, 5.388958953394926],
            [-10.353484870698784, 5.686015101376792],
            [-10.304719338066393, 5.996762097006375],
            [-10.276034156465192, 6.178290422400769],
            [-10.274068254212983, 6.198339375653054],
            [-10.22173851821333, 6.526823331265312],
            [-10.202187348093167, 6.645220638841391],
            [-10.203932989888141, 6.649873288870813],
            [-10.175059913337176, 6.834662304207684],
            [-10.144936273838875, 7.025408051675661],
            [-10.12283903070833, 7.163371842579349],
            [-10.030623403050514, 7.14886234673704],
            [-9.938411368329165, 7.1343299780456855],
            [-9.880003726127113, 7.116505903548283],
            [-9.804433529884394, 7.105256197427408],
            [-9.728865541987334, 7.093991184240547],
            [-9.699187851365464, 7.090288757096232],
            [-9.671342462016028, 7.091906392499655],
            [-9.614126079913653, 7.083439994173625],
            [-9.586249846965135, 7.076914903445543],
            [-9.515396190140608, 7.065896914407765],
            [-9.460334365955456, 7.064315940003274],
            [-9.362521693581748, 7.049806329905938],
            [-9.264712855845099, 7.035271077254399],
            [-9.219811266666012, 7.027329686697665],
            [-9.10570924734232, 7.012005182372292],
            [-9.001851616555802, 6.998557354547006],
            [-8.897997405359439, 6.9850807588664],
            [-8.828661906199859, 6.975712230266818],
            [-8.75932810005148, 6.966330868063272],
            [-8.74593521903593, 6.958202286419536],
            [-8.676117013268803, 6.948924404445689],
            [-8.606300494700708, 6.939633527082069],
            [-8.536485680535135, 6.930329655955122],
            [-8.466672587969116, 6.9210127927581615],
            [-8.348537331889501, 6.904886294493064],
            [-8.263222303283287, 6.894062611191682],
            [-8.177909679929085, 6.883219562910048],
            [-8.084626694349243, 6.871500131971603],
            [-7.991346586728802, 6.859757562387052],
            [-7.858444967713633, 6.843343351158536],
            [-7.725549148981749, 6.8268822104901465],
            [-7.625888663513288, 6.815567543881694],
            [-7.501055611899121, 6.799978416776538],
            [-7.376227991703441, 6.784347896902717],
            [-7.346774946556772, 6.777673927957929],
            [-7.276616051793791, 6.769269160244814],
            [-7.206458781999854, 6.760851341550511],
            [-7.096403734849928, 6.7479310856654156],
            [-6.986352620084179, 6.734978741806166],
            [-6.878582045795893, 6.722680111970551],
            [-6.770815138964442, 6.7103507446394515],
            [-6.653010689099084, 6.697743282735279],
            [-6.5352102314776825, 6.685099155015122],
            [-6.523952901629506, 6.690678569883938],
            [-6.423873844001274, 6.680520768844948],
            [-6.32379746858681, 6.670336521718875],
            [-6.2335414134180684, 6.661276795770672],
            [-6.143287549235818, 6.652195569808911],
            [-6.072261035538543, 6.645236085138587],
            [-6.001235845900673, 6.638263293955803],
            [-5.902816760227784, 6.62891484048777],
            [-5.80440012990138, 6.619540855058967],
            [-5.713792111421712, 6.6106240010079],
            [-5.623186374359991, 6.601685500844445],
            [-5.493699618838805, 6.589905183316107],
            [-5.3642170230129205, 6.578080724676638],
            [-5.292062671249941, 6.5716573885650815],
            [-5.219909595290242, 6.5652203539821645]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -107.55137977029698, "lat": 42.999554009336 },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779807"
      },
      "bbox": [
        -10.751826998256716, 2.5753996714605933, -5.219909595290242,
        7.163371842579349
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.6984857337805535, -8.253031845832624],
              [6.727811505924407, -8.248502577393229],
              [6.7401643567930725, -8.241413853959797],
              [6.79188098676169, -8.255667603995628],
              [6.843566760606143, -8.259661932483217],
              [6.843990985557965, -8.263921963706277],
              [6.784612344602124, -8.260516820807235],
              [6.741129924020031, -8.24983256076271],
              [6.708961708616064, -8.257160149823044],
              [6.6984857337805535, -8.253031845832624]
            ]
          ],
          [
            [
              [6.384073998972226, -8.288795108853694],
              [6.429901465172437, -8.28707925051949],
              [6.424994791330131, -8.303558930608725],
              [6.403039212353191, -8.303361823766627],
              [6.4023981579357665, -8.295852147071777],
              [6.384073998972226, -8.288795108853694]
            ]
          ],
          [
            [
              [4.49038541961474, -5.635746950419626],
              [4.493131741868275, -5.620005485285179],
              [4.512977092264224, -5.610085569287063],
              [4.522549101690662, -5.5994521381380835],
              [4.5218005910043875, -5.5741413998850815],
              [4.499604908999349, -5.55721684697406],
              [4.48020860212407, -5.551620719352647],
              [4.455599339075448, -5.531849509510021],
              [4.454471346475759, -5.5183777176443485],
              [4.468760211978355, -5.499033568935224],
              [4.488196098395871, -5.498526469604828],
              [4.496991313624659, -5.508634141280144],
              [4.538922621443324, -5.5060621331651705],
              [4.55037688819819, -5.4993875317202665],
              [4.553353724212625, -5.466005972376144],
              [4.5490790318079, -5.446080194038924],
              [4.5340200643354915, -5.4177159163644095],
              [4.545753496009764, -5.414888651028612],
              [4.573731442357986, -5.383779944108017],
              [4.578129093360446, -5.360032908389861],
              [4.5739475755157155, -5.352060247121327],
              [4.558057513671508, -5.348483601385161],
              [4.542920960484281, -5.36284230027281],
              [4.535630731504106, -5.39535578766345],
              [4.524098632846556, -5.3916306201370485],
              [4.508400439984557, -5.369781749086537],
              [4.5098999290947335, -5.357909854426676],
              [4.4955753868595565, -5.339286570760016],
              [4.492531180744079, -5.289806959684576],
              [4.509837702168275, -5.274046577815437],
              [4.524326673797735, -5.249831497941914],
              [4.541455239342544, -5.233416212396438],
              [4.558018343932458, -5.206411358485802],
              [4.557147250891754, -5.18855114669576],
              [4.546180044041544, -5.179766209925629],
              [4.5273886104756285, -5.193969811125438],
              [4.524878862660851, -5.22970461538973],
              [4.513826092938144, -5.24441280655318],
              [4.49116740736537, -5.2586857497879755],
              [4.471001301632963, -5.260062860903299],
              [4.449934606010602, -5.251164345819982],
              [4.434395109856604, -5.237892774487408],
              [4.441662556192729, -5.222781286841769],
              [4.4608343568043525, -5.223161134260372],
              [4.4910612870253805, -5.2116101981235055],
              [4.506790765391486, -5.19147236133745],
              [4.50382792081507, -5.170262119988641],
              [4.494039498748396, -5.156630636520012],
              [4.468852059024284, -5.1419257027027845],
              [4.4566705251254755, -5.152809837654415],
              [4.464399973074359, -5.187807294820893],
              [4.455060611607674, -5.19955647776222],
              [4.434704070658114, -5.207544345446573],
              [4.410958484158348, -5.203587843432587],
              [4.412956654577731, -5.185286772643186],
              [4.431509969818903, -5.172803689778622],
              [4.448652760069097, -5.132852715249247],
              [4.419330473997756, -5.111571714523304],
              [4.40538423026318, -5.0835153790071805],
              [4.412751079115176, -5.0739538331544765],
              [4.4570900749663185, -5.071404266935603],
              [4.484549790149479, -5.048007895251551],
              [4.4903637825641844, -5.0293463512877885],
              [4.482180674716267, -5.011280988536157],
              [4.462744101012219, -4.99617326654299],
              [4.443629220587862, -4.9864843966327745],
              [4.418905152795043, -4.984263054496089],
              [4.404368342809985, -4.97062141839783],
              [4.402923138651851, -4.957546489648481],
              [4.417994597273076, -4.940661868488944],
              [4.450669044124267, -4.936968567648434],
              [4.4591637966059565, -4.9323497425186575],
              [4.4829309805582875, -4.961093767359801],
              [4.51862989753532, -4.978379092739171],
              [4.5311657442292335, -4.9763309444988035],
              [4.562906671130702, -4.962469947708977],
              [4.567310250760014, -4.954105706091264],
              [4.552251737337648, -4.927218237489566],
              [4.541066713667978, -4.919578775632898],
              [4.517270015457179, -4.9286121625446455],
              [4.494712882173926, -4.931885142063886],
              [4.467426737069983, -4.907051905307149],
              [4.476931231729417, -4.854779378302165],
              [4.498632037835188, -4.8649055341979075],
              [4.543648374393348, -4.85597789117875],
              [4.56702696237168, -4.868353321121464],
              [4.587065031214126, -4.863473604770331],
              [4.594954136377533, -4.854797630010087],
              [4.593681276930345, -4.838977695502177],
              [4.581595313807168, -4.830114388174814],
              [4.559772725259044, -4.825482491510812],
              [4.545214630006697, -4.8179606802924715],
              [4.5262956156012555, -4.78947526499844],
              [4.525208726318624, -4.762006413680972],
              [4.55281220895354, -4.734893600862078],
              [4.5711355225980705, -4.70042915234636],
              [4.5598904154517985, -4.689327388638883],
              [4.5137911002679605, -4.680818340419084],
              [4.504044352310342, -4.670825685318781],
              [4.50199118330195, -4.643861871894352],
              [4.506991905472257, -4.626013736919994],
              [4.5200606455142465, -4.6284717790905985],
              [4.536252968372438, -4.640819700323662],
              [4.560155410123157, -4.628969201410329],
              [4.57758462303267, -4.665060192553959],
              [4.601873368742031, -4.668367251795604],
              [4.608560038787208, -4.649835419925263],
              [4.593564916120693, -4.633304652135413],
              [4.584583363002108, -4.611610964821591],
              [4.608809159549749, -4.602759366875647],
              [4.640882053785373, -4.606479471378574],
              [4.659774505892314, -4.6015771838887005],
              [4.6672307988265525, -4.58710588888581],
              [4.666100652551921, -4.567697050828647],
              [4.677406605404235, -4.5443422752576605],
              [4.672236508368703, -4.532816493865311],
              [4.658087061633837, -4.528663112293265],
              [4.635531204023074, -4.534175617438745],
              [4.613010225580126, -4.519217493359252],
              [4.603366975539632, -4.506781356720308],
              [4.602637479722208, -4.4937014863627285],
              [4.640907883756947, -4.461459284552124],
              [4.653964895260509, -4.465343365205865],
              [4.682977414029078, -4.485682166836734],
              [4.703016826197125, -4.485917231272546],
              [4.7137545770206115, -4.479118408673898],
              [4.725101606923614, -4.4606240740612915],
              [4.716551507261559, -4.439756006042653],
              [4.685332779621851, -4.437615209984178],
              [4.658397224689818, -4.44351227191633],
              [4.635659436246891, -4.4313350854791915],
              [4.617982635967379, -4.410011283852964],
              [4.615057283548826, -4.3953183517370125],
              [4.621078414804544, -4.382991806795533],
              [4.639663764249961, -4.382159946623994],
              [4.645585553171648, -4.396697254215832],
              [4.661655680583211, -4.409162400493219],
              [4.682358063319863, -4.413139760854988],
              [4.695951264233269, -4.407533902638132],
              [4.693900595882872, -4.3856324945097285],
              [4.697585100241031, -4.349157897551688],
              [4.711054007676041, -4.341808450828292],
              [4.7535131166736315, -4.35069401422772],
              [4.775005314071631, -4.329614675664453],
              [4.775064842142012, -4.306673562928547],
              [4.746661449564708, -4.272287016748724],
              [4.745629249781806, -4.26162160325176],
              [4.761108602332827, -4.250989420334748],
              [4.785319702800308, -4.257042967581486],
              [4.801149286036869, -4.254438022905789],
              [4.8190244124823876, -4.244779867414086],
              [4.817701477745863, -4.2634978996512265],
              [4.810267107706392, -4.277991689580522],
              [4.809879084097171, -4.294168431733281],
              [4.822714982213404, -4.3030544029219175],
              [4.8390563483407245, -4.292877953419625],
              [4.829549255274419, -4.259596451718515],
              [4.848834607470264, -4.225245887756581],
              [4.871151304749615, -4.2225556736957985],
              [4.892360661244268, -4.202334313278922],
              [4.898084254562553, -4.18005390955008],
              [4.882839217849645, -4.134248203504879],
              [4.882440160782598, -4.120919829774968],
              [4.890281796134515, -4.095264146158943],
              [4.920495289059059, -4.068820916763035],
              [4.921129653442535, -4.050934633829849],
              [4.8920259424327845, -4.0180861712186156],
              [4.876303667477034, -3.991710566989849],
              [4.88261437601013, -3.955114003434606],
              [4.891052159171566, -3.94337324650641],
              [4.889177825727178, -3.916193958460263],
              [4.909343945962981, -3.9201108118051717],
              [4.9146710673144876, -3.9314537862280075],
              [4.905340228232503, -3.949249560947003],
              [4.904112657927084, -3.9628917637096905],
              [4.911056972841052, -3.9771830243231525],
              [4.935905531009702, -3.9764888499797792],
              [4.97300262521136, -3.9349497129806035],
              [4.977068719393465, -3.9205584069431327],
              [4.966585580812984, -3.899802778257131],
              [4.9325573413663015, -3.9115674256666595],
              [4.919673230760283, -3.91162158120966],
              [4.89685096505361, -3.8982225804675434],
              [4.886564834207052, -3.8968511916334605],
              [4.891906102337723, -3.8713542744561944],
              [4.9065322779549225, -3.8693977505456485],
              [4.910556327204584, -3.852652721180347],
              [4.902154970128785, -3.8248610808168015],
              [4.907078781984206, -3.811981374588925],
              [4.922758178494381, -3.804921360028725],
              [4.9475116632568135, -3.8331673055542668],
              [4.947077090168552, -3.848377581386195],
              [4.9243712842076075, -3.875931823349025],
              [4.937707401364169, -3.8829999955040875],
              [4.964817310938494, -3.881151534901523],
              [4.985547103318911, -3.864598351190298],
              [4.9811179494252436, -3.8481711025004954],
              [4.959550370071837, -3.8112166216706367],
              [4.964192092884647, -3.791780377944393],
              [4.9750863846065645, -3.782900653844193],
              [4.9490190933915175, -3.7412796139963516],
              [4.954480562344219, -3.7185234524406816],
              [4.9653177129364545, -3.7119499881320897],
              [4.98672555714768, -3.719780524689356],
              [4.993520647703068, -3.735634536826128],
              [4.978582941118407, -3.763409905399381],
              [4.988354926078508, -3.77762786950724],
              [5.019880926752839, -3.773307124008814],
              [5.0494515678811425, -3.756375186691486],
              [5.067849168096867, -3.7394038597318198],
              [5.090753569961798, -3.75244683242496],
              [5.094196225314879, -3.734657908756431],
              [5.083913728363234, -3.7258035852674714],
              [5.1311854202850125, -3.700455966997771],
              [5.142119652714725, -3.683950907648612],
              [5.137488602624768, -3.6442820493381003],
              [5.116782988365072, -3.635412394437943],
              [5.09514745774498, -3.6188511154665925],
              [5.084008686486994, -3.6001347696913455],
              [5.369823608351954, -3.5836473027882074],
              [5.5001096760977966, -3.575523445496771],
              [5.543333230500684, -3.571782062243129],
              [5.730274303305297, -3.5596943438108557],
              [5.792091456615612, -3.556460664433564],
              [5.968271712355204, -3.5431090988176708],
              [6.017431371180028, -3.5403963522748367],
              [6.2049685912831904, -3.5257421234045467],
              [6.399951064654212, -3.5103125595282276],
              [6.57937112384951, -3.4957724447684466],
              [6.792130435242689, -3.478987803252178],
              [6.814270791927082, -3.510615812109614],
              [6.83501016137596, -3.5494347194807774],
              [6.850767378061669, -3.563079888260382],
              [6.8835026249364235, -3.5759075779596516],
              [6.880895847829824, -3.745680831705419],
              [6.876486290353999, -3.8486447524929503],
              [6.871818122600952, -4.00994521157489],
              [6.8708522708188475, -4.09085227765162],
              [6.867109965487471, -4.254710783726701],
              [6.867669030916599, -4.270974998973344],
              [6.864721556079743, -4.360782928478702],
              [6.863242942819726, -4.4483523561897345],
              [6.857916178003979, -4.632186568797967],
              [6.854609678634387, -4.761021399884054],
              [6.852393547494841, -4.908888739578774],
              [6.8508297221097845, -4.96987349185781],
              [6.845564803878848, -5.263589754367048],
              [6.8423144250000805, -5.412452534531228],
              [6.838939249592509, -5.611686551167742],
              [6.837529958201746, -5.739829652415678],
              [6.836261385187079, -5.775908873887957],
              [6.8318890808503525, -6.040277177041143],
              [6.829603782972699, -6.115512238522623],
              [6.827399197393819, -6.239795353314662],
              [6.824878307969032, -6.317509966838827],
              [6.8180258561115785, -6.597460257144682],
              [6.841032321871533, -6.791771106148407],
              [6.851277267591261, -6.867211763182068],
              [6.871327502423616, -7.027802568897604],
              [6.898500748997005, -7.238014506993156],
              [6.929688508062235, -7.483690073853705],
              [6.946187600555248, -7.6138155546192285],
              [6.984594591746644, -7.932796631810803],
              [7.006155954506046, -8.104219097785652],
              [6.992172015556843, -8.116673739297001],
              [6.960241007579272, -8.122440883919829],
              [6.963641450753737, -8.13785887876345],
              [6.958851643841982, -8.147555635369756],
              [6.937149375017964, -8.160483611887377],
              [6.916394062410087, -8.16039110654448],
              [6.895033656752024, -8.139816558810061],
              [6.849353268427022, -8.139972731011417],
              [6.844560100653637, -8.12049814886674],
              [6.82133775082844, -8.132020225484242],
              [6.814303352787172, -8.11608295284222],
              [6.798555273902129, -8.12996305390905],
              [6.775948860425313, -8.129457854420119],
              [6.745791176536837, -8.15007267369155],
              [6.721555929119583, -8.15292767794818],
              [6.705671704352198, -8.14920731608291],
              [6.64775168486859, -8.106748196774145],
              [6.619928707885471, -8.094009728602757],
              [6.604253313420052, -8.074696645591661],
              [6.594093123112672, -8.081366532113554],
              [6.595436323054903, -8.096354167718527],
              [6.603711528333742, -8.112884630961538],
              [6.551834032307868, -8.114784276962157],
              [6.509794555221318, -8.120308308882965],
              [6.47150416684873, -8.129809727760628],
              [6.419581435689707, -8.148135877326233],
              [6.328949119894277, -8.193183609822878],
              [6.30069268440332, -8.203835216614982],
              [6.257726054344214, -8.22376551312736],
              [6.241021133015169, -8.227117717550142],
              [6.238925279758018, -8.202614985679498],
              [6.257902376179685, -8.188867459022127],
              [6.231524194857155, -8.164413769280044],
              [6.21576303153906, -8.156497343087558],
              [6.1864102748752074, -8.163630149253741],
              [6.165117176089884, -8.186540403786093],
              [6.169355610360122, -8.20218377799999],
              [6.191349949886892, -8.19054657570211],
              [6.203253729172773, -8.195363420127238],
              [6.2133285302723404, -8.213148734689394],
              [6.207946647233086, -8.229822936664021],
              [6.176826455765508, -8.250967863424355],
              [6.161390511553172, -8.268998921320144],
              [6.138622817193283, -8.279454522110797],
              [6.130523367211768, -8.292311178802295],
              [6.1349633794669876, -8.307864228556129],
              [6.1120464735867035, -8.334737676677772],
              [6.115192249721174, -8.347895940478288],
              [6.108042798786872, -8.357143127376409],
              [6.096620166335834, -8.345863360120994],
              [6.086235394873739, -8.346631530787976],
              [6.071959554790945, -8.359017210766918],
              [6.050366000368266, -8.35952585957548],
              [6.045336092595074, -8.354143940186885],
              [6.028814761064346, -8.351164343520566],
              [6.009703475484349, -8.36515960376783],
              [6.0001757640158955, -8.359938589507959],
              [5.980506519718377, -8.331558735751017],
              [5.966137844505063, -8.321194370297153],
              [5.965574791634745, -8.301465345924031],
              [5.95148286610705, -8.292936567825496],
              [5.950283161659114, -8.270427888096771],
              [5.935751845964837, -8.259835436799802],
              [5.941154953230604, -8.24359344006239],
              [5.952425598457017, -8.235915668973485],
              [5.9477315346895905, -8.21135368724099],
              [5.922972789680194, -8.19587445390937],
              [5.9176797416703355, -8.18156357207343],
              [5.896918412178125, -8.148537954945366],
              [5.9008187361772695, -8.140190619211431],
              [5.893710052837941, -8.115310935494763],
              [5.894099904958285, -8.103074881159085],
              [5.864499579060674, -8.079166173403731],
              [5.856076827392591, -8.06569321722514],
              [5.840462220145072, -8.061330661206224],
              [5.817217534357928, -8.04524061626106],
              [5.805488886574488, -8.01683984275144],
              [5.792862502990958, -8.013741917945403],
              [5.7951765749405, -7.991615804074946],
              [5.7811501439561885, -7.995344231604173],
              [5.764888021009643, -7.959492322117192],
              [5.76499537390132, -7.931465472199238],
              [5.759701277315171, -7.915276335172477],
              [5.739338561783306, -7.896074711941672],
              [5.747141604363888, -7.866201303629335],
              [5.738119341340926, -7.8590598167963535],
              [5.752150085199131, -7.8405378476435414],
              [5.753572292465849, -7.823465304673229],
              [5.745863067511768, -7.801634379592098],
              [5.759743309700926, -7.771599015647985],
              [5.783154949088849, -7.73662632902143],
              [5.777016292784923, -7.732298689844492],
              [5.781059305798277, -7.710514168267132],
              [5.794049308561689, -7.697074081911203],
              [5.787508426376093, -7.667152039578318],
              [5.801645270786148, -7.662041211146388],
              [5.810611197502528, -7.643661494494099],
              [5.799140438083661, -7.619938381273235],
              [5.81523410439384, -7.595897410611055],
              [5.820278416085138, -7.568906869738835],
              [5.815419798420064, -7.557763275472113],
              [5.7984454146307725, -7.5618403253479824],
              [5.6531000447209685, -7.571600345278755],
              [5.550276714224184, -7.578215167079858],
              [5.44745215392851, -7.58481173974444],
              [5.35525430199564, -7.590907440197951],
              [5.263055363111245, -7.596988463916796],
              [5.1120944018638745, -7.605913649378933],
              [4.961130992736869, -7.61479953549221],
              [4.824363651366938, -7.621788581221069],
              [4.676308253735606, -7.630251143006462],
              [4.5241784597178905, -7.637388867159569],
              [4.373016398222828, -7.645235978704202],
              [4.287012349189992, -7.649168178785925],
              [4.201007726216122, -7.6530876539327295],
              [4.200721240711668, -7.646923556141986],
              [4.229748623984582, -7.6337536780702395],
              [4.25097915683476, -7.611180109890588],
              [4.254100140863162, -7.5959510298685435],
              [4.246745307326735, -7.580297195468408],
              [4.2049802743332485, -7.548199543831536],
              [4.1948266435523145, -7.536179290267313],
              [4.1975887708972754, -7.516164773886942],
              [4.217323451662294, -7.48874967327846],
              [4.223449706884702, -7.473435562334294],
              [4.221890612606534, -7.458461174802703],
              [4.211351257343628, -7.444124831230706],
              [4.190531936852348, -7.427648793079893],
              [4.173772638487949, -7.4201019288222065],
              [4.164562023774205, -7.3992628725526135],
              [4.177930218001577, -7.3867728625064775],
              [4.191804482421463, -7.386009203123052],
              [4.231982255069665, -7.390660225995674],
              [4.249417178429784, -7.3880982095493275],
              [4.2788959000201086, -7.374535951948278],
              [4.286389048589249, -7.357882622077652],
              [4.284182782214099, -7.332896262867783],
              [4.249662331547197, -7.3041784865200325],
              [4.247491376064904, -7.275315161766844],
              [4.231254318885824, -7.274758478658966],
              [4.2222830990865905, -7.2538039137308745],
              [4.23231560561456, -7.229035741937249],
              [4.246074902023902, -7.219204153998976],
              [4.261768757379886, -7.2607349887055825],
              [4.27661088593015, -7.279966034140008],
              [4.286903234280992, -7.284802040765727],
              [4.308395438969939, -7.2837850224783125],
              [4.313533462110884, -7.27719178636654],
              [4.31269744970351, -7.252710140924282],
              [4.287761638968972, -7.229366473455342],
              [4.275319829236681, -7.206145846233857],
              [4.26941064639944, -7.167447907649768],
              [4.270890970336749, -7.1408216224979615],
              [4.263862681270916, -7.129217618081489],
              [4.269149495617957, -7.120177288694117],
              [4.291199516469536, -7.115777942404913],
              [4.299780377757275, -7.119263033903684],
              [4.324519460299033, -7.10881461720691],
              [4.358776187480921, -7.077551686753207],
              [4.361176206931763, -7.057084535106229],
              [4.34489265725481, -7.050582856276099],
              [4.315862581748696, -7.061443033102411],
              [4.292456020450256, -7.06394737070407],
              [4.2771172377085644, -7.055131211313677],
              [4.264675977491712, -7.039661382725104],
              [4.2638634386216125, -7.024220620484137],
              [4.279093115320254, -7.005506179944182],
              [4.308952796866791, -7.029047058151537],
              [4.345547083505402, -7.036084463703009],
              [4.362147263525109, -7.026507900884048],
              [4.36547903132197, -7.002598807656459],
              [4.359615642299437, -6.958970642933173],
              [4.3610265446991905, -6.935746649096428],
              [4.386365516739108, -6.89776826171943],
              [4.408576087103465, -6.89487109271438],
              [4.462172496838686, -6.896724283340415],
              [4.4719896017627265, -6.887300319798185],
              [4.471669687031877, -6.87480893009165],
              [4.451971419408869, -6.870722932675712],
              [4.4187387861731855, -6.882889051376864],
              [4.3941849655997105, -6.8875264391745326],
              [4.385288746139526, -6.884398772975869],
              [4.388524594063002, -6.846566900181975],
              [4.398047987685686, -6.802666298842517],
              [4.412494976511342, -6.790077273790604],
              [4.44136231435797, -6.783269544508224],
              [4.446308503322346, -6.814484660226237],
              [4.4579001135546195, -6.831188325175863],
              [4.4704215639402465, -6.832566213603929],
              [4.482144194955925, -6.819041296390034],
              [4.483072111537587, -6.8081674481213],
              [4.464443686371776, -6.791118296735107],
              [4.462939797540298, -6.779707753352718],
              [4.489931455073374, -6.764180967894404],
              [4.516903565665089, -6.730570256073636],
              [4.531568097887877, -6.722839683763425],
              [4.530281117733697, -6.70592111633144],
              [4.5221398463112905, -6.703833008808896],
              [4.524987061295564, -6.678410935971814],
              [4.544038524494297, -6.655866749025788],
              [4.5834313306591365, -6.6493676314193735],
              [4.605768982618348, -6.635131664321035],
              [4.616867504003476, -6.617898956945158],
              [4.5992818770041195, -6.598185943542991],
              [4.557026389911946, -6.591247045371329],
              [4.547279299802703, -6.585644197267975],
              [4.542042837474968, -6.570816555691483],
              [4.552186897776678, -6.5579068327155765],
              [4.569382199977571, -6.5606311322024915],
              [4.582368607162282, -6.5782607717473836],
              [4.596021386164478, -6.587457885310073],
              [4.612432605384192, -6.5847154977166085],
              [4.610171851610678, -6.555942766900341],
              [4.6440303601190935, -6.535097224655238],
              [4.64934111994581, -6.512526743081097],
              [4.664856751209292, -6.5011183971670805],
              [4.670713511383526, -6.469913515371945],
              [4.652097774671201, -6.470384754803063],
              [4.637338153142359, -6.459152123302788],
              [4.623129440797458, -6.463188253671032],
              [4.631594229645563, -6.476649609938137],
              [4.630408490768517, -6.50982429685256],
              [4.605955431350905, -6.501332338896348],
              [4.581457504602852, -6.511544145900135],
              [4.537702030842639, -6.506113559222326],
              [4.5266947067431, -6.484388525377229],
              [4.533285488019805, -6.442145411369102],
              [4.558149665856857, -6.424337299867842],
              [4.572215219122703, -6.430384812281032],
              [4.5994021052400305, -6.409205195488972],
              [4.618551578104452, -6.416019489868998],
              [4.629898227470072, -6.392927262899287],
              [4.640128769551812, -6.391996122163389],
              [4.667491483434161, -6.409074055926885],
              [4.669296837721006, -6.436175705649753],
              [4.68423140924254, -6.420604112095982],
              [4.685408775907553, -6.387577442225222],
              [4.6940820859224655, -6.378198923066874],
              [4.68172860498073, -6.36106696385743],
              [4.686039350481157, -6.33467143993675],
              [4.6961349478126495, -6.333717701477598],
              [4.710549005875373, -6.346349881841726],
              [4.736071020911365, -6.324888678745067],
              [4.76169261827289, -6.269512093708309],
              [4.748775727696096, -6.27339765935522],
              [4.737326842840272, -6.28892571144964],
              [4.6743137358132305, -6.2799421384124],
              [4.65848382657982, -6.264375090137786],
              [4.665339920538462, -6.228268167829986],
              [4.681358836092334, -6.219280477626731],
              [4.686905926610063, -6.197099848340496],
              [4.676072811281001, -6.184492341901777],
              [4.663034503353357, -6.181354720664082],
              [4.6339893737624385, -6.200197353705846],
              [4.614200783119681, -6.196319865198817],
              [4.577606514933741, -6.177887676106399],
              [4.558999274931132, -6.154416243517482],
              [4.557534945656559, -6.137472978209277],
              [4.569118079061661, -6.111389175189632],
              [4.574229746627836, -6.087567377309915],
              [4.590885991253226, -6.102391574111281],
              [4.612648157254792, -6.134636012043945],
              [4.62387866293993, -6.143763770086198],
              [4.652713428626044, -6.15057026698973],
              [4.663728088619367, -6.144377710830618],
              [4.659135800785893, -6.123730910177734],
              [4.63871662987995, -6.112374753509865],
              [4.610820106224204, -6.103941384343037],
              [4.589730330044005, -6.0891827493887325],
              [4.585018047752925, -6.079688488946981],
              [4.620821945666143, -6.054688859460802],
              [4.645640659437541, -6.023124280000965],
              [4.646334585016184, -6.010292360367969],
              [4.635919522568798, -5.99288005296309],
              [4.625998538463508, -5.987296201622401],
              [4.615958093262301, -5.9979656299969335],
              [4.607974077255996, -6.027682024149037],
              [4.583462330606876, -6.035466928906163],
              [4.551527572874474, -6.052669885783727],
              [4.537270722647818, -6.046876022548841],
              [4.527489952681645, -6.034862412091692],
              [4.520210269068074, -6.0131617052151025],
              [4.520179583108848, -5.998564276292398],
              [4.532264977108901, -5.98806979160199],
              [4.547255559936189, -5.9638112784534565],
              [4.577385212435491, -5.945182641217718],
              [4.591139739836326, -5.932652079936235],
              [4.598035521020618, -5.912925564215085],
              [4.5925126532095, -5.907966356376419],
              [4.539619824565496, -5.895351869281373],
              [4.517049019138047, -5.89751565883657],
              [4.503966385148339, -5.8886457376004655],
              [4.509500259333222, -5.859265020796361],
              [4.502977667888144, -5.854106397665649],
              [4.503890482021229, -5.827359909525865],
              [4.516233935863396, -5.796261025859597],
              [4.529879890268932, -5.783348824737438],
              [4.548264134650878, -5.7790634851923],
              [4.5758924407975, -5.7473061406674555],
              [4.580372854217664, -5.734638882126567],
              [4.57875053371332, -5.70925836714544],
              [4.564860665561788, -5.693190063224779],
              [4.563904166836594, -5.6735994796706954],
              [4.55783537192111, -5.660403791498012],
              [4.540712170956611, -5.648577047976252],
              [4.517102939839848, -5.659090425598972],
              [4.5217239118945765, -5.674739135673839],
              [4.516534024508967, -5.686091861862322],
              [4.523178870562653, -5.708518658866068],
              [4.512955073123551, -5.73365595422789],
              [4.500827011046838, -5.739900692158962],
              [4.469798899242302, -5.734546428517415],
              [4.45564618608131, -5.719899944542131],
              [4.454952526970946, -5.705927904596228],
              [4.465294238768537, -5.689129098305328],
              [4.462821095073075, -5.680332453554024],
              [4.485312012450959, -5.654256379151431],
              [4.49038541961474, -5.635746950419626]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.6654658682246, "lat": 32.75128218146674 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779790"
      },
      "bbox": [
        4.164562023774205, -8.36515960376783, 7.006155954506046,
        -3.478987803252178
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.921111935953661, 1.7755932379598092],
            [3.944212728908203, 1.7834394434163072],
            [3.953384187886528, 1.7909017024707323],
            [3.953634274956202, 1.8171743004673926],
            [3.947316115376866, 1.8345375425243633],
            [3.9484122163750053, 1.855789157872902],
            [3.9570125286965316, 1.8842448742246234],
            [3.952498239809534, 1.9126560751075918],
            [3.937184788530084, 1.932641009838122],
            [3.9230679082586213, 1.9416762559785647],
            [3.92580183187083, 1.9587248647939608],
            [3.941413867160648, 1.9746137868163427],
            [3.9550183951657454, 2.0028858759955313],
            [3.9630042371591805, 2.0112394657146817],
            [3.993910082530558, 2.0294483610421215],
            [4.0373911180382365, 2.0438811410204414],
            [4.083183475442724, 2.045082728200163],
            [4.12891024619697, 2.0795653723135508],
            [4.136468408985315, 2.108078205174839],
            [4.132161070148422, 2.136266705619733],
            [4.136478405464069, 2.1624926905136492],
            [4.147355331435481, 2.1920900291101137],
            [4.141839581435271, 2.224005020283655],
            [4.146238503075853, 2.237371308259474],
            [4.170202496920192, 2.26257773944867],
            [4.177974893940738, 2.2831318871455775],
            [4.194439656883834, 2.2997985715023948],
            [4.2104274881967925, 2.324953692895555],
            [4.236159646881291, 2.3433007932723613],
            [4.242570353519462, 2.3772194840426764],
            [4.236801181242215, 2.3986337158223847],
            [4.24448474009225, 2.4260064702947384],
            [4.245734192218061, 2.4545284324148344],
            [4.238372136937457, 2.4924785037626616],
            [4.239148200873461, 2.5166486975460582],
            [4.223535227867205, 2.5389454073559237],
            [4.203886906583641, 2.5743744677864138],
            [4.1899659324553475, 2.584198226999573],
            [4.16465185169828, 2.582827813013477],
            [4.144737968335294, 2.6154528398555605],
            [4.106977437434836, 2.6557367693908813],
            [4.106129751656908, 2.664392862706845],
            [4.120710484785167, 2.70233086897802],
            [4.130748090166716, 2.717889572942838],
            [4.136492910936519, 2.7860088994269803],
            [4.145665851951388, 2.8027984014896097],
            [4.147117054739241, 2.8286969121483114],
            [4.161333583661745, 2.8422436308240684],
            [4.199874570924197, 2.854735019996258],
            [4.234090989229776, 2.843869556936238],
            [4.255514445602691, 2.8548438896849233],
            [4.286217413386522, 2.878268359743782],
            [4.301016013957409, 2.881965465194564],
            [4.3754845268647795, 2.8805081736099893],
            [4.435469598082332, 2.895956858711317],
            [4.4706816386497765, 2.9303056477925598],
            [4.477659243436073, 2.947637497379456],
            [4.517069605298842, 2.9651119382457947],
            [4.547432411676817, 2.9586965497940185],
            [4.576186445283997, 2.9659104195670225],
            [4.609757789596039, 3.010012400387078],
            [4.659997419929906, 3.035664378356133],
            [4.662091122410317, 3.0466756810537476],
            [4.656287794033364, 3.0950410136624367],
            [4.660939701053882, 3.1281747203631705],
            [4.674699122450202, 3.144386664755887],
            [4.6719298805998895, 3.183961671445519],
            [4.680174542155683, 3.2003438325699816],
            [4.69697516725473, 3.218812923579354],
            [4.737054614184233, 3.247209142224885],
            [4.7617700189732375, 3.2588222398931963],
            [4.766637432127687, 3.2680033363267924],
            [4.762878939568498, 3.2890248406845517],
            [4.769473695351426, 3.3139445205759337],
            [4.770486343141974, 3.3331865994728282],
            [4.780759763404033, 3.364217481860894],
            [4.7807123035877135, 3.388783060940588],
            [4.7708224797285625, 3.4022098734567625],
            [4.771068510081369, 3.4187036073217407],
            [4.781554835848896, 3.4395299964175137],
            [4.784735252928372, 3.4618073884086975],
            [4.774557080303633, 3.4887581169617934],
            [4.764347251333402, 3.4996845449114784],
            [4.759417123330261, 3.533293645370513],
            [4.762329628800387, 3.5453891145805585],
            [4.760905912827538, 3.5746089581539127],
            [4.754445337622589, 3.582751231583724],
            [4.7317186209776425, 3.5871404480144027],
            [4.724449431920806, 3.608588941629224],
            [4.693431644507482, 3.6256232182978527],
            [4.669441531579023, 3.631603517769169],
            [4.634240319777457, 3.651844536119987],
            [4.612905527681169, 3.6550026485382636],
            [4.586640331153541, 3.673608190352068],
            [4.564209143450023, 3.7014701347987744],
            [4.554325481893937, 3.7248054420198917],
            [4.562662937700447, 3.7700427183306235],
            [4.540266927594551, 3.8014515633661086],
            [4.514114870337033, 3.828678815129047],
            [4.496692382039814, 3.839485285950277],
            [4.455299664113878, 3.85782622463355],
            [4.442320830390637, 3.8827975659327136],
            [4.402111761172791, 3.8978173769141193],
            [4.379267508618973, 3.9162415048442485],
            [4.377130784396683, 3.9293962216401344],
            [4.385750629327054, 3.946753194607181],
            [4.472423231268022, 3.9509480065490843],
            [4.559096463000489, 3.9551282184293055],
            [4.680519592599577, 3.9631890309197466],
            [4.801944723596657, 3.9712211378898066],
            [4.888654485504942, 3.9740110975493192],
            [4.993824669368608, 3.9805279490845438],
            [5.098996148152486, 3.987023280048339],
            [5.205222094822162, 3.991085089840908],
            [5.304669121197377, 3.996048861505157],
            [5.404116889606898, 4.000993420864787],
            [5.498484636083215, 4.006835736345516],
            [5.592853350582467, 4.012660740881042],
            [5.743644590892394, 4.01986564154483],
            [5.851543209743163, 4.031215503809351],
            [5.933923270998633, 4.037486663971589],
            [6.016304318794681, 4.043744611744654],
            [6.1195646489034665, 4.052256991302082],
            [6.233650651343308, 4.063036370704713],
            [6.348124161956465, 4.070897957520463],
            [6.462599189360064, 4.078734046600045],
            [6.467342584926983, 4.058128825403192],
            [6.46609929476348, 4.017205499948816],
            [6.470597233141822, 3.976534009829241],
            [6.46319717407711, 3.946775178737827],
            [6.4571226128053905, 3.940106817384471],
            [6.455246815469063, 3.8855445871811316],
            [6.462516802901804, 3.854311814327771],
            [6.48728831519248, 3.7965824503742285],
            [6.543221556611228, 3.7109233616457042],
            [6.563950162694717, 3.6870242969047164],
            [6.58667004005198, 3.669238894138361],
            [6.596204274606397, 3.6525252585433834],
            [6.600599287725384, 3.6234583512077387],
            [6.6151575682437835, 3.5842094331957415],
            [6.6280483214247035, 3.562363862867272],
            [6.645694805953488, 3.4991419098346874],
            [6.652818471062404, 3.49131448836658],
            [6.653557226502978, 3.466439372959746],
            [6.661397917964638, 3.46502837349509],
            [6.660670287934206, 3.4431442476392258],
            [6.668863022607322, 3.4252940629812754],
            [6.68439466196526, 3.403985980552857],
            [6.693501158200758, 3.379532294628762],
            [6.708940005926445, 3.3619564724770146],
            [6.727123260412538, 3.3509453459084804],
            [6.735776846418827, 3.311573963954939],
            [6.7549973630841755, 3.0855096157168522],
            [6.7706841304155985, 2.900328665841041],
            [6.795485275685457, 2.62572433042335],
            [6.8154469274900285, 2.407552179162864],
            [6.843191100992163, 2.093402969431885],
            [6.870397306961415, 1.7455487353354486],
            [6.893820829232005, 1.4681116994334356],
            [6.915726604846571, 1.2311148827192155],
            [6.934144119679178, 1.0325965382294524],
            [6.942097036727281, 0.9416016359029405],
            [6.9308688140719, 0.9447392266041431],
            [6.920759730242891, 0.9303646727657423],
            [6.899541381106989, 0.9233919867920434],
            [6.888718670721905, 0.8993739176923852],
            [6.894867908803491, 0.8821917733040053],
            [6.88872667755389, 0.8746617527107243],
            [6.893317525554441, 0.8504521497187763],
            [6.903884848342264, 0.8362422034350574],
            [6.912995826924785, 0.8449401330411421],
            [6.920943710226901, 0.808318443484335],
            [6.913422560680238, 0.78861996172274],
            [6.901582413913697, 0.779136355554318],
            [6.890783099389692, 0.7586842702660092],
            [6.878000642879083, 0.7542790688660471],
            [6.863882112624907, 0.7197585043312339],
            [6.876480128579159, 0.7133330763087128],
            [6.8710170503018375, 0.6908367795785121],
            [6.897589604132235, 0.6905918167805042],
            [6.901374894262098, 0.668915641340538],
            [6.912861117807282, 0.6687556688328745],
            [6.936853968368082, 0.6464396415031733],
            [6.932387906233379, 0.6304888906277714],
            [6.941989334392283, 0.6122517935862495],
            [6.940140207661391, 0.5751993615096316],
            [6.9775363556883345, 0.5635443541075735],
            [6.991356483233279, 0.5486381377920484],
            [6.990909274780283, 0.5252788481553596],
            [6.984408154565788, 0.5005782969373509],
            [6.973631643023565, 0.47909147820756826],
            [6.976928246579948, 0.4567686758955312],
            [6.97025805022088, 0.44976449443037303],
            [6.991369583217053, 0.43996820161530914],
            [6.996604099771306, 0.4179128461655687],
            [6.99301367866919, 0.4090209428607846],
            [7.020124522736446, 0.3783129440369423],
            [7.02109991456652, 0.3579956605586909],
            [7.0174186793561075, 0.32691230562959633],
            [7.008713565106243, 0.3012806553554848],
            [7.010067208296296, 0.2903224364877429],
            [7.0020723733743795, 0.2739046241606385],
            [6.991631949181173, 0.2664613921375047],
            [6.966016231535484, 0.2589728660698008],
            [6.952907107371763, 0.2505505238889919],
            [6.9350403893534, 0.188276092317295],
            [6.94018201547843, 0.16922495482668748],
            [6.926512632781694, 0.1716644902356779],
            [6.928395129843977, 0.15598470375158996],
            [6.92139350358459, 0.1371995122025407],
            [6.908381575688427, 0.12135865033504441],
            [6.929612668300242, 0.09121220052604982],
            [6.921559517780118, 0.08198598555721376],
            [6.908985876821811, 0.08659652180904778],
            [6.899906065312561, 0.07003412883970572],
            [6.879240017236666, 0.05609858903801436],
            [6.855838615712757, 0.05140746006335496],
            [6.848992237922022, 0.02913081700273784],
            [6.867947898591271, 0.025616228935910305],
            [6.863049031477207, 0.01221186081911072],
            [6.8613473925320205, -0.01731188493472585],
            [6.835604818736849, -0.060227912776780974],
            [6.818313948293569, -0.06752103285253704],
            [6.806392912704745, -0.08595804742608194],
            [6.801407094906297, -0.10564010739715884],
            [6.8045967826135, -0.1333472170551171],
            [6.796754738457678, -0.15550235346099908],
            [6.784332757165355, -0.15805071507627427],
            [6.7780777279731295, -0.14513918263003867],
            [6.781431107496177, -0.13154089265573626],
            [6.766038964332541, -0.13059044542211282],
            [6.761752346538094, -0.15128205526492003],
            [6.7483886323142315, -0.16830036157726008],
            [6.739556363077666, -0.15846907776256955],
            [6.74554642815046, -0.1455400700709162],
            [6.725445282221884, -0.1436399021144172],
            [6.7141120891623, -0.1639639198461953],
            [6.709807379506, -0.2045361439569529],
            [6.694476228395406, -0.20235646694625609],
            [6.693784313025036, -0.23427966839785075],
            [6.706198992176819, -0.2507825791421871],
            [6.730423121172204, -0.26583812493379283],
            [6.754303362288517, -0.2722142167240364],
            [6.741959289555025, -0.2891888259242669],
            [6.730686684694228, -0.3147510076821219],
            [6.711712064060446, -0.3121769981513355],
            [6.708945117115858, -0.3333799037359564],
            [6.691212145161908, -0.33646449023158176],
            [6.677862469829251, -0.34897107466013044],
            [6.688333818193346, -0.36155867935312747],
            [6.721399345934046, -0.34343910504564457],
            [6.725449020194214, -0.3561526890900247],
            [6.718874073859165, -0.3760634596123968],
            [6.6937008978514365, -0.3939600681493106],
            [6.669360902864539, -0.3958065614562898],
            [6.669860704885132, -0.4157277273179462],
            [6.683908075785644, -0.4226532765838656],
            [6.678411454645213, -0.440140331361196],
            [6.691277468488178, -0.4696438777688162],
            [6.686325841735437, -0.48800846528697656],
            [6.67415188934135, -0.4916239961935037],
            [6.681371627737358, -0.5180626405393897],
            [6.673393521446361, -0.5246242709535216],
            [6.662139803308008, -0.5162483946520204],
            [6.652564896214852, -0.5279755672978934],
            [6.665831411426538, -0.5337705092423771],
            [6.6908882538229255, -0.5346959622700836],
            [6.69763771809264, -0.5524147202925545],
            [6.665222476985055, -0.558801929656371],
            [6.639970519483417, -0.546245840990886],
            [6.63419028980466, -0.5589117193518893],
            [6.64820800589513, -0.5725065880036482],
            [6.665648860617376, -0.6018380280759306],
            [6.68657497408993, -0.6069885942301416],
            [6.688289683502414, -0.6246121835524614],
            [6.6689316311088565, -0.6281957561408453],
            [6.646778244034074, -0.6230166687801351],
            [6.644476409015915, -0.6359931977369485],
            [6.656126452282315, -0.6473177090688018],
            [6.669469899613702, -0.6496862895446355],
            [6.685921658012764, -0.6395234714480178],
            [6.6943006719984055, -0.6496011995450596],
            [6.688838719189655, -0.6574644677711436],
            [6.6856495509121, -0.6828591787022412],
            [6.671510058842154, -0.7128974491641139],
            [6.626361522425347, -0.7486300042103743],
            [6.620442078432018, -0.7649231734199518],
            [6.604001292794047, -0.7935960186880456],
            [6.605917561341001, -0.8183552774119961],
            [6.622005745068072, -0.8546148460449728],
            [6.630198018507552, -0.8825158756022808],
            [6.656291829979532, -0.9013209338494518],
            [6.669676443945786, -0.919264261854644],
            [6.685396361395257, -0.9279078074969186],
            [6.692920308372296, -0.9570114640556164],
            [6.679812613342853, -0.9813392985655934],
            [6.638122375914613, -0.9862216645484241],
            [6.607331413431567, -0.9967071116500855],
            [6.568902095473269, -1.0063509819470822],
            [6.524905721451061, -1.0148006863602892],
            [6.501658497692073, -1.0288491432592721],
            [6.466330571320226, -1.0698493189849896],
            [6.427482679744922, -1.0503962821458728],
            [6.391825984308174, -1.0701894563366667],
            [6.3774039046515085, -1.093218050037438],
            [6.373051431137725, -1.1414449375985543],
            [6.357046000833377, -1.184301599067041],
            [6.354707931346398, -1.1991538493136293],
            [6.361642991095849, -1.2207972904194344],
            [6.382475612527796, -1.240776435182271],
            [6.394520231619532, -1.2607019459572746],
            [6.414711874142131, -1.275936019423834],
            [6.430982136063334, -1.318416736144753],
            [6.437189061070967, -1.3258911015388575],
            [6.425600007771073, -1.3705985922704016],
            [6.425749798729578, -1.3846986587271783],
            [6.414963487524756, -1.406779009037305],
            [6.398513100660043, -1.4151016204796991],
            [6.367729083237786, -1.4193409407747035],
            [6.325772295384051, -1.4080391734664044],
            [6.311513987586914, -1.389917533344408],
            [6.293120911683532, -1.3774352387500428],
            [6.2660083884481415, -1.369316744691342],
            [6.230953468233795, -1.3552862812990096],
            [6.195699011799084, -1.353360049173941],
            [6.159283312699399, -1.3310091509950663],
            [6.134344108880593, -1.3128435804532927],
            [6.044779566675667, -1.2837491699427224],
            [6.015641534240955, -1.285088601459926],
            [5.998323541515711, -1.2814155853107292],
            [5.978069788452338, -1.288284233440276],
            [5.956233185115891, -1.303310481995472],
            [5.9225071317225675, -1.3422369408753547],
            [5.910723669234213, -1.3620083385072161],
            [5.9041134182100885, -1.3870995161845037],
            [5.888899122007435, -1.4117949585191547],
            [5.875605775044434, -1.4226687167226706],
            [5.857522457319219, -1.4490720487455817],
            [5.84882923686423, -1.4870829755563957],
            [5.8527994742081795, -1.5033402850629347],
            [5.863956318959887, -1.520339084713577],
            [5.892131116056546, -1.5396953503345954],
            [5.86354227101607, -1.553802416434249],
            [5.845407880562191, -1.5452926278622212],
            [5.838073832033339, -1.5137120131816344],
            [5.8323066906566305, -1.5057017229258367],
            [5.808183904649902, -1.4899893988651733],
            [5.78585623667526, -1.4644643983822627],
            [5.74778611038563, -1.4615087065901902],
            [5.746182799042057, -1.473518487411051],
            [5.754552216661341, -1.4859966970728098],
            [5.773833994594029, -1.4935806178415294],
            [5.79116783751959, -1.5132406601612551],
            [5.785729119297728, -1.5330488093216774],
            [5.776500754918951, -1.5414254306648685],
            [5.765595580830256, -1.538636156086275],
            [5.744378664976266, -1.51931095917709],
            [5.707472756267319, -1.5043057307671523],
            [5.694283655487953, -1.4956662194601265],
            [5.687561067735099, -1.4777774752465447],
            [5.693125061277056, -1.4488677468069204],
            [5.685161472960815, -1.431886700062784],
            [5.659766468435679, -1.4116114423122563],
            [5.6415512640257255, -1.3855127665941127],
            [5.617265410351555, -1.3391996274520097],
            [5.611280089028189, -1.317019749705389],
            [5.617230178195883, -1.2978658593288805],
            [5.614641625001827, -1.2877138086584439],
            [5.591608252943118, -1.2885503563056717],
            [5.566901198529218, -1.2556533419688096],
            [5.570264730694435, -1.2297945696705734],
            [5.585071445755925, -1.2080003209565602],
            [5.597660640813726, -1.2002507601016015],
            [5.627488161119565, -1.191843021497356],
            [5.632840258017334, -1.1796153513212277],
            [5.634471103169864, -1.1380369357510185],
            [5.6232443862678005, -1.1087424054401214],
            [5.608418651484181, -1.0862657754839473],
            [5.591413204240719, -1.0708363931448095],
            [5.573161006138278, -1.0442244263996985],
            [5.5654415293510535, -1.0255800011002716],
            [5.551177407437126, -1.0036803109537837],
            [5.5451541332621, -0.9786123371773933],
            [5.547737101012722, -0.9543813605646877],
            [5.565645824288284, -0.9575966363916922],
            [5.578167556899011, -0.9508986939111114],
            [5.5766023563155, -0.9378657388692875],
            [5.552751687198615, -0.9130045932415143],
            [5.542910304420612, -0.8973156193116805],
            [5.544324693680973, -0.8523768976836246],
            [5.532708984729085, -0.8400983545206593],
            [5.486681795629054, -0.8282257821478001],
            [5.474991306237651, -0.8091544829408184],
            [5.457666009724119, -0.7932853048472619],
            [5.432753936185155, -0.7992290463542367],
            [5.417388481635456, -0.786102127266558],
            [5.421530794260942, -0.7586924111501353],
            [5.413380970920176, -0.7454470811345032],
            [5.386331101701604, -0.7301542734631411],
            [5.364365463147425, -0.713121113735408],
            [5.3554251227746175, -0.7017207158403832],
            [5.310733690693037, -0.6919301542568952],
            [5.307882393049528, -0.6717265119523758],
            [5.269728944994267, -0.6479847712246555],
            [5.256131703703946, -0.6576341520939777],
            [5.2428097133731475, -0.6760145774028565],
            [5.227563611434057, -0.6868804196099805],
            [5.210850809475399, -0.6870922003665462],
            [5.187176581592704, -0.6759099491326196],
            [5.167930035301129, -0.6407101287051086],
            [5.177947618438797, -0.6188467845431908],
            [5.187460526329532, -0.618099157643813],
            [5.203748539771812, -0.6031014971985165],
            [5.190687744829551, -0.5868282131279676],
            [5.153951238854548, -0.5985020249226293],
            [5.140569950037069, -0.5930771979498666],
            [5.115096438620853, -0.5646391587138265],
            [5.095469677693872, -0.5478170371047688],
            [5.068534622560188, -0.5471809236635348],
            [5.041864305972568, -0.5256986600416379],
            [5.03693969229097, -0.5041107717421147],
            [5.015103388954788, -0.4928549480676732],
            [5.000307973736835, -0.49745262472298124],
            [4.966553063372418, -0.4760317833989009],
            [4.946447071633164, -0.4587363764216987],
            [4.918973787190335, -0.4149288062208373],
            [4.905886050843102, -0.40272978327938963],
            [4.8806663043777325, -0.39297298717239154],
            [4.854217502565941, -0.3619145179609136],
            [4.842604218805874, -0.3302147919096554],
            [4.835324199091878, -0.28982364051456144],
            [4.833214479240679, -0.25239526739376283],
            [4.8355386899822665, -0.2351619425953797],
            [4.853805090827306, -0.18495456033209384],
            [4.88867156880331, -0.14256725431686132],
            [4.907738053002668, -0.04055880603101711],
            [4.932792155455626, 0.008202653360091185],
            [4.956357615242913, 0.033818694562132975],
            [4.964534795040494, 0.06487034737514785],
            [4.9593644851032055, 0.10117486088577853],
            [4.933821169727993, 0.1465526582994354],
            [4.937811214214495, 0.1674328205027167],
            [4.9537147121427925, 0.1832751167300968],
            [4.965223041071407, 0.21008098686642293],
            [4.997009774857012, 0.2377359900114704],
            [5.005330990549738, 0.2781101462505074],
            [5.001340646360758, 0.2898584724600936],
            [4.95880046762667, 0.3145879845452957],
            [4.9340924508854105, 0.3245043401032164],
            [4.9133129842175824, 0.3432058369048803],
            [4.8916532513135484, 0.3539835238063035],
            [4.845824642000394, 0.3560529328551642],
            [4.787290452295815, 0.38425832809647303],
            [4.768999841239836, 0.39036034293168015],
            [4.734539248569594, 0.39360726920298955],
            [4.718665606624931, 0.38365386599492096],
            [4.70916971565093, 0.34987266981746895],
            [4.694772351807941, 0.325559582953628],
            [4.66823141981752, 0.2959977071192803],
            [4.638280458561846, 0.2881945143338114],
            [4.605030894884782, 0.3061507172355879],
            [4.595867792925572, 0.3210919614484054],
            [4.573323864577809, 0.3435285833859758],
            [4.561756244365112, 0.3780257561088539],
            [4.558351996567697, 0.407879242962137],
            [4.529605297783899, 0.4618348540469672],
            [4.528290898878193, 0.4721422532750935],
            [4.549406353431996, 0.5049546037593039],
            [4.545207174908425, 0.5344848319082999],
            [4.533155210990953, 0.5516618250088183],
            [4.525390324177041, 0.5711195076680139],
            [4.516684857502168, 0.6134071787715476],
            [4.515982564902251, 0.630048840126024],
            [4.5063351429003875, 0.6671855814941439],
            [4.48668630854281, 0.6805132642173681],
            [4.452195173837, 0.7231648790764833],
            [4.433689949251461, 0.7332710024699685],
            [4.414803278770332, 0.752402431898396],
            [4.372287254365065, 0.7773023502506667],
            [4.360683372061157, 0.7902945582900596],
            [4.340189624075161, 0.8006361388570603],
            [4.328439266770775, 0.8155515535798585],
            [4.2928489173064825, 0.8292906620033139],
            [4.257515702028131, 0.8531873020418123],
            [4.240273095189803, 0.8729312825321542],
            [4.235205921775918, 0.898726529284713],
            [4.226376265874543, 0.9065577241707945],
            [4.205429138993838, 0.9417060653818944],
            [4.168464133612021, 0.9469867464639655],
            [4.152114462009739, 0.9654857404649102],
            [4.145907088324053, 0.9938548423657213],
            [4.136711101811217, 1.0053185704197334],
            [4.112785409331229, 1.0142199423463731],
            [4.093291265308714, 1.028340458643759],
            [4.064893520778404, 1.0629879821384307],
            [4.004095926602615, 1.1100231907216398],
            [3.9901098076535493, 1.1267633730166162],
            [3.9938121534190403, 1.1800402118050144],
            [3.980186760131076, 1.2058387669633521],
            [3.9397123627064157, 1.2306793657950725],
            [3.9238463585193624, 1.2704756551526808],
            [3.9263798042098275, 1.2863875228330233],
            [3.942533286904108, 1.3086616588964484],
            [3.9409291544009393, 1.3268753424692183],
            [3.920367253936828, 1.3526834563291577],
            [3.8805433888484377, 1.4285055849962085],
            [3.8835343852312456, 1.4498380113739124],
            [3.878524976196133, 1.4632503834704063],
            [3.864477047860882, 1.5201915444577307],
            [3.8646505839019563, 1.550162061231387],
            [3.8599426927089517, 1.5735655575501455],
            [3.8655486427897503, 1.5911984700054573],
            [3.8622041313268407, 1.6294523933609997],
            [3.8731686591746324, 1.6533907391112854],
            [3.8706089763920963, 1.6721693278150505],
            [3.884515392935164, 1.7123306728346357],
            [3.8906196820983423, 1.737936738088285],
            [3.9026762690423302, 1.7594685229042966],
            [3.921111935953661, 1.7755932379598092]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.1983383357267, "lat": 40.06495987343483 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779784"
      },
      "bbox": [
        3.8599426927089517, -1.553802416434249, 7.02109991456652,
        4.078734046600045
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.940510946379339, 2.607055640309153],
            [15.9548738402986, 2.6281506940661408],
            [15.965531498529723, 2.6525693236089136],
            [15.964982888230944, 2.68170849606279],
            [15.982354069892864, 2.7029054349054804],
            [15.981221787352464, 2.7250139346905033],
            [15.98561641194449, 2.7572925769076826],
            [16.010794285063273, 2.800087211570629],
            [16.047623142825895, 2.8474158654231867],
            [16.063447642148013, 2.860294808458113],
            [16.106725965854537, 2.869940462750889],
            [16.141703820990443, 2.890549535005842],
            [16.165685791676054, 2.9170124390411356],
            [16.190639103134664, 2.9243343626200224],
            [16.19787415078612, 2.932388782829693],
            [16.200028175375625, 2.9554296543965926],
            [16.19135518245112, 2.9695017263207846],
            [16.18808670320575, 3.0011972303810275],
            [16.205710799384793, 3.0192384730490174],
            [16.224236174874903, 3.0292245988919073],
            [16.234833850440694, 3.058988169806526],
            [16.246694796231132, 3.072642119772083],
            [16.261776809074167, 3.0816794295880143],
            [16.28824241889454, 3.120686040568076],
            [16.31006237529066, 3.142214399202687],
            [16.327187594014042, 3.1475162563824464],
            [16.360310691652217, 3.1701716941503677],
            [16.372867263064986, 3.1895368779714106],
            [16.3764151882818, 3.2142596156665597],
            [16.383063749749365, 3.2195590797370808],
            [16.409747899336317, 3.2184433841080873],
            [16.42395229174719, 3.2353290657852116],
            [16.43716665879399, 3.239833325112766],
            [16.446676565775213, 3.2533086002611262],
            [16.445023277199333, 3.267569008660873],
            [16.433418372572813, 3.2792926356544365],
            [16.41459205743799, 3.287621554188455],
            [16.396308091447164, 3.3129953089680972],
            [16.375747593905853, 3.3229217028881015],
            [16.336362264735264, 3.335803719864944],
            [16.307307734842933, 3.375402022434341],
            [16.290014905010135, 3.3870930048941985],
            [16.272918838681587, 3.390054879242284],
            [16.241084183919916, 3.409379471246087],
            [16.232517713930537, 3.4303753434536066],
            [16.21451312403888, 3.4577907758331388],
            [16.187284629923088, 3.467453351034556],
            [16.16793482300402, 3.4558173257511386],
            [16.139617466613572, 3.4645589067597875],
            [16.1228111267398, 3.499086337902318],
            [16.12264328404724, 3.5263635507008346],
            [16.105063559664515, 3.5849448917093696],
            [16.07612101386142, 3.6048808386342834],
            [16.047611647993346, 3.6066966534806],
            [16.03395693436682, 3.5928842992307675],
            [16.021626383561326, 3.5898436450210904],
            [16.005384543445896, 3.5978489002367358],
            [16.000886567285875, 3.624097461422935],
            [15.991614816238192, 3.634364853092213],
            [15.998804045087395, 3.646273465480689],
            [15.985194557294207, 3.666218171640448],
            [15.995236646740123, 3.7002414237845587],
            [15.980265822430253, 3.7005957375609215],
            [15.972895380809458, 3.7094761396073563],
            [15.98019302262197, 3.7507139982726736],
            [15.965146798733384, 3.7697552804090417],
            [15.976357773127786, 3.785229068122172],
            [15.97771102382912, 3.799468631199436],
            [16.00583776282622, 3.801621628939488],
            [16.01127517243043, 3.8162167907707034],
            [16.021003933065828, 3.822867885412944],
            [16.02340578114825, 3.8403996868797545],
            [16.031660677071958, 3.859659162223074],
            [16.018041208532253, 3.873628528621949],
            [16.02107137378742, 3.8827792792052818],
            [16.04111481777538, 3.887533404095811],
            [16.046627600737114, 3.903803289499798],
            [16.042977334962963, 3.9129029258313874],
            [16.021813067946578, 3.930891906020996],
            [16.01537661257118, 3.948213467571859],
            [16.001236960281293, 3.9556372369543342],
            [15.978630151218367, 3.980357364569064],
            [15.971329351679847, 3.996385732454313],
            [15.960414569169167, 4.000874247600585],
            [15.960903957766469, 4.015646663057374],
            [15.973723016765826, 4.031909175737562],
            [15.995771948975083, 4.050254231324365],
            [16.02580293575373, 4.080052252601055],
            [16.030070682689583, 4.108793080940393],
            [16.05663390635122, 4.13413008845464],
            [16.03996794331996, 4.137598571085249],
            [16.04337111037691, 4.15481189425455],
            [16.05510932258494, 4.16362079532562],
            [16.065844479818352, 4.181300682158048],
            [16.07978802484164, 4.193807636258485],
            [16.090665943738983, 4.225150976496303],
            [16.10020197343096, 4.2424035327207354],
            [16.10799396233611, 4.28504826207651],
            [16.100497552740812, 4.29084341087558],
            [16.10324323419156, 4.313316674737368],
            [16.10868894489215, 4.31683008246501],
            [16.11060653271121, 4.344155069970309],
            [16.11890392076422, 4.363086916276098],
            [16.136476273044785, 4.384363222135303],
            [16.134157146379202, 4.396037425366859],
            [16.14848862832135, 4.401975462286655],
            [16.157117249063553, 4.4256172351331164],
            [16.180304367218362, 4.432177802812394],
            [16.196942500218572, 4.446304334048551],
            [16.269433634895496, 4.421945685687195],
            [16.393944835200873, 4.378751175940339],
            [16.488600856266185, 4.342622165761066],
            [16.572917569497598, 4.315532594425661],
            [16.696987132502056, 4.277726629370518],
            [16.855250125765608, 4.227187024259033],
            [16.863595181696823, 4.21321862649404],
            [16.862921523675787, 4.157341884315765],
            [16.860685568355123, 4.1162188869556156],
            [16.852611213214338, 4.075477485943749],
            [16.850663097860256, 4.049998935219695],
            [16.829565057711246, 3.9733535029158413],
            [16.83157027190263, 3.9348958022093887],
            [16.814767893828762, 3.900905131815458],
            [16.80652827338998, 3.9042717653963916],
            [16.79718683492239, 3.8718995204611626],
            [16.79981020139914, 3.8590675694498837],
            [16.76082391671389, 3.8394980006772825],
            [16.762621052873232, 3.854442906854505],
            [16.77770665223143, 3.9036980122798197],
            [16.77032296089005, 3.9164783206064664],
            [16.760027608887256, 3.8874471898619336],
            [16.757560030137753, 3.870023894383175],
            [16.730011500653635, 3.835843740205596],
            [16.719066620128547, 3.8120097579851957],
            [16.726259941572092, 3.7789421097201887],
            [16.727120891670445, 3.7503853797823545],
            [16.715015541457056, 3.744769268529803],
            [16.701419734815282, 3.7274227524933927],
            [16.711217021884764, 3.703561861463536],
            [16.70193254545025, 3.665340270389357],
            [16.715284105968653, 3.64394478967136],
            [16.770653653432436, 3.6323169944655214],
            [16.77906903387797, 3.6510303403344304],
            [16.795590622005967, 3.643945801245008],
            [16.81036778317717, 3.6565277158765217],
            [16.83081486012199, 3.6489204715911665],
            [16.848982661969824, 3.6479432880865623],
            [16.883011279529406, 3.6357558082024792],
            [16.915301511128362, 3.6352736912748083],
            [16.921370348319535, 3.6453528464187737],
            [16.938588547593962, 3.635513143312329],
            [16.95386467097822, 3.5855513215958292],
            [16.962448562589977, 3.530775001985679],
            [16.965073935763844, 3.467547142942558],
            [16.964238270088586, 3.348344279084004],
            [16.97256307402055, 3.2015056701800853],
            [16.984041165032252, 3.0839803033674236],
            [16.993290108789502, 3.0217214680014735],
            [16.997976317049453, 2.977579825749817],
            [16.989413140042966, 2.9533238189451265],
            [16.98156319928192, 2.9043315209615734],
            [16.95968673568312, 2.8324376417936024],
            [16.939053849811334, 2.755653680407367],
            [16.913328426011947, 2.701598607762302],
            [16.888431036178726, 2.6948638874821857],
            [16.902338850418786, 2.6723905512529327],
            [16.903893507122937, 2.6624955485542405],
            [16.893382146604115, 2.636557585823263],
            [16.897148415664788, 2.621029925375947],
            [16.8800732701802, 2.582816551341477],
            [16.85794353572333, 2.5474632830979793],
            [16.848426945078156, 2.5272523870305363],
            [16.823716176006684, 2.510803676857153],
            [16.78842524025753, 2.4742683331371675],
            [16.77633683815151, 2.457020158048935],
            [16.764644847965045, 2.450784731965306],
            [16.766801941296478, 2.4365151920365222],
            [16.750814143600525, 2.4170725343059756],
            [16.728261818451937, 2.380610160692983],
            [16.70288790837248, 2.3121339203442415],
            [16.69250335648421, 2.276742441454365],
            [16.685532013350883, 2.2407476721289776],
            [16.694343586420302, 2.2306539400012575],
            [16.677014244320425, 2.1977480721046163],
            [16.6610913699814, 2.1502618024331404],
            [16.642066064818955, 2.13941056292621],
            [16.65619470059427, 2.1164699935749938],
            [16.65284773711013, 2.1086610681172466],
            [16.6188215090916, 2.059981288927605],
            [16.611668276893433, 2.0437487568320045],
            [16.59658079732762, 2.0424099678833953],
            [16.581534171962748, 2.0282403447950537],
            [16.562373145307745, 2.020327772570278],
            [16.53595540303343, 2.019444981035391],
            [16.530865455544024, 2.0254960185543798],
            [16.5298633506234, 2.088247530718829],
            [16.53513303547236, 2.124517721989825],
            [16.549528521731215, 2.1818030138323303],
            [16.552140007398236, 2.2090201871857014],
            [16.546020841536404, 2.2548441711843545],
            [16.5332976334502, 2.266953955782583],
            [16.48172858665561, 2.2746833939543465],
            [16.451646134023242, 2.266785649754927],
            [16.43417205489345, 2.2656674009404845],
            [16.42969350907445, 2.2849011442146447],
            [16.41269340880129, 2.2831871715618846],
            [16.36083649405807, 2.2684330393692607],
            [16.35873314424124, 2.2454276241272897],
            [16.34857816922666, 2.239379464871412],
            [16.326284952839263, 2.2515721267292594],
            [16.327117309817204, 2.263155117174491],
            [16.315297536054075, 2.2848247642711215],
            [16.2993174849564, 2.2899883670763916],
            [16.284437761065156, 2.3035701417257495],
            [16.25513781728533, 2.3089269807229407],
            [16.241868940805674, 2.3331016394898736],
            [16.217315638222335, 2.332959617958649],
            [16.216380824784025, 2.3184282158677334],
            [16.192109908995416, 2.3326815184649266],
            [16.170667615647275, 2.363835221234287],
            [16.14365135257548, 2.363484480192745],
            [16.125475410724235, 2.3678062510500295],
            [16.119317081601412, 2.380849388105267],
            [16.09986519911735, 2.3919179325043096],
            [16.09107984984198, 2.3901596611723805],
            [16.077046191647707, 2.402050521065813],
            [16.052056928556325, 2.4344015677491364],
            [16.024727080997987, 2.4386294281330914],
            [16.01543235783916, 2.447236774015843],
            [15.994168107296034, 2.444061579017018],
            [15.987207265481373, 2.4527489380587535],
            [15.981725698597968, 2.4785172905504127],
            [15.992484514610718, 2.4824806549653746],
            [15.984588425337982, 2.5191036068824006],
            [15.978687976360558, 2.523413240649042],
            [15.989922940848595, 2.554178106955057],
            [15.987591742271682, 2.5630124473238918],
            [15.94800009285296, 2.5845114583017774],
            [15.940510946379339, 2.607055640309153]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.6620225189301, "lat": 40.184136670529554 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779795"
      },
      "bbox": [
        15.940510946379339, 2.019444981035391, 16.997976317049453,
        4.446304334048551
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.275939734919326, 3.6114500886515115],
              [10.282770132992512, 3.625892174075021],
              [10.313754979039043, 3.6251583083673253],
              [10.31393726859386, 3.600670422752161],
              [10.284075594151561, 3.6047431549601416],
              [10.275939734919326, 3.6114500886515115]
            ]
          ],
          [
            [
              [10.197810812760936, 3.68328702384558],
              [10.213370217013585, 3.6897526985260125],
              [10.214131668860375, 3.6726941998683507],
              [10.197810812760936, 3.68328702384558]
            ]
          ],
          [
            [
              [10.189577069062535, 3.6430185862342817],
              [10.195263422589779, 3.654617948325177],
              [10.211697229537872, 3.6545458718341934],
              [10.203839597328065, 3.6326528021936557],
              [10.189577069062535, 3.6430185862342817]
            ]
          ],
          [
            [
              [8.740484202174706, 3.5070616795644556],
              [8.781456368911766, 3.514066847524448],
              [8.924184487773445, 3.535564566369998],
              [9.066918373390477, 3.557026735934837],
              [9.23240667968276, 3.583948935771482],
              [9.33289117978944, 3.600906911906527],
              [9.433378969358321, 3.617847116977203],
              [9.581046752283337, 3.6429903929177803],
              [9.72872167487993, 3.6680951964867674],
              [9.721066884431542, 3.6566631758617736],
              [9.71681360935496, 3.631645280229672],
              [9.733120287116524, 3.6334062125933233],
              [9.758128069144583, 3.62798007527371],
              [9.779831431489736, 3.633347804636754],
              [9.790595444964154, 3.6284112158207793],
              [9.810973338216886, 3.6324890581881566],
              [9.82014406055407, 3.6525214211294044],
              [9.84464295862253, 3.6377920071288568],
              [9.84576951569606, 3.6266743400993398],
              [9.862771107911582, 3.628018653214716],
              [9.923406950595703, 3.595129573767631],
              [9.966305196246527, 3.584178214001968],
              [10.003454795729018, 3.5833031779181814],
              [10.025962784596667, 3.5738542586696567],
              [10.058057784870025, 3.5393155105449376],
              [10.089434516997065, 3.5197406918441265],
              [10.11402373634676, 3.5081098325950593],
              [10.147217627329994, 3.5029028893743557],
              [10.174076938880287, 3.5142771884577133],
              [10.187060365198414, 3.5281580751571466],
              [10.193599390307016, 3.542691826825392],
              [10.191687955268263, 3.579183304967493],
              [10.205218996557148, 3.584795372889233],
              [10.216665368524408, 3.5705651568675285],
              [10.247213211111514, 3.5436174880102755],
              [10.27239409692171, 3.5528023471113808],
              [10.295138203071279, 3.551900222020619],
              [10.30287935734386, 3.538420961460862],
              [10.294814572823897, 3.521143687986216],
              [10.279202315116214, 3.5192707998176216],
              [10.267452942662912, 3.5080407424367226],
              [10.236867121515663, 3.507531728199425],
              [10.227952689197659, 3.491030086703499],
              [10.209384701346215, 3.499162835197024],
              [10.18274490486013, 3.481956697029002],
              [10.126489231559358, 3.4739418640200053],
              [10.118087508638682, 3.4511445304521042],
              [10.099001951986155, 3.4438893149896534],
              [10.092469191143152, 3.4497541274225583],
              [10.07120162318893, 3.4421270335946628],
              [10.084455215403494, 3.426340661022882],
              [10.101273390140484, 3.4183516823443414],
              [10.1185933733331, 3.437365558745461],
              [10.136859518837214, 3.4113176004097654],
              [10.161282798946148, 3.4075150823350064],
              [10.177401429359097, 3.423241060582806],
              [10.20381717341996, 3.435637697807313],
              [10.221409684053603, 3.447769826426916],
              [10.237104537328575, 3.470240517805353],
              [10.274594786448029, 3.4510492685043492],
              [10.300263503970273, 3.458958304234536],
              [10.319835866956224, 3.4748898924034615],
              [10.32790763024996, 3.4673532626899672],
              [10.341663846204316, 3.468286122939676],
              [10.332855386823677, 3.491337159478539],
              [10.400088481049048, 3.442062613704463],
              [10.430238058011257, 3.4285872511279223],
              [10.47066995679308, 3.4149895000269845],
              [10.49375039684781, 3.4165755120329537],
              [10.528294458926052, 3.437301367728383],
              [10.573911558815354, 3.4744932574514418],
              [10.603267056075552, 3.482136950453741],
              [10.62665242298966, 3.4835837433314873],
              [10.65298524292881, 3.4933737418509097],
              [10.704111300621696, 3.5386564599016928],
              [10.744478933043972, 3.561856019043055],
              [10.819278481193953, 3.6003166766322794],
              [10.832073432462364, 3.6011971479144234],
              [10.872651166132862, 3.584693037772637],
              [10.933501977254208, 3.583941795551562],
              [10.969365461660818, 3.602143320809987],
              [10.99154876214414, 3.605867151800481],
              [11.020221593719898, 3.6014900674315564],
              [11.044229921194955, 3.619360854650479],
              [11.0566012233084, 3.6385480727461803],
              [11.097895238613965, 3.6711608365344492],
              [11.115606738389642, 3.6907159316108036],
              [11.158867286956895, 3.751481885019911],
              [11.187882943994458, 3.7751999041136894],
              [11.213924840708009, 3.820210439346717],
              [11.248046603521981, 3.860220653427053],
              [11.31467455473596, 3.923819717549265],
              [11.332241679562381, 3.925010762753498],
              [11.359510847082818, 3.939575448510621],
              [11.4220923502607, 3.9929536595354707],
              [11.448800729195273, 4.009191059216292],
              [11.506928198225186, 4.048830370378145],
              [11.579466828980795, 4.076384561208545],
              [11.61744567376786, 4.10368849629336],
              [11.630397622055725, 4.10979422948721],
              [11.645803631940224, 4.128815311472681],
              [11.66609444725603, 4.130651855499303],
              [11.682958672034005, 4.14190240039733],
              [11.708962786962108, 4.1514710490239235],
              [11.747765423033599, 4.176771227062139],
              [11.76430166078154, 4.182580134227758],
              [11.797876809744766, 4.201976491012563],
              [11.817486010867025, 4.217357914070474],
              [11.83985974464064, 4.229066116558844],
              [11.890111715684625, 3.924282420893916],
              [11.928667984162825, 3.6918470987025604],
              [11.959389051425998, 3.5066560439783636],
              [12.012689630747683, 3.1810464546623725],
              [12.058926407137232, 2.9005546949258045],
              [12.030414128881745, 2.880444998862051],
              [12.020061964044274, 2.86909844151106],
              [12.001905242392713, 2.877400405592308],
              [11.981674920566059, 2.8686629139505566],
              [11.959980321114157, 2.836208119983583],
              [11.959651981628758, 2.817846787738127],
              [11.995093575755044, 2.784955945258948],
              [12.007645480301859, 2.752552430540526],
              [12.02480842954946, 2.7354612842953547],
              [12.02941692648853, 2.71150468553041],
              [12.023163944505196, 2.689451064058613],
              [12.028230209940004, 2.6556624009370817],
              [12.01738646275744, 2.6457251074553376],
              [12.036938502303638, 2.6220587567742575],
              [12.036623670439534, 2.599643035510007],
              [12.051124313675498, 2.571373461639385],
              [12.044115058925815, 2.5439821735536983],
              [12.043352103784562, 2.5130149587918402],
              [12.028558883880159, 2.499880561604579],
              [12.019389112001294, 2.476458588339056],
              [12.019374574450193, 2.4456864267338037],
              [12.008822141814768, 2.4255221209542603],
              [11.999352437951213, 2.3966293068522515],
              [11.99795394667312, 2.3795377080063376],
              [12.004887737669888, 2.3526359362092655],
              [12.004094979435783, 2.340965281249892],
              [11.986699302907095, 2.313735383421382],
              [11.996740664952547, 2.2882926358253477],
              [11.995420009975922, 2.243612461288372],
              [12.00247996826545, 2.2091564577570435],
              [11.990547125169124, 2.1954255680289414],
              [11.98809627974623, 2.1821181604824003],
              [11.999369741758679, 2.1532437602329275],
              [11.991227958761367, 2.1448667536956085],
              [11.979080539919698, 2.1505877574290206],
              [11.963409156524646, 2.149694981534828],
              [11.961690248792891, 2.133547539867835],
              [11.976249287429276, 2.1150144452225557],
              [11.979954091688317, 2.096164735961951],
              [11.964181040001929, 2.082672454276517],
              [11.958095348116368, 2.0700713163104627],
              [11.966494166633465, 2.0408278987060045],
              [11.965670887067564, 2.0272874675860644],
              [11.94162917389113, 1.9995306907655261],
              [11.943418959762774, 1.9773975432297746],
              [11.96036879433179, 1.9643464901318748],
              [11.974247146466451, 1.9478430449182624],
              [11.975055808898182, 1.9316478719661447],
              [11.955687358969634, 1.9184489575187886],
              [11.953753928797777, 1.9108425824161042],
              [11.958540198753314, 1.8770069558473568],
              [11.953314569849178, 1.8435645286209443],
              [11.914368248689508, 1.8313084306924403],
              [11.890298743810128, 1.8022476124143734],
              [11.875758397541507, 1.7806495652801617],
              [11.855978695300669, 1.758155772613651],
              [11.826487467035745, 1.7163738198334173],
              [11.80820287085418, 1.684045149186601],
              [11.801223236858169, 1.6615928036706695],
              [11.789447728198505, 1.6380788873478949],
              [11.763017799874367, 1.6278909994053452],
              [11.752768688183858, 1.6176550056410224],
              [11.73130309003972, 1.5686605363304205],
              [11.716834179873091, 1.570699296782348],
              [11.695672648622738, 1.5629359727419194],
              [11.677193065908158, 1.5482704627588586],
              [11.643758480347957, 1.513850219634529],
              [11.622895027940668, 1.5064528209547483],
              [11.605672194795089, 1.5179343537067187],
              [11.592469354272298, 1.5491166343450882],
              [11.573195127131337, 1.5637860399878296],
              [11.551791856056987, 1.5644652518338016],
              [11.540297603250647, 1.553398751240712],
              [11.521730202756359, 1.5230487894417737],
              [11.495208479631616, 1.498183553681454],
              [11.485853935756728, 1.48235535288853],
              [11.487091755411287, 1.4099550902533549],
              [11.456888482663658, 1.4138849370112843],
              [11.447477452776935, 1.4099998222351997],
              [11.420508040665798, 1.4096841074667812],
              [11.404229772288408, 1.4035363016470772],
              [11.393076982313726, 1.3847766535872397],
              [11.401303983285132, 1.3563306782490587],
              [11.3779772816393, 1.34112021278755],
              [11.372351996292316, 1.319608753737768],
              [11.35969363588185, 1.2983098935679334],
              [11.372879910453596, 1.2708382950686357],
              [11.379527854786117, 1.2395480330016067],
              [11.375833222615105, 1.2115303607598293],
              [11.359928044047276, 1.197391049377695],
              [11.334528151310291, 1.1992826540741237],
              [11.335303023293317, 1.1744925355693456],
              [11.343403349287499, 1.1635636491733814],
              [11.369840366078956, 1.1455990189483016],
              [11.378026471380789, 1.1357063347383918],
              [11.372234511771747, 1.0834377966915816],
              [11.375861005116914, 1.0747524586956225],
              [11.396528055274777, 1.0550556210455513],
              [11.39474752458962, 1.0469082233406348],
              [11.375148619177335, 1.0443254589460396],
              [11.350367845090984, 1.0609878421819947],
              [11.337574823882907, 1.0565431517552355],
              [11.329934519737227, 1.0401342197379526],
              [11.3308542988259, 1.012364179402212],
              [11.324706452896102, 0.9999919954482144],
              [11.303973383716023, 0.9806463074483944],
              [11.287150970189387, 0.9832515850050916],
              [11.272617259870877, 0.993645743228125],
              [11.271396683463601, 1.0033736697125986],
              [11.288168452324651, 1.0304704015461994],
              [11.285848727867982, 1.042643909976062],
              [11.253573727712014, 1.0888484252657915],
              [11.238423974822334, 1.0951371756138844],
              [11.219119607447325, 1.0888440278978586],
              [11.201372447024067, 1.116619523151027],
              [11.179342920815879, 1.1203949313970931],
              [11.168598695503452, 1.1131787832503965],
              [11.162437229104391, 1.0821779278285277],
              [11.136587907393741, 1.059587032379312],
              [11.125822749572528, 1.0269826417634307],
              [11.12575175376922, 1.013707169844561],
              [11.106800978433384, 0.9757187805865689],
              [11.107340753847298, 0.9609007054015976],
              [11.114658654410322, 0.9431400231965652],
              [11.113952482821626, 0.9179959660006423],
              [11.103525721739372, 0.9002952059193933],
              [11.082314552645961, 0.8875003040351971],
              [11.065226720224013, 0.8651503097495437],
              [11.069714939021402, 0.8379205328562442],
              [11.08481566979815, 0.8292860629990663],
              [11.104518588098776, 0.782228383985843],
              [11.102247109592373, 0.7529174634676792],
              [11.124592576524469, 0.7006786448187136],
              [11.123859794342655, 0.6779170992290859],
              [11.11634022056197, 0.667836260312958],
              [11.091284089484642, 0.6605006151245827],
              [11.072019886691745, 0.6649345864205356],
              [11.051041389951367, 0.6569831383451863],
              [11.040152395662862, 0.6404021959519233],
              [11.042657634425362, 0.5994438721324052],
              [11.03935700449634, 0.5833541778189164],
              [11.042217381979386, 0.5563486186074309],
              [11.033859575080697, 0.5071419502538126],
              [11.022289823444762, 0.49697794293180775],
              [10.9855417684244, 0.48494346584696296],
              [10.97320181096008, 0.48825802153002956],
              [10.951888792875488, 0.47574022708812685],
              [10.913519198852443, 0.457996075222827],
              [10.882329573316364, 0.44038042961871543],
              [10.850041925446517, 0.4357359893885197],
              [10.830872703699372, 0.4500269229077461],
              [10.817330006183525, 0.4868803589267144],
              [10.807790592691523, 0.5005069824304395],
              [10.771441512043756, 0.5180904090088978],
              [10.740669766452298, 0.5536233004784803],
              [10.71086529635302, 0.5715343127807087],
              [10.652361935198837, 0.5690257309684503],
              [10.635657299293554, 0.5763984257743373],
              [10.61180451016016, 0.5959734642501029],
              [10.60163441003286, 0.6207041374675525],
              [10.597737666128738, 0.6459165042526013],
              [10.58914751741875, 0.668370547927782],
              [10.575290409083381, 0.6877492284310125],
              [10.575902017039551, 0.7265700310372571],
              [10.56531827068792, 0.7488489699017445],
              [10.553363887210926, 0.7523877656471959],
              [10.517752581814683, 0.7339033097398375],
              [10.492402208288228, 0.7127672291362238],
              [10.467025543169434, 0.7134327495559171],
              [10.451659302727784, 0.7049499621387663],
              [10.440116576365513, 0.6748579262737064],
              [10.418299642556802, 0.6568489448349769],
              [10.404629057617262, 0.6511352425206987],
              [10.391931385121179, 0.6309421712726748],
              [10.386098515938487, 0.6021437430629791],
              [10.373489538655848, 0.5872908420183272],
              [10.335479038589948, 0.5799954565752987],
              [10.301723345563463, 0.5874884560789005],
              [10.28703780996791, 0.576389895312554],
              [10.268818008089188, 0.5504766628534249],
              [10.249206792914288, 0.5607334931556146],
              [10.242623612350156, 0.581623904983154],
              [10.227092723597739, 0.5948825956689675],
              [10.204934909695046, 0.605020373201875],
              [10.12495745607202, 0.6116185702684912],
              [10.108901500368555, 0.6243906444265392],
              [10.080769801764804, 0.6338557316720889],
              [10.059612470641563, 0.6267286817630661],
              [10.002669301775276, 0.5994942162997634],
              [9.99672464453357, 0.5851077408326761],
              [9.992499356245702, 0.5497683516506012],
              [9.975331867010606, 0.5429649945785265],
              [9.9349673613765, 0.5573855986519604],
              [9.902307580392108, 0.558646969420045],
              [9.89407261530669, 0.5637378052461514],
              [9.880430759012787, 0.6001433228489649],
              [9.87424112267247, 0.6054876854520185],
              [9.849322909451791, 0.610314833518406],
              [9.83336899280739, 0.6208202264175025],
              [9.82644413373148, 0.6406741447065404],
              [9.814755693126378, 0.6539356789679921],
              [9.792116250359536, 0.6599963512426038],
              [9.760807652711259, 0.6620600035958462],
              [9.746253188923983, 0.672471658004446],
              [9.719130396095734, 0.6725680037143897],
              [9.670929932601883, 0.6496309941365347],
              [9.650254516793742, 0.6469208691702862],
              [9.620539169104752, 0.6521045542328197],
              [9.582510864552221, 0.6632688071044317],
              [9.537509737300892, 0.6686326625725476],
              [9.521678779070331, 0.6878642282579235],
              [9.510094891778095, 0.7542620803313452],
              [9.489108841557764, 0.7821560606707632],
              [9.461242738937509, 0.8118453044197618],
              [9.442325995731546, 0.861044372501606],
              [9.423044358612387, 0.8800316428767818],
              [9.395442462935572, 0.8907672479289704],
              [9.359408076358424, 0.8907150975600018],
              [9.340378443290772, 0.9011997997796625],
              [9.333675752150405, 0.9369916397386289],
              [9.321740046022406, 0.9560759889327097],
              [9.30158504765758, 0.9607342820598131],
              [9.275067434687458, 0.9292371821652556],
              [9.263878592503707, 0.9263536041201664],
              [9.243010365260325, 0.9311464165498884],
              [9.228851346928382, 0.9118429422862444],
              [9.207264388869515, 0.9011598906691596],
              [9.18345981552524, 0.900984959084298],
              [9.168002487569066, 0.9142785673423077],
              [9.136429994573914, 0.9232051778528851],
              [9.110515947085473, 0.9535587139049777],
              [9.099333756164285, 0.9597479849210537],
              [9.081984037185729, 0.9599202206820416],
              [9.062848621776903, 0.9285773960441345],
              [9.036739570403844, 0.91269942906734],
              [9.013619605957546, 1.112922169767891],
              [8.995918472456845, 1.2868663097200062],
              [8.978907095781993, 1.4373798334522856],
              [8.957352524919775, 1.6230171017983566],
              [8.938070236313457, 1.8052500214340235],
              [8.917982079935063, 2.008657519670674],
              [8.906203695492117, 2.1231953196764266],
              [8.893878219003986, 2.2241458037630673],
              [8.884327920699254, 2.313221459900367],
              [8.849317783453042, 2.6123611019309765],
              [8.8263437104253, 2.7998141231543405],
              [8.794818727497699, 3.0640879814971305],
              [8.772622713716636, 3.248232722806682],
              [8.740484202174706, 3.5070616795644556]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.79009102534324, "lat": 40.29128392881899 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01085497"
      },
      "bbox": [
        8.740484202174706, 0.4357359893885197, 12.058926407137232,
        4.229066116558844
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.069750699194865, -1.5138966209814764],
            [-5.057859590965613, -1.516372094707364],
            [-4.920104333883186, -1.525171146670728],
            [-4.830228801763204, -1.536198028501368],
            [-4.559765402927883, -1.5553742726339366],
            [-4.312581802134678, -1.5730893088079339],
            [-3.9890795311144016, -1.5910177301599422],
            [-3.7131374503481855, -1.6051390100261942],
            [-3.499352188212645, -1.61520190363783],
            [-3.279604769238648, -1.6255829617776363],
            [-3.1350172531619678, -1.6310717254547515],
            [-2.7905459502801326, -1.6451805192420639],
            [-2.6006624590703464, -1.6537170480155257],
            [-2.4215293404775027, -1.662883938948823],
            [-2.2694189719597917, -1.668703914386186],
            [-1.9319725039910007, -1.6800915045461733],
            [-1.6830842192240065, -1.688151383151602],
            [-1.5489559826226507, -1.69192542069109],
            [-1.3981143098194189, -1.6968580217058502],
            [-1.206674519568244, -1.7011810711730118],
            [-1.0204018260151917, -1.704614952077285],
            [-0.806948958437267, -1.7084439614218443],
            [-0.529517860381884, -1.7123082823038829],
            [-0.3510164455138082, -1.7145163170465478],
            [-0.11887798166524768, -1.716312595063542],
            [0.06802344230198813, -1.718177170455022],
            [0.15188160265296427, -1.7179882891438734],
            [0.4630993689258249, -1.7189991781328489],
            [0.7036748663743151, -1.718258184392711],
            [0.9322053485857114, -1.717155686347217],
            [1.2584202422176411, -1.7141255556729866],
            [1.4625749957300929, -1.7125632419593388],
            [1.556862308451191, -1.711009596695432],
            [1.5587580774469383, -1.8639748924909074],
            [1.5626519081783166, -2.100772444564189],
            [1.5642308322079228, -2.2149504691715425],
            [1.592480239428368, -2.4157268496953335],
            [1.6147253231462617, -2.564516395762297],
            [1.6489439673719268, -2.7836624342420024],
            [1.6695909890927736, -2.921786401771558],
            [1.7022818291296113, -3.1371845417112523],
            [1.7146743241780973, -3.2235736688541072],
            [1.7317678512252646, -3.3283051972032056],
            [1.7281969888361746, -3.524934730058889],
            [1.7285460132791441, -3.5351141580825134],
            [1.7249202919865427, -3.828422019604886],
            [1.7224836199564721, -4.0909699035473315],
            [1.7202754458358804, -4.3754243447936965],
            [1.7187188081083935, -4.625748148014833],
            [1.7167918155194735, -4.878486670733559],
            [1.7153364813237575, -5.092739001057705],
            [1.7108885221497157, -5.105603262926602],
            [1.7001193286591927, -5.110220203054148],
            [1.6613166949086051, -5.102984427726394],
            [1.6471471406805571, -5.094457811019324],
            [1.6659775990761638, -5.085118273710786],
            [1.6622844050222199, -5.070678405243911],
            [1.6451176851460112, -5.079415656601041],
            [1.6366800151440961, -5.052859370594541],
            [1.6181545233382846, -5.0689459263884995],
            [1.605802800347581, -5.050881577056612],
            [1.5970766604950712, -5.051177101660529],
            [1.5892147670086552, -5.067840277180517],
            [1.5744912936705313, -5.07247579482931],
            [1.563342771045462, -5.0684220819219385],
            [1.5799249280404513, -5.048460842666089],
            [1.5609010509960415, -5.0394133498705935],
            [1.5502723949619812, -5.0485450689557885],
            [1.5079920314785542, -5.041819901187545],
            [1.4933615208501956, -5.023296518056518],
            [1.4973271619708317, -5.008759494231186],
            [1.4767443520008572, -5.006543231426116],
            [1.464152246359726, -4.998546689480449],
            [1.4411414679750678, -4.994922898371617],
            [1.4442216638459335, -4.98312216365109],
            [1.428707501478405, -4.976145383635701],
            [1.4290301522736246, -4.993782747151212],
            [1.4137043551253874, -4.994887314941876],
            [1.3926452377744871, -4.9855257385801615],
            [1.381614841562336, -4.965732337115021],
            [1.3733896375946093, -4.966005441529131],
            [1.353129069328918, -4.943394638388107],
            [1.3502451300299592, -4.926285511407218],
            [1.338090953827641, -4.929431568846315],
            [1.3268147030864745, -4.918720174451009],
            [1.3346600593317166, -4.90576090902524],
            [1.3176139087087613, -4.898197827981977],
            [1.3136475105768828, -4.874255134086926],
            [1.2941407805427547, -4.882956829464868],
            [1.2496096683706537, -4.873266001244592],
            [1.2397374433538784, -4.848284821453574],
            [1.2380605117719974, -4.833920438447792],
            [1.222629931893599, -4.832908438151167],
            [1.2213792116904691, -4.853776448023172],
            [1.206196661908182, -4.845263885947642],
            [1.2140459838948068, -4.821774888059463],
            [1.1910596613772375, -4.8326166963319075],
            [1.1789970981143647, -4.820270592334982],
            [1.1874686540105586, -4.804852300494729],
            [1.1568512539669271, -4.798884589911785],
            [1.1461845526899248, -4.789961940644842],
            [1.122906079995465, -4.7826636673416205],
            [1.1106643393070303, -4.77456337161004],
            [1.0971009089249049, -4.777026472218981],
            [1.0953371035310158, -4.7871443628238355],
            [1.0811896379684023, -4.798540986630514],
            [1.0828983989282537, -4.816907304303858],
            [1.0794627341203316, -4.842991966321937],
            [1.068580737317505, -4.8419280299458585],
            [1.058105831728225, -4.859547395079921],
            [1.0358594871690048, -4.862825336963232],
            [1.0159467335918484, -4.8521885204013175],
            [1.0118930828554848, -4.860962357126639],
            [0.9891653551788738, -4.871406646727401],
            [0.9709202250105494, -4.86967545591057],
            [0.9565930141381052, -4.874019663110452],
            [0.9357365137477759, -4.8678658758642985],
            [0.924539255396077, -4.871964566046797],
            [0.8983965929103106, -4.858152453999689],
            [0.8711519194210795, -4.861418265485555],
            [0.8668369795041685, -4.8407131180031575],
            [0.8483460619012149, -4.857585125074952],
            [0.8337516734731167, -4.845779735406879],
            [0.8356893394411742, -4.830168322299354],
            [0.8306585635074698, -4.810577320990991],
            [0.8088743500200694, -4.804881227206416],
            [0.7958575094441263, -4.796689711449365],
            [0.7900612151391767, -4.809642081104669],
            [0.7796463579544116, -4.811467665892536],
            [0.7711477721309756, -4.831115933387356],
            [0.7601851944208948, -4.834055278378744],
            [0.7437053870181874, -4.828989860411441],
            [0.7234306491181626, -4.8489923216129185],
            [0.7022657335872055, -4.854311472508205],
            [0.6837569824862416, -4.843444661280659],
            [0.6644809209527432, -4.84676279594522],
            [0.6594249991820489, -4.865103347671422],
            [0.6684554063641125, -4.878397521221247],
            [0.6529051197574625, -4.894326717558448],
            [0.6279022179030923, -4.878380226669464],
            [0.6107460670131333, -4.883010375127184],
            [0.6053602718216743, -4.903675871886653],
            [0.5913396740046688, -4.900672709939637],
            [0.5248937542208028, -4.854649604899328],
            [0.5121523370277506, -4.878128164574003],
            [0.465099479904036, -4.888752668935879],
            [0.44758067789280936, -4.8992730130994975],
            [0.42347428805950116, -4.903377529873013],
            [0.3812195618129349, -4.891798865011003],
            [0.381807080696022, -4.909365279387997],
            [0.36236615205904904, -4.899813572999392],
            [0.3416519885441344, -4.901957162691584],
            [0.3410273424143911, -4.920626549183979],
            [0.3278160883647426, -4.922009941475843],
            [0.32945755735983995, -4.951145479057839],
            [0.31677935774000837, -4.979473573686009],
            [0.2987351511527699, -4.987868077882497],
            [0.27468604321356116, -4.991924210446128],
            [0.24620357538575574, -4.972336872871766],
            [0.2258630180294741, -4.96851083273197],
            [0.21901633085666763, -4.973940955542951],
            [0.20995423360490648, -5.004803054268956],
            [0.20774774234550908, -5.029395114946854],
            [0.19849595939563536, -5.044804907889479],
            [0.1845048461743432, -5.051149674129994],
            [0.1645373800872063, -5.047976189678756],
            [0.15852894766948517, -5.02287853693035],
            [0.13064617665192266, -4.993184715980862],
            [0.11498283131106776, -4.963260680188716],
            [0.09404541428038503, -4.958157416027976],
            [0.08485091384197813, -4.963933290818713],
            [0.050910320248223076, -4.96642100487278],
            [0.03808392464540299, -4.951086541946293],
            [0.0376136608669234, -4.935655631833757],
            [0.029405178318786102, -4.917823125625833],
            [-0.00877425154723377, -4.919402660222952],
            [-0.02037199416922077, -4.910388342348806],
            [-0.05004177197416214, -4.896676107055918],
            [-0.05476243139795073, -4.885680192887098],
            [-0.04064144623520854, -4.869100212911209],
            [-0.028551726200846856, -4.863068654812365],
            [-0.018586279194806543, -4.849230302178088],
            [-0.024796667983944063, -4.842498175929478],
            [-0.05392582028556337, -4.843455108528097],
            [-0.07980781835422535, -4.821004719538736],
            [-0.09100238989240324, -4.825331711840507],
            [-0.0972946595289443, -4.841423767462305],
            [-0.09849586588392986, -4.863829199985979],
            [-0.10567520977117725, -4.887785217433719],
            [-0.12371414310567114, -4.9060470265096106],
            [-0.16431330404762728, -4.912987135539189],
            [-0.17071224571928517, -4.909853414639236],
            [-0.17887982643075312, -4.879210912879708],
            [-0.19089480840903741, -4.868123139095374],
            [-0.22206272301620933, -4.861885629805246],
            [-0.23003387707597037, -4.883840311208085],
            [-0.25051299970950847, -4.883400994008804],
            [-0.2640346596246908, -4.86835039578225],
            [-0.2742469053901539, -4.839750423802049],
            [-0.27695101185026816, -4.802263492516804],
            [-0.28160677147509927, -4.788674217155201],
            [-0.2953681541721596, -4.776132268693774],
            [-0.33712557855189995, -4.799597666319569],
            [-0.3558001656633549, -4.7878516097816775],
            [-0.35567714686091945, -4.803181393328526],
            [-0.3468924490401635, -4.844520971178073],
            [-0.35802253690489994, -4.864414605236644],
            [-0.3783568738511068, -4.888931493071442],
            [-0.3987850240193981, -4.895554862758691],
            [-0.406611106251252, -4.879226259158918],
            [-0.41664114409782166, -4.874372534977707],
            [-0.4325275672664839, -4.881236863982544],
            [-0.4295468558334709, -4.894312093753429],
            [-0.4088888224997799, -4.898249941694646],
            [-0.40069599166708325, -4.917720587097092],
            [-0.42585669714921287, -4.922157535752392],
            [-0.43936687666644314, -4.936280054788995],
            [-0.4318664629491268, -4.969505367543714],
            [-0.43292112899049184, -4.991148928213757],
            [-0.4421549347529457, -5.007223663197869],
            [-0.46618523020326946, -5.017849309634427],
            [-0.48535741428125995, -5.012577284600046],
            [-0.5039881117561404, -4.996718221399728],
            [-0.5187988267076147, -4.952149684700317],
            [-0.5308188054033479, -4.9307852221145305],
            [-0.5287702991534214, -4.911823713566369],
            [-0.5103900240073158, -4.902467608704895],
            [-0.49803850549303463, -4.886623265153487],
            [-0.5081769050541116, -4.8413857236611975],
            [-0.5128896533190455, -4.832843996958248],
            [-0.5336688071530674, -4.817157897513485],
            [-0.5465367845922138, -4.818421149828459],
            [-0.5629168735847604, -4.832563685975354],
            [-0.5657463926333478, -4.85786880493354],
            [-0.5833654987866301, -4.874581482115157],
            [-0.6120302732469971, -4.845870585785309],
            [-0.6195913779123611, -4.865288732723665],
            [-0.631552509151963, -4.87672270891109],
            [-0.6400909074470864, -4.869948678445634],
            [-0.6564682405602151, -4.901884910811864],
            [-0.6685182376997372, -4.912316304132816],
            [-0.7126799251317331, -4.911724483042338],
            [-0.7344446725829482, -4.9022233285874925],
            [-0.7423198592683089, -4.888816352928839],
            [-0.7324831277602122, -4.85969551863227],
            [-0.7317439462887229, -4.839158041676712],
            [-0.7393121380761162, -4.82644248000465],
            [-0.7606298114181042, -4.81301462803822],
            [-0.7724926397894973, -4.8101691033582314],
            [-0.7926466897350432, -4.81777328218753],
            [-0.8145057328243434, -4.8312802121804035],
            [-0.8388087071806974, -4.8291421389179225],
            [-0.8515594564831167, -4.808297560028738],
            [-0.8443136823829877, -4.776634339164892],
            [-0.8607177605609587, -4.760080564175118],
            [-0.880807893172628, -4.746519413650486],
            [-0.9118933559562736, -4.735824592182807],
            [-0.9336607189602575, -4.749538787329558],
            [-0.9497133871104807, -4.779041179583578],
            [-0.9626708510897031, -4.789827496410528],
            [-0.9878264976756798, -4.791671049807765],
            [-0.9853430594701417, -4.8073571598220335],
            [-1.0074170464139656, -4.812545702392188],
            [-1.002852506167948, -4.821076398738161],
            [-1.0208788444345256, -4.831359802118534],
            [-1.0216871990990388, -4.845685092511562],
            [-1.0482418673767655, -4.86756766278457],
            [-1.0743106525348425, -4.8753727141123955],
            [-1.0996672809179535, -4.866246538209016],
            [-1.132201762815818, -4.84428863865407],
            [-1.1577039220125223, -4.8405275420045335],
            [-1.1711302399169334, -4.82190172602405],
            [-1.148288345417261, -4.80856607349637],
            [-1.146442537763915, -4.784772997277115],
            [-1.1501417187753702, -4.770897078136018],
            [-1.1375353609200396, -4.73453111787997],
            [-1.1476661551674123, -4.731863103710902],
            [-1.1583406136680894, -4.716991565650859],
            [-1.197920832991371, -4.7278440282742125],
            [-1.2157247568697866, -4.7278144588819115],
            [-1.2498511316845942, -4.718081246512002],
            [-1.2495319556250208, -4.709667256649103],
            [-1.2622075508634212, -4.696209103163337],
            [-1.2498054352906611, -4.67860039501133],
            [-1.2746245390241082, -4.657399833455167],
            [-1.278095881199423, -4.635026938068197],
            [-1.2653752511638106, -4.621519142209146],
            [-1.2536345875802863, -4.597886277670483],
            [-1.2636162727704743, -4.584390342049852],
            [-1.2683583995356325, -4.565278455111499],
            [-1.2797725803014692, -4.5645939948189715],
            [-1.2909840745873062, -4.5739371473034875],
            [-1.3059300348493912, -4.595964429328359],
            [-1.3182542177726413, -4.604288329538736],
            [-1.3436192049377664, -4.601082781256997],
            [-1.3627455630847731, -4.592289700634734],
            [-1.3686461510018615, -4.583179348476985],
            [-1.3896328150983415, -4.587249054140605],
            [-1.4254294987589222, -4.5812711736041605],
            [-1.4457463438614644, -4.564253061444977],
            [-1.4772648310061338, -4.557364280584023],
            [-1.4919351092784143, -4.564944523936236],
            [-1.503368026894825, -4.58262847557467],
            [-1.5068114219131776, -4.609421713361527],
            [-1.5175862446968815, -4.613412015173394],
            [-1.5180748314893013, -4.6257245854899836],
            [-1.5446318461685815, -4.630981095429137],
            [-1.580153361993446, -4.649708212858895],
            [-1.5945425896259056, -4.639597250178806],
            [-1.6199849640609776, -4.603702328191757],
            [-1.6395179873363006, -4.586877984213499],
            [-1.638941959257343, -4.577211690662115],
            [-1.6524248840954163, -4.561011334622519],
            [-1.6707013678424905, -4.548848821785278],
            [-1.6887518037979843, -4.551747133596193],
            [-1.710223993715362, -4.543871660745412],
            [-1.7460212616771034, -4.574493635519455],
            [-1.781814527659367, -4.570675407399647],
            [-1.8008180825315188, -4.5813077438446665],
            [-1.8074806071359377, -4.569313906348879],
            [-1.8388492591826293, -4.55075514233741],
            [-1.8605199271194082, -4.541850284265379],
            [-1.8652574505203068, -4.547396845728426],
            [-1.893612605954502, -4.537972839420344],
            [-1.9333880564392674, -4.5182627106962885],
            [-1.9568660925781036, -4.489149054182194],
            [-1.9765894335741196, -4.4966921000492315],
            [-1.9820784303996142, -4.482430723113869],
            [-1.997983947726425, -4.481871222298249],
            [-2.0085432271335333, -4.496034196028455],
            [-2.0274523810890845, -4.491724877906332],
            [-2.0336370001534356, -4.500276893602916],
            [-2.062785148270187, -4.4859611184804935],
            [-2.0956420596251655, -4.494714716225993],
            [-2.11887973256649, -4.486213284525082],
            [-2.1528843618603726, -4.480188969490654],
            [-2.1581349880062253, -4.449867298042145],
            [-2.156143530108194, -4.412568064051989],
            [-2.165490833782765, -4.4098810844177025],
            [-2.1692544603446566, -4.382757670813732],
            [-2.1633957929032643, -4.376632224671009],
            [-2.1655512453326686, -4.355699132295031],
            [-2.1848036772256982, -4.339205573540427],
            [-2.1870586281332987, -4.325812082618867],
            [-2.232079691021595, -4.275317265111212],
            [-2.2527220430812034, -4.281142478747345],
            [-2.259662445812562, -4.26730763139588],
            [-2.2818900899911507, -4.246650748851321],
            [-2.2798758265589596, -4.236951316595322],
            [-2.301226012689425, -4.231087409020301],
            [-2.31315941863665, -4.245587947700931],
            [-2.3157583118471057, -4.268318881028041],
            [-2.3082702483747806, -4.27605396462691],
            [-2.315618240738987, -4.292145028779767],
            [-2.3169566572153824, -4.308500690375713],
            [-2.3256545880581028, -4.315041354382004],
            [-2.344040875294764, -4.305919055143154],
            [-2.351157960890333, -4.3155744334564785],
            [-2.3622992582867477, -4.297984589599858],
            [-2.3732554675488924, -4.289894194834903],
            [-2.390224682165157, -4.287207897243495],
            [-2.400145325058153, -4.275122742141635],
            [-2.4245407415083804, -4.27236780513309],
            [-2.450833108748326, -4.265487435120115],
            [-2.4654611655457956, -4.265609019650465],
            [-2.4700848085230374, -4.291033410740955],
            [-2.4833913868912516, -4.307145437734838],
            [-2.503211908046801, -4.307511425731294],
            [-2.5224670330597703, -4.297990228371158],
            [-2.5347169899066606, -4.30620290957006],
            [-2.547224856119522, -4.299566008268502],
            [-2.5609350487699105, -4.3005100762028645],
            [-2.5749308055558155, -4.287296436064029],
            [-2.577516963776495, -4.27523789778906],
            [-2.6077246458796113, -4.255468678229771],
            [-2.616359611885866, -4.238830938784932],
            [-2.6386598508065977, -4.2214401458267385],
            [-2.654618481269832, -4.198355683789884],
            [-2.6602416926718226, -4.176098428120494],
            [-2.6848375107568025, -4.161530017992425],
            [-2.7111279029363287, -4.122770777739265],
            [-2.7385340137122123, -4.100305290362388],
            [-2.7576760291055415, -4.090436362222133],
            [-2.779476261526876, -4.106734568544172],
            [-2.8030728865587426, -4.107427701059519],
            [-2.795188356897902, -3.9206720578837504],
            [-2.7831575443717487, -3.6355763544352535],
            [-2.7716882205140982, -3.3636871077595902],
            [-2.7609836109566235, -3.109839118473127],
            [-2.7527620415303593, -2.9148322964338096],
            [-2.740175490060515, -2.6162286787878335],
            [-2.7303749142370908, -2.3836715568328413],
            [-2.7207681708797633, -2.1556761897028043],
            [-2.986529497868491, -2.14430867733275],
            [-3.1358861471386774, -2.137479832571115],
            [-3.3972167427478452, -2.1241791541219506],
            [-3.5835679461437127, -2.114896881134512],
            [-3.8075231711016144, -2.1024285322893284],
            [-3.9793644408156594, -2.092410244753107],
            [-4.172942430513291, -2.080635739742341],
            [-4.255288181124038, -2.074658131690034],
            [-4.4398360036543405, -2.0631117966593675],
            [-4.764168514292834, -2.0413119556687644],
            [-4.940111874323867, -2.0289224054741464],
            [-5.107072791315379, -2.0167843711479536],
            [-5.0941503071790395, -1.8408990602975206],
            [-5.076293330059413, -1.6050361162961084],
            [-5.069750699194865, -1.5138966209814764]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.50790580825223,
          "lat": 35.583279622693844
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01102857"
      },
      "bbox": [
        -5.107072791315379, -5.110220203054148, 1.7317678512252646,
        -1.5138966209814764
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [20.52471131538896, 8.964707981746432],
              [20.537394145233225, 8.97848597897775],
              [20.552978919241006, 8.977845261024514],
              [20.548948023671194, 8.959232556162904],
              [20.534645404646767, 8.95311394082087],
              [20.52471131538896, 8.964707981746432]
            ]
          ],
          [
            [
              [20.382705479825493, 8.898154295803312],
              [20.400217080039393, 8.893463653018687],
              [20.41003563054974, 8.882421342421164],
              [20.395751520584692, 8.876237134288578],
              [20.382705479825493, 8.898154295803312]
            ]
          ],
          [
            [
              [20.39094308336791, 8.818993184923148],
              [20.413454301932752, 8.828494434873766],
              [20.431244721935396, 8.81663603532584],
              [20.415877870439846, 8.788449248849028],
              [20.407955226307127, 8.808713716805386],
              [20.39094308336791, 8.818993184923148]
            ]
          ],
          [
            [
              [20.35264238912173, 8.80451991075619],
              [20.364896439496025, 8.809477785774499],
              [20.378431076378938, 8.826775640690535],
              [20.3775261394053, 8.79790645034203],
              [20.385653051902334, 8.796817364994192],
              [20.402635450751184, 8.767349107982735],
              [20.394431918609133, 8.755305271163126],
              [20.37169584487391, 8.786670209153378],
              [20.363476366581928, 8.803401171331544],
              [20.35264238912173, 8.80451991075619]
            ]
          ],
          [
            [
              [20.197844760300434, 8.693255147427758],
              [20.203843200767487, 8.704205418620107],
              [20.221198353598457, 8.67778449569176],
              [20.21097144897931, 8.673645384253605],
              [20.197844760300434, 8.693255147427758]
            ]
          ],
          [
            [
              [19.97977308146224, 8.434237141401935],
              [19.996559352204883, 8.438066099918444],
              [20.00647221698459, 8.423846030094284],
              [19.99238874204977, 8.412453983521859],
              [19.983469082052785, 8.416809350255392],
              [19.97977308146224, 8.434237141401935]
            ]
          ],
          [
            [
              [19.951825273981154, 8.27839839549599],
              [19.965507412164946, 8.295042784000985],
              [19.9846798821311, 8.280826674498453],
              [19.98234365834831, 8.272090146299753],
              [19.959360075643815, 8.271128972471528],
              [19.951825273981154, 8.27839839549599]
            ]
          ],
          [
            [
              [19.830633808664963, 8.478751631159147],
              [19.831533861113687, 8.492509296320438],
              [19.843909285753618, 8.511361287499478],
              [19.855781693534237, 8.499565687392613],
              [19.850752223434835, 8.480486659107232],
              [19.854621148897955, 8.470012766206848],
              [19.843809043676533, 8.462590400500071],
              [19.830633808664963, 8.478751631159147]
            ]
          ],
          [
            [
              [19.85484294490969, 8.288809187934731],
              [19.859719319040664, 8.307615548627263],
              [19.86758309466749, 8.309519297555545],
              [19.871168278045847, 8.331821010023369],
              [19.878083705577474, 8.334687957340343],
              [19.895575337023466, 8.315483287870789],
              [19.912126284814022, 8.328847854672496],
              [19.935087425163502, 8.31444347582125],
              [19.932706215190372, 8.299505382985265],
              [19.917963483478054, 8.283235073431692],
              [19.90861139618668, 8.265518459170199],
              [19.890993670600803, 8.281810070996965],
              [19.883821290048896, 8.29858821816073],
              [19.870948699550212, 8.285686357008684],
              [19.85484294490969, 8.288809187934731]
            ]
          ],
          [
            [
              [19.854474252994166, 8.24649107322544],
              [19.86174323228564, 8.262922750846657],
              [19.874086052501664, 8.248756592221051],
              [19.86494621875605, 8.237522996767524],
              [19.854474252994166, 8.24649107322544]
            ]
          ],
          [
            [
              [19.783451250115775, 8.453775348988358],
              [19.78301417515701, 8.47928545385895],
              [19.777966940660868, 8.501254295088685],
              [19.78936212080724, 8.505910781049618],
              [19.822744245031465, 8.450832137460141],
              [19.7898019054799, 8.445725171396148],
              [19.783451250115775, 8.453775348988358]
            ]
          ],
          [
            [
              [19.76055404940801, 8.180254459559237],
              [19.786443331547556, 8.19622501476843],
              [19.788527746296314, 8.208747589765693],
              [19.805477342511583, 8.204217994671195],
              [19.81734460928015, 8.165164427483393],
              [19.81851002485548, 8.13197193976812],
              [19.80573461074108, 8.137211572303379],
              [19.78421097715829, 8.12621830892992],
              [19.783349824723135, 8.14758884852388],
              [19.777651019526463, 8.174116424153178],
              [19.76055404940801, 8.180254459559237]
            ]
          ],
          [
            [
              [19.67732402619774, 8.307908211171366],
              [19.697119874174902, 8.324400985549406],
              [19.693898594180943, 8.337988031482109],
              [19.701626942557944, 8.358492193030465],
              [19.711190397535937, 8.36675053843278],
              [19.72900274392998, 8.365884981414723],
              [19.754957399912634, 8.353195012585127],
              [19.76558814167032, 8.334049808665947],
              [19.796431516539, 8.325114775289295],
              [19.800910190980353, 8.311962591416117],
              [19.792246676949713, 8.302812938501528],
              [19.759885186520233, 8.308742816887538],
              [19.769126421861923, 8.295042752985246],
              [19.75759414794408, 8.264300758989275],
              [19.74094307389815, 8.253597784666994],
              [19.711327282504673, 8.250280500190158],
              [19.699101911319076, 8.260780990208298],
              [19.696021478790076, 8.289521931995122],
              [19.67732402619774, 8.307908211171366]
            ]
          ],
          [
            [
              [19.6470315228951, 8.380662646613125],
              [19.656314197098702, 8.38662022148134],
              [19.682975429772622, 8.380875430078879],
              [19.69086309037882, 8.375257411459682],
              [19.683856963051266, 8.359835814057561],
              [19.662197154711865, 8.368340802941667],
              [19.6470315228951, 8.380662646613125]
            ]
          ],
          [
            [
              [19.66195992022995, 7.921466163366697],
              [19.66007883505074, 7.9367994304094065],
              [19.677820903951357, 7.935463429915107],
              [19.67017742407698, 7.918346340781616],
              [19.66195992022995, 7.921466163366697]
            ]
          ],
          [
            [
              [19.58942805315646, 8.151619990750916],
              [19.586921992747957, 8.167218662838287],
              [19.598015362581595, 8.184212248400508],
              [19.616067200545576, 8.18309647733989],
              [19.619917399427617, 8.176090659356717],
              [19.642952416582236, 8.194623851226133],
              [19.65627432773131, 8.192142469896785],
              [19.69034768539447, 8.162837389672614],
              [19.6928309512502, 8.14853046424365],
              [19.674284687257636, 8.110043352325471],
              [19.651756814458224, 8.111804673588965],
              [19.64817799299929, 8.096873577682347],
              [19.63641419312165, 8.098320616947957],
              [19.630679425423647, 8.116468543415738],
              [19.62107992434897, 8.122523262924528],
              [19.61745894717201, 8.137737086510576],
              [19.58942805315646, 8.151619990750916]
            ]
          ],
          [
            [
              [19.51555558996434, 8.324673568789212],
              [19.519892357276746, 8.345438157799803],
              [19.531418645665983, 8.370778536205806],
              [19.516176887998235, 8.379895772677534],
              [19.521266399069233, 8.38940102069588],
              [19.513807083614708, 8.407570105502543],
              [19.515519170381733, 8.422110970072747],
              [19.543238314264208, 8.426222845631408],
              [19.549188050186576, 8.407340638178082],
              [19.536219470304687, 8.384468086733023],
              [19.536921698445315, 8.359362105009586],
              [19.54814627632766, 8.354878971258733],
              [19.543665344586717, 8.328243949261559],
              [19.544308928482344, 8.299366672379264],
              [19.525305052142357, 8.326968890079156],
              [19.51555558996434, 8.324673568789212]
            ]
          ],
          [
            [
              [19.56256569773445, 8.160702398332633],
              [19.571794974478546, 8.200965911043705],
              [19.588420800213942, 8.217788768638599],
              [19.609673145877217, 8.248606411759322],
              [19.623873369435188, 8.254497361599391],
              [19.64228846437239, 8.222505273292015],
              [19.63051762967241, 8.219785882339098],
              [19.599191164592046, 8.188614861943984],
              [19.590198769179366, 8.196244506972128],
              [19.571140053070845, 8.176239878518222],
              [19.56256569773445, 8.160702398332633]
            ]
          ],
          [
            [
              [19.27492440799807, 7.8749884766598806],
              [19.270331461466515, 7.89727441248409],
              [19.282236088403064, 7.895463371252946],
              [19.27492440799807, 7.8749884766598806]
            ]
          ],
          [
            [
              [18.845115309063203, 7.559270810200457],
              [18.848821567948512, 7.578791599258195],
              [18.86766493855458, 7.586998937547674],
              [18.86116059387084, 7.558945162353006],
              [18.845115309063203, 7.559270810200457]
            ]
          ],
          [
            [
              [18.821786870076348, 7.4746752514432595],
              [18.825589050357582, 7.498474405613582],
              [18.83667977628609, 7.486873508341115],
              [18.821786870076348, 7.4746752514432595]
            ]
          ],
          [
            [
              [18.62918678603264, 6.809621263148216],
              [18.62320533295072, 6.824045590103765],
              [18.60147104485095, 6.816606437426556],
              [18.58700151467192, 6.819077339800409],
              [18.575281764517353, 6.829982741208473],
              [18.525250314653285, 6.851142627879603],
              [18.51513643401478, 6.8688965990992195],
              [18.51505997478237, 6.89751981479319],
              [18.50914461308647, 6.93730614573127],
              [18.51158387578877, 6.948257961851163],
              [18.50233658040004, 6.959569028579078],
              [18.486457515215033, 6.960483765570174],
              [18.48022811192086, 6.970581784303761],
              [18.44860106897246, 6.980852195458656],
              [18.435033283479697, 6.9904365419324135],
              [18.411792478552925, 7.020364670276071],
              [18.392857477832248, 7.032943808684008],
              [18.379990076644965, 7.026732704347917],
              [18.37013512164378, 7.033481104270548],
              [18.349724449061558, 7.061437576795984],
              [18.338025176495105, 7.097695083534393],
              [18.349642316518395, 7.125645597655354],
              [18.34245540946871, 7.136255336279247],
              [18.342733454606154, 7.152989127380287],
              [18.33124263790447, 7.170160588179935],
              [18.33504420430216, 7.184754078221066],
              [18.333538378664375, 7.204426552058918],
              [18.322756190522, 7.218522334364848],
              [18.327338560480392, 7.2360361762537275],
              [18.30707098346144, 7.250460540010267],
              [18.290657244093794, 7.302646420907007],
              [18.23763875601114, 7.461104712155997],
              [18.202684430204577, 7.579413107430111],
              [18.150677748774733, 7.7475149846596985],
              [18.07819305674416, 7.983256331688673],
              [18.012007814930318, 8.189074632388786],
              [17.983670387946574, 8.281484710147224],
              [17.925039124271034, 8.460491242489411],
              [17.873686891835444, 8.610809378756715],
              [17.798677460581334, 8.838814904726974],
              [17.7787337237348, 8.893448955344688],
              [17.793320356933005, 8.905814734722373],
              [17.812474371072717, 8.90713494023963],
              [17.826034055747115, 8.919897893799991],
              [17.822020330911524, 8.945847973464884],
              [17.838524547109543, 8.936697149613607],
              [17.859260610749562, 8.949292068344118],
              [17.867613764798712, 8.937752839439733],
              [17.88973543448157, 8.929603213686137],
              [17.89777173464751, 8.915646101859492],
              [17.89563515718773, 8.897922335926937],
              [17.9168112775142, 8.882130003324413],
              [17.920632876548908, 8.868388229113211],
              [17.932178549658, 8.862035250194952],
              [17.952683470141242, 8.861668090518346],
              [17.954539457452093, 8.878091117734533],
              [17.949507046907932, 8.895814332522901],
              [17.956810255346056, 8.914395609890448],
              [17.95525053755522, 8.925051226638658],
              [17.963956034145678, 8.939302358399752],
              [17.963097838938733, 8.958112191766716],
              [17.950744162393015, 8.969606413701626],
              [17.95328087074473, 8.984048810430386],
              [17.948550640339054, 9.011508945720399],
              [17.929206414534043, 9.030633520848088],
              [17.951016266567247, 9.06806130468069],
              [17.96928929166159, 9.070103574878003],
              [17.99424021650262, 9.047120862821659],
              [18.008519513010135, 9.042005902481055],
              [18.030757752975642, 9.05183600704225],
              [18.053465830250925, 9.040306279304517],
              [18.064363306412545, 9.072784462807956],
              [18.057785067721685, 9.087051513113519],
              [18.035926707681067, 9.104988595584025],
              [18.017566545549887, 9.107699241446367],
              [18.00411804458977, 9.11555151794161],
              [18.000075582823715, 9.125769583255707],
              [17.978601397619354, 9.135884254752572],
              [17.975456622780694, 9.165589642857634],
              [17.983521369238158, 9.197486567518403],
              [17.979474438489905, 9.209222659283048],
              [17.992703292050074, 9.238610756811203],
              [17.997236698227375, 9.260498775160697],
              [18.012733457867732, 9.269687744946483],
              [18.018125212978926, 9.285881322989303],
              [18.026613157916024, 9.29173336914963],
              [18.039720732504644, 9.33292332977296],
              [18.061114091380524, 9.338505148430961],
              [18.09152403222262, 9.387453400136737],
              [18.11027892943385, 9.39063896127589],
              [18.13208712062552, 9.412372918443548],
              [18.13215229798344, 9.442953102261699],
              [18.1167891544987, 9.451138539479254],
              [18.11346340226566, 9.46527938624537],
              [18.10091462722776, 9.48103506367027],
              [18.114091576972108, 9.488308593098791],
              [18.11410430741598, 9.50891989065408],
              [18.12884408921056, 9.529698099794947],
              [18.135847314200465, 9.548733626691806],
              [18.15820947928268, 9.562555760809866],
              [18.169678016333183, 9.578258276230343],
              [18.18189014039997, 9.613232929935991],
              [18.169868939295224, 9.631252423359461],
              [18.180074016342097, 9.654380003559462],
              [18.149694904293128, 9.669712636890939],
              [18.130725278832767, 9.662488941860838],
              [18.123686228800747, 9.676228702503149],
              [18.135320988211557, 9.69126764363392],
              [18.123167955435328, 9.695255950126436],
              [18.107936933157436, 9.712050008207138],
              [18.124638189775652, 9.750010750878484],
              [18.10405735644302, 9.753727799175783],
              [18.10200414705075, 9.77553667249101],
              [18.106613665610947, 9.7880984547259],
              [18.125607644980786, 9.809498878013086],
              [18.127279445305643, 9.843195498762714],
              [18.078692274005434, 9.879746398370132],
              [18.087830994104284, 9.90299675386134],
              [18.08815452788737, 9.959324167553824],
              [18.09315978937183, 9.985294596766655],
              [18.1078884983963, 9.99817274931951],
              [18.09834643592574, 10.027629960740077],
              [18.114490917412336, 10.060582668958988],
              [18.130212310064028, 10.064519722617536],
              [18.155820714155375, 10.12431327985422],
              [18.176117067709875, 10.134479317148825],
              [18.158305778049545, 10.272282848325814],
              [18.14052978519153, 10.409970405433215],
              [18.15790722372329, 10.460545721170586],
              [18.175296021248805, 10.511106206932796],
              [18.19269625588242, 10.561651801474087],
              [18.210108005968983, 10.61218244374855],
              [18.2346227358918, 10.682616072918208],
              [18.2591602985829, 10.753020338752101],
              [18.283720909101543, 10.82339507804336],
              [18.308304783383534, 10.893740128369416],
              [18.332952615831598, 10.964172835166448],
              [18.357624225964347, 11.034575429880398],
              [18.37832828641067, 11.093671688518471],
              [18.399049389403825, 11.15274650625754],
              [18.419787665914495, 11.211799788682276],
              [18.440543247358953, 11.27083144178972],
              [18.454036617578968, 11.26897974301001],
              [18.471458681777765, 11.276498160263602],
              [18.511949693600773, 11.273611410207081],
              [18.52501256140579, 11.265912069212233],
              [18.54436933483044, 11.2642362165769],
              [18.552669149802757, 11.275645314166825],
              [18.567369299012253, 11.274426460767751],
              [18.576418884921086, 11.26361259522728],
              [18.577888535118348, 11.233060056851755],
              [18.5742801883296, 11.225968806170425],
              [18.59142719311167, 11.167210499656328],
              [18.60914542377535, 11.127360074205294],
              [18.61102192887729, 11.112426223293152],
              [18.619595101845064, 11.104472362879147],
              [18.66674043102739, 11.092034647236185],
              [18.683448800590238, 11.082038354591266],
              [18.69544735025238, 11.08630047164659],
              [18.724405242406927, 11.07277370651204],
              [18.741270345012715, 11.07605028030604],
              [18.752413579927456, 11.084615460711019],
              [18.778313915902146, 11.11938754506625],
              [18.807784549632814, 11.134597654512573],
              [18.83291078842885, 11.16107131118541],
              [18.85989528409862, 11.17062945755289],
              [18.8693013417221, 11.167392035934338],
              [18.90084469742085, 11.184737513187823],
              [18.909203177721178, 11.202085410643582],
              [18.902710289424775, 11.210795703581217],
              [18.910907774769544, 11.231161184409324],
              [18.92853160373931, 11.23090069074752],
              [18.94809190383087, 11.250688124652271],
              [18.975877320952282, 11.260269018935707],
              [18.990396065202, 11.251376707048891],
              [19.010586851300815, 11.25412351731048],
              [19.01681401856667, 11.26196532149634],
              [19.038806123190668, 11.267133446784639],
              [19.040399812114583, 11.277220714496494],
              [19.027791210814126, 11.300671086693146],
              [19.025777002478534, 11.321287619980723],
              [19.037115413935002, 11.33878370163155],
              [19.052723730277666, 11.346582348025596],
              [19.072937921583275, 11.3483167244891],
              [19.082556291325638, 11.355516137607612],
              [19.097175573829123, 11.351835410512587],
              [19.116389523084994, 11.360033593206026],
              [19.127041785661344, 11.352478653229008],
              [19.17960607943014, 11.3445981764941],
              [19.183057809212272, 11.3337502204087],
              [19.196977211913012, 11.323805030790316],
              [19.23929255945966, 11.311746631804533],
              [19.257499714305595, 11.301387854165883],
              [19.293725272236472, 11.289726857687581],
              [19.31792445376082, 11.272064195936803],
              [19.346506174347663, 11.26639540753038],
              [19.35064548306681, 11.254786908834703],
              [19.37467343849161, 11.232795241209091],
              [19.387797984370945, 11.2297651041493],
              [19.407904447280664, 11.21183407050131],
              [19.412870421601294, 11.198406472122196],
              [19.48950802928733, 11.1783456068258],
              [19.544774084412776, 11.003977712084659],
              [19.569487427388548, 10.923338848960373],
              [19.626670803889276, 10.742928993027764],
              [19.677132672130824, 10.589846642015246],
              [19.724878909425623, 10.441964486923206],
              [19.82378331757722, 10.12626072193986],
              [19.82867186768491, 10.118659323934198],
              [19.851556010023227, 10.108785517165481],
              [19.84561565348246, 10.087115077202023],
              [19.834798591741688, 10.080853094281295],
              [19.826153539202206, 10.065134358323688],
              [19.831651138626057, 10.051088808488476],
              [19.844733959879438, 10.038697394475838],
              [19.876025123931104, 10.01923420068557],
              [19.86128281678782, 10.00711027004082],
              [19.850607772241474, 9.990868723502336],
              [19.85640231758775, 9.955517106062326],
              [19.885169182936266, 9.926810114110147],
              [19.867065374592446, 9.919385879319078],
              [19.88643481881117, 9.872312875612877],
              [19.909696324102484, 9.879008880887206],
              [19.922188931348707, 9.87269509734453],
              [19.936763559557917, 9.873693482969474],
              [19.934775352965676, 9.887237963278706],
              [19.945801130872777, 9.893647922696065],
              [19.985688777652747, 9.853943041338551],
              [20.01058729041674, 9.843592746588028],
              [20.01184138910412, 9.855800384648706],
              [20.037712486502638, 9.844191741076282],
              [20.050073159930914, 9.848527655008482],
              [20.07256900120436, 9.843137643044722],
              [20.082108111532765, 9.848567414617317],
              [20.103238412325975, 9.845269926339457],
              [20.11630500667355, 9.84830982850656],
              [20.121473084446514, 9.864938408575485],
              [20.14053317907187, 9.873895340221788],
              [20.163890213054103, 9.859482655601296],
              [20.179726575798068, 9.829518327175393],
              [20.174860045917082, 9.818742205824647],
              [20.181104393764915, 9.798959117404598],
              [20.19060748275156, 9.787327224651143],
              [20.175645939103205, 9.776246816968426],
              [20.16391654074963, 9.782049814006065],
              [20.148273108443007, 9.74566974703314],
              [20.165029149598872, 9.733005822030405],
              [20.167417479531355, 9.722115567986519],
              [20.182680602056745, 9.699688065294696],
              [20.19054543804928, 9.700975375357112],
              [20.223060689182358, 9.677819873922775],
              [20.23149354461766, 9.663763071975753],
              [20.23539163691958, 9.634133062273447],
              [20.228432675907342, 9.61754468388762],
              [20.22710668281114, 9.586319312501724],
              [20.21342541767686, 9.562420999366227],
              [20.223867553917646, 9.559041975649272],
              [20.241737188625006, 9.532650723386986],
              [20.26264229488469, 9.521421085016877],
              [20.278297925999503, 9.500054141024222],
              [20.304023532965054, 9.482745583799943],
              [20.306312986034314, 9.465408704562687],
              [20.32517297651382, 9.462773904946197],
              [20.349208711988474, 9.44737784114007],
              [20.360087996672576, 9.44639149367463],
              [20.37069427495348, 9.455603103918316],
              [20.368505542859065, 9.466373172989027],
              [20.381850154672254, 9.474869769769052],
              [20.376372452501474, 9.483989531417627],
              [20.375007717106936, 9.516184986063175],
              [20.386871065734784, 9.522332044719123],
              [20.40633493457746, 9.517654012918221],
              [20.42446507530347, 9.505540012569341],
              [20.437877070549945, 9.517693402704639],
              [20.471920746388776, 9.51743811095953],
              [20.517094448521984, 9.481036269667687],
              [20.544715595444117, 9.44445995129922],
              [20.530200171710703, 9.42755559901946],
              [20.562311032163098, 9.409419457318133],
              [20.58018564450915, 9.385351377852684],
              [20.59366959300774, 9.374775001998994],
              [20.6219864270751, 9.3350431089],
              [20.635789932623087, 9.336422322700455],
              [20.639019718353296, 9.325745145294137],
              [20.663264302797266, 9.319514067312552],
              [20.662555024495877, 9.297824958119646],
              [20.68329200087948, 9.267096738192214],
              [20.675567246285887, 9.252964719172393],
              [20.700190980567278, 9.222951050685817],
              [20.678554067181985, 9.174629832742964],
              [20.656958833455086, 9.171512863258341],
              [20.65446607404445, 9.139943371138106],
              [20.641325197844655, 9.136632651155477],
              [20.64108982002308, 9.109761339159888],
              [20.635731416342946, 9.092927933173092],
              [20.62439410592238, 9.080743373383845],
              [20.620933736153287, 9.054360720952307],
              [20.601636187068316, 9.04135470293506],
              [20.604850089605144, 9.024596624496954],
              [20.576950320619623, 9.007344844078979],
              [20.568473044897427, 9.008603001522351],
              [20.564023791416794, 9.032978142007332],
              [20.542789646952148, 9.02468216223666],
              [20.557883261672412, 8.994791848013561],
              [20.544916863877777, 8.983783197781086],
              [20.53415654543596, 9.005830415534215],
              [20.519760746494413, 9.014791787370088],
              [20.516676243797615, 9.032416143597601],
              [20.505682575267407, 9.05822902724223],
              [20.485994076750167, 9.043476609245632],
              [20.47376894312521, 9.04024727611663],
              [20.460509824624058, 9.025148661785556],
              [20.464913810634492, 9.002153092182706],
              [20.474564102235036, 9.002560442113406],
              [20.489482094327077, 8.983578036371247],
              [20.48984490081886, 8.967556048324425],
              [20.47875219146549, 8.953631642913313],
              [20.473640517162753, 8.931032831654148],
              [20.451533648870253, 8.944063052022248],
              [20.44264198763368, 8.927848007442988],
              [20.417471933405242, 8.931274833044105],
              [20.3929538719053, 8.950503219710994],
              [20.370511217007337, 8.932999569272793],
              [20.36338591284263, 8.912926032015626],
              [20.36988524775864, 8.90456098857158],
              [20.36846916184421, 8.86408974108501],
              [20.384865010197398, 8.847529860088622],
              [20.38393848961247, 8.839168253262763],
              [20.36369887391492, 8.833179281885448],
              [20.350771919022854, 8.82415187767152],
              [20.325696759621106, 8.814973330922905],
              [20.32012239834718, 8.82495046032443],
              [20.308116202904564, 8.823762874051656],
              [20.293961590929253, 8.813604872626028],
              [20.29997441388673, 8.790210411312897],
              [20.294424437225352, 8.77203889351588],
              [20.272693615152885, 8.769460506856595],
              [20.262084205849913, 8.801206423529681],
              [20.24700528452579, 8.815070580970508],
              [20.23717007774921, 8.810537311065891],
              [20.240488530247767, 8.78589351288688],
              [20.22465523102638, 8.782405076160131],
              [20.217818658188097, 8.799754272940515],
              [20.208954051890107, 8.795848571056679],
              [20.196200179427063, 8.810245272773836],
              [20.187969451637752, 8.76652537690063],
              [20.200846655204256, 8.746000997624842],
              [20.199418336039265, 8.722555668079549],
              [20.18324770534429, 8.715925326721282],
              [20.191327537303966, 8.69832376675852],
              [20.19574363706188, 8.670085370277784],
              [20.195465938805384, 8.640567448183702],
              [20.175335132741665, 8.673288170638406],
              [20.172811488245422, 8.692396861521912],
              [20.15583278584737, 8.683925225238784],
              [20.16474256675201, 8.672378723231375],
              [20.169297684986052, 8.64990092305901],
              [20.149027311392725, 8.660771650024989],
              [20.138756373845567, 8.684089728495126],
              [20.1259285537532, 8.697633006793078],
              [20.11362681580091, 8.683574384950628],
              [20.085548419821983, 8.690965412449781],
              [20.09132568160501, 8.6784678081584],
              [20.126646089352977, 8.667093958774368],
              [20.142576562561523, 8.640576229844244],
              [20.154840362562243, 8.631768426694174],
              [20.142031837439834, 8.612962226306866],
              [20.120541685717832, 8.633962925734334],
              [20.113356075017485, 8.619318076727483],
              [20.12083962878277, 8.608188334396162],
              [20.11677545369505, 8.587960198565451],
              [20.10743033063763, 8.575124105097048],
              [20.113430202576502, 8.562168056590298],
              [20.09936051260896, 8.549691376629672],
              [20.089651197300057, 8.559461257709629],
              [20.076817133170444, 8.597643508343506],
              [20.065813316523432, 8.593121173109742],
              [20.04936236327062, 8.603007611651256],
              [20.046704510399067, 8.618014470016691],
              [20.03143202969943, 8.64329238795481],
              [20.02812877115688, 8.665339744507243],
              [20.0207598524126, 8.674571858639109],
              [20.008605640706865, 8.670452273100187],
              [20.00321341211883, 8.682852521304387],
              [19.9890191562502, 8.682480498935957],
              [19.989422164463395, 8.65618132275542],
              [19.97531251797815, 8.657332814597055],
              [19.954163420477574, 8.697185441464255],
              [19.947477858001196, 8.695370727262484],
              [19.950358832428766, 8.668509940023778],
              [19.939487878228555, 8.64386489389658],
              [19.929615816766418, 8.652516004644687],
              [19.922978108481068, 8.637718069016923],
              [19.905110089376226, 8.63260420747112],
              [19.920146882148348, 8.616283902159916],
              [19.908660274412078, 8.6110083625354],
              [19.888027138193596, 8.617883636584152],
              [19.88742615498523, 8.604713455078734],
              [19.86946074280304, 8.603958018201373],
              [19.86685369138227, 8.579303741378663],
              [19.883013731740803, 8.574952272267659],
              [19.900823176745504, 8.603064210447739],
              [19.91615285417808, 8.595903265762628],
              [19.93180733448512, 8.607516237472806],
              [19.948020611535348, 8.605622940143215],
              [19.960354900214412, 8.584542765902931],
              [19.982145218179774, 8.571447228812053],
              [19.996028613588617, 8.571320029567687],
              [20.023256944982492, 8.536790689727615],
              [20.026341911593036, 8.524127682347995],
              [20.02089784438386, 8.507708992074024],
              [20.024356184358, 8.497891652890996],
              [20.005155816674193, 8.474475484251542],
              [19.958101261656143, 8.456790565080652],
              [19.945151396853312, 8.463873648451798],
              [19.94032360797709, 8.452926626940839],
              [19.964844356306788, 8.432961207152173],
              [19.97221738437504, 8.419016383780308],
              [19.96403181901154, 8.397954078880263],
              [19.94577030150475, 8.387078781518731],
              [19.933354554202612, 8.398144219272211],
              [19.89235721583083, 8.403357091451218],
              [19.880691238700177, 8.421177959526768],
              [19.861453671286103, 8.440572982805449],
              [19.857505365678406, 8.453886698483197],
              [19.867646217645014, 8.466875740301548],
              [19.866735314294832, 8.482039751002892],
              [19.857675136621342, 8.487075567731523],
              [19.86621048082221, 8.509599406968151],
              [19.861679825556923, 8.520940601902321],
              [19.88549310147329, 8.544578301481408],
              [19.869067976686154, 8.569067215197705],
              [19.855614107533576, 8.577911439898916],
              [19.84461563394281, 8.540049798469022],
              [19.83333846246375, 8.534083916692083],
              [19.826359258296055, 8.54959588567614],
              [19.823177381518438, 8.577109407961677],
              [19.81652747569598, 8.590945748677454],
              [19.813494557030552, 8.612687850803885],
              [19.78193917245317, 8.615484601418874],
              [19.787231886077265, 8.594414871406652],
              [19.800165501883782, 8.576113504920015],
              [19.793351396163672, 8.567083192789545],
              [19.807896966759618, 8.550473026993497],
              [19.810284721293392, 8.528421488448133],
              [19.816971367374933, 8.511059626846903],
              [19.800006800522542, 8.515126162727425],
              [19.80260544370794, 8.532395638207438],
              [19.78128630175251, 8.568443844226222],
              [19.781381797505198, 8.536566628509371],
              [19.771493738978744, 8.53278834814509],
              [19.766681218402347, 8.51602511684218],
              [19.746549420768382, 8.515467701497027],
              [19.74144570060261, 8.504415583231742],
              [19.752071540223398, 8.486693248904443],
              [19.767050807683585, 8.471117184074561],
              [19.761172460808183, 8.44666388226879],
              [19.76777096829122, 8.422711526738473],
              [19.791489006475743, 8.412323704334405],
              [19.812393535095058, 8.385177092558022],
              [19.80432164062872, 8.377866737763535],
              [19.818816087831106, 8.354980763092456],
              [19.796414747354014, 8.357032882472563],
              [19.796650050826873, 8.364505843502519],
              [19.774110949703037, 8.36881189668637],
              [19.750333809955155, 8.383114508333854],
              [19.727215082520228, 8.388453035884801],
              [19.685210141396333, 8.386794345797584],
              [19.676573004842037, 8.396765154100514],
              [19.653329297044138, 8.403237402642446],
              [19.64069973412776, 8.411533175728461],
              [19.626179458285204, 8.403598285638278],
              [19.609727965653164, 8.376321255234089],
              [19.586516695758878, 8.374014354341407],
              [19.581401116179318, 8.39567940950406],
              [19.581024900578516, 8.436328176679158],
              [19.571921712297918, 8.441408910939439],
              [19.56334092253341, 8.465426025397939],
              [19.561430048951188, 8.483824450883027],
              [19.56929571429572, 8.495816431886604],
              [19.566747883303314, 8.509668641093418],
              [19.571290802282817, 8.525984035984848],
              [19.571357259656786, 8.54826570464161],
              [19.558322829653598, 8.572502864574538],
              [19.541084336532656, 8.580094775195859],
              [19.543061508329753, 8.55212110604485],
              [19.533259565931548, 8.533501900980868],
              [19.543653557147568, 8.522852596790027],
              [19.54247332681352, 8.511990398227937],
              [19.514698034820405, 8.473057386490709],
              [19.49959576119681, 8.49194180494685],
              [19.48116024585411, 8.492796173171897],
              [19.479165469337513, 8.473670205842168],
              [19.469029930339982, 8.462281452232874],
              [19.441052653474536, 8.445623462247013],
              [19.456512723731368, 8.425854514749268],
              [19.459281866791343, 8.413490742746202],
              [19.4711975044802, 8.411853966032288],
              [19.49139036393059, 8.39162375175404],
              [19.496040986178212, 8.360062030564881],
              [19.494322860752302, 8.34329875011684],
              [19.486644979792707, 8.327133686969917],
              [19.475693578923057, 8.326799146524559],
              [19.475439909519828, 8.302431722060732],
              [19.462713196895677, 8.256985502626346],
              [19.46611420884874, 8.238835619659525],
              [19.45688624768103, 8.22866645669562],
              [19.465342250083385, 8.218701800615472],
              [19.46536653996101, 8.205289508787947],
              [19.456250809423718, 8.195349619622004],
              [19.45630572708211, 8.175603225468866],
              [19.4660293789651, 8.155482911987402],
              [19.467241648212394, 8.136060154584152],
              [19.45386105588247, 8.13362267127955],
              [19.454850033293216, 8.118195513211344],
              [19.46512773572703, 8.101904188978358],
              [19.490536211135648, 8.121738560714876],
              [19.497632043597633, 8.105265672080424],
              [19.485577659259267, 8.07901649983901],
              [19.491115903056, 8.067153463901148],
              [19.480257341868903, 8.060641911748158],
              [19.463024755766355, 8.033254307307713],
              [19.4796279649591, 8.014491509321642],
              [19.463743357514346, 8.012398865379874],
              [19.438039241028623, 7.993233098724452],
              [19.440131879485165, 7.967025316651551],
              [19.432072023381863, 7.946222338490035],
              [19.391328042412464, 7.905993731431307],
              [19.385027827641334, 7.912622877565101],
              [19.38755773252238, 7.935394294099131],
              [19.36918986389264, 7.944625040037581],
              [19.340126626556085, 7.950057206126798],
              [19.347783114536327, 7.931732422359031],
              [19.320675129393013, 7.916089723761741],
              [19.32774766352963, 7.9384054530787225],
              [19.336622879823228, 7.949963250730627],
              [19.30822622853529, 7.964684705787562],
              [19.29633837440326, 7.962888791661709],
              [19.298783170710074, 7.941651126231232],
              [19.28586128729756, 7.946463523099898],
              [19.26134103898429, 7.932589159408267],
              [19.265801442120743, 7.853481580538599],
              [19.257559061512335, 7.831033216548915],
              [19.254301682762797, 7.7877549481678],
              [19.245444893518954, 7.792607306669084],
              [19.228106236886187, 7.821169956399702],
              [19.210739529471688, 7.819213353298319],
              [19.218970162800996, 7.802126285702136],
              [19.221700302845434, 7.7753675547144105],
              [19.203259882083955, 7.777747783999932],
              [19.206023477595394, 7.757424158644254],
              [19.199628988525802, 7.745075393610072],
              [19.18757549291179, 7.756578124957499],
              [19.194630576562556, 7.7638493819787815],
              [19.189587717808656, 7.784213502181091],
              [19.178709254476267, 7.787392653855751],
              [19.178525614054305, 7.766083669597402],
              [19.153467549026015, 7.757806939486671],
              [19.160942263150655, 7.742431215843124],
              [19.16345756605762, 7.7138099088587815],
              [19.135718954346412, 7.725744016261864],
              [19.128408645673886, 7.739472088633485],
              [19.126926668731787, 7.771180883817074],
              [19.118803543532014, 7.780528285203787],
              [19.11239649512658, 7.8090352057640375],
              [19.11459618812045, 7.837100446758551],
              [19.102390741941214, 7.827114485990024],
              [19.119093673446645, 7.73170724042661],
              [19.115629413208975, 7.720236232307124],
              [19.118753519662615, 7.691881267798646],
              [19.108777697670536, 7.675928286345578],
              [19.106689874536354, 7.649045176777924],
              [19.08306676478697, 7.637811865691672],
              [19.08470100456283, 7.631215733105912],
              [19.058861505532136, 7.608644218560674],
              [19.064991415897726, 7.598987753691819],
              [19.047448032802844, 7.591973266242452],
              [19.040248011732693, 7.609785687659547],
              [19.04167150333234, 7.629056568659784],
              [19.027683692298748, 7.625700548663714],
              [19.028103397653766, 7.643016367030769],
              [19.014683848965593, 7.658964885536225],
              [18.996869305645202, 7.646989388252101],
              [18.972768728262736, 7.6527619650891126],
              [18.96977384164749, 7.632814595285772],
              [18.958971376863396, 7.637197135672648],
              [18.952993236777516, 7.615992091835082],
              [18.940233967883927, 7.602176235301164],
              [18.905272924912214, 7.597074667647935],
              [18.916696622033836, 7.620251227623657],
              [18.921891287099857, 7.6415615066633125],
              [18.92310466636003, 7.665175905568138],
              [18.93081898093347, 7.670512756989464],
              [18.929635462693078, 7.685957987512776],
              [18.939979740353174, 7.709765229760233],
              [18.939138789351738, 7.718815411990275],
              [18.91011335576962, 7.706037374511276],
              [18.891982848882897, 7.707820339099452],
              [18.88122155380894, 7.680296946800843],
              [18.85157948664458, 7.652411938364721],
              [18.82823503573651, 7.624320335348314],
              [18.821668152685888, 7.602419373670834],
              [18.798961593715585, 7.593899129939357],
              [18.79699269052906, 7.572488827086353],
              [18.8027394231507, 7.5621267951923805],
              [18.77798094927884, 7.49694563061575],
              [18.792213390395847, 7.473949767190295],
              [18.80558880371654, 7.468430750286686],
              [18.8129023865727, 7.452490218638561],
              [18.825057363129467, 7.44615543718338],
              [18.825220869180637, 7.418915607636035],
              [18.838145428688062, 7.411309761751887],
              [18.84811723573913, 7.392202988326671],
              [18.83002561884509, 7.386060643659834],
              [18.818738570780088, 7.370351205731],
              [18.804592236206823, 7.3678302625988525],
              [18.79626659685758, 7.375295620542498],
              [18.780943778091643, 7.358646489270174],
              [18.774647125585755, 7.341066567587558],
              [18.75402523663465, 7.340805535379568],
              [18.74354236594016, 7.326253900024606],
              [18.735943800385932, 7.289899321999419],
              [18.74435952670068, 7.264944673428563],
              [18.755713927788, 7.2529661783490615],
              [18.77948376367837, 7.261724364319694],
              [18.782111542838837, 7.248231937863705],
              [18.767112258461903, 7.239542743446264],
              [18.759986586000714, 7.225765083299241],
              [18.76131755745846, 7.209377769320545],
              [18.734684938673478, 7.179133261514715],
              [18.750140152690093, 7.154201037954586],
              [18.71584608105092, 7.1258497586997045],
              [18.70676030097867, 7.128114103006779],
              [18.683954102478317, 7.118515982059471],
              [18.673641230202488, 7.1081913942815955],
              [18.66137547482895, 7.07780102125875],
              [18.655918976245363, 7.012896544907332],
              [18.675872440219653, 6.989941652295882],
              [18.670812303632225, 6.974912867319368],
              [18.67196512423889, 6.95500676121159],
              [18.661124102654494, 6.925685636791677],
              [18.66178239126861, 6.881018449001484],
              [18.650264818335234, 6.844853019175651],
              [18.647935068517636, 6.825553997627825],
              [18.62918678603264, 6.809621263148216]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -69.22727244581888, "lat": 45.37465023533005 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779787"
      },
      "bbox": [
        17.7787337237348, 6.809621263148216, 20.700190980567278,
        11.360033593206026
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.756033191784057, 11.640698765202629],
            [-12.666976176086482, 11.622289291475274],
            [-12.577925095676642, 11.60385078467944],
            [-12.488880037809452, 11.585383259222553],
            [-12.399841089754021, 11.566886729448571],
            [-12.304641652696725, 11.546918990841885],
            [-12.209449547657474, 11.526918107518139],
            [-12.131103221564295, 11.511760008453937],
            [-12.052761027664227, 11.496579584872435],
            [-11.974423024982498, 11.481376845960328],
            [-11.896089272567714, 11.466151800868449],
            [-11.781616010351875, 11.444390424988407],
            [-11.667151575621888, 11.422581511544962],
            [-11.56409225853998, 11.401747306871712],
            [-11.461041489230665, 11.3808744789295],
            [-11.401347885363052, 11.369453809291965],
            [-11.34165683915575, 11.35802023329235],
            [-11.28196837672188, 11.346573754791748],
            [-11.222282524171902, 11.335114377637257],
            [-11.145826365868489, 11.321876652720807],
            [-11.074250622925677, 11.308715576131302],
            [-11.002678353814314, 11.295536007647431],
            [-10.889266707771437, 11.275423877411596],
            [-10.775863225754021, 11.255265434142297],
            [-10.670392769569458, 11.237028438678035],
            [-10.564929133665556, 11.218751468048708],
            [-10.459472461037508, 11.200434541603911],
            [-10.354022894712793, 11.182077678560589],
            [-10.294413758659507, 11.172062073915598],
            [-10.234806756248592, 11.162033734896283],
            [-10.175201913254122, 11.151992664866606],
            [-10.115599255453182, 11.141938867176846],
            [-10.037335111285133, 11.128373288509971],
            [-9.95907508711361, 11.114785752165774],
            [-9.873669281367565, 11.100552725020343],
            [-9.788268037684857, 11.086293610330246],
            [-9.712535847277394, 11.074297903785139],
            [-9.636806887940693, 11.062281735295489],
            [-9.549561144277897, 11.048692506520705],
            [-9.462319614702976, 11.035076152823676],
            [-9.39475330395617, 11.025052420974609],
            [-9.327189270521963, 11.015012453418857],
            [-9.259627551656937, 11.004956254516847],
            [-9.192068184631207, 10.994883828607124],
            [-9.12295747568086, 10.984625445176867],
            [-9.053849267199235, 10.974350091784821],
            [-8.984743599100844, 10.964057772993032],
            [-8.915640511306123, 10.953748493338054],
            [-8.799831010134099, 10.93723278987366],
            [-8.684028203619253, 10.920669541453552],
            [-8.612472115214425, 10.91068209238848],
            [-8.540918520404434, 10.900676513308941],
            [-8.469367463381532, 10.890652808960526],
            [-8.397818988345966, 10.880610984059349],
            [-8.3348009207997, 10.871707393966318],
            [-8.271784946260142, 10.862789750580305],
            [-8.208771094940685, 10.853858057069813],
            [-8.145759397051338, 10.844912316584571],
            [-8.082357302626074, 10.836442187882708],
            [-8.018957131519672, 10.827957866290122],
            [-7.913599940698729, 10.814160121116796],
            [-7.808247964434525, 10.80032322295296],
            [-7.725339772437106, 10.789761479076875],
            [-7.642434695157599, 10.7791755180368],
            [-7.555425161201525, 10.768326879418677],
            [-7.4684189828777905, 10.757451593547623],
            [-7.380859626905928, 10.746760361775683],
            [-7.293303604899315, 10.736042169589838],
            [-7.205750997464919, 10.725297024384929],
            [-7.118201885213589, 10.714524933486281],
            [-7.032022084085181, 10.704687606408733],
            [-6.945845197509066, 10.694824218912567],
            [-6.830985714595906, 10.681631704342673],
            [-6.716131733028775, 10.66839291823629],
            [-6.599953499791415, 10.655379899614557],
            [-6.48378081545104, 10.642319589530985],
            [-6.412940202186023, 10.63475675396134],
            [-6.34210148880922, 10.627176356649963],
            [-6.271264717853027, 10.619578400985429],
            [-6.200429931851826, 10.611962890326208],
            [-6.128068168385535, 10.604727651421557],
            [-6.055708192905366, 10.597474117394441],
            [-5.983350050668083, 10.590202291679523],
            [-5.91099378693774, 10.582912177678905],
            [-5.826174428865965, 10.574408111553913],
            [-5.7413577366953135, 10.565878925487256],
            [-5.661953491768343, 10.55831295912168],
            [-5.582551385581249, 10.55072499993505],
            [-5.50315147788977, 10.543115052137518],
            [-5.423753828450328, 10.535483119890914],
            [-5.3482822414765145, 10.528805680297609],
            [-5.272812387166984, 10.52210840161842],
            [-5.159571537631471, 10.512349783281037],
            [-5.0463345377645, 10.502546528605084],
            [-4.961473913854218, 10.49544749891862],
            [-4.876615406855657, 10.488323418964386],
            [-4.8894667416146484, 10.340695202060454],
            [-4.907136838346149, 10.125637333479574],
            [-4.909778323417601, 10.099870093006622],
            [-4.927375147087052, 9.881325015571035],
            [-4.936984965080938, 9.767146073595049],
            [-4.9594773459409245, 9.489249088659326],
            [-4.967107759192593, 9.382604828306123],
            [-4.977834424493673, 9.270298449419618],
            [-4.9971840522145285, 9.05199063733067],
            [-5.013150156636403, 8.87584353585659],
            [-5.030943725876586, 8.664236913858169],
            [-5.0566700652987775, 8.373313634066358],
            [-5.083127726587173, 8.057808441352563],
            [-5.095477674361352, 7.9172008454216245],
            [-5.115714310795587, 7.678931337546151],
            [-5.127347619893428, 7.555964166628073],
            [-5.131026307445941, 7.501735889876537],
            [-5.145543324027559, 7.308769559680804],
            [-5.161310507585421, 7.11893167967082],
            [-5.1755613336562964, 6.937139115999535],
            [-5.189214905096545, 6.77745491789973],
            [-5.207074053444822, 6.564602139308387],
            [-5.219909595290242, 6.5652203539821645],
            [-5.292062671249941, 6.5716573885650815],
            [-5.3642170230129205, 6.578080724676638],
            [-5.493699618838805, 6.589905183316107],
            [-5.623186374359991, 6.601685500844445],
            [-5.713792111421712, 6.6106240010079],
            [-5.80440012990138, 6.619540855058967],
            [-5.902816760227784, 6.62891484048777],
            [-6.001235845900673, 6.638263293955803],
            [-6.072261035538543, 6.645236085138587],
            [-6.143287549235818, 6.652195569808911],
            [-6.2335414134180684, 6.661276795770672],
            [-6.32379746858681, 6.670336521718875],
            [-6.423873844001274, 6.680520768844948],
            [-6.523952901629506, 6.690678569883938],
            [-6.5352102314776825, 6.685099155015122],
            [-6.653010689099084, 6.697743282735279],
            [-6.770815138964442, 6.7103507446394515],
            [-6.878582045795893, 6.722680111970551],
            [-6.986352620084179, 6.734978741806166],
            [-7.096403734849928, 6.7479310856654156],
            [-7.206458781999854, 6.760851341550511],
            [-7.276616051793791, 6.769269160244814],
            [-7.346774946556772, 6.777673927957929],
            [-7.376227991703441, 6.784347896902717],
            [-7.501055611899121, 6.799978416776538],
            [-7.625888663513288, 6.815567543881694],
            [-7.725549148981749, 6.8268822104901465],
            [-7.858444967713633, 6.843343351158536],
            [-7.991346586728802, 6.859757562387052],
            [-8.084626694349243, 6.871500131971603],
            [-8.177909679929085, 6.883219562910048],
            [-8.263222303283287, 6.894062611191682],
            [-8.348537331889501, 6.904886294493064],
            [-8.466672587969116, 6.9210127927581615],
            [-8.536485680535135, 6.930329655955122],
            [-8.606300494700708, 6.939633527082069],
            [-8.676117013268803, 6.948924404445689],
            [-8.74593521903593, 6.958202286419536],
            [-8.75932810005148, 6.966330868063272],
            [-8.828661906199859, 6.975712230266818],
            [-8.897997405359439, 6.9850807588664],
            [-9.001851616555802, 6.998557354547006],
            [-9.10570924734232, 7.012005182372292],
            [-9.219811266666012, 7.027329686697665],
            [-9.264712855845099, 7.035271077254399],
            [-9.362521693581748, 7.049806329905938],
            [-9.460334365955456, 7.064315940003274],
            [-9.515396190140608, 7.065896914407765],
            [-9.586249846965135, 7.076914903445543],
            [-9.614126079913653, 7.083439994173625],
            [-9.671342462016028, 7.091906392499655],
            [-9.699187851365464, 7.090288757096232],
            [-9.728865541987334, 7.093991184240547],
            [-9.804433529884394, 7.105256197427408],
            [-9.880003726127113, 7.116505903548283],
            [-9.938411368329165, 7.1343299780456855],
            [-10.030623403050514, 7.14886234673704],
            [-10.12283903070833, 7.163371842579349],
            [-10.144936273838875, 7.025408051675661],
            [-10.175059913337176, 6.834662304207684],
            [-10.203932989888141, 6.649873288870813],
            [-10.236517862307322, 6.664502318974822],
            [-10.25545121301433, 6.679971402017791],
            [-10.258382864585549, 6.697303392802676],
            [-10.25082597964994, 6.711803613876385],
            [-10.263894052026098, 6.716452056416609],
            [-10.267939335914193, 6.7284853414032995],
            [-10.281904257602521, 6.739408602651247],
            [-10.279815379358208, 6.7535413158193665],
            [-10.29310795661757, 6.762389344857309],
            [-10.311153546587786, 6.76656927140385],
            [-10.313886407250365, 6.804992469455599],
            [-10.298784944877477, 6.809851428300737],
            [-10.32498555104662, 6.856973272077976],
            [-10.331216663833093, 6.876452383034043],
            [-10.34114855588813, 6.886201075647402],
            [-10.339173811906603, 6.896963182502242],
            [-10.363091040246179, 6.93218244668363],
            [-10.37650846951126, 6.928330478335642],
            [-10.381862579525464, 6.944353019135934],
            [-10.398558971845056, 6.957272073911767],
            [-10.406827643559234, 6.930100259121167],
            [-10.420541973673558, 6.918882879474445],
            [-10.431149801063777, 6.930641073269755],
            [-10.456405331852011, 6.9274607380650375],
            [-10.475121973502121, 6.917508348911679],
            [-10.468243064824227, 6.882447352893393],
            [-10.48803550841032, 6.8629164164737215],
            [-10.502713267954046, 6.865048932120725],
            [-10.495937510685694, 6.846556649102842],
            [-10.506408867665183, 6.841775670720158],
            [-10.51537284961723, 6.827930063100961],
            [-10.513950291555027, 6.804463969311822],
            [-10.503974591057013, 6.793072770950776],
            [-10.509924913819253, 6.78354322593906],
            [-10.492665337033428, 6.774537381126656],
            [-10.493772083938714, 6.760740184861166],
            [-10.51952198463794, 6.759828094712955],
            [-10.523593813777852, 6.7714385885017325],
            [-10.565302563127888, 6.79320244116605],
            [-10.58592492162464, 6.782580810304149],
            [-10.599256746053456, 6.789317163223058],
            [-10.648288423089268, 6.803854694558725],
            [-10.659034576991406, 6.789207114291659],
            [-10.68103108145045, 6.79022873315239],
            [-10.711260345453683, 6.777926624966925],
            [-10.72480974441672, 6.780257132173658],
            [-10.739000389145307, 6.767754465811009],
            [-10.750700951669408, 6.787103068653971],
            [-10.764162087899845, 6.827062391114138],
            [-10.785676435336445, 6.824632368127338],
            [-10.82041927424954, 6.829203044653269],
            [-10.843857953923061, 6.81248977514787],
            [-10.863045494787752, 6.818334807732635],
            [-10.880771586401272, 6.829629977048286],
            [-10.883561989742192, 6.812011275490839],
            [-10.908258822579189, 6.824448022087643],
            [-10.92605036180743, 6.820499417443816],
            [-10.933387620565263, 6.812500165716844],
            [-10.949334118546329, 6.823272471879606],
            [-10.955076721634809, 6.835294448006469],
            [-10.974099791977006, 6.840318732820604],
            [-10.989054426207069, 6.834320355364688],
            [-11.013737254412606, 6.849095222332264],
            [-11.015585930179423, 6.870204839660378],
            [-11.033692882301853, 6.880571460512332],
            [-11.054528995514469, 6.88142518687184],
            [-11.07591739083191, 6.869883204688884],
            [-11.082800216948723, 6.856496347469141],
            [-11.10792395911393, 6.857319321751097],
            [-11.112387487574894, 6.851229191258018],
            [-11.116896453314979, 6.8159188695835855],
            [-11.131035503405226, 6.790629959468113],
            [-11.145508665618832, 6.775066078474238],
            [-11.1657206341356, 6.784069430421736],
            [-11.201561349463656, 6.81647954985987],
            [-11.210767628802673, 6.809690030584587],
            [-11.23001656609923, 6.8169248746829645],
            [-11.253489416763676, 6.83090303966451],
            [-11.278959820364456, 6.831940047797052],
            [-11.289275112872703, 6.843448269084902],
            [-11.309272514893081, 6.838958324173261],
            [-11.310963396781695, 6.847598780257809],
            [-11.33322642756243, 6.846659528970163],
            [-11.348696766534895, 6.861436636255178],
            [-11.368965445194837, 6.871248540389615],
            [-11.385434341028484, 6.860715731314768],
            [-11.414976603922257, 6.859434840396406],
            [-11.431406218498207, 6.839372635366805],
            [-11.456818101579511, 6.822043782812362],
            [-11.467420012990676, 6.807218122479511],
            [-11.45805942780618, 6.789025794654295],
            [-11.457352461019587, 6.757805198153388],
            [-11.483132392921318, 6.743431936079562],
            [-11.504797674479184, 6.769211633580699],
            [-11.50703519066924, 6.795809438117822],
            [-11.516174197596364, 6.790941025145507],
            [-11.533219710385133, 6.80836285568331],
            [-11.546884352543616, 6.814985487700314],
            [-11.563828402726877, 6.834326127167483],
            [-11.578228662591027, 6.857305672640394],
            [-11.576179911397347, 6.875076504887013],
            [-11.585665546062462, 6.901577920892337],
            [-11.57444260551566, 6.919826785136119],
            [-11.5666217295858, 6.92240589863123],
            [-11.577487691031427, 6.942423840272524],
            [-11.591232352235403, 6.955288914691211],
            [-11.581253158672748, 6.970482013261701],
            [-11.599294544488316, 6.9878650929442845],
            [-11.594853405979018, 6.994518165687854],
            [-11.60987442995015, 7.010448223308678],
            [-11.59828564129504, 7.022990684912883],
            [-11.585194875885431, 7.025310247359332],
            [-11.57798886140753, 7.042554382860521],
            [-11.585626516800337, 7.056366280245697],
            [-11.581857192951897, 7.085538662213781],
            [-11.590561803135328, 7.09174255050152],
            [-11.60033695463146, 7.116598987291434],
            [-11.596404401152464, 7.139301574393072],
            [-11.616070762538405, 7.173898392044972],
            [-11.60965372124556, 7.185801729118788],
            [-11.640363674751603, 7.205635677183107],
            [-11.657068626037884, 7.230760830032165],
            [-11.67607435632909, 7.239107621855792],
            [-11.680593505841363, 7.248812025108435],
            [-11.705807854891638, 7.242703731237417],
            [-11.722660830138295, 7.233086332248042],
            [-11.75259269312255, 7.223732689107966],
            [-11.75742107917471, 7.259943750109545],
            [-11.773880989574318, 7.280852813710135],
            [-11.799795444018725, 7.2856644504813195],
            [-11.801743650883111, 7.302857303548503],
            [-11.818007681279559, 7.317180136488832],
            [-11.818368495158978, 7.338799526192695],
            [-11.828492804255665, 7.349222300661018],
            [-11.821686837515458, 7.362348444236797],
            [-11.832543797606762, 7.379591866113598],
            [-11.83414827503442, 7.397207695103493],
            [-11.820382883445939, 7.4033797177956595],
            [-11.80997335687901, 7.398991523188195],
            [-11.79295250482337, 7.408279312068289],
            [-11.787381079532215, 7.446774506138192],
            [-11.78011846518471, 7.453562896454052],
            [-11.785215017856833, 7.467999471871057],
            [-11.78114681746784, 7.480124391804987],
            [-11.780474628020913, 7.5059610343062255],
            [-11.802747842023134, 7.5144808811552535],
            [-11.8019546570105, 7.525545857913438],
            [-11.823291538650569, 7.547686203303013],
            [-11.808683807004822, 7.561622064137999],
            [-11.812349001091455, 7.570049249599566],
            [-11.838566831498706, 7.57106857477292],
            [-11.853572463873304, 7.592498447535089],
            [-11.852775862699243, 7.6093446748674065],
            [-11.859285602711395, 7.629139887850836],
            [-11.854455169675447, 7.645821207266224],
            [-11.880384489276931, 7.6796542611673155],
            [-11.8894686959002, 7.710044160033959],
            [-11.90237132231305, 7.720771076449287],
            [-11.90938715211241, 7.736015957918373],
            [-11.898397361449224, 7.749971187821361],
            [-11.914553101133249, 7.7748892440759],
            [-11.917800081777253, 7.790410608619091],
            [-11.928831808256769, 7.805155031300246],
            [-11.92739283469217, 7.820642339237318],
            [-11.917954356447188, 7.8307018244896],
            [-11.914434949390396, 7.866990086461687],
            [-11.922639416570517, 7.8790907301145285],
            [-11.939216627373677, 7.885942705593413],
            [-11.93905439542882, 7.896281193711601],
            [-11.925674909796312, 7.904468266905343],
            [-11.935747254774036, 7.914031168051784],
            [-11.936559593722016, 7.934985427962964],
            [-11.928862568674049, 7.948399814627018],
            [-11.915661677842019, 7.956324450878467],
            [-11.918167327738162, 7.990578488620367],
            [-11.937288926854588, 8.003137992236471],
            [-11.959280493490875, 8.004615560366615],
            [-11.940351222760162, 8.04153448230956],
            [-11.922380301060628, 8.059748532853062],
            [-11.925596630707858, 8.081174342990296],
            [-11.934518548673621, 8.092237749189001],
            [-11.94828323007351, 8.095115249964769],
            [-11.958719228143469, 8.108361068182925],
            [-11.97671933600999, 8.105552568787918],
            [-11.98826891174407, 8.111918255160756],
            [-11.97838473715368, 8.132015060068547],
            [-11.992329537332019, 8.149222314105948],
            [-11.998697520916524, 8.188620031149895],
            [-12.012375917028882, 8.185554299612223],
            [-12.01963654814375, 8.199564258588465],
            [-12.034961059873773, 8.202983498788873],
            [-12.054127223996293, 8.196073182104037],
            [-12.063074469877094, 8.180649972298488],
            [-12.057109097356392, 8.167093129303625],
            [-12.062293619121803, 8.153040965189355],
            [-12.072352396851263, 8.154645109384832],
            [-12.087975642929072, 8.142012793571796],
            [-12.099259587371327, 8.139386698945865],
            [-12.112483356017757, 8.124881099147817],
            [-12.115673798002808, 8.111066599403184],
            [-12.128231830868875, 8.103380342842662],
            [-12.145065976246183, 8.104133312291705],
            [-12.160260566537994, 8.079515967888918],
            [-12.192038832896731, 8.079224962195871],
            [-12.210741094032882, 8.067561330420352],
            [-12.22494910243761, 8.08066568187739],
            [-12.239596341320182, 8.083029264854138],
            [-12.242573276448521, 8.06317757819801],
            [-12.257365004080935, 8.037331150780329],
            [-12.27313096961187, 8.023602205197497],
            [-12.315301602313474, 8.01056516658213],
            [-12.321921796816222, 8.012440392852728],
            [-12.33102160520019, 8.045783908672425],
            [-12.343812447845444, 8.059415585554122],
            [-12.363120419898625, 8.070895665569726],
            [-12.367923540379117, 8.091817823735331],
            [-12.387801692951157, 8.111681700769791],
            [-12.385781958277839, 8.126573772567331],
            [-12.409428572359277, 8.126110753576267],
            [-12.426589931280418, 8.144933939698142],
            [-12.446492640882168, 8.134900094284301],
            [-12.445112000023459, 8.16212978271172],
            [-12.42696848083826, 8.182278832065037],
            [-12.439346956666332, 8.209438206023638],
            [-12.419916236630739, 8.223762709896421],
            [-12.408294486325149, 8.220563382640153],
            [-12.388267787524999, 8.237074134127901],
            [-12.384849495789291, 8.260706653274113],
            [-12.378927907184375, 8.268976202506252],
            [-12.381357072431214, 8.28820344525805],
            [-12.395606760924816, 8.297008419413443],
            [-12.406249396568262, 8.31456813198414],
            [-12.40159221462451, 8.32923550786627],
            [-12.414027763744167, 8.346648105624471],
            [-12.367964589915935, 8.391875033506185],
            [-12.360919479573184, 8.409035925995251],
            [-12.332914885037653, 8.409567747545617],
            [-12.309097280151601, 8.41609096778472],
            [-12.291407820663485, 8.402371003891343],
            [-12.283755924574644, 8.42055726541216],
            [-12.271266440058394, 8.42852037157611],
            [-12.272160521080579, 8.447415435319801],
            [-12.282464477843908, 8.460182905274284],
            [-12.290196493730217, 8.486410791449059],
            [-12.266259195452637, 8.503813740499712],
            [-12.268733875592275, 8.524348811971791],
            [-12.291394552729827, 8.538294595509642],
            [-12.296209759052903, 8.549310179873137],
            [-12.308531432889396, 8.54655284812359],
            [-12.315671523120253, 8.559415740608689],
            [-12.30409049102296, 8.566631534546895],
            [-12.305537907061218, 8.584389738484953],
            [-12.323621285139165, 8.58935963957055],
            [-12.310143377222202, 8.60740125566267],
            [-12.291932419971696, 8.61334079958506],
            [-12.278891132470822, 8.646977962722671],
            [-12.285944581739113, 8.663828708592654],
            [-12.295819382519769, 8.666062163620603],
            [-12.314566227755176, 8.681205035532866],
            [-12.314930734135752, 8.702706528724844],
            [-12.303272812253828, 8.720455005216909],
            [-12.284812415773613, 8.718272042486197],
            [-12.277327906948917, 8.709846788537984],
            [-12.254337880475024, 8.71874399116821],
            [-12.246888123378936, 8.746492914075779],
            [-12.245501840338399, 8.784146828419697],
            [-12.25422501300172, 8.792276619389442],
            [-12.25344549862711, 8.811185072451206],
            [-12.227428097032698, 8.816749896916324],
            [-12.220552640020514, 8.82246295330656],
            [-12.21996043557088, 8.844929065242816],
            [-12.201721435556472, 8.870906893389785],
            [-12.193468426596782, 8.899095402087863],
            [-12.1971613241061, 8.92209203343545],
            [-12.16734553247693, 8.940310472197064],
            [-12.164127737636194, 8.956072046493379],
            [-12.15268580900441, 8.969176417671383],
            [-12.154311899605958, 8.98746560128001],
            [-12.165294242045638, 9.008031996303615],
            [-12.159995853201256, 9.030185497403707],
            [-12.143599762529549, 9.026572531021307],
            [-12.12641304485442, 9.029261509532775],
            [-12.11822056135098, 9.03822721596504],
            [-12.120412119818468, 9.049943204178328],
            [-12.114685433585086, 9.07181561649985],
            [-12.10000779252977, 9.089123044904522],
            [-12.105242940065152, 9.107416899247632],
            [-12.086731912170146, 9.125453521099143],
            [-12.07885476397248, 9.160256937965762],
            [-12.08440793215696, 9.17478438978812],
            [-12.099683230704365, 9.185506039070459],
            [-12.146170845137062, 9.186432105600588],
            [-12.165193226458571, 9.178867430032481],
            [-12.18056518775168, 9.164145751871555],
            [-12.232107293939885, 9.187132854707963],
            [-12.247771681135818, 9.188831393408645],
            [-12.258890940489907, 9.180878231988462],
            [-12.278552601204899, 9.190574896982188],
            [-12.279526115374752, 9.20974373815252],
            [-12.289204615105504, 9.213138889712123],
            [-12.289351486344591, 9.232938397337664],
            [-12.274446466746346, 9.242497605501276],
            [-12.271527281035628, 9.262131182334063],
            [-12.293177699333476, 9.293738505626726],
            [-12.318135758595634, 9.293280997531562],
            [-12.328587748122176, 9.278856956244427],
            [-12.34920740246797, 9.277548472375035],
            [-12.360724298757832, 9.264993524744126],
            [-12.381814689206816, 9.284167044768276],
            [-12.36508028614626, 9.303828618298713],
            [-12.35730875875097, 9.325581184735483],
            [-12.381456360522382, 9.3543724461361],
            [-12.395903117960618, 9.3579871906414],
            [-12.414078323028901, 9.393228399466045],
            [-12.429446167275206, 9.391195879844977],
            [-12.448619828671912, 9.412676563991003],
            [-12.448601269214128, 9.440588208774454],
            [-12.460509759309318, 9.449095862484505],
            [-12.446147369310157, 9.462010187152964],
            [-12.445543571403281, 9.482461128535686],
            [-12.433636800943987, 9.501550610613158],
            [-12.455321327884292, 9.517550368893506],
            [-12.466484635168314, 9.538684556120664],
            [-12.474216542309255, 9.562885095001743],
            [-12.505235212910476, 9.578435076846944],
            [-12.513990753559568, 9.593970781688753],
            [-12.51083979046558, 9.624250370850765],
            [-12.51753578595338, 9.645554205667999],
            [-12.52728699651372, 9.649144119451364],
            [-12.542131460540492, 9.673691897219944],
            [-12.544414238536994, 9.70720910265365],
            [-12.562038316132622, 9.71593828572163],
            [-12.566855727645686, 9.739182471016461],
            [-12.586993491659154, 9.762858538833678],
            [-12.60085196923587, 9.76739609780128],
            [-12.607587071948663, 9.799742150559583],
            [-12.62357457234051, 9.804780906262515],
            [-12.631196224284869, 9.81630109600884],
            [-12.621423060772843, 9.830878457096288],
            [-12.62313322525833, 9.846736798418247],
            [-12.633351825444489, 9.856603494716287],
            [-12.633485100979714, 9.879668139285783],
            [-12.643481093152827, 9.888250482797371],
            [-12.656679902810486, 9.887706722215507],
            [-12.672374471898918, 9.89892255519309],
            [-12.691005863590679, 9.899662272066028],
            [-12.69712175142988, 9.916593085696478],
            [-12.71841790622858, 9.918987288290205],
            [-12.722930789705286, 9.928766222115664],
            [-12.738590530118, 9.934282496817632],
            [-12.761754312205056, 9.948869077326535],
            [-12.76575859650272, 9.99759645924637],
            [-12.78132361211196, 10.009467988189337],
            [-12.780708381825102, 10.020871650737286],
            [-12.805438416382366, 10.040875465552926],
            [-12.822210363718684, 10.03938955975083],
            [-12.827137173050296, 10.063249468551282],
            [-12.84724778606104, 10.082539606199814],
            [-12.86049112248291, 10.085347868608219],
            [-12.864652256327188, 10.096517838759548],
            [-12.89025586283086, 10.099977912401949],
            [-12.879029891385276, 10.115459498448887],
            [-12.838581972596572, 10.12248084246898],
            [-12.82908715240321, 10.116515094721262],
            [-12.803558785702796, 10.117874174697205],
            [-12.795253926497296, 10.137903633118654],
            [-12.813246911770822, 10.138114021971148],
            [-12.816177700443589, 10.149551727398121],
            [-12.829119637559291, 10.148369632257625],
            [-12.83787991546913, 10.188493183771925],
            [-12.861034826930387, 10.21199243767266],
            [-12.860550600192017, 10.22249636992535],
            [-12.807939523276978, 10.25455770108569],
            [-12.812124400188987, 10.263548052609664],
            [-12.806191429933772, 10.282313499308774],
            [-12.812881556804752, 10.294751782227213],
            [-12.826263827908397, 10.305012289833838],
            [-12.827775900663351, 10.3177137639989],
            [-12.817364598820491, 10.334014061680357],
            [-12.810496701287882, 10.35405214867841],
            [-12.814283133429313, 10.365295796319902],
            [-12.829625790390343, 10.382409035694486],
            [-12.839683669515782, 10.383240190233915],
            [-12.844039425342606, 10.396180295977558],
            [-12.83921632768557, 10.407661954548988],
            [-12.851307259070744, 10.425916438224352],
            [-12.866434611690336, 10.423202213709677],
            [-12.874578322636678, 10.457681411536043],
            [-12.866880334759246, 10.485683380515468],
            [-12.868410057052975, 10.49641809889102],
            [-12.879817171958244, 10.508366203163028],
            [-12.884227265063982, 10.523704935715635],
            [-12.898342032637608, 10.520370861617677],
            [-12.907223238412307, 10.536499199681652],
            [-12.92667373131878, 10.593869149135099],
            [-12.937202503292704, 10.601498858119832],
            [-12.956782560899585, 10.661766479854085],
            [-12.96826225472624, 10.668390399771264],
            [-12.909140920687676, 10.939095647239535],
            [-12.86364688904887, 11.148264070979408],
            [-12.799352625964639, 11.442468199108323],
            [-12.756033191784057, 11.640698765202629]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.64503482859479,
          "lat": 47.033481358649674
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "00767982"
      },
      "bbox": [
        -12.96826225472624, 6.564602139308387, -4.876615406855657,
        11.640698765202629
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.084306113134627, -3.0523042324662346],
              [-18.070551723017534, -3.060529240527774],
              [-18.037142741302603, -3.0682917555576066],
              [-18.01421394750892, -3.0932753760204377],
              [-18.00878338720114, -3.106955202571454],
              [-17.99306085703871, -3.105613458012295],
              [-17.968297787050055, -3.131634758568214],
              [-17.950766377164538, -3.13755043874186],
              [-17.92136941761598, -3.162564929766034],
              [-17.90500188078029, -3.2036446256943],
              [-17.881055006603265, -3.2498380798510027],
              [-17.882633806141463, -3.2747373743001713],
              [-17.901545321995187, -3.2818451839285303],
              [-17.93660159255834, -3.251765734350582],
              [-17.963524906959393, -3.2438359999009494],
              [-17.990463272483986, -3.2404081032925203],
              [-18.00830603397705, -3.2283645464847215],
              [-18.02026651895253, -3.1998164366273376],
              [-18.0060983368935, -3.163817843984826],
              [-18.005041092023642, -3.132187754321574],
              [-18.021206791852567, -3.1181155710778534],
              [-18.040731364663124, -3.1082962015629994],
              [-18.06178022451504, -3.1034484769555406],
              [-18.084306113134627, -3.0523042324662346]
            ]
          ],
          [
            [
              [-18.194916059568243, -3.4863529496941776],
              [-18.169765791603837, -3.4908670468714833],
              [-18.16274153418999, -3.502371215887627],
              [-18.16241469603496, -3.5211926450819866],
              [-18.156120456282835, -3.5406329419647293],
              [-18.13855755087414, -3.576829114161061],
              [-18.121767237988582, -3.616907383426859],
              [-18.10944648993883, -3.627856894054149],
              [-18.101680639149592, -3.6452333123755647],
              [-18.04851568605499, -3.7218883301454],
              [-18.03705340874898, -3.7433457319120462],
              [-18.066378684848658, -3.7308069372539863],
              [-18.10467866456033, -3.7472337997536513],
              [-18.107498149671557, -3.7318856570791707],
              [-18.118646206396825, -3.7236715553272357],
              [-18.132772518938772, -3.7003120409463195],
              [-18.15294863826954, -3.6824223556936655],
              [-18.151702765281726, -3.6556676752923094],
              [-18.160304460892736, -3.6460077108407165],
              [-18.16439098571553, -3.6246126575754274],
              [-18.17219595084623, -3.6169165453234635],
              [-18.171445543221914, -3.5808215355618813],
              [-18.1844042562592, -3.549501608433362],
              [-18.18597114223821, -3.5097619534409907],
              [-18.198787702308973, -3.503129536320809],
              [-18.194916059568243, -3.4863529496941776]
            ]
          ],
          [
            [
              [-18.91592300786711, -3.0536125634696334],
              [-18.905569139063527, -3.063867761607544],
              [-18.875195948818455, -3.056814908841908],
              [-18.848192295022212, -3.083970236144109],
              [-18.82737062345269, -3.0986824904034953],
              [-18.812787975990783, -3.1285098040406267],
              [-18.81886754595283, -3.138719812135345],
              [-18.845507059897322, -3.137578869648442],
              [-18.877819927361795, -3.120865867702104],
              [-18.902278645189504, -3.1047806684534174],
              [-18.919278857459553, -3.0740488904585086],
              [-18.91592300786711, -3.0536125634696334]
            ]
          ],
          [
            [
              [-19.00365613482785, -2.2201248237387485],
              [-18.990706360424014, -2.2052108851469363],
              [-18.942960024280897, -2.223680188417152],
              [-18.92079989421667, -2.2413116777986892],
              [-18.916825004135216, -2.2493929419141705],
              [-18.8681186248306, -2.2557684355132848],
              [-18.851439647775045, -2.2732678646601796],
              [-18.83466629170415, -2.28047252972228],
              [-18.819721737311298, -2.308648413788733],
              [-18.794206696463796, -2.315005620131171],
              [-18.782487985171187, -2.3249908696977233],
              [-18.767001669557978, -2.3255016902058654],
              [-18.751258167263742, -2.3138156529729064],
              [-18.739395770894372, -2.298184222216467],
              [-18.71195477519681, -2.299127306318298],
              [-18.708590598387318, -2.306710990371157],
              [-18.689342222826205, -2.319514225851094],
              [-18.712087460152098, -2.350825701771947],
              [-18.72522623574316, -2.3578251994677806],
              [-18.75038591757249, -2.3575005127840694],
              [-18.809262475515016, -2.346538778715387],
              [-18.848472828874623, -2.3550132405948974],
              [-18.85671420336327, -2.3598692562219705],
              [-18.884647118538123, -2.3503414587603126],
              [-18.917103225017033, -2.346733191399752],
              [-18.93970468077674, -2.340333590283724],
              [-18.947801561586783, -2.329141254642938],
              [-18.961713857543984, -2.326617692493624],
              [-18.978514043622045, -2.309073030148816],
              [-18.98232080028453, -2.2787765397494986],
              [-18.96793051514705, -2.258037552240458],
              [-18.993115720639917, -2.224271176340887],
              [-19.00365613482785, -2.2201248237387485]
            ]
          ],
          [
            [
              [-19.272626494422273, -2.2100571344193107],
              [-19.24813112528436, -2.208228213744031],
              [-19.229367059250833, -2.219438770761964],
              [-19.20569649799255, -2.221496342728991],
              [-19.17612742941644, -2.210583445775684],
              [-19.16114434044042, -2.220938535202377],
              [-19.12697391226735, -2.2249890316902032],
              [-19.108896731308175, -2.215880778698761],
              [-19.099948036362523, -2.220192819170456],
              [-19.111289152782543, -2.240635459030646],
              [-19.111618700295974, -2.2544113007832105],
              [-19.098547304939235, -2.2722042219019554],
              [-19.0827033436086, -2.2831438029692555],
              [-19.062525582356077, -2.2866181663047374],
              [-19.06801626234779, -2.32546413721989],
              [-19.089992123632086, -2.320765350752021],
              [-19.124743800389197, -2.3294479373847894],
              [-19.13564400790422, -2.3370452923418177],
              [-19.16976276036834, -2.333763382862083],
              [-19.19793345127868, -2.3405285218701914],
              [-19.235388788070036, -2.2972343481189754],
              [-19.23899038077494, -2.2757972414994225],
              [-19.24482828753011, -2.2695899791772454],
              [-19.254576625832456, -2.230280124691905],
              [-19.272626494422273, -2.2100571344193107]
            ]
          ],
          [
            [
              [-19.424101780339303, -2.137394177036526],
              [-19.39112320037811, -2.1244375743879553],
              [-19.372492200849724, -2.1324135888568314],
              [-19.344320463028563, -2.1178711894751325],
              [-19.3389105647563, -2.1468513342167164],
              [-19.32571037422604, -2.1476811373927203],
              [-19.311755427086418, -2.171656797507739],
              [-19.322202687044296, -2.1800925208323543],
              [-19.336006782161192, -2.1744408127086947],
              [-19.355705521704813, -2.175290686850815],
              [-19.392241883917475, -2.1478407825727337],
              [-19.408326962236476, -2.1506689293244925],
              [-19.424101780339303, -2.137394177036526]
            ]
          ],
          [
            [
              [-19.945725968540472, 2.009173105168503],
              [-19.931413968452176, 2.016308255908672],
              [-19.925764751332988, 2.0040359763365028],
              [-19.939906783754772, 1.9993896702583807],
              [-19.945725968540472, 2.009173105168503]
            ]
          ],
          [
            [
              [-20.0491724919578, 6.379574429172973],
              [-19.89995536071786, 6.3319662155021605],
              [-19.78339107485438, 6.296899362166803],
              [-19.708189292705768, 6.275388494610742],
              [-19.65860309265812, 6.258555652504499],
              [-19.633789980372082, 6.256059679012835],
              [-19.506723628968736, 6.219282344156378],
              [-19.43797752796268, 6.1976274954721156],
              [-19.32074373130648, 6.170042656373816],
              [-19.292867598515915, 6.165000059504424],
              [-19.222441030710122, 6.138556042019366],
              [-19.10503848601383, 6.105235995152803],
              [-18.98764323190909, 6.071888262758918],
              [-18.93185720395023, 6.056757407656165],
              [-18.87033470974607, 6.041765408164323],
              [-18.748912674609276, 6.009296014935259],
              [-18.665809229229577, 5.983861182863991],
              [-18.596919077738093, 5.964102493426899],
              [-18.451578300544956, 5.919508331614938],
              [-18.43898483871931, 5.916336840044659],
              [-18.31565010354856, 5.879840479373247],
              [-18.192324107076384, 5.843313453155064],
              [-18.105122663435285, 5.817969990339544],
              [-18.017925489438298, 5.792611276779058],
              [-17.983732131896854, 5.784513515659188],
              [-17.896075494586736, 5.760664288106146],
              [-17.788801553235032, 5.72773554691078],
              [-17.686139527537577, 5.700767374359409],
              [-17.59269904011616, 5.675618504589839],
              [-17.499262971175444, 5.650452409731392],
              [-17.40859041555332, 5.627215129470037],
              [-17.29277824810738, 5.5958838866022],
              [-17.193507793212262, 5.572038983905649],
              [-17.058519470490573, 5.537740661654423],
              [-17.088704651853956, 5.421603307603182],
              [-17.11950966486665, 5.299620218069185],
              [-17.152510418637508, 5.1722254513247075],
              [-17.183292870422193, 5.056919519400809],
              [-17.263133998680175, 4.749787601865479],
              [-17.34107716246633, 4.447161032138295],
              [-17.378074862024775, 4.298712397946405],
              [-17.432613471296893, 4.083048362535021],
              [-17.492640307530067, 3.851700128578866],
              [-17.570829493692116, 3.553654257967657],
              [-17.63256800935863, 3.3260066292912214],
              [-17.679174599492914, 3.1469611325838023],
              [-17.732287980772835, 2.955190160162996],
              [-17.761261340008925, 2.8415689218983595],
              [-17.814662675346472, 2.6203340234148236],
              [-17.687426192609145, 2.4287224273939554],
              [-17.575771650064844, 2.2611351524532313],
              [-17.497761820913187, 2.144401005387673],
              [-17.454833062342598, 2.0782891870143896],
              [-17.292472185833212, 1.8360867480612393],
              [-17.236721357736698, 1.7503753346718052],
              [-17.206400420097147, 1.7067932820593867],
              [-17.10258915523815, 1.5492746316968198],
              [-17.068527302161915, 1.4997310566157698],
              [-17.014459781859927, 1.4161563350887552],
              [-16.985023568589966, 1.3732308278474588],
              [-16.795644527197098, 1.0875599625700407],
              [-16.632170401014083, 0.8420056477863587],
              [-16.590135234360485, 0.7766804670556811],
              [-16.572466442692253, 0.7532800468470736],
              [-16.47529286641765, 0.6037549761748605],
              [-16.45587273548098, 0.5769229116511863],
              [-16.396728219393072, 0.4860480537949266],
              [-16.34756271062745, 0.4140335187434233],
              [-16.273150625501074, 0.30005818291412667],
              [-16.20693403494016, 0.20009519598105377],
              [-16.193930303080325, 0.18195114093287762],
              [-16.08624158736432, 0.0189708554934203],
              [-16.04613676166095, -0.04041047390724319],
              [-15.869390943736642, -0.3076151358634902],
              [-15.733366752325097, -0.5116266975720368],
              [-15.664494780487018, -0.6160733336502936],
              [-15.492629514890622, -0.8744346862173669],
              [-15.3660720735335, -1.0648896876345646],
              [-15.34099718945475, -1.101472543111328],
              [-15.277656174536778, -1.1977517121413346],
              [-15.226382805375513, -1.2732576496415635],
              [-15.121498089559221, -1.4323882376127925],
              [-15.049427726788208, -1.5403690789297793],
              [-14.977344755766865, -1.6483394384825747],
              [-14.859307626511551, -1.8261165553192231],
              [-14.758931362151806, -1.9764192072026208],
              [-14.67145398533461, -2.1068961834177538],
              [-14.573320821003112, -2.2553274498737936],
              [-14.572069763683478, -2.265883024562385],
              [-14.582925197253708, -2.297538049583939],
              [-14.5815977169728, -2.312295687061361],
              [-14.589822743163223, -2.349236976282049],
              [-14.598757211905623, -2.36961036078878],
              [-14.597702811308432, -2.3897000909477075],
              [-14.568726998034679, -2.426955107511587],
              [-14.564187120190345, -2.470349725874871],
              [-14.554908356489399, -2.500345160655224],
              [-14.531966299976931, -2.535806469456806],
              [-14.502069944033751, -2.5650819440431776],
              [-14.493479062771483, -2.6171258320747017],
              [-14.49210038241483, -2.6620011445660943],
              [-14.482594207522277, -2.675158020244231],
              [-14.494989571667682, -2.686742000868969],
              [-14.48691209712598, -2.70483548479356],
              [-14.475313850684529, -2.718473109405281],
              [-14.463498072377606, -2.7617426261888642],
              [-14.46566788757822, -2.78433885520582],
              [-14.482116125146943, -2.8317818769276224],
              [-14.473822050420567, -2.8446617447964657],
              [-14.447979159746177, -2.8450896614008845],
              [-14.437485394112224, -2.8616942813105646],
              [-14.419332712614565, -2.875944455223687],
              [-14.412054199035838, -2.899379286691889],
              [-14.39476131641312, -2.906855452741098],
              [-14.375363186368778, -2.93591814564555],
              [-14.370862168684933, -2.947810484203611],
              [-14.350328740027956, -2.956447153707624],
              [-14.334491390608541, -2.971883850969271],
              [-14.324664407131504, -3.0060201191363434],
              [-14.312236559970387, -3.0234188861312297],
              [-14.316252012331395, -3.04951353758829],
              [-14.31428614860155, -3.064538292273452],
              [-14.3419051860755, -3.063031641539902],
              [-14.345231981401815, -3.0719752809658343],
              [-14.402194608020844, -3.11002406840259],
              [-14.408151598156014, -3.1240875069889906],
              [-14.430352394607835, -3.13320534683086],
              [-14.457704892836222, -3.1312744412265023],
              [-14.48274916987089, -3.152800468437791],
              [-14.494268235288013, -3.158774672601701],
              [-14.513637619818649, -3.1573555129065465],
              [-14.53159941650992, -3.1701316455443243],
              [-14.552629990799925, -3.174725296388512],
              [-14.573538758553752, -3.1731416070453955],
              [-14.592206205001803, -3.1902524719186522],
              [-14.602095000931339, -3.218544930171813],
              [-14.602457985761227, -3.2390905236082586],
              [-14.608082484292819, -3.2535449689402407],
              [-14.629359373438929, -3.272531422706221],
              [-14.669665587978974, -3.3037979159511615],
              [-14.688733044638386, -3.3063644268147105],
              [-14.703712024917493, -3.3249130061541785],
              [-14.704790235682719, -3.334206248924012],
              [-14.688942492436446, -3.3519757840948867],
              [-14.688714828654446, -3.362735083747689],
              [-14.702145340603431, -3.367267334622241],
              [-14.689814757878716, -3.3868720528530107],
              [-14.701727097429812, -3.403227074598222],
              [-14.715237153911477, -3.4038430669462967],
              [-14.712497877282674, -3.435193411567035],
              [-14.721067917937825, -3.4441826429599165],
              [-14.713274261649007, -3.493920665111517],
              [-14.714463914146332, -3.5110379634539948],
              [-14.724105500625134, -3.526339139315011],
              [-14.714254123997069, -3.543708948201072],
              [-14.718527242909149, -3.565670520808613],
              [-14.742939127546856, -3.5721579233950203],
              [-14.752712861551979, -3.5868074090435944],
              [-14.744223154010887, -3.60259394346963],
              [-14.75774685398214, -3.607597198394687],
              [-14.752794627019954, -3.6226535275401686],
              [-14.760911570331906, -3.6321056104606337],
              [-14.755958889133101, -3.646026954182728],
              [-14.774882524743814, -3.6626483831611436],
              [-14.775451568965979, -3.6853379682099874],
              [-14.769526436867833, -3.7038409331853583],
              [-14.801360702104374, -3.718472643081477],
              [-14.805984338808809, -3.733007169568096],
              [-14.834214621993395, -3.745147183383803],
              [-14.843804433124507, -3.7587470390140982],
              [-14.868098148954516, -3.7823679470470277],
              [-14.879135022570033, -3.8092953763686896],
              [-14.892477819963657, -3.8183204639486843],
              [-14.90546751398687, -3.819543032813252],
              [-14.928545738653492, -3.8099323040216553],
              [-14.94162903214115, -3.817119978413222],
              [-14.95663289224271, -3.8146432285836203],
              [-14.960710762723956, -3.8231658161491984],
              [-14.951830425706007, -3.8399222910942874],
              [-14.948748092053442, -3.864093530309266],
              [-14.9550317533971, -3.887562926408804],
              [-14.966281928036278, -3.9021290110579567],
              [-14.986494320363343, -3.9167175321757717],
              [-14.982839016024368, -3.93214749064991],
              [-14.961010023473868, -3.944983359517197],
              [-14.948714900708579, -3.9572734060686563],
              [-14.949509045844176, -3.972037971248918],
              [-14.96370755897438, -3.979812188786074],
              [-14.955413093461134, -4.001678038505525],
              [-14.963228483163919, -4.022707926935471],
              [-14.963327573002369, -4.038320612384662],
              [-14.971172354996858, -4.06259289073525],
              [-14.992179597034163, -4.090909984112708],
              [-15.00785823013727, -4.122368000863964],
              [-15.008533719144268, -4.131724458598869],
              [-14.995083489948724, -4.138619348580276],
              [-14.995995909836541, -4.151812314191665],
              [-14.98833978645223, -4.167454476650753],
              [-14.989255669540114, -4.186908586438872],
              [-14.979470749141317, -4.193106095274455],
              [-14.96229123166331, -4.184778357899276],
              [-14.95588280161195, -4.200618210974646],
              [-14.934695916875471, -4.210583254368341],
              [-14.908509288554217, -4.204282915969066],
              [-14.867698119746844, -4.2191203964215225],
              [-14.858781656166327, -4.234146577003786],
              [-14.854868568909465, -4.28311723549861],
              [-14.837148347290313, -4.284132164406323],
              [-14.839180902322939, -4.30006774100737],
              [-14.85406932567209, -4.318693442975413],
              [-14.844886334174662, -4.343118742141823],
              [-14.845989094416522, -4.354400713365417],
              [-14.861795505491239, -4.409301405606764],
              [-14.886650910640816, -4.426776921037586],
              [-14.901183445769759, -4.430944856293647],
              [-14.92368236184937, -4.452313995273612],
              [-14.92637971002104, -4.486634456301012],
              [-14.937942988756818, -4.491801736765706],
              [-14.958680692626112, -4.487978012453254],
              [-14.975754241477777, -4.499542858815712],
              [-15.001194922946436, -4.494955482060847],
              [-15.007078384501119, -4.500203157930851],
              [-15.062974016304938, -4.479481917463895],
              [-15.072200379500671, -4.469597910450658],
              [-15.09199840085031, -4.493052079178924],
              [-15.209179722196051, -4.479331296812877],
              [-15.326361005699619, -4.465593681268992],
              [-15.464246600620001, -4.4493751628207105],
              [-15.602132202211235, -4.4331331676703964],
              [-15.713575718841039, -4.419737496315605],
              [-15.902935064427197, -4.397770580091412],
              [-16.050942158713255, -4.38015204846618],
              [-16.198949404730094, -4.362505993353271],
              [-16.336316642624162, -4.346418904804011],
              [-16.474051867295753, -4.330167324279988],
              [-16.611787421955466, -4.313891590933679],
              [-16.68411020578842, -4.305710950168735],
              [-16.81741191182218, -4.2896374667918336],
              [-16.950713905495, -4.273541110729467],
              [-17.09949647090371, -4.256216870228566],
              [-17.100004982747052, -4.22283820202333],
              [-17.092742811697125, -4.193402819376709],
              [-17.090998379333797, -4.165464539992524],
              [-17.100645815447322, -4.120985392774624],
              [-17.12242917578885, -4.094556432230231],
              [-17.147899648408284, -4.0917749223196545],
              [-17.16816269277274, -4.10688133018854],
              [-17.169551682385826, -4.0698258225650985],
              [-17.16633576499428, -4.0448238374309415],
              [-17.15611353277886, -4.020442384128638],
              [-17.150626641633337, -3.99138783380706],
              [-17.15119478124118, -3.968664163880095],
              [-17.16356612729738, -3.945936587510364],
              [-17.15933584145051, -3.925175099589556],
              [-17.14448340775769, -3.9227020356450693],
              [-17.128332737004392, -3.8999934895300075],
              [-17.12338814422092, -3.870756988220413],
              [-17.12100022666745, -3.754682699554298],
              [-17.127677972671965, -3.7318078822024536],
              [-17.13026710024984, -3.680591012433713],
              [-17.13532599866845, -3.6435164626901866],
              [-17.14151119694101, -3.619984897667735],
              [-17.175569061710686, -3.5376238365822257],
              [-17.197379123021943, -3.47817362052692],
              [-17.210686709562122, -3.4463570997898767],
              [-17.231596998114615, -3.4035713130152208],
              [-17.258336009647476, -3.3648030143859584],
              [-17.292340069154992, -3.3328536204058334],
              [-17.30544680724634, -3.2950097257077684],
              [-17.31802288991007, -3.274314705996498],
              [-17.343920295764505, -3.245077672244379],
              [-17.356352165337487, -3.2485423825418502],
              [-17.371449269207552, -3.2405907741644713],
              [-17.375662216946605, -3.2153427893863773],
              [-17.40891852819766, -3.147299870024501],
              [-17.43033432688357, -3.1326365657786175],
              [-17.4465460419591, -3.105426102568273],
              [-17.46896793492506, -3.0805211355588646],
              [-17.509706577805943, -3.0562539874785606],
              [-17.516870302167636, -3.0413145831624298],
              [-17.557237794518027, -2.996388710117186],
              [-17.574871647345077, -2.9687570722565937],
              [-17.59535767275326, -2.9284679953727704],
              [-17.610451063280635, -2.904361597569359],
              [-17.65338541417172, -2.8644553941739863],
              [-17.67637611790211, -2.8537563815254265],
              [-17.686304145848602, -2.8609537698357195],
              [-17.686764071280756, -2.8813789143309263],
              [-17.695888468931923, -2.8823542027664364],
              [-17.70823995431781, -2.8664933705370887],
              [-17.7223559155523, -2.8681583964098127],
              [-17.73059877311879, -2.8782352947804917],
              [-17.74911383560873, -2.886557737898238],
              [-17.756287659347812, -2.87912065912686],
              [-17.770459548836797, -2.8821018415544755],
              [-17.7763743499137, -2.8909909104537714],
              [-17.8154497559598, -2.8610359609930796],
              [-17.829955064679236, -2.8449477784304995],
              [-17.845919444845713, -2.837061505406381],
              [-17.866377475741942, -2.8332445919712286],
              [-17.867118444650963, -2.7906687336573777],
              [-17.83831007219723, -2.7746427271111496],
              [-17.827746263957287, -2.7440420262133536],
              [-17.8337552201201, -2.6936214983767264],
              [-17.84785134824462, -2.6120057625198987],
              [-17.87566504070728, -2.545157318428781],
              [-17.902883767463113, -2.5159887674345858],
              [-17.924330294343576, -2.5080022677454386],
              [-17.95610173737823, -2.5058165645511576],
              [-17.998114285383274, -2.4928286865894274],
              [-18.03529580772835, -2.4935963180989202],
              [-18.056988333832788, -2.484579250451468],
              [-18.075929597993927, -2.487781082964262],
              [-18.100216537175505, -2.486650733895152],
              [-18.12205205445818, -2.5027069004161726],
              [-18.130504378760183, -2.485547952245297],
              [-18.152425434183616, -2.4595483484392244],
              [-18.215310632482964, -2.435096061223196],
              [-18.258397995493933, -2.4013384333303356],
              [-18.26777127056146, -2.3981450973119425],
              [-18.286580835976572, -2.3765787919808097],
              [-18.304957852855576, -2.369675992937193],
              [-18.32136128686919, -2.35122134656867],
              [-18.3403729190111, -2.349982802799455],
              [-18.355481258280463, -2.3411327805179836],
              [-18.393550876742484, -2.292079001822241],
              [-18.413977413175306, -2.279627321663323],
              [-18.423228558269724, -2.2465007528119405],
              [-18.432199867123572, -2.1906140660474254],
              [-18.430680143608313, -2.1646155087504937],
              [-18.434022075342554, -2.1492485028974206],
              [-18.451272304198646, -2.1388550264895763],
              [-18.47501892315534, -2.1144159967314984],
              [-18.49406997683513, -2.0796209340779797],
              [-18.510355246736193, -2.076872291740776],
              [-18.533508286481226, -2.0325226942483066],
              [-18.543147529581937, -2.0293738485489516],
              [-18.55268976166838, -2.00820070916503],
              [-18.56154824996692, -2.0043445317354407],
              [-18.607521649040482, -1.971662417444264],
              [-18.624218353502734, -1.9472803462291155],
              [-18.664759400533725, -1.9311138762943967],
              [-18.683525989023767, -1.9318604051764667],
              [-18.709603283657025, -1.9248205767209685],
              [-18.74425858744309, -1.9375217368163056],
              [-18.760238777786554, -1.9329312990583523],
              [-18.80556651447476, -1.8980810044168146],
              [-18.8309229815174, -1.8928201938184248],
              [-18.85587298260485, -1.8959115767790102],
              [-18.87549156072861, -1.8916170858169161],
              [-18.880311033596428, -1.8800656043168524],
              [-18.908240632307862, -1.8539086965641023],
              [-18.929598580310444, -1.8485113674383018],
              [-18.964973666794968, -1.8132953368841385],
              [-18.988573089602237, -1.8040946245532408],
              [-19.02879189897816, -1.7970510311321428],
              [-19.04994284133711, -1.7814555579501599],
              [-19.07533676818722, -1.771382864874811],
              [-19.08985873489887, -1.7712999491930737],
              [-19.134536654146252, -1.7587884423490479],
              [-19.180609694383023, -1.7490998600454764],
              [-19.223225902623305, -1.74396524140065],
              [-19.229234845184422, -1.7463505932785468],
              [-19.281872079173215, -1.7361488810320471],
              [-19.29854723896739, -1.7374104521242768],
              [-19.334895577296138, -1.730017832431448],
              [-19.333483593856116, -1.695782611599696],
              [-19.34260821015649, -1.6784321231697594],
              [-19.34726258558935, -1.6484948542858922],
              [-19.367195526999325, -1.6257400012565741],
              [-19.376068551165368, -1.6212225940380611],
              [-19.393704599268695, -1.6007871370879343],
              [-19.427064370463395, -1.595024253848169],
              [-19.43799340022052, -1.5822056562681797],
              [-19.438663955194965, -1.5679627735981465],
              [-19.42734914069566, -1.54086014494052],
              [-19.408293576568063, -1.5160963632099458],
              [-19.375025014666022, -1.462961205452295],
              [-19.37072297938185, -1.4529003513956227],
              [-19.375342400157603, -1.424494068517338],
              [-19.38247544111042, -1.4149262412645514],
              [-19.381811976324542, -1.3849822602962087],
              [-19.365569842694864, -1.3618107101225823],
              [-19.342510939529408, -1.3163458815457738],
              [-19.341371825153896, -1.2916294355695082],
              [-19.35589237099323, -1.2735191271413946],
              [-19.356859830225417, -1.2516499154411078],
              [-19.373863697531178, -1.2466860864196898],
              [-19.359744042193242, -1.2147008495504272],
              [-19.324764778410607, -1.1539364542841424],
              [-19.30173515211569, -1.0989583446459457],
              [-19.291291902927526, -1.057509031756956],
              [-19.289725416823803, -1.032002732824253],
              [-19.293136927120862, -1.0152386759377785],
              [-19.31344139320028, -1.0003355122990316],
              [-19.327411808096087, -0.9777029733087382],
              [-19.353186638307783, -0.9632480290960802],
              [-19.370289794197937, -0.9626283802315728],
              [-19.378623647289533, -0.9760543785704293],
              [-19.39398925311731, -0.9532140150166868],
              [-19.441248881473104, -0.9104966628718015],
              [-19.462314940921523, -0.8616353713236644],
              [-19.44551313180888, -0.8294973426505653],
              [-19.42703260061294, -0.8078380983073589],
              [-19.40929919594633, -0.7723320254523636],
              [-19.40019306667817, -0.7159955024579314],
              [-19.405296840154378, -0.6865136200677081],
              [-19.41844614305874, -0.6632763242422187],
              [-19.4521010584957, -0.6553370307720133],
              [-19.4634873738478, -0.6395553883310778],
              [-19.48979852647339, -0.6319389333552622],
              [-19.500879129947794, -0.6039942478264975],
              [-19.507892555475877, -0.5970930118739214],
              [-19.542523865352, -0.5255962268314434],
              [-19.55074279204204, -0.4734687596760523],
              [-19.56030850803947, -0.46166180014416347],
              [-19.570270007244186, -0.42774339317041726],
              [-19.585933923789895, -0.41517638397431716],
              [-19.601641664771524, -0.4123209710061952],
              [-19.60885399737057, -0.39965549080555046],
              [-19.623253908116855, -0.39549796831373474],
              [-19.636420501879993, -0.3792747268123345],
              [-19.65611774409606, -0.3727867794048743],
              [-19.652310510797736, -0.3488243604979322],
              [-19.66584518695424, -0.32007981904691246],
              [-19.659583784643335, -0.28911926644754327],
              [-19.662576270284383, -0.27479232248047225],
              [-19.66053406317061, -0.24859721504108984],
              [-19.673760334838583, -0.22293122337698185],
              [-19.69277634088648, -0.1975912345544618],
              [-19.70468117547748, -0.15825987728209437],
              [-19.72122698083691, -0.14426718054924328],
              [-19.73362148848487, -0.11752339071955997],
              [-19.72922776656131, -0.10360074182593766],
              [-19.733185463195802, -0.09114642183776549],
              [-19.727504063560474, -0.07915016762963878],
              [-19.731728481028366, -0.054788871362722306],
              [-19.72910244778813, -0.03336969474377385],
              [-19.73356539014007, -0.003620878040223523],
              [-19.739373486966876, 0.00716037844592311],
              [-19.783318450631292, 0.03840304914297257],
              [-19.78872919891586, 0.06348210837757755],
              [-19.78659110608184, 0.0816181091985497],
              [-19.795495874614396, 0.09090522892254564],
              [-19.800930999938146, 0.10792971786282997],
              [-19.802567209103756, 0.14351077828261102],
              [-19.809949838125057, 0.15346368597061613],
              [-19.82421127029889, 0.1909127389924851],
              [-19.839075419920277, 0.21274709001433761],
              [-19.84757097628208, 0.23419040272809447],
              [-19.89853599226831, 0.2892750946954084],
              [-19.911853071450984, 0.29412971168317825],
              [-19.92386552681628, 0.3136570263540896],
              [-19.928974164830663, 0.34346150774124307],
              [-19.94348725007784, 0.3592829565451933],
              [-19.95737268120001, 0.3826904147780594],
              [-19.943024536907934, 0.4150853323208715],
              [-19.948875507457455, 0.4310058844900089],
              [-19.93904625059241, 0.45531789646246973],
              [-19.943419670648552, 0.4788993537921865],
              [-19.936490835309783, 0.5009334755479934],
              [-19.94107178747977, 0.5309373836487296],
              [-19.936718559982484, 0.5354312488214508],
              [-19.94347226455821, 0.5707803419029317],
              [-19.933537809594043, 0.5843231496686178],
              [-19.934176837918766, 0.5994850275353978],
              [-19.917568873298354, 0.599956142201727],
              [-19.914184159320403, 0.6350016806669351],
              [-19.939907251542582, 0.6549827285718263],
              [-19.920484799119556, 0.6881565398618622],
              [-19.90492326543448, 0.6933411227191832],
              [-19.896289581927164, 0.7105131342262008],
              [-19.887775104949363, 0.7059295631760757],
              [-19.86535320550824, 0.6642731755487793],
              [-19.850705655616093, 0.666136383752418],
              [-19.82087255200858, 0.6875162060694814],
              [-19.797260065771958, 0.7165228921063087],
              [-19.781973183554516, 0.7433779297814853],
              [-19.765434390216154, 0.7929423658756103],
              [-19.73761193265386, 0.8415294905597607],
              [-19.73707836729045, 0.853108789895129],
              [-19.74728000438258, 0.9231913795081006],
              [-19.75952124623773, 0.9813107215084523],
              [-19.76812102759494, 1.0032047757331763],
              [-19.783060478392645, 1.0270827584382125],
              [-19.798542805279048, 1.0410559144242644],
              [-19.816825149326984, 1.0391489143400727],
              [-19.83761661258249, 1.0268368676933644],
              [-19.844847206930496, 1.0336612823956715],
              [-19.873992934929692, 1.0454283073356618],
              [-19.8791833129238, 1.0360351985279155],
              [-19.909937085509394, 1.0411808771112672],
              [-19.94014193928779, 1.059942659075658],
              [-19.98601939840062, 1.115044523347757],
              [-20.00917733066928, 1.1501697024173578],
              [-20.009424786497817, 1.1637764024883797],
              [-20.021468513069994, 1.1890896247387746],
              [-20.03467069299627, 1.2372184189669406],
              [-20.046784451158803, 1.2560162200217608],
              [-20.065431864025427, 1.2578115118166342],
              [-20.070402356005165, 1.2674203458533118],
              [-20.065459051967817, 1.2818435056141968],
              [-20.07906950143376, 1.3006674728202658],
              [-20.077472938923556, 1.3239705648649518],
              [-20.096099033705887, 1.3384048589477398],
              [-20.099940364325303, 1.3544864187648649],
              [-20.09498292349323, 1.377923855211737],
              [-20.09547999109855, 1.4085665569126875],
              [-20.08555230355485, 1.4239194471675674],
              [-20.0579923450749, 1.4907630424802625],
              [-20.051482612338383, 1.512226792127136],
              [-20.0592324730363, 1.5494094021967464],
              [-20.06263086586519, 1.595937189446259],
              [-20.057269360720138, 1.6212803248386358],
              [-20.058885520646996, 1.6544846135395517],
              [-20.06639572905306, 1.6648288013624104],
              [-20.084839027548313, 1.661495059434256],
              [-20.09407293980852, 1.6945848452443837],
              [-20.091780989976183, 1.7106879964821724],
              [-20.083215260401648, 1.723918405079201],
              [-20.075177793736717, 1.761932510452715],
              [-20.060756630046306, 1.7672536535336916],
              [-20.04291299799491, 1.8087600074384493],
              [-20.033165674982556, 1.8504822505701632],
              [-20.03010449615867, 1.8887628878632512],
              [-20.02025116486741, 1.9458858467277067],
              [-19.995933759378307, 1.9492161979158267],
              [-19.985284609088172, 1.9647767972393602],
              [-19.97549600488266, 1.9580955946367622],
              [-19.93349432871072, 1.9505663134846596],
              [-19.92260786710167, 1.9263792366048873],
              [-19.92893884220982, 1.9018424474919473],
              [-19.91788906533459, 1.8618443220407161],
              [-19.92540435003978, 1.85117493285965],
              [-19.949962218722423, 1.8489830964710436],
              [-19.952951385540217, 1.8198441378194725],
              [-19.947562538099014, 1.8006215336492934],
              [-19.95957249202168, 1.7755121664735327],
              [-19.950029148231643, 1.7655801156412996],
              [-19.960645240084077, 1.7419275340686584],
              [-19.95622583879418, 1.7299347296767869],
              [-19.92238426425214, 1.7189934533374942],
              [-19.919920591250143, 1.7017577415931768],
              [-19.887866416254194, 1.6910166988885784],
              [-19.87900228825579, 1.6663114932041274],
              [-19.866399148322785, 1.652694001817168],
              [-19.85244494475646, 1.6456055489344894],
              [-19.85348108747535, 1.6316635964373445],
              [-19.83198469060058, 1.597903130002481],
              [-19.810571868773543, 1.5987875561652285],
              [-19.806032037711606, 1.5904038715748225],
              [-19.807250219747505, 1.556681809672951],
              [-19.789645705216458, 1.535672477332753],
              [-19.768135007552168, 1.5238753962335518],
              [-19.75810465549921, 1.5234299971311474],
              [-19.74902750309226, 1.5345065056411733],
              [-19.757169764494314, 1.548614967903114],
              [-19.752776814279514, 1.5703533274300772],
              [-19.771536607798275, 1.5822739388451728],
              [-19.792149566594517, 1.5867021613501144],
              [-19.786264796283124, 1.6150348279015854],
              [-19.796393798852087, 1.6803556203816572],
              [-19.790693549476646, 1.6986537732574472],
              [-19.786226784252644, 1.73361079853397],
              [-19.787561468776918, 1.7709638108480996],
              [-19.802513222740828, 1.7944210006011665],
              [-19.81705816074793, 1.8024485868157105],
              [-19.838195458108437, 1.8353975950962005],
              [-19.84028481869394, 1.8553146920265826],
              [-19.824611546904816, 1.859692584602568],
              [-19.872513057611993, 1.902550762640758],
              [-19.882605790387498, 1.9078893827215717],
              [-19.878161214435245, 1.920373796977852],
              [-19.858108241963, 1.9484630528018994],
              [-19.84313294855314, 1.9453938429175432],
              [-19.839253003339238, 1.9726489011505317],
              [-19.851982139673407, 1.9959703807668938],
              [-19.84012729365882, 1.9983726180050212],
              [-19.835018086305865, 2.0107769869807512],
              [-19.849923357263236, 2.0331893813031288],
              [-19.8759912186958, 2.0346373085194047],
              [-19.891472964806354, 2.043755852913956],
              [-19.88598542133737, 2.0541955334781106],
              [-19.89967684364304, 2.0704911413791858],
              [-19.893072680272613, 2.101062702832152],
              [-19.855118071998, 2.105869233869949],
              [-19.847586919795383, 2.116131605658298],
              [-19.847864040553794, 2.13505175064797],
              [-19.822373497988696, 2.1210395808128655],
              [-19.80673710521825, 2.127207320441883],
              [-19.795966702140213, 2.123392196494781],
              [-19.77970001360431, 2.131135498343968],
              [-19.756293078791334, 2.154708183572427],
              [-19.762607574906642, 2.1894511545118385],
              [-19.77178669322182, 2.213411142996216],
              [-19.80751653498381, 2.2549505052260406],
              [-19.82888471824995, 2.271820831061503],
              [-19.87360399787186, 2.256802576863373],
              [-19.86863923344609, 2.2778004734488344],
              [-19.914585824929937, 2.2665692520672986],
              [-19.90986285244822, 2.2505848499217973],
              [-19.916322080816897, 2.2215445059317367],
              [-19.93909988886585, 2.186497773939403],
              [-19.94141921157834, 2.1737648397092872],
              [-19.93241920378703, 2.1588258143812076],
              [-19.919605811418673, 2.1506994609457895],
              [-19.91323538017681, 2.128960438148294],
              [-19.932477042356293, 2.131707493918274],
              [-19.950958043174296, 2.1191293515118366],
              [-19.95991917243657, 2.0766932365517956],
              [-19.946746035379622, 2.0437311765812103],
              [-19.934762056745715, 2.0280339105082503],
              [-19.946160048429043, 2.021104772974813],
              [-19.963406860348798, 2.028406829364768],
              [-19.960115208111873, 2.0378502530759324],
              [-19.969198319584212, 2.0518095209519975],
              [-19.981080157395112, 2.053601275479013],
              [-19.98154996097469, 2.0245071290300514],
              [-19.971278454527386, 2.014479335625084],
              [-19.972937938709645, 1.9911166514148508],
              [-19.98060089509034, 1.9820375268720176],
              [-20.001510846563775, 1.9827934139325432],
              [-20.014913669633724, 1.9905385852426902],
              [-20.03078608797918, 2.0070642126884457],
              [-20.03583833277887, 2.024891524077109],
              [-20.04966629007996, 2.034333426046975],
              [-20.059252205903622, 2.056075371745942],
              [-20.07472848070597, 2.0667434605243393],
              [-20.08355330690398, 2.0865633991990205],
              [-20.108424170816825, 2.103277599497551],
              [-20.13014571156528, 2.0961119739317966],
              [-20.145629906194703, 2.1119299071241584],
              [-20.14689390207961, 2.1345624696799197],
              [-20.174871472281, 2.166472706236199],
              [-20.178013871370553, 2.1969582667554977],
              [-20.19034510359964, 2.221623093870313],
              [-20.211092669346066, 2.248632730889619],
              [-20.227816567806027, 2.2624772787069025],
              [-20.26908365438704, 2.28144748206177],
              [-20.282790045243026, 2.282087619365831],
              [-20.3070289356854, 2.268548887288698],
              [-20.311284285367815, 2.2574778363567227],
              [-20.330924914304287, 2.2695479730087498],
              [-20.305766070551975, 2.3024878723394306],
              [-20.26203466747343, 2.364579815760987],
              [-20.24821690762029, 2.387459756827752],
              [-20.23917924903546, 2.411604303975569],
              [-20.244454296877947, 2.4373870048912982],
              [-20.24214525344742, 2.452809077855361],
              [-20.252459790062503, 2.493857664570229],
              [-20.237934033584956, 2.480184639262676],
              [-20.22807782016082, 2.4982676277203173],
              [-20.230330937957067, 2.5181730471278034],
              [-20.242272340503014, 2.552247017291504],
              [-20.253508391932947, 2.5697783668735785],
              [-20.26340389948445, 2.575824459846943],
              [-20.285228012879713, 2.5702227881100828],
              [-20.287653721400485, 2.5923709740188405],
              [-20.27941079397027, 2.6032418804721202],
              [-20.272287507087967, 2.627073261008638],
              [-20.276480855117182, 2.660526390210797],
              [-20.282881788803664, 2.688694913368233],
              [-20.292204980276672, 2.7066309592228803],
              [-20.291667787911937, 2.727930058951445],
              [-20.31097996909879, 2.752306991200901],
              [-20.312665708569032, 2.759874646167842],
              [-20.333809062561276, 2.7864459538963686],
              [-20.365267215792006, 2.812392634957205],
              [-20.37306331752758, 2.835401739777615],
              [-20.395423893538208, 2.8623825394673568],
              [-20.396484286285773, 2.869962157152799],
              [-20.41395057035588, 2.891993065365962],
              [-20.413965050210283, 2.917844788405126],
              [-20.426001057319667, 2.928163173125743],
              [-20.432832217605537, 2.963838814443408],
              [-20.441153537697957, 2.9867993596565703],
              [-20.44357370060518, 3.0085106734257407],
              [-20.452759798423788, 3.0376006767219406],
              [-20.48033691852793, 3.084465091872302],
              [-20.49467741476013, 3.0944662616040053],
              [-20.504664392016053, 3.1340474584646993],
              [-20.525260870789342, 3.1676136497856247],
              [-20.536539416561066, 3.176605602188009],
              [-20.53832665991212, 3.1924811145432046],
              [-20.556849821424045, 3.220214991022453],
              [-20.562850531307017, 3.2236994094064806],
              [-20.564218191883118, 3.252580685700656],
              [-20.576511349406925, 3.266815359768775],
              [-20.587514596151134, 3.29060809515923],
              [-20.5892624618039, 3.304643581991049],
              [-20.600917031677213, 3.312926176084746],
              [-20.59089754376528, 3.3491129019095682],
              [-20.57169772377864, 3.3650890737118],
              [-20.543892330350413, 3.4030376022540367],
              [-20.53512743074178, 3.4387216072420803],
              [-20.537677692613077, 3.4558169026093806],
              [-20.536196901550746, 3.5074015013984674],
              [-20.532122055416124, 3.518642008614618],
              [-20.542825205971063, 3.5272455689326407],
              [-20.537589298237485, 3.5499468294870944],
              [-20.553056890631463, 3.5877436296186223],
              [-20.544926130398302, 3.630535437741707],
              [-20.54402094842414, 3.6644508942101517],
              [-20.55087318657535, 3.668243590273278],
              [-20.549821883280355, 3.687191612466221],
              [-20.54039656264931, 3.6966522384522067],
              [-20.540564208670162, 3.725722821412192],
              [-20.549505518738602, 3.748929785717687],
              [-20.528225086064705, 3.8039451566668783],
              [-20.519956338029118, 3.813075036422937],
              [-20.51301352228551, 3.8390980776818533],
              [-20.49057216978525, 3.876858076782146],
              [-20.4707325444468, 3.8946017003840683],
              [-20.44516888133222, 3.932554031520932],
              [-20.443907626292866, 3.964764155066878],
              [-20.4476500476171, 3.982904304505416],
              [-20.4367822489879, 4.002261306616389],
              [-20.428548766048905, 4.040215236757018],
              [-20.431183096223865, 4.048514772240183],
              [-20.42555237946588, 4.070925246201656],
              [-20.4297207429824, 4.09396311696118],
              [-20.439628744337355, 4.104735442538048],
              [-20.439375820774096, 4.140704592327097],
              [-20.42802355660264, 4.182740462744016],
              [-20.426988653358407, 4.222867507693629],
              [-20.443856371267906, 4.239849825674188],
              [-20.457797026336465, 4.2625628152853015],
              [-20.460448687045744, 4.3124322726124],
              [-20.474857032327296, 4.330110493899075],
              [-20.481358087160945, 4.374223365359554],
              [-20.489760877104445, 4.387896501943227],
              [-20.50704241704477, 4.435476732352311],
              [-20.51870609826097, 4.4505638085465815],
              [-20.530879479337383, 4.452522396465353],
              [-20.5338450834313, 4.4633116849118695],
              [-20.52406488809515, 4.496150038287561],
              [-20.52506736947358, 4.509422104882777],
              [-20.534638645136717, 4.538956954657029],
              [-20.55225203950263, 4.557544338577035],
              [-20.58280218751934, 4.5817678088466804],
              [-20.593420259555902, 4.616935333526626],
              [-20.604739603360287, 4.635945078554218],
              [-20.618020834786062, 4.649028378039727],
              [-20.634800972261818, 4.6740216420441065],
              [-20.671273251600425, 4.746002194225753],
              [-20.666911897923505, 4.760695401411175],
              [-20.644114406834703, 4.794125251576972],
              [-20.646206512736093, 4.82438471284108],
              [-20.63889402627712, 4.855865576114824],
              [-20.639481237964592, 4.875048486180162],
              [-20.6517545580164, 4.90950563490851],
              [-20.649798668655365, 4.931092733078419],
              [-20.618902194704415, 4.970638251003422],
              [-20.61591072192175, 4.985634508845998],
              [-20.541376790108586, 5.07999302092506],
              [-20.493700171251778, 5.131833214352358],
              [-20.448028776776976, 5.176239439093293],
              [-20.42344329976558, 5.204693326782213],
              [-20.39400765236899, 5.23324336689476],
              [-20.341820304886195, 5.291875995759382],
              [-20.311965883927805, 5.334941135825035],
              [-20.27972946819077, 5.3918357968362205],
              [-20.264096241500603, 5.426571142791292],
              [-20.267538155369536, 5.450303046492019],
              [-20.279068697396053, 5.463303429990254],
              [-20.28448197556525, 5.481777474111044],
              [-20.27695495160822, 5.493723552394516],
              [-20.277786707555222, 5.506412491866929],
              [-20.26339062275161, 5.548214527396458],
              [-20.252370667792594, 5.546614133957629],
              [-20.22403869836776, 5.585262227591271],
              [-20.20109680989019, 5.620207236808057],
              [-20.133743272559684, 5.75200761321319],
              [-20.1081915879211, 5.812124373533511],
              [-20.10131478395605, 5.842194166204418],
              [-20.1002250044979, 5.884796386712319],
              [-20.089902968312327, 5.919950465856233],
              [-20.097205943975595, 5.94461623703054],
              [-20.087311641572832, 5.976513883281802],
              [-20.09266958787238, 5.993085962130011],
              [-20.08986511422033, 6.016944491683714],
              [-20.0957557070884, 6.036489952755705],
              [-20.09214235642303, 6.0662633750615536],
              [-20.086096410422126, 6.088005335106933],
              [-20.09207296854271, 6.122122975815328],
              [-20.09961833542576, 6.130485904474331],
              [-20.11607198219937, 6.134617149008261],
              [-20.144756986392775, 6.177992671966153],
              [-20.124829938587993, 6.199140378824843],
              [-20.099608889221688, 6.235746285739332],
              [-20.079419607192843, 6.273334833276479],
              [-20.060316953993322, 6.3227773895298744],
              [-20.06215516129997, 6.3337363957996],
              [-20.048898340993365, 6.36377091098827],
              [-20.0491724919578, 6.379574429172973]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.61060994717245,
          "lat": 37.246338610069266
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779778"
      },
      "bbox": [
        -20.671273251600425, -4.500203157930851, -14.312236559970387,
        6.379574429172973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.569869189169268, 8.539499711586219],
            [17.569397153813867, 8.568482595120614],
            [17.557339093091933, 8.593856801667629],
            [17.574174421213076, 8.613054692515377],
            [17.580785579309783, 8.643463482931887],
            [17.590906183254084, 8.658156298893129],
            [17.582121938277602, 8.672010007066968],
            [17.591630255787354, 8.739885210088188],
            [17.5688352212396, 8.763763934398527],
            [17.578346822390237, 8.776349165730974],
            [17.593557994937232, 8.77246821030885],
            [17.6057572197659, 8.798449928955101],
            [17.599043520483843, 8.806157564559582],
            [17.61557692089362, 8.817282468931277],
            [17.643964379041876, 8.854314451435013],
            [17.658894991616666, 8.849513714046426],
            [17.66431525799372, 8.834523606961719],
            [17.687519303481604, 8.823184652051347],
            [17.695240453933618, 8.8143109988602],
            [17.711054141162403, 8.823201030066645],
            [17.731013087927764, 8.815252795324138],
            [17.739394253269772, 8.826620873740156],
            [17.76059775266917, 8.825917139336473],
            [17.765474650514687, 8.845756315421584],
            [17.770250303951947, 8.887572445004356],
            [17.7787337237348, 8.893448955344688],
            [17.798677460581334, 8.838814904726974],
            [17.873686891835444, 8.610809378756715],
            [17.925039124271034, 8.460491242489411],
            [17.983670387946574, 8.281484710147224],
            [18.012007814930318, 8.189074632388786],
            [18.07819305674416, 7.983256331688673],
            [18.150677748774733, 7.7475149846596985],
            [18.202684430204577, 7.579413107430111],
            [18.23763875601114, 7.461104712155997],
            [18.290657244093794, 7.302646420907007],
            [18.30707098346144, 7.250460540010267],
            [18.327338560480392, 7.2360361762537275],
            [18.322756190522, 7.218522334364848],
            [18.333538378664375, 7.204426552058918],
            [18.33504420430216, 7.184754078221066],
            [18.33124263790447, 7.170160588179935],
            [18.342733454606154, 7.152989127380287],
            [18.34245540946871, 7.136255336279247],
            [18.349642316518395, 7.125645597655354],
            [18.338025176495105, 7.097695083534393],
            [18.349724449061558, 7.061437576795984],
            [18.37013512164378, 7.033481104270548],
            [18.379990076644965, 7.026732704347917],
            [18.392857477832248, 7.032943808684008],
            [18.411792478552925, 7.020364670276071],
            [18.435033283479697, 6.9904365419324135],
            [18.44860106897246, 6.980852195458656],
            [18.48022811192086, 6.970581784303761],
            [18.486457515215033, 6.960483765570174],
            [18.50233658040004, 6.959569028579078],
            [18.51158387578877, 6.948257961851163],
            [18.50914461308647, 6.93730614573127],
            [18.51505997478237, 6.89751981479319],
            [18.51513643401478, 6.8688965990992195],
            [18.525250314653285, 6.851142627879603],
            [18.575281764517353, 6.829982741208473],
            [18.58700151467192, 6.819077339800409],
            [18.60147104485095, 6.816606437426556],
            [18.62320533295072, 6.824045590103765],
            [18.62918678603264, 6.809621263148216],
            [18.620438227139207, 6.773902874766333],
            [18.614818590097393, 6.735221544100069],
            [18.610186525255052, 6.733605724925718],
            [18.605924362200636, 6.6971365849068825],
            [18.59756928693334, 6.676951824139397],
            [18.59964721030003, 6.65788298004125],
            [18.594542289129823, 6.641974262506025],
            [18.599005136503877, 6.607362704381934],
            [18.57995923630865, 6.590481481784752],
            [18.547880094015664, 6.604284989795935],
            [18.535154342348644, 6.604923152423347],
            [18.51594996489579, 6.597759403449471],
            [18.494924625007865, 6.575978636533273],
            [18.451986132008376, 6.554246882799193],
            [18.445385184058306, 6.541825800364477],
            [18.442535070072555, 6.497085470767985],
            [18.390490667208944, 6.498843304511339],
            [18.370475259503074, 6.480381930639291],
            [18.360704392699773, 6.459163926872058],
            [18.37752609717923, 6.408687884596803],
            [18.345470384062462, 6.409598065053434],
            [18.33129740359824, 6.401600607197926],
            [18.319817792096508, 6.381284134143938],
            [18.30873265850484, 6.3484506519775055],
            [18.228319900596, 6.330080933235504],
            [18.147909930712487, 6.31169731548448],
            [18.0675027625085, 6.293299798022779],
            [17.987098409640016, 6.274888380341702],
            [17.903066362654982, 6.256318585361358],
            [17.819037230044355, 6.237733660423045],
            [17.710276101762936, 6.214315124274293],
            [17.6015196789415, 6.190871298351479],
            [17.47809209521186, 6.165109857488111],
            [17.458157774091134, 6.19192498541979],
            [17.443777033543167, 6.203541865773666],
            [17.429394150000643, 6.207620947023132],
            [17.401521519788364, 6.2263275428578995],
            [17.3860547522993, 6.260802048916749],
            [17.377205938814914, 6.269926507320193],
            [17.372477571314946, 6.3016815122256045],
            [17.384379102254204, 6.318045305177116],
            [17.38442984161408, 6.33924386448444],
            [17.377486460998764, 6.359563471887895],
            [17.369433022067152, 6.367846166460747],
            [17.37755287941308, 6.383564497228663],
            [17.4068298838319, 6.4000578030419595],
            [17.412758378857326, 6.412742336591612],
            [17.40970660590321, 6.4296774751293135],
            [17.417919017696015, 6.442549776501075],
            [17.400551096214564, 6.456700281299055],
            [17.391525842219146, 6.479286840801899],
            [17.402526147636355, 6.501325329556876],
            [17.405809455357886, 6.517886088366217],
            [17.396767498392062, 6.530263745359005],
            [17.399220988887357, 6.550265674321997],
            [17.37575501827476, 6.5720834602743174],
            [17.369082557371605, 6.617715513180099],
            [17.375382132184715, 6.629871878749709],
            [17.36940734589483, 6.645157055190337],
            [17.37065076220093, 6.660277606001917],
            [17.363390291197373, 6.684255491829777],
            [17.371745586596397, 6.691463548260122],
            [17.37659316582784, 6.712712462333177],
            [17.37784829019207, 6.744024642504559],
            [17.36278595120174, 6.759466771369596],
            [17.370660767141754, 6.785446610499436],
            [17.352995808183614, 6.7889851898217035],
            [17.34776826133663, 6.801865239193582],
            [17.352495435326283, 6.8189107711039805],
            [17.342266551385045, 6.891613825965645],
            [17.343485278515157, 6.921058286790145],
            [17.326169993430472, 6.937318595324057],
            [17.332108970659988, 6.967049689192419],
            [17.32479741450952, 6.989122920968054],
            [17.327426066504987, 7.005770338722268],
            [17.35120007815628, 7.032026383443656],
            [17.345797724669016, 7.046251634122153],
            [17.345421926589577, 7.069046960822617],
            [17.352817567932508, 7.07542939958387],
            [17.34996001887239, 7.090128792320916],
            [17.35215647630822, 7.113226608762503],
            [17.347629483062832, 7.141080661973957],
            [17.359301753600032, 7.165887274020519],
            [17.383373706934908, 7.1909352759360115],
            [17.38878414769414, 7.210466374790795],
            [17.397347936411638, 7.220365358076237],
            [17.393729965238776, 7.233269528179928],
            [17.40313338470395, 7.256336162377644],
            [17.39594687681213, 7.273623744233123],
            [17.397670807456073, 7.2851064915394765],
            [17.388194881406424, 7.305412356987714],
            [17.392309138564467, 7.330657024518264],
            [17.402293772160945, 7.355840823441295],
            [17.41989356598095, 7.382828455060747],
            [17.414790581655257, 7.406078459776873],
            [17.424703115792273, 7.418764393960622],
            [17.403012513368225, 7.451362323921326],
            [17.40668013467539, 7.4693700038725375],
            [17.418194686544002, 7.482745113845137],
            [17.431605311852, 7.535222638890552],
            [17.427207423192364, 7.542014213239488],
            [17.437458426354812, 7.559845789031736],
            [17.42118168764428, 7.565511064994785],
            [17.416511908724388, 7.583631773561857],
            [17.42584899157346, 7.591540782534457],
            [17.41571350096556, 7.618744929835993],
            [17.38946352283596, 7.648492004714369],
            [17.391642407753956, 7.678926261079287],
            [17.389926915056368, 7.6986265258825455],
            [17.367520108895455, 7.726581399771431],
            [17.370387778271844, 7.742649500342744],
            [17.384402920646195, 7.762882827153609],
            [17.38951142810794, 7.78239784319395],
            [17.40914428627896, 7.798706696885035],
            [17.411273244635368, 7.8056980485037615],
            [17.4471646261475, 7.814969893316009],
            [17.463155702542664, 7.82925595731868],
            [17.48650399394592, 7.824095331349379],
            [17.499132117216256, 7.83170006868544],
            [17.522734461598866, 7.854665181229907],
            [17.51515979817159, 7.8779715076167545],
            [17.52687505499472, 7.8998030093929055],
            [17.543002064475214, 7.910458397009656],
            [17.559933873992545, 7.909518153446134],
            [17.561824005698206, 7.918254338681437],
            [17.576965458747242, 7.922288177176569],
            [17.598723624593617, 7.947581928463137],
            [17.60670532927549, 7.962741962461825],
            [17.608333062678817, 7.997788455891401],
            [17.622341271734303, 8.001409253184999],
            [17.624252071627428, 8.012844785660182],
            [17.636879779869677, 8.016579853572146],
            [17.64784486884509, 8.037699456067797],
            [17.638714217519038, 8.055102421417088],
            [17.640159295093284, 8.073214919787718],
            [17.621191937389813, 8.081841631613921],
            [17.624661065930223, 8.095004142007246],
            [17.637849084457677, 8.095335056933283],
            [17.650001406435855, 8.105542206552535],
            [17.654396113402075, 8.122712847781775],
            [17.63472847883984, 8.132477950528054],
            [17.632688616385188, 8.163044741616922],
            [17.61968746166272, 8.182508016868065],
            [17.60252563797863, 8.183729917828579],
            [17.59040352438849, 8.200820195694272],
            [17.58202493858263, 8.224931766066522],
            [17.55663927545912, 8.244756696831782],
            [17.54682303376789, 8.266220532792968],
            [17.574370142702424, 8.306443878999808],
            [17.576446805393246, 8.346501798775007],
            [17.580584274757634, 8.363173103118777],
            [17.575106686282545, 8.370465281766428],
            [17.577048347171278, 8.390563985047542],
            [17.58385767076881, 8.395757310303988],
            [17.60000103014472, 8.440368708902295],
            [17.582122699160557, 8.4541740752985],
            [17.572087208845147, 8.489629287965476],
            [17.550876490502258, 8.50783162771065],
            [17.556598663985536, 8.524339171080953],
            [17.569869189169268, 8.539499711586219]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.5776317944426, "lat": 43.68535577437577 },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779794"
      },
      "bbox": [
        17.32479741450952, 6.165109857488111, 18.62918678603264,
        8.893448955344688
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.913897606654318, 1.6749028482263562],
            [14.961219572292226, 1.747007252643242],
            [15.081108810712488, 1.6659757317273014],
            [15.003435884670454, 1.546033719265387],
            [14.995172440334915, 1.5861376155823976],
            [14.997181433714161, 1.6053879502387811],
            [14.98631055376111, 1.6245057723482559],
            [14.979986231743151, 1.6227131444267142],
            [14.96053598303627, 1.648130402997801],
            [14.939251410711972, 1.6507366651794082],
            [14.913897606654318, 1.6749028482263562]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.01597697924367,
          "lat": 38.904543283540576
        },
        "year": "2023",
        "ste_code": ["11"],
        "ste_name": ["District of Columbia"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01702382"
      },
      "bbox": [
        14.913897606654318, 1.546033719265387, 15.081108810712488,
        1.747007252643242
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.219909595290242, 6.5652203539821645],
            [-5.207074053444822, 6.564602139308387],
            [-5.189214905096545, 6.77745491789973],
            [-5.1755613336562964, 6.937139115999535],
            [-5.161310507585421, 7.11893167967082],
            [-5.145543324027559, 7.308769559680804],
            [-5.131026307445941, 7.501735889876537],
            [-5.0260338133898745, 7.493058710847798],
            [-4.921043968381471, 7.484350011955672],
            [-4.79330543372866, 7.474009216945373],
            [-4.6980023653635286, 7.466639091775553],
            [-4.6027013284802925, 7.459243023274717],
            [-4.476473332221881, 7.449838857594297],
            [-4.35024879759785, 7.4403892063522825],
            [-4.221930278382978, 7.431368746181637],
            [-4.093615117153223, 7.422301316053969],
            [-3.96373897453028, 7.413493904582173],
            [-3.8338662231163085, 7.404638401539142],
            [-3.755070568514817, 7.3996587586785925],
            [-3.676276048276538, 7.394661426153228],
            [-3.5974826932505657, 7.38964640539164],
            [-3.5186905342781314, 7.384613697899198],
            [-3.4132323924020493, 7.37828124780238],
            [-3.3077762512846918, 7.371917131451024],
            [-3.2046161090073326, 7.366599216246891],
            [-3.087847452738474, 7.360170051163368],
            [-2.9710810498659743, 7.353702090031181],
            [-2.8640316813159385, 7.348315477502467],
            [-2.7569840002418537, 7.342896277174465],
            [-2.688452354459361, 7.339659530646658],
            [-2.619921350309769, 7.336409433125914],
            [-2.5296058324295436, 7.331807664918514],
            [-2.4392916708021604, 7.327182705223109],
            [-2.366187861654375, 7.323790886175803],
            [-2.293084835483207, 7.320383880791126],
            [-2.2199826168469725, 7.316961690068228],
            [-2.1468812302931313, 7.313524315062611],
            [-2.0563920301198335, 7.309831455653028],
            [-1.9659038750547453, 7.306115343629835],
            [-1.8850141425553673, 7.303125514888974],
            [-1.8041251463868824, 7.3001171119652275],
            [-1.689384299095329, 7.296436291510898],
            [-1.5830822320754487, 7.292591793466889],
            [-1.4767815423491204, 7.28871522404836],
            [-1.3470670655903478, 7.283991316145071],
            [-1.2173548501936537, 7.279219662222955],
            [-1.1376920309895193, 7.277157899099029],
            [-1.0580297254466973, 7.2750781417473185],
            [-0.986920738054339, 7.27343277838024],
            [-0.9158121121545504, 7.271773080091538],
            [-0.8447038702933279, 7.270099047329163],
            [-0.7735960350117022, 7.268410680591494],
            [-0.6701099574274814, 7.266539981439162],
            [-0.5666244819745044, 7.264638931019307],
            [-0.4500780358457631, 7.263131625322019],
            [-0.3335320770465625, 7.261585830590572],
            [-0.3044407422376036, 7.261950958780582],
            [-0.2006738140460177, 7.260655346573365],
            [-0.09690736557451837, 7.259329223457833],
            [-0.012834028770350395, 7.258643547224137],
            [0.07123911518028396, 7.257937844817463],
            [0.06656427138532804, 7.234978100320264],
            [0.06313116836011803, 7.166673231021599],
            [0.05938394087431718, 7.149568333688782],
            [0.03632444836185154, 7.118603351496711],
            [0.027325363660702484, 7.112198859786426],
            [0.008285508342682758, 7.071555102962363],
            [-0.006089333851284535, 7.057300696867932],
            [-0.033084438878454, 7.0428412872737995],
            [-0.06061284662652187, 7.024423967178745],
            [-0.06805151200217126, 7.013308749732217],
            [-0.12425393223486568, 6.971886791335657],
            [-0.13650126456715647, 6.932964693629121],
            [-0.072473567787591, 6.848496388395242],
            [-0.05886186446208415, 6.815918623361212],
            [-0.04922787421399642, 6.784371952172646],
            [-0.02226643028573328, 6.744757755475061],
            [-0.013833221859788629, 6.737903772131699],
            [0.0301758163515238, 6.7352142578267875],
            [0.08038122319266285, 6.708044663426243],
            [0.09733373813724783, 6.702580195896509],
            [0.12021577637682275, 6.684004967745576],
            [0.14521977256869698, 6.62529498095343],
            [0.14532400046492822, 6.536692942550115],
            [0.144128184502302, 6.29171604711663],
            [0.14346078745774446, 6.033168875305303],
            [0.14211054926412414, 5.7911645117175405],
            [0.1401696091080964, 5.528180008495507],
            [0.138682581304729, 5.309572932622421],
            [0.137307690818881, 5.021175811994435],
            [0.13648753483494733, 4.8317847135304826],
            [0.03131726923833612, 4.832431873082665],
            [0.04039527785982082, 4.823006887123196],
            [0.04299040627947745, 4.798914436427521],
            [0.030240004004017662, 4.7890100632983925],
            [0.03427530787956998, 4.766027970321241],
            [0.04804453452903704, 4.7635433336337085],
            [0.04912635134090064, 4.750991689458211],
            [0.07534625252250461, 4.726639510451003],
            [0.08479697831547418, 4.726285489140371],
            [0.08226140042514826, 4.699606178938764],
            [0.08435624084111602, 4.678666397992941],
            [0.07660787535686718, 4.667950785547975],
            [0.08324054105590702, 4.643867096482981],
            [0.0719417171849084, 4.626989405622735],
            [0.043173702218868557, 4.620610811706383],
            [0.04587472644549015, 4.59984405337416],
            [0.06335403114927522, 4.589181486370193],
            [0.06302316536265579, 4.578675104605248],
            [0.049761564679949036, 4.570416922759177],
            [0.061472331656449046, 4.558137397581227],
            [0.0818061348533775, 4.555312572504813],
            [0.08727461364323928, 4.548888580330688],
            [0.11196375048391756, 4.555264729160643],
            [0.12236762127374977, 4.536089374602553],
            [0.12652150377579957, 4.512955078737956],
            [0.12517450309567038, 4.481138554729355],
            [0.14186519989716187, 4.464565317778111],
            [0.14474583485864506, 4.44459638664676],
            [0.12927432085715135, 4.425647832721764],
            [0.13303291860006958, 4.405693800841975],
            [0.12888106543217703, 4.394666079266455],
            [0.11720708646083546, 4.393069325144115],
            [0.10736660087267032, 4.381495659867291],
            [0.09290621733941473, 4.38069731450372],
            [0.09223282690600787, 4.355419022210487],
            [0.10620450266432004, 4.340311429407075],
            [0.08524814431446144, 4.308270586650706],
            [0.09965677943070013, 4.289889899199391],
            [0.09291126792804533, 4.275644718943677],
            [0.06977366794042913, 4.255056786065052],
            [0.07930999384403484, 4.220993263961764],
            [0.0626154769198954, 4.193585670307532],
            [0.06282211859860372, 4.171047122999989],
            [0.03915730833704922, 4.164117025088523],
            [0.03158052975375089, 4.131522013958231],
            [0.011777372946622039, 4.114502640314651],
            [0.00022059140888398723, 4.093700761462283],
            [0.005490274305628685, 4.0868233051630725],
            [0.000059486853631150533, 4.070634966404761],
            [0.007586379508055435, 4.055790181559556],
            [0.006145902579184779, 4.040577469030618],
            [0.021388194337308174, 4.032139963692714],
            [0.07058706307561922, 3.985084281880725],
            [0.07053297710052989, 3.9760658311664363],
            [0.08619387580551764, 3.9599074762642315],
            [0.08560204939510736, 3.945375170977412],
            [0.09460124503723571, 3.9343305317112076],
            [0.10152428539853796, 3.9080436971376975],
            [0.09850577747039535, 3.8899666917370745],
            [0.11461718415781542, 3.8851120894956157],
            [0.11229070127950955, 3.8531102388498826],
            [0.11699849844499963, 3.83234326963228],
            [0.11540916061460674, 3.818376992439604],
            [0.1373248837675174, 3.819284287914901],
            [0.11524952431595231, 3.808752401422278],
            [0.09639028943447953, 3.8115735670941624],
            [0.079088136831482, 3.8392667838685544],
            [0.055245560096835025, 3.8495902539279765],
            [0.035707055553366396, 3.8371094585083902],
            [0.021680343360863132, 3.8338088703800954],
            [0.005266350378499618, 3.843068676713385],
            [-0.003318364172046383, 3.881666685525558],
            [-0.018385593281414314, 3.896293392708504],
            [-0.03805640471128307, 3.9079961116883077],
            [-0.05630487961392704, 3.938432494562798],
            [-0.0534662609177821, 3.9556667843364846],
            [-0.03891619484078713, 3.983474936786826],
            [-0.06830737426618885, 3.997500779412322],
            [-0.09468190897719815, 3.992792029588207],
            [-0.11597258073092938, 3.997020124545856],
            [-0.12245318008117316, 4.003310516979624],
            [-0.12513660979383304, 4.0353672820740485],
            [-0.1522341343881237, 4.0435003094362925],
            [-0.1645819208281535, 4.052415234942305],
            [-0.18382465300691392, 4.057032498577222],
            [-0.19831061779033698, 4.06577737668773],
            [-0.22093203321863428, 4.051742628263625],
            [-0.23986480743611524, 4.052981269924945],
            [-0.23798130612553567, 4.073013413830347],
            [-0.25307998505913554, 4.093168258265501],
            [-0.2841871640205152, 4.095378401953544],
            [-0.3183732029442128, 4.105663742518924],
            [-0.34742800306513494, 4.103071561297807],
            [-0.36177889489174675, 4.105788262228017],
            [-0.3756696233073524, 4.129672611853849],
            [-0.3851503026805777, 4.1354980309107745],
            [-0.41879309391850433, 4.1439832067077935],
            [-0.4246653635308492, 4.180730941757056],
            [-0.44620912669496055, 4.190578775006156],
            [-0.4763074443176592, 4.191093020922989],
            [-0.4883962274327486, 4.203401666674152],
            [-0.5137029778313501, 4.19199350954664],
            [-0.527118448932139, 4.191114161930839],
            [-0.5394478595452543, 4.201703718600909],
            [-0.5688529312747397, 4.202860089333223],
            [-0.5875244232053051, 4.183382175690465],
            [-0.6185381896600081, 4.188016120678169],
            [-0.632930827755462, 4.1963773954174926],
            [-0.6527559248011303, 4.188293907467758],
            [-0.6747060264268403, 4.186088835638272],
            [-0.705011911511227, 4.197404641443348],
            [-0.7365009432286372, 4.187179406646241],
            [-0.7655896294468029, 4.1825040119511225],
            [-0.7902383432552993, 4.187965318547322],
            [-0.8295531580514774, 4.191029067411021],
            [-0.880808118860169, 4.210021965249008],
            [-0.9028981222205545, 4.201413472989035],
            [-0.9133574747225629, 4.160006818987023],
            [-0.9257133620264437, 4.141809971878723],
            [-0.9592407555679088, 4.113131477978134],
            [-0.9792546377000563, 4.113849108103646],
            [-0.9960007280803335, 4.107507622115047],
            [-1.02128833341529, 4.108995597638496],
            [-1.0391990124438304, 4.117978493399148],
            [-1.0412600647415065, 4.126400106029196],
            [-1.0885899634257352, 4.167691995653674],
            [-1.1020299719391298, 4.1868435630295675],
            [-1.1188975282927336, 4.184316909888821],
            [-1.1540237347124418, 4.201224230615772],
            [-1.1815326872947065, 4.223175415075466],
            [-1.1973472199290554, 4.2241600616352475],
            [-1.230466373730231, 4.2365029831286005],
            [-1.242159332880356, 4.251183935822795],
            [-1.2983978656838018, 4.2837676924455295],
            [-1.312324018809789, 4.280381835023939],
            [-1.331915592511527, 4.300309395738328],
            [-1.34794199527739, 4.331213698107286],
            [-1.3532640882319567, 4.352028186162179],
            [-1.499179637570253, 4.355963809682711],
            [-1.6450963365469424, 4.359855182529204],
            [-1.7524122010783714, 4.36329192766225],
            [-1.8597288325180323, 4.366704730842184],
            [-1.9600943181688602, 4.37015611303834],
            [-2.060460515964137, 4.373586550440904],
            [-2.143273442573928, 4.376666335206856],
            [-2.226086896087067, 4.379731857638732],
            [-2.3057206019904166, 4.3830109178890755],
            [-2.385354862217553, 4.386276785708913],
            [-2.4636665400734405, 4.389865678324474],
            [-2.5419788335040914, 4.393441807263606],
            [-2.620291729661874, 4.397005171805163],
            [-2.698605215690079, 4.4005557713682855],
            [-2.7880824528883883, 4.405249320199809],
            [-2.9036388610405046, 4.4095713990145295],
            [-2.989257045112878, 4.4139358386772],
            [-3.0748760194663682, 4.418285012889661],
            [-3.171484934555088, 4.422550896450455],
            [-3.2549569941042464, 4.427226930412307],
            [-3.3384298898427103, 4.431888447356086],
            [-3.481924484162076, 4.43925514287718],
            [-3.6254211206721316, 4.446578953104414],
            [-3.689397575272638, 4.450771931790908],
            [-3.78826052938638, 4.459496228911805],
            [-3.872664386784412, 4.464806487234284],
            [-3.957069182661222, 4.470101884763057],
            [-4.1039379713607635, 4.479922918703879],
            [-4.250809793775354, 4.489698929994051],
            [-4.361356817624386, 4.497634853115394],
            [-4.471905707957089, 4.505545249592367],
            [-4.595488235826771, 4.515006653448175],
            [-4.719073277746229, 4.524436129166684],
            [-4.817559443551106, 4.531945876718961],
            [-4.916047154231561, 4.539435344018847],
            [-5.071027170723168, 4.55161231829379],
            [-5.212761399791492, 4.563810923548373],
            [-5.299433738477238, 4.570649512622229],
            [-5.38610727169448, 4.577472383580555],
            [-5.366501778048347, 4.815366882103244],
            [-5.353536078436803, 4.973391876649692],
            [-5.330324105621542, 5.248682365042791],
            [-5.3159696254613, 5.42070295106756],
            [-5.291475409235854, 5.700376908754585],
            [-5.275931046341002, 5.890205440224414],
            [-5.249303126659181, 6.203797866002558],
            [-5.2289223518098975, 6.443531305614931],
            [-5.219909595290242, 6.5652203539821645]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.23040732385448,
          "lat": 44.43602356619911
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01785534"
      },
      "bbox": [
        -5.38610727169448, 3.808752401422278, 0.14532400046492822,
        7.501735889876537
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.13648753483494733, 4.8317847135304826],
            [0.21737290401496087, 4.831436519741026],
            [0.2982582004552121, 4.83107383311668],
            [0.38883796638213136, 4.830888466947581],
            [0.47941767903383786, 4.830684926325596],
            [0.6069534244476247, 4.830881396405891],
            [0.734489202833593, 4.831041837180704],
            [0.8725357611642535, 4.8319431815262055],
            [0.9528607279542363, 4.832872244154962],
            [1.0331859053846078, 4.833787012124928],
            [1.140290412444361, 4.834880516983745],
            [1.247395182709142, 4.83594860625554],
            [1.3730326562524684, 4.837365817306658],
            [1.4986704697629964, 4.838748055410061],
            [1.6098218358088343, 4.8404946340021375],
            [1.720973610683026, 4.842213837407455],
            [1.8248614505308778, 4.844159954620867],
            [1.9287497187635023, 4.846082155438422],
            [2.0663257533133543, 4.849182641676717],
            [2.2039027060987886, 4.852241179275219],
            [2.3224838290012917, 4.855324692930019],
            [2.4410657382694523, 4.858377036883898],
            [2.560624574758428, 4.862233065222658],
            [2.680184474162066, 4.86605739609835],
            [2.816351820118971, 4.8709536006024905],
            [2.9525206967180764, 4.875808675612068],
            [3.0670982198575625, 4.880349804969073],
            [3.1816769365352426, 4.8848618029908355],
            [3.282729237791721, 4.88904688506605],
            [3.3837824864700874, 4.893209302490908],
            [3.522046786415325, 4.899315703827072],
            [3.6603129520728674, 4.9053796624097705],
            [3.773350488589498, 4.911055516544113],
            [3.886389495572894, 4.916702985907932],
            [3.915091965080603, 4.917702139268153],
            [3.9176362422771662, 4.902042160745052],
            [3.9066529153251417, 4.876654016341807],
            [3.9099018409598267, 4.862300937371041],
            [3.9296851608718284, 4.837498480048964],
            [3.934878932613338, 4.813226378255368],
            [3.924019340657423, 4.783142064142642],
            [3.9342067299213963, 4.766837616388744],
            [3.9493510090735393, 4.764416021899368],
            [3.9879345185630863, 4.746746520033049],
            [4.004411173013478, 4.734848915050221],
            [4.021148443803267, 4.7138707932764525],
            [4.043192313618133, 4.676992601701091],
            [4.0290670833390205, 4.650470806926574],
            [4.001667765287336, 4.621077757610824],
            [3.9864216336447815, 4.576198394495659],
            [3.96271560992577, 4.547361153597211],
            [3.9659820578869245, 4.5223340666116325],
            [3.964742116829608, 4.48579567913238],
            [3.969664977463491, 4.45722402489408],
            [3.9939629024301357, 4.382797185730792],
            [3.992797697694515, 4.3595432492488575],
            [3.9969802953886022, 4.329236745494542],
            [4.031540748571291, 4.304121271019501],
            [4.039932152486227, 4.271191420938312],
            [4.038002938743635, 4.256132352926128],
            [4.050358288896139, 4.249449458696912],
            [4.051873209735334, 4.2282807666640005],
            [4.063635406685303, 4.179217188697834],
            [4.075049177232609, 4.159635067939449],
            [4.116920604460896, 4.13841521372904],
            [4.128614085891687, 4.12418700588759],
            [4.149806807377635, 4.113093831065875],
            [4.172686905050235, 4.112931939096705],
            [4.188424463207493, 4.104575749077036],
            [4.223898431868165, 4.094995630741899],
            [4.285209606468988, 4.084890654448231],
            [4.321778596865963, 4.076169410456324],
            [4.3351413100928315, 4.066857750831702],
            [4.348791916830914, 4.028430486544873],
            [4.368723864444179, 4.005642716981564],
            [4.383101731937818, 3.978157554432355],
            [4.39036987645043, 3.953980149277714],
            [4.385750629327054, 3.946753194607181],
            [4.377130784396683, 3.9293962216401344],
            [4.379267508618973, 3.9162415048442485],
            [4.402111761172791, 3.8978173769141193],
            [4.442320830390637, 3.8827975659327136],
            [4.455299664113878, 3.85782622463355],
            [4.496692382039814, 3.839485285950277],
            [4.514114870337033, 3.828678815129047],
            [4.540266927594551, 3.8014515633661086],
            [4.562662937700447, 3.7700427183306235],
            [4.554325481893937, 3.7248054420198917],
            [4.564209143450023, 3.7014701347987744],
            [4.586640331153541, 3.673608190352068],
            [4.612905527681169, 3.6550026485382636],
            [4.634240319777457, 3.651844536119987],
            [4.669441531579023, 3.631603517769169],
            [4.693431644507482, 3.6256232182978527],
            [4.724449431920806, 3.608588941629224],
            [4.7317186209776425, 3.5871404480144027],
            [4.754445337622589, 3.582751231583724],
            [4.760905912827538, 3.5746089581539127],
            [4.762329628800387, 3.5453891145805585],
            [4.759417123330261, 3.533293645370513],
            [4.764347251333402, 3.4996845449114784],
            [4.774557080303633, 3.4887581169617934],
            [4.784735252928372, 3.4618073884086975],
            [4.781554835848896, 3.4395299964175137],
            [4.771068510081369, 3.4187036073217407],
            [4.7708224797285625, 3.4022098734567625],
            [4.7807123035877135, 3.388783060940588],
            [4.780759763404033, 3.364217481860894],
            [4.770486343141974, 3.3331865994728282],
            [4.769473695351426, 3.3139445205759337],
            [4.762878939568498, 3.2890248406845517],
            [4.766637432127687, 3.2680033363267924],
            [4.7617700189732375, 3.2588222398931963],
            [4.737054614184233, 3.247209142224885],
            [4.69697516725473, 3.218812923579354],
            [4.680174542155683, 3.2003438325699816],
            [4.6719298805998895, 3.183961671445519],
            [4.674699122450202, 3.144386664755887],
            [4.660939701053882, 3.1281747203631705],
            [4.656287794033364, 3.0950410136624367],
            [4.662091122410317, 3.0466756810537476],
            [4.659997419929906, 3.035664378356133],
            [4.609757789596039, 3.010012400387078],
            [4.576186445283997, 2.9659104195670225],
            [4.547432411676817, 2.9586965497940185],
            [4.517069605298842, 2.9651119382457947],
            [4.477659243436073, 2.947637497379456],
            [4.4706816386497765, 2.9303056477925598],
            [4.435469598082332, 2.895956858711317],
            [4.3754845268647795, 2.8805081736099893],
            [4.301016013957409, 2.881965465194564],
            [4.286217413386522, 2.878268359743782],
            [4.255514445602691, 2.8548438896849233],
            [4.234090989229776, 2.843869556936238],
            [4.199874570924197, 2.854735019996258],
            [4.161333583661745, 2.8422436308240684],
            [4.147117054739241, 2.8286969121483114],
            [4.145665851951388, 2.8027984014896097],
            [4.136492910936519, 2.7860088994269803],
            [4.130748090166716, 2.717889572942838],
            [4.120710484785167, 2.70233086897802],
            [4.106129751656908, 2.664392862706845],
            [4.106977437434836, 2.6557367693908813],
            [4.144737968335294, 2.6154528398555605],
            [4.16465185169828, 2.582827813013477],
            [4.1899659324553475, 2.584198226999573],
            [4.203886906583641, 2.5743744677864138],
            [4.223535227867205, 2.5389454073559237],
            [4.239148200873461, 2.5166486975460582],
            [4.238372136937457, 2.4924785037626616],
            [4.245734192218061, 2.4545284324148344],
            [4.24448474009225, 2.4260064702947384],
            [4.236801181242215, 2.3986337158223847],
            [4.242570353519462, 2.3772194840426764],
            [4.236159646881291, 2.3433007932723613],
            [4.2104274881967925, 2.324953692895555],
            [4.194439656883834, 2.2997985715023948],
            [4.177974893940738, 2.2831318871455775],
            [4.170202496920192, 2.26257773944867],
            [4.146238503075853, 2.237371308259474],
            [4.141839581435271, 2.224005020283655],
            [4.147355331435481, 2.1920900291101137],
            [4.136478405464069, 2.1624926905136492],
            [4.132161070148422, 2.136266705619733],
            [4.136468408985315, 2.108078205174839],
            [4.12891024619697, 2.0795653723135508],
            [4.083183475442724, 2.045082728200163],
            [4.0373911180382365, 2.0438811410204414],
            [3.993910082530558, 2.0294483610421215],
            [3.9630042371591805, 2.0112394657146817],
            [3.9550183951657454, 2.0028858759955313],
            [3.941413867160648, 1.9746137868163427],
            [3.92580183187083, 1.9587248647939608],
            [3.9230679082586213, 1.9416762559785647],
            [3.937184788530084, 1.932641009838122],
            [3.952498239809534, 1.9126560751075918],
            [3.9570125286965316, 1.8842448742246234],
            [3.9484122163750053, 1.855789157872902],
            [3.947316115376866, 1.8345375425243633],
            [3.953634274956202, 1.8171743004673926],
            [3.953384187886528, 1.7909017024707323],
            [3.944212728908203, 1.7834394434163072],
            [3.921111935953661, 1.7755932379598092],
            [3.9042677981847436, 1.782850484781163],
            [3.8750649318131196, 1.77694073043207],
            [3.8606463922522822, 1.7965908332503333],
            [3.840231621978402, 1.8045492653993627],
            [3.8434771962229637, 1.825429392973121],
            [3.8320711580345272, 1.8344880618286206],
            [3.8349365210656288, 1.8529921029557745],
            [3.8082903265207486, 1.853747841274658],
            [3.7953809775634255, 1.8632672549568672],
            [3.7834963342668195, 1.8869213644860046],
            [3.7662449895061667, 1.8960118149549121],
            [3.7617247613479794, 1.9081631470639342],
            [3.7631068483342673, 1.9304749519073185],
            [3.7582645047702936, 1.9347086735600438],
            [3.715269242414726, 1.9423650172957234],
            [3.708115920008755, 1.9489613226873679],
            [3.7085330250204454, 1.972711736603016],
            [3.690550352413172, 1.983641448552697],
            [3.676855849794116, 2.0017880284792073],
            [3.512855299272942, 1.9863639940220104],
            [3.401197866657003, 1.978017095918405],
            [3.255335871962476, 1.968855725227286],
            [3.109475889158148, 1.9596650244698812],
            [3.03759073061359, 1.9542453846383423],
            [2.9044394738805783, 1.9463080639753436],
            [2.7658882915504903, 1.9405412291577646],
            [2.6198975216765437, 1.93106253822557],
            [2.526027431852093, 1.9262214660684207],
            [2.3897069367945685, 1.9215349323702333],
            [2.309520704503726, 1.919927491949928],
            [2.2026627578170115, 1.9146882976968225],
            [2.046134741381181, 1.9091774341921868],
            [1.909264252654974, 1.903144913248134],
            [1.753347894225956, 1.8987772429575036],
            [1.6013233937274578, 1.8953797160379895],
            [1.4938309381590524, 1.894235577991261],
            [1.358411155944612, 1.8948276061712679],
            [1.222991167928384, 1.895394578798959],
            [1.0498885362990558, 1.8969289800673526],
            [0.9354841796958896, 1.8978290069023376],
            [0.82107962269591, 1.8987111233883225],
            [0.733396490277555, 1.900488693731867],
            [0.6401822948134792, 1.9011802407597256],
            [0.649571076347882, 1.9088981788157735],
            [0.6509412763254722, 1.9252506018374098],
            [0.6367453074453652, 1.9407074667787043],
            [0.6357744186304455, 1.9557941347357923],
            [0.6220678322856148, 1.9759186098347412],
            [0.5969119980789673, 1.983782451107418],
            [0.5819388449886975, 1.994094416312047],
            [0.5694289152010591, 2.024878040252835],
            [0.5515294853359836, 2.0344536301045992],
            [0.5472074272121549, 2.0488378327216887],
            [0.5511426936709565, 2.0649450476366407],
            [0.561387973914065, 2.076865615505528],
            [0.5862022681018685, 2.0938684073982787],
            [0.5810196480218682, 2.1213797986663665],
            [0.5858880715068198, 2.1531979601982894],
            [0.5778895799343003, 2.18239016148217],
            [0.6046235969615288, 2.202502376456379],
            [0.602923151043651, 2.2213395084255114],
            [0.5862994838928105, 2.2401579436342245],
            [0.583393353986226, 2.258592288038466],
            [0.5922832627160881, 2.29128926265016],
            [0.5883654805673065, 2.3016417446414206],
            [0.5659179062161446, 2.316396249065262],
            [0.5614146324502871, 2.3285392164751233],
            [0.5685513805583982, 2.3446728045043557],
            [0.5671361470882116, 2.3587990292759144],
            [0.5538739242988121, 2.3727558174587045],
            [0.5548879800517587, 2.389165408431194],
            [0.5664625674618242, 2.408131542674806],
            [0.5639529539442313, 2.4378426520395786],
            [0.5518151435239407, 2.4641161026592493],
            [0.5507551875728017, 2.475093581425278],
            [0.5593833873346152, 2.4884239657026286],
            [0.5736675233603942, 2.4857010301686007],
            [0.5822387371138085, 2.4953838406464137],
            [0.5646731925859763, 2.508752058362515],
            [0.5311589691341609, 2.5047844099818137],
            [0.5189817013321167, 2.5161547234409194],
            [0.5197896550109142, 2.53176584383383],
            [0.5298387502176454, 2.5587644709031343],
            [0.5224366435262248, 2.579402372531532],
            [0.5278687887363979, 2.5923975402067208],
            [0.5169008368426812, 2.6024583824454317],
            [0.5177823627685765, 2.6195764497027536],
            [0.5338794883023109, 2.6221079111596697],
            [0.5289796779462493, 2.6005551956677593],
            [0.536441918811119, 2.5944198061265804],
            [0.5514181645351983, 2.6024916453027838],
            [0.5595252145286622, 2.617002473175922],
            [0.5466770194566155, 2.640447794943334],
            [0.5191059244312792, 2.643542309515958],
            [0.4986815651632024, 2.661350169808804],
            [0.49592125348397326, 2.670712655186316],
            [0.5151259713949551, 2.6863299264440528],
            [0.5107115315280746, 2.718233008048502],
            [0.5152533781977031, 2.7280942409730877],
            [0.5134575770547014, 2.75150008486474],
            [0.5230266187769077, 2.7737910872308174],
            [0.513617625459473, 2.7860969850820068],
            [0.4894072720983778, 2.7857941531364707],
            [0.4602397864480645, 2.7946799957759927],
            [0.44921405163749695, 2.809050474498073],
            [0.4690655259185516, 2.834600442863485],
            [0.4637653158136409, 2.8622567123145353],
            [0.44394050341031843, 2.863151213973245],
            [0.43654093057201776, 2.8316311876619125],
            [0.4238437354537696, 2.8314479839709104],
            [0.3953945839670001, 2.856683701725272],
            [0.3942265360415502, 2.8812030472157644],
            [0.40347407481466835, 2.897300149155492],
            [0.40181987424618765, 2.9064244558579153],
            [0.3825581225364847, 2.9200620428216015],
            [0.37651035167467906, 2.9332803911786223],
            [0.37905901607549763, 2.9473413937779633],
            [0.39325222157260864, 2.9708623088015473],
            [0.3897135932491259, 2.9846159836453086],
            [0.37405599344339474, 3.0015693527474063],
            [0.376472278560918, 3.018027023274587],
            [0.3858404670216567, 3.0237469778650286],
            [0.40745416976989723, 3.0254810958593827],
            [0.4047060735802109, 3.04188382694669],
            [0.3877303521877505, 3.052015152596733],
            [0.38625789775849967, 3.0683096589242083],
            [0.4010401235440382, 3.0774527338024753],
            [0.4063399978830396, 3.1021047789135894],
            [0.41458662114642053, 3.113253409152964],
            [0.4121927562896701, 3.1279373959760113],
            [0.3841455551674886, 3.145240423274059],
            [0.3839320442424107, 3.1650093201272855],
            [0.3778181458431288, 3.179630715491989],
            [0.35693267306161547, 3.196742128485857],
            [0.35483351246530065, 3.209776521203102],
            [0.3442151901249433, 3.2268995455989837],
            [0.3586379267406219, 3.240512187085077],
            [0.3577641761900989, 3.262645031585136],
            [0.3681419758601341, 3.297106333540602],
            [0.3482007948540118, 3.3056468137954176],
            [0.327745293069904, 3.3022235301630563],
            [0.3219313824536074, 3.3100426233989957],
            [0.32498174147510306, 3.3320177022836943],
            [0.3049451039818932, 3.3324401910695967],
            [0.2942066416156755, 3.3201074303208937],
            [0.2875219685203946, 3.338126158555501],
            [0.29879564348632753, 3.348491587387111],
            [0.2879391785015013, 3.3670528284279624],
            [0.27488196533354586, 3.3640626543205534],
            [0.26358897614957294, 3.371038842446115],
            [0.258032250596008, 3.400246774520379],
            [0.26652962226443855, 3.422489370939872],
            [0.26680384398793, 3.4366497442013837],
            [0.25808714506779884, 3.4499579297575655],
            [0.23537013533734844, 3.4591176320976826],
            [0.22846343848824718, 3.4733365497878435],
            [0.20775574484076198, 3.4936701440115283],
            [0.20762763550023242, 3.521751371407441],
            [0.20143202996690565, 3.5423102695638233],
            [0.21635441396672617, 3.546014342831427],
            [0.22566003167274645, 3.5570007253604583],
            [0.22016848742424655, 3.5867055903980756],
            [0.20181203168934164, 3.6039033813677603],
            [0.19300488364822815, 3.6193777363764172],
            [0.19196626034145928, 3.638501116672355],
            [0.18159622345475884, 3.653607929836296],
            [0.1641455244202646, 3.6652677670773626],
            [0.15695552033270854, 3.6866883654362246],
            [0.16399124084846067, 3.7041285371217425],
            [0.15926491941625204, 3.721576675299118],
            [0.16166834630190263, 3.7390956042268226],
            [0.1795082287178049, 3.7607153500729398],
            [0.1846247245120239, 3.7746549299093317],
            [0.18085391701839082, 3.802891253195955],
            [0.1734924171610186, 3.812562034616949],
            [0.1373248837675174, 3.819284287914901],
            [0.11540916061460674, 3.818376992439604],
            [0.11699849844499963, 3.83234326963228],
            [0.11229070127950955, 3.8531102388498826],
            [0.11461718415781542, 3.8851120894956157],
            [0.09850577747039535, 3.8899666917370745],
            [0.10152428539853796, 3.9080436971376975],
            [0.09460124503723571, 3.9343305317112076],
            [0.08560204939510736, 3.945375170977412],
            [0.08619387580551764, 3.9599074762642315],
            [0.07053297710052989, 3.9760658311664363],
            [0.07058706307561922, 3.985084281880725],
            [0.021388194337308174, 4.032139963692714],
            [0.006145902579184779, 4.040577469030618],
            [0.007586379508055435, 4.055790181559556],
            [0.000059486853631150533, 4.070634966404761],
            [0.005490274305628685, 4.0868233051630725],
            [0.00022059140888398723, 4.093700761462283],
            [0.011777372946622039, 4.114502640314651],
            [0.03158052975375089, 4.131522013958231],
            [0.03915730833704922, 4.164117025088523],
            [0.06282211859860372, 4.171047122999989],
            [0.0626154769198954, 4.193585670307532],
            [0.07930999384403484, 4.220993263961764],
            [0.06977366794042913, 4.255056786065052],
            [0.09291126792804533, 4.275644718943677],
            [0.09965677943070013, 4.289889899199391],
            [0.08524814431446144, 4.308270586650706],
            [0.10620450266432004, 4.340311429407075],
            [0.09223282690600787, 4.355419022210487],
            [0.09290621733941473, 4.38069731450372],
            [0.10736660087267032, 4.381495659867291],
            [0.11720708646083546, 4.393069325144115],
            [0.12888106543217703, 4.394666079266455],
            [0.13303291860006958, 4.405693800841975],
            [0.12927432085715135, 4.425647832721764],
            [0.14474583485864506, 4.44459638664676],
            [0.14186519989716187, 4.464565317778111],
            [0.12517450309567038, 4.481138554729355],
            [0.12652150377579957, 4.512955078737956],
            [0.12236762127374977, 4.536089374602553],
            [0.11196375048391756, 4.555264729160643],
            [0.08727461364323928, 4.548888580330688],
            [0.0818061348533775, 4.555312572504813],
            [0.061472331656449046, 4.558137397581227],
            [0.049761564679949036, 4.570416922759177],
            [0.06302316536265579, 4.578675104605248],
            [0.06335403114927522, 4.589181486370193],
            [0.04587472644549015, 4.59984405337416],
            [0.043173702218868557, 4.620610811706383],
            [0.0719417171849084, 4.626989405622735],
            [0.08324054105590702, 4.643867096482981],
            [0.07660787535686718, 4.667950785547975],
            [0.08435624084111602, 4.678666397992941],
            [0.08226140042514826, 4.699606178938764],
            [0.08479697831547418, 4.726285489140371],
            [0.07534625252250461, 4.726639510451003],
            [0.04912635134090064, 4.750991689458211],
            [0.04804453452903704, 4.7635433336337085],
            [0.03427530787956998, 4.766027970321241],
            [0.030240004004017662, 4.7890100632983925],
            [0.04299040627947745, 4.798914436427521],
            [0.04039527785982082, 4.823006887123196],
            [0.03131726923833612, 4.832431873082665],
            [0.13648753483494733, 4.8317847135304826]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.50005321232668, "lat": 42.07457605913389 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779785"
      },
      "bbox": [
        0.000059486853631150533, 1.7755932379598092, 4.784735252928372,
        4.917702139268153
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.35873823281522, 10.290830594694793],
            [-18.32452932178959, 10.292986097378911],
            [-18.310718485997157, 10.287023865553499],
            [-18.294916725782517, 10.262634673861365],
            [-18.287471313530297, 10.239476932807861],
            [-18.30327362249369, 10.195146666464618],
            [-18.283981685397265, 10.161700491580586],
            [-18.273641640270892, 10.150429352111432],
            [-18.213324221419544, 10.131305454207725],
            [-18.160833132821196, 10.144444398071451],
            [-18.1251636817009, 10.150943465453434],
            [-18.09258613730529, 10.137735111123751],
            [-18.087473265751722, 10.12848630541784],
            [-18.058295237291595, 10.095422671186675],
            [-18.053819806615063, 10.086712922677778],
            [-18.03263131299622, 10.06778949345822],
            [-18.01304299723739, 10.032462759518813],
            [-17.97986948807914, 10.001362247101993],
            [-17.97330158373856, 9.975465817914161],
            [-17.977118844071125, 9.946861437865866],
            [-17.96715345927973, 9.92679191099516],
            [-17.96414569599671, 9.891466219911212],
            [-17.953861448807878, 9.868208526739634],
            [-17.95658424144047, 9.839718507115505],
            [-17.965615293383646, 9.82212135173084],
            [-17.964528024596255, 9.792716019016094],
            [-17.960403823955264, 9.774491562094925],
            [-17.96737669529769, 9.752412047083531],
            [-17.97958765622769, 9.736223514896468],
            [-17.983523895447938, 9.721944458692581],
            [-17.9742210766321, 9.689128387907289],
            [-17.974750400233862, 9.667314992717067],
            [-17.980721717166215, 9.643635709716396],
            [-17.99870428990056, 9.613094455588755],
            [-18.005381524104784, 9.595302498506006],
            [-18.004667614472947, 9.57119385217085],
            [-17.99101085245258, 9.553961201194223],
            [-17.976204838132066, 9.542869173655424],
            [-17.95583584850878, 9.517169651713804],
            [-17.93722161690795, 9.50336456203097],
            [-17.910027461141077, 9.493494031936045],
            [-17.876396094848246, 9.472816722741344],
            [-17.832024595859032, 9.441341445085902],
            [-17.81184310094287, 9.420552439366729],
            [-17.769151493913952, 9.421212154790009],
            [-17.752413469097228, 9.409844071468305],
            [-17.743866420868912, 9.385703433891214],
            [-17.720490833850548, 9.374329922209],
            [-17.688409013068693, 9.369661372782367],
            [-17.652075346647713, 9.376321254273384],
            [-17.63625685952603, 9.385803327558477],
            [-17.605473664074704, 9.3842076082372],
            [-17.57941589409585, 9.375941692348354],
            [-17.533769380640553, 9.389909081881635],
            [-17.50462850525403, 9.388404925951322],
            [-17.4730385020401, 9.396929042164418],
            [-17.464870787341578, 9.405706977577227],
            [-17.450842444639488, 9.40245688228408],
            [-17.42998321881668, 9.407176378791027],
            [-17.42127494255298, 9.421481733091738],
            [-17.391856276614952, 9.436472750707114],
            [-17.350633867020264, 9.438937695419522],
            [-17.3027368700728, 9.412782170469342],
            [-17.283846195596492, 9.408399728992336],
            [-17.25484349630095, 9.410983216522602],
            [-17.22990729839733, 9.403743297367427],
            [-17.158048595735032, 9.406569801393138],
            [-17.136689806400256, 9.394949106263187],
            [-17.117387647805185, 9.36979887160421],
            [-17.078442517864914, 9.350592742810063],
            [-17.056086921421283, 9.355009663807259],
            [-17.032143188213507, 9.350432106863794],
            [-17.01622673759806, 9.34100967232865],
            [-17.002847729042763, 9.324217060609389],
            [-16.95873295001043, 9.296239480036432],
            [-16.953942765841205, 9.273071086842949],
            [-16.9600505559015, 9.24082777400013],
            [-16.954147679707074, 9.228768449909357],
            [-16.918233952559603, 9.222554948343657],
            [-16.9067114986604, 9.233145773885369],
            [-16.87652901024885, 9.250395301641612],
            [-16.861432611872527, 9.25112866963465],
            [-16.822826853200862, 9.241535267107015],
            [-16.807906049420506, 9.232591316995467],
            [-16.779127627767465, 9.233230499224364],
            [-16.7627768955588, 9.2121431991344],
            [-16.749933006597665, 9.211705503548686],
            [-16.715585186559803, 9.231836425667812],
            [-16.666678236520475, 9.233946706448181],
            [-16.59187504015922, 9.244500968318071],
            [-16.574364597692643, 9.254504165339272],
            [-16.54745591241678, 9.26347792581665],
            [-16.517708918727756, 9.256414416599894],
            [-16.498401230680567, 9.243009160508436],
            [-16.471965820914797, 9.19704358031042],
            [-16.457511130043237, 9.187569885692682],
            [-16.403302531456937, 9.178392534459167],
            [-16.3496838770832, 9.176553499326078],
            [-16.315404222463126, 9.178107234930625],
            [-16.265954543149725, 9.170169251831176],
            [-16.229659333167945, 9.197544053032425],
            [-16.20718253615969, 9.203195592686557],
            [-16.156066679364223, 9.202343795445469],
            [-16.075739984152083, 9.221811595407937],
            [-16.03543266850763, 9.21541298194944],
            [-15.959823162022454, 9.216022194532261],
            [-15.940223714142139, 9.209089512720539],
            [-15.867816211835086, 9.202359113298357],
            [-15.82442236734502, 9.241094322236153],
            [-15.805574320148233, 9.250555284096345],
            [-15.784577865296155, 9.251278981883958],
            [-15.75700084411686, 9.22725768769174],
            [-15.732704995890018, 9.218865769784308],
            [-15.704629286925805, 9.223112279940683],
            [-15.645597235243681, 9.212785759216793],
            [-15.614490191376388, 9.216856687573937],
            [-15.568705228149337, 9.212407457641095],
            [-15.529984582714185, 9.190626190789537],
            [-15.512455266326414, 9.186048367321698],
            [-15.481874375302063, 9.183886849675437],
            [-15.457263263641334, 9.187902676032763],
            [-15.432012536114572, 9.197758043157483],
            [-15.406222029760867, 9.20223323236999],
            [-15.391296977907942, 9.208886062729135],
            [-15.371896221170873, 9.225059318909667],
            [-15.340730381661205, 9.218208223667991],
            [-15.26566422302479, 9.20018828766325],
            [-15.1906020885669, 9.182150987979165],
            [-15.115544006808504, 9.164096330657884],
            [-15.040490006254123, 9.146024321818594],
            [-14.915077974590126, 9.116263689270193],
            [-14.789677181044784, 9.086454725675388],
            [-14.702035863529442, 9.06650905794231],
            [-14.60762939484724, 9.044229968309773],
            [-14.51322935172644, 9.021923543458026],
            [-14.431198571750578, 9.002202249726636],
            [-14.34917288402684, 8.982460296176352],
            [-14.25577620460146, 8.962101749717604],
            [-14.136613512402583, 8.934618985336993],
            [-14.017460911068879, 8.907092860325736],
            [-13.970354314944897, 8.895086305804204],
            [-13.95879784323947, 8.873284504154256],
            [-13.961035802617598, 8.85723452037858],
            [-13.95211186532841, 8.849603070865866],
            [-13.953847394517096, 8.81211417749285],
            [-13.94357961964589, 8.784886117876542],
            [-13.926773543944876, 8.766296836292694],
            [-13.918602926967448, 8.745203822099333],
            [-13.916673538506462, 8.711300036512494],
            [-13.905453241193761, 8.699938101560393],
            [-13.884899952986276, 8.70514113421436],
            [-13.86004409952791, 8.694310623829683],
            [-13.853705675477741, 8.665347464081533],
            [-13.846123279393197, 8.651963902402517],
            [-13.822778395934463, 8.649885031607017],
            [-13.7975612746453, 8.63787941793278],
            [-13.779692222965837, 8.610371659745361],
            [-13.771866324470855, 8.604405898567027],
            [-13.767988205532392, 8.586628302531372],
            [-13.776887508981199, 8.545562163641216],
            [-13.774222240217444, 8.534600471912993],
            [-13.753430787322273, 8.498009518314063],
            [-13.744026226977699, 8.461578827877482],
            [-13.7468923560538, 8.449040202517155],
            [-13.761792065487645, 8.437239342606636],
            [-13.76562177175301, 8.426999222414384],
            [-13.7813788663746, 8.41988353332801],
            [-13.799945583800232, 8.403660807112994],
            [-13.820716423281482, 8.375339978829093],
            [-13.831151484923403, 8.369543946508838],
            [-13.838044246078729, 8.345672835059773],
            [-13.839240480395665, 8.327435462498173],
            [-13.866395335256811, 8.31306862056091],
            [-13.879218191480714, 8.285307127678086],
            [-13.89716432743, 8.274461818729176],
            [-13.951243446510253, 8.208511146874848],
            [-13.961475748449777, 8.164944148657124],
            [-13.971917521661727, 8.158615081894405],
            [-13.988862349766443, 8.134876451764825],
            [-14.001402549662513, 8.09928398921138],
            [-14.018308682077798, 8.071007597465258],
            [-14.029967348886561, 8.041522529457875],
            [-14.041313427010035, 8.037012698266023],
            [-14.05171469668655, 8.019940078742101],
            [-14.07482889813192, 8.006560285135553],
            [-14.079754149208695, 7.9885335720895005],
            [-14.092761991162424, 7.974430807071359],
            [-14.135824966053006, 7.94566474150366],
            [-14.138149190921698, 7.924671264275177],
            [-14.15024440657748, 7.9099286625216765],
            [-14.146973642619004, 7.896613176393521],
            [-14.151802723418701, 7.883662035578443],
            [-14.145240119204033, 7.864447324219773],
            [-14.150857618517149, 7.848375558977022],
            [-14.168343196956291, 7.81561604532521],
            [-14.1809602363455, 7.801142330320117],
            [-14.20524198028875, 7.791417171472129],
            [-14.21670565565044, 7.772642198002316],
            [-14.243881326337098, 7.742035938005315],
            [-14.247834660002498, 7.727755175439707],
            [-14.27193362557706, 7.724254783939738],
            [-14.298254787573471, 7.710980044022031],
            [-14.308456602978785, 7.71371862842492],
            [-14.332061987941474, 7.707072399302182],
            [-14.348511933001182, 7.692426091383307],
            [-14.35269649742606, 7.6725042385649305],
            [-14.367872545032638, 7.6611543603604995],
            [-14.37326497587131, 7.643534501010019],
            [-14.38551566630856, 7.637162798333202],
            [-14.392450719621035, 7.6142260969984985],
            [-14.413644582739801, 7.592459109592031],
            [-14.423386830837522, 7.563243953436276],
            [-14.441502591111506, 7.551788230236751],
            [-14.44528274115995, 7.529247340114003],
            [-14.461515788151786, 7.512019972390917],
            [-14.476258212096086, 7.513082617754138],
            [-14.49020667979329, 7.4926997507787645],
            [-14.503505225542943, 7.481193801605962],
            [-14.51669207682534, 7.477768726150413],
            [-14.515813231398804, 7.4456023752681855],
            [-14.520747108083052, 7.4254370534920895],
            [-14.533810148438352, 7.406375231000597],
            [-14.546722113878603, 7.400071094520982],
            [-14.546513319655439, 7.376878886677561],
            [-14.525524615123764, 7.34411555914],
            [-14.523255913326462, 7.33363340462096],
            [-14.537910878840082, 7.312897203821796],
            [-14.5493104840347, 7.309501715878919],
            [-14.55288548821509, 7.291103777352311],
            [-14.526958605197692, 7.255208337823241],
            [-14.504694418511933, 7.250699403497314],
            [-14.488490059362135, 7.265647480529875],
            [-14.476252609564094, 7.265307906615991],
            [-14.470805816106171, 7.241946932934452],
            [-14.45846693395685, 7.224676839010109],
            [-14.453856411844603, 7.210245828359881],
            [-14.432770057438828, 7.2236545136514305],
            [-14.395054791001598, 7.209341780109747],
            [-14.3966581675128, 7.183841030518321],
            [-14.402116553291076, 7.16441239627877],
            [-14.386636210032457, 7.154856664226356],
            [-14.371092571484303, 7.151688896270763],
            [-14.357945223134505, 7.136451816764598],
            [-14.356114928583613, 7.1163825420535725],
            [-14.391581240023209, 7.070316301165853],
            [-14.404843772772747, 7.059725719420109],
            [-14.430652485511002, 7.056592742006617],
            [-14.435304475756185, 7.020277962385667],
            [-14.41781672215009, 7.002988651244288],
            [-14.414768735251387, 6.987615800065522],
            [-14.425202915377625, 6.971498361905082],
            [-14.42540276977776, 6.952554203006991],
            [-14.44093156573905, 6.954307944535324],
            [-14.454143187611214, 6.948870192475946],
            [-14.445083224063234, 6.935719097966142],
            [-14.456939073110682, 6.908720188552854],
            [-14.457222580862842, 6.891102811482152],
            [-14.469590866240127, 6.891582442769902],
            [-14.471667631810732, 6.871112469026717],
            [-14.48111297313585, 6.84917988999396],
            [-14.510313851539037, 6.843155255802358],
            [-14.505798968573167, 6.8327459744870795],
            [-14.525690627765023, 6.817028692629125],
            [-14.520087383245357, 6.80492230012969],
            [-14.526139706217975, 6.794734740257234],
            [-14.584036752385039, 6.5394039989505925],
            [-14.634818466837654, 6.314911899014345],
            [-14.69879092753657, 6.031967765700701],
            [-14.746546691853846, 5.8194535211898435],
            [-14.787144119729161, 5.641215506329828],
            [-14.841459174727527, 5.400463045737311],
            [-14.888070478072866, 5.192916489985554],
            [-14.92486600987085, 5.029971282100715],
            [-15.048267081621049, 5.058238267867252],
            [-15.202499301050853, 5.092296531406042],
            [-15.356741049712493, 5.12630940423575],
            [-15.445645060243509, 5.147061360906781],
            [-15.53455249245739, 5.167798136321453],
            [-15.651011895092019, 5.19450292910858],
            [-15.76747697388009, 5.221181707966136],
            [-15.8766015099354, 5.2464298816673205],
            [-15.98573106261739, 5.271655180210401],
            [-16.126740580199296, 5.301915929805751],
            [-16.23566142428298, 5.3295459173092405],
            [-16.344587955390303, 5.3571528343548165],
            [-16.493186262726507, 5.3932067687792005],
            [-16.577484330982553, 5.415423957128289],
            [-16.661785975091536, 5.437627228487091],
            [-16.762232059795892, 5.4633954447565465],
            [-16.862682995359172, 5.489143960516239],
            [-16.96992398248974, 5.517383123241515],
            [-17.058519470490573, 5.537740661654423],
            [-17.193507793212262, 5.572038983905649],
            [-17.29277824810738, 5.5958838866022],
            [-17.40859041555332, 5.627215129470037],
            [-17.499262971175444, 5.650452409731392],
            [-17.59269904011616, 5.675618504589839],
            [-17.686139527537577, 5.700767374359409],
            [-17.788801553235032, 5.72773554691078],
            [-17.896075494586736, 5.760664288106146],
            [-17.983732131896854, 5.784513515659188],
            [-18.017925489438298, 5.792611276779058],
            [-18.105122663435285, 5.817969990339544],
            [-18.192324107076384, 5.843313453155064],
            [-18.31565010354856, 5.879840479373247],
            [-18.43898483871931, 5.916336840044659],
            [-18.451578300544956, 5.919508331614938],
            [-18.596919077738093, 5.964102493426899],
            [-18.665809229229577, 5.983861182863991],
            [-18.748912674609276, 6.009296014935259],
            [-18.87033470974607, 6.041765408164323],
            [-18.93185720395023, 6.056757407656165],
            [-18.98764323190909, 6.071888262758918],
            [-19.10503848601383, 6.105235995152803],
            [-19.222441030710122, 6.138556042019366],
            [-19.292867598515915, 6.165000059504424],
            [-19.32074373130648, 6.170042656373816],
            [-19.43797752796268, 6.1976274954721156],
            [-19.506723628968736, 6.219282344156378],
            [-19.633789980372082, 6.256059679012835],
            [-19.65860309265812, 6.258555652504499],
            [-19.708189292705768, 6.275388494610742],
            [-19.78339107485438, 6.296899362166803],
            [-19.89995536071786, 6.3319662155021605],
            [-20.0491724919578, 6.379574429172973],
            [-20.05156201922595, 6.390198144080046],
            [-20.067098553893388, 6.4138525623864275],
            [-20.076801021466974, 6.437272714566081],
            [-20.095549226808433, 6.449458495835626],
            [-20.106180219878127, 6.487944413774074],
            [-20.113279331202328, 6.499417308694384],
            [-20.116437632875808, 6.525211085357928],
            [-20.10766323893643, 6.540270122272964],
            [-20.111302047238716, 6.565961306171867],
            [-20.100602809072612, 6.586031410586725],
            [-20.104781286645945, 6.603005554051959],
            [-20.101115677125048, 6.626012559330427],
            [-20.115058450586467, 6.663488004898849],
            [-20.10427781255176, 6.691376402255793],
            [-20.098789633445534, 6.717985699864263],
            [-20.10878620602068, 6.738395208918961],
            [-20.101452434906665, 6.747556560008588],
            [-20.078149859413806, 6.818340852889436],
            [-20.07718560491785, 6.84712665104671],
            [-20.06034821624807, 6.867117012557624],
            [-20.05002096756989, 6.90076193145672],
            [-20.02196244320653, 6.9359320049637105],
            [-20.004265881794932, 6.968649474744872],
            [-20.006211714148947, 6.987186891697719],
            [-19.996566117035027, 7.021092044556748],
            [-19.999849222764837, 7.041535282870959],
            [-19.99580144694632, 7.052981412842486],
            [-20.016777541713214, 7.078067573399172],
            [-20.01185340956498, 7.085903138206933],
            [-20.016035966167443, 7.137264269863318],
            [-20.03984405395524, 7.158311974873865],
            [-20.034325830214566, 7.202552396805174],
            [-20.035179793125504, 7.228285773836481],
            [-20.045367377766706, 7.2524372165083975],
            [-20.021130608239602, 7.27429598370936],
            [-19.979447592895983, 7.319094184897165],
            [-19.95599637780652, 7.347394911855335],
            [-19.90849536449159, 7.416673971991692],
            [-19.878895147366404, 7.476037558724934],
            [-19.87491991511239, 7.494227935350995],
            [-19.86452647683416, 7.502391833829538],
            [-19.831818594584767, 7.552925538661338],
            [-19.816034197250463, 7.588782188479051],
            [-19.793245899144324, 7.630050021948222],
            [-19.791677856064947, 7.650788619352473],
            [-19.79677272445002, 7.668341313306415],
            [-19.766388852245846, 7.693544860623948],
            [-19.751661487365357, 7.69292527335101],
            [-19.711666924517328, 7.7283797730954085],
            [-19.678112196299203, 7.768070932408894],
            [-19.637106356443674, 7.824204373872006],
            [-19.603117959339812, 7.876572037972084],
            [-19.571848543109912, 7.934960528374644],
            [-19.552614130313774, 7.977401141184202],
            [-19.534516710084237, 8.005880455264398],
            [-19.487018718646578, 8.097845943895116],
            [-19.44458606052464, 8.190902058365117],
            [-19.411651271639006, 8.268694933760687],
            [-19.402596517486213, 8.294705213537311],
            [-19.369472785580996, 8.370690581189773],
            [-19.367323544854596, 8.386847559359877],
            [-19.345373382357153, 8.431992010597199],
            [-19.322834857404466, 8.490714976043753],
            [-19.3225527030757, 8.501941238173366],
            [-19.312504977632685, 8.519134312140581],
            [-19.314610539829726, 8.52927413676587],
            [-19.29711362088589, 8.569365472792198],
            [-19.287377035759125, 8.580464594417379],
            [-19.247097631812665, 8.670402551807365],
            [-19.22638287085156, 8.737432376717303],
            [-19.21190417950891, 8.764648462732652],
            [-19.186915559056295, 8.823978859147921],
            [-19.18390596599413, 8.840483488267177],
            [-19.163146883845787, 8.881740027968187],
            [-19.162982225929387, 8.90676334326483],
            [-19.14064488594803, 8.953925910136652],
            [-19.138760986257953, 8.987127514080726],
            [-19.141993006956774, 8.991819486268179],
            [-19.13325111528609, 9.01681236766669],
            [-19.1187442936902, 9.046017624366621],
            [-19.108062231211356, 9.050740212863529],
            [-19.075040276019067, 9.105519221038561],
            [-19.055048635709234, 9.15017862703985],
            [-19.025682105121778, 9.210486640176576],
            [-19.02201008697046, 9.24355922228917],
            [-19.010189978702336, 9.268015866934702],
            [-18.989936862620436, 9.27963115412585],
            [-18.965483067718427, 9.325404068382001],
            [-18.944420978691525, 9.376626455507127],
            [-18.94301281969994, 9.391607274978565],
            [-18.91748822410932, 9.450950548523181],
            [-18.9081074757893, 9.485222470976927],
            [-18.909652741031035, 9.51733598753769],
            [-18.903354943764114, 9.522738888090247],
            [-18.88907442684494, 9.550891554982444],
            [-18.872682884434294, 9.591893193120246],
            [-18.871549890732037, 9.629220642814317],
            [-18.854460129612892, 9.6548578405479],
            [-18.831996711345116, 9.697807898368662],
            [-18.82935901844047, 9.723704790199214],
            [-18.794405754225394, 9.797607809388145],
            [-18.775143276551557, 9.867798871557747],
            [-18.78356403789204, 9.887376716299427],
            [-18.780264715636992, 9.901488087669293],
            [-18.789928805356805, 9.914400548039355],
            [-18.777340343288937, 9.92277078291518],
            [-18.755567724970675, 9.975156683158346],
            [-18.739144046868507, 10.042935481096032],
            [-18.7399975028361, 10.064521424074805],
            [-18.745326857270772, 10.084472537313985],
            [-18.7300547338736, 10.08987748078741],
            [-18.722950500202646, 10.101123833616748],
            [-18.69892620820277, 10.102349501916473],
            [-18.683215614445064, 10.13080081305419],
            [-18.668896452659794, 10.190308535282835],
            [-18.66545387324696, 10.234920525559183],
            [-18.66787727039096, 10.289693448569826],
            [-18.67606653733394, 10.348277020301683],
            [-18.66560643558469, 10.358389569727514],
            [-18.65438887452464, 10.330691759891003],
            [-18.61872019753242, 10.287252335402284],
            [-18.62033843779606, 10.275437051918885],
            [-18.59193019135838, 10.255337484775941],
            [-18.580423548058835, 10.266491450465766],
            [-18.588681677112653, 10.278004922766383],
            [-18.576035503961236, 10.286867597396435],
            [-18.56053558322916, 10.279820870051596],
            [-18.532506264334145, 10.279972525859463],
            [-18.511338479431934, 10.288535644929283],
            [-18.492036495033037, 10.2582098272479],
            [-18.475377170590534, 10.254134835036359],
            [-18.46018134713756, 10.258254559397473],
            [-18.449511570509042, 10.275636247568771],
            [-18.436000387884995, 10.266472310674601],
            [-18.418967879361766, 10.263649023171537],
            [-18.389990179631447, 10.270720455770872],
            [-18.361945990564212, 10.281433674837894],
            [-18.35873823281522, 10.290830594694793]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -120.5553932097094, "lat": 43.93659911844378 },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01155107"
      },
      "bbox": [
        -20.116437632875808, 5.029971282100715, -13.744026226977699,
        10.358389569727514
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.735776846418827, 3.311573963954939],
            [6.7489849376515165, 3.2984069121933297],
            [6.774080138381033, 3.2815952310351064],
            [6.810706607120183, 3.299880294118812],
            [6.8241098412033505, 3.2911910800793196],
            [6.8162314338579995, 3.269516439597625],
            [6.824768110996771, 3.254307924582929],
            [6.857540099770476, 3.2434857300005833],
            [6.917561354535517, 3.239681311718722],
            [6.967542529884051, 3.2478319793825032],
            [7.009771240382488, 3.2629025971955263],
            [7.012143128851044, 3.2693845202569873],
            [7.0547873281907965, 3.2836543253557777],
            [7.1051519017695295, 3.311524345998415],
            [7.150553792528924, 3.3410120032868895],
            [7.179091555163663, 3.3570115053148055],
            [7.187763231204577, 3.372203930832026],
            [7.211551131824423, 3.385601557787923],
            [7.246690071478481, 3.4115212082293382],
            [7.359287624543721, 3.42219824721433],
            [7.471887225477914, 3.4328532477659084],
            [7.6160044800678275, 3.448147135090895],
            [7.760125624267612, 3.463404838855522],
            [7.884081350518487, 3.4757586182009095],
            [8.008039655753489, 3.488085656175933],
            [8.143340973260873, 3.5028078354917707],
            [8.25344688512497, 3.5155736653899257],
            [8.363555283652062, 3.5283183253820667],
            [8.48693256722366, 3.542093356690406],
            [8.610312765786034, 3.5558418241024805],
            [8.732961335534574, 3.5710778982706786],
            [8.740484202174706, 3.5070616795644556],
            [8.772622713716636, 3.248232722806682],
            [8.794818727497699, 3.0640879814971305],
            [8.8263437104253, 2.7998141231543405],
            [8.849317783453042, 2.6123611019309765],
            [8.884327920699254, 2.313221459900367],
            [8.893878219003986, 2.2241458037630673],
            [8.906203695492117, 2.1231953196764266],
            [8.917982079935063, 2.008657519670674],
            [8.938070236313457, 1.8052500214340235],
            [8.957352524919775, 1.6230171017983566],
            [8.978907095781993, 1.4373798334522856],
            [8.995918472456845, 1.2868663097200062],
            [9.013619605957546, 1.112922169767891],
            [9.036739570403844, 0.91269942906734],
            [9.027958583696153, 0.9065890821458579],
            [9.009028988567831, 0.8816402316959966],
            [8.988892289909252, 0.86731493387318],
            [8.984432732405807, 0.8535044286572327],
            [9.03768378804248, 0.7934482900139521],
            [9.045447414033651, 0.7753811227244074],
            [9.042743868018707, 0.7634486054076413],
            [9.018904066315168, 0.7314339949482882],
            [9.013938853864339, 0.7175181315721312],
            [9.02279234221044, 0.7025717420585794],
            [9.053516005476311, 0.7030073462545985],
            [9.077386898802278, 0.6995403483667345],
            [9.08903432585285, 0.6919224698223899],
            [9.089709205296579, 0.673808875292239],
            [9.065835720661534, 0.6454362164152119],
            [9.065409348800202, 0.6244812997213725],
            [9.080318768939389, 0.5999438066866455],
            [9.079003502916493, 0.5913720965828803],
            [9.061192404477497, 0.5896935215742731],
            [9.022095374364245, 0.5951253417735888],
            [8.989089985631717, 0.5737138167750704],
            [8.97784329666045, 0.5703356690316533],
            [8.943763554369077, 0.5694612738724327],
            [8.930487225804765, 0.5562236432150409],
            [8.886690606277538, 0.5252683127903108],
            [8.868516550012433, 0.5088877639671301],
            [8.841746957846595, 0.47808620945396285],
            [8.81523575956099, 0.46263475856270353],
            [8.803310960104236, 0.46082531698792334],
            [8.783504660421865, 0.46655605963512453],
            [8.772351334183186, 0.47587574268196803],
            [8.753823557292787, 0.5001431177811305],
            [8.73599392904635, 0.506598281030519],
            [8.707567512668103, 0.5047838901522975],
            [8.675122425859763, 0.49173352707050705],
            [8.657433965376187, 0.48786245840773734],
            [8.627528751878206, 0.49130268503870994],
            [8.608489759520745, 0.4803860455976866],
            [8.59842564119492, 0.45864995963989563],
            [8.59894372372001, 0.432187198636665],
            [8.614358440781313, 0.410771053742222],
            [8.618954583371886, 0.3626929485966667],
            [8.623059260754394, 0.34983825581576533],
            [8.642720417797294, 0.31664441887793715],
            [8.641060649916634, 0.28534047749174163],
            [8.629977946304294, 0.272926497796858],
            [8.609326130956335, 0.25935664826475907],
            [8.589421891708005, 0.21386618871936347],
            [8.57062382716919, 0.2010081109647477],
            [8.52424828522001, 0.1882271859048337],
            [8.51106692365482, 0.17735930893175839],
            [8.502000750882958, 0.1616681260191186],
            [8.494071434734998, 0.12962624198619432],
            [8.493126839344743, 0.09730278037333946],
            [8.484652805458897, 0.055642631988737194],
            [8.465973424100383, 0.024775886337589318],
            [8.424706307335239, -0.0077463567265910705],
            [8.408741598093295, -0.005299045551852029],
            [8.398504104283438, 0.0074179505429151195],
            [8.386874078497325, 0.009154662999269472],
            [8.363970978708148, 0.00044558536572454843],
            [8.351307292090738, -0.018279193727217008],
            [8.351801801270518, -0.044186166766758864],
            [8.343455711245628, -0.06314580675977034],
            [8.323861762116639, -0.08410529586699535],
            [8.308722735233587, -0.11540302236470239],
            [8.30926387115533, -0.15632130812189365],
            [8.316766308363773, -0.20107865058926724],
            [8.31119819995303, -0.23011400458515513],
            [8.308139398089947, -0.2701891179850603],
            [8.293272284100988, -0.28872706762492745],
            [8.269934670702185, -0.29292422575408367],
            [8.23351960712365, -0.30578923920386547],
            [8.227247755560787, -0.31979687369673027],
            [8.229852925446409, -0.33651928542990384],
            [8.21811791343772, -0.3419376418311301],
            [8.205009560792716, -0.3279636894827086],
            [8.191098154393126, -0.30403134989482233],
            [8.170608329599695, -0.29398920850687704],
            [8.151508036966607, -0.29236311206226406],
            [8.114682423009066, -0.30224528244067617],
            [8.078553431316731, -0.28776337271042934],
            [8.067569316712667, -0.27727609396413233],
            [8.039524146742057, -0.26272993118573773],
            [8.028730576913002, -0.2377669847524186],
            [8.025764126009427, -0.21952215863046198],
            [8.02961419388515, -0.18965873776642278],
            [8.013663651764661, -0.16271415261369665],
            [7.988865533897516, -0.1500593201610412],
            [7.962869746368983, -0.12991846843748617],
            [7.942893787918796, -0.13399260685917208],
            [7.94232338604136, -0.15635347604444258],
            [7.952143069017997, -0.16535120117502342],
            [7.982291247631367, -0.16912517370214195],
            [7.988386423209079, -0.17640080409731657],
            [7.983789639434625, -0.1921024940551555],
            [7.975357384213363, -0.19728913444499102],
            [7.948117645417004, -0.19712659781167385],
            [7.927593535768353, -0.22440926747481724],
            [7.9066431020638275, -0.20675713971157747],
            [7.890749590084312, -0.2063902305477477],
            [7.8794182850605, -0.22050852771844454],
            [7.8869022616002376, -0.2384609957401624],
            [7.907059663179129, -0.2458090561793362],
            [7.910022606271676, -0.2653947419268221],
            [7.89666123520222, -0.28367311133909745],
            [7.846942592320108, -0.296640322768481],
            [7.842465745769538, -0.3120624669810143],
            [7.848301691134886, -0.3720154249091853],
            [7.86558675235823, -0.4025460840905622],
            [7.863546405034485, -0.41322282386767145],
            [7.846467370584793, -0.42417976253429235],
            [7.820997871862651, -0.42148701443739134],
            [7.803744229661076, -0.4242229699414356],
            [7.79642210151179, -0.4395676168344502],
            [7.801701593057549, -0.478996639245737],
            [7.7975405094896555, -0.4886538073632972],
            [7.772910914940007, -0.5068750197921118],
            [7.757202649275056, -0.5069786136073323],
            [7.752644551012968, -0.4944329068655902],
            [7.762691901238711, -0.4550304445050109],
            [7.7569764739993055, -0.4395521718739895],
            [7.728797565392523, -0.43982354807394397],
            [7.7055343659417534, -0.4623598929421761],
            [7.695305387016664, -0.46212646416957137],
            [7.67829541325427, -0.44496472986178837],
            [7.651640197993661, -0.40437282271803404],
            [7.636201520010226, -0.37138779446705505],
            [7.613542198390595, -0.3639617287931177],
            [7.589460064203632, -0.3781059706896428],
            [7.568083837458279, -0.4047391507412429],
            [7.557639836026134, -0.42260402734888053],
            [7.5401979179289595, -0.43577914935056544],
            [7.499357826289198, -0.44465820844800097],
            [7.474469933682494, -0.4586799207084474],
            [7.451251341365498, -0.485602772430079],
            [7.455194798758541, -0.5113784560082207],
            [7.448674392553232, -0.5536008999470838],
            [7.441007519801909, -0.5807128247226182],
            [7.422009028465151, -0.5989857698560164],
            [7.395704679324001, -0.6000842946522366],
            [7.383657849662454, -0.5710808040120855],
            [7.363208429468417, -0.5475989955912689],
            [7.332452777071603, -0.5472794490879553],
            [7.319198257804945, -0.543851629397628],
            [7.289276846045106, -0.527028508499382],
            [7.269040122554139, -0.5114063241857645],
            [7.236592826912907, -0.49422361290576317],
            [7.216483131654405, -0.490343601224656],
            [7.18254801253669, -0.4665586514792995],
            [7.1602123699321, -0.46144308775263887],
            [7.14122066958644, -0.4636588814672656],
            [7.120619922112117, -0.4761960111169977],
            [7.098244282020268, -0.5010420461100458],
            [7.087303060385609, -0.506829238434149],
            [7.05464374052505, -0.4904925789121019],
            [7.036509144850878, -0.4705983541957364],
            [7.0318320768711455, -0.44957878917871347],
            [7.011420795838043, -0.4478153301892933],
            [7.010181965482401, -0.4693759703003718],
            [6.995312429420193, -0.4989649026665268],
            [7.002130951729844, -0.5131395106446708],
            [7.03036001633758, -0.5337708627998073],
            [7.030265892528642, -0.5604184906528247],
            [7.013065787977306, -0.588913308207762],
            [6.989873799046915, -0.5971189644024899],
            [6.968909837842834, -0.5956912326384134],
            [6.959348786106704, -0.5693746947733751],
            [6.968772221227268, -0.5442860450769128],
            [6.9673472865366985, -0.5282816708370357],
            [6.950972681424513, -0.5223326193461846],
            [6.93338736636914, -0.533149288247311],
            [6.911947150359931, -0.5342098753474191],
            [6.893245960749851, -0.5398499659951727],
            [6.875939526339479, -0.5557269520295033],
            [6.842179508968669, -0.5587766282479035],
            [6.818693258078115, -0.5362457619225517],
            [6.805028821255511, -0.5167935376202228],
            [6.788919515867872, -0.5111482655419443],
            [6.779593742973882, -0.5150239905880637],
            [6.756377299908676, -0.5515502475068856],
            [6.759998012863342, -0.5744142819402451],
            [6.778188947696016, -0.5914302329761718],
            [6.78956468041973, -0.6227436871293803],
            [6.788092378234191, -0.6331436116598592],
            [6.767228059853423, -0.647491818818104],
            [6.761472917470745, -0.66821254263904],
            [6.749538805206836, -0.6712856184989213],
            [6.735520882779716, -0.657494314121808],
            [6.70411884623183, -0.64603305924615],
            [6.6943006719984055, -0.6496011995450596],
            [6.685921658012764, -0.6395234714480178],
            [6.669469899613702, -0.6496862895446355],
            [6.656126452282315, -0.6473177090688018],
            [6.644476409015915, -0.6359931977369485],
            [6.646778244034074, -0.6230166687801351],
            [6.6689316311088565, -0.6281957561408453],
            [6.688289683502414, -0.6246121835524614],
            [6.68657497408993, -0.6069885942301416],
            [6.665648860617376, -0.6018380280759306],
            [6.64820800589513, -0.5725065880036482],
            [6.63419028980466, -0.5589117193518893],
            [6.639970519483417, -0.546245840990886],
            [6.665222476985055, -0.558801929656371],
            [6.69763771809264, -0.5524147202925545],
            [6.6908882538229255, -0.5346959622700836],
            [6.665831411426538, -0.5337705092423771],
            [6.652564896214852, -0.5279755672978934],
            [6.662139803308008, -0.5162483946520204],
            [6.673393521446361, -0.5246242709535216],
            [6.681371627737358, -0.5180626405393897],
            [6.67415188934135, -0.4916239961935037],
            [6.686325841735437, -0.48800846528697656],
            [6.691277468488178, -0.4696438777688162],
            [6.678411454645213, -0.440140331361196],
            [6.683908075785644, -0.4226532765838656],
            [6.669860704885132, -0.4157277273179462],
            [6.669360902864539, -0.3958065614562898],
            [6.6937008978514365, -0.3939600681493106],
            [6.718874073859165, -0.3760634596123968],
            [6.725449020194214, -0.3561526890900247],
            [6.721399345934046, -0.34343910504564457],
            [6.688333818193346, -0.36155867935312747],
            [6.677862469829251, -0.34897107466013044],
            [6.691212145161908, -0.33646449023158176],
            [6.708945117115858, -0.3333799037359564],
            [6.711712064060446, -0.3121769981513355],
            [6.730686684694228, -0.3147510076821219],
            [6.741959289555025, -0.2891888259242669],
            [6.754303362288517, -0.2722142167240364],
            [6.730423121172204, -0.26583812493379283],
            [6.706198992176819, -0.2507825791421871],
            [6.693784313025036, -0.23427966839785075],
            [6.694476228395406, -0.20235646694625609],
            [6.709807379506, -0.2045361439569529],
            [6.7141120891623, -0.1639639198461953],
            [6.725445282221884, -0.1436399021144172],
            [6.74554642815046, -0.1455400700709162],
            [6.739556363077666, -0.15846907776256955],
            [6.7483886323142315, -0.16830036157726008],
            [6.761752346538094, -0.15128205526492003],
            [6.766038964332541, -0.13059044542211282],
            [6.781431107496177, -0.13154089265573626],
            [6.7780777279731295, -0.14513918263003867],
            [6.784332757165355, -0.15805071507627427],
            [6.796754738457678, -0.15550235346099908],
            [6.8045967826135, -0.1333472170551171],
            [6.801407094906297, -0.10564010739715884],
            [6.806392912704745, -0.08595804742608194],
            [6.818313948293569, -0.06752103285253704],
            [6.835604818736849, -0.060227912776780974],
            [6.8613473925320205, -0.01731188493472585],
            [6.863049031477207, 0.01221186081911072],
            [6.867947898591271, 0.025616228935910305],
            [6.848992237922022, 0.02913081700273784],
            [6.855838615712757, 0.05140746006335496],
            [6.879240017236666, 0.05609858903801436],
            [6.899906065312561, 0.07003412883970572],
            [6.908985876821811, 0.08659652180904778],
            [6.921559517780118, 0.08198598555721376],
            [6.929612668300242, 0.09121220052604982],
            [6.908381575688427, 0.12135865033504441],
            [6.92139350358459, 0.1371995122025407],
            [6.928395129843977, 0.15598470375158996],
            [6.926512632781694, 0.1716644902356779],
            [6.94018201547843, 0.16922495482668748],
            [6.9350403893534, 0.188276092317295],
            [6.952907107371763, 0.2505505238889919],
            [6.966016231535484, 0.2589728660698008],
            [6.991631949181173, 0.2664613921375047],
            [7.0020723733743795, 0.2739046241606385],
            [7.010067208296296, 0.2903224364877429],
            [7.008713565106243, 0.3012806553554848],
            [7.0174186793561075, 0.32691230562959633],
            [7.02109991456652, 0.3579956605586909],
            [7.020124522736446, 0.3783129440369423],
            [6.99301367866919, 0.4090209428607846],
            [6.996604099771306, 0.4179128461655687],
            [6.991369583217053, 0.43996820161530914],
            [6.97025805022088, 0.44976449443037303],
            [6.976928246579948, 0.4567686758955312],
            [6.973631643023565, 0.47909147820756826],
            [6.984408154565788, 0.5005782969373509],
            [6.990909274780283, 0.5252788481553596],
            [6.991356483233279, 0.5486381377920484],
            [6.9775363556883345, 0.5635443541075735],
            [6.940140207661391, 0.5751993615096316],
            [6.941989334392283, 0.6122517935862495],
            [6.932387906233379, 0.6304888906277714],
            [6.936853968368082, 0.6464396415031733],
            [6.912861117807282, 0.6687556688328745],
            [6.901374894262098, 0.668915641340538],
            [6.897589604132235, 0.6905918167805042],
            [6.8710170503018375, 0.6908367795785121],
            [6.876480128579159, 0.7133330763087128],
            [6.863882112624907, 0.7197585043312339],
            [6.878000642879083, 0.7542790688660471],
            [6.890783099389692, 0.7586842702660092],
            [6.901582413913697, 0.779136355554318],
            [6.913422560680238, 0.78861996172274],
            [6.920943710226901, 0.808318443484335],
            [6.912995826924785, 0.8449401330411421],
            [6.903884848342264, 0.8362422034350574],
            [6.893317525554441, 0.8504521497187763],
            [6.88872667755389, 0.8746617527107243],
            [6.894867908803491, 0.8821917733040053],
            [6.888718670721905, 0.8993739176923852],
            [6.899541381106989, 0.9233919867920434],
            [6.920759730242891, 0.9303646727657423],
            [6.9308688140719, 0.9447392266041431],
            [6.942097036727281, 0.9416016359029405],
            [6.934144119679178, 1.0325965382294524],
            [6.915726604846571, 1.2311148827192155],
            [6.893820829232005, 1.4681116994334356],
            [6.870397306961415, 1.7455487353354486],
            [6.843191100992163, 2.093402969431885],
            [6.8154469274900285, 2.407552179162864],
            [6.795485275685457, 2.62572433042335],
            [6.7706841304155985, 2.900328665841041],
            [6.7549973630841755, 3.0855096157168522],
            [6.735776846418827, 3.311573963954939]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.27560226403571, "lat": 39.90812940518638 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "00448508"
      },
      "bbox": [
        6.63419028980466, -0.6712856184989213, 9.089709205296579,
        3.5710778982706786
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.605251423641647, -1.0642165067663665],
              [16.61112110346935, -1.0589494342365402],
              [16.632975651772604, -1.0570836878519865],
              [16.661480075250175, -1.0688282646183012],
              [16.662331275968267, -1.0821103830507581],
              [16.675741933081834, -1.0799532748935106],
              [16.694286742171954, -1.0992965448760232],
              [16.7085476848451, -1.12388525611788],
              [16.708115041360134, -1.1329892225765454],
              [16.719223770663337, -1.1635592426680712],
              [16.71281783184187, -1.171430500995054],
              [16.69925470463313, -1.1648285655030275],
              [16.675504591249165, -1.1649305658059779],
              [16.678402762060088, -1.1487410882418827],
              [16.6728719509749, -1.1252333082868642],
              [16.65901435051204, -1.1077145042767806],
              [16.635413029205452, -1.092995610806806],
              [16.628939324779054, -1.0801624169443464],
              [16.609818791607147, -1.0738357751153824],
              [16.605251423641647, -1.0642165067663665]
            ]
          ],
          [
            [
              [16.757859262953282, -1.7902431837601187],
              [16.780694940281354, -1.7738476663940403],
              [16.787889765284046, -1.7520987174413643],
              [16.804761135192823, -1.7608572546946937],
              [16.823934775402783, -1.746674124120596],
              [16.83788402229981, -1.7248092207917678],
              [16.86525181539418, -1.702220161043896],
              [16.89619842047145, -1.6852490636368962],
              [16.907996378974577, -1.6860734287317005],
              [16.90821009799194, -1.6537839153113068],
              [16.899009587147688, -1.6189613152500684],
              [16.897245436291644, -1.5983334786988614],
              [16.904117125961065, -1.5812217741393857],
              [16.904937663113504, -1.5634364326602457],
              [16.898575369992567, -1.506633424987309],
              [16.89126321028539, -1.4580688942261595],
              [16.884170345182874, -1.4418414130610173],
              [16.888558907209944, -1.4171084806740897],
              [16.8858311184779, -1.3767022926807135],
              [16.873408683441525, -1.3301980681803298],
              [16.84304708298836, -1.2837952577920764],
              [16.835052153329038, -1.259826847709356],
              [16.826595484179116, -1.2525100514017582],
              [16.805493234963485, -1.2084000585920742],
              [16.820754770198757, -1.2151289174835387],
              [16.845390469276428, -1.2569634483951455],
              [16.86177100358186, -1.291456243234881],
              [16.88716059414245, -1.3571161319068774],
              [16.89473691261041, -1.3917961440570845],
              [16.89712355306494, -1.4677748846007905],
              [16.90981243887625, -1.550343405192171],
              [16.910160745002862, -1.6282465090874305],
              [16.914653693090763, -1.6971220955432293],
              [16.911447148218734, -1.7297636324411598],
              [16.88855618358808, -1.7268503101591246],
              [16.85402130841855, -1.7360506199868961],
              [16.81906051640388, -1.7541446019880804],
              [16.767772791285314, -1.789922875383658],
              [16.757859262953282, -1.7902431837601187]
            ]
          ],
          [
            [
              [16.56118852566391, -1.9662375757084352],
              [16.571252084504554, -1.9542651032270268],
              [16.5789832006446, -1.9341710058562775],
              [16.57286795901137, -1.916636580522755],
              [16.5806360496312, -1.9105667895339677],
              [16.597011648769698, -1.9124775080187593],
              [16.655857473095963, -1.8615822003639222],
              [16.660884002080905, -1.8657115875012833],
              [16.6251932885241, -1.8968215462235591],
              [16.59486914160932, -1.9291715032360244],
              [16.571259049950413, -1.9616820346702237],
              [16.56118852566391, -1.9662375757084352]
            ]
          ],
          [
            [
              [16.35738852317065, -2.238784339467854],
              [16.378399830842824, -2.209390156348964],
              [16.380063996910476, -2.195145827658625],
              [16.39244247160609, -2.192381803086829],
              [16.42334045128347, -2.1448400125896376],
              [16.441126345716917, -2.106806804595681],
              [16.461680021069316, -2.0759753400340792],
              [16.478078488884933, -2.046103910533594],
              [16.493082621101873, -2.030165688317596],
              [16.49364929319543, -2.020578918170983],
              [16.50814638675086, -2.0037836599961127],
              [16.513218017445492, -1.977201820790816],
              [16.530338207208644, -1.9720362508463802],
              [16.546418331277877, -1.9834488794891425],
              [16.52113774038118, -2.007358818315615],
              [16.50659680349404, -2.0261734159856584],
              [16.449924283938714, -2.1080779156578133],
              [16.414669241200162, -2.1651356322167206],
              [16.37748364603464, -2.215927903800798],
              [16.35738852317065, -2.238784339467854]
            ]
          ],
          [
            [
              [16.212317490972247, -2.4103793520042256],
              [16.2354265103253, -2.409201858101413],
              [16.234413670318073, -2.417654955602591],
              [16.2170856378244, -2.419040211947111],
              [16.212317490972247, -2.4103793520042256]
            ]
          ],
          [
            [
              [16.225396068979848, -2.4976460865500196],
              [16.24509013245645, -2.5066001220092455],
              [16.261102973930512, -2.4453307863059344],
              [16.270918912390325, -2.3974376865820353],
              [16.292171819583945, -2.369930108162989],
              [16.288526809074785, -2.3452836938297024],
              [16.308008920204347, -2.3343840197440837],
              [16.29772081148442, -2.3684504599709615],
              [16.267903518582422, -2.439572194121326],
              [16.250169876311258, -2.5001528885775657],
              [16.24638900436367, -2.525812521058582],
              [16.232364626281626, -2.511735750250509],
              [16.225396068979848, -2.4976460865500196]
            ]
          ],
          [
            [
              [16.18071062986301, -2.4135098306256557],
              [16.202001722611293, -2.413120926448607],
              [16.208897731806328, -2.4253617782451458],
              [16.187542828269507, -2.427373098155183],
              [16.18071062986301, -2.4135098306256557]
            ]
          ],
          [
            [
              [15.784953605620501, -2.563248073903266],
              [15.79129363126591, -2.552591513905486],
              [15.846210891761519, -2.52093537206288],
              [15.856828675281978, -2.5229648700275766],
              [15.929591658502032, -2.494780665593933],
              [15.936514340478574, -2.4879873248026865],
              [15.978501085420746, -2.4742854422206677],
              [15.990135510454836, -2.4634711508346854],
              [16.01789204320166, -2.456830262464865],
              [16.039525757857223, -2.456979951114065],
              [16.068206632543497, -2.4502117884379744],
              [16.092955183767867, -2.4343530866822394],
              [16.099173929789004, -2.451080734169634],
              [16.058737418964355, -2.455354276801295],
              [16.001968561490415, -2.47059862584951],
              [15.939254108748225, -2.493280094100212],
              [15.84873548147861, -2.531922830251943],
              [15.789838973272705, -2.5646227182902477],
              [15.784953605620501, -2.563248073903266]
            ]
          ],
          [
            [
              [11.81193691335464, -1.2771767341724631],
              [11.87233408404559, -1.26910409391499],
              [11.936148152496818, -1.2659724801190404],
              [12.051989587307812, -1.2540717361472706],
              [12.10484589592818, -1.2454977314373683],
              [12.301528934355973, -1.2228148168173008],
              [12.34530749307849, -1.219284523626619],
              [12.39079982754584, -1.2124764699598363],
              [12.47656863876141, -1.2028982095958158],
              [12.580367575411735, -1.1828536392124342],
              [12.643859867335681, -1.1765210048399388],
              [12.90496477016735, -1.1482202999794364],
              [13.041014022433837, -1.1267682724654227],
              [13.225295999291863, -1.0952678527320863],
              [13.520983227356759, -1.0462111214999783],
              [13.725387310195314, -1.0096939320932996],
              [13.942912150619852, -0.9696244466881092],
              [14.080407249396533, -0.9450165693203866],
              [14.184442831402725, -0.9255983229853194],
              [14.304617385396561, -0.9043048807543077],
              [14.3350337468166, -0.8973532811875587],
              [14.510884610918753, -0.8621841429570982],
              [14.598998504684625, -0.8460941851376311],
              [14.780302038122521, -0.8105059428906765],
              [14.898140271204092, -0.7868110483209715],
              [15.113197651571857, -0.7451692479095163],
              [15.323472582710401, -0.7038278213103734],
              [15.350625644734434, -0.6955675079522897],
              [15.364508549983675, -0.6961122226458403],
              [15.409359452626994, -0.6865219955595218],
              [15.54914734451746, -0.6590446893845103],
              [15.547598331292933, -0.6508322070743178],
              [15.63273979415984, -0.6349852309404855],
              [15.813200914631038, -0.5976704659491351],
              [16.111334390076202, -0.5355375459966785],
              [16.36438119318854, -0.48163348794928973],
              [16.382644641845218, -0.5289045294962216],
              [16.443454295410582, -0.6637242040300915],
              [16.475181784276824, -0.7262990369973211],
              [16.506822650923173, -0.7823623145402336],
              [16.522154756152357, -0.8045896987221695],
              [16.54949173006542, -0.8507432013279761],
              [16.573903002953024, -0.8873895758227356],
              [16.59851464904283, -0.9194120616153306],
              [16.64064445032076, -0.9691968586111094],
              [16.743956755449638, -1.1089671069439695],
              [16.77560521358012, -1.1622131039383785],
              [16.768129852034942, -1.1731669220541028],
              [16.747748323246427, -1.1496680729700564],
              [16.750949361874174, -1.1435569649419406],
              [16.732935731222756, -1.1303481827276454],
              [16.716156668876895, -1.1035559052422408],
              [16.69605135827882, -1.0894409187429845],
              [16.70166124242333, -1.0748584237426364],
              [16.694615428750847, -1.0545264659473619],
              [16.663621787350493, -1.0220456426736748],
              [16.644472105480173, -1.0190163536572765],
              [16.627304933601973, -0.9974819090121742],
              [16.616203826268478, -1.001578881987972],
              [16.602912277610653, -0.9951283601715453],
              [16.590210350603737, -0.9976819484385101],
              [16.586432980721703, -0.9793435717341561],
              [16.598775053633315, -0.9728987238693092],
              [16.599134724122525, -0.9588281822230239],
              [16.5902969948087, -0.951318231664631],
              [16.574780029656953, -0.962464297121402],
              [16.565355497169683, -0.9288961069177721],
              [16.54574519580176, -0.88450474764409],
              [16.545855680692515, -0.8620832733700002],
              [16.50946623313783, -0.7940799477891743],
              [16.499283189338463, -0.796873251951535],
              [16.472672594153554, -0.7694588481244313],
              [16.47419114345923, -0.7499354957519021],
              [16.461836543513627, -0.7277715643114369],
              [16.44538160327635, -0.7293395903142693],
              [16.433789248078675, -0.7194615521572816],
              [16.424792923272218, -0.7022310607228951],
              [16.427547327760582, -0.6929395215534385],
              [16.44748641247897, -0.6990246056098907],
              [16.43376356833752, -0.6574055519443027],
              [16.416417339873803, -0.6480010835049612],
              [16.41022923401888, -0.6269096480777129],
              [16.411024551882324, -0.606297133616249],
              [16.390394206804746, -0.5923727579783458],
              [16.37136820402182, -0.5925004885998648],
              [16.353752678099674, -0.5544261402069148],
              [16.332249299505893, -0.5583258957622819],
              [16.324263070108053, -0.5519994187538597],
              [16.28154523700913, -0.5564551742240108],
              [16.28443684330055, -0.5391255618134386],
              [16.277342744729616, -0.5258534282727758],
              [16.26216031859166, -0.5172682574223834],
              [16.239968792105373, -0.5202305660859607],
              [16.248004605915547, -0.5415820995766029],
              [16.236666776488157, -0.550110823037879],
              [16.25083565244268, -0.5760618635284449],
              [16.273495061259087, -0.6073887050424391],
              [16.29325115119421, -0.6141665210683624],
              [16.307127315683292, -0.6108231724512372],
              [16.32703142658427, -0.6440770369062403],
              [16.33868884662758, -0.6141041314860963],
              [16.34658660309021, -0.6144748783195072],
              [16.35317620670645, -0.6394626106203384],
              [16.360617803715016, -0.6490853519620569],
              [16.359570164593876, -0.6712103149648441],
              [16.391795924188646, -0.7140352733941904],
              [16.408482315801276, -0.7464560955144854],
              [16.4229667541191, -0.7430823652209345],
              [16.4354893638798, -0.7978760890399204],
              [16.462035599467523, -0.818461159491404],
              [16.458280029083976, -0.8239993338123159],
              [16.464997330823675, -0.8453235664503164],
              [16.483377543101618, -0.8643278163539702],
              [16.490528629950123, -0.877560298737725],
              [16.50959117693722, -0.8971721503665324],
              [16.510822251100805, -0.9164720957930657],
              [16.525338127170265, -0.9336730921295372],
              [16.520261779212852, -0.9418108471126861],
              [16.47329297774777, -0.9182665496232144],
              [16.454849424067586, -0.8988340947596168],
              [16.451056153275747, -0.8664839288448722],
              [16.436346883395917, -0.8443227530992836],
              [16.406469020468748, -0.825322684756592],
              [16.392359693557168, -0.7982501260530814],
              [16.364290160739834, -0.7828555200177199],
              [16.355267705430364, -0.7926822013757089],
              [16.366124846410365, -0.8064073410663913],
              [16.37124829866831, -0.8260145802138978],
              [16.366834357070488, -0.8440197404976821],
              [16.389730177281546, -0.8611180478486878],
              [16.393594284159075, -0.8723198918633137],
              [16.338918799650976, -0.869335838580799],
              [16.32487973380689, -0.8658941335323902],
              [16.31441431185484, -0.8519887047255349],
              [16.299881208039096, -0.8457850031513934],
              [16.285774339886675, -0.8242240858457508],
              [16.265032155415973, -0.8251148116406017],
              [16.243442329717336, -0.808076568820985],
              [16.237460762467528, -0.7956857162858372],
              [16.210355283734557, -0.7845128795195684],
              [16.187442869347173, -0.7858079276793427],
              [16.17873282679065, -0.7772389660966239],
              [16.154900140865657, -0.7921254957146698],
              [16.186001145866467, -0.8157237689248023],
              [16.21013763123512, -0.8154632636050324],
              [16.22988538405273, -0.8381160151175244],
              [16.240821944679286, -0.855773977324062],
              [16.2727693852488, -0.8635052243747888],
              [16.29960584839213, -0.9095466365133204],
              [16.29181386780061, -0.9205968438986821],
              [16.220941688793225, -0.95263064268187],
              [16.204204942200725, -0.9543898696169743],
              [16.18654830446359, -0.9456627659193232],
              [16.1654949601609, -0.9284826968235226],
              [16.143616164977693, -0.9058191548125846],
              [16.120435189777105, -0.9045700273023513],
              [16.122549497857314, -0.9146108492428102],
              [16.151508684115797, -0.9312671378149131],
              [16.16372152004563, -0.9504666635447749],
              [16.181162578835462, -0.9667840557515072],
              [16.197603500272365, -0.9728178308160053],
              [16.18986389474852, -0.9877238867139702],
              [16.153075548642015, -0.9847894883470044],
              [16.108948768863492, -0.9750503260205793],
              [16.095981632358946, -0.9674962422539067],
              [16.066617358492444, -0.9683135834264849],
              [16.055884139149832, -0.9724422848073135],
              [16.0377777698778, -0.9512001772536013],
              [15.994318550038017, -0.9300194488991794],
              [15.980036133692973, -0.9397233421205794],
              [16.037860848444218, -0.9752108332371545],
              [16.061547937009944, -0.9923367165940605],
              [16.08070889062181, -0.9849588666633801],
              [16.088472295792897, -0.9956019710894861],
              [16.108804551267315, -0.999847554255463],
              [16.10617497261396, -1.0168845026823745],
              [16.086918833358066, -1.0169188045803523],
              [16.04414321772733, -1.0361620160362432],
              [16.012747339693107, -1.089084177777409],
              [16.01144608926855, -1.0993306782091319],
              [15.988369934823657, -1.1112028160671292],
              [15.972865987125644, -1.1255255187655375],
              [15.919998090867717, -1.132336109934174],
              [15.8970183327531, -1.1115397801580529],
              [15.890368852234811, -1.0935084314609307],
              [15.882833027164365, -1.094671400219951],
              [15.87130241785787, -1.1150738160600948],
              [15.858592320627256, -1.1195497928938902],
              [15.837865829169756, -1.115245030670085],
              [15.821154251279681, -1.0953227650677309],
              [15.815471344516816, -1.0545382703709416],
              [15.802027664919857, -1.0543390060810223],
              [15.79251632077232, -1.03077832011191],
              [15.781394463332825, -1.019485387095132],
              [15.772578101936126, -0.9665463522342657],
              [15.774483759188284, -0.9431634456712102],
              [15.794698762220905, -0.8888296101127605],
              [15.774747894523303, -0.8932649477585675],
              [15.761216779159426, -0.9229774556579647],
              [15.761661283636808, -0.9377359299142101],
              [15.749274454282787, -0.9422217183619337],
              [15.74619686004793, -0.9612274280317802],
              [15.755815637288718, -1.0250714130895267],
              [15.780316606840582, -1.0649361745677066],
              [15.788281224609124, -1.0712341430120929],
              [15.788859364510156, -1.093258279815993],
              [15.80435727226154, -1.1175862858100922],
              [15.815223234102392, -1.1209614931177676],
              [15.823174759061494, -1.1523298123973298],
              [15.838029764663597, -1.1536288563544366],
              [15.844610231891508, -1.1695083030430893],
              [15.833636195505763, -1.1880162732896897],
              [15.820353373235076, -1.1997499094987214],
              [15.81957369162846, -1.2323684091358034],
              [15.834278548930074, -1.217707810137675],
              [15.87164309355351, -1.2231984317690376],
              [15.916087795738692, -1.2060264821155393],
              [15.955324888638078, -1.1975590986760027],
              [15.989713501772622, -1.1804442851067565],
              [16.00131818735542, -1.1677747869664952],
              [16.06780241254313, -1.1309021413158589],
              [16.082114395522247, -1.1388135246670674],
              [16.09267576696514, -1.1532033272884765],
              [16.08761067901562, -1.15947933442332],
              [16.100245877647122, -1.1732982553264732],
              [16.11615445933566, -1.1618296516082625],
              [16.135013387718853, -1.1616426109602505],
              [16.16260330542964, -1.1260256417338015],
              [16.219002602782645, -1.0934775721344645],
              [16.23830793660225, -1.088886320336784],
              [16.244897476565654, -1.0808215168515587],
              [16.26225242183207, -1.0768734118342738],
              [16.275681315075428, -1.07958110184825],
              [16.299614724997973, -1.072119959453076],
              [16.33038233905541, -1.0665685669009357],
              [16.36424114372249, -1.0809845628450467],
              [16.375427143631313, -1.095719537280646],
              [16.375643842953266, -1.117064889764091],
              [16.383841774132982, -1.1262368213594511],
              [16.373881674937476, -1.1398808336298083],
              [16.368102569553127, -1.1575981052735458],
              [16.368662344203656, -1.1827056954485722],
              [16.358704546290642, -1.2022003525016371],
              [16.36467125910071, -1.231258081560808],
              [16.37852378626544, -1.2461998129981409],
              [16.384062674529222, -1.2929551447514849],
              [16.394871104798913, -1.3145209610330488],
              [16.389259483005755, -1.3366225244089982],
              [16.39689695374819, -1.3495273650104471],
              [16.414493857487628, -1.3605118833515983],
              [16.413170690320054, -1.3974383943870998],
              [16.426158382772787, -1.4014441598048701],
              [16.4356578233574, -1.3918486880696297],
              [16.442126041647736, -1.3488426358814465],
              [16.434414260200892, -1.3182383158757949],
              [16.43928951046307, -1.299880497238687],
              [16.438843211815076, -1.2685372445394543],
              [16.434963224444868, -1.2540480199019646],
              [16.42159437207364, -1.2309852273625],
              [16.430349269019516, -1.2023377935931556],
              [16.415910822042395, -1.1813725480016666],
              [16.420094893908427, -1.1717340760309587],
              [16.411803273816084, -1.154189152483225],
              [16.42762446612282, -1.1380114750053492],
              [16.435188872205284, -1.116834040701158],
              [16.452483811499576, -1.0970566741005836],
              [16.427256350699288, -1.077783789615595],
              [16.45328821099942, -1.0580110990293135],
              [16.4831533413906, -1.0464708662197644],
              [16.512036209508032, -1.0485694572243291],
              [16.535530733641103, -1.0550602416570116],
              [16.541286097197794, -1.0674326225717812],
              [16.562097719409913, -1.0760512063588836],
              [16.565208031360655, -1.0896853216524562],
              [16.588287544343128, -1.1163350422282685],
              [16.598493792183884, -1.1190615546698273],
              [16.603697554827857, -1.152136139253516],
              [16.620052368779064, -1.1627185937172348],
              [16.63030759782753, -1.1929270263400547],
              [16.62689498549511, -1.2006307788218897],
              [16.635176004503684, -1.2352634365645474],
              [16.635836078526935, -1.250053146353508],
              [16.64773554409845, -1.2580308183063342],
              [16.653385139641777, -1.282301843451358],
              [16.664568798694706, -1.3013953391668605],
              [16.647910200345198, -1.3040064123981332],
              [16.622567312849615, -1.2981312459179406],
              [16.61684977275394, -1.3215688769219633],
              [16.629341698586494, -1.3261382077566333],
              [16.629169942556867, -1.3381444318613456],
              [16.645090118062154, -1.3523622447221122],
              [16.65335372845399, -1.3496562797455152],
              [16.664169367082778, -1.3670024502563627],
              [16.655317027290383, -1.3918155876329383],
              [16.63202980667155, -1.4096855297043371],
              [16.64100811669056, -1.4240373729354652],
              [16.613445290547908, -1.4263329530757796],
              [16.59683054944517, -1.4199630317017407],
              [16.580997917201717, -1.4318992547665164],
              [16.560494428614497, -1.409534758713168],
              [16.55880038015353, -1.389988577114312],
              [16.54762774450268, -1.3878208442070552],
              [16.546057785689786, -1.422745024043342],
              [16.559519113334154, -1.4453495586356317],
              [16.533207436221627, -1.4660677350570313],
              [16.54220205240581, -1.4814934401683078],
              [16.51963727533779, -1.4951077856779316],
              [16.51088935784687, -1.507355082054285],
              [16.513284833112962, -1.54006932927509],
              [16.494833180648197, -1.553294219737401],
              [16.493318177822456, -1.5755766302097138],
              [16.48272602810547, -1.600399333532864],
              [16.487434090779843, -1.61381334654048],
              [16.47609453212421, -1.6313022792665262],
              [16.46606448799181, -1.6152183714105561],
              [16.445571718832547, -1.641196147105561],
              [16.449589521680707, -1.6529170778602142],
              [16.43987730347671, -1.6618531991874121],
              [16.45410632208232, -1.6798050765206112],
              [16.43819075053412, -1.6843878867477702],
              [16.424442792019512, -1.7022177783115862],
              [16.40943065525791, -1.702482333892456],
              [16.40693315348603, -1.7165146235586122],
              [16.3935340780134, -1.7266330175581261],
              [16.37729992453492, -1.7204774053653307],
              [16.367864583191952, -1.7278687742684167],
              [16.341636017190947, -1.7348081092975205],
              [16.329525455724653, -1.7183829414918905],
              [16.318698681299225, -1.7126759909845948],
              [16.305593721269062, -1.7166361574193667],
              [16.314301743294422, -1.7306595430775027],
              [16.30448265983739, -1.7430400884639263],
              [16.271669958698276, -1.734559305594544],
              [16.266168317341315, -1.7205360976182862],
              [16.254136893312637, -1.7202674533318576],
              [16.24898790432462, -1.7069711062751844],
              [16.232853427958343, -1.7039678465498511],
              [16.22473648491595, -1.7148530239300346],
              [16.240992550790533, -1.739002380392601],
              [16.24588537872551, -1.7529561243971314],
              [16.215950846676606, -1.7600277892377336],
              [16.214343990279165, -1.7429881053006486],
              [16.18936772170348, -1.7605941220692563],
              [16.182572791988463, -1.7318617867042074],
              [16.220928784526578, -1.7388131132410105],
              [16.22358663634042, -1.7252766579707404],
              [16.19067797690728, -1.7040170445660867],
              [16.196252981421726, -1.6884802622365978],
              [16.18473053705788, -1.6737290372291531],
              [16.168615204338348, -1.6838820485086152],
              [16.157926548610302, -1.713453400630782],
              [16.12285212102526, -1.7145777459673859],
              [16.138062418678143, -1.7431584850095259],
              [16.115332343035305, -1.7396936237877891],
              [16.10101296896745, -1.7265057246944644],
              [16.08292010803086, -1.7262737387694098],
              [16.074571076413108, -1.7183224869293225],
              [16.075837071949234, -1.6957578897969265],
              [16.05957771880256, -1.6944366967975917],
              [16.046717006129015, -1.6841149473578725],
              [16.059970514831733, -1.669600949671053],
              [16.043547730733604, -1.6584526156993038],
              [16.040780069000693, -1.642282039519425],
              [16.017456533305648, -1.628978777705279],
              [16.05751846312302, -1.6200740117385506],
              [16.074857520888596, -1.6224518882873442],
              [16.094412118323852, -1.617587634277348],
              [16.10824159864685, -1.5993598408212184],
              [16.106151904381633, -1.579618715298142],
              [16.113290172069885, -1.5675517441934512],
              [16.09495108720036, -1.5656646122002222],
              [16.092426051072234, -1.5817306874954427],
              [16.07318151978021, -1.5881895629372171],
              [16.052844590302676, -1.6008032037547264],
              [16.015053711603485, -1.5966014715762726],
              [16.00154931071943, -1.6003931893463121],
              [15.976440797651358, -1.6332754803551264],
              [16.00006323702512, -1.6546979278979583],
              [16.014834223224153, -1.6572956026484247],
              [16.01260378531654, -1.6849970923708373],
              [16.027720344050117, -1.7012118891916423],
              [16.03364201937782, -1.7203306113655612],
              [16.04235341585116, -1.7283020387732237],
              [16.049818990829984, -1.7472256647397195],
              [15.990909135865817, -1.7431267638695818],
              [15.972389232320321, -1.729394196668838],
              [15.96238177897823, -1.7360838809561054],
              [15.936136839429563, -1.7284848508916104],
              [15.910354882343475, -1.7355777809316013],
              [15.899679556662306, -1.7459190927317827],
              [15.890233713923935, -1.7397064340615327],
              [15.856046075824002, -1.7325550484127574],
              [15.847154169533422, -1.722614748417251],
              [15.837101193909351, -1.7288368152452436],
              [15.795579155107283, -1.7251745305996689],
              [15.775351201867274, -1.7296930961566934],
              [15.729805100555653, -1.7146487652423623],
              [15.712657378343845, -1.7177344212413046],
              [15.685215733999161, -1.6983983302388093],
              [15.68247191157782, -1.69258331395733],
              [15.651558617582433, -1.675149474095327],
              [15.658150122792726, -1.7038724266969452],
              [15.66691797319946, -1.7172314793915215],
              [15.694015502783104, -1.7292731035433724],
              [15.709153522555198, -1.729592915747438],
              [15.721187336912596, -1.7412082563624645],
              [15.732868192129729, -1.7644288570315978],
              [15.76246146081478, -1.7431748154876934],
              [15.778601793986896, -1.7533417725059934],
              [15.805654267384885, -1.7591919869416892],
              [15.831242812555052, -1.7549680373537124],
              [15.851245716533615, -1.7668064924964078],
              [15.854116349219792, -1.7748171004407138],
              [15.872891579026776, -1.7803486520951377],
              [15.894489299997801, -1.7757256032828495],
              [15.89911022362329, -1.7829555359950862],
              [15.925411009890976, -1.785936510421079],
              [15.940048509509014, -1.7827299969614223],
              [15.962604994703815, -1.7909510143383707],
              [15.975323769551201, -1.801610583862178],
              [16.00120212449139, -1.8062558061644223],
              [16.028314648756382, -1.7978619232403625],
              [16.038577039325826, -1.8095149670639876],
              [16.063560275094034, -1.803145956761211],
              [16.138919961914194, -1.8048706105320602],
              [16.128869642259982, -1.8149438390708759],
              [16.149411598523887, -1.8382497080238602],
              [16.147136653332428, -1.8522653360807135],
              [16.152600793201614, -1.867766484283298],
              [16.138667534677648, -1.880059510973121],
              [16.140868633788127, -1.8981945873110169],
              [16.120270406407464, -1.8936786792908065],
              [16.098419273494567, -1.8954144469944731],
              [16.09717555020077, -1.9064672246566814],
              [16.11475534642118, -1.907818527348682],
              [16.134501867832117, -1.920514321802586],
              [16.13167960936658, -1.9391005720332528],
              [16.09029020319936, -1.9310871263525142],
              [16.0698890755063, -1.938909705374988],
              [16.064410467266757, -1.9580401259327047],
              [16.048586376919488, -1.9671095191790502],
              [16.051740291075067, -1.980458958018777],
              [16.067110316365547, -1.974882678353609],
              [16.09036359361653, -1.9788740162989988],
              [16.091629028619096, -1.9584079711228997],
              [16.10547956156328, -1.963539950387528],
              [16.127512370494863, -1.9805780184286421],
              [16.11984847751282, -2.003379353184623],
              [16.115410505111747, -2.0313208878297324],
              [16.10063611197189, -2.0369830045538593],
              [16.098333832227908, -2.060082853460443],
              [16.075040665398607, -2.0779133178689757],
              [16.04585073921458, -2.116183850568109],
              [16.025912948309177, -2.1316505298589528],
              [16.021606854428047, -2.147407158598214],
              [15.987561768945111, -2.166820202266078],
              [15.979849127344393, -2.1845200903337467],
              [15.957758751441487, -2.197367964630861],
              [15.94177169106095, -2.198233894492889],
              [15.898698789226122, -2.175496808641442],
              [15.892233502148649, -2.1756968944323773],
              [15.866731941984542, -2.157865898668968],
              [15.84701574224534, -2.1576360065447258],
              [15.840107586767472, -2.1460665341040315],
              [15.827192845790284, -2.14548845584145],
              [15.819059985284321, -2.134532474536508],
              [15.803524966465009, -2.138484390064732],
              [15.77943252369062, -2.122559271415025],
              [15.742260759208943, -2.0720885986881203],
              [15.720688219082353, -2.061655162068361],
              [15.72566999010159, -2.0814369370016523],
              [15.743244423054598, -2.094387077276655],
              [15.743167984749808, -2.106694601158068],
              [15.767725798991592, -2.1337307558266945],
              [15.792805111558899, -2.1536695957513103],
              [15.807146123491068, -2.1863851728085786],
              [15.817094822565688, -2.1965809159908343],
              [15.849569017738158, -2.2148215722778466],
              [15.884458139203838, -2.2235501420198385],
              [15.891680197639921, -2.231897189768198],
              [15.908454637366352, -2.2290793830270865],
              [15.927012567179261, -2.2369156597101463],
              [15.955572284379707, -2.2280745900709635],
              [16.00043717083983, -2.2429406041001902],
              [16.02524285339437, -2.225418263510966],
              [16.03503617442439, -2.196344161110132],
              [16.0588675334251, -2.1866274052398915],
              [16.05649242940414, -2.1769287069488046],
              [16.069197730703458, -2.160248302919457],
              [16.088915266180013, -2.149765904375412],
              [16.133249676353202, -2.1534252363534807],
              [16.12947494024418, -2.1399755489305683],
              [16.139721760395496, -2.129344794057354],
              [16.18059185292695, -2.113928931490366],
              [16.1955439333683, -2.1314760506344346],
              [16.205866710703805, -2.1261216172221182],
              [16.19116024825855, -2.1085352312290397],
              [16.193766712778256, -2.0746161009004958],
              [16.209305397584465, -2.06508350972602],
              [16.202181124637377, -2.0545468855483144],
              [16.20415132488719, -2.0355823844958425],
              [16.22163103507499, -2.050493128787328],
              [16.22996552814873, -2.0492178125563116],
              [16.240313222128396, -2.077652169660457],
              [16.235187185880225, -2.092750692515408],
              [16.249797783127498, -2.103230877408076],
              [16.257257839351688, -2.126635435924341],
              [16.252975875370094, -2.136351918480141],
              [16.262343402345632, -2.1528472907305254],
              [16.27542322069391, -2.137078067330032],
              [16.290435990052497, -2.1465746306425793],
              [16.29216179375067, -2.1265581229938286],
              [16.318488155633073, -2.119299642489816],
              [16.338597663754044, -2.1268551646912988],
              [16.33851270154359, -2.111428635721248],
              [16.31830889191473, -2.0932069462419913],
              [16.29127987073166, -2.0583786773280854],
              [16.35285399115004, -2.0732281807037376],
              [16.389978098076217, -2.0746487425991442],
              [16.392853422932728, -2.0939823902585677],
              [16.38485012381892, -2.1018862515706274],
              [16.36007484200173, -2.0854382834866545],
              [16.34710505947066, -2.093178081522508],
              [16.364993716725383, -2.113487200123661],
              [16.375603016109654, -2.118878160891284],
              [16.378286826225644, -2.1381773869993466],
              [16.35428298713697, -2.1582726920754216],
              [16.33116374813143, -2.1563009825967403],
              [16.339263648048327, -2.178884111964233],
              [16.35806501793589, -2.178529084109211],
              [16.348751646585676, -2.2025651253311875],
              [16.33886701668745, -2.216504752818065],
              [16.321855128673576, -2.220554789244407],
              [16.31405445369008, -2.238567567457082],
              [16.29899063530176, -2.2326831135049],
              [16.302010970782398, -2.2188018403070187],
              [16.291843769801154, -2.2126975308723282],
              [16.29097948375235, -2.2387737751731542],
              [16.295313781730677, -2.2679883410279094],
              [16.280658084474695, -2.274462774670868],
              [16.269048875898157, -2.298374105315117],
              [16.259707057243975, -2.3400726864123493],
              [16.25219739902405, -2.35030219501457],
              [16.230051114227958, -2.3617390429546243],
              [16.247139383663104, -2.381098641039163],
              [16.238166695936577, -2.3950246339464383],
              [16.20479672767104, -2.3963224505813723],
              [16.187614389324906, -2.404103168907866],
              [16.184316640047822, -2.3862966840416298],
              [16.150732033862838, -2.341617824757142],
              [16.140894178315197, -2.3456597201125575],
              [16.147612279787996, -2.380025927116399],
              [16.143847366885407, -2.3876347671000704],
              [16.147113143568653, -2.4148913697868633],
              [16.156312969482446, -2.428589257374614],
              [16.09713726486735, -2.428629537982606],
              [16.078375137209793, -2.4327572189478066],
              [16.061021086266862, -2.4307637358757925],
              [15.97348422601045, -2.440263883511423],
              [15.934287811717963, -2.452270443724661],
              [15.877677171352131, -2.482967074778899],
              [15.850448615907201, -2.5031838793685752],
              [15.82296564129521, -2.5117647648531483],
              [15.808304355230009, -2.525101610153654],
              [15.78439631457382, -2.5365837066246937],
              [15.762148409280577, -2.526666958660241],
              [15.749169404696062, -2.536424412883899],
              [15.748878164494062, -2.546470693055758],
              [15.720824265153865, -2.5788241576477153],
              [15.702633561244163, -2.5935919897438526],
              [15.699107399723518, -2.604539837309632],
              [15.68039780546112, -2.6289134598757817],
              [15.687492641004656, -2.6381445513967257],
              [15.638168040408411, -2.697144754512061],
              [15.611748788175444, -2.72270576608969],
              [15.56423713564096, -2.7618355748873427],
              [15.50720337398346, -2.814274862308469],
              [15.44526700578352, -2.883515213876557],
              [15.402289931653021, -2.945510182756747],
              [15.375336591763062, -2.979596619326448],
              [15.360723843546085, -3.0085376267479633],
              [15.3434476882209, -3.0347955588960183],
              [15.322652920610036, -3.0790456740464567],
              [15.292554187641107, -3.156693820443135],
              [15.287746247608434, -3.1733646320603603],
              [15.272503512263814, -3.25127312753926],
              [15.259586994987128, -3.359287994575682],
              [15.243484701794237, -3.4402960447148354],
              [15.247693169341394, -3.493242275419796],
              [15.216713256615765, -3.4869477532140754],
              [15.203827445038103, -3.475974791778538],
              [15.213505669668988, -3.460035504955522],
              [15.21332810640483, -3.4391072640390092],
              [15.200731315915988, -3.436376717867156],
              [15.190741460385329, -3.4435326616962203],
              [15.193821966452703, -3.457049014388663],
              [15.146745031608006, -3.4526657667078116],
              [15.10558385464601, -3.4516133310041734],
              [15.058409864450265, -3.456506191169595],
              [15.016509633003949, -3.4658764592753952],
              [15.00156399326096, -3.4667301498310295],
              [14.947881817774746, -3.482085511721351],
              [14.909333273518225, -3.4963825957008368],
              [14.896521380380461, -3.4981762592226873],
              [14.79953013690012, -3.55364908531003],
              [14.77602893412056, -3.5724128118874607],
              [14.769818767471937, -3.569706734684254],
              [14.658519756935371, -3.4900128609966816],
              [14.556345589025263, -3.4167507662766274],
              [14.454185781983266, -3.3434657031410446],
              [14.360084626978729, -3.276208119986698],
              [14.26599518773344, -3.2089321311092625],
              [14.180643667478957, -3.1472410394146055],
              [14.095301512155926, -3.0855353795506555],
              [13.991080837060224, -3.006282659325382],
              [13.89484801983752, -2.9376912124345522],
              [13.793059568750024, -2.8656368239403824],
              [13.69128321028691, -2.7935645327073],
              [13.612089886765613, -2.806031098365774],
              [13.534383969035733, -2.8199352303661507],
              [13.241483747276227, -2.861772108990545],
              [13.10787374079587, -2.881750258128065],
              [13.027261914544168, -2.892864051928598],
              [12.787596609355505, -2.9292878767067188],
              [12.781405212577173, -2.811944636665745],
              [12.742648833062212, -2.773381915584867],
              [12.680062901627961, -2.7081130758938903],
              [12.631360046299788, -2.6609069327987585],
              [12.615351088264704, -2.6785312247532773],
              [12.555938745674784, -2.7368787596156823],
              [12.540184110817714, -2.7212893033864485],
              [12.536772211202527, -2.697657984438779],
              [12.550095766997819, -2.678804471550897],
              [12.551819115368447, -2.667099165399],
              [12.535136601965648, -2.652093643482451],
              [12.537601663920334, -2.6324936756973405],
              [12.484356553430127, -2.636591134021101],
              [12.377416636900804, -2.6473046190503027],
              [12.103107358746263, -2.676442936999336],
              [11.994418930824974, -2.6870792466532754],
              [11.825673124147245, -2.7056351535865955],
              [11.623069209125852, -2.727112848066536],
              [11.543558444622592, -2.732308454686766],
              [11.512088560373872, -2.746435964468839],
              [11.50694373610967, -2.7531762507116326],
              [11.48873812523523, -2.747332815534058],
              [11.475504857010653, -2.7515690774302755],
              [11.468975793815854, -2.7620618751346466],
              [11.448738750048989, -2.7304215776458594],
              [11.427657083687519, -2.750537865749344],
              [11.416436834864978, -2.785484759581415],
              [11.39823504471171, -2.775595372294935],
              [11.377172608148134, -2.7843593239235047],
              [11.372168743874614, -2.7931982992657214],
              [11.355450529375112, -2.7966741938723088],
              [11.341400052582012, -2.8075066869151213],
              [11.335107060343615, -2.800966831222401],
              [11.314810802463846, -2.820954943811825],
              [11.283754148622464, -2.8316992025185397],
              [11.244421387784788, -2.8585408016377554],
              [11.223600274792798, -2.854361005493256],
              [11.226469358269494, -2.8712032244666905],
              [11.205467715341063, -2.889641940756223],
              [11.195890170309633, -2.8897674150302937],
              [11.188817859110195, -2.905701974515373],
              [11.177962344884294, -2.9067772802827947],
              [11.174892095841976, -2.919284302885039],
              [11.159625212252534, -2.925363334304369],
              [11.151878015212663, -2.9046218176247596],
              [10.901176457974957, -3.0250479223237448],
              [10.730286438342016, -3.0535504244362492],
              [10.548272045231066, -3.0811535961859713],
              [10.491301635364279, -3.089034529460623],
              [10.49218307561353, -3.094504465177479],
              [10.38739499698396, -3.107022536015105],
              [10.322025502779361, -3.1158622976892403],
              [10.081485796757043, -3.146181431056437],
              [9.926347655403003, -3.164552685089192],
              [9.923600023596203, -3.0296264094813514],
              [9.922448870585814, -2.924338422515646],
              [9.944468630518408, -2.9050595843977014],
              [9.970484521104115, -2.874213182018785],
              [9.980416244950767, -2.876023074220672],
              [9.993415419971049, -2.897145144051768],
              [10.066671408032057, -2.880026699063986],
              [10.07414652776925, -2.8834545872808905],
              [10.086003653012746, -2.867810368116665],
              [10.105515821727595, -2.8582058942706965],
              [10.128848831078841, -2.8215391611379497],
              [10.115455041068282, -2.80657674598984],
              [10.118423011923053, -2.7905461826435567],
              [10.109391886375612, -2.7768427719516495],
              [10.120508108954708, -2.7689325393491444],
              [10.131021629049197, -2.749882743982869],
              [10.128146897502939, -2.7312295458581124],
              [10.119107050229045, -2.723537019511672],
              [10.12019551003773, -2.710295293918181],
              [10.134622254537408, -2.6819710902221265],
              [10.148870402740974, -2.6691331100971967],
              [10.156545202394607, -2.6526923580336117],
              [10.166265835468444, -2.65448178107704],
              [10.174853801108107, -2.642875005048706],
              [10.194486829447698, -2.6357802308650466],
              [10.200177964009123, -2.6141976337851576],
              [10.21259336596155, -2.5916469658082257],
              [10.257322817736023, -2.5791505586526773],
              [10.273554885433354, -2.5590115727784988],
              [10.290256362665932, -2.5479136011065773],
              [10.295449591745244, -2.5353193777034857],
              [10.33408106200131, -2.530564389580811],
              [10.346214585375279, -2.522220026833839],
              [10.408223934217306, -2.5147915849664053],
              [10.429152628726388, -2.5015405255297596],
              [10.447063446714942, -2.514994401584211],
              [10.459345580030538, -2.51001672749552],
              [10.513898706137965, -2.505888508146875],
              [10.52344368935588, -2.4993153931883105],
              [10.531833231621137, -2.475732049608605],
              [10.543300706992685, -2.4663401683011172],
              [10.549396876853395, -2.451540200069798],
              [10.560430018289708, -2.4519684489257347],
              [10.59007189007367, -2.4326112811358898],
              [10.59207670946411, -2.4237100874251305],
              [10.608778475914077, -2.416248937997763],
              [10.618228233321984, -2.39349353525117],
              [10.630719716627894, -2.3861121566972137],
              [10.649873364636736, -2.3943900969455676],
              [10.661930369104292, -2.389779709014919],
              [10.666051015051885, -2.3721775885545324],
              [10.67930359923362, -2.3633072924228724],
              [10.689915033231596, -2.3470399553519403],
              [10.687400688819992, -2.326859312217285],
              [10.697685477654282, -2.314758841173872],
              [10.731661056149209, -2.311454251935128],
              [10.741095265098654, -2.305703227297529],
              [10.757443646811302, -2.2678682725368615],
              [10.788353277333337, -2.2622978077278892],
              [10.80532613122044, -2.2499762721420944],
              [10.818197983264652, -2.234575270436674],
              [10.85234618575462, -2.2320035287009157],
              [10.889362801987259, -2.2406153285480315],
              [10.909423604011685, -2.2215324320923133],
              [10.919420358942977, -2.1848470982586794],
              [10.940158232292065, -2.164970930458322],
              [10.933177231529415, -2.1383436926772355],
              [10.950852511963564, -2.123852692982267],
              [10.931253901742757, -2.0819588977081795],
              [10.941774061101157, -2.074119159376998],
              [10.944765397364325, -2.058633426958412],
              [10.958420207806846, -2.04908481903969],
              [10.976086354807444, -2.0503040205091256],
              [10.99984717210075, -2.066717778101095],
              [11.014746349693185, -2.056271167803686],
              [11.027365034281212, -2.0400211930121843],
              [11.029050997111177, -2.0267300723328203],
              [11.024108608838755, -2.004052793078925],
              [11.029761270048972, -1.9908608613915144],
              [11.049522341957848, -1.9820821017706558],
              [11.07404557043432, -1.9556183415902435],
              [11.093504501821922, -1.9426928633842289],
              [11.0966520417684, -1.9346091102600858],
              [11.134570825896889, -1.9092853281561775],
              [11.162969404408255, -1.9355198599957124],
              [11.164628410209785, -1.947203640617581],
              [11.157477259558968, -1.9726690995350755],
              [11.167908135250025, -1.984421196451557],
              [11.165450910503312, -2.005052645439444],
              [11.192243339012434, -2.0045239300435123],
              [11.209464331063787, -2.0125636628926156],
              [11.21449257583853, -2.001278884761452],
              [11.247747380925714, -1.9828782286445137],
              [11.278930633780408, -1.947715713851317],
              [11.308676889685268, -1.8663998864002682],
              [11.34706047261941, -1.82804567881326],
              [11.361737414931191, -1.8266371527943792],
              [11.396185576042187, -1.8004401326302746],
              [11.404393866220197, -1.80628206027629],
              [11.430094509882062, -1.8004484720603358],
              [11.445253273064235, -1.778719030376195],
              [11.460039253327203, -1.7693662278064441],
              [11.48439197772052, -1.780948798200564],
              [11.506200024212335, -1.7703071357051052],
              [11.518260714059968, -1.7896432084901086],
              [11.526220205857825, -1.8113147683318938],
              [11.566516114086141, -1.8052793402912206],
              [11.5801138179017, -1.79654162739688],
              [11.583793003579778, -1.782027089362687],
              [11.601363728487554, -1.7859553683724803],
              [11.643183550195069, -1.6698934109801895],
              [11.673240557112843, -1.5900433486282013],
              [11.68866639952998, -1.5804130245999064],
              [11.70845018907234, -1.5513376848515368],
              [11.725612718809803, -1.5359558160561646],
              [11.75778076588656, -1.52237640726518],
              [11.780787817459984, -1.5364971823133224],
              [11.79707126638802, -1.534951378556708],
              [11.81690773427275, -1.5217450856902612],
              [11.798535018168181, -1.4920785853457157],
              [11.788706611795996, -1.4593013466944371],
              [11.802986172318239, -1.4475520213153026],
              [11.805646468728764, -1.432278174768261],
              [11.802349371105814, -1.4122481903125195],
              [11.816154112760168, -1.3992431906666183],
              [11.80899946135735, -1.3625853607977816],
              [11.79586034002067, -1.3326036555684184],
              [11.814966336236663, -1.2944788907165194],
              [11.81193691335464, -1.2771767341724631]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.37491509188717,
          "lat": 35.541724755324005
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01027616"
      },
      "bbox": [
        9.922448870585814, -3.5724128118874607, 16.914653693090763,
        -0.48163348794928973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.058519470490573, 5.537740661654423],
            [-16.96992398248974, 5.517383123241515],
            [-16.862682995359172, 5.489143960516239],
            [-16.762232059795892, 5.4633954447565465],
            [-16.661785975091536, 5.437627228487091],
            [-16.577484330982553, 5.415423957128289],
            [-16.493186262726507, 5.3932067687792005],
            [-16.344587955390303, 5.3571528343548165],
            [-16.23566142428298, 5.3295459173092405],
            [-16.126740580199296, 5.301915929805751],
            [-15.98573106261739, 5.271655180210401],
            [-15.8766015099354, 5.2464298816673205],
            [-15.76747697388009, 5.221181707966136],
            [-15.651011895092019, 5.19450292910858],
            [-15.53455249245739, 5.167798136321453],
            [-15.445645060243509, 5.147061360906781],
            [-15.356741049712493, 5.12630940423575],
            [-15.202499301050853, 5.092296531406042],
            [-15.048267081621049, 5.058238267867252],
            [-14.92486600987085, 5.029971282100715],
            [-14.883997628083016, 5.019903411444217],
            [-14.760819590833663, 4.991991613452758],
            [-14.637647976291905, 4.964050829095016],
            [-14.544713711538462, 4.943021369312953],
            [-14.451783118264759, 4.921975426511769],
            [-14.425815893781039, 4.917378529908844],
            [-14.329582932382738, 4.89678962434099],
            [-14.233353613523978, 4.8761831530517625],
            [-14.143816408854718, 4.856136770638951],
            [-14.029746357345712, 4.832611269962884],
            [-13.915681194920893, 4.809061191114107],
            [-13.875397193979856, 4.800070546617587],
            [-13.782950785804825, 4.780591259019899],
            [-13.69050772247273, 4.76109580987815],
            [-13.588544198873475, 4.7402762743198466],
            [-13.486584581317997, 4.719437143031464],
            [-13.372762727629704, 4.701949054267855],
            [-13.32239080314261, 4.692379548193095],
            [-13.261114564614005, 4.676487713777388],
            [-13.173224431979156, 4.655258112380211],
            [-13.078423007116074, 4.637599808644719],
            [-12.944169869173265, 4.610094700502241],
            [-12.857122781851107, 4.593142707624603],
            [-12.77007841343745, 4.576176516246913],
            [-12.789476815955162, 4.468387208877647],
            [-12.797072552848467, 4.4348463945105],
            [-12.814565005668276, 4.339174471633488],
            [-12.864631214677818, 4.080574848952529],
            [-12.917160092315427, 3.8124069395824307],
            [-12.959567876311946, 3.5951151053274164],
            [-13.003760398778065, 3.369638153838723],
            [-13.077053471975887, 3.0007917184826356],
            [-13.108709471064282, 2.836191454035291],
            [-13.153777663565723, 2.603569801140969],
            [-13.199550955208803, 2.36852441473509],
            [-13.257888977144537, 2.0678562557251015],
            [-13.344581058517775, 1.6218690454812061],
            [-13.397731176564784, 1.3480941476532184],
            [-13.441990142968608, 1.120925316919056],
            [-13.48602076340965, 0.8875164871930613],
            [-13.537256525186326, 0.6251551448946355],
            [-13.57029510959211, 0.45020542895374493],
            [-13.571997651199778, 0.43635885315467127],
            [-13.586673862949054, 0.37350950161327817],
            [-13.616834138704448, 0.22175861855196285],
            [-13.649216870253005, 0.048342304636840985],
            [-13.684058848969125, -0.13439490529242362],
            [-13.71204656811846, -0.2785380944619556],
            [-13.727936259507592, -0.36600235568978384],
            [-13.757927185927638, -0.5219287729939397],
            [-13.786376501987917, -0.675057426312751],
            [-13.819596509749605, -0.8668393526889139],
            [-13.823238922984158, -0.8932359166148685],
            [-13.840491802104612, -0.9827440866317197],
            [-13.862481124786884, -1.0875839729555754],
            [-13.87651895431457, -1.1670320709458832],
            [-13.898568268305281, -1.1788889842992292],
            [-13.93202473795297, -1.23088459741404],
            [-13.948907851899442, -1.2337678262674174],
            [-13.948513601371625, -1.2533752621116463],
            [-13.969450703516946, -1.280248071721913],
            [-13.976494817696175, -1.3013861198610277],
            [-13.993485213540177, -1.3194179521493266],
            [-14.010002906841478, -1.3125040290885113],
            [-14.04271028427811, -1.3184166082122588],
            [-14.060018647868977, -1.3171123537663796],
            [-14.079583475873852, -1.3003391649352964],
            [-14.083153702192224, -1.279014532746526],
            [-14.097921394130331, -1.2710115714757932],
            [-14.111851272696573, -1.2522523791968203],
            [-14.104379979308117, -1.236879594409182],
            [-14.117090372106714, -1.210738399222784],
            [-14.136488978031096, -1.1840252486170026],
            [-14.142420016871107, -1.1676168604189872],
            [-14.177322145305734, -1.158208647787012],
            [-14.203484176826413, -1.173156971318667],
            [-14.211073770543734, -1.1588723091988034],
            [-14.220474434579849, -1.1561418412295128],
            [-14.246559389245434, -1.1636322139814868],
            [-14.249313819438003, -1.1393281871560326],
            [-14.298475299896797, -1.1281912112345194],
            [-14.33334800944548, -1.1413860959391826],
            [-14.346820553698016, -1.1277455418477893],
            [-14.394298923238075, -1.1523337245785414],
            [-14.437235676410715, -1.148689987993091],
            [-14.45575272445436, -1.1652250149639147],
            [-14.446947833483726, -1.1992043802227392],
            [-14.45382758181285, -1.205892679826647],
            [-14.442041255747874, -1.2271718069145436],
            [-14.458654908503123, -1.2380847554850851],
            [-14.466162319665727, -1.275356516460739],
            [-14.45275099287421, -1.3230931645445567],
            [-14.449030579766378, -1.3547905535513205],
            [-14.425389160619975, -1.3883834268114013],
            [-14.464368101456948, -1.405995379249027],
            [-14.458782552421933, -1.424331194008799],
            [-14.477218899012524, -1.447505672279994],
            [-14.469971736617937, -1.465409077317668],
            [-14.476104238446618, -1.4858904789167329],
            [-14.47419324790384, -1.499746206212506],
            [-14.479853531003394, -1.52155630612222],
            [-14.490600583304625, -1.5419705315858454],
            [-14.48952517215964, -1.5531627932770173],
            [-14.477185703764583, -1.5684904623979328],
            [-14.487766919864086, -1.590462884799357],
            [-14.489742355625136, -1.6053723019053974],
            [-14.482425635172417, -1.6155768795735568],
            [-14.469399480659169, -1.650032157551917],
            [-14.478596542359744, -1.6721767026882421],
            [-14.492376693195192, -1.6764421381560817],
            [-14.486141554131759, -1.6936215494143352],
            [-14.487814693079827, -1.7270814725641725],
            [-14.507457993594315, -1.7431550972197611],
            [-14.511473346586117, -1.7568752512190269],
            [-14.507458278062977, -1.789307490740426],
            [-14.509494908307158, -1.8096594236914239],
            [-14.504290780449189, -1.8281496504248034],
            [-14.487865231608023, -1.8531807543856798],
            [-14.486475779306199, -1.8837958230811698],
            [-14.481256491437275, -1.9071133357281997],
            [-14.47957255592661, -1.942616961785443],
            [-14.48678120807353, -1.9692323699092937],
            [-14.485326385158428, -2.005058968087924],
            [-14.489969984966152, -2.0583364268670628],
            [-14.485509802084737, -2.0685179261118254],
            [-14.490946766194673, -2.1067724946394115],
            [-14.50445524740983, -2.13853017669192],
            [-14.521377307582853, -2.1424500288463713],
            [-14.549722351596433, -2.14160550208369],
            [-14.564229372857973, -2.154361945742996],
            [-14.536101095264739, -2.18772956219732],
            [-14.54077686625319, -2.2031289194535053],
            [-14.559833258673399, -2.213961543460822],
            [-14.570824824353997, -2.2285842738304535],
            [-14.573320821003112, -2.2553274498737936],
            [-14.67145398533461, -2.1068961834177538],
            [-14.758931362151806, -1.9764192072026208],
            [-14.859307626511551, -1.8261165553192231],
            [-14.977344755766865, -1.6483394384825747],
            [-15.049427726788208, -1.5403690789297793],
            [-15.121498089559221, -1.4323882376127925],
            [-15.226382805375513, -1.2732576496415635],
            [-15.277656174536778, -1.1977517121413346],
            [-15.34099718945475, -1.101472543111328],
            [-15.3660720735335, -1.0648896876345646],
            [-15.492629514890622, -0.8744346862173669],
            [-15.664494780487018, -0.6160733336502936],
            [-15.733366752325097, -0.5116266975720368],
            [-15.869390943736642, -0.3076151358634902],
            [-16.04613676166095, -0.04041047390724319],
            [-16.08624158736432, 0.0189708554934203],
            [-16.193930303080325, 0.18195114093287762],
            [-16.20693403494016, 0.20009519598105377],
            [-16.273150625501074, 0.30005818291412667],
            [-16.34756271062745, 0.4140335187434233],
            [-16.396728219393072, 0.4860480537949266],
            [-16.45587273548098, 0.5769229116511863],
            [-16.47529286641765, 0.6037549761748605],
            [-16.572466442692253, 0.7532800468470736],
            [-16.590135234360485, 0.7766804670556811],
            [-16.632170401014083, 0.8420056477863587],
            [-16.795644527197098, 1.0875599625700407],
            [-16.985023568589966, 1.3732308278474588],
            [-17.014459781859927, 1.4161563350887552],
            [-17.068527302161915, 1.4997310566157698],
            [-17.10258915523815, 1.5492746316968198],
            [-17.206400420097147, 1.7067932820593867],
            [-17.236721357736698, 1.7503753346718052],
            [-17.292472185833212, 1.8360867480612393],
            [-17.454833062342598, 2.0782891870143896],
            [-17.497761820913187, 2.144401005387673],
            [-17.575771650064844, 2.2611351524532313],
            [-17.687426192609145, 2.4287224273939554],
            [-17.814662675346472, 2.6203340234148236],
            [-17.761261340008925, 2.8415689218983595],
            [-17.732287980772835, 2.955190160162996],
            [-17.679174599492914, 3.1469611325838023],
            [-17.63256800935863, 3.3260066292912214],
            [-17.570829493692116, 3.553654257967657],
            [-17.492640307530067, 3.851700128578866],
            [-17.432613471296893, 4.083048362535021],
            [-17.378074862024775, 4.298712397946405],
            [-17.34107716246633, 4.447161032138295],
            [-17.263133998680175, 4.749787601865479],
            [-17.183292870422193, 5.056919519400809],
            [-17.152510418637508, 5.1722254513247075],
            [-17.11950966486665, 5.299620218069185],
            [-17.088704651853956, 5.421603307603182],
            [-17.058519470490573, 5.537740661654423]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.65523065519616,
          "lat": 39.35617418430396
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779793"
      },
      "bbox": [
        -17.814662675346472, -2.2553274498737936, -12.77007841343745,
        5.537740661654423
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [8.938748823887709, 7.91289835709726],
              [8.952938313447763, 7.927956856528197],
              [8.965425560434483, 7.918459563143139],
              [8.95957290171268, 7.904629201681937],
              [8.950097440134119, 7.9012749945084115],
              [8.938748823887709, 7.91289835709726]
            ]
          ],
          [
            [
              [8.873351197559764, 7.828749521185434],
              [8.880005334291372, 7.861051666742619],
              [8.892928416157927, 7.882201308670676],
              [8.902458885208455, 7.867203493427707],
              [8.92526366116616, 7.843764463377639],
              [8.940615149431494, 7.8603060932077025],
              [8.947489220310906, 7.887446470515671],
              [8.967018633788637, 7.889129421189912],
              [8.97270471060247, 7.900761068622616],
              [9.008833412227172, 7.925369630342071],
              [9.002571070073415, 7.942568141534891],
              [8.98676647870405, 7.942909274750845],
              [8.963029695811858, 7.951363859745185],
              [8.969750526988953, 7.966298579050595],
              [8.98293865613479, 7.970823293689707],
              [9.01022990041992, 7.9707481883396945],
              [9.034499950937958, 7.975837971773359],
              [9.058928504251918, 7.965406474235222],
              [9.066607504055064, 7.967449415325954],
              [9.075196152585837, 7.948904302928121],
              [9.095547586835023, 7.929585925912256],
              [9.103401517408027, 7.904058672915203],
              [9.13057476250145, 7.881613051259203],
              [9.142440590437873, 7.8875124265805],
              [9.154858411742538, 7.874054252265726],
              [9.139743358567165, 7.847638691736097],
              [9.14214582706847, 7.8375934771636775],
              [9.133908784462822, 7.8250261163962636],
              [9.135595673100568, 7.814338889987735],
              [9.125566074577637, 7.8036970811263044],
              [9.073103695778551, 7.803719859643077],
              [9.058367932683948, 7.821677498634424],
              [9.032657359311324, 7.819249083565796],
              [9.013224688022524, 7.806688508096618],
              [8.976025309520471, 7.803798735271792],
              [8.962884566073132, 7.81941309838082],
              [8.95012028435149, 7.811759336480937],
              [8.945537725106092, 7.795527018507134],
              [8.92268828082667, 7.809733957686907],
              [8.902988078876568, 7.81011018225904],
              [8.883579331816895, 7.816946283408765],
              [8.873351197559764, 7.828749521185434]
            ]
          ],
          [
            [
              [8.404307299401975, 7.608688924128674],
              [8.414946918366095, 7.616586325281112],
              [8.44104872142061, 7.608158240843372],
              [8.460723122601763, 7.613781624128221],
              [8.51586389689277, 7.596090086319995],
              [8.5291574616612, 7.6111531966216],
              [8.534577673374589, 7.599612624753586],
              [8.571697328844747, 7.586896405202249],
              [8.565224253808086, 7.564451725947603],
              [8.551107313608354, 7.553161626225206],
              [8.550805695186472, 7.541815203830061],
              [8.533720115713045, 7.531774518505468],
              [8.523095381592984, 7.53859338415612],
              [8.510854506736447, 7.535371721657494],
              [8.475374470456757, 7.541816921371737],
              [8.467876556745074, 7.557661931212075],
              [8.43493983880474, 7.589685101137237],
              [8.411364065472437, 7.599269384068576],
              [8.404307299401975, 7.608688924128674]
            ]
          ],
          [
            [
              [8.349654103027044, 7.761799157235621],
              [8.357112159923279, 7.76922366788789],
              [8.372991491209453, 7.759168113791258],
              [8.3586864364357, 7.745381903664546],
              [8.349654103027044, 7.761799157235621]
            ]
          ],
          [
            [
              [8.355922134346175, 7.652755733370922],
              [8.35670031589129, 7.673589478974881],
              [8.374227247269907, 7.669641092993629],
              [8.391371333347186, 7.646301766246092],
              [8.379933289070852, 7.638440420939743],
              [8.355922134346175, 7.652755733370922]
            ]
          ],
          [
            [
              [7.850784518606892, 7.509290300510302],
              [7.868376334160753, 7.532935745297959],
              [7.876381704886383, 7.5135274633560485],
              [7.8639230913533416, 7.502652404721048],
              [7.850784518606892, 7.509290300510302]
            ]
          ],
          [
            [
              [7.754493102198428, 7.52191198352187],
              [7.754025252167352, 7.549136670750848],
              [7.778343423595246, 7.54334718340767],
              [7.794420754334572, 7.532294252394013],
              [7.799947144100876, 7.506666817799679],
              [7.754493102198428, 7.52191198352187]
            ]
          ],
          [
            [
              [7.709494926319211, 7.318708808570276],
              [7.711255406705197, 7.341802787467543],
              [7.720686247493501, 7.3583233304776305],
              [7.714983520351142, 7.381549236393395],
              [7.716370499589788, 7.399715155423584],
              [7.7351745313806175, 7.431044132678914],
              [7.732970261694606, 7.447001111360131],
              [7.739222085962838, 7.455442286563422],
              [7.7326446589450395, 7.477776212597514],
              [7.7502536075387365, 7.472559434162263],
              [7.775546860350182, 7.479116583292161],
              [7.782813388373299, 7.470982585899045],
              [7.772816494627391, 7.460214490506886],
              [7.784234205776578, 7.4512446096569676],
              [7.790606167115672, 7.424211946918384],
              [7.784118621505698, 7.406219001916382],
              [7.798333275916699, 7.3788350536197225],
              [7.8039863328260655, 7.348624849667034],
              [7.8022268239888275, 7.3347801788106155],
              [7.7795188950239496, 7.316384734146247],
              [7.771432780827145, 7.298991147871324],
              [7.757473831253632, 7.294637285730581],
              [7.739817393308563, 7.3003266690567585],
              [7.715776482429768, 7.300735428474031],
              [7.709494926319211, 7.318708808570276]
            ]
          ],
          [
            [
              [7.6426356775588875, 7.448015037816104],
              [7.655053920106607, 7.458296556008844],
              [7.675286531173635, 7.453323485433753],
              [7.677016426730889, 7.4291610062577025],
              [7.661361866308399, 7.407707298771767],
              [7.649291485587347, 7.40798582242617],
              [7.654174464741363, 7.43058552991824],
              [7.6426356775588875, 7.448015037816104]
            ]
          ],
          [
            [
              [7.546128461477179, 7.144749297748441],
              [7.569729449151373, 7.139403340977822],
              [7.585513454708125, 7.124647079831546],
              [7.590857852113064, 7.110638473790508],
              [7.581534794349943, 7.094888208898927],
              [7.554887474462132, 7.126311415189527],
              [7.546128461477179, 7.144749297748441]
            ]
          ],
          [
            [
              [7.452584013167618, 6.83010927875981],
              [7.454825277772066, 6.843023777647071],
              [7.464547033494831, 6.851323325096729],
              [7.503989002261498, 6.846944887505359],
              [7.514162535134119, 6.835315451252028],
              [7.514452903011436, 6.784080584357649],
              [7.522083659123433, 6.760476824666621],
              [7.507112461229972, 6.750309934019029],
              [7.4740722615632915, 6.783181102599942],
              [7.460727707570155, 6.7921559212283205],
              [7.452584013167618, 6.83010927875981]
            ]
          ],
          [
            [
              [7.4016434432491796, 6.699670354381241],
              [7.411002978608926, 6.729278263174433],
              [7.424607288696328, 6.736124946057165],
              [7.448460175864779, 6.729668447831487],
              [7.438518135397684, 6.7119071123238445],
              [7.444377627102635, 6.696071871887504],
              [7.4180732505626965, 6.683943910659111],
              [7.40378319232618, 6.688234224600307],
              [7.4016434432491796, 6.699670354381241]
            ]
          ],
          [
            [
              [6.991544547499511, 7.2216706221995555],
              [7.001123090468651, 7.227913306084738],
              [7.015664155301494, 7.218382591174633],
              [7.017504943806157, 7.1951609884920265],
              [7.00308159441106, 7.188651063870507],
              [6.991544547499511, 7.2216706221995555]
            ]
          ],
          [
            [
              [6.960308235713892, 7.24565164446998],
              [6.965657691120136, 7.257532427442319],
              [6.982508710492058, 7.250372897460564],
              [6.969296948087759, 7.23655718672457],
              [6.960308235713892, 7.24565164446998]
            ]
          ],
          [
            [
              [6.86363637075567, 8.170145745037455],
              [6.883045800384389, 8.187579223248191],
              [6.900354658758017, 8.189076835338666],
              [6.921437940146724, 8.165561729850717],
              [6.9210564611774466, 8.148339537281037],
              [6.9120257575447965, 8.117625575119604],
              [6.92574395678998, 8.109330274193445],
              [6.940547069492235, 8.108724357814664],
              [6.931370465914511, 8.08877441255764],
              [6.919405514382946, 8.08549088283357],
              [6.9046970790833235, 8.09980800390835],
              [6.898529720372606, 8.07971626108096],
              [6.887039793068672, 8.084171403768883],
              [6.884772426807377, 8.127012117895065],
              [6.872021437479617, 8.137252506087966],
              [6.86363637075567, 8.170145745037455]
            ]
          ],
          [
            [
              [6.913322821472252, 7.1379723345774675],
              [6.931254792838536, 7.141561908768124],
              [6.933153546979442, 7.116960244900209],
              [6.917243868881924, 7.125162086826758],
              [6.913322821472252, 7.1379723345774675]
            ]
          ],
          [
            [
              [7.246690071478481, 3.4115212082293382],
              [7.279378600619193, 3.4394431860579204],
              [7.342257175487155, 3.5015957364998984],
              [7.352089935178064, 3.518238466630222],
              [7.383254626825321, 3.5579201782385406],
              [7.398187153735442, 3.5860241070671743],
              [7.40734371287069, 3.6111258845396352],
              [7.422347375103883, 3.6771795120128585],
              [7.443772537021969, 3.7338167492586827],
              [7.460888961106354, 3.794222582591649],
              [7.473155846482565, 3.811778813005894],
              [7.5123806751619195, 3.8783076734342856],
              [7.541766972601006, 3.939678981080101],
              [7.557523778649486, 3.9855069169285184],
              [7.574086530113938, 4.047949486923377],
              [7.58323836703224, 4.104508183732591],
              [7.593398025800971, 4.146174370179691],
              [7.597415485605383, 4.183456068574001],
              [7.596609080516964, 4.233712258351152],
              [7.601897080281989, 4.289505231173747],
              [7.5951095259569, 4.332070162184945],
              [7.601328080418017, 4.355779268000926],
              [7.604007231407524, 4.405470697883651],
              [7.597489216952296, 4.457900529986532],
              [7.593623450617254, 4.471947556690466],
              [7.58610821097749, 4.550933893032031],
              [7.575222187654238, 4.61368934662704],
              [7.560757915652016, 4.6820102960138525],
              [7.530460424920576, 4.774728372607288],
              [7.506194098418225, 4.82522523601323],
              [7.466274918430716, 4.895757145806707],
              [7.404882638065104, 4.996343906652466],
              [7.376409354625851, 5.052553599262516],
              [7.355039766592749, 5.107818815685955],
              [7.337950125707276, 5.159037388367984],
              [7.317898785988277, 5.201183319319538],
              [7.289174850975315, 5.246744155810442],
              [7.271976860655666, 5.286028093665333],
              [7.267865570919505, 5.327122519100765],
              [7.272625799184343, 5.346784917320726],
              [7.31415891337163, 5.420062809084077],
              [7.3234124639292055, 5.44598734259523],
              [7.32862215831741, 5.476901496322429],
              [7.328435341119889, 5.50275917901436],
              [7.32295292883436, 5.530364881728598],
              [7.311268793107414, 5.56345571521924],
              [7.3066549874730695, 5.591473913590522],
              [7.294732566848396, 5.620701981375825],
              [7.290469765952123, 5.642949910649228],
              [7.273031787021123, 5.671523427064649],
              [7.257829244121535, 5.69081513129441],
              [7.2449666330878495, 5.725869712969728],
              [7.253368474206498, 5.744256420023157],
              [7.288470716454557, 5.778235770722369],
              [7.308826360576581, 5.812896435627492],
              [7.324905580156914, 5.860802183467709],
              [7.340828990126557, 5.895138123351338],
              [7.347250020685793, 5.928256097301042],
              [7.357605258399505, 5.942795005587453],
              [7.372185345838237, 5.989544346011106],
              [7.390774748851257, 6.028666481463754],
              [7.397638866370624, 6.105175993709752],
              [7.391824541209145, 6.135335581724369],
              [7.390677497562025, 6.166656382916272],
              [7.395957512887077, 6.185912698101056],
              [7.40209296917059, 6.25315261255164],
              [7.3958033848002644, 6.278970900486176],
              [7.379310161190794, 6.30985290896561],
              [7.36499116888479, 6.344978474192258],
              [7.3641971881092765, 6.3680404603608345],
              [7.3793744721592995, 6.388897040902289],
              [7.4146420016394945, 6.405160224265852],
              [7.431510524010769, 6.420325128542214],
              [7.455656258450515, 6.418706343560991],
              [7.476451816614544, 6.434892950416276],
              [7.484514568450584, 6.463652886454551],
              [7.478716186746595, 6.487588775059875],
              [7.484562318834033, 6.513694510332661],
              [7.473589376674477, 6.577510502995829],
              [7.475432195589094, 6.598608396054807],
              [7.490616654945311, 6.609239817098635],
              [7.507548994631311, 6.599050443273861],
              [7.528218274818251, 6.5984679632375665],
              [7.536236234396935, 6.605423120441743],
              [7.542949594910128, 6.62948697786899],
              [7.551914841617992, 6.64170918213918],
              [7.563791554996651, 6.671000104599375],
              [7.574906798969865, 6.671693826167279],
              [7.593102537664488, 6.663093952050658],
              [7.610340786097832, 6.646164935743847],
              [7.63389532468108, 6.649897813918071],
              [7.653072850001104, 6.66150775719946],
              [7.669961696806799, 6.69658959929916],
              [7.665869696353573, 6.722707532187641],
              [7.676474961516974, 6.736822573983423],
              [7.688435036215537, 6.771085910246266],
              [7.7073921870383595, 6.783175749803013],
              [7.726313559647023, 6.812290231818792],
              [7.7276159022511415, 6.835089918677664],
              [7.738116903069281, 6.86665322231407],
              [7.7606065898150645, 6.910341104536019],
              [7.7689109764162305, 6.902678587228312],
              [7.78338813943669, 6.90616129476484],
              [7.796987324208537, 6.919807808454409],
              [7.8044953560336525, 6.938817199814308],
              [7.811701031729617, 6.939771069112841],
              [7.823882658905096, 6.919527866771062],
              [7.821901958682, 6.907245792052489],
              [7.797220665183619, 6.882445849116783],
              [7.777115720024992, 6.87439240530852],
              [7.7693188300078075, 6.851823643938231],
              [7.784390380668416, 6.817369252625325],
              [7.799977080796338, 6.793986856919426],
              [7.790511644334962, 6.771636529789044],
              [7.791163613192812, 6.74838560516199],
              [7.768966897955905, 6.717566786987388],
              [7.76133252435839, 6.697959935699899],
              [7.776214633573382, 6.691703572876339],
              [7.7886796187191765, 6.711534388543493],
              [7.7960407628201365, 6.708391344249386],
              [7.796694029663033, 6.665584211619438],
              [7.800623766513708, 6.6520918828671896],
              [7.784490485897289, 6.647995839101637],
              [7.774058750483544, 6.608335859780635],
              [7.7729679857620795, 6.573630960998402],
              [7.775516740915411, 6.556420863857802],
              [7.791706234176784, 6.526956275955331],
              [7.789124018316473, 6.501766399038066],
              [7.798958769021761, 6.494489641713667],
              [7.819425823792587, 6.495411915886317],
              [7.827952071552385, 6.548219940873117],
              [7.834573789559267, 6.556586986615643],
              [7.844194378582202, 6.595535944924883],
              [7.854332765255458, 6.60664037706933],
              [7.844775288985608, 6.649221430970953],
              [7.853676500664296, 6.6938004800060344],
              [7.8522925270534385, 6.707306056786551],
              [7.871046637868687, 6.725922772517862],
              [7.881995359682973, 6.72831458583708],
              [7.89153125834324, 6.702841148665108],
              [7.88179868622618, 6.698856054733652],
              [7.877606300954124, 6.663648540769385],
              [7.882337216139192, 6.638268753923507],
              [7.877647762946628, 6.608331481828386],
              [7.879558183674968, 6.5922947129551694],
              [7.853708484052751, 6.5675034620006025],
              [7.8442191384033, 6.55053268187696],
              [7.845040950876118, 6.519778421181406],
              [7.8360347510078165, 6.491507536429078],
              [7.852961193873979, 6.481879656272451],
              [7.872215077697535, 6.482747487341866],
              [7.88463486574063, 6.502392082335701],
              [7.88045879374863, 6.523549743631981],
              [7.885530045463414, 6.541142669357655],
              [7.903810024771436, 6.5554289271323],
              [7.913792673823344, 6.593936436482697],
              [7.928721913732782, 6.623318669092867],
              [7.944310089479462, 6.674473643814934],
              [7.950230637364582, 6.747461229751755],
              [7.944491270540368, 6.761947481372244],
              [7.942372331835839, 6.789106695422161],
              [7.949490522167578, 6.812474797979957],
              [7.946812240064811, 6.855455119723328],
              [7.9388174958538995, 6.869181889450143],
              [7.931577266933963, 6.8937359027833365],
              [7.927191377136166, 6.922517340970632],
              [7.920630911239457, 6.93243938781922],
              [7.917119127064909, 6.979014945170414],
              [7.923353795857301, 7.012010512322952],
              [7.942351752164162, 7.029968645634467],
              [7.950644735758869, 7.046959884434071],
              [7.965329363645398, 7.064399139474901],
              [7.986681292978577, 7.063679715396743],
              [7.998613240987744, 7.075247259363295],
              [8.030419957514523, 7.115021524218129],
              [8.03819555549632, 7.114203715472856],
              [8.074924419808193, 7.131665848095359],
              [8.095665027972204, 7.127246039420268],
              [8.133340838839146, 7.129537920017721],
              [8.142466109987465, 7.127420147217715],
              [8.16238508974442, 7.1392900356525475],
              [8.180560925262874, 7.1391143076451025],
              [8.19837567092075, 7.148165312253739],
              [8.227563631722496, 7.168840723673164],
              [8.227641854790075, 7.185497828706389],
              [8.219921274386628, 7.1967282307951805],
              [8.179239811826427, 7.1998134462064245],
              [8.16496443994238, 7.195421066958559],
              [8.138308036802544, 7.200272548366243],
              [8.118640119588497, 7.214383017367953],
              [8.093395007890624, 7.241728899739323],
              [8.071633828140715, 7.296997932920719],
              [8.065287763351916, 7.325842430226061],
              [8.068812580737447, 7.343016343293939],
              [8.079960980127138, 7.358554197642004],
              [8.0895639932946, 7.388715275811462],
              [8.097713192944635, 7.399890435893055],
              [8.128385845988493, 7.415447551360524],
              [8.137125720839396, 7.426094652003172],
              [8.140651623890017, 7.44521792280265],
              [8.14895234634625, 7.447577795612758],
              [8.17083526016965, 7.477697556393891],
              [8.170321440609024, 7.49701160844551],
              [8.155331658279803, 7.5118568074305365],
              [8.128431670543387, 7.522037914554941],
              [8.179247939355879, 7.526293922382728],
              [8.193580542312645, 7.5175690379575375],
              [8.21107042264983, 7.529456062936054],
              [8.241168773712133, 7.521548432983277],
              [8.250537577478921, 7.53035036628461],
              [8.261499737031809, 7.52405951613382],
              [8.274103399583312, 7.532672942105533],
              [8.279097787596625, 7.547271860003792],
              [8.268414516005661, 7.561899472734432],
              [8.280643339824845, 7.5705813125081685],
              [8.296105543602009, 7.565850819477893],
              [8.3086883930477, 7.572799424371385],
              [8.322720203542282, 7.5524746088234815],
              [8.34789587002708, 7.545215382702544],
              [8.349438527810804, 7.538960135385373],
              [8.371717283925875, 7.53495866810097],
              [8.384626351462625, 7.526348547115151],
              [8.426524077993106, 7.509302155712773],
              [8.439337395943134, 7.509335653488464],
              [8.444906361123357, 7.49794069914401],
              [8.466150781824112, 7.487919219007456],
              [8.500044976987844, 7.464502109313969],
              [8.525663257063128, 7.465572417178769],
              [8.533866639854368, 7.456746606303416],
              [8.544442011636828, 7.466079128976032],
              [8.54432848113634, 7.482232528597198],
              [8.571811607172753, 7.471852317203208],
              [8.603006568735086, 7.484596653663856],
              [8.633664582432411, 7.47652644868278],
              [8.646098358138586, 7.470138976761973],
              [8.685525013677545, 7.4652194779639816],
              [8.725611141285881, 7.426740069902644],
              [8.755014812633547, 7.4009820963928545],
              [8.763475829511268, 7.365436627740066],
              [8.772855387903473, 7.349630798744771],
              [8.785302553279028, 7.340256273037969],
              [8.81155774249908, 7.335045407524066],
              [8.833349258349113, 7.34510755153204],
              [8.861257912017686, 7.3442086238754944],
              [8.872417309379207, 7.348962129257239],
              [8.89772725993729, 7.3493902373022975],
              [8.917069183122866, 7.34527283166142],
              [8.938576045035427, 7.330127706198754],
              [8.956039755625323, 7.31250237477267],
              [8.993999188689171, 7.289861907233085],
              [9.022316174066166, 7.279820301153345],
              [9.042287947924232, 7.279045472261578],
              [9.059802634366157, 7.292048039207981],
              [9.073783976173301, 7.277260669202507],
              [9.101726692220458, 7.266397022073337],
              [9.126291457534608, 7.251316127085291],
              [9.161703077574458, 7.24508332738147],
              [9.169594061529486, 7.239280795109801],
              [9.191911066967016, 7.252896748718724],
              [9.206761171765377, 7.243388363911835],
              [9.224761209155782, 7.23849331112204],
              [9.237056434124598, 7.226495761718067],
              [9.25705884480353, 7.222748158877024],
              [9.281875953840881, 7.196653013911499],
              [9.312597672803538, 7.180390318574968],
              [9.307790542447183, 7.1625407048708185],
              [9.2895965823613, 7.164419269840936],
              [9.302432914049565, 7.134857491454852],
              [9.322284765495674, 7.115542647554389],
              [9.334971651477694, 7.0858847815573975],
              [9.365728852762208, 7.063164212044232],
              [9.377808776184093, 7.045022572197898],
              [9.382751904013517, 7.020393360252673],
              [9.391284230585788, 7.015702499868949],
              [9.381779300068406, 6.999693031332336],
              [9.388210057591971, 6.991650025733647],
              [9.387749895100423, 6.972709640122594],
              [9.414512078745615, 6.969476843352369],
              [9.4273546094078, 6.948900321303834],
              [9.371267658409138, 6.960239558933114],
              [9.35001801083161, 6.977396314241367],
              [9.348579322159464, 6.991156992456302],
              [9.33331128217209, 6.9895224537126674],
              [9.30171196184861, 6.963748977080988],
              [9.29284094515898, 6.940493205246096],
              [9.29108665039019, 6.903341583975203],
              [9.305858778204367, 6.889862084875601],
              [9.311182851897478, 6.8619464755976445],
              [9.327446816089706, 6.838509347019344],
              [9.343019030694498, 6.832563341427967],
              [9.348581834599706, 6.82045627864382],
              [9.365203586467379, 6.817228457356246],
              [9.373649191183544, 6.808265594120674],
              [9.410758869470104, 6.800896484494571],
              [9.410198916475826, 6.775461961099316],
              [9.427818510740114, 6.753709588901006],
              [9.435451905904483, 6.734009478812445],
              [9.43619142021781, 6.712824719206577],
              [9.443089142715074, 6.692058862076737],
              [9.439388249694693, 6.68092350621944],
              [9.444624802019382, 6.663460283771911],
              [9.46235967298483, 6.642816333680766],
              [9.463533614591771, 6.621254549287001],
              [9.460245906308641, 6.585728219200229],
              [9.449604069880623, 6.55665186998309],
              [9.448537058613878, 6.52160947812504],
              [9.455032136466274, 6.487082412189383],
              [9.461658218688436, 6.470258289451716],
              [9.457409686898847, 6.44173170741422],
              [9.46166369187837, 6.413794506282829],
              [9.460716631764948, 6.371799852384622],
              [9.470155593741996, 6.33537405882164],
              [9.465407135360568, 6.3001010977379055],
              [9.47053934859015, 6.268578542471391],
              [9.46615809748959, 6.258523790835881],
              [9.449124130182193, 6.2578081743103136],
              [9.418823194840963, 6.215517545467727],
              [9.409385632362378, 6.183836160727104],
              [9.399333877450596, 6.191649243666877],
              [9.374583883356147, 6.1951363599703955],
              [9.354684195045026, 6.186101504511147],
              [9.337602034139195, 6.158167857489351],
              [9.3322782438648, 6.13645588769518],
              [9.332796672488566, 6.098933741863636],
              [9.32841239100542, 6.064126707773995],
              [9.334157858559898, 6.01344519902044],
              [9.322900413029837, 5.992776111872963],
              [9.323601747987656, 5.976610332340435],
              [9.33373829058223, 5.95767061401525],
              [9.311096567839572, 5.961564087670856],
              [9.285531023448604, 5.955192498787442],
              [9.264570692943776, 5.935504481713131],
              [9.259238299600728, 5.922230104170648],
              [9.269718743195028, 5.893719454606681],
              [9.257906648591334, 5.890396790360552],
              [9.225534435316103, 5.899081702301925],
              [9.212022447303447, 5.877777431059041],
              [9.173622487280058, 5.883836622560889],
              [9.158026205568525, 5.881622046160272],
              [9.150846058986682, 5.873719511673034],
              [9.144486051776159, 5.849080965368782],
              [9.13494120551475, 5.843914081975704],
              [9.129816047449689, 5.827609888365453],
              [9.129069854441042, 5.804774473530629],
              [9.11728214408085, 5.794964908776447],
              [9.113539389155958, 5.7372645894951955],
              [9.120847633495224, 5.69618567736467],
              [9.120593702898482, 5.655979364468306],
              [9.102872526591597, 5.637241627646461],
              [9.120889528119262, 5.593790620271221],
              [9.14452136670259, 5.558710609100202],
              [9.161778026189165, 5.545571402699867],
              [9.189094437829946, 5.533226686640302],
              [9.196840089551147, 5.540517089344905],
              [9.217823943378999, 5.533817134034621],
              [9.220121597705601, 5.525735519758936],
              [9.2528102868014, 5.522998336463994],
              [9.279375807368657, 5.515267734527616],
              [9.299432888365718, 5.501841606831924],
              [9.30718509515774, 5.490429335984159],
              [9.319255087466182, 5.487274809668741],
              [9.33090752523897, 5.49470222833517],
              [9.357279089455, 5.531709434731129],
              [9.381664871285752, 5.5764645227687115],
              [9.389462803265804, 5.586683342859657],
              [9.40683114683958, 5.623647008489231],
              [9.416900160940088, 5.633847141155003],
              [9.438838123129466, 5.616868794632595],
              [9.455151511313247, 5.646007035685599],
              [9.45788696849047, 5.660543731212614],
              [9.468559028094074, 5.679847437350144],
              [9.47404498062828, 5.709110743220586],
              [9.495048600223086, 5.747147138299807],
              [9.498177389729532, 5.781516573150329],
              [9.51881875369426, 5.789454546551033],
              [9.536718827724627, 5.81785265293682],
              [9.531078968963717, 5.836486948914842],
              [9.506484451613922, 5.8369340982032965],
              [9.543133117637947, 5.855242284866972],
              [9.561921716737347, 5.878907991294298],
              [9.569008522989607, 5.914176685127189],
              [9.613514648577654, 5.92850493907335],
              [9.623117853516089, 5.9277730161335525],
              [9.646334591112904, 5.937133997319877],
              [9.671648874994123, 5.957624539549581],
              [9.69564183012304, 5.957238412587131],
              [9.709537446514235, 5.964314160860174],
              [9.718437832734711, 5.978385615762191],
              [9.726135078710168, 6.006857301240815],
              [9.751989177764973, 6.013055367169925],
              [9.764992193530004, 6.031221836620177],
              [9.780919574061544, 6.030465291318581],
              [9.792401115144395, 6.03813338164808],
              [9.814140870515299, 6.033070760234674],
              [9.833986376793801, 6.020508882948143],
              [9.879726214984062, 6.014076136150951],
              [9.895671341306116, 6.007094183582271],
              [9.908119490702385, 5.993592973047577],
              [9.916817107654609, 5.99524511437997],
              [9.940797523170692, 5.9757306620608865],
              [9.975074857288744, 5.920525835181335],
              [9.990296529935563, 5.9033659289468705],
              [9.997245060472578, 5.877464410320002],
              [10.015265155504917, 5.86705693277831],
              [10.032595339114778, 5.836307826246463],
              [10.05649732393577, 5.783573853342862],
              [10.056599363552586, 5.759904223122705],
              [10.06576691758372, 5.7408676455033225],
              [10.079272187739424, 5.667807561578768],
              [10.092484624700305, 5.622913586726029],
              [10.09103246295841, 5.612078871115003],
              [10.110771940846224, 5.553197784226206],
              [10.119299924078371, 5.539114663329036],
              [10.132932366440858, 5.502959669269768],
              [10.150634674114867, 5.470871470791391],
              [10.160028975727737, 5.447751532275907],
              [10.164523669807409, 5.413759821442594],
              [10.170399708389782, 5.400103120854814],
              [10.173246684328081, 5.365115595456724],
              [10.178996822896021, 5.355430041879959],
              [10.18246335113882, 5.323224836875168],
              [10.18781815413458, 5.307377075899534],
              [10.200558387059472, 5.244504385172884],
              [10.214821231762887, 5.217600129537397],
              [10.225001438592715, 5.183560628352611],
              [10.232912568781021, 5.166563117984056],
              [10.244646234413418, 5.126510494495839],
              [10.257547338937215, 5.1132726978749155],
              [10.265874403754273, 5.0960558895087935],
              [10.29961844989641, 5.048116719869365],
              [10.30686051535931, 5.034462316661802],
              [10.304163953517024, 5.024624631438569],
              [10.31480304250046, 5.009454275648977],
              [10.307469725850767, 4.983215327164015],
              [10.291618444451517, 4.955350982137558],
              [10.286919481235369, 4.914944130647652],
              [10.29218592299603, 4.886993624154907],
              [10.28902553272705, 4.835449521587151],
              [10.299774460459977, 4.814043435404731],
              [10.306453047214362, 4.790093439575067],
              [10.29915966974531, 4.760760859750989],
              [10.301016687763804, 4.745345479350378],
              [10.289048542235227, 4.689517216059125],
              [10.293657522295014, 4.662566177558812],
              [10.28698159635197, 4.6295608825076116],
              [10.272434366407317, 4.613506849665872],
              [10.253449763790279, 4.583922660832237],
              [10.25183676719031, 4.572280640376904],
              [10.236906791098162, 4.564216065633048],
              [10.222167976587071, 4.571218196538613],
              [10.204774671393743, 4.571004136275199],
              [10.193735960148196, 4.5788481251806985],
              [10.175073997722897, 4.573657746759918],
              [10.192932090931405, 4.601250212882324],
              [10.178235099602094, 4.605828695190768],
              [10.162438663431598, 4.592041215082248],
              [10.152153613674008, 4.602664801631728],
              [10.16973794943099, 4.613759453167005],
              [10.169898852171578, 4.630613031171076],
              [10.182388051053055, 4.641580791156926],
              [10.188307977835988, 4.661097206204878],
              [10.205402421265962, 4.654932027176569],
              [10.207273490321462, 4.678780058159686],
              [10.197544981674408, 4.687693809468075],
              [10.17937328133307, 4.688237626165038],
              [10.167692551546375, 4.695131735108662],
              [10.148042439684016, 4.694901186963428],
              [10.130614921578232, 4.685591610144733],
              [10.108887041779823, 4.663374324805315],
              [10.109746865226912, 4.656144764089151],
              [10.086673178170443, 4.651466053433342],
              [10.073388455589662, 4.635136180145874],
              [10.071768061110006, 4.60901906905518],
              [10.093557478184229, 4.60141581311709],
              [10.106275722733633, 4.568652521292361],
              [10.077708812135395, 4.564746353494516],
              [10.061552827454417, 4.55309174338983],
              [10.059690721835088, 4.541028629351244],
              [10.045541051472824, 4.512474391518392],
              [10.042925970430463, 4.489321432174954],
              [10.044821414029515, 4.4648042775359045],
              [10.059417196149091, 4.444772110359209],
              [10.052625678945251, 4.386273001398836],
              [10.03610282737258, 4.363869001190051],
              [10.031424953125912, 4.347205103848012],
              [10.008891534202917, 4.321502952171327],
              [9.988944727025029, 4.311067811674903],
              [9.962062941760347, 4.3038045818736785],
              [9.936495489562303, 4.288095041973131],
              [9.925675032564705, 4.276421985236845],
              [9.914340798529924, 4.254958571687379],
              [9.90151157554336, 4.203839983552537],
              [9.904333501991287, 4.139574205969406],
              [9.922101578579046, 4.0919595275691245],
              [9.917536276241758, 4.0557601155186545],
              [9.896119019698071, 4.052541008557625],
              [9.876160896682231, 4.037251035297934],
              [9.883156181495462, 4.0046092182812],
              [9.88125514821385, 3.9863393241982474],
              [9.871744715846154, 3.9732830530655057],
              [9.87350972035266, 3.954397559041863],
              [9.846823758372306, 3.928239341162293],
              [9.842278548349114, 3.8928391046600743],
              [9.813582236183574, 3.8935974938541387],
              [9.801471961809062, 3.8812311531056127],
              [9.795381752548314, 3.860762796510812],
              [9.791822517762778, 3.8251052893634543],
              [9.771347349399761, 3.819863863720103],
              [9.763096253270785, 3.811389181275702],
              [9.74938255128912, 3.7696992376388456],
              [9.729652641146261, 3.7496746172766118],
              [9.729221584538603, 3.726501194154585],
              [9.736255960548576, 3.6956067474650216],
              [9.707470795993075, 3.690207452294014],
              [9.717480065155032, 3.674741753727321],
              [9.72872167487993, 3.6680951964867674],
              [9.581046752283337, 3.6429903929177803],
              [9.433378969358321, 3.617847116977203],
              [9.33289117978944, 3.600906911906527],
              [9.23240667968276, 3.583948935771482],
              [9.066918373390477, 3.557026735934837],
              [8.924184487773445, 3.535564566369998],
              [8.781456368911766, 3.514066847524448],
              [8.740484202174706, 3.5070616795644556],
              [8.732961335534574, 3.5710778982706786],
              [8.610312765786034, 3.5558418241024805],
              [8.48693256722366, 3.542093356690406],
              [8.363555283652062, 3.5283183253820667],
              [8.25344688512497, 3.5155736653899257],
              [8.143340973260873, 3.5028078354917707],
              [8.008039655753489, 3.488085656175933],
              [7.884081350518487, 3.4757586182009095],
              [7.760125624267612, 3.463404838855522],
              [7.6160044800678275, 3.448147135090895],
              [7.471887225477914, 3.4328532477659084],
              [7.359287624543721, 3.42219824721433],
              [7.246690071478481, 3.4115212082293382]
            ]
          ],
          [
            [
              [6.140605375432809, 8.965882391348593],
              [6.15813649131716, 8.976096702909413],
              [6.1764249591797125, 8.973239696138178],
              [6.175585349995854, 8.959317127700084],
              [6.140605375432809, 8.965882391348593]
            ]
          ],
          [
            [
              [5.014720316572866, 9.322415586474067],
              [5.01940528306353, 9.328867107303166],
              [5.040072477655585, 9.334391628392723],
              [5.036225500096957, 9.343037744674962],
              [5.04019209596253, 9.364568887030073],
              [5.066490981941097, 9.390019593868157],
              [5.120671699229776, 9.426157444929201],
              [5.186187898289143, 9.464609393780139],
              [5.2508783286711, 9.4956105485664],
              [5.251375309697461, 9.501248349132126],
              [5.288639090151538, 9.52591213898796],
              [5.301903189624416, 9.526808249163652],
              [5.326873240791882, 9.539388358391875],
              [5.33461544671111, 9.556895205592458],
              [5.371056049503058, 9.579229084706892],
              [5.391468944257754, 9.59576145441597],
              [5.396423835330301, 9.611021142281405],
              [5.4301872915036915, 9.632394626936117],
              [5.453499974483866, 9.641610934238107],
              [5.473582450390136, 9.655434573386387],
              [5.4892756229007675, 9.647243508170044],
              [5.504926644610379, 9.651293978391909],
              [5.516786863821122, 9.663719625060233],
              [5.539893767717706, 9.66847046902051],
              [5.555779671267136, 9.677617500935861],
              [5.559206022709486, 9.658047026461793],
              [5.542773833861955, 9.641543202038852],
              [5.504639454880765, 9.608435395234052],
              [5.46651572676182, 9.575316031998357],
              [5.460625301503259, 9.566310500244578],
              [5.4637086303409905, 9.544839201468767],
              [5.456834842318932, 9.535880119695873],
              [5.403525060455769, 9.48978892644475],
              [5.37215435948652, 9.471402555075333],
              [5.3239852232127225, 9.451883207342599],
              [5.2965283625088855, 9.435403603902262],
              [5.283970783694391, 9.435536680925924],
              [5.2601007795441985, 9.42049083570773],
              [5.2373193741263595, 9.410435092643835],
              [5.237907006021646, 9.404050529950595],
              [5.187031291153699, 9.372680802957365],
              [5.1897811880090305, 9.355284504837899],
              [5.205321841779112, 9.360943866802513],
              [5.223829027401093, 9.35769337622587],
              [5.207450684836548, 9.339813692954513],
              [5.1774219310309, 9.322894654835954],
              [5.162971758187678, 9.319116192035692],
              [5.111185959269885, 9.288748621894104],
              [5.085964370764024, 9.281988906560136],
              [5.064592339433168, 9.290159817484268],
              [5.059695094965499, 9.304314781346378],
              [5.035063104433804, 9.306030712638435],
              [5.039347585143507, 9.331054284891417],
              [5.014720316572866, 9.322415586474067]
            ]
          ],
          [
            [
              [4.311393207447987, 7.992702401520623],
              [4.369134366977226, 8.038330888977434],
              [4.385992331284306, 8.033324703548642],
              [4.413472267781328, 8.050558680912548],
              [4.432156315592029, 8.057580043181163],
              [4.481481700818829, 8.081353221266648],
              [4.524431367018537, 8.093488348632832],
              [4.5733187427332345, 8.11490161152364],
              [4.593354826166758, 8.13394605089952],
              [4.600373004581545, 8.145707178380823],
              [4.643430392916996, 8.182009317210579],
              [4.68832756207108, 8.242126004517921],
              [4.7282490732629, 8.267395733590039],
              [4.774387068868872, 8.282559358593467],
              [4.806348491400881, 8.287441400613853],
              [4.848511171408435, 8.27666286665553],
              [4.860401237999915, 8.28427979403655],
              [4.915034072611798, 8.303202237465754],
              [4.9443915607558395, 8.300772877997519],
              [4.982572373347766, 8.309926684430424],
              [5.024320900525209, 8.331565067785707],
              [5.036932211136877, 8.342743517974496],
              [5.069509441290679, 8.361275659199912],
              [5.105961253195837, 8.386640393979134],
              [5.1227347973761495, 8.405794465216319],
              [5.139743548810392, 8.439324739803082],
              [5.1500186359486175, 8.445400917072702],
              [5.1591855687131005, 8.461417493040656],
              [5.175091215491563, 8.471797257617883],
              [5.183893013738522, 8.464788695101584],
              [5.213253810728111, 8.468921259851728],
              [5.2356889130013045, 8.483003828249274],
              [5.244774326878465, 8.476655811717082],
              [5.26449119696868, 8.481252357164276],
              [5.288110543440508, 8.499631014022057],
              [5.298622302594304, 8.51687866564871],
              [5.309781322675147, 8.545783481076155],
              [5.3103965992771585, 8.560180388973874],
              [5.3238064997492005, 8.587602851548679],
              [5.352302481708679, 8.60361180636014],
              [5.366929413834492, 8.626953378964043],
              [5.387767529299725, 8.642047694349754],
              [5.406752428127059, 8.649222880219703],
              [5.426094821726245, 8.679371074076647],
              [5.445100189664552, 8.69954853979238],
              [5.47477875314673, 8.722496654057446],
              [5.4936250524117245, 8.727542171814777],
              [5.501519942980294, 8.73690912005007],
              [5.525555515049507, 8.744346422894463],
              [5.573576331517867, 8.796879578898228],
              [5.587678495387287, 8.817654298110474],
              [5.598150282741727, 8.844536844696542],
              [5.619496900914608, 8.87474389754824],
              [5.6527865266760955, 8.900122849654121],
              [5.686068786699674, 8.914682034186288],
              [5.709919164255902, 8.934529390518756],
              [5.736123934133945, 8.942365984863342],
              [5.747915242677713, 8.950269128992533],
              [5.756053001337662, 8.965538111855762],
              [5.777021789678809, 8.974857858201279],
              [5.838123979170428, 8.990128825249718],
              [5.8665772337794175, 8.994378282519522],
              [5.871458071196502, 9.000683509626107],
              [5.94026474888197, 9.010122448208445],
              [5.964815202946226, 9.009521349842911],
              [5.981347674459585, 9.001856436621875],
              [6.00252040560675, 9.009551743034498],
              [6.033737857280549, 9.011683521535131],
              [6.064939973367353, 9.001958477171629],
              [6.094399153260377, 8.983900916990736],
              [6.100111454882608, 8.946534909404894],
              [6.079381184772725, 8.94910730668717],
              [6.063467268119457, 8.936050850563076],
              [6.0412907064489225, 8.932363387901171],
              [6.031689578112827, 8.924291520300173],
              [6.002741329123859, 8.932273472390087],
              [5.985391139111068, 8.931001750770154],
              [5.935325544999879, 8.918579146291862],
              [5.9336620733151015, 8.894078508315713],
              [5.951876539969236, 8.875650693140058],
              [5.947051156765609, 8.867314381249551],
              [5.93207735621659, 8.86441108212759],
              [5.901752812198719, 8.835943868739504],
              [5.87634438434112, 8.825912504445137],
              [5.850843597525717, 8.787429957736373],
              [5.837339549615235, 8.780227238250104],
              [5.82566400440423, 8.759427134149233],
              [5.807326188049257, 8.738670794313252],
              [5.776511940141424, 8.730134072419093],
              [5.760252064612374, 8.70594439789277],
              [5.760023648686941, 8.678485287349588],
              [5.768185036645509, 8.666859417732619],
              [5.735058702129836, 8.656524850721476],
              [5.727405230951298, 8.61672129979108],
              [5.693493826489073, 8.59216481760497],
              [5.692642569000578, 8.5708343918878],
              [5.686002478266564, 8.535129259654306],
              [5.664217731217325, 8.499467765557206],
              [5.636054834183115, 8.48273202502353],
              [5.63363773622747, 8.436270019398425],
              [5.622585838084401, 8.398566777325545],
              [5.622696900894554, 8.33942727393217],
              [5.639288965161851, 8.303920100802944],
              [5.626455160931098, 8.296641405311103],
              [5.616327472611679, 8.272571580369638],
              [5.629948310206996, 8.26464250429471],
              [5.6495735507490705, 8.279223497908749],
              [5.658667501308451, 8.309933864600401],
              [5.690999618016001, 8.356948011967443],
              [5.684410050120356, 8.36967522197081],
              [5.709690036000155, 8.376784572165343],
              [5.735563050215044, 8.411193461690585],
              [5.766787890741191, 8.439170402528886],
              [5.777374681913738, 8.453954499182199],
              [5.8074542419496025, 8.470524214380752],
              [5.812855553654787, 8.479267263146648],
              [5.842432041144602, 8.496193796031799],
              [5.840701497213424, 8.472959318876805],
              [5.817149390612654, 8.446696728215498],
              [5.801226010830357, 8.435551605328854],
              [5.782204018377412, 8.410334734156034],
              [5.790265429285142, 8.398716611098875],
              [5.803745561449691, 8.411117773925834],
              [5.800392969348838, 8.417990298055251],
              [5.820193606452526, 8.432762660048773],
              [5.859331309798334, 8.44109627350178],
              [5.87623452565228, 8.449767388392038],
              [5.8971631578889765, 8.453799800584765],
              [5.922213662058924, 8.445114734555428],
              [5.947367665443157, 8.443948852446843],
              [5.976260932508509, 8.450024164059398],
              [6.016161546775624, 8.453242339113899],
              [6.033351696934855, 8.438555937570303],
              [6.053471847240873, 8.43169034908127],
              [6.072956845303056, 8.440517596799273],
              [6.082730184772594, 8.431692489452947],
              [6.097403245149775, 8.431442131412746],
              [6.102393565098445, 8.418980675726498],
              [6.117262975625172, 8.413959314883568],
              [6.1270093429788846, 8.419539001514142],
              [6.139780040393111, 8.38168254251548],
              [6.162581974020023, 8.384753884535224],
              [6.1749385058377735, 8.395715929144602],
              [6.181233577405739, 8.376610403518848],
              [6.205333110947977, 8.373776201755987],
              [6.234542929681273, 8.338959865241883],
              [6.247123355410089, 8.296714613427095],
              [6.254371190951343, 8.287169040268871],
              [6.2899703750921985, 8.260906352638889],
              [6.291591756454221, 8.246968296065054],
              [6.309139127575833, 8.21998987633634],
              [6.3342544241632845, 8.210463643539004],
              [6.33876144760614, 8.190252443754071],
              [6.363528510363273, 8.16832412303327],
              [6.376148111889326, 8.170668161042713],
              [6.3952740178548195, 8.163080397326803],
              [6.391650413518849, 8.151439009246882],
              [6.405139856712442, 8.128238719045969],
              [6.39425127083226, 8.114346564256456],
              [6.404369684122708, 8.09950790759624],
              [6.420702798706476, 8.087262624501536],
              [6.455193984467269, 8.079049567815547],
              [6.491308754923652, 8.078608157900748],
              [6.529802228842929, 8.084684426669568],
              [6.549989922034399, 8.099643072501259],
              [6.576151743336557, 8.092025192544913],
              [6.588399878873013, 8.094043117791587],
              [6.6135348168530665, 8.11673541560216],
              [6.648360019647319, 8.130607499530118],
              [6.650000929131865, 8.138856527708608],
              [6.681409796504782, 8.134242950461473],
              [6.690894617605932, 8.125191776449853],
              [6.708411227814911, 8.09060176715151],
              [6.710408760002796, 8.080158765159444],
              [6.733746717242219, 8.079649162427524],
              [6.748020352157341, 8.073446974125869],
              [6.759884757279663, 8.053125546820539],
              [6.786116335887335, 8.0525627992675],
              [6.800495476179036, 8.057617616221007],
              [6.806299683746181, 8.08672003274114],
              [6.815993453978283, 8.098622111694759],
              [6.838769482978671, 8.102667279563356],
              [6.855356842796159, 8.090390361762035],
              [6.877930843658711, 8.066569439835972],
              [6.9007176745115615, 8.074974144286415],
              [6.913390039775434, 8.06223567966085],
              [6.907625059109895, 8.05216344327725],
              [6.925422274312264, 8.043723846058585],
              [6.958182961713438, 8.102747857161244],
              [6.976814033586604, 8.13199200172842],
              [6.989707690656903, 8.137787574604307],
              [7.0003266704601605, 8.154740931638248],
              [7.012574371241351, 8.164604878037373],
              [7.02857389621809, 8.193550383967327],
              [7.04547952080809, 8.190126162804479],
              [7.080573650758743, 8.209399435912665],
              [7.106878433580822, 8.226763514691617],
              [7.158487172065335, 8.269683391693235],
              [7.210111052283776, 8.312586152028352],
              [7.226566310008789, 8.32960796675429],
              [7.2422269984167595, 8.334649465936657],
              [7.256472637995078, 8.32057551569866],
              [7.278541486554685, 8.320938059200426],
              [7.312173334593828, 8.336631541827657],
              [7.34025227913269, 8.345557735960371],
              [7.3516129689636545, 8.3434339806438],
              [7.397658595739923, 8.364680256125649],
              [7.418632398383912, 8.37088952840605],
              [7.444070923399548, 8.371584240655581],
              [7.476482816133547, 8.367286096795763],
              [7.532013798510604, 8.369337418736855],
              [7.562918287051966, 8.375887577309486],
              [7.619264580614975, 8.37626600632342],
              [7.6785409069884984, 8.384143189608077],
              [7.76800505137783, 8.434185166264813],
              [7.801391782288597, 8.458728099781473],
              [7.836568845756088, 8.478389714067983],
              [7.902912256199728, 8.497541948676616],
              [7.955429750680046, 8.49639029002569],
              [7.986470748220147, 8.502390748638035],
              [8.01177837062241, 8.516088996594272],
              [8.028749989924172, 8.520024645820163],
              [8.042293704266436, 8.516231167882106],
              [8.009744844579036, 8.473224219444948],
              [7.999691828692054, 8.441425291723231],
              [8.002536090195797, 8.369871228342681],
              [8.007542929121756, 8.327286971293523],
              [8.017713807699133, 8.290215124538719],
              [8.001152491877784, 8.278176259407854],
              [8.001859855854594, 8.260303681740812],
              [8.019488570419782, 8.23542488433124],
              [8.033131096401668, 8.229085346546182],
              [8.06838503238283, 8.230239462992925],
              [8.085393201746127, 8.241571004697615],
              [8.098248895686249, 8.226912397349075],
              [8.11833560886799, 8.224716138748931],
              [8.139744319770603, 8.231702457053109],
              [8.1577248058132, 8.210309474278702],
              [8.17302125479039, 8.210136425601945],
              [8.2049833631986, 8.22303132267208],
              [8.234673357822905, 8.241179137649167],
              [8.263176677251353, 8.263855917960187],
              [8.280650507245689, 8.260517666730408],
              [8.296013288719763, 8.264944961644833],
              [8.32179689862439, 8.23514573349794],
              [8.320260731815395, 8.217500281274756],
              [8.328165397842156, 8.199466941090584],
              [8.337251831132908, 8.198922253461047],
              [8.364248628182592, 8.210323246823133],
              [8.392391699552004, 8.2386721776037],
              [8.406185979589752, 8.226154119222615],
              [8.416780518124584, 8.235751325023417],
              [8.419176463983712, 8.25775887413567],
              [8.413084112516868, 8.261645821398243],
              [8.42293485485816, 8.284288516681073],
              [8.438522936236787, 8.29816355268054],
              [8.456253554614618, 8.298490246359126],
              [8.46927849425957, 8.309869943864316],
              [8.491745360117733, 8.311206287587538],
              [8.526735921426564, 8.300685992170525],
              [8.54547029749121, 8.304564469726781],
              [8.552188032198249, 8.311780165661412],
              [8.567501464610837, 8.346566955618174],
              [8.588719930735826, 8.355376101606318],
              [8.601716061514063, 8.343832726333238],
              [8.634531985756551, 8.351080966546139],
              [8.649885235203183, 8.327140663989763],
              [8.636565142630653, 8.240357506412797],
              [8.647296556060764, 8.195628728821232],
              [8.665253976679253, 8.162826046770558],
              [8.67596933312312, 8.149180072545212],
              [8.667642129317173, 8.14122624948378],
              [8.6762569664573, 8.095722572695928],
              [8.689950669848637, 8.085766165126723],
              [8.684755185065882, 8.069910417694658],
              [8.66606698044328, 8.056110834532417],
              [8.65316313008791, 8.054572836156192],
              [8.637536466919071, 8.068740809483938],
              [8.614423841336809, 8.067049072185098],
              [8.613622481695863, 8.051523664916507],
              [8.598972810869856, 8.03838622768908],
              [8.584541665477577, 8.034516201703301],
              [8.576207576577087, 8.016868145715451],
              [8.594215311107154, 7.993624418380815],
              [8.616743880453907, 7.983625318305302],
              [8.633117269175736, 7.988723105868363],
              [8.649815972965353, 8.006243151104746],
              [8.666650329584158, 8.00583205250716],
              [8.709496038479324, 7.978566041888126],
              [8.729452915099877, 7.98076597685775],
              [8.752081997288693, 7.9720429390559415],
              [8.72868652782228, 7.938660832150094],
              [8.72895974263666, 7.927690919743876],
              [8.748440803353295, 7.911972030932755],
              [8.764217768424533, 7.8927439440157015],
              [8.78111102591974, 7.886971872820615],
              [8.798896047317083, 7.871032485615756],
              [8.82919024303559, 7.877734217718029],
              [8.831359918317386, 7.868238848086203],
              [8.85103669736502, 7.861840448144486],
              [8.863262812858292, 7.8384234666323644],
              [8.84714057995081, 7.817353244971768],
              [8.80808340568266, 7.8137387225003305],
              [8.782426101987861, 7.800903046942322],
              [8.746520081240137, 7.803943606442994],
              [8.717136874822751, 7.810740838105977],
              [8.710726058513714, 7.8161724913396196],
              [8.681248944030438, 7.803435175213188],
              [8.667168990343539, 7.809709615944291],
              [8.655817915257478, 7.798895482991953],
              [8.638123412657647, 7.809050071265297],
              [8.631622732956107, 7.799767585391985],
              [8.602062346601889, 7.807572712977414],
              [8.614829335901431, 7.788146663535939],
              [8.591849138412497, 7.772033917778542],
              [8.548670903288395, 7.770281784576944],
              [8.551633249771765, 7.753093183263782],
              [8.519858480900062, 7.752918979923528],
              [8.50438645909411, 7.7653179718248895],
              [8.504460521905209, 7.781858315733796],
              [8.518105959467912, 7.795972988867706],
              [8.48610418421, 7.811984348202005],
              [8.465518035037569, 7.803324106541826],
              [8.474596522922868, 7.785740000289926],
              [8.459698055622418, 7.779647458948408],
              [8.452779779300828, 7.796520405147596],
              [8.435779975924563, 7.791839504882108],
              [8.437973628335701, 7.770763134490634],
              [8.425537557375886, 7.767429947529057],
              [8.424246207965696, 7.789139159022802],
              [8.410824484442097, 7.818893738881728],
              [8.396221355423826, 7.826707590050872],
              [8.381253738436657, 7.81906277045388],
              [8.367511163665377, 7.819765789536514],
              [8.329844031994535, 7.838909139383389],
              [8.310725214992733, 7.818934393408883],
              [8.309273283145219, 7.800917068722154],
              [8.316555837722525, 7.790270948298928],
              [8.311945037173432, 7.769984208821837],
              [8.28984138733618, 7.743047401607001],
              [8.285265943677228, 7.7232138669718395],
              [8.298245092761649, 7.702575410554772],
              [8.291137984014394, 7.694994943073845],
              [8.319689854050843, 7.634645934033663],
              [8.295329285556017, 7.630972106863709],
              [8.284837290358475, 7.624516217005433],
              [8.258628643979145, 7.637192285930275],
              [8.249817809263211, 7.647868176418905],
              [8.237804007048899, 7.644247806844251],
              [8.224312528340883, 7.655923155829145],
              [8.221806689145733, 7.671657352428123],
              [8.20791129692624, 7.674632341769621],
              [8.184878733647105, 7.694133978135649],
              [8.16716899819688, 7.693475308467411],
              [8.143198030080642, 7.726002175756633],
              [8.095650494594421, 7.76517123682376],
              [8.058334605360457, 7.777492459651059],
              [8.030778107283277, 7.779240715169065],
              [8.00345642149414, 7.794398661440922],
              [7.981234973498511, 7.793563203223924],
              [7.96724370411117, 7.805851058607042],
              [7.9506474795672295, 7.795925985732803],
              [7.93479329008083, 7.80139085078961],
              [7.912724697415158, 7.800800154431114],
              [7.863764715381876, 7.822615735296451],
              [7.842371412491702, 7.822061064711494],
              [7.827561352871903, 7.804279501819378],
              [7.818261717036843, 7.820893079339564],
              [7.792466709641981, 7.826350091975208],
              [7.772308172533175, 7.812687415743621],
              [7.742499467419357, 7.815840314214336],
              [7.728300614432884, 7.80862648303118],
              [7.70149638085393, 7.775251450260745],
              [7.6967649313992865, 7.761008609010452],
              [7.682176774970379, 7.745771938848417],
              [7.671205838171722, 7.717127866560129],
              [7.6507913840320345, 7.6899119198940165],
              [7.647089051718166, 7.6749058339825424],
              [7.632882557917377, 7.674588022295745],
              [7.622018180082765, 7.665625594421164],
              [7.598811720965046, 7.669880399896053],
              [7.572276979428179, 7.670517925243918],
              [7.555048784426597, 7.676953762931006],
              [7.536186882365009, 7.677111600659031],
              [7.526510891734501, 7.663996748686675],
              [7.483993758914025, 7.658593770696735],
              [7.46813737830448, 7.6421417652483274],
              [7.465787705603858, 7.621984211591951],
              [7.453628608894176, 7.618135677062908],
              [7.443753411490781, 7.625651212086091],
              [7.413360574679711, 7.6352540691412845],
              [7.3681543611353515, 7.643783474319178],
              [7.3255959048030235, 7.639839420565008],
              [7.2993599561070335, 7.626514305140829],
              [7.275183726629575, 7.633092531121471],
              [7.259058497419301, 7.627159157322127],
              [7.253579707305716, 7.615132624439303],
              [7.238005618900008, 7.615674659956868],
              [7.222385413932476, 7.608159008245049],
              [7.217289970283261, 7.5902228770705085],
              [7.203533395998301, 7.584299429903236],
              [7.192621655410937, 7.567845375953818],
              [7.1939432127896366, 7.548998877120465],
              [7.189000690649567, 7.530830561599537],
              [7.195805909974854, 7.517385867403156],
              [7.182632688864178, 7.493340751717477],
              [7.186311723216723, 7.482818648342984],
              [7.172444063608913, 7.448321790638539],
              [7.157788302378401, 7.454685176399296],
              [7.134590286453903, 7.446182740654865],
              [7.1292099149129795, 7.417709474325772],
              [7.115009387895844, 7.411731896436051],
              [7.099925646291234, 7.417015925105333],
              [7.097038576536183, 7.402530333924974],
              [7.084580701696492, 7.404305225218319],
              [7.064173920813009, 7.396219196881611],
              [7.064606791765144, 7.3581511452661905],
              [7.038518400416961, 7.36299442876594],
              [7.0320871378682215, 7.344506224131253],
              [7.030964120545278, 7.311999835002719],
              [7.016929951209648, 7.314965559244695],
              [7.006675193322643, 7.304138186555809],
              [7.0183096705622425, 7.262423600608689],
              [6.995133102380585, 7.259359297574213],
              [6.967591125372693, 7.2747862439267115],
              [6.960017238853884, 7.293553768133314],
              [6.947565123903642, 7.29593428318063],
              [6.942855341614885, 7.321886439264084],
              [6.951931417680785, 7.329887210677856],
              [6.969625502313874, 7.33237596787512],
              [6.975918623123369, 7.3433047826047275],
              [6.97000784722578, 7.3612826368367825],
              [6.983262772350248, 7.369824803574994],
              [6.997805365661952, 7.397767683770388],
              [6.989739919736936, 7.406921582347614],
              [6.9935557274703655, 7.419474339847958],
              [7.0235172881625765, 7.424242988185046],
              [7.027156387903138, 7.446171887752053],
              [7.036916914926066, 7.4511226533968475],
              [7.039915307445276, 7.478524593170633],
              [7.049196224011868, 7.485020346952736],
              [7.056629040144839, 7.501638722132427],
              [7.0484068674578575, 7.533222083424608],
              [7.030230895761643, 7.54480314440713],
              [7.014716544523534, 7.540151580437846],
              [7.005168422044182, 7.519768857971471],
              [6.99505812910261, 7.518183792955494],
              [6.983006237853457, 7.50116306496789],
              [6.985132378786306, 7.484691165261384],
              [6.9656577683549505, 7.473731104468984],
              [6.915737091898651, 7.4831811749952895],
              [6.906725708291267, 7.4983580670860155],
              [6.895389308112429, 7.4998033456594655],
              [6.879679783617347, 7.491241566271541],
              [6.881247773820019, 7.4724206922247065],
              [6.890512785440341, 7.443708402308896],
              [6.88477849799379, 7.426452697419588],
              [6.8718390572478025, 7.424147705955518],
              [6.870250778495048, 7.406838455946102],
              [6.86096658371227, 7.400019378272105],
              [6.86282040327673, 7.385982390551926],
              [6.847760082235438, 7.365352811098686],
              [6.8511396298548295, 7.348623471443597],
              [6.835549923256654, 7.337717681412424],
              [6.80999632244929, 7.334119426692623],
              [6.799856014917209, 7.32073584976912],
              [6.7841150550919425, 7.324779257713737],
              [6.778334163230544, 7.306997465436633],
              [6.75376660852991, 7.325549086567406],
              [6.756414623786978, 7.348656088031868],
              [6.755233325885509, 7.375476587098129],
              [6.741173130087238, 7.428696058138814],
              [6.727591965474802, 7.4455055139130275],
              [6.739244455198362, 7.454298339305255],
              [6.740940285784746, 7.465249625963515],
              [6.762813738316672, 7.496549314549782],
              [6.760774695531706, 7.516847144405125],
              [6.739467892948153, 7.523059313644675],
              [6.722717691845998, 7.485144230739651],
              [6.713176905490811, 7.475273151051288],
              [6.730342305603217, 7.464616791910728],
              [6.703249859322378, 7.4486390399440845],
              [6.693074884696525, 7.4260307689623595],
              [6.6933412611638765, 7.372654199856537],
              [6.700174298489445, 7.351387205407946],
              [6.686299341234384, 7.320816996968042],
              [6.67395280039631, 7.309881260558206],
              [6.674949284400398, 7.299245261455012],
              [6.653636399820043, 7.291509071290331],
              [6.631244998063631, 7.273930553099144],
              [6.6253512586837155, 7.257997387495081],
              [6.612585631292144, 7.240563775075382],
              [6.5884825859249165, 7.181010331214947],
              [6.580267748391378, 7.171865561455908],
              [6.561265210500781, 7.103566235600944],
              [6.548904684553257, 7.071903252097111],
              [6.534810024395555, 7.047651914377887],
              [6.541092726195106, 7.0309811135629205],
              [6.535610558625485, 7.015978312390527],
              [6.520854718854495, 7.003602665853184],
              [6.519608023289038, 6.991111818806083],
              [6.500636730838706, 6.966988808736773],
              [6.499928242554442, 6.94711553974217],
              [6.490623686572947, 6.939111202560619],
              [6.47184744088966, 6.886622921819177],
              [6.456436376615338, 6.864457411680218],
              [6.4129815940648935, 6.784363477484167],
              [6.397275700067203, 6.77291588333989],
              [6.3836366439147945, 6.746340973103764],
              [6.37471222501974, 6.737402093874931],
              [6.370718291374039, 6.700790575019463],
              [6.384988582524139, 6.682703555915062],
              [6.356343865868928, 6.691626821513314],
              [6.335321175690323, 6.691837984320826],
              [6.31624819590397, 6.725957322200756],
              [6.298840022078374, 6.7349642143319555],
              [6.277318529679339, 6.7560091477666315],
              [6.270956808004088, 6.775968976821123],
              [6.28087907620348, 6.787990787292345],
              [6.280235917898956, 6.81172015288928],
              [6.288634733075553, 6.8191603692699125],
              [6.2902317492148985, 6.845140474131763],
              [6.300269189839482, 6.878104047460823],
              [6.316431267312091, 6.902776794980903],
              [6.324212854514291, 6.921413333866149],
              [6.314154375393776, 6.950767675344444],
              [6.287727245704685, 6.968569403056023],
              [6.271369870274898, 6.954758556060519],
              [6.258684688464612, 6.932705352062147],
              [6.249165588091459, 6.924906773744083],
              [6.223471154296268, 6.926682482203868],
              [6.193978667377595, 6.922962641063846],
              [6.190722396897597, 6.915559134829094],
              [6.156514935085203, 6.930277804599792],
              [6.172138794982073, 6.956957001031978],
              [6.1771349575906935, 6.9786005229329815],
              [6.166588576241912, 7.002567321664553],
              [6.185021058526027, 7.025510730449015],
              [6.1980908459659165, 7.034835831888101],
              [6.209120654445223, 7.071453622169586],
              [6.201378547562673, 7.083829440360078],
              [6.198404818280619, 7.10868573461664],
              [6.175943687154709, 7.1278633049442295],
              [6.1776710928252125, 7.137286504588074],
              [6.200434693319855, 7.1326130333459945],
              [6.212930651685734, 7.173415976898087],
              [6.1850125640501155, 7.207561399129368],
              [6.17459871926365, 7.215036884549914],
              [6.17391293558743, 7.230499198513669],
              [6.201939807965346, 7.243401351071478],
              [6.196489577230881, 7.256766429559893],
              [6.180418455753473, 7.268480416670437],
              [6.177277550937224, 7.279123274851663],
              [6.159390039508179, 7.283181353190255],
              [6.145908229906131, 7.292004828247522],
              [6.139679014813682, 7.309456825173185],
              [6.126594794303751, 7.318118096789689],
              [6.112661248730922, 7.315596995183836],
              [6.091816454563816, 7.3206647586459095],
              [6.080050713849095, 7.316031821771092],
              [6.051178199334454, 7.326428725886977],
              [6.054423453963893, 7.334042007478889],
              [6.0441738061305275, 7.35171705680338],
              [6.012427850896417, 7.34311217584702],
              [6.005566682394538, 7.3339349329985515],
              [5.974982708396613, 7.336059045245951],
              [5.963572610411861, 7.35282377860156],
              [5.9483992558438405, 7.357363074326961],
              [5.944350582382089, 7.3707906418257],
              [5.979965082960254, 7.414190065911271],
              [5.983531873283189, 7.425240270820583],
              [5.961466758734355, 7.432220992144882],
              [5.956521971068724, 7.447983611746929],
              [5.963492038473178, 7.4645251496606555],
              [5.9412643966314045, 7.468316232222718],
              [5.924848030357918, 7.482912322851012],
              [5.885365853410755, 7.490010919459829],
              [5.865049407006856, 7.4878255035607015],
              [5.855080938516113, 7.502246775873114],
              [5.823641973870168, 7.488161844756734],
              [5.803395864876846, 7.495323276051852],
              [5.7594735807717825, 7.5232893632779865],
              [5.754772791610406, 7.514485753797722],
              [5.735299844437728, 7.50514822107134],
              [5.712069261680308, 7.5176593983185045],
              [5.704436574111802, 7.526612158400379],
              [5.6856176283146915, 7.516747654300073],
              [5.6778919725680685, 7.520312390591213],
              [5.667612488412368, 7.543359313468486],
              [5.651577218494863, 7.544134401467626],
              [5.646153710223585, 7.536314888988857],
              [5.629078769560386, 7.5369171774454475],
              [5.613601139865993, 7.525160291756186],
              [5.602361117167874, 7.535316125864413],
              [5.595942648218091, 7.5065394526751374],
              [5.563366978664558, 7.504002630003357],
              [5.550443486664869, 7.528699068490202],
              [5.5071885802749305, 7.5390743195078915],
              [5.478806022557934, 7.526254825938003],
              [5.438606272914174, 7.536701686254529],
              [5.4297537321712435, 7.546115034018598],
              [5.342533355088922, 7.588461131861581],
              [5.255290290512489, 7.630773980906078],
              [5.231656937925606, 7.6350497717298245],
              [5.166291584822087, 7.648293913242336],
              [5.100920130028638, 7.661524295185387],
              [5.035542569707288, 7.674740903645592],
              [4.97015890023739, 7.687943724850563],
              [4.895694820029544, 7.703252424666823],
              [4.821222680537394, 7.718543150063931],
              [4.746742476519673, 7.733815880890813],
              [4.672254203106715, 7.749070597232104],
              [4.601352039381179, 7.764020513774418],
              [4.530442367726775, 7.778953991260012],
              [4.5302093877169, 7.801109306964067],
              [4.519046208086391, 7.8128873708476005],
              [4.508464236762084, 7.839270806203029],
              [4.500194252794262, 7.84882227280828],
              [4.494800664434234, 7.873548783119675],
              [4.484449856440247, 7.878485125601639],
              [4.454050613734317, 7.937527603299985],
              [4.42038336682707, 7.937552464178856],
              [4.406971965728906, 7.951628227893144],
              [4.38613765380314, 7.947748863345605],
              [4.386847148010582, 7.970704709228031],
              [4.371537271612874, 7.983557754709781],
              [4.359602448937115, 7.97020896322308],
              [4.348015771358887, 7.970189719246841],
              [4.330447037708523, 7.960705539323517],
              [4.311393207447987, 7.992702401520623]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.43911234809995,
          "lat": 44.350481001136515
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779789"
      },
      "bbox": [
        4.311393207447987, 3.4115212082293382, 10.31480304250046,
        9.677617500935861
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.830872703699372, 0.4500269229077461],
            [10.850041925446517, 0.4357359893885197],
            [10.882329573316364, 0.44038042961871543],
            [10.913519198852443, 0.457996075222827],
            [10.951888792875488, 0.47574022708812685],
            [10.97320181096008, 0.48825802153002956],
            [10.9855417684244, 0.48494346584696296],
            [11.022289823444762, 0.49697794293180775],
            [11.033859575080697, 0.5071419502538126],
            [11.042217381979386, 0.5563486186074309],
            [11.03935700449634, 0.5833541778189164],
            [11.042657634425362, 0.5994438721324052],
            [11.040152395662862, 0.6404021959519233],
            [11.051041389951367, 0.6569831383451863],
            [11.072019886691745, 0.6649345864205356],
            [11.091284089484642, 0.6605006151245827],
            [11.11634022056197, 0.667836260312958],
            [11.123859794342655, 0.6779170992290859],
            [11.124592576524469, 0.7006786448187136],
            [11.102247109592373, 0.7529174634676792],
            [11.104518588098776, 0.782228383985843],
            [11.08481566979815, 0.8292860629990663],
            [11.069714939021402, 0.8379205328562442],
            [11.065226720224013, 0.8651503097495437],
            [11.082314552645961, 0.8875003040351971],
            [11.103525721739372, 0.9002952059193933],
            [11.113952482821626, 0.9179959660006423],
            [11.114658654410322, 0.9431400231965652],
            [11.107340753847298, 0.9609007054015976],
            [11.106800978433384, 0.9757187805865689],
            [11.12575175376922, 1.013707169844561],
            [11.125822749572528, 1.0269826417634307],
            [11.136587907393741, 1.059587032379312],
            [11.162437229104391, 1.0821779278285277],
            [11.168598695503452, 1.1131787832503965],
            [11.179342920815879, 1.1203949313970931],
            [11.201372447024067, 1.116619523151027],
            [11.219119607447325, 1.0888440278978586],
            [11.238423974822334, 1.0951371756138844],
            [11.253573727712014, 1.0888484252657915],
            [11.285848727867982, 1.042643909976062],
            [11.288168452324651, 1.0304704015461994],
            [11.271396683463601, 1.0033736697125986],
            [11.272617259870877, 0.993645743228125],
            [11.287150970189387, 0.9832515850050916],
            [11.303973383716023, 0.9806463074483944],
            [11.324706452896102, 0.9999919954482144],
            [11.3308542988259, 1.012364179402212],
            [11.329934519737227, 1.0401342197379526],
            [11.337574823882907, 1.0565431517552355],
            [11.350367845090984, 1.0609878421819947],
            [11.375148619177335, 1.0443254589460396],
            [11.39474752458962, 1.0469082233406348],
            [11.396528055274777, 1.0550556210455513],
            [11.375861005116914, 1.0747524586956225],
            [11.372234511771747, 1.0834377966915816],
            [11.378026471380789, 1.1357063347383918],
            [11.369840366078956, 1.1455990189483016],
            [11.343403349287499, 1.1635636491733814],
            [11.335303023293317, 1.1744925355693456],
            [11.334528151310291, 1.1992826540741237],
            [11.359928044047276, 1.197391049377695],
            [11.375833222615105, 1.2115303607598293],
            [11.379527854786117, 1.2395480330016067],
            [11.372879910453596, 1.2708382950686357],
            [11.35969363588185, 1.2983098935679334],
            [11.372351996292316, 1.319608753737768],
            [11.3779772816393, 1.34112021278755],
            [11.401303983285132, 1.3563306782490587],
            [11.393076982313726, 1.3847766535872397],
            [11.404229772288408, 1.4035363016470772],
            [11.420508040665798, 1.4096841074667812],
            [11.447477452776935, 1.4099998222351997],
            [11.456888482663658, 1.4138849370112843],
            [11.487091755411287, 1.4099550902533549],
            [11.485853935756728, 1.48235535288853],
            [11.495208479631616, 1.498183553681454],
            [11.521730202756359, 1.5230487894417737],
            [11.540297603250647, 1.553398751240712],
            [11.551791856056987, 1.5644652518338016],
            [11.573195127131337, 1.5637860399878296],
            [11.592469354272298, 1.5491166343450882],
            [11.605672194795089, 1.5179343537067187],
            [11.622895027940668, 1.5064528209547483],
            [11.643758480347957, 1.513850219634529],
            [11.677193065908158, 1.5482704627588586],
            [11.695672648622738, 1.5629359727419194],
            [11.716834179873091, 1.570699296782348],
            [11.73130309003972, 1.5686605363304205],
            [11.752768688183858, 1.6176550056410224],
            [11.763017799874367, 1.6278909994053452],
            [11.789447728198505, 1.6380788873478949],
            [11.801223236858169, 1.6615928036706695],
            [11.80820287085418, 1.684045149186601],
            [11.826487467035745, 1.7163738198334173],
            [11.855978695300669, 1.758155772613651],
            [11.875758397541507, 1.7806495652801617],
            [11.890298743810128, 1.8022476124143734],
            [11.914368248689508, 1.8313084306924403],
            [11.953314569849178, 1.8435645286209443],
            [11.958540198753314, 1.8770069558473568],
            [11.953753928797777, 1.9108425824161042],
            [11.955687358969634, 1.9184489575187886],
            [11.975055808898182, 1.9316478719661447],
            [11.974247146466451, 1.9478430449182624],
            [11.96036879433179, 1.9643464901318748],
            [11.943418959762774, 1.9773975432297746],
            [11.94162917389113, 1.9995306907655261],
            [11.965670887067564, 2.0272874675860644],
            [11.966494166633465, 2.0408278987060045],
            [11.958095348116368, 2.0700713163104627],
            [11.964181040001929, 2.082672454276517],
            [11.979954091688317, 2.096164735961951],
            [11.976249287429276, 2.1150144452225557],
            [11.961690248792891, 2.133547539867835],
            [11.963409156524646, 2.149694981534828],
            [11.979080539919698, 2.1505877574290206],
            [11.991227958761367, 2.1448667536956085],
            [11.999369741758679, 2.1532437602329275],
            [11.98809627974623, 2.1821181604824003],
            [11.990547125169124, 2.1954255680289414],
            [12.00247996826545, 2.2091564577570435],
            [11.995420009975922, 2.243612461288372],
            [11.996740664952547, 2.2882926358253477],
            [11.986699302907095, 2.313735383421382],
            [12.004094979435783, 2.340965281249892],
            [12.004887737669888, 2.3526359362092655],
            [11.99795394667312, 2.3795377080063376],
            [11.999352437951213, 2.3966293068522515],
            [12.008822141814768, 2.4255221209542603],
            [12.019374574450193, 2.4456864267338037],
            [12.019389112001294, 2.476458588339056],
            [12.028558883880159, 2.499880561604579],
            [12.043352103784562, 2.5130149587918402],
            [12.044115058925815, 2.5439821735536983],
            [12.051124313675498, 2.571373461639385],
            [12.036623670439534, 2.599643035510007],
            [12.036938502303638, 2.6220587567742575],
            [12.01738646275744, 2.6457251074553376],
            [12.028230209940004, 2.6556624009370817],
            [12.023163944505196, 2.689451064058613],
            [12.02941692648853, 2.71150468553041],
            [12.02480842954946, 2.7354612842953547],
            [12.007645480301859, 2.752552430540526],
            [11.995093575755044, 2.784955945258948],
            [11.959651981628758, 2.817846787738127],
            [11.959980321114157, 2.836208119983583],
            [11.981674920566059, 2.8686629139505566],
            [12.001905242392713, 2.877400405592308],
            [12.020061964044274, 2.86909844151106],
            [12.030414128881745, 2.880444998862051],
            [12.058926407137232, 2.9005546949258045],
            [12.085939713865436, 2.7363829524777987],
            [12.088739406776849, 2.725405379026047],
            [12.107427328791585, 2.6055454216320206],
            [12.137227556507389, 2.4240826447179096],
            [12.173563378568563, 2.2024846565574534],
            [12.208772513519158, 1.9879362656961566],
            [12.366593939844414, 2.013892875710069],
            [12.542071970722152, 2.0434193440654673],
            [12.709738530141058, 2.071309054919308],
            [12.850952514650567, 2.096003585433765],
            [12.992170407303297, 2.120675400225142],
            [13.02357862537608, 1.9322190728730115],
            [13.020944670312936, 1.9317568654811448],
            [13.052140674749667, 1.745272893846129],
            [13.06089921260204, 1.6808652620756017],
            [13.074396527561705, 1.6074438532779558],
            [13.087697440608444, 1.6074968132717238],
            [13.108013347978199, 1.6247370736890796],
            [13.117721298592155, 1.6378169669462448],
            [13.135657671381587, 1.6754624488128598],
            [13.144514043699468, 1.6872680700002127],
            [13.162342170620397, 1.6967941001248572],
            [13.166716684257494, 1.7134470496623762],
            [13.187129255337588, 1.728178955886261],
            [13.206536347039066, 1.7264387009090445],
            [13.20853301189414, 1.751108398352716],
            [13.226927459731739, 1.770810978882407],
            [13.22736747727865, 1.7878595699104112],
            [13.239190792367975, 1.799118718663519],
            [13.252478282012271, 1.800372588852446],
            [13.260948831921143, 1.8276240479922496],
            [13.270722177055667, 1.8259393006511155],
            [13.286897101218393, 1.8356059732459167],
            [13.281849251814172, 1.8439596740012079],
            [13.292129060620637, 1.8597018376455494],
            [13.3076102174012, 1.8655818098238186],
            [13.304958666719974, 1.877469478742729],
            [13.331955926545167, 1.9252021804603898],
            [13.369772069798277, 1.9283024131865307],
            [13.432768714203364, 1.911497192277735],
            [13.432018923035388, 1.9261663035729266],
            [13.441907827208532, 1.960233864980392],
            [13.454724400061048, 1.962933375465116],
            [13.46770395017737, 1.9921683932826355],
            [13.479599778573649, 2.004439190788166],
            [13.49870603648975, 2.053746212461526],
            [13.51280230328719, 2.0494650734267394],
            [13.504224492991584, 2.076829807213599],
            [13.523579017262731, 2.0989321832687997],
            [13.515427568278303, 2.1185186192120646],
            [13.521571026980446, 2.1307158046727497],
            [13.535559807747243, 2.13184071491683],
            [13.534660992271604, 2.1161145277634184],
            [13.545940977229206, 2.1152939005491826],
            [13.555612073884902, 2.1246198239592817],
            [13.568923462210833, 2.1144162057085207],
            [13.544085031488525, 2.104500803801767],
            [13.5378931723521, 2.0958395882392438],
            [13.548416022963524, 2.0835356281787156],
            [13.56568523436521, 2.0785553331176683],
            [13.573739208371947, 2.0872883148692125],
            [13.584605974105148, 2.066058331230467],
            [13.609387905100682, 2.0596166921348114],
            [13.614640192310151, 2.0529097865536037],
            [13.641814412288056, 2.046555847491482],
            [13.66568437477477, 2.0559036930420205],
            [13.69031684901523, 2.052563999895116],
            [13.71227962429423, 2.0439394463240865],
            [13.744758561724636, 2.0554541025787794],
            [13.759556396835162, 2.051908015632731],
            [13.78586598079146, 2.0548969448443337],
            [13.79563722950959, 2.0784310834190562],
            [13.81834417561278, 2.0946362022581595],
            [13.785921484473421, 2.113943016380711],
            [13.781391983678171, 2.1264992786839985],
            [13.791207921321533, 2.1322061284684457],
            [13.819914469749328, 2.1246807868760493],
            [13.825676541862336, 2.1377036527097886],
            [13.805883127230272, 2.147290895005991],
            [13.793348387260785, 2.1604186039391213],
            [13.802086145833979, 2.1679643257159054],
            [13.836811978048452, 2.158206703502283],
            [13.830610586802315, 2.1714817754111233],
            [13.845258266549362, 2.1781308431384967],
            [13.850502509118563, 2.193931188737016],
            [13.918341254495434, 2.1844573916693877],
            [13.923921300012246, 2.2073442283347906],
            [13.942343817885783, 2.2339390921515125],
            [13.937208365747484, 2.2468399195607174],
            [13.955380514019724, 2.2508240467067013],
            [13.96703166384969, 2.2719776791592268],
            [13.97547393908384, 2.2740936921913795],
            [14.025595189949088, 2.2697836158190925],
            [14.050804336607866, 2.26097520257711],
            [14.0882037823868, 2.234065738656491],
            [14.11268274626612, 2.2062589645783346],
            [14.139488755592815, 2.2069389645898267],
            [14.148723410128303, 2.2179112845357793],
            [14.159368578438766, 2.2035289986898157],
            [14.170105309954756, 2.1998708221186396],
            [14.178534916742516, 2.219685634041963],
            [14.206068992643628, 2.2172745907052986],
            [14.205057639292404, 2.236013397383068],
            [14.24221271365306, 2.233272965889115],
            [14.251290234076212, 2.2195409946649183],
            [14.252535684166508, 2.1991996291770763],
            [14.247101109550131, 2.1912831556181547],
            [14.220059260767417, 2.1851993032866535],
            [14.216279065489347, 2.1726092793921654],
            [14.23615022354882, 2.1588404083485266],
            [14.238070532884754, 2.1415897410754416],
            [14.268591984727266, 2.146700411198926],
            [14.257074456679193, 2.125705274318894],
            [14.296355223102491, 2.1240538780118046],
            [14.30506364875774, 2.1354462747074616],
            [14.314378656944324, 2.1271213561054463],
            [14.297963522748246, 2.1163516833678027],
            [14.311658163669636, 2.0834240935477846],
            [14.309862285364764, 2.0660134367965757],
            [14.332384638604454, 2.06816568681471],
            [14.34106440997766, 2.0645339889687686],
            [14.360511062348339, 2.0318100302093742],
            [14.349582755898716, 2.020000466116359],
            [14.35993917449998, 1.996216547882199],
            [14.35139764494359, 1.9864304995036413],
            [14.356247612054835, 1.9756402309413381],
            [14.385953816308806, 1.9684806934736008],
            [14.376102209979065, 1.95741088144332],
            [14.370137007124097, 1.9383582923924145],
            [14.363185176021007, 1.8771610091568738],
            [14.351575726549616, 1.8475158736450983],
            [14.34983180118155, 1.810274896849798],
            [14.341511336057112, 1.7814596675263148],
            [14.34048675311383, 1.7654057807246542],
            [14.16100237013467, 1.8665999012073553],
            [14.051687123665621, 1.9269048724063704],
            [13.95967686167564, 1.9823245383807173],
            [13.886638285955508, 2.021639097559692],
            [13.89407308584704, 1.983623564374751],
            [13.887382032869214, 1.9668833994289117],
            [13.903944879753382, 1.945636076563014],
            [13.891644164789053, 1.9130258745534416],
            [13.912587970506667, 1.9110053599490475],
            [13.90452160674446, 1.872818910887982],
            [13.888556918226186, 1.8448367360464581],
            [13.870985101123393, 1.8046378398186362],
            [13.888270119278113, 1.7941704446300724],
            [13.886303815848702, 1.7805045845526557],
            [13.867510578937585, 1.7429821417546414],
            [13.89957071636067, 1.7175647488714658],
            [13.884491916581373, 1.6996262813925713],
            [13.87914695132933, 1.6774990332638373],
            [13.867191648343985, 1.6559713649471706],
            [13.853821478955677, 1.6498765832857956],
            [13.830248788816235, 1.6167017734092706],
            [13.797523732760077, 1.5594980693174711],
            [13.816305432525823, 1.5486829433560019],
            [13.798668484713355, 1.5171851011623974],
            [13.787400938403982, 1.488447003827073],
            [13.769861925089145, 1.5036768994708019],
            [13.75272614057184, 1.4856667462201203],
            [13.747093538983922, 1.463316782948666],
            [13.734915083112321, 1.4384283437570393],
            [13.729094462366048, 1.4368093126853587],
            [13.71159346186119, 1.4131145127803475],
            [13.701979914431673, 1.4386210217174047],
            [13.690251242286308, 1.4322366419426225],
            [13.679843598936014, 1.402871487806855],
            [13.660699815870634, 1.3835546920345252],
            [13.650677318881733, 1.3520157735260208],
            [13.645397921177741, 1.3251990555437358],
            [13.62119099540673, 1.2510156056598523],
            [13.510771751568264, 1.320346950756571],
            [13.506141356125532, 1.2932597093909362],
            [13.497150366194644, 1.2848656139599348],
            [13.495930370222363, 1.2581812859494035],
            [13.48126808094833, 1.2555368952631991],
            [13.480962171194472, 1.2354796903212624],
            [13.4694934001219, 1.2076683619758917],
            [13.462213150022729, 1.159998417755943],
            [13.471427131892217, 1.1454496091399082],
            [13.46970791359885, 1.1174465313620874],
            [13.448803021312276, 1.1144088741647873],
            [13.44182936609619, 1.1059790750044622],
            [13.430807597427137, 1.0609343281871135],
            [13.429636468391502, 1.031897759332158],
            [13.40772530095281, 0.9678813053702161],
            [13.40972501060498, 0.9358210546661855],
            [13.401134740186924, 0.9174256831404906],
            [13.391326074600286, 0.9088777873284561],
            [13.36915359570453, 0.8580980781961844],
            [13.346421554592625, 0.8414513963989656],
            [13.212902240164583, 0.8643846088484343],
            [13.165299868704752, 0.93464927849282],
            [13.150589452314414, 0.9494982569838482],
            [13.057961738989155, 0.9749568292812449],
            [13.0510814186148, 0.9521411731929293],
            [13.050574809468346, 0.9093231554656546],
            [13.061174917670385, 0.8976360306095804],
            [13.048049060485372, 0.8903375739495698],
            [13.040083391866157, 0.8721670504734593],
            [13.039935613042571, 0.8525859894426393],
            [13.052441408089102, 0.8294707580947528],
            [13.05460081472038, 0.8103370600754208],
            [13.04434383912084, 0.7924630523755505],
            [13.032465589532409, 0.7470081960646501],
            [13.038775888428278, 0.7383153295885372],
            [13.026309435271102, 0.7260576049133203],
            [13.0103168595575, 0.7259060510075864],
            [13.00729161632683, 0.7038825533261497],
            [12.99139725652075, 0.6887989772105797],
            [12.984168285460706, 0.6686588427400049],
            [12.997938225534963, 0.6558552939029278],
            [13.006896203400975, 0.6400512462771772],
            [12.985534034828035, 0.6107393578664291],
            [12.967451796215284, 0.5991567982088313],
            [12.935597022288917, 0.5455918196583427],
            [12.920282320247303, 0.5299979069401478],
            [12.926930201826858, 0.5133539488153069],
            [12.921171067844023, 0.4885519964833316],
            [12.910421003444325, 0.47833214492193904],
            [12.918335349853757, 0.45922948139018377],
            [12.928789081879662, 0.45643669348478505],
            [12.911791588445045, 0.4261307058336454],
            [12.910417140001522, 0.40878973690987197],
            [12.889624810763989, 0.3325969166340426],
            [12.860258405980069, 0.29147266845133885],
            [12.842732502888087, 0.2728767666380065],
            [12.829808795987338, 0.2460013287896609],
            [12.824769161688842, 0.2459685484434966],
            [12.800801035118925, 0.2047580606644851],
            [12.786444731466052, 0.19466778171863225],
            [12.774058660538532, 0.1543085489164517],
            [12.753865622509883, 0.12229379948815607],
            [12.748382891794504, 0.10350626667807479],
            [12.749974292402127, 0.0894117619692063],
            [12.731686769905119, 0.04543013629660774],
            [12.741400716576038, 0.03834014118039351],
            [12.719853044148707, 0.0005231167694284644],
            [12.713640416555066, -0.0052429470165962395],
            [12.732369908280209, -0.037649273920477254],
            [12.743410217433992, -0.0470356567555255],
            [12.766599779354944, -0.05179517596647308],
            [12.782409437827539, -0.0592891382863158],
            [12.770957526630093, -0.08250951837899488],
            [12.7584372297625, -0.0963387610239439],
            [12.709750656278919, -0.1363831412353571],
            [12.72522479195639, -0.15231135853551367],
            [12.71300758079983, -0.16457707408664138],
            [12.730714173563149, -0.17070211932127402],
            [12.750579975593693, -0.16110780981837125],
            [12.741291020469967, -0.18850277744614158],
            [12.696851528416772, -0.2248351147138369],
            [12.653368788260709, -0.2628739943826564],
            [12.619048571296066, -0.2960977141500755],
            [12.602109908752688, -0.28648315101098715],
            [12.599853350136431, -0.263645613579678],
            [12.58165379850359, -0.24215795795456227],
            [12.551460085758281, -0.2554137827144456],
            [12.518562381918573, -0.2888259567278374],
            [12.445424830079473, -0.35348440716565516],
            [12.398622088656328, -0.3838303468585139],
            [12.38408522455731, -0.36344688434344885],
            [12.365333007265333, -0.35672303008434214],
            [12.338718474454296, -0.34031280469610115],
            [12.322328875279332, -0.34018986940575546],
            [12.320291188513607, -0.356086056369286],
            [12.308841386645344, -0.38645281020300365],
            [12.34103378088475, -0.41914731759721174],
            [12.32718339206886, -0.4298977230974388],
            [12.306421857646065, -0.45733439420778366],
            [12.272633787470172, -0.4822988018221335],
            [12.248040989148322, -0.4894214445634638],
            [12.246958923893668, -0.47984359370117663],
            [12.20405012971003, -0.4989659036742577],
            [12.147222313685106, -0.5199796948410735],
            [12.107302803205114, -0.5422347078593605],
            [12.066462314835409, -0.5772730707336866],
            [11.982442533090225, -0.5245327498355998],
            [11.943765857877846, -0.49134285508592646],
            [11.93714840605732, -0.5118588045042839],
            [11.919629965791977, -0.5227264838108602],
            [11.911304391370223, -0.5622492957665638],
            [11.89521135310994, -0.5638667865159424],
            [11.87827924992561, -0.5752023405943921],
            [11.865257337103607, -0.5919260569746209],
            [11.847077765207272, -0.5932332972506447],
            [11.845787238797298, -0.6138780405042275],
            [11.819807563405616, -0.6299218230971882],
            [11.809342957517694, -0.6459254133078308],
            [11.71844009559674, -0.6650750950722253],
            [11.710044920334601, -0.6544804081816907],
            [11.685052264586027, -0.6422703544078134],
            [11.677565323485924, -0.6314332997332632],
            [11.66583289767004, -0.6354841821313509],
            [11.661554985176293, -0.6200086636042038],
            [11.642095657199368, -0.6008285735521407],
            [11.608206197957303, -0.5955175501048291],
            [11.59644321870485, -0.6039286713276899],
            [11.568764522452957, -0.5996196485456158],
            [11.565230947977671, -0.580884211866097],
            [11.543297205047311, -0.5614356642521311],
            [11.531090883476649, -0.5619670772576655],
            [11.524993150080412, -0.5516512361801211],
            [11.510383661062294, -0.5454167240533957],
            [11.49109001753226, -0.5184759607302359],
            [11.494333927858376, -0.5023816545822437],
            [11.488279849143051, -0.4814654644574684],
            [11.470600968698466, -0.45299277151246314],
            [11.455997110098538, -0.45424113229098484],
            [11.450384407043375, -0.4454019730083978],
            [11.43497780509958, -0.44274267806695683],
            [11.42928751898654, -0.42746942526445114],
            [11.442873606499075, -0.4173891237362161],
            [11.466154176729898, -0.3894174888929058],
            [11.463775375603376, -0.37690518765323805],
            [11.442383717567298, -0.3629145599698426],
            [11.439467614494799, -0.35470229437478373],
            [11.412426018780012, -0.3718123121152906],
            [11.395201165980605, -0.37029162514303054],
            [11.367670618873584, -0.37517614615966616],
            [11.358136211291619, -0.3580544341450198],
            [11.337661888322547, -0.36333813102345486],
            [11.332862512951081, -0.35650519259028307],
            [11.311855494214504, -0.36710615257699347],
            [11.30801225247869, -0.35641023963026025],
            [11.315285495549562, -0.34253738197771955],
            [11.306658118086835, -0.3265393293827684],
            [11.287767725281935, -0.32986088282976733],
            [11.263352906258191, -0.29837479851123105],
            [11.238993100369836, -0.3039039970140301],
            [11.225096888436314, -0.2774893749092981],
            [11.212768809680844, -0.2706389686672653],
            [11.200514105503478, -0.2773410875239569],
            [11.187924431223696, -0.2719964953054909],
            [11.165981791277616, -0.2523361084926233],
            [11.145285205568102, -0.21925093803116846],
            [11.14198573853033, -0.2079827505014529],
            [11.128319122987227, -0.19958150867251964],
            [11.136439984637944, -0.18447628035413016],
            [11.12518878347837, -0.17773710009307095],
            [11.11714895485911, -0.1574960956680822],
            [11.08718197585871, -0.14553061352661917],
            [11.067106032961343, -0.12841018098780008],
            [11.042445618001551, -0.08882688877875075],
            [11.039022492821772, -0.0661205041255729],
            [11.01289816412916, -0.04739081551132637],
            [10.983682219430754, -0.04050240432395325],
            [10.970846055494409, -0.028575387508985903],
            [10.990813367682984, 0.000809015669936872],
            [10.991784779592539, 0.027130377774044652],
            [10.97763599355645, 0.024463594710330036],
            [10.971435906137001, 0.03876260695443581],
            [10.951948253437509, 0.03622917837283194],
            [10.939263753832668, 0.06214141772934616],
            [10.927797588639843, 0.07170072788934036],
            [10.913293931779153, 0.10372096956239678],
            [10.885171680959864, 0.1199809488936198],
            [10.88157195953625, 0.13613567168625582],
            [10.850665885041364, 0.15724154355962874],
            [10.837220562423495, 0.1625318058164138],
            [10.831335789191943, 0.1944003386330535],
            [10.852634685498591, 0.19786013929675497],
            [10.858252778054958, 0.22485186700590626],
            [10.85607643990247, 0.2451067704400952],
            [10.842795284710949, 0.26072434245796533],
            [10.84532565980946, 0.27273258629706054],
            [10.861600726512709, 0.2746769152691361],
            [10.867786962241036, 0.2941774294158447],
            [10.857352564873485, 0.3299955506791999],
            [10.86285585446941, 0.34393731071898365],
            [10.857237611818345, 0.35820907645865935],
            [10.838332051587361, 0.37264367854828384],
            [10.836781790808573, 0.40849751285271085],
            [10.830872703699372, 0.4500269229077461]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.61418958772357,
          "lat": 38.642337589421246
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779805"
      },
      "bbox": [
        10.830872703699372, -0.6650750950722253, 14.385953816308806,
        2.9005546949258045
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.377508398018282, 11.130280440451847],
              [-17.366112320312375, 11.145763950294546],
              [-17.369485082160402, 11.16189511946912],
              [-17.354993856979217, 11.179891481500986],
              [-17.3449665099467, 11.212418352685967],
              [-17.32705250428434, 11.234779010637459],
              [-17.31519123854829, 11.238766124790596],
              [-17.30355449988808, 11.263830001738457],
              [-17.28979777367275, 11.252262232639485],
              [-17.29932214893184, 11.2380933460885],
              [-17.287473557785397, 11.214066877215211],
              [-17.297362592220605, 11.203690402755562],
              [-17.296879919058753, 11.17335249573937],
              [-17.305244246383424, 11.168933910379197],
              [-17.301052000114286, 11.152672558964749],
              [-17.280691529102462, 11.14408071502202],
              [-17.26953655074634, 11.13025390237129],
              [-17.28899976077531, 11.128443048383662],
              [-17.31788608731976, 11.12034029351846],
              [-17.334569271661394, 11.102427205198435],
              [-17.347602125480243, 11.113941569970265],
              [-17.33232665297817, 11.13399225424006],
              [-17.344350296779655, 11.1424270413897],
              [-17.363791007212324, 11.09735102447814],
              [-17.379811165618616, 11.104964963738253],
              [-17.377508398018282, 11.130280440451847]
            ]
          ],
          [
            [
              [-17.336452861684442, 11.427253483659792],
              [-17.314270235566926, 11.43986973480172],
              [-17.306063487375635, 11.466105094537069],
              [-17.295943201782624, 11.474067016582458],
              [-17.285541502244946, 11.454206107360529],
              [-17.272103225893108, 11.455180961152173],
              [-17.271211798602838, 11.440439638783397],
              [-17.280835449380632, 11.419293414645255],
              [-17.27868562687037, 11.407303607790437],
              [-17.287912432848927, 11.393752800454655],
              [-17.27835989324621, 11.380466489052994],
              [-17.289883808843776, 11.368136177671802],
              [-17.294022524447275, 11.349091780897878],
              [-17.287748272008336, 11.335733777636122],
              [-17.303825506486035, 11.329018764079478],
              [-17.316094291483335, 11.332552544202356],
              [-17.320670262682427, 11.354758288868947],
              [-17.34456346538425, 11.365855250620408],
              [-17.33332452430314, 11.40652560648635],
              [-17.336452861684442, 11.427253483659792]
            ]
          ],
          [
            [
              [-17.13435560104078, 12.264507087739783],
              [-17.125697464511543, 12.274056491542495],
              [-17.124130992749738, 12.296297362259338],
              [-17.08652390734852, 12.25021406037471],
              [-17.089758950556934, 12.232180078057997],
              [-17.103154340391885, 12.243588108268629],
              [-17.132198960575963, 12.240638985087266],
              [-17.137842868753488, 12.254400243890691],
              [-17.13435560104078, 12.264507087739783]
            ]
          ],
          [
            [
              [-17.494251939179993, 11.07952246229617],
              [-17.48142335794647, 11.074609742731518],
              [-17.452092585504715, 11.027663811518753],
              [-17.466461632495186, 11.01177637248738],
              [-17.495214133600637, 11.073673416061798],
              [-17.494251939179993, 11.07952246229617]
            ]
          ],
          [
            [
              [-17.14391500497803, 12.33977431770261],
              [-17.125384560570126, 12.343433196421994],
              [-17.120774519961163, 12.332515827092232],
              [-17.12621987230228, 12.321686819908077],
              [-17.14391500497803, 12.33977431770261]
            ]
          ],
          [
            [
              [-17.128353619195337, 12.446491499170545],
              [-17.11276307814651, 12.454133213647154],
              [-17.099876007854427, 12.415420457843236],
              [-17.101139386583558, 12.404425688461309],
              [-17.089776048386796, 12.395189162395104],
              [-17.078314165467955, 12.37119264726299],
              [-17.078604837926875, 12.350921244741887],
              [-17.09443381401555, 12.356747764976816],
              [-17.111042331511037, 12.39053806654337],
              [-17.114342330337543, 12.42231506060137],
              [-17.13021763053853, 12.432136591834169],
              [-17.128353619195337, 12.446491499170545]
            ]
          ],
          [
            [
              [-17.550835793295228, 11.025366662943632],
              [-17.529701138909747, 11.043343233603764],
              [-17.513439969120594, 11.038948554751979],
              [-17.497280113089865, 11.01858910911625],
              [-17.497201929834254, 11.003533012094623],
              [-17.523071393309372, 11.000943713660917],
              [-17.545537037089087, 11.015348574179816],
              [-17.550835793295228, 11.025366662943632]
            ]
          ],
          [
            [
              [-17.18029972018171, 12.313693992133723],
              [-17.165292375071846, 12.327846083372265],
              [-17.1547214130492, 12.330950059730332],
              [-17.151231051247873, 12.308618975185867],
              [-17.138968631160985, 12.28337304418998],
              [-17.16017792538508, 12.277183504674253],
              [-17.15379826448874, 12.266295277317353],
              [-17.180873859731427, 12.26919519689441],
              [-17.174501070079646, 12.291448427568556],
              [-17.18267765544285, 12.303203452893117],
              [-17.18029972018171, 12.313693992133723]
            ]
          ],
          [
            [
              [-17.575051346516418, 10.979026587745915],
              [-17.5639056798552, 10.981641225211366],
              [-17.55742142203022, 10.995794931370327],
              [-17.535506861192186, 11.002331145994937],
              [-17.52510969079859, 10.98482840340756],
              [-17.535155218548464, 10.954422913341972],
              [-17.54735993775729, 10.959699071622184],
              [-17.55223191349521, 10.94292291097504],
              [-17.56307281748857, 10.947810455896088],
              [-17.575051346516418, 10.979026587745915]
            ]
          ],
          [
            [
              [-17.297587391756785, 11.986700366988325],
              [-17.27741700527937, 12.013794183253731],
              [-17.25883169425427, 12.02807078620774],
              [-17.24591593870426, 12.049473665378187],
              [-17.20056125696258, 12.087497226095861],
              [-17.18936302516235, 12.104636761977872],
              [-17.18187342454628, 12.129412349821767],
              [-17.16798613830933, 12.1295109377491],
              [-17.156142992335376, 12.12114174606217],
              [-17.14371813248914, 12.128805488328846],
              [-17.132300582336935, 12.109079587171978],
              [-17.13564861378524, 12.086290429144977],
              [-17.15067984285816, 12.076353401853702],
              [-17.125056048511297, 12.053623538022746],
              [-17.104926008695365, 12.015637691681743],
              [-17.11208615383645, 12.001033611297563],
              [-17.12821340843041, 11.994350081239908],
              [-17.145982991857895, 11.99894774491251],
              [-17.153151998035785, 12.0139058222022],
              [-17.168140337286978, 12.021544464805473],
              [-17.18149592583243, 12.021122706902474],
              [-17.19251103776973, 12.001285995851488],
              [-17.211524815388007, 12.000257741766625],
              [-17.22106618866212, 11.982199027540522],
              [-17.234647516221862, 11.980120143559777],
              [-17.269349441986098, 11.983688312299615],
              [-17.269880819000576, 11.964985836967543],
              [-17.249329919337267, 11.96770732463466],
              [-17.207517061249273, 11.956150336279066],
              [-17.196745358818212, 11.93689410271552],
              [-17.190980149927153, 11.911031074219226],
              [-17.19408682275087, 11.888946051678381],
              [-17.18866506565802, 11.876349071905016],
              [-17.190422395154318, 11.845819646462594],
              [-17.203913456968046, 11.833720673786074],
              [-17.199482363014795, 11.80748902405073],
              [-17.202263089640436, 11.784387819437496],
              [-17.196795004670363, 11.77931148791667],
              [-17.201919909817445, 11.756446812669582],
              [-17.19078855991402, 11.749552498695266],
              [-17.180664911043202, 11.76420820463015],
              [-17.181093911264085, 11.77812648777498],
              [-17.171887620382346, 11.797635227321244],
              [-17.17537885952306, 11.820050992605262],
              [-17.153778189503637, 11.811679786959747],
              [-17.14413244727423, 11.791620909293076],
              [-17.137000218242584, 11.766688397060689],
              [-17.112605215409562, 11.74211760260539],
              [-17.095617254626607, 11.735075198290586],
              [-17.10165089250585, 11.697218636816322],
              [-17.09492283510587, 11.684418937585905],
              [-17.101115095799273, 11.654592728377354],
              [-17.110651585347625, 11.64127636175136],
              [-17.12608755043953, 11.6317242605137],
              [-17.129056674172045, 11.618962344075873],
              [-17.13980843220219, 11.617359666510962],
              [-17.162720505577656, 11.635847803833446],
              [-17.168925353025767, 11.6502837176384],
              [-17.15994523756632, 11.669614297163383],
              [-17.160708584229983, 11.681253469991612],
              [-17.17430267969692, 11.711983720551673],
              [-17.189598064020394, 11.713521056571777],
              [-17.206398244842216, 11.70399656648662],
              [-17.224593271972896, 11.703262160391768],
              [-17.224553077974008, 11.713486895868073],
              [-17.214131429122574, 11.726372916461706],
              [-17.22240711279023, 11.742338543099269],
              [-17.235455356432677, 11.749929473236149],
              [-17.24089366347249, 11.766990754522592],
              [-17.23139726223934, 11.795179948521326],
              [-17.239262592745824, 11.814024834017438],
              [-17.21871745044389, 11.846435731093585],
              [-17.21443711821375, 11.870095606388164],
              [-17.215641296251924, 11.891278821490229],
              [-17.234994248142883, 11.904936540809176],
              [-17.257563953320485, 11.901219024569768],
              [-17.25829843505602, 11.922220964087543],
              [-17.269184447231105, 11.94438728102347],
              [-17.282628010638035, 11.954635146798376],
              [-17.296493787852846, 11.974074656472194],
              [-17.297587391756785, 11.986700366988325]
            ]
          ],
          [
            [
              [-17.241920924304868, 12.318585831254898],
              [-17.2244409379975, 12.330092258749374],
              [-17.214110385604823, 12.318334892238473],
              [-17.205891213586256, 12.298889818900665],
              [-17.209625912801112, 12.289234969799567],
              [-17.229044296146593, 12.276615221326173],
              [-17.23824133425955, 12.276066693984452],
              [-17.244463865414623, 12.301182373892601],
              [-17.241920924304868, 12.318585831254898]
            ]
          ],
          [
            [
              [-17.341775862185933, 12.251527574296674],
              [-17.32194945735335, 12.285861269955005],
              [-17.31019175046681, 12.28806610570661],
              [-17.305257655628086, 12.314556230874274],
              [-17.284263405164204, 12.316190948204692],
              [-17.273332006043837, 12.308968533823204],
              [-17.26773260323689, 12.295499834452247],
              [-17.28148439684785, 12.268177475013697],
              [-17.287393322936385, 12.26446389171442],
              [-17.28070044305997, 12.234006651184886],
              [-17.272152403279094, 12.22368134997501],
              [-17.267174751846476, 12.255823011685038],
              [-17.253952031082807, 12.272440517041584],
              [-17.230415596107324, 12.267861171626652],
              [-17.22928704634743, 12.252218112796788],
              [-17.24305895413779, 12.240177865585707],
              [-17.25570802239219, 12.23717484135994],
              [-17.26520986955937, 12.21212602508898],
              [-17.263393658066825, 12.181317120884534],
              [-17.27867756361102, 12.176129752730711],
              [-17.28586255952784, 12.189259742007861],
              [-17.298571106373885, 12.180830455964324],
              [-17.313502957867062, 12.191700638659142],
              [-17.29852496474193, 12.200796226846265],
              [-17.323918341427262, 12.214682230122042],
              [-17.334016758844083, 12.232008576910513],
              [-17.346377016839437, 12.232827227541193],
              [-17.341775862185933, 12.251527574296674]
            ]
          ],
          [
            [
              [-17.356685400139302, 12.368954849335939],
              [-17.351191315684446, 12.362950203932858],
              [-17.33173641987246, 12.364965641123385],
              [-17.308664653243426, 12.351210943304475],
              [-17.29435056995508, 12.348095735385368],
              [-17.287778410648382, 12.334784498302064],
              [-17.302595861136368, 12.32551776143393],
              [-17.33514132721199, 12.321499027597923],
              [-17.346343991678776, 12.332715285101468],
              [-17.3393350514725, 12.341678799680162],
              [-17.356685400139302, 12.368954849335939]
            ]
          ],
          [
            [
              [-17.35393676019645, 12.408183791350218],
              [-17.334002835432063, 12.427728472350678],
              [-17.312000980955585, 12.441411988825095],
              [-17.2954917121825, 12.44558665476549],
              [-17.27750202996237, 12.45905800520717],
              [-17.258153513596437, 12.465245731516804],
              [-17.23309397027859, 12.457093239250655],
              [-17.210781605781282, 12.437908775093314],
              [-17.189324947777955, 12.410719363490541],
              [-17.160020694505757, 12.385687549091468],
              [-17.171793293509012, 12.376091448463102],
              [-17.189989997377467, 12.370915508101255],
              [-17.214561378315796, 12.358524396933362],
              [-17.227973241815565, 12.358210510518354],
              [-17.239257535888125, 12.36765764749589],
              [-17.2426833986284, 12.386172302218133],
              [-17.25044651610818, 12.394536703925034],
              [-17.251204289452755, 12.409584864220802],
              [-17.243796855312905, 12.432439929810496],
              [-17.249066781824435, 12.443440886525018],
              [-17.26776104719979, 12.440192816111741],
              [-17.26474071691918, 12.423706495284245],
              [-17.269948151510505, 12.408446748486197],
              [-17.256155185785612, 12.388489766700692],
              [-17.256775983971405, 12.373259805698092],
              [-17.25072904380869, 12.361092368172574],
              [-17.26169506774213, 12.346483258921216],
              [-17.27153253930958, 12.343285364515276],
              [-17.297890621832593, 12.353467897155676],
              [-17.30987640082421, 12.362730157768107],
              [-17.309481068463487, 12.38401480936907],
              [-17.32076209085167, 12.411056794725777],
              [-17.328643534937353, 12.40571636890545],
              [-17.321451892599395, 12.378324266473978],
              [-17.33600289294061, 12.376659998869101],
              [-17.338797453378728, 12.38901653968159],
              [-17.357695638305145, 12.390090510264319],
              [-17.35393676019645, 12.408183791350218]
            ]
          ],
          [
            [
              [-17.35847572075329, 12.480332752685328],
              [-17.315132650088028, 12.490078654527851],
              [-17.3198695441525, 12.463317174358808],
              [-17.339601514513326, 12.452840881019025],
              [-17.341089015619296, 12.465084079343379],
              [-17.35847572075329, 12.480332752685328]
            ]
          ],
          [
            [
              [-17.28912975309653, 12.763659578120047],
              [-17.253918917701345, 12.753786610875007],
              [-17.252069714447767, 12.73505781059986],
              [-17.264361419546507, 12.731824945173178],
              [-17.293434920832272, 12.734252737864912],
              [-17.28912975309653, 12.763659578120047]
            ]
          ],
          [
            [
              [-17.474423018331123, 12.408121899210355],
              [-17.451859673811267, 12.428325081268625],
              [-17.438537358774404, 12.419194864211512],
              [-17.40401961341917, 12.415207898670225],
              [-17.407510712248712, 12.392420895855153],
              [-17.39295401098168, 12.381047838987907],
              [-17.375734397050532, 12.347820863191194],
              [-17.363783617646117, 12.342711880199898],
              [-17.357575924234446, 12.314162240300515],
              [-17.34106532829334, 12.310090118895632],
              [-17.346900642886208, 12.29585877257885],
              [-17.361231609760786, 12.29430751657931],
              [-17.37583655259761, 12.302408290776809],
              [-17.38464016041412, 12.281282896000706],
              [-17.38235959897942, 12.256186079718857],
              [-17.37245817373552, 12.245012484851973],
              [-17.354912376996882, 12.241210343116714],
              [-17.358934482905983, 12.229652308605608],
              [-17.407227041300633, 12.254042498390518],
              [-17.45641365835321, 12.304982904454796],
              [-17.466974236492266, 12.340003242294395],
              [-17.460782197430003, 12.356548045170756],
              [-17.466380958438943, 12.372383333176959],
              [-17.45927995635197, 12.383829623511545],
              [-17.474423018331123, 12.408121899210355]
            ]
          ],
          [
            [
              [-17.470419751507908, 12.497025633333502],
              [-17.456117433838696, 12.497881811901864],
              [-17.436763575143164, 12.486657224604295],
              [-17.419172660477535, 12.466339588660002],
              [-17.447175539161258, 12.465998184172248],
              [-17.46395772421442, 12.480802758582396],
              [-17.470419751507908, 12.497025633333502]
            ]
          ],
          [
            [
              [-13.394364304951525, 11.776285390775541],
              [-13.42114946871368, 11.65898421082036],
              [-13.44906761116855, 11.541078523095774],
              [-13.50471709452705, 11.304881233975491],
              [-13.532598221191245, 11.18260862860391],
              [-13.58999015307666, 10.950134544048002],
              [-13.62533814272638, 10.799686649675222],
              [-13.653151710484764, 10.678615547474696],
              [-13.709829664812435, 10.426145130592785],
              [-13.730237661449834, 10.3341976926713],
              [-13.777990188821239, 10.125620287421322],
              [-13.82377452694876, 9.92455684056673],
              [-13.874850292503766, 9.701085392241012],
              [-13.899771877959695, 9.590588318581467],
              [-13.96018767658383, 9.327076847302472],
              [-13.958293010687129, 9.319487179020676],
              [-13.975019909818236, 9.284118174641936],
              [-13.988861338690782, 9.272775577966085],
              [-13.988600784908217, 9.252780800447358],
              [-13.968993796103009, 9.238782457356452],
              [-13.971481468393481, 9.217955481316054],
              [-13.951966692670105, 9.191333512603629],
              [-13.959938220999668, 9.176582729273452],
              [-13.949153578332062, 9.158940829010634],
              [-13.947201585432278, 9.122912465009886],
              [-13.957641290319437, 9.10853894727516],
              [-13.957634110227652, 9.098668068211607],
              [-13.946452753503637, 9.081402896266573],
              [-13.938832929597472, 9.05518613465552],
              [-13.948198644126334, 9.0506758300337],
              [-13.953227224369513, 9.033054702033645],
              [-13.965678521098882, 9.023463923979076],
              [-13.97728996751204, 9.001375003851859],
              [-13.994530474067915, 8.997402479390384],
              [-13.994595997618463, 8.985957139029011],
              [-13.9809701372165, 8.978332514809768],
              [-13.974144947053112, 8.962219629658938],
              [-13.970128585761405, 8.918165774001952],
              [-13.970354314944897, 8.895086305804204],
              [-14.017460911068879, 8.907092860325736],
              [-14.136613512402583, 8.934618985336993],
              [-14.25577620460146, 8.962101749717604],
              [-14.34917288402684, 8.982460296176352],
              [-14.431198571750578, 9.002202249726636],
              [-14.51322935172644, 9.021923543458026],
              [-14.60762939484724, 9.044229968309773],
              [-14.702035863529442, 9.06650905794231],
              [-14.789677181044784, 9.086454725675388],
              [-14.915077974590126, 9.116263689270193],
              [-15.040490006254123, 9.146024321818594],
              [-15.115544006808504, 9.164096330657884],
              [-15.1906020885669, 9.182150987979165],
              [-15.26566422302479, 9.20018828766325],
              [-15.340730381661205, 9.218208223667991],
              [-15.371896221170873, 9.225059318909667],
              [-15.391296977907942, 9.208886062729135],
              [-15.406222029760867, 9.20223323236999],
              [-15.432012536114572, 9.197758043157483],
              [-15.457263263641334, 9.187902676032763],
              [-15.481874375302063, 9.183886849675437],
              [-15.512455266326414, 9.186048367321698],
              [-15.529984582714185, 9.190626190789537],
              [-15.568705228149337, 9.212407457641095],
              [-15.614490191376388, 9.216856687573937],
              [-15.645597235243681, 9.212785759216793],
              [-15.704629286925805, 9.223112279940683],
              [-15.732704995890018, 9.218865769784308],
              [-15.75700084411686, 9.22725768769174],
              [-15.784577865296155, 9.251278981883958],
              [-15.805574320148233, 9.250555284096345],
              [-15.82442236734502, 9.241094322236153],
              [-15.867816211835086, 9.202359113298357],
              [-15.940223714142139, 9.209089512720539],
              [-15.959823162022454, 9.216022194532261],
              [-16.03543266850763, 9.21541298194944],
              [-16.075739984152083, 9.221811595407937],
              [-16.156066679364223, 9.202343795445469],
              [-16.20718253615969, 9.203195592686557],
              [-16.229659333167945, 9.197544053032425],
              [-16.265954543149725, 9.170169251831176],
              [-16.315404222463126, 9.178107234930625],
              [-16.3496838770832, 9.176553499326078],
              [-16.403302531456937, 9.178392534459167],
              [-16.457511130043237, 9.187569885692682],
              [-16.471965820914797, 9.19704358031042],
              [-16.498401230680567, 9.243009160508436],
              [-16.517708918727756, 9.256414416599894],
              [-16.54745591241678, 9.26347792581665],
              [-16.574364597692643, 9.254504165339272],
              [-16.59187504015922, 9.244500968318071],
              [-16.666678236520475, 9.233946706448181],
              [-16.715585186559803, 9.231836425667812],
              [-16.749933006597665, 9.211705503548686],
              [-16.7627768955588, 9.2121431991344],
              [-16.779127627767465, 9.233230499224364],
              [-16.807906049420506, 9.232591316995467],
              [-16.822826853200862, 9.241535267107015],
              [-16.861432611872527, 9.25112866963465],
              [-16.87652901024885, 9.250395301641612],
              [-16.9067114986604, 9.233145773885369],
              [-16.918233952559603, 9.222554948343657],
              [-16.954147679707074, 9.228768449909357],
              [-16.9600505559015, 9.24082777400013],
              [-16.953942765841205, 9.273071086842949],
              [-16.95873295001043, 9.296239480036432],
              [-17.002847729042763, 9.324217060609389],
              [-17.01622673759806, 9.34100967232865],
              [-17.032143188213507, 9.350432106863794],
              [-17.056086921421283, 9.355009663807259],
              [-17.078442517864914, 9.350592742810063],
              [-17.117387647805185, 9.36979887160421],
              [-17.136689806400256, 9.394949106263187],
              [-17.158048595735032, 9.406569801393138],
              [-17.22990729839733, 9.403743297367427],
              [-17.25484349630095, 9.410983216522602],
              [-17.283846195596492, 9.408399728992336],
              [-17.3027368700728, 9.412782170469342],
              [-17.350633867020264, 9.438937695419522],
              [-17.391856276614952, 9.436472750707114],
              [-17.42127494255298, 9.421481733091738],
              [-17.42998321881668, 9.407176378791027],
              [-17.450842444639488, 9.40245688228408],
              [-17.464870787341578, 9.405706977577227],
              [-17.4730385020401, 9.396929042164418],
              [-17.50462850525403, 9.388404925951322],
              [-17.533769380640553, 9.389909081881635],
              [-17.57941589409585, 9.375941692348354],
              [-17.605473664074704, 9.3842076082372],
              [-17.63625685952603, 9.385803327558477],
              [-17.652075346647713, 9.376321254273384],
              [-17.688409013068693, 9.369661372782367],
              [-17.720490833850548, 9.374329922209],
              [-17.743866420868912, 9.385703433891214],
              [-17.752413469097228, 9.409844071468305],
              [-17.769151493913952, 9.421212154790009],
              [-17.81184310094287, 9.420552439366729],
              [-17.832024595859032, 9.441341445085902],
              [-17.876396094848246, 9.472816722741344],
              [-17.910027461141077, 9.493494031936045],
              [-17.93722161690795, 9.50336456203097],
              [-17.95583584850878, 9.517169651713804],
              [-17.976204838132066, 9.542869173655424],
              [-17.99101085245258, 9.553961201194223],
              [-18.004667614472947, 9.57119385217085],
              [-18.005381524104784, 9.595302498506006],
              [-17.99870428990056, 9.613094455588755],
              [-17.980721717166215, 9.643635709716396],
              [-17.974750400233862, 9.667314992717067],
              [-17.9742210766321, 9.689128387907289],
              [-17.983523895447938, 9.721944458692581],
              [-17.97958765622769, 9.736223514896468],
              [-17.96737669529769, 9.752412047083531],
              [-17.960403823955264, 9.774491562094925],
              [-17.964528024596255, 9.792716019016094],
              [-17.965615293383646, 9.82212135173084],
              [-17.95658424144047, 9.839718507115505],
              [-17.953861448807878, 9.868208526739634],
              [-17.96414569599671, 9.891466219911212],
              [-17.96715345927973, 9.92679191099516],
              [-17.977118844071125, 9.946861437865866],
              [-17.97330158373856, 9.975465817914161],
              [-17.97986948807914, 10.001362247101993],
              [-18.01304299723739, 10.032462759518813],
              [-18.03263131299622, 10.06778949345822],
              [-18.053819806615063, 10.086712922677778],
              [-18.058295237291595, 10.095422671186675],
              [-18.087473265751722, 10.12848630541784],
              [-18.09258613730529, 10.137735111123751],
              [-18.1251636817009, 10.150943465453434],
              [-18.160833132821196, 10.144444398071451],
              [-18.213324221419544, 10.131305454207725],
              [-18.273641640270892, 10.150429352111432],
              [-18.283981685397265, 10.161700491580586],
              [-18.30327362249369, 10.195146666464618],
              [-18.287471313530297, 10.239476932807861],
              [-18.294916725782517, 10.262634673861365],
              [-18.310718485997157, 10.287023865553499],
              [-18.32452932178959, 10.292986097378911],
              [-18.35873823281522, 10.290830594694793],
              [-18.402231950638367, 10.304510004113542],
              [-18.415389442573534, 10.313745170747143],
              [-18.43741745357628, 10.321884413959676],
              [-18.442180413785497, 10.329098947254145],
              [-18.436403040675877, 10.351498211118361],
              [-18.447313951995344, 10.363505725777346],
              [-18.463916481144242, 10.364880604635303],
              [-18.470344931413507, 10.354036266179627],
              [-18.48376208497096, 10.36139361242269],
              [-18.494813202136932, 10.347278100506754],
              [-18.505228295250404, 10.349873762158467],
              [-18.51598056260586, 10.363206239037549],
              [-18.535634185493983, 10.35385418742032],
              [-18.55830826878228, 10.351163426107101],
              [-18.5819119373163, 10.336923191178869],
              [-18.602678185755078, 10.34894595278446],
              [-18.621388520325993, 10.380852627179863],
              [-18.627586820072402, 10.411592748047758],
              [-18.634622908605362, 10.423622898268853],
              [-18.656101200492056, 10.436900687969251],
              [-18.676393088769995, 10.42678436168378],
              [-18.68184265569201, 10.403894819525922],
              [-18.7057199680522, 10.410920014848866],
              [-18.69859232012899, 10.429874696365335],
              [-18.68205555898262, 10.45610316923025],
              [-18.660603212092166, 10.510793331251488],
              [-18.628729655069613, 10.610734145629575],
              [-18.597186338177494, 10.74189914157291],
              [-18.580567971872057, 10.75212899769747],
              [-18.573637194232262, 10.735376657190589],
              [-18.58891775738046, 10.728553005074662],
              [-18.58077874310373, 10.687773903893191],
              [-18.597163460116843, 10.640480185133589],
              [-18.601262186981362, 10.621759339413183],
              [-18.61114406486935, 10.60859124634746],
              [-18.624688614653437, 10.53068507951788],
              [-18.6343541726413, 10.494933792178182],
              [-18.631095805790157, 10.486566221979517],
              [-18.608427315683205, 10.488207984640576],
              [-18.593560247094953, 10.482937708385931],
              [-18.581943899114712, 10.511728668916],
              [-18.592640424785454, 10.513235429606567],
              [-18.586970093449537, 10.542767236231786],
              [-18.59847646067065, 10.556096202591219],
              [-18.594294053901987, 10.575388561163237],
              [-18.58232000142131, 10.600639528064642],
              [-18.574636635825758, 10.587221477554593],
              [-18.576978272390953, 10.576886796764779],
              [-18.561212207387545, 10.561765411255706],
              [-18.554703028639604, 10.583016258384568],
              [-18.516043660624863, 10.598388222060937],
              [-18.506032053377794, 10.632451644763492],
              [-18.51303881386882, 10.637657281495574],
              [-18.517704208602233, 10.65631162100538],
              [-18.51646132148884, 10.675077889752433],
              [-18.529325201368625, 10.704187559012077],
              [-18.518514782548635, 10.724244645066749],
              [-18.494159760542026, 10.731255898485243],
              [-18.48180528014988, 10.756619762930752],
              [-18.474195813525267, 10.754800932242933],
              [-18.442623379494734, 10.765477464800112],
              [-18.417295599206238, 10.764194644487294],
              [-18.416262076352766, 10.777740874502134],
              [-18.441174532550512, 10.797735708451855],
              [-18.443446161968783, 10.818574773427592],
              [-18.458958776874933, 10.81943096931807],
              [-18.466576487273286, 10.801210928651807],
              [-18.490117503570808, 10.806868620911699],
              [-18.500106215462043, 10.820819779514446],
              [-18.51071725762308, 10.812272942857629],
              [-18.512929629623937, 10.791143720813185],
              [-18.528768001121456, 10.79852636498005],
              [-18.5369207106343, 10.814571017763267],
              [-18.545294164821303, 10.815499919969147],
              [-18.563054293687557, 10.837094033869661],
              [-18.574424598086196, 10.841861341699373],
              [-18.581396041560343, 10.855400092221496],
              [-18.57041002072754, 10.891150940584305],
              [-18.562822672209403, 10.942058809983898],
              [-18.561639216346453, 11.003025901845751],
              [-18.542409349631505, 11.013756395955502],
              [-18.533957141564795, 11.00012824806043],
              [-18.541387939839638, 10.96766911554987],
              [-18.532569472042226, 10.958674491111081],
              [-18.518138143403412, 10.963496672232127],
              [-18.508293330575704, 10.981835479549387],
              [-18.48132335528059, 10.98643663053865],
              [-18.47526879572213, 10.993796081080113],
              [-18.45727490030437, 10.997951198115382],
              [-18.439352167657592, 10.99194957104432],
              [-18.423810927017968, 10.994860983673462],
              [-18.3757383967863, 10.995429574285184],
              [-18.36028600708333, 10.99987329521482],
              [-18.36142356458626, 11.016106016802741],
              [-18.40120934681293, 11.032282267667993],
              [-18.418686398189113, 11.03428418757121],
              [-18.422999841679594, 11.048858291484084],
              [-18.444714147012473, 11.053742624023403],
              [-18.458161798470936, 11.07136614339198],
              [-18.446806096176847, 11.078560350211541],
              [-18.45303711797451, 11.107234057885714],
              [-18.475754044269863, 11.12518935265188],
              [-18.512419651103336, 11.136665010388736],
              [-18.527054889717625, 11.134399874718932],
              [-18.53753054022912, 11.12321118766225],
              [-18.53483807324425, 11.099980043794883],
              [-18.54341279877766, 11.073754572473668],
              [-18.54385569711862, 11.047896246769698],
              [-18.5639829368032, 11.040162154942813],
              [-18.57962648777783, 11.039935331786111],
              [-18.556941533627192, 11.101858009590392],
              [-18.533307294810147, 11.195333034879996],
              [-18.522277418059925, 11.2746805653572],
              [-18.51800951881548, 11.318435368335702],
              [-18.51572962329747, 11.388247273117036],
              [-18.52460843909308, 11.408010890904812],
              [-18.537394081969715, 11.414215376563911],
              [-18.5393911128258, 11.45760992645615],
              [-18.549952726460102, 11.468124820218984],
              [-18.543961988784535, 11.51175214911022],
              [-18.546553876014748, 11.517566924762649],
              [-18.53918327270146, 11.54377410932366],
              [-18.52776412447998, 11.597420206331188],
              [-18.514169680058824, 11.688417444669698],
              [-18.5099797907238, 11.73789294811562],
              [-18.50919456237046, 11.771462717732911],
              [-18.512139252561305, 11.798454967659078],
              [-18.507423227548827, 11.831704270068846],
              [-18.50797950268504, 11.853178097921095],
              [-18.51644546443638, 11.872941919350476],
              [-18.52613815670233, 11.88103362519643],
              [-18.52849214667232, 11.902499322686172],
              [-18.524741083626118, 11.921358555701193],
              [-18.5292423958342, 11.937217791357941],
              [-18.542350510675575, 11.950854452121344],
              [-18.55890976403931, 11.977755739455729],
              [-18.556808100505066, 11.986701375347742],
              [-18.566901429086936, 12.001425126782918],
              [-18.58444802917711, 12.012271042968226],
              [-18.59408479338002, 12.02787058864513],
              [-18.59682950958073, 12.044338154292593],
              [-18.591326739284618, 12.070588497991288],
              [-18.59846092723465, 12.084151263701889],
              [-18.59486882700238, 12.100197265298718],
              [-18.59551431808296, 12.129742145468706],
              [-18.58351291042193, 12.183873604515487],
              [-18.58478226157636, 12.204597073040663],
              [-18.57283738796422, 12.224498429366424],
              [-18.570257450015117, 12.239691053467364],
              [-18.57770956610798, 12.304639769672091],
              [-18.555730350394498, 12.312576211430965],
              [-18.538910573017883, 12.33604756755548],
              [-18.54051494603547, 12.364188535529332],
              [-18.52236535088326, 12.374209900253339],
              [-18.51339465945353, 12.39378289415165],
              [-18.513965109561788, 12.404250537189736],
              [-18.49734512112576, 12.411288480103885],
              [-18.483542109218885, 12.439241048209999],
              [-18.487651235219374, 12.450905374262643],
              [-18.499692239758993, 12.451963971771248],
              [-18.515484271727395, 12.499694104038982],
              [-18.50341584817834, 12.504748424711064],
              [-18.466249342243593, 12.494575563168157],
              [-18.455001503273955, 12.48573176910863],
              [-18.452289841312307, 12.471468994569669],
              [-18.441883632001602, 12.462718474077182],
              [-18.427333737558133, 12.465275855326476],
              [-18.41241031482115, 12.455004147966125],
              [-18.401016607948975, 12.433306300164462],
              [-18.39270209973861, 12.429911036615163],
              [-18.335285871993722, 12.363858729800988],
              [-18.31873804396867, 12.342489606358008],
              [-18.305364020915064, 12.341388507857054],
              [-18.29442049220438, 12.326344739907618],
              [-18.271044388653223, 12.311503869557466],
              [-18.2717369535452, 12.302002910219993],
              [-18.25298131214342, 12.292250402325044],
              [-18.24104546216412, 12.29900873336578],
              [-18.20900092426713, 12.270743437562864],
              [-18.18142255529944, 12.243377935145563],
              [-18.17656242999622, 12.235077620711875],
              [-18.159048586551272, 12.226052637084367],
              [-18.167739134137285, 12.21164585990402],
              [-18.149516877749964, 12.196739058530905],
              [-18.137494778397805, 12.180019796774726],
              [-18.09166364060519, 12.152851336767723],
              [-18.07339299074641, 12.149566887936452],
              [-18.06777929547136, 12.142229232218765],
              [-18.03656237117565, 12.133173187658157],
              [-18.025545189407875, 12.12362917071118],
              [-17.968283788221438, 12.10743356948151],
              [-17.920571492223214, 12.10567408155725],
              [-17.89809666799973, 12.094161036593695],
              [-17.881377350980078, 12.080504539573285],
              [-17.880553895241558, 12.068515637527142],
              [-17.853356997754215, 12.052980579600739],
              [-17.82308294767326, 12.060766040247758],
              [-17.80030340364155, 12.03432684734625],
              [-17.77032860066552, 12.028538833596015],
              [-17.750889804659106, 12.006058673412076],
              [-17.71952251462683, 11.992933920696103],
              [-17.705209439824085, 11.992546658872278],
              [-17.681019259181777, 11.981425660505947],
              [-17.66197074023124, 11.983313103217753],
              [-17.65086023895728, 11.97510857273664],
              [-17.631022390733953, 11.971532387201536],
              [-17.614333157341935, 11.97580678761349],
              [-17.569418310027864, 12.001984683986489],
              [-17.553945807237273, 12.007692090202896],
              [-17.557510573118723, 11.989645526729282],
              [-17.54031522961241, 11.97592837520586],
              [-17.529044306938466, 11.951234481588102],
              [-17.51865883434576, 11.94152099129143],
              [-17.51215393197058, 11.903111982829522],
              [-17.51923981011563, 11.892719541843073],
              [-17.519250900719168, 11.873979944283741],
              [-17.51360131405796, 11.851370396169457],
              [-17.49917168118594, 11.842008457439896],
              [-17.50096958685589, 11.869657185776738],
              [-17.49449074417776, 11.88343546763041],
              [-17.499910334131584, 11.899376254563325],
              [-17.469362106502103, 11.902638931999766],
              [-17.447103916169056, 11.898928243700354],
              [-17.42868608091014, 11.890515833668914],
              [-17.44437075984911, 11.866859807287266],
              [-17.441082687174866, 11.856160693733727],
              [-17.415692865861413, 11.837236646182761],
              [-17.414773040436934, 11.805822396169226],
              [-17.426954886120388, 11.786449775453514],
              [-17.41262507098825, 11.785863257740735],
              [-17.39881198844884, 11.795268680252553],
              [-17.385304216616728, 11.830629748279948],
              [-17.397081023665315, 11.839993513714871],
              [-17.407298417513406, 11.863644670527675],
              [-17.402753544000998, 11.896163022304037],
              [-17.36413801916488, 11.911543990859489],
              [-17.330134825258682, 11.910427574318922],
              [-17.31624668019822, 11.90640004797527],
              [-17.319096556679355, 11.89211218974757],
              [-17.314427802775082, 11.879906988034792],
              [-17.338559224510462, 11.874873888095475],
              [-17.356512424401963, 11.862068282485998],
              [-17.34642592307574, 11.83170152534037],
              [-17.34594605815915, 11.811589641054244],
              [-17.338107919842297, 11.798842433909964],
              [-17.32754207082857, 11.800715110998198],
              [-17.328781399770712, 11.815587783931703],
              [-17.311397361483234, 11.853001802912033],
              [-17.284484626429585, 11.857449562071569],
              [-17.285598311419125, 11.827336216689476],
              [-17.291940532470722, 11.798612612701634],
              [-17.28619587026753, 11.785710702710581],
              [-17.291026267105135, 11.772889382464122],
              [-17.303818843558204, 11.767690616328439],
              [-17.321950802219664, 11.790346901682174],
              [-17.329158244738498, 11.78738842189953],
              [-17.33004456772973, 11.753715933005934],
              [-17.322714532488618, 11.737134881205382],
              [-17.311705704765203, 11.732856230301614],
              [-17.310864928723586, 11.718991212179397],
              [-17.320400109623122, 11.706830058532429],
              [-17.31967348615175, 11.681135146860264],
              [-17.304913233741143, 11.67914314757048],
              [-17.31189755372012, 11.665010173755357],
              [-17.304578128378736, 11.64766459162079],
              [-17.29244706982871, 11.64454622239344],
              [-17.308187088329717, 11.626895474996404],
              [-17.319961648768643, 11.625623132179816],
              [-17.347198533002576, 11.63750191472785],
              [-17.345677650432716, 11.612556341957994],
              [-17.353203567070313, 11.601770213664668],
              [-17.374698440843616, 11.590730125654787],
              [-17.395184942586052, 11.592282269372532],
              [-17.401233816563664, 11.58570142908917],
              [-17.407881938023454, 11.560938572478571],
              [-17.420074513407997, 11.539978159046127],
              [-17.445697145625243, 11.51801553959415],
              [-17.45059860096413, 11.50045117043399],
              [-17.446804221344614, 11.48725039814718],
              [-17.476320156158756, 11.486337989768076],
              [-17.48507592132593, 11.495488961972484],
              [-17.47584129933347, 11.514908892167485],
              [-17.467089702714045, 11.517281637594508],
              [-17.455795558160336, 11.546218041275585],
              [-17.446525850188394, 11.55450316598469],
              [-17.426097019288736, 11.595271779463225],
              [-17.4301054114238, 11.633233056719238],
              [-17.445345024298504, 11.618506554813539],
              [-17.442675808976883, 11.60332003714776],
              [-17.452227331433278, 11.587334651903609],
              [-17.475253089523772, 11.58482470606582],
              [-17.468117888540633, 11.607205918979197],
              [-17.479462036221562, 11.60509959482819],
              [-17.484926733166777, 11.575930992011894],
              [-17.478220862817214, 11.566097792654192],
              [-17.48414085669376, 11.552567749482181],
              [-17.49697460336987, 11.553953588310128],
              [-17.50780538659667, 11.544570637053893],
              [-17.51929212293641, 11.52224808985911],
              [-17.516255072177184, 11.505337603914391],
              [-17.543183618094403, 11.487550209626649],
              [-17.545461498537318, 11.46856554681587],
              [-17.565943510616936, 11.47310947840816],
              [-17.573792467419175, 11.462524323647372],
              [-17.59882116083033, 11.451807847607297],
              [-17.62526038656227, 11.42962693826284],
              [-17.65743708802726, 11.393486377822896],
              [-17.672032188101596, 11.38672264284396],
              [-17.685697153900872, 11.361805338768276],
              [-17.72479413616552, 11.335063544842734],
              [-17.767740543257624, 11.286723964980702],
              [-17.779631136076308, 11.261298926722572],
              [-17.793373580615143, 11.24407959224125],
              [-17.784362799770275, 11.228683727412076],
              [-17.76422424121262, 11.2234967445107],
              [-17.75743478159904, 11.23607650235489],
              [-17.73640153643195, 11.22288381451755],
              [-17.709768917433085, 11.216549939887935],
              [-17.672860429825555, 11.230017478346257],
              [-17.631482708743132, 11.233061307615506],
              [-17.62142451136875, 11.2300264081679],
              [-17.60276714970007, 11.243489606162623],
              [-17.59666142682807, 11.258402708570667],
              [-17.636961610333927, 11.24867673010823],
              [-17.66266167744465, 11.248980428679866],
              [-17.66971727901779, 11.242848499118278],
              [-17.69085605307872, 11.239258068260613],
              [-17.70300832377157, 11.225080868044056],
              [-17.715385442027344, 11.226013158789549],
              [-17.722280776100607, 11.237969218228846],
              [-17.73933212657623, 11.249237822379357],
              [-17.753213434834684, 11.250780359120721],
              [-17.75726577605115, 11.271379298836553],
              [-17.7502002455784, 11.275827262703078],
              [-17.726915397517597, 11.304864058366263],
              [-17.69507035327169, 11.33402944065683],
              [-17.672157548564567, 11.351142439425631],
              [-17.665912755262877, 11.36687513362677],
              [-17.609929457303657, 11.411484089064048],
              [-17.601976838882297, 11.423520633359555],
              [-17.582046986990207, 11.422704696228134],
              [-17.570879946095165, 11.427481696878223],
              [-17.560821492534945, 11.447764343705384],
              [-17.518349294461697, 11.453928572216123],
              [-17.513123059148935, 11.4613682411285],
              [-17.495251992818453, 11.464085865438657],
              [-17.481547330347965, 11.45527210061548],
              [-17.44053103863879, 11.461264318753635],
              [-17.43153389701496, 11.473867562284546],
              [-17.42401791650294, 11.507351023037552],
              [-17.398806674064243, 11.531496571546574],
              [-17.388520777761244, 11.547501825451288],
              [-17.36894184425207, 11.55365588955497],
              [-17.360004197074474, 11.570878386460489],
              [-17.33296778921157, 11.586987963730879],
              [-17.310077786733867, 11.594858149229504],
              [-17.29464129135825, 11.611273416704822],
              [-17.272029054420834, 11.60577320627843],
              [-17.267138205987557, 11.621081589937871],
              [-17.26952659873925, 11.66839005847023],
              [-17.282185952261734, 11.677079405670705],
              [-17.268927680417143, 11.688708309180974],
              [-17.266268400490095, 11.669807216559782],
              [-17.239219019976197, 11.65871800481094],
              [-17.225641417810003, 11.648097105251368],
              [-17.229542945232378, 11.636672438282378],
              [-17.225703464553458, 11.617233156073523],
              [-17.231249098338935, 11.60279402268422],
              [-17.230298861267126, 11.58537287523393],
              [-17.235179335540685, 11.569294207282473],
              [-17.224266788728517, 11.549816453973284],
              [-17.229121014692147, 11.539664385140862],
              [-17.243637297913903, 11.530135329989845],
              [-17.234115468291886, 11.518544993587817],
              [-17.2305482351526, 11.501460115850884],
              [-17.235242538916143, 11.486439951520756],
              [-17.24778011110098, 11.483666927871171],
              [-17.278609092151022, 11.49589729800882],
              [-17.291078265686565, 11.482993078042798],
              [-17.329418962741517, 11.456717885222178],
              [-17.341175708029144, 11.47805302742363],
              [-17.350941286643547, 11.431717230069975],
              [-17.357736191848833, 11.419640652253705],
              [-17.344222563920304, 11.401371738977534],
              [-17.357851856304105, 11.371854002857011],
              [-17.35585239746742, 11.363157940934249],
              [-17.368486392537143, 11.346208826128226],
              [-17.387709225102384, 11.338040716600691],
              [-17.421633983576534, 11.333058964017027],
              [-17.434682189087912, 11.316994413979552],
              [-17.387118408216807, 11.324708958724239],
              [-17.378467555697835, 11.321181106303433],
              [-17.344554108577537, 11.348012640782212],
              [-17.329664099667674, 11.323837618540816],
              [-17.34499090213245, 11.287446452749618],
              [-17.329275667935885, 11.283455449297911],
              [-17.315786850361246, 11.267202651591527],
              [-17.35140729516339, 11.234824705890059],
              [-17.361756205262157, 11.198283966029525],
              [-17.38490789191279, 11.16858419620285],
              [-17.380997764496716, 11.148545300120947],
              [-17.41986500859003, 11.101112478140283],
              [-17.411749441883828, 11.065250319268374],
              [-17.42905828945017, 11.049885596038608],
              [-17.445512265432892, 11.04278452358135],
              [-17.46853228715447, 11.07297354325141],
              [-17.492691483317465, 11.088971801973338],
              [-17.510372903142358, 11.091696515191957],
              [-17.499209240057596, 11.112368814138817],
              [-17.477515472390202, 11.140636945054181],
              [-17.449876526809465, 11.154400975155546],
              [-17.437741633245167, 11.171067866674866],
              [-17.47920097265405, 11.16530449534475],
              [-17.518296088228315, 11.144053712324268],
              [-17.551709935099353, 11.09603099290136],
              [-17.548731025235973, 11.078637331212777],
              [-17.537510994204812, 11.059393835367768],
              [-17.542499179987875, 11.036703317851408],
              [-17.568121991201572, 11.021983330094777],
              [-17.577093497803514, 10.997264928535152],
              [-17.591336739750673, 10.995914381630511],
              [-17.591146752007923, 11.014403337660122],
              [-17.597539703259976, 11.018519429119266],
              [-17.602176846959875, 11.043190855806904],
              [-17.599515566268792, 11.054203380272273],
              [-17.610352772322447, 11.078877691591677],
              [-17.59008645755461, 11.10533557981364],
              [-17.564802411068648, 11.123088199556758],
              [-17.56454517895934, 11.142894956703557],
              [-17.555391907645397, 11.159759148745135],
              [-17.56175890366706, 11.182156286455378],
              [-17.574355973158205, 11.173661834493915],
              [-17.589902926529934, 11.145036946028876],
              [-17.60614023838747, 11.144913133554919],
              [-17.60511109818913, 11.131848554551285],
              [-17.623461227476813, 11.120041462269965],
              [-17.631470021580267, 11.092986472672763],
              [-17.629041711306495, 11.062936290293493],
              [-17.62392102331338, 11.04847528557217],
              [-17.638808186425162, 11.026485882131391],
              [-17.650481364807465, 11.016179078270111],
              [-17.639590112260244, 10.993520872324604],
              [-17.64919330429731, 10.980701344572315],
              [-17.640003794852, 10.96749589272278],
              [-17.62988099587569, 11.000616454460575],
              [-17.621466924587192, 11.014102696104914],
              [-17.609583102702672, 10.986296833919111],
              [-17.612025324531196, 10.961087238286728],
              [-17.60013760221398, 10.95082290100674],
              [-17.580443832703814, 10.925105187564233],
              [-17.58142224658077, 10.91866154642304],
              [-17.553582471373407, 10.913964122769952],
              [-17.527759256692082, 10.937287154536426],
              [-17.502782309971032, 10.945184045424652],
              [-17.48700226565089, 10.968854203701921],
              [-17.471594561342936, 10.970871338502478],
              [-17.460312928444484, 10.984594575564525],
              [-17.453954503434275, 11.001046589072827],
              [-17.4421042155218, 11.009315161138213],
              [-17.4339867554308, 11.02899379521255],
              [-17.40469485348501, 11.054161219682442],
              [-17.397389226589805, 11.069096747114088],
              [-17.393879413173867, 11.091970880652184],
              [-17.38018258727213, 11.076890764275563],
              [-17.377489322225372, 11.065339021042133],
              [-17.34781182540901, 11.023614332806744],
              [-17.333089904667364, 11.027839175467276],
              [-17.320151665611135, 11.04279707659336],
              [-17.331655274654686, 11.065235522804883],
              [-17.325288438949578, 11.075798377818636],
              [-17.258362681440858, 11.079162673441099],
              [-17.24849909738478, 11.083611885212642],
              [-17.23941621854695, 11.120832479920756],
              [-17.239028767210232, 11.14171315524258],
              [-17.245372015624614, 11.15108769184642],
              [-17.242947118379536, 11.176769062489646],
              [-17.25893199083675, 11.18995278893116],
              [-17.24668235150675, 11.195348570766294],
              [-17.236257605205132, 11.214937154467627],
              [-17.2509534020487, 11.255541111403],
              [-17.245760883899912, 11.261570030939136],
              [-17.24174500309176, 11.286079449202512],
              [-17.249581388602195, 11.314507718955003],
              [-17.22201292064371, 11.326750893571056],
              [-17.208921429323635, 11.31102482144201],
              [-17.19437318662798, 11.314476873252378],
              [-17.190814005666155, 11.33160889127183],
              [-17.202920306114713, 11.351251133071703],
              [-17.227969735471998, 11.373016157500633],
              [-17.232662653529424, 11.393719666644976],
              [-17.214786296079886, 11.406236316600497],
              [-17.2048778021641, 11.425221196960617],
              [-17.19142663407957, 11.428367236474566],
              [-17.17655730850184, 11.449183662977235],
              [-17.173214424284794, 11.477890743629029],
              [-17.178735248316972, 11.493290024791627],
              [-17.170101002227035, 11.525859017619046],
              [-17.158958360154475, 11.529922567734523],
              [-17.133325340153267, 11.54977834941292],
              [-17.123016842113653, 11.55307070293969],
              [-17.11009172572326, 11.572412165334445],
              [-17.10975278549372, 11.583260122254805],
              [-17.093296331824202, 11.611889492573907],
              [-17.082764074102272, 11.621080118555644],
              [-17.073854726861008, 11.642842254310708],
              [-17.03334139049394, 11.642075455148634],
              [-17.01794117783795, 11.649322690667338],
              [-17.008403911324194, 11.684868214318088],
              [-16.997421983127005, 11.693457253399922],
              [-17.025815452502226, 11.729547330489119],
              [-17.02543868822173, 11.744414797294418],
              [-17.047433008451325, 11.76861641964716],
              [-17.047257071411007, 11.780560262881666],
              [-17.057063215584193, 11.788086854786124],
              [-17.062868599751685, 11.82733310281207],
              [-17.056326627753702, 11.855646351108273],
              [-17.04331091284011, 11.869642964082022],
              [-17.049247262721863, 11.880025195177126],
              [-17.041558110332307, 11.901745134240427],
              [-17.052740960302987, 11.920989341620377],
              [-17.0686694877557, 11.921372203037249],
              [-17.075937757651964, 11.933140400896889],
              [-17.09289868268354, 11.930441764473972],
              [-17.090670561845844, 11.910148217517648],
              [-17.102459676149603, 11.900625869305593],
              [-17.120056690134906, 11.896923723252327],
              [-17.124092735574976, 11.876573665414657],
              [-17.112254171757908, 11.836993313616578],
              [-17.102109368635617, 11.82556719962378],
              [-17.083328105488675, 11.785067220855696],
              [-17.076958535355477, 11.752383668150028],
              [-17.089893340861853, 11.756807317069217],
              [-17.09477815894917, 11.779267894024922],
              [-17.1077497668365, 11.807582841423855],
              [-17.119211467923776, 11.814904262641305],
              [-17.128648567202454, 11.84108620197018],
              [-17.143665723241096, 11.835801804891753],
              [-17.156499817037247, 11.852496710263695],
              [-17.153536256512265, 11.866226280445982],
              [-17.159197092549874, 11.903511630666475],
              [-17.154819282074325, 11.921413460496888],
              [-17.13713160084966, 11.963961340561207],
              [-17.11502572105282, 11.964612269318822],
              [-17.09915064598939, 11.958773355136273],
              [-17.090265851778817, 11.970780273408735],
              [-17.0561457903452, 11.943333186469236],
              [-17.049647361642787, 11.942878904802646],
              [-17.02481735949593, 11.97470315274291],
              [-17.028576449228495, 11.994131018899393],
              [-17.037303544744884, 12.013230729627312],
              [-17.056091705683407, 12.030081898900187],
              [-17.078031425054423, 12.065416304800255],
              [-17.104125915412542, 12.080851264433472],
              [-17.106695698346055, 12.132767015797226],
              [-17.094857887810207, 12.149213202250632],
              [-17.11270150474895, 12.153902125438396],
              [-17.124431956014394, 12.13766368912403],
              [-17.13778761285576, 12.139034106514059],
              [-17.146238503304026, 12.131717817838636],
              [-17.174678041528022, 12.13368177372122],
              [-17.181626383678182, 12.152731146081189],
              [-17.179470259798606, 12.164023821981544],
              [-17.161141434502234, 12.17653115612734],
              [-17.157848235471477, 12.194587372961447],
              [-17.160964155188164, 12.208886704105128],
              [-17.18168135412413, 12.220505078828104],
              [-17.165152313031776, 12.23307192721765],
              [-17.15811354488557, 12.225911531760975],
              [-17.11718457172883, 12.231955690564625],
              [-17.107518576409944, 12.228755715328887],
              [-17.115690855469033, 12.202429846832661],
              [-17.113204941552098, 12.175309139616688],
              [-17.10432916017735, 12.172817580881164],
              [-17.101836191932126, 12.198415512890508],
              [-17.086751626035245, 12.20166315328111],
              [-17.082020770974523, 12.166637711030699],
              [-17.06241425486733, 12.152441190886272],
              [-17.038252866765646, 12.1568423171283],
              [-17.04036313000084, 12.181237907101115],
              [-17.032644413895756, 12.205161959544283],
              [-17.034127214819517, 12.252275154519452],
              [-17.02136089507978, 12.243553006245572],
              [-17.001510869118945, 12.24415156142303],
              [-16.98366037807584, 12.255103145658007],
              [-16.9737888515476, 12.270359180183672],
              [-16.98257145402154, 12.296033249976992],
              [-16.99172003691806, 12.301696835297651],
              [-17.010542421860304, 12.345807964006092],
              [-16.99604817251911, 12.348611430280462],
              [-16.99458561148743, 12.375007107442771],
              [-17.002506632347913, 12.38359149741474],
              [-17.00214187097941, 12.396502874500255],
              [-16.977284952202744, 12.414905912230216],
              [-16.996694246805568, 12.454206077559828],
              [-17.013786749139054, 12.461401596780266],
              [-17.04669083838185, 12.454809293168985],
              [-17.07267945718717, 12.434920118168323],
              [-17.08417012226321, 12.419986355728806],
              [-17.09636076733154, 12.443266491159182],
              [-17.068804740481145, 12.472297388587029],
              [-17.0653656104985, 12.482392223790919],
              [-17.083584922893845, 12.50587542389098],
              [-17.09908039691056, 12.509282579542095],
              [-17.0940181978325, 12.538056539485476],
              [-17.0953732302764, 12.558969060007858],
              [-17.108736491333154, 12.571453784248835],
              [-17.126800348381394, 12.600177460209334],
              [-17.12294770094817, 12.608698960718687],
              [-17.097645721241168, 12.618216967676304],
              [-17.089298718854277, 12.635423013471044],
              [-17.1012866334412, 12.650643592495557],
              [-17.115186953975957, 12.643705861715194],
              [-17.132767209697683, 12.656061810222145],
              [-17.127474365845057, 12.671531644713076],
              [-17.10925132137488, 12.685498937881274],
              [-17.076940843174295, 12.703790183968788],
              [-16.965165570599, 12.672411816092195],
              [-16.853403457993103, 12.640985175192156],
              [-16.754514308884005, 12.61362650699365],
              [-16.655635270863257, 12.586230179755418],
              [-16.54523134517277, 12.553733935174064],
              [-16.434842302259316, 12.521190445369873],
              [-16.320615483270608, 12.491689914832852],
              [-16.20640042082842, 12.462139670572117],
              [-16.1175105977693, 12.438683721293721],
              [-16.033382200007942, 12.417706218860841],
              [-15.939191110870391, 12.391836293908481],
              [-15.855032674142675, 12.36976664331587],
              [-15.770881176573168, 12.347670054609086],
              [-15.661501859589812, 12.319723374094636],
              [-15.552133723649183, 12.291731368551785],
              [-15.491934102351625, 12.276129199059556],
              [-15.431738045092917, 12.260513296264872],
              [-15.371545579503396, 12.244883666074315],
              [-15.311356733211573, 12.229240314381927],
              [-15.230683707335254, 12.209977194695329],
              [-15.118116434659854, 12.181659136817718],
              [-15.030358614834702, 12.15995481331917],
              [-14.942607838641932, 12.138221523849884],
              [-14.847036469991844, 12.114886828215617],
              [-14.751473337380574, 12.091517858645217],
              [-14.656174694745612, 12.068572052677824],
              [-14.560884110319398, 12.045592250054662],
              [-14.45343879028212, 12.020087798911982],
              [-14.34600355947601, 11.994540238113961],
              [-14.24703883800684, 11.971387361256504],
              [-14.148082543624152, 11.948198000191578],
              [-14.044207831133674, 11.924292057070979],
              [-13.940342217000985, 11.900346019795828],
              [-13.853358871202612, 11.880689548645657],
              [-13.766381739302236, 11.861005032441446],
              [-13.688569792005817, 11.843139823375072],
              [-13.610763110021976, 11.825252165934772],
              [-13.53296175215974, 11.807342070912492],
              [-13.455165777218534, 11.789409549061402],
              [-13.394364304951525, 11.776285390775541]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.44503208101239,
          "lat": 47.38045558263267
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779804"
      },
      "bbox": [
        -18.7057199680522, 8.895086305804204, -13.394364304951525,
        12.763659578120047
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.47075346858794,
          "lat": 18.222604843777038
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "ste_area_code": "PRI",
        "ste_type": "outlying area",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779808"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.822358383519017, -1.011957823660947],
            [-9.590672354069358, -1.043530342410286],
            [-9.42350897042423, -1.0657097505154773],
            [-9.19935461445599, -1.0948570412146987],
            [-9.198423776931506, -1.0955334649141495],
            [-9.003153533422367, -1.1195724909484932],
            [-8.776953644506646, -1.1479302370676179],
            [-8.595859677603729, -1.1701312034340023],
            [-8.37214944815262, -1.1968863520768096],
            [-8.121052616545114, -1.226090556880314],
            [-8.116051019118409, -1.2345023559896153],
            [-7.917417773040539, -1.2564965133418666],
            [-7.7018345666129955, -1.2790764343004235],
            [-7.590435192052807, -1.291270192932592],
            [-7.4288075441795245, -1.307188716191141],
            [-7.138695027911062, -1.336972436981272],
            [-6.996825933589092, -1.3509097536230035],
            [-6.739885136192615, -1.3766785843471137],
            [-6.66803871802045, -1.3862944332760028],
            [-6.645407195430993, -1.3879043989663464],
            [-6.365373820397578, -1.4138511608283093],
            [-6.349154299249158, -1.414315783822781],
            [-6.12411375218037, -1.435298967181331],
            [-5.863036259101317, -1.4550594123417042],
            [-5.6472966178118105, -1.4711360546518002],
            [-5.440215575690302, -1.4867408028458098],
            [-5.190993485281601, -1.5047230305346424],
            [-5.069750699194865, -1.5138966209814764],
            [-5.076293330059413, -1.6050361162961084],
            [-5.0941503071790395, -1.8408990602975206],
            [-5.107072791315379, -2.0167843711479536],
            [-5.138428724799877, -2.0144223977961406],
            [-5.151899095787713, -2.1977029584218473],
            [-5.170816225323626, -2.4623102406595185],
            [-5.187450655632798, -2.6810050171704565],
            [-5.2037247213138835, -2.8973036363886826],
            [-5.221133009920525, -3.126105551170803],
            [-5.237198034996244, -3.3386192984884726],
            [-5.254439233341931, -3.5685356120350944],
            [-5.275785535690646, -3.852467294450726],
            [-5.298465073021847, -4.144879541839831],
            [-5.313760232219485, -4.354073444184341],
            [-5.326246717888332, -4.5216241961401336],
            [-5.356650210840658, -4.852843284663803],
            [-5.382907747166302, -5.136559907965902],
            [-5.39840177245642, -5.305524882378409],
            [-5.418542471584097, -5.524399452617093],
            [-5.442445253150781, -5.841124172482838],
            [-5.468178720845662, -6.188199753156977],
            [-5.493003085156609, -6.5210569575272626],
            [-5.603286916637028, -6.512828397413604],
            [-5.713569477583268, -6.504582711640043],
            [-5.880322655422768, -6.49153852308255],
            [-6.0470727745254, -6.478455138627785],
            [-6.175397422574997, -6.46762228569231],
            [-6.300794644969867, -6.457720659158645],
            [-6.429073674895255, -6.446706272256011],
            [-6.557350694036456, -6.43566863431937],
            [-6.727260627794966, -6.420609637971063],
            [-6.9144853769642, -6.403232240146385],
            [-6.929515928717852, -6.404900625011126],
            [-6.980365928997684, -6.39767889335434],
            [-7.115239558515723, -6.38472498118972],
            [-7.250110648675626, -6.371745282159311],
            [-7.384182263231166, -6.358546674482103],
            [-7.518251339520916, -6.345322562731393],
            [-7.626568852459522, -6.333993998031215],
            [-7.734884540210316, -6.3226487564267915],
            [-7.90026254088277, -6.304947924537664],
            [-8.065636238855756, -6.2872081849329255],
            [-8.128790575452108, -6.2812212753086065],
            [-8.29125658696532, -6.263957894814737],
            [-8.479420372635152, -6.244190793943796],
            [-8.499330726922505, -6.262217850256454],
            [-8.488716542256546, -6.282794126771981],
            [-8.492412577387379, -6.3182766325419255],
            [-8.48286231539839, -6.324699314802454],
            [-8.508933552257439, -6.337269265320831],
            [-8.513768854338611, -6.346514550034231],
            [-8.501497989011149, -6.359080109696695],
            [-8.509111139428047, -6.375794139132698],
            [-8.483540660650648, -6.405397482172116],
            [-8.487640494432595, -6.416686695314349],
            [-8.473812873690694, -6.424056986310708],
            [-8.466038500402359, -6.436672354269584],
            [-8.441076255622429, -6.442554817419057],
            [-8.42786534994199, -6.46827646016047],
            [-8.430686498721657, -6.467205424770211],
            [-8.614734510072868, -6.446650077193911],
            [-8.719855108172716, -6.434846562339341],
            [-8.824973891893498, -6.423026492156208],
            [-8.949446451091616, -6.408336757780963],
            [-9.073916250019852, -6.3936237660253585],
            [-9.218201114351668, -6.376334530530368],
            [-9.36248227336575, -6.359014014706789],
            [-9.457215397375045, -6.347318302790261],
            [-9.551946865764988, -6.335609086447188],
            [-9.69572777298454, -6.317428454831606],
            [-9.839504771845418, -6.299216675127125],
            [-9.8611311848284, -6.467635210591654],
            [-9.8975605466777, -6.744606698566503],
            [-10.002843657707281, -6.73090140002227],
            [-10.108124379058841, -6.717177730846388],
            [-10.213402732272316, -6.703435687525822],
            [-10.318678738816592, -6.689675266014231],
            [-10.387149858679713, -6.681329453075261],
            [-10.497318404020907, -6.6663044255170565],
            [-10.607484207250137, -6.651259223088225],
            [-10.587326643077576, -6.505540479952775],
            [-10.564914322712212, -6.3508905289586925],
            [-10.53228315507816, -6.119318078570261],
            [-10.502006815751734, -5.903245432892877],
            [-10.455048555995198, -5.569169690661018],
            [-10.424708638217094, -5.350333182657517],
            [-10.406301904104422, -5.220888041784823],
            [-10.37912508016368, -5.023439445500565],
            [-10.362793963602945, -4.9078017053920115],
            [-10.341524809952203, -4.751618966931861],
            [-10.319378453699798, -4.592881083585155],
            [-10.289192281391495, -4.378871973748453],
            [-10.273743632029213, -4.264450246407879],
            [-10.254541094735462, -4.13013808255927],
            [-10.237781221287975, -4.005636678560503],
            [-10.214554255937534, -3.839469110684387],
            [-10.183878432423443, -3.619951729964119],
            [-10.157203945374619, -3.4286384161786323],
            [-10.130696103689495, -3.237479201332402],
            [-10.104468295790664, -3.049284773050056],
            [-10.064588828462691, -2.7595703230917983],
            [-10.049480446590534, -2.646114848484998],
            [-10.003235368523328, -2.315080303546561],
            [-9.977592270249964, -2.1306952455917916],
            [-9.944596999624972, -1.8936998524233786],
            [-9.915414173091197, -1.6819113829585886],
            [-9.887338230325641, -1.4810814449120027],
            [-9.854292096483833, -1.2418952602492161],
            [-9.822358383519017, -1.011957823660947]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.10835981892727,
          "lat": 34.42136054999401
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "00897535"
      },
      "bbox": [
        -10.607484207250137, -6.744606698566503, -5.069750699194865,
        -1.011957823660947
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.83985974464064, 4.229066116558844],
            [11.895262821793605, 4.267125199573045],
            [11.91913645464977, 4.278703079481743],
            [11.945117250003758, 4.29787388431482],
            [11.96772356465707, 4.3096404315857875],
            [12.009432310978516, 4.341824067893681],
            [12.026541736667992, 4.360810052354276],
            [12.043773965631463, 4.370414369186539],
            [12.075778776867718, 4.3991853870587745],
            [12.082864797019722, 4.4094351034384935],
            [12.090508349784953, 4.445933664779162],
            [12.101026261957434, 4.46349936746949],
            [12.122095624669, 4.474793377428979],
            [12.14536287561194, 4.450598702972125],
            [12.194254736191418, 4.493395252682719],
            [12.229073071664441, 4.52779143358809],
            [12.24933603445604, 4.541388370131761],
            [12.266916972389023, 4.559950090417994],
            [12.287019880054665, 4.5669523591694725],
            [12.330457580022353, 4.604815022021945],
            [12.34107876064715, 4.611228174705898],
            [12.387857959324206, 4.3434164872075876],
            [12.45415554271507, 4.355128126029702],
            [12.598018203730179, 4.379072203781372],
            [12.70468009800133, 4.398548061462899],
            [12.811345848766242, 4.418002727569611],
            [12.953417878340668, 4.442968574651726],
            [13.032301213213584, 4.455829739097817],
            [13.122939027583389, 4.472912910806083],
            [13.233718185740868, 4.495077679568177],
            [13.3518261833645, 4.516639184308593],
            [13.469938790318691, 4.538174668966248],
            [13.575850911326695, 4.559700884943559],
            [13.66837904469005, 4.57558782351628],
            [13.788325086143125, 4.598377870833863],
            [13.906480187687754, 4.622182877282049],
            [14.024640535073686, 4.645961624140816],
            [14.16242329168816, 4.6729851937890325],
            [14.30021283496757, 4.699973105986153],
            [14.447207549225311, 4.732055321192163],
            [14.5709215248881, 4.7571711980119895],
            [14.675077232133289, 4.777248539566399],
            [14.779236644825733, 4.7973055031897545],
            [14.864897893795202, 4.814556779392628],
            [15.023629049355932, 4.8485571244405605],
            [15.114931285816658, 4.8679346063919615],
            [15.206236773372428, 4.887296290748189],
            [15.299100430540065, 4.906266330875082],
            [15.393978836608264, 4.9279193095701315],
            [15.484286228830488, 4.947903985777022],
            [15.574596969440341, 4.967873127490774],
            [15.589343139832318, 4.964259510096525],
            [15.592392320296314, 4.945952198074255],
            [15.603184121305684, 4.942088664886391],
            [15.62103150470146, 4.92626766589955],
            [15.631817248994462, 4.934381390204297],
            [15.645771055234322, 4.9213483919421055],
            [15.661031439192254, 4.891965975568265],
            [15.662632987540727, 4.87207473767093],
            [15.671648013483136, 4.856997460804576],
            [15.703479711326096, 4.8503613318711425],
            [15.707621612000217, 4.861552952076177],
            [15.719689574189847, 4.865622748014421],
            [15.731534186060555, 4.859722668517758],
            [15.741567622646402, 4.868661361767868],
            [15.750036580175706, 4.852847305319829],
            [15.764918183036817, 4.858458858888576],
            [15.785433408922765, 4.854285217295649],
            [15.790769933708864, 4.83407926085374],
            [15.813108953222379, 4.827579996823965],
            [15.807719351333072, 4.787884289809114],
            [15.829042382063095, 4.789873824147595],
            [15.849484782423005, 4.774908423782157],
            [15.860430022879742, 4.738824892058178],
            [15.84812418704286, 4.728945557664094],
            [15.864115327210385, 4.712173647229638],
            [15.862833475386807, 4.6975004737347525],
            [15.871843840781947, 4.687311445181493],
            [15.885788455708665, 4.6445477111229],
            [15.873706900819718, 4.639266574232751],
            [15.866486454439586, 4.627613507855495],
            [15.891603041649423, 4.610110005054482],
            [15.899135697066031, 4.5978246427767075],
            [15.918995420278366, 4.583852513355085],
            [15.91709651702876, 4.571073036660628],
            [15.935755663846537, 4.559033913175914],
            [15.94250542758762, 4.543400218651347],
            [15.953729167383932, 4.545101953827652],
            [15.961595795823294, 4.519406903938707],
            [15.979346687347421, 4.51973291309736],
            [15.996654634226262, 4.529722630455305],
            [16.015819289958856, 4.523848236037078],
            [16.029215718645055, 4.51218973159301],
            [16.038267260102515, 4.4936980891135105],
            [16.058743906607535, 4.504665380464603],
            [16.077308081296, 4.495665651332965],
            [16.09765265222831, 4.511053809092225],
            [16.10913509381991, 4.4949809165996495],
            [16.13599539277248, 4.500347669264019],
            [16.147043579550395, 4.510964356238263],
            [16.157872397956343, 4.479660987351045],
            [16.17626128692106, 4.474988610588784],
            [16.197471907840598, 4.456629453910387],
            [16.196942500218572, 4.446304334048551],
            [16.180304367218362, 4.432177802812394],
            [16.157117249063553, 4.4256172351331164],
            [16.14848862832135, 4.401975462286655],
            [16.134157146379202, 4.396037425366859],
            [16.136476273044785, 4.384363222135303],
            [16.11890392076422, 4.363086916276098],
            [16.11060653271121, 4.344155069970309],
            [16.10868894489215, 4.31683008246501],
            [16.10324323419156, 4.313316674737368],
            [16.100497552740812, 4.29084341087558],
            [16.10799396233611, 4.28504826207651],
            [16.10020197343096, 4.2424035327207354],
            [16.090665943738983, 4.225150976496303],
            [16.07978802484164, 4.193807636258485],
            [16.065844479818352, 4.181300682158048],
            [16.05510932258494, 4.16362079532562],
            [16.04337111037691, 4.15481189425455],
            [16.03996794331996, 4.137598571085249],
            [16.05663390635122, 4.13413008845464],
            [16.030070682689583, 4.108793080940393],
            [16.02580293575373, 4.080052252601055],
            [15.995771948975083, 4.050254231324365],
            [15.973723016765826, 4.031909175737562],
            [15.960903957766469, 4.015646663057374],
            [15.960414569169167, 4.000874247600585],
            [15.971329351679847, 3.996385732454313],
            [15.978630151218367, 3.980357364569064],
            [16.001236960281293, 3.9556372369543342],
            [16.01537661257118, 3.948213467571859],
            [16.021813067946578, 3.930891906020996],
            [16.042977334962963, 3.9129029258313874],
            [16.046627600737114, 3.903803289499798],
            [16.04111481777538, 3.887533404095811],
            [16.02107137378742, 3.8827792792052818],
            [16.018041208532253, 3.873628528621949],
            [16.031660677071958, 3.859659162223074],
            [16.02340578114825, 3.8403996868797545],
            [16.021003933065828, 3.822867885412944],
            [16.01127517243043, 3.8162167907707034],
            [16.00583776282622, 3.801621628939488],
            [15.97771102382912, 3.799468631199436],
            [15.976357773127786, 3.785229068122172],
            [15.965146798733384, 3.7697552804090417],
            [15.98019302262197, 3.7507139982726736],
            [15.972895380809458, 3.7094761396073563],
            [15.980265822430253, 3.7005957375609215],
            [15.995236646740123, 3.7002414237845587],
            [15.985194557294207, 3.666218171640448],
            [15.998804045087395, 3.646273465480689],
            [15.991614816238192, 3.634364853092213],
            [16.000886567285875, 3.624097461422935],
            [16.005384543445896, 3.5978489002367358],
            [16.021626383561326, 3.5898436450210904],
            [16.03395693436682, 3.5928842992307675],
            [16.047611647993346, 3.6066966534806],
            [16.07612101386142, 3.6048808386342834],
            [16.105063559664515, 3.5849448917093696],
            [16.12264328404724, 3.5263635507008346],
            [16.1228111267398, 3.499086337902318],
            [16.139617466613572, 3.4645589067597875],
            [16.16793482300402, 3.4558173257511386],
            [16.187284629923088, 3.467453351034556],
            [16.21451312403888, 3.4577907758331388],
            [16.232517713930537, 3.4303753434536066],
            [16.241084183919916, 3.409379471246087],
            [16.272918838681587, 3.390054879242284],
            [16.290014905010135, 3.3870930048941985],
            [16.307307734842933, 3.375402022434341],
            [16.336362264735264, 3.335803719864944],
            [16.375747593905853, 3.3229217028881015],
            [16.396308091447164, 3.3129953089680972],
            [16.41459205743799, 3.287621554188455],
            [16.433418372572813, 3.2792926356544365],
            [16.445023277199333, 3.267569008660873],
            [16.446676565775213, 3.2533086002611262],
            [16.43716665879399, 3.239833325112766],
            [16.42395229174719, 3.2353290657852116],
            [16.409747899336317, 3.2184433841080873],
            [16.383063749749365, 3.2195590797370808],
            [16.3764151882818, 3.2142596156665597],
            [16.372867263064986, 3.1895368779714106],
            [16.360310691652217, 3.1701716941503677],
            [16.327187594014042, 3.1475162563824464],
            [16.31006237529066, 3.142214399202687],
            [16.28824241889454, 3.120686040568076],
            [16.261776809074167, 3.0816794295880143],
            [16.246694796231132, 3.072642119772083],
            [16.234833850440694, 3.058988169806526],
            [16.224236174874903, 3.0292245988919073],
            [16.205710799384793, 3.0192384730490174],
            [16.18808670320575, 3.0011972303810275],
            [16.19135518245112, 2.9695017263207846],
            [16.200028175375625, 2.9554296543965926],
            [16.19787415078612, 2.932388782829693],
            [16.190639103134664, 2.9243343626200224],
            [16.165685791676054, 2.9170124390411356],
            [16.141703820990443, 2.890549535005842],
            [16.106725965854537, 2.869940462750889],
            [16.063447642148013, 2.860294808458113],
            [16.047623142825895, 2.8474158654231867],
            [16.010794285063273, 2.800087211570629],
            [16.003565619720938, 2.8033459683329247],
            [15.978057287318082, 2.8118834717931063],
            [15.94172259824918, 2.8173388565991604],
            [15.887260980625543, 2.811318042434794],
            [15.853558047882778, 2.7988105182224743],
            [15.822431142274702, 2.7787911000521928],
            [15.797851378912243, 2.754331687707798],
            [15.782576020147834, 2.731962005633773],
            [15.768868943920143, 2.701668614558432],
            [15.760996474853318, 2.663421411726063],
            [15.749965176337065, 2.661040188822219],
            [15.593594699610316, 2.6268509760656067],
            [15.418764253058281, 2.58949075683619],
            [15.280422560496442, 2.5603631602710295],
            [15.16969392414503, 2.5373804097359147],
            [15.058968160175114, 2.514383443614861],
            [14.853670628584236, 2.471155715208658],
            [14.740793995734137, 2.448593177023767],
            [14.62792023167793, 2.4260159366120404],
            [14.49625722005113, 2.3999274248985003],
            [14.305414346467852, 2.3634380451801733],
            [14.192489334234475, 2.3429245105773986],
            [14.024512726779598, 2.3108346037806475],
            [13.860275691262181, 2.280049679089773],
            [13.69604434239877, 2.2492338193896826],
            [13.55669321969784, 2.224066591119978],
            [13.40108242182799, 2.195386905750452],
            [13.193306679823745, 2.1574181593528117],
            [12.992170407303297, 2.120675400225142],
            [12.850952514650567, 2.096003585433765],
            [12.709738530141058, 2.071309054919308],
            [12.542071970722152, 2.0434193440654673],
            [12.366593939844414, 2.013892875710069],
            [12.208772513519158, 1.9879362656961566],
            [12.173563378568563, 2.2024846565574534],
            [12.137227556507389, 2.4240826447179096],
            [12.107427328791585, 2.6055454216320206],
            [12.088739406776849, 2.725405379026047],
            [12.085939713865436, 2.7363829524777987],
            [12.058926407137232, 2.9005546949258045],
            [12.012689630747683, 3.1810464546623725],
            [11.959389051425998, 3.5066560439783636],
            [11.928667984162825, 3.6918470987025604],
            [11.890111715684625, 3.924282420893916],
            [11.83985974464064, 4.229066116558844]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.79960738965717,
          "lat": 40.873781599040875
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779798"
      },
      "bbox": [
        11.83985974464064, 1.9879362656961566, 16.446676565775213,
        4.967873127490774
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.126822499258076, 1.4600188352959906],
            [-3.9672043223892195, 1.449725348705754],
            [-3.8038958686074085, 1.4398498210968569],
            [-3.6405893471124053, 1.4299424356744157],
            [-3.5754567463542752, 1.4266072794563898],
            [-3.4289528839569403, 1.418427815078435],
            [-3.282450458410086, 1.4102227253816777],
            [-3.089894075313207, 1.4005613937529178],
            [-2.9271628346812726, 1.3922074600919683],
            [-2.7210591666720045, 1.3825755272403148],
            [-2.575613954087233, 1.3764097122649694],
            [-2.430169813620717, 1.3702186758749442],
            [-2.2746547820648755, 1.364614936844663],
            [-2.1191407868654344, 1.358982373168501],
            [-1.941948510039168, 1.3528099279815393],
            [-1.7636304952624529, 1.3473655326568237],
            [-1.5933792442461503, 1.3422840947288939],
            [-1.4725181297599645, 1.3391653407607855],
            [-1.3516574641372912, 1.3360291838558345],
            [-1.240791826140919, 1.3333242970218058],
            [-1.1299265476541214, 1.3306047676203487],
            [-0.9316445411048271, 1.3261775897302854],
            [-0.807555432479006, 1.3239948418645027],
            [-0.6834666479880754, 1.3217937563465365],
            [-0.49004751282210446, 1.3186389371303135],
            [-0.33302555264591926, 1.3164920614269722],
            [-0.17086860494994097, 1.3149984359425486],
            [-0.008711950295315407, 1.313473506465764],
            [0.11192186466041686, 1.3126271961414364],
            [0.23255555313087561, 1.311763563476781],
            [0.3465628395031638, 1.3113532004945987],
            [0.5529151905848424, 1.311287943345694],
            [0.6760278549007911, 1.311526393890513],
            [0.7991405509988933, 1.3117468061249327],
            [0.9888107714647052, 1.3126668445997582],
            [0.9933163492704824, 1.2969192149295459],
            [1.0181995694048203, 1.2820113038605223],
            [1.0400416432581427, 1.2575162151107833],
            [1.0561286171001194, 1.257125748444353],
            [1.0705996399501023, 1.2469148936412475],
            [1.0674326994391254, 1.2207359781317628],
            [1.0874782144703656, 1.2126191310649468],
            [1.1023294457895751, 1.2197333267700106],
            [1.1145607024866933, 1.2147307332182724],
            [1.1171784153069904, 1.1943414851337248],
            [1.126702666532011, 1.1868370978454792],
            [1.1622830272349116, 1.1746122897700406],
            [1.1955300098672703, 1.178799877487378],
            [1.2029484235408567, 1.1849096123208824],
            [1.2096658364989814, 1.2110627948969501],
            [1.2313026988651212, 1.2109241017345993],
            [1.2548218245925653, 1.215880929537977],
            [1.2788499551504713, 1.2004480203165866],
            [1.2680283010824474, 1.1705488126807473],
            [1.2877715622223285, 1.1501207419471207],
            [1.3106196807222668, 1.147316944963701],
            [1.318254821559583, 1.1379774370526479],
            [1.3189886333489378, 1.120971960499847],
            [1.306524153156476, 1.1048850605016542],
            [1.2816917780671977, 1.1032438115995615],
            [1.2752837026536876, 1.0869119584041325],
            [1.2887346912442936, 1.0742433544354983],
            [1.3021599914966075, 1.0747205282559826],
            [1.315547080754295, 1.084968684001779],
            [1.331392341109034, 1.0769178517792417],
            [1.3299596112956154, 1.0566157222096555],
            [1.3204343465886417, 1.0438872091692164],
            [1.2999597939237983, 1.0372979018863784],
            [1.2718688421879423, 1.0545151079478619],
            [1.2595850001504483, 1.0585278896040198],
            [1.2482034571684597, 1.0447108325742411],
            [1.249730184195325, 1.0051990126409864],
            [1.2383303500259188, 0.9898325693961041],
            [1.2193864676537107, 0.9875282974954706],
            [1.2052944311512275, 0.9769763076316755],
            [1.1888914494622091, 0.9489767082656754],
            [1.1847559882397591, 0.9325658273708395],
            [1.191603152766994, 0.9123966550686861],
            [1.1838359696402863, 0.8910840719466347],
            [1.1589271728435309, 0.8913065010851379],
            [1.1452986333521902, 0.8839252307709026],
            [1.1408258105837683, 0.8637955663710952],
            [1.1491710139714197, 0.8430872619758811],
            [1.1688069331067261, 0.823294748677786],
            [1.1826217355675848, 0.8159516299954113],
            [1.1900896345104124, 0.8041877698206585],
            [1.1923595399195872, 0.7845836620421329],
            [1.2029988412156005, 0.7704633688303409],
            [1.236222418286702, 0.7559863270340819],
            [1.2468113812639137, 0.7364244931535524],
            [1.2702407067757047, 0.7154262829461125],
            [1.2709208001952692, 0.7035270702645818],
            [1.2882260316767573, 0.6942733408828518],
            [1.304426135466352, 0.7028434974472655],
            [1.3173196279142072, 0.6999681777793002],
            [1.3220331557559495, 0.6857917730675227],
            [1.304288047749972, 0.6701191018385202],
            [1.2981904522972778, 0.6578863786975109],
            [1.3004497280521459, 0.6330053904956525],
            [1.3068660363022488, 0.609384522635139],
            [1.3237478503792082, 0.5903437940382458],
            [1.3484365852923652, 0.5778632680042114],
            [1.3599744554218027, 0.5656793178617757],
            [1.364610244462434, 0.5510530478562997],
            [1.3577490427018593, 0.5329099891149565],
            [1.3664442218471873, 0.5189149442248675],
            [1.3944438842104614, 0.5170376042061762],
            [1.4035954968837356, 0.5100230031930181],
            [1.4133847231737757, 0.4892514996263099],
            [1.4339509937631076, 0.4787189005788825],
            [1.4511344823290935, 0.4801609327950538],
            [1.4716073774196936, 0.4936671486594094],
            [1.4855246227699304, 0.49234624212954325],
            [1.4917390214989732, 0.47298662589432977],
            [1.5084702843360063, 0.4641018953794403],
            [1.5322637007603697, 0.47185423858185316],
            [1.547977110792163, 0.46080288449325],
            [1.5469996820063208, 0.4497929862154438],
            [1.5331826726042002, 0.428350611483101],
            [1.5347669434999052, 0.37562702673753695],
            [1.5351613805201714, 0.290918226034501],
            [1.5379886641176557, 0.13520492674117787],
            [1.5377767575323258, -0.07391019630184857],
            [1.539808516512156, -0.29308743417362665],
            [1.543095332199839, -0.4806496108103408],
            [1.5431630179551517, -0.5491995823839299],
            [1.5455977382507373, -0.7565976824392857],
            [1.545687140939183, -0.9296720771630366],
            [1.546891462757465, -1.0212982754413842],
            [1.5501119852014944, -1.1835190827281983],
            [1.5537946190940664, -1.5193956719427795],
            [1.556862308451191, -1.711009596695432],
            [1.4625749957300929, -1.7125632419593388],
            [1.2584202422176411, -1.7141255556729866],
            [0.9322053485857114, -1.717155686347217],
            [0.7036748663743151, -1.718258184392711],
            [0.4630993689258249, -1.7189991781328489],
            [0.15188160265296427, -1.7179882891438734],
            [0.06802344230198813, -1.718177170455022],
            [-0.11887798166524768, -1.716312595063542],
            [-0.3510164455138082, -1.7145163170465478],
            [-0.529517860381884, -1.7123082823038829],
            [-0.806948958437267, -1.7084439614218443],
            [-1.0204018260151917, -1.704614952077285],
            [-1.206674519568244, -1.7011810711730118],
            [-1.3981143098194189, -1.6968580217058502],
            [-1.5489559826226507, -1.69192542069109],
            [-1.6830842192240065, -1.688151383151602],
            [-1.9319725039910007, -1.6800915045461733],
            [-2.2694189719597917, -1.668703914386186],
            [-2.4215293404775027, -1.662883938948823],
            [-2.6006624590703464, -1.6537170480155257],
            [-2.7905459502801326, -1.6451805192420639],
            [-3.1350172531619678, -1.6310717254547515],
            [-3.279604769238648, -1.6255829617776363],
            [-3.499352188212645, -1.61520190363783],
            [-3.7131374503481855, -1.6051390100261942],
            [-3.9890795311144016, -1.5910177301599422],
            [-4.312581802134678, -1.5730893088079339],
            [-4.302972944334442, -1.4232756543569378],
            [-4.2894241659620205, -1.2108373293953443],
            [-4.277740260036826, -1.0268067269080536],
            [-4.2680813557071815, -0.8805458359628718],
            [-4.2612616564715315, -0.7564329882277453],
            [-4.2470506188801975, -0.5124830493818544],
            [-4.233735993570824, -0.30642703614386174],
            [-4.221384381258824, -0.1011709061823192],
            [-4.2073297162853525, 0.11645478357088274],
            [-4.198344278634931, 0.2613491345296642],
            [-4.184257398984513, 0.49683040895674296],
            [-4.16925607881352, 0.7549380954427215],
            [-4.162242097950218, 0.8760626106721703],
            [-4.148744384338328, 1.1004387588694535],
            [-4.136532180492734, 1.3056858477867548],
            [-4.126822499258076, 1.4600188352959906]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.38026095490471, "lat": 38.48463476425185 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "00481813"
      },
      "bbox": [
        -4.312581802134678, -1.7189991781328489, 1.556862308451191,
        1.4600188352959906
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5642308322079228, -2.2149504691715425],
            [1.7686206682903076, -2.211516787747053],
            [1.9680992153863486, -2.208838738620227],
            [2.130938304280664, -2.2052963659622193],
            [2.2727175288217443, -2.201719986895591],
            [2.5123610113599755, -2.196071182062483],
            [2.7519850919357904, -2.189948530349887],
            [2.797749767129029, -2.188148695895679],
            [3.033443277537629, -2.1809970735778603],
            [3.2367334440971263, -2.1728472254725903],
            [3.3693064506474717, -2.1688337886483886],
            [3.552244691305862, -2.1605015974117046],
            [3.659275022810363, -2.156494654250273],
            [3.9085929650363544, -2.144512084199942],
            [4.016367136086727, -2.1398379160893493],
            [4.121421252859027, -2.136887750964634],
            [4.342796797041927, -2.1252612096054966],
            [4.474670463093403, -2.1176613470654178],
            [4.672996842226744, -2.1069913806850615],
            [4.829645735737201, -2.0980179951906037],
            [5.056420135886646, -2.085225187159584],
            [5.115719167046353, -2.082548253518219],
            [5.113270010478372, -2.100158611559927],
            [5.128059764355222, -2.1159906248327065],
            [5.135582363478823, -2.142200303163148],
            [5.13631795749176, -2.1652806084552303],
            [5.157216362082211, -2.1737385692301197],
            [5.1805562471719275, -2.1756330520148306],
            [5.194395456069013, -2.193647323542405],
            [5.194411253556198, -2.216674722524132],
            [5.18601619063428, -2.228135959523368],
            [5.184276098921005, -2.2549058533221533],
            [5.19980084663978, -2.2731984024956686],
            [5.189712138299077, -2.2886726430374726],
            [5.185991025962368, -2.3050907200293715],
            [5.161547696500665, -2.3134169704165504],
            [5.159674823714341, -2.3257642281487327],
            [5.142135667712003, -2.353089102693095],
            [5.127767628458325, -2.365851341324011],
            [5.106850729511805, -2.37764924810466],
            [5.095009627567983, -2.396983798625202],
            [5.0823923237994935, -2.3999509284074194],
            [5.072030892617269, -2.426455941282529],
            [5.075934577480829, -2.438145621403282],
            [5.063091133647422, -2.4566172100099206],
            [5.044978537999033, -2.4695766246598216],
            [5.0286422540626585, -2.4743196284436273],
            [5.024184639195023, -2.4908837044905754],
            [5.008270428866484, -2.5030475022778105],
            [5.009156357604819, -2.518966973498545],
            [4.9993816682162215, -2.523411247555087],
            [4.9974627859282466, -2.543475253724699],
            [4.989205635091793, -2.5498404999896565],
            [4.98714207981321, -2.5667221930731374],
            [4.967987957206259, -2.597819360563091],
            [5.168355784556562, -2.583728831349693],
            [5.369630889099148, -2.5690748342606335],
            [5.483556340515383, -2.5603852277651202],
            [5.492449175231355, -2.5716689053229933],
            [5.494865193944066, -2.5931204024447694],
            [5.501526847568865, -2.6006217660114594],
            [5.5547005099553965, -2.6295704538148175],
            [5.563511862341645, -2.649870221024208],
            [5.561243453644994, -2.6713975479195256],
            [5.55200270720497, -2.681199086926004],
            [5.537216332499032, -2.6822301635503805],
            [5.504357315414, -2.654556299475826],
            [5.481448060247342, -2.651088504998475],
            [5.463484890757265, -2.6728025404344926],
            [5.459178054943224, -2.6933264768676692],
            [5.464465071163361, -2.703368157310407],
            [5.52304293095425, -2.7235986030005597],
            [5.524851537040717, -2.7397434710956263],
            [5.500648376767736, -2.759413622944535],
            [5.475868151039739, -2.7532256301498754],
            [5.4575835268853226, -2.7596873905002117],
            [5.444337974113685, -2.7776210061426436],
            [5.445455882175498, -2.809041326697483],
            [5.415759597499074, -2.8261342581412814],
            [5.39543402772036, -2.8123064624382614],
            [5.370929842243827, -2.8202428739885192],
            [5.360703149606246, -2.812721526888996],
            [5.335929009089313, -2.8294654679753517],
            [5.320936496194624, -2.8479583732915685],
            [5.324305973000426, -2.8803407007122077],
            [5.344065288258383, -2.9087093183927157],
            [5.367712465743685, -2.92112998794431],
            [5.38295487531454, -2.9176346070016015],
            [5.390568815191964, -2.9039265469909035],
            [5.404784367030851, -2.9007814505697493],
            [5.411478284623547, -2.9119621164179517],
            [5.4086028881590735, -2.9353623759803553],
            [5.38273172713855, -2.9552347822085996],
            [5.365758709061622, -2.9551345371580178],
            [5.334991432653819, -2.977397687215802],
            [5.330394125803919, -2.99041616159501],
            [5.3449602936179685, -3.017743123757364],
            [5.368891089529334, -3.024098460330265],
            [5.37890172334647, -3.0477464616611196],
            [5.37431950729646, -3.058939933532407],
            [5.3583745933983415, -3.061853026924107],
            [5.333598224230307, -3.0518498589561407],
            [5.3326552054116485, -3.033872542886049],
            [5.306644531233547, -3.0170054756591713],
            [5.291411051885051, -3.0179450706634974],
            [5.266841520788494, -3.0326222987098217],
            [5.2605318541685575, -3.0647347240375655],
            [5.266842335259122, -3.0858040149103743],
            [5.287787656803092, -3.1059428310928765],
            [5.299402731914894, -3.1252696995452713],
            [5.304173057918857, -3.1479054427739546],
            [5.289902019333033, -3.1592039010577295],
            [5.2687565032391435, -3.1690990480565335],
            [5.262241750072731, -3.1774539187566893],
            [5.246398584774655, -3.1480423118104115],
            [5.249434704496964, -3.1153099567296745],
            [5.239734803474753, -3.105164580219657],
            [5.216597829378364, -3.106540630665082],
            [5.207332892830098, -3.1175461720463047],
            [5.201274986546845, -3.1426301193073902],
            [5.170735120254985, -3.164938515675903],
            [5.16462779140876, -3.2023347840508847],
            [5.176600403308095, -3.212915756040929],
            [5.200450511966576, -3.2087376523275],
            [5.193346097601285, -3.1981409813993986],
            [5.192330580995959, -3.1786286120482594],
            [5.203111718869364, -3.171068433305277],
            [5.2176620635855, -3.1744488589164366],
            [5.244125760590547, -3.1969519500260697],
            [5.246738159599175, -3.2076224504275745],
            [5.233916760835127, -3.234737854376367],
            [5.225534372772084, -3.2795222567668207],
            [5.202067676051611, -3.2871882282572136],
            [5.187512122861303, -3.285395923033083],
            [5.181672028249333, -3.2941335940954835],
            [5.18169233468895, -3.3128999220747706],
            [5.194558566566675, -3.3308756222742724],
            [5.204787835288581, -3.333966912065266],
            [5.22264512553767, -3.329337819053689],
            [5.241673716818943, -3.3352272548261843],
            [5.258076801608323, -3.3617651063063523],
            [5.248628345520016, -3.371594080161885],
            [5.243331133302493, -3.3895489326323567],
            [5.226716882068638, -3.3954101441850755],
            [5.240807009459782, -3.413675380239237],
            [5.2682475505382325, -3.427191973667393],
            [5.271172835894298, -3.4463335555097196],
            [5.259138397995525, -3.4627378345783337],
            [5.23965751381092, -3.4658450455993033],
            [5.210510934427265, -3.4539309789645856],
            [5.190416893029014, -3.4647046792258496],
            [5.183450086056181, -3.4767286335934644],
            [5.181767710016467, -3.504161183634135],
            [5.187167475270384, -3.5128366220647576],
            [5.183546194066888, -3.5353694072146524],
            [5.164085706532367, -3.5649677541886766],
            [5.127680133143332, -3.5612899706228895],
            [5.116590517840582, -3.5530464695369712],
            [5.090676677103929, -3.556896935251568],
            [5.0818900148426955, -3.593200885754378],
            [5.084008686486994, -3.6001347696913455],
            [5.09514745774498, -3.6188511154665925],
            [5.116782988365072, -3.635412394437943],
            [5.137488602624768, -3.6442820493381003],
            [5.142119652714725, -3.683950907648612],
            [5.1311854202850125, -3.700455966997771],
            [5.083913728363234, -3.7258035852674714],
            [5.094196225314879, -3.734657908756431],
            [5.090753569961798, -3.75244683242496],
            [5.067849168096867, -3.7394038597318198],
            [5.0494515678811425, -3.756375186691486],
            [5.019880926752839, -3.773307124008814],
            [4.988354926078508, -3.77762786950724],
            [4.978582941118407, -3.763409905399381],
            [4.993520647703068, -3.735634536826128],
            [4.98672555714768, -3.719780524689356],
            [4.9653177129364545, -3.7119499881320897],
            [4.954480562344219, -3.7185234524406816],
            [4.9490190933915175, -3.7412796139963516],
            [4.9750863846065645, -3.782900653844193],
            [4.964192092884647, -3.791780377944393],
            [4.959550370071837, -3.8112166216706367],
            [4.9811179494252436, -3.8481711025004954],
            [4.985547103318911, -3.864598351190298],
            [4.964817310938494, -3.881151534901523],
            [4.937707401364169, -3.8829999955040875],
            [4.9243712842076075, -3.875931823349025],
            [4.947077090168552, -3.848377581386195],
            [4.9475116632568135, -3.8331673055542668],
            [4.922758178494381, -3.804921360028725],
            [4.907078781984206, -3.811981374588925],
            [4.902154970128785, -3.8248610808168015],
            [4.910556327204584, -3.852652721180347],
            [4.9065322779549225, -3.8693977505456485],
            [4.891906102337723, -3.8713542744561944],
            [4.886564834207052, -3.8968511916334605],
            [4.89685096505361, -3.8982225804675434],
            [4.919673230760283, -3.91162158120966],
            [4.9325573413663015, -3.9115674256666595],
            [4.966585580812984, -3.899802778257131],
            [4.977068719393465, -3.9205584069431327],
            [4.97300262521136, -3.9349497129806035],
            [4.935905531009702, -3.9764888499797792],
            [4.911056972841052, -3.9771830243231525],
            [4.904112657927084, -3.9628917637096905],
            [4.905340228232503, -3.949249560947003],
            [4.9146710673144876, -3.9314537862280075],
            [4.909343945962981, -3.9201108118051717],
            [4.889177825727178, -3.916193958460263],
            [4.891052159171566, -3.94337324650641],
            [4.88261437601013, -3.955114003434606],
            [4.876303667477034, -3.991710566989849],
            [4.8920259424327845, -4.0180861712186156],
            [4.921129653442535, -4.050934633829849],
            [4.920495289059059, -4.068820916763035],
            [4.890281796134515, -4.095264146158943],
            [4.882440160782598, -4.120919829774968],
            [4.882839217849645, -4.134248203504879],
            [4.898084254562553, -4.18005390955008],
            [4.892360661244268, -4.202334313278922],
            [4.871151304749615, -4.2225556736957985],
            [4.848834607470264, -4.225245887756581],
            [4.829549255274419, -4.259596451718515],
            [4.8390563483407245, -4.292877953419625],
            [4.822714982213404, -4.3030544029219175],
            [4.809879084097171, -4.294168431733281],
            [4.810267107706392, -4.277991689580522],
            [4.817701477745863, -4.2634978996512265],
            [4.8190244124823876, -4.244779867414086],
            [4.801149286036869, -4.254438022905789],
            [4.785319702800308, -4.257042967581486],
            [4.761108602332827, -4.250989420334748],
            [4.745629249781806, -4.26162160325176],
            [4.746661449564708, -4.272287016748724],
            [4.775064842142012, -4.306673562928547],
            [4.775005314071631, -4.329614675664453],
            [4.7535131166736315, -4.35069401422772],
            [4.711054007676041, -4.341808450828292],
            [4.697585100241031, -4.349157897551688],
            [4.693900595882872, -4.3856324945097285],
            [4.695951264233269, -4.407533902638132],
            [4.682358063319863, -4.413139760854988],
            [4.661655680583211, -4.409162400493219],
            [4.645585553171648, -4.396697254215832],
            [4.639663764249961, -4.382159946623994],
            [4.621078414804544, -4.382991806795533],
            [4.615057283548826, -4.3953183517370125],
            [4.617982635967379, -4.410011283852964],
            [4.635659436246891, -4.4313350854791915],
            [4.658397224689818, -4.44351227191633],
            [4.685332779621851, -4.437615209984178],
            [4.716551507261559, -4.439756006042653],
            [4.725101606923614, -4.4606240740612915],
            [4.7137545770206115, -4.479118408673898],
            [4.703016826197125, -4.485917231272546],
            [4.682977414029078, -4.485682166836734],
            [4.653964895260509, -4.465343365205865],
            [4.640907883756947, -4.461459284552124],
            [4.602637479722208, -4.4937014863627285],
            [4.603366975539632, -4.506781356720308],
            [4.613010225580126, -4.519217493359252],
            [4.635531204023074, -4.534175617438745],
            [4.658087061633837, -4.528663112293265],
            [4.672236508368703, -4.532816493865311],
            [4.677406605404235, -4.5443422752576605],
            [4.666100652551921, -4.567697050828647],
            [4.6672307988265525, -4.58710588888581],
            [4.659774505892314, -4.6015771838887005],
            [4.640882053785373, -4.606479471378574],
            [4.608809159549749, -4.602759366875647],
            [4.584583363002108, -4.611610964821591],
            [4.593564916120693, -4.633304652135413],
            [4.608560038787208, -4.649835419925263],
            [4.601873368742031, -4.668367251795604],
            [4.57758462303267, -4.665060192553959],
            [4.560155410123157, -4.628969201410329],
            [4.536252968372438, -4.640819700323662],
            [4.5200606455142465, -4.6284717790905985],
            [4.506991905472257, -4.626013736919994],
            [4.50199118330195, -4.643861871894352],
            [4.504044352310342, -4.670825685318781],
            [4.5137911002679605, -4.680818340419084],
            [4.5598904154517985, -4.689327388638883],
            [4.5711355225980705, -4.70042915234636],
            [4.55281220895354, -4.734893600862078],
            [4.525208726318624, -4.762006413680972],
            [4.5262956156012555, -4.78947526499844],
            [4.545214630006697, -4.8179606802924715],
            [4.559772725259044, -4.825482491510812],
            [4.581595313807168, -4.830114388174814],
            [4.593681276930345, -4.838977695502177],
            [4.594954136377533, -4.854797630010087],
            [4.587065031214126, -4.863473604770331],
            [4.56702696237168, -4.868353321121464],
            [4.543648374393348, -4.85597789117875],
            [4.498632037835188, -4.8649055341979075],
            [4.476931231729417, -4.854779378302165],
            [4.467426737069983, -4.907051905307149],
            [4.494712882173926, -4.931885142063886],
            [4.517270015457179, -4.9286121625446455],
            [4.541066713667978, -4.919578775632898],
            [4.552251737337648, -4.927218237489566],
            [4.567310250760014, -4.954105706091264],
            [4.562906671130702, -4.962469947708977],
            [4.5311657442292335, -4.9763309444988035],
            [4.51862989753532, -4.978379092739171],
            [4.4829309805582875, -4.961093767359801],
            [4.4591637966059565, -4.9323497425186575],
            [4.450669044124267, -4.936968567648434],
            [4.417994597273076, -4.940661868488944],
            [4.402923138651851, -4.957546489648481],
            [4.404368342809985, -4.97062141839783],
            [4.418905152795043, -4.984263054496089],
            [4.443629220587862, -4.9864843966327745],
            [4.462744101012219, -4.99617326654299],
            [4.482180674716267, -5.011280988536157],
            [4.4903637825641844, -5.0293463512877885],
            [4.484549790149479, -5.048007895251551],
            [4.4570900749663185, -5.071404266935603],
            [4.412751079115176, -5.0739538331544765],
            [4.40538423026318, -5.0835153790071805],
            [4.419330473997756, -5.111571714523304],
            [4.448652760069097, -5.132852715249247],
            [4.431509969818903, -5.172803689778622],
            [4.412956654577731, -5.185286772643186],
            [4.410958484158348, -5.203587843432587],
            [4.434704070658114, -5.207544345446573],
            [4.455060611607674, -5.19955647776222],
            [4.464399973074359, -5.187807294820893],
            [4.4566705251254755, -5.152809837654415],
            [4.468852059024284, -5.1419257027027845],
            [4.494039498748396, -5.156630636520012],
            [4.50382792081507, -5.170262119988641],
            [4.506790765391486, -5.19147236133745],
            [4.4910612870253805, -5.2116101981235055],
            [4.4608343568043525, -5.223161134260372],
            [4.441662556192729, -5.222781286841769],
            [4.434395109856604, -5.237892774487408],
            [4.449934606010602, -5.251164345819982],
            [4.471001301632963, -5.260062860903299],
            [4.49116740736537, -5.2586857497879755],
            [4.513826092938144, -5.24441280655318],
            [4.524878862660851, -5.22970461538973],
            [4.5273886104756285, -5.193969811125438],
            [4.546180044041544, -5.179766209925629],
            [4.557147250891754, -5.18855114669576],
            [4.558018343932458, -5.206411358485802],
            [4.541455239342544, -5.233416212396438],
            [4.524326673797735, -5.249831497941914],
            [4.509837702168275, -5.274046577815437],
            [4.492531180744079, -5.289806959684576],
            [4.4955753868595565, -5.339286570760016],
            [4.5098999290947335, -5.357909854426676],
            [4.508400439984557, -5.369781749086537],
            [4.524098632846556, -5.3916306201370485],
            [4.535630731504106, -5.39535578766345],
            [4.542920960484281, -5.36284230027281],
            [4.558057513671508, -5.348483601385161],
            [4.5739475755157155, -5.352060247121327],
            [4.578129093360446, -5.360032908389861],
            [4.573731442357986, -5.383779944108017],
            [4.545753496009764, -5.414888651028612],
            [4.5340200643354915, -5.4177159163644095],
            [4.5490790318079, -5.446080194038924],
            [4.553353724212625, -5.466005972376144],
            [4.55037688819819, -5.4993875317202665],
            [4.538922621443324, -5.5060621331651705],
            [4.496991313624659, -5.508634141280144],
            [4.488196098395871, -5.498526469604828],
            [4.468760211978355, -5.499033568935224],
            [4.454471346475759, -5.5183777176443485],
            [4.455599339075448, -5.531849509510021],
            [4.48020860212407, -5.551620719352647],
            [4.499604908999349, -5.55721684697406],
            [4.5218005910043875, -5.5741413998850815],
            [4.522549101690662, -5.5994521381380835],
            [4.512977092264224, -5.610085569287063],
            [4.493131741868275, -5.620005485285179],
            [4.49038541961474, -5.635746950419626],
            [4.378106153721363, -5.640376138986109],
            [4.265826496238728, -5.644991815220013],
            [4.106902607052829, -5.651891951707595],
            [3.900013280082617, -5.660010789404721],
            [3.836061071918249, -5.663049432473683],
            [3.723263526335187, -5.666851771363752],
            [3.610465673893632, -5.670640504476521],
            [3.4934349150543818, -5.673562275078724],
            [3.376404087668829, -5.676469420308467],
            [3.2544608354295317, -5.679415762517647],
            [3.1325174679408176, -5.682346244772846],
            [3.0928869954453466, -5.682465723826605],
            [2.9041072924274802, -5.68672009658165],
            [2.7642495600695454, -5.690687325735906],
            [2.5541100652306223, -5.696035763872276],
            [2.3605256909218264, -5.69986987795275],
            [2.227378347282711, -5.702949871078608],
            [2.0942305385462805, -5.706011006132126],
            [2.09151095763117, -5.564742451829376],
            [2.087057651568523, -5.365910792200888],
            [2.082780023528329, -5.171945902362996],
            [2.058996261346948, -5.170813930668637],
            [2.0630814387887733, -5.155638551091289],
            [2.049881932248935, -5.149300808295203],
            [2.019230880958327, -5.158430857525312],
            [1.995582836137128, -5.160218456877361],
            [1.9837590739081268, -5.137144779351379],
            [1.9657455450069916, -5.131695008891224],
            [1.9555545780686352, -5.14489303853454],
            [1.9435917652120793, -5.143689685198134],
            [1.9417894647889538, -5.163795926552832],
            [1.9314020970059507, -5.174243670206997],
            [1.9116342499097265, -5.170743630037739],
            [1.9206351022916128, -5.1505582301191515],
            [1.9048677522055364, -5.145043271083602],
            [1.8915145247990242, -5.169217136438536],
            [1.8848837968277403, -5.1549547967502125],
            [1.8714083607854202, -5.151957047923505],
            [1.862591933643558, -5.176735490942125],
            [1.844151122416056, -5.175379843510562],
            [1.8384574881254827, -5.161702477939862],
            [1.8267975058572767, -5.168395817859903],
            [1.8243775194029486, -5.185922276508394],
            [1.7965359232825546, -5.182788052062095],
            [1.7765940977365662, -5.160462345019935],
            [1.7622647347602243, -5.13887488186274],
            [1.7424335071751038, -5.138096192996021],
            [1.729407084548146, -5.1231649734569435],
            [1.7414187386373994, -5.115106071453628],
            [1.746324360763717, -5.095622274022462],
            [1.7153364813237575, -5.092739001057705],
            [1.7167918155194735, -4.878486670733559],
            [1.7187188081083935, -4.625748148014833],
            [1.7202754458358804, -4.3754243447936965],
            [1.7224836199564721, -4.0909699035473315],
            [1.7249202919865427, -3.828422019604886],
            [1.7285460132791441, -3.5351141580825134],
            [1.7281969888361746, -3.524934730058889],
            [1.7317678512252646, -3.3283051972032056],
            [1.7146743241780973, -3.2235736688541072],
            [1.7022818291296113, -3.1371845417112523],
            [1.6695909890927736, -2.921786401771558],
            [1.6489439673719268, -2.7836624342420024],
            [1.6147253231462617, -2.564516395762297],
            [1.592480239428368, -2.4157268496953335],
            [1.5642308322079228, -2.2149504691715425]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.43857563779447, "lat": 34.89989438415253 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "00068085"
      },
      "bbox": [
        1.5642308322079228, -5.706011006132126, 5.563511862341645,
        -2.082548253518219
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [14.780866502623573, -12.102984394118003],
              [14.780278389638324, -12.082364489623489],
              [14.789116858021318, -12.062895511450671],
              [14.811203029062101, -12.052541394256505],
              [14.797036477951858, -12.104308929992404],
              [14.780866502623573, -12.102984394118003]
            ]
          ],
          [
            [
              [14.10018941931926, -12.84862135807829],
              [14.130142971675514, -12.8348051021057],
              [14.142230289161684, -12.833022950430365],
              [14.162933466253508, -12.809272958451261],
              [14.17472833462575, -12.80233552133795],
              [14.185932523907004, -12.809645288141093],
              [14.21295993814911, -12.795274090143861],
              [14.23757744558998, -12.77222648806303],
              [14.26006808901411, -12.764995124312222],
              [14.216528609872011, -12.805244157180077],
              [14.19046989446696, -12.825162551135568],
              [14.179313435471316, -12.816717147205129],
              [14.15137699383316, -12.833129530104292],
              [14.141008176191162, -12.857113924218172],
              [14.118246190386389, -12.863898584720445],
              [14.10018941931926, -12.84862135807829]
            ]
          ],
          [
            [
              [13.96612950771471, -12.919287722637891],
              [13.982128601460746, -12.898137051643491],
              [13.99685920570976, -12.901388051868095],
              [13.96612950771471, -12.919287722637891]
            ]
          ],
          [
            [
              [13.738755987656608, -11.930170674780902],
              [13.750642544645357, -11.919490670601155],
              [13.756330657449697, -11.937919645645195],
              [13.740754417500455, -11.94065941565517],
              [13.738755987656608, -11.930170674780902]
            ]
          ],
          [
            [
              [13.498173730234699, -13.093049032797786],
              [13.510661826803112, -13.065036742145978],
              [13.534282855615144, -13.051590847824206],
              [13.547536070352145, -13.055260614239458],
              [13.571742757079267, -13.02601317453467],
              [13.56434115476062, -13.016484995637436],
              [13.52842811088263, -13.007140585872822],
              [13.535342717854336, -12.985298545362424],
              [13.580074372490277, -12.955671538694073],
              [13.603224370755175, -12.931050166032449],
              [13.677526526172137, -12.883831175087394],
              [13.686824299815871, -12.863309153415155],
              [13.695061411938514, -12.858162586449131],
              [13.737181969682915, -12.855967539435708],
              [13.747816385170974, -12.818919595820438],
              [13.767598809884836, -12.809751580448493],
              [13.79430090146928, -12.791685213362666],
              [13.79926999706053, -12.800307501991078],
              [13.785911011489214, -12.823654716400094],
              [13.794024094655216, -12.837012777262077],
              [13.820813277356669, -12.822146617127189],
              [13.831985042546759, -12.806126243012372],
              [13.864620872498461, -12.814462407045507],
              [13.871843222280539, -12.822904851678448],
              [13.875187941980037, -12.848601999822202],
              [13.902798020956476, -12.878793030447957],
              [13.923682602301575, -12.879935060584247],
              [13.939259977358196, -12.914604573074312],
              [13.951527305046683, -12.921744980025686],
              [13.924812335261509, -12.935516028836883],
              [13.90926127673376, -12.947210060203874],
              [13.867602263201729, -12.967785730544698],
              [13.85381480948877, -12.949116185637106],
              [13.815315108611744, -12.944240178838779],
              [13.784353985364856, -12.954355673453996],
              [13.761388187908516, -12.951283458409396],
              [13.76131835027199, -12.97935213672383],
              [13.719631312304426, -13.001240132762291],
              [13.715985734000173, -13.00736033838486],
              [13.681989299093493, -13.029608127249494],
              [13.647394650719383, -13.045679455485992],
              [13.628491831996703, -13.050092891259077],
              [13.61232988068089, -13.066657597364925],
              [13.56694166253589, -13.075152395161481],
              [13.506548282304276, -13.095998758880208],
              [13.498173730234699, -13.093049032797786]
            ]
          ],
          [
            [
              [13.18822773876532, -13.097991075404217],
              [13.205966526023305, -13.088494596472879],
              [13.22884522263621, -13.096894878869758],
              [13.232245672058037, -13.106565040599085],
              [13.216040742431954, -13.113631419789128],
              [13.210850037661347, -13.102724090248895],
              [13.18822773876532, -13.097991075404217]
            ]
          ],
          [
            [
              [12.828735501893727, -11.181094048133195],
              [12.837406105439646, -11.179804762010336],
              [12.87242558970726, -11.252927933920084],
              [12.894842909510071, -11.284908809958456],
              [12.91337263792708, -11.292209947987406],
              [12.928238738937301, -11.28862903337591],
              [12.971007241199004, -11.305949919953378],
              [12.99193332864017, -11.288218188710221],
              [13.021578007482201, -11.30108010761789],
              [13.037967371653753, -11.29931618504307],
              [12.997907294435036, -11.331288753464689],
              [12.987773301291053, -11.336099111934141],
              [12.966726469210935, -11.336290178370245],
              [12.939593186929047, -11.32907431072168],
              [12.917145927339869, -11.313447674363545],
              [12.893786211398133, -11.304809164691454],
              [12.8786154495723, -11.285781057274125],
              [12.850468819682682, -11.212390676304738],
              [12.83429501058218, -11.19898686796957],
              [12.828735501893727, -11.181094048133195]
            ]
          ],
          [
            [
              [12.782904469865992, -11.107838443634284],
              [12.785974699995405, -11.08774647956891],
              [12.809125629316167, -11.111199067917148],
              [12.807354443912578, -11.125462424063626],
              [12.819045640861006, -11.141564224373573],
              [12.81300214439034, -11.148912272487602],
              [12.782904469865992, -11.107838443634284]
            ]
          ],
          [
            [
              [12.049352597889806, -9.115091810814578],
              [12.062226824920822, -9.11081942282514],
              [12.079915067335286, -9.121083573043705],
              [12.071033322802142, -9.138980755629545],
              [12.049352597889806, -9.115091810814578]
            ]
          ],
          [
            [
              [10.263446751512362, -8.36277256909237],
              [10.274968843039245, -8.365908668216706],
              [10.28938363700438, -8.35626905688171],
              [10.306173167479589, -8.35384531317127],
              [10.32208302455806, -8.330462401500029],
              [10.339824886538842, -8.313120728646872],
              [10.346746370189631, -8.325168592166351],
              [10.340186702647344, -8.333952777746793],
              [10.307045710418317, -8.35533891789106],
              [10.27758656893788, -8.368045960461771],
              [10.263446751512362, -8.36277256909237]
            ]
          ],
          [
            [
              [9.917831482181484, -8.562340510933673],
              [9.944061931775906, -8.57607606769548],
              [9.98176640387295, -8.5844203541964],
              [9.991693941345348, -8.576783640825438],
              [10.019720519937454, -8.56819427673015],
              [10.046673017594921, -8.551188200376414],
              [10.063549057949059, -8.526976454337357],
              [10.08211538397579, -8.521052173793056],
              [10.115877104289346, -8.49318700098199],
              [10.123205108489246, -8.493239968602614],
              [10.165048617281549, -8.476565318942448],
              [10.169957939739808, -8.457030267044187],
              [10.184439667596521, -8.450670603127197],
              [10.195768992589386, -8.45698777259714],
              [10.168579377802033, -8.478271218825446],
              [10.123375042441292, -8.500334265914475],
              [10.09825793233971, -8.515680934931297],
              [10.040723376017043, -8.5604404640665],
              [9.967318827574811, -8.595767796022399],
              [9.919947376912038, -8.567150411772133],
              [9.917831482181484, -8.562340510933673]
            ]
          ],
          [
            [
              [9.803633193602574, -8.522410944506962],
              [9.82105832265087, -8.517220225962767],
              [9.860601106239145, -8.515684177528842],
              [9.895933022838316, -8.502679371643783],
              [9.913939721585121, -8.504433289369743],
              [9.926678801204266, -8.512867019437088],
              [9.917399947637067, -8.555604055152699],
              [9.897296960427123, -8.560920965993082],
              [9.87909196174973, -8.558983231023559],
              [9.86393714822052, -8.547116805834607],
              [9.835660534810998, -8.532386699100764],
              [9.803633193602574, -8.522410944506962]
            ]
          ],
          [
            [
              [9.840603025130743, -7.1983393089815815],
              [9.842457894162326, -7.225388506011801],
              [9.861627135854775, -7.231072078012681],
              [9.864010447367727, -7.259445027021166],
              [9.91230981486412, -7.309037724950838],
              [9.909270783571126, -7.319805248875104],
              [9.923549548563491, -7.350488853706978],
              [9.91677847335867, -7.369600513254285],
              [9.938274000607551, -7.409953757468577],
              [9.94428231721928, -7.433779757111859],
              [9.960126850178332, -7.434940273880553],
              [9.991459177131954, -7.470374028573082],
              [10.015718860641094, -7.4683730149498],
              [10.14299219620664, -7.46027128270762],
              [10.270265413231582, -7.452139766706247],
              [10.326061570282386, -7.449404102355674],
              [10.411149663721917, -7.442080828925933],
              [10.547306723640414, -7.432829654188686],
              [10.683463518680517, -7.423544214074665],
              [10.83516953922286, -7.413315006911473],
              [10.950421626836949, -7.405802841338658],
              [11.065673792646681, -7.398265991027005],
              [11.16152879066079, -7.391347020426482],
              [11.319758362272346, -7.381379924312351],
              [11.477988504390911, -7.371366046262535],
              [11.587054237345304, -7.363798794236887],
              [11.696120024636, -7.3562092213439065],
              [11.849296483674246, -7.34574754011096],
              [11.960583102496214, -7.337457610243826],
              [12.112835909446822, -7.326945249534485],
              [12.265089131687022, -7.316389030491824],
              [12.250173035089835, -7.330601407721538],
              [12.247813520043852, -7.349850247239559],
              [12.259295902247253, -7.368710591928898],
              [12.288595190871506, -7.396781389775022],
              [12.28681454439543, -7.421805066633775],
              [12.292310447688479, -7.437070919045117],
              [12.289818503705728, -7.457430156795465],
              [12.298418049102592, -7.479536598035349],
              [12.333620989221263, -7.516993589104293],
              [12.387828762368809, -7.499672261795722],
              [12.397575105064533, -7.505816817743329],
              [12.420093865638627, -7.504127159751882],
              [12.437061866616908, -7.497544140091437],
              [12.444095096141647, -7.474399905811563],
              [12.437892734798083, -7.463707335147968],
              [12.43573509600477, -7.426184828660339],
              [12.441503637673321, -7.412403168674313],
              [12.446316686837982, -7.383885893799837],
              [12.44330429271654, -7.346223309826689],
              [12.438230204127459, -7.336098412137616],
              [12.439176664998874, -7.309568734262739],
              [12.4437839518552, -7.295420748503505],
              [12.43369760630306, -7.2664735587885385],
              [12.419279245150566, -7.256149421084723],
              [12.415654378463442, -7.240925049023862],
              [12.392869209720763, -7.210373831978726],
              [12.3890466920917, -7.1901060331380435],
              [12.396484632618149, -7.158530309580386],
              [12.38617529362818, -7.138025835656383],
              [12.38916793345258, -7.1114866596755775],
              [12.397820444588367, -7.11354058402497],
              [12.409501959249186, -7.1002849505778425],
              [12.39646637073588, -7.081991771919339],
              [12.410880069992022, -7.071124319042277],
              [12.430911680849345, -7.08151704752218],
              [12.439267600845085, -7.07957659377383],
              [12.44592949913459, -7.056295530101713],
              [12.441537150613673, -7.039733049270616],
              [12.461247095919685, -7.026018234824691],
              [12.472855826147724, -7.035637176847295],
              [12.486736648663687, -7.035034045632782],
              [12.492716438767156, -7.020264378862874],
              [12.50264835247749, -7.026289513779135],
              [12.51406630904633, -7.047287743583118],
              [12.526323845957565, -7.052577147978213],
              [12.538560969497139, -7.048967984802938],
              [12.551841627883872, -7.055068517826752],
              [12.578255335754026, -7.047588197326407],
              [12.591543249175404, -7.050274348651243],
              [12.600972034048423, -7.061541752752251],
              [12.612234538652745, -7.055592850332649],
              [12.63904358333666, -7.065177351800867],
              [12.647404276535969, -7.077118211047381],
              [12.659227527412515, -7.081231450452506],
              [12.67997476934103, -7.074307888888675],
              [12.70000787952264, -7.080829514144209],
              [12.70571178444316, -7.064403821588493],
              [12.717815339218577, -7.076390153807533],
              [12.743930234862761, -7.088542824435564],
              [12.75970111910462, -7.091177634100929],
              [12.766503949757087, -7.082538564382243],
              [12.786516974115251, -7.0844487768161795],
              [12.799159765892377, -7.093244424746787],
              [12.822306689133223, -7.07711266938624],
              [12.857292551937778, -7.069884792092417],
              [12.870704524602667, -7.079256938386072],
              [12.898283094300744, -7.080110493388119],
              [12.915193045673545, -7.086842152502939],
              [12.916909163478588, -7.11641209588417],
              [12.916745467912914, -7.186308018071917],
              [12.92019364973348, -7.216868705429119],
              [12.933409921674063, -7.259525400152491],
              [12.917208996833242, -7.265494206029794],
              [12.918275877966023, -7.274604769474334],
              [12.942270458582753, -7.297241175542839],
              [12.959247138925386, -7.298977896983191],
              [12.970991137663356, -7.345720483202269],
              [12.969054765526245, -7.35782976784683],
              [12.989412361777978, -7.3821921488507245],
              [12.988387292027259, -7.398501334978156],
              [12.996971020428672, -7.445839695006836],
              [13.021379275735946, -7.516738977254807],
              [13.057453769250131, -7.605877566171765],
              [13.103575752937946, -7.729420919317066],
              [13.126988933759192, -7.7890781584795254],
              [13.152483233820398, -7.839597683336759],
              [13.164127740568127, -7.849036591681246],
              [13.180082636823583, -7.8902930565356],
              [13.193601537894954, -7.94252368053002],
              [13.203888090049936, -7.970423205181902],
              [13.25716793564909, -8.072231100956097],
              [13.315726374042955, -8.175180914022347],
              [13.362421991799218, -8.248883557580504],
              [13.40866733991117, -8.325091741397902],
              [13.454922260145048, -8.401265487960712],
              [13.502180992995184, -8.473865896959737],
              [13.54944962861878, -8.546433638542453],
              [13.574113200510167, -8.579659363766579],
              [13.610461822701042, -8.613863478565397],
              [13.647143448651066, -8.667400086327614],
              [13.697305227113377, -8.72758492663764],
              [13.747477231974333, -8.787743760391919],
              [13.790411272840373, -8.840138415235723],
              [13.833352944295369, -8.892513275289152],
              [13.900125786024134, -8.960529516937367],
              [13.933550170846537, -8.998408401103914],
              [13.978417864936075, -9.040320251752012],
              [13.9987504103616, -9.091551339899487],
              [14.007380934874536, -9.10704501430031],
              [14.041454373015181, -9.15578772674168],
              [14.03966814778393, -9.165816222916144],
              [14.011624578486115, -9.184227025814208],
              [13.994156845018878, -9.214913563461417],
              [13.989261378464766, -9.2554448973477],
              [13.99028536790353, -9.284221794578746],
              [13.99659811623471, -9.325692711405168],
              [14.00668618707559, -9.36778057247505],
              [14.023807261052282, -9.421521981617055],
              [14.056724497151032, -9.50016996006692],
              [14.068371762029493, -9.523748003463158],
              [14.108371605167841, -9.589356091780171],
              [14.15354750836105, -9.654829133776822],
              [14.206418004310445, -9.724441391757198],
              [14.243828757430558, -9.781275984267078],
              [14.280874787771667, -9.832435628163363],
              [14.307435625973616, -9.884291637161146],
              [14.336767021447802, -9.947497038378893],
              [14.351515134441286, -9.965098219057507],
              [14.379926654243535, -10.030813789913422],
              [14.40671436147388, -10.07709187162785],
              [14.408090843324938, -10.084592137451537],
              [14.445572497054485, -10.150089752401533],
              [14.47886551688988, -10.197269352563918],
              [14.487892952766334, -10.214214701781525],
              [14.529597367429018, -10.279964182380239],
              [14.566831479313446, -10.330090190909328],
              [14.577851309033024, -10.351581266020101],
              [14.575180928786114, -10.358149607771418],
              [14.606321800796886, -10.41374682520241],
              [14.626173940407972, -10.43966781857439],
              [14.655278244933918, -10.488173229153938],
              [14.694862839464324, -10.574513187492846],
              [14.723841399305213, -10.634630524899102],
              [14.747482862468972, -10.692966789184489],
              [14.750718230569783, -10.714895037153026],
              [14.747058351193605, -10.722730979903874],
              [14.759425915156493, -10.771662183045233],
              [14.767466865291563, -10.838348011543895],
              [14.775395464298409, -10.880002191547334],
              [14.779629250793272, -10.935782041470471],
              [14.778204259185253, -10.971496958528158],
              [14.780857218216207, -11.04669693274593],
              [14.788893278180534, -11.140668851791578],
              [14.787650494667602, -11.15844256697825],
              [14.793131181648498, -11.216668734735148],
              [14.789751212788437, -11.234445386406563],
              [14.793304543989622, -11.338536213367378],
              [14.798146795804499, -11.377016139279402],
              [14.795506233956331, -11.382551871627387],
              [14.80496575878383, -11.482950036992621],
              [14.815629327351429, -11.568445091302124],
              [14.826835439297907, -11.618050319163347],
              [14.830197396882978, -11.649430264228434],
              [14.828291018372479, -11.692468127025881],
              [14.820348868785072, -11.72152002071008],
              [14.817774843066891, -11.764240116906864],
              [14.824856141990788, -11.789544604966343],
              [14.80050474016764, -11.778798909866149],
              [14.807499666553383, -11.763412122403684],
              [14.801115545543372, -11.756126161043207],
              [14.815183120246855, -11.740393409531906],
              [14.789327439119647, -11.722203891252569],
              [14.762828577812154, -11.726996551802472],
              [14.739506263207709, -11.748882895999161],
              [14.731659381263196, -11.76377513879878],
              [14.737704492538784, -11.77749324642667],
              [14.724189659163768, -11.818451944964485],
              [14.723222023726008, -11.8380475711297],
              [14.713474726001246, -11.85842733832316],
              [14.702482248924188, -11.858696516702999],
              [14.695805254835323, -11.876858177934533],
              [14.70669253831925, -11.906930722500102],
              [14.701927775741158, -11.942668493361788],
              [14.687802734844256, -11.952755291916318],
              [14.684890780803096, -11.980695640665992],
              [14.68991463859522, -12.011626561023977],
              [14.707352335738037, -12.038164578491848],
              [14.71234624272044, -12.07766157220092],
              [14.727528575130549, -12.083893825583257],
              [14.732027444821998, -12.097728490265084],
              [14.720244580483802, -12.115380107382826],
              [14.709711817385973, -12.1420918577388],
              [14.685779887963687, -12.154138227677802],
              [14.683389844663653, -12.175131340836753],
              [14.668503520326748, -12.202430975472986],
              [14.673200741108163, -12.239250747749665],
              [14.661226026996788, -12.244030993172354],
              [14.658801805433514, -12.267476654339326],
              [14.664369793046061, -12.279525558848423],
              [14.678969201817464, -12.283691318703031],
              [14.703609921488086, -12.26579414447537],
              [14.720570633632644, -12.261788039599773],
              [14.731865517708355, -12.227734705536236],
              [14.730241286438698, -12.20588836291605],
              [14.717215521610598, -12.194739989545385],
              [14.747180134667948, -12.166308574403088],
              [14.766088382131796, -12.135668612331866],
              [14.774551750471568, -12.111416191865395],
              [14.789018598320117, -12.120393609114336],
              [14.785272638122173, -12.136340026385959],
              [14.771731545885181, -12.152809304276856],
              [14.76720984058959, -12.1792358022297],
              [14.753227887436399, -12.209008228075184],
              [14.748857401326463, -12.226474336325202],
              [14.735639169814313, -12.250876461385337],
              [14.730949194891826, -12.271958617318191],
              [14.718630762239792, -12.29189898394745],
              [14.725864241538616, -12.297464430833875],
              [14.724545982210484, -12.31433636006433],
              [14.71483757141779, -12.31915383803679],
              [14.711122682337132, -12.338912466322986],
              [14.694244468063946, -12.363026571453007],
              [14.673035782117976, -12.370455830371265],
              [14.660179918533117, -12.400132382649485],
              [14.64460393134687, -12.408597985241444],
              [14.620521423686249, -12.443056808973077],
              [14.625606166016778, -12.450845502544889],
              [14.605558241411021, -12.479709467696985],
              [14.592465595217153, -12.487227547107747],
              [14.578737000376824, -12.515535587351634],
              [14.56543149490344, -12.534043735957583],
              [14.540564683677744, -12.545183998690232],
              [14.536330707511787, -12.533997318287483],
              [14.564204050598327, -12.527188523944652],
              [14.574447470833096, -12.51331210785681],
              [14.579075865370406, -12.474004813348687],
              [14.60424240811784, -12.469231407563631],
              [14.616394064671704, -12.4357169355412],
              [14.6245386220594, -12.428714450763025],
              [14.663992477651473, -12.36854662555294],
              [14.653398313159048, -12.356148699091953],
              [14.634673575127923, -12.349167105799431],
              [14.637086505913034, -12.339844445256972],
              [14.629764124953146, -12.3229293840031],
              [14.642760974411258, -12.296489803183968],
              [14.634658756012405, -12.285035128098746],
              [14.618165496864478, -12.274245335123958],
              [14.605260523581375, -12.27435721903834],
              [14.591425066456928, -12.284910181622394],
              [14.567800666227663, -12.27171762690081],
              [14.55977548224089, -12.280454335930797],
              [14.513049175255501, -12.292171556551978],
              [14.513396425567501, -12.301482077996544],
              [14.49726355500628, -12.314738199468517],
              [14.489939060974404, -12.30318699746467],
              [14.464920484225349, -12.319425595054659],
              [14.452528719406653, -12.319330148383315],
              [14.444483422454347, -12.3363560664867],
              [14.42912553019866, -12.341041935182071],
              [14.406193644978716, -12.366773982731418],
              [14.394393596762875, -12.361083230591158],
              [14.365739221724663, -12.36671115582146],
              [14.324092517208076, -12.368704380960502],
              [14.326008278406666, -12.352012387058606],
              [14.307397034946458, -12.352165475527205],
              [14.313826267957323, -12.364657247462382],
              [14.30022904835759, -12.374871505848208],
              [14.292196323753231, -12.364445012123296],
              [14.277494461020483, -12.36181473147991],
              [14.260044137179158, -12.366213974935294],
              [14.233368007631045, -12.384003026632941],
              [14.236402891998967, -12.40539265232556],
              [14.22226728547046, -12.406008075709448],
              [14.198651679611407, -12.416399607717427],
              [14.172902150552721, -12.420887223633196],
              [14.149617600173936, -12.434024528832238],
              [14.127270313152438, -12.432441773002912],
              [14.10254839860991, -12.43736874054514],
              [14.074170698559524, -12.45356075645597],
              [14.044305661885497, -12.429566763891659],
              [14.016227150239667, -12.422442189324862],
              [14.011085546228392, -12.398010378834302],
              [13.995285974909546, -12.375911119635681],
              [13.978132956481462, -12.364689232663821],
              [13.975260132407747, -12.318503427842726],
              [13.977925501249914, -12.290098027040992],
              [13.983172645745764, -12.282495037975485],
              [13.980561874859879, -12.264093492815041],
              [13.988713792051932, -12.246842072711763],
              [14.005949736994928, -12.246501041869479],
              [14.00719261307472, -12.230455494290368],
              [13.999119755559112, -12.225574287585],
              [13.998247689141696, -12.208190032021923],
              [13.972216766121042, -12.204236320699742],
              [13.972628518363893, -12.187493780485667],
              [13.958955277702852, -12.160040451396075],
              [13.94745583496589, -12.145770147108324],
              [13.9438178848015, -12.128107900832973],
              [13.923152133083997, -12.120279693068888],
              [13.900518338088657, -12.098525863321969],
              [13.902159398646184, -12.071175038670535],
              [13.894406368347859, -12.058209487765074],
              [13.869450562084866, -12.042153950467359],
              [13.857516968488973, -12.020982387741503],
              [13.856370380529533, -12.007300080367987],
              [13.828368050873557, -12.0039245364001],
              [13.823025017708982, -11.981066346987076],
              [13.80569682615141, -11.968211954289192],
              [13.800245870078642, -11.936510148890733],
              [13.778497041826077, -11.924725492833618],
              [13.760767033165473, -11.919840151275807],
              [13.735590314369462, -11.905945846932433],
              [13.729190087860731, -11.894107519461935],
              [13.708540847181109, -11.889989568721541],
              [13.704973570476454, -11.864712641562654],
              [13.673411625594635, -11.860835373145887],
              [13.663952647937764, -11.853077692727016],
              [13.647505400174873, -11.850164542335653],
              [13.632883757767674, -11.853816119702326],
              [13.625368222236775, -11.841672438123261],
              [13.59630722507635, -11.826844935969424],
              [13.568036308349232, -11.821174364972391],
              [13.555445105290083, -11.807749650914863],
              [13.519521434857193, -11.804324872453199],
              [13.486623239893522, -11.783266124561328],
              [13.470980566501996, -11.786993776335102],
              [13.451073503757707, -11.775470833937321],
              [13.42590306730494, -11.80759597835265],
              [13.432413817347582, -11.816573150232102],
              [13.42769984853522, -11.832964653678875],
              [13.416540045536951, -11.832314299841823],
              [13.382820811165645, -11.78316324355584],
              [13.372252440353567, -11.783279374767679],
              [13.366768899067367, -11.762415792741487],
              [13.341802496117461, -11.740799805571767],
              [13.349714315866816, -11.727050615265387],
              [13.34241499336792, -11.707016272783036],
              [13.328377534749459, -11.694936177364559],
              [13.314780334095508, -11.670497285637314],
              [13.280536893494414, -11.618233540794241],
              [13.265217124653201, -11.560745320554023],
              [13.256960429032816, -11.54141228785425],
              [13.242162910677777, -11.481136331734817],
              [13.222501099471202, -11.427238636073186],
              [13.207413286747542, -11.396824925816176],
              [13.17809940625506, -11.351045517496656],
              [13.144100886006335, -11.324107799454454],
              [13.131490609944798, -11.307966643772518],
              [13.089437060393848, -11.291297778173641],
              [13.086910906494984, -11.27744267364218],
              [13.074030900264928, -11.270015521865954],
              [13.033970115206547, -11.265643067255956],
              [13.037352954562955, -11.255054422555082],
              [13.033130450678987, -11.218990240234676],
              [13.005133290288493, -11.231684924235534],
              [12.997731664167759, -11.218800665896604],
              [12.984569535868662, -11.212272209867136],
              [12.976489345710824, -11.226207463225695],
              [12.980300224264502, -11.247208673726114],
              [12.99355782018659, -11.264749954846685],
              [12.968302565678528, -11.272591912323971],
              [12.949636371433158, -11.27342107609336],
              [12.95207794337613, -11.254010931924801],
              [12.939472487376305, -11.239301199362242],
              [12.926184896051158, -11.214228868640642],
              [12.920529271937273, -11.188056600401222],
              [12.909731860827698, -11.16226199779176],
              [12.903463862136835, -11.160811832989632],
              [12.892260387369726, -11.140881493060824],
              [12.895472092218855, -11.131134761334591],
              [12.855284637759464, -11.09969680711897],
              [12.851581369269661, -11.08712775895748],
              [12.85872887977489, -11.075644546205039],
              [12.872447883060126, -11.07199855991665],
              [12.902366495879072, -11.075364294526475],
              [12.91741533372164, -11.090820442834234],
              [12.934005636874982, -11.123562340710976],
              [12.947927690459858, -11.114018738206441],
              [12.937766309357784, -11.102519503954749],
              [12.938285770201356, -11.067342071065191],
              [12.948823972570093, -11.026166883532449],
              [12.953849459232423, -10.954765107304299],
              [12.94640095809601, -10.93750394016501],
              [12.944822736980182, -10.90619974101468],
              [12.934430794100402, -10.892507915007197],
              [12.909818679356876, -10.888019117487438],
              [12.896773196720652, -10.864289658110755],
              [12.903981259769173, -10.850219957021233],
              [12.920939977076484, -10.847693463977969],
              [12.931555014914391, -10.83430799005396],
              [12.918463494377216, -10.82178537504719],
              [12.869811972833897, -10.820203645636026],
              [12.875171522090856, -10.831294665511287],
              [12.856066605414211, -10.86088344210545],
              [12.844499663043464, -10.861622847089265],
              [12.824526094293383, -10.847895220674717],
              [12.817362189077304, -10.854777119149198],
              [12.82112512686078, -10.868447027000506],
              [12.855538590047143, -10.92995939202812],
              [12.872326221961949, -10.991721698052151],
              [12.850949648911232, -11.01340762445297],
              [12.82832416281796, -11.013731610837928],
              [12.822143640991953, -11.022980979543291],
              [12.798787736194374, -11.019848394008639],
              [12.782816327113382, -11.030077882964193],
              [12.779035788252733, -11.06500796218489],
              [12.76226219531869, -11.011610459308768],
              [12.74774785034618, -10.994439084949981],
              [12.746194853520716, -10.983048038587656],
              [12.698984579777354, -10.929187200985291],
              [12.681706327257556, -10.914686494729798],
              [12.61725387173064, -10.834837643439078],
              [12.60655619559019, -10.817050930028504],
              [12.566530440127382, -10.767345112025385],
              [12.527409505779504, -10.693334917060488],
              [12.501575506597788, -10.658148920599725],
              [12.475277984768516, -10.61464272550209],
              [12.450258500490728, -10.585911931264546],
              [12.432319079825135, -10.579703149781924],
              [12.425878432333898, -10.571129077098416],
              [12.423645604629268, -10.552543327535439],
              [12.400801547415133, -10.526326439879792],
              [12.366457452386767, -10.497686787279182],
              [12.32654644218747, -10.453447134909947],
              [12.297901688084428, -10.435869176152922],
              [12.29570051574944, -10.42637531082106],
              [12.274843737026838, -10.386485731410682],
              [12.25649825966952, -10.36332431818225],
              [12.237758224278364, -10.34864156151969],
              [12.23712509476574, -10.340548903646445],
              [12.269723591487077, -10.352110239631504],
              [12.274228254810836, -10.375895407915596],
              [12.288981523434153, -10.375828118632917],
              [12.299701187141798, -10.351406117107494],
              [12.32824057718626, -10.341611255060883],
              [12.332756369815195, -10.314876359081481],
              [12.347726156580185, -10.293678533403165],
              [12.346028758214066, -10.280015994844318],
              [12.374239278426938, -10.26195506789598],
              [12.382359477947483, -10.244833143616319],
              [12.3854196233204, -10.221680482186162],
              [12.415003112988385, -10.151300026347771],
              [12.430171065229091, -10.135923127018152],
              [12.445501324072096, -10.129085146577518],
              [12.440885708222773, -10.107392591018215],
              [12.470695601421731, -10.091998758312931],
              [12.474220703102251, -10.07379965273345],
              [12.486335262281784, -10.055262632033825],
              [12.491422992566125, -10.036376119954628],
              [12.505900063510087, -10.021314224576745],
              [12.49240729819896, -9.98665865258563],
              [12.488141106946287, -9.9656138329805],
              [12.474461902233514, -9.9499329843272],
              [12.459244017930372, -9.95360532004536],
              [12.43232633061071, -9.946632731183358],
              [12.429815261248267, -9.919898056487717],
              [12.40577134577992, -9.940383910964579],
              [12.411251742363524, -9.96393448252882],
              [12.418576495521194, -9.968813696086915],
              [12.41547599809289, -9.995135812448204],
              [12.435529698749415, -10.012014619515005],
              [12.435295758528351, -10.03259339880905],
              [12.400462584439886, -10.03209600176908],
              [12.3762669939593, -10.022843411937638],
              [12.358913864824602, -10.003565754441464],
              [12.37636119453211, -9.992189567581718],
              [12.365416534622637, -9.927494540404505],
              [12.354724168451094, -9.923914907388511],
              [12.353427065559643, -9.91170040765598],
              [12.343384989652582, -9.902374096732098],
              [12.298678514630982, -9.89346367790724],
              [12.265480717594762, -9.87472162378177],
              [12.26046821031994, -9.86459435838669],
              [12.247611992641255, -9.866411335373147],
              [12.226181224507359, -9.853375148595473],
              [12.21547385344969, -9.860271658121595],
              [12.23125914371567, -9.879920655576832],
              [12.219250653607068, -9.903018331137034],
              [12.219088092269246, -9.923370089175933],
              [12.197750699518254, -9.934952918359981],
              [12.201358969815491, -9.952743645667521],
              [12.236082586729266, -9.968069419615732],
              [12.277925151620549, -9.97334461517063],
              [12.279707749861021, -9.984715186755448],
              [12.300533843280233, -9.993759612735952],
              [12.319627270814424, -10.014139719587208],
              [12.334537540833336, -10.050265243002382],
              [12.32687760872207, -10.056614747097097],
              [12.321077022055945, -10.078018942335934],
              [12.308111465945302, -10.083486968757379],
              [12.310766269216613, -10.11165576020987],
              [12.305914266360515, -10.118736354511197],
              [12.31389452243306, -10.144254261479832],
              [12.30470619035609, -10.168399756650864],
              [12.294025304942458, -10.173449833739946],
              [12.276428231444232, -10.170354002797112],
              [12.261915464850327, -10.178739849679653],
              [12.252345647192728, -10.171528176625134],
              [12.241424131185182, -10.175748569220241],
              [12.236795647005978, -10.189606932762336],
              [12.236615972388662, -10.218970248915754],
              [12.242170544247886, -10.22268939820772],
              [12.258211167601784, -10.25263136423765],
              [12.231792339594788, -10.268823938777876],
              [12.231096344143234, -10.256795310761511],
              [12.218733276830244, -10.22993133803002],
              [12.22071889566643, -10.200069736064455],
              [12.217837061079909, -10.177583476098222],
              [12.207014000321719, -10.15593640347199],
              [12.192362877908518, -10.143099066269091],
              [12.181043853759439, -10.123807527139812],
              [12.159975060945731, -10.102184163191708],
              [12.12222717207879, -10.076479697727306],
              [12.102024097772638, -10.047520091847144],
              [12.092713705523805, -10.01743196661177],
              [12.094276530619974, -9.969781913263697],
              [12.100053922720274, -9.938668616802456],
              [12.095344857363294, -9.884146388235937],
              [12.113908669336741, -9.89511231875998],
              [12.107758390215585, -9.905733765556159],
              [12.123248269721604, -9.933972342716483],
              [12.12809102106437, -9.893159504062568],
              [12.128440352300798, -9.852017871364756],
              [12.095811307791893, -9.850438811400885],
              [12.084127075185423, -9.842432857646642],
              [12.07800304835987, -9.827680282942028],
              [12.087599065699196, -9.82288566248161],
              [12.091630783430855, -9.841430515979914],
              [12.115258323233743, -9.849172615660764],
              [12.125610051901093, -9.835268560242103],
              [12.12506149103943, -9.779460307784584],
              [12.100938962424353, -9.732434868763345],
              [12.09888079869978, -9.717396241204211],
              [12.107395850742359, -9.711063025281007],
              [12.109492983554588, -9.69642286003147],
              [12.120343498598645, -9.694655176861707],
              [12.129883190148535, -9.673154878788823],
              [12.136135939216322, -9.61849037155434],
              [12.137893384327686, -9.57579694966692],
              [12.148717279794752, -9.55395200120886],
              [12.146111250488522, -9.54637215754787],
              [12.157334645408772, -9.523633974267275],
              [12.150863712337937, -9.513233203451435],
              [12.157680728629092, -9.483474634355058],
              [12.176654301610583, -9.463090795425927],
              [12.16499143540623, -9.370147331832344],
              [12.176983597265163, -9.358971753047419],
              [12.16612460424007, -9.347549003278294],
              [12.175751303831731, -9.340044657230544],
              [12.168710527540961, -9.322715485905047],
              [12.16538174967041, -9.28528392869396],
              [12.148370876085808, -9.27251528227721],
              [12.138904263213849, -9.247843474647285],
              [12.155765095397099, -9.225574296776148],
              [12.143358552139821, -9.218913562137368],
              [12.13513051722587, -9.20521421552144],
              [12.12077591822356, -9.203718055239651],
              [12.096383426328035, -9.18197888109583],
              [12.108396794795253, -9.159775107374665],
              [12.105331600001453, -9.133863717330623],
              [12.107816805348646, -9.118794218246286],
              [12.087921817922043, -9.110778342589724],
              [12.062211396566475, -9.089349872757948],
              [12.069821989680372, -9.073900030365593],
              [12.062635281721972, -9.062011814063437],
              [12.065145430737333, -9.042686631991362],
              [12.08782292559333, -9.032318225656464],
              [12.096257521100759, -9.024175713607981],
              [12.094244526897954, -9.004421649795477],
              [12.081376475143724, -8.99249606037223],
              [12.0543775038111, -8.953562457048816],
              [12.037703784314143, -8.947942694380208],
              [12.015927757372868, -8.921550453249578],
              [12.021351599381676, -8.894103755870711],
              [12.008590916777138, -8.86794387579029],
              [11.996653770778343, -8.866696908468498],
              [11.98945239739408, -8.85588994917913],
              [11.974478149011942, -8.85226911288202],
              [11.96113376308284, -8.856074653317922],
              [11.957299020847517, -8.827672427695083],
              [11.967046931346202, -8.811783192088978],
              [11.960031643361317, -8.803789246051025],
              [11.960338641078904, -8.782797346538104],
              [11.950209826081615, -8.768363470069625],
              [11.933673753773519, -8.77820373639452],
              [11.911917732937622, -8.773865191406346],
              [11.89654284470884, -8.778829751170951],
              [11.85511606599338, -8.7741860913952],
              [11.835743344705117, -8.77877694404141],
              [11.78876507556087, -8.778897707762882],
              [11.787071750709297, -8.795881695923185],
              [11.77840520380264, -8.799844705490163],
              [11.774140277257137, -8.815436409355344],
              [11.756692613354684, -8.819666467131121],
              [11.744587108203005, -8.828963419037144],
              [11.731299091004814, -8.807614933588704],
              [11.728244469712159, -8.782350963511542],
              [11.708219429085192, -8.754532623294773],
              [11.705605381224698, -8.739776384097086],
              [11.709648605774532, -8.70866530689823],
              [11.690097419580603, -8.694344647757346],
              [11.6646982916465, -8.691285815989609],
              [11.628545645127874, -8.678222044750747],
              [11.618975476225422, -8.666464615361464],
              [11.631954459667373, -8.652441847595588],
              [11.617158322350335, -8.646575474091982],
              [11.608315311832953, -8.629165378879662],
              [11.582752423711126, -8.5980547644917],
              [11.582708573655367, -8.587026632204664],
              [11.565716815253376, -8.563292962266976],
              [11.544650962185798, -8.553452181569458],
              [11.510331503487063, -8.557794154584073],
              [11.494391699119085, -8.5458479701982],
              [11.481786548110756, -8.526223977934784],
              [11.460783423144989, -8.52229386436815],
              [11.435476104945902, -8.501393204709117],
              [11.415553994058563, -8.500378425814416],
              [11.398321288920751, -8.479946549198383],
              [11.382636355308762, -8.437856464424955],
              [11.380464483671487, -8.420193605457957],
              [11.383642672476107, -8.395406737405944],
              [11.372710450991445, -8.35954050656229],
              [11.36378306119088, -8.34750350677938],
              [11.34346000486701, -8.336369997370406],
              [11.33346618046055, -8.339815975362127],
              [11.301202531293018, -8.331114858730547],
              [11.290016111411264, -8.308138910298448],
              [11.280266787247742, -8.308384640420565],
              [11.24536448994469, -8.298530966171185],
              [11.228368959776063, -8.285885145140702],
              [11.220769786756104, -8.268499369614982],
              [11.208735965500818, -8.263130412585872],
              [11.197973585656163, -8.24966547930012],
              [11.20311258906969, -8.24020598550056],
              [11.195302646752685, -8.227968712794214],
              [11.19536797913533, -8.214365156784774],
              [11.165048817042898, -8.194931057923746],
              [11.142688563240844, -8.154131931742757],
              [11.128184760207892, -8.147436898694684],
              [11.101321264009114, -8.124006330129074],
              [11.058380965743636, -8.110155116437404],
              [11.04038683463897, -8.095617504145208],
              [11.001526797001704, -8.081458784837917],
              [10.98525544979562, -8.083809213715913],
              [10.966437983540025, -8.079738855968142],
              [10.950174524538257, -8.066940100471248],
              [10.876951290083815, -8.039755558748709],
              [10.870144982711533, -8.031015105133555],
              [10.843673528008397, -8.01360151379361],
              [10.822454536559542, -8.008140541491771],
              [10.806492851215955, -7.991854003397115],
              [10.783460301956149, -7.98286721176329],
              [10.75051128403188, -7.988885770556067],
              [10.734447714503238, -7.999979164044237],
              [10.725079927683918, -7.999479963397595],
              [10.70890605628258, -8.00996649739279],
              [10.698792875354306, -8.006105504175412],
              [10.673247696070714, -8.027151483313633],
              [10.654431558493693, -8.029010369045816],
              [10.656769240476107, -8.010947508270998],
              [10.639015257869701, -8.006298898963644],
              [10.632205414330247, -8.02034578573031],
              [10.603272725317744, -8.02296576916512],
              [10.592363721334436, -8.008742592576583],
              [10.579378929616258, -8.007757896358292],
              [10.571992738715599, -8.020021257018554],
              [10.5764573830348, -8.04371319965284],
              [10.571952630954453, -8.0520890538381],
              [10.554567286391235, -8.057030078302528],
              [10.525796702546321, -8.080896280535189],
              [10.513213907516402, -8.106573458777842],
              [10.501949220968287, -8.112184147496164],
              [10.508073042005654, -8.132329971726286],
              [10.522090035424426, -8.149272023000702],
              [10.480617608451698, -8.14103555078711],
              [10.4597859478322, -8.142638007163985],
              [10.441757767863583, -8.160236954283366],
              [10.475096958721164, -8.164213209639207],
              [10.494891988255137, -8.16088383351263],
              [10.53547081641805, -8.174146348320273],
              [10.540148872130755, -8.19232939694691],
              [10.533965074102378, -8.217734409104667],
              [10.503320652148988, -8.226769285961389],
              [10.465638488772322, -8.221795176796345],
              [10.449444544488731, -8.214092084100159],
              [10.438118713634038, -8.199370338769736],
              [10.42266962791539, -8.205787978299504],
              [10.405787334602076, -8.222445066735299],
              [10.389201337602966, -8.217990375670773],
              [10.368063625938422, -8.226759665090109],
              [10.342615394856654, -8.248386557896898],
              [10.314156088123791, -8.26710411214896],
              [10.275554014595675, -8.304221004134165],
              [10.235560012848165, -8.328082605061473],
              [10.188175755217964, -8.369243267741101],
              [10.13795474818047, -8.405396379037617],
              [10.127055181145302, -8.409023541931624],
              [10.091189441486671, -8.435170054939801],
              [10.073467735096784, -8.435795270514417],
              [10.083710402080781, -8.404589573932531],
              [10.094824426217347, -8.387456749576211],
              [10.08237076613363, -8.385717537511105],
              [10.056702905138259, -8.389920661269608],
              [10.048550009161165, -8.412895359097735],
              [10.034022023229818, -8.43068528663484],
              [10.019479861610137, -8.437619629493662],
              [10.010569727648965, -8.457128332084627],
              [9.980148547147948, -8.472274004243513],
              [9.928804158571129, -8.468683135325977],
              [9.886609987168564, -8.476652488929828],
              [9.844184902011337, -8.493772465275239],
              [9.778211978806688, -8.517484568140057],
              [9.720649546972785, -8.529487770555283],
              [9.693695672886362, -8.547329186765937],
              [9.680814431871303, -8.538174172886807],
              [9.657366239320263, -8.502881507482611],
              [9.644722114938293, -8.476803755716954],
              [9.630740052015835, -8.439857570474265],
              [9.618590836017505, -8.393077062036584],
              [9.620205496750721, -8.363153595896957],
              [9.631242120581868, -8.371164162878213],
              [9.624586677406075, -8.39161670462393],
              [9.627114528899208, -8.413883331089504],
              [9.645043274093535, -8.457444945159725],
              [9.654625321803032, -8.488457910243046],
              [9.680971644612413, -8.52442292807654],
              [9.684355916283202, -8.536430620361665],
              [9.711032279072269, -8.525720964446492],
              [9.724086176899801, -8.524238466200037],
              [9.728679602265066, -8.48971008569706],
              [9.722226149821617, -8.44133685754221],
              [9.722563768589113, -8.412358830551472],
              [9.711717737170469, -8.39822542610427],
              [9.706968481915613, -8.380465117017462],
              [9.679770522239318, -8.358387652820168],
              [9.657198132063414, -8.32006401019625],
              [9.617224546666169, -8.285061882480855],
              [9.603026228087163, -8.277984153737389],
              [9.572106253770583, -8.271870094856974],
              [9.54949003652134, -8.273231078493758],
              [9.524421322555737, -8.261926093062625],
              [9.49637936954207, -8.233193476913986],
              [9.481193054238199, -8.226852035546342],
              [9.440996004240482, -8.192669506832704],
              [9.42119921810603, -8.183206500512293],
              [9.346346300298523, -8.154920553987516],
              [9.31898938290631, -8.138397655660013],
              [9.275103394605013, -8.105166177571691],
              [9.24199760901868, -8.086731434979127],
              [9.18059102634823, -8.056055914087338],
              [9.117417165951492, -8.029352365848078],
              [9.070286345866931, -8.012647171321564],
              [8.989669442282777, -7.988336271723715],
              [8.901830458326783, -7.966854213940841],
              [8.835522919539473, -7.952763430958707],
              [8.791197896038199, -7.946013913846373],
              [8.747382183272586, -7.942327523270841],
              [8.678212657997566, -7.940610953514527],
              [8.624962724373612, -7.9468155790413055],
              [8.612472220860742, -7.943725558901125],
              [8.521612109230617, -7.942717101459651],
              [8.494203615310774, -7.945194369181224],
              [8.424693467653324, -7.955428365857667],
              [8.342056651414818, -7.973400841842976],
              [8.243638210751211, -8.000650589869386],
              [8.16333110839618, -8.025267830912465],
              [8.073602939855352, -8.054025089827752],
              [8.03075729759383, -8.064227671322314],
              [7.975515664599468, -8.073984364574194],
              [7.94928340098842, -8.06503188678156],
              [7.9377585757027695, -8.072718728045649],
              [7.843041317165438, -8.106288802153621],
              [7.766408790851986, -8.128941301955603],
              [7.766051296714882, -8.125522343379318],
              [7.821257091604689, -8.104384011216275],
              [7.8143482389919345, -8.096936110040781],
              [7.793974150597248, -8.102234981893293],
              [7.777353672673297, -8.101222430179336],
              [7.774207970725648, -8.084835047901446],
              [7.784597792471105, -8.077080330728668],
              [7.807552941898121, -8.072647099635674],
              [7.8183278870239326, -8.058776970844752],
              [7.816086939517382, -8.038124422861534],
              [7.825754618770127, -8.023715064545062],
              [7.823075331475855, -8.013296235006493],
              [7.831239948741298, -7.997623010400136],
              [7.853281510718178, -7.991960300097307],
              [7.879133838309847, -7.96941648382096],
              [7.877989879003402, -7.9532031659417335],
              [7.839423284945423, -7.946277667971876],
              [7.819423852253496, -7.924950905562386],
              [7.821812315333526, -7.909490561000443],
              [7.809166478974431, -7.898962497024921],
              [7.805800618330581, -7.879754293312191],
              [7.813351621069747, -7.8570779530024755],
              [7.826575895090736, -7.843235811876595],
              [7.839191306117885, -7.798459742452438],
              [7.841760142507965, -7.7730310591873115],
              [7.836492541620119, -7.750097658465456],
              [7.82632168328466, -7.730252597955253],
              [7.800269794413086, -7.719120839460485],
              [7.786124252640319, -7.7092766023170505],
              [7.765846079416224, -7.704323648610922],
              [7.7591505885887155, -7.695023156261256],
              [7.7406808698454315, -7.691596763478099],
              [7.731574316778978, -7.6804899868078955],
              [7.712857617241202, -7.672219343729684],
              [7.70733643160294, -7.6537127638046],
              [7.692448997668218, -7.631360050996929],
              [7.664682084405828, -7.607718104427629],
              [7.648070642809214, -7.600972740228161],
              [7.622764299536196, -7.575916563563459],
              [7.614689954018194, -7.5587353234960855],
              [7.6239451493874055, -7.538441968788427],
              [7.632636785996175, -7.498670260241406],
              [7.643668381303691, -7.470744985495234],
              [7.644961228917952, -7.45768012645026],
              [7.633744631506997, -7.425723422836608],
              [7.780075481074797, -7.412204208807013],
              [7.926402740310412, -7.398647711185643],
              [7.941294543861605, -7.399173710197057],
              [8.02348088340449, -7.3884605690430405],
              [8.114150685446887, -7.380873518295892],
              [8.204819447568024, -7.373272173876737],
              [8.290954085197466, -7.36542381930705],
              [8.377087609333861, -7.357562539351559],
              [8.393560016867854, -7.358129663186751],
              [8.514975122591439, -7.345705964867014],
              [8.552162120586528, -7.344001025710874],
              [8.680150766559208, -7.3299637505343895],
              [8.791477915225688, -7.318766763985248],
              [8.894839500486016, -7.309587124600047],
              [8.989734534517538, -7.299385055918543],
              [9.08462781594112, -7.289167209153765],
              [9.206726083461389, -7.274320817691247],
              [9.313397797357617, -7.26191393331862],
              [9.42006701152063, -7.2494870645664955],
              [9.527970023284945, -7.235495643894879],
              [9.635869953032927, -7.221483692615826],
              [9.738237517337549, -7.209920692043495],
              [9.840603025130743, -7.1983393089815815]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.49838567045278,
          "lat": 28.631731823479992
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "00294478"
      },
      "bbox": [
        7.614689954018194, -13.113631419789128, 14.830197396882978,
        -7.020264378862874
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": 144.7744152177639, "lat": 13.443647263615143 },
        "year": "2023",
        "ste_code": ["66"],
        "ste_name": ["Guam"],
        "ste_area_code": "GUM",
        "ste_type": "outlying area",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01802705"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.891330600248326, -3.2888721062213198],
            [9.003313659687246, -3.2782415232168205],
            [9.06931058104359, -3.2708653695304664],
            [9.155794715153473, -3.259117877341463],
            [9.428429791624438, -3.22480692539148],
            [9.534299750803926, -3.2127044647959906],
            [9.684760971513402, -3.1940353546854263],
            [9.774797855427016, -3.183491229025209],
            [9.926347655403003, -3.164552685089192],
            [10.081485796757043, -3.146181431056437],
            [10.322025502779361, -3.1158622976892403],
            [10.38739499698396, -3.107022536015105],
            [10.49218307561353, -3.094504465177479],
            [10.491301635364279, -3.089034529460623],
            [10.548272045231066, -3.0811535961859713],
            [10.730286438342016, -3.0535504244362492],
            [10.901176457974957, -3.0250479223237448],
            [10.911069305061291, -3.033093573715902],
            [10.8969289858118, -3.058956801839788],
            [10.899035719142624, -3.07413949711331],
            [10.90833953110809, -3.090478956218911],
            [10.874873258388694, -3.114142161916417],
            [10.864456155728554, -3.113808760970828],
            [10.839803683611455, -3.1568798305029344],
            [10.830434403645043, -3.155398661452353],
            [10.81038713602173, -3.1631735479130825],
            [10.804739219316907, -3.197705788224222],
            [10.792510902170674, -3.208937154779428],
            [10.797655378079023, -3.2220544045168067],
            [10.780556637770763, -3.2270614125688284],
            [10.772033761908727, -3.2447140055596764],
            [10.757119405706316, -3.261674932727371],
            [10.7640501654955, -3.2837111883761283],
            [10.760288617498626, -3.298466355972198],
            [10.743803220163418, -3.315100361860419],
            [10.743362743338308, -3.3346464855201665],
            [10.759182655844208, -3.3632599211491483],
            [10.788701910154852, -3.377205458227854],
            [10.800016546743402, -3.3911893532035484],
            [10.833628364594505, -3.4041371845193598],
            [10.855842431971231, -3.427454936437076],
            [10.87411571484066, -3.4254768485865585],
            [10.886148939446954, -3.4312704818040607],
            [10.906236466729823, -3.424487350310934],
            [10.909594491565892, -3.440688287392275],
            [10.932297294097886, -3.4554807057319206],
            [10.935948405250956, -3.4661694615153844],
            [10.962534987390695, -3.4781216723223785],
            [10.97049714956869, -3.491744802710095],
            [10.985287716788688, -3.4913597539773606],
            [11.001702110574525, -3.5184040868329056],
            [11.062682283240713, -3.540196412294077],
            [11.067056611646398, -3.532866655844325],
            [11.105603957151096, -3.521013870753058],
            [11.120580280957851, -3.5228709181642275],
            [11.139801362691678, -3.5150188752293046],
            [11.172796062621172, -3.5373082829205935],
            [11.207640550146, -3.61312744623914],
            [11.210621458270104, -3.627548823938659],
            [11.246739591763847, -3.6486411514427317],
            [11.263157446889332, -3.6896792241766154],
            [11.288948213374825, -3.7088883052590695],
            [11.301179321008691, -3.731621610142974],
            [11.308116190176671, -3.7729686059212133],
            [11.317648264574325, -3.7870576139189063],
            [11.32207020151637, -3.805925905242055],
            [11.336081531593035, -3.8291229424092856],
            [11.348252905228406, -3.8370995133005934],
            [11.373353890871824, -3.8449698979470543],
            [11.390309306808891, -3.868795357753327],
            [11.407893855990102, -3.884003371201165],
            [11.40497879820683, -3.8950708836916066],
            [11.42197593755872, -3.905452695945686],
            [11.441481342166906, -3.928469259224964],
            [11.451780057791332, -3.934261504008825],
            [11.462267455592574, -3.9644137973223397],
            [11.471360694742625, -3.9810284372177107],
            [11.495833366195232, -4.014894177855669],
            [11.522462668999657, -4.013130331894102],
            [11.532800426304142, -4.0181459935887665],
            [11.553004807794544, -4.042893405370299],
            [11.587869344785252, -4.06644138132123],
            [11.611295189741927, -4.079131477285511],
            [11.628205124648915, -4.07622146942568],
            [11.663945504330691, -4.095456609753142],
            [11.683594809987358, -4.101234208436245],
            [11.726931938687486, -4.130392777756133],
            [11.729246249668092, -4.144742049940351],
            [11.77595745737408, -4.170335616170916],
            [11.785953749890073, -4.190931680765223],
            [11.79410483567397, -4.220866693509726],
            [11.809147857756395, -4.232804621401606],
            [11.828093956111696, -4.254955125728131],
            [11.83530707378686, -4.28554815477694],
            [11.854456745943386, -4.2998121874675865],
            [11.869647678118772, -4.301717818339107],
            [11.892752450988603, -4.317798401132288],
            [11.914330923737309, -4.309454737325057],
            [11.926135042877299, -4.320810226278853],
            [11.944110002931545, -4.323477739280707],
            [11.96803323338061, -4.3338399857200764],
            [11.993971382968006, -4.359240932156336],
            [12.002674949581795, -4.3626239888811655],
            [12.023158701885437, -4.389716256653871],
            [12.028902997622511, -4.403302276241221],
            [12.081236405065376, -4.419489156083985],
            [12.095719498792501, -4.4423077755255544],
            [12.082614927839046, -4.453695518019621],
            [12.091063107338673, -4.471290483012991],
            [12.083820033556805, -4.485781053013814],
            [12.08983350944282, -4.502308879103969],
            [12.080829525465344, -4.519918731756989],
            [12.101130942705128, -4.53632673300806],
            [12.106627389689384, -4.5471337651027675],
            [12.140132975071536, -4.561826702303574],
            [12.150262392678679, -4.560594023975903],
            [12.160006108063355, -4.573978207839936],
            [12.161415888997132, -4.587263139483759],
            [12.173587081198326, -4.586985217204882],
            [12.178144391025851, -4.604267589845617],
            [12.173359074603963, -4.623121617404827],
            [12.196889726632444, -4.639891190503412],
            [12.210935541812571, -4.642757334074678],
            [12.215570979875798, -4.652310741893796],
            [12.230912787488426, -4.655385157240643],
            [12.248055887526872, -4.644793747170308],
            [12.259875844670955, -4.66178551349666],
            [12.253171328963134, -4.682476078170536],
            [12.260547472555219, -4.700642882746102],
            [12.278445744808675, -4.715498811476629],
            [12.315141619937908, -4.736036696722269],
            [12.355165251297548, -4.743472860457021],
            [12.369927663017316, -4.751380057857199],
            [12.39206145493293, -4.7455851367215836],
            [12.413974815472777, -4.765068829622242],
            [12.426350692691424, -4.7701510162369685],
            [12.443280187717296, -4.788217262762803],
            [12.462081411646324, -4.790654030540307],
            [12.488628703586755, -4.8016176715741095],
            [12.506940983283354, -4.81820181354901],
            [12.507114350741077, -4.8606970449707765],
            [12.497030733564916, -4.860272304296297],
            [12.508429420956476, -4.886963134058716],
            [12.527104335859983, -4.901229043209298],
            [12.539870574263576, -4.944062256764453],
            [12.559032143158449, -4.944934289471522],
            [12.559385146142953, -4.966458565647349],
            [12.569580894081376, -4.966551651292421],
            [12.591195379235375, -4.979238510709373],
            [12.596029276122135, -5.000244825993732],
            [12.591186344924072, -5.004847341330996],
            [12.592414063433647, -5.033211484545297],
            [12.610360866976453, -5.0493578159996675],
            [12.607084408618025, -5.065205025860517],
            [12.617351905730118, -5.07138668524646],
            [12.61157016877523, -5.084010643771626],
            [12.612839505881306, -5.113143545315398],
            [12.632454544423403, -5.132768693499074],
            [12.631703150555154, -5.143647462743815],
            [12.642079372982378, -5.159591507686495],
            [12.629385553216578, -5.171874646768862],
            [12.62587814681846, -5.183599029340887],
            [12.6547602120332, -5.212505845789246],
            [12.678176689079061, -5.222718988021427],
            [12.683800701914702, -5.2301198744812885],
            [12.716213083098646, -5.239383155992819],
            [12.735424222206115, -5.232869140489605],
            [12.75021280908496, -5.237222703534077],
            [12.761621258949827, -5.261844307027828],
            [12.779690765095092, -5.271287547161283],
            [12.787482880118887, -5.268145665029286],
            [12.798764308455455, -5.288425325073841],
            [12.831325458174103, -5.314256282716997],
            [12.829180132664257, -5.345990696665003],
            [12.833701996753947, -5.358853097269877],
            [12.860602854359149, -5.385012272592128],
            [12.860236496106014, -5.399556301410832],
            [12.873528513275021, -5.408665487622564],
            [12.8815508071376, -5.425528921033886],
            [12.898246442201831, -5.423008214067657],
            [12.908917864052242, -5.4359730536469355],
            [12.91370261729506, -5.457416107018276],
            [12.921207045890792, -5.464923908735887],
            [12.921800387310844, -5.486854017542252],
            [12.909367568972606, -5.5233392925444145],
            [12.902372745003005, -5.530162680194332],
            [12.917020884691986, -5.550329462125983],
            [12.936835866012435, -5.567882087405796],
            [12.943685541071664, -5.583038435190258],
            [12.937739140106698, -5.600377090714977],
            [12.951927415070493, -5.615447361607229],
            [12.950054407607986, -5.633989612970407],
            [12.956887032177184, -5.652450888894652],
            [12.977566469559187, -5.653063564319244],
            [12.981763619559118, -5.663497097586048],
            [13.026063209444013, -5.672911415561746],
            [13.040983026892425, -5.655312489854087],
            [13.051281273597974, -5.650055397638919],
            [13.062587040161754, -5.65581111463044],
            [13.072200236832101, -5.6698478980811355],
            [13.098360299552066, -5.675222239903963],
            [13.126813710855686, -5.699257421194842],
            [13.141932123094664, -5.700685574429015],
            [13.157201403162574, -5.7057669245352525],
            [13.171745360707176, -5.717593250087497],
            [13.189180244578422, -5.702627448580173],
            [13.201754816282385, -5.71799451848351],
            [13.200278855548433, -5.742610001936069],
            [13.191526002489292, -5.747338150024762],
            [13.190248133020305, -5.762645299441563],
            [13.176355955313213, -5.777684797637886],
            [13.146307195511334, -5.800645971494386],
            [13.13331141970596, -5.779235320290851],
            [13.120740388873312, -5.785987630473485],
            [13.095483900860419, -5.8158638679642225],
            [13.110612474644105, -5.82950894343522],
            [13.143836913969766, -5.832076767093566],
            [13.114152163736, -5.867284621412603],
            [13.099615537857714, -5.890130659023392],
            [13.055896877273778, -5.878266742831133],
            [13.03596375515137, -5.880503312836351],
            [13.04455608711641, -5.89865965952448],
            [13.034700571583093, -5.929328535241746],
            [13.070970670493917, -5.942492694967946],
            [13.048301823940298, -5.985506804205286],
            [13.031123990634699, -6.010692652862137],
            [13.005543240031606, -6.041458641095357],
            [12.951902950723708, -6.039184893539585],
            [12.945026761796745, -6.054207369128547],
            [12.962272434018873, -6.069649741563298],
            [12.984955557755914, -6.076320983875807],
            [12.991556638574947, -6.0682004875189826],
            [13.009334568587121, -6.068080075058197],
            [13.007514382180283, -6.080783639617836],
            [13.015535944634145, -6.122523479921341],
            [13.021320527274186, -6.131237215054648],
            [13.004447319104633, -6.195534140561951],
            [12.990944787024908, -6.210058615508405],
            [12.973370665407037, -6.190292725527657],
            [12.959626319666368, -6.214681530889847],
            [12.939920215051266, -6.223916029779071],
            [12.91046379122142, -6.232384060630615],
            [12.894563077999782, -6.249960715422953],
            [12.89899163500695, -6.261364117398654],
            [12.92834127756835, -6.24920796572739],
            [12.92613676204491, -6.2628996827880234],
            [12.915557860276175, -6.270937431313755],
            [12.916511666923038, -6.282885739685508],
            [12.930072873649006, -6.282552472293331],
            [12.938143631885675, -6.271281036570062],
            [12.94688077332206, -6.2461908937228925],
            [12.966469084553971, -6.244189915202579],
            [12.97789141933313, -6.233435652077589],
            [12.996982446745985, -6.25140879141746],
            [12.990321431852713, -6.265283619083154],
            [12.982277549814642, -6.29731224182346],
            [12.954815873722653, -6.352430168939655],
            [12.942752453360606, -6.394466284832829],
            [12.923421695001531, -6.412016133943987],
            [12.933334318164816, -6.429534439048676],
            [12.939476478128162, -6.452029708166226],
            [12.937999612465862, -6.468361866609423],
            [12.950802278875262, -6.505528044012227],
            [12.958693555045386, -6.510207247861472],
            [12.952261616775736, -6.532965882736904],
            [12.949962902677335, -6.5602013639708],
            [12.939480960426042, -6.562645542749086],
            [12.918936406600945, -6.585923411464576],
            [12.903496212851463, -6.618317993305974],
            [12.897247539500368, -6.638706117033539],
            [12.88083774186543, -6.654860693691329],
            [12.870825610750622, -6.656723833265531],
            [12.864595936464323, -6.671296836391268],
            [12.871550388276438, -6.683836306844643],
            [12.878899280344426, -6.717323586839706],
            [12.871289079778018, -6.775022558468962],
            [12.845320917049381, -6.780202592774437],
            [12.8397830663376, -6.7975517577490185],
            [12.8169304789591, -6.815346247856444],
            [12.815473399594556, -6.823049616133736],
            [12.832327637316595, -6.832113897596033],
            [12.839157178187094, -6.826097474326712],
            [12.875043991095117, -6.835003025734638],
            [12.878131470935795, -6.816933378519256],
            [12.887392522827117, -6.811840676934775],
            [12.894718125631929, -6.830672632493239],
            [12.902463531900782, -6.884071041872137],
            [12.89812414118843, -6.9028589866001555],
            [12.892072368535397, -6.953563969479559],
            [12.88051193254307, -6.98146685943004],
            [12.875578243008205, -7.022981941604844],
            [12.880346638504193, -7.050375425336978],
            [12.898283094300744, -7.080110493388119],
            [12.870704524602667, -7.079256938386072],
            [12.857292551937778, -7.069884792092417],
            [12.822306689133223, -7.07711266938624],
            [12.799159765892377, -7.093244424746787],
            [12.786516974115251, -7.0844487768161795],
            [12.766503949757087, -7.082538564382243],
            [12.75970111910462, -7.091177634100929],
            [12.743930234862761, -7.088542824435564],
            [12.717815339218577, -7.076390153807533],
            [12.70571178444316, -7.064403821588493],
            [12.70000787952264, -7.080829514144209],
            [12.67997476934103, -7.074307888888675],
            [12.659227527412515, -7.081231450452506],
            [12.647404276535969, -7.077118211047381],
            [12.63904358333666, -7.065177351800867],
            [12.612234538652745, -7.055592850332649],
            [12.600972034048423, -7.061541752752251],
            [12.591543249175404, -7.050274348651243],
            [12.578255335754026, -7.047588197326407],
            [12.551841627883872, -7.055068517826752],
            [12.538560969497139, -7.048967984802938],
            [12.526323845957565, -7.052577147978213],
            [12.51406630904633, -7.047287743583118],
            [12.50264835247749, -7.026289513779135],
            [12.492716438767156, -7.020264378862874],
            [12.486736648663687, -7.035034045632782],
            [12.472855826147724, -7.035637176847295],
            [12.461247095919685, -7.026018234824691],
            [12.441537150613673, -7.039733049270616],
            [12.44592949913459, -7.056295530101713],
            [12.439267600845085, -7.07957659377383],
            [12.430911680849345, -7.08151704752218],
            [12.410880069992022, -7.071124319042277],
            [12.39646637073588, -7.081991771919339],
            [12.409501959249186, -7.1002849505778425],
            [12.397820444588367, -7.11354058402497],
            [12.38916793345258, -7.1114866596755775],
            [12.38617529362818, -7.138025835656383],
            [12.396484632618149, -7.158530309580386],
            [12.3890466920917, -7.1901060331380435],
            [12.392869209720763, -7.210373831978726],
            [12.415654378463442, -7.240925049023862],
            [12.419279245150566, -7.256149421084723],
            [12.43369760630306, -7.2664735587885385],
            [12.4437839518552, -7.295420748503505],
            [12.439176664998874, -7.309568734262739],
            [12.438230204127459, -7.336098412137616],
            [12.44330429271654, -7.346223309826689],
            [12.446316686837982, -7.383885893799837],
            [12.441503637673321, -7.412403168674313],
            [12.43573509600477, -7.426184828660339],
            [12.437892734798083, -7.463707335147968],
            [12.444095096141647, -7.474399905811563],
            [12.437061866616908, -7.497544140091437],
            [12.420093865638627, -7.504127159751882],
            [12.397575105064533, -7.505816817743329],
            [12.387828762368809, -7.499672261795722],
            [12.333620989221263, -7.516993589104293],
            [12.298418049102592, -7.479536598035349],
            [12.289818503705728, -7.457430156795465],
            [12.292310447688479, -7.437070919045117],
            [12.28681454439543, -7.421805066633775],
            [12.288595190871506, -7.396781389775022],
            [12.259295902247253, -7.368710591928898],
            [12.247813520043852, -7.349850247239559],
            [12.250173035089835, -7.330601407721538],
            [12.265089131687022, -7.316389030491824],
            [12.112835909446822, -7.326945249534485],
            [11.960583102496214, -7.337457610243826],
            [11.849296483674246, -7.34574754011096],
            [11.696120024636, -7.3562092213439065],
            [11.587054237345304, -7.363798794236887],
            [11.477988504390911, -7.371366046262535],
            [11.319758362272346, -7.381379924312351],
            [11.16152879066079, -7.391347020426482],
            [11.065673792646681, -7.398265991027005],
            [10.950421626836949, -7.405802841338658],
            [10.83516953922286, -7.413315006911473],
            [10.683463518680517, -7.423544214074665],
            [10.547306723640414, -7.432829654188686],
            [10.411149663721917, -7.442080828925933],
            [10.326061570282386, -7.449404102355674],
            [10.270265413231582, -7.452139766706247],
            [10.14299219620664, -7.46027128270762],
            [10.015718860641094, -7.4683730149498],
            [9.991459177131954, -7.470374028573082],
            [9.960126850178332, -7.434940273880553],
            [9.94428231721928, -7.433779757111859],
            [9.938274000607551, -7.409953757468577],
            [9.91677847335867, -7.369600513254285],
            [9.923549548563491, -7.350488853706978],
            [9.909270783571126, -7.319805248875104],
            [9.91230981486412, -7.309037724950838],
            [9.864010447367727, -7.259445027021166],
            [9.861627135854775, -7.231072078012681],
            [9.842457894162326, -7.225388506011801],
            [9.840603025130743, -7.1983393089815815],
            [9.841685203005337, -7.185028650876032],
            [9.831069205367552, -7.167681568405174],
            [9.826937023179031, -7.14694703102069],
            [9.80993178824995, -7.127824114477308],
            [9.810947042952744, -7.118089745633111],
            [9.800078479458259, -7.095275130881158],
            [9.782463215049713, -7.084644456891065],
            [9.772040112615969, -7.064113497358803],
            [9.75970218900793, -7.051061747991925],
            [9.738741063901125, -7.044877201264703],
            [9.738497463500602, -7.0302067126628245],
            [9.730143743683437, -7.024848072582566],
            [9.728748329672246, -7.008725138812452],
            [9.734748785769122, -6.985022213407404],
            [9.716344185963322, -6.948329652482672],
            [9.716846888860596, -6.930833768290591],
            [9.732691048376395, -6.915690933677572],
            [9.73361777820804, -6.8821988709607975],
            [9.722673250177543, -6.847076264466299],
            [9.728604345577281, -6.82636891945482],
            [9.729810344486259, -6.785875226972534],
            [9.737286378352026, -6.7791727128313415],
            [9.728081153388596, -6.742297310957207],
            [9.73127570412409, -6.726135649567162],
            [9.744858614145182, -6.687651310219742],
            [9.745281236228177, -6.667445881627422],
            [9.727794363167602, -6.639484723695298],
            [9.722692858856032, -6.592091089524659],
            [9.707653908642188, -6.582828573931993],
            [9.688491135061923, -6.554496819781917],
            [9.656606621314289, -6.522992130590153],
            [9.653265709710777, -6.501478420848916],
            [9.657836391033511, -6.484985100166565],
            [9.646190207408202, -6.460197558771037],
            [9.64746040048309, -6.449805418596528],
            [9.63284150707247, -6.438312471883249],
            [9.639216610084635, -6.427136477854861],
            [9.634928481732912, -6.391149192143871],
            [9.626364456288744, -6.381479646592219],
            [9.625559333543933, -6.361975693406119],
            [9.633033042104099, -6.343436043251293],
            [9.627675887058734, -6.327263208539879],
            [9.643509659240223, -6.3251528383395765],
            [9.652992755435898, -6.2909983411845305],
            [9.66758821708745, -6.275351940386924],
            [9.658933836830952, -6.258651278868771],
            [9.674921378736936, -6.243344064818366],
            [9.669516489897836, -6.233407354641623],
            [9.673203099833168, -6.210377621755831],
            [9.679457774108236, -6.203047915205534],
            [9.672161531331314, -6.167741052586105],
            [9.672931583384356, -6.1335078576253865],
            [9.678674428535654, -6.126547264929644],
            [9.659550387457582, -6.082856334163729],
            [9.67203048411749, -6.07008047983016],
            [9.698622224787593, -6.028633258345944],
            [9.733800628802284, -6.011228343457251],
            [9.72484078285578, -5.989020212328247],
            [9.759860036045403, -5.984147886688922],
            [9.779335301215026, -5.943252682316415],
            [9.789265281375155, -5.938583096588554],
            [9.758177191211477, -5.917622742009222],
            [9.74753971885309, -5.905846598228164],
            [9.687928851880736, -5.888844772783416],
            [9.682977693194392, -5.866078787509962],
            [9.696227564444092, -5.850588725800787],
            [9.6961723783518, -5.797037280187501],
            [9.708316991931737, -5.785255659891116],
            [9.698948690876467, -5.765897955522473],
            [9.67994021714416, -5.760143296999589],
            [9.674911504819224, -5.749645923845484],
            [9.674755737209782, -5.725188460114961],
            [9.665840057201832, -5.697310131854208],
            [9.64510130160979, -5.67131552070741],
            [9.603381785725011, -5.6392252320871945],
            [9.579862952164456, -5.595696628424617],
            [9.564407124673467, -5.577914637551758],
            [9.576934968220188, -5.563455524133639],
            [9.57135402841043, -5.5520271778457],
            [9.549252374031445, -5.532087503723739],
            [9.542543056868805, -5.501714114010898],
            [9.547780540921535, -5.491155384030466],
            [9.530640785148455, -5.481426514963156],
            [9.52016028117228, -5.466223619486004],
            [9.535628090708324, -5.4516827925862135],
            [9.50856917594306, -5.4338568558589815],
            [9.493262007248164, -5.417952931462829],
            [9.491185478726921, -5.400455615289626],
            [9.500510846574834, -5.380969560149696],
            [9.473921163702222, -5.370044487343855],
            [9.472586961197194, -5.360910381908241],
            [9.406051864388282, -5.128876938329145],
            [9.336622111646502, -4.879373256881904],
            [9.30408840833018, -4.762069277713806],
            [9.230423459722989, -4.500404009863391],
            [9.202094912399442, -4.396508194522014],
            [9.131588121262126, -4.143180413171522],
            [9.129372492275989, -4.132607080628627],
            [9.07328023488033, -3.933355553634173],
            [9.018264146739114, -3.747169218341171],
            [8.952588687962006, -3.519729757374934],
            [8.906074334039607, -3.3485415105036713],
            [8.891330600248326, -3.2888721062213198]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.44674156101864, "lat": 32.64946127166055 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01705317"
      },
      "bbox": [
        8.891330600248326, -7.516993589104293, 13.201754816282385,
        -3.0250479223237448
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.77007841343745, 4.576176516246913],
            [-12.732984971631494, 4.568287246827497],
            [-12.669684077778056, 4.551585646452922],
            [-12.57028302561319, 4.533697026735359],
            [-12.48344905598958, 4.5191161243651985],
            [-12.396617268966326, 4.504521243288873],
            [-12.239086559240928, 4.478019709172456],
            [-12.081563140797407, 4.451472157349072],
            [-11.965838458613531, 4.431922496670568],
            [-11.850117784938172, 4.412347996452412],
            [-11.700945990541937, 4.38680856090048],
            [-11.551781076518884, 4.361227831138835],
            [-11.412345376920264, 4.337664450935757],
            [-11.39904066875811, 4.331015969402906],
            [-11.25223289045407, 4.307303698825377],
            [-11.10543132401479, 4.283551601176585],
            [-11.006134071932173, 4.267282449128282],
            [-10.906839755536003, 4.250995068529408],
            [-10.789120663483045, 4.23342949122344],
            [-10.690733727456225, 4.217889684066389],
            [-10.592349556832646, 4.202332016486536],
            [-10.627268423696604, 3.981962568425353],
            [-10.658693603422627, 3.783579308070293],
            [-10.69408552071222, 3.566017583283496],
            [-10.72662032966022, 3.3626749712446173],
            [-10.751826998256716, 3.2055539859608855],
            [-10.642493161957121, 3.187742852686528],
            [-10.53316231276618, 3.169913326128231],
            [-10.377241535326565, 3.1452218166728487],
            [-10.34855963881364, 3.1391822968128413],
            [-10.251245336622066, 3.124732808216697],
            [-10.153933148089273, 3.1102688247926493],
            [-10.067663375503251, 3.099025127996892],
            [-9.969022763489152, 3.08469137197812],
            [-9.870384280599879, 3.0703427346067134],
            [-9.737781487500882, 3.0518237510865207],
            [-9.63299175375873, 3.0364845327812207],
            [-9.60748723855648, 3.033838453821618],
            [-9.514733132886537, 3.021679985761781],
            [-9.421980690416571, 3.0095084068374383],
            [-9.27327646575219, 2.988473635073093],
            [-9.296167829565377, 2.81414283608019],
            [-9.31203169768867, 2.7029239453787515],
            [-9.3244135710859, 2.607669606357837],
            [-9.336816606898928, 2.5291464724405746],
            [-9.350722291586779, 2.433404587672387],
            [-9.381359885475707, 2.2119980690546406],
            [-9.429118939720349, 1.8646374205922518],
            [-9.459074018911512, 1.6503271842902765],
            [-9.481808287540483, 1.4876710011759766],
            [-9.499460624173555, 1.3566261385189542],
            [-9.53327536008065, 1.1161658604733782],
            [-9.570026327162434, 0.8653388967945008],
            [-9.595564488867396, 0.7107925748177759],
            [-9.626302244904604, 0.49089603178816926],
            [-9.65743180599137, 0.26635161200307717],
            [-9.658643807393803, 0.15357022278633936],
            [-9.685999246617166, -0.03677772534566125],
            [-9.693661694162007, -0.10404451017355784],
            [-9.727913507216279, -0.34516181234931775],
            [-9.746294657075527, -0.48058563335361765],
            [-9.770881369127915, -0.6359331943621936],
            [-9.798343407154421, -0.8336630314228928],
            [-9.822358383519017, -1.011957823660947],
            [-10.17492078271948, -0.9623955104160725],
            [-10.277076215640994, -0.9485355120568365],
            [-10.472731531033427, -0.9198332359432482],
            [-10.785935870448025, -0.8733617362893166],
            [-10.937842315282898, -0.8504829720175557],
            [-10.960726737729248, -0.8405711285961532],
            [-11.15628645236416, -0.8113269728955733],
            [-11.403129812787293, -0.7731158690323874],
            [-11.455886615739168, -0.7663098150300895],
            [-11.568824313077583, -0.7484078813204715],
            [-11.66798278179875, -0.7312069733130415],
            [-11.847154846743683, -0.7018169478869588],
            [-12.026874269867223, -0.6718740210988985],
            [-12.410693634391622, -0.6064250668204505],
            [-12.553087573220731, -0.5818983772755014],
            [-12.77830971860178, -0.5422024007283731],
            [-12.97326546281445, -0.5072909732724957],
            [-13.124714546375145, -0.4796672271397344],
            [-13.396724686764585, -0.4292479954822152],
            [-13.62343578048976, -0.38643324437511356],
            [-13.727936259507592, -0.36600235568978384],
            [-13.71204656811846, -0.2785380944619556],
            [-13.684058848969125, -0.13439490529242362],
            [-13.649216870253005, 0.048342304636840985],
            [-13.616834138704448, 0.22175861855196285],
            [-13.586673862949054, 0.37350950161327817],
            [-13.571997651199778, 0.43635885315467127],
            [-13.57029510959211, 0.45020542895374493],
            [-13.537256525186326, 0.6251551448946355],
            [-13.48602076340965, 0.8875164871930613],
            [-13.441990142968608, 1.120925316919056],
            [-13.397731176564784, 1.3480941476532184],
            [-13.344581058517775, 1.6218690454812061],
            [-13.257888977144537, 2.0678562557251015],
            [-13.199550955208803, 2.36852441473509],
            [-13.153777663565723, 2.603569801140969],
            [-13.108709471064282, 2.836191454035291],
            [-13.077053471975887, 3.0007917184826356],
            [-13.003760398778065, 3.369638153838723],
            [-12.959567876311946, 3.5951151053274164],
            [-12.917160092315427, 3.8124069395824307],
            [-12.864631214677818, 4.080574848952529],
            [-12.814565005668276, 4.339174471633488],
            [-12.797072552848467, 4.4348463945105],
            [-12.789476815955162, 4.468387208877647],
            [-12.77007841343745, 4.576176516246913]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.67822724170476,
          "lat": 39.323788330065454
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01455989"
      },
      "bbox": [
        -13.727936259507592, -1.011957823660947, -9.27327646575219,
        4.576176516246913
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.940510946379339, 2.607055640309153],
              [15.94800009285296, 2.5845114583017774],
              [15.933686331952083, 2.5968001670750684],
              [15.940510946379339, 2.607055640309153]
            ]
          ],
          [
            [
              [15.749965176337065, 2.661040188822219],
              [15.760996474853318, 2.663421411726063],
              [15.768868943920143, 2.701668614558432],
              [15.782576020147834, 2.731962005633773],
              [15.797851378912243, 2.754331687707798],
              [15.822431142274702, 2.7787911000521928],
              [15.853558047882778, 2.7988105182224743],
              [15.887260980625543, 2.811318042434794],
              [15.94172259824918, 2.8173388565991604],
              [15.978057287318082, 2.8118834717931063],
              [16.003565619720938, 2.8033459683329247],
              [15.974404920384234, 2.776159081838797],
              [15.965084364936581, 2.7414134397708274],
              [15.958536143598828, 2.704168858742184],
              [15.932629929507325, 2.633099101070309],
              [15.91529996454313, 2.6234377498116492],
              [15.902126132234265, 2.584386789015715],
              [15.908389504456881, 2.566612146545831],
              [15.952389798784207, 2.5399033190361022],
              [15.95514594609272, 2.4939116973954203],
              [15.948137146249012, 2.4709671300802776],
              [15.947841762053406, 2.453182572667203],
              [15.954505447796405, 2.435668087639697],
              [15.972381959388166, 2.416942704069667],
              [16.00211412476765, 2.400313047443794],
              [16.027333303084525, 2.366431998486902],
              [16.032061341095712, 2.3548755126255143],
              [16.048647854180253, 2.3465899558428926],
              [16.05041087238734, 2.338681072033223],
              [16.098827873409718, 2.315016892760983],
              [16.10695029290177, 2.2932622646727916],
              [16.131993924538126, 2.2714370711284557],
              [16.141802592260646, 2.2339341761123097],
              [16.153856934895153, 2.2146800263168727],
              [16.15548796440054, 2.1963684506487273],
              [16.152775862082223, 2.161517201883252],
              [16.16337981627223, 2.132046245307245],
              [16.17470811821101, 2.1103417376272273],
              [16.176655857145757, 2.089615341407357],
              [16.18630727633137, 2.0703254641287763],
              [16.236163292004505, 2.0421296597305076],
              [16.260021115968495, 2.0145696601567593],
              [16.26957438785556, 1.9954401199790972],
              [16.274639182517316, 1.9727862821990936],
              [16.272901783753287, 1.9608348212643523],
              [16.28711807076111, 1.9430185265892672],
              [16.325765030113637, 1.9145624627109692],
              [16.35640807998279, 1.887146190939661],
              [16.38108670184278, 1.8710541622880499],
              [16.395840637411478, 1.8572500365897273],
              [16.423253658082306, 1.8461182804895608],
              [16.443838074441445, 1.8424850467176197],
              [16.470232133374882, 1.8550578838376313],
              [16.48514212078016, 1.8412799354451317],
              [16.494829448955063, 1.8083684999127012],
              [16.522198510410302, 1.734640926773809],
              [16.528737243913163, 1.706486575949377],
              [16.538098865230758, 1.6830500771440575],
              [16.572650883150224, 1.5652941361658144],
              [16.58101801504701, 1.5308344569992172],
              [16.47762623361203, 1.5076938544474736],
              [16.32700455988805, 1.4752947622144101],
              [16.193145422846147, 1.4495063915018467],
              [16.090842820310915, 1.4318920773046542],
              [16.007378334519302, 1.7293571544493853],
              [15.954881301976855, 1.9160010757599442],
              [15.898172211950373, 2.117895750926485],
              [15.835454449178506, 2.3401874195868606],
              [15.792424784943462, 2.4928310532423543],
              [15.763550088418505, 2.597965819231217],
              [15.749965176337065, 2.661040188822219]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.5004311952289, "lat": 38.98647266200131 },
        "year": "2023",
        "ste_code": ["10"],
        "ste_name": ["Delaware"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779781"
      },
      "bbox": [
        15.749965176337065, 1.4318920773046542, 16.58101801504701,
        2.8173388565991604
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.970127637938052, 0.8827301716042092],
              [15.929920303076974, 0.8742523110628564],
              [15.919603542722918, 0.9097565706530436],
              [15.917646064580385, 0.952543887518399],
              [15.942323924783143, 0.9627114977016298],
              [15.948309396040884, 0.9518385514081418],
              [15.96024100251381, 0.9486229664389192],
              [15.969824386824511, 0.9357382041409735],
              [15.963998716944365, 0.9139071828260542],
              [15.964208602629947, 0.8960579863798273],
              [15.970127637938052, 0.8827301716042092]
            ]
          ],
          [
            [
              [15.894465723717728, 1.0119380012407901],
              [15.903799401045296, 1.021457297285719],
              [15.898972764817577, 1.0365497173336435],
              [15.910425207719474, 1.0441065119736204],
              [15.916057654391768, 1.0288012138074873],
              [15.930205046616026, 1.0166789173335018],
              [15.906049695852781, 1.0016677809780674],
              [15.894465723717728, 1.0119380012407901]
            ]
          ],
          [
            [
              [15.853622022202034, 1.0743231044852075],
              [15.856848882765822, 1.0881689243035568],
              [15.875397166985696, 1.12091756815053],
              [15.89741516619219, 1.1031917074325897],
              [15.890709443139704, 1.0864092317951817],
              [15.9011319402916, 1.0752045552872296],
              [15.885582424988922, 1.0650226709687167],
              [15.874177347091907, 1.0845270551691342],
              [15.863907475645206, 1.0714430574273732],
              [15.853622022202034, 1.0743231044852075]
            ]
          ],
          [
            [
              [15.40324209610315, 2.097967196566789],
              [15.421954960414006, 2.1156944240034767],
              [15.430872677627033, 2.1063841631326707],
              [15.415739431685369, 2.090682210889906],
              [15.40324209610315, 2.097967196566789]
            ]
          ],
          [
            [
              [15.498866997750618, 1.6217879855407122],
              [15.511132466844717, 1.632368787737036],
              [15.52367524260709, 1.6066978135023735],
              [15.513804421544279, 1.6006973046120117],
              [15.498866997750618, 1.6217879855407122]
            ]
          ],
          [
            [
              [12.992170407303297, 2.120675400225142],
              [13.193306679823745, 2.1574181593528117],
              [13.40108242182799, 2.195386905750452],
              [13.55669321969784, 2.224066591119978],
              [13.69604434239877, 2.2492338193896826],
              [13.860275691262181, 2.280049679089773],
              [14.024512726779598, 2.3108346037806475],
              [14.192489334234475, 2.3429245105773986],
              [14.305414346467852, 2.3634380451801733],
              [14.49625722005113, 2.3999274248985003],
              [14.62792023167793, 2.4260159366120404],
              [14.740793995734137, 2.448593177023767],
              [14.853670628584236, 2.471155715208658],
              [15.058968160175114, 2.514383443614861],
              [15.16969392414503, 2.5373804097359147],
              [15.280422560496442, 2.5603631602710295],
              [15.418764253058281, 2.58949075683619],
              [15.593594699610316, 2.6268509760656067],
              [15.749965176337065, 2.661040188822219],
              [15.763550088418505, 2.597965819231217],
              [15.792424784943462, 2.4928310532423543],
              [15.835454449178506, 2.3401874195868606],
              [15.898172211950373, 2.117895750926485],
              [15.954881301976855, 1.9160010757599442],
              [16.007378334519302, 1.7293571544493853],
              [16.090842820310915, 1.4318920773046542],
              [16.193145422846147, 1.4495063915018467],
              [16.32700455988805, 1.4752947622144101],
              [16.47762623361203, 1.5076938544474736],
              [16.58101801504701, 1.5308344569992172],
              [16.58478277988202, 1.4939890858552758],
              [16.58437492114662, 1.4322934033277888],
              [16.581326069262797, 1.3995351020836126],
              [16.570918722996982, 1.384025130725698],
              [16.564423212036154, 1.3157289753113404],
              [16.5563911944345, 1.249124839147899],
              [16.55375682223349, 1.1886729196163754],
              [16.549279883306284, 1.1562843076239029],
              [16.539797447052873, 1.1187758639446885],
              [16.52734479588741, 1.0800627457493506],
              [16.412612017289597, 1.0406485820668787],
              [16.243382038720906, 0.9837068391766816],
              [16.231133183951425, 0.9527044303573903],
              [16.225162484190907, 0.9438635986674875],
              [16.208914989266024, 0.9491044463549841],
              [16.19890868579563, 0.9458684361102555],
              [16.177630514273027, 0.9529076014188559],
              [16.164534056638406, 0.9345942006767318],
              [16.158095962277862, 0.9545802264519158],
              [16.148503412130502, 0.9440864929662601],
              [16.12644195319093, 0.9360349458965398],
              [16.10544300884536, 0.9044342351062161],
              [16.09768863851981, 0.8866234450300186],
              [16.07927865966973, 0.8698007770506089],
              [16.055179492387484, 0.8631113704718704],
              [16.04948372797539, 0.8999310403057084],
              [16.07104764906676, 0.9062833629773467],
              [16.061273196539705, 0.9270173085659696],
              [16.044412091187795, 0.9229106018929758],
              [16.043880014807907, 0.9425080203784738],
              [16.056148885034517, 0.989244245614941],
              [16.06923498689207, 0.9803763803033133],
              [16.09272159820402, 1.0117319841220014],
              [16.094612523562912, 1.0214184441385044],
              [16.059126342831313, 1.0244772994323847],
              [16.041529165509285, 1.0072181646645604],
              [16.033564559085665, 1.0272111432691309],
              [16.043438121303257, 1.0545518377440106],
              [16.05541428909717, 1.0665196584040406],
              [16.052243540195523, 1.0786900327783204],
              [16.072179930239795, 1.0977174942242174],
              [16.0484086179453, 1.103019895372247],
              [16.03298495545766, 1.0893592748556662],
              [16.01519701788084, 1.0932691891244917],
              [15.998126840570624, 1.0837164632997167],
              [15.977387665324013, 1.0605576997068895],
              [15.957494529700364, 1.069650940542613],
              [15.96006498347335, 1.1217499291678439],
              [15.9731300234452, 1.1278506234245849],
              [15.997839044391817, 1.1471445835816807],
              [16.01670210150692, 1.1481469305120744],
              [16.040360813353107, 1.1689151459451974],
              [16.04589764231821, 1.1805218446369579],
              [16.014714200855618, 1.1839300915742206],
              [16.036603158464644, 1.2060899487367087],
              [16.018756893117796, 1.2068721529719824],
              [16.016222594268697, 1.1966894486120483],
              [15.992747980792927, 1.1880093782198122],
              [15.986797667900921, 1.1703291944316019],
              [15.96322439758712, 1.2010862031843372],
              [15.97029351638781, 1.2261298644374978],
              [15.968464628866831, 1.2412435292822017],
              [15.975513151625595, 1.2717377321632888],
              [15.991033771686894, 1.2961532367019686],
              [15.99307033912375, 1.3125665479535187],
              [15.949965545542687, 1.2807878217934658],
              [15.952341775696253, 1.2646397446248543],
              [15.943121952549102, 1.2567971448653013],
              [15.938539293850502, 1.2275073501643403],
              [15.94395547923501, 1.20487783977381],
              [15.934262820638672, 1.1956576476212664],
              [15.944184794837067, 1.170429196252763],
              [15.913368386006493, 1.1959241776630662],
              [15.891912872232753, 1.218895640443521],
              [15.883226385708484, 1.234575417646814],
              [15.903363220109815, 1.2418559561317133],
              [15.913994966938784, 1.2517154638145502],
              [15.912109909193624, 1.2728700149181216],
              [15.898329859759102, 1.2931245882162434],
              [15.883026546249638, 1.2936860577648688],
              [15.87111871727891, 1.2849486102014325],
              [15.872337753238542, 1.2535947650440697],
              [15.853885853424426, 1.2344969224437088],
              [15.853350538233315, 1.219781925127011],
              [15.875807265022196, 1.2011447652118477],
              [15.871133350548286, 1.1591377908975038],
              [15.863236058529594, 1.1437297586703843],
              [15.84212397848002, 1.1671525893174088],
              [15.84015659700091, 1.1790626439237233],
              [15.824544832440395, 1.1874030089516718],
              [15.805064057492011, 1.2059782366020997],
              [15.794648619707608, 1.2007832805108456],
              [15.799285619466964, 1.1869423759736712],
              [15.781667816455876, 1.1844908501649087],
              [15.791368436618013, 1.2042271029222134],
              [15.788533109389842, 1.2118057856489775],
              [15.764138326258577, 1.2128924599556088],
              [15.763063302682552, 1.227769778542353],
              [15.741249421765188, 1.2532576440827567],
              [15.729178434316784, 1.2550319051758436],
              [15.713505813224172, 1.2667185338607057],
              [15.702851757701682, 1.2671612926440379],
              [15.700970072549467, 1.2506135688371973],
              [15.715955324542202, 1.230121836001185],
              [15.72335237651049, 1.2272592983371882],
              [15.720771542188682, 1.2015103917734669],
              [15.735661676984254, 1.1908951548108064],
              [15.741268836913948, 1.1831293472854236],
              [15.759214732912564, 1.1857684883752386],
              [15.760928344370845, 1.1656261002867168],
              [15.778978560324939, 1.1470267467781465],
              [15.791715549177269, 1.1505145396989238],
              [15.808093375813778, 1.1470426517730823],
              [15.799820114335143, 1.133820639501773],
              [15.772741284020235, 1.1446288640768978],
              [15.758712882729233, 1.1582908493165807],
              [15.752323415762659, 1.170514781853901],
              [15.73575113271728, 1.1889875240298857],
              [15.714806663182863, 1.2010222115219846],
              [15.705869449576392, 1.2309741305241972],
              [15.689203324310014, 1.2470364150804985],
              [15.663842019702175, 1.2604489103764904],
              [15.653269983841495, 1.2926683010614068],
              [15.629033766036487, 1.3209742349257463],
              [15.614229293264033, 1.3320542173690921],
              [15.60101224582684, 1.3500874162800987],
              [15.606336520886739, 1.362660038418137],
              [15.62272940730802, 1.3744732051905144],
              [15.64952484895534, 1.3761554238459233],
              [15.657746744001896, 1.4050710277472251],
              [15.676594103020062, 1.417358373429217],
              [15.638606660492604, 1.4203774046260855],
              [15.61591505649817, 1.443035531389497],
              [15.630454921802626, 1.4635229781266994],
              [15.61557585104904, 1.4866604018391492],
              [15.642855890596838, 1.5087582232641834],
              [15.645311201438492, 1.4982706640650347],
              [15.673129503237764, 1.4979952095215525],
              [15.689622443655507, 1.518924837987792],
              [15.701550659420105, 1.5083344506074488],
              [15.70097333641212, 1.4950847222729107],
              [15.714461602779814, 1.4913290472357503],
              [15.720870507134874, 1.5032284205578108],
              [15.746124567661752, 1.4848155776031857],
              [15.766577097211359, 1.4921320495201846],
              [15.80442613477279, 1.4756394311084164],
              [15.816027889422577, 1.4830034063016508],
              [15.80910583407871, 1.4964872304767811],
              [15.790302781488375, 1.505711470476549],
              [15.787910520390058, 1.5151706823468178],
              [15.765207968997265, 1.5215528465337487],
              [15.756642180869694, 1.5313260367712913],
              [15.738798959004702, 1.5228417842096424],
              [15.71902233268495, 1.5367513871382952],
              [15.70999073552688, 1.532722773858705],
              [15.69914762294214, 1.552344201108838],
              [15.678976091672169, 1.5665694451690966],
              [15.67982574703355, 1.5785222146218696],
              [15.669517620463244, 1.5841887566047095],
              [15.662729736520124, 1.5638997392732346],
              [15.650903167226144, 1.5667051152861287],
              [15.624847256181067, 1.5931376687306311],
              [15.620248798959267, 1.6170210788328494],
              [15.639255518573353, 1.6123294392596004],
              [15.644485340264033, 1.624431902187607],
              [15.612153760809218, 1.6389289282246913],
              [15.605124226907497, 1.6264535071248598],
              [15.607549338377112, 1.6138675163218703],
              [15.598587628244484, 1.5995082045956335],
              [15.579217842938062, 1.5952028401487224],
              [15.571864837987398, 1.6200270622957749],
              [15.561983969196516, 1.6139354433792472],
              [15.554802858614456, 1.5683791933587117],
              [15.56682038938399, 1.5568596033391264],
              [15.555802751366235, 1.5406205617052966],
              [15.547676491267369, 1.5554579756418458],
              [15.547434552190163, 1.586600992747977],
              [15.538848482741743, 1.6123588093225065],
              [15.53987192775793, 1.6372165063422155],
              [15.553442864129208, 1.6647505250791483],
              [15.55089132622821, 1.681231436460959],
              [15.55618000065635, 1.697779931728258],
              [15.576337924761724, 1.7218213372956555],
              [15.600525822590653, 1.6958129523626493],
              [15.609288440647925, 1.701804519897175],
              [15.626059452791289, 1.6889742103036298],
              [15.62630297157378, 1.6696304213796271],
              [15.667847887398318, 1.6443831246820206],
              [15.671111422224186, 1.6586498445618567],
              [15.655712725322651, 1.665809972719983],
              [15.635106135936448, 1.6883052588894025],
              [15.6364578791467, 1.716091687333015],
              [15.620268820059954, 1.7367501566916983],
              [15.618475065134925, 1.779785529299672],
              [15.613086033534671, 1.7794318642828917],
              [15.599392650353701, 1.8262055609425796],
              [15.579905938203396, 1.8205674944164278],
              [15.568553106588817, 1.8420022666253293],
              [15.561274351245773, 1.8397061065154612],
              [15.568115572484201, 1.815698438513049],
              [15.551202465886432, 1.8139041514807674],
              [15.532930148371753, 1.7895119255328156],
              [15.522323399968318, 1.7883323772117732],
              [15.506809915480298, 1.7735393708987717],
              [15.5236196264714, 1.7280734771199522],
              [15.50210111289075, 1.7087698328981145],
              [15.492540728211289, 1.7122769986645527],
              [15.49625449942588, 1.7321434762505912],
              [15.4885467484279, 1.765222595718202],
              [15.484945968892506, 1.797152549783444],
              [15.487159364403619, 1.8162371263852761],
              [15.501262704450484, 1.8588533447676674],
              [15.498797036955484, 1.886504074335647],
              [15.516419161450715, 1.8862640523156924],
              [15.522572852869137, 1.871840405420378],
              [15.539451363984238, 1.8532646912198651],
              [15.56497807197816, 1.8567846546698976],
              [15.570587250961637, 1.8505312954364699],
              [15.598004983633635, 1.8559023445378895],
              [15.621375998605274, 1.888138845533097],
              [15.619456221704999, 1.898579526411927],
              [15.603898050405913, 1.9175730063737466],
              [15.600479299794019, 1.9448444786019299],
              [15.611363702289902, 1.954038868184936],
              [15.616254878396619, 1.983489821636389],
              [15.621748183165014, 1.9962990102518943],
              [15.594118865074721, 1.9981178384622778],
              [15.583100518242665, 1.9935440423423394],
              [15.585762914681604, 1.9805293705366653],
              [15.573736679428784, 1.9668535582726148],
              [15.57155668813331, 1.9329547616956806],
              [15.590217215102413, 1.8959558780211079],
              [15.584922862136597, 1.8899468160160473],
              [15.555985829584627, 1.9046330580783994],
              [15.5580054635414, 1.9381538028765206],
              [15.546234967239368, 1.9757418428705094],
              [15.533816158831858, 1.9925507988759212],
              [15.533158133132698, 2.004716200437156],
              [15.50644824303897, 2.0151573112644363],
              [15.503521456443922, 2.0344053341468245],
              [15.514235867784707, 2.0714338525633593],
              [15.521377626787505, 2.1081276234867876],
              [15.523472843059666, 2.1337356376084484],
              [15.535620435206075, 2.159273335681447],
              [15.542780335976596, 2.1621431595033473],
              [15.547183985408488, 2.182382277120491],
              [15.538293169127801, 2.200367124312187],
              [15.554249027598898, 2.22083329612188],
              [15.574522615085295, 2.2220114428828652],
              [15.571222565319845, 2.2417801617032964],
              [15.581469488125299, 2.252397628187144],
              [15.583459941050009, 2.2645056559637053],
              [15.619628767616781, 2.2719173297476796],
              [15.65120608389869, 2.2682292078619515],
              [15.671352416713964, 2.282983878763684],
              [15.667255054191457, 2.2951849745894197],
              [15.640381645914344, 2.2902249583136114],
              [15.634978534751587, 2.3073122652480227],
              [15.652178349369905, 2.322720317243651],
              [15.65594724401471, 2.3398071263179627],
              [15.665980105645199, 2.3470785498382427],
              [15.67210987119243, 2.3767998723207393],
              [15.64694349361651, 2.3746299906887147],
              [15.648817636560445, 2.4070675068683545],
              [15.647740509791353, 2.4399324424400017],
              [15.659831865217692, 2.4497419404898477],
              [15.64961718694232, 2.469441843648938],
              [15.661320114493254, 2.4959314831850348],
              [15.651370824664065, 2.5061344128620044],
              [15.644585970022904, 2.481920765625001],
              [15.6267984224431, 2.467835687892517],
              [15.6247998351943, 2.4526854344604936],
              [15.600628305272146, 2.454402850354259],
              [15.559733052901707, 2.4292494537724427],
              [15.549577244085295, 2.3775764842757723],
              [15.570813659077205, 2.3689168340002844],
              [15.590738902290632, 2.372048124128639],
              [15.60496426463619, 2.349136872239514],
              [15.591908048310069, 2.332766126377003],
              [15.584093438557032, 2.339778997519662],
              [15.549688732824912, 2.2914284802374296],
              [15.54019384357169, 2.290449070144746],
              [15.519652145827001, 2.2464448546095825],
              [15.495347292712609, 2.22498813154781],
              [15.481168023215266, 2.231599678019198],
              [15.475076394321762, 2.2482830304340706],
              [15.477114709173817, 2.2783381399566234],
              [15.48685121932132, 2.2991316886450317],
              [15.475015744261757, 2.3094094020934963],
              [15.475637776774327, 2.3284608350123808],
              [15.466797889096558, 2.331610161214594],
              [15.46162417876239, 2.3112231620075043],
              [15.46781785806811, 2.304769952927425],
              [15.467118467693554, 2.280776090283378],
              [15.458272534201656, 2.2698267615149383],
              [15.463446224944404, 2.259839394265972],
              [15.458346153729702, 2.2372718666715445],
              [15.47008022124047, 2.2270491989335803],
              [15.48084278774925, 2.207336374296698],
              [15.468610259939881, 2.188556467334325],
              [15.470277721103304, 2.1657405736126982],
              [15.458631459315608, 2.165737108184271],
              [15.460730866160615, 2.181780884783947],
              [15.451363498437775, 2.1922244996475775],
              [15.450557608517695, 2.2123998618148493],
              [15.438202640218114, 2.215172390597542],
              [15.438620513573087, 2.2390900533617337],
              [15.429614815694674, 2.2487502029661237],
              [15.39417338988195, 2.2470901521771194],
              [15.42647663933379, 2.181707980715714],
              [15.424161326396707, 2.1680366146457417],
              [15.411442340347332, 2.170108903088133],
              [15.389397056779009, 2.1349725970008495],
              [15.39178167118623, 2.1154292526222473],
              [15.380485847291553, 2.093471834709892],
              [15.358054632783078, 2.097142149597281],
              [15.353848517611393, 2.0892207654015955],
              [15.378554399967255, 2.077320580776166],
              [15.384790850316438, 2.0655093871777135],
              [15.374265201322775, 2.0451304507242334],
              [15.363200317084807, 2.059408858382231],
              [15.353249081897125, 2.0446029785390754],
              [15.329866981529955, 2.035579718657577],
              [15.323476283244966, 2.0600543221235337],
              [15.311726994621276, 2.0592243038789313],
              [15.30555971191939, 2.071412238264037],
              [15.293981475647621, 2.06663652910184],
              [15.275603523477463, 2.0815994633034336],
              [15.24946542545774, 2.080166016245935],
              [15.269304473983281, 2.0635097986220714],
              [15.273504292001663, 2.047307831199125],
              [15.300624711776585, 2.0378675570527167],
              [15.312185499899101, 2.0072045825425864],
              [15.34439371920818, 1.992740679902427],
              [15.357784110470622, 1.992779706391182],
              [15.39285221946338, 1.9768118503245407],
              [15.39558326078319, 1.9558498750421847],
              [15.411086326477625, 1.9237881750432633],
              [15.403290931769291, 1.8972114920044298],
              [15.432820454486134, 1.8831969007590788],
              [15.445034990115222, 1.8645885394314228],
              [15.432691816159721, 1.8504183770404432],
              [15.40944301238119, 1.8388343215299903],
              [15.41009452223875, 1.8211350385344536],
              [15.389902762988429, 1.8209547148969347],
              [15.39876326436767, 1.7970220972201505],
              [15.417772790045754, 1.7851096325015556],
              [15.410525273810547, 1.7695413613343405],
              [15.409391893887886, 1.7528480057840752],
              [15.391016189098387, 1.7653620024375374],
              [15.377765113851376, 1.7548858841701778],
              [15.390961269101686, 1.7467645283320614],
              [15.398892015606846, 1.7231381705159086],
              [15.371122578040593, 1.6833248369730005],
              [15.38728977616778, 1.6870656071269683],
              [15.408985094220036, 1.6777155988921568],
              [15.40781295696671, 1.6528195047654533],
              [15.391679260570795, 1.6290682859712586],
              [15.384752333824592, 1.6066806378984753],
              [15.370743895301285, 1.596215176366882],
              [15.377170730346803, 1.5741749756481709],
              [15.390533782048474, 1.5594412426961133],
              [15.40506189631997, 1.558934135828909],
              [15.405322478526745, 1.5336090017458723],
              [15.409803489305265, 1.5125745120528362],
              [15.422349585172816, 1.4817701780959338],
              [15.438664750667204, 1.4540133075764454],
              [15.440074642436615, 1.4279985728899542],
              [15.453143772908579, 1.3675722422819294],
              [15.480089560711816, 1.3256021991238498],
              [15.55284587942137, 1.2704776444462165],
              [15.566811985800122, 1.2524807819467048],
              [15.584159659205397, 1.2478373831447518],
              [15.579628216709917, 1.2352068335652795],
              [15.58545369824383, 1.2222043544797023],
              [15.568887598804167, 1.1791838664143832],
              [15.5443755297959, 1.1744018334595465],
              [15.53036964668241, 1.1773457121618036],
              [15.527391754385684, 1.1608609868001756],
              [15.54435020995941, 1.1446788241614267],
              [15.567135256187175, 1.1494333250672193],
              [15.56996973426246, 1.1607023819717488],
              [15.589707287349777, 1.1688036656673761],
              [15.607362344527973, 1.1629960148869356],
              [15.597178996455991, 1.1390111800195863],
              [15.597179320132522, 1.1194657981660654],
              [15.616486783259203, 1.0806644298572332],
              [15.64885807163381, 1.0465794641069162],
              [15.667278669844375, 1.0314006939915747],
              [15.682550413571061, 1.012594176537874],
              [15.671308886863038, 0.9876373427867584],
              [15.681597298531209, 0.9724313262579253],
              [15.688892922101857, 0.9459027840575125],
              [15.699686597534194, 0.9247070087700667],
              [15.675340083198575, 0.9232261942239446],
              [15.634844913999212, 0.9660290094922394],
              [15.612168272973053, 0.9645295963780973],
              [15.593487128074681, 0.9916422714199806],
              [15.587380846390749, 1.015871918914189],
              [15.565459934489398, 1.0035892273233846],
              [15.574782246850347, 0.991073562394936],
              [15.572384298340193, 0.9698687332265938],
              [15.564511452293825, 0.9647311696285314],
              [15.543700086374475, 0.9841288364022984],
              [15.530789615205682, 0.9835777751464533],
              [15.511623703055907, 0.9920122433885181],
              [15.49501328876205, 1.023849866738074],
              [15.46076560863049, 1.0445944902273114],
              [15.426496445420497, 1.049306399677549],
              [15.415362852076504, 1.046459570159455],
              [15.37278333157087, 1.0537187386557392],
              [15.358445598980959, 1.043007619631331],
              [15.346532351463962, 1.0538027680084054],
              [15.335977464784941, 1.0270187538003672],
              [15.314616589683343, 1.0291803568643687],
              [15.31232296707785, 1.0436051537055508],
              [15.28924600137591, 1.0499319193220338],
              [15.286917445938338, 1.0732143323897658],
              [15.263866593319728, 1.0955600434036772],
              [15.250284819326458, 1.124632221893689],
              [15.253609659839997, 1.1392400422674627],
              [15.229285848743887, 1.145794133707417],
              [15.224197144730107, 1.117191877313205],
              [15.241329787585375, 1.1043572974784086],
              [15.262592178375373, 1.0654659809204838],
              [15.256853736515206, 1.0458968973859764],
              [15.241153549677376, 1.05586614634886],
              [15.204375134458108, 1.0684851169280283],
              [15.19058522620162, 1.0679868475123278],
              [15.18851968194603, 1.08882407105666],
              [15.179996798444504, 1.0991987051449057],
              [15.148198407774588, 1.1117781143341239],
              [15.131392807187549, 1.1304437911632843],
              [15.121401746873667, 1.1613580987051608],
              [15.08989585812726, 1.2070958950139805],
              [15.071638783722541, 1.202420626988918],
              [15.049119127701925, 1.1773687148831389],
              [15.040692792395609, 1.157992012255889],
              [15.01554004618062, 1.1561188459943126],
              [15.009096349840286, 1.1354136365673306],
              [14.98119483697107, 1.105855179281256],
              [14.961716173185991, 1.0930229319171127],
              [14.924546446281, 1.1091791442952827],
              [14.907088485651723, 1.1373196966988768],
              [14.910132942190685, 1.155373191044079],
              [14.892718781633478, 1.1865153524874033],
              [14.886673323499, 1.203527516732217],
              [14.888700800103582, 1.2354074973189655],
              [14.900534544460054, 1.278463999678336],
              [14.912482870759876, 1.284300126778451],
              [14.928796661601321, 1.3186679386525397],
              [14.93229963228869, 1.3347699292416146],
              [14.94128151893824, 1.3432530801591438],
              [14.957482896313715, 1.345198936887697],
              [14.978958489097833, 1.3679268184363698],
              [14.965623336512248, 1.3771254181553192],
              [14.958352993818805, 1.3909025626020906],
              [14.956152012030044, 1.4151708033082167],
              [14.971728716663211, 1.441987091118636],
              [14.988957330614268, 1.458016648269004],
              [15.009039435326962, 1.4630015593970713],
              [15.014710828586022, 1.4806190912826973],
              [15.003435884670454, 1.546033719265387],
              [15.081108810712488, 1.6659757317273014],
              [14.961219572292226, 1.747007252643242],
              [14.913897606654318, 1.6749028482263562],
              [14.887681500785167, 1.700378029285201],
              [14.872807432202158, 1.7013026960744089],
              [14.848733399837718, 1.6952396893718307],
              [14.829719862749855, 1.6960642557909882],
              [14.810041633593293, 1.703682008551329],
              [14.797743309168428, 1.72167855393244],
              [14.802617511901085, 1.7408682398188262],
              [14.792584947317176, 1.749052312847918],
              [14.777138652478722, 1.7501696918845067],
              [14.760805225050694, 1.7596903117035576],
              [14.721964375468852, 1.7689194026926538],
              [14.696053692494377, 1.7620304826078679],
              [14.658672649015093, 1.7603650035554128],
              [14.627088077831623, 1.7637604008795544],
              [14.603140130281169, 1.7930354293570265],
              [14.579068465458521, 1.7978453709794837],
              [14.57030240230637, 1.8056129001316732],
              [14.56465875210062, 1.8234415761967864],
              [14.568030526769414, 1.8494615842654833],
              [14.574338561594182, 1.8621803076939263],
              [14.58808828374079, 1.8686081594152812],
              [14.594529631619354, 1.8794119235421252],
              [14.592951628723904, 1.8929576035833118],
              [14.601694857468667, 1.9117702059474646],
              [14.575354134758161, 1.929780784169245],
              [14.558102972012632, 1.9315686011976554],
              [14.529124824243452, 1.9405796535033983],
              [14.512121710935295, 1.956997413319138],
              [14.503916611889755, 1.9759191382868913],
              [14.488451282240892, 1.9686016905614416],
              [14.467463640899398, 1.9652785329426963],
              [14.439530242663565, 1.96810392644456],
              [14.418245366059104, 1.9777316614661289],
              [14.40306288731875, 1.9690568772126291],
              [14.385953816308806, 1.9684806934736008],
              [14.356247612054835, 1.9756402309413381],
              [14.35139764494359, 1.9864304995036413],
              [14.35993917449998, 1.996216547882199],
              [14.349582755898716, 2.020000466116359],
              [14.360511062348339, 2.0318100302093742],
              [14.34106440997766, 2.0645339889687686],
              [14.332384638604454, 2.06816568681471],
              [14.309862285364764, 2.0660134367965757],
              [14.311658163669636, 2.0834240935477846],
              [14.297963522748246, 2.1163516833678027],
              [14.314378656944324, 2.1271213561054463],
              [14.30506364875774, 2.1354462747074616],
              [14.296355223102491, 2.1240538780118046],
              [14.257074456679193, 2.125705274318894],
              [14.268591984727266, 2.146700411198926],
              [14.238070532884754, 2.1415897410754416],
              [14.23615022354882, 2.1588404083485266],
              [14.216279065489347, 2.1726092793921654],
              [14.220059260767417, 2.1851993032866535],
              [14.247101109550131, 2.1912831556181547],
              [14.252535684166508, 2.1991996291770763],
              [14.251290234076212, 2.2195409946649183],
              [14.24221271365306, 2.233272965889115],
              [14.205057639292404, 2.236013397383068],
              [14.206068992643628, 2.2172745907052986],
              [14.178534916742516, 2.219685634041963],
              [14.170105309954756, 2.1998708221186396],
              [14.159368578438766, 2.2035289986898157],
              [14.148723410128303, 2.2179112845357793],
              [14.139488755592815, 2.2069389645898267],
              [14.11268274626612, 2.2062589645783346],
              [14.0882037823868, 2.234065738656491],
              [14.050804336607866, 2.26097520257711],
              [14.025595189949088, 2.2697836158190925],
              [13.97547393908384, 2.2740936921913795],
              [13.96703166384969, 2.2719776791592268],
              [13.955380514019724, 2.2508240467067013],
              [13.937208365747484, 2.2468399195607174],
              [13.942343817885783, 2.2339390921515125],
              [13.923921300012246, 2.2073442283347906],
              [13.918341254495434, 2.1844573916693877],
              [13.850502509118563, 2.193931188737016],
              [13.845258266549362, 2.1781308431384967],
              [13.830610586802315, 2.1714817754111233],
              [13.836811978048452, 2.158206703502283],
              [13.802086145833979, 2.1679643257159054],
              [13.793348387260785, 2.1604186039391213],
              [13.805883127230272, 2.147290895005991],
              [13.825676541862336, 2.1377036527097886],
              [13.819914469749328, 2.1246807868760493],
              [13.791207921321533, 2.1322061284684457],
              [13.781391983678171, 2.1264992786839985],
              [13.785921484473421, 2.113943016380711],
              [13.81834417561278, 2.0946362022581595],
              [13.79563722950959, 2.0784310834190562],
              [13.78586598079146, 2.0548969448443337],
              [13.759556396835162, 2.051908015632731],
              [13.744758561724636, 2.0554541025787794],
              [13.71227962429423, 2.0439394463240865],
              [13.69031684901523, 2.052563999895116],
              [13.66568437477477, 2.0559036930420205],
              [13.641814412288056, 2.046555847491482],
              [13.614640192310151, 2.0529097865536037],
              [13.609387905100682, 2.0596166921348114],
              [13.584605974105148, 2.066058331230467],
              [13.573739208371947, 2.0872883148692125],
              [13.56568523436521, 2.0785553331176683],
              [13.548416022963524, 2.0835356281787156],
              [13.5378931723521, 2.0958395882392438],
              [13.544085031488525, 2.104500803801767],
              [13.568923462210833, 2.1144162057085207],
              [13.555612073884902, 2.1246198239592817],
              [13.545940977229206, 2.1152939005491826],
              [13.534660992271604, 2.1161145277634184],
              [13.535559807747243, 2.13184071491683],
              [13.521571026980446, 2.1307158046727497],
              [13.515427568278303, 2.1185186192120646],
              [13.523579017262731, 2.0989321832687997],
              [13.504224492991584, 2.076829807213599],
              [13.51280230328719, 2.0494650734267394],
              [13.49870603648975, 2.053746212461526],
              [13.479599778573649, 2.004439190788166],
              [13.46770395017737, 1.9921683932826355],
              [13.454724400061048, 1.962933375465116],
              [13.441907827208532, 1.960233864980392],
              [13.432018923035388, 1.9261663035729266],
              [13.432768714203364, 1.911497192277735],
              [13.369772069798277, 1.9283024131865307],
              [13.331955926545167, 1.9252021804603898],
              [13.304958666719974, 1.877469478742729],
              [13.3076102174012, 1.8655818098238186],
              [13.292129060620637, 1.8597018376455494],
              [13.281849251814172, 1.8439596740012079],
              [13.286897101218393, 1.8356059732459167],
              [13.270722177055667, 1.8259393006511155],
              [13.260948831921143, 1.8276240479922496],
              [13.252478282012271, 1.800372588852446],
              [13.239190792367975, 1.799118718663519],
              [13.22736747727865, 1.7878595699104112],
              [13.226927459731739, 1.770810978882407],
              [13.20853301189414, 1.751108398352716],
              [13.206536347039066, 1.7264387009090445],
              [13.187129255337588, 1.728178955886261],
              [13.166716684257494, 1.7134470496623762],
              [13.162342170620397, 1.6967941001248572],
              [13.144514043699468, 1.6872680700002127],
              [13.135657671381587, 1.6754624488128598],
              [13.117721298592155, 1.6378169669462448],
              [13.108013347978199, 1.6247370736890796],
              [13.087697440608444, 1.6074968132717238],
              [13.074396527561705, 1.6074438532779558],
              [13.06089921260204, 1.6808652620756017],
              [13.052140674749667, 1.745272893846129],
              [13.020944670312936, 1.9317568654811448],
              [13.02357862537608, 1.9322190728730115],
              [12.992170407303297, 2.120675400225142]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.77390863305521, "lat": 39.0374180954519 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01714934"
      },
      "bbox": [
        12.992170407303297, 0.8631113704718704, 16.58478277988202,
        2.661040188822219
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6401822948134792, 1.9011802407597256],
            [0.733396490277555, 1.900488693731867],
            [0.82107962269591, 1.8987111233883225],
            [0.9354841796958896, 1.8978290069023376],
            [1.0498885362990558, 1.8969289800673526],
            [1.222991167928384, 1.895394578798959],
            [1.358411155944612, 1.8948276061712679],
            [1.4938309381590524, 1.894235577991261],
            [1.6013233937274578, 1.8953797160379895],
            [1.753347894225956, 1.8987772429575036],
            [1.909264252654974, 1.903144913248134],
            [2.046134741381181, 1.9091774341921868],
            [2.2026627578170115, 1.9146882976968225],
            [2.309520704503726, 1.919927491949928],
            [2.3897069367945685, 1.9215349323702333],
            [2.526027431852093, 1.9262214660684207],
            [2.6198975216765437, 1.93106253822557],
            [2.7658882915504903, 1.9405412291577646],
            [2.9044394738805783, 1.9463080639753436],
            [3.03759073061359, 1.9542453846383423],
            [3.109475889158148, 1.9596650244698812],
            [3.255335871962476, 1.968855725227286],
            [3.401197866657003, 1.978017095918405],
            [3.512855299272942, 1.9863639940220104],
            [3.676855849794116, 2.0017880284792073],
            [3.690550352413172, 1.983641448552697],
            [3.7085330250204454, 1.972711736603016],
            [3.708115920008755, 1.9489613226873679],
            [3.715269242414726, 1.9423650172957234],
            [3.7582645047702936, 1.9347086735600438],
            [3.7631068483342673, 1.9304749519073185],
            [3.7617247613479794, 1.9081631470639342],
            [3.7662449895061667, 1.8960118149549121],
            [3.7834963342668195, 1.8869213644860046],
            [3.7953809775634255, 1.8632672549568672],
            [3.8082903265207486, 1.853747841274658],
            [3.8349365210656288, 1.8529921029557745],
            [3.8320711580345272, 1.8344880618286206],
            [3.8434771962229637, 1.825429392973121],
            [3.840231621978402, 1.8045492653993627],
            [3.8606463922522822, 1.7965908332503333],
            [3.8750649318131196, 1.77694073043207],
            [3.9042677981847436, 1.782850484781163],
            [3.921111935953661, 1.7755932379598092],
            [3.9026762690423302, 1.7594685229042966],
            [3.8906196820983423, 1.737936738088285],
            [3.884515392935164, 1.7123306728346357],
            [3.8706089763920963, 1.6721693278150505],
            [3.8731686591746324, 1.6533907391112854],
            [3.8622041313268407, 1.6294523933609997],
            [3.8655486427897503, 1.5911984700054573],
            [3.8599426927089517, 1.5735655575501455],
            [3.8646505839019563, 1.550162061231387],
            [3.864477047860882, 1.5201915444577307],
            [3.878524976196133, 1.4632503834704063],
            [3.8835343852312456, 1.4498380113739124],
            [3.8805433888484377, 1.4285055849962085],
            [3.920367253936828, 1.3526834563291577],
            [3.9409291544009393, 1.3268753424692183],
            [3.942533286904108, 1.3086616588964484],
            [3.9263798042098275, 1.2863875228330233],
            [3.9238463585193624, 1.2704756551526808],
            [3.9397123627064157, 1.2306793657950725],
            [3.980186760131076, 1.2058387669633521],
            [3.9938121534190403, 1.1800402118050144],
            [3.9901098076535493, 1.1267633730166162],
            [4.004095926602615, 1.1100231907216398],
            [4.064893520778404, 1.0629879821384307],
            [4.093291265308714, 1.028340458643759],
            [4.112785409331229, 1.0142199423463731],
            [4.136711101811217, 1.0053185704197334],
            [4.145907088324053, 0.9938548423657213],
            [4.152114462009739, 0.9654857404649102],
            [4.168464133612021, 0.9469867464639655],
            [4.205429138993838, 0.9417060653818944],
            [4.226376265874543, 0.9065577241707945],
            [4.235205921775918, 0.898726529284713],
            [4.240273095189803, 0.8729312825321542],
            [4.257515702028131, 0.8531873020418123],
            [4.2928489173064825, 0.8292906620033139],
            [4.328439266770775, 0.8155515535798585],
            [4.340189624075161, 0.8006361388570603],
            [4.360683372061157, 0.7902945582900596],
            [4.372287254365065, 0.7773023502506667],
            [4.414803278770332, 0.752402431898396],
            [4.433689949251461, 0.7332710024699685],
            [4.452195173837, 0.7231648790764833],
            [4.48668630854281, 0.6805132642173681],
            [4.5063351429003875, 0.6671855814941439],
            [4.515982564902251, 0.630048840126024],
            [4.516684857502168, 0.6134071787715476],
            [4.525390324177041, 0.5711195076680139],
            [4.533155210990953, 0.5516618250088183],
            [4.545207174908425, 0.5344848319082999],
            [4.549406353431996, 0.5049546037593039],
            [4.528290898878193, 0.4721422532750935],
            [4.529605297783899, 0.4618348540469672],
            [4.558351996567697, 0.407879242962137],
            [4.561756244365112, 0.3780257561088539],
            [4.573323864577809, 0.3435285833859758],
            [4.595867792925572, 0.3210919614484054],
            [4.605030894884782, 0.3061507172355879],
            [4.638280458561846, 0.2881945143338114],
            [4.66823141981752, 0.2959977071192803],
            [4.694772351807941, 0.325559582953628],
            [4.70916971565093, 0.34987266981746895],
            [4.718665606624931, 0.38365386599492096],
            [4.734539248569594, 0.39360726920298955],
            [4.768999841239836, 0.39036034293168015],
            [4.787290452295815, 0.38425832809647303],
            [4.845824642000394, 0.3560529328551642],
            [4.8916532513135484, 0.3539835238063035],
            [4.9133129842175824, 0.3432058369048803],
            [4.9340924508854105, 0.3245043401032164],
            [4.95880046762667, 0.3145879845452957],
            [5.001340646360758, 0.2898584724600936],
            [5.005330990549738, 0.2781101462505074],
            [4.997009774857012, 0.2377359900114704],
            [4.965223041071407, 0.21008098686642293],
            [4.9537147121427925, 0.1832751167300968],
            [4.937811214214495, 0.1674328205027167],
            [4.933821169727993, 0.1465526582994354],
            [4.9593644851032055, 0.10117486088577853],
            [4.964534795040494, 0.06487034737514785],
            [4.956357615242913, 0.033818694562132975],
            [4.932792155455626, 0.008202653360091185],
            [4.907738053002668, -0.04055880603101711],
            [4.88867156880331, -0.14256725431686132],
            [4.853805090827306, -0.18495456033209384],
            [4.8355386899822665, -0.2351619425953797],
            [4.833214479240679, -0.25239526739376283],
            [4.835324199091878, -0.28982364051456144],
            [4.842604218805874, -0.3302147919096554],
            [4.854217502565941, -0.3619145179609136],
            [4.8806663043777325, -0.39297298717239154],
            [4.905886050843102, -0.40272978327938963],
            [4.918973787190335, -0.4149288062208373],
            [4.946447071633164, -0.4587363764216987],
            [4.966553063372418, -0.4760317833989009],
            [5.000307973736835, -0.49745262472298124],
            [5.015103388954788, -0.4928549480676732],
            [5.03693969229097, -0.5041107717421147],
            [5.041864305972568, -0.5256986600416379],
            [5.068534622560188, -0.5471809236635348],
            [5.095469677693872, -0.5478170371047688],
            [5.115096438620853, -0.5646391587138265],
            [5.140569950037069, -0.5930771979498666],
            [5.153951238854548, -0.5985020249226293],
            [5.190687744829551, -0.5868282131279676],
            [5.203748539771812, -0.6031014971985165],
            [5.187460526329532, -0.618099157643813],
            [5.177947618438797, -0.6188467845431908],
            [5.167930035301129, -0.6407101287051086],
            [5.187176581592704, -0.6759099491326196],
            [5.210850809475399, -0.6870922003665462],
            [5.227563611434057, -0.6868804196099805],
            [5.2428097133731475, -0.6760145774028565],
            [5.256131703703946, -0.6576341520939777],
            [5.269728944994267, -0.6479847712246555],
            [5.307882393049528, -0.6717265119523758],
            [5.310733690693037, -0.6919301542568952],
            [5.3554251227746175, -0.7017207158403832],
            [5.364365463147425, -0.713121113735408],
            [5.386331101701604, -0.7301542734631411],
            [5.413380970920176, -0.7454470811345032],
            [5.421530794260942, -0.7586924111501353],
            [5.417388481635456, -0.786102127266558],
            [5.432753936185155, -0.7992290463542367],
            [5.457666009724119, -0.7932853048472619],
            [5.474991306237651, -0.8091544829408184],
            [5.486681795629054, -0.8282257821478001],
            [5.532708984729085, -0.8400983545206593],
            [5.544324693680973, -0.8523768976836246],
            [5.542910304420612, -0.8973156193116805],
            [5.552751687198615, -0.9130045932415143],
            [5.5766023563155, -0.9378657388692875],
            [5.578167556899011, -0.9508986939111114],
            [5.565645824288284, -0.9575966363916922],
            [5.547737101012722, -0.9543813605646877],
            [5.5451541332621, -0.9786123371773933],
            [5.551177407437126, -1.0036803109537837],
            [5.5654415293510535, -1.0255800011002716],
            [5.573161006138278, -1.0442244263996985],
            [5.591413204240719, -1.0708363931448095],
            [5.608418651484181, -1.0862657754839473],
            [5.6232443862678005, -1.1087424054401214],
            [5.634471103169864, -1.1380369357510185],
            [5.632840258017334, -1.1796153513212277],
            [5.627488161119565, -1.191843021497356],
            [5.597660640813726, -1.2002507601016015],
            [5.585071445755925, -1.2080003209565602],
            [5.570264730694435, -1.2297945696705734],
            [5.566901198529218, -1.2556533419688096],
            [5.591608252943118, -1.2885503563056717],
            [5.614641625001827, -1.2877138086584439],
            [5.617230178195883, -1.2978658593288805],
            [5.611280089028189, -1.317019749705389],
            [5.617265410351555, -1.3391996274520097],
            [5.6415512640257255, -1.3855127665941127],
            [5.659766468435679, -1.4116114423122563],
            [5.685161472960815, -1.431886700062784],
            [5.693125061277056, -1.4488677468069204],
            [5.687561067735099, -1.4777774752465447],
            [5.694283655487953, -1.4956662194601265],
            [5.707472756267319, -1.5043057307671523],
            [5.744378664976266, -1.51931095917709],
            [5.765595580830256, -1.538636156086275],
            [5.776500754918951, -1.5414254306648685],
            [5.785729119297728, -1.5330488093216774],
            [5.79116783751959, -1.5132406601612551],
            [5.773833994594029, -1.4935806178415294],
            [5.754552216661341, -1.4859966970728098],
            [5.746182799042057, -1.473518487411051],
            [5.74778611038563, -1.4615087065901902],
            [5.78585623667526, -1.4644643983822627],
            [5.808183904649902, -1.4899893988651733],
            [5.8323066906566305, -1.5057017229258367],
            [5.838073832033339, -1.5137120131816344],
            [5.845407880562191, -1.5452926278622212],
            [5.86354227101607, -1.553802416434249],
            [5.892131116056546, -1.5396953503345954],
            [5.903505584562542, -1.5391963369348156],
            [5.919535844714394, -1.5555761134456072],
            [5.920117147280087, -1.576350086891429],
            [5.910988913801707, -1.634305387345951],
            [5.897783236349084, -1.6757437122102072],
            [5.870305333594023, -1.6853573110825946],
            [5.866592293946043, -1.6941619142465623],
            [5.86950053119358, -1.718336202940882],
            [5.887844782196641, -1.7353724951554592],
            [5.909286003264716, -1.7352895826494295],
            [5.919721657734245, -1.7467460382043027],
            [5.91411469011194, -1.7713058735987297],
            [5.881283403088419, -1.765685356629964],
            [5.867759387229628, -1.7727230158243363],
            [5.858270720701087, -1.7877963703953152],
            [5.858633562022027, -1.8114107429105069],
            [5.8843280334417365, -1.8370504763635083],
            [5.886192538151267, -1.8541006767223094],
            [5.894235860123664, -1.8591261186004575],
            [5.866368525578332, -1.898980123973972],
            [5.864415199932448, -1.9267971465510043],
            [5.857270661818628, -1.9490133173109474],
            [5.84712885073432, -1.9606054684580143],
            [5.822846915494205, -1.9668116533115318],
            [5.814835209029547, -1.9633746444036353],
            [5.7919760094246024, -1.9398860800285964],
            [5.775214279975538, -1.9143737652596717],
            [5.763791643390805, -1.9029726221778474],
            [5.740443353797834, -1.9084001536880075],
            [5.726316309491103, -1.9222531264068308],
            [5.722774959501791, -1.9549832998607637],
            [5.714022229327384, -1.9798197371211046],
            [5.713032318814526, -1.997405514494931],
            [5.701299804083866, -2.0420288825828727],
            [5.687530911819314, -2.0678382660408032],
            [5.666961267617542, -2.0866938572349545],
            [5.64911882847234, -2.0834391831528603],
            [5.64215309939818, -2.06664521002877],
            [5.647265000096341, -2.04729262884135],
            [5.660536644847745, -2.0135599134040376],
            [5.652542173727762, -1.9837987978210068],
            [5.642594704635868, -1.97244417919315],
            [5.608027489021804, -1.9653767415662375],
            [5.588414365646052, -1.9707248789483267],
            [5.578048086682571, -1.9845360071708924],
            [5.57568772631737, -2.001758589693611],
            [5.5858367345555795, -2.0232238424040387],
            [5.604489220131763, -2.049767203232579],
            [5.6187870087722835, -2.0656084658349783],
            [5.622118055139882, -2.079844309394402],
            [5.617176130883975, -2.0958111179719485],
            [5.6041756209068465, -2.113511453353006],
            [5.607356713852394, -2.128271979676771],
            [5.63235139272771, -2.1621717739665853],
            [5.636496080695368, -2.173278599670051],
            [5.63083429973198, -2.1989684021036804],
            [5.621269634512791, -2.20907781600894],
            [5.598588820890136, -2.212135700146745],
            [5.581398178817175, -2.2086376741504288],
            [5.558397720343885, -2.2121246354392836],
            [5.551962072435008, -2.2301844273464804],
            [5.559623738103991, -2.2437397429240273],
            [5.587584010100187, -2.262852369199148],
            [5.623031799363688, -2.2784181376808457],
            [5.624889142454886, -2.29645325623423],
            [5.6064657811550225, -2.2992609612238994],
            [5.583869181422427, -2.3124689951318946],
            [5.564894310948805, -2.3139630756273104],
            [5.531140154388708, -2.3046813562770536],
            [5.5109520107936225, -2.3084618871360414],
            [5.496949226540447, -2.3048621868704733],
            [5.490047859287221, -2.321692797514984],
            [5.50088711839723, -2.3327078733400617],
            [5.572815288841673, -2.38225854348671],
            [5.586055453877027, -2.4026520938939244],
            [5.586182281477017, -2.425819890982799],
            [5.560167206143414, -2.4481243329239377],
            [5.530326594449882, -2.4612887115265605],
            [5.520490447879729, -2.4753931441115946],
            [5.517963369203855, -2.524519268379417],
            [5.504439629589271, -2.5588309308612063],
            [5.483556340515383, -2.5603852277651202],
            [5.369630889099148, -2.5690748342606335],
            [5.168355784556562, -2.583728831349693],
            [4.967987957206259, -2.597819360563091],
            [4.98714207981321, -2.5667221930731374],
            [4.989205635091793, -2.5498404999896565],
            [4.9974627859282466, -2.543475253724699],
            [4.9993816682162215, -2.523411247555087],
            [5.009156357604819, -2.518966973498545],
            [5.008270428866484, -2.5030475022778105],
            [5.024184639195023, -2.4908837044905754],
            [5.0286422540626585, -2.4743196284436273],
            [5.044978537999033, -2.4695766246598216],
            [5.063091133647422, -2.4566172100099206],
            [5.075934577480829, -2.438145621403282],
            [5.072030892617269, -2.426455941282529],
            [5.0823923237994935, -2.3999509284074194],
            [5.095009627567983, -2.396983798625202],
            [5.106850729511805, -2.37764924810466],
            [5.127767628458325, -2.365851341324011],
            [5.142135667712003, -2.353089102693095],
            [5.159674823714341, -2.3257642281487327],
            [5.161547696500665, -2.3134169704165504],
            [5.185991025962368, -2.3050907200293715],
            [5.189712138299077, -2.2886726430374726],
            [5.19980084663978, -2.2731984024956686],
            [5.184276098921005, -2.2549058533221533],
            [5.18601619063428, -2.228135959523368],
            [5.194411253556198, -2.216674722524132],
            [5.194395456069013, -2.193647323542405],
            [5.1805562471719275, -2.1756330520148306],
            [5.157216362082211, -2.1737385692301197],
            [5.13631795749176, -2.1652806084552303],
            [5.135582363478823, -2.142200303163148],
            [5.128059764355222, -2.1159906248327065],
            [5.113270010478372, -2.100158611559927],
            [5.115719167046353, -2.082548253518219],
            [5.056420135886646, -2.085225187159584],
            [4.829645735737201, -2.0980179951906037],
            [4.672996842226744, -2.1069913806850615],
            [4.474670463093403, -2.1176613470654178],
            [4.342796797041927, -2.1252612096054966],
            [4.121421252859027, -2.136887750964634],
            [4.016367136086727, -2.1398379160893493],
            [3.9085929650363544, -2.144512084199942],
            [3.659275022810363, -2.156494654250273],
            [3.552244691305862, -2.1605015974117046],
            [3.3693064506474717, -2.1688337886483886],
            [3.2367334440971263, -2.1728472254725903],
            [3.033443277537629, -2.1809970735778603],
            [2.797749767129029, -2.188148695895679],
            [2.7519850919357904, -2.189948530349887],
            [2.5123610113599755, -2.196071182062483],
            [2.2727175288217443, -2.201719986895591],
            [2.130938304280664, -2.2052963659622193],
            [1.9680992153863486, -2.208838738620227],
            [1.7686206682903076, -2.211516787747053],
            [1.5642308322079228, -2.2149504691715425],
            [1.5626519081783166, -2.100772444564189],
            [1.5587580774469383, -1.8639748924909074],
            [1.556862308451191, -1.711009596695432],
            [1.5537946190940664, -1.5193956719427795],
            [1.5501119852014944, -1.1835190827281983],
            [1.546891462757465, -1.0212982754413842],
            [1.545687140939183, -0.9296720771630366],
            [1.5455977382507373, -0.7565976824392857],
            [1.5431630179551517, -0.5491995823839299],
            [1.543095332199839, -0.4806496108103408],
            [1.539808516512156, -0.29308743417362665],
            [1.5377767575323258, -0.07391019630184857],
            [1.5379886641176557, 0.13520492674117787],
            [1.5351613805201714, 0.290918226034501],
            [1.5347669434999052, 0.37562702673753695],
            [1.5331826726042002, 0.428350611483101],
            [1.5469996820063208, 0.4497929862154438],
            [1.547977110792163, 0.46080288449325],
            [1.5322637007603697, 0.47185423858185316],
            [1.5084702843360063, 0.4641018953794403],
            [1.4917390214989732, 0.47298662589432977],
            [1.4855246227699304, 0.49234624212954325],
            [1.4716073774196936, 0.4936671486594094],
            [1.4511344823290935, 0.4801609327950538],
            [1.4339509937631076, 0.4787189005788825],
            [1.4133847231737757, 0.4892514996263099],
            [1.4035954968837356, 0.5100230031930181],
            [1.3944438842104614, 0.5170376042061762],
            [1.3664442218471873, 0.5189149442248675],
            [1.3577490427018593, 0.5329099891149565],
            [1.364610244462434, 0.5510530478562997],
            [1.3599744554218027, 0.5656793178617757],
            [1.3484365852923652, 0.5778632680042114],
            [1.3237478503792082, 0.5903437940382458],
            [1.3068660363022488, 0.609384522635139],
            [1.3004497280521459, 0.6330053904956525],
            [1.2981904522972778, 0.6578863786975109],
            [1.304288047749972, 0.6701191018385202],
            [1.3220331557559495, 0.6857917730675227],
            [1.3173196279142072, 0.6999681777793002],
            [1.304426135466352, 0.7028434974472655],
            [1.2882260316767573, 0.6942733408828518],
            [1.2709208001952692, 0.7035270702645818],
            [1.2702407067757047, 0.7154262829461125],
            [1.2468113812639137, 0.7364244931535524],
            [1.236222418286702, 0.7559863270340819],
            [1.2029988412156005, 0.7704633688303409],
            [1.1923595399195872, 0.7845836620421329],
            [1.1900896345104124, 0.8041877698206585],
            [1.1826217355675848, 0.8159516299954113],
            [1.1688069331067261, 0.823294748677786],
            [1.1491710139714197, 0.8430872619758811],
            [1.1408258105837683, 0.8637955663710952],
            [1.1452986333521902, 0.8839252307709026],
            [1.1589271728435309, 0.8913065010851379],
            [1.1838359696402863, 0.8910840719466347],
            [1.191603152766994, 0.9123966550686861],
            [1.1847559882397591, 0.9325658273708395],
            [1.1888914494622091, 0.9489767082656754],
            [1.2052944311512275, 0.9769763076316755],
            [1.2193864676537107, 0.9875282974954706],
            [1.2383303500259188, 0.9898325693961041],
            [1.249730184195325, 1.0051990126409864],
            [1.2482034571684597, 1.0447108325742411],
            [1.2595850001504483, 1.0585278896040198],
            [1.2718688421879423, 1.0545151079478619],
            [1.2999597939237983, 1.0372979018863784],
            [1.3204343465886417, 1.0438872091692164],
            [1.3299596112956154, 1.0566157222096555],
            [1.331392341109034, 1.0769178517792417],
            [1.315547080754295, 1.084968684001779],
            [1.3021599914966075, 1.0747205282559826],
            [1.2887346912442936, 1.0742433544354983],
            [1.2752837026536876, 1.0869119584041325],
            [1.2816917780671977, 1.1032438115995615],
            [1.306524153156476, 1.1048850605016542],
            [1.3189886333489378, 1.120971960499847],
            [1.318254821559583, 1.1379774370526479],
            [1.3106196807222668, 1.147316944963701],
            [1.2877715622223285, 1.1501207419471207],
            [1.2680283010824474, 1.1705488126807473],
            [1.2788499551504713, 1.2004480203165866],
            [1.2548218245925653, 1.215880929537977],
            [1.2313026988651212, 1.2109241017345993],
            [1.2096658364989814, 1.2110627948969501],
            [1.2029484235408567, 1.1849096123208824],
            [1.1955300098672703, 1.178799877487378],
            [1.1622830272349116, 1.1746122897700406],
            [1.126702666532011, 1.1868370978454792],
            [1.1171784153069904, 1.1943414851337248],
            [1.1145607024866933, 1.2147307332182724],
            [1.1023294457895751, 1.2197333267700106],
            [1.0874782144703656, 1.2126191310649468],
            [1.0674326994391254, 1.2207359781317628],
            [1.0705996399501023, 1.2469148936412475],
            [1.0561286171001194, 1.257125748444353],
            [1.0400416432581427, 1.2575162151107833],
            [1.0181995694048203, 1.2820113038605223],
            [0.9933163492704824, 1.2969192149295459],
            [0.9888107714647052, 1.3126668445997582],
            [0.9857658049515485, 1.3221254633122146],
            [0.9463226667682222, 1.344150321223062],
            [0.9319549439232736, 1.3396306981643145],
            [0.9086418810549124, 1.3508954971077527],
            [0.902406972183949, 1.3715670373776536],
            [0.9112483410330083, 1.3871251215301097],
            [0.9105438698695386, 1.40448347306417],
            [0.9237456303571525, 1.4243833036288953],
            [0.9194002690497256, 1.43973346583115],
            [0.8948111221008516, 1.451679157691287],
            [0.8906545363837198, 1.4721408734254402],
            [0.8721156578664391, 1.4825774916065142],
            [0.8602647703050363, 1.4954377975022106],
            [0.8556055605021847, 1.514253518685919],
            [0.8649906021674207, 1.5417820978942582],
            [0.8590193092918336, 1.556688906216922],
            [0.8469509972997118, 1.5635225469012373],
            [0.8297802651647489, 1.5630568948395964],
            [0.808824052984977, 1.5745522492215482],
            [0.7992938425335011, 1.5846676922310572],
            [0.8014529062310387, 1.6052496448868951],
            [0.7798733382700641, 1.613645528689572],
            [0.758155493528625, 1.6280661303583408],
            [0.7318182457314256, 1.6196154332145676],
            [0.7254070509978865, 1.6366247973364176],
            [0.7404353554330364, 1.6434532543746079],
            [0.7487784399646834, 1.6551431251518034],
            [0.7337780887551317, 1.6843036633497426],
            [0.7325659079323931, 1.701462816292197],
            [0.7192272040470026, 1.7307568755658973],
            [0.721603173435057, 1.7569155672502557],
            [0.7113279021378655, 1.771818028856643],
            [0.6951524788636128, 1.7845707815482827],
            [0.6898831221722344, 1.8207305435000283],
            [0.7186941764866784, 1.8329606603027442],
            [0.7257200793611711, 1.853962412582397],
            [0.710949796466817, 1.8786230696999582],
            [0.6941036160081335, 1.8728363390526157],
            [0.6918880980065623, 1.844130375836676],
            [0.6467608062914589, 1.8414934106380183],
            [0.637563701111645, 1.852224292822794],
            [0.641796467812463, 1.8639723212936847],
            [0.6342483383052611, 1.8941057326083874],
            [0.6401822948134792, 1.9011802407597256]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.47734619873745, "lat": 38.36760475089098 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "01779791"
      },
      "bbox": [
        0.6342483383052611, -2.597819360563091, 5.920117147280087,
        2.0017880284792073
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [19.436656623279497, 5.188127953405291],
              [19.455404935822738, 5.182897944182771],
              [19.466953231752143, 5.1909378554768315],
              [19.468060404775258, 5.2060607858083605],
              [19.513135408028482, 5.217887042588922],
              [19.542141326499817, 5.231421811464547],
              [19.561835897179282, 5.260423573679863],
              [19.567613485987607, 5.280465120786674],
              [19.567394522490915, 5.311333759244397],
              [19.635099861949506, 5.236146724460901],
              [19.6387023877508, 5.21280810341785],
              [19.633322963859403, 5.202070469854679],
              [19.60675520473375, 5.1857150894632635],
              [19.57784473509236, 5.183967663542274],
              [19.531255408852545, 5.169247449219593],
              [19.49003944610117, 5.173511383839084],
              [19.4481143518415, 5.182324765331084],
              [19.436656623279497, 5.188127953405291]
            ]
          ],
          [
            [
              [19.399151751404066, 5.204458299504338],
              [19.42214016594114, 5.20550410887315],
              [19.426070886084634, 5.188311885651604],
              [19.399151751404066, 5.204458299504338]
            ]
          ],
          [
            [
              [18.979076419717014, 5.242953251300895],
              [18.990421469959188, 5.266179345689408],
              [19.022471760363594, 5.301084303416214],
              [19.032601101256084, 5.320200673256191],
              [19.038630802467956, 5.292419273647469],
              [19.02376886663657, 5.284499320265018],
              [19.00745448531171, 5.249703971554917],
              [18.994245632945592, 5.234533052311668],
              [18.979076419717014, 5.242953251300895]
            ]
          ],
          [
            [
              [18.9857115633869, 5.128920175215985],
              [19.002483951365267, 5.142330257372788],
              [19.025430857564338, 5.140302062610246],
              [19.0343407173403, 5.148349381815344],
              [19.046984164672732, 5.182496532355599],
              [19.049161607045384, 5.198712251319725],
              [19.060182935925326, 5.213200696426328],
              [19.061745995511515, 5.239798766859959],
              [19.080415296202965, 5.253561416806552],
              [19.08431212724796, 5.273672296209401],
              [19.096430926622308, 5.278674460241276],
              [19.11877238397398, 5.3056378183491635],
              [19.134106520146744, 5.2822676301473805],
              [19.15118048497922, 5.300685590123169],
              [19.162664669441558, 5.286993678660417],
              [19.166891920908945, 5.265178267630491],
              [19.17666015480243, 5.252183238722572],
              [19.193147168624012, 5.245521335127175],
              [19.209942781599427, 5.245059745642213],
              [19.22602568123033, 5.232175322114052],
              [19.236352679750947, 5.248085810295122],
              [19.232026908829813, 5.2599716801372844],
              [19.24504630012317, 5.275976940175317],
              [19.254542698670136, 5.253365646979301],
              [19.26455290610121, 5.211522226854596],
              [19.255412868537782, 5.202589151524567],
              [19.171519937819195, 5.182271092132011],
              [19.092611090821883, 5.15484295760313],
              [19.064464895871215, 5.138805386654161],
              [19.046863454554448, 5.115806424239781],
              [19.043297466330667, 5.09640013834174],
              [19.02080402497534, 5.10407289774355],
              [18.9857115633869, 5.128920175215985]
            ]
          ],
          [
            [
              [18.95669876934452, 5.230979895102788],
              [18.969409767789628, 5.240269149999641],
              [18.980622395715866, 5.233923355550845],
              [18.96657717038668, 5.221605313826937],
              [18.95669876934452, 5.230979895102788]
            ]
          ],
          [
            [
              [18.9171260965443, 5.197338807134797],
              [18.93201803544602, 5.203203149525904],
              [18.94270126338263, 5.216458461626592],
              [18.956101780978827, 5.209989178088291],
              [18.94267012075379, 5.195178132917478],
              [18.92040882756753, 5.188798341820675],
              [18.9171260965443, 5.197338807134797]
            ]
          ],
          [
            [
              [16.902060924292833, 6.042522196775324],
              [16.983398538113295, 6.060064221750681],
              [17.064738880024798, 6.077592087629369],
              [17.146081935849438, 6.095105794807839],
              [17.227427691409908, 6.112605343879432],
              [17.352756870088264, 6.1388743620722845],
              [17.47809209521186, 6.165109857488111],
              [17.6015196789415, 6.190871298351479],
              [17.710276101762936, 6.214315124274293],
              [17.819037230044355, 6.237733660423045],
              [17.903066362654982, 6.256318585361358],
              [17.987098409640016, 6.274888380341702],
              [18.0675027625085, 6.293299798022779],
              [18.147909930712487, 6.31169731548448],
              [18.228319900596, 6.330080933235504],
              [18.30873265850484, 6.3484506519775055],
              [18.319817792096508, 6.381284134143938],
              [18.33129740359824, 6.401600607197926],
              [18.345470384062462, 6.409598065053434],
              [18.37752609717923, 6.408687884596803],
              [18.360704392699773, 6.459163926872058],
              [18.370475259503074, 6.480381930639291],
              [18.390490667208944, 6.498843304511339],
              [18.442535070072555, 6.497085470767985],
              [18.445385184058306, 6.541825800364477],
              [18.451986132008376, 6.554246882799193],
              [18.494924625007865, 6.575978636533273],
              [18.51594996489579, 6.597759403449471],
              [18.535154342348644, 6.604923152423347],
              [18.547880094015664, 6.604284989795935],
              [18.57995923630865, 6.590481481784752],
              [18.599005136503877, 6.607362704381934],
              [18.60440875052871, 6.586377212113275],
              [18.62027316256689, 6.5537202618885155],
              [18.631344676530205, 6.5223838011071305],
              [18.649187121199457, 6.4912796179533885],
              [18.673213362169722, 6.46041938198142],
              [18.67574886564209, 6.440591555944664],
              [18.70057191244956, 6.43698515765874],
              [18.71437878976599, 6.425441706125538],
              [18.74495296415712, 6.4225580327461085],
              [18.758691971553365, 6.448890370770674],
              [18.774536900021424, 6.466343852226443],
              [18.78633476431314, 6.465970971767045],
              [18.790857741514507, 6.4410757799842635],
              [18.80919000800442, 6.4442377386441105],
              [18.819015542862168, 6.421154821352768],
              [18.810872409159042, 6.418802391655555],
              [18.79691309249775, 6.396240436699993],
              [18.79889406766983, 6.379619378224024],
              [18.784341449817983, 6.37360622122728],
              [18.767962640083095, 6.3787734274272685],
              [18.768815984784265, 6.364427107995007],
              [18.753491091742486, 6.338612164463272],
              [18.731864127474, 6.33507832079384],
              [18.709577477556593, 6.313039065193021],
              [18.69625329846618, 6.314771470246078],
              [18.684155846489496, 6.300826789934251],
              [18.66041585142315, 6.2912661887958645],
              [18.65423682790327, 6.2833677369427985],
              [18.65916035843385, 6.2571971676913645],
              [18.672463485025364, 6.25961682148028],
              [18.67742471905901, 6.2365083978188585],
              [18.65854814008006, 6.21578002504795],
              [18.652924079167132, 6.195713492737985],
              [18.631800336498017, 6.1960484872851165],
              [18.6186581622049, 6.183857810329083],
              [18.606632777475085, 6.164166775365297],
              [18.598857692609982, 6.1254417293304],
              [18.617443899339676, 6.10755999916327],
              [18.62065667023692, 6.094826940866141],
              [18.601102376907214, 6.090096154829021],
              [18.60235247690095, 6.064232696704392],
              [18.576605991750803, 6.074560638672409],
              [18.57019974948569, 6.065432239688886],
              [18.59946589888867, 6.057794866979599],
              [18.580458700853754, 6.033791122690097],
              [18.59248657966496, 6.01286224935685],
              [18.631746070232715, 5.9888408288768264],
              [18.64882125038912, 5.989447069504393],
              [18.66297004986084, 6.0048528094710845],
              [18.66329549774508, 5.974992645599591],
              [18.6768425288854, 5.990545074360403],
              [18.685616095269218, 6.008503297942256],
              [18.71663534768735, 5.9895535843717695],
              [18.719862383840848, 6.00215806629625],
              [18.71174431400121, 6.0116390708797045],
              [18.715588047772897, 6.030885102043855],
              [18.734198696500133, 6.017851723563222],
              [18.748623107680974, 6.020862610648617],
              [18.782230294547638, 6.0159244749021275],
              [18.80158629493931, 6.0174452708893496],
              [18.80748640710468, 6.003157096407203],
              [18.834862772671812, 5.985562653539898],
              [18.84905459644884, 5.982652349749606],
              [18.850180408355353, 5.962637317908468],
              [18.887624901661386, 5.918990830873006],
              [18.909366879084036, 5.899260263195545],
              [18.93148562773782, 5.884811950735037],
              [18.9296470913341, 5.8715369520408105],
              [18.939868918325566, 5.842707171704531],
              [18.924397699813866, 5.829385551581021],
              [18.93228986843281, 5.8057764581673466],
              [18.92606317728889, 5.797012459622746],
              [18.911878220911095, 5.8013008313435055],
              [18.916573583947887, 5.77531908655326],
              [18.931231877286894, 5.771031581436898],
              [18.948310662627332, 5.755847604085144],
              [18.963769534456937, 5.748878531997504],
              [18.99356520559848, 5.748042973141293],
              [19.008606372649115, 5.761810303193034],
              [19.0431291527548, 5.7465723403960975],
              [19.046819569583175, 5.727708452500487],
              [19.061389615377742, 5.713406071871511],
              [19.074260593872143, 5.684869116859424],
              [19.06982049086798, 5.655104006618298],
              [19.074693832937033, 5.640312649142106],
              [19.09816293800318, 5.620941845296221],
              [19.138745678262552, 5.60148787420386],
              [19.19514649402072, 5.596324099023836],
              [19.213531185432053, 5.5983173984782555],
              [19.202990570984333, 5.581191178687504],
              [19.247350224092777, 5.568696965082379],
              [19.26100451776349, 5.581100265708202],
              [19.311194963717842, 5.592947719933559],
              [19.312611350230842, 5.613935105248276],
              [19.32607072852743, 5.633740100222482],
              [19.374623551734498, 5.664986819048439],
              [19.38890306199354, 5.6676714564204165],
              [19.42622095130138, 5.692629098386531],
              [19.450487827515754, 5.7145068178250265],
              [19.459619387473662, 5.739079107906115],
              [19.437407432301885, 5.803771993491898],
              [19.440881831992353, 5.815475544180454],
              [19.421208871580266, 5.819774894314437],
              [19.426321259486834, 5.831236446821594],
              [19.397283616196447, 5.848181121229222],
              [19.387239950678786, 5.838565008012319],
              [19.37074787970372, 5.854640232815871],
              [19.359175758696235, 5.8952595835745685],
              [19.34745999427876, 5.91961219255085],
              [19.333425283801198, 5.937334735571542],
              [19.308826874489164, 5.950089704544025],
              [19.282930830971832, 5.9540726963772626],
              [19.26386181740205, 5.93635268454057],
              [19.26186472171023, 5.921189528542345],
              [19.253605704385212, 5.913028434983131],
              [19.24245404496675, 5.925642039643586],
              [19.218675020901106, 5.937661786824319],
              [19.228698764220326, 5.955889093313342],
              [19.25348017782528, 5.966631024760602],
              [19.275170929766432, 5.9687852652834525],
              [19.309525320365097, 5.966891333466],
              [19.336718970784226, 5.960949971226376],
              [19.357706221415658, 5.9519231676548685],
              [19.381629249037264, 5.935050129687633],
              [19.40459341599951, 5.912306433148875],
              [19.433857820561883, 5.878725016426623],
              [19.456613877458985, 5.845642238596089],
              [19.49130251845568, 5.786142349395454],
              [19.50623465566567, 5.753136209772995],
              [19.531536839524243, 5.689141329197234],
              [19.540673384612916, 5.657537560416201],
              [19.544991713889885, 5.62768866868998],
              [19.541646040290892, 5.612327554158586],
              [19.541854606337907, 5.575939781910446],
              [19.539296067686628, 5.556640877685903],
              [19.528870122718686, 5.54991250491221],
              [19.52890997907944, 5.535482343144405],
              [19.539870869458554, 5.497156961063975],
              [19.53253681122054, 5.480362938552205],
              [19.52271192590686, 5.4885535951225615],
              [19.529217909503846, 5.505849134959929],
              [19.528397248713606, 5.529389747448671],
              [19.523772515768083, 5.543304655355134],
              [19.52781099412787, 5.588327799333959],
              [19.503424345100576, 5.604142002958895],
              [19.48937834362042, 5.605205931404132],
              [19.479723767170114, 5.598110181464324],
              [19.438301118708146, 5.581435500331832],
              [19.40477920356051, 5.559216985340435],
              [19.384738245523764, 5.555294789906979],
              [19.36665608076219, 5.546029310634429],
              [19.335690971906224, 5.517228065071878],
              [19.324900185664436, 5.495959529025556],
              [19.314010591212185, 5.51586640784085],
              [19.301893113920997, 5.514882324995825],
              [19.285926009967685, 5.500332050777254],
              [19.267669900370016, 5.506633834575889],
              [19.253153585654566, 5.497153516838625],
              [19.25043512496245, 5.480607718741186],
              [19.23100896945167, 5.465374164739139],
              [19.20506310190396, 5.457153947442044],
              [19.196834631896692, 5.420031046910308],
              [19.17923716958527, 5.394633049786782],
              [19.155323277006378, 5.382552167082423],
              [19.141037951092915, 5.383527523059798],
              [19.082375374414493, 5.353843386194339],
              [19.07211652212222, 5.326634241173342],
              [19.059112573439577, 5.341946391241644],
              [19.064447832599992, 5.3611054009592625],
              [19.060691019666194, 5.375927652755502],
              [19.064427638554175, 5.395566668487234],
              [19.051093701630126, 5.414968035938087],
              [19.054846943581975, 5.4361693800690425],
              [19.04146140785645, 5.45489900379954],
              [19.052871056248947, 5.460917922809994],
              [19.042746699992172, 5.490467571433903],
              [19.032208430570762, 5.501939929458809],
              [19.04839444682934, 5.513347352128742],
              [19.04099746836526, 5.524294188775533],
              [19.013361949482427, 5.520109888347432],
              [18.969064665404144, 5.528393197243619],
              [18.96547633583632, 5.514048980380386],
              [18.981295546296398, 5.496361297540714],
              [18.974050886032277, 5.4802694350061785],
              [18.96200032543696, 5.468964891543856],
              [18.957921508432502, 5.427050048930602],
              [18.95009174790908, 5.434921534465941],
              [18.92496667727531, 5.436063645076205],
              [18.91724402132955, 5.424195259483993],
              [18.932619802619325, 5.420219290941285],
              [18.932898605597654, 5.403368728300819],
              [18.90158940696975, 5.391755651636255],
              [18.91407743000257, 5.367654792582912],
              [18.910490073632374, 5.3545319833901175],
              [18.887454242906607, 5.394163752684785],
              [18.84989063100121, 5.368936504706867],
              [18.857131262567552, 5.350923855054567],
              [18.85416033386783, 5.33289155485062],
              [18.86389881782363, 5.305645770200889],
              [18.859288536077834, 5.284717344890116],
              [18.836779089588955, 5.27634569366917],
              [18.83892873724457, 5.257526226335133],
              [18.82427793238622, 5.2567269774869025],
              [18.800960820591232, 5.235538353294903],
              [18.77669804375475, 5.240834448755497],
              [18.743876597347192, 5.2201933146006025],
              [18.7114371412628, 5.31008517777842],
              [18.701453057438027, 5.32071210620319],
              [18.69263776486263, 5.375482933498569],
              [18.659611068890683, 5.374993390994894],
              [18.643791199106325, 5.378040989551329],
              [18.613712283002545, 5.406808562578172],
              [18.576673768252675, 5.440371868958107],
              [18.521789251107307, 5.455105703980105],
              [18.496973961442603, 5.492746080390143],
              [18.502348571804642, 5.507030418284402],
              [18.494940483504234, 5.514720967014064],
              [18.496278540427063, 5.533228668964338],
              [18.486431028063645, 5.550647021652974],
              [18.4835897208797, 5.567321352008222],
              [18.45421653759287, 5.55417437076048],
              [18.422028087409416, 5.675926347112304],
              [18.337922972788224, 5.652146480427089],
              [18.318726636953514, 5.644832906368611],
              [18.23432487284826, 5.620113077125355],
              [18.149927243056972, 5.595378958010462],
              [18.12662721117976, 5.587598911861518],
              [18.121689103721366, 5.602377393920277],
              [18.057139908668606, 5.586517663107996],
              [17.98756288094156, 5.5712035682370935],
              [17.933040978202946, 5.557700799283035],
              [17.88074313934693, 5.547327400478781],
              [17.750657108079864, 5.515966755152931],
              [17.59922373113464, 5.480256718792404],
              [17.56798967953646, 5.468131795091844],
              [17.562817658522135, 5.461206878471406],
              [17.543006789119985, 5.462555534232559],
              [17.478589799655396, 5.4526721755200525],
              [17.435868729293393, 5.441431880943359],
              [17.440265821756014, 5.436324525680792],
              [17.4361606043838, 5.407197764366401],
              [17.401674616370915, 5.393063545182944],
              [17.394503396602314, 5.4314774506009815],
              [17.260832109890323, 5.40072171068424],
              [17.177635613038632, 5.383602588100771],
              [17.09444152233837, 5.366470206246002],
              [16.947623291808405, 5.336821038843018],
              [16.908785599680986, 5.326495530562303],
              [16.901920907041287, 5.324884086481278],
              [16.88521080237491, 5.358602322746027],
              [16.889891681911838, 5.542942512935105],
              [16.89403914848875, 5.7145069684595695],
              [16.898034568581473, 5.878557134458239],
              [16.902060924292833, 6.042522196775324]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.80408551071972, "lat": 42.25494607224355 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "ste_area_code": "USA",
        "ste_type": "state",
        "ste_name_long": null,
        "ste_fp_code": null,
        "ste_gnis_code": "00606926"
      },
      "bbox": [
        16.88521080237491, 5.09640013834174, 19.6387023877508, 6.607362704381934
      ]
    }
  ]
}
